/**
* plotly.js (basic - minified) v2.35.2
* Copyright 2012-2024, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/
/*! For license information please see plotly-basic.min.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Plotly = t() : e.Plotly = t();
}(self, function () {
  return function () {
    var e = {
        6713: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = {
              "X,X div": 'direction:ltr;font-family:"Open Sans",verdana,arial,sans-serif;margin:0;padding:0;',
              "X input,X button": 'font-family:"Open Sans",verdana,arial,sans-serif;',
              "X input:focus,X button:focus": "outline:none;",
              "X a": "text-decoration:none;",
              "X a:hover": "text-decoration:none;",
              "X .crisp": "shape-rendering:crispEdges;",
              "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
              "X svg": "overflow:hidden;",
              "X svg a": "fill:#447adb;",
              "X svg a:hover": "fill:#3c6dc5;",
              "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
              "X .main-svg .draglayer": "pointer-events:all;",
              "X .cursor-default": "cursor:default;",
              "X .cursor-pointer": "cursor:pointer;",
              "X .cursor-crosshair": "cursor:crosshair;",
              "X .cursor-move": "cursor:move;",
              "X .cursor-col-resize": "cursor:col-resize;",
              "X .cursor-row-resize": "cursor:row-resize;",
              "X .cursor-ns-resize": "cursor:ns-resize;",
              "X .cursor-ew-resize": "cursor:ew-resize;",
              "X .cursor-sw-resize": "cursor:sw-resize;",
              "X .cursor-s-resize": "cursor:s-resize;",
              "X .cursor-se-resize": "cursor:se-resize;",
              "X .cursor-w-resize": "cursor:w-resize;",
              "X .cursor-e-resize": "cursor:e-resize;",
              "X .cursor-nw-resize": "cursor:nw-resize;",
              "X .cursor-n-resize": "cursor:n-resize;",
              "X .cursor-ne-resize": "cursor:ne-resize;",
              "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
              "X .modebar": "position:absolute;top:2px;right:2px;",
              "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;",
              "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;",
              "X:hover .modebar--hover .modebar-group": "opacity:1;",
              "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
              "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
              "X .modebar-btn svg": "position:relative;top:2px;",
              "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
              "X .modebar.vertical svg": "top:-1px;",
              "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
              "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
              "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
              "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
              "X [data-title]:before": 'content:"";position:absolute;background:rgba(0,0,0,0);border:6px solid rgba(0,0,0,0);z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;',
              "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
              "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
              "X .vertical [data-title]:before": "border:6px solid rgba(0,0,0,0);border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
              Y: 'font-family:"Open Sans",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;',
              "Y p": "margin:0;",
              "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
              "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
              "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
            };
          for (var i in a) {
            var o = i.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier");
            n.addStyleRule(o, a[i]);
          }
        },
        4187: function (e, t, r) {
          "use strict";

          e.exports = r(7908);
        },
        273: function (e, t, r) {
          "use strict";

          e.exports = r(8218);
        },
        8847: function (e, t, r) {
          "use strict";

          e.exports = r(7317);
        },
        7549: function (e, t, r) {
          "use strict";

          e.exports = r(7430);
        },
        6200: function (e, t, r) {
          "use strict";

          e.exports = r(2849);
        },
        3430: function (e, t, r) {
          "use strict";

          e.exports = r(453);
        },
        5611: function (e, t, r) {
          "use strict";

          var n = r(7549);
          n.register([r(273), r(8170), r(4187), r(6200), r(3430), r(590), r(8847)]), e.exports = n;
        },
        8170: function (e, t, r) {
          "use strict";

          e.exports = r(9913);
        },
        590: function (e, t, r) {
          "use strict";

          e.exports = r(9855);
        },
        1645: function (e) {
          "use strict";

          e.exports = [{
            path: "",
            backoff: 0
          }, {
            path: "M-2.4,-3V3L0.6,0Z",
            backoff: .6
          }, {
            path: "M-3.7,-2.5V2.5L1.3,0Z",
            backoff: 1.3
          }, {
            path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
            backoff: 1.55
          }, {
            path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
            backoff: 1.6
          }, {
            path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
            backoff: 2
          }, {
            path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
            backoff: 0,
            noRotate: !0
          }, {
            path: "M2,2V-2H-2V2Z",
            backoff: 0,
            noRotate: !0
          }];
        },
        222: function (e, t, r) {
          "use strict";

          var n = r(1645),
            a = r(337),
            i = r(4826),
            o = r(8032).templatedArray;
          r(5081), e.exports = o("annotation", {
            visible: {
              valType: "boolean",
              dflt: !0,
              editType: "calc+arraydraw"
            },
            text: {
              valType: "string",
              editType: "calc+arraydraw"
            },
            textangle: {
              valType: "angle",
              dflt: 0,
              editType: "calc+arraydraw"
            },
            font: a({
              editType: "calc+arraydraw",
              colorEditType: "arraydraw"
            }),
            width: {
              valType: "number",
              min: 1,
              dflt: null,
              editType: "calc+arraydraw"
            },
            height: {
              valType: "number",
              min: 1,
              dflt: null,
              editType: "calc+arraydraw"
            },
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1,
              editType: "arraydraw"
            },
            align: {
              valType: "enumerated",
              values: ["left", "center", "right"],
              dflt: "center",
              editType: "arraydraw"
            },
            valign: {
              valType: "enumerated",
              values: ["top", "middle", "bottom"],
              dflt: "middle",
              editType: "arraydraw"
            },
            bgcolor: {
              valType: "color",
              dflt: "rgba(0,0,0,0)",
              editType: "arraydraw"
            },
            bordercolor: {
              valType: "color",
              dflt: "rgba(0,0,0,0)",
              editType: "arraydraw"
            },
            borderpad: {
              valType: "number",
              min: 0,
              dflt: 1,
              editType: "calc+arraydraw"
            },
            borderwidth: {
              valType: "number",
              min: 0,
              dflt: 1,
              editType: "calc+arraydraw"
            },
            showarrow: {
              valType: "boolean",
              dflt: !0,
              editType: "calc+arraydraw"
            },
            arrowcolor: {
              valType: "color",
              editType: "arraydraw"
            },
            arrowhead: {
              valType: "integer",
              min: 0,
              max: n.length,
              dflt: 1,
              editType: "arraydraw"
            },
            startarrowhead: {
              valType: "integer",
              min: 0,
              max: n.length,
              dflt: 1,
              editType: "arraydraw"
            },
            arrowside: {
              valType: "flaglist",
              flags: ["end", "start"],
              extras: ["none"],
              dflt: "end",
              editType: "arraydraw"
            },
            arrowsize: {
              valType: "number",
              min: .3,
              dflt: 1,
              editType: "calc+arraydraw"
            },
            startarrowsize: {
              valType: "number",
              min: .3,
              dflt: 1,
              editType: "calc+arraydraw"
            },
            arrowwidth: {
              valType: "number",
              min: .1,
              editType: "calc+arraydraw"
            },
            standoff: {
              valType: "number",
              min: 0,
              dflt: 0,
              editType: "calc+arraydraw"
            },
            startstandoff: {
              valType: "number",
              min: 0,
              dflt: 0,
              editType: "calc+arraydraw"
            },
            ax: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            ay: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            axref: {
              valType: "enumerated",
              dflt: "pixel",
              values: ["pixel", i.idRegex.x.toString()],
              editType: "calc"
            },
            ayref: {
              valType: "enumerated",
              dflt: "pixel",
              values: ["pixel", i.idRegex.y.toString()],
              editType: "calc"
            },
            xref: {
              valType: "enumerated",
              values: ["paper", i.idRegex.x.toString()],
              editType: "calc"
            },
            x: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            xanchor: {
              valType: "enumerated",
              values: ["auto", "left", "center", "right"],
              dflt: "auto",
              editType: "calc+arraydraw"
            },
            xshift: {
              valType: "number",
              dflt: 0,
              editType: "calc+arraydraw"
            },
            yref: {
              valType: "enumerated",
              values: ["paper", i.idRegex.y.toString()],
              editType: "calc"
            },
            y: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            yanchor: {
              valType: "enumerated",
              values: ["auto", "top", "middle", "bottom"],
              dflt: "auto",
              editType: "calc+arraydraw"
            },
            yshift: {
              valType: "number",
              dflt: 0,
              editType: "calc+arraydraw"
            },
            clicktoshow: {
              valType: "enumerated",
              values: [!1, "onoff", "onout"],
              dflt: !1,
              editType: "arraydraw"
            },
            xclick: {
              valType: "any",
              editType: "arraydraw"
            },
            yclick: {
              valType: "any",
              editType: "arraydraw"
            },
            hovertext: {
              valType: "string",
              editType: "arraydraw"
            },
            hoverlabel: {
              bgcolor: {
                valType: "color",
                editType: "arraydraw"
              },
              bordercolor: {
                valType: "color",
                editType: "arraydraw"
              },
              font: a({
                editType: "arraydraw"
              }),
              editType: "arraydraw"
            },
            captureevents: {
              valType: "boolean",
              editType: "arraydraw"
            },
            editType: "calc",
            _deprecated: {
              ref: {
                valType: "string",
                editType: "calc"
              }
            }
          });
        },
        317: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714),
            i = r(3377).draw;
          function o(e) {
            var t = e._fullLayout;
            n.filterVisible(t.annotations).forEach(function (t) {
              var r = a.getFromId(e, t.xref),
                n = a.getFromId(e, t.yref),
                i = a.getRefType(t.xref),
                o = a.getRefType(t.yref);
              t._extremes = {}, "range" === i && l(t, r), "range" === o && l(t, n);
            });
          }
          function l(e, t) {
            var r,
              n = t._id,
              i = n.charAt(0),
              o = e[i],
              l = e["a" + i],
              s = e[i + "ref"],
              c = e["a" + i + "ref"],
              u = e["_" + i + "padplus"],
              f = e["_" + i + "padminus"],
              d = {
                x: 1,
                y: -1
              }[i] * e[i + "shift"],
              h = 3 * e.arrowsize * e.arrowwidth || 0,
              p = h + d,
              v = h - d,
              g = 3 * e.startarrowsize * e.arrowwidth || 0,
              m = g + d,
              y = g - d;
            if (c === s) {
              var x = a.findExtremes(t, [t.r2c(o)], {
                  ppadplus: p,
                  ppadminus: v
                }),
                b = a.findExtremes(t, [t.r2c(l)], {
                  ppadplus: Math.max(u, m),
                  ppadminus: Math.max(f, y)
                });
              r = {
                min: [x.min[0], b.min[0]],
                max: [x.max[0], b.max[0]]
              };
            } else m = l ? m + l : m, y = l ? y - l : y, r = a.findExtremes(t, [t.r2c(o)], {
              ppadplus: Math.max(u, p, m),
              ppadminus: Math.max(f, v, y)
            });
            e._extremes[n] = r;
          }
          e.exports = function (e) {
            var t = e._fullLayout;
            if (n.filterVisible(t.annotations).length && e._fullData.length) return n.syncOrAsync([i, o], e);
          };
        },
        6035: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(3626),
            i = r(8032).arrayEditor;
          function o(e, t) {
            var r,
              n,
              a,
              i,
              o,
              s,
              c,
              u = e._fullLayout.annotations,
              f = [],
              d = [],
              h = [],
              p = (t || []).length;
            for (r = 0; r < u.length; r++) if (i = (a = u[r]).clicktoshow) {
              for (n = 0; n < p; n++) if (s = (o = t[n]).xaxis, c = o.yaxis, s._id === a.xref && c._id === a.yref && s.d2r(o.x) === l(a._xclick, s) && c.d2r(o.y) === l(a._yclick, c)) {
                (a.visible ? "onout" === i ? d : h : f).push(r);
                break;
              }
              n === p && a.visible && "onout" === i && d.push(r);
            }
            return {
              on: f,
              off: d,
              explicitOff: h
            };
          }
          function l(e, t) {
            return "log" === t.type ? t.l2r(e) : t.d2r(e);
          }
          e.exports = {
            hasClickToShow: function (e, t) {
              var r = o(e, t);
              return r.on.length > 0 || r.explicitOff.length > 0;
            },
            onClick: function (e, t) {
              var r,
                l,
                s = o(e, t),
                c = s.on,
                u = s.off.concat(s.explicitOff),
                f = {},
                d = e._fullLayout.annotations;
              if (c.length || u.length) {
                for (r = 0; r < c.length; r++) (l = i(e.layout, "annotations", d[c[r]])).modifyItem("visible", !0), n.extendFlat(f, l.getUpdateObj());
                for (r = 0; r < u.length; r++) (l = i(e.layout, "annotations", d[u[r]])).modifyItem("visible", !1), n.extendFlat(f, l.getUpdateObj());
                return a.call("update", e, {}, f);
              }
            }
          };
        },
        3271: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8766);
          e.exports = function (e, t, r, i) {
            i("opacity");
            var o = i("bgcolor"),
              l = i("bordercolor"),
              s = a.opacity(l);
            i("borderpad");
            var c = i("borderwidth"),
              u = i("showarrow");
            if (i("text", u ? " " : r._dfltTitle.annotation), i("textangle"), n.coerceFont(i, "font", r.font), i("width"), i("align"), i("height") && i("valign"), u) {
              var f,
                d,
                h = i("arrowside");
              -1 !== h.indexOf("end") && (f = i("arrowhead"), d = i("arrowsize")), -1 !== h.indexOf("start") && (i("startarrowhead", f), i("startarrowsize", d)), i("arrowcolor", s ? t.bordercolor : a.defaultLine), i("arrowwidth", 2 * (s && c || 1)), i("standoff"), i("startstandoff");
            }
            var p = i("hovertext"),
              v = r.hoverlabel || {};
            if (p) {
              var g = i("hoverlabel.bgcolor", v.bgcolor || (a.opacity(o) ? a.rgb(o) : a.defaultLine)),
                m = i("hoverlabel.bordercolor", v.bordercolor || a.contrast(g)),
                y = n.extendFlat({}, v.font);
              y.color || (y.color = m), n.coerceFont(i, "hoverlabel.font", y);
            }
            i("captureevents", !!p);
          };
        },
        9741: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(8083);
          e.exports = function (e, t, r, i) {
            t = t || {};
            var o = "log" === r && "linear" === t.type,
              l = "linear" === r && "log" === t.type;
            if (o || l) for (var s, c, u = e._fullLayout.annotations, f = t._id.charAt(0), d = 0; d < u.length; d++) s = u[d], c = "annotations[" + d + "].", s[f + "ref"] === t._id && h(f), s["a" + f + "ref"] === t._id && h("a" + f);
            function h(e) {
              var r = s[e],
                l = null;
              l = o ? a(r, t.range) : Math.pow(10, r), n(l) || (l = null), i(c + e, l);
            }
          };
        },
        6118: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714),
            i = r(9008),
            o = r(3271),
            l = r(222);
          function s(e, t, r) {
            function i(r, a) {
              return n.coerce(e, t, l, r, a);
            }
            var s = i("visible"),
              c = i("clicktoshow");
            if (s || c) {
              o(e, t, r, i);
              for (var u = t.showarrow, f = ["x", "y"], d = [-10, -30], h = {
                  _fullLayout: r
                }, p = 0; p < 2; p++) {
                var v = f[p],
                  g = a.coerceRef(e, t, h, v, "", "paper");
                if ("paper" !== g && a.getFromId(h, g)._annIndices.push(t._index), a.coercePosition(t, h, i, g, v, .5), u) {
                  var m = "a" + v,
                    y = a.coerceRef(e, t, h, m, "pixel", ["pixel", "paper"]);
                  "pixel" !== y && y !== g && (y = t[m] = "pixel");
                  var x = "pixel" === y ? d[p] : .4;
                  a.coercePosition(t, h, i, y, m, x);
                }
                i(v + "anchor"), i(v + "shift");
              }
              if (n.noneOrAll(e, t, ["x", "y"]), u && n.noneOrAll(e, t, ["ax", "ay"]), c) {
                var b = i("xclick"),
                  _ = i("yclick");
                t._xclick = void 0 === b ? t.x : a.cleanPosition(b, h, t.xref), t._yclick = void 0 === _ ? t.y : a.cleanPosition(_, h, t.yref);
              }
            }
          }
          e.exports = function (e, t) {
            i(e, t, {
              name: "annotations",
              handleItemDefaults: s
            });
          };
        },
        3377: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(3626),
            i = r(4122),
            o = r(4809),
            l = o.strTranslate,
            s = r(9714),
            c = r(8766),
            u = r(2203),
            f = r(2141),
            d = r(635),
            h = r(7983),
            p = r(4751),
            v = r(8032).arrayEditor,
            g = r(3768);
          function m(e, t) {
            var r = e._fullLayout.annotations[t] || {},
              n = s.getFromId(e, r.xref),
              a = s.getFromId(e, r.yref);
            n && n.setScale(), a && a.setScale(), x(e, r, t, !1, n, a);
          }
          function y(e, t, r, n, a) {
            var i = a[r],
              o = a[r + "ref"],
              l = -1 !== r.indexOf("y"),
              c = "domain" === s.getRefType(o),
              u = l ? n.h : n.w;
            return e ? c ? i + (l ? -t : t) / e._length : e.p2r(e.r2p(i) + t) : i + (l ? -t : t) / u;
          }
          function x(e, t, r, i, m, x) {
            var b,
              _,
              w = e._fullLayout,
              T = e._fullLayout._size,
              M = e._context.edits;
            i ? (b = "annotation-" + i, _ = i + ".annotations") : (b = "annotation", _ = "annotations");
            var k = v(e.layout, _, t),
              A = k.modifyBase,
              L = k.modifyItem,
              S = k.getUpdateObj;
            w._infolayer.selectAll("." + b + '[data-index="' + r + '"]').remove();
            var C = "clip" + w._uid + "_ann" + r;
            if (t._input && !1 !== t.visible) {
              var O = {
                  x: {},
                  y: {}
                },
                D = +t.textangle || 0,
                P = w._infolayer.append("g").classed(b, !0).attr("data-index", String(r)).style("opacity", t.opacity),
                z = P.append("g").classed("annotation-text-g", !0),
                I = M[t.showarrow ? "annotationTail" : "annotationPosition"],
                E = t.captureevents || M.annotationText || I,
                R = z.append("g").style("pointer-events", E ? "all" : null).call(h, "pointer").on("click", function () {
                  e._dragging = !1, e.emit("plotly_clickannotation", G(n.event));
                });
              t.hovertext && R.on("mouseover", function () {
                var r = t.hoverlabel,
                  n = r.font,
                  a = this.getBoundingClientRect(),
                  i = e.getBoundingClientRect();
                f.loneHover({
                  x0: a.left - i.left,
                  x1: a.right - i.left,
                  y: (a.top + a.bottom) / 2 - i.top,
                  text: t.hovertext,
                  color: r.bgcolor,
                  borderColor: r.bordercolor,
                  fontFamily: n.family,
                  fontSize: n.size,
                  fontColor: n.color,
                  fontWeight: n.weight,
                  fontStyle: n.style,
                  fontVariant: n.variant,
                  fontShadow: n.fontShadow,
                  fontLineposition: n.fontLineposition,
                  fontTextcase: n.fontTextcase
                }, {
                  container: w._hoverlayer.node(),
                  outerContainer: w._paper.node(),
                  gd: e
                });
              }).on("mouseout", function () {
                f.loneUnhover(w._hoverlayer.node());
              });
              var N = t.borderwidth,
                F = t.borderpad,
                H = N + F,
                B = R.append("rect").attr("class", "bg").style("stroke-width", N + "px").call(c.stroke, t.bordercolor).call(c.fill, t.bgcolor),
                j = t.width || t.height,
                Y = w._topclips.selectAll("#" + C).data(j ? [0] : []);
              Y.enter().append("clipPath").classed("annclip", !0).attr("id", C).append("rect"), Y.exit().remove();
              var V = t.font,
                U = w._meta ? o.templateString(t.text, w._meta) : t.text,
                q = R.append("text").classed("annotation-text", !0).text(U);
              M.annotationText ? q.call(d.makeEditable, {
                delegate: R,
                gd: e
              }).call(Z).on("edit", function (r) {
                t.text = r, this.call(Z), L("text", r), m && m.autorange && A(m._name + ".autorange", !0), x && x.autorange && A(x._name + ".autorange", !0), a.call("_guiRelayout", e, S());
              }) : q.call(Z);
            } else n.selectAll("#" + C).remove();
            function G(e) {
              var n = {
                index: r,
                annotation: t._input,
                fullAnnotation: t,
                event: e
              };
              return i && (n.subplotId = i), n;
            }
            function Z(r) {
              return r.call(u.font, V).attr({
                "text-anchor": {
                  left: "start",
                  right: "end"
                }[t.align] || "middle"
              }), d.convertToTspans(r, e, W), r;
            }
            function W() {
              var r = q.selectAll("a");
              1 === r.size() && r.text() === q.text() && R.insert("a", ":first-child").attr({
                "xlink:xlink:href": r.attr("xlink:href"),
                "xlink:xlink:show": r.attr("xlink:show")
              }).style({
                cursor: "pointer"
              }).node().appendChild(B.node());
              var n = R.select(".annotation-text-math-group"),
                f = !n.empty(),
                v = u.bBox((f ? n : q).node()),
                b = v.width,
                _ = v.height,
                k = t.width || b,
                E = t.height || _,
                F = Math.round(k + 2 * H),
                V = Math.round(E + 2 * H);
              function U(e, t) {
                return "auto" === t && (t = e < 1 / 3 ? "left" : e > 2 / 3 ? "right" : "center"), {
                  center: 0,
                  middle: 0,
                  left: .5,
                  bottom: -.5,
                  right: -.5,
                  top: .5
                }[t];
              }
              for (var Z = !1, W = ["x", "y"], J = 0; J < W.length; J++) {
                var X,
                  K,
                  Q,
                  $,
                  ee,
                  te = W[J],
                  re = t[te + "ref"] || te,
                  ne = t["a" + te + "ref"],
                  ae = {
                    x: m,
                    y: x
                  }[te],
                  ie = (D + ("x" === te ? 0 : -90)) * Math.PI / 180,
                  oe = F * Math.cos(ie),
                  le = V * Math.sin(ie),
                  se = Math.abs(oe) + Math.abs(le),
                  ce = t[te + "anchor"],
                  ue = t[te + "shift"] * ("x" === te ? 1 : -1),
                  fe = O[te],
                  de = s.getRefType(re);
                if (ae && "domain" !== de) {
                  var he = ae.r2fraction(t[te]);
                  (he < 0 || he > 1) && (ne === re ? ((he = ae.r2fraction(t["a" + te])) < 0 || he > 1) && (Z = !0) : Z = !0), X = ae._offset + ae.r2p(t[te]), $ = .5;
                } else {
                  var pe = "domain" === de;
                  "x" === te ? (Q = t[te], X = pe ? ae._offset + ae._length * Q : X = T.l + T.w * Q) : (Q = 1 - t[te], X = pe ? ae._offset + ae._length * Q : X = T.t + T.h * Q), $ = t.showarrow ? .5 : Q;
                }
                if (t.showarrow) {
                  fe.head = X;
                  var ve = t["a" + te];
                  if (ee = oe * U(.5, t.xanchor) - le * U(.5, t.yanchor), ne === re) {
                    var ge = s.getRefType(ne);
                    "domain" === ge ? ("y" === te && (ve = 1 - ve), fe.tail = ae._offset + ae._length * ve) : "paper" === ge ? "y" === te ? (ve = 1 - ve, fe.tail = T.t + T.h * ve) : fe.tail = T.l + T.w * ve : fe.tail = ae._offset + ae.r2p(ve), K = ee;
                  } else fe.tail = X + ve, K = ee + ve;
                  fe.text = fe.tail + ee;
                  var me = w["x" === te ? "width" : "height"];
                  if ("paper" === re && (fe.head = o.constrain(fe.head, 1, me - 1)), "pixel" === ne) {
                    var ye = -Math.max(fe.tail - 3, fe.text),
                      xe = Math.min(fe.tail + 3, fe.text) - me;
                    ye > 0 ? (fe.tail += ye, fe.text += ye) : xe > 0 && (fe.tail -= xe, fe.text -= xe);
                  }
                  fe.tail += ue, fe.head += ue;
                } else K = ee = se * U($, ce), fe.text = X + ee;
                fe.text += ue, ee += ue, K += ue, t["_" + te + "padplus"] = se / 2 + K, t["_" + te + "padminus"] = se / 2 - K, t["_" + te + "size"] = se, t["_" + te + "shift"] = ee;
              }
              if (Z) R.remove();else {
                var be = 0,
                  _e = 0;
                if ("left" !== t.align && (be = (k - b) * ("center" === t.align ? .5 : 1)), "top" !== t.valign && (_e = (E - _) * ("middle" === t.valign ? .5 : 1)), f) n.select("svg").attr({
                  x: H + be - 1,
                  y: H + _e
                }).call(u.setClipUrl, j ? C : null, e);else {
                  var we = H + _e - v.top,
                    Te = H + be - v.left;
                  q.call(d.positionText, Te, we).call(u.setClipUrl, j ? C : null, e);
                }
                Y.select("rect").call(u.setRect, H, H, k, E), B.call(u.setRect, N / 2, N / 2, F - N, V - N), R.call(u.setTranslate, Math.round(O.x.text - F / 2), Math.round(O.y.text - V / 2)), z.attr({
                  transform: "rotate(" + D + "," + O.x.text + "," + O.y.text + ")"
                });
                var Me,
                  ke = function (r, n) {
                    P.selectAll(".annotation-arrow-g").remove();
                    var s = O.x.head,
                      f = O.y.head,
                      d = O.x.tail + r,
                      h = O.y.tail + n,
                      v = O.x.text + r,
                      b = O.y.text + n,
                      _ = o.rotationXYMatrix(D, v, b),
                      w = o.apply2DTransform(_),
                      k = o.apply2DTransform2(_),
                      C = +B.attr("width"),
                      I = +B.attr("height"),
                      E = v - .5 * C,
                      N = E + C,
                      F = b - .5 * I,
                      H = F + I,
                      j = [[E, F, E, H], [E, H, N, H], [N, H, N, F], [N, F, E, F]].map(k);
                    if (!j.reduce(function (e, t) {
                      return e ^ !!o.segmentsIntersect(s, f, s + 1e6, f + 1e6, t[0], t[1], t[2], t[3]);
                    }, !1)) {
                      j.forEach(function (e) {
                        var t = o.segmentsIntersect(d, h, s, f, e[0], e[1], e[2], e[3]);
                        t && (d = t.x, h = t.y);
                      });
                      var Y = t.arrowwidth,
                        V = t.arrowcolor,
                        U = t.arrowside,
                        q = P.append("g").style({
                          opacity: c.opacity(V)
                        }).classed("annotation-arrow-g", !0),
                        G = q.append("path").attr("d", "M" + d + "," + h + "L" + s + "," + f).style("stroke-width", Y + "px").call(c.stroke, c.rgb(V));
                      if (g(G, U, t), M.annotationPosition && G.node().parentNode && !i) {
                        var Z = s,
                          W = f;
                        if (t.standoff) {
                          var J = Math.sqrt(Math.pow(s - d, 2) + Math.pow(f - h, 2));
                          Z += t.standoff * (d - s) / J, W += t.standoff * (h - f) / J;
                        }
                        var X,
                          K,
                          Q = q.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({
                            d: "M3,3H-3V-3H3ZM0,0L" + (d - Z) + "," + (h - W),
                            transform: l(Z, W)
                          }).style("stroke-width", Y + 6 + "px").call(c.stroke, "rgba(0,0,0,0)").call(c.fill, "rgba(0,0,0,0)");
                        p.init({
                          element: Q.node(),
                          gd: e,
                          prepFn: function () {
                            var e = u.getTranslate(R);
                            X = e.x, K = e.y, m && m.autorange && A(m._name + ".autorange", !0), x && x.autorange && A(x._name + ".autorange", !0);
                          },
                          moveFn: function (e, r) {
                            var n = w(X, K),
                              a = n[0] + e,
                              i = n[1] + r;
                            R.call(u.setTranslate, a, i), L("x", y(m, e, "x", T, t)), L("y", y(x, r, "y", T, t)), t.axref === t.xref && L("ax", y(m, e, "ax", T, t)), t.ayref === t.yref && L("ay", y(x, r, "ay", T, t)), q.attr("transform", l(e, r)), z.attr({
                              transform: "rotate(" + D + "," + a + "," + i + ")"
                            });
                          },
                          doneFn: function () {
                            a.call("_guiRelayout", e, S());
                            var t = document.querySelector(".js-notes-box-panel");
                            t && t.redraw(t.selectedObj);
                          }
                        });
                      }
                    }
                  };
                t.showarrow && ke(0, 0), I && p.init({
                  element: R.node(),
                  gd: e,
                  prepFn: function () {
                    Me = z.attr("transform");
                  },
                  moveFn: function (e, r) {
                    var n = "pointer";
                    if (t.showarrow) t.axref === t.xref ? L("ax", y(m, e, "ax", T, t)) : L("ax", t.ax + e), t.ayref === t.yref ? L("ay", y(x, r, "ay", T.w, t)) : L("ay", t.ay + r), ke(e, r);else {
                      if (i) return;
                      var a, o;
                      if (m) a = y(m, e, "x", T, t);else {
                        var s = t._xsize / T.w,
                          c = t.x + (t._xshift - t.xshift) / T.w - s / 2;
                        a = p.align(c + e / T.w, s, 0, 1, t.xanchor);
                      }
                      if (x) o = y(x, r, "y", T, t);else {
                        var u = t._ysize / T.h,
                          f = t.y - (t._yshift + t.yshift) / T.h - u / 2;
                        o = p.align(f - r / T.h, u, 0, 1, t.yanchor);
                      }
                      L("x", a), L("y", o), m && x || (n = p.getCursor(m ? .5 : a, x ? .5 : o, t.xanchor, t.yanchor));
                    }
                    z.attr({
                      transform: l(e, r) + Me
                    }), h(R, n);
                  },
                  clickFn: function (r, n) {
                    t.captureevents && e.emit("plotly_clickannotation", G(n));
                  },
                  doneFn: function () {
                    h(R), a.call("_guiRelayout", e, S());
                    var t = document.querySelector(".js-notes-box-panel");
                    t && t.redraw(t.selectedObj);
                  }
                });
              }
            }
          }
          e.exports = {
            draw: function (e) {
              var t = e._fullLayout;
              t._infolayer.selectAll(".annotation").remove();
              for (var r = 0; r < t.annotations.length; r++) t.annotations[r].visible && m(e, r);
              return i.previousPromises(e);
            },
            drawOne: m,
            drawRaw: x
          };
        },
        3768: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(8766),
            i = r(1645),
            o = r(4809),
            l = o.strScale,
            s = o.strRotate,
            c = o.strTranslate;
          e.exports = function (e, t, r) {
            var o,
              u,
              f,
              d,
              h = e.node(),
              p = i[r.arrowhead || 0],
              v = i[r.startarrowhead || 0],
              g = (r.arrowwidth || 1) * (r.arrowsize || 1),
              m = (r.arrowwidth || 1) * (r.startarrowsize || 1),
              y = t.indexOf("start") >= 0,
              x = t.indexOf("end") >= 0,
              b = p.backoff * g + r.standoff,
              _ = v.backoff * m + r.startstandoff;
            if ("line" === h.nodeName) {
              o = {
                x: +e.attr("x1"),
                y: +e.attr("y1")
              }, u = {
                x: +e.attr("x2"),
                y: +e.attr("y2")
              };
              var w = o.x - u.x,
                T = o.y - u.y;
              if (d = (f = Math.atan2(T, w)) + Math.PI, b && _ && b + _ > Math.sqrt(w * w + T * T)) return void I();
              if (b) {
                if (b * b > w * w + T * T) return void I();
                var M = b * Math.cos(f),
                  k = b * Math.sin(f);
                u.x += M, u.y += k, e.attr({
                  x2: u.x,
                  y2: u.y
                });
              }
              if (_) {
                if (_ * _ > w * w + T * T) return void I();
                var A = _ * Math.cos(f),
                  L = _ * Math.sin(f);
                o.x -= A, o.y -= L, e.attr({
                  x1: o.x,
                  y1: o.y
                });
              }
            } else if ("path" === h.nodeName) {
              var S = h.getTotalLength(),
                C = "";
              if (S < b + _) return void I();
              var O = h.getPointAtLength(0),
                D = h.getPointAtLength(.1);
              f = Math.atan2(O.y - D.y, O.x - D.x), o = h.getPointAtLength(Math.min(_, S)), C = "0px," + _ + "px,";
              var P = h.getPointAtLength(S),
                z = h.getPointAtLength(S - .1);
              d = Math.atan2(P.y - z.y, P.x - z.x), u = h.getPointAtLength(Math.max(0, S - b)), C += S - (C ? _ + b : b) + "px," + S + "px", e.style("stroke-dasharray", C);
            }
            function I() {
              e.style("stroke-dasharray", "0px,100px");
            }
            function E(t, i, o, u) {
              t.path && (t.noRotate && (o = 0), n.select(h.parentNode).append("path").attr({
                class: e.attr("class"),
                d: t.path,
                transform: c(i.x, i.y) + s(180 * o / Math.PI) + l(u)
              }).style({
                fill: a.rgb(r.arrowcolor),
                "stroke-width": 0
              }));
            }
            y && E(v, o, f, m), x && E(p, u, d, g);
          };
        },
        3599: function (e, t, r) {
          "use strict";

          var n = r(3377),
            a = r(6035);
          e.exports = {
            moduleType: "component",
            name: "annotations",
            layoutAttributes: r(222),
            supplyLayoutDefaults: r(6118),
            includeBasePlot: r(706)("annotations"),
            calcAutorange: r(317),
            draw: n.draw,
            drawOne: n.drawOne,
            drawRaw: n.drawRaw,
            hasClickToShow: a.hasClickToShow,
            onClick: a.onClick,
            convertCoords: r(9741)
          };
        },
        8239: function (e, t, r) {
          "use strict";

          var n = r(222),
            a = r(3582).overrideAll,
            i = r(8032).templatedArray;
          e.exports = a(i("annotation", {
            visible: n.visible,
            x: {
              valType: "any"
            },
            y: {
              valType: "any"
            },
            z: {
              valType: "any"
            },
            ax: {
              valType: "number"
            },
            ay: {
              valType: "number"
            },
            xanchor: n.xanchor,
            xshift: n.xshift,
            yanchor: n.yanchor,
            yshift: n.yshift,
            text: n.text,
            textangle: n.textangle,
            font: n.font,
            width: n.width,
            height: n.height,
            opacity: n.opacity,
            align: n.align,
            valign: n.valign,
            bgcolor: n.bgcolor,
            bordercolor: n.bordercolor,
            borderpad: n.borderpad,
            borderwidth: n.borderwidth,
            showarrow: n.showarrow,
            arrowcolor: n.arrowcolor,
            arrowhead: n.arrowhead,
            startarrowhead: n.startarrowhead,
            arrowside: n.arrowside,
            arrowsize: n.arrowsize,
            startarrowsize: n.startarrowsize,
            arrowwidth: n.arrowwidth,
            standoff: n.standoff,
            startstandoff: n.startstandoff,
            hovertext: n.hovertext,
            hoverlabel: n.hoverlabel,
            captureevents: n.captureevents
          }), "calc", "from-root");
        },
        7979: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714);
          function i(e, t) {
            var r = t.fullSceneLayout.domain,
              i = t.fullLayout._size,
              o = {
                pdata: null,
                type: "linear",
                autorange: !1,
                range: [-1 / 0, 1 / 0]
              };
            e._xa = {}, n.extendFlat(e._xa, o), a.setConvert(e._xa), e._xa._offset = i.l + r.x[0] * i.w, e._xa.l2p = function () {
              return .5 * (1 + e._pdata[0] / e._pdata[3]) * i.w * (r.x[1] - r.x[0]);
            }, e._ya = {}, n.extendFlat(e._ya, o), a.setConvert(e._ya), e._ya._offset = i.t + (1 - r.y[1]) * i.h, e._ya.l2p = function () {
              return .5 * (1 - e._pdata[1] / e._pdata[3]) * i.h * (r.y[1] - r.y[0]);
            };
          }
          e.exports = function (e) {
            for (var t = e.fullSceneLayout.annotations, r = 0; r < t.length; r++) i(t[r], e);
            e.fullLayout._infolayer.selectAll(".annotation-" + e.id).remove();
          };
        },
        4232: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714),
            i = r(9008),
            o = r(3271),
            l = r(8239);
          function s(e, t, r, i) {
            function s(r, a) {
              return n.coerce(e, t, l, r, a);
            }
            function c(e) {
              var n = e + "axis",
                i = {
                  _fullLayout: {}
                };
              return i._fullLayout[n] = r[n], a.coercePosition(t, i, s, e, e, .5);
            }
            s("visible") && (o(e, t, i.fullLayout, s), c("x"), c("y"), c("z"), n.noneOrAll(e, t, ["x", "y", "z"]), t.xref = "x", t.yref = "y", t.zref = "z", s("xanchor"), s("yanchor"), s("xshift"), s("yshift"), t.showarrow && (t.axref = "pixel", t.ayref = "pixel", s("ax", -10), s("ay", -30), n.noneOrAll(e, t, ["ax", "ay"])));
          }
          e.exports = function (e, t, r) {
            i(e, t, {
              name: "annotations",
              handleItemDefaults: s,
              fullLayout: r.fullLayout
            });
          };
        },
        9756: function (e, t, r) {
          "use strict";

          var n = r(3377).drawRaw,
            a = r(5802),
            i = ["x", "y", "z"];
          e.exports = function (e) {
            for (var t = e.fullSceneLayout, r = e.dataScale, o = t.annotations, l = 0; l < o.length; l++) {
              for (var s = o[l], c = !1, u = 0; u < 3; u++) {
                var f = i[u],
                  d = s[f],
                  h = t[f + "axis"].r2fraction(d);
                if (h < 0 || h > 1) {
                  c = !0;
                  break;
                }
              }
              c ? e.fullLayout._infolayer.select(".annotation-" + e.id + '[data-index="' + l + '"]').remove() : (s._pdata = a(e.glplot.cameraParams, [t.xaxis.r2l(s.x) * r[0], t.yaxis.r2l(s.y) * r[1], t.zaxis.r2l(s.z) * r[2]]), n(e.graphDiv, s, l, e.id, s._xa, s._ya));
            }
          };
        },
        3348: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(4809);
          e.exports = {
            moduleType: "component",
            name: "annotations3d",
            schema: {
              subplots: {
                scene: {
                  annotations: r(8239)
                }
              }
            },
            layoutAttributes: r(8239),
            handleDefaults: r(4232),
            includeBasePlot: function (e, t) {
              var r = n.subplotsRegistry.gl3d;
              if (r) for (var i = r.attrRegex, o = Object.keys(e), l = 0; l < o.length; l++) {
                var s = o[l];
                i.test(s) && (e[s].annotations || []).length && (a.pushUnique(t._basePlotModules, r), a.pushUnique(t._subplots.gl3d, s));
              }
            },
            convert: r(7979),
            draw: r(9756)
          };
        },
        7177: function (e, t, r) {
          "use strict";

          e.exports = r(6834), r(3428), r(1401), r(2210), r(8569), r(1133), r(8295), r(5512), r(2645), r(2324), r(1662), r(6445), r(506), r(4756), r(1858), r(7985);
        },
        7317: function (e, t, r) {
          "use strict";

          var n = r(7177),
            a = r(4809),
            i = r(3821),
            o = i.EPOCHJD,
            l = i.ONEDAY,
            s = {
              valType: "enumerated",
              values: a.sortObjectKeys(n.calendars),
              editType: "calc",
              dflt: "gregorian"
            },
            c = function (e, t, r, n) {
              var i = {};
              return i[r] = s, a.coerce(e, t, i, r, n);
            },
            u = "##",
            f = {
              d: {
                0: "dd",
                "-": "d"
              },
              e: {
                0: "d",
                "-": "d"
              },
              a: {
                0: "D",
                "-": "D"
              },
              A: {
                0: "DD",
                "-": "DD"
              },
              j: {
                0: "oo",
                "-": "o"
              },
              W: {
                0: "ww",
                "-": "w"
              },
              m: {
                0: "mm",
                "-": "m"
              },
              b: {
                0: "M",
                "-": "M"
              },
              B: {
                0: "MM",
                "-": "MM"
              },
              y: {
                0: "yy",
                "-": "yy"
              },
              Y: {
                0: "yyyy",
                "-": "yyyy"
              },
              U: u,
              w: u,
              c: {
                0: "D M d %X yyyy",
                "-": "D M d %X yyyy"
              },
              x: {
                0: "mm/dd/yyyy",
                "-": "mm/dd/yyyy"
              }
            },
            d = {};
          function h(e) {
            var t = d[e];
            return t || (d[e] = n.instance(e));
          }
          function p(e) {
            return a.extendFlat({}, s, {
              description: e
            });
          }
          function v(e) {
            return "Sets the calendar system to use with `" + e + "` date data.";
          }
          var g = {
              xcalendar: p(v("x"))
            },
            m = a.extendFlat({}, g, {
              ycalendar: p(v("y"))
            }),
            y = a.extendFlat({}, m, {
              zcalendar: p(v("z"))
            }),
            x = p(["Sets the calendar system to use for `range` and `tick0`", "if this is a date axis. This does not set the calendar for", "interpreting data on this axis, that's specified in the trace", "or via the global `layout.calendar`"].join(" "));
          e.exports = {
            moduleType: "component",
            name: "calendars",
            schema: {
              traces: {
                scatter: m,
                bar: m,
                box: m,
                heatmap: m,
                contour: m,
                histogram: m,
                histogram2d: m,
                histogram2dcontour: m,
                scatter3d: y,
                surface: y,
                mesh3d: y,
                scattergl: m,
                ohlc: g,
                candlestick: g
              },
              layout: {
                calendar: p(["Sets the default calendar system to use for interpreting and", "displaying dates throughout the plot."].join(" "))
              },
              subplots: {
                xaxis: {
                  calendar: x
                },
                yaxis: {
                  calendar: x
                },
                scene: {
                  xaxis: {
                    calendar: x
                  },
                  yaxis: {
                    calendar: x
                  },
                  zaxis: {
                    calendar: x
                  }
                },
                polar: {
                  radialaxis: {
                    calendar: x
                  }
                }
              },
              transforms: {
                filter: {
                  valuecalendar: p(["WARNING: All transforms are deprecated and may be removed from the API in next major version.", "Sets the calendar system to use for `value`, if it is a date."].join(" ")),
                  targetcalendar: p(["WARNING: All transforms are deprecated and may be removed from the API in next major version.", "Sets the calendar system to use for `target`, if it is an", "array of dates. If `target` is a string (eg *x*) we use the", "corresponding trace attribute (eg `xcalendar`) if it exists,", "even if `targetcalendar` is provided."].join(" "))
                }
              }
            },
            layoutAttributes: s,
            handleDefaults: c,
            handleTraceDefaults: function (e, t, r, n) {
              for (var a = 0; a < r.length; a++) c(e, t, r[a] + "calendar", n.calendar);
            },
            CANONICAL_SUNDAY: {
              chinese: "2000-01-02",
              coptic: "2000-01-03",
              discworld: "2000-01-03",
              ethiopian: "2000-01-05",
              hebrew: "5000-01-01",
              islamic: "1000-01-02",
              julian: "2000-01-03",
              mayan: "5000-01-01",
              nanakshahi: "1000-01-05",
              nepali: "2000-01-05",
              persian: "1000-01-01",
              jalali: "1000-01-01",
              taiwan: "1000-01-04",
              thai: "2000-01-04",
              ummalqura: "1400-01-06"
            },
            CANONICAL_TICK: {
              chinese: "2000-01-01",
              coptic: "2000-01-01",
              discworld: "2000-01-01",
              ethiopian: "2000-01-01",
              hebrew: "5000-01-01",
              islamic: "1000-01-01",
              julian: "2000-01-01",
              mayan: "5000-01-01",
              nanakshahi: "1000-01-01",
              nepali: "2000-01-01",
              persian: "1000-01-01",
              jalali: "1000-01-01",
              taiwan: "1000-01-01",
              thai: "2000-01-01",
              ummalqura: "1400-01-01"
            },
            DFLTRANGE: {
              chinese: ["2000-01-01", "2001-01-01"],
              coptic: ["1700-01-01", "1701-01-01"],
              discworld: ["1800-01-01", "1801-01-01"],
              ethiopian: ["2000-01-01", "2001-01-01"],
              hebrew: ["5700-01-01", "5701-01-01"],
              islamic: ["1400-01-01", "1401-01-01"],
              julian: ["2000-01-01", "2001-01-01"],
              mayan: ["5200-01-01", "5201-01-01"],
              nanakshahi: ["0500-01-01", "0501-01-01"],
              nepali: ["2000-01-01", "2001-01-01"],
              persian: ["1400-01-01", "1401-01-01"],
              jalali: ["1400-01-01", "1401-01-01"],
              taiwan: ["0100-01-01", "0101-01-01"],
              thai: ["2500-01-01", "2501-01-01"],
              ummalqura: ["1400-01-01", "1401-01-01"]
            },
            getCal: h,
            worldCalFmt: function (e, t, r) {
              for (var n, a, i, s, c, d = Math.floor((t + .05) / l) + o, p = h(r).fromJD(d), v = 0; -1 !== (v = e.indexOf("%", v));) "0" === (n = e.charAt(v + 1)) || "-" === n || "_" === n ? (i = 3, a = e.charAt(v + 2), "_" === n && (n = "-")) : (a = n, n = "0", i = 2), (s = f[a]) ? (c = s === u ? u : p.formatDate(s[n]), e = e.substr(0, v) + c + e.substr(v + i), v += c.length) : v += i;
              return e;
            }
          };
        },
        229: function (e, t) {
          "use strict";

          t.defaults = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"], t.defaultLine = "#444", t.lightLine = "#eee", t.background = "#fff", t.borderLine = "#BEC8D9", t.lightFraction = 1e3 / 11;
        },
        8766: function (e, t, r) {
          "use strict";

          var n = r(5657),
            a = r(721),
            i = r(7800).isTypedArray,
            o = e.exports = {},
            l = r(229);
          o.defaults = l.defaults;
          var s = o.defaultLine = l.defaultLine;
          o.lightLine = l.lightLine;
          var c = o.background = l.background;
          function u(e) {
            if (a(e) || "string" != typeof e) return e;
            var t = e.trim();
            if ("rgb" !== t.substr(0, 3)) return e;
            var r = t.match(/^rgba?\s*\(([^()]*)\)$/);
            if (!r) return e;
            var n = r[1].trim().split(/\s*[\s,]\s*/),
              i = "a" === t.charAt(3) && 4 === n.length;
            if (!i && 3 !== n.length) return e;
            for (var o = 0; o < n.length; o++) {
              if (!n[o].length) return e;
              if (n[o] = Number(n[o]), !(n[o] >= 0)) return e;
              if (3 === o) n[o] > 1 && (n[o] = 1);else if (n[o] >= 1) return e;
            }
            var l = Math.round(255 * n[0]) + ", " + Math.round(255 * n[1]) + ", " + Math.round(255 * n[2]);
            return i ? "rgba(" + l + ", " + n[3] + ")" : "rgb(" + l + ")";
          }
          o.tinyRGB = function (e) {
            var t = e.toRgb();
            return "rgb(" + Math.round(t.r) + ", " + Math.round(t.g) + ", " + Math.round(t.b) + ")";
          }, o.rgb = function (e) {
            return o.tinyRGB(n(e));
          }, o.opacity = function (e) {
            return e ? n(e).getAlpha() : 0;
          }, o.addOpacity = function (e, t) {
            var r = n(e).toRgb();
            return "rgba(" + Math.round(r.r) + ", " + Math.round(r.g) + ", " + Math.round(r.b) + ", " + t + ")";
          }, o.combine = function (e, t) {
            var r = n(e).toRgb();
            if (1 === r.a) return n(e).toRgbString();
            var a = n(t || c).toRgb(),
              i = 1 === a.a ? a : {
                r: 255 * (1 - a.a) + a.r * a.a,
                g: 255 * (1 - a.a) + a.g * a.a,
                b: 255 * (1 - a.a) + a.b * a.a
              },
              o = {
                r: i.r * (1 - r.a) + r.r * r.a,
                g: i.g * (1 - r.a) + r.g * r.a,
                b: i.b * (1 - r.a) + r.b * r.a
              };
            return n(o).toRgbString();
          }, o.interpolate = function (e, t, r) {
            var a = n(e).toRgb(),
              i = n(t).toRgb(),
              o = {
                r: r * a.r + (1 - r) * i.r,
                g: r * a.g + (1 - r) * i.g,
                b: r * a.b + (1 - r) * i.b
              };
            return n(o).toRgbString();
          }, o.contrast = function (e, t, r) {
            var a = n(e);
            return 1 !== a.getAlpha() && (a = n(o.combine(e, c))), (a.isDark() ? t ? a.lighten(t) : c : r ? a.darken(r) : s).toString();
          }, o.stroke = function (e, t) {
            var r = n(t);
            e.style({
              stroke: o.tinyRGB(r),
              "stroke-opacity": r.getAlpha()
            });
          }, o.fill = function (e, t) {
            var r = n(t);
            e.style({
              fill: o.tinyRGB(r),
              "fill-opacity": r.getAlpha()
            });
          }, o.clean = function (e) {
            if (e && "object" == typeof e) {
              var t,
                r,
                n,
                a,
                l = Object.keys(e);
              for (t = 0; t < l.length; t++) if (a = e[n = l[t]], "color" === n.substr(n.length - 5)) {
                if (Array.isArray(a)) for (r = 0; r < a.length; r++) a[r] = u(a[r]);else e[n] = u(a);
              } else if ("colorscale" === n.substr(n.length - 10) && Array.isArray(a)) for (r = 0; r < a.length; r++) Array.isArray(a[r]) && (a[r][1] = u(a[r][1]));else if (Array.isArray(a)) {
                var s = a[0];
                if (!Array.isArray(s) && s && "object" == typeof s) for (r = 0; r < a.length; r++) o.clean(a[r]);
              } else a && "object" == typeof a && !i(a) && o.clean(a);
            }
          };
        },
        5158: function (e, t, r) {
          "use strict";

          var n = r(5829),
            a = r(337),
            i = r(3049).extendFlat,
            o = r(3582).overrideAll;
          e.exports = o({
            orientation: {
              valType: "enumerated",
              values: ["h", "v"],
              dflt: "v"
            },
            thicknessmode: {
              valType: "enumerated",
              values: ["fraction", "pixels"],
              dflt: "pixels"
            },
            thickness: {
              valType: "number",
              min: 0,
              dflt: 30
            },
            lenmode: {
              valType: "enumerated",
              values: ["fraction", "pixels"],
              dflt: "fraction"
            },
            len: {
              valType: "number",
              min: 0,
              dflt: 1
            },
            x: {
              valType: "number"
            },
            xref: {
              valType: "enumerated",
              dflt: "paper",
              values: ["container", "paper"],
              editType: "layoutstyle"
            },
            xanchor: {
              valType: "enumerated",
              values: ["left", "center", "right"]
            },
            xpad: {
              valType: "number",
              min: 0,
              dflt: 10
            },
            y: {
              valType: "number"
            },
            yref: {
              valType: "enumerated",
              dflt: "paper",
              values: ["container", "paper"],
              editType: "layoutstyle"
            },
            yanchor: {
              valType: "enumerated",
              values: ["top", "middle", "bottom"]
            },
            ypad: {
              valType: "number",
              min: 0,
              dflt: 10
            },
            outlinecolor: n.linecolor,
            outlinewidth: n.linewidth,
            bordercolor: n.linecolor,
            borderwidth: {
              valType: "number",
              min: 0,
              dflt: 0
            },
            bgcolor: {
              valType: "color",
              dflt: "rgba(0,0,0,0)"
            },
            tickmode: n.minor.tickmode,
            nticks: n.nticks,
            tick0: n.tick0,
            dtick: n.dtick,
            tickvals: n.tickvals,
            ticktext: n.ticktext,
            ticks: i({}, n.ticks, {
              dflt: ""
            }),
            ticklabeloverflow: i({}, n.ticklabeloverflow, {}),
            ticklabelposition: {
              valType: "enumerated",
              values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"],
              dflt: "outside"
            },
            ticklen: n.ticklen,
            tickwidth: n.tickwidth,
            tickcolor: n.tickcolor,
            ticklabelstep: n.ticklabelstep,
            showticklabels: n.showticklabels,
            labelalias: n.labelalias,
            tickfont: a({}),
            tickangle: n.tickangle,
            tickformat: n.tickformat,
            tickformatstops: n.tickformatstops,
            tickprefix: n.tickprefix,
            showtickprefix: n.showtickprefix,
            ticksuffix: n.ticksuffix,
            showticksuffix: n.showticksuffix,
            separatethousands: n.separatethousands,
            exponentformat: n.exponentformat,
            minexponent: n.minexponent,
            showexponent: n.showexponent,
            title: {
              text: {
                valType: "string"
              },
              font: a({}),
              side: {
                valType: "enumerated",
                values: ["right", "top", "bottom"]
              }
            },
            _deprecated: {
              title: {
                valType: "string"
              },
              titlefont: a({}),
              titleside: {
                valType: "enumerated",
                values: ["right", "top", "bottom"],
                dflt: "top"
              }
            }
          }, "colorbars", "from-root");
        },
        4554: function (e) {
          "use strict";

          e.exports = {
            cn: {
              colorbar: "colorbar",
              cbbg: "cbbg",
              cbfill: "cbfill",
              cbfills: "cbfills",
              cbline: "cbline",
              cblines: "cblines",
              cbaxis: "cbaxis",
              cbtitleunshift: "cbtitleunshift",
              cbtitle: "cbtitle",
              cboutline: "cboutline",
              crisp: "crisp",
              jsPlaceholder: "js-placeholder"
            }
          };
        },
        2097: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8032),
            i = r(2777),
            o = r(7433),
            l = r(2036),
            s = r(4616),
            c = r(5158);
          e.exports = function (e, t, r) {
            var u = a.newContainer(t, "colorbar"),
              f = e.colorbar || {};
            function d(e, t) {
              return n.coerce(f, u, c, e, t);
            }
            var h = r.margin || {
                t: 0,
                b: 0,
                l: 0,
                r: 0
              },
              p = r.width - h.l - h.r,
              v = r.height - h.t - h.b,
              g = "v" === d("orientation"),
              m = d("thicknessmode");
            d("thickness", "fraction" === m ? 30 / (g ? p : v) : 30);
            var y = d("lenmode");
            d("len", "fraction" === y ? 1 : g ? v : p);
            var x,
              b,
              _,
              w = "paper" === d("yref"),
              T = "paper" === d("xref"),
              M = "left";
            g ? (_ = "middle", M = T ? "left" : "right", x = T ? 1.02 : 1, b = .5) : (_ = w ? "bottom" : "top", M = "center", x = .5, b = w ? 1.02 : 1), n.coerce(f, u, {
              x: {
                valType: "number",
                min: T ? -2 : 0,
                max: T ? 3 : 1,
                dflt: x
              }
            }, "x"), n.coerce(f, u, {
              y: {
                valType: "number",
                min: w ? -2 : 0,
                max: w ? 3 : 1,
                dflt: b
              }
            }, "y"), d("xanchor", M), d("xpad"), d("yanchor", _), d("ypad"), n.noneOrAll(f, u, ["x", "y"]), d("outlinecolor"), d("outlinewidth"), d("bordercolor"), d("borderwidth"), d("bgcolor");
            var k = n.coerce(f, u, {
              ticklabelposition: {
                valType: "enumerated",
                dflt: "outside",
                values: g ? ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"] : ["outside", "inside", "outside left", "inside left", "outside right", "inside right"]
              }
            }, "ticklabelposition");
            d("ticklabeloverflow", -1 !== k.indexOf("inside") ? "hide past domain" : "hide past div"), i(f, u, d, "linear");
            var A = r.font,
              L = {
                noAutotickangles: !0,
                noTicklabelshift: !0,
                noTicklabelstandoff: !0,
                outerTicks: !1,
                font: A
              };
            -1 !== k.indexOf("inside") && (L.bgColor = "black"), s(f, u, d, "linear", L), l(f, u, d, "linear", L), o(f, u, d, "linear", L), d("title.text", r._dfltTitle.colorbar);
            var S = u.showticklabels ? u.tickfont : A,
              C = n.extendFlat({}, A, {
                family: S.family,
                size: n.bigFont(S.size)
              });
            n.coerceFont(d, "title.font", C), d("title.side", g ? "top" : "right");
          };
        },
        5881: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(5657),
            i = r(4122),
            o = r(3626),
            l = r(9714),
            s = r(4751),
            c = r(4809),
            u = c.strTranslate,
            f = r(3049).extendFlat,
            d = r(7983),
            h = r(2203),
            p = r(8766),
            v = r(7240),
            g = r(635),
            m = r(5477).flipScale,
            y = r(7655),
            x = r(957),
            b = r(5829),
            _ = r(4530),
            w = _.LINE_SPACING,
            T = _.FROM_TL,
            M = _.FROM_BR,
            k = r(4554).cn;
          e.exports = {
            draw: function (e) {
              var t = e._fullLayout._infolayer.selectAll("g." + k.colorbar).data(function (e) {
                var t,
                  r,
                  n,
                  a,
                  i = e._fullLayout,
                  o = e.calcdata,
                  l = [];
                function s(e) {
                  return f(e, {
                    _fillcolor: null,
                    _line: {
                      color: null,
                      width: null,
                      dash: null
                    },
                    _levels: {
                      start: null,
                      end: null,
                      size: null
                    },
                    _filllevels: null,
                    _fillgradient: null,
                    _zrange: null
                  });
                }
                function c() {
                  "function" == typeof a.calc ? a.calc(e, n, t) : (t._fillgradient = r.reversescale ? m(r.colorscale) : r.colorscale, t._zrange = [r[a.min], r[a.max]]);
                }
                for (var u = 0; u < o.length; u++) {
                  var d = o[u];
                  if ((n = d[0].trace)._module) {
                    var h = n._module.colorbar;
                    if (!0 === n.visible && h) for (var p = Array.isArray(h), v = p ? h : [h], g = 0; g < v.length; g++) {
                      var y = (a = v[g]).container;
                      (r = y ? n[y] : n) && r.showscale && ((t = s(r.colorbar))._id = "cb" + n.uid + (p && y ? "-" + y : ""), t._traceIndex = n.index, t._propPrefix = (y ? y + "." : "") + "colorbar.", t._meta = n._meta, c(), l.push(t));
                    }
                  }
                }
                for (var x in i._colorAxes) if ((r = i[x]).showscale) {
                  var b = i._colorAxes[x];
                  (t = s(r.colorbar))._id = "cb" + x, t._propPrefix = x + ".colorbar.", t._meta = i._meta, a = {
                    min: "cmin",
                    max: "cmax"
                  }, "heatmap" !== b[0] && (n = b[1], a.calc = n._module.colorbar.calc), c(), l.push(t);
                }
                return l;
              }(e), function (e) {
                return e._id;
              });
              t.enter().append("g").attr("class", function (e) {
                return e._id;
              }).classed(k.colorbar, !0), t.each(function (t) {
                var r = n.select(this);
                c.ensureSingle(r, "rect", k.cbbg), c.ensureSingle(r, "g", k.cbfills), c.ensureSingle(r, "g", k.cblines), c.ensureSingle(r, "g", k.cbaxis, function (e) {
                  e.classed(k.crisp, !0);
                }), c.ensureSingle(r, "g", k.cbtitleunshift, function (e) {
                  e.append("g").classed(k.cbtitle, !0);
                }), c.ensureSingle(r, "rect", k.cboutline);
                var m = function (e, t, r) {
                  var o = "v" === t.orientation,
                    s = t.len,
                    d = t.lenmode,
                    m = t.thickness,
                    _ = t.thicknessmode,
                    A = t.outlinewidth,
                    L = t.borderwidth,
                    S = t.bgcolor,
                    C = t.xanchor,
                    O = t.yanchor,
                    D = t.xpad,
                    P = t.ypad,
                    z = t.x,
                    I = o ? t.y : 1 - t.y,
                    E = "paper" === t.yref,
                    R = "paper" === t.xref,
                    N = r._fullLayout,
                    F = N._size,
                    H = t._fillcolor,
                    B = t._line,
                    j = t.title,
                    Y = j.side,
                    V = t._zrange || n.extent(("function" == typeof H ? H : B.color).domain()),
                    U = "function" == typeof B.color ? B.color : function () {
                      return B.color;
                    },
                    q = "function" == typeof H ? H : function () {
                      return H;
                    },
                    G = t._levels,
                    Z = function (e, t, r) {
                      var n,
                        a,
                        i = t._levels,
                        o = [],
                        l = [],
                        s = i.end + i.size / 100,
                        c = i.size,
                        u = 1.001 * r[0] - .001 * r[1],
                        f = 1.001 * r[1] - .001 * r[0];
                      for (a = 0; a < 1e5 && (n = i.start + a * c, !(c > 0 ? n >= s : n <= s)); a++) n > u && n < f && o.push(n);
                      if (t._fillgradient) l = [0];else if ("function" == typeof t._fillcolor) {
                        var d = t._filllevels;
                        if (d) for (s = d.end + d.size / 100, c = d.size, a = 0; a < 1e5 && (n = d.start + a * c, !(c > 0 ? n >= s : n <= s)); a++) n > r[0] && n < r[1] && l.push(n);else (l = o.map(function (e) {
                          return e - i.size / 2;
                        })).push(l[l.length - 1] + i.size);
                      } else t._fillcolor && "string" == typeof t._fillcolor && (l = [0]);
                      return i.size < 0 && (o.reverse(), l.reverse()), {
                        line: o,
                        fill: l
                      };
                    }(0, t, V),
                    W = Z.fill,
                    J = Z.line,
                    X = Math.round(m * ("fraction" === _ ? o ? F.w : F.h : 1)),
                    K = X / (o ? F.w : F.h),
                    Q = Math.round(s * ("fraction" === d ? o ? F.h : F.w : 1)),
                    $ = Q / (o ? F.h : F.w),
                    ee = R ? F.w : r._fullLayout.width,
                    te = E ? F.h : r._fullLayout.height,
                    re = Math.round(o ? z * ee + D : I * te + P),
                    ne = {
                      center: .5,
                      right: 1
                    }[C] || 0,
                    ae = {
                      top: 1,
                      middle: .5
                    }[O] || 0,
                    ie = o ? z - ne * K : I - ae * K,
                    oe = o ? I - ae * $ : z - ne * $,
                    le = Math.round(o ? te * (1 - oe) : ee * oe);
                  t._lenFrac = $, t._thickFrac = K, t._uFrac = ie, t._vFrac = oe;
                  var se = t._axis = function (e, t, r) {
                    var n = e._fullLayout,
                      a = "v" === t.orientation,
                      i = {
                        type: "linear",
                        range: r,
                        tickmode: t.tickmode,
                        nticks: t.nticks,
                        tick0: t.tick0,
                        dtick: t.dtick,
                        tickvals: t.tickvals,
                        ticktext: t.ticktext,
                        ticks: t.ticks,
                        ticklen: t.ticklen,
                        tickwidth: t.tickwidth,
                        tickcolor: t.tickcolor,
                        showticklabels: t.showticklabels,
                        labelalias: t.labelalias,
                        ticklabelposition: t.ticklabelposition,
                        ticklabeloverflow: t.ticklabeloverflow,
                        ticklabelstep: t.ticklabelstep,
                        tickfont: t.tickfont,
                        tickangle: t.tickangle,
                        tickformat: t.tickformat,
                        exponentformat: t.exponentformat,
                        minexponent: t.minexponent,
                        separatethousands: t.separatethousands,
                        showexponent: t.showexponent,
                        showtickprefix: t.showtickprefix,
                        tickprefix: t.tickprefix,
                        showticksuffix: t.showticksuffix,
                        ticksuffix: t.ticksuffix,
                        title: t.title,
                        showline: !0,
                        anchor: "free",
                        side: a ? "right" : "bottom",
                        position: 1
                      },
                      o = a ? "y" : "x",
                      l = {
                        type: "linear",
                        _id: o + t._id
                      },
                      s = {
                        letter: o,
                        font: n.font,
                        noAutotickangles: "y" === o,
                        noHover: !0,
                        noTickson: !0,
                        noTicklabelmode: !0,
                        noInsideRange: !0,
                        calendar: n.calendar
                      };
                    function u(e, t) {
                      return c.coerce(i, l, b, e, t);
                    }
                    return y(i, l, u, s, n), x(i, l, u, s), l;
                  }(r, t, V);
                  se.position = K + (o ? z + D / F.w : I + P / F.h);
                  var ce = -1 !== ["top", "bottom"].indexOf(Y);
                  if (o && ce && (se.title.side = Y, se.titlex = z + D / F.w, se.titley = oe + ("top" === j.side ? $ - P / F.h : P / F.h)), o || ce || (se.title.side = Y, se.titley = I + P / F.h, se.titlex = oe + D / F.w), B.color && "auto" === t.tickmode) {
                    se.tickmode = "linear", se.tick0 = G.start;
                    var ue = G.size,
                      fe = c.constrain(Q / 50, 4, 15) + 1,
                      de = (V[1] - V[0]) / ((t.nticks || fe) * ue);
                    if (de > 1) {
                      var he = Math.pow(10, Math.floor(Math.log(de) / Math.LN10));
                      ue *= he * c.roundUp(de / he, [2, 5, 10]), (Math.abs(G.start) / G.size + 1e-6) % 1 < 2e-6 && (se.tick0 = 0);
                    }
                    se.dtick = ue;
                  }
                  se.domain = o ? [oe + P / F.h, oe + $ - P / F.h] : [oe + D / F.w, oe + $ - D / F.w], se.setScale(), e.attr("transform", u(Math.round(F.l), Math.round(F.t)));
                  var pe,
                    ve = e.select("." + k.cbtitleunshift).attr("transform", u(-Math.round(F.l), -Math.round(F.t))),
                    ge = se.ticklabelposition,
                    me = se.title.font.size,
                    ye = e.select("." + k.cbaxis),
                    xe = 0,
                    be = 0;
                  function _e(n, a) {
                    var i = {
                        propContainer: se,
                        propName: t._propPrefix + "title",
                        traceIndex: t._traceIndex,
                        _meta: t._meta,
                        placeholder: N._dfltTitle.colorbar,
                        containerGroup: e.select("." + k.cbtitle)
                      },
                      o = "h" === n.charAt(0) ? n.substr(1) : "h" + n;
                    e.selectAll("." + o + ",." + o + "-math-group").remove(), v.draw(r, n, f(i, a || {}));
                  }
                  return c.syncOrAsync([i.previousPromises, function () {
                    var e, t;
                    (o && ce || !o && !ce) && ("top" === Y && (e = D + F.l + ee * z, t = P + F.t + te * (1 - oe - $) + 3 + .75 * me), "bottom" === Y && (e = D + F.l + ee * z, t = P + F.t + te * (1 - oe) - 3 - .25 * me), "right" === Y && (t = P + F.t + te * I + 3 + .75 * me, e = D + F.l + ee * oe), _e(se._id + "title", {
                      attributes: {
                        x: e,
                        y: t,
                        "text-anchor": o ? "start" : "middle"
                      }
                    }));
                  }, function () {
                    if (!o && !ce || o && ce) {
                      var i,
                        s = e.select("." + k.cbtitle),
                        f = s.select("text"),
                        d = [-A / 2, A / 2],
                        p = s.select(".h" + se._id + "title-math-group").node(),
                        v = 15.6;
                      if (f.node() && (v = parseInt(f.node().style.fontSize, 10) * w), p ? (i = h.bBox(p), be = i.width, (xe = i.height) > v && (d[1] -= (xe - v) / 2)) : f.node() && !f.classed(k.jsPlaceholder) && (i = h.bBox(f.node()), be = i.width, xe = i.height), o) {
                        if (xe) {
                          if (xe += 5, "top" === Y) se.domain[1] -= xe / F.h, d[1] *= -1;else {
                            se.domain[0] += xe / F.h;
                            var m = g.lineCount(f);
                            d[1] += (1 - m) * v;
                          }
                          s.attr("transform", u(d[0], d[1])), se.setScale();
                        }
                      } else be && ("right" === Y && (se.domain[0] += (be + me / 2) / F.w), s.attr("transform", u(d[0], d[1])), se.setScale());
                    }
                    e.selectAll("." + k.cbfills + ",." + k.cblines).attr("transform", o ? u(0, Math.round(F.h * (1 - se.domain[1]))) : u(Math.round(F.w * se.domain[0]), 0)), ye.attr("transform", o ? u(0, Math.round(-F.t)) : u(Math.round(-F.l), 0));
                    var y = e.select("." + k.cbfills).selectAll("rect." + k.cbfill).attr("style", "").data(W);
                    y.enter().append("rect").classed(k.cbfill, !0).attr("style", ""), y.exit().remove();
                    var x = V.map(se.c2p).map(Math.round).sort(function (e, t) {
                      return e - t;
                    });
                    y.each(function (e, i) {
                      var l = [0 === i ? V[0] : (W[i] + W[i - 1]) / 2, i === W.length - 1 ? V[1] : (W[i] + W[i + 1]) / 2].map(se.c2p).map(Math.round);
                      o && (l[1] = c.constrain(l[1] + (l[1] > l[0]) ? 1 : -1, x[0], x[1]));
                      var s = n.select(this).attr(o ? "x" : "y", re).attr(o ? "y" : "x", n.min(l)).attr(o ? "width" : "height", Math.max(X, 2)).attr(o ? "height" : "width", Math.max(n.max(l) - n.min(l), 2));
                      if (t._fillgradient) h.gradient(s, r, t._id, o ? "vertical" : "horizontalreversed", t._fillgradient, "fill");else {
                        var u = q(e).replace("e-", "");
                        s.attr("fill", a(u).toHexString());
                      }
                    });
                    var b = e.select("." + k.cblines).selectAll("path." + k.cbline).data(B.color && B.width ? J : []);
                    b.enter().append("path").classed(k.cbline, !0), b.exit().remove(), b.each(function (e) {
                      var t = re,
                        r = Math.round(se.c2p(e)) + B.width / 2 % 1;
                      n.select(this).attr("d", "M" + (o ? t + "," + r : r + "," + t) + (o ? "h" : "v") + X).call(h.lineGroupStyle, B.width, U(e), B.dash);
                    }), ye.selectAll("g." + se._id + "tick,path").remove();
                    var _ = re + X + (A || 0) / 2 - ("outside" === t.ticks ? 1 : 0),
                      T = l.calcTicks(se),
                      M = l.getTickSigns(se)[2];
                    return l.drawTicks(r, se, {
                      vals: "inside" === se.ticks ? l.clipEnds(se, T) : T,
                      layer: ye,
                      path: l.makeTickPath(se, _, M),
                      transFn: l.makeTransTickFn(se)
                    }), l.drawLabels(r, se, {
                      vals: T,
                      layer: ye,
                      transFn: l.makeTransTickLabelFn(se),
                      labelFns: l.makeLabelFns(se, _)
                    });
                  }, function () {
                    if (o && !ce || !o && ce) {
                      var e,
                        a,
                        i = se.position || 0,
                        l = se._offset + se._length / 2;
                      if ("right" === Y) a = l, e = F.l + ee * i + 10 + me * (se.showticklabels ? 1 : .5);else if (e = l, "bottom" === Y && (a = F.t + te * i + 10 + (-1 === ge.indexOf("inside") ? se.tickfont.size : 0) + ("intside" !== se.ticks && t.ticklen || 0)), "top" === Y) {
                        var s = j.text.split("<br>").length;
                        a = F.t + te * i + 10 - X - w * me * s;
                      }
                      _e((o ? "h" : "v") + se._id + "title", {
                        avoid: {
                          selection: n.select(r).selectAll("g." + se._id + "tick"),
                          side: Y,
                          offsetTop: o ? 0 : F.t,
                          offsetLeft: o ? F.l : 0,
                          maxShift: o ? N.width : N.height
                        },
                        attributes: {
                          x: e,
                          y: a,
                          "text-anchor": "middle"
                        },
                        transform: {
                          rotate: o ? -90 : 0,
                          offset: 0
                        }
                      });
                    }
                  }, i.previousPromises, function () {
                    var n,
                      l = X + A / 2;
                    -1 === ge.indexOf("inside") && (n = h.bBox(ye.node()), l += o ? n.width : n.height), pe = ve.select("text");
                    var c = 0,
                      f = o && "top" === Y,
                      v = !o && "right" === Y,
                      g = 0;
                    if (pe.node() && !pe.classed(k.jsPlaceholder)) {
                      var y,
                        x = ve.select(".h" + se._id + "title-math-group").node();
                      x && (o && ce || !o && !ce) ? (c = (n = h.bBox(x)).width, y = n.height) : (c = (n = h.bBox(ve.node())).right - F.l - (o ? re : le), y = n.bottom - F.t - (o ? le : re), o || "top" !== Y || (l += n.height, g = n.height)), v && (pe.attr("transform", u(c / 2 + me / 2, 0)), c *= 2), l = Math.max(l, o ? c : y);
                    }
                    var b = 2 * (o ? D : P) + l + L + A / 2,
                      w = 0;
                    !o && j.text && "bottom" === O && I <= 0 && (b += w = b / 2, g += w), N._hColorbarMoveTitle = w, N._hColorbarMoveCBTitle = g;
                    var H = L + A,
                      B = (o ? re : le) - H / 2 - (o ? D : 0),
                      V = (o ? le : re) - (o ? Q : P + g - w);
                    e.select("." + k.cbbg).attr("x", B).attr("y", V).attr(o ? "width" : "height", Math.max(b - w, 2)).attr(o ? "height" : "width", Math.max(Q + H, 2)).call(p.fill, S).call(p.stroke, t.bordercolor).style("stroke-width", L);
                    var U = v ? Math.max(c - 10, 0) : 0;
                    e.selectAll("." + k.cboutline).attr("x", (o ? re : le + D) + U).attr("y", (o ? le + P - Q : re) + (f ? xe : 0)).attr(o ? "width" : "height", Math.max(X, 2)).attr(o ? "height" : "width", Math.max(Q - (o ? 2 * P + xe : 2 * D + U), 2)).call(p.stroke, t.outlinecolor).style({
                      fill: "none",
                      "stroke-width": A
                    });
                    var q = o ? ne * b : 0,
                      G = o ? 0 : (1 - ae) * b - g;
                    if (q = R ? F.l - q : -q, G = E ? F.t - G : -G, e.attr("transform", u(q, G)), !o && (L || a(S).getAlpha() && !a.equals(N.paper_bgcolor, S))) {
                      var Z = ye.selectAll("text"),
                        W = Z[0].length,
                        J = e.select("." + k.cbbg).node(),
                        K = h.bBox(J),
                        $ = h.getTranslate(e);
                      Z.each(function (e, t) {
                        var r = W - 1;
                        if (0 === t || t === r) {
                          var n,
                            a = h.bBox(this),
                            i = h.getTranslate(this);
                          if (t === r) {
                            var o = a.right + i.x;
                            (n = K.right + $.x + le - L - 2 + z - o) > 0 && (n = 0);
                          } else if (0 === t) {
                            var l = a.left + i.x;
                            (n = K.left + $.x + le + L + 2 - l) < 0 && (n = 0);
                          }
                          n && (W < 3 ? this.setAttribute("transform", "translate(" + n + ",0) " + this.getAttribute("transform")) : this.setAttribute("visibility", "hidden"));
                        }
                      });
                    }
                    var ee = {},
                      te = T[C],
                      ie = M[C],
                      oe = T[O],
                      ue = M[O],
                      fe = b - X;
                    o ? ("pixels" === d ? (ee.y = I, ee.t = Q * oe, ee.b = Q * ue) : (ee.t = ee.b = 0, ee.yt = I + s * oe, ee.yb = I - s * ue), "pixels" === _ ? (ee.x = z, ee.l = b * te, ee.r = b * ie) : (ee.l = fe * te, ee.r = fe * ie, ee.xl = z - m * te, ee.xr = z + m * ie)) : ("pixels" === d ? (ee.x = z, ee.l = Q * te, ee.r = Q * ie) : (ee.l = ee.r = 0, ee.xl = z + s * te, ee.xr = z - s * ie), "pixels" === _ ? (ee.y = 1 - I, ee.t = b * oe, ee.b = b * ue) : (ee.t = fe * oe, ee.b = fe * ue, ee.yt = I - m * oe, ee.yb = I + m * ue));
                    var de = t.y < .5 ? "b" : "t",
                      he = t.x < .5 ? "l" : "r";
                    r._fullLayout._reservedMargin[t._id] = {};
                    var be = {
                      r: N.width - B - q,
                      l: B + ee.r,
                      b: N.height - V - G,
                      t: V + ee.b
                    };
                    R && E ? i.autoMargin(r, t._id, ee) : R ? r._fullLayout._reservedMargin[t._id][de] = be[de] : E || o ? r._fullLayout._reservedMargin[t._id][he] = be[he] : r._fullLayout._reservedMargin[t._id][de] = be[de];
                  }], r);
                }(r, t, e);
                m && m.then && (e._promises || []).push(m), e._context.edits.colorbarPosition && function (e, t, r) {
                  var n,
                    a,
                    i,
                    l = "v" === t.orientation,
                    c = r._fullLayout._size;
                  s.init({
                    element: e.node(),
                    gd: r,
                    prepFn: function () {
                      n = e.attr("transform"), d(e);
                    },
                    moveFn: function (r, o) {
                      e.attr("transform", n + u(r, o)), a = s.align((l ? t._uFrac : t._vFrac) + r / c.w, l ? t._thickFrac : t._lenFrac, 0, 1, t.xanchor), i = s.align((l ? t._vFrac : 1 - t._uFrac) - o / c.h, l ? t._lenFrac : t._thickFrac, 0, 1, t.yanchor);
                      var f = s.getCursor(a, i, t.xanchor, t.yanchor);
                      d(e, f);
                    },
                    doneFn: function () {
                      if (d(e), void 0 !== a && void 0 !== i) {
                        var n = {};
                        n[t._propPrefix + "x"] = a, n[t._propPrefix + "y"] = i, void 0 !== t._traceIndex ? o.call("_guiRestyle", r, n, t._traceIndex) : o.call("_guiRelayout", r, n);
                      }
                    }
                  });
                }(r, t, e);
              }), t.exit().each(function (t) {
                i.autoMargin(e, t._id);
              }).remove(), t.order();
            }
          };
        },
        1362: function (e, t, r) {
          "use strict";

          var n = r(4809);
          e.exports = function (e) {
            return n.isPlainObject(e.colorbar);
          };
        },
        6919: function (e, t, r) {
          "use strict";

          e.exports = {
            moduleType: "component",
            name: "colorbar",
            attributes: r(5158),
            supplyDefaults: r(2097),
            draw: r(5881).draw,
            hasColorbar: r(1362)
          };
        },
        7163: function (e, t, r) {
          "use strict";

          var n = r(5158),
            a = r(694).counter,
            i = r(2994),
            o = r(9017).scales;
          function l(e) {
            return "`" + e + "`";
          }
          i(o), e.exports = function (e, t) {
            e = e || "";
            var r,
              i = (t = t || {}).cLetter || "c",
              s = ("onlyIfNumerical" in t ? t.onlyIfNumerical : Boolean(e), "noScale" in t ? t.noScale : "marker.line" === e),
              c = "showScaleDflt" in t ? t.showScaleDflt : "z" === i,
              u = "string" == typeof t.colorscaleDflt ? o[t.colorscaleDflt] : null,
              f = t.editTypeOverride || "",
              d = e ? e + "." : "";
            "colorAttr" in t ? (r = t.colorAttr, t.colorAttr) : l(d + (r = {
              z: "z",
              c: "color"
            }[i]));
            var h = i + "auto",
              p = i + "min",
              v = i + "max",
              g = i + "mid",
              m = (l(d + h), l(d + p), l(d + v), {});
            m[p] = m[v] = void 0;
            var y = {};
            y[h] = !1;
            var x = {};
            return "color" === r && (x.color = {
              valType: "color",
              arrayOk: !0,
              editType: f || "style"
            }, t.anim && (x.color.anim = !0)), x[h] = {
              valType: "boolean",
              dflt: !0,
              editType: "calc",
              impliedEdits: m
            }, x[p] = {
              valType: "number",
              dflt: null,
              editType: f || "plot",
              impliedEdits: y
            }, x[v] = {
              valType: "number",
              dflt: null,
              editType: f || "plot",
              impliedEdits: y
            }, x[g] = {
              valType: "number",
              dflt: null,
              editType: "calc",
              impliedEdits: m
            }, x.colorscale = {
              valType: "colorscale",
              editType: "calc",
              dflt: u,
              impliedEdits: {
                autocolorscale: !1
              }
            }, x.autocolorscale = {
              valType: "boolean",
              dflt: !1 !== t.autoColorDflt,
              editType: "calc",
              impliedEdits: {
                colorscale: void 0
              }
            }, x.reversescale = {
              valType: "boolean",
              dflt: !1,
              editType: "plot"
            }, s || (x.showscale = {
              valType: "boolean",
              dflt: c,
              editType: "calc"
            }, x.colorbar = n), t.noColorAxis || (x.coloraxis = {
              valType: "subplotid",
              regex: a("coloraxis"),
              dflt: null,
              editType: "calc"
            }), x;
          };
        },
        8379: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809),
            i = r(5477).extractOpts;
          e.exports = function (e, t, r) {
            var o,
              l = e._fullLayout,
              s = r.vals,
              c = r.containerStr,
              u = c ? a.nestedProperty(t, c).get() : t,
              f = i(u),
              d = !1 !== f.auto,
              h = f.min,
              p = f.max,
              v = f.mid,
              g = function () {
                return a.aggNums(Math.min, null, s);
              },
              m = function () {
                return a.aggNums(Math.max, null, s);
              };
            void 0 === h ? h = g() : d && (h = u._colorAx && n(h) ? Math.min(h, g()) : g()), void 0 === p ? p = m() : d && (p = u._colorAx && n(p) ? Math.max(p, m()) : m()), d && void 0 !== v && (p - v > v - h ? h = v - (p - v) : p - v < v - h && (p = v + (v - h))), h === p && (h -= .5, p += .5), f._sync("min", h), f._sync("max", p), f.autocolorscale && (o = h * p < 0 ? l.colorscale.diverging : h >= 0 ? l.colorscale.sequential : l.colorscale.sequentialminus, f._sync("colorscale", o));
          };
        },
        7623: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(5477).hasColorscale,
            i = r(5477).extractOpts;
          e.exports = function (e, t) {
            function r(e, t) {
              var r = e["_" + t];
              void 0 !== r && (e[t] = r);
            }
            function o(e, a) {
              var o = a.container ? n.nestedProperty(e, a.container).get() : e;
              if (o) if (o.coloraxis) o._colorAx = t[o.coloraxis];else {
                var l = i(o),
                  s = l.auto;
                (s || void 0 === l.min) && r(o, a.min), (s || void 0 === l.max) && r(o, a.max), l.autocolorscale && r(o, "colorscale");
              }
            }
            for (var l = 0; l < e.length; l++) {
              var s = e[l],
                c = s._module.colorbar;
              if (c) if (Array.isArray(c)) for (var u = 0; u < c.length; u++) o(s, c[u]);else o(s, c);
              a(s, "marker.line") && o(s, {
                container: "marker.line",
                min: "cmin",
                max: "cmax"
              });
            }
            for (var f in t._colorAxes) o(t[f], {
              min: "cmin",
              max: "cmax"
            });
          };
        },
        9356: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809),
            i = r(1362),
            o = r(2097),
            l = r(9017).isValid,
            s = r(3626).traceIs;
          function c(e, t) {
            var r = t.slice(0, t.length - 1);
            return t ? a.nestedProperty(e, r).get() || {} : e;
          }
          e.exports = function e(t, r, u, f, d) {
            var h = d.prefix,
              p = d.cLetter,
              v = "_module" in r,
              g = c(t, h),
              m = c(r, h),
              y = c(r._template || {}, h) || {},
              x = function () {
                return delete t.coloraxis, delete r.coloraxis, e(t, r, u, f, d);
              };
            if (v) {
              var b = u._colorAxes || {},
                _ = f(h + "coloraxis");
              if (_) {
                var w = s(r, "contour") && a.nestedProperty(r, "contours.coloring").get() || "heatmap",
                  T = b[_];
                return void (T ? (T[2].push(x), T[0] !== w && (T[0] = !1, a.warn(["Ignoring coloraxis:", _, "setting", "as it is linked to incompatible colorscales."].join(" ")))) : b[_] = [w, r, [x]]);
              }
            }
            var M = g[p + "min"],
              k = g[p + "max"],
              A = n(M) && n(k) && M < k;
            f(h + p + "auto", !A) ? f(h + p + "mid") : (f(h + p + "min"), f(h + p + "max"));
            var L,
              S,
              C = g.colorscale,
              O = y.colorscale;
            void 0 !== C && (L = !l(C)), void 0 !== O && (L = !l(O)), f(h + "autocolorscale", L), f(h + "colorscale"), f(h + "reversescale"), "marker.line." !== h && (h && v && (S = i(g)), f(h + "showscale", S) && (h && y && (m._template = y), o(g, m, u)));
          };
        },
        5477: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(5657),
            i = r(721),
            o = r(4809),
            l = r(8766),
            s = r(9017).isValid,
            c = ["showscale", "autocolorscale", "colorscale", "reversescale", "colorbar"],
            u = ["min", "max", "mid", "auto"];
          function f(e) {
            var t,
              r,
              n,
              a = e._colorAx,
              i = a || e,
              o = {};
            for (r = 0; r < c.length; r++) o[n = c[r]] = i[n];
            if (a) for (t = "c", r = 0; r < u.length; r++) o[n = u[r]] = i["c" + n];else {
              var l;
              for (r = 0; r < u.length; r++) ((l = "c" + (n = u[r])) in i || (l = "z" + n) in i) && (o[n] = i[l]);
              t = l.charAt(0);
            }
            return o._sync = function (e, r) {
              var n = -1 !== u.indexOf(e) ? t + e : e;
              i[n] = i["_" + n] = r;
            }, o;
          }
          function d(e) {
            for (var t = f(e), r = t.min, n = t.max, a = t.reversescale ? h(t.colorscale) : t.colorscale, i = a.length, o = new Array(i), l = new Array(i), s = 0; s < i; s++) {
              var c = a[s];
              o[s] = r + c[0] * (n - r), l[s] = c[1];
            }
            return {
              domain: o,
              range: l
            };
          }
          function h(e) {
            for (var t = e.length, r = new Array(t), n = t - 1, a = 0; n >= 0; n--, a++) {
              var i = e[n];
              r[a] = [1 - i[0], i[1]];
            }
            return r;
          }
          function p(e, t) {
            t = t || {};
            for (var r = e.domain, o = e.range, s = o.length, c = new Array(s), u = 0; u < s; u++) {
              var f = a(o[u]).toRgb();
              c[u] = [f.r, f.g, f.b, f.a];
            }
            var d,
              h = n.scale.linear().domain(r).range(c).clamp(!0),
              p = t.noNumericCheck,
              g = t.returnArray;
            return (d = p && g ? h : p ? function (e) {
              return v(h(e));
            } : g ? function (e) {
              return i(e) ? h(e) : a(e).isValid() ? e : l.defaultLine;
            } : function (e) {
              return i(e) ? v(h(e)) : a(e).isValid() ? e : l.defaultLine;
            }).domain = h.domain, d.range = function () {
              return o;
            }, d;
          }
          function v(e) {
            var t = {
              r: e[0],
              g: e[1],
              b: e[2],
              a: e[3]
            };
            return a(t).toRgbString();
          }
          e.exports = {
            hasColorscale: function (e, t, r) {
              var n = t ? o.nestedProperty(e, t).get() || {} : e,
                a = n[r || "color"];
              a && a._inputArray && (a = a._inputArray);
              var l = !1;
              if (o.isArrayOrTypedArray(a)) for (var c = 0; c < a.length; c++) if (i(a[c])) {
                l = !0;
                break;
              }
              return o.isPlainObject(n) && (l || !0 === n.showscale || i(n.cmin) && i(n.cmax) || s(n.colorscale) || o.isPlainObject(n.colorbar));
            },
            extractOpts: f,
            extractScale: d,
            flipScale: h,
            makeColorScaleFunc: p,
            makeColorScaleFuncFromTrace: function (e, t) {
              return p(d(e), t);
            }
          };
        },
        8856: function (e, t, r) {
          "use strict";

          var n = r(9017),
            a = r(5477);
          e.exports = {
            moduleType: "component",
            name: "colorscale",
            attributes: r(7163),
            layoutAttributes: r(6978),
            supplyLayoutDefaults: r(4613),
            handleDefaults: r(9356),
            crossTraceDefaults: r(7623),
            calc: r(8379),
            scales: n.scales,
            defaultScale: n.defaultScale,
            getScale: n.get,
            isValidScale: n.isValid,
            hasColorscale: a.hasColorscale,
            extractOpts: a.extractOpts,
            extractScale: a.extractScale,
            flipScale: a.flipScale,
            makeColorScaleFunc: a.makeColorScaleFunc,
            makeColorScaleFuncFromTrace: a.makeColorScaleFuncFromTrace
          };
        },
        6978: function (e, t, r) {
          "use strict";

          var n = r(3049).extendFlat,
            a = r(7163),
            i = r(9017).scales;
          e.exports = {
            editType: "calc",
            colorscale: {
              editType: "calc",
              sequential: {
                valType: "colorscale",
                dflt: i.Reds,
                editType: "calc"
              },
              sequentialminus: {
                valType: "colorscale",
                dflt: i.Blues,
                editType: "calc"
              },
              diverging: {
                valType: "colorscale",
                dflt: i.RdBu,
                editType: "calc"
              }
            },
            coloraxis: n({
              _isSubplotObj: !0,
              editType: "calc"
            }, a("", {
              colorAttr: "corresponding trace color array(s)",
              noColorAxis: !0,
              showScaleDflt: !0
            }))
          };
        },
        4613: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8032),
            i = r(6978),
            o = r(9356);
          e.exports = function (e, t) {
            function r(r, a) {
              return n.coerce(e, t, i, r, a);
            }
            r("colorscale.sequential"), r("colorscale.sequentialminus"), r("colorscale.diverging");
            var l,
              s,
              c = t._colorAxes;
            function u(e, t) {
              return n.coerce(l, s, i.coloraxis, e, t);
            }
            for (var f in c) {
              var d = c[f];
              if (d[0]) l = e[f] || {}, (s = a.newContainer(t, f, "coloraxis"))._name = f, o(l, s, t, u, {
                prefix: "",
                cLetter: "c"
              });else {
                for (var h = 0; h < d[2].length; h++) d[2][h]();
                delete t._colorAxes[f];
              }
            }
          };
        },
        9017: function (e, t, r) {
          "use strict";

          var n = r(5657),
            a = {
              Greys: [[0, "rgb(0,0,0)"], [1, "rgb(255,255,255)"]],
              YlGnBu: [[0, "rgb(8,29,88)"], [.125, "rgb(37,52,148)"], [.25, "rgb(34,94,168)"], [.375, "rgb(29,145,192)"], [.5, "rgb(65,182,196)"], [.625, "rgb(127,205,187)"], [.75, "rgb(199,233,180)"], [.875, "rgb(237,248,217)"], [1, "rgb(255,255,217)"]],
              Greens: [[0, "rgb(0,68,27)"], [.125, "rgb(0,109,44)"], [.25, "rgb(35,139,69)"], [.375, "rgb(65,171,93)"], [.5, "rgb(116,196,118)"], [.625, "rgb(161,217,155)"], [.75, "rgb(199,233,192)"], [.875, "rgb(229,245,224)"], [1, "rgb(247,252,245)"]],
              YlOrRd: [[0, "rgb(128,0,38)"], [.125, "rgb(189,0,38)"], [.25, "rgb(227,26,28)"], [.375, "rgb(252,78,42)"], [.5, "rgb(253,141,60)"], [.625, "rgb(254,178,76)"], [.75, "rgb(254,217,118)"], [.875, "rgb(255,237,160)"], [1, "rgb(255,255,204)"]],
              Bluered: [[0, "rgb(0,0,255)"], [1, "rgb(255,0,0)"]],
              RdBu: [[0, "rgb(5,10,172)"], [.35, "rgb(106,137,247)"], [.5, "rgb(190,190,190)"], [.6, "rgb(220,170,132)"], [.7, "rgb(230,145,90)"], [1, "rgb(178,10,28)"]],
              Reds: [[0, "rgb(220,220,220)"], [.2, "rgb(245,195,157)"], [.4, "rgb(245,160,105)"], [1, "rgb(178,10,28)"]],
              Blues: [[0, "rgb(5,10,172)"], [.35, "rgb(40,60,190)"], [.5, "rgb(70,100,245)"], [.6, "rgb(90,120,245)"], [.7, "rgb(106,137,247)"], [1, "rgb(220,220,220)"]],
              Picnic: [[0, "rgb(0,0,255)"], [.1, "rgb(51,153,255)"], [.2, "rgb(102,204,255)"], [.3, "rgb(153,204,255)"], [.4, "rgb(204,204,255)"], [.5, "rgb(255,255,255)"], [.6, "rgb(255,204,255)"], [.7, "rgb(255,153,255)"], [.8, "rgb(255,102,204)"], [.9, "rgb(255,102,102)"], [1, "rgb(255,0,0)"]],
              Rainbow: [[0, "rgb(150,0,90)"], [.125, "rgb(0,0,200)"], [.25, "rgb(0,25,255)"], [.375, "rgb(0,152,255)"], [.5, "rgb(44,255,150)"], [.625, "rgb(151,255,0)"], [.75, "rgb(255,234,0)"], [.875, "rgb(255,111,0)"], [1, "rgb(255,0,0)"]],
              Portland: [[0, "rgb(12,51,131)"], [.25, "rgb(10,136,186)"], [.5, "rgb(242,211,56)"], [.75, "rgb(242,143,56)"], [1, "rgb(217,30,30)"]],
              Jet: [[0, "rgb(0,0,131)"], [.125, "rgb(0,60,170)"], [.375, "rgb(5,255,255)"], [.625, "rgb(255,255,0)"], [.875, "rgb(250,0,0)"], [1, "rgb(128,0,0)"]],
              Hot: [[0, "rgb(0,0,0)"], [.3, "rgb(230,0,0)"], [.6, "rgb(255,210,0)"], [1, "rgb(255,255,255)"]],
              Blackbody: [[0, "rgb(0,0,0)"], [.2, "rgb(230,0,0)"], [.4, "rgb(230,210,0)"], [.7, "rgb(255,255,255)"], [1, "rgb(160,200,255)"]],
              Earth: [[0, "rgb(0,0,130)"], [.1, "rgb(0,180,180)"], [.2, "rgb(40,210,40)"], [.4, "rgb(230,230,50)"], [.6, "rgb(120,70,20)"], [1, "rgb(255,255,255)"]],
              Electric: [[0, "rgb(0,0,0)"], [.15, "rgb(30,0,100)"], [.4, "rgb(120,0,100)"], [.6, "rgb(160,90,0)"], [.8, "rgb(230,200,0)"], [1, "rgb(255,250,220)"]],
              Viridis: [[0, "#440154"], [.06274509803921569, "#48186a"], [.12549019607843137, "#472d7b"], [.18823529411764706, "#424086"], [.25098039215686274, "#3b528b"], [.3137254901960784, "#33638d"], [.3764705882352941, "#2c728e"], [.4392156862745098, "#26828e"], [.5019607843137255, "#21918c"], [.5647058823529412, "#1fa088"], [.6274509803921569, "#28ae80"], [.6901960784313725, "#3fbc73"], [.7529411764705882, "#5ec962"], [.8156862745098039, "#84d44b"], [.8784313725490196, "#addc30"], [.9411764705882353, "#d8e219"], [1, "#fde725"]],
              Cividis: [[0, "rgb(0,32,76)"], [.058824, "rgb(0,42,102)"], [.117647, "rgb(0,52,110)"], [.176471, "rgb(39,63,108)"], [.235294, "rgb(60,74,107)"], [.294118, "rgb(76,85,107)"], [.352941, "rgb(91,95,109)"], [.411765, "rgb(104,106,112)"], [.470588, "rgb(117,117,117)"], [.529412, "rgb(131,129,120)"], [.588235, "rgb(146,140,120)"], [.647059, "rgb(161,152,118)"], [.705882, "rgb(176,165,114)"], [.764706, "rgb(192,177,109)"], [.823529, "rgb(209,191,102)"], [.882353, "rgb(225,204,92)"], [.941176, "rgb(243,219,79)"], [1, "rgb(255,233,69)"]]
            },
            i = a.RdBu;
          function o(e) {
            var t = 0;
            if (!Array.isArray(e) || e.length < 2) return !1;
            if (!e[0] || !e[e.length - 1]) return !1;
            if (0 != +e[0][0] || 1 != +e[e.length - 1][0]) return !1;
            for (var r = 0; r < e.length; r++) {
              var a = e[r];
              if (2 !== a.length || +a[0] < t || !n(a[1]).isValid()) return !1;
              t = +a[0];
            }
            return !0;
          }
          e.exports = {
            scales: a,
            defaultScale: i,
            get: function (e, t) {
              if (t || (t = i), !e) return t;
              function r() {
                try {
                  e = a[e] || JSON.parse(e);
                } catch (r) {
                  e = t;
                }
              }
              return "string" == typeof e && (r(), "string" == typeof e && r()), o(e) ? e : t;
            },
            isValid: function (e) {
              return void 0 !== a[e] || o(e);
            }
          };
        },
        3770: function (e) {
          "use strict";

          e.exports = function (e, t, r, n, a) {
            var i = (e - r) / (n - r),
              o = i + t / (n - r),
              l = (i + o) / 2;
            return "left" === a || "bottom" === a ? i : "center" === a || "middle" === a ? l : "right" === a || "top" === a ? o : i < 2 / 3 - l ? i : o > 4 / 3 - l ? o : l;
          };
        },
        4001: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = [["sw-resize", "s-resize", "se-resize"], ["w-resize", "move", "e-resize"], ["nw-resize", "n-resize", "ne-resize"]];
          e.exports = function (e, t, r, i) {
            return e = "left" === r ? 0 : "center" === r ? 1 : "right" === r ? 2 : n.constrain(Math.floor(3 * e), 0, 2), t = "bottom" === i ? 0 : "middle" === i ? 1 : "top" === i ? 2 : n.constrain(Math.floor(3 * t), 0, 2), a[t][e];
          };
        },
        414: function (e, t) {
          "use strict";

          t.selectMode = function (e) {
            return "lasso" === e || "select" === e;
          }, t.drawMode = function (e) {
            return "drawclosedpath" === e || "drawopenpath" === e || "drawline" === e || "drawrect" === e || "drawcircle" === e;
          }, t.openMode = function (e) {
            return "drawline" === e || "drawopenpath" === e;
          }, t.rectMode = function (e) {
            return "select" === e || "drawline" === e || "drawrect" === e || "drawcircle" === e;
          }, t.freeMode = function (e) {
            return "lasso" === e || "drawclosedpath" === e || "drawopenpath" === e;
          }, t.selectingOrDrawing = function (e) {
            return t.freeMode(e) || t.rectMode(e);
          };
        },
        4751: function (e, t, r) {
          "use strict";

          var n = r(4039),
            a = r(9784),
            i = r(4043),
            o = r(4809).removeElement,
            l = r(4826),
            s = e.exports = {};
          s.align = r(3770), s.getCursor = r(4001);
          var c = r(148);
          function u() {
            var e = document.createElement("div");
            e.className = "dragcover";
            var t = e.style;
            return t.position = "fixed", t.left = 0, t.right = 0, t.top = 0, t.bottom = 0, t.zIndex = 999999999, t.background = "none", document.body.appendChild(e), e;
          }
          function f(e) {
            return n(e.changedTouches ? e.changedTouches[0] : e, document.body);
          }
          s.unhover = c.wrapped, s.unhoverRaw = c.raw, s.init = function (e) {
            var t,
              r,
              n,
              c,
              d,
              h,
              p,
              v,
              g = e.gd,
              m = 1,
              y = g._context.doubleClickDelay,
              x = e.element;
            g._mouseDownTime || (g._mouseDownTime = 0), x.style.pointerEvents = "all", x.onmousedown = _, i ? (x._ontouchstart && x.removeEventListener("touchstart", x._ontouchstart), x._ontouchstart = _, x.addEventListener("touchstart", _, {
              passive: !1
            })) : x.ontouchstart = _;
            var b = e.clampFn || function (e, t, r) {
              return Math.abs(e) < r && (e = 0), Math.abs(t) < r && (t = 0), [e, t];
            };
            function _(i) {
              g._dragged = !1, g._dragging = !0;
              var o = f(i);
              t = o[0], r = o[1], p = i.target, h = i, v = 2 === i.buttons || i.ctrlKey, void 0 === i.clientX && void 0 === i.clientY && (i.clientX = t, i.clientY = r), (n = new Date().getTime()) - g._mouseDownTime < y ? m += 1 : (m = 1, g._mouseDownTime = n), e.prepFn && e.prepFn(i, t, r), a && !v ? (d = u()).style.cursor = window.getComputedStyle(x).cursor : a || (d = document, c = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(x).cursor), document.addEventListener("mouseup", T), document.addEventListener("touchend", T), !1 !== e.dragmode && (i.preventDefault(), document.addEventListener("mousemove", w), document.addEventListener("touchmove", w, {
                passive: !1
              }));
            }
            function w(n) {
              n.preventDefault();
              var a = f(n),
                i = e.minDrag || l.MINDRAG,
                o = b(a[0] - t, a[1] - r, i),
                c = o[0],
                u = o[1];
              (c || u) && (g._dragged = !0, s.unhover(g, n)), g._dragged && e.moveFn && !v && (g._dragdata = {
                element: x,
                dx: c,
                dy: u
              }, e.moveFn(c, u));
            }
            function T(t) {
              if (delete g._dragdata, !1 !== e.dragmode && (t.preventDefault(), document.removeEventListener("mousemove", w), document.removeEventListener("touchmove", w)), document.removeEventListener("mouseup", T), document.removeEventListener("touchend", T), a ? o(d) : c && (d.documentElement.style.cursor = c, c = null), g._dragging) {
                if (g._dragging = !1, new Date().getTime() - g._mouseDownTime > y && (m = Math.max(m - 1, 1)), g._dragged) e.doneFn && e.doneFn();else if (e.clickFn && e.clickFn(m, h), !v) {
                  var r;
                  try {
                    r = new MouseEvent("click", t);
                  } catch (e) {
                    var n = f(t);
                    (r = document.createEvent("MouseEvents")).initMouseEvent("click", t.bubbles, t.cancelable, t.view, t.detail, t.screenX, t.screenY, n[0], n[1], t.ctrlKey, t.altKey, t.shiftKey, t.metaKey, t.button, t.relatedTarget);
                  }
                  p.dispatchEvent(r);
                }
                g._dragging = !1, g._dragged = !1;
              } else g._dragged = !1;
            }
          }, s.coverSlip = u;
        },
        148: function (e, t, r) {
          "use strict";

          var n = r(8596),
            a = r(4025),
            i = r(5425).getGraphDiv,
            o = r(5988),
            l = e.exports = {};
          l.wrapped = function (e, t, r) {
            (e = i(e))._fullLayout && a.clear(e._fullLayout._uid + o.HOVERID), l.raw(e, t, r);
          }, l.raw = function (e, t) {
            var r = e._fullLayout,
              a = e._hoverdata;
            t || (t = {}), t.target && !e._dragged && !1 === n.triggerHandler(e, "plotly_beforehover", t) || (r._hoverlayer.selectAll("g").remove(), r._hoverlayer.selectAll("line").remove(), r._hoverlayer.selectAll("circle").remove(), e._hoverdata = void 0, t.target && a && e.emit("plotly_unhover", {
              event: t,
              points: a
            }));
          };
        },
        4850: function (e, t) {
          "use strict";

          t.T = {
            valType: "string",
            values: ["solid", "dot", "dash", "longdash", "dashdot", "longdashdot"],
            dflt: "solid",
            editType: "style"
          }, t.k = {
            shape: {
              valType: "enumerated",
              values: ["", "/", "\\", "x", "-", "|", "+", "."],
              dflt: "",
              arrayOk: !0,
              editType: "style"
            },
            fillmode: {
              valType: "enumerated",
              values: ["replace", "overlay"],
              dflt: "replace",
              editType: "style"
            },
            bgcolor: {
              valType: "color",
              arrayOk: !0,
              editType: "style"
            },
            fgcolor: {
              valType: "color",
              arrayOk: !0,
              editType: "style"
            },
            fgopacity: {
              valType: "number",
              editType: "style",
              min: 0,
              max: 1
            },
            size: {
              valType: "number",
              min: 0,
              dflt: 8,
              arrayOk: !0,
              editType: "style"
            },
            solidity: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: .3,
              arrayOk: !0,
              editType: "style"
            },
            editType: "style"
          };
        },
        2203: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4809),
            i = a.numberFormat,
            o = r(721),
            l = r(5657),
            s = r(3626),
            c = r(8766),
            u = r(8856),
            f = a.strTranslate,
            d = r(635),
            h = r(2972),
            p = r(4530).LINE_SPACING,
            v = r(438).DESELECTDIM,
            g = r(4726),
            m = r(2527),
            y = r(6040).appendArrayPointValue,
            x = e.exports = {};
          function b(e) {
            return "none" === e ? void 0 : e;
          }
          x.font = function (e, t) {
            var r = t.variant,
              n = t.style,
              a = t.weight,
              i = t.color,
              o = t.size,
              l = t.family,
              s = t.shadow,
              u = t.lineposition,
              f = t.textcase;
            l && e.style("font-family", l), o + 1 && e.style("font-size", o + "px"), i && e.call(c.fill, i), a && e.style("font-weight", a), n && e.style("font-style", n), r && e.style("font-variant", r), f && e.style("text-transform", b(function (e) {
              return _[e];
            }(f))), s && e.style("text-shadow", "auto" === s ? d.makeTextShadow(c.contrast(i)) : b(s)), u && e.style("text-decoration-line", b(function (e) {
              return e.replace("under", "underline").replace("over", "overline").replace("through", "line-through").split("+").join(" ");
            }(u)));
          };
          var _ = {
            normal: "none",
            lower: "lowercase",
            upper: "uppercase",
            "word caps": "capitalize"
          };
          function w(e, t, r, n) {
            var a = t.fillpattern,
              i = t.fillgradient,
              o = a && x.getPatternAttr(a.shape, 0, "");
            if (o) {
              var l = x.getPatternAttr(a.bgcolor, 0, null),
                s = x.getPatternAttr(a.fgcolor, 0, null),
                u = a.fgopacity,
                f = x.getPatternAttr(a.size, 0, 8),
                d = x.getPatternAttr(a.solidity, 0, .3),
                h = t.uid;
              x.pattern(e, "point", r, h, o, f, d, void 0, a.fillmode, l, s, u);
            } else if (i && "none" !== i.type) {
              var p,
                v,
                g = i.type,
                m = "scatterfill-" + t.uid;
              n && (m = "legendfill-" + t.uid), n || void 0 === i.start && void 0 === i.stop ? ("horizontal" === g && (g += "reversed"), e.call(x.gradient, r, m, g, i.colorscale, "fill")) : ("horizontal" === g ? (p = {
                x: i.start,
                y: 0
              }, v = {
                x: i.stop,
                y: 0
              }) : "vertical" === g && (p = {
                x: 0,
                y: i.start
              }, v = {
                x: 0,
                y: i.stop
              }), p.x = t._xA.c2p(void 0 === p.x ? t._extremes.x.min[0].val : p.x, !0), p.y = t._yA.c2p(void 0 === p.y ? t._extremes.y.min[0].val : p.y, !0), v.x = t._xA.c2p(void 0 === v.x ? t._extremes.x.max[0].val : v.x, !0), v.y = t._yA.c2p(void 0 === v.y ? t._extremes.y.max[0].val : v.y, !0), e.call(S, r, m, "linear", i.colorscale, "fill", p, v, !0, !1));
            } else t.fillcolor && e.call(c.fill, t.fillcolor);
          }
          x.setPosition = function (e, t, r) {
            e.attr("x", t).attr("y", r);
          }, x.setSize = function (e, t, r) {
            e.attr("width", t).attr("height", r);
          }, x.setRect = function (e, t, r, n, a) {
            e.call(x.setPosition, t, r).call(x.setSize, n, a);
          }, x.translatePoint = function (e, t, r, n) {
            var a = r.c2p(e.x),
              i = n.c2p(e.y);
            return !!(o(a) && o(i) && t.node()) && ("text" === t.node().nodeName ? t.attr("x", a).attr("y", i) : t.attr("transform", f(a, i)), !0);
          }, x.translatePoints = function (e, t, r) {
            e.each(function (e) {
              var a = n.select(this);
              x.translatePoint(e, a, t, r);
            });
          }, x.hideOutsideRangePoint = function (e, t, r, n, a, i) {
            t.attr("display", r.isPtWithinRange(e, a) && n.isPtWithinRange(e, i) ? null : "none");
          }, x.hideOutsideRangePoints = function (e, t) {
            if (t._hasClipOnAxisFalse) {
              var r = t.xaxis,
                a = t.yaxis;
              e.each(function (t) {
                var i = t[0].trace,
                  o = i.xcalendar,
                  l = i.ycalendar,
                  c = s.traceIs(i, "bar-like") ? ".bartext" : ".point,.textpoint";
                e.selectAll(c).each(function (e) {
                  x.hideOutsideRangePoint(e, n.select(this), r, a, o, l);
                });
              });
            }
          }, x.crispRound = function (e, t, r) {
            return t && o(t) ? e._context.staticPlot ? t : t < 1 ? 1 : Math.round(t) : r || 0;
          }, x.singleLineStyle = function (e, t, r, n, a) {
            t.style("fill", "none");
            var i = (((e || [])[0] || {}).trace || {}).line || {},
              o = r || i.width || 0,
              l = a || i.dash || "";
            c.stroke(t, n || i.color), x.dashLine(t, l, o);
          }, x.lineGroupStyle = function (e, t, r, a) {
            e.style("fill", "none").each(function (e) {
              var i = (((e || [])[0] || {}).trace || {}).line || {},
                o = t || i.width || 0,
                l = a || i.dash || "";
              n.select(this).call(c.stroke, r || i.color).call(x.dashLine, l, o);
            });
          }, x.dashLine = function (e, t, r) {
            r = +r || 0, t = x.dashStyle(t, r), e.style({
              "stroke-dasharray": t,
              "stroke-width": r + "px"
            });
          }, x.dashStyle = function (e, t) {
            t = +t || 1;
            var r = Math.max(t, 3);
            return "solid" === e ? e = "" : "dot" === e ? e = r + "px," + r + "px" : "dash" === e ? e = 3 * r + "px," + 3 * r + "px" : "longdash" === e ? e = 5 * r + "px," + 5 * r + "px" : "dashdot" === e ? e = 3 * r + "px," + r + "px," + r + "px," + r + "px" : "longdashdot" === e && (e = 5 * r + "px," + 2 * r + "px," + r + "px," + 2 * r + "px"), e;
          }, x.singleFillStyle = function (e, t) {
            var r = n.select(e.node());
            w(e, ((r.data()[0] || [])[0] || {}).trace || {}, t, !1);
          }, x.fillGroupStyle = function (e, t, r) {
            e.style("stroke-width", 0).each(function (e) {
              var a = n.select(this);
              e[0].trace && w(a, e[0].trace, t, r);
            });
          };
          var T = r(8882);
          x.symbolNames = [], x.symbolFuncs = [], x.symbolBackOffs = [], x.symbolNeedLines = {}, x.symbolNoDot = {}, x.symbolNoFill = {}, x.symbolList = [], Object.keys(T).forEach(function (e) {
            var t = T[e],
              r = t.n;
            x.symbolList.push(r, String(r), e, r + 100, String(r + 100), e + "-open"), x.symbolNames[r] = e, x.symbolFuncs[r] = t.f, x.symbolBackOffs[r] = t.backoff || 0, t.needLine && (x.symbolNeedLines[r] = !0), t.noDot ? x.symbolNoDot[r] = !0 : x.symbolList.push(r + 200, String(r + 200), e + "-dot", r + 300, String(r + 300), e + "-open-dot"), t.noFill && (x.symbolNoFill[r] = !0);
          });
          var M = x.symbolNames.length;
          function k(e, t, r, n) {
            var a = e % 100;
            return x.symbolFuncs[a](t, r, n) + (e >= 200 ? "M0,0.5L0.5,0L0,-0.5L-0.5,0Z" : "");
          }
          x.symbolNumber = function (e) {
            if (o(e)) e = +e;else if ("string" == typeof e) {
              var t = 0;
              e.indexOf("-open") > 0 && (t = 100, e = e.replace("-open", "")), e.indexOf("-dot") > 0 && (t += 200, e = e.replace("-dot", "")), (e = x.symbolNames.indexOf(e)) >= 0 && (e += t);
            }
            return e % 100 >= M || e >= 400 ? 0 : Math.floor(Math.max(e, 0));
          };
          var A = i("~f"),
            L = {
              radial: {
                type: "radial"
              },
              radialreversed: {
                type: "radial",
                reversed: !0
              },
              horizontal: {
                type: "linear",
                start: {
                  x: 1,
                  y: 0
                },
                stop: {
                  x: 0,
                  y: 0
                }
              },
              horizontalreversed: {
                type: "linear",
                start: {
                  x: 1,
                  y: 0
                },
                stop: {
                  x: 0,
                  y: 0
                },
                reversed: !0
              },
              vertical: {
                type: "linear",
                start: {
                  x: 0,
                  y: 1
                },
                stop: {
                  x: 0,
                  y: 0
                }
              },
              verticalreversed: {
                type: "linear",
                start: {
                  x: 0,
                  y: 1
                },
                stop: {
                  x: 0,
                  y: 0
                },
                reversed: !0
              }
            };
          function S(e, t, r, i, o, s, u, f, d, h) {
            var p,
              v = o.length;
            "linear" === i ? p = {
              node: "linearGradient",
              attrs: {
                x1: u.x,
                y1: u.y,
                x2: f.x,
                y2: f.y,
                gradientUnits: d ? "userSpaceOnUse" : "objectBoundingBox"
              },
              reversed: h
            } : "radial" === i && (p = {
              node: "radialGradient",
              reversed: h
            });
            for (var g = new Array(v), m = 0; m < v; m++) p.reversed ? g[v - 1 - m] = [A(100 * (1 - o[m][0])), o[m][1]] : g[m] = [A(100 * o[m][0]), o[m][1]];
            var y = t._fullLayout,
              x = "g" + y._uid + "-" + r,
              b = y._defs.select(".gradients").selectAll("#" + x).data([i + g.join(";")], a.identity);
            b.exit().remove(), b.enter().append(p.node).each(function () {
              var e = n.select(this);
              p.attrs && e.attr(p.attrs), e.attr("id", x);
              var t = e.selectAll("stop").data(g);
              t.exit().remove(), t.enter().append("stop"), t.each(function (e) {
                var t = l(e[1]);
                n.select(this).attr({
                  offset: e[0] + "%",
                  "stop-color": c.tinyRGB(t),
                  "stop-opacity": t.getAlpha()
                });
              });
            }), e.style(s, V(x, t)).style(s + "-opacity", null), e.classed("gradient_filled", !0);
          }
          x.gradient = function (e, t, r, n, a, i) {
            var o = L[n];
            return S(e, t, r, o.type, a, i, o.start, o.stop, !1, o.reversed);
          }, x.pattern = function (e, t, r, i, o, s, u, f, d, h, p, v) {
            var g = "legend" === t;
            f && ("overlay" === d ? (h = f, p = c.contrast(h)) : (h = void 0, p = f));
            var m,
              y,
              x,
              b,
              _,
              w,
              T,
              M,
              k,
              A = r._fullLayout,
              L = "p" + A._uid + "-" + i,
              S = {},
              C = l(p),
              O = c.tinyRGB(C),
              D = v * C.getAlpha();
            switch (o) {
              case "/":
                m = s * Math.sqrt(2), y = s * Math.sqrt(2), w = "path", S = {
                  d: x = "M-" + m / 4 + "," + y / 4 + "l" + m / 2 + ",-" + y / 2 + "M0," + y + "L" + m + ",0M" + m / 4 * 3 + "," + y / 4 * 5 + "l" + m / 2 + ",-" + y / 2,
                  opacity: D,
                  stroke: O,
                  "stroke-width": (b = u * s) + "px"
                };
                break;
              case "\\":
                m = s * Math.sqrt(2), y = s * Math.sqrt(2), w = "path", S = {
                  d: x = "M" + m / 4 * 3 + ",-" + y / 4 + "l" + m / 2 + "," + y / 2 + "M0,0L" + m + "," + y + "M-" + m / 4 + "," + y / 4 * 3 + "l" + m / 2 + "," + y / 2,
                  opacity: D,
                  stroke: O,
                  "stroke-width": (b = u * s) + "px"
                };
                break;
              case "x":
                m = s * Math.sqrt(2), y = s * Math.sqrt(2), x = "M-" + m / 4 + "," + y / 4 + "l" + m / 2 + ",-" + y / 2 + "M0," + y + "L" + m + ",0M" + m / 4 * 3 + "," + y / 4 * 5 + "l" + m / 2 + ",-" + y / 2 + "M" + m / 4 * 3 + ",-" + y / 4 + "l" + m / 2 + "," + y / 2 + "M0,0L" + m + "," + y + "M-" + m / 4 + "," + y / 4 * 3 + "l" + m / 2 + "," + y / 2, b = s - s * Math.sqrt(1 - u), w = "path", S = {
                  d: x,
                  opacity: D,
                  stroke: O,
                  "stroke-width": b + "px"
                };
                break;
              case "|":
                w = "path", w = "path", S = {
                  d: x = "M" + (m = s) / 2 + ",0L" + m / 2 + "," + (y = s),
                  opacity: D,
                  stroke: O,
                  "stroke-width": (b = u * s) + "px"
                };
                break;
              case "-":
                w = "path", w = "path", S = {
                  d: x = "M0," + (y = s) / 2 + "L" + (m = s) + "," + y / 2,
                  opacity: D,
                  stroke: O,
                  "stroke-width": (b = u * s) + "px"
                };
                break;
              case "+":
                w = "path", x = "M" + (m = s) / 2 + ",0L" + m / 2 + "," + (y = s) + "M0," + y / 2 + "L" + m + "," + y / 2, b = s - s * Math.sqrt(1 - u), w = "path", S = {
                  d: x,
                  opacity: D,
                  stroke: O,
                  "stroke-width": b + "px"
                };
                break;
              case ".":
                m = s, y = s, u < Math.PI / 4 ? _ = Math.sqrt(u * s * s / Math.PI) : (T = u, M = Math.PI / 4, 1, _ = (k = s / 2) + (s / Math.sqrt(2) - k) * (T - M) / (1 - M)), w = "circle", S = {
                  cx: m / 2,
                  cy: y / 2,
                  r: _,
                  opacity: D,
                  fill: O
                };
            }
            var P = [o || "noSh", h || "noBg", p || "noFg", s, u].join(";"),
              z = A._defs.select(".patterns").selectAll("#" + L).data([P], a.identity);
            z.exit().remove(), z.enter().append("pattern").each(function () {
              var e = n.select(this);
              if (e.attr({
                id: L,
                width: m + "px",
                height: y + "px",
                patternUnits: "userSpaceOnUse",
                patternTransform: g ? "scale(0.8)" : ""
              }), h) {
                var t = l(h),
                  r = c.tinyRGB(t),
                  a = t.getAlpha(),
                  i = e.selectAll("rect").data([0]);
                i.exit().remove(), i.enter().append("rect").attr({
                  width: m + "px",
                  height: y + "px",
                  fill: r,
                  "fill-opacity": a
                });
              }
              var o = e.selectAll(w).data([0]);
              o.exit().remove(), o.enter().append(w).attr(S);
            }), e.style("fill", V(L, r)).style("fill-opacity", null), e.classed("pattern_filled", !0);
          }, x.initGradients = function (e) {
            var t = e._fullLayout;
            a.ensureSingle(t._defs, "g", "gradients").selectAll("linearGradient,radialGradient").remove(), n.select(e).selectAll(".gradient_filled").classed("gradient_filled", !1);
          }, x.initPatterns = function (e) {
            var t = e._fullLayout;
            a.ensureSingle(t._defs, "g", "patterns").selectAll("pattern").remove(), n.select(e).selectAll(".pattern_filled").classed("pattern_filled", !1);
          }, x.getPatternAttr = function (e, t, r) {
            return e && a.isArrayOrTypedArray(e) ? t < e.length ? e[t] : r : e;
          }, x.pointStyle = function (e, t, r, a) {
            if (e.size()) {
              var i = x.makePointStyleFns(t);
              e.each(function (e) {
                x.singlePointStyle(e, n.select(this), t, i, r, a);
              });
            }
          }, x.singlePointStyle = function (e, t, r, n, i, o) {
            var l = r.marker,
              s = l.line;
            if (o && o.i >= 0 && void 0 === e.i && (e.i = o.i), t.style("opacity", n.selectedOpacityFn ? n.selectedOpacityFn(e) : void 0 === e.mo ? l.opacity : e.mo), n.ms2mrc) {
              var u;
              u = "various" === e.ms || "various" === l.size ? 3 : n.ms2mrc(e.ms), e.mrc = u, n.selectedSizeFn && (u = e.mrc = n.selectedSizeFn(e));
              var f = x.symbolNumber(e.mx || l.symbol) || 0;
              e.om = f % 200 >= 100;
              var d = ne(e, r),
                h = G(e, r);
              t.attr("d", k(f, u, d, h));
            }
            var p,
              v,
              g,
              m = !1;
            if (e.so) g = s.outlierwidth, v = s.outliercolor, p = l.outliercolor;else {
              var y = (s || {}).width;
              g = (e.mlw + 1 || y + 1 || (e.trace ? (e.trace.marker.line || {}).width : 0) + 1) - 1 || 0, v = "mlc" in e ? e.mlcc = n.lineScale(e.mlc) : a.isArrayOrTypedArray(s.color) ? c.defaultLine : s.color, a.isArrayOrTypedArray(l.color) && (p = c.defaultLine, m = !0), p = "mc" in e ? e.mcc = n.markerScale(e.mc) : l.color || l.colors || "rgba(0,0,0,0)", n.selectedColorFn && (p = n.selectedColorFn(e));
            }
            if (e.om) t.call(c.stroke, p).style({
              "stroke-width": (g || 1) + "px",
              fill: "none"
            });else {
              t.style("stroke-width", (e.isBlank ? 0 : g) + "px");
              var b = l.gradient,
                _ = e.mgt;
              _ ? m = !0 : _ = b && b.type, a.isArrayOrTypedArray(_) && (_ = _[0], L[_] || (_ = 0));
              var w = l.pattern,
                T = w && x.getPatternAttr(w.shape, e.i, "");
              if (_ && "none" !== _) {
                var M = e.mgc;
                M ? m = !0 : M = b.color;
                var A = r.uid;
                m && (A += "-" + e.i), x.gradient(t, i, A, _, [[0, M], [1, p]], "fill");
              } else if (T) {
                var S = !1,
                  C = w.fgcolor;
                !C && o && o.color && (C = o.color, S = !0);
                var O = x.getPatternAttr(C, e.i, o && o.color || null),
                  D = x.getPatternAttr(w.bgcolor, e.i, null),
                  P = w.fgopacity,
                  z = x.getPatternAttr(w.size, e.i, 8),
                  I = x.getPatternAttr(w.solidity, e.i, .3);
                S = S || e.mcc || a.isArrayOrTypedArray(w.shape) || a.isArrayOrTypedArray(w.bgcolor) || a.isArrayOrTypedArray(w.fgcolor) || a.isArrayOrTypedArray(w.size) || a.isArrayOrTypedArray(w.solidity);
                var E = r.uid;
                S && (E += "-" + e.i), x.pattern(t, "point", i, E, T, z, I, e.mcc, w.fillmode, D, O, P);
              } else a.isArrayOrTypedArray(p) ? c.fill(t, p[e.i]) : c.fill(t, p);
              g && c.stroke(t, v);
            }
          }, x.makePointStyleFns = function (e) {
            var t = {},
              r = e.marker;
            return t.markerScale = x.tryColorscale(r, ""), t.lineScale = x.tryColorscale(r, "line"), s.traceIs(e, "symbols") && (t.ms2mrc = g.isBubble(e) ? m(e) : function () {
              return (r.size || 6) / 2;
            }), e.selectedpoints && a.extendFlat(t, x.makeSelectedPointStyleFns(e)), t;
          }, x.makeSelectedPointStyleFns = function (e) {
            var t = {},
              r = e.selected || {},
              n = e.unselected || {},
              i = e.marker || {},
              o = r.marker || {},
              l = n.marker || {},
              c = i.opacity,
              u = o.opacity,
              f = l.opacity,
              d = void 0 !== u,
              h = void 0 !== f;
            (a.isArrayOrTypedArray(c) || d || h) && (t.selectedOpacityFn = function (e) {
              var t = void 0 === e.mo ? i.opacity : e.mo;
              return e.selected ? d ? u : t : h ? f : v * t;
            });
            var p = i.color,
              g = o.color,
              m = l.color;
            (g || m) && (t.selectedColorFn = function (e) {
              var t = e.mcc || p;
              return e.selected ? g || t : m || t;
            });
            var y = i.size,
              x = o.size,
              b = l.size,
              _ = void 0 !== x,
              w = void 0 !== b;
            return s.traceIs(e, "symbols") && (_ || w) && (t.selectedSizeFn = function (e) {
              var t = e.mrc || y / 2;
              return e.selected ? _ ? x / 2 : t : w ? b / 2 : t;
            }), t;
          }, x.makeSelectedTextStyleFns = function (e) {
            var t = {},
              r = e.selected || {},
              n = e.unselected || {},
              a = e.textfont || {},
              i = r.textfont || {},
              o = n.textfont || {},
              l = a.color,
              s = i.color,
              u = o.color;
            return t.selectedTextColorFn = function (e) {
              var t = e.tc || l;
              return e.selected ? s || t : u || (s ? t : c.addOpacity(t, v));
            }, t;
          }, x.selectedPointStyle = function (e, t) {
            if (e.size() && t.selectedpoints) {
              var r = x.makeSelectedPointStyleFns(t),
                a = t.marker || {},
                i = [];
              r.selectedOpacityFn && i.push(function (e, t) {
                e.style("opacity", r.selectedOpacityFn(t));
              }), r.selectedColorFn && i.push(function (e, t) {
                c.fill(e, r.selectedColorFn(t));
              }), r.selectedSizeFn && i.push(function (e, n) {
                var i = n.mx || a.symbol || 0,
                  o = r.selectedSizeFn(n);
                e.attr("d", k(x.symbolNumber(i), o, ne(n, t), G(n, t))), n.mrc2 = o;
              }), i.length && e.each(function (e) {
                for (var t = n.select(this), r = 0; r < i.length; r++) i[r](t, e);
              });
            }
          }, x.tryColorscale = function (e, t) {
            var r = t ? a.nestedProperty(e, t).get() : e;
            if (r) {
              var n = r.color;
              if ((r.colorscale || r._colorAx) && a.isArrayOrTypedArray(n)) return u.makeColorScaleFuncFromTrace(r);
            }
            return a.identity;
          };
          var C,
            O,
            D = {
              start: 1,
              end: -1,
              middle: 0,
              bottom: 1,
              top: -1
            };
          function P(e, t, r, a, i) {
            var o = n.select(e.node().parentNode),
              l = -1 !== t.indexOf("top") ? "top" : -1 !== t.indexOf("bottom") ? "bottom" : "middle",
              s = -1 !== t.indexOf("left") ? "end" : -1 !== t.indexOf("right") ? "start" : "middle",
              c = a ? a / .8 + 1 : 0,
              u = (d.lineCount(e) - 1) * p + 1,
              h = D[s] * c,
              v = .75 * r + D[l] * c + (D[l] - 1) * u * r / 2;
            e.attr("text-anchor", s), i || o.attr("transform", f(h, v));
          }
          function z(e, t) {
            var r = e.ts || t.textfont.size;
            return o(r) && r > 0 ? r : 0;
          }
          function I(e, t, r) {
            return r && (e = B(e)), t ? R(e[1]) : E(e[0]);
          }
          function E(e) {
            var t = n.round(e, 2);
            return C = t, t;
          }
          function R(e) {
            var t = n.round(e, 2);
            return O = t, t;
          }
          function N(e, t, r, n) {
            var a = e[0] - t[0],
              i = e[1] - t[1],
              o = r[0] - t[0],
              l = r[1] - t[1],
              s = Math.pow(a * a + i * i, .25),
              c = Math.pow(o * o + l * l, .25),
              u = (c * c * a - s * s * o) * n,
              f = (c * c * i - s * s * l) * n,
              d = 3 * c * (s + c),
              h = 3 * s * (s + c);
            return [[E(t[0] + (d && u / d)), R(t[1] + (d && f / d))], [E(t[0] - (h && u / h)), R(t[1] - (h && f / h))]];
          }
          x.textPointStyle = function (e, t, r) {
            if (e.size()) {
              var i;
              if (t.selectedpoints) {
                var o = x.makeSelectedTextStyleFns(t);
                i = o.selectedTextColorFn;
              }
              var l = t.texttemplate,
                s = r._fullLayout;
              e.each(function (e) {
                var o = n.select(this),
                  c = l ? a.extractOption(e, t, "txt", "texttemplate") : a.extractOption(e, t, "tx", "text");
                if (c || 0 === c) {
                  if (l) {
                    var u = t._module.formatLabels,
                      f = u ? u(e, t, s) : {},
                      h = {};
                    y(h, t, e.i);
                    var p = t._meta || {};
                    c = a.texttemplateString(c, f, s._d3locale, h, e, p);
                  }
                  var v = e.tp || t.textposition,
                    g = z(e, t),
                    m = i ? i(e) : e.tc || t.textfont.color;
                  o.call(x.font, {
                    family: e.tf || t.textfont.family,
                    weight: e.tw || t.textfont.weight,
                    style: e.ty || t.textfont.style,
                    variant: e.tv || t.textfont.variant,
                    textcase: e.tC || t.textfont.textcase,
                    lineposition: e.tE || t.textfont.lineposition,
                    shadow: e.tS || t.textfont.shadow,
                    size: g,
                    color: m
                  }).text(c).call(d.convertToTspans, r).call(P, v, g, e.mrc);
                } else o.remove();
              });
            }
          }, x.selectedTextStyle = function (e, t) {
            if (e.size() && t.selectedpoints) {
              var r = x.makeSelectedTextStyleFns(t);
              e.each(function (e) {
                var a = n.select(this),
                  i = r.selectedTextColorFn(e),
                  o = e.tp || t.textposition,
                  l = z(e, t);
                c.fill(a, i);
                var u = s.traceIs(t, "bar-like");
                P(a, o, l, e.mrc2 || e.mrc, u);
              });
            }
          }, x.smoothopen = function (e, t) {
            if (e.length < 3) return "M" + e.join("L");
            var r,
              n = "M" + e[0],
              a = [];
            for (r = 1; r < e.length - 1; r++) a.push(N(e[r - 1], e[r], e[r + 1], t));
            for (n += "Q" + a[0][0] + " " + e[1], r = 2; r < e.length - 1; r++) n += "C" + a[r - 2][1] + " " + a[r - 1][0] + " " + e[r];
            return n + "Q" + a[e.length - 3][1] + " " + e[e.length - 1];
          }, x.smoothclosed = function (e, t) {
            if (e.length < 3) return "M" + e.join("L") + "Z";
            var r,
              n = "M" + e[0],
              a = e.length - 1,
              i = [N(e[a], e[0], e[1], t)];
            for (r = 1; r < a; r++) i.push(N(e[r - 1], e[r], e[r + 1], t));
            for (i.push(N(e[a - 1], e[a], e[0], t)), r = 1; r <= a; r++) n += "C" + i[r - 1][1] + " " + i[r][0] + " " + e[r];
            return n + "C" + i[a][1] + " " + i[0][0] + " " + e[0] + "Z";
          };
          var F = {
              hv: function (e, t, r) {
                return "H" + E(t[0]) + "V" + I(t, 1, r);
              },
              vh: function (e, t, r) {
                return "V" + R(t[1]) + "H" + I(t, 0, r);
              },
              hvh: function (e, t, r) {
                return "H" + E((e[0] + t[0]) / 2) + "V" + R(t[1]) + "H" + I(t, 0, r);
              },
              vhv: function (e, t, r) {
                return "V" + R((e[1] + t[1]) / 2) + "H" + E(t[0]) + "V" + I(t, 1, r);
              }
            },
            H = function (e, t, r) {
              return "L" + I(t, 0, r) + "," + I(t, 1, r);
            };
          function B(e, t) {
            var r = e.backoff,
              n = e.trace,
              i = e.d,
              o = e.i;
            if (r && n && n.marker && n.marker.angle % 360 == 0 && n.line && "spline" !== n.line.shape) {
              var l = a.isArrayOrTypedArray(r),
                s = e,
                c = t ? t[0] : C || 0,
                u = t ? t[1] : O || 0,
                f = s[0],
                d = s[1],
                h = f - c,
                p = d - u,
                v = Math.atan2(p, h),
                g = l ? r[o] : r;
              if ("auto" === g) {
                var m = s.i;
                "scatter" === n.type && m--;
                var y = s.marker,
                  b = y.symbol;
                a.isArrayOrTypedArray(b) && (b = b[m]);
                var _ = y.size;
                a.isArrayOrTypedArray(_) && (_ = _[m]), g = y ? x.symbolBackOffs[x.symbolNumber(b)] * _ : 0, g += x.getMarkerStandoff(i[m], n) || 0;
              }
              var w = f - g * Math.cos(v),
                T = d - g * Math.sin(v);
              (w <= f && w >= c || w >= f && w <= c) && (T <= d && T >= u || T >= d && T <= u) && (e = [w, T]);
            }
            return e;
          }
          x.steps = function (e) {
            var t = F[e] || H;
            return function (e) {
              for (var r = "M" + E(e[0][0]) + "," + R(e[0][1]), n = e.length, a = 1; a < n; a++) r += t(e[a - 1], e[a], a === n - 1);
              return r;
            };
          }, x.applyBackoff = B, x.makeTester = function () {
            var e = a.ensureSingleById(n.select("body"), "svg", "js-plotly-tester", function (e) {
                e.attr(h.svgAttrs).style({
                  position: "absolute",
                  left: "-10000px",
                  top: "-10000px",
                  width: "9000px",
                  height: "9000px",
                  "z-index": "1"
                });
              }),
              t = a.ensureSingle(e, "path", "js-reference-point", function (e) {
                e.attr("d", "M0,0H1V1H0Z").style({
                  "stroke-width": 0,
                  fill: "black"
                });
              });
            x.tester = e, x.testref = t;
          }, x.savedBBoxes = {};
          var j = 0;
          function Y(e) {
            var t = e.getAttribute("data-unformatted");
            if (null !== t) return t + e.getAttribute("data-math") + e.getAttribute("text-anchor") + e.getAttribute("style");
          }
          function V(e, t) {
            if (!e) return null;
            var r = t._context,
              n = r._exportedPlot ? "" : r._baseUrl || "";
            return n ? "url('" + n + "#" + e + "')" : "url(#" + e + ")";
          }
          x.bBox = function (e, t, r) {
            var i, o, l;
            if (r || (r = Y(e)), r) {
              if (i = x.savedBBoxes[r]) return a.extendFlat({}, i);
            } else if (1 === e.childNodes.length) {
              var s = e.childNodes[0];
              if (r = Y(s)) {
                var c = +s.getAttribute("x") || 0,
                  u = +s.getAttribute("y") || 0,
                  f = s.getAttribute("transform");
                if (!f) {
                  var h = x.bBox(s, !1, r);
                  return c && (h.left += c, h.right += c), u && (h.top += u, h.bottom += u), h;
                }
                if (r += "~" + c + "~" + u + "~" + f, i = x.savedBBoxes[r]) return a.extendFlat({}, i);
              }
            }
            t ? o = e : (l = x.tester.node(), o = e.cloneNode(!0), l.appendChild(o)), n.select(o).attr("transform", null).call(d.positionText, 0, 0);
            var p = o.getBoundingClientRect(),
              v = x.testref.node().getBoundingClientRect();
            t || l.removeChild(o);
            var g = {
              height: p.height,
              width: p.width,
              left: p.left - v.left,
              top: p.top - v.top,
              right: p.right - v.left,
              bottom: p.bottom - v.top
            };
            return j >= 1e4 && (x.savedBBoxes = {}, j = 0), r && (x.savedBBoxes[r] = g), j++, a.extendFlat({}, g);
          }, x.setClipUrl = function (e, t, r) {
            e.attr("clip-path", V(t, r));
          }, x.getTranslate = function (e) {
            var t = (e[e.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/, function (e, t, r) {
              return [t, r].join(" ");
            }).split(" ");
            return {
              x: +t[0] || 0,
              y: +t[1] || 0
            };
          }, x.setTranslate = function (e, t, r) {
            var n = e.attr ? "attr" : "getAttribute",
              a = e.attr ? "attr" : "setAttribute",
              i = e[n]("transform") || "";
            return t = t || 0, r = r || 0, i = i.replace(/(\btranslate\(.*?\);?)/, "").trim(), i = (i += f(t, r)).trim(), e[a]("transform", i), i;
          }, x.getScale = function (e) {
            var t = (e[e.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/, function (e, t, r) {
              return [t, r].join(" ");
            }).split(" ");
            return {
              x: +t[0] || 1,
              y: +t[1] || 1
            };
          }, x.setScale = function (e, t, r) {
            var n = e.attr ? "attr" : "getAttribute",
              a = e.attr ? "attr" : "setAttribute",
              i = e[n]("transform") || "";
            return t = t || 1, r = r || 1, i = i.replace(/(\bscale\(.*?\);?)/, "").trim(), i = (i += "scale(" + t + "," + r + ")").trim(), e[a]("transform", i), i;
          };
          var U = /\s*sc.*/;
          x.setPointGroupScale = function (e, t, r) {
            if (t = t || 1, r = r || 1, e) {
              var n = 1 === t && 1 === r ? "" : "scale(" + t + "," + r + ")";
              e.each(function () {
                var e = (this.getAttribute("transform") || "").replace(U, "");
                e = (e += n).trim(), this.setAttribute("transform", e);
              });
            }
          };
          var q = /translate\([^)]*\)\s*$/;
          function G(e, t) {
            var r;
            return e && (r = e.mf), void 0 === r && (r = t.marker && t.marker.standoff || 0), t._geo || t._xA ? r : -r;
          }
          x.setTextPointsScale = function (e, t, r) {
            e && e.each(function () {
              var e,
                a = n.select(this),
                i = a.select("text");
              if (i.node()) {
                var o = parseFloat(i.attr("x") || 0),
                  l = parseFloat(i.attr("y") || 0),
                  s = (a.attr("transform") || "").match(q);
                e = 1 === t && 1 === r ? [] : [f(o, l), "scale(" + t + "," + r + ")", f(-o, -l)], s && e.push(s), a.attr("transform", e.join(""));
              }
            });
          }, x.getMarkerStandoff = G;
          var Z,
            W,
            J,
            X,
            K,
            Q,
            $ = Math.atan2,
            ee = Math.cos,
            te = Math.sin;
          function re(e, t) {
            var r = t[0],
              n = t[1];
            return [r * ee(e) - n * te(e), r * te(e) + n * ee(e)];
          }
          function ne(e, t) {
            var r,
              n,
              i = e.ma;
            void 0 === i && ((i = t.marker.angle) && !a.isArrayOrTypedArray(i) || (i = 0));
            var l = t.marker.angleref;
            if ("previous" === l || "north" === l) {
              if (t._geo) {
                var s = t._geo.project(e.lonlat);
                r = s[0], n = s[1];
              } else {
                var c = t._xA,
                  u = t._yA;
                if (!c || !u) return 90;
                r = c.c2p(e.x), n = u.c2p(e.y);
              }
              if (t._geo) {
                var f,
                  d = e.lonlat[0],
                  h = e.lonlat[1],
                  p = t._geo.project([d, h + 1e-5]),
                  v = t._geo.project([d + 1e-5, h]),
                  g = $(v[1] - n, v[0] - r),
                  m = $(p[1] - n, p[0] - r);
                if ("north" === l) f = i / 180 * Math.PI;else if ("previous" === l) {
                  var y = d / 180 * Math.PI,
                    x = h / 180 * Math.PI,
                    b = Z / 180 * Math.PI,
                    _ = W / 180 * Math.PI,
                    w = b - y,
                    T = ee(_) * te(w),
                    M = te(_) * ee(x) - ee(_) * te(x) * ee(w);
                  f = -$(T, M) - Math.PI, Z = d, W = h;
                }
                var k = re(g, [ee(f), 0]),
                  A = re(m, [te(f), 0]);
                i = $(k[1] + A[1], k[0] + A[0]) / Math.PI * 180, "previous" !== l || Q === t.uid && e.i === K + 1 || (i = null);
              }
              if ("previous" === l && !t._geo) if (Q === t.uid && e.i === K + 1 && o(r) && o(n)) {
                var L = r - J,
                  S = n - X,
                  C = t.line && t.line.shape || "",
                  O = C.slice(C.length - 1);
                "h" === O && (S = 0), "v" === O && (L = 0), i += $(S, L) / Math.PI * 180 + 90;
              } else i = null;
            }
            return J = r, X = n, K = e.i, Q = t.uid, i;
          }
          x.getMarkerAngle = ne;
        },
        8882: function (e, t, r) {
          "use strict";

          var n,
            a,
            i,
            o,
            l = r(6953),
            s = r(5568).round,
            c = "M0,0Z",
            u = Math.sqrt(2),
            f = Math.sqrt(3),
            d = Math.PI,
            h = Math.cos,
            p = Math.sin;
          function v(e) {
            return null === e;
          }
          function g(e, t, r) {
            if (!(e && e % 360 != 0 || t)) return r;
            if (i === e && o === t && n === r) return a;
            function s(e, r) {
              var n = h(e),
                a = p(e),
                i = r[0],
                o = r[1] + (t || 0);
              return [i * n - o * a, i * a + o * n];
            }
            i = e, o = t, n = r;
            for (var c = e / 180 * d, u = 0, f = 0, v = l(r), g = "", m = 0; m < v.length; m++) {
              var y = v[m],
                x = y[0],
                b = u,
                _ = f;
              if ("M" === x || "L" === x) u = +y[1], f = +y[2];else if ("m" === x || "l" === x) u += +y[1], f += +y[2];else if ("H" === x) u = +y[1];else if ("h" === x) u += +y[1];else if ("V" === x) f = +y[1];else if ("v" === x) f += +y[1];else if ("A" === x) {
                u = +y[1], f = +y[2];
                var w = s(c, [+y[6], +y[7]]);
                y[6] = w[0], y[7] = w[1], y[3] = +y[3] + e;
              }
              "H" !== x && "V" !== x || (x = "L"), "h" !== x && "v" !== x || (x = "l"), "m" !== x && "l" !== x || (u -= b, f -= _);
              var T = s(c, [u, f]);
              "H" !== x && "V" !== x || (x = "L"), "M" !== x && "L" !== x && "m" !== x && "l" !== x || (y[1] = T[0], y[2] = T[1]), y[0] = x, g += y[0] + y.slice(1).join(",");
            }
            return a = g, g;
          }
          e.exports = {
            circle: {
              n: 0,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2),
                  a = "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z";
                return r ? g(t, r, a) : a;
              }
            },
            square: {
              n: 1,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
              }
            },
            diamond: {
              n: 2,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.3 * e, 2);
                return g(t, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "Z");
              }
            },
            cross: {
              n: 3,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.4 * e, 2),
                  a = s(1.2 * e, 2);
                return g(t, r, "M" + a + "," + n + "H" + n + "V" + a + "H-" + n + "V" + n + "H-" + a + "V-" + n + "H-" + n + "V-" + a + "H" + n + "V-" + n + "H" + a + "Z");
              }
            },
            x: {
              n: 4,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.8 * e / u, 2),
                  a = "l" + n + "," + n,
                  i = "l" + n + ",-" + n,
                  o = "l-" + n + ",-" + n,
                  l = "l-" + n + "," + n;
                return g(t, r, "M0," + n + a + i + o + i + o + l + o + l + a + l + a + "Z");
              }
            },
            "triangle-up": {
              n: 5,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(2 * e / f, 2);
                return g(t, r, "M-" + n + "," + s(e / 2, 2) + "H" + n + "L0,-" + s(e, 2) + "Z");
              }
            },
            "triangle-down": {
              n: 6,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(2 * e / f, 2);
                return g(t, r, "M-" + n + ",-" + s(e / 2, 2) + "H" + n + "L0," + s(e, 2) + "Z");
              }
            },
            "triangle-left": {
              n: 7,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(2 * e / f, 2);
                return g(t, r, "M" + s(e / 2, 2) + ",-" + n + "V" + n + "L-" + s(e, 2) + ",0Z");
              }
            },
            "triangle-right": {
              n: 8,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(2 * e / f, 2);
                return g(t, r, "M-" + s(e / 2, 2) + ",-" + n + "V" + n + "L" + s(e, 2) + ",0Z");
              }
            },
            "triangle-ne": {
              n: 9,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.6 * e, 2),
                  a = s(1.2 * e, 2);
                return g(t, r, "M-" + a + ",-" + n + "H" + n + "V" + a + "Z");
              }
            },
            "triangle-se": {
              n: 10,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.6 * e, 2),
                  a = s(1.2 * e, 2);
                return g(t, r, "M" + n + ",-" + a + "V" + n + "H-" + a + "Z");
              }
            },
            "triangle-sw": {
              n: 11,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.6 * e, 2),
                  a = s(1.2 * e, 2);
                return g(t, r, "M" + a + "," + n + "H-" + n + "V-" + a + "Z");
              }
            },
            "triangle-nw": {
              n: 12,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.6 * e, 2),
                  a = s(1.2 * e, 2);
                return g(t, r, "M-" + n + "," + a + "V-" + n + "H" + a + "Z");
              }
            },
            pentagon: {
              n: 13,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.951 * e, 2),
                  a = s(.588 * e, 2),
                  i = s(-e, 2),
                  o = s(-.309 * e, 2);
                return g(t, r, "M" + n + "," + o + "L" + a + "," + s(.809 * e, 2) + "H-" + a + "L-" + n + "," + o + "L0," + i + "Z");
              }
            },
            hexagon: {
              n: 14,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2),
                  a = s(e / 2, 2),
                  i = s(e * f / 2, 2);
                return g(t, r, "M" + i + ",-" + a + "V" + a + "L0," + n + "L-" + i + "," + a + "V-" + a + "L0,-" + n + "Z");
              }
            },
            hexagon2: {
              n: 15,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2),
                  a = s(e / 2, 2),
                  i = s(e * f / 2, 2);
                return g(t, r, "M-" + a + "," + i + "H" + a + "L" + n + ",0L" + a + ",-" + i + "H-" + a + "L-" + n + ",0Z");
              }
            },
            octagon: {
              n: 16,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.924 * e, 2),
                  a = s(.383 * e, 2);
                return g(t, r, "M-" + a + ",-" + n + "H" + a + "L" + n + ",-" + a + "V" + a + "L" + a + "," + n + "H-" + a + "L-" + n + "," + a + "V-" + a + "Z");
              }
            },
            star: {
              n: 17,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = 1.4 * e,
                  a = s(.225 * n, 2),
                  i = s(.951 * n, 2),
                  o = s(.363 * n, 2),
                  l = s(.588 * n, 2),
                  u = s(-n, 2),
                  f = s(-.309 * n, 2),
                  d = s(.118 * n, 2),
                  h = s(.809 * n, 2);
                return g(t, r, "M" + a + "," + f + "H" + i + "L" + o + "," + d + "L" + l + "," + h + "L0," + s(.382 * n, 2) + "L-" + l + "," + h + "L-" + o + "," + d + "L-" + i + "," + f + "H-" + a + "L0," + u + "Z");
              }
            },
            hexagram: {
              n: 18,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.66 * e, 2),
                  a = s(.38 * e, 2),
                  i = s(.76 * e, 2);
                return g(t, r, "M-" + i + ",0l-" + a + ",-" + n + "h" + i + "l" + a + ",-" + n + "l" + a + "," + n + "h" + i + "l-" + a + "," + n + "l" + a + "," + n + "h-" + i + "l-" + a + "," + n + "l-" + a + ",-" + n + "h-" + i + "Z");
              }
            },
            "star-triangle-up": {
              n: 19,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e * f * .8, 2),
                  a = s(.8 * e, 2),
                  i = s(1.6 * e, 2),
                  o = s(4 * e, 2),
                  l = "A " + o + "," + o + " 0 0 1 ";
                return g(t, r, "M-" + n + "," + a + l + n + "," + a + l + "0,-" + i + l + "-" + n + "," + a + "Z");
              }
            },
            "star-triangle-down": {
              n: 20,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e * f * .8, 2),
                  a = s(.8 * e, 2),
                  i = s(1.6 * e, 2),
                  o = s(4 * e, 2),
                  l = "A " + o + "," + o + " 0 0 1 ";
                return g(t, r, "M" + n + ",-" + a + l + "-" + n + ",-" + a + l + "0," + i + l + n + ",-" + a + "Z");
              }
            },
            "star-square": {
              n: 21,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.1 * e, 2),
                  a = s(2 * e, 2),
                  i = "A " + a + "," + a + " 0 0 1 ";
                return g(t, r, "M-" + n + ",-" + n + i + "-" + n + "," + n + i + n + "," + n + i + n + ",-" + n + i + "-" + n + ",-" + n + "Z");
              }
            },
            "star-diamond": {
              n: 22,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.4 * e, 2),
                  a = s(1.9 * e, 2),
                  i = "A " + a + "," + a + " 0 0 1 ";
                return g(t, r, "M-" + n + ",0" + i + "0," + n + i + n + ",0" + i + "0,-" + n + i + "-" + n + ",0Z");
              }
            },
            "diamond-tall": {
              n: 23,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(.7 * e, 2),
                  a = s(1.4 * e, 2);
                return g(t, r, "M0," + a + "L" + n + ",0L0,-" + a + "L-" + n + ",0Z");
              }
            },
            "diamond-wide": {
              n: 24,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.4 * e, 2),
                  a = s(.7 * e, 2);
                return g(t, r, "M0," + a + "L" + n + ",0L0,-" + a + "L-" + n + ",0Z");
              }
            },
            hourglass: {
              n: 25,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M" + n + "," + n + "H-" + n + "L" + n + ",-" + n + "H-" + n + "Z");
              },
              noDot: !0
            },
            bowtie: {
              n: 26,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M" + n + "," + n + "V-" + n + "L-" + n + "," + n + "V-" + n + "Z");
              },
              noDot: !0
            },
            "circle-cross": {
              n: 27,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z");
              },
              needLine: !0,
              noDot: !0
            },
            "circle-x": {
              n: 28,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2),
                  a = s(e / u, 2);
                return g(t, r, "M" + a + "," + a + "L-" + a + ",-" + a + "M" + a + ",-" + a + "L-" + a + "," + a + "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z");
              },
              needLine: !0,
              noDot: !0
            },
            "square-cross": {
              n: 29,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
              },
              needLine: !0,
              noDot: !0
            },
            "square-x": {
              n: 30,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n + "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
              },
              needLine: !0,
              noDot: !0
            },
            "diamond-cross": {
              n: 31,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.3 * e, 2);
                return g(t, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "ZM0,-" + n + "V" + n + "M-" + n + ",0H" + n);
              },
              needLine: !0,
              noDot: !0
            },
            "diamond-x": {
              n: 32,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.3 * e, 2),
                  a = s(.65 * e, 2);
                return g(t, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "ZM-" + a + ",-" + a + "L" + a + "," + a + "M-" + a + "," + a + "L" + a + ",-" + a);
              },
              needLine: !0,
              noDot: !0
            },
            "cross-thin": {
              n: 33,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.4 * e, 2);
                return g(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n);
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            "x-thin": {
              n: 34,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n);
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            asterisk: {
              n: 35,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.2 * e, 2),
                  a = s(.85 * e, 2);
                return g(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + a + "," + a + "L-" + a + ",-" + a + "M" + a + ",-" + a + "L-" + a + "," + a);
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            hash: {
              n: 36,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e / 2, 2),
                  a = s(e, 2);
                return g(t, r, "M" + n + "," + a + "V-" + a + "M" + (n - a) + ",-" + a + "V" + a + "M" + a + "," + n + "H-" + a + "M-" + a + "," + (n - a) + "H" + a);
              },
              needLine: !0,
              noFill: !0
            },
            "y-up": {
              n: 37,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.2 * e, 2),
                  a = s(1.6 * e, 2),
                  i = s(.8 * e, 2);
                return g(t, r, "M-" + n + "," + i + "L0,0M" + n + "," + i + "L0,0M0,-" + a + "L0,0");
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            "y-down": {
              n: 38,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.2 * e, 2),
                  a = s(1.6 * e, 2),
                  i = s(.8 * e, 2);
                return g(t, r, "M-" + n + ",-" + i + "L0,0M" + n + ",-" + i + "L0,0M0," + a + "L0,0");
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            "y-left": {
              n: 39,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.2 * e, 2),
                  a = s(1.6 * e, 2),
                  i = s(.8 * e, 2);
                return g(t, r, "M" + i + "," + n + "L0,0M" + i + ",-" + n + "L0,0M-" + a + ",0L0,0");
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            "y-right": {
              n: 40,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.2 * e, 2),
                  a = s(1.6 * e, 2),
                  i = s(.8 * e, 2);
                return g(t, r, "M-" + i + "," + n + "L0,0M-" + i + ",-" + n + "L0,0M" + a + ",0L0,0");
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            "line-ew": {
              n: 41,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.4 * e, 2);
                return g(t, r, "M" + n + ",0H-" + n);
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            "line-ns": {
              n: 42,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(1.4 * e, 2);
                return g(t, r, "M0," + n + "V-" + n);
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            "line-ne": {
              n: 43,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M" + n + ",-" + n + "L-" + n + "," + n);
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            "line-nw": {
              n: 44,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M" + n + "," + n + "L-" + n + ",-" + n);
              },
              needLine: !0,
              noDot: !0,
              noFill: !0
            },
            "arrow-up": {
              n: 45,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M0,0L-" + n + "," + s(2 * e, 2) + "H" + n + "Z");
              },
              backoff: 1,
              noDot: !0
            },
            "arrow-down": {
              n: 46,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M0,0L-" + n + ",-" + s(2 * e, 2) + "H" + n + "Z");
              },
              noDot: !0
            },
            "arrow-left": {
              n: 47,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(2 * e, 2),
                  a = s(e, 2);
                return g(t, r, "M0,0L" + n + ",-" + a + "V" + a + "Z");
              },
              noDot: !0
            },
            "arrow-right": {
              n: 48,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(2 * e, 2),
                  a = s(e, 2);
                return g(t, r, "M0,0L-" + n + ",-" + a + "V" + a + "Z");
              },
              noDot: !0
            },
            "arrow-bar-up": {
              n: 49,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M-" + n + ",0H" + n + "M0,0L-" + n + "," + s(2 * e, 2) + "H" + n + "Z");
              },
              backoff: 1,
              needLine: !0,
              noDot: !0
            },
            "arrow-bar-down": {
              n: 50,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(e, 2);
                return g(t, r, "M-" + n + ",0H" + n + "M0,0L-" + n + ",-" + s(2 * e, 2) + "H" + n + "Z");
              },
              needLine: !0,
              noDot: !0
            },
            "arrow-bar-left": {
              n: 51,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(2 * e, 2),
                  a = s(e, 2);
                return g(t, r, "M0,-" + a + "V" + a + "M0,0L" + n + ",-" + a + "V" + a + "Z");
              },
              needLine: !0,
              noDot: !0
            },
            "arrow-bar-right": {
              n: 52,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = s(2 * e, 2),
                  a = s(e, 2);
                return g(t, r, "M0,-" + a + "V" + a + "M0,0L-" + n + ",-" + a + "V" + a + "Z");
              },
              needLine: !0,
              noDot: !0
            },
            arrow: {
              n: 53,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = d / 2.5,
                  a = 2 * e * h(n),
                  i = 2 * e * p(n);
                return g(t, r, "M0,0L" + -a + "," + i + "L" + a + "," + i + "Z");
              },
              backoff: .9,
              noDot: !0
            },
            "arrow-wide": {
              n: 54,
              f: function (e, t, r) {
                if (v(t)) return c;
                var n = d / 4,
                  a = 2 * e * h(n),
                  i = 2 * e * p(n);
                return g(t, r, "M0,0L" + -a + "," + i + "A " + 2 * e + "," + 2 * e + " 0 0 1 " + a + "," + i + "Z");
              },
              backoff: .4,
              noDot: !0
            }
          };
        },
        3187: function (e) {
          "use strict";

          e.exports = {
            visible: {
              valType: "boolean",
              editType: "calc"
            },
            type: {
              valType: "enumerated",
              values: ["percent", "constant", "sqrt", "data"],
              editType: "calc"
            },
            symmetric: {
              valType: "boolean",
              editType: "calc"
            },
            array: {
              valType: "data_array",
              editType: "calc"
            },
            arrayminus: {
              valType: "data_array",
              editType: "calc"
            },
            value: {
              valType: "number",
              min: 0,
              dflt: 10,
              editType: "calc"
            },
            valueminus: {
              valType: "number",
              min: 0,
              dflt: 10,
              editType: "calc"
            },
            traceref: {
              valType: "integer",
              min: 0,
              dflt: 0,
              editType: "style"
            },
            tracerefminus: {
              valType: "integer",
              min: 0,
              dflt: 0,
              editType: "style"
            },
            copy_ystyle: {
              valType: "boolean",
              editType: "plot"
            },
            copy_zstyle: {
              valType: "boolean",
              editType: "style"
            },
            color: {
              valType: "color",
              editType: "style"
            },
            thickness: {
              valType: "number",
              min: 0,
              dflt: 2,
              editType: "style"
            },
            width: {
              valType: "number",
              min: 0,
              editType: "plot"
            },
            editType: "calc",
            _deprecated: {
              opacity: {
                valType: "number",
                editType: "style"
              }
            }
          };
        },
        352: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(3626),
            i = r(9714),
            o = r(4809),
            l = r(5589);
          function s(e, t, r, a) {
            var s = t["error_" + a] || {},
              c = [];
            if (s.visible && -1 !== ["linear", "log"].indexOf(r.type)) {
              for (var u = l(s), f = 0; f < e.length; f++) {
                var d = e[f],
                  h = d.i;
                if (void 0 === h) h = f;else if (null === h) continue;
                var p = d[a];
                if (n(r.c2l(p))) {
                  var v = u(p, h);
                  if (n(v[0]) && n(v[1])) {
                    var g = d[a + "s"] = p - v[0],
                      m = d[a + "h"] = p + v[1];
                    c.push(g, m);
                  }
                }
              }
              var y = r._id,
                x = t._extremes[y],
                b = i.findExtremes(r, c, o.extendFlat({
                  tozero: x.opts.tozero
                }, {
                  padded: !0
                }));
              x.min = x.min.concat(b.min), x.max = x.max.concat(b.max);
            }
          }
          e.exports = function (e) {
            for (var t = e.calcdata, r = 0; r < t.length; r++) {
              var n = t[r],
                o = n[0].trace;
              if (!0 === o.visible && a.traceIs(o, "errorBarsOK")) {
                var l = i.getFromId(e, o.xaxis),
                  c = i.getFromId(e, o.yaxis);
                s(n, o, l, "x"), s(n, o, c, "y");
              }
            }
          };
        },
        5589: function (e) {
          "use strict";

          function t(e, t) {
            return "percent" === e ? function (e) {
              return Math.abs(e * t / 100);
            } : "constant" === e ? function () {
              return Math.abs(t);
            } : "sqrt" === e ? function (e) {
              return Math.sqrt(Math.abs(e));
            } : void 0;
          }
          e.exports = function (e) {
            var r = e.type,
              n = e.symmetric;
            if ("data" === r) {
              var a = e.array || [];
              if (n) return function (e, t) {
                var r = +a[t];
                return [r, r];
              };
              var i = e.arrayminus || [];
              return function (e, t) {
                var r = +a[t],
                  n = +i[t];
                return isNaN(r) && isNaN(n) ? [NaN, NaN] : [n || 0, r || 0];
              };
            }
            var o = t(r, e.value),
              l = t(r, e.valueminus);
            return n || void 0 === e.valueminus ? function (e) {
              var t = o(e);
              return [t, t];
            } : function (e) {
              return [l(e), o(e)];
            };
          };
        },
        5543: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(3626),
            i = r(4809),
            o = r(8032),
            l = r(3187);
          e.exports = function (e, t, r, s) {
            var c = "error_" + s.axis,
              u = o.newContainer(t, c),
              f = e[c] || {};
            function d(e, t) {
              return i.coerce(f, u, l, e, t);
            }
            if (!1 !== d("visible", void 0 !== f.array || void 0 !== f.value || "sqrt" === f.type)) {
              var h = d("type", "array" in f ? "data" : "percent"),
                p = !0;
              "sqrt" !== h && (p = d("symmetric", !(("data" === h ? "arrayminus" : "valueminus") in f))), "data" === h ? (d("array"), d("traceref"), p || (d("arrayminus"), d("tracerefminus"))) : "percent" !== h && "constant" !== h || (d("value"), p || d("valueminus"));
              var v = "copy_" + s.inherit + "style";
              s.inherit && (t["error_" + s.inherit] || {}).visible && d(v, !(f.color || n(f.thickness) || n(f.width))), s.inherit && u[v] || (d("color", r), d("thickness"), d("width", a.traceIs(t, "gl3d") ? 0 : 4));
            }
          };
        },
        7901: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(3582).overrideAll,
            i = r(3187),
            o = {
              error_x: n.extendFlat({}, i),
              error_y: n.extendFlat({}, i)
            };
          delete o.error_x.copy_zstyle, delete o.error_y.copy_zstyle, delete o.error_y.copy_ystyle;
          var l = {
            error_x: n.extendFlat({}, i),
            error_y: n.extendFlat({}, i),
            error_z: n.extendFlat({}, i)
          };
          delete l.error_x.copy_ystyle, delete l.error_y.copy_ystyle, delete l.error_z.copy_ystyle, delete l.error_z.copy_zstyle, e.exports = {
            moduleType: "component",
            name: "errorbars",
            schema: {
              traces: {
                scatter: o,
                bar: o,
                histogram: o,
                scatter3d: a(l, "calc", "nested"),
                scattergl: a(o, "calc", "nested")
              }
            },
            supplyDefaults: r(5543),
            calc: r(352),
            makeComputeError: r(5589),
            plot: r(2130),
            style: r(2800),
            hoverInfo: function (e, t, r) {
              (t.error_y || {}).visible && (r.yerr = e.yh - e.y, t.error_y.symmetric || (r.yerrneg = e.y - e.ys)), (t.error_x || {}).visible && (r.xerr = e.xh - e.x, t.error_x.symmetric || (r.xerrneg = e.x - e.xs));
            }
          };
        },
        2130: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(721),
            i = r(2203),
            o = r(4726);
          e.exports = function (e, t, r, l) {
            var s = r.xaxis,
              c = r.yaxis,
              u = l && l.duration > 0,
              f = e._context.staticPlot;
            t.each(function (t) {
              var d,
                h = t[0].trace,
                p = h.error_x || {},
                v = h.error_y || {};
              h.ids && (d = function (e) {
                return e.id;
              });
              var g = o.hasMarkers(h) && h.marker.maxdisplayed > 0;
              v.visible || p.visible || (t = []);
              var m = n.select(this).selectAll("g.errorbar").data(t, d);
              if (m.exit().remove(), t.length) {
                p.visible || m.selectAll("path.xerror").remove(), v.visible || m.selectAll("path.yerror").remove(), m.style("opacity", 1);
                var y = m.enter().append("g").classed("errorbar", !0);
                u && y.style("opacity", 0).transition().duration(l.duration).style("opacity", 1), i.setClipUrl(m, r.layerClipId, e), m.each(function (e) {
                  var t = n.select(this),
                    r = function (e, t, r) {
                      var n = {
                        x: t.c2p(e.x),
                        y: r.c2p(e.y)
                      };
                      return void 0 !== e.yh && (n.yh = r.c2p(e.yh), n.ys = r.c2p(e.ys), a(n.ys) || (n.noYS = !0, n.ys = r.c2p(e.ys, !0))), void 0 !== e.xh && (n.xh = t.c2p(e.xh), n.xs = t.c2p(e.xs), a(n.xs) || (n.noXS = !0, n.xs = t.c2p(e.xs, !0))), n;
                    }(e, s, c);
                  if (!g || e.vis) {
                    var i,
                      o = t.select("path.yerror");
                    if (v.visible && a(r.x) && a(r.yh) && a(r.ys)) {
                      var d = v.width;
                      i = "M" + (r.x - d) + "," + r.yh + "h" + 2 * d + "m-" + d + ",0V" + r.ys, r.noYS || (i += "m-" + d + ",0h" + 2 * d), o.size() ? u && (o = o.transition().duration(l.duration).ease(l.easing)) : o = t.append("path").style("vector-effect", f ? "none" : "non-scaling-stroke").classed("yerror", !0), o.attr("d", i);
                    } else o.remove();
                    var h = t.select("path.xerror");
                    if (p.visible && a(r.y) && a(r.xh) && a(r.xs)) {
                      var m = (p.copy_ystyle ? v : p).width;
                      i = "M" + r.xh + "," + (r.y - m) + "v" + 2 * m + "m0,-" + m + "H" + r.xs, r.noXS || (i += "m0,-" + m + "v" + 2 * m), h.size() ? u && (h = h.transition().duration(l.duration).ease(l.easing)) : h = t.append("path").style("vector-effect", f ? "none" : "non-scaling-stroke").classed("xerror", !0), h.attr("d", i);
                    } else h.remove();
                  }
                });
              }
            });
          };
        },
        2800: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(8766);
          e.exports = function (e) {
            e.each(function (e) {
              var t = e[0].trace,
                r = t.error_y || {},
                i = t.error_x || {},
                o = n.select(this);
              o.selectAll("path.yerror").style("stroke-width", r.thickness + "px").call(a.stroke, r.color), i.copy_ystyle && (i = r), o.selectAll("path.xerror").style("stroke-width", i.thickness + "px").call(a.stroke, i.color);
            });
          };
        },
        192: function (e, t, r) {
          "use strict";

          var n = r(337),
            a = r(6811).hoverlabel,
            i = r(3049).extendFlat;
          e.exports = {
            hoverlabel: {
              bgcolor: i({}, a.bgcolor, {
                arrayOk: !0
              }),
              bordercolor: i({}, a.bordercolor, {
                arrayOk: !0
              }),
              font: n({
                arrayOk: !0,
                editType: "none"
              }),
              align: i({}, a.align, {
                arrayOk: !0
              }),
              namelength: i({}, a.namelength, {
                arrayOk: !0
              }),
              editType: "none"
            }
          };
        },
        3552: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(3626);
          function i(e, t, r, a) {
            a = a || n.identity, Array.isArray(e) && (t[0][r] = a(e));
          }
          e.exports = function (e) {
            var t = e.calcdata,
              r = e._fullLayout;
            function o(e) {
              return function (t) {
                return n.coerceHoverinfo({
                  hoverinfo: t
                }, {
                  _module: e._module
                }, r);
              };
            }
            for (var l = 0; l < t.length; l++) {
              var s = t[l],
                c = s[0].trace;
              if (!a.traceIs(c, "pie-like")) {
                var u = a.traceIs(c, "2dMap") ? i : n.fillArray;
                u(c.hoverinfo, s, "hi", o(c)), c.hovertemplate && u(c.hovertemplate, s, "ht"), c.hoverlabel && (u(c.hoverlabel.bgcolor, s, "hbg"), u(c.hoverlabel.bordercolor, s, "hbc"), u(c.hoverlabel.font.size, s, "hts"), u(c.hoverlabel.font.color, s, "htc"), u(c.hoverlabel.font.family, s, "htf"), u(c.hoverlabel.font.weight, s, "htw"), u(c.hoverlabel.font.style, s, "hty"), u(c.hoverlabel.font.variant, s, "htv"), u(c.hoverlabel.namelength, s, "hnl"), u(c.hoverlabel.align, s, "hta"));
              }
            }
          };
        },
        4225: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(8103).hover;
          e.exports = function (e, t, r) {
            var i = n.getComponentMethod("annotations", "onClick")(e, e._hoverdata);
            function o() {
              e.emit("plotly_click", {
                points: e._hoverdata,
                event: t
              });
            }
            void 0 !== r && a(e, t, r, !0), e._hoverdata && t && t.target && (i && i.then ? i.then(o) : o(), t.stopImmediatePropagation && t.stopImmediatePropagation());
          };
        },
        5988: function (e) {
          "use strict";

          e.exports = {
            YANGLE: 60,
            HOVERARROWSIZE: 6,
            HOVERTEXTPAD: 3,
            HOVERFONTSIZE: 13,
            HOVERFONT: "Arial, sans-serif",
            HOVERMINTIME: 50,
            HOVERID: "-hover"
          };
        },
        3239: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(192),
            i = r(6430);
          e.exports = function (e, t, r, o) {
            var l = n.extendFlat({}, o.hoverlabel);
            t.hovertemplate && (l.namelength = -1), i(e, t, function (r, i) {
              return n.coerce(e, t, a, r, i);
            }, l);
          };
        },
        6040: function (e, t, r) {
          "use strict";

          var n = r(4809);
          t.getSubplot = function (e) {
            return e.subplot || e.xaxis + e.yaxis || e.geo;
          }, t.isTraceInSubplots = function (e, r) {
            if ("splom" === e.type) {
              for (var n = e.xaxes || [], a = e.yaxes || [], i = 0; i < n.length; i++) for (var o = 0; o < a.length; o++) if (-1 !== r.indexOf(n[i] + a[o])) return !0;
              return !1;
            }
            return -1 !== r.indexOf(t.getSubplot(e));
          }, t.flat = function (e, t) {
            for (var r = new Array(e.length), n = 0; n < e.length; n++) r[n] = t;
            return r;
          }, t.p2c = function (e, t) {
            for (var r = new Array(e.length), n = 0; n < e.length; n++) r[n] = e[n].p2c(t);
            return r;
          }, t.getDistanceFunction = function (e, r, n, a) {
            return "closest" === e ? a || t.quadrature(r, n) : "x" === e.charAt(0) ? r : n;
          }, t.getClosest = function (e, t, r) {
            if (!1 !== r.index) r.index >= 0 && r.index < e.length ? r.distance = 0 : r.index = !1;else for (var n = 0; n < e.length; n++) {
              var a = t(e[n]);
              a <= r.distance && (r.index = n, r.distance = a);
            }
            return r;
          }, t.inbox = function (e, t, r) {
            return e * t < 0 || 0 === e ? r : 1 / 0;
          }, t.quadrature = function (e, t) {
            return function (r) {
              var n = e(r),
                a = t(r);
              return Math.sqrt(n * n + a * a);
            };
          }, t.makeEventData = function (e, r, n) {
            var a = "index" in e ? e.index : e.pointNumber,
              i = {
                data: r._input,
                fullData: r,
                curveNumber: r.index,
                pointNumber: a
              };
            if (r._indexToPoints) {
              var o = r._indexToPoints[a];
              1 === o.length ? i.pointIndex = o[0] : i.pointIndices = o;
            } else i.pointIndex = a;
            return r._module.eventData ? i = r._module.eventData(i, e, r, n, a) : ("xVal" in e ? i.x = e.xVal : "x" in e && (i.x = e.x), "yVal" in e ? i.y = e.yVal : "y" in e && (i.y = e.y), e.xa && (i.xaxis = e.xa), e.ya && (i.yaxis = e.ya), void 0 !== e.zLabelVal && (i.z = e.zLabelVal)), t.appendArrayPointValue(i, r, a), i;
          }, t.appendArrayPointValue = function (e, t, r) {
            var a = t._arrayAttrs;
            if (a) for (var l = 0; l < a.length; l++) {
              var s = a[l],
                c = i(s);
              if (void 0 === e[c]) {
                var u = o(n.nestedProperty(t, s).get(), r);
                void 0 !== u && (e[c] = u);
              }
            }
          }, t.appendArrayMultiPointValues = function (e, t, r) {
            var a = t._arrayAttrs;
            if (a) for (var l = 0; l < a.length; l++) {
              var s = a[l],
                c = i(s);
              if (void 0 === e[c]) {
                for (var u = n.nestedProperty(t, s).get(), f = new Array(r.length), d = 0; d < r.length; d++) f[d] = o(u, r[d]);
                e[c] = f;
              }
            }
          };
          var a = {
            ids: "id",
            locations: "location",
            labels: "label",
            values: "value",
            "marker.colors": "color",
            parents: "parent"
          };
          function i(e) {
            return a[e] || e;
          }
          function o(e, t) {
            return Array.isArray(t) ? Array.isArray(e) && Array.isArray(e[t[0]]) ? e[t[0]][t[1]] : void 0 : e[t];
          }
          var l = {
              x: !0,
              y: !0
            },
            s = {
              "x unified": !0,
              "y unified": !0
            };
          t.isUnifiedHover = function (e) {
            return "string" == typeof e && !!s[e];
          }, t.isXYhover = function (e) {
            return "string" == typeof e && !!l[e];
          };
        },
        8103: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(721),
            i = r(5657),
            o = r(4809),
            l = o.pushUnique,
            s = o.strTranslate,
            c = o.strRotate,
            u = r(8596),
            f = r(635),
            d = r(3134),
            h = r(2203),
            p = r(8766),
            v = r(4751),
            g = r(9714),
            m = r(4826).zindexSeparator,
            y = r(3626),
            x = r(6040),
            b = r(5988),
            _ = r(3970),
            w = r(6134),
            T = b.YANGLE,
            M = Math.PI * T / 180,
            k = 1 / Math.sin(M),
            A = Math.cos(M),
            L = Math.sin(M),
            S = b.HOVERARROWSIZE,
            C = b.HOVERTEXTPAD,
            O = {
              box: !0,
              ohlc: !0,
              violin: !0,
              candlestick: !0
            },
            D = {
              scatter: !0,
              scattergl: !0,
              splom: !0
            };
          function P(e, t) {
            return e.distance - t.distance;
          }
          function z(e) {
            return [e.trace.index, e.index, e.x0, e.y0, e.name, e.attr, e.xa ? e.xa._id : "", e.ya ? e.ya._id : ""].join(",");
          }
          t.hover = function (e, t, r, i) {
            e = o.getGraphDiv(e);
            var s = t.target;
            o.throttle(e._fullLayout._uid + b.HOVERID, b.HOVERMINTIME, function () {
              !function (e, t, r, i, s) {
                r || (r = "xy"), "string" == typeof r && (r = r.split(m)[0]);
                var c,
                  f,
                  h,
                  b = Array.isArray(r) ? r : [r],
                  _ = e._fullLayout,
                  w = _.hoversubplots,
                  T = _._plots || [],
                  M = T[r],
                  A = _._has("cartesian"),
                  L = t.hovermode || _.hovermode,
                  C = "x" === (L || "").charAt(0),
                  I = "y" === (L || "").charAt(0);
                if (A && (C || I) && "axis" === w) for (var R = b.length, Y = 0; Y < R; Y++) if (T[c = b[Y]]) {
                  f = g.getFromId(e, c, "x"), h = g.getFromId(e, c, "y");
                  var G = (C ? f : h)._subplotsWith;
                  if (G && G.length) for (var Z = 0; Z < G.length; Z++) l(b, G[Z]);
                }
                if (M && "single" !== w) {
                  var W = M.overlays.map(function (e) {
                    return e.id;
                  });
                  b = b.concat(W);
                }
                for (var J = b.length, X = new Array(J), K = new Array(J), Q = !1, $ = 0; $ < J; $++) if (T[c = b[$]]) Q = !0, X[$] = T[c].xaxis, K[$] = T[c].yaxis;else {
                  if (!_[c] || !_[c]._subplot) return void o.warn("Unrecognized subplot: " + c);
                  var ee = _[c]._subplot;
                  X[$] = ee.xaxis, K[$] = ee.yaxis;
                }
                if (L && !Q && (L = "closest"), -1 === ["x", "y", "closest", "x unified", "y unified"].indexOf(L) || !e.calcdata || e.querySelector(".zoombox") || e._dragging) return v.unhoverRaw(e, t);
                var te = _.hoverdistance;
                -1 === te && (te = 1 / 0);
                var re = _.spikedistance;
                -1 === re && (re = 1 / 0);
                var ne,
                  ae,
                  ie,
                  oe,
                  le,
                  se,
                  ce,
                  ue,
                  fe,
                  de,
                  he,
                  pe,
                  ve,
                  ge = [],
                  me = [],
                  ye = {
                    hLinePoint: null,
                    vLinePoint: null
                  },
                  xe = !1;
                if (Array.isArray(t)) for (L = "array", ie = 0; ie < t.length; ie++) (le = e.calcdata[t[ie].curveNumber || 0]) && (se = le[0].trace, "skip" !== le[0].trace.hoverinfo && (me.push(le), "h" === se.orientation && (xe = !0)));else {
                  var be,
                    _e,
                    we = e.calcdata.slice();
                  for (we.sort(function (e, t) {
                    return (e[0].trace.zorder || 0) - (t[0].trace.zorder || 0);
                  }), oe = 0; oe < we.length; oe++) le = we[oe], "skip" !== (se = le[0].trace).hoverinfo && x.isTraceInSubplots(se, b) && (me.push(le), "h" === se.orientation && (xe = !0));
                  if (s) {
                    if (!1 === u.triggerHandler(e, "plotly_beforehover", t)) return;
                    var Te = s.getBoundingClientRect();
                    be = t.clientX - Te.left, _e = t.clientY - Te.top, _._calcInverseTransform(e);
                    var Me = o.apply3DTransform(_._invTransform)(be, _e);
                    if (be = Me[0], _e = Me[1], be < 0 || be > X[0]._length || _e < 0 || _e > K[0]._length) return v.unhoverRaw(e, t);
                  } else be = "xpx" in t ? t.xpx : X[0]._length / 2, _e = "ypx" in t ? t.ypx : K[0]._length / 2;
                  if (t.pointerX = be + X[0]._offset, t.pointerY = _e + K[0]._offset, ne = "xval" in t ? x.flat(b, t.xval) : x.p2c(X, be), ae = "yval" in t ? x.flat(b, t.yval) : x.p2c(K, _e), !a(ne[0]) || !a(ae[0])) return o.warn("Fx.hover failed", t, e), v.unhoverRaw(e, t);
                }
                var ke = 1 / 0;
                function Ae(r, n) {
                  for (oe = 0; oe < me.length; oe++) if ((le = me[oe]) && le[0] && le[0].trace && !0 === (se = le[0].trace).visible && 0 !== se._length && -1 === ["carpet", "contourcarpet"].indexOf(se._module.name)) {
                    if (fe = L, x.isUnifiedHover(fe) && (fe = fe.charAt(0)), "splom" === se.type ? ce = b[ue = 0] : (ce = x.getSubplot(se), ue = b.indexOf(ce)), pe = {
                      cd: le,
                      trace: se,
                      xa: X[ue],
                      ya: K[ue],
                      maxHoverDistance: te,
                      maxSpikeDistance: re,
                      index: !1,
                      distance: Math.min(ke, te),
                      spikeDistance: 1 / 0,
                      xSpike: void 0,
                      ySpike: void 0,
                      color: p.defaultLine,
                      name: se.name,
                      x0: void 0,
                      x1: void 0,
                      y0: void 0,
                      y1: void 0,
                      xLabelVal: void 0,
                      yLabelVal: void 0,
                      zLabelVal: void 0,
                      text: void 0
                    }, _[ce] && (pe.subplot = _[ce]._subplot), _._splomScenes && _._splomScenes[se.uid] && (pe.scene = _._splomScenes[se.uid]), "array" === fe) {
                      var i = t[oe];
                      "pointNumber" in i ? (pe.index = i.pointNumber, fe = "closest") : (fe = "", "xval" in i && (de = i.xval, fe = "x"), "yval" in i && (he = i.yval, fe = fe ? "closest" : "y"));
                    } else void 0 !== r && void 0 !== n ? (de = r, he = n) : (de = ne[ue], he = ae[ue]);
                    if (ve = ge.length, 0 !== te) if (se._module && se._module.hoverPoints) {
                      var l = se._module.hoverPoints(pe, de, he, fe, {
                        finiteRange: !0,
                        hoverLayer: _._hoverlayer,
                        hoversubplots: w,
                        gd: e
                      });
                      if (l) for (var s, c = 0; c < l.length; c++) s = l[c], a(s.x0) && a(s.y0) && ge.push(H(s, L));
                    } else o.log("Unrecognized trace type in hover:", se);
                    if ("closest" === L && ge.length > ve && (ge.splice(0, ve), ke = ge[0].distance), A && 0 !== re && 0 === ge.length) {
                      pe.distance = re, pe.index = !1;
                      var u = se._module.hoverPoints(pe, de, he, "closest", {
                        hoverLayer: _._hoverlayer
                      });
                      if (u && (u = u.filter(function (e) {
                        return e.spikeDistance <= re;
                      })), u && u.length) {
                        var f,
                          d = u.filter(function (e) {
                            return e.xa.showspikes && "hovered data" !== e.xa.spikesnap;
                          });
                        if (d.length) {
                          var h = d[0];
                          a(h.x0) && a(h.y0) && (f = Se(h), (!ye.vLinePoint || ye.vLinePoint.spikeDistance > f.spikeDistance) && (ye.vLinePoint = f));
                        }
                        var v = u.filter(function (e) {
                          return e.ya.showspikes && "hovered data" !== e.ya.spikesnap;
                        });
                        if (v.length) {
                          var g = v[0];
                          a(g.x0) && a(g.y0) && (f = Se(g), (!ye.hLinePoint || ye.hLinePoint.spikeDistance > f.spikeDistance) && (ye.hLinePoint = f));
                        }
                      }
                    }
                  }
                }
                function Le(e, t, r) {
                  for (var n, a = null, i = 1 / 0, o = 0; o < e.length; o++) f && f._id !== e[o].xa._id || h && h._id !== e[o].ya._id || (n = e[o].spikeDistance, r && 0 === o && (n = -1 / 0), n <= i && n <= t && (a = e[o], i = n));
                  return a;
                }
                function Se(e) {
                  return e ? {
                    xa: e.xa,
                    ya: e.ya,
                    x: void 0 !== e.xSpike ? e.xSpike : (e.x0 + e.x1) / 2,
                    y: void 0 !== e.ySpike ? e.ySpike : (e.y0 + e.y1) / 2,
                    distance: e.distance,
                    spikeDistance: e.spikeDistance,
                    curveNumber: e.trace.index,
                    color: e.color,
                    pointNumber: e.index
                  } : null;
                }
                Ae();
                var Ce = {
                    fullLayout: _,
                    container: _._hoverlayer,
                    event: t
                  },
                  Oe = e._spikepoints,
                  De = {
                    vLinePoint: ye.vLinePoint,
                    hLinePoint: ye.hLinePoint
                  };
                e._spikepoints = De;
                var Pe = function () {
                  var e = ge.filter(function (e) {
                      return f && f._id === e.xa._id && h && h._id === e.ya._id;
                    }),
                    t = ge.filter(function (e) {
                      return !(f && f._id === e.xa._id && h && h._id === e.ya._id);
                    });
                  e.sort(P), t.sort(P), ge = function (e, t) {
                    for (var r = t.charAt(0), n = [], a = [], i = [], o = 0; o < e.length; o++) {
                      var l = e[o];
                      y.traceIs(l.trace, "bar-like") || y.traceIs(l.trace, "box-violin") ? i.push(l) : l.trace[r + "period"] ? a.push(l) : n.push(l);
                    }
                    return n.concat(a).concat(i);
                  }(ge = e.concat(t), L);
                };
                Pe();
                var ze = L.charAt(0),
                  Ie = ("x" === ze || "y" === ze) && ge[0] && D[ge[0].trace.type];
                if (A && 0 !== re && 0 !== ge.length) {
                  var Ee = Le(ge.filter(function (e) {
                    return e.ya.showspikes;
                  }), re, Ie);
                  ye.hLinePoint = Se(Ee);
                  var Re = Le(ge.filter(function (e) {
                    return e.xa.showspikes;
                  }), re, Ie);
                  ye.vLinePoint = Se(Re);
                }
                if (0 === ge.length) {
                  var Ne = v.unhoverRaw(e, t);
                  return !A || null === ye.hLinePoint && null === ye.vLinePoint || j(Oe) && B(e, ye, Ce), Ne;
                }
                if (A && j(Oe) && B(e, ye, Ce), x.isXYhover(fe) && 0 !== ge[0].length && "splom" !== ge[0].trace.type) {
                  var Fe = ge[0],
                    He = (ge = O[Fe.trace.type] ? ge.filter(function (e) {
                      return e.trace.index === Fe.trace.index;
                    }) : [Fe]).length;
                  Ae(V("x", Fe, _), V("y", Fe, _));
                  var Be,
                    je = [],
                    Ye = {},
                    Ve = 0,
                    Ue = function (e) {
                      var t = O[e.trace.type] ? z(e) : e.trace.index;
                      if (Ye[t]) {
                        var r = Ye[t] - 1,
                          n = je[r];
                        r > 0 && Math.abs(e.distance) < Math.abs(n.distance) && (je[r] = e);
                      } else Ve++, Ye[t] = Ve, je.push(e);
                    };
                  for (Be = 0; Be < He; Be++) Ue(ge[Be]);
                  for (Be = ge.length - 1; Be > He - 1; Be--) Ue(ge[Be]);
                  ge = je, Pe();
                }
                var qe = e._hoverdata,
                  Ge = [],
                  Ze = U(e),
                  We = q(e);
                for (ie = 0; ie < ge.length; ie++) {
                  var Je = ge[ie],
                    Xe = x.makeEventData(Je, Je.trace, Je.cd);
                  if (!1 !== Je.hovertemplate) {
                    var Ke = !1;
                    Je.cd[Je.index] && Je.cd[Je.index].ht && (Ke = Je.cd[Je.index].ht), Je.hovertemplate = Ke || Je.trace.hovertemplate || !1;
                  }
                  if (Je.xa && Je.ya) {
                    var Qe = Je.x0 + Je.xa._offset,
                      $e = Je.x1 + Je.xa._offset,
                      et = Je.y0 + Je.ya._offset,
                      tt = Je.y1 + Je.ya._offset,
                      rt = Math.min(Qe, $e),
                      nt = Math.max(Qe, $e),
                      at = Math.min(et, tt),
                      it = Math.max(et, tt);
                    Xe.bbox = {
                      x0: rt + We,
                      x1: nt + We,
                      y0: at + Ze,
                      y1: it + Ze
                    };
                  }
                  Je.eventData = [Xe], Ge.push(Xe);
                }
                e._hoverdata = Ge;
                var ot = "y" === L && (me.length > 1 || ge.length > 1) || "closest" === L && xe && ge.length > 1,
                  lt = p.combine(_.plot_bgcolor || p.background, _.paper_bgcolor),
                  st = E(ge, {
                    gd: e,
                    hovermode: L,
                    rotateLabels: ot,
                    bgColor: lt,
                    container: _._hoverlayer,
                    outerContainer: _._paper.node(),
                    commonLabelOpts: _.hoverlabel,
                    hoverdistance: _.hoverdistance
                  }),
                  ct = st.hoverLabels;
                if (x.isUnifiedHover(L) || (function (e, t, r, n) {
                  var a,
                    i,
                    o,
                    l,
                    s,
                    c,
                    u,
                    f = t ? "xa" : "ya",
                    d = t ? "ya" : "xa",
                    h = 0,
                    p = 1,
                    v = e.size(),
                    g = new Array(v),
                    m = 0,
                    y = n.minX,
                    x = n.maxX,
                    b = n.minY,
                    _ = n.maxY,
                    w = function (e) {
                      return e * r._invScaleX;
                    },
                    T = function (e) {
                      return e * r._invScaleY;
                    };
                  function M(e) {
                    var t = e[0],
                      r = e[e.length - 1];
                    if (i = t.pmin - t.pos - t.dp + t.size, o = r.pos + r.dp + r.size - t.pmax, i > .01) {
                      for (s = e.length - 1; s >= 0; s--) e[s].dp += i;
                      a = !1;
                    }
                    if (!(o < .01)) {
                      if (i < -.01) {
                        for (s = e.length - 1; s >= 0; s--) e[s].dp -= o;
                        a = !1;
                      }
                      if (a) {
                        var n = 0;
                        for (l = 0; l < e.length; l++) (c = e[l]).pos + c.dp + c.size > t.pmax && n++;
                        for (l = e.length - 1; l >= 0 && !(n <= 0); l--) (c = e[l]).pos > t.pmax - 1 && (c.del = !0, n--);
                        for (l = 0; l < e.length && !(n <= 0); l++) if ((c = e[l]).pos < t.pmin + 1) for (c.del = !0, n--, o = 2 * c.size, s = e.length - 1; s >= 0; s--) e[s].dp -= o;
                        for (l = e.length - 1; l >= 0 && !(n <= 0); l--) (c = e[l]).pos + c.dp + c.size > t.pmax && (c.del = !0, n--);
                      }
                    }
                  }
                  for (e.each(function (e) {
                    var n = e[f],
                      a = e[d],
                      i = "x" === n._id.charAt(0),
                      o = n.range;
                    0 === m && o && o[0] > o[1] !== i && (p = -1);
                    var l = 0,
                      s = i ? r.width : r.height;
                    if ("x" === r.hovermode || "y" === r.hovermode) {
                      var c,
                        u,
                        h = N(e, t),
                        v = e.anchor,
                        M = "end" === v ? -1 : 1;
                      if ("middle" === v) u = (c = e.crossPos + (i ? T(h.y - e.by / 2) : w(e.bx / 2 + e.tx2width / 2))) + (i ? T(e.by) : w(e.bx));else if (i) u = (c = e.crossPos + T(S + h.y) - T(e.by / 2 - S)) + T(e.by);else {
                        var A = w(M * S + h.x),
                          L = A + w(M * e.bx);
                        c = e.crossPos + Math.min(A, L), u = e.crossPos + Math.max(A, L);
                      }
                      i ? void 0 !== b && void 0 !== _ && Math.min(u, _) - Math.max(c, b) > 1 && ("left" === a.side ? (l = a._mainLinePosition, s = r.width) : s = a._mainLinePosition) : void 0 !== y && void 0 !== x && Math.min(u, x) - Math.max(c, y) > 1 && ("top" === a.side ? (l = a._mainLinePosition, s = r.height) : s = a._mainLinePosition);
                    }
                    g[m++] = [{
                      datum: e,
                      traceIndex: e.trace.index,
                      dp: 0,
                      pos: e.pos,
                      posref: e.posref,
                      size: e.by * (i ? k : 1) / 2,
                      pmin: l,
                      pmax: s
                    }];
                  }), g.sort(function (e, t) {
                    return e[0].posref - t[0].posref || p * (t[0].traceIndex - e[0].traceIndex);
                  }); !a && h <= v;) {
                    for (h++, a = !0, l = 0; l < g.length - 1;) {
                      var A = g[l],
                        L = g[l + 1],
                        C = A[A.length - 1],
                        O = L[0];
                      if ((i = C.pos + C.dp + C.size - O.pos - O.dp + O.size) > .01) {
                        for (s = L.length - 1; s >= 0; s--) L[s].dp += i;
                        for (A.push.apply(A, L), g.splice(l + 1, 1), u = 0, s = A.length - 1; s >= 0; s--) u += A[s].dp;
                        for (o = u / A.length, s = A.length - 1; s >= 0; s--) A[s].dp -= o;
                        a = !1;
                      } else l++;
                    }
                    g.forEach(M);
                  }
                  for (l = g.length - 1; l >= 0; l--) {
                    var D = g[l];
                    for (s = D.length - 1; s >= 0; s--) {
                      var P = D[s],
                        z = P.datum;
                      z.offset = P.dp, z.del = P.del;
                    }
                  }
                }(ct, ot, _, st.commonLabelBoundingBox), F(ct, ot, _._invScaleX, _._invScaleY)), s && s.tagName) {
                  var ut = y.getComponentMethod("annotations", "hasClickToShow")(e, Ge);
                  d(n.select(s), ut ? "pointer" : "");
                }
                s && !i && function (e, t, r) {
                  if (!r || r.length !== e._hoverdata.length) return !0;
                  for (var n = r.length - 1; n >= 0; n--) {
                    var a = r[n],
                      i = e._hoverdata[n];
                    if (a.curveNumber !== i.curveNumber || String(a.pointNumber) !== String(i.pointNumber) || String(a.pointNumbers) !== String(i.pointNumbers)) return !0;
                  }
                  return !1;
                }(e, 0, qe) && (qe && e.emit("plotly_unhover", {
                  event: t,
                  points: qe
                }), e.emit("plotly_hover", {
                  event: t,
                  points: e._hoverdata,
                  xaxes: X,
                  yaxes: K,
                  xvals: ne,
                  yvals: ae
                }));
              }(e, t, r, i, s);
            });
          }, t.loneHover = function (e, t) {
            var r = !0;
            Array.isArray(e) || (r = !1, e = [e]);
            var a = t.gd,
              i = U(a),
              o = q(a),
              l = E(e.map(function (e) {
                var r = e._x0 || e.x0 || e.x || 0,
                  n = e._x1 || e.x1 || e.x || 0,
                  l = e._y0 || e.y0 || e.y || 0,
                  s = e._y1 || e.y1 || e.y || 0,
                  c = e.eventData;
                if (c) {
                  var u = Math.min(r, n),
                    f = Math.max(r, n),
                    d = Math.min(l, s),
                    h = Math.max(l, s),
                    v = e.trace;
                  if (y.traceIs(v, "gl3d")) {
                    var g = a._fullLayout[v.scene]._scene.container,
                      m = g.offsetLeft,
                      x = g.offsetTop;
                    u += m, f += m, d += x, h += x;
                  }
                  c.bbox = {
                    x0: u + o,
                    x1: f + o,
                    y0: d + i,
                    y1: h + i
                  }, t.inOut_bbox && t.inOut_bbox.push(c.bbox);
                } else c = !1;
                return {
                  color: e.color || p.defaultLine,
                  x0: e.x0 || e.x || 0,
                  x1: e.x1 || e.x || 0,
                  y0: e.y0 || e.y || 0,
                  y1: e.y1 || e.y || 0,
                  xLabel: e.xLabel,
                  yLabel: e.yLabel,
                  zLabel: e.zLabel,
                  text: e.text,
                  name: e.name,
                  idealAlign: e.idealAlign,
                  borderColor: e.borderColor,
                  fontFamily: e.fontFamily,
                  fontSize: e.fontSize,
                  fontColor: e.fontColor,
                  fontWeight: e.fontWeight,
                  fontStyle: e.fontStyle,
                  fontVariant: e.fontVariant,
                  nameLength: e.nameLength,
                  textAlign: e.textAlign,
                  trace: e.trace || {
                    index: 0,
                    hoverinfo: ""
                  },
                  xa: {
                    _offset: 0
                  },
                  ya: {
                    _offset: 0
                  },
                  index: 0,
                  hovertemplate: e.hovertemplate || !1,
                  hovertemplateLabels: e.hovertemplateLabels || !1,
                  eventData: c
                };
              }), {
                gd: a,
                hovermode: "closest",
                rotateLabels: !1,
                bgColor: t.bgColor || p.background,
                container: n.select(t.container),
                outerContainer: t.outerContainer || t.container
              }).hoverLabels,
              s = 0,
              c = 0;
            return l.sort(function (e, t) {
              return e.y0 - t.y0;
            }).each(function (e, r) {
              var n = e.y0 - e.by / 2;
              e.offset = n - 5 < s ? s - n + 5 : 0, s = n + e.by + e.offset, r === t.anchorIndex && (c = e.offset);
            }).each(function (e) {
              e.offset -= c;
            }), F(l, !1, a._fullLayout._invScaleX, a._fullLayout._invScaleY), r ? l : l.node();
          };
          var I = /<extra>([\s\S]*)<\/extra>/;
          function E(e, t) {
            var r = t.gd,
              a = r._fullLayout,
              i = t.hovermode,
              l = t.rotateLabels,
              u = t.bgColor,
              d = t.container,
              v = t.outerContainer,
              g = t.commonLabelOpts || {};
            if (0 === e.length) return [[]];
            var m = t.fontFamily || b.HOVERFONT,
              M = t.fontSize || b.HOVERFONTSIZE,
              k = t.fontWeight || a.font.weight,
              A = t.fontStyle || a.font.style,
              L = t.fontVariant || a.font.variant,
              O = t.fontTextcase || a.font.textcase,
              D = t.fontLineposition || a.font.lineposition,
              P = t.fontShadow || a.font.shadow,
              I = e[0],
              E = I.xa,
              N = I.ya,
              F = i.charAt(0),
              H = F + "Label",
              B = I[H];
            if (void 0 === B && "multicategory" === E.type) for (var j = 0; j < e.length && void 0 === (B = e[j][H]); j++);
            var Y = G(r, v),
              V = Y.top,
              U = Y.width,
              q = Y.height,
              Z = void 0 !== B && I.distance <= t.hoverdistance && ("x" === i || "y" === i);
            if (Z) {
              var W,
                J,
                X = !0;
              for (W = 0; W < e.length; W++) if (X && void 0 === e[W].zLabel && (X = !1), J = e[W].hoverinfo || e[W].trace.hoverinfo) {
                var K = Array.isArray(J) ? J : J.split("+");
                if (-1 === K.indexOf("all") && -1 === K.indexOf(i)) {
                  Z = !1;
                  break;
                }
              }
              X && (Z = !1);
            }
            var Q = d.selectAll("g.axistext").data(Z ? [0] : []);
            Q.enter().append("g").classed("axistext", !0), Q.exit().remove();
            var $ = {
              minX: 0,
              maxX: 0,
              minY: 0,
              maxY: 0
            };
            if (Q.each(function () {
              var e = n.select(this),
                t = o.ensureSingle(e, "path", "", function (e) {
                  e.style({
                    "stroke-width": "1px"
                  });
                }),
                l = o.ensureSingle(e, "text", "", function (e) {
                  e.attr("data-notex", 1);
                }),
                c = g.bgcolor || p.defaultLine,
                u = g.bordercolor || p.contrast(c),
                d = p.contrast(c),
                v = g.font,
                y = {
                  weight: v.weight || k,
                  style: v.style || A,
                  variant: v.variant || L,
                  textcase: v.textcase || O,
                  lineposition: v.lineposition || D,
                  shadow: v.shadow || P,
                  family: v.family || m,
                  size: v.size || M,
                  color: v.color || d
                };
              t.style({
                fill: c,
                stroke: u
              }), l.text(B).call(h.font, y).call(f.positionText, 0, 0).call(f.convertToTspans, r), e.attr("transform", "");
              var x,
                b,
                _ = G(r, l.node());
              if ("x" === i) {
                var w = "top" === E.side ? "-" : "";
                l.attr("text-anchor", "middle").call(f.positionText, 0, "top" === E.side ? V - _.bottom - S - C : V - _.top + S + C), x = E._offset + (I.x0 + I.x1) / 2, b = N._offset + ("top" === E.side ? 0 : N._length);
                var T = _.width / 2 + C,
                  z = x;
                x < T ? z = T : x > a.width - T && (z = a.width - T), t.attr("d", "M" + (x - z) + ",0L" + (x - z + S) + "," + w + S + "H" + T + "v" + w + (2 * C + _.height) + "H" + -T + "V" + w + S + "H" + (x - z - S) + "Z"), x = z, $.minX = x - T, $.maxX = x + T, "top" === E.side ? ($.minY = b - (2 * C + _.height), $.maxY = b - C) : ($.minY = b + C, $.maxY = b + (2 * C + _.height));
              } else {
                var R, F, H;
                "right" === N.side ? (R = "start", F = 1, H = "", x = E._offset + E._length) : (R = "end", F = -1, H = "-", x = E._offset), b = N._offset + (I.y0 + I.y1) / 2, l.attr("text-anchor", R), t.attr("d", "M0,0L" + H + S + "," + S + "V" + (C + _.height / 2) + "h" + H + (2 * C + _.width) + "V-" + (C + _.height / 2) + "H" + H + S + "V-" + S + "Z"), $.minY = b - (C + _.height / 2), $.maxY = b + (C + _.height / 2), "right" === N.side ? ($.minX = x + S, $.maxX = x + S + (2 * C + _.width)) : ($.minX = x - S - (2 * C + _.width), $.maxX = x - S);
                var j,
                  Y = _.height / 2,
                  U = V - _.top - Y,
                  q = "clip" + a._uid + "commonlabel" + N._id;
                if (x < _.width + 2 * C + S) {
                  j = "M-" + (S + C) + "-" + Y + "h-" + (_.width - C) + "V" + Y + "h" + (_.width - C) + "Z";
                  var Z = _.width - x + C;
                  f.positionText(l, Z, U), "end" === R && l.selectAll("tspan").each(function () {
                    var e = n.select(this),
                      t = h.tester.append("text").text(e.text()).call(h.font, y),
                      a = G(r, t.node());
                    Math.round(a.width) < Math.round(_.width) && e.attr("x", Z - a.width), t.remove();
                  });
                } else f.positionText(l, F * (C + S), U), j = null;
                var W = a._topclips.selectAll("#" + q).data(j ? [0] : []);
                W.enter().append("clipPath").attr("id", q).append("path"), W.exit().remove(), W.select("path").attr("d", j), h.setClipUrl(l, j ? q : null, r);
              }
              e.attr("transform", s(x, b));
            }), x.isUnifiedHover(i)) {
              d.selectAll("g.hovertext").remove();
              var ee = e.filter(function (e) {
                return "none" !== e.hoverinfo;
              });
              if (0 === ee.length) return [];
              var te = a.hoverlabel,
                re = te.font,
                ne = {
                  showlegend: !0,
                  legend: {
                    title: {
                      text: B,
                      font: re
                    },
                    font: re,
                    bgcolor: te.bgcolor,
                    bordercolor: te.bordercolor,
                    borderwidth: 1,
                    tracegroupgap: 7,
                    traceorder: a.legend ? a.legend.traceorder : void 0,
                    orientation: "v"
                  }
                },
                ae = {
                  font: re
                };
              _(ne, ae, r._fullData);
              var ie = ae.legend;
              ie.entries = [];
              for (var oe = 0; oe < ee.length; oe++) {
                var le = ee[oe];
                if ("none" !== le.hoverinfo) {
                  var se = R(le, !0, i, a, B),
                    ce = se[0],
                    ue = se[1];
                  le.name = ue, le.text = "" !== ue ? ue + " : " + ce : ce;
                  var fe = le.cd[le.index];
                  fe && (fe.mc && (le.mc = fe.mc), fe.mcc && (le.mc = fe.mcc), fe.mlc && (le.mlc = fe.mlc), fe.mlcc && (le.mlc = fe.mlcc), fe.mlw && (le.mlw = fe.mlw), fe.mrc && (le.mrc = fe.mrc), fe.dir && (le.dir = fe.dir)), le._distinct = !0, ie.entries.push([le]);
                }
              }
              ie.entries.sort(function (e, t) {
                return e[0].trace.index - t[0].trace.index;
              }), ie.layer = d, ie._inHover = !0, ie._groupTitleFont = te.grouptitlefont, w(r, ie);
              var de,
                he,
                pe,
                ve,
                ge = d.select("g.legend"),
                me = G(r, ge.node()),
                ye = me.width + 2 * C,
                xe = me.height + 2 * C,
                be = ee[0],
                _e = (be.x0 + be.x1) / 2,
                we = (be.y0 + be.y1) / 2,
                Te = !(y.traceIs(be.trace, "bar-like") || y.traceIs(be.trace, "box-violin"));
              "y" === F ? Te ? (he = we - C, de = we + C) : (he = Math.min.apply(null, ee.map(function (e) {
                return Math.min(e.y0, e.y1);
              })), de = Math.max.apply(null, ee.map(function (e) {
                return Math.max(e.y0, e.y1);
              }))) : he = de = o.mean(ee.map(function (e) {
                return (e.y0 + e.y1) / 2;
              })) - xe / 2, "x" === F ? Te ? (pe = _e + C, ve = _e - C) : (pe = Math.max.apply(null, ee.map(function (e) {
                return Math.max(e.x0, e.x1);
              })), ve = Math.min.apply(null, ee.map(function (e) {
                return Math.min(e.x0, e.x1);
              }))) : pe = ve = o.mean(ee.map(function (e) {
                return (e.x0 + e.x1) / 2;
              })) - ye / 2;
              var Me,
                ke,
                Ae = E._offset,
                Le = N._offset;
              return ve += Ae - ye, he += Le - xe, Me = (pe += Ae) + ye < U && pe >= 0 ? pe : ve + ye < U && ve >= 0 ? ve : Ae + ye < U ? Ae : pe - _e < _e - ve + ye ? U - ye : 0, Me += C, ke = (de += Le) + xe < q && de >= 0 ? de : he + xe < q && he >= 0 ? he : Le + xe < q ? Le : de - we < we - he + xe ? q - xe : 0, ke += C, ge.attr("transform", s(Me - 1, ke - 1)), ge;
            }
            var Se = d.selectAll("g.hovertext").data(e, function (e) {
              return z(e);
            });
            return Se.enter().append("g").classed("hovertext", !0).each(function () {
              var e = n.select(this);
              e.append("rect").call(p.fill, p.addOpacity(u, .8)), e.append("text").classed("name", !0), e.append("path").style("stroke-width", "1px"), e.append("text").classed("nums", !0).call(h.font, {
                weight: k,
                style: A,
                variant: L,
                textcase: O,
                lineposition: D,
                shadow: P,
                family: m,
                size: M
              });
            }), Se.exit().remove(), Se.each(function (e) {
              var t = n.select(this).attr("transform", ""),
                o = e.color;
              Array.isArray(o) && (o = o[e.eventData[0].pointNumber]);
              var d = e.bgcolor || o,
                v = p.combine(p.opacity(d) ? d : p.defaultLine, u),
                g = p.combine(p.opacity(o) ? o : p.defaultLine, u),
                y = e.borderColor || p.contrast(v),
                x = R(e, Z, i, a, B, t),
                b = x[0],
                _ = x[1],
                w = t.select("text.nums").call(h.font, {
                  family: e.fontFamily || m,
                  size: e.fontSize || M,
                  color: e.fontColor || y,
                  weight: e.fontWeight || k,
                  style: e.fontStyle || A,
                  variant: e.fontVariant || L,
                  textcase: e.fontTextcase || O,
                  lineposition: e.fontLineposition || D,
                  shadow: e.fontShadow || P
                }).text(b).attr("data-notex", 1).call(f.positionText, 0, 0).call(f.convertToTspans, r),
                z = t.select("text.name"),
                I = 0,
                E = 0;
              if (_ && _ !== b) {
                z.call(h.font, {
                  family: e.fontFamily || m,
                  size: e.fontSize || M,
                  color: g,
                  weight: e.fontWeight || k,
                  style: e.fontStyle || A,
                  variant: e.fontVariant || L,
                  textcase: e.fontTextcase || O,
                  lineposition: e.fontLineposition || D,
                  shadow: e.fontShadow || P
                }).text(_).attr("data-notex", 1).call(f.positionText, 0, 0).call(f.convertToTspans, r);
                var N = G(r, z.node());
                I = N.width + 2 * C, E = N.height + 2 * C;
              } else z.remove(), t.select("rect").remove();
              t.select("path").style({
                fill: v,
                stroke: y
              });
              var F = e.xa._offset + (e.x0 + e.x1) / 2,
                H = e.ya._offset + (e.y0 + e.y1) / 2,
                j = Math.abs(e.x1 - e.x0),
                Y = Math.abs(e.y1 - e.y0),
                W = G(r, w.node()),
                J = W.width / a._invScaleX,
                X = W.height / a._invScaleY;
              e.ty0 = (V - W.top) / a._invScaleY, e.bx = J + 2 * C, e.by = Math.max(X + 2 * C, E), e.anchor = "start", e.txwidth = J, e.tx2width = I, e.offset = 0;
              var K,
                Q,
                $ = (J + S + C + I) * a._invScaleX;
              if (l) e.pos = F, K = H + Y / 2 + $ <= q, Q = H - Y / 2 - $ >= 0, "top" !== e.idealAlign && K || !Q ? K ? (H += Y / 2, e.anchor = "start") : e.anchor = "middle" : (H -= Y / 2, e.anchor = "end"), e.crossPos = H;else {
                if (e.pos = H, K = F + j / 2 + $ <= U, Q = F - j / 2 - $ >= 0, "left" !== e.idealAlign && K || !Q) {
                  if (K) F += j / 2, e.anchor = "start";else {
                    e.anchor = "middle";
                    var ee = $ / 2,
                      te = F + ee - U,
                      re = F - ee;
                    te > 0 && (F -= te), re < 0 && (F += -re);
                  }
                } else F -= j / 2, e.anchor = "end";
                e.crossPos = F;
              }
              w.attr("text-anchor", e.anchor), I && z.attr("text-anchor", e.anchor), t.attr("transform", s(F, H) + (l ? c(T) : ""));
            }), {
              hoverLabels: Se,
              commonLabelBoundingBox: $
            };
          }
          function R(e, t, r, n, a, i) {
            var l = "",
              s = "";
            void 0 !== e.nameOverride && (e.name = e.nameOverride), e.name && (e.trace._meta && (e.name = o.templateString(e.name, e.trace._meta)), l = Y(e.name, e.nameLength));
            var c = r.charAt(0),
              u = "x" === c ? "y" : "x";
            void 0 !== e.zLabel ? (void 0 !== e.xLabel && (s += "x: " + e.xLabel + "<br>"), void 0 !== e.yLabel && (s += "y: " + e.yLabel + "<br>"), "choropleth" !== e.trace.type && "choroplethmapbox" !== e.trace.type && "choroplethmap" !== e.trace.type && (s += (s ? "z: " : "") + e.zLabel)) : t && e[c + "Label"] === a ? s = e[u + "Label"] || "" : void 0 === e.xLabel ? void 0 !== e.yLabel && "scattercarpet" !== e.trace.type && (s = e.yLabel) : s = void 0 === e.yLabel ? e.xLabel : "(" + e.xLabel + ", " + e.yLabel + ")", !e.text && 0 !== e.text || Array.isArray(e.text) || (s += (s ? "<br>" : "") + e.text), void 0 !== e.extraText && (s += (s ? "<br>" : "") + e.extraText), i && "" === s && !e.hovertemplate && ("" === l && i.remove(), s = l);
            var f = e.hovertemplate || !1;
            if (f) {
              var d = e.hovertemplateLabels || e;
              e[c + "Label"] !== a && (d[c + "other"] = d[c + "Val"], d[c + "otherLabel"] = d[c + "Label"]), s = (s = o.hovertemplateString(f, d, n._d3locale, e.eventData[0] || {}, e.trace._meta)).replace(I, function (t, r) {
                return l = Y(r, e.nameLength), "";
              });
            }
            return [s, l];
          }
          function N(e, t) {
            var r = 0,
              n = e.offset;
            return t && (n *= -L, r = e.offset * A), {
              x: r,
              y: n
            };
          }
          function F(e, t, r, a) {
            var i = function (e) {
                return e * r;
              },
              o = function (e) {
                return e * a;
              };
            e.each(function (e) {
              var r = n.select(this);
              if (e.del) return r.remove();
              var a,
                l,
                s,
                c,
                u = r.select("text.nums"),
                d = e.anchor,
                p = "end" === d ? -1 : 1,
                v = (c = (s = (l = {
                  start: 1,
                  end: -1,
                  middle: 0
                }[(a = e).anchor]) * (S + C)) + l * (a.txwidth + C), "middle" === a.anchor && (s -= a.tx2width / 2, c += a.txwidth / 2 + C), {
                  alignShift: l,
                  textShiftX: s,
                  text2ShiftX: c
                }),
                g = N(e, t),
                m = g.x,
                y = g.y,
                x = "middle" === d;
              r.select("path").attr("d", x ? "M-" + i(e.bx / 2 + e.tx2width / 2) + "," + o(y - e.by / 2) + "h" + i(e.bx) + "v" + o(e.by) + "h-" + i(e.bx) + "Z" : "M0,0L" + i(p * S + m) + "," + o(S + y) + "v" + o(e.by / 2 - S) + "h" + i(p * e.bx) + "v-" + o(e.by) + "H" + i(p * S + m) + "V" + o(y - S) + "Z");
              var b = m + v.textShiftX,
                _ = y + e.ty0 - e.by / 2 + C,
                w = e.textAlign || "auto";
              "auto" !== w && ("left" === w && "start" !== d ? (u.attr("text-anchor", "start"), b = x ? -e.bx / 2 - e.tx2width / 2 + C : -e.bx - C) : "right" === w && "end" !== d && (u.attr("text-anchor", "end"), b = x ? e.bx / 2 - e.tx2width / 2 - C : e.bx + C)), u.call(f.positionText, i(b), o(_)), e.tx2width && (r.select("text.name").call(f.positionText, i(v.text2ShiftX + v.alignShift * C + m), o(y + e.ty0 - e.by / 2 + C)), r.select("rect").call(h.setRect, i(v.text2ShiftX + (v.alignShift - 1) * e.tx2width / 2 + m), o(y - e.by / 2 - 1), i(e.tx2width), o(e.by + 2)));
            });
          }
          function H(e, t) {
            var r = e.index,
              n = e.trace || {},
              i = e.cd[0],
              l = e.cd[r] || {};
            function s(e) {
              return e || a(e) && 0 === e;
            }
            var c = Array.isArray(r) ? function (e, t) {
              var a = o.castOption(i, r, e);
              return s(a) ? a : o.extractOption({}, n, "", t);
            } : function (e, t) {
              return o.extractOption(l, n, e, t);
            };
            function u(t, r, n) {
              var a = c(r, n);
              s(a) && (e[t] = a);
            }
            if (u("hoverinfo", "hi", "hoverinfo"), u("bgcolor", "hbg", "hoverlabel.bgcolor"), u("borderColor", "hbc", "hoverlabel.bordercolor"), u("fontFamily", "htf", "hoverlabel.font.family"), u("fontSize", "hts", "hoverlabel.font.size"), u("fontColor", "htc", "hoverlabel.font.color"), u("fontWeight", "htw", "hoverlabel.font.weight"), u("fontStyle", "hty", "hoverlabel.font.style"), u("fontVariant", "htv", "hoverlabel.font.variant"), u("nameLength", "hnl", "hoverlabel.namelength"), u("textAlign", "hta", "hoverlabel.align"), e.posref = "y" === t || "closest" === t && "h" === n.orientation ? e.xa._offset + (e.x0 + e.x1) / 2 : e.ya._offset + (e.y0 + e.y1) / 2, e.x0 = o.constrain(e.x0, 0, e.xa._length), e.x1 = o.constrain(e.x1, 0, e.xa._length), e.y0 = o.constrain(e.y0, 0, e.ya._length), e.y1 = o.constrain(e.y1, 0, e.ya._length), void 0 !== e.xLabelVal && (e.xLabel = "xLabel" in e ? e.xLabel : g.hoverLabelText(e.xa, e.xLabelVal, n.xhoverformat), e.xVal = e.xa.c2d(e.xLabelVal)), void 0 !== e.yLabelVal && (e.yLabel = "yLabel" in e ? e.yLabel : g.hoverLabelText(e.ya, e.yLabelVal, n.yhoverformat), e.yVal = e.ya.c2d(e.yLabelVal)), void 0 !== e.zLabelVal && void 0 === e.zLabel && (e.zLabel = String(e.zLabelVal)), !(isNaN(e.xerr) || "log" === e.xa.type && e.xerr <= 0)) {
              var f = g.tickText(e.xa, e.xa.c2l(e.xerr), "hover").text;
              void 0 !== e.xerrneg ? e.xLabel += " +" + f + " / -" + g.tickText(e.xa, e.xa.c2l(e.xerrneg), "hover").text : e.xLabel += " ± " + f, "x" === t && (e.distance += 1);
            }
            if (!(isNaN(e.yerr) || "log" === e.ya.type && e.yerr <= 0)) {
              var d = g.tickText(e.ya, e.ya.c2l(e.yerr), "hover").text;
              void 0 !== e.yerrneg ? e.yLabel += " +" + d + " / -" + g.tickText(e.ya, e.ya.c2l(e.yerrneg), "hover").text : e.yLabel += " ± " + d, "y" === t && (e.distance += 1);
            }
            var h = e.hoverinfo || e.trace.hoverinfo;
            return h && "all" !== h && (-1 === (h = Array.isArray(h) ? h : h.split("+")).indexOf("x") && (e.xLabel = void 0), -1 === h.indexOf("y") && (e.yLabel = void 0), -1 === h.indexOf("z") && (e.zLabel = void 0), -1 === h.indexOf("text") && (e.text = void 0), -1 === h.indexOf("name") && (e.name = void 0)), e;
          }
          function B(e, t, r) {
            var n,
              a,
              o = r.container,
              l = r.fullLayout,
              s = l._size,
              c = r.event,
              u = !!t.hLinePoint,
              f = !!t.vLinePoint;
            if (o.selectAll(".spikeline").remove(), f || u) {
              var d = p.combine(l.plot_bgcolor, l.paper_bgcolor);
              if (u) {
                var v,
                  m,
                  y = t.hLinePoint;
                n = y && y.xa, "cursor" === (a = y && y.ya).spikesnap ? (v = c.pointerX, m = c.pointerY) : (v = n._offset + y.x, m = a._offset + y.y);
                var x,
                  b,
                  _ = i.readability(y.color, d) < 1.5 ? p.contrast(d) : y.color,
                  w = a.spikemode,
                  T = a.spikethickness,
                  M = a.spikecolor || _,
                  k = g.getPxPosition(e, a);
                if (-1 !== w.indexOf("toaxis") || -1 !== w.indexOf("across")) {
                  if (-1 !== w.indexOf("toaxis") && (x = k, b = v), -1 !== w.indexOf("across")) {
                    var A = a._counterDomainMin,
                      L = a._counterDomainMax;
                    "free" === a.anchor && (A = Math.min(A, a.position), L = Math.max(L, a.position)), x = s.l + A * s.w, b = s.l + L * s.w;
                  }
                  o.insert("line", ":first-child").attr({
                    x1: x,
                    x2: b,
                    y1: m,
                    y2: m,
                    "stroke-width": T,
                    stroke: M,
                    "stroke-dasharray": h.dashStyle(a.spikedash, T)
                  }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                    x1: x,
                    x2: b,
                    y1: m,
                    y2: m,
                    "stroke-width": T + 2,
                    stroke: d
                  }).classed("spikeline", !0).classed("crisp", !0);
                }
                -1 !== w.indexOf("marker") && o.insert("circle", ":first-child").attr({
                  cx: k + ("right" !== a.side ? T : -T),
                  cy: m,
                  r: T,
                  fill: M
                }).classed("spikeline", !0);
              }
              if (f) {
                var S,
                  C,
                  O = t.vLinePoint;
                n = O && O.xa, a = O && O.ya, "cursor" === n.spikesnap ? (S = c.pointerX, C = c.pointerY) : (S = n._offset + O.x, C = a._offset + O.y);
                var D,
                  P,
                  z = i.readability(O.color, d) < 1.5 ? p.contrast(d) : O.color,
                  I = n.spikemode,
                  E = n.spikethickness,
                  R = n.spikecolor || z,
                  N = g.getPxPosition(e, n);
                if (-1 !== I.indexOf("toaxis") || -1 !== I.indexOf("across")) {
                  if (-1 !== I.indexOf("toaxis") && (D = N, P = C), -1 !== I.indexOf("across")) {
                    var F = n._counterDomainMin,
                      H = n._counterDomainMax;
                    "free" === n.anchor && (F = Math.min(F, n.position), H = Math.max(H, n.position)), D = s.t + (1 - H) * s.h, P = s.t + (1 - F) * s.h;
                  }
                  o.insert("line", ":first-child").attr({
                    x1: S,
                    x2: S,
                    y1: D,
                    y2: P,
                    "stroke-width": E,
                    stroke: R,
                    "stroke-dasharray": h.dashStyle(n.spikedash, E)
                  }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                    x1: S,
                    x2: S,
                    y1: D,
                    y2: P,
                    "stroke-width": E + 2,
                    stroke: d
                  }).classed("spikeline", !0).classed("crisp", !0);
                }
                -1 !== I.indexOf("marker") && o.insert("circle", ":first-child").attr({
                  cx: S,
                  cy: N - ("top" !== n.side ? E : -E),
                  r: E,
                  fill: R
                }).classed("spikeline", !0);
              }
            }
          }
          function j(e, t) {
            return !t || t.vLinePoint !== e._spikepoints.vLinePoint || t.hLinePoint !== e._spikepoints.hLinePoint;
          }
          function Y(e, t) {
            return f.plainText(e || "", {
              len: t,
              allowedTags: ["br", "sub", "sup", "b", "i", "em", "s", "u"]
            });
          }
          function V(e, t, r) {
            var n = t[e + "a"],
              a = t[e + "Val"],
              i = t.cd[0];
            if ("category" === n.type || "multicategory" === n.type) a = n._categoriesMap[a];else if ("date" === n.type) {
              var o = t.trace[e + "periodalignment"];
              if (o) {
                var l = t.cd[t.index],
                  s = l[e + "Start"];
                void 0 === s && (s = l[e]);
                var c = l[e + "End"];
                void 0 === c && (c = l[e]);
                var u = c - s;
                "end" === o ? a += u : "middle" === o && (a += u / 2);
              }
              a = n.d2c(a);
            }
            return i && i.t && i.t.posLetter === n._id && ("group" !== r.boxmode && "group" !== r.violinmode || (a += i.t.dPos)), a;
          }
          function U(e) {
            return e.offsetTop + e.clientTop;
          }
          function q(e) {
            return e.offsetLeft + e.clientLeft;
          }
          function G(e, t) {
            var r = e._fullLayout,
              n = t.getBoundingClientRect(),
              a = n.left,
              i = n.top,
              l = a + n.width,
              s = i + n.height,
              c = o.apply3DTransform(r._invTransform)(a, i),
              u = o.apply3DTransform(r._invTransform)(l, s),
              f = c[0],
              d = c[1],
              h = u[0],
              p = u[1];
            return {
              x: f,
              y: d,
              width: h - f,
              height: p - d,
              top: Math.min(d, p),
              left: Math.min(f, h),
              right: Math.max(f, h),
              bottom: Math.max(d, p)
            };
          }
        },
        6430: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8766),
            i = r(6040).isUnifiedHover;
          e.exports = function (e, t, r, o) {
            o = o || {};
            var l = t.legend;
            function s(e) {
              o.font[e] || (o.font[e] = l ? t.legend.font[e] : t.font[e]);
            }
            t && i(t.hovermode) && (o.font || (o.font = {}), s("size"), s("family"), s("color"), s("weight"), s("style"), s("variant"), l ? (o.bgcolor || (o.bgcolor = a.combine(t.legend.bgcolor, t.paper_bgcolor)), o.bordercolor || (o.bordercolor = t.legend.bordercolor)) : o.bgcolor || (o.bgcolor = t.paper_bgcolor)), r("hoverlabel.bgcolor", o.bgcolor), r("hoverlabel.bordercolor", o.bordercolor), r("hoverlabel.namelength", o.namelength), n.coerceFont(r, "hoverlabel.font", o.font), r("hoverlabel.align", o.align);
          };
        },
        5265: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(6811);
          e.exports = function (e, t) {
            function r(r, i) {
              return void 0 !== t[r] ? t[r] : n.coerce(e, t, a, r, i);
            }
            return r("clickmode"), r("hoversubplots"), r("hovermode");
          };
        },
        2141: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4809),
            i = r(4751),
            o = r(6040),
            l = r(6811),
            s = r(8103);
          e.exports = {
            moduleType: "component",
            name: "fx",
            constants: r(5988),
            schema: {
              layout: l
            },
            attributes: r(192),
            layoutAttributes: l,
            supplyLayoutGlobalDefaults: r(5358),
            supplyDefaults: r(3239),
            supplyLayoutDefaults: r(8412),
            calc: r(3552),
            getDistanceFunction: o.getDistanceFunction,
            getClosest: o.getClosest,
            inbox: o.inbox,
            quadrature: o.quadrature,
            appendArrayPointValue: o.appendArrayPointValue,
            castHoverOption: function (e, t, r) {
              return a.castOption(e, t, "hoverlabel." + r);
            },
            castHoverinfo: function (e, t, r) {
              return a.castOption(e, r, "hoverinfo", function (r) {
                return a.coerceHoverinfo({
                  hoverinfo: r
                }, {
                  _module: e._module
                }, t);
              });
            },
            hover: s.hover,
            unhover: i.unhover,
            loneHover: s.loneHover,
            loneUnhover: function (e) {
              var t = a.isD3Selection(e) ? e : n.select(e);
              t.selectAll("g.hovertext").remove(), t.selectAll(".spikeline").remove();
            },
            click: r(4225)
          };
        },
        6811: function (e, t, r) {
          "use strict";

          var n = r(5988),
            a = r(337),
            i = a({
              editType: "none"
            });
          i.family.dflt = n.HOVERFONT, i.size.dflt = n.HOVERFONTSIZE, e.exports = {
            clickmode: {
              valType: "flaglist",
              flags: ["event", "select"],
              dflt: "event",
              editType: "plot",
              extras: ["none"]
            },
            dragmode: {
              valType: "enumerated",
              values: ["zoom", "pan", "select", "lasso", "drawclosedpath", "drawopenpath", "drawline", "drawrect", "drawcircle", "orbit", "turntable", !1],
              dflt: "zoom",
              editType: "modebar"
            },
            hovermode: {
              valType: "enumerated",
              values: ["x", "y", "closest", !1, "x unified", "y unified"],
              dflt: "closest",
              editType: "modebar"
            },
            hoversubplots: {
              valType: "enumerated",
              values: ["single", "overlaying", "axis"],
              dflt: "overlaying",
              editType: "none"
            },
            hoverdistance: {
              valType: "integer",
              min: -1,
              dflt: 20,
              editType: "none"
            },
            spikedistance: {
              valType: "integer",
              min: -1,
              dflt: -1,
              editType: "none"
            },
            hoverlabel: {
              bgcolor: {
                valType: "color",
                editType: "none"
              },
              bordercolor: {
                valType: "color",
                editType: "none"
              },
              font: i,
              grouptitlefont: a({
                editType: "none"
              }),
              align: {
                valType: "enumerated",
                values: ["left", "right", "auto"],
                dflt: "auto",
                editType: "none"
              },
              namelength: {
                valType: "integer",
                min: -1,
                dflt: 15,
                editType: "none"
              },
              editType: "none"
            },
            selectdirection: {
              valType: "enumerated",
              values: ["h", "v", "d", "any"],
              dflt: "any",
              editType: "none"
            }
          };
        },
        8412: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(6811),
            i = r(5265),
            o = r(6430);
          e.exports = function (e, t) {
            function r(r, i) {
              return n.coerce(e, t, a, r, i);
            }
            i(e, t) && (r("hoverdistance"), r("spikedistance")), "select" === r("dragmode") && r("selectdirection");
            var l = t._has("mapbox"),
              s = t._has("map"),
              c = t._has("geo"),
              u = t._basePlotModules.length;
            "zoom" === t.dragmode && ((l || s || c) && 1 === u || (l || s) && c && 2 === u) && (t.dragmode = "pan"), o(e, t, r), n.coerceFont(r, "hoverlabel.grouptitlefont", t.hoverlabel.font);
          };
        },
        5358: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(6430),
            i = r(6811);
          e.exports = function (e, t) {
            a(e, t, function (r, a) {
              return n.coerce(e, t, i, r, a);
            });
          };
        },
        3595: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(694).counter,
            i = r(3792).u,
            o = r(4826).idRegex,
            l = r(8032),
            s = {
              rows: {
                valType: "integer",
                min: 1,
                editType: "plot"
              },
              roworder: {
                valType: "enumerated",
                values: ["top to bottom", "bottom to top"],
                dflt: "top to bottom",
                editType: "plot"
              },
              columns: {
                valType: "integer",
                min: 1,
                editType: "plot"
              },
              subplots: {
                valType: "info_array",
                freeLength: !0,
                dimensions: 2,
                items: {
                  valType: "enumerated",
                  values: [a("xy").toString(), ""],
                  editType: "plot"
                },
                editType: "plot"
              },
              xaxes: {
                valType: "info_array",
                freeLength: !0,
                items: {
                  valType: "enumerated",
                  values: [o.x.toString(), ""],
                  editType: "plot"
                },
                editType: "plot"
              },
              yaxes: {
                valType: "info_array",
                freeLength: !0,
                items: {
                  valType: "enumerated",
                  values: [o.y.toString(), ""],
                  editType: "plot"
                },
                editType: "plot"
              },
              pattern: {
                valType: "enumerated",
                values: ["independent", "coupled"],
                dflt: "coupled",
                editType: "plot"
              },
              xgap: {
                valType: "number",
                min: 0,
                max: 1,
                editType: "plot"
              },
              ygap: {
                valType: "number",
                min: 0,
                max: 1,
                editType: "plot"
              },
              domain: i({
                name: "grid",
                editType: "plot",
                noGridCell: !0
              }, {}),
              xside: {
                valType: "enumerated",
                values: ["bottom", "bottom plot", "top plot", "top"],
                dflt: "bottom plot",
                editType: "plot"
              },
              yside: {
                valType: "enumerated",
                values: ["left", "left plot", "right plot", "right"],
                dflt: "left plot",
                editType: "plot"
              },
              editType: "plot"
            };
          function c(e, t, r) {
            var n = t[r + "axes"],
              a = Object.keys((e._splomAxes || {})[r] || {});
            return Array.isArray(n) ? n : a.length ? a : void 0;
          }
          function u(e, t, r, n, a, i) {
            var o = t(e + "gap", r),
              l = t("domain." + e);
            t(e + "side", n);
            for (var s = new Array(a), c = l[0], u = (l[1] - c) / (a - o), f = u * (1 - o), d = 0; d < a; d++) {
              var h = c + u * d;
              s[i ? a - 1 - d : d] = [h, h + f];
            }
            return s;
          }
          function f(e, t, r, n, a) {
            var i,
              o = new Array(r);
            function l(e, r) {
              -1 !== t.indexOf(r) && void 0 === n[r] ? (o[e] = r, n[r] = e) : o[e] = "";
            }
            if (Array.isArray(e)) for (i = 0; i < r; i++) l(i, e[i]);else for (l(0, a), i = 1; i < r; i++) l(i, a + (i + 1));
            return o;
          }
          e.exports = {
            moduleType: "component",
            name: "grid",
            schema: {
              layout: {
                grid: s
              }
            },
            layoutAttributes: s,
            sizeDefaults: function (e, t) {
              var r = e.grid || {},
                a = c(t, r, "x"),
                i = c(t, r, "y");
              if (e.grid || a || i) {
                var o,
                  f,
                  d = Array.isArray(r.subplots) && Array.isArray(r.subplots[0]),
                  h = Array.isArray(a),
                  p = Array.isArray(i),
                  v = h && a !== r.xaxes && p && i !== r.yaxes;
                d ? (o = r.subplots.length, f = r.subplots[0].length) : (p && (o = i.length), h && (f = a.length));
                var g = l.newContainer(t, "grid"),
                  m = M("rows", o),
                  y = M("columns", f);
                if (m * y > 1) {
                  d || h || p || "independent" === M("pattern") && (d = !0), g._hasSubplotGrid = d;
                  var x,
                    b,
                    _ = "top to bottom" === M("roworder"),
                    w = d ? .2 : .1,
                    T = d ? .3 : .1;
                  v && t._splomGridDflt && (x = t._splomGridDflt.xside, b = t._splomGridDflt.yside), g._domains = {
                    x: u("x", M, w, x, y),
                    y: u("y", M, T, b, m, _)
                  };
                } else delete t.grid;
              }
              function M(e, t) {
                return n.coerce(r, g, s, e, t);
              }
            },
            contentDefaults: function (e, t) {
              var r = t.grid;
              if (r && r._domains) {
                var n,
                  a,
                  i,
                  o,
                  l,
                  s,
                  u,
                  d = e.grid || {},
                  h = t._subplots,
                  p = r._hasSubplotGrid,
                  v = r.rows,
                  g = r.columns,
                  m = "independent" === r.pattern,
                  y = r._axisMap = {};
                if (p) {
                  var x = d.subplots || [];
                  s = r.subplots = new Array(v);
                  var b = 1;
                  for (n = 0; n < v; n++) {
                    var _ = s[n] = new Array(g),
                      w = x[n] || [];
                    for (a = 0; a < g; a++) if (m ? (l = 1 === b ? "xy" : "x" + b + "y" + b, b++) : l = w[a], _[a] = "", -1 !== h.cartesian.indexOf(l)) {
                      if (u = l.indexOf("y"), i = l.slice(0, u), o = l.slice(u), void 0 !== y[i] && y[i] !== a || void 0 !== y[o] && y[o] !== n) continue;
                      _[a] = l, y[i] = a, y[o] = n;
                    }
                  }
                } else {
                  var T = c(t, d, "x"),
                    M = c(t, d, "y");
                  r.xaxes = f(T, h.xaxis, g, y, "x"), r.yaxes = f(M, h.yaxis, v, y, "y");
                }
                var k = r._anchors = {},
                  A = "top to bottom" === r.roworder;
                for (var L in y) {
                  var S,
                    C,
                    O,
                    D = L.charAt(0),
                    P = r[D + "side"];
                  if (P.length < 8) k[L] = "free";else if ("x" === D) {
                    if ("t" === P.charAt(0) === A ? (S = 0, C = 1, O = v) : (S = v - 1, C = -1, O = -1), p) {
                      var z = y[L];
                      for (n = S; n !== O; n += C) if ((l = s[n][z]) && (u = l.indexOf("y"), l.slice(0, u) === L)) {
                        k[L] = l.slice(u);
                        break;
                      }
                    } else for (n = S; n !== O; n += C) if (o = r.yaxes[n], -1 !== h.cartesian.indexOf(L + o)) {
                      k[L] = o;
                      break;
                    }
                  } else if ("l" === P.charAt(0) ? (S = 0, C = 1, O = g) : (S = g - 1, C = -1, O = -1), p) {
                    var I = y[L];
                    for (n = S; n !== O; n += C) if ((l = s[I][n]) && (u = l.indexOf("y"), l.slice(u) === L)) {
                      k[L] = l.slice(0, u);
                      break;
                    }
                  } else for (n = S; n !== O; n += C) if (i = r.xaxes[n], -1 !== h.cartesian.indexOf(i + L)) {
                    k[L] = i;
                    break;
                  }
                }
              }
            }
          };
        },
        7260: function (e, t, r) {
          "use strict";

          var n = r(4826),
            a = r(8032).templatedArray;
          r(5081), e.exports = a("image", {
            visible: {
              valType: "boolean",
              dflt: !0,
              editType: "arraydraw"
            },
            source: {
              valType: "string",
              editType: "arraydraw"
            },
            layer: {
              valType: "enumerated",
              values: ["below", "above"],
              dflt: "above",
              editType: "arraydraw"
            },
            sizex: {
              valType: "number",
              dflt: 0,
              editType: "arraydraw"
            },
            sizey: {
              valType: "number",
              dflt: 0,
              editType: "arraydraw"
            },
            sizing: {
              valType: "enumerated",
              values: ["fill", "contain", "stretch"],
              dflt: "contain",
              editType: "arraydraw"
            },
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1,
              editType: "arraydraw"
            },
            x: {
              valType: "any",
              dflt: 0,
              editType: "arraydraw"
            },
            y: {
              valType: "any",
              dflt: 0,
              editType: "arraydraw"
            },
            xanchor: {
              valType: "enumerated",
              values: ["left", "center", "right"],
              dflt: "left",
              editType: "arraydraw"
            },
            yanchor: {
              valType: "enumerated",
              values: ["top", "middle", "bottom"],
              dflt: "top",
              editType: "arraydraw"
            },
            xref: {
              valType: "enumerated",
              values: ["paper", n.idRegex.x.toString()],
              dflt: "paper",
              editType: "arraydraw"
            },
            yref: {
              valType: "enumerated",
              values: ["paper", n.idRegex.y.toString()],
              dflt: "paper",
              editType: "arraydraw"
            },
            editType: "arraydraw"
          });
        },
        9443: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(8083);
          e.exports = function (e, t, r, i) {
            t = t || {};
            var o = "log" === r && "linear" === t.type,
              l = "linear" === r && "log" === t.type;
            if (o || l) for (var s, c, u = e._fullLayout.images, f = t._id.charAt(0), d = 0; d < u.length; d++) if (c = "images[" + d + "].", (s = u[d])[f + "ref"] === t._id) {
              var h = s[f],
                p = s["size" + f],
                v = null,
                g = null;
              if (o) {
                v = a(h, t.range);
                var m = p / Math.pow(10, v) / 2;
                g = 2 * Math.log(m + Math.sqrt(1 + m * m)) / Math.LN10;
              } else g = (v = Math.pow(10, h)) * (Math.pow(10, p / 2) - Math.pow(10, -p / 2));
              n(v) ? n(g) || (g = null) : (v = null, g = null), i(c + f, v), i(c + "size" + f, g);
            }
          };
        },
        507: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714),
            i = r(9008),
            o = r(7260);
          function l(e, t, r) {
            function i(r, a) {
              return n.coerce(e, t, o, r, a);
            }
            var l = i("source");
            if (!i("visible", !!l)) return t;
            i("layer"), i("xanchor"), i("yanchor"), i("sizex"), i("sizey"), i("sizing"), i("opacity");
            for (var s = {
                _fullLayout: r
              }, c = ["x", "y"], u = 0; u < 2; u++) {
              var f = c[u],
                d = a.coerceRef(e, t, s, f, "paper", void 0);
              "paper" !== d && a.getFromId(s, d)._imgIndices.push(t._index), a.coercePosition(t, s, i, d, f, 0);
            }
            return t;
          }
          e.exports = function (e, t) {
            i(e, t, {
              name: "images",
              handleItemDefaults: l
            });
          };
        },
        2211: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(2203),
            i = r(9714),
            o = r(5975),
            l = r(2972);
          e.exports = function (e) {
            var t,
              r,
              s = e._fullLayout,
              c = [],
              u = {},
              f = [];
            for (r = 0; r < s.images.length; r++) {
              var d = s.images[r];
              if (d.visible) if ("below" === d.layer && "paper" !== d.xref && "paper" !== d.yref) {
                t = o.ref2id(d.xref) + o.ref2id(d.yref);
                var h = s._plots[t];
                if (!h) {
                  f.push(d);
                  continue;
                }
                h.mainplot && (t = h.mainplot.id), u[t] || (u[t] = []), u[t].push(d);
              } else "above" === d.layer ? c.push(d) : f.push(d);
            }
            var p = {
                left: {
                  sizing: "xMin",
                  offset: 0
                },
                center: {
                  sizing: "xMid",
                  offset: -.5
                },
                right: {
                  sizing: "xMax",
                  offset: -1
                }
              },
              v = {
                top: {
                  sizing: "YMin",
                  offset: 0
                },
                middle: {
                  sizing: "YMid",
                  offset: -.5
                },
                bottom: {
                  sizing: "YMax",
                  offset: -1
                }
              };
            function g(t) {
              var r = n.select(this);
              if (this._imgSrc !== t.source) if (r.attr("xmlns", l.svg), t.source && "data:" === t.source.slice(0, 5)) r.attr("xlink:href", t.source), this._imgSrc = t.source;else {
                var a = new Promise(function (e) {
                  var n = new Image();
                  function a() {
                    r.remove(), e();
                  }
                  this.img = n, n.setAttribute("crossOrigin", "anonymous"), n.onerror = a, n.onload = function () {
                    var t = document.createElement("canvas");
                    t.width = this.width, t.height = this.height, t.getContext("2d", {
                      willReadFrequently: !0
                    }).drawImage(this, 0, 0);
                    var n = t.toDataURL("image/png");
                    r.attr("xlink:href", n), e();
                  }, r.on("error", a), n.src = t.source, this._imgSrc = t.source;
                }.bind(this));
                e._promises.push(a);
              }
            }
            function m(t) {
              var r,
                o,
                l = n.select(this),
                c = i.getFromId(e, t.xref),
                u = i.getFromId(e, t.yref),
                f = "domain" === i.getRefType(t.xref),
                d = "domain" === i.getRefType(t.yref),
                h = s._size;
              r = void 0 !== c ? "string" == typeof t.xref && f ? c._length * t.sizex : Math.abs(c.l2p(t.sizex) - c.l2p(0)) : t.sizex * h.w, o = void 0 !== u ? "string" == typeof t.yref && d ? u._length * t.sizey : Math.abs(u.l2p(t.sizey) - u.l2p(0)) : t.sizey * h.h;
              var g,
                m,
                y = r * p[t.xanchor].offset,
                x = o * v[t.yanchor].offset,
                b = p[t.xanchor].sizing + v[t.yanchor].sizing;
              switch (g = void 0 !== c ? "string" == typeof t.xref && f ? c._length * t.x + c._offset : c.r2p(t.x) + c._offset : t.x * h.w + h.l, g += y, m = void 0 !== u ? "string" == typeof t.yref && d ? u._length * (1 - t.y) + u._offset : u.r2p(t.y) + u._offset : h.h - t.y * h.h + h.t, m += x, t.sizing) {
                case "fill":
                  b += " slice";
                  break;
                case "stretch":
                  b = "none";
              }
              l.attr({
                x: g,
                y: m,
                width: r,
                height: o,
                preserveAspectRatio: b,
                opacity: t.opacity
              });
              var _ = (c && "domain" !== i.getRefType(t.xref) ? c._id : "") + (u && "domain" !== i.getRefType(t.yref) ? u._id : "");
              a.setClipUrl(l, _ ? "clip" + s._uid + _ : null, e);
            }
            var y = s._imageLowerLayer.selectAll("image").data(f),
              x = s._imageUpperLayer.selectAll("image").data(c);
            y.enter().append("image"), x.enter().append("image"), y.exit().remove(), x.exit().remove(), y.each(function (e) {
              g.bind(this)(e), m.bind(this)(e);
            }), x.each(function (e) {
              g.bind(this)(e), m.bind(this)(e);
            });
            var b = Object.keys(s._plots);
            for (r = 0; r < b.length; r++) {
              t = b[r];
              var _ = s._plots[t];
              if (_.imagelayer) {
                var w = _.imagelayer.selectAll("image").data(u[t] || []);
                w.enter().append("image"), w.exit().remove(), w.each(function (e) {
                  g.bind(this)(e), m.bind(this)(e);
                });
              }
            }
          };
        },
        5553: function (e, t, r) {
          "use strict";

          e.exports = {
            moduleType: "component",
            name: "images",
            layoutAttributes: r(7260),
            supplyLayoutDefaults: r(507),
            includeBasePlot: r(706)("images"),
            draw: r(2211),
            convertCoords: r(9443)
          };
        },
        6405: function (e, t, r) {
          "use strict";

          var n = r(337),
            a = r(229);
          e.exports = {
            _isSubplotObj: !0,
            visible: {
              valType: "boolean",
              dflt: !0,
              editType: "legend"
            },
            bgcolor: {
              valType: "color",
              editType: "legend"
            },
            bordercolor: {
              valType: "color",
              dflt: a.defaultLine,
              editType: "legend"
            },
            borderwidth: {
              valType: "number",
              min: 0,
              dflt: 0,
              editType: "legend"
            },
            font: n({
              editType: "legend"
            }),
            grouptitlefont: n({
              editType: "legend"
            }),
            orientation: {
              valType: "enumerated",
              values: ["v", "h"],
              dflt: "v",
              editType: "legend"
            },
            traceorder: {
              valType: "flaglist",
              flags: ["reversed", "grouped"],
              extras: ["normal"],
              editType: "legend"
            },
            tracegroupgap: {
              valType: "number",
              min: 0,
              dflt: 10,
              editType: "legend"
            },
            entrywidth: {
              valType: "number",
              min: 0,
              editType: "legend"
            },
            entrywidthmode: {
              valType: "enumerated",
              values: ["fraction", "pixels"],
              dflt: "pixels",
              editType: "legend"
            },
            indentation: {
              valType: "number",
              min: -15,
              dflt: 0,
              editType: "legend"
            },
            itemsizing: {
              valType: "enumerated",
              values: ["trace", "constant"],
              dflt: "trace",
              editType: "legend"
            },
            itemwidth: {
              valType: "number",
              min: 30,
              dflt: 30,
              editType: "legend"
            },
            itemclick: {
              valType: "enumerated",
              values: ["toggle", "toggleothers", !1],
              dflt: "toggle",
              editType: "legend"
            },
            itemdoubleclick: {
              valType: "enumerated",
              values: ["toggle", "toggleothers", !1],
              dflt: "toggleothers",
              editType: "legend"
            },
            groupclick: {
              valType: "enumerated",
              values: ["toggleitem", "togglegroup"],
              dflt: "togglegroup",
              editType: "legend"
            },
            x: {
              valType: "number",
              editType: "legend"
            },
            xref: {
              valType: "enumerated",
              dflt: "paper",
              values: ["container", "paper"],
              editType: "layoutstyle"
            },
            xanchor: {
              valType: "enumerated",
              values: ["auto", "left", "center", "right"],
              dflt: "left",
              editType: "legend"
            },
            y: {
              valType: "number",
              editType: "legend"
            },
            yref: {
              valType: "enumerated",
              dflt: "paper",
              values: ["container", "paper"],
              editType: "layoutstyle"
            },
            yanchor: {
              valType: "enumerated",
              values: ["auto", "top", "middle", "bottom"],
              editType: "legend"
            },
            uirevision: {
              valType: "any",
              editType: "none"
            },
            valign: {
              valType: "enumerated",
              values: ["top", "middle", "bottom"],
              dflt: "middle",
              editType: "legend"
            },
            title: {
              text: {
                valType: "string",
                dflt: "",
                editType: "legend"
              },
              font: n({
                editType: "legend"
              }),
              side: {
                valType: "enumerated",
                values: ["top", "left", "top left", "top center", "top right"],
                editType: "legend"
              },
              editType: "legend"
            },
            editType: "legend"
          };
        },
        2783: function (e) {
          "use strict";

          e.exports = {
            scrollBarWidth: 6,
            scrollBarMinHeight: 20,
            scrollBarColor: "#808BA4",
            scrollBarMargin: 4,
            scrollBarEnterAttrs: {
              rx: 20,
              ry: 3,
              width: 0,
              height: 0
            },
            titlePad: 2,
            itemGap: 5
          };
        },
        3970: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(4809),
            i = r(8032),
            o = r(9829),
            l = r(6405),
            s = r(6704),
            c = r(7599);
          function u(e, t, r, u) {
            var f = t[e] || {},
              d = i.newContainer(r, e);
            function h(e, t) {
              return a.coerce(f, d, l, e, t);
            }
            var p = a.coerceFont(h, "font", r.font);
            if (h("bgcolor", r.paper_bgcolor), h("bordercolor"), h("visible")) {
              for (var v, g = function (e, t) {
                  var r = v._input,
                    n = v;
                  return a.coerce(r, n, o, e, t);
                }, m = r.font || {}, y = a.coerceFont(h, "grouptitlefont", m, {
                  overrideDflt: {
                    size: Math.round(1.1 * m.size)
                  }
                }), x = 0, b = !1, _ = "normal", w = (r.shapes || []).filter(function (e) {
                  return e.showlegend;
                }), T = u.concat(w).filter(function (t) {
                  return e === (t.legend || "legend");
                }), M = 0; M < T.length; M++) if ((v = T[M]).visible) {
                var k = v._isShape;
                (v.showlegend || v._dfltShowLegend && !(v._module && v._module.attributes && v._module.attributes.showlegend && !1 === v._module.attributes.showlegend.dflt)) && (x++, v.showlegend && (b = !0, (!k && n.traceIs(v, "pie-like") || !0 === v._input.showlegend) && x++), a.coerceFont(g, "legendgrouptitle.font", y)), (!k && n.traceIs(v, "bar") && "stack" === r.barmode || -1 !== ["tonextx", "tonexty"].indexOf(v.fill)) && (_ = c.isGrouped({
                  traceorder: _
                }) ? "grouped+reversed" : "reversed"), void 0 !== v.legendgroup && "" !== v.legendgroup && (_ = c.isReversed({
                  traceorder: _
                }) ? "reversed+grouped" : "grouped");
              }
              var A = a.coerce(t, r, s, "showlegend", b && x > ("legend" === e ? 1 : 0));
              if (!1 === A && (r[e] = void 0), (!1 !== A || f.uirevision) && (h("uirevision", r.uirevision), !1 !== A)) {
                h("borderwidth");
                var L,
                  S,
                  C,
                  O = "h" === h("orientation"),
                  D = "paper" === h("yref"),
                  P = "paper" === h("xref"),
                  z = "left";
                if (O ? (L = 0, n.getComponentMethod("rangeslider", "isVisible")(t.xaxis) ? D ? (S = 1.1, C = "bottom") : (S = 1, C = "top") : D ? (S = -.1, C = "top") : (S = 0, C = "bottom")) : (S = 1, C = "auto", P ? L = 1.02 : (L = 1, z = "right")), a.coerce(f, d, {
                  x: {
                    valType: "number",
                    editType: "legend",
                    min: P ? -2 : 0,
                    max: P ? 3 : 1,
                    dflt: L
                  }
                }, "x"), a.coerce(f, d, {
                  y: {
                    valType: "number",
                    editType: "legend",
                    min: D ? -2 : 0,
                    max: D ? 3 : 1,
                    dflt: S
                  }
                }, "y"), h("traceorder", _), c.isGrouped(r[e]) && h("tracegroupgap"), h("entrywidth"), h("entrywidthmode"), h("indentation"), h("itemsizing"), h("itemwidth"), h("itemclick"), h("itemdoubleclick"), h("groupclick"), h("xanchor", z), h("yanchor", C), h("valign"), a.noneOrAll(f, d, ["x", "y"]), h("title.text")) {
                  h("title.side", O ? "left" : "top");
                  var I = a.extendFlat({}, p, {
                    size: a.bigFont(p.size)
                  });
                  a.coerceFont(h, "title.font", I);
                }
              }
            }
          }
          e.exports = function (e, t, r) {
            var n,
              i = r.slice(),
              o = t.shapes;
            if (o) for (n = 0; n < o.length; n++) {
              var l = o[n];
              if (l.showlegend) {
                var s = {
                  _input: l._input,
                  visible: l.visible,
                  showlegend: l.showlegend,
                  legend: l.legend
                };
                i.push(s);
              }
            }
            var c = ["legend"];
            for (n = 0; n < i.length; n++) a.pushUnique(c, i[n].legend);
            for (t._legends = [], n = 0; n < c.length; n++) {
              var f = c[n];
              u(f, e, t, i), t[f] && t[f].visible && (t[f]._id = f), t._legends.push(f);
            }
          };
        },
        6134: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4809),
            i = r(4122),
            o = r(3626),
            l = r(8596),
            s = r(4751),
            c = r(2203),
            u = r(8766),
            f = r(635),
            d = r(2165),
            h = r(2783),
            p = r(4530),
            v = p.LINE_SPACING,
            g = p.FROM_TL,
            m = p.FROM_BR,
            y = r(851),
            x = r(4375),
            b = r(7599),
            _ = 1,
            w = /^legend[0-9]*$/;
          function T(e, t) {
            var r,
              l,
              d = t || {},
              p = e._fullLayout,
              w = P(d),
              T = d._inHover;
            if (T ? (l = d.layer, r = "hover") : (l = p._infolayer, r = w), l) {
              var L;
              if (r += p._uid, e._legendMouseDownTime || (e._legendMouseDownTime = 0), T) {
                if (!d.entries) return;
                L = y(d.entries, d);
              } else {
                for (var z = (e.calcdata || []).slice(), I = p.shapes, E = 0; E < I.length; E++) {
                  var R = I[E];
                  if (R.showlegend) {
                    var N = {
                      _isShape: !0,
                      _fullInput: R,
                      index: R._index,
                      name: R.name || R.label.text || "shape " + R._index,
                      legend: R.legend,
                      legendgroup: R.legendgroup,
                      legendgrouptitle: R.legendgrouptitle,
                      legendrank: R.legendrank,
                      legendwidth: R.legendwidth,
                      showlegend: R.showlegend,
                      visible: R.visible,
                      opacity: R.opacity,
                      mode: "line" === R.type ? "lines" : "markers",
                      line: R.line,
                      marker: {
                        line: R.line,
                        color: R.fillcolor,
                        size: 12,
                        symbol: "rect" === R.type ? "square" : "circle" === R.type ? "circle" : "hexagon2"
                      }
                    };
                    z.push([{
                      trace: N
                    }]);
                  }
                }
                L = p.showlegend && y(z, d, p._legends.length > 1);
              }
              var F = p.hiddenlabels || [];
              if (!(T || p.showlegend && L.length)) return l.selectAll("." + w).remove(), p._topdefs.select("#" + r).remove(), i.autoMargin(e, w);
              var H = a.ensureSingle(l, "g", w, function (e) {
                  T || e.attr("pointer-events", "all");
                }),
                B = a.ensureSingleById(p._topdefs, "clipPath", r, function (e) {
                  e.append("rect");
                }),
                j = a.ensureSingle(H, "rect", "bg", function (e) {
                  e.attr("shape-rendering", "crispEdges");
                });
              j.call(u.stroke, d.bordercolor).call(u.fill, d.bgcolor).style("stroke-width", d.borderwidth + "px");
              var Y,
                V = a.ensureSingle(H, "g", "scrollbox"),
                U = d.title;
              d._titleWidth = 0, d._titleHeight = 0, U.text ? ((Y = a.ensureSingle(V, "text", w + "titletext")).attr("text-anchor", "start").call(c.font, U.font).text(U.text), C(Y, V, e, d, _)) : V.selectAll("." + w + "titletext").remove();
              var q = a.ensureSingle(H, "rect", "scrollbar", function (e) {
                  e.attr(h.scrollBarEnterAttrs).call(u.fill, h.scrollBarColor);
                }),
                G = V.selectAll("g.groups").data(L);
              G.enter().append("g").attr("class", "groups"), G.exit().remove();
              var Z = G.selectAll("g.traces").data(a.identity);
              Z.enter().append("g").attr("class", "traces"), Z.exit().remove(), Z.style("opacity", function (e) {
                var t = e[0].trace;
                return o.traceIs(t, "pie-like") ? -1 !== F.indexOf(e[0].label) ? .5 : 1 : "legendonly" === t.visible ? .5 : 1;
              }).each(function () {
                n.select(this).call(A, e, d);
              }).call(x, e, d).each(function () {
                T || n.select(this).call(S, e, w);
              }), a.syncOrAsync([i.previousPromises, function () {
                return function (e, t, r, a) {
                  var i = e._fullLayout,
                    o = P(a);
                  a || (a = i[o]);
                  var l = i._size,
                    s = b.isVertical(a),
                    u = b.isGrouped(a),
                    f = "fraction" === a.entrywidthmode,
                    d = a.borderwidth,
                    p = 2 * d,
                    v = h.itemGap,
                    g = a.indentation + a.itemwidth + 2 * v,
                    m = 2 * (d + v),
                    y = D(a),
                    x = a.y < 0 || 0 === a.y && "top" === y,
                    _ = a.y > 1 || 1 === a.y && "bottom" === y,
                    w = a.tracegroupgap,
                    T = {};
                  a._maxHeight = Math.max(x || _ ? i.height / 2 : l.h, 30);
                  var k = 0;
                  a._width = 0, a._height = 0;
                  var A = function (e) {
                    var t = 0,
                      r = 0,
                      n = e.title.side;
                    return n && (-1 !== n.indexOf("left") && (t = e._titleWidth), -1 !== n.indexOf("top") && (r = e._titleHeight)), [t, r];
                  }(a);
                  if (s) r.each(function (e) {
                    var t = e[0].height;
                    c.setTranslate(this, d + A[0], d + A[1] + a._height + t / 2 + v), a._height += t, a._width = Math.max(a._width, e[0].width);
                  }), k = g + a._width, a._width += v + g + p, a._height += m, u && (t.each(function (e, t) {
                    c.setTranslate(this, 0, t * a.tracegroupgap);
                  }), a._height += (a._lgroupsLength - 1) * a.tracegroupgap);else {
                    var L = O(a),
                      S = a.x < 0 || 0 === a.x && "right" === L,
                      C = a.x > 1 || 1 === a.x && "left" === L,
                      z = _ || x,
                      I = i.width / 2;
                    a._maxWidth = Math.max(S ? z && "left" === L ? l.l + l.w : I : C ? z && "right" === L ? l.r + l.w : I : l.w, 2 * g);
                    var E = 0,
                      R = 0;
                    r.each(function (e) {
                      var t = M(e, a, g);
                      E = Math.max(E, t), R += t;
                    }), k = null;
                    var N = 0;
                    if (u) {
                      var F = 0,
                        H = 0,
                        B = 0;
                      t.each(function () {
                        var e = 0,
                          t = 0;
                        n.select(this).selectAll("g.traces").each(function (r) {
                          var n = M(r, a, g),
                            i = r[0].height;
                          c.setTranslate(this, A[0], A[1] + d + v + i / 2 + t), t += i, e = Math.max(e, n), T[r[0].trace.legendgroup] = e;
                        });
                        var r = e + v;
                        H > 0 && r + d + H > a._maxWidth ? (N = Math.max(N, H), H = 0, B += F + w, F = t) : F = Math.max(F, t), c.setTranslate(this, H, B), H += r;
                      }), a._width = Math.max(N, H) + d, a._height = B + F + m;
                    } else {
                      var j = r.size(),
                        Y = R + p + (j - 1) * v < a._maxWidth,
                        V = 0,
                        U = 0,
                        q = 0,
                        G = 0;
                      r.each(function (e) {
                        var t = e[0].height,
                          r = M(e, a, g),
                          n = Y ? r : E;
                        f || (n += v), n + d + U - v >= a._maxWidth && (N = Math.max(N, G), U = 0, q += V, a._height += V, V = 0), c.setTranslate(this, A[0] + d + U, A[1] + d + q + t / 2 + v), G = U + r + v, U += n, V = Math.max(V, t);
                      }), Y ? (a._width = U + p, a._height = V + m) : (a._width = Math.max(N, G) + p, a._height += V + m);
                    }
                  }
                  a._width = Math.ceil(Math.max(a._width + A[0], a._titleWidth + 2 * (d + h.titlePad))), a._height = Math.ceil(Math.max(a._height + A[1], a._titleHeight + 2 * (d + h.itemGap))), a._effHeight = Math.min(a._height, a._maxHeight);
                  var Z = e._context.edits,
                    W = Z.legendText || Z.legendPosition;
                  r.each(function (e) {
                    var t = n.select(this).select("." + o + "toggle"),
                      r = e[0].height,
                      i = e[0].trace.legendgroup,
                      l = M(e, a, g);
                    u && "" !== i && (l = T[i]);
                    var d = W ? g : k || l;
                    s || f || (d += v / 2), c.setRect(t, 0, -r / 2, d, r);
                  });
                }(e, G, Z, d);
              }, function () {
                var t,
                  u,
                  y,
                  x,
                  b = p._size,
                  _ = d.borderwidth,
                  M = "paper" === d.xref,
                  A = "paper" === d.yref;
                if (U.text && function (e, t, r) {
                  if ("top center" === t.title.side || "top right" === t.title.side) {
                    var n = t.title.font.size * v,
                      a = 0,
                      i = e.node(),
                      o = c.bBox(i).width;
                    "top center" === t.title.side ? a = .5 * (t._width - 2 * r - 2 * h.titlePad - o) : "top right" === t.title.side && (a = t._width - 2 * r - 2 * h.titlePad - o), f.positionText(e, r + h.titlePad + a, r + n);
                  }
                }(Y, d, _), !T) {
                  var L, S;
                  L = M ? b.l + b.w * d.x - g[O(d)] * d._width : p.width * d.x - g[O(d)] * d._width, S = A ? b.t + b.h * (1 - d.y) - g[D(d)] * d._effHeight : p.height * (1 - d.y) - g[D(d)] * d._effHeight;
                  var C = function (e, t, r, n) {
                    var a = e._fullLayout,
                      o = a[t],
                      l = O(o),
                      s = D(o),
                      c = "paper" === o.xref,
                      u = "paper" === o.yref;
                    e._fullLayout._reservedMargin[t] = {};
                    var f = o.y < .5 ? "b" : "t",
                      d = o.x < .5 ? "l" : "r",
                      h = {
                        r: a.width - r,
                        l: r + o._width,
                        b: a.height - n,
                        t: n + o._effHeight
                      };
                    if (c && u) return i.autoMargin(e, t, {
                      x: o.x,
                      y: o.y,
                      l: o._width * g[l],
                      r: o._width * m[l],
                      b: o._effHeight * m[s],
                      t: o._effHeight * g[s]
                    });
                    c ? e._fullLayout._reservedMargin[t][f] = h[f] : u || "v" === o.orientation ? e._fullLayout._reservedMargin[t][d] = h[d] : e._fullLayout._reservedMargin[t][f] = h[f];
                  }(e, w, L, S);
                  if (C) return;
                  if (p.margin.autoexpand) {
                    var P = L,
                      z = S;
                    L = M ? a.constrain(L, 0, p.width - d._width) : P, S = A ? a.constrain(S, 0, p.height - d._effHeight) : z, L !== P && a.log("Constrain " + w + ".x to make legend fit inside graph"), S !== z && a.log("Constrain " + w + ".y to make legend fit inside graph");
                  }
                  c.setTranslate(H, L, S);
                }
                if (q.on(".drag", null), H.on("wheel", null), T || d._height <= d._maxHeight || e._context.staticPlot) {
                  var I = d._effHeight;
                  T && (I = d._height), j.attr({
                    width: d._width - _,
                    height: I - _,
                    x: _ / 2,
                    y: _ / 2
                  }), c.setTranslate(V, 0, 0), B.select("rect").attr({
                    width: d._width - 2 * _,
                    height: I - 2 * _,
                    x: _,
                    y: _
                  }), c.setClipUrl(V, r, e), c.setRect(q, 0, 0, 0, 0), delete d._scrollY;
                } else {
                  var E,
                    R,
                    N,
                    F = Math.max(h.scrollBarMinHeight, d._effHeight * d._effHeight / d._height),
                    G = d._effHeight - F - 2 * h.scrollBarMargin,
                    Z = d._height - d._effHeight,
                    W = G / Z,
                    J = Math.min(d._scrollY || 0, Z);
                  j.attr({
                    width: d._width - 2 * _ + h.scrollBarWidth + h.scrollBarMargin,
                    height: d._effHeight - _,
                    x: _ / 2,
                    y: _ / 2
                  }), B.select("rect").attr({
                    width: d._width - 2 * _ + h.scrollBarWidth + h.scrollBarMargin,
                    height: d._effHeight - 2 * _,
                    x: _,
                    y: _ + J
                  }), c.setClipUrl(V, r, e), Q(J, F, W), H.on("wheel", function () {
                    Q(J = a.constrain(d._scrollY + n.event.deltaY / G * Z, 0, Z), F, W), 0 !== J && J !== Z && n.event.preventDefault();
                  });
                  var X = n.behavior.drag().on("dragstart", function () {
                    var e = n.event.sourceEvent;
                    E = "touchstart" === e.type ? e.changedTouches[0].clientY : e.clientY, N = J;
                  }).on("drag", function () {
                    var e = n.event.sourceEvent;
                    2 === e.buttons || e.ctrlKey || (R = "touchmove" === e.type ? e.changedTouches[0].clientY : e.clientY, J = function (e, t, r) {
                      var n = (r - t) / W + e;
                      return a.constrain(n, 0, Z);
                    }(N, E, R), Q(J, F, W));
                  });
                  q.call(X);
                  var K = n.behavior.drag().on("dragstart", function () {
                    var e = n.event.sourceEvent;
                    "touchstart" === e.type && (E = e.changedTouches[0].clientY, N = J);
                  }).on("drag", function () {
                    var e = n.event.sourceEvent;
                    "touchmove" === e.type && (R = e.changedTouches[0].clientY, J = function (e, t, r) {
                      var n = (t - r) / W + e;
                      return a.constrain(n, 0, Z);
                    }(N, E, R), Q(J, F, W));
                  });
                  V.call(K);
                }
                function Q(t, r, n) {
                  d._scrollY = e._fullLayout[w]._scrollY = t, c.setTranslate(V, 0, -t), c.setRect(q, d._width, h.scrollBarMargin + t * n, h.scrollBarWidth, r), B.select("rect").attr("y", _ + t);
                }
                e._context.edits.legendPosition && (H.classed("cursor-move", !0), s.init({
                  element: H.node(),
                  gd: e,
                  prepFn: function (e) {
                    if (e.target !== q.node()) {
                      var t = c.getTranslate(H);
                      y = t.x, x = t.y;
                    }
                  },
                  moveFn: function (e, r) {
                    if (void 0 !== y && void 0 !== x) {
                      var n = y + e,
                        a = x + r;
                      c.setTranslate(H, n, a), t = s.align(n, d._width, b.l, b.l + b.w, d.xanchor), u = s.align(a + d._height, -d._height, b.t + b.h, b.t, d.yanchor);
                    }
                  },
                  doneFn: function () {
                    if (void 0 !== t && void 0 !== u) {
                      var r = {};
                      r[w + ".x"] = t, r[w + ".y"] = u, o.call("_guiRelayout", e, r);
                    }
                  },
                  clickFn: function (t, r) {
                    var n = l.selectAll("g.traces").filter(function () {
                      var e = this.getBoundingClientRect();
                      return r.clientX >= e.left && r.clientX <= e.right && r.clientY >= e.top && r.clientY <= e.bottom;
                    });
                    n.size() > 0 && k(e, H, n, t, r);
                  }
                }));
              }], e);
            }
          }
          function M(e, t, r) {
            var n = e[0],
              a = n.width,
              i = t.entrywidthmode,
              o = n.trace.legendwidth || t.entrywidth;
            return "fraction" === i ? t._maxWidth * o : r + (o || a);
          }
          function k(e, t, r, n, a) {
            var i = r.data()[0][0].trace,
              s = {
                event: a,
                node: r.node(),
                curveNumber: i.index,
                expandedIndex: i._expandedIndex,
                data: e.data,
                layout: e.layout,
                frames: e._transitionData._frames,
                config: e._context,
                fullData: e._fullData,
                fullLayout: e._fullLayout
              };
            i._group && (s.group = i._group), o.traceIs(i, "pie-like") && (s.label = r.datum()[0].label);
            var c = l.triggerHandler(e, "plotly_legendclick", s);
            if (1 === n) {
              if (!1 === c) return;
              t._clickTimeout = setTimeout(function () {
                e._fullLayout && d(r, e, n);
              }, e._context.doubleClickDelay);
            } else 2 === n && (t._clickTimeout && clearTimeout(t._clickTimeout), e._legendMouseDownTime = 0, !1 !== l.triggerHandler(e, "plotly_legenddoubleclick", s) && !1 !== c && d(r, e, n));
          }
          function A(e, t, r) {
            var n,
              i,
              l = P(r),
              s = e.data()[0][0],
              u = s.trace,
              d = o.traceIs(u, "pie-like"),
              p = !r._inHover && t._context.edits.legendText && !d,
              v = r._maxNameLength;
            s.groupTitle ? (n = s.groupTitle.text, i = s.groupTitle.font) : (i = r.font, r.entries ? n = s.text : (n = d ? s.label : u.name, u._meta && (n = a.templateString(n, u._meta))));
            var g = a.ensureSingle(e, "text", l + "text");
            g.attr("text-anchor", "start").call(c.font, i).text(p ? L(n, v) : n);
            var m = r.indentation + r.itemwidth + 2 * h.itemGap;
            f.positionText(g, m, 0), p ? g.call(f.makeEditable, {
              gd: t,
              text: n
            }).call(C, e, t, r).on("edit", function (n) {
              this.text(L(n, v)).call(C, e, t, r);
              var i = s.trace._fullInput || {},
                l = {};
              if (o.hasTransform(i, "groupby")) {
                var c = o.getTransformIndices(i, "groupby"),
                  f = c[c.length - 1],
                  d = a.keyedContainer(i, "transforms[" + f + "].styles", "target", "value.name");
                d.set(s.trace._group, n), l = d.constructUpdate();
              } else l.name = n;
              return i._isShape ? o.call("_guiRelayout", t, "shapes[" + u.index + "].name", l.name) : o.call("_guiRestyle", t, l, u.index);
            }) : C(g, e, t, r);
          }
          function L(e, t) {
            var r = Math.max(4, t);
            if (e && e.trim().length >= r / 2) return e;
            for (var n = r - (e = e || "").length; n > 0; n--) e += " ";
            return e;
          }
          function S(e, t, r) {
            var i,
              o = t._context.doubleClickDelay,
              l = 1,
              s = a.ensureSingle(e, "rect", r + "toggle", function (e) {
                t._context.staticPlot || e.style("cursor", "pointer").attr("pointer-events", "all"), e.call(u.fill, "rgba(0,0,0,0)");
              });
            t._context.staticPlot || (s.on("mousedown", function () {
              (i = new Date().getTime()) - t._legendMouseDownTime < o ? l += 1 : (l = 1, t._legendMouseDownTime = i);
            }), s.on("mouseup", function () {
              if (!t._dragged && !t._editing) {
                var a = t._fullLayout[r];
                new Date().getTime() - t._legendMouseDownTime > o && (l = Math.max(l - 1, 1)), k(t, a, e, l, n.event);
              }
            }));
          }
          function C(e, t, r, n, a) {
            n._inHover && e.attr("data-notex", !0), f.convertToTspans(e, r, function () {
              !function (e, t, r, n) {
                var a = e.data()[0][0];
                if (r._inHover || !a || a.trace.showlegend) {
                  var i = e.select("g[class*=math-group]"),
                    o = i.node(),
                    l = P(r);
                  r || (r = t._fullLayout[l]);
                  var s,
                    u,
                    d = r.borderwidth,
                    p = (n === _ ? r.title.font : a.groupTitle ? a.groupTitle.font : r.font).size * v;
                  if (o) {
                    var g = c.bBox(o);
                    s = g.height, u = g.width, n === _ ? c.setTranslate(i, d, d + .75 * s) : c.setTranslate(i, 0, .25 * s);
                  } else {
                    var m = "." + l + (n === _ ? "title" : "") + "text",
                      y = e.select(m),
                      x = f.lineCount(y),
                      b = y.node();
                    if (s = p * x, u = b ? c.bBox(b).width : 0, n === _) "left" === r.title.side && (u += 2 * h.itemGap), f.positionText(y, d + h.titlePad, d + p);else {
                      var w = 2 * h.itemGap + r.indentation + r.itemwidth;
                      a.groupTitle && (w = h.itemGap, u -= r.indentation + r.itemwidth), f.positionText(y, w, -p * ((x - 1) / 2 - .3));
                    }
                  }
                  n === _ ? (r._titleWidth = u, r._titleHeight = s) : (a.lineHeight = p, a.height = Math.max(s, 16) + 3, a.width = u);
                } else e.remove();
              }(t, r, n, a);
            });
          }
          function O(e) {
            return a.isRightAnchor(e) ? "right" : a.isCenterAnchor(e) ? "center" : "left";
          }
          function D(e) {
            return a.isBottomAnchor(e) ? "bottom" : a.isMiddleAnchor(e) ? "middle" : "top";
          }
          function P(e) {
            return e._id || "legend";
          }
          e.exports = function (e, t) {
            if (t) T(e, t);else {
              var r = e._fullLayout,
                a = r._legends;
              r._infolayer.selectAll('[class^="legend"]').each(function () {
                var e = n.select(this),
                  t = e.attr("class").split(" ")[0];
                t.match(w) && -1 === a.indexOf(t) && e.remove();
              });
              for (var i = 0; i < a.length; i++) {
                var o = a[i];
                T(e, e._fullLayout[o]);
              }
            }
          };
        },
        851: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(7599);
          e.exports = function (e, t, r) {
            var i,
              o,
              l = t._inHover,
              s = a.isGrouped(t),
              c = a.isReversed(t),
              u = {},
              f = [],
              d = !1,
              h = {},
              p = 0,
              v = 0;
            function g(e, n, i) {
              if (!1 !== t.visible && (!r || e === t._id)) if ("" !== n && a.isGrouped(t)) -1 === f.indexOf(n) ? (f.push(n), d = !0, u[n] = [i]) : u[n].push(i);else {
                var o = "~~i" + p;
                f.push(o), u[o] = [i], p++;
              }
            }
            for (i = 0; i < e.length; i++) {
              var m = e[i],
                y = m[0],
                x = y.trace,
                b = x.legend,
                _ = x.legendgroup;
              if (l || x.visible && x.showlegend) if (n.traceIs(x, "pie-like")) for (h[_] || (h[_] = {}), o = 0; o < m.length; o++) {
                var w = m[o].label;
                h[_][w] || (g(b, _, {
                  label: w,
                  color: m[o].color,
                  i: m[o].i,
                  trace: x,
                  pts: m[o].pts
                }), h[_][w] = !0, v = Math.max(v, (w || "").length));
              } else g(b, _, y), v = Math.max(v, (x.name || "").length);
            }
            if (!f.length) return [];
            var T = !d || !s,
              M = [];
            for (i = 0; i < f.length; i++) {
              var k = u[f[i]];
              T ? M.push(k[0]) : M.push(k);
            }
            for (T && (M = [M]), i = 0; i < M.length; i++) {
              var A = 1 / 0;
              for (o = 0; o < M[i].length; o++) {
                var L = M[i][o].trace.legendrank;
                A > L && (A = L);
              }
              M[i][0]._groupMinRank = A, M[i][0]._preGroupSort = i;
            }
            var S = function (e, t) {
              return e.trace.legendrank - t.trace.legendrank || e._preSort - t._preSort;
            };
            for (M.forEach(function (e, t) {
              e[0]._preGroupSort = t;
            }), M.sort(function (e, t) {
              return e[0]._groupMinRank - t[0]._groupMinRank || e[0]._preGroupSort - t[0]._preGroupSort;
            }), i = 0; i < M.length; i++) {
              M[i].forEach(function (e, t) {
                e._preSort = t;
              }), M[i].sort(S);
              var C = M[i][0].trace,
                O = null;
              for (o = 0; o < M[i].length; o++) {
                var D = M[i][o].trace.legendgrouptitle;
                if (D && D.text) {
                  O = D, l && (D.font = t._groupTitleFont);
                  break;
                }
              }
              if (c && M[i].reverse(), O) {
                var P = !1;
                for (o = 0; o < M[i].length; o++) if (n.traceIs(M[i][o].trace, "pie-like")) {
                  P = !0;
                  break;
                }
                M[i].unshift({
                  i: -1,
                  groupTitle: O,
                  noClick: P,
                  trace: {
                    showlegend: C.showlegend,
                    legendgroup: C.legendgroup,
                    visible: "toggleitem" === t.groupclick || C.visible
                  }
                });
              }
              for (o = 0; o < M[i].length; o++) M[i][o] = [M[i][o]];
            }
            return t._lgroupsLength = M.length, t._maxNameLength = v, M;
          };
        },
        2165: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(4809),
            i = a.pushUnique,
            o = !0;
          e.exports = function (e, t, r) {
            var l = t._fullLayout;
            if (!t._dragged && !t._editing) {
              var s,
                c = l.legend.itemclick,
                u = l.legend.itemdoubleclick,
                f = l.legend.groupclick;
              if (1 === r && "toggle" === c && "toggleothers" === u && o && t.data && t._context.showTips ? (a.notifier(a._(t, "Double-click on legend to isolate one trace"), "long"), o = !1) : o = !1, 1 === r ? s = c : 2 === r && (s = u), s) {
                var d = "togglegroup" === f,
                  h = l.hiddenlabels ? l.hiddenlabels.slice() : [],
                  p = e.data()[0][0];
                if (!p.groupTitle || !p.noClick) {
                  var v = t._fullData,
                    g = (l.shapes || []).filter(function (e) {
                      return e.showlegend;
                    }),
                    m = v.concat(g),
                    y = p.trace;
                  y._isShape && (y = y._fullInput);
                  var x,
                    b,
                    _,
                    w,
                    T,
                    M = y.legendgroup,
                    k = {},
                    A = [],
                    L = [],
                    S = [],
                    C = (l.shapes || []).map(function (e) {
                      return e._input;
                    }),
                    O = !1,
                    D = y.legend,
                    P = y._fullInput;
                  if (P && P._isShape || !n.traceIs(y, "pie-like")) {
                    var z,
                      I = M && M.length,
                      E = [];
                    if (I) for (x = 0; x < m.length; x++) (z = m[x]).visible && z.legendgroup === M && E.push(x);
                    if ("toggle" === s) {
                      var R;
                      switch (y.visible) {
                        case !0:
                          R = "legendonly";
                          break;
                        case !1:
                          R = !1;
                          break;
                        case "legendonly":
                          R = !0;
                      }
                      if (I) {
                        if (d) for (x = 0; x < m.length; x++) {
                          var N = m[x];
                          !1 !== N.visible && N.legendgroup === M && ee(N, R);
                        } else ee(y, R);
                      } else ee(y, R);
                    } else if ("toggleothers" === s) {
                      var F,
                        H,
                        B,
                        j,
                        Y = !0;
                      for (x = 0; x < m.length; x++) if (F = (j = m[x]) === y, H = !0 !== j.showlegend, !(F || H || I && j.legendgroup === M || j.legend !== D || !0 !== j.visible || n.traceIs(j, "notLegendIsolatable"))) {
                        Y = !1;
                        break;
                      }
                      for (x = 0; x < m.length; x++) if (!1 !== (j = m[x]).visible && j.legend === D && !n.traceIs(j, "notLegendIsolatable")) switch (y.visible) {
                        case "legendonly":
                          ee(j, !0);
                          break;
                        case !0:
                          B = !!Y || "legendonly", F = j === y, H = !0 !== j.showlegend && !j.legendgroup, ee(j, !!(F || I && j.legendgroup === M || H) || B);
                      }
                    }
                    for (x = 0; x < L.length; x++) if (_ = L[x]) {
                      var V = _.constructUpdate(),
                        U = Object.keys(V);
                      for (b = 0; b < U.length; b++) w = U[b], (k[w] = k[w] || [])[S[x]] = V[w];
                    }
                    for (T = Object.keys(k), x = 0; x < T.length; x++) for (w = T[x], b = 0; b < A.length; b++) k[w].hasOwnProperty(b) || (k[w][b] = void 0);
                    O ? n.call("_guiUpdate", t, k, {
                      shapes: C
                    }, A) : n.call("_guiRestyle", t, k, A);
                  } else {
                    var q = p.label,
                      G = h.indexOf(q);
                    if ("toggle" === s) -1 === G ? h.push(q) : h.splice(G, 1);else if ("toggleothers" === s) {
                      var Z = -1 !== G,
                        W = [];
                      for (x = 0; x < t.calcdata.length; x++) {
                        var J = t.calcdata[x];
                        for (b = 0; b < J.length; b++) {
                          var X = J[b].label;
                          D === J[0].trace.legend && q !== X && (-1 === h.indexOf(X) && (Z = !0), i(h, X), W.push(X));
                        }
                      }
                      if (!Z) for (var K = 0; K < W.length; K++) {
                        var Q = h.indexOf(W[K]);
                        -1 !== Q && h.splice(Q, 1);
                      }
                    }
                    n.call("_guiRelayout", t, "hiddenlabels", h);
                  }
                }
              }
            }
            function $(e, t) {
              var r = A.indexOf(e),
                n = k.visible;
              return n || (n = k.visible = []), -1 === A.indexOf(e) && (A.push(e), r = A.length - 1), n[r] = t, r;
            }
            function ee(e, t) {
              if (!p.groupTitle || d) {
                var r,
                  i = e._fullInput || e,
                  o = i._isShape,
                  l = i.index;
                if (void 0 === l && (l = i._index), n.hasTransform(i, "groupby")) {
                  var s = L[l];
                  if (!s) {
                    var c = n.getTransformIndices(i, "groupby"),
                      u = c[c.length - 1];
                    s = a.keyedContainer(i, "transforms[" + u + "].styles", "target", "value.visible"), L[l] = s;
                  }
                  var f = s.get(e._group);
                  void 0 === f && (f = !0), !1 !== f && s.set(e._group, t), S[l] = $(l, !1 !== i.visible);
                } else {
                  var h = !1 !== i.visible && t;
                  o ? (r = h, C[l].visible = r, O = !0) : $(l, h);
                }
              }
            }
          };
        },
        7599: function (e, t) {
          "use strict";

          t.isGrouped = function (e) {
            return -1 !== (e.traceorder || "").indexOf("grouped");
          }, t.isVertical = function (e) {
            return "h" !== e.orientation;
          }, t.isReversed = function (e) {
            return -1 !== (e.traceorder || "").indexOf("reversed");
          };
        },
        2494: function (e, t, r) {
          "use strict";

          e.exports = {
            moduleType: "component",
            name: "legend",
            layoutAttributes: r(6405),
            supplyLayoutDefaults: r(3970),
            draw: r(6134),
            style: r(4375)
          };
        },
        4375: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(3626),
            i = r(4809),
            o = i.strTranslate,
            l = r(2203),
            s = r(8766),
            c = r(5477).extractOpts,
            u = r(4726),
            f = r(2891),
            d = r(7252).castOption,
            h = r(2783);
          function p(e, t) {
            return (t ? "radial" : "horizontal") + (e ? "" : "reversed");
          }
          function v(e) {
            var t = e[0].trace,
              r = t.contours,
              n = u.hasLines(t),
              a = u.hasMarkers(t),
              i = t.visible && t.fill && "none" !== t.fill,
              o = !1,
              l = !1;
            if (r) {
              var s = r.coloring;
              "lines" === s ? o = !0 : n = "none" === s || "heatmap" === s || r.showlines, "constraint" === r.type ? i = "=" !== r._operation : "fill" !== s && "heatmap" !== s || (l = !0);
            }
            return {
              showMarker: a,
              showLine: n,
              showFill: i,
              showGradientLine: o,
              showGradientFill: l,
              anyLine: n || o,
              anyFill: i || l
            };
          }
          function g(e, t, r) {
            return e && i.isArrayOrTypedArray(e) ? t : e > r ? r : e;
          }
          e.exports = function (e, t, r) {
            var m = t._fullLayout;
            r || (r = m.legend);
            var y = "constant" === r.itemsizing,
              x = r.itemwidth,
              b = (x + 2 * h.itemGap) / 2,
              _ = o(b, 0),
              w = function (e, t, r, n) {
                var a;
                if (e + 1) a = e;else {
                  if (!(t && t.width > 0)) return 0;
                  a = t.width;
                }
                return y ? n : Math.min(a, r);
              };
            function T(e, i, o) {
              var u = e[0].trace,
                f = u.marker || {},
                d = f.line || {},
                h = f.cornerradius ? "M6,3a3,3,0,0,1-3,3H-3a3,3,0,0,1-3-3V-3a3,3,0,0,1,3-3H3a3,3,0,0,1,3,3Z" : "M6,6H-6V-6H6Z",
                p = o ? u.visible && u.type === o : a.traceIs(u, "bar"),
                v = n.select(i).select("g.legendpoints").selectAll("path.legend" + o).data(p ? [e] : []);
              v.enter().append("path").classed("legend" + o, !0).attr("d", h).attr("transform", _), v.exit().remove(), v.each(function (e) {
                var a = n.select(this),
                  i = e[0],
                  o = w(i.mlw, f.line, 5, 2);
                a.style("stroke-width", o + "px");
                var h = i.mcc;
                if (!r._inHover && "mc" in i) {
                  var p = c(f),
                    v = p.mid;
                  void 0 === v && (v = (p.max + p.min) / 2), h = l.tryColorscale(f, "")(v);
                }
                var m = h || i.mc || f.color,
                  y = f.pattern,
                  x = y && l.getPatternAttr(y.shape, 0, "");
                if (x) {
                  var b = l.getPatternAttr(y.bgcolor, 0, null),
                    _ = l.getPatternAttr(y.fgcolor, 0, null),
                    T = y.fgopacity,
                    M = g(y.size, 8, 10),
                    k = g(y.solidity, .5, 1),
                    A = "legend-" + u.uid;
                  a.call(l.pattern, "legend", t, A, x, M, k, h, y.fillmode, b, _, T);
                } else a.call(s.fill, m);
                o && s.stroke(a, i.mlc || d.color);
              });
            }
            function M(e, r, o) {
              var l = e[0],
                s = l.trace,
                c = o ? s.visible && s.type === o : a.traceIs(s, o),
                u = n.select(r).select("g.legendpoints").selectAll("path.legend" + o).data(c ? [e] : []);
              if (u.enter().append("path").classed("legend" + o, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), u.exit().remove(), u.size()) {
                var h = s.marker || {},
                  p = w(d(h.line.width, l.pts), h.line, 5, 2),
                  v = "pieLike",
                  g = i.minExtend(s, {
                    marker: {
                      line: {
                        width: p
                      }
                    }
                  }, v),
                  m = i.minExtend(l, {
                    trace: g
                  }, v);
                f(u, m, g, t);
              }
            }
            e.each(function (e) {
              var t = n.select(this),
                a = i.ensureSingle(t, "g", "layers");
              a.style("opacity", e[0].trace.opacity);
              var l = r.indentation,
                s = r.valign,
                c = e[0].lineHeight,
                u = e[0].height;
              if ("middle" === s && 0 === l || !c || !u) a.attr("transform", null);else {
                var f = {
                    top: 1,
                    bottom: -1
                  }[s] * (.5 * (c - u + 3)) || 0,
                  d = r.indentation;
                a.attr("transform", o(d, f));
              }
              a.selectAll("g.legendfill").data([e]).enter().append("g").classed("legendfill", !0), a.selectAll("g.legendlines").data([e]).enter().append("g").classed("legendlines", !0);
              var h = a.selectAll("g.legendsymbols").data([e]);
              h.enter().append("g").classed("legendsymbols", !0), h.selectAll("g.legendpoints").data([e]).enter().append("g").classed("legendpoints", !0);
            }).each(function (e) {
              var r,
                a = e[0].trace,
                o = [];
              if (a.visible) switch (a.type) {
                case "histogram2d":
                case "heatmap":
                  o = [["M-15,-2V4H15V-2Z"]], r = !0;
                  break;
                case "choropleth":
                case "choroplethmapbox":
                case "choroplethmap":
                  o = [["M-6,-6V6H6V-6Z"]], r = !0;
                  break;
                case "densitymapbox":
                case "densitymap":
                  o = [["M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"]], r = "radial";
                  break;
                case "cone":
                  o = [["M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"], ["M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"]], r = !1;
                  break;
                case "streamtube":
                  o = [["M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"], ["M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"]], r = !1;
                  break;
                case "surface":
                  o = [["M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"], ["M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"]], r = !0;
                  break;
                case "mesh3d":
                  o = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], r = !1;
                  break;
                case "volume":
                  o = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], r = !0;
                  break;
                case "isosurface":
                  o = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"]], r = !1;
              }
              var u = n.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(o);
              u.enter().append("path").classed("legend3dandfriends", !0).attr("transform", _).style("stroke-miterlimit", 1), u.exit().remove(), u.each(function (e, o) {
                var u,
                  f = n.select(this),
                  d = c(a),
                  h = d.colorscale,
                  v = d.reversescale;
                if (h) {
                  if (!r) {
                    var g = h.length;
                    u = 0 === o ? h[v ? g - 1 : 0][1] : 1 === o ? h[v ? 0 : g - 1][1] : h[Math.floor((g - 1) / 2)][1];
                  }
                } else {
                  var m = a.vertexcolor || a.facecolor || a.color;
                  u = i.isArrayOrTypedArray(m) ? m[o] || m[0] : m;
                }
                f.attr("d", e[0]), u ? f.call(s.fill, u) : f.call(function (e) {
                  if (e.size()) {
                    var n = "legendfill-" + a.uid;
                    l.gradient(e, t, n, p(v, "radial" === r), h, "fill");
                  }
                });
              });
            }).each(function (e) {
              var t = e[0].trace,
                r = "waterfall" === t.type;
              if (e[0]._distinct && r) {
                var a = e[0].trace[e[0].dir].marker;
                return e[0].mc = a.color, e[0].mlw = a.line.width, e[0].mlc = a.line.color, T(e, this, "waterfall");
              }
              var i = [];
              t.visible && r && (i = e[0].hasTotals ? [["increasing", "M-6,-6V6H0Z"], ["totals", "M6,6H0L-6,-6H-0Z"], ["decreasing", "M6,6V-6H0Z"]] : [["increasing", "M-6,-6V6H6Z"], ["decreasing", "M6,6V-6H-6Z"]]);
              var o = n.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(i);
              o.enter().append("path").classed("legendwaterfall", !0).attr("transform", _).style("stroke-miterlimit", 1), o.exit().remove(), o.each(function (e) {
                var r = n.select(this),
                  a = t[e[0]].marker,
                  i = w(void 0, a.line, 5, 2);
                r.attr("d", e[1]).style("stroke-width", i + "px").call(s.fill, a.color), i && r.call(s.stroke, a.line.color);
              });
            }).each(function (e) {
              T(e, this, "funnel");
            }).each(function (e) {
              T(e, this);
            }).each(function (e) {
              var r = e[0].trace,
                o = n.select(this).select("g.legendpoints").selectAll("path.legendbox").data(r.visible && a.traceIs(r, "box-violin") ? [e] : []);
              o.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), o.exit().remove(), o.each(function () {
                var e = n.select(this);
                if ("all" !== r.boxpoints && "all" !== r.points || 0 !== s.opacity(r.fillcolor) || 0 !== s.opacity((r.line || {}).color)) {
                  var a = w(void 0, r.line, 5, 2);
                  e.style("stroke-width", a + "px").call(s.fill, r.fillcolor), a && s.stroke(e, r.line.color);
                } else {
                  var c = i.minExtend(r, {
                    marker: {
                      size: y ? 12 : i.constrain(r.marker.size, 2, 16),
                      sizeref: 1,
                      sizemin: 1,
                      sizemode: "diameter"
                    }
                  });
                  o.call(l.pointStyle, c, t);
                }
              });
            }).each(function (e) {
              M(e, this, "funnelarea");
            }).each(function (e) {
              M(e, this, "pie");
            }).each(function (e) {
              var r,
                a,
                o = v(e),
                s = o.showFill,
                f = o.showLine,
                d = o.showGradientLine,
                h = o.showGradientFill,
                g = o.anyFill,
                m = o.anyLine,
                y = e[0],
                b = y.trace,
                _ = c(b),
                T = _.colorscale,
                M = _.reversescale,
                k = u.hasMarkers(b) || !g ? "M5,0" : m ? "M5,-2" : "M5,-3",
                A = n.select(this),
                L = A.select(".legendfill").selectAll("path").data(s || h ? [e] : []);
              if (L.enter().append("path").classed("js-fill", !0), L.exit().remove(), L.attr("d", k + "h" + x + "v6h-" + x + "z").call(function (e) {
                if (e.size()) if (s) l.fillGroupStyle(e, t, !0);else {
                  var r = "legendfill-" + b.uid;
                  l.gradient(e, t, r, p(M), T, "fill");
                }
              }), f || d) {
                var S = w(void 0, b.line, 10, 5);
                a = i.minExtend(b, {
                  line: {
                    width: S
                  }
                }), r = [i.minExtend(y, {
                  trace: a
                })];
              }
              var C = A.select(".legendlines").selectAll("path").data(f || d ? [r] : []);
              C.enter().append("path").classed("js-line", !0), C.exit().remove(), C.attr("d", k + (d ? "l" + x + ",0.0001" : "h" + x)).call(f ? l.lineGroupStyle : function (e) {
                if (e.size()) {
                  var r = "legendline-" + b.uid;
                  l.lineGroupStyle(e), l.gradient(e, t, r, p(M), T, "stroke");
                }
              });
            }).each(function (e) {
              var r,
                a,
                o = v(e),
                s = o.anyFill,
                c = o.anyLine,
                f = o.showLine,
                d = o.showMarker,
                h = e[0],
                p = h.trace,
                g = !d && !c && !s && u.hasText(p);
              function m(e, t, r, n) {
                var a = i.nestedProperty(p, e).get(),
                  o = i.isArrayOrTypedArray(a) && t ? t(a) : a;
                if (y && o && void 0 !== n && (o = n), r) {
                  if (o < r[0]) return r[0];
                  if (o > r[1]) return r[1];
                }
                return o;
              }
              function x(e) {
                return h._distinct && h.index && e[h.index] ? e[h.index] : e[0];
              }
              if (d || g || f) {
                var b = {},
                  w = {};
                if (d) {
                  b.mc = m("marker.color", x), b.mx = m("marker.symbol", x), b.mo = m("marker.opacity", i.mean, [.2, 1]), b.mlc = m("marker.line.color", x), b.mlw = m("marker.line.width", i.mean, [0, 5], 2), w.marker = {
                    sizeref: 1,
                    sizemin: 1,
                    sizemode: "diameter"
                  };
                  var T = m("marker.size", i.mean, [2, 16], 12);
                  b.ms = T, w.marker.size = T;
                }
                f && (w.line = {
                  width: m("line.width", x, [0, 10], 5)
                }), g && (b.tx = "Aa", b.tp = m("textposition", x), b.ts = 10, b.tc = m("textfont.color", x), b.tf = m("textfont.family", x), b.tw = m("textfont.weight", x), b.ty = m("textfont.style", x), b.tv = m("textfont.variant", x), b.tC = m("textfont.textcase", x), b.tE = m("textfont.lineposition", x), b.tS = m("textfont.shadow", x)), r = [i.minExtend(h, b)], (a = i.minExtend(p, w)).selectedpoints = null, a.texttemplate = null;
              }
              var M = n.select(this).select("g.legendpoints"),
                k = M.selectAll("path.scatterpts").data(d ? r : []);
              k.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", _), k.exit().remove(), k.call(l.pointStyle, a, t), d && (r[0].mrc = 3);
              var A = M.selectAll("g.pointtext").data(g ? r : []);
              A.enter().append("g").classed("pointtext", !0).append("text").attr("transform", _), A.exit().remove(), A.selectAll("text").call(l.textPointStyle, a, t);
            }).each(function (e) {
              var t = e[0].trace,
                r = n.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(t.visible && "candlestick" === t.type ? [e, e] : []);
              r.enter().append("path").classed("legendcandle", !0).attr("d", function (e, t) {
                return t ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
              }).attr("transform", _).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function (e, r) {
                var a = n.select(this),
                  i = t[r ? "increasing" : "decreasing"],
                  o = w(void 0, i.line, 5, 2);
                a.style("stroke-width", o + "px").call(s.fill, i.fillcolor), o && s.stroke(a, i.line.color);
              });
            }).each(function (e) {
              var t = e[0].trace,
                r = n.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(t.visible && "ohlc" === t.type ? [e, e] : []);
              r.enter().append("path").classed("legendohlc", !0).attr("d", function (e, t) {
                return t ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
              }).attr("transform", _).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function (e, r) {
                var a = n.select(this),
                  i = t[r ? "increasing" : "decreasing"],
                  o = w(void 0, i.line, 5, 2);
                a.style("fill", "none").call(l.dashLine, i.line.dash, o), o && s.stroke(a, i.line.color);
              });
            });
          };
        },
        308: function (e, t, r) {
          "use strict";

          r(7632), e.exports = {
            editType: "modebar",
            orientation: {
              valType: "enumerated",
              values: ["v", "h"],
              dflt: "h",
              editType: "modebar"
            },
            bgcolor: {
              valType: "color",
              editType: "modebar"
            },
            color: {
              valType: "color",
              editType: "modebar"
            },
            activecolor: {
              valType: "color",
              editType: "modebar"
            },
            uirevision: {
              valType: "any",
              editType: "none"
            },
            add: {
              valType: "string",
              arrayOk: !0,
              dflt: "",
              editType: "modebar"
            },
            remove: {
              valType: "string",
              arrayOk: !0,
              dflt: "",
              editType: "modebar"
            }
          };
        },
        5832: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(4122),
            i = r(5975),
            o = r(5188),
            l = r(8231).eraseActiveShape,
            s = r(4809),
            c = s._,
            u = e.exports = {};
          function f(e, t) {
            var r,
              a,
              o = t.currentTarget,
              l = o.getAttribute("data-attr"),
              s = o.getAttribute("data-val") || !0,
              c = e._fullLayout,
              u = {},
              f = i.list(e, null, !0),
              d = c._cartesianSpikesEnabled;
            if ("zoom" === l) {
              var h,
                p = "in" === s ? .5 : 2,
                v = (1 + p) / 2,
                g = (1 - p) / 2;
              for (a = 0; a < f.length; a++) if (!(r = f[a]).fixedrange) if (h = r._name, "auto" === s) u[h + ".autorange"] = !0;else if ("reset" === s) void 0 === r._rangeInitial0 && void 0 === r._rangeInitial1 ? u[h + ".autorange"] = !0 : void 0 === r._rangeInitial0 ? (u[h + ".autorange"] = r._autorangeInitial, u[h + ".range"] = [null, r._rangeInitial1]) : void 0 === r._rangeInitial1 ? (u[h + ".range"] = [r._rangeInitial0, null], u[h + ".autorange"] = r._autorangeInitial) : u[h + ".range"] = [r._rangeInitial0, r._rangeInitial1], void 0 !== r._showSpikeInitial && (u[h + ".showspikes"] = r._showSpikeInitial, "on" !== d || r._showSpikeInitial || (d = "off"));else {
                var m = [r.r2l(r.range[0]), r.r2l(r.range[1])],
                  y = [v * m[0] + g * m[1], v * m[1] + g * m[0]];
                u[h + ".range[0]"] = r.l2r(y[0]), u[h + ".range[1]"] = r.l2r(y[1]);
              }
            } else "hovermode" !== l || "x" !== s && "y" !== s || (s = c._isHoriz ? "y" : "x", o.setAttribute("data-val", s)), u[l] = s;
            c._cartesianSpikesEnabled = d, n.call("_guiRelayout", e, u);
          }
          function d(e, t) {
            for (var r = t.currentTarget, a = r.getAttribute("data-attr"), i = r.getAttribute("data-val") || !0, o = e._fullLayout._subplots.gl3d || [], l = {}, s = a.split("."), c = 0; c < o.length; c++) l[o[c] + "." + s[1]] = i;
            var u = "pan" === i ? i : "zoom";
            l.dragmode = u, n.call("_guiRelayout", e, l);
          }
          function h(e, t) {
            for (var r = t.currentTarget.getAttribute("data-attr"), a = "resetLastSave" === r, i = "resetDefault" === r, o = e._fullLayout, l = o._subplots.gl3d || [], s = {}, c = 0; c < l.length; c++) {
              var u,
                f = l[c],
                d = f + ".camera",
                h = f + ".aspectratio",
                p = f + ".aspectmode",
                v = o[f]._scene;
              a ? (s[d + ".up"] = v.viewInitial.up, s[d + ".eye"] = v.viewInitial.eye, s[d + ".center"] = v.viewInitial.center, u = !0) : i && (s[d + ".up"] = null, s[d + ".eye"] = null, s[d + ".center"] = null, u = !0), u && (s[h + ".x"] = v.viewInitial.aspectratio.x, s[h + ".y"] = v.viewInitial.aspectratio.y, s[h + ".z"] = v.viewInitial.aspectratio.z, s[p] = v.viewInitial.aspectmode);
            }
            n.call("_guiRelayout", e, s);
          }
          function p(e, t) {
            var r = t.currentTarget,
              n = r._previousVal,
              a = e._fullLayout,
              i = a._subplots.gl3d || [],
              o = ["xaxis", "yaxis", "zaxis"],
              l = {},
              s = {};
            if (n) s = n, r._previousVal = null;else {
              for (var c = 0; c < i.length; c++) {
                var u = i[c],
                  f = a[u],
                  d = u + ".hovermode";
                l[d] = f.hovermode, s[d] = !1;
                for (var h = 0; h < 3; h++) {
                  var p = o[h],
                    v = u + "." + p + ".showspikes";
                  s[v] = !1, l[v] = f[p].showspikes;
                }
              }
              r._previousVal = l;
            }
            return s;
          }
          function v(e, t) {
            for (var r = t.currentTarget, a = r.getAttribute("data-attr"), i = r.getAttribute("data-val") || !0, o = e._fullLayout, l = o._subplots.geo || [], s = 0; s < l.length; s++) {
              var c = l[s],
                u = o[c];
              if ("zoom" === a) {
                var f = u.projection.scale,
                  d = "in" === i ? 2 * f : .5 * f;
                n.call("_guiRelayout", e, c + ".projection.scale", d);
              }
            }
            "reset" === a && _(e, "geo");
          }
          function g(e) {
            var t = e._fullLayout;
            return !t.hovermode && (t._has("cartesian") ? t._isHoriz ? "y" : "x" : "closest");
          }
          function m(e) {
            var t = g(e);
            n.call("_guiRelayout", e, "hovermode", t);
          }
          function y(e, t) {
            b(e, t, "mapbox");
          }
          function x(e, t) {
            b(e, t, "map");
          }
          function b(e, t, r) {
            for (var a = t.currentTarget.getAttribute("data-val"), i = e._fullLayout, o = i._subplots[r] || [], l = {}, s = 0; s < o.length; s++) {
              var c = o[s],
                u = i[c].zoom,
                f = "in" === a ? 1.05 * u : u / 1.05;
              l[c + ".zoom"] = f;
            }
            n.call("_guiRelayout", e, l);
          }
          function _(e, t) {
            for (var r = e._fullLayout, a = r._subplots[t] || [], i = {}, o = 0; o < a.length; o++) for (var l = a[o], s = r[l]._subplot.viewInitial, c = Object.keys(s), u = 0; u < c.length; u++) {
              var f = c[u];
              i[l + "." + f] = s[f];
            }
            n.call("_guiRelayout", e, i);
          }
          u.toImage = {
            name: "toImage",
            title: function (e) {
              var t = (e._context.toImageButtonOptions || {}).format || "png";
              return c(e, "png" === t ? "Download plot as a png" : "Download plot");
            },
            icon: o.camera,
            click: function (e) {
              var t = e._context.toImageButtonOptions,
                r = {
                  format: t.format || "png"
                };
              s.notifier(c(e, "Taking snapshot - this may take a few seconds"), "long"), "svg" !== r.format && s.isIE() && (s.notifier(c(e, "IE only supports svg.  Changing format to svg."), "long"), r.format = "svg"), ["filename", "width", "height", "scale"].forEach(function (e) {
                e in t && (r[e] = t[e]);
              }), n.call("downloadImage", e, r).then(function (t) {
                s.notifier(c(e, "Snapshot succeeded") + " - " + t, "long");
              }).catch(function () {
                s.notifier(c(e, "Sorry, there was a problem downloading your snapshot!"), "long");
              });
            }
          }, u.sendDataToCloud = {
            name: "sendDataToCloud",
            title: function (e) {
              return c(e, "Edit in Chart Studio");
            },
            icon: o.disk,
            click: function (e) {
              a.sendDataToCloud(e);
            }
          }, u.editInChartStudio = {
            name: "editInChartStudio",
            title: function (e) {
              return c(e, "Edit in Chart Studio");
            },
            icon: o.pencil,
            click: function (e) {
              a.sendDataToCloud(e);
            }
          }, u.zoom2d = {
            name: "zoom2d",
            _cat: "zoom",
            title: function (e) {
              return c(e, "Zoom");
            },
            attr: "dragmode",
            val: "zoom",
            icon: o.zoombox,
            click: f
          }, u.pan2d = {
            name: "pan2d",
            _cat: "pan",
            title: function (e) {
              return c(e, "Pan");
            },
            attr: "dragmode",
            val: "pan",
            icon: o.pan,
            click: f
          }, u.select2d = {
            name: "select2d",
            _cat: "select",
            title: function (e) {
              return c(e, "Box Select");
            },
            attr: "dragmode",
            val: "select",
            icon: o.selectbox,
            click: f
          }, u.lasso2d = {
            name: "lasso2d",
            _cat: "lasso",
            title: function (e) {
              return c(e, "Lasso Select");
            },
            attr: "dragmode",
            val: "lasso",
            icon: o.lasso,
            click: f
          }, u.drawclosedpath = {
            name: "drawclosedpath",
            title: function (e) {
              return c(e, "Draw closed freeform");
            },
            attr: "dragmode",
            val: "drawclosedpath",
            icon: o.drawclosedpath,
            click: f
          }, u.drawopenpath = {
            name: "drawopenpath",
            title: function (e) {
              return c(e, "Draw open freeform");
            },
            attr: "dragmode",
            val: "drawopenpath",
            icon: o.drawopenpath,
            click: f
          }, u.drawline = {
            name: "drawline",
            title: function (e) {
              return c(e, "Draw line");
            },
            attr: "dragmode",
            val: "drawline",
            icon: o.drawline,
            click: f
          }, u.drawrect = {
            name: "drawrect",
            title: function (e) {
              return c(e, "Draw rectangle");
            },
            attr: "dragmode",
            val: "drawrect",
            icon: o.drawrect,
            click: f
          }, u.drawcircle = {
            name: "drawcircle",
            title: function (e) {
              return c(e, "Draw circle");
            },
            attr: "dragmode",
            val: "drawcircle",
            icon: o.drawcircle,
            click: f
          }, u.eraseshape = {
            name: "eraseshape",
            title: function (e) {
              return c(e, "Erase active shape");
            },
            icon: o.eraseshape,
            click: l
          }, u.zoomIn2d = {
            name: "zoomIn2d",
            _cat: "zoomin",
            title: function (e) {
              return c(e, "Zoom in");
            },
            attr: "zoom",
            val: "in",
            icon: o.zoom_plus,
            click: f
          }, u.zoomOut2d = {
            name: "zoomOut2d",
            _cat: "zoomout",
            title: function (e) {
              return c(e, "Zoom out");
            },
            attr: "zoom",
            val: "out",
            icon: o.zoom_minus,
            click: f
          }, u.autoScale2d = {
            name: "autoScale2d",
            _cat: "autoscale",
            title: function (e) {
              return c(e, "Autoscale");
            },
            attr: "zoom",
            val: "auto",
            icon: o.autoscale,
            click: f
          }, u.resetScale2d = {
            name: "resetScale2d",
            _cat: "resetscale",
            title: function (e) {
              return c(e, "Reset axes");
            },
            attr: "zoom",
            val: "reset",
            icon: o.home,
            click: f
          }, u.hoverClosestCartesian = {
            name: "hoverClosestCartesian",
            _cat: "hoverclosest",
            title: function (e) {
              return c(e, "Show closest data on hover");
            },
            attr: "hovermode",
            val: "closest",
            icon: o.tooltip_basic,
            gravity: "ne",
            click: f
          }, u.hoverCompareCartesian = {
            name: "hoverCompareCartesian",
            _cat: "hoverCompare",
            title: function (e) {
              return c(e, "Compare data on hover");
            },
            attr: "hovermode",
            val: function (e) {
              return e._fullLayout._isHoriz ? "y" : "x";
            },
            icon: o.tooltip_compare,
            gravity: "ne",
            click: f
          }, u.zoom3d = {
            name: "zoom3d",
            _cat: "zoom",
            title: function (e) {
              return c(e, "Zoom");
            },
            attr: "scene.dragmode",
            val: "zoom",
            icon: o.zoombox,
            click: d
          }, u.pan3d = {
            name: "pan3d",
            _cat: "pan",
            title: function (e) {
              return c(e, "Pan");
            },
            attr: "scene.dragmode",
            val: "pan",
            icon: o.pan,
            click: d
          }, u.orbitRotation = {
            name: "orbitRotation",
            title: function (e) {
              return c(e, "Orbital rotation");
            },
            attr: "scene.dragmode",
            val: "orbit",
            icon: o["3d_rotate"],
            click: d
          }, u.tableRotation = {
            name: "tableRotation",
            title: function (e) {
              return c(e, "Turntable rotation");
            },
            attr: "scene.dragmode",
            val: "turntable",
            icon: o["z-axis"],
            click: d
          }, u.resetCameraDefault3d = {
            name: "resetCameraDefault3d",
            _cat: "resetCameraDefault",
            title: function (e) {
              return c(e, "Reset camera to default");
            },
            attr: "resetDefault",
            icon: o.home,
            click: h
          }, u.resetCameraLastSave3d = {
            name: "resetCameraLastSave3d",
            _cat: "resetCameraLastSave",
            title: function (e) {
              return c(e, "Reset camera to last save");
            },
            attr: "resetLastSave",
            icon: o.movie,
            click: h
          }, u.hoverClosest3d = {
            name: "hoverClosest3d",
            _cat: "hoverclosest",
            title: function (e) {
              return c(e, "Toggle show closest data on hover");
            },
            attr: "hovermode",
            val: null,
            toggle: !0,
            icon: o.tooltip_basic,
            gravity: "ne",
            click: function (e, t) {
              var r = p(e, t);
              n.call("_guiRelayout", e, r);
            }
          }, u.zoomInGeo = {
            name: "zoomInGeo",
            _cat: "zoomin",
            title: function (e) {
              return c(e, "Zoom in");
            },
            attr: "zoom",
            val: "in",
            icon: o.zoom_plus,
            click: v
          }, u.zoomOutGeo = {
            name: "zoomOutGeo",
            _cat: "zoomout",
            title: function (e) {
              return c(e, "Zoom out");
            },
            attr: "zoom",
            val: "out",
            icon: o.zoom_minus,
            click: v
          }, u.resetGeo = {
            name: "resetGeo",
            _cat: "reset",
            title: function (e) {
              return c(e, "Reset");
            },
            attr: "reset",
            val: null,
            icon: o.autoscale,
            click: v
          }, u.hoverClosestGeo = {
            name: "hoverClosestGeo",
            _cat: "hoverclosest",
            title: function (e) {
              return c(e, "Toggle show closest data on hover");
            },
            attr: "hovermode",
            val: null,
            toggle: !0,
            icon: o.tooltip_basic,
            gravity: "ne",
            click: m
          }, u.hoverClosestGl2d = {
            name: "hoverClosestGl2d",
            _cat: "hoverclosest",
            title: function (e) {
              return c(e, "Toggle show closest data on hover");
            },
            attr: "hovermode",
            val: null,
            toggle: !0,
            icon: o.tooltip_basic,
            gravity: "ne",
            click: m
          }, u.hoverClosestPie = {
            name: "hoverClosestPie",
            _cat: "hoverclosest",
            title: function (e) {
              return c(e, "Toggle show closest data on hover");
            },
            attr: "hovermode",
            val: "closest",
            icon: o.tooltip_basic,
            gravity: "ne",
            click: m
          }, u.resetViewSankey = {
            name: "resetSankeyGroup",
            title: function (e) {
              return c(e, "Reset view");
            },
            icon: o.home,
            click: function (e) {
              for (var t = {
                  "node.groups": [],
                  "node.x": [],
                  "node.y": []
                }, r = 0; r < e._fullData.length; r++) {
                var a = e._fullData[r]._viewInitial;
                t["node.groups"].push(a.node.groups.slice()), t["node.x"].push(a.node.x.slice()), t["node.y"].push(a.node.y.slice());
              }
              n.call("restyle", e, t);
            }
          }, u.toggleHover = {
            name: "toggleHover",
            title: function (e) {
              return c(e, "Toggle show closest data on hover");
            },
            attr: "hovermode",
            val: null,
            toggle: !0,
            icon: o.tooltip_basic,
            gravity: "ne",
            click: function (e, t) {
              var r = p(e, t);
              r.hovermode = g(e), n.call("_guiRelayout", e, r);
            }
          }, u.resetViews = {
            name: "resetViews",
            title: function (e) {
              return c(e, "Reset views");
            },
            icon: o.home,
            click: function (e, t) {
              var r = t.currentTarget;
              r.setAttribute("data-attr", "zoom"), r.setAttribute("data-val", "reset"), f(e, t), r.setAttribute("data-attr", "resetLastSave"), h(e, t), _(e, "geo"), _(e, "mapbox"), _(e, "map");
            }
          }, u.toggleSpikelines = {
            name: "toggleSpikelines",
            title: function (e) {
              return c(e, "Toggle Spike Lines");
            },
            icon: o.spikeline,
            attr: "_cartesianSpikesEnabled",
            val: "on",
            click: function (e) {
              var t = e._fullLayout,
                r = t._cartesianSpikesEnabled;
              t._cartesianSpikesEnabled = "on" === r ? "off" : "on", n.call("_guiRelayout", e, function (e) {
                for (var t = "on" === e._fullLayout._cartesianSpikesEnabled, r = i.list(e, null, !0), n = {}, a = 0; a < r.length; a++) {
                  var o = r[a];
                  n[o._name + ".showspikes"] = !!t || o._showSpikeInitial;
                }
                return n;
              }(e));
            }
          }, u.resetViewMapbox = {
            name: "resetViewMapbox",
            _cat: "resetView",
            title: function (e) {
              return c(e, "Reset view");
            },
            attr: "reset",
            icon: o.home,
            click: function (e) {
              _(e, "mapbox");
            }
          }, u.resetViewMap = {
            name: "resetViewMap",
            _cat: "resetView",
            title: function (e) {
              return c(e, "Reset view");
            },
            attr: "reset",
            icon: o.home,
            click: function (e) {
              _(e, "map");
            }
          }, u.zoomInMapbox = {
            name: "zoomInMapbox",
            _cat: "zoomin",
            title: function (e) {
              return c(e, "Zoom in");
            },
            attr: "zoom",
            val: "in",
            icon: o.zoom_plus,
            click: y
          }, u.zoomInMap = {
            name: "zoomInMap",
            _cat: "zoomin",
            title: function (e) {
              return c(e, "Zoom in");
            },
            attr: "zoom",
            val: "in",
            icon: o.zoom_plus,
            click: x
          }, u.zoomOutMapbox = {
            name: "zoomOutMapbox",
            _cat: "zoomout",
            title: function (e) {
              return c(e, "Zoom out");
            },
            attr: "zoom",
            val: "out",
            icon: o.zoom_minus,
            click: y
          }, u.zoomOutMap = {
            name: "zoomOutMap",
            _cat: "zoomout",
            title: function (e) {
              return c(e, "Zoom out");
            },
            attr: "zoom",
            val: "out",
            icon: o.zoom_minus,
            click: x
          };
        },
        7632: function (e, t, r) {
          "use strict";

          var n = r(5832),
            a = Object.keys(n),
            i = ["drawline", "drawopenpath", "drawclosedpath", "drawcircle", "drawrect", "eraseshape"],
            o = ["v1hovermode", "hoverclosest", "hovercompare", "togglehover", "togglespikelines"].concat(i),
            l = [];
          a.forEach(function (e) {
            !function (e) {
              if (-1 === o.indexOf(e._cat || e.name)) {
                var t = e.name,
                  r = (e._cat || e.name).toLowerCase();
                -1 === l.indexOf(t) && l.push(t), -1 === l.indexOf(r) && l.push(r);
              }
            }(n[e]);
          }), l.sort(), e.exports = {
            DRAW_MODES: i,
            backButtons: o,
            foreButtons: l
          };
        },
        64: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8766),
            i = r(8032),
            o = r(308);
          e.exports = function (e, t) {
            var r = e.modebar || {},
              l = i.newContainer(t, "modebar");
            function s(e, t) {
              return n.coerce(r, l, o, e, t);
            }
            s("orientation"), s("bgcolor", a.addOpacity(t.paper_bgcolor, .5));
            var c = a.contrast(a.rgb(t.modebar.bgcolor));
            s("color", a.addOpacity(c, .3)), s("activecolor", a.addOpacity(c, .7)), s("uirevision", t.uirevision), s("add"), s("remove");
          };
        },
        5433: function (e, t, r) {
          "use strict";

          e.exports = {
            moduleType: "component",
            name: "modebar",
            layoutAttributes: r(308),
            supplyLayoutDefaults: r(64),
            manage: r(5442)
          };
        },
        5442: function (e, t, r) {
          "use strict";

          var n = r(5975),
            a = r(4726),
            i = r(3626),
            o = r(6040).isUnifiedHover,
            l = r(5393),
            s = r(5832),
            c = r(7632).DRAW_MODES,
            u = r(4809).extendDeep;
          e.exports = function (e) {
            var t = e._fullLayout,
              r = e._context,
              f = t._modeBar;
            if (r.displayModeBar || r.watermark) {
              if (!Array.isArray(r.modeBarButtonsToRemove)) throw new Error(["*modeBarButtonsToRemove* configuration options", "must be an array."].join(" "));
              if (!Array.isArray(r.modeBarButtonsToAdd)) throw new Error(["*modeBarButtonsToAdd* configuration options", "must be an array."].join(" "));
              var d,
                h = r.modeBarButtons;
              d = Array.isArray(h) && h.length ? function (e) {
                for (var t = u([], e), r = 0; r < t.length; r++) for (var n = t[r], a = 0; a < n.length; a++) {
                  var i = n[a];
                  if ("string" == typeof i) {
                    if (void 0 === s[i]) throw new Error(["*modeBarButtons* configuration options", "invalid button name"].join(" "));
                    t[r][a] = s[i];
                  }
                }
                return t;
              }(h) : !r.displayModeBar && r.watermark ? [] : function (e) {
                var t = e._fullLayout,
                  r = e._fullData,
                  l = e._context;
                function u(e, t) {
                  if ("string" == typeof t) {
                    if (t.toLowerCase() === e.toLowerCase()) return !0;
                  } else {
                    var r = t.name,
                      n = t._cat || t.name;
                    if (r === e || n === e.toLowerCase()) return !0;
                  }
                  return !1;
                }
                var f = t.modebar.add;
                "string" == typeof f && (f = [f]);
                var d = t.modebar.remove;
                "string" == typeof d && (d = [d]);
                var h = l.modeBarButtonsToAdd.concat(f.filter(function (e) {
                    for (var t = 0; t < l.modeBarButtonsToRemove.length; t++) if (u(e, l.modeBarButtonsToRemove[t])) return !1;
                    return !0;
                  })),
                  p = l.modeBarButtonsToRemove.concat(d.filter(function (e) {
                    for (var t = 0; t < l.modeBarButtonsToAdd.length; t++) if (u(e, l.modeBarButtonsToAdd[t])) return !1;
                    return !0;
                  })),
                  v = t._has("cartesian"),
                  g = t._has("gl3d"),
                  m = t._has("geo"),
                  y = t._has("pie"),
                  x = t._has("funnelarea"),
                  b = t._has("gl2d"),
                  _ = t._has("ternary"),
                  w = t._has("mapbox"),
                  T = t._has("map"),
                  M = t._has("polar"),
                  k = t._has("smith"),
                  A = t._has("sankey"),
                  L = function (e) {
                    for (var t = n.list({
                        _fullLayout: e
                      }, null, !0), r = 0; r < t.length; r++) if (!t[r].fixedrange) return !1;
                    return !0;
                  }(t),
                  S = o(t.hovermode),
                  C = [];
                function O(e) {
                  if (e.length) {
                    for (var t = [], r = 0; r < e.length; r++) {
                      for (var n = e[r], a = s[n], i = a.name.toLowerCase(), o = (a._cat || a.name).toLowerCase(), l = !1, c = 0; c < p.length; c++) {
                        var u = p[c].toLowerCase();
                        if (u === i || u === o) {
                          l = !0;
                          break;
                        }
                      }
                      l || t.push(s[n]);
                    }
                    C.push(t);
                  }
                }
                var D = ["toImage"];
                l.showEditInChartStudio ? D.push("editInChartStudio") : l.showSendToCloud && D.push("sendDataToCloud"), O(D);
                var P = [],
                  z = [],
                  I = [],
                  E = [];
                (v || b || y || x || _) + m + g + w + T + M + k > 1 ? (z = ["toggleHover"], I = ["resetViews"]) : m ? (P = ["zoomInGeo", "zoomOutGeo"], z = ["hoverClosestGeo"], I = ["resetGeo"]) : g ? (z = ["hoverClosest3d"], I = ["resetCameraDefault3d", "resetCameraLastSave3d"]) : w ? (P = ["zoomInMapbox", "zoomOutMapbox"], z = ["toggleHover"], I = ["resetViewMapbox"]) : T ? (P = ["zoomInMap", "zoomOutMap"], z = ["toggleHover"], I = ["resetViewMap"]) : b ? z = ["hoverClosestGl2d"] : y ? z = ["hoverClosestPie"] : A ? (z = ["hoverClosestCartesian", "hoverCompareCartesian"], I = ["resetViewSankey"]) : z = ["toggleHover"], v && z.push("toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian"), (function (e) {
                  for (var t = 0; t < e.length; t++) if (!i.traceIs(e[t], "noHover")) return !1;
                  return !0;
                }(r) || S) && (z = []), !v && !b || L || (P = ["zoomIn2d", "zoomOut2d", "autoScale2d"], "resetViews" !== I[0] && (I = ["resetScale2d"])), g ? E = ["zoom3d", "pan3d", "orbitRotation", "tableRotation"] : (v || b) && !L || _ ? E = ["zoom2d", "pan2d"] : w || T || m ? E = ["pan2d"] : M && (E = ["zoom2d"]), function (e) {
                  for (var t = !1, r = 0; r < e.length && !t; r++) {
                    var n = e[r];
                    n._module && n._module.selectPoints && (i.traceIs(n, "scatter-like") ? (a.hasMarkers(n) || a.hasText(n)) && (t = !0) : i.traceIs(n, "box-violin") && "all" !== n.boxpoints && "all" !== n.points || (t = !0));
                  }
                  return t;
                }(r) && E.push("select2d", "lasso2d");
                var R = [],
                  N = function (e) {
                    -1 === R.indexOf(e) && -1 !== z.indexOf(e) && R.push(e);
                  };
                if (Array.isArray(h)) {
                  for (var F = [], H = 0; H < h.length; H++) {
                    var B = h[H];
                    "string" == typeof B ? (B = B.toLowerCase(), -1 !== c.indexOf(B) ? (t._has("mapbox") || t._has("map") || t._has("cartesian")) && E.push(B) : "togglespikelines" === B ? N("toggleSpikelines") : "togglehover" === B ? N("toggleHover") : "hovercompare" === B ? N("hoverCompareCartesian") : "hoverclosest" === B ? (N("hoverClosestCartesian"), N("hoverClosestGeo"), N("hoverClosest3d"), N("hoverClosestGl2d"), N("hoverClosestPie")) : "v1hovermode" === B && (N("hoverClosestCartesian"), N("hoverCompareCartesian"), N("hoverClosestGeo"), N("hoverClosest3d"), N("hoverClosestGl2d"), N("hoverClosestPie"))) : F.push(B);
                  }
                  h = F;
                }
                return O(E), O(P.concat(I)), O(R), function (e, t) {
                  if (t.length) if (Array.isArray(t[0])) for (var r = 0; r < t.length; r++) e.push(t[r]);else e.push(t);
                  return e;
                }(C, h);
              }(e), f ? f.update(e, d) : t._modeBar = l(e, d);
            } else f && (f.destroy(), delete t._modeBar);
          };
        },
        5393: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(721),
            i = r(4809),
            o = r(5188),
            l = r(9697).version,
            s = new DOMParser();
          function c(e) {
            this.container = e.container, this.element = document.createElement("div"), this.update(e.graphInfo, e.buttons), this.container.appendChild(this.element);
          }
          var u = c.prototype;
          u.update = function (e, t) {
            this.graphInfo = e;
            var r = this.graphInfo._context,
              n = this.graphInfo._fullLayout,
              a = "modebar-" + n._uid;
            this.element.setAttribute("id", a), this._uid = a, this.element.className = "modebar", "hover" === r.displayModeBar && (this.element.className += " modebar--hover ease-bg"), "v" === n.modebar.orientation && (this.element.className += " vertical", t = t.reverse());
            var o = n.modebar,
              l = "hover" === r.displayModeBar ? ".js-plotly-plot .plotly:hover " : "";
            i.deleteRelatedStyleRule(a), i.addRelatedStyleRule(a, l + "#" + a + " .modebar-group", "background-color: " + o.bgcolor), i.addRelatedStyleRule(a, "#" + a + " .modebar-btn .icon path", "fill: " + o.color), i.addRelatedStyleRule(a, "#" + a + " .modebar-btn:hover .icon path", "fill: " + o.activecolor), i.addRelatedStyleRule(a, "#" + a + " .modebar-btn.active .icon path", "fill: " + o.activecolor);
            var s = !this.hasButtons(t),
              c = this.hasLogo !== r.displaylogo,
              u = this.locale !== r.locale;
            if (this.locale = r.locale, (s || c || u) && (this.removeAllButtons(), this.updateButtons(t), r.watermark || r.displaylogo)) {
              var f = this.getLogo();
              r.watermark && (f.className = f.className + " watermark"), "v" === n.modebar.orientation ? this.element.insertBefore(f, this.element.childNodes[0]) : this.element.appendChild(f), this.hasLogo = !0;
            }
            this.updateActiveButton();
          }, u.updateButtons = function (e) {
            var t = this;
            this.buttons = e, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function (e) {
              var r = t.createGroup();
              e.forEach(function (e) {
                var n = e.name;
                if (!n) throw new Error("must provide button 'name' in button config");
                if (-1 !== t.buttonsNames.indexOf(n)) throw new Error("button name '" + n + "' is taken");
                t.buttonsNames.push(n);
                var a = t.createButton(e);
                t.buttonElements.push(a), r.appendChild(a);
              }), t.element.appendChild(r);
            });
          }, u.createGroup = function () {
            var e = document.createElement("div");
            return e.className = "modebar-group", e;
          }, u.createButton = function (e) {
            var t = this,
              r = document.createElement("a");
            r.setAttribute("rel", "tooltip"), r.className = "modebar-btn";
            var a = e.title;
            void 0 === a ? a = e.name : "function" == typeof a && (a = a(this.graphInfo)), (a || 0 === a) && r.setAttribute("data-title", a), void 0 !== e.attr && r.setAttribute("data-attr", e.attr);
            var i = e.val;
            if (void 0 !== i && ("function" == typeof i && (i = i(this.graphInfo)), r.setAttribute("data-val", i)), "function" != typeof e.click) throw new Error("must provide button 'click' function in button config");
            r.addEventListener("click", function (r) {
              e.click(t.graphInfo, r), t.updateActiveButton(r.currentTarget);
            }), r.setAttribute("data-toggle", e.toggle || !1), e.toggle && n.select(r).classed("active", !0);
            var l = e.icon;
            return "function" == typeof l ? r.appendChild(l()) : r.appendChild(this.createIcon(l || o.question)), r.setAttribute("data-gravity", e.gravity || "n"), r;
          }, u.createIcon = function (e) {
            var t,
              r = a(e.height) ? Number(e.height) : e.ascent - e.descent,
              n = "http://www.w3.org/2000/svg";
            if (e.path) {
              (t = document.createElementNS(n, "svg")).setAttribute("viewBox", [0, 0, e.width, r].join(" ")), t.setAttribute("class", "icon");
              var i = document.createElementNS(n, "path");
              i.setAttribute("d", e.path), e.transform ? i.setAttribute("transform", e.transform) : void 0 !== e.ascent && i.setAttribute("transform", "matrix(1 0 0 -1 0 " + e.ascent + ")"), t.appendChild(i);
            }
            return e.svg && (t = s.parseFromString(e.svg, "application/xml").childNodes[0]), t.setAttribute("height", "1em"), t.setAttribute("width", "1em"), t;
          }, u.updateActiveButton = function (e) {
            var t = this.graphInfo._fullLayout,
              r = void 0 !== e ? e.getAttribute("data-attr") : null;
            this.buttonElements.forEach(function (e) {
              var a = e.getAttribute("data-val") || !0,
                o = e.getAttribute("data-attr"),
                l = "true" === e.getAttribute("data-toggle"),
                s = n.select(e);
              if (l) o === r && s.classed("active", !s.classed("active"));else {
                var c = null === o ? o : i.nestedProperty(t, o).get();
                s.classed("active", c === a);
              }
            });
          }, u.hasButtons = function (e) {
            var t = this.buttons;
            if (!t) return !1;
            if (e.length !== t.length) return !1;
            for (var r = 0; r < e.length; ++r) {
              if (e[r].length !== t[r].length) return !1;
              for (var n = 0; n < e[r].length; n++) if (e[r][n].name !== t[r][n].name) return !1;
            }
            return !0;
          }, u.getLogo = function () {
            var e = this.createGroup(),
              t = document.createElement("a");
            return t.href = "https://plotly.com/", t.target = "_blank", t.setAttribute("data-title", i._(this.graphInfo, "Produced with Plotly.js") + " (v" + l + ")"), t.className = "modebar-btn plotlyjsicon modebar-btn--logo", t.appendChild(this.createIcon(o.newplotlylogo)), e.appendChild(t), e;
          }, u.removeAllButtons = function () {
            for (; this.element.firstChild;) this.element.removeChild(this.element.firstChild);
            this.hasLogo = !1;
          }, u.destroy = function () {
            i.removeElement(this.container.querySelector(".modebar")), i.deleteRelatedStyleRule(this._uid);
          }, e.exports = function (e, t) {
            var r = e._fullLayout,
              a = new c({
                graphInfo: e,
                container: r._modebardiv.node(),
                buttons: t
              });
            return r._privateplot && n.select(a.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), a;
          };
        },
        1032: function (e, t, r) {
          "use strict";

          var n = r(337),
            a = r(229),
            i = (0, r(8032).templatedArray)("button", {
              visible: {
                valType: "boolean",
                dflt: !0,
                editType: "plot"
              },
              step: {
                valType: "enumerated",
                values: ["month", "year", "day", "hour", "minute", "second", "all"],
                dflt: "month",
                editType: "plot"
              },
              stepmode: {
                valType: "enumerated",
                values: ["backward", "todate"],
                dflt: "backward",
                editType: "plot"
              },
              count: {
                valType: "number",
                min: 0,
                dflt: 1,
                editType: "plot"
              },
              label: {
                valType: "string",
                editType: "plot"
              },
              editType: "plot"
            });
          e.exports = {
            visible: {
              valType: "boolean",
              editType: "plot"
            },
            buttons: i,
            x: {
              valType: "number",
              min: -2,
              max: 3,
              editType: "plot"
            },
            xanchor: {
              valType: "enumerated",
              values: ["auto", "left", "center", "right"],
              dflt: "left",
              editType: "plot"
            },
            y: {
              valType: "number",
              min: -2,
              max: 3,
              editType: "plot"
            },
            yanchor: {
              valType: "enumerated",
              values: ["auto", "top", "middle", "bottom"],
              dflt: "bottom",
              editType: "plot"
            },
            font: n({
              editType: "plot"
            }),
            bgcolor: {
              valType: "color",
              dflt: a.lightLine,
              editType: "plot"
            },
            activecolor: {
              valType: "color",
              editType: "plot"
            },
            bordercolor: {
              valType: "color",
              dflt: a.defaultLine,
              editType: "plot"
            },
            borderwidth: {
              valType: "number",
              min: 0,
              dflt: 0,
              editType: "plot"
            },
            editType: "plot"
          };
        },
        8508: function (e) {
          "use strict";

          e.exports = {
            yPad: .02,
            minButtonWidth: 30,
            rx: 3,
            ry: 3,
            lightAmount: 25,
            darkAmount: 10
          };
        },
        6255: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8766),
            i = r(8032),
            o = r(9008),
            l = r(1032),
            s = r(8508);
          function c(e, t, r, a) {
            var i = a.calendar;
            function o(r, a) {
              return n.coerce(e, t, l.buttons, r, a);
            }
            if (o("visible")) {
              var s = o("step");
              "all" !== s && (!i || "gregorian" === i || "month" !== s && "year" !== s ? o("stepmode") : t.stepmode = "backward", o("count")), o("label");
            }
          }
          e.exports = function (e, t, r, u, f) {
            var d = e.rangeselector || {},
              h = i.newContainer(t, "rangeselector");
            function p(e, t) {
              return n.coerce(d, h, l, e, t);
            }
            if (p("visible", o(d, h, {
              name: "buttons",
              handleItemDefaults: c,
              calendar: f
            }).length > 0)) {
              var v = function (e, t, r) {
                for (var n = r.filter(function (r) {
                    return t[r].anchor === e._id;
                  }), a = 0, i = 0; i < n.length; i++) {
                  var o = t[n[i]].domain;
                  o && (a = Math.max(o[1], a));
                }
                return [e.domain[0], a + s.yPad];
              }(t, r, u);
              p("x", v[0]), p("y", v[1]), n.noneOrAll(e, t, ["x", "y"]), p("xanchor"), p("yanchor"), n.coerceFont(p, "font", r.font);
              var g = p("bgcolor");
              p("activecolor", a.contrast(g, s.lightAmount, s.darkAmount)), p("bordercolor"), p("borderwidth");
            }
          };
        },
        5431: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(3626),
            i = r(4122),
            o = r(8766),
            l = r(2203),
            s = r(4809),
            c = s.strTranslate,
            u = r(635),
            f = r(5975),
            d = r(4530),
            h = d.LINE_SPACING,
            p = d.FROM_TL,
            v = d.FROM_BR,
            g = r(8508),
            m = r(6383);
          function y(e) {
            return e._id;
          }
          function x(e, t, r) {
            var n = s.ensureSingle(e, "rect", "selector-rect", function (e) {
              e.attr("shape-rendering", "crispEdges");
            });
            n.attr({
              rx: g.rx,
              ry: g.ry
            }), n.call(o.stroke, t.bordercolor).call(o.fill, function (e, t) {
              return t._isActive || t._isHovered ? e.activecolor : e.bgcolor;
            }(t, r)).style("stroke-width", t.borderwidth + "px");
          }
          function b(e, t, r, n) {
            var a, i;
            s.ensureSingle(e, "text", "selector-text", function (e) {
              e.attr("text-anchor", "middle");
            }).call(l.font, t.font).text((a = r, i = n._fullLayout._meta, a.label ? i ? s.templateString(a.label, i) : a.label : "all" === a.step ? "all" : a.count + a.step.charAt(0))).call(function (e) {
              u.convertToTspans(e, n);
            });
          }
          e.exports = function (e) {
            var t = e._fullLayout._infolayer.selectAll(".rangeselector").data(function (e) {
              for (var t = f.list(e, "x", !0), r = [], n = 0; n < t.length; n++) {
                var a = t[n];
                a.rangeselector && a.rangeselector.visible && r.push(a);
              }
              return r;
            }(e), y);
            t.enter().append("g").classed("rangeselector", !0), t.exit().remove(), t.style({
              cursor: "pointer",
              "pointer-events": "all"
            }), t.each(function (t) {
              var r = n.select(this),
                o = t,
                f = o.rangeselector,
                d = r.selectAll("g.button").data(s.filterVisible(f.buttons));
              d.enter().append("g").classed("button", !0), d.exit().remove(), d.each(function (t) {
                var r = n.select(this),
                  i = m(o, t);
                t._isActive = function (e, t, r) {
                  if ("all" === t.step) return !0 === e.autorange;
                  var n = Object.keys(r);
                  return e.range[0] === r[n[0]] && e.range[1] === r[n[1]];
                }(o, t, i), r.call(x, f, t), r.call(b, f, t, e), r.on("click", function () {
                  e._dragged || a.call("_guiRelayout", e, i);
                }), r.on("mouseover", function () {
                  t._isHovered = !0, r.call(x, f, t);
                }), r.on("mouseout", function () {
                  t._isHovered = !1, r.call(x, f, t);
                });
              }), function (e, t, r, a, o) {
                var f = 0,
                  d = 0,
                  m = r.borderwidth;
                t.each(function () {
                  var e = n.select(this).select(".selector-text"),
                    t = r.font.size * h,
                    a = Math.max(t * u.lineCount(e), 16) + 3;
                  d = Math.max(d, a);
                }), t.each(function () {
                  var e = n.select(this),
                    t = e.select(".selector-rect"),
                    a = e.select(".selector-text"),
                    i = a.node() && l.bBox(a.node()).width,
                    o = r.font.size * h,
                    s = u.lineCount(a),
                    p = Math.max(i + 10, g.minButtonWidth);
                  e.attr("transform", c(m + f, m)), t.attr({
                    x: 0,
                    y: 0,
                    width: p,
                    height: d
                  }), u.positionText(a, p / 2, d / 2 - (s - 1) * o / 2 + 3), f += p + 5;
                });
                var y = e._fullLayout._size,
                  x = y.l + y.w * r.x,
                  b = y.t + y.h * (1 - r.y),
                  _ = "left";
                s.isRightAnchor(r) && (x -= f, _ = "right"), s.isCenterAnchor(r) && (x -= f / 2, _ = "center");
                var w = "top";
                s.isBottomAnchor(r) && (b -= d, w = "bottom"), s.isMiddleAnchor(r) && (b -= d / 2, w = "middle"), f = Math.ceil(f), d = Math.ceil(d), x = Math.round(x), b = Math.round(b), i.autoMargin(e, a + "-range-selector", {
                  x: r.x,
                  y: r.y,
                  l: f * p[_],
                  r: f * v[_],
                  b: d * v[w],
                  t: d * p[w]
                }), o.attr("transform", c(x, b));
              }(e, d, f, o._name, r);
            });
          };
        },
        6383: function (e, t, r) {
          "use strict";

          var n = r(936),
            a = r(4809).titleCase;
          e.exports = function (e, t) {
            var r = e._name,
              i = {};
            if ("all" === t.step) i[r + ".autorange"] = !0;else {
              var o = function (e, t) {
                var r,
                  i = e.range,
                  o = new Date(e.r2l(i[1])),
                  l = t.step,
                  s = n["utc" + a(l)],
                  c = t.count;
                switch (t.stepmode) {
                  case "backward":
                    r = e.l2r(+s.offset(o, -c));
                    break;
                  case "todate":
                    var u = s.offset(o, -c);
                    r = e.l2r(+s.ceil(u));
                }
                return [r, i[1]];
              }(e, t);
              i[r + ".range[0]"] = o[0], i[r + ".range[1]"] = o[1];
            }
            return i;
          };
        },
        4453: function (e, t, r) {
          "use strict";

          e.exports = {
            moduleType: "component",
            name: "rangeselector",
            schema: {
              subplots: {
                xaxis: {
                  rangeselector: r(1032)
                }
              }
            },
            layoutAttributes: r(1032),
            handleDefaults: r(6255),
            draw: r(5431)
          };
        },
        3608: function (e, t, r) {
          "use strict";

          var n = r(229);
          e.exports = {
            bgcolor: {
              valType: "color",
              dflt: n.background,
              editType: "plot"
            },
            bordercolor: {
              valType: "color",
              dflt: n.defaultLine,
              editType: "plot"
            },
            borderwidth: {
              valType: "integer",
              dflt: 0,
              min: 0,
              editType: "plot"
            },
            autorange: {
              valType: "boolean",
              dflt: !0,
              editType: "calc",
              impliedEdits: {
                "range[0]": void 0,
                "range[1]": void 0
              }
            },
            range: {
              valType: "info_array",
              items: [{
                valType: "any",
                editType: "calc",
                impliedEdits: {
                  "^autorange": !1
                }
              }, {
                valType: "any",
                editType: "calc",
                impliedEdits: {
                  "^autorange": !1
                }
              }],
              editType: "calc",
              impliedEdits: {
                autorange: !1
              }
            },
            thickness: {
              valType: "number",
              dflt: .15,
              min: 0,
              max: 1,
              editType: "plot"
            },
            visible: {
              valType: "boolean",
              dflt: !0,
              editType: "calc"
            },
            editType: "calc"
          };
        },
        6223: function (e, t, r) {
          "use strict";

          var n = r(5975).list,
            a = r(2919).getAutoRange,
            i = r(604);
          e.exports = function (e) {
            for (var t = n(e, "x", !0), r = 0; r < t.length; r++) {
              var o = t[r],
                l = o[i.name];
              l && l.visible && l.autorange && (l._input.autorange = !0, l._input.range = l.range = a(e, o));
            }
          };
        },
        604: function (e) {
          "use strict";

          e.exports = {
            name: "rangeslider",
            containerClassName: "rangeslider-container",
            bgClassName: "rangeslider-bg",
            rangePlotClassName: "rangeslider-rangeplot",
            maskMinClassName: "rangeslider-mask-min",
            maskMaxClassName: "rangeslider-mask-max",
            slideBoxClassName: "rangeslider-slidebox",
            grabberMinClassName: "rangeslider-grabber-min",
            grabAreaMinClassName: "rangeslider-grabarea-min",
            handleMinClassName: "rangeslider-handle-min",
            grabberMaxClassName: "rangeslider-grabber-max",
            grabAreaMaxClassName: "rangeslider-grabarea-max",
            handleMaxClassName: "rangeslider-handle-max",
            maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
            maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
            maskColor: "rgba(0,0,0,0.4)",
            maskOppAxisColor: "rgba(0,0,0,0.2)",
            slideBoxFill: "transparent",
            slideBoxCursor: "ew-resize",
            grabAreaFill: "transparent",
            grabAreaCursor: "col-resize",
            grabAreaWidth: 10,
            handleWidth: 4,
            handleRadius: 1,
            handleStrokeWidth: 1,
            extraPad: 15
          };
        },
        1295: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8032),
            i = r(5975),
            o = r(3608),
            l = r(6249);
          e.exports = function (e, t, r) {
            var s = e[r],
              c = t[r];
            if (s.rangeslider || t._requestRangeslider[c._id]) {
              n.isPlainObject(s.rangeslider) || (s.rangeslider = {});
              var u,
                f,
                d = s.rangeslider,
                h = a.newContainer(c, "rangeslider");
              if (_("visible")) {
                _("bgcolor", t.plot_bgcolor), _("bordercolor"), _("borderwidth"), _("thickness"), _("autorange", !c.isValidRange(d.range)), _("range");
                var p = t._subplots;
                if (p) for (var v = p.cartesian.filter(function (e) {
                    return e.substr(0, e.indexOf("y")) === i.name2id(r);
                  }).map(function (e) {
                    return e.substr(e.indexOf("y"), e.length);
                  }), g = n.simpleMap(v, i.id2name), m = 0; m < g.length; m++) {
                  var y = g[m];
                  u = d[y] || {}, f = a.newContainer(h, y, "yaxis");
                  var x,
                    b = t[y];
                  u.range && b.isValidRange(u.range) && (x = "fixed"), "match" !== w("rangemode", x) && w("range", b.range.slice());
                }
                h._input = d;
              }
            }
            function _(e, t) {
              return n.coerce(d, h, o, e, t);
            }
            function w(e, t) {
              return n.coerce(u, f, l, e, t);
            }
          };
        },
        8887: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(3626),
            i = r(4122),
            o = r(4809),
            l = o.strTranslate,
            s = r(2203),
            c = r(8766),
            u = r(7240),
            f = r(84),
            d = r(5975),
            h = r(4751),
            p = r(7983),
            v = r(604);
          function g(e) {
            return "number" == typeof e.clientX ? e.clientX : e.touches && e.touches.length > 0 ? e.touches[0].clientX : 0;
          }
          function m(e, t, r, n) {
            var a = o.ensureSingle(e, "rect", v.bgClassName, function (e) {
                e.attr({
                  x: 0,
                  y: 0,
                  "shape-rendering": "crispEdges"
                });
              }),
              i = n.borderwidth % 2 == 0 ? n.borderwidth : n.borderwidth - 1,
              u = -n._offsetShift,
              f = s.crispRound(t, n.borderwidth);
            a.attr({
              width: n._width + i,
              height: n._height + i,
              transform: l(u, u),
              "stroke-width": f
            }).call(c.stroke, n.bordercolor).call(c.fill, n.bgcolor);
          }
          function y(e, t, r, n) {
            var a = t._fullLayout;
            o.ensureSingleById(a._topdefs, "clipPath", n._clipId, function (e) {
              e.append("rect").attr({
                x: 0,
                y: 0
              });
            }).select("rect").attr({
              width: n._width,
              height: n._height
            });
          }
          function x(e, t, r, a) {
            var l,
              c = t.calcdata,
              u = e.selectAll("g." + v.rangePlotClassName).data(r._subplotsWith, o.identity);
            u.enter().append("g").attr("class", function (e) {
              return v.rangePlotClassName + " " + e;
            }).call(s.setClipUrl, a._clipId, t), u.order(), u.exit().remove(), u.each(function (e, o) {
              var s = n.select(this),
                u = 0 === o,
                h = d.getFromId(t, e, "y"),
                p = h._name,
                v = a[p],
                g = {
                  data: [],
                  layout: {
                    xaxis: {
                      type: r.type,
                      domain: [0, 1],
                      range: a.range.slice(),
                      calendar: r.calendar
                    },
                    width: a._width,
                    height: a._height,
                    margin: {
                      t: 0,
                      b: 0,
                      l: 0,
                      r: 0
                    }
                  },
                  _context: t._context
                };
              r.rangebreaks && (g.layout.xaxis.rangebreaks = r.rangebreaks), g.layout[p] = {
                type: h.type,
                domain: [0, 1],
                range: "match" !== v.rangemode ? v.range.slice() : h.range.slice(),
                calendar: h.calendar
              }, h.rangebreaks && (g.layout[p].rangebreaks = h.rangebreaks), i.supplyDefaults(g);
              var m = g._fullLayout.xaxis,
                y = g._fullLayout[p];
              m.clearCalc(), m.setScale(), y.clearCalc(), y.setScale();
              var x = {
                id: e,
                plotgroup: s,
                xaxis: m,
                yaxis: y,
                isRangePlot: !0
              };
              u ? l = x : (x.mainplot = "xy", x.mainplotinfo = l), f.rangePlot(t, x, function (e, t) {
                for (var r = [], n = 0; n < e.length; n++) {
                  var a = e[n],
                    i = a[0].trace;
                  i.xaxis + i.yaxis === t && r.push(a);
                }
                return r;
              }(c, e));
            });
          }
          function b(e, t, r, n, a) {
            o.ensureSingle(e, "rect", v.maskMinClassName, function (e) {
              e.attr({
                x: 0,
                y: 0,
                "shape-rendering": "crispEdges"
              });
            }).attr("height", n._height).call(c.fill, v.maskColor), o.ensureSingle(e, "rect", v.maskMaxClassName, function (e) {
              e.attr({
                y: 0,
                "shape-rendering": "crispEdges"
              });
            }).attr("height", n._height).call(c.fill, v.maskColor), "match" !== a.rangemode && (o.ensureSingle(e, "rect", v.maskMinOppAxisClassName, function (e) {
              e.attr({
                y: 0,
                "shape-rendering": "crispEdges"
              });
            }).attr("width", n._width).call(c.fill, v.maskOppAxisColor), o.ensureSingle(e, "rect", v.maskMaxOppAxisClassName, function (e) {
              e.attr({
                y: 0,
                "shape-rendering": "crispEdges"
              });
            }).attr("width", n._width).style("border-top", v.maskOppBorder).call(c.fill, v.maskOppAxisColor));
          }
          function _(e, t, r, n) {
            t._context.staticPlot || o.ensureSingle(e, "rect", v.slideBoxClassName, function (e) {
              e.attr({
                y: 0,
                cursor: v.slideBoxCursor,
                "shape-rendering": "crispEdges"
              });
            }).attr({
              height: n._height,
              fill: v.slideBoxFill
            });
          }
          function w(e, t, r, n) {
            var a = o.ensureSingle(e, "g", v.grabberMinClassName),
              i = o.ensureSingle(e, "g", v.grabberMaxClassName),
              l = {
                x: 0,
                width: v.handleWidth,
                rx: v.handleRadius,
                fill: c.background,
                stroke: c.defaultLine,
                "stroke-width": v.handleStrokeWidth,
                "shape-rendering": "crispEdges"
              },
              s = {
                y: Math.round(n._height / 4),
                height: Math.round(n._height / 2)
              };
            o.ensureSingle(a, "rect", v.handleMinClassName, function (e) {
              e.attr(l);
            }).attr(s), o.ensureSingle(i, "rect", v.handleMaxClassName, function (e) {
              e.attr(l);
            }).attr(s);
            var u = {
              width: v.grabAreaWidth,
              x: 0,
              y: 0,
              fill: v.grabAreaFill,
              cursor: t._context.staticPlot ? void 0 : v.grabAreaCursor
            };
            o.ensureSingle(a, "rect", v.grabAreaMinClassName, function (e) {
              e.attr(u);
            }).attr("height", n._height), o.ensureSingle(i, "rect", v.grabAreaMaxClassName, function (e) {
              e.attr(u);
            }).attr("height", n._height);
          }
          e.exports = function (e) {
            for (var t = e._fullLayout, r = t._rangeSliderData, i = 0; i < r.length; i++) {
              var s = r[i][v.name];
              s._clipId = s._id + "-" + t._uid;
            }
            var c = t._infolayer.selectAll("g." + v.containerClassName).data(r, function (e) {
              return e._name;
            });
            c.exit().each(function (e) {
              var r = e[v.name];
              t._topdefs.select("#" + r._clipId).remove();
            }).remove(), 0 !== r.length && (c.enter().append("g").classed(v.containerClassName, !0).attr("pointer-events", "all"), c.each(function (r) {
              var i = n.select(this),
                s = r[v.name],
                c = t[d.id2name(r.anchor)],
                f = s[d.id2name(r.anchor)];
              if (s.range) {
                var T,
                  M = o.simpleMap(s.range, r.r2l),
                  k = o.simpleMap(r.range, r.r2l);
                T = k[0] < k[1] ? [Math.min(M[0], k[0]), Math.max(M[1], k[1])] : [Math.max(M[0], k[0]), Math.min(M[1], k[1])], s.range = s._input.range = o.simpleMap(T, r.l2r);
              }
              r.cleanRange("rangeslider.range");
              var A = t._size,
                L = r.domain;
              s._width = A.w * (L[1] - L[0]);
              var S = Math.round(A.l + A.w * L[0]),
                C = Math.round(A.t + A.h * (1 - r._counterDomainMin) + ("bottom" === r.side ? r._depth : 0) + s._offsetShift + v.extraPad);
              i.attr("transform", l(S, C)), s._rl = o.simpleMap(s.range, r.r2l);
              var O = s._rl[0],
                D = s._rl[1],
                P = D - O;
              if (s.p2d = function (e) {
                return e / s._width * P + O;
              }, s.d2p = function (e) {
                return (e - O) / P * s._width;
              }, r.rangebreaks) {
                var z = r.locateBreaks(O, D);
                if (z.length) {
                  var I,
                    E,
                    R = 0;
                  for (I = 0; I < z.length; I++) R += (E = z[I]).max - E.min;
                  var N = s._width / (D - O - R),
                    F = [-N * O];
                  for (I = 0; I < z.length; I++) E = z[I], F.push(F[F.length - 1] - N * (E.max - E.min));
                  for (s.d2p = function (e) {
                    for (var t = F[0], r = 0; r < z.length; r++) {
                      var n = z[r];
                      if (e >= n.max) t = F[r + 1];else if (e < n.min) break;
                    }
                    return t + N * e;
                  }, I = 0; I < z.length; I++) (E = z[I]).pmin = s.d2p(E.min), E.pmax = s.d2p(E.max);
                  s.p2d = function (e) {
                    for (var t = F[0], r = 0; r < z.length; r++) {
                      var n = z[r];
                      if (e >= n.pmax) t = F[r + 1];else if (e < n.pmin) break;
                    }
                    return (e - t) / N;
                  };
                }
              }
              if ("match" !== f.rangemode) {
                var H = c.r2l(f.range[0]),
                  B = c.r2l(f.range[1]) - H;
                s.d2pOppAxis = function (e) {
                  return (e - H) / B * s._height;
                };
              }
              i.call(m, e, r, s).call(y, e, r, s).call(x, e, r, s).call(b, e, r, s, f).call(_, e, r, s).call(w, e, r, s), function (e, t, r, i) {
                if (!t._context.staticPlot) {
                  var l = e.select("rect." + v.slideBoxClassName).node(),
                    s = e.select("rect." + v.grabAreaMinClassName).node(),
                    c = e.select("rect." + v.grabAreaMaxClassName).node();
                  e.on("mousedown", u), e.on("touchstart", u);
                }
                function u() {
                  var u = n.event,
                    f = u.target,
                    d = g(u),
                    v = d - e.node().getBoundingClientRect().left,
                    m = i.d2p(r._rl[0]),
                    y = i.d2p(r._rl[1]),
                    x = h.coverSlip();
                  function b(e) {
                    var u,
                      h,
                      b,
                      _ = +g(e) - d;
                    switch (f) {
                      case l:
                        if (b = "ew-resize", m + _ > r._length || y + _ < 0) return;
                        u = m + _, h = y + _;
                        break;
                      case s:
                        if (b = "col-resize", m + _ > r._length) return;
                        u = m + _, h = y;
                        break;
                      case c:
                        if (b = "col-resize", y + _ < 0) return;
                        u = m, h = y + _;
                        break;
                      default:
                        b = "ew-resize", u = v, h = v + _;
                    }
                    if (h < u) {
                      var w = h;
                      h = u, u = w;
                    }
                    i._pixelMin = u, i._pixelMax = h, p(n.select(x), b), function (e, t, r, n) {
                      function i(e) {
                        return r.l2r(o.constrain(e, n._rl[0], n._rl[1]));
                      }
                      var l = i(n.p2d(n._pixelMin)),
                        s = i(n.p2d(n._pixelMax));
                      window.requestAnimationFrame(function () {
                        a.call("_guiRelayout", t, r._name + ".range", [l, s]);
                      });
                    }(0, t, r, i);
                  }
                  function _() {
                    x.removeEventListener("mousemove", b), x.removeEventListener("mouseup", _), this.removeEventListener("touchmove", b), this.removeEventListener("touchend", _), o.removeElement(x);
                  }
                  this.addEventListener("touchmove", b), this.addEventListener("touchend", _), x.addEventListener("mousemove", b), x.addEventListener("mouseup", _);
                }
              }(i, e, r, s), function (e, t, r, n, a, i) {
                var s = v.handleWidth / 2;
                function c(e) {
                  return o.constrain(e, 0, n._width);
                }
                function u(e) {
                  return o.constrain(e, 0, n._height);
                }
                function f(e) {
                  return o.constrain(e, -s, n._width + s);
                }
                var d = c(n.d2p(r._rl[0])),
                  h = c(n.d2p(r._rl[1]));
                if (e.select("rect." + v.slideBoxClassName).attr("x", d).attr("width", h - d), e.select("rect." + v.maskMinClassName).attr("width", d), e.select("rect." + v.maskMaxClassName).attr("x", h).attr("width", n._width - h), "match" !== i.rangemode) {
                  var p = n._height - u(n.d2pOppAxis(a._rl[1])),
                    g = n._height - u(n.d2pOppAxis(a._rl[0]));
                  e.select("rect." + v.maskMinOppAxisClassName).attr("x", d).attr("height", p).attr("width", h - d), e.select("rect." + v.maskMaxOppAxisClassName).attr("x", d).attr("y", g).attr("height", n._height - g).attr("width", h - d), e.select("rect." + v.slideBoxClassName).attr("y", p).attr("height", g - p);
                }
                var m = .5,
                  y = Math.round(f(d - s)) - m,
                  x = Math.round(f(h - s)) + m;
                e.select("g." + v.grabberMinClassName).attr("transform", l(y, m)), e.select("g." + v.grabberMaxClassName).attr("transform", l(x, m));
              }(i, 0, r, s, c, f), "bottom" === r.side && u.draw(e, r._id + "title", {
                propContainer: r,
                propName: r._name + ".title",
                placeholder: t._dfltTitle.x,
                attributes: {
                  x: r._offset + r._length / 2,
                  y: C + s._height + s._offsetShift + 10 + 1.5 * r.title.font.size,
                  "text-anchor": "middle"
                }
              });
            }));
          };
        },
        400: function (e, t, r) {
          "use strict";

          var n = r(5975),
            a = r(635),
            i = r(604),
            o = r(4530).LINE_SPACING,
            l = i.name;
          function s(e) {
            var t = e && e[l];
            return t && t.visible;
          }
          t.isVisible = s, t.makeData = function (e) {
            var t = n.list({
                _fullLayout: e
              }, "x", !0),
              r = e.margin,
              a = [];
            if (!e._has("gl2d")) for (var i = 0; i < t.length; i++) {
              var o = t[i];
              if (s(o)) {
                a.push(o);
                var c = o[l];
                c._id = l + o._id, c._height = (e.height - r.b - r.t) * c.thickness, c._offsetShift = Math.floor(c.borderwidth / 2);
              }
            }
            e._rangeSliderData = a;
          }, t.autoMarginOpts = function (e, t) {
            var r = e._fullLayout,
              n = t[l],
              s = t._id.charAt(0),
              c = 0,
              u = 0;
            return "bottom" === t.side && (c = t._depth, t.title.text !== r._dfltTitle[s] && (u = 1.5 * t.title.font.size + 10 + n._offsetShift, u += (t.title.text.match(a.BR_TAG_ALL) || []).length * t.title.font.size * o)), {
              x: 0,
              y: t._counterDomainMin,
              l: 0,
              r: 0,
              t: 0,
              b: n._height + c + Math.max(r.margin.b, u),
              pad: i.extraPad + 2 * n._offsetShift
            };
          };
        },
        5429: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(3608),
            i = r(6249),
            o = r(400);
          e.exports = {
            moduleType: "component",
            name: "rangeslider",
            schema: {
              subplots: {
                xaxis: {
                  rangeslider: n.extendFlat({}, a, {
                    yaxis: i
                  })
                }
              }
            },
            layoutAttributes: r(3608),
            handleDefaults: r(1295),
            calcAutorange: r(6223),
            draw: r(8887),
            isVisible: o.isVisible,
            makeData: o.makeData,
            autoMarginOpts: o.autoMarginOpts
          };
        },
        6249: function (e) {
          "use strict";

          e.exports = {
            _isSubplotObj: !0,
            rangemode: {
              valType: "enumerated",
              values: ["auto", "fixed", "match"],
              dflt: "match",
              editType: "calc"
            },
            range: {
              valType: "info_array",
              items: [{
                valType: "any",
                editType: "plot"
              }, {
                valType: "any",
                editType: "plot"
              }],
              editType: "plot"
            },
            editType: "calc"
          };
        },
        4327: function (e, t, r) {
          "use strict";

          var n = r(222),
            a = r(6640).line,
            i = r(4850).T,
            o = r(3049).extendFlat,
            l = r(3582).overrideAll,
            s = r(8032).templatedArray;
          r(5081), e.exports = l(s("selection", {
            type: {
              valType: "enumerated",
              values: ["rect", "path"]
            },
            xref: o({}, n.xref, {}),
            yref: o({}, n.yref, {}),
            x0: {
              valType: "any"
            },
            x1: {
              valType: "any"
            },
            y0: {
              valType: "any"
            },
            y1: {
              valType: "any"
            },
            path: {
              valType: "string",
              editType: "arraydraw"
            },
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: .7,
              editType: "arraydraw"
            },
            line: {
              color: a.color,
              width: o({}, a.width, {
                min: 1,
                dflt: 1
              }),
              dash: o({}, i, {
                dflt: "dot"
              })
            }
          }), "arraydraw", "from-root");
        },
        8865: function (e) {
          "use strict";

          e.exports = {
            BENDPX: 1.5,
            MINSELECT: 12,
            SELECTDELAY: 100,
            SELECTID: "-select"
          };
        },
        2272: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714),
            i = r(9008),
            o = r(4327),
            l = r(9728);
          function s(e, t, r) {
            function i(r, a) {
              return n.coerce(e, t, o, r, a);
            }
            var s = i("path"),
              c = "path" !== i("type", s ? "path" : "rect");
            c && delete t.path, i("opacity"), i("line.color"), i("line.width"), i("line.dash");
            for (var u = ["x", "y"], f = 0; f < 2; f++) {
              var d,
                h,
                p,
                v = u[f],
                g = {
                  _fullLayout: r
                },
                m = a.coerceRef(e, t, g, v);
              if ((d = a.getFromId(g, m))._selectionIndices.push(t._index), p = l.rangeToShapePosition(d), h = l.shapePositionToRange(d), c) {
                var y = v + "0",
                  x = v + "1",
                  b = e[y],
                  _ = e[x];
                e[y] = h(e[y], !0), e[x] = h(e[x], !0), a.coercePosition(t, g, i, m, y), a.coercePosition(t, g, i, m, x);
                var w = t[y],
                  T = t[x];
                void 0 !== w && void 0 !== T && (t[y] = p(w), t[x] = p(T), e[y] = b, e[x] = _);
              }
            }
            c && n.noneOrAll(e, t, ["x0", "x1", "y0", "y1"]);
          }
          e.exports = function (e, t) {
            i(e, t, {
              name: "selections",
              handleItemDefaults: s
            });
            for (var r = t.selections, n = 0; n < r.length; n++) {
              var a = r[n];
              a && void 0 === a.path && (void 0 !== a.x0 && void 0 !== a.x1 && void 0 !== a.y0 && void 0 !== a.y1 || (t.selections[n] = null));
            }
          };
        },
        7028: function (e, t, r) {
          "use strict";

          var n = r(1055).readPaths,
            a = r(561),
            i = r(8534).clearOutlineControllers,
            o = r(8766),
            l = r(2203),
            s = r(8032).arrayEditor,
            c = r(9728),
            u = c.getPathString;
          function f(e) {
            var t = e._fullLayout;
            for (var r in i(e), t._selectionLayer.selectAll("path").remove(), t._plots) {
              var n = t._plots[r].selectionLayer;
              n && n.selectAll("path").remove();
            }
            for (var a = 0; a < t.selections.length; a++) h(e, a);
          }
          function d(e) {
            return e._context.editSelection;
          }
          function h(e, t) {
            e._fullLayout._paperdiv.selectAll('.selectionlayer [data-index="' + t + '"]').remove();
            var r = c.makeSelectionsOptionsAndPlotinfo(e, t),
              i = r.options,
              h = r.plotinfo;
            i._input && function (r) {
              var c = u(e, i),
                g = {
                  "data-index": t,
                  "fill-rule": "evenodd",
                  d: c
                },
                m = i.opacity,
                y = "rgba(0,0,0,0)",
                x = i.line.color || o.contrast(e._fullLayout.plot_bgcolor),
                b = i.line.width,
                _ = i.line.dash;
              b || (b = 5, _ = "solid");
              var w = d(e) && e._fullLayout._activeSelectionIndex === t;
              w && (y = e._fullLayout.activeselection.fillcolor, m = e._fullLayout.activeselection.opacity);
              for (var T = [], M = 1; M >= 0; M--) {
                var k = r.append("path").attr(g).style("opacity", M ? .1 : m).call(o.stroke, x).call(o.fill, y).call(l.dashLine, M ? "solid" : _, M ? 4 + b : b);
                if (p(k, e, i), w) {
                  var A = s(e.layout, "selections", i);
                  k.style({
                    cursor: "move"
                  });
                  var L = {
                      element: k.node(),
                      plotinfo: h,
                      gd: e,
                      editHelpers: A,
                      isActiveSelection: !0
                    },
                    S = n(c, e);
                  a(S, k, L);
                } else k.style("pointer-events", M ? "all" : "none");
                T[M] = k;
              }
              var C = T[0];
              T[1].node().addEventListener("click", function () {
                return function (e, t) {
                  if (d(e)) {
                    var r = +t.node().getAttribute("data-index");
                    if (r >= 0) {
                      if (r === e._fullLayout._activeSelectionIndex) return void v(e);
                      e._fullLayout._activeSelectionIndex = r, e._fullLayout._deactivateSelection = v, f(e);
                    }
                  }
                }(e, C);
              });
            }(e._fullLayout._selectionLayer);
          }
          function p(e, t, r) {
            var n = r.xref + r.yref;
            l.setClipUrl(e, "clip" + t._fullLayout._uid + n, t);
          }
          function v(e) {
            d(e) && e._fullLayout._activeSelectionIndex >= 0 && (i(e), delete e._fullLayout._activeSelectionIndex, f(e));
          }
          e.exports = {
            draw: f,
            drawOne: h,
            activateLastSelection: function (e) {
              if (d(e)) {
                var t = e._fullLayout.selections.length - 1;
                e._fullLayout._activeSelectionIndex = t, e._fullLayout._deactivateSelection = v, f(e);
              }
            }
          };
        },
        2307: function (e, t, r) {
          "use strict";

          var n = r(4850).T,
            a = r(3049).extendFlat;
          e.exports = {
            newselection: {
              mode: {
                valType: "enumerated",
                values: ["immediate", "gradual"],
                dflt: "immediate",
                editType: "none"
              },
              line: {
                color: {
                  valType: "color",
                  editType: "none"
                },
                width: {
                  valType: "number",
                  min: 1,
                  dflt: 1,
                  editType: "none"
                },
                dash: a({}, n, {
                  dflt: "dot",
                  editType: "none"
                }),
                editType: "none"
              },
              editType: "none"
            },
            activeselection: {
              fillcolor: {
                valType: "color",
                dflt: "rgba(0,0,0,0)",
                editType: "none"
              },
              opacity: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: .5,
                editType: "none"
              },
              editType: "none"
            }
          };
        },
        3028: function (e) {
          "use strict";

          e.exports = function (e, t, r) {
            r("newselection.mode"), r("newselection.line.width") && (r("newselection.line.color"), r("newselection.line.dash")), r("activeselection.fillcolor"), r("activeselection.opacity");
          };
        },
        4198: function (e, t, r) {
          "use strict";

          var n = r(414).selectMode,
            a = r(8534).clearOutline,
            i = r(1055),
            o = i.readPaths,
            l = i.writePaths,
            s = i.fixDatesForPaths;
          e.exports = function (e, t) {
            if (e.length) {
              var r = e[0][0];
              if (r) {
                var i = r.getAttribute("d"),
                  c = t.gd,
                  u = c._fullLayout.newselection,
                  f = t.plotinfo,
                  d = f.xaxis,
                  h = f.yaxis,
                  p = t.isActiveSelection,
                  v = t.dragmode,
                  g = (c.layout || {}).selections || [];
                if (!n(v) && void 0 !== p) {
                  var m = c._fullLayout._activeSelectionIndex;
                  if (m < g.length) switch (c._fullLayout.selections[m].type) {
                    case "rect":
                      v = "select";
                      break;
                    case "path":
                      v = "lasso";
                  }
                }
                var y,
                  x = o(i, c, f, p),
                  b = {
                    xref: d._id,
                    yref: h._id,
                    opacity: u.opacity,
                    line: {
                      color: u.line.color,
                      width: u.line.width,
                      dash: u.line.dash
                    }
                  };
                1 === x.length && (y = x[0]), y && 5 === y.length && "select" === v ? (b.type = "rect", b.x0 = y[0][1], b.y0 = y[0][2], b.x1 = y[2][1], b.y1 = y[2][2]) : (b.type = "path", d && h && s(x, d, h), b.path = l(x), y = null), a(c);
                for (var _ = t.editHelpers, w = (_ || {}).modifyItem, T = [], M = 0; M < g.length; M++) {
                  var k = c._fullLayout.selections[M];
                  if (k) {
                    if (T[M] = k._input, void 0 !== p && M === c._fullLayout._activeSelectionIndex) {
                      var A = b;
                      switch (k.type) {
                        case "rect":
                          w("x0", A.x0), w("x1", A.x1), w("y0", A.y0), w("y1", A.y1);
                          break;
                        case "path":
                          w("path", A.path);
                      }
                    }
                  } else T[M] = k;
                }
                return void 0 === p ? (T.push(b), T) : _ ? _.getUpdateObj() : {};
              }
            }
          };
        },
        9801: function (e, t, r) {
          "use strict";

          var n = r(4809).strTranslate;
          function a(e, t) {
            switch (e.type) {
              case "log":
                return e.p2d(t);
              case "date":
                return e.p2r(t, 0, e.calendar);
              default:
                return e.p2r(t);
            }
          }
          e.exports = {
            p2r: a,
            r2p: function (e, t) {
              switch (e.type) {
                case "log":
                  return e.d2p(t);
                case "date":
                  return e.r2p(t, 0, e.calendar);
                default:
                  return e.r2p(t);
              }
            },
            axValue: function (e) {
              var t = "y" === e._id.charAt(0) ? 1 : 0;
              return function (r) {
                return a(e, r[t]);
              };
            },
            getTransform: function (e) {
              return n(e.xaxis._offset, e.yaxis._offset);
            }
          };
        },
        4844: function (e, t, r) {
          "use strict";

          var n = r(7028),
            a = r(8666);
          e.exports = {
            moduleType: "component",
            name: "selections",
            layoutAttributes: r(4327),
            supplyLayoutDefaults: r(2272),
            supplyDrawNewSelectionDefaults: r(3028),
            includeBasePlot: r(706)("selections"),
            draw: n.draw,
            drawOne: n.drawOne,
            reselect: a.reselect,
            prepSelect: a.prepSelect,
            clearOutline: a.clearOutline,
            clearSelectionsCache: a.clearSelectionsCache,
            selectOnClick: a.selectOnClick
          };
        },
        8666: function (e, t, r) {
          "use strict";

          var n = r(1516),
            a = r(2773),
            i = r(3626),
            o = r(2203).dashStyle,
            l = r(8766),
            s = r(2141),
            c = r(6040).makeEventData,
            u = r(414),
            f = u.freeMode,
            d = u.rectMode,
            h = u.drawMode,
            p = u.openMode,
            v = u.selectMode,
            g = r(9728),
            m = r(2956),
            y = r(561),
            x = r(8534).clearOutline,
            b = r(1055),
            _ = b.handleEllipse,
            w = b.readPaths,
            T = r(7562).newShapes,
            M = r(4198),
            k = r(7028).activateLastSelection,
            A = r(4809),
            L = A.sorterAsc,
            S = r(899),
            C = r(4025),
            O = r(5975).getFromId,
            D = r(4823),
            P = r(1817).redrawReglTraces,
            z = r(8865),
            I = z.MINSELECT,
            E = S.filter,
            R = S.tester,
            N = r(9801),
            F = N.p2r,
            H = N.axValue,
            B = N.getTransform;
          function j(e) {
            return void 0 !== e.subplot;
          }
          function Y(e, t, r, n, a, i, o) {
            var l,
              s,
              c,
              u,
              f,
              d,
              h,
              v,
              g,
              m = t._hoverdata,
              x = t._fullLayout.clickmode.indexOf("event") > -1,
              b = [];
            if (function (e) {
              return e && Array.isArray(e) && !0 !== e[0].hoverOnBox;
            }(m)) {
              G(e, t, i);
              var _ = function (e, t) {
                var r,
                  n,
                  a = e[0],
                  i = -1,
                  o = [];
                for (n = 0; n < t.length; n++) if (r = t[n], a.fullData._expandedIndex === r.cd[0].trace._expandedIndex) {
                  if (!0 === a.hoverOnBox) break;
                  void 0 !== a.pointNumber ? i = a.pointNumber : void 0 !== a.binNumber && (i = a.binNumber, o = a.pointNumbers);
                  break;
                }
                return {
                  pointNumber: i,
                  pointNumbers: o,
                  searchInfo: r
                };
              }(m, l = J(t, r, n, a));
              if (_.pointNumbers.length > 0 ? function (e, t) {
                var r,
                  n,
                  a,
                  i = [];
                for (a = 0; a < e.length; a++) (r = e[a]).cd[0].trace.selectedpoints && r.cd[0].trace.selectedpoints.length > 0 && i.push(r);
                if (1 === i.length && i[0] === t.searchInfo && (n = t.searchInfo.cd[0].trace).selectedpoints.length === t.pointNumbers.length) {
                  for (a = 0; a < t.pointNumbers.length; a++) if (n.selectedpoints.indexOf(t.pointNumbers[a]) < 0) return !1;
                  return !0;
                }
                return !1;
              }(l, _) : function (e) {
                var t,
                  r,
                  n = 0;
                for (r = 0; r < e.length; r++) if ((t = e[r].cd[0].trace).selectedpoints) {
                  if (t.selectedpoints.length > 1) return !1;
                  if ((n += t.selectedpoints.length) > 1) return !1;
                }
                return 1 === n;
              }(l) && (d = K(_))) {
                for (o && o.remove(), g = 0; g < l.length; g++) (s = l[g])._module.selectPoints(s, !1);
                Q(t, l), Z(i), x && de(t);
              } else {
                for (h = e.shiftKey && (void 0 !== d ? d : K(_)), c = function (e, t, r) {
                  return {
                    pointNumber: e,
                    searchInfo: t,
                    subtract: !!r
                  };
                }(_.pointNumber, _.searchInfo, h), u = q(i.selectionDefs.concat([c])), g = 0; g < l.length; g++) if (f = ee(l[g]._module.selectPoints(l[g], u), l[g]), b.length) for (var w = 0; w < f.length; w++) b.push(f[w]);else b = f;
                if (Q(t, l, v = {
                  points: b
                }), c && i && i.selectionDefs.push(c), o) {
                  var T = i.mergedPolygons,
                    M = p(i.dragmode);
                  y(te(T, M), o, i);
                }
                x && fe(t, v);
              }
            }
          }
          function V(e) {
            return "pointNumber" in e && "searchInfo" in e;
          }
          function U(e) {
            return {
              xmin: 0,
              xmax: 0,
              ymin: 0,
              ymax: 0,
              pts: [],
              contains: function (t, r, n, a) {
                var i = e.searchInfo.cd[0].trace._expandedIndex;
                return a.cd[0].trace._expandedIndex === i && n === e.pointNumber;
              },
              isRect: !1,
              degenerate: !1,
              subtract: !!e.subtract
            };
          }
          function q(e) {
            if (e.length) {
              for (var t = [], r = V(e[0]) ? 0 : e[0][0][0], n = r, a = V(e[0]) ? 0 : e[0][0][1], i = a, o = 0; o < e.length; o++) if (V(e[o])) t.push(U(e[o]));else {
                var l = R(e[o]);
                l.subtract = !!e[o].subtract, t.push(l), r = Math.min(r, l.xmin), n = Math.max(n, l.xmax), a = Math.min(a, l.ymin), i = Math.max(i, l.ymax);
              }
              return {
                xmin: r,
                xmax: n,
                ymin: a,
                ymax: i,
                pts: [],
                contains: function (e, r, n, a) {
                  for (var i = !1, o = 0; o < t.length; o++) t[o].contains(e, r, n, a) && (i = !t[o].subtract);
                  return i;
                },
                isRect: !1,
                degenerate: !1
              };
            }
          }
          function G(e, t, r) {
            var n = t._fullLayout,
              a = r.plotinfo,
              i = r.dragmode,
              o = n._lastSelectedSubplot && n._lastSelectedSubplot === a.id,
              l = (e.shiftKey || e.altKey) && !(h(i) && p(i));
            o && l && a.selection && a.selection.selectionDefs && !r.selectionDefs ? (r.selectionDefs = a.selection.selectionDefs, r.mergedPolygons = a.selection.mergedPolygons) : l && a.selection || Z(r), o || (x(t), n._lastSelectedSubplot = a.id);
          }
          function Z(e, t) {
            var r = e.dragmode,
              n = e.plotinfo,
              a = e.gd;
            (function (e) {
              return e._fullLayout._activeShapeIndex >= 0;
            })(a) && a._fullLayout._deactivateShape(a), function (e) {
              return e._fullLayout._activeSelectionIndex >= 0;
            }(a) && a._fullLayout._deactivateSelection(a);
            var o = a._fullLayout._zoomlayer,
              l = h(r),
              s = v(r);
            if (l || s) {
              var c,
                u,
                f = o.selectAll(".select-outline-" + n.id);
              f && a._fullLayout._outlining && (l && (c = T(f, e)), c && i.call("_guiRelayout", a, {
                shapes: c
              }), s && !j(e) && (u = M(f, e)), u && (a._fullLayout._noEmitSelectedAtStart = !0, i.call("_guiRelayout", a, {
                selections: u
              }).then(function () {
                t && k(a);
              })), a._fullLayout._outlining = !1);
            }
            n.selection = {}, n.selection.selectionDefs = e.selectionDefs = [], n.selection.mergedPolygons = e.mergedPolygons = [];
          }
          function W(e) {
            return e._id;
          }
          function J(e, t, r, n) {
            if (!e.calcdata) return [];
            var a,
              i,
              o,
              l = [],
              s = t.map(W),
              c = r.map(W);
            for (o = 0; o < e.calcdata.length; o++) if (!0 === (i = (a = e.calcdata[o])[0].trace).visible && i._module && i._module.selectPoints) if (!j({
              subplot: n
            }) || i.subplot !== n && i.geo !== n) {
              if ("splom" === i.type) {
                if (i._xaxes[s[0]] && i._yaxes[c[0]]) {
                  var u = X(i._module, a, t[0], r[0]);
                  u.scene = e._fullLayout._splomScenes[i.uid], l.push(u);
                }
              } else if ("sankey" === i.type) {
                var f = X(i._module, a, t[0], r[0]);
                l.push(f);
              } else {
                if (!(-1 !== s.indexOf(i.xaxis) || i._xA && i._xA.overlaying)) continue;
                if (!(-1 !== c.indexOf(i.yaxis) || i._yA && i._yA.overlaying)) continue;
                l.push(X(i._module, a, O(e, i.xaxis), O(e, i.yaxis)));
              }
            } else l.push(X(i._module, a, t[0], r[0]));
            return l;
          }
          function X(e, t, r, n) {
            return {
              _module: e,
              cd: t,
              xaxis: r,
              yaxis: n
            };
          }
          function K(e) {
            var t = e.searchInfo.cd[0].trace,
              r = e.pointNumber,
              n = e.pointNumbers,
              a = n.length > 0 ? n[0] : r;
            return !!t.selectedpoints && t.selectedpoints.indexOf(a) > -1;
          }
          function Q(e, t, r) {
            var n, a;
            for (n = 0; n < t.length; n++) {
              var o = t[n].cd[0].trace._fullInput,
                l = e._fullLayout._tracePreGUI[o.uid] || {};
              void 0 === l.selectedpoints && (l.selectedpoints = o._input.selectedpoints || null);
            }
            if (r) {
              var s = r.points || [];
              for (n = 0; n < t.length; n++) (a = t[n].cd[0].trace)._input.selectedpoints = a._fullInput.selectedpoints = [], a._fullInput !== a && (a.selectedpoints = []);
              for (var c = 0; c < s.length; c++) {
                var u = s[c],
                  f = u.data,
                  d = u.fullData,
                  h = u.pointIndex,
                  p = u.pointIndices;
                p ? ([].push.apply(f.selectedpoints, p), a._fullInput !== a && [].push.apply(d.selectedpoints, p)) : (f.selectedpoints.push(h), a._fullInput !== a && d.selectedpoints.push(h));
              }
            } else for (n = 0; n < t.length; n++) delete (a = t[n].cd[0].trace).selectedpoints, delete a._input.selectedpoints, a._fullInput !== a && delete a._fullInput.selectedpoints;
            !function (e, t) {
              for (var r = !1, n = 0; n < t.length; n++) {
                var a = t[n],
                  o = a.cd;
                i.traceIs(o[0].trace, "regl") && (r = !0);
                var l = a._module,
                  s = l.styleOnSelect || l.style;
                s && (s(e, o, o[0].node3), o[0].nodeRangePlot3 && s(e, o, o[0].nodeRangePlot3));
              }
              r && (D(e), P(e));
            }(e, t);
          }
          function $(e, t, r) {
            for (var a = (r ? n.difference : n.union)({
                regions: e
              }, {
                regions: [t]
              }).regions.reverse(), i = 0; i < a.length; i++) {
              var o = a[i];
              o.subtract = le(o, a.slice(0, i));
            }
            return a;
          }
          function ee(e, t) {
            if (Array.isArray(e)) for (var r = t.cd, n = t.cd[0].trace, a = 0; a < e.length; a++) e[a] = c(e[a], n, r);
            return e;
          }
          function te(e, t) {
            for (var r = [], n = 0; n < e.length; n++) {
              r[n] = [];
              for (var a = 0; a < e[n].length; a++) {
                r[n][a] = [], r[n][a][0] = a ? "L" : "M";
                for (var i = 0; i < e[n][a].length; i++) r[n][a].push(e[n][a][i]);
              }
              t || r[n].push(["Z", r[n][0][1], r[n][0][2]]);
            }
            return r;
          }
          function re(e, t) {
            for (var r, n, a = [], i = [], o = 0; o < t.length; o++) {
              var l = t[o];
              n = l._module.selectPoints(l, e), i.push(n), r = ee(n, l), a = a.concat(r);
            }
            return a;
          }
          function ne(e, t, r, n, a) {
            var i,
              o,
              l,
              s = !!n;
            a && (i = a.plotinfo, o = a.xaxes[0]._id, l = a.yaxes[0]._id);
            var c = [],
              u = [],
              f = oe(e),
              d = e._fullLayout;
            if (i) {
              var p = d._zoomlayer,
                g = d.dragmode,
                m = h(g),
                y = v(g);
              if (m || y) {
                var x = O(e, o, "x"),
                  b = O(e, l, "y");
                if (x && b) {
                  var _ = p.selectAll(".select-outline-" + i.id);
                  if (_ && e._fullLayout._outlining && _.length) {
                    for (var T = _[0][0].getAttribute("d"), M = w(T, e, i), k = [], A = 0; A < M.length; A++) {
                      for (var L = M[A], S = [], C = 0; C < L.length; C++) S.push([se(x, L[C][1]), se(b, L[C][2])]);
                      S.xref = o, S.yref = l, S.subtract = le(S, k), k.push(S);
                    }
                    f = f.concat(k);
                  }
                }
              }
            }
            var D = o && l ? [o + l] : d._subplots.cartesian;
            !function (e) {
              var t = e.calcdata;
              if (t) for (var r = 0; r < t.length; r++) {
                var n = t[r][0].trace,
                  a = e._fullLayout._splomScenes;
                if (a) {
                  var i = a[n.uid];
                  i && (i.selectBatch = []);
                }
              }
            }(e);
            for (var P = {}, z = 0; z < D.length; z++) {
              var I = D[z],
                E = I.indexOf("y"),
                R = I.slice(0, E),
                N = I.slice(E),
                F = o && l ? r : void 0;
              if (F = ie(f, R, N, F)) {
                var H = n;
                if (!s) {
                  var B = O(e, R, "x"),
                    j = O(e, N, "y");
                  H = J(e, [B], [j], I);
                  for (var Y = 0; Y < H.length; Y++) {
                    var V = H[Y],
                      U = V.cd[0],
                      q = U.trace;
                    if ("scattergl" === V._module.name && !U.t.xpx) {
                      var G = q.x,
                        Z = q.y,
                        W = q._length;
                      U.t.xpx = [], U.t.ypx = [];
                      for (var X = 0; X < W; X++) U.t.xpx[X] = B.c2p(G[X]), U.t.ypx[X] = j.c2p(Z[X]);
                    }
                    "splom" === V._module.name && (P[q.uid] || (P[q.uid] = !0));
                  }
                }
                var K = re(F, H);
                c = c.concat(K), u = u.concat(H);
              }
            }
            var $ = {
              points: c
            };
            Q(e, u, $);
            var ee = d.clickmode.indexOf("event") > -1 && t;
            if (!i && t) {
              var te = oe(e, !0);
              if (te.length) {
                var ne = te[0].xref,
                  he = te[0].yref;
                if (ne && he) {
                  var pe = ce(te);
                  ue([O(e, ne, "x"), O(e, he, "y")])($, pe);
                }
              }
              e._fullLayout._noEmitSelectedAtStart ? e._fullLayout._noEmitSelectedAtStart = !1 : ee && fe(e, $), d._reselect = !1;
            }
            if (!i && d._deselect) {
              var ve = d._deselect;
              (function (e, t, r) {
                for (var n = 0; n < r.length; n++) {
                  var a = r[n];
                  if (a.xaxis && a.xaxis._id === e && a.yaxis && a.yaxis._id === t) return !0;
                }
                return !1;
              })(o = ve.xref, l = ve.yref, u) || ae(e, o, l, n), ee && ($.points.length ? fe(e, $) : de(e)), d._deselect = !1;
            }
            return {
              eventData: $,
              selectionTesters: r
            };
          }
          function ae(e, t, r, n) {
            n = J(e, [O(e, t, "x")], [O(e, r, "y")], t + r);
            for (var a = 0; a < n.length; a++) {
              var i = n[a];
              i._module.selectPoints(i, !1);
            }
            Q(e, n);
          }
          function ie(e, t, r, n) {
            for (var a, i = 0; i < e.length; i++) {
              var o = e[i];
              t === o.xref && r === o.yref && (a ? n = q(a = $(a, o, !!o.subtract)) : (a = [o], n = R(o)));
            }
            return n;
          }
          function oe(e, t) {
            for (var r = [], n = e._fullLayout, a = n.selections, i = a.length, o = 0; o < i; o++) if (!t || o === n._activeSelectionIndex) {
              var l = a[o];
              if (l) {
                var s,
                  c,
                  u,
                  f,
                  d,
                  h = l.xref,
                  p = l.yref,
                  v = O(e, h, "x"),
                  y = O(e, p, "y");
                if ("rect" === l.type) {
                  d = [];
                  var x = se(v, l.x0),
                    b = se(v, l.x1),
                    _ = se(y, l.y0),
                    w = se(y, l.y1);
                  d = [[x, _], [x, w], [b, w], [b, _]], s = Math.min(x, b), c = Math.max(x, b), u = Math.min(_, w), f = Math.max(_, w), d.xmin = s, d.xmax = c, d.ymin = u, d.ymax = f, d.xref = h, d.yref = p, d.subtract = !1, d.isRect = !0, r.push(d);
                } else if ("path" === l.type) for (var T = l.path.split("Z"), M = [], k = 0; k < T.length; k++) {
                  var A = T[k];
                  if (A) {
                    A += "Z";
                    var L = g.extractPathCoords(A, m.paramIsX, "raw"),
                      S = g.extractPathCoords(A, m.paramIsY, "raw");
                    s = 1 / 0, c = -1 / 0, u = 1 / 0, f = -1 / 0, d = [];
                    for (var C = 0; C < L.length; C++) {
                      var D = se(v, L[C]),
                        P = se(y, S[C]);
                      d.push([D, P]), s = Math.min(D, s), c = Math.max(D, c), u = Math.min(P, u), f = Math.max(P, f);
                    }
                    d.xmin = s, d.xmax = c, d.ymin = u, d.ymax = f, d.xref = h, d.yref = p, d.subtract = le(d, M), M.push(d), r.push(d);
                  }
                }
              }
            }
            return r;
          }
          function le(e, t) {
            for (var r = !1, n = 0; n < t.length; n++) for (var i = t[n], o = 0; o < e.length; o++) if (a(e[o], i)) {
              r = !r;
              break;
            }
            return r;
          }
          function se(e, t) {
            return "date" === e.type && (t = t.replace("_", " ")), "log" === e.type ? e.c2p(t) : e.r2p(t, null, e.calendar);
          }
          function ce(e) {
            for (var t = e.length, r = [], n = 0; n < t; n++) {
              var a = e[n];
              r = (r = r.concat(a)).concat([a[0]]);
            }
            return (i = r).isRect = 5 === i.length && i[0][0] === i[4][0] && i[0][1] === i[4][1] && i[0][0] === i[1][0] && i[2][0] === i[3][0] && i[0][1] === i[3][1] && i[1][1] === i[2][1] || i[0][1] === i[1][1] && i[2][1] === i[3][1] && i[0][0] === i[3][0] && i[1][0] === i[2][0], i.isRect && (i.xmin = Math.min(i[0][0], i[2][0]), i.xmax = Math.max(i[0][0], i[2][0]), i.ymin = Math.min(i[0][1], i[2][1]), i.ymax = Math.max(i[0][1], i[2][1])), i;
            var i;
          }
          function ue(e) {
            return function (t, r) {
              for (var n, a, i = 0; i < e.length; i++) {
                var o = e[i],
                  l = o._id,
                  s = l.charAt(0);
                if (r.isRect) {
                  n || (n = {});
                  var c = r[s + "min"],
                    u = r[s + "max"];
                  void 0 !== c && void 0 !== u && (n[l] = [F(o, c), F(o, u)].sort(L));
                } else a || (a = {}), a[l] = r.map(H(o));
              }
              n && (t.range = n), a && (t.lassoPoints = a);
            };
          }
          function fe(e, t) {
            t && (t.selections = (e.layout || {}).selections || []), e.emit("plotly_selected", t);
          }
          function de(e) {
            e.emit("plotly_deselect", null);
          }
          e.exports = {
            reselect: ne,
            prepSelect: function (e, t, r, n, a) {
              var c = !j(n),
                u = f(a),
                g = d(a),
                m = p(a),
                x = h(a),
                b = v(a),
                w = "drawcircle" === a,
                T = "drawline" === a || w,
                M = n.gd,
                k = M._fullLayout,
                L = b && "immediate" === k.newselection.mode && c,
                S = k._zoomlayer,
                O = n.element.getBoundingClientRect(),
                D = n.plotinfo,
                P = B(D),
                N = t - O.left,
                F = r - O.top;
              k._calcInverseTransform(M);
              var H = A.apply3DTransform(k._invTransform)(N, F);
              N = H[0], F = H[1];
              var V,
                U,
                W,
                X,
                K,
                ee,
                ie,
                oe = k._invScaleX,
                le = k._invScaleY,
                se = N,
                he = F,
                pe = "M" + N + "," + F,
                ve = n.xaxes[0],
                ge = n.yaxes[0],
                me = ve._length,
                ye = ge._length,
                xe = e.altKey && !(h(a) && m);
              G(e, M, n), u && (V = E([[N, F]], z.BENDPX));
              var be = S.selectAll("path.select-outline-" + D.id).data([1]),
                _e = x ? k.newshape : k.newselection;
              x && (n.hasText = _e.label.text || _e.label.texttemplate);
              var we = x && !m ? _e.fillcolor : "rgba(0,0,0,0)",
                Te = _e.line.color || (c ? l.contrast(M._fullLayout.plot_bgcolor) : "#7f7f7f");
              be.enter().append("path").attr("class", "select-outline select-outline-" + D.id).style({
                opacity: x ? _e.opacity / 2 : 1,
                "stroke-dasharray": o(_e.line.dash, _e.line.width),
                "stroke-width": _e.line.width + "px",
                "shape-rendering": "crispEdges"
              }).call(l.stroke, Te).call(l.fill, we).attr("fill-rule", "evenodd").classed("cursor-move", !!x).attr("transform", P).attr("d", pe + "Z");
              var Me = S.append("path").attr("class", "zoombox-corners").style({
                fill: l.background,
                stroke: l.defaultLine,
                "stroke-width": 1
              }).attr("transform", P).attr("d", "M0,0Z");
              if (x && n.hasText) {
                var ke = S.select(".label-temp");
                ke.empty() && (ke = S.append("g").classed("label-temp", !0).classed("select-outline", !0).style({
                  opacity: .8
                }));
              }
              var Ae = k._uid + z.SELECTID,
                Le = [],
                Se = J(M, n.xaxes, n.yaxes, n.subplot);
              L && !e.shiftKey && (n._clearSubplotSelections = function () {
                if (c) {
                  var e = ve._id,
                    t = ge._id;
                  ae(M, e, t, Se);
                  for (var r = (M.layout || {}).selections || [], n = [], a = !1, o = 0; o < r.length; o++) {
                    var l = k.selections[o];
                    l.xref !== e || l.yref !== t ? n.push(r[o]) : a = !0;
                  }
                  a && (M._fullLayout._noEmitSelectedAtStart = !0, i.call("_guiRelayout", M, {
                    selections: n
                  }));
                }
              });
              var Ce = function (e) {
                return e.plotinfo.fillRangeItems || ue(e.xaxes.concat(e.yaxes));
              }(n);
              n.moveFn = function (e, t) {
                n._clearSubplotSelections && (n._clearSubplotSelections(), n._clearSubplotSelections = void 0), se = Math.max(0, Math.min(me, oe * e + N)), he = Math.max(0, Math.min(ye, le * t + F));
                var r = Math.abs(se - N),
                  a = Math.abs(he - F);
                if (g) {
                  var i, o, l;
                  if (b) {
                    var s = k.selectdirection;
                    switch (i = "any" === s ? a < Math.min(.6 * r, I) ? "h" : r < Math.min(.6 * a, I) ? "v" : "d" : s) {
                      case "h":
                        o = w ? ye / 2 : 0, l = ye;
                        break;
                      case "v":
                        o = w ? me / 2 : 0, l = me;
                    }
                  }
                  if (x) switch (k.newshape.drawdirection) {
                    case "vertical":
                      i = "h", o = w ? ye / 2 : 0, l = ye;
                      break;
                    case "horizontal":
                      i = "v", o = w ? me / 2 : 0, l = me;
                      break;
                    case "ortho":
                      r < a ? (i = "h", o = F, l = he) : (i = "v", o = N, l = se);
                      break;
                    default:
                      i = "d";
                  }
                  "h" === i ? ((X = T ? _(w, [se, o], [se, l]) : [[N, o], [N, l], [se, l], [se, o]]).xmin = T ? se : Math.min(N, se), X.xmax = T ? se : Math.max(N, se), X.ymin = Math.min(o, l), X.ymax = Math.max(o, l), Me.attr("d", "M" + X.xmin + "," + (F - I) + "h-4v" + 2 * I + "h4ZM" + (X.xmax - 1) + "," + (F - I) + "h4v" + 2 * I + "h-4Z")) : "v" === i ? ((X = T ? _(w, [o, he], [l, he]) : [[o, F], [o, he], [l, he], [l, F]]).xmin = Math.min(o, l), X.xmax = Math.max(o, l), X.ymin = T ? he : Math.min(F, he), X.ymax = T ? he : Math.max(F, he), Me.attr("d", "M" + (N - I) + "," + X.ymin + "v-4h" + 2 * I + "v4ZM" + (N - I) + "," + (X.ymax - 1) + "v4h" + 2 * I + "v-4Z")) : "d" === i && ((X = T ? _(w, [N, F], [se, he]) : [[N, F], [N, he], [se, he], [se, F]]).xmin = Math.min(N, se), X.xmax = Math.max(N, se), X.ymin = Math.min(F, he), X.ymax = Math.max(F, he), Me.attr("d", "M0,0Z"));
                } else u && (V.addPt([se, he]), X = V.filtered);
                if (n.selectionDefs && n.selectionDefs.length ? (W = $(n.mergedPolygons, X, xe), X.subtract = xe, U = q(n.selectionDefs.concat([X]))) : (W = [X], U = R(X)), y(te(W, m), be, n), b) {
                  var c,
                    f = ne(M, !1),
                    d = f.eventData ? f.eventData.points.slice() : [];
                  f = ne(M, !1, U, Se, n), U = f.selectionTesters, ie = f.eventData, c = V ? V.filtered : ce(W), C.throttle(Ae, z.SELECTDELAY, function () {
                    for (var e = (Le = re(U, Se)).slice(), t = 0; t < d.length; t++) {
                      for (var r = d[t], n = !1, a = 0; a < e.length; a++) if (e[a].curveNumber === r.curveNumber && e[a].pointNumber === r.pointNumber) {
                        n = !0;
                        break;
                      }
                      n || e.push(r);
                    }
                    e.length && (ie || (ie = {}), ie.points = e), Ce(ie, c), function (e, t) {
                      e.emit("plotly_selecting", t);
                    }(M, ie);
                  });
                }
              }, n.clickFn = function (e, t) {
                if (Me.remove(), M._fullLayout._activeShapeIndex >= 0) M._fullLayout._deactivateShape(M);else if (!x) {
                  var r = k.clickmode;
                  C.done(Ae).then(function () {
                    if (C.clear(Ae), 2 === e) {
                      for (be.remove(), K = 0; K < Se.length; K++) (ee = Se[K])._module.selectPoints(ee, !1);
                      if (Q(M, Se), Z(n), de(M), Se.length) {
                        var a = Se[0].xaxis,
                          o = Se[0].yaxis;
                        if (a && o) {
                          for (var l = [], c = M._fullLayout.selections, u = 0; u < c.length; u++) {
                            var f = c[u];
                            f && (f.xref === a._id && f.yref === o._id || l.push(f));
                          }
                          l.length < c.length && (M._fullLayout._noEmitSelectedAtStart = !0, i.call("_guiRelayout", M, {
                            selections: l
                          }));
                        }
                      }
                    } else r.indexOf("select") > -1 && Y(t, M, n.xaxes, n.yaxes, n.subplot, n, be), "event" === r && fe(M, void 0);
                    s.click(M, t, D.id);
                  }).catch(A.error);
                }
              }, n.doneFn = function () {
                Me.remove(), C.done(Ae).then(function () {
                  C.clear(Ae), !L && X && n.selectionDefs && (X.subtract = xe, n.selectionDefs.push(X), n.mergedPolygons.length = 0, [].push.apply(n.mergedPolygons, W)), (L || x) && Z(n, L), n.doneFnCompleted && n.doneFnCompleted(Le), b && fe(M, ie);
                }).catch(A.error);
              };
            },
            clearOutline: x,
            clearSelectionsCache: Z,
            selectOnClick: Y
          };
        },
        3144: function (e, t, r) {
          "use strict";

          var n = r(222),
            a = r(337),
            i = r(6640).line,
            o = r(4850).T,
            l = r(3049).extendFlat,
            s = r(8032).templatedArray,
            c = (r(5081), r(9829)),
            u = r(3208).LF,
            f = r(1235);
          e.exports = s("shape", {
            visible: l({}, c.visible, {
              editType: "calc+arraydraw"
            }),
            showlegend: {
              valType: "boolean",
              dflt: !1,
              editType: "calc+arraydraw"
            },
            legend: l({}, c.legend, {
              editType: "calc+arraydraw"
            }),
            legendgroup: l({}, c.legendgroup, {
              editType: "calc+arraydraw"
            }),
            legendgrouptitle: {
              text: l({}, c.legendgrouptitle.text, {
                editType: "calc+arraydraw"
              }),
              font: a({
                editType: "calc+arraydraw"
              }),
              editType: "calc+arraydraw"
            },
            legendrank: l({}, c.legendrank, {
              editType: "calc+arraydraw"
            }),
            legendwidth: l({}, c.legendwidth, {
              editType: "calc+arraydraw"
            }),
            type: {
              valType: "enumerated",
              values: ["circle", "rect", "path", "line"],
              editType: "calc+arraydraw"
            },
            layer: {
              valType: "enumerated",
              values: ["below", "above", "between"],
              dflt: "above",
              editType: "arraydraw"
            },
            xref: l({}, n.xref, {}),
            xsizemode: {
              valType: "enumerated",
              values: ["scaled", "pixel"],
              dflt: "scaled",
              editType: "calc+arraydraw"
            },
            xanchor: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            x0: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            x1: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            x0shift: {
              valType: "number",
              dflt: 0,
              min: -1,
              max: 1,
              editType: "calc"
            },
            x1shift: {
              valType: "number",
              dflt: 0,
              min: -1,
              max: 1,
              editType: "calc"
            },
            yref: l({}, n.yref, {}),
            ysizemode: {
              valType: "enumerated",
              values: ["scaled", "pixel"],
              dflt: "scaled",
              editType: "calc+arraydraw"
            },
            yanchor: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            y0: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            y1: {
              valType: "any",
              editType: "calc+arraydraw"
            },
            y0shift: {
              valType: "number",
              dflt: 0,
              min: -1,
              max: 1,
              editType: "calc"
            },
            y1shift: {
              valType: "number",
              dflt: 0,
              min: -1,
              max: 1,
              editType: "calc"
            },
            path: {
              valType: "string",
              editType: "calc+arraydraw"
            },
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1,
              editType: "arraydraw"
            },
            line: {
              color: l({}, i.color, {
                editType: "arraydraw"
              }),
              width: l({}, i.width, {
                editType: "calc+arraydraw"
              }),
              dash: l({}, o, {
                editType: "arraydraw"
              }),
              editType: "calc+arraydraw"
            },
            fillcolor: {
              valType: "color",
              dflt: "rgba(0,0,0,0)",
              editType: "arraydraw"
            },
            fillrule: {
              valType: "enumerated",
              values: ["evenodd", "nonzero"],
              dflt: "evenodd",
              editType: "arraydraw"
            },
            editable: {
              valType: "boolean",
              dflt: !1,
              editType: "calc+arraydraw"
            },
            label: {
              text: {
                valType: "string",
                dflt: "",
                editType: "arraydraw"
              },
              texttemplate: u({}, {
                keys: Object.keys(f)
              }),
              font: a({
                editType: "calc+arraydraw",
                colorEditType: "arraydraw"
              }),
              textposition: {
                valType: "enumerated",
                values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right", "start", "middle", "end"],
                editType: "arraydraw"
              },
              textangle: {
                valType: "angle",
                dflt: "auto",
                editType: "calc+arraydraw"
              },
              xanchor: {
                valType: "enumerated",
                values: ["auto", "left", "center", "right"],
                dflt: "auto",
                editType: "calc+arraydraw"
              },
              yanchor: {
                valType: "enumerated",
                values: ["top", "middle", "bottom"],
                editType: "calc+arraydraw"
              },
              padding: {
                valType: "number",
                dflt: 3,
                min: 0,
                editType: "arraydraw"
              },
              editType: "arraydraw"
            },
            editType: "arraydraw"
          });
        },
        4959: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714),
            i = r(2956),
            o = r(9728);
          function l(e) {
            return c(e.line.width, e.xsizemode, e.x0, e.x1, e.path, !1);
          }
          function s(e) {
            return c(e.line.width, e.ysizemode, e.y0, e.y1, e.path, !0);
          }
          function c(e, t, r, a, l, s) {
            var c = e / 2,
              u = s;
            if ("pixel" === t) {
              var f = l ? o.extractPathCoords(l, s ? i.paramIsY : i.paramIsX) : [r, a],
                d = n.aggNums(Math.max, null, f),
                h = n.aggNums(Math.min, null, f),
                p = h < 0 ? Math.abs(h) + c : c,
                v = d > 0 ? d + c : c;
              return {
                ppad: c,
                ppadplus: u ? p : v,
                ppadminus: u ? v : p
              };
            }
            return {
              ppad: c
            };
          }
          function u(e, t, r) {
            var n,
              a,
              l = "x" === e._id.charAt(0) ? "x" : "y",
              s = "category" === e.type || "multicategory" === e.type,
              c = 0,
              u = 0,
              f = s ? e.r2c : e.d2c;
            if ("scaled" === t[l + "sizemode"] ? (n = t[l + "0"], a = t[l + "1"], s && (c = t[l + "0shift"], u = t[l + "1shift"])) : (n = t[l + "anchor"], a = t[l + "anchor"]), void 0 !== n) return [f(n) + c, f(a) + u];
            if (t.path) {
              var d,
                h,
                p,
                v,
                g = 1 / 0,
                m = -1 / 0,
                y = t.path.match(i.segmentRE);
              for ("date" === e.type && (f = o.decodeDate(f)), d = 0; d < y.length; d++) void 0 !== (h = r[y[d].charAt(0)].drawn) && (!(p = y[d].substr(1).match(i.paramRE)) || p.length < h || ((v = f(p[h])) < g && (g = v), v > m && (m = v)));
              return m >= g ? [g, m] : void 0;
            }
          }
          e.exports = function (e) {
            var t = e._fullLayout,
              r = n.filterVisible(t.shapes);
            if (r.length && e._fullData.length) for (var o = 0; o < r.length; o++) {
              var c,
                f,
                d = r[o];
              d._extremes = {};
              var h = a.getRefType(d.xref),
                p = a.getRefType(d.yref);
              "paper" !== d.xref && "domain" !== h && (f = u(c = a.getFromId(e, d.xref), d, i.paramIsX)) && (d._extremes[c._id] = a.findExtremes(c, f, l(d))), "paper" !== d.yref && "domain" !== p && (f = u(c = a.getFromId(e, d.yref), d, i.paramIsY)) && (d._extremes[c._id] = a.findExtremes(c, f, s(d)));
            }
          };
        },
        2956: function (e) {
          "use strict";

          e.exports = {
            segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
            paramRE: /[^\s,]+/g,
            paramIsX: {
              M: {
                0: !0,
                drawn: 0
              },
              L: {
                0: !0,
                drawn: 0
              },
              H: {
                0: !0,
                drawn: 0
              },
              V: {},
              Q: {
                0: !0,
                2: !0,
                drawn: 2
              },
              C: {
                0: !0,
                2: !0,
                4: !0,
                drawn: 4
              },
              T: {
                0: !0,
                drawn: 0
              },
              S: {
                0: !0,
                2: !0,
                drawn: 2
              },
              Z: {}
            },
            paramIsY: {
              M: {
                1: !0,
                drawn: 1
              },
              L: {
                1: !0,
                drawn: 1
              },
              H: {},
              V: {
                0: !0,
                drawn: 0
              },
              Q: {
                1: !0,
                3: !0,
                drawn: 3
              },
              C: {
                1: !0,
                3: !0,
                5: !0,
                drawn: 5
              },
              T: {
                1: !0,
                drawn: 1
              },
              S: {
                1: !0,
                3: !0,
                drawn: 5
              },
              Z: {}
            },
            numParams: {
              M: 2,
              L: 2,
              H: 1,
              V: 1,
              Q: 4,
              C: 6,
              T: 2,
              S: 4,
              Z: 0
            }
          };
        },
        4367: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714),
            i = r(9008),
            o = r(3144),
            l = r(9728);
          function s(e, t, r) {
            function i(r, a) {
              return n.coerce(e, t, o, r, a);
            }
            if (t._isShape = !0, i("visible")) {
              i("showlegend") && (i("legend"), i("legendwidth"), i("legendgroup"), i("legendgrouptitle.text"), n.coerceFont(i, "legendgrouptitle.font"), i("legendrank"));
              var s = i("path"),
                c = i("type", s ? "path" : "rect"),
                u = "path" !== c;
              u && delete t.path, i("editable"), i("layer"), i("opacity"), i("fillcolor"), i("fillrule"), i("line.width") && (i("line.color"), i("line.dash"));
              for (var f = i("xsizemode"), d = i("ysizemode"), h = ["x", "y"], p = 0; p < 2; p++) {
                var v,
                  g,
                  m,
                  y = h[p],
                  x = y + "anchor",
                  b = "x" === y ? f : d,
                  _ = {
                    _fullLayout: r
                  },
                  w = a.coerceRef(e, t, _, y, void 0, "paper");
                if ("range" === a.getRefType(w) ? ((v = a.getFromId(_, w))._shapeIndices.push(t._index), m = l.rangeToShapePosition(v), g = l.shapePositionToRange(v), "category" !== v.type && "multicategory" !== v.type || (i(y + "0shift"), i(y + "1shift"))) : g = m = n.identity, u) {
                  var T = y + "0",
                    M = y + "1",
                    k = e[T],
                    A = e[M];
                  e[T] = g(e[T], !0), e[M] = g(e[M], !0), "pixel" === b ? (i(T, 0), i(M, 10)) : (a.coercePosition(t, _, i, w, T, .25), a.coercePosition(t, _, i, w, M, .75)), t[T] = m(t[T]), t[M] = m(t[M]), e[T] = k, e[M] = A;
                }
                if ("pixel" === b) {
                  var L = e[x];
                  e[x] = g(e[x], !0), a.coercePosition(t, _, i, w, x, .25), t[x] = m(t[x]), e[x] = L;
                }
              }
              u && n.noneOrAll(e, t, ["x0", "x1", "y0", "y1"]);
              var S,
                C,
                O = "line" === c;
              if (u && (S = i("label.texttemplate")), S || (C = i("label.text")), C || S) {
                i("label.textangle");
                var D = i("label.textposition", O ? "middle" : "middle center");
                i("label.xanchor"), i("label.yanchor", function (e, t) {
                  return e ? "bottom" : -1 !== t.indexOf("top") ? "top" : -1 !== t.indexOf("bottom") ? "bottom" : "middle";
                }(O, D)), i("label.padding"), n.coerceFont(i, "label.font", r.font);
              }
            }
          }
          e.exports = function (e, t) {
            i(e, t, {
              name: "shapes",
              handleItemDefaults: s
            });
          };
        },
        4433: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714),
            i = r(635),
            o = r(2203),
            l = r(1055).readPaths,
            s = r(9728),
            c = s.getPathString,
            u = r(1235),
            f = r(4530).FROM_TL;
          e.exports = function (e, t, r, d) {
            if (d.selectAll(".shape-label").remove(), r.label.text || r.label.texttemplate) {
              var h;
              if (r.label.texttemplate) {
                var p = {};
                if ("path" !== r.type) {
                  var v = a.getFromId(e, r.xref),
                    g = a.getFromId(e, r.yref);
                  for (var m in u) {
                    var y = u[m](r, v, g);
                    void 0 !== y && (p[m] = y);
                  }
                }
                h = n.texttemplateStringForShapes(r.label.texttemplate, {}, e._fullLayout._d3locale, p);
              } else h = r.label.text;
              var x,
                b,
                _,
                w,
                T = {
                  "data-index": t
                },
                M = r.label.font,
                k = d.append("g").attr(T).classed("shape-label", !0).append("text").attr({
                  "data-notex": 1
                }).classed("shape-label-text", !0).text(h);
              if (r.path) {
                var A = c(e, r),
                  L = l(A, e);
                x = 1 / 0, _ = 1 / 0, b = -1 / 0, w = -1 / 0;
                for (var S = 0; S < L.length; S++) for (var C = 0; C < L[S].length; C++) for (var O = L[S][C], D = 1; D < O.length; D += 2) {
                  var P = O[D],
                    z = O[D + 1];
                  x = Math.min(x, P), b = Math.max(b, P), _ = Math.min(_, z), w = Math.max(w, z);
                }
              } else {
                var I = a.getFromId(e, r.xref),
                  E = r.x0shift,
                  R = r.x1shift,
                  N = a.getRefType(r.xref),
                  F = a.getFromId(e, r.yref),
                  H = r.y0shift,
                  B = r.y1shift,
                  j = a.getRefType(r.yref),
                  Y = function (t, r) {
                    return s.getDataToPixel(e, I, r, !1, N)(t);
                  },
                  V = function (t, r) {
                    return s.getDataToPixel(e, F, r, !0, j)(t);
                  };
                x = Y(r.x0, E), b = Y(r.x1, R), _ = V(r.y0, H), w = V(r.y1, B);
              }
              var U = r.label.textangle;
              "auto" === U && (U = "line" === r.type ? function (e, t, r, n) {
                var a, i;
                return i = Math.abs(r - e), a = r >= e ? t - n : n - t, -180 / Math.PI * Math.atan2(a, i);
              }(x, _, b, w) : 0), k.call(function (t) {
                return t.call(o.font, M).attr({}), i.convertToTspans(t, e), t;
              });
              var q = function (e, t, r, n, a, i, o) {
                  var l,
                    s,
                    c,
                    u,
                    d = a.label.textposition,
                    h = a.label.textangle,
                    p = a.label.padding,
                    v = a.type,
                    g = Math.PI / 180 * i,
                    m = Math.sin(g),
                    y = Math.cos(g),
                    x = a.label.xanchor,
                    b = a.label.yanchor;
                  if ("line" === v) {
                    "start" === d ? (l = e, s = t) : "end" === d ? (l = r, s = n) : (l = (e + r) / 2, s = (t + n) / 2), "auto" === x && (x = "start" === d ? "auto" === h ? r > e ? "left" : r < e ? "right" : "center" : r > e ? "right" : r < e ? "left" : "center" : "end" === d ? "auto" === h ? r > e ? "right" : r < e ? "left" : "center" : r > e ? "left" : r < e ? "right" : "center" : "center");
                    var _ = {
                      bottom: -1,
                      middle: 0,
                      top: 1
                    };
                    if ("auto" === h) {
                      var w = _[b];
                      c = -p * m * w, u = p * y * w;
                    } else c = p * {
                      left: 1,
                      center: 0,
                      right: -1
                    }[x], u = p * _[b];
                    l += c, s += u;
                  } else c = p + 3, -1 !== d.indexOf("right") ? (l = Math.max(e, r) - c, "auto" === x && (x = "right")) : -1 !== d.indexOf("left") ? (l = Math.min(e, r) + c, "auto" === x && (x = "left")) : (l = (e + r) / 2, "auto" === x && (x = "center")), s = -1 !== d.indexOf("top") ? Math.min(t, n) : -1 !== d.indexOf("bottom") ? Math.max(t, n) : (t + n) / 2, u = p, "bottom" === b ? s -= u : "top" === b && (s += u);
                  var T = f[b],
                    M = a.label.font.size,
                    k = o.height;
                  return {
                    textx: l + (k * T - M) * m,
                    texty: s + -(k * T - M) * y,
                    xanchor: x
                  };
                }(x, _, b, w, r, U, o.bBox(k.node())),
                G = q.textx,
                Z = q.texty,
                W = q.xanchor;
              k.attr({
                "text-anchor": {
                  left: "start",
                  center: "middle",
                  right: "end"
                }[W],
                y: Z,
                x: G,
                transform: "rotate(" + U + "," + G + "," + Z + ")"
              }).call(i.positionText, G, Z);
            }
          };
        },
        561: function (e, t, r) {
          "use strict";

          var n = r(4809).strTranslate,
            a = r(4751),
            i = r(414),
            o = i.drawMode,
            l = i.selectMode,
            s = r(3626),
            c = r(8766),
            u = r(3391),
            f = u.i000,
            d = u.i090,
            h = u.i180,
            p = u.i270,
            v = r(8534).clearOutlineControllers,
            g = r(1055),
            m = g.pointsOnRectangle,
            y = g.pointsOnEllipse,
            x = g.writePaths,
            b = r(7562).newShapes,
            _ = r(7562).createShapeObj,
            w = r(4198),
            T = r(4433);
          function M(e, t) {
            var r,
              n,
              a,
              i = e[t][1],
              o = e[t][2],
              l = e.length;
            return n = e[r = (t + 1) % l][1], a = e[r][2], n === i && a === o && (n = e[r = (t + 2) % l][1], a = e[r][2]), [r, n, a];
          }
          e.exports = function e(t, r, i, u) {
            u || (u = 0);
            var g = i.gd;
            function k() {
              e(t, r, i, u++), (y(t[0]) || i.hasText) && A({
                redrawing: !0
              });
            }
            function A(e) {
              var t = {};
              void 0 !== i.isActiveShape && (i.isActiveShape = !1, t = b(r, i)), void 0 !== i.isActiveSelection && (i.isActiveSelection = !1, t = w(r, i), g._fullLayout._reselect = !0), Object.keys(t).length && s.call((e || {}).redrawing ? "relayout" : "_guiRelayout", g, t);
            }
            var L,
              S,
              C,
              O,
              D,
              P = g._fullLayout._zoomlayer,
              z = i.dragmode,
              I = o(z),
              E = l(z);
            if ((I || E) && (g._fullLayout._outlining = !0), v(g), r.attr("d", x(t)), u || !i.isActiveShape && !i.isActiveSelection || (D = function (e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                e[r] = [];
                for (var a = 0; a < n.length; a++) {
                  e[r][a] = [];
                  for (var i = 0; i < n[a].length; i++) e[r][a][i] = n[a][i];
                }
              }
              return e;
            }([], t), function (e) {
              L = [];
              for (var r = 0; r < t.length; r++) {
                var o = t[r],
                  l = m(o),
                  s = !l && y(o);
                L[r] = [];
                for (var u = o.length, v = 0; v < u; v++) if ("Z" !== o[v][0] && (!s || v === f || v === d || v === h || v === p)) {
                  var x,
                    b = l && i.isActiveSelection;
                  b && (x = M(o, v));
                  var _ = o[v][1],
                    w = o[v][2],
                    T = e.append(b ? "rect" : "circle").attr("data-i", r).attr("data-j", v).style({
                      fill: c.background,
                      stroke: c.defaultLine,
                      "stroke-width": 1,
                      "shape-rendering": "crispEdges"
                    });
                  if (b) {
                    var k = x[1] - _,
                      A = x[2] - w,
                      S = A ? 5 : Math.max(Math.min(25, Math.abs(k) - 5), 5),
                      C = k ? 5 : Math.max(Math.min(25, Math.abs(A) - 5), 5);
                    T.classed(A ? "cursor-ew-resize" : "cursor-ns-resize", !0).attr("width", S).attr("height", C).attr("x", _ - S / 2).attr("y", w - C / 2).attr("transform", n(k / 2, A / 2));
                  } else T.classed("cursor-grab", !0).attr("r", 5).attr("cx", _).attr("cy", w);
                  L[r][v] = {
                    element: T.node(),
                    gd: g,
                    prepFn: F,
                    doneFn: B,
                    clickFn: j
                  }, a.init(L[r][v]);
                }
              }
            }(P.append("g").attr("class", "outline-controllers")), function () {
              if (S = [], t.length) {
                S[0] = {
                  element: r[0][0],
                  gd: g,
                  prepFn: V,
                  doneFn: U,
                  clickFn: q
                }, a.init(S[0]);
              }
            }()), I && i.hasText) {
              var R = P.select(".label-temp"),
                N = _(r, i, i.dragmode);
              T(g, "label-temp", N, R);
            }
            function F(e) {
              C = +e.srcElement.getAttribute("data-i"), O = +e.srcElement.getAttribute("data-j"), L[C][O].moveFn = H;
            }
            function H(e, r) {
              if (t.length) {
                var n = D[C][O][1],
                  a = D[C][O][2],
                  o = t[C],
                  l = o.length;
                if (m(o)) {
                  var s = e,
                    c = r;
                  i.isActiveSelection && (M(o, O)[1] === o[O][1] ? c = 0 : s = 0);
                  for (var u = 0; u < l; u++) if (u !== O) {
                    var f = o[u];
                    f[1] === o[O][1] && (f[1] = n + s), f[2] === o[O][2] && (f[2] = a + c);
                  }
                  if (o[O][1] = n + s, o[O][2] = a + c, !m(o)) for (var d = 0; d < l; d++) for (var h = 0; h < o[d].length; h++) o[d][h] = D[C][d][h];
                } else o[O][1] = n + e, o[O][2] = a + r;
                k();
              }
            }
            function B() {
              A();
            }
            function j(e, r) {
              if (2 === e) {
                C = +r.srcElement.getAttribute("data-i"), O = +r.srcElement.getAttribute("data-j");
                var n = t[C];
                m(n) || y(n) || function () {
                  if (t.length && t[C] && t[C].length) {
                    for (var e = [], r = 0; r < t[C].length; r++) r !== O && e.push(t[C][r]);
                    e.length > 1 && (2 !== e.length || "Z" !== e[1][0]) && (0 === O && (e[0][0] = "M"), t[C] = e, k(), A());
                  }
                }();
              }
            }
            function Y(e, r) {
              !function (e, r) {
                if (t.length) for (var n = 0; n < t.length; n++) for (var a = 0; a < t[n].length; a++) for (var i = 0; i + 2 < t[n][a].length; i += 2) t[n][a][i + 1] = D[n][a][i + 1] + e, t[n][a][i + 2] = D[n][a][i + 2] + r;
              }(e, r), k();
            }
            function V(e) {
              (C = +e.srcElement.getAttribute("data-i")) || (C = 0), S[C].moveFn = Y;
            }
            function U() {
              A();
            }
            function q(e) {
              2 === e && function (e) {
                if (l(e._fullLayout.dragmode)) {
                  v(e);
                  var t = e._fullLayout._activeSelectionIndex,
                    r = (e.layout || {}).selections || [];
                  if (t < r.length) {
                    for (var n = [], a = 0; a < r.length; a++) a !== t && n.push(r[a]);
                    delete e._fullLayout._activeSelectionIndex;
                    var i = e._fullLayout.selections[t];
                    e._fullLayout._deselect = {
                      xref: i.xref,
                      yref: i.yref
                    }, s.call("_guiRelayout", e, {
                      selections: n
                    });
                  }
                }
              }(g);
            }
          };
        },
        8231: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(3626),
            i = r(4809),
            o = r(9714),
            l = r(1055).readPaths,
            s = r(561),
            c = r(4433),
            u = r(8534).clearOutlineControllers,
            f = r(8766),
            d = r(2203),
            h = r(8032).arrayEditor,
            p = r(4751),
            v = r(7983),
            g = r(2956),
            m = r(9728),
            y = m.getPathString;
          function x(e) {
            var t = e._fullLayout;
            for (var r in t._shapeUpperLayer.selectAll("path").remove(), t._shapeLowerLayer.selectAll("path").remove(), t._shapeUpperLayer.selectAll("text").remove(), t._shapeLowerLayer.selectAll("text").remove(), t._plots) {
              var n = t._plots[r].shapelayer;
              n && (n.selectAll("path").remove(), n.selectAll("text").remove());
            }
            for (var a = 0; a < t.shapes.length; a++) !0 === t.shapes[a].visible && w(e, a);
          }
          function b(e) {
            return !!e._fullLayout._outlining;
          }
          function _(e) {
            return !e._context.edits.shapePosition;
          }
          function w(e, t) {
            e._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + t + '"]').remove();
            var r = m.makeShapesOptionsAndPlotinfo(e, t),
              u = r.options,
              w = r.plotinfo;
            function A(r) {
              var A = y(e, u),
                L = {
                  "data-index": t,
                  "fill-rule": u.fillrule,
                  d: A
                },
                S = u.opacity,
                C = u.fillcolor,
                O = u.line.width ? u.line.color : "rgba(0,0,0,0)",
                D = u.line.width,
                P = u.line.dash;
              D || !0 !== u.editable || (D = 5, P = "solid");
              var z = "Z" !== A[A.length - 1],
                I = _(e) && u.editable && e._fullLayout._activeShapeIndex === t;
              I && (C = z ? "rgba(0,0,0,0)" : e._fullLayout.activeshape.fillcolor, S = e._fullLayout.activeshape.opacity);
              var E,
                R = r.append("g").classed("shape-group", !0).attr({
                  "data-index": t
                }),
                N = R.append("path").attr(L).style("opacity", S).call(f.stroke, O).call(f.fill, C).call(d.dashLine, P, D);
              if (T(R, e, u), c(e, t, u, R), (I || e._context.edits.shapePosition) && (E = h(e.layout, "shapes", u)), I) {
                N.style({
                  cursor: "move"
                });
                var F = {
                    element: N.node(),
                    plotinfo: w,
                    gd: e,
                    editHelpers: E,
                    hasText: u.label.text || u.label.texttemplate,
                    isActiveShape: !0
                  },
                  H = l(A, e);
                s(H, N, F);
              } else e._context.edits.shapePosition ? function (e, t, r, l, s, u) {
                var f,
                  h,
                  x,
                  _,
                  w,
                  k,
                  A,
                  L,
                  S,
                  C,
                  O,
                  D,
                  P,
                  z,
                  I,
                  E,
                  R = 10,
                  N = 10,
                  F = "pixel" === r.xsizemode,
                  H = "pixel" === r.ysizemode,
                  B = "line" === r.type,
                  j = "path" === r.type,
                  Y = u.modifyItem,
                  V = n.select(t.node().parentNode),
                  U = o.getFromId(e, r.xref),
                  q = o.getRefType(r.xref),
                  G = o.getFromId(e, r.yref),
                  Z = o.getRefType(r.yref),
                  W = r.x0shift,
                  J = r.x1shift,
                  X = r.y0shift,
                  K = r.y1shift,
                  Q = function (t, r) {
                    return m.getDataToPixel(e, U, r, !1, q)(t);
                  },
                  $ = function (t, r) {
                    return m.getDataToPixel(e, G, r, !0, Z)(t);
                  },
                  ee = m.getPixelToData(e, U, !1, q),
                  te = m.getPixelToData(e, G, !0, Z),
                  re = B ? function () {
                    var e = 10,
                      n = Math.max(r.line.width, e),
                      a = s.append("g").attr("data-index", l).attr("drag-helper", !0);
                    a.append("path").attr("d", t.attr("d")).style({
                      cursor: "move",
                      "stroke-width": n,
                      "stroke-opacity": "0"
                    });
                    var i = {
                        "fill-opacity": "0"
                      },
                      o = Math.max(n / 2, e);
                    return a.append("circle").attr({
                      "data-line-point": "start-point",
                      cx: F ? Q(r.xanchor) + r.x0 : Q(r.x0, W),
                      cy: H ? $(r.yanchor) - r.y0 : $(r.y0, X),
                      r: o
                    }).style(i).classed("cursor-grab", !0), a.append("circle").attr({
                      "data-line-point": "end-point",
                      cx: F ? Q(r.xanchor) + r.x1 : Q(r.x1, J),
                      cy: H ? $(r.yanchor) - r.y1 : $(r.y1, K),
                      r: o
                    }).style(i).classed("cursor-grab", !0), a;
                  }() : t,
                  ne = {
                    element: re.node(),
                    gd: e,
                    prepFn: function (n) {
                      b(e) || (F && (w = Q(r.xanchor)), H && (k = $(r.yanchor)), "path" === r.type ? I = r.path : (f = F ? r.x0 : Q(r.x0), h = H ? r.y0 : $(r.y0), x = F ? r.x1 : Q(r.x1), _ = H ? r.y1 : $(r.y1)), f < x ? (S = f, P = "x0", C = x, z = "x1") : (S = x, P = "x1", C = f, z = "x0"), !H && h < _ || H && h > _ ? (A = h, O = "y0", L = _, D = "y1") : (A = _, O = "y1", L = h, D = "y0"), ae(n), le(s, r), function (e, t, r) {
                        var n = t.xref,
                          a = t.yref,
                          i = o.getFromId(r, n),
                          l = o.getFromId(r, a),
                          s = "";
                        "paper" === n || i.autorange || (s += n), "paper" === a || l.autorange || (s += a), d.setClipUrl(e, s ? "clip" + r._fullLayout._uid + s : null, r);
                      }(t, r, e), ne.moveFn = "move" === E ? ie : oe, ne.altKey = n.altKey);
                    },
                    doneFn: function () {
                      b(e) || (v(t), se(s), T(t, e, r), a.call("_guiRelayout", e, u.getUpdateObj()));
                    },
                    clickFn: function () {
                      b(e) || se(s);
                    }
                  };
                function ae(r) {
                  if (b(e)) E = null;else if (B) E = "path" === r.target.tagName ? "move" : "start-point" === r.target.attributes["data-line-point"].value ? "resize-over-start-point" : "resize-over-end-point";else {
                    var n = ne.element.getBoundingClientRect(),
                      a = n.right - n.left,
                      i = n.bottom - n.top,
                      o = r.clientX - n.left,
                      l = r.clientY - n.top,
                      s = !j && a > R && i > N && !r.shiftKey ? p.getCursor(o / a, 1 - l / i) : "move";
                    v(t, s), E = s.split("-")[0];
                  }
                }
                function ie(n, a) {
                  if ("path" === r.type) {
                    var i = function (e) {
                        return e;
                      },
                      o = i,
                      u = i;
                    F ? Y("xanchor", r.xanchor = ee(w + n)) : (o = function (e) {
                      return ee(Q(e) + n);
                    }, U && "date" === U.type && (o = m.encodeDate(o))), H ? Y("yanchor", r.yanchor = te(k + a)) : (u = function (e) {
                      return te($(e) + a);
                    }, G && "date" === G.type && (u = m.encodeDate(u))), Y("path", r.path = M(I, o, u));
                  } else F ? Y("xanchor", r.xanchor = ee(w + n)) : (Y("x0", r.x0 = ee(f + n)), Y("x1", r.x1 = ee(x + n))), H ? Y("yanchor", r.yanchor = te(k + a)) : (Y("y0", r.y0 = te(h + a)), Y("y1", r.y1 = te(_ + a)));
                  t.attr("d", y(e, r)), le(s, r), c(e, l, r, V);
                }
                function oe(n, a) {
                  if (j) {
                    var i = function (e) {
                        return e;
                      },
                      o = i,
                      u = i;
                    F ? Y("xanchor", r.xanchor = ee(w + n)) : (o = function (e) {
                      return ee(Q(e) + n);
                    }, U && "date" === U.type && (o = m.encodeDate(o))), H ? Y("yanchor", r.yanchor = te(k + a)) : (u = function (e) {
                      return te($(e) + a);
                    }, G && "date" === G.type && (u = m.encodeDate(u))), Y("path", r.path = M(I, o, u));
                  } else if (B) {
                    if ("resize-over-start-point" === E) {
                      var d = f + n,
                        p = H ? h - a : h + a;
                      Y("x0", r.x0 = F ? d : ee(d)), Y("y0", r.y0 = H ? p : te(p));
                    } else if ("resize-over-end-point" === E) {
                      var v = x + n,
                        g = H ? _ - a : _ + a;
                      Y("x1", r.x1 = F ? v : ee(v)), Y("y1", r.y1 = H ? g : te(g));
                    }
                  } else {
                    var b = function (e) {
                        return -1 !== E.indexOf(e);
                      },
                      T = b("n"),
                      q = b("s"),
                      Z = b("w"),
                      W = b("e"),
                      J = T ? A + a : A,
                      X = q ? L + a : L,
                      K = Z ? S + n : S,
                      re = W ? C + n : C;
                    H && (T && (J = A - a), q && (X = L - a)), (!H && X - J > N || H && J - X > N) && (Y(O, r[O] = H ? J : te(J)), Y(D, r[D] = H ? X : te(X))), re - K > R && (Y(P, r[P] = F ? K : ee(K)), Y(z, r[z] = F ? re : ee(re)));
                  }
                  t.attr("d", y(e, r)), le(s, r), c(e, l, r, V);
                }
                function le(e, t) {
                  (F || H) && function () {
                    var r = "path" !== t.type,
                      n = e.selectAll(".visual-cue").data([0]);
                    n.enter().append("path").attr({
                      fill: "#fff",
                      "fill-rule": "evenodd",
                      stroke: "#000",
                      "stroke-width": 1
                    }).classed("visual-cue", !0);
                    var a = Q(F ? t.xanchor : i.midRange(r ? [t.x0, t.x1] : m.extractPathCoords(t.path, g.paramIsX))),
                      o = $(H ? t.yanchor : i.midRange(r ? [t.y0, t.y1] : m.extractPathCoords(t.path, g.paramIsY)));
                    if (a = m.roundPositionForSharpStrokeRendering(a, 1), o = m.roundPositionForSharpStrokeRendering(o, 1), F && H) {
                      var l = "M" + (a - 1 - 1) + "," + (o - 1 - 1) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
                      n.attr("d", l);
                    } else if (F) {
                      var s = "M" + (a - 1 - 1) + "," + (o - 9 - 1) + "v18 h2 v-18 Z";
                      n.attr("d", s);
                    } else {
                      var c = "M" + (a - 9 - 1) + "," + (o - 1 - 1) + "h18 v2 h-18 Z";
                      n.attr("d", c);
                    }
                  }();
                }
                function se(e) {
                  e.selectAll(".visual-cue").remove();
                }
                p.init(ne), re.node().onmousemove = ae;
              }(e, N, u, t, r, E) : !0 === u.editable && N.style("pointer-events", z || f.opacity(C) * S <= .5 ? "stroke" : "all");
              N.node().addEventListener("click", function () {
                return function (e, t) {
                  if (_(e)) {
                    var r = +t.node().getAttribute("data-index");
                    if (r >= 0) {
                      if (r === e._fullLayout._activeShapeIndex) return void k(e);
                      e._fullLayout._activeShapeIndex = r, e._fullLayout._deactivateShape = k, x(e);
                    }
                  }
                }(e, N);
              });
            }
            u._input && !0 === u.visible && ("above" === u.layer ? A(e._fullLayout._shapeUpperLayer) : "paper" === u.xref || "paper" === u.yref ? A(e._fullLayout._shapeLowerLayer) : "between" === u.layer ? A(w.shapelayerBetween) : w._hadPlotinfo ? A((w.mainplotinfo || w).shapelayer) : A(e._fullLayout._shapeLowerLayer));
          }
          function T(e, t, r) {
            var n = (r.xref + r.yref).replace(/paper/g, "").replace(/[xyz][1-9]* *domain/g, "");
            d.setClipUrl(e, n ? "clip" + t._fullLayout._uid + n : null, t);
          }
          function M(e, t, r) {
            return e.replace(g.segmentRE, function (e) {
              var n = 0,
                a = e.charAt(0),
                i = g.paramIsX[a],
                o = g.paramIsY[a],
                l = g.numParams[a];
              return a + e.substr(1).replace(g.paramRE, function (e) {
                return n >= l || (i[n] ? e = t(e) : o[n] && (e = r(e)), n++), e;
              });
            });
          }
          function k(e) {
            _(e) && e._fullLayout._activeShapeIndex >= 0 && (u(e), delete e._fullLayout._activeShapeIndex, x(e));
          }
          e.exports = {
            draw: x,
            drawOne: w,
            eraseActiveShape: function (e) {
              if (_(e)) {
                u(e);
                var t = e._fullLayout._activeShapeIndex,
                  r = (e.layout || {}).shapes || [];
                if (t < r.length) {
                  for (var n = [], i = 0; i < r.length; i++) i !== t && n.push(r[i]);
                  return delete e._fullLayout._activeShapeIndex, a.call("_guiRelayout", e, {
                    shapes: n
                  });
                }
              }
            },
            drawLabel: c
          };
        },
        4101: function (e, t, r) {
          "use strict";

          var n = r(3582).overrideAll,
            a = r(9829),
            i = r(337),
            o = r(4850).T,
            l = r(3049).extendFlat,
            s = r(3208).LF,
            c = r(1235);
          e.exports = n({
            newshape: {
              visible: l({}, a.visible, {}),
              showlegend: {
                valType: "boolean",
                dflt: !1
              },
              legend: l({}, a.legend, {}),
              legendgroup: l({}, a.legendgroup, {}),
              legendgrouptitle: {
                text: l({}, a.legendgrouptitle.text, {}),
                font: i({})
              },
              legendrank: l({}, a.legendrank, {}),
              legendwidth: l({}, a.legendwidth, {}),
              line: {
                color: {
                  valType: "color"
                },
                width: {
                  valType: "number",
                  min: 0,
                  dflt: 4
                },
                dash: l({}, o, {
                  dflt: "solid"
                })
              },
              fillcolor: {
                valType: "color",
                dflt: "rgba(0,0,0,0)"
              },
              fillrule: {
                valType: "enumerated",
                values: ["evenodd", "nonzero"],
                dflt: "evenodd"
              },
              opacity: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: 1
              },
              layer: {
                valType: "enumerated",
                values: ["below", "above", "between"],
                dflt: "above"
              },
              drawdirection: {
                valType: "enumerated",
                values: ["ortho", "horizontal", "vertical", "diagonal"],
                dflt: "diagonal"
              },
              name: l({}, a.name, {}),
              label: {
                text: {
                  valType: "string",
                  dflt: ""
                },
                texttemplate: s({
                  newshape: !0
                }, {
                  keys: Object.keys(c)
                }),
                font: i({}),
                textposition: {
                  valType: "enumerated",
                  values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right", "start", "middle", "end"]
                },
                textangle: {
                  valType: "angle",
                  dflt: "auto"
                },
                xanchor: {
                  valType: "enumerated",
                  values: ["auto", "left", "center", "right"],
                  dflt: "auto"
                },
                yanchor: {
                  valType: "enumerated",
                  values: ["top", "middle", "bottom"]
                },
                padding: {
                  valType: "number",
                  dflt: 3,
                  min: 0
                }
              }
            },
            activeshape: {
              fillcolor: {
                valType: "color",
                dflt: "rgb(255,0,255)"
              },
              opacity: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: .5
              }
            }
          }, "none", "from-root");
        },
        3391: function (e) {
          "use strict";

          e.exports = {
            CIRCLE_SIDES: 32,
            i000: 0,
            i090: 8,
            i180: 16,
            i270: 24,
            cos45: Math.cos(Math.PI / 4),
            sin45: Math.sin(Math.PI / 4),
            SQRT2: Math.sqrt(2)
          };
        },
        5522: function (e, t, r) {
          "use strict";

          var n = r(8766),
            a = r(4809);
          e.exports = function (e, t, r) {
            if (r("newshape.visible"), r("newshape.name"), r("newshape.showlegend"), r("newshape.legend"), r("newshape.legendwidth"), r("newshape.legendgroup"), r("newshape.legendgrouptitle.text"), a.coerceFont(r, "newshape.legendgrouptitle.font"), r("newshape.legendrank"), r("newshape.drawdirection"), r("newshape.layer"), r("newshape.fillcolor"), r("newshape.fillrule"), r("newshape.opacity"), r("newshape.line.width")) {
              var i = (e || {}).plot_bgcolor || "#FFF";
              r("newshape.line.color", n.contrast(i)), r("newshape.line.dash");
            }
            var o = "drawline" === e.dragmode,
              l = r("newshape.label.text"),
              s = r("newshape.label.texttemplate");
            if (l || s) {
              r("newshape.label.textangle");
              var c = r("newshape.label.textposition", o ? "middle" : "middle center");
              r("newshape.label.xanchor"), r("newshape.label.yanchor", function (e, t) {
                return e ? "bottom" : -1 !== t.indexOf("top") ? "top" : -1 !== t.indexOf("bottom") ? "bottom" : "middle";
              }(o, c)), r("newshape.label.padding"), a.coerceFont(r, "newshape.label.font", t.font);
            }
            r("activeshape.fillcolor"), r("activeshape.opacity");
          };
        },
        1055: function (e, t, r) {
          "use strict";

          var n = r(6953),
            a = r(3391),
            i = a.CIRCLE_SIDES,
            o = a.SQRT2,
            l = r(9801),
            s = l.p2r,
            c = l.r2p,
            u = [0, 3, 4, 5, 6, 1, 2],
            f = [0, 3, 4, 1, 2];
          function d(e, t) {
            return Math.abs(e - t) <= 1e-6;
          }
          function h(e, t) {
            var r = t[1] - e[1],
              n = t[2] - e[2];
            return Math.sqrt(r * r + n * n);
          }
          t.writePaths = function (e) {
            var t = e.length;
            if (!t) return "M0,0Z";
            for (var r = "", n = 0; n < t; n++) for (var a = e[n].length, i = 0; i < a; i++) {
              var o = e[n][i][0];
              if ("Z" === o) r += "Z";else for (var l = e[n][i].length, s = 0; s < l; s++) {
                var c = s;
                "Q" === o || "S" === o ? c = f[s] : "C" === o && (c = u[s]), r += e[n][i][c], s > 0 && s < l - 1 && (r += ",");
              }
            }
            return r;
          }, t.readPaths = function (e, t, r, a) {
            var o,
              l,
              u,
              f = n(e),
              d = [],
              h = -1,
              p = 0,
              v = 0,
              g = function () {
                l = p, u = v;
              };
            g();
            for (var m = 0; m < f.length; m++) {
              var y,
                x,
                b,
                _,
                w = [],
                T = f[m][0],
                M = T;
              switch (T) {
                case "M":
                  d[++h] = [], p = +f[m][1], v = +f[m][2], w.push([M, p, v]), g();
                  break;
                case "Q":
                case "S":
                  y = +f[m][1], b = +f[m][2], p = +f[m][3], v = +f[m][4], w.push([M, p, v, y, b]);
                  break;
                case "C":
                  y = +f[m][1], b = +f[m][2], x = +f[m][3], _ = +f[m][4], p = +f[m][5], v = +f[m][6], w.push([M, p, v, y, b, x, _]);
                  break;
                case "T":
                case "L":
                  p = +f[m][1], v = +f[m][2], w.push([M, p, v]);
                  break;
                case "H":
                  M = "L", p = +f[m][1], w.push([M, p, v]);
                  break;
                case "V":
                  M = "L", v = +f[m][1], w.push([M, p, v]);
                  break;
                case "A":
                  M = "L";
                  var k = +f[m][1],
                    A = +f[m][2];
                  +f[m][4] || (k = -k, A = -A);
                  var L = p - k,
                    S = v;
                  for (o = 1; o <= i / 2; o++) {
                    var C = 2 * Math.PI * o / i;
                    w.push([M, L + k * Math.cos(C), S + A * Math.sin(C)]);
                  }
                  break;
                case "Z":
                  p === l && v === u || (p = l, v = u, w.push([M, p, v]));
              }
              for (var O = (r || {}).domain, D = t._fullLayout._size, P = r && "pixel" === r.xsizemode, z = r && "pixel" === r.ysizemode, I = !1 === a, E = 0; E < w.length; E++) {
                for (o = 0; o + 2 < 7; o += 2) {
                  var R = w[E][o + 1],
                    N = w[E][o + 2];
                  void 0 !== R && void 0 !== N && (p = R, v = N, r && (r.xaxis && r.xaxis.p2r ? (I && (R -= r.xaxis._offset), R = P ? c(r.xaxis, r.xanchor) + R : s(r.xaxis, R)) : (I && (R -= D.l), O ? R = O.x[0] + R / D.w : R /= D.w), r.yaxis && r.yaxis.p2r ? (I && (N -= r.yaxis._offset), N = z ? c(r.yaxis, r.yanchor) - N : s(r.yaxis, N)) : (I && (N -= D.t), N = O ? O.y[1] - N / D.h : 1 - N / D.h)), w[E][o + 1] = R, w[E][o + 2] = N);
                }
                d[h].push(w[E].slice());
              }
            }
            return d;
          }, t.pointsOnRectangle = function (e) {
            if (5 !== e.length) return !1;
            for (var t = 1; t < 3; t++) {
              if (!d(e[0][t] - e[1][t], e[3][t] - e[2][t])) return !1;
              if (!d(e[0][t] - e[3][t], e[1][t] - e[2][t])) return !1;
            }
            return !(!d(e[0][1], e[1][1]) && !d(e[0][1], e[3][1]) || !(h(e[0], e[1]) * h(e[0], e[3])));
          }, t.pointsOnEllipse = function (e) {
            var t = e.length;
            if (t !== i + 1) return !1;
            t = i;
            for (var r = 0; r < t; r++) {
              var n = (2 * t - r) % t,
                a = (t / 2 + n) % t,
                o = (t / 2 + r) % t;
              if (!d(h(e[r], e[o]), h(e[n], e[a]))) return !1;
            }
            return !0;
          }, t.handleEllipse = function (e, r, n) {
            if (!e) return [r, n];
            var a = t.ellipseOver({
                x0: r[0],
                y0: r[1],
                x1: n[0],
                y1: n[1]
              }),
              l = (a.x1 + a.x0) / 2,
              s = (a.y1 + a.y0) / 2,
              c = (a.x1 - a.x0) / 2,
              u = (a.y1 - a.y0) / 2;
            c || (c = u /= o), u || (u = c /= o);
            for (var f = [], d = 0; d < i; d++) {
              var h = 2 * d * Math.PI / i;
              f.push([l + c * Math.cos(h), s + u * Math.sin(h)]);
            }
            return f;
          }, t.ellipseOver = function (e) {
            var t = e.x0,
              r = e.y0,
              n = e.x1,
              a = e.y1,
              i = n - t,
              l = a - r,
              s = ((t -= i) + n) / 2,
              c = ((r -= l) + a) / 2;
            return {
              x0: s - (i *= o),
              y0: c - (l *= o),
              x1: s + i,
              y1: c + l
            };
          }, t.fixDatesForPaths = function (e, t, r) {
            var n = "date" === t.type,
              a = "date" === r.type;
            if (!n && !a) return e;
            for (var i = 0; i < e.length; i++) for (var o = 0; o < e[i].length; o++) for (var l = 0; l + 2 < e[i][o].length; l += 2) n && (e[i][o][l + 1] = e[i][o][l + 1].replace(" ", "_")), a && (e[i][o][l + 2] = e[i][o][l + 2].replace(" ", "_"));
            return e;
          };
        },
        7562: function (e, t, r) {
          "use strict";

          var n = r(414),
            a = n.drawMode,
            i = n.openMode,
            o = r(3391),
            l = o.i000,
            s = o.i090,
            c = o.i180,
            u = o.i270,
            f = o.cos45,
            d = o.sin45,
            h = r(9801),
            p = h.p2r,
            v = h.r2p,
            g = r(8534).clearOutline,
            m = r(1055),
            y = m.readPaths,
            x = m.writePaths,
            b = m.ellipseOver,
            _ = m.fixDatesForPaths;
          function w(e, t, r) {
            var n,
              a = e[0][0],
              o = t.gd,
              h = a.getAttribute("d"),
              g = o._fullLayout.newshape,
              m = t.plotinfo,
              w = t.isActiveShape,
              T = m.xaxis,
              M = m.yaxis,
              k = !!m.domain || !m.xaxis,
              A = !!m.domain || !m.yaxis,
              L = i(r),
              S = y(h, o, m, w),
              C = {
                editable: !0,
                visible: g.visible,
                name: g.name,
                showlegend: g.showlegend,
                legend: g.legend,
                legendwidth: g.legendwidth,
                legendgroup: g.legendgroup,
                legendgrouptitle: {
                  text: g.legendgrouptitle.text,
                  font: g.legendgrouptitle.font
                },
                legendrank: g.legendrank,
                label: g.label,
                xref: k ? "paper" : T._id,
                yref: A ? "paper" : M._id,
                layer: g.layer,
                opacity: g.opacity,
                line: {
                  color: g.line.color,
                  width: g.line.width,
                  dash: g.line.dash
                }
              };
            if (L || (C.fillcolor = g.fillcolor, C.fillrule = g.fillrule), 1 === S.length && (n = S[0]), n && 5 === n.length && "drawrect" === r) C.type = "rect", C.x0 = n[0][1], C.y0 = n[0][2], C.x1 = n[2][1], C.y1 = n[2][2];else if (n && "drawline" === r) C.type = "line", C.x0 = n[0][1], C.y0 = n[0][2], C.x1 = n[1][1], C.y1 = n[1][2];else if (n && "drawcircle" === r) {
              C.type = "circle";
              var O = n[l][1],
                D = n[s][1],
                P = n[c][1],
                z = n[u][1],
                I = n[l][2],
                E = n[s][2],
                R = n[c][2],
                N = n[u][2],
                F = m.xaxis && ("date" === m.xaxis.type || "log" === m.xaxis.type),
                H = m.yaxis && ("date" === m.yaxis.type || "log" === m.yaxis.type);
              F && (O = v(m.xaxis, O), D = v(m.xaxis, D), P = v(m.xaxis, P), z = v(m.xaxis, z)), H && (I = v(m.yaxis, I), E = v(m.yaxis, E), R = v(m.yaxis, R), N = v(m.yaxis, N));
              var B = (D + z) / 2,
                j = (I + R) / 2,
                Y = b({
                  x0: B,
                  y0: j,
                  x1: B + (z - D + P - O) / 2 * f,
                  y1: j + (N - E + R - I) / 2 * d
                });
              F && (Y.x0 = p(m.xaxis, Y.x0), Y.x1 = p(m.xaxis, Y.x1)), H && (Y.y0 = p(m.yaxis, Y.y0), Y.y1 = p(m.yaxis, Y.y1)), C.x0 = Y.x0, C.y0 = Y.y0, C.x1 = Y.x1, C.y1 = Y.y1;
            } else C.type = "path", T && M && _(S, T, M), C.path = x(S), n = null;
            return C;
          }
          e.exports = {
            newShapes: function (e, t) {
              if (e.length && e[0][0]) {
                var r = t.gd,
                  n = t.isActiveShape,
                  i = t.dragmode,
                  o = (r.layout || {}).shapes || [];
                if (!a(i) && void 0 !== n) {
                  var l = r._fullLayout._activeShapeIndex;
                  if (l < o.length) switch (r._fullLayout.shapes[l].type) {
                    case "rect":
                      i = "drawrect";
                      break;
                    case "circle":
                      i = "drawcircle";
                      break;
                    case "line":
                      i = "drawline";
                      break;
                    case "path":
                      var s = o[l].path || "";
                      i = "Z" === s[s.length - 1] ? "drawclosedpath" : "drawopenpath";
                  }
                }
                var c = w(e, t, i);
                g(r);
                for (var u = t.editHelpers, f = (u || {}).modifyItem, d = [], h = 0; h < o.length; h++) {
                  var p = r._fullLayout.shapes[h];
                  if (d[h] = p._input, void 0 !== n && h === r._fullLayout._activeShapeIndex) {
                    var v = c;
                    switch (p.type) {
                      case "line":
                      case "rect":
                      case "circle":
                        f("x0", v.x0 - (p.x0shift || 0)), f("x1", v.x1 - (p.x1shift || 0)), f("y0", v.y0 - (p.y0shift || 0)), f("y1", v.y1 - (p.y1shift || 0));
                        break;
                      case "path":
                        f("path", v.path);
                    }
                  }
                }
                return void 0 === n ? (d.push(c), d) : u ? u.getUpdateObj() : {};
              }
            },
            createShapeObj: w
          };
        },
        8534: function (e) {
          "use strict";

          e.exports = {
            clearOutlineControllers: function (e) {
              var t = e._fullLayout._zoomlayer;
              t && t.selectAll(".outline-controllers").remove();
            },
            clearOutline: function (e) {
              var t = e._fullLayout._zoomlayer;
              t && t.selectAll(".select-outline").remove(), e._fullLayout._outlining = !1;
            }
          };
        },
        9728: function (e, t, r) {
          "use strict";

          var n = r(2956),
            a = r(4809),
            i = r(9714);
          function o(e, t) {
            var r = 0;
            return (t = t || 0) && e && ("category" === e.type || "multicategory" === e.type) && (r = (e.r2p(1) - e.r2p(0)) * t), r;
          }
          t.rangeToShapePosition = function (e) {
            return "log" === e.type ? e.r2d : function (e) {
              return e;
            };
          }, t.shapePositionToRange = function (e) {
            return "log" === e.type ? e.d2r : function (e) {
              return e;
            };
          }, t.decodeDate = function (e) {
            return function (t) {
              return t.replace && (t = t.replace("_", " ")), e(t);
            };
          }, t.encodeDate = function (e) {
            return function (t) {
              return e(t).replace(" ", "_");
            };
          }, t.extractPathCoords = function (e, t, r) {
            var i = [];
            return e.match(n.segmentRE).forEach(function (e) {
              var o = t[e.charAt(0)].drawn;
              if (void 0 !== o) {
                var l = e.substr(1).match(n.paramRE);
                if (l && !(l.length < o)) {
                  var s = l[o],
                    c = r ? s : a.cleanNumber(s);
                  i.push(c);
                }
              }
            }), i;
          }, t.getDataToPixel = function (e, r, n, a, i) {
            var l,
              s = e._fullLayout._size;
            if (r) {
              if ("domain" === i) l = function (e) {
                return r._length * (a ? 1 - e : e) + r._offset;
              };else {
                var c = t.shapePositionToRange(r);
                l = function (e) {
                  var t = o(r, n);
                  return r._offset + r.r2p(c(e, !0)) + t;
                }, "date" === r.type && (l = t.decodeDate(l));
              }
            } else l = a ? function (e) {
              return s.t + s.h * (1 - e);
            } : function (e) {
              return s.l + s.w * e;
            };
            return l;
          }, t.getPixelToData = function (e, r, n, a) {
            var i,
              o = e._fullLayout._size;
            if (r) {
              if ("domain" === a) i = function (e) {
                var t = (e - r._offset) / r._length;
                return n ? 1 - t : t;
              };else {
                var l = t.rangeToShapePosition(r);
                i = function (e) {
                  return l(r.p2r(e - r._offset));
                };
              }
            } else i = n ? function (e) {
              return 1 - (e - o.t) / o.h;
            } : function (e) {
              return (e - o.l) / o.w;
            };
            return i;
          }, t.roundPositionForSharpStrokeRendering = function (e, t) {
            var r = 1 === Math.round(t % 2),
              n = Math.round(e);
            return r ? n + .5 : n;
          }, t.makeShapesOptionsAndPlotinfo = function (e, t) {
            var r = e._fullLayout.shapes[t] || {},
              n = e._fullLayout._plots[r.xref + r.yref];
            return n ? n._hadPlotinfo = !0 : (n = {}, r.xref && "paper" !== r.xref && (n.xaxis = e._fullLayout[r.xref + "axis"]), r.yref && "paper" !== r.yref && (n.yaxis = e._fullLayout[r.yref + "axis"])), n.xsizemode = r.xsizemode, n.ysizemode = r.ysizemode, n.xanchor = r.xanchor, n.yanchor = r.yanchor, {
              options: r,
              plotinfo: n
            };
          }, t.makeSelectionsOptionsAndPlotinfo = function (e, t) {
            var r = e._fullLayout.selections[t] || {},
              n = e._fullLayout._plots[r.xref + r.yref];
            return n ? n._hadPlotinfo = !0 : (n = {}, r.xref && (n.xaxis = e._fullLayout[r.xref + "axis"]), r.yref && (n.yaxis = e._fullLayout[r.yref + "axis"])), {
              options: r,
              plotinfo: n
            };
          }, t.getPathString = function (e, r) {
            var l,
              s,
              c,
              u,
              f,
              d,
              h,
              p,
              v = r.type,
              g = i.getRefType(r.xref),
              m = i.getRefType(r.yref),
              y = i.getFromId(e, r.xref),
              x = i.getFromId(e, r.yref),
              b = e._fullLayout._size,
              _ = o(y, r.x0shift),
              w = o(y, r.x1shift),
              T = o(x, r.y0shift),
              M = o(x, r.y1shift);
            if (y ? "domain" === g ? s = function (e) {
              return y._offset + y._length * e;
            } : (l = t.shapePositionToRange(y), s = function (e) {
              return y._offset + y.r2p(l(e, !0));
            }) : s = function (e) {
              return b.l + b.w * e;
            }, x ? "domain" === m ? u = function (e) {
              return x._offset + x._length * (1 - e);
            } : (c = t.shapePositionToRange(x), u = function (e) {
              return x._offset + x.r2p(c(e, !0));
            }) : u = function (e) {
              return b.t + b.h * (1 - e);
            }, "path" === v) return y && "date" === y.type && (s = t.decodeDate(s)), x && "date" === x.type && (u = t.decodeDate(u)), function (e, t, r) {
              var i = e.path,
                o = e.xsizemode,
                l = e.ysizemode,
                s = e.xanchor,
                c = e.yanchor;
              return i.replace(n.segmentRE, function (e) {
                var i = 0,
                  u = e.charAt(0),
                  f = n.paramIsX[u],
                  d = n.paramIsY[u],
                  h = n.numParams[u],
                  p = e.substr(1).replace(n.paramRE, function (e) {
                    return f[i] ? e = "pixel" === o ? t(s) + Number(e) : t(e) : d[i] && (e = "pixel" === l ? r(c) - Number(e) : r(e)), ++i > h && (e = "X"), e;
                  });
                return i > h && (p = p.replace(/[\s,]*X.*/, ""), a.log("Ignoring extra params in segment " + e)), u + p;
              });
            }(r, s, u);
            if ("pixel" === r.xsizemode) {
              var k = s(r.xanchor);
              f = k + r.x0 + _, d = k + r.x1 + w;
            } else f = s(r.x0) + _, d = s(r.x1) + w;
            if ("pixel" === r.ysizemode) {
              var A = u(r.yanchor);
              h = A - r.y0 + T, p = A - r.y1 + M;
            } else h = u(r.y0) + T, p = u(r.y1) + M;
            if ("line" === v) return "M" + f + "," + h + "L" + d + "," + p;
            if ("rect" === v) return "M" + f + "," + h + "H" + d + "V" + p + "H" + f + "Z";
            var L = (f + d) / 2,
              S = (h + p) / 2,
              C = Math.abs(L - f),
              O = Math.abs(S - h),
              D = "A" + C + "," + O,
              P = L + C + "," + S;
            return "M" + P + D + " 0 1,1 " + L + "," + (S - O) + D + " 0 0,1 " + P + "Z";
          };
        },
        3701: function (e, t, r) {
          "use strict";

          var n = r(8231);
          e.exports = {
            moduleType: "component",
            name: "shapes",
            layoutAttributes: r(3144),
            supplyLayoutDefaults: r(4367),
            supplyDrawNewShapeDefaults: r(5522),
            includeBasePlot: r(706)("shapes"),
            calcAutorange: r(4959),
            draw: n.draw,
            drawOne: n.drawOne
          };
        },
        1235: function (e) {
          "use strict";

          function t(e, t) {
            return t ? t.d2l(e) : e;
          }
          function r(e, t) {
            return t ? t.l2d(e) : e;
          }
          function n(e) {
            return e.x0shift || 0;
          }
          function a(e) {
            return e.x1shift || 0;
          }
          function i(e) {
            return e.y0shift || 0;
          }
          function o(e) {
            return e.y1shift || 0;
          }
          function l(e, r) {
            return t(e.x1, r) + a(e) - t(e.x0, r) - n(e);
          }
          function s(e, r, n) {
            return t(e.y1, n) + o(e) - t(e.y0, n) - i(e);
          }
          e.exports = {
            x0: function (e) {
              return e.x0;
            },
            x1: function (e) {
              return e.x1;
            },
            y0: function (e) {
              return e.y0;
            },
            y1: function (e) {
              return e.y1;
            },
            slope: function (e, t, r) {
              return "line" !== e.type ? void 0 : s(e, 0, r) / l(e, t);
            },
            dx: l,
            dy: s,
            width: function (e, t) {
              return Math.abs(l(e, t));
            },
            height: function (e, t, r) {
              return Math.abs(s(e, 0, r));
            },
            length: function (e, t, r) {
              return "line" !== e.type ? void 0 : Math.sqrt(Math.pow(l(e, t), 2) + Math.pow(s(e, 0, r), 2));
            },
            xcenter: function (e, i) {
              return r((t(e.x1, i) + a(e) + t(e.x0, i) + n(e)) / 2, i);
            },
            ycenter: function (e, n, a) {
              return r((t(e.y1, a) + o(e) + t(e.y0, a) + i(e)) / 2, a);
            }
          };
        },
        8606: function (e, t, r) {
          "use strict";

          var n = r(337),
            a = r(7891),
            i = r(3049).extendDeepAll,
            o = r(3582).overrideAll,
            l = r(9722),
            s = r(8032).templatedArray,
            c = r(4194),
            u = s("step", {
              visible: {
                valType: "boolean",
                dflt: !0
              },
              method: {
                valType: "enumerated",
                values: ["restyle", "relayout", "animate", "update", "skip"],
                dflt: "restyle"
              },
              args: {
                valType: "info_array",
                freeLength: !0,
                items: [{
                  valType: "any"
                }, {
                  valType: "any"
                }, {
                  valType: "any"
                }]
              },
              label: {
                valType: "string"
              },
              value: {
                valType: "string"
              },
              execute: {
                valType: "boolean",
                dflt: !0
              }
            });
          e.exports = o(s("slider", {
            visible: {
              valType: "boolean",
              dflt: !0
            },
            active: {
              valType: "number",
              min: 0,
              dflt: 0
            },
            steps: u,
            lenmode: {
              valType: "enumerated",
              values: ["fraction", "pixels"],
              dflt: "fraction"
            },
            len: {
              valType: "number",
              min: 0,
              dflt: 1
            },
            x: {
              valType: "number",
              min: -2,
              max: 3,
              dflt: 0
            },
            pad: i(a({
              editType: "arraydraw"
            }), {}, {
              t: {
                dflt: 20
              }
            }),
            xanchor: {
              valType: "enumerated",
              values: ["auto", "left", "center", "right"],
              dflt: "left"
            },
            y: {
              valType: "number",
              min: -2,
              max: 3,
              dflt: 0
            },
            yanchor: {
              valType: "enumerated",
              values: ["auto", "top", "middle", "bottom"],
              dflt: "top"
            },
            transition: {
              duration: {
                valType: "number",
                min: 0,
                dflt: 150
              },
              easing: {
                valType: "enumerated",
                values: l.transition.easing.values,
                dflt: "cubic-in-out"
              }
            },
            currentvalue: {
              visible: {
                valType: "boolean",
                dflt: !0
              },
              xanchor: {
                valType: "enumerated",
                values: ["left", "center", "right"],
                dflt: "left"
              },
              offset: {
                valType: "number",
                dflt: 10
              },
              prefix: {
                valType: "string"
              },
              suffix: {
                valType: "string"
              },
              font: n({})
            },
            font: n({}),
            activebgcolor: {
              valType: "color",
              dflt: c.gripBgActiveColor
            },
            bgcolor: {
              valType: "color",
              dflt: c.railBgColor
            },
            bordercolor: {
              valType: "color",
              dflt: c.railBorderColor
            },
            borderwidth: {
              valType: "number",
              min: 0,
              dflt: c.railBorderWidth
            },
            ticklen: {
              valType: "number",
              min: 0,
              dflt: c.tickLength
            },
            tickcolor: {
              valType: "color",
              dflt: c.tickColor
            },
            tickwidth: {
              valType: "number",
              min: 0,
              dflt: 1
            },
            minorticklen: {
              valType: "number",
              min: 0,
              dflt: c.minorTickLength
            }
          }), "arraydraw", "from-root");
        },
        4194: function (e) {
          "use strict";

          e.exports = {
            name: "sliders",
            containerClassName: "slider-container",
            groupClassName: "slider-group",
            inputAreaClass: "slider-input-area",
            railRectClass: "slider-rail-rect",
            railTouchRectClass: "slider-rail-touch-rect",
            gripRectClass: "slider-grip-rect",
            tickRectClass: "slider-tick-rect",
            inputProxyClass: "slider-input-proxy",
            labelsClass: "slider-labels",
            labelGroupClass: "slider-label-group",
            labelClass: "slider-label",
            currentValueClass: "slider-current-value",
            railHeight: 5,
            menuIndexAttrName: "slider-active-index",
            autoMarginIdRoot: "slider-",
            minWidth: 30,
            minHeight: 30,
            textPadX: 40,
            arrowOffsetX: 4,
            railRadius: 2,
            railWidth: 5,
            railBorder: 4,
            railBorderWidth: 1,
            railBorderColor: "#bec8d9",
            railBgColor: "#f8fafc",
            railInset: 8,
            stepInset: 10,
            gripRadius: 10,
            gripWidth: 20,
            gripHeight: 20,
            gripBorder: 20,
            gripBorderWidth: 1,
            gripBorderColor: "#bec8d9",
            gripBgColor: "#f6f8fa",
            gripBgActiveColor: "#dbdde0",
            labelPadding: 8,
            labelOffset: 0,
            tickWidth: 1,
            tickColor: "#333",
            tickOffset: 25,
            tickLength: 7,
            minorTickOffset: 25,
            minorTickColor: "#333",
            minorTickLength: 4,
            currentValuePadding: 8,
            currentValueInset: 0
          };
        },
        4537: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9008),
            i = r(8606),
            o = r(4194).name,
            l = i.steps;
          function s(e, t, r) {
            function o(r, a) {
              return n.coerce(e, t, i, r, a);
            }
            for (var l = a(e, t, {
                name: "steps",
                handleItemDefaults: c
              }), s = 0, u = 0; u < l.length; u++) l[u].visible && s++;
            if (s < 2 ? t.visible = !1 : o("visible")) {
              t._stepCount = s;
              var f = t._visibleSteps = n.filterVisible(l);
              (l[o("active")] || {}).visible || (t.active = f[0]._index), o("x"), o("y"), n.noneOrAll(e, t, ["x", "y"]), o("xanchor"), o("yanchor"), o("len"), o("lenmode"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("currentvalue.visible") && (o("currentvalue.xanchor"), o("currentvalue.prefix"), o("currentvalue.suffix"), o("currentvalue.offset"), n.coerceFont(o, "currentvalue.font", t.font)), o("transition.duration"), o("transition.easing"), o("bgcolor"), o("activebgcolor"), o("bordercolor"), o("borderwidth"), o("ticklen"), o("tickwidth"), o("tickcolor"), o("minorticklen");
            }
          }
          function c(e, t) {
            function r(r, a) {
              return n.coerce(e, t, l, r, a);
            }
            if ("skip" === e.method || Array.isArray(e.args) ? r("visible") : t.visible = !1) {
              r("method"), r("args");
              var a = r("label", "step-" + t._index);
              r("value", a), r("execute");
            }
          }
          e.exports = function (e, t) {
            a(e, t, {
              name: o,
              handleItemDefaults: s
            });
          };
        },
        4097: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4122),
            i = r(8766),
            o = r(2203),
            l = r(4809),
            s = l.strTranslate,
            c = r(635),
            u = r(8032).arrayEditor,
            f = r(4194),
            d = r(4530),
            h = d.LINE_SPACING,
            p = d.FROM_TL,
            v = d.FROM_BR;
          function g(e) {
            return f.autoMarginIdRoot + e._index;
          }
          function m(e) {
            return e._index;
          }
          function y(e, t) {
            var r = o.tester.selectAll("g." + f.labelGroupClass).data(t._visibleSteps);
            r.enter().append("g").classed(f.labelGroupClass, !0);
            var i = 0,
              s = 0;
            r.each(function (e) {
              var r = _(n.select(this), {
                step: e
              }, t).node();
              if (r) {
                var a = o.bBox(r);
                s = Math.max(s, a.height), i = Math.max(i, a.width);
              }
            }), r.remove();
            var u = t._dims = {};
            u.inputAreaWidth = Math.max(f.railWidth, f.gripHeight);
            var d = e._fullLayout._size;
            u.lx = d.l + d.w * t.x, u.ly = d.t + d.h * (1 - t.y), "fraction" === t.lenmode ? u.outerLength = Math.round(d.w * t.len) : u.outerLength = t.len, u.inputAreaStart = 0, u.inputAreaLength = Math.round(u.outerLength - t.pad.l - t.pad.r);
            var h = (u.inputAreaLength - 2 * f.stepInset) / (t._stepCount - 1),
              m = i + f.labelPadding;
            if (u.labelStride = Math.max(1, Math.ceil(m / h)), u.labelHeight = s, u.currentValueMaxWidth = 0, u.currentValueHeight = 0, u.currentValueTotalHeight = 0, u.currentValueMaxLines = 1, t.currentvalue.visible) {
              var y = o.tester.append("g");
              r.each(function (e) {
                var r = x(y, t, e.label),
                  n = r.node() && o.bBox(r.node()) || {
                    width: 0,
                    height: 0
                  },
                  a = c.lineCount(r);
                u.currentValueMaxWidth = Math.max(u.currentValueMaxWidth, Math.ceil(n.width)), u.currentValueHeight = Math.max(u.currentValueHeight, Math.ceil(n.height)), u.currentValueMaxLines = Math.max(u.currentValueMaxLines, a);
              }), u.currentValueTotalHeight = u.currentValueHeight + t.currentvalue.offset, y.remove();
            }
            u.height = u.currentValueTotalHeight + f.tickOffset + t.ticklen + f.labelOffset + u.labelHeight + t.pad.t + t.pad.b;
            var b = "left";
            l.isRightAnchor(t) && (u.lx -= u.outerLength, b = "right"), l.isCenterAnchor(t) && (u.lx -= u.outerLength / 2, b = "center");
            var w = "top";
            l.isBottomAnchor(t) && (u.ly -= u.height, w = "bottom"), l.isMiddleAnchor(t) && (u.ly -= u.height / 2, w = "middle"), u.outerLength = Math.ceil(u.outerLength), u.height = Math.ceil(u.height), u.lx = Math.round(u.lx), u.ly = Math.round(u.ly);
            var T = {
              y: t.y,
              b: u.height * v[w],
              t: u.height * p[w]
            };
            "fraction" === t.lenmode ? (T.l = 0, T.xl = t.x - t.len * p[b], T.r = 0, T.xr = t.x + t.len * v[b]) : (T.x = t.x, T.l = u.outerLength * p[b], T.r = u.outerLength * v[b]), a.autoMargin(e, g(t), T);
          }
          function x(e, t, r) {
            if (t.currentvalue.visible) {
              var n,
                a,
                i = t._dims;
              switch (t.currentvalue.xanchor) {
                case "right":
                  n = i.inputAreaLength - f.currentValueInset - i.currentValueMaxWidth, a = "left";
                  break;
                case "center":
                  n = .5 * i.inputAreaLength, a = "middle";
                  break;
                default:
                  n = f.currentValueInset, a = "left";
              }
              var s = l.ensureSingle(e, "text", f.labelClass, function (e) {
                  e.attr({
                    "text-anchor": a,
                    "data-notex": 1
                  });
                }),
                u = t.currentvalue.prefix ? t.currentvalue.prefix : "";
              if ("string" == typeof r) u += r;else {
                var d = t.steps[t.active].label,
                  p = t._gd._fullLayout._meta;
                p && (d = l.templateString(d, p)), u += d;
              }
              t.currentvalue.suffix && (u += t.currentvalue.suffix), s.call(o.font, t.currentvalue.font).text(u).call(c.convertToTspans, t._gd);
              var v = c.lineCount(s),
                g = (i.currentValueMaxLines + 1 - v) * t.currentvalue.font.size * h;
              return c.positionText(s, n, g), s;
            }
          }
          function b(e, t, r) {
            l.ensureSingle(e, "rect", f.gripRectClass, function (n) {
              n.call(k, t, e, r).style("pointer-events", "all");
            }).attr({
              width: f.gripWidth,
              height: f.gripHeight,
              rx: f.gripRadius,
              ry: f.gripRadius
            }).call(i.stroke, r.bordercolor).call(i.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px");
          }
          function _(e, t, r) {
            var n = l.ensureSingle(e, "text", f.labelClass, function (e) {
                e.attr({
                  "text-anchor": "middle",
                  "data-notex": 1
                });
              }),
              a = t.step.label,
              i = r._gd._fullLayout._meta;
            return i && (a = l.templateString(a, i)), n.call(o.font, r.font).text(a).call(c.convertToTspans, r._gd), n;
          }
          function w(e, t) {
            var r = l.ensureSingle(e, "g", f.labelsClass),
              a = t._dims,
              i = r.selectAll("g." + f.labelGroupClass).data(a.labelSteps);
            i.enter().append("g").classed(f.labelGroupClass, !0), i.exit().remove(), i.each(function (e) {
              var r = n.select(this);
              r.call(_, e, t), o.setTranslate(r, S(t, e.fraction), f.tickOffset + t.ticklen + t.font.size * h + f.labelOffset + a.currentValueTotalHeight);
            });
          }
          function T(e, t, r, n, a) {
            var i = Math.round(n * (r._stepCount - 1)),
              o = r._visibleSteps[i]._index;
            o !== r.active && M(e, t, r, o, !0, a);
          }
          function M(e, t, r, n, i, o) {
            var l = r.active;
            r.active = n, u(e.layout, f.name, r).applyUpdate("active", n);
            var s = r.steps[r.active];
            t.call(L, r, o), t.call(x, r), e.emit("plotly_sliderchange", {
              slider: r,
              step: r.steps[r.active],
              interaction: i,
              previousActive: l
            }), s && s.method && i && (t._nextMethod ? (t._nextMethod.step = s, t._nextMethod.doCallback = i, t._nextMethod.doTransition = o) : (t._nextMethod = {
              step: s,
              doCallback: i,
              doTransition: o
            }, t._nextMethodRaf = window.requestAnimationFrame(function () {
              var r = t._nextMethod.step;
              r.method && (r.execute && a.executeAPICommand(e, r.method, r.args), t._nextMethod = null, t._nextMethodRaf = null);
            })));
          }
          function k(e, t, r) {
            if (!t._context.staticPlot) {
              var a = r.node(),
                o = n.select(t);
              e.on("mousedown", s), e.on("touchstart", s);
            }
            function l() {
              return r.data()[0];
            }
            function s() {
              var e = l();
              t.emit("plotly_sliderstart", {
                slider: e
              });
              var s = r.select("." + f.gripRectClass);
              n.event.stopPropagation(), n.event.preventDefault(), s.call(i.fill, e.activebgcolor);
              var c = C(e, n.mouse(a)[0]);
              function u() {
                var e = l(),
                  i = C(e, n.mouse(a)[0]);
                T(t, r, e, i, !1);
              }
              function d() {
                var e = l();
                e._dragging = !1, s.call(i.fill, e.bgcolor), o.on("mouseup", null), o.on("mousemove", null), o.on("touchend", null), o.on("touchmove", null), t.emit("plotly_sliderend", {
                  slider: e,
                  step: e.steps[e.active]
                });
              }
              T(t, r, e, c, !0), e._dragging = !0, o.on("mousemove", u), o.on("touchmove", u), o.on("mouseup", d), o.on("touchend", d);
            }
          }
          function A(e, t) {
            var r = e.selectAll("rect." + f.tickRectClass).data(t._visibleSteps),
              a = t._dims;
            r.enter().append("rect").classed(f.tickRectClass, !0), r.exit().remove(), r.attr({
              width: t.tickwidth + "px",
              "shape-rendering": "crispEdges"
            }), r.each(function (e, r) {
              var l = r % a.labelStride == 0,
                s = n.select(this);
              s.attr({
                height: l ? t.ticklen : t.minorticklen
              }).call(i.fill, t.tickcolor), o.setTranslate(s, S(t, r / (t._stepCount - 1)) - .5 * t.tickwidth, (l ? f.tickOffset : f.minorTickOffset) + a.currentValueTotalHeight);
            });
          }
          function L(e, t, r) {
            for (var n = e.select("rect." + f.gripRectClass), a = 0, i = 0; i < t._stepCount; i++) if (t._visibleSteps[i]._index === t.active) {
              a = i;
              break;
            }
            var o = S(t, a / (t._stepCount - 1));
            if (!t._invokingCommand) {
              var l = n;
              r && t.transition.duration > 0 && (l = l.transition().duration(t.transition.duration).ease(t.transition.easing)), l.attr("transform", s(o - .5 * f.gripWidth, t._dims.currentValueTotalHeight));
            }
          }
          function S(e, t) {
            var r = e._dims;
            return r.inputAreaStart + f.stepInset + (r.inputAreaLength - 2 * f.stepInset) * Math.min(1, Math.max(0, t));
          }
          function C(e, t) {
            var r = e._dims;
            return Math.min(1, Math.max(0, (t - f.stepInset - r.inputAreaStart) / (r.inputAreaLength - 2 * f.stepInset - 2 * r.inputAreaStart)));
          }
          function O(e, t, r) {
            var n = r._dims,
              a = l.ensureSingle(e, "rect", f.railTouchRectClass, function (n) {
                n.call(k, t, e, r).style("pointer-events", "all");
              });
            a.attr({
              width: n.inputAreaLength,
              height: Math.max(n.inputAreaWidth, f.tickOffset + r.ticklen + n.labelHeight)
            }).call(i.fill, r.bgcolor).attr("opacity", 0), o.setTranslate(a, 0, n.currentValueTotalHeight);
          }
          function D(e, t) {
            var r = t._dims,
              n = r.inputAreaLength - 2 * f.railInset,
              a = l.ensureSingle(e, "rect", f.railRectClass);
            a.attr({
              width: n,
              height: f.railWidth,
              rx: f.railRadius,
              ry: f.railRadius,
              "shape-rendering": "crispEdges"
            }).call(i.stroke, t.bordercolor).call(i.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px"), o.setTranslate(a, f.railInset, .5 * (r.inputAreaWidth - f.railWidth) + r.currentValueTotalHeight);
          }
          e.exports = function (e) {
            var t = e._context.staticPlot,
              r = e._fullLayout,
              i = function (e, t) {
                for (var r = e[f.name], n = [], a = 0; a < r.length; a++) {
                  var i = r[a];
                  i.visible && (i._gd = t, n.push(i));
                }
                return n;
              }(r, e),
              l = r._infolayer.selectAll("g." + f.containerClassName).data(i.length > 0 ? [0] : []);
            function s(t) {
              t._commandObserver && (t._commandObserver.remove(), delete t._commandObserver), a.autoMargin(e, g(t));
            }
            if (l.enter().append("g").classed(f.containerClassName, !0).style("cursor", t ? null : "ew-resize"), l.exit().each(function () {
              n.select(this).selectAll("g." + f.groupClassName).each(s);
            }).remove(), 0 !== i.length) {
              var c = l.selectAll("g." + f.groupClassName).data(i, m);
              c.enter().append("g").classed(f.groupClassName, !0), c.exit().each(s).remove();
              for (var u = 0; u < i.length; u++) {
                var d = i[u];
                y(e, d);
              }
              c.each(function (t) {
                var r = n.select(this);
                !function (e) {
                  var t = e._dims;
                  t.labelSteps = [];
                  for (var r = e._stepCount, n = 0; n < r; n += t.labelStride) t.labelSteps.push({
                    fraction: n / (r - 1),
                    step: e._visibleSteps[n]
                  });
                }(t), a.manageCommandObserver(e, t, t._visibleSteps, function (t) {
                  var n = r.data()[0];
                  n.active !== t.index && (n._dragging || M(e, r, n, t.index, !1, !0));
                }), function (e, t, r) {
                  (r.steps[r.active] || {}).visible || (r.active = r._visibleSteps[0]._index), t.call(x, r).call(D, r).call(w, r).call(A, r).call(O, e, r).call(b, e, r);
                  var n = r._dims;
                  o.setTranslate(t, n.lx + r.pad.l, n.ly + r.pad.t), t.call(L, r, !1), t.call(x, r);
                }(e, n.select(this), t);
              });
            }
          };
        },
        5359: function (e, t, r) {
          "use strict";

          var n = r(4194);
          e.exports = {
            moduleType: "component",
            name: n.name,
            layoutAttributes: r(8606),
            supplyLayoutDefaults: r(4537),
            draw: r(4097)
          };
        },
        7240: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(721),
            i = r(4122),
            o = r(3626),
            l = r(4809),
            s = l.strTranslate,
            c = r(2203),
            u = r(8766),
            f = r(635),
            d = r(438),
            h = r(4530).OPPOSITE_SIDE,
            p = / [XY][0-9]* /;
          e.exports = {
            draw: function (e, t, r) {
              var v,
                g = e._fullLayout,
                m = r.propContainer,
                y = r.propName,
                x = r.placeholder,
                b = r.traceIndex,
                _ = r.avoid || {},
                w = r.attributes,
                T = r.transform,
                M = r.containerGroup,
                k = 1,
                A = m.title,
                L = (A && A.text ? A.text : "").trim(),
                S = !1,
                C = A && A.font ? A.font : {},
                O = C.family,
                D = C.size,
                P = C.color,
                z = C.weight,
                I = C.style,
                E = C.variant,
                R = C.textcase,
                N = C.lineposition,
                F = C.shadow,
                H = !!r.subtitlePropName,
                B = r.subtitlePlaceholder,
                j = (m.title || {}).subtitle || {
                  text: "",
                  font: {}
                },
                Y = j.text.trim(),
                V = !1,
                U = 1,
                q = j.font,
                G = q.family,
                Z = q.size,
                W = q.color,
                J = q.weight,
                X = q.style,
                K = q.variant,
                Q = q.textcase,
                $ = q.lineposition,
                ee = q.shadow;
              "title.text" === y ? v = "titleText" : -1 !== y.indexOf("axis") ? v = "axisTitleText" : y.indexOf(!0) && (v = "colorbarTitleText");
              var te = e._context.edits[v];
              function re(e, t) {
                return void 0 !== e && void 0 !== t && e.replace(p, " % ") === t.replace(p, " % ");
              }
              "" === L ? k = 0 : re(L, x) && (te || (L = ""), k = .2, S = !0), H && ("" === Y ? U = 0 : re(Y, B) && (te || (Y = ""), U = .2, V = !0)), r._meta ? L = l.templateString(L, r._meta) : g._meta && (L = l.templateString(L, g._meta));
              var ne,
                ae = L || Y || te;
              M || (M = l.ensureSingle(g._infolayer, "g", "g-" + t), ne = g._hColorbarMoveTitle);
              var ie = M.selectAll("text." + t).data(ae ? [0] : []);
              ie.enter().append("text"), ie.text(L).attr("class", t), ie.exit().remove();
              var oe = null,
                le = t + "-subtitle",
                se = Y || te;
              if (H && se && ((oe = M.selectAll("text." + le).data(se ? [0] : [])).enter().append("text"), oe.text(Y).attr("class", le), oe.exit().remove()), !ae) return M;
              function ce(e, t) {
                l.syncOrAsync([ue, fe], {
                  title: e,
                  subtitle: t
                });
              }
              function ue(r) {
                var a,
                  o = r.title,
                  d = r.subtitle;
                if (!T && ne && (T = {}), T ? (a = "", T.rotate && (a += "rotate(" + [T.rotate, w.x, w.y] + ")"), (T.offset || ne) && (a += s(0, (T.offset || 0) - (ne || 0)))) : a = null, o.attr("transform", a), o.style("opacity", k * u.opacity(P)).call(c.font, {
                  color: u.rgb(P),
                  size: n.round(D, 2),
                  family: O,
                  weight: z,
                  style: I,
                  variant: E,
                  textcase: R,
                  shadow: F,
                  lineposition: N
                }).attr(w).call(f.convertToTspans, e, function (e) {
                  if (e) {
                    var t = n.select(e.node().parentNode).select("." + le);
                    if (!t.empty()) {
                      var r = e.node().getBBox();
                      if (r.height) {
                        var a = r.y + r.height + 1.6 * Z;
                        t.attr("y", a);
                      }
                    }
                  }
                }), d) {
                  var h = M.select("." + t + "-math-group"),
                    p = o.node().getBBox(),
                    v = h.node() ? h.node().getBBox() : void 0,
                    g = v ? v.y + v.height + 1.6 * Z : p.y + p.height + 1.6 * Z,
                    m = l.extendFlat({}, w, {
                      y: g
                    });
                  d.attr("transform", a), d.style("opacity", U * u.opacity(W)).call(c.font, {
                    color: u.rgb(W),
                    size: n.round(Z, 2),
                    family: G,
                    weight: J,
                    style: X,
                    variant: K,
                    textcase: Q,
                    shadow: ee,
                    lineposition: $
                  }).attr(m).call(f.convertToTspans, e);
                }
                return i.previousPromises(e);
              }
              function fe(t) {
                var r = t.title,
                  i = n.select(r.node().parentNode);
                if (_ && _.selection && _.side && L) {
                  i.attr("transform", null);
                  var o = h[_.side],
                    u = "left" === _.side || "top" === _.side ? -1 : 1,
                    f = a(_.pad) ? _.pad : 2,
                    d = c.bBox(i.node()),
                    p = {
                      t: 0,
                      b: 0,
                      l: 0,
                      r: 0
                    },
                    v = e._fullLayout._reservedMargin;
                  for (var y in v) for (var x in v[y]) {
                    var b = v[y][x];
                    p[x] = Math.max(p[x], b);
                  }
                  var w = {
                      left: p.l,
                      top: p.t,
                      right: g.width - p.r,
                      bottom: g.height - p.b
                    },
                    T = _.maxShift || u * (w[_.side] - d[_.side]),
                    M = 0;
                  if (T < 0) M = T;else {
                    var k = _.offsetLeft || 0,
                      A = _.offsetTop || 0;
                    d.left -= k, d.right -= k, d.top -= A, d.bottom -= A, _.selection.each(function () {
                      var e = c.bBox(this);
                      l.bBoxIntersect(d, e, f) && (M = Math.max(M, u * (e[_.side] - d[o]) + f));
                    }), M = Math.min(T, M), m._titleScoot = Math.abs(M);
                  }
                  if (M > 0 || T < 0) {
                    var S = {
                      left: [-M, 0],
                      right: [M, 0],
                      top: [0, -M],
                      bottom: [0, M]
                    }[_.side];
                    i.attr("transform", s(S[0], S[1]));
                  }
                }
              }
              function de(e, t) {
                e.text(t).on("mouseover.opacity", function () {
                  n.select(this).transition().duration(d.SHOW_PLACEHOLDER).style("opacity", 1);
                }).on("mouseout.opacity", function () {
                  n.select(this).transition().duration(d.HIDE_PLACEHOLDER).style("opacity", 0);
                });
              }
              if (ie.call(ce, oe), te && (L ? ie.on(".opacity", null) : (de(ie, x), S = !0), ie.call(f.makeEditable, {
                gd: e
              }).on("edit", function (t) {
                void 0 !== b ? o.call("_guiRestyle", e, y, t, b) : o.call("_guiRelayout", e, y, t);
              }).on("cancel", function () {
                this.text(this.attr("data-unformatted")).call(ce);
              }).on("input", function (e) {
                this.text(e || " ").call(f.positionText, w.x, w.y);
              }), H)) {
                if (H && !L) {
                  var he = ie.node().getBBox(),
                    pe = he.y + he.height + 1.6 * Z;
                  oe.attr("y", pe);
                }
                Y ? oe.on(".opacity", null) : (de(oe, B), V = !0), oe.call(f.makeEditable, {
                  gd: e
                }).on("edit", function (t) {
                  o.call("_guiRelayout", e, "title.subtitle.text", t);
                }).on("cancel", function () {
                  this.text(this.attr("data-unformatted")).call(ce);
                }).on("input", function (e) {
                  this.text(e || " ").call(f.positionText, oe.attr("x"), oe.attr("y"));
                });
              }
              return ie.classed("js-placeholder", S), oe && oe.classed("js-placeholder", V), M;
            },
            SUBTITLE_PADDING_EM: 1.6,
            SUBTITLE_PADDING_MATHJAX_EM: 1.6
          };
        },
        5389: function (e, t, r) {
          "use strict";

          var n = r(337),
            a = r(229),
            i = r(3049).extendFlat,
            o = r(3582).overrideAll,
            l = r(7891),
            s = r(8032).templatedArray,
            c = s("button", {
              visible: {
                valType: "boolean"
              },
              method: {
                valType: "enumerated",
                values: ["restyle", "relayout", "animate", "update", "skip"],
                dflt: "restyle"
              },
              args: {
                valType: "info_array",
                freeLength: !0,
                items: [{
                  valType: "any"
                }, {
                  valType: "any"
                }, {
                  valType: "any"
                }]
              },
              args2: {
                valType: "info_array",
                freeLength: !0,
                items: [{
                  valType: "any"
                }, {
                  valType: "any"
                }, {
                  valType: "any"
                }]
              },
              label: {
                valType: "string",
                dflt: ""
              },
              execute: {
                valType: "boolean",
                dflt: !0
              }
            });
          e.exports = o(s("updatemenu", {
            _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/],
            visible: {
              valType: "boolean"
            },
            type: {
              valType: "enumerated",
              values: ["dropdown", "buttons"],
              dflt: "dropdown"
            },
            direction: {
              valType: "enumerated",
              values: ["left", "right", "up", "down"],
              dflt: "down"
            },
            active: {
              valType: "integer",
              min: -1,
              dflt: 0
            },
            showactive: {
              valType: "boolean",
              dflt: !0
            },
            buttons: c,
            x: {
              valType: "number",
              min: -2,
              max: 3,
              dflt: -.05
            },
            xanchor: {
              valType: "enumerated",
              values: ["auto", "left", "center", "right"],
              dflt: "right"
            },
            y: {
              valType: "number",
              min: -2,
              max: 3,
              dflt: 1
            },
            yanchor: {
              valType: "enumerated",
              values: ["auto", "top", "middle", "bottom"],
              dflt: "top"
            },
            pad: i(l({
              editType: "arraydraw"
            }), {}),
            font: n({}),
            bgcolor: {
              valType: "color"
            },
            bordercolor: {
              valType: "color",
              dflt: a.borderLine
            },
            borderwidth: {
              valType: "number",
              min: 0,
              dflt: 1,
              editType: "arraydraw"
            }
          }), "arraydraw", "from-root");
        },
        1559: function (e) {
          "use strict";

          e.exports = {
            name: "updatemenus",
            containerClassName: "updatemenu-container",
            headerGroupClassName: "updatemenu-header-group",
            headerClassName: "updatemenu-header",
            headerArrowClassName: "updatemenu-header-arrow",
            dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
            dropdownButtonClassName: "updatemenu-dropdown-button",
            buttonClassName: "updatemenu-button",
            itemRectClassName: "updatemenu-item-rect",
            itemTextClassName: "updatemenu-item-text",
            menuIndexAttrName: "updatemenu-active-index",
            autoMarginIdRoot: "updatemenu-",
            blankHeaderOpts: {
              label: "  "
            },
            minWidth: 30,
            minHeight: 30,
            textPadX: 24,
            arrowPadX: 16,
            rx: 2,
            ry: 2,
            textOffsetX: 12,
            textOffsetY: 3,
            arrowOffsetX: 4,
            gapButtonHeader: 5,
            gapButton: 2,
            activeColor: "#F4FAFF",
            hoverColor: "#F4FAFF",
            arrowSymbol: {
              left: "◄",
              right: "►",
              up: "▲",
              down: "▼"
            }
          };
        },
        2746: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9008),
            i = r(5389),
            o = r(1559).name,
            l = i.buttons;
          function s(e, t, r) {
            function o(r, a) {
              return n.coerce(e, t, i, r, a);
            }
            o("visible", a(e, t, {
              name: "buttons",
              handleItemDefaults: c
            }).length > 0) && (o("active"), o("direction"), o("type"), o("showactive"), o("x"), o("y"), n.noneOrAll(e, t, ["x", "y"]), o("xanchor"), o("yanchor"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("bgcolor", r.paper_bgcolor), o("bordercolor"), o("borderwidth"));
          }
          function c(e, t) {
            function r(r, a) {
              return n.coerce(e, t, l, r, a);
            }
            r("visible", "skip" === e.method || Array.isArray(e.args)) && (r("method"), r("args"), r("args2"), r("label"), r("execute"));
          }
          e.exports = function (e, t) {
            a(e, t, {
              name: o,
              handleItemDefaults: s
            });
          };
        },
        974: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4122),
            i = r(8766),
            o = r(2203),
            l = r(4809),
            s = r(635),
            c = r(8032).arrayEditor,
            u = r(4530).LINE_SPACING,
            f = r(1559),
            d = r(1736);
          function h(e) {
            return e._index;
          }
          function p(e, t) {
            return +e.attr(f.menuIndexAttrName) === t._index;
          }
          function v(e, t, r, n, a, i, o, l) {
            t.active = o, c(e.layout, f.name, t).applyUpdate("active", o), "buttons" === t.type ? m(e, n, null, null, t) : "dropdown" === t.type && (a.attr(f.menuIndexAttrName, "-1"), g(e, n, a, i, t), l || m(e, n, a, i, t));
          }
          function g(e, t, r, n, a) {
            var i = l.ensureSingle(t, "g", f.headerClassName, function (e) {
                e.style("pointer-events", "all");
              }),
              s = a._dims,
              c = a.active,
              u = a.buttons[c] || f.blankHeaderOpts,
              d = {
                y: a.pad.t,
                yPad: 0,
                x: a.pad.l,
                xPad: 0,
                index: 0
              },
              h = {
                width: s.headerWidth,
                height: s.headerHeight
              };
            i.call(y, a, u, e).call(A, a, d, h), l.ensureSingle(t, "text", f.headerArrowClassName, function (e) {
              e.attr("text-anchor", "end").call(o.font, a.font).text(f.arrowSymbol[a.direction]);
            }).attr({
              x: s.headerWidth - f.arrowOffsetX + a.pad.l,
              y: s.headerHeight / 2 + f.textOffsetY + a.pad.t
            }), i.on("click", function () {
              r.call(L, String(p(r, a) ? -1 : a._index)), m(e, t, r, n, a);
            }), i.on("mouseover", function () {
              i.call(w);
            }), i.on("mouseout", function () {
              i.call(T, a);
            }), o.setTranslate(t, s.lx, s.ly);
          }
          function m(e, t, r, i, o) {
            r || (r = t).attr("pointer-events", "all");
            var s = function (e) {
                return -1 == +e.attr(f.menuIndexAttrName);
              }(r) && "buttons" !== o.type ? [] : o.buttons,
              c = "dropdown" === o.type ? f.dropdownButtonClassName : f.buttonClassName,
              u = r.selectAll("g." + c).data(l.filterVisible(s)),
              d = u.enter().append("g").classed(c, !0),
              h = u.exit();
            "dropdown" === o.type ? (d.attr("opacity", "0").transition().attr("opacity", "1"), h.transition().attr("opacity", "0").remove()) : h.remove();
            var p = 0,
              g = 0,
              m = o._dims,
              x = -1 !== ["up", "down"].indexOf(o.direction);
            "dropdown" === o.type && (x ? g = m.headerHeight + f.gapButtonHeader : p = m.headerWidth + f.gapButtonHeader), "dropdown" === o.type && "up" === o.direction && (g = -f.gapButtonHeader + f.gapButton - m.openHeight), "dropdown" === o.type && "left" === o.direction && (p = -f.gapButtonHeader + f.gapButton - m.openWidth);
            var b = {
                x: m.lx + p + o.pad.l,
                y: m.ly + g + o.pad.t,
                yPad: f.gapButton,
                xPad: f.gapButton,
                index: 0
              },
              M = {
                l: b.x + o.borderwidth,
                t: b.y + o.borderwidth
              };
            u.each(function (l, s) {
              var c = n.select(this);
              c.call(y, o, l, e).call(A, o, b), c.on("click", function () {
                n.event.defaultPrevented || (l.execute && (l.args2 && o.active === s ? (v(e, o, 0, t, r, i, -1), a.executeAPICommand(e, l.method, l.args2)) : (v(e, o, 0, t, r, i, s), a.executeAPICommand(e, l.method, l.args))), e.emit("plotly_buttonclicked", {
                  menu: o,
                  button: l,
                  active: o.active
                }));
              }), c.on("mouseover", function () {
                c.call(w);
              }), c.on("mouseout", function () {
                c.call(T, o), u.call(_, o);
              });
            }), u.call(_, o), x ? (M.w = Math.max(m.openWidth, m.headerWidth), M.h = b.y - M.t) : (M.w = b.x - M.l, M.h = Math.max(m.openHeight, m.headerHeight)), M.direction = o.direction, i && (u.size() ? function (e, t, r, n, a, i) {
              var o,
                l,
                s,
                c = a.direction,
                u = "up" === c || "down" === c,
                d = a._dims,
                h = a.active;
              if (u) for (l = 0, s = 0; s < h; s++) l += d.heights[s] + f.gapButton;else for (o = 0, s = 0; s < h; s++) o += d.widths[s] + f.gapButton;
              n.enable(i, o, l), n.hbar && n.hbar.attr("opacity", "0").transition().attr("opacity", "1"), n.vbar && n.vbar.attr("opacity", "0").transition().attr("opacity", "1");
            }(0, 0, 0, i, o, M) : function (e) {
              var t = !!e.hbar,
                r = !!e.vbar;
              t && e.hbar.transition().attr("opacity", "0").each("end", function () {
                t = !1, r || e.disable();
              }), r && e.vbar.transition().attr("opacity", "0").each("end", function () {
                r = !1, t || e.disable();
              });
            }(i));
          }
          function y(e, t, r, n) {
            e.call(x, t).call(b, t, r, n);
          }
          function x(e, t) {
            l.ensureSingle(e, "rect", f.itemRectClassName, function (e) {
              e.attr({
                rx: f.rx,
                ry: f.ry,
                "shape-rendering": "crispEdges"
              });
            }).call(i.stroke, t.bordercolor).call(i.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px");
          }
          function b(e, t, r, n) {
            var a = l.ensureSingle(e, "text", f.itemTextClassName, function (e) {
                e.attr({
                  "text-anchor": "start",
                  "data-notex": 1
                });
              }),
              i = r.label,
              c = n._fullLayout._meta;
            c && (i = l.templateString(i, c)), a.call(o.font, t.font).text(i).call(s.convertToTspans, n);
          }
          function _(e, t) {
            var r = t.active;
            e.each(function (e, a) {
              var o = n.select(this);
              a === r && t.showactive && o.select("rect." + f.itemRectClassName).call(i.fill, f.activeColor);
            });
          }
          function w(e) {
            e.select("rect." + f.itemRectClassName).call(i.fill, f.hoverColor);
          }
          function T(e, t) {
            e.select("rect." + f.itemRectClassName).call(i.fill, t.bgcolor);
          }
          function M(e, t) {
            var r = t._dims = {
                width1: 0,
                height1: 0,
                heights: [],
                widths: [],
                totalWidth: 0,
                totalHeight: 0,
                openWidth: 0,
                openHeight: 0,
                lx: 0,
                ly: 0
              },
              i = o.tester.selectAll("g." + f.dropdownButtonClassName).data(l.filterVisible(t.buttons));
            i.enter().append("g").classed(f.dropdownButtonClassName, !0);
            var c = -1 !== ["up", "down"].indexOf(t.direction);
            i.each(function (a, i) {
              var l = n.select(this);
              l.call(y, t, a, e);
              var d = l.select("." + f.itemTextClassName),
                h = d.node() && o.bBox(d.node()).width,
                p = Math.max(h + f.textPadX, f.minWidth),
                v = t.font.size * u,
                g = s.lineCount(d),
                m = Math.max(v * g, f.minHeight) + f.textOffsetY;
              m = Math.ceil(m), p = Math.ceil(p), r.widths[i] = p, r.heights[i] = m, r.height1 = Math.max(r.height1, m), r.width1 = Math.max(r.width1, p), c ? (r.totalWidth = Math.max(r.totalWidth, p), r.openWidth = r.totalWidth, r.totalHeight += m + f.gapButton, r.openHeight += m + f.gapButton) : (r.totalWidth += p + f.gapButton, r.openWidth += p + f.gapButton, r.totalHeight = Math.max(r.totalHeight, m), r.openHeight = r.totalHeight);
            }), c ? r.totalHeight -= f.gapButton : r.totalWidth -= f.gapButton, r.headerWidth = r.width1 + f.arrowPadX, r.headerHeight = r.height1, "dropdown" === t.type && (c ? (r.width1 += f.arrowPadX, r.totalHeight = r.height1) : r.totalWidth = r.width1, r.totalWidth += f.arrowPadX), i.remove();
            var d = r.totalWidth + t.pad.l + t.pad.r,
              h = r.totalHeight + t.pad.t + t.pad.b,
              p = e._fullLayout._size;
            r.lx = p.l + p.w * t.x, r.ly = p.t + p.h * (1 - t.y);
            var v = "left";
            l.isRightAnchor(t) && (r.lx -= d, v = "right"), l.isCenterAnchor(t) && (r.lx -= d / 2, v = "center");
            var g = "top";
            l.isBottomAnchor(t) && (r.ly -= h, g = "bottom"), l.isMiddleAnchor(t) && (r.ly -= h / 2, g = "middle"), r.totalWidth = Math.ceil(r.totalWidth), r.totalHeight = Math.ceil(r.totalHeight), r.lx = Math.round(r.lx), r.ly = Math.round(r.ly), a.autoMargin(e, k(t), {
              x: t.x,
              y: t.y,
              l: d * ({
                right: 1,
                center: .5
              }[v] || 0),
              r: d * ({
                left: 1,
                center: .5
              }[v] || 0),
              b: h * ({
                top: 1,
                middle: .5
              }[g] || 0),
              t: h * ({
                bottom: 1,
                middle: .5
              }[g] || 0)
            });
          }
          function k(e) {
            return f.autoMarginIdRoot + e._index;
          }
          function A(e, t, r, n) {
            n = n || {};
            var a = e.select("." + f.itemRectClassName),
              i = e.select("." + f.itemTextClassName),
              l = t.borderwidth,
              c = r.index,
              d = t._dims;
            o.setTranslate(e, l + r.x, l + r.y);
            var h = -1 !== ["up", "down"].indexOf(t.direction),
              p = n.height || (h ? d.heights[c] : d.height1);
            a.attr({
              x: 0,
              y: 0,
              width: n.width || (h ? d.width1 : d.widths[c]),
              height: p
            });
            var v = t.font.size * u,
              g = (s.lineCount(i) - 1) * v / 2;
            s.positionText(i, f.textOffsetX, p / 2 - g + f.textOffsetY), h ? r.y += d.heights[c] + r.yPad : r.x += d.widths[c] + r.xPad, r.index++;
          }
          function L(e, t) {
            e.attr(f.menuIndexAttrName, t || "-1").selectAll("g." + f.dropdownButtonClassName).remove();
          }
          e.exports = function (e) {
            var t = e._fullLayout,
              r = l.filterVisible(t[f.name]);
            function i(t) {
              a.autoMargin(e, k(t));
            }
            var o = t._menulayer.selectAll("g." + f.containerClassName).data(r.length > 0 ? [0] : []);
            if (o.enter().append("g").classed(f.containerClassName, !0).style("cursor", "pointer"), o.exit().each(function () {
              n.select(this).selectAll("g." + f.headerGroupClassName).each(i);
            }).remove(), 0 !== r.length) {
              var s = o.selectAll("g." + f.headerGroupClassName).data(r, h);
              s.enter().append("g").classed(f.headerGroupClassName, !0);
              for (var c = l.ensureSingle(o, "g", f.dropdownButtonGroupClassName, function (e) {
                  e.style("pointer-events", "all");
                }), u = 0; u < r.length; u++) {
                var y = r[u];
                M(e, y);
              }
              var x = "updatemenus" + t._uid,
                b = new d(e, c, x);
              s.enter().size() && (c.node().parentNode.appendChild(c.node()), c.call(L)), s.exit().each(function (e) {
                c.call(L), i(e);
              }).remove(), s.each(function (t) {
                var r = n.select(this),
                  i = "dropdown" === t.type ? c : null;
                a.manageCommandObserver(e, t, t.buttons, function (n) {
                  v(e, t, t.buttons[n.index], r, i, b, n.index, !0);
                }), "dropdown" === t.type ? (g(e, r, c, b, t), p(c, t) && m(e, r, c, b, t)) : m(e, r, null, null, t);
              });
            }
          };
        },
        6230: function (e, t, r) {
          "use strict";

          var n = r(1559);
          e.exports = {
            moduleType: "component",
            name: n.name,
            layoutAttributes: r(5389),
            supplyLayoutDefaults: r(2746),
            draw: r(974)
          };
        },
        1736: function (e, t, r) {
          "use strict";

          e.exports = l;
          var n = r(5568),
            a = r(8766),
            i = r(2203),
            o = r(4809);
          function l(e, t, r) {
            this.gd = e, this.container = t, this.id = r, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([0]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({
              opacity: 0,
              x: 0,
              y: 0,
              width: 0,
              height: 0
            });
          }
          l.barWidth = 2, l.barLength = 20, l.barRadius = 2, l.barPad = 1, l.barColor = "#808BA4", l.prototype.enable = function (e, t, r) {
            var o = this.gd._fullLayout,
              s = o.width,
              c = o.height;
            this.position = e;
            var u,
              f,
              d,
              h,
              p = this.position.l,
              v = this.position.w,
              g = this.position.t,
              m = this.position.h,
              y = this.position.direction,
              x = "down" === y,
              b = "left" === y,
              _ = "up" === y,
              w = v,
              T = m;
            x || b || "right" === y || _ || (this.position.direction = "down", x = !0), x || _ ? (f = (u = p) + w, x ? (d = g, T = (h = Math.min(d + T, c)) - d) : T = (h = g + T) - (d = Math.max(h - T, 0))) : (h = (d = g) + T, b ? w = (f = p + w) - (u = Math.max(f - w, 0)) : (u = p, w = (f = Math.min(u + w, s)) - u)), this._box = {
              l: u,
              t: d,
              w: w,
              h: T
            };
            var M = v > w,
              k = l.barLength + 2 * l.barPad,
              A = l.barWidth + 2 * l.barPad,
              L = p,
              S = g + m;
            S + A > c && (S = c - A);
            var C = this.container.selectAll("rect.scrollbar-horizontal").data(M ? [0] : []);
            C.exit().on(".drag", null).remove(), C.enter().append("rect").classed("scrollbar-horizontal", !0).call(a.fill, l.barColor), M ? (this.hbar = C.attr({
              rx: l.barRadius,
              ry: l.barRadius,
              x: L,
              y: S,
              width: k,
              height: A
            }), this._hbarXMin = L + k / 2, this._hbarTranslateMax = w - k) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
            var O = m > T,
              D = l.barWidth + 2 * l.barPad,
              P = l.barLength + 2 * l.barPad,
              z = p + v,
              I = g;
            z + D > s && (z = s - D);
            var E = this.container.selectAll("rect.scrollbar-vertical").data(O ? [0] : []);
            E.exit().on(".drag", null).remove(), E.enter().append("rect").classed("scrollbar-vertical", !0).call(a.fill, l.barColor), O ? (this.vbar = E.attr({
              rx: l.barRadius,
              ry: l.barRadius,
              x: z,
              y: I,
              width: D,
              height: P
            }), this._vbarYMin = I + P / 2, this._vbarTranslateMax = T - P) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
            var R = this.id,
              N = u - .5,
              F = O ? f + D + .5 : f + .5,
              H = d - .5,
              B = M ? h + A + .5 : h + .5,
              j = o._topdefs.selectAll("#" + R).data(M || O ? [0] : []);
            if (j.exit().remove(), j.enter().append("clipPath").attr("id", R).append("rect"), M || O ? (this._clipRect = j.select("rect").attr({
              x: Math.floor(N),
              y: Math.floor(H),
              width: Math.ceil(F) - Math.floor(N),
              height: Math.ceil(B) - Math.floor(H)
            }), this.container.call(i.setClipUrl, R, this.gd), this.bg.attr({
              x: p,
              y: g,
              width: v,
              height: m
            })) : (this.bg.attr({
              width: 0,
              height: 0
            }), this.container.on("wheel", null).on(".drag", null).call(i.setClipUrl, null), delete this._clipRect), M || O) {
              var Y = n.behavior.drag().on("dragstart", function () {
                n.event.sourceEvent.preventDefault();
              }).on("drag", this._onBoxDrag.bind(this));
              this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(Y);
              var V = n.behavior.drag().on("dragstart", function () {
                n.event.sourceEvent.preventDefault(), n.event.sourceEvent.stopPropagation();
              }).on("drag", this._onBarDrag.bind(this));
              M && this.hbar.on(".drag", null).call(V), O && this.vbar.on(".drag", null).call(V);
            }
            this.setTranslate(t, r);
          }, l.prototype.disable = function () {
            (this.hbar || this.vbar) && (this.bg.attr({
              width: 0,
              height: 0
            }), this.container.on("wheel", null).on(".drag", null).call(i.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
          }, l.prototype._onBoxDrag = function () {
            var e = this.translateX,
              t = this.translateY;
            this.hbar && (e -= n.event.dx), this.vbar && (t -= n.event.dy), this.setTranslate(e, t);
          }, l.prototype._onBoxWheel = function () {
            var e = this.translateX,
              t = this.translateY;
            this.hbar && (e += n.event.deltaY), this.vbar && (t += n.event.deltaY), this.setTranslate(e, t);
          }, l.prototype._onBarDrag = function () {
            var e = this.translateX,
              t = this.translateY;
            if (this.hbar) {
              var r = e + this._hbarXMin,
                a = r + this._hbarTranslateMax;
              e = (o.constrain(n.event.x, r, a) - r) / (a - r) * (this.position.w - this._box.w);
            }
            if (this.vbar) {
              var i = t + this._vbarYMin,
                l = i + this._vbarTranslateMax;
              t = (o.constrain(n.event.y, i, l) - i) / (l - i) * (this.position.h - this._box.h);
            }
            this.setTranslate(e, t);
          }, l.prototype.setTranslate = function (e, t) {
            var r = this.position.w - this._box.w,
              n = this.position.h - this._box.h;
            if (e = o.constrain(e || 0, 0, r), t = o.constrain(t || 0, 0, n), this.translateX = e, this.translateY = t, this.container.call(i.setTranslate, this._box.l - this.position.l - e, this._box.t - this.position.t - t), this._clipRect && this._clipRect.attr({
              x: Math.floor(this.position.l + e - .5),
              y: Math.floor(this.position.t + t - .5)
            }), this.hbar) {
              var a = e / r;
              this.hbar.call(i.setTranslate, e + a * this._hbarTranslateMax, t);
            }
            if (this.vbar) {
              var l = t / n;
              this.vbar.call(i.setTranslate, e, t + l * this._vbarTranslateMax);
            }
          };
        },
        4530: function (e) {
          "use strict";

          e.exports = {
            FROM_BL: {
              left: 0,
              center: .5,
              right: 1,
              bottom: 0,
              middle: .5,
              top: 1
            },
            FROM_TL: {
              left: 0,
              center: .5,
              right: 1,
              bottom: 1,
              middle: .5,
              top: 0
            },
            FROM_BR: {
              left: 1,
              center: .5,
              right: 0,
              bottom: 0,
              middle: .5,
              top: 1
            },
            LINE_SPACING: 1.3,
            CAP_SHIFT: .7,
            MID_SHIFT: .35,
            OPPOSITE_SIDE: {
              left: "right",
              right: "left",
              top: "bottom",
              bottom: "top"
            }
          };
        },
        5081: function (e) {
          "use strict";

          e.exports = {
            axisRefDescription: function (e, t, r) {
              return ["If set to a", e, "axis id (e.g. *" + e + "* or", "*" + e + "2*), the `" + e + "` position refers to a", e, "coordinate. If set to *paper*, the `" + e + "`", "position refers to the distance from the", t, "of the plotting", "area in normalized coordinates where *0* (*1*) corresponds to the", t, "(" + r + "). If set to a", e, "axis ID followed by", "*domain* (separated by a space), the position behaves like for", "*paper*, but refers to the distance in fractions of the domain", "length from the", t, "of the domain of that axis: e.g.,", "*" + e + "2 domain* refers to the domain of the second", e, " axis and a", e, "position of 0.5 refers to the", "point between the", t, "and the", r, "of the domain of the", "second", e, "axis."].join(" ");
            }
          };
        },
        7296: function (e) {
          "use strict";

          e.exports = {
            FORMAT_LINK: "https://github.com/d3/d3-format/tree/v1.4.5#d3-format",
            DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format"
          };
        },
        726: function (e) {
          "use strict";

          e.exports = {
            COMPARISON_OPS: ["=", "!=", "<", ">=", ">", "<="],
            COMPARISON_OPS2: ["=", "<", ">=", ">", "<="],
            INTERVAL_OPS: ["[]", "()", "[)", "(]", "][", ")(", "](", ")["],
            SET_OPS: ["{}", "}{"],
            CONSTRAINT_REDUCTION: {
              "=": "=",
              "<": "<",
              "<=": "<",
              ">": ">",
              ">=": ">",
              "[]": "[]",
              "()": "[]",
              "[)": "[]",
              "(]": "[]",
              "][": "][",
              ")(": "][",
              "](": "][",
              ")[": "]["
            }
          };
        },
        438: function (e) {
          "use strict";

          e.exports = {
            SHOW_PLACEHOLDER: 100,
            HIDE_PLACEHOLDER: 1e3,
            DESELECTDIM: .2
          };
        },
        3821: function (e) {
          "use strict";

          e.exports = {
            BADNUM: void 0,
            FP_SAFE: 1e-4 * Number.MAX_VALUE,
            ONEMAXYEAR: 316224e5,
            ONEAVGYEAR: 315576e5,
            ONEMINYEAR: 31536e6,
            ONEMAXQUARTER: 79488e5,
            ONEAVGQUARTER: 78894e5,
            ONEMINQUARTER: 76896e5,
            ONEMAXMONTH: 26784e5,
            ONEAVGMONTH: 26298e5,
            ONEMINMONTH: 24192e5,
            ONEWEEK: 6048e5,
            ONEDAY: 864e5,
            ONEHOUR: 36e5,
            ONEMIN: 6e4,
            ONESEC: 1e3,
            ONEMILLI: 1,
            ONEMICROSEC: .001,
            EPOCHJD: 2440587.5,
            ALMOST_EQUAL: .999999,
            LOG_CLIP: 10,
            MINUS_SIGN: "−"
          };
        },
        2972: function (e, t) {
          "use strict";

          t.xmlns = "http://www.w3.org/2000/xmlns/", t.svg = "http://www.w3.org/2000/svg", t.xlink = "http://www.w3.org/1999/xlink", t.svgAttrs = {
            xmlns: t.svg,
            "xmlns:xlink": t.xlink
          };
        },
        7430: function (e, t, r) {
          "use strict";

          t.version = r(9697).version, r(1116), r(6713);
          for (var n = r(3626), a = t.register = n.register, i = r(742), o = Object.keys(i), l = 0; l < o.length; l++) {
            var s = o[l];
            "_" !== s.charAt(0) && (t[s] = i[s]), a({
              moduleType: "apiMethod",
              name: s,
              fn: i[s]
            });
          }
          a(r(9693)), a([r(3599), r(3348), r(4844), r(3701), r(5553), r(6230), r(5359), r(5429), r(4453), r(3595), r(7901), r(8856), r(6919), r(2494), r(2141), r(5433)]), a([r(227), r(4611)]), window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (a(window.PlotlyLocales), delete window.PlotlyLocales), t.Icons = r(5188);
          var c = r(2141),
            u = r(4122);
          t.Plots = {
            resize: u.resize,
            graphJson: u.graphJson,
            sendDataToCloud: u.sendDataToCloud
          }, t.Fx = {
            hover: c.hover,
            unhover: c.unhover,
            loneHover: c.loneHover,
            loneUnhover: c.loneUnhover
          }, t.Snapshot = r(6170), t.PlotSchema = r(7297);
        },
        5188: function (e) {
          "use strict";

          e.exports = {
            undo: {
              width: 857.1,
              height: 1e3,
              path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            home: {
              width: 928.6,
              height: 1e3,
              path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            "camera-retro": {
              width: 1e3,
              height: 1e3,
              path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            zoombox: {
              width: 1e3,
              height: 1e3,
              path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            pan: {
              width: 1e3,
              height: 1e3,
              path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            zoom_plus: {
              width: 875,
              height: 1e3,
              path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            zoom_minus: {
              width: 875,
              height: 1e3,
              path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            autoscale: {
              width: 1e3,
              height: 1e3,
              path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            tooltip_basic: {
              width: 1500,
              height: 1e3,
              path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            tooltip_compare: {
              width: 1125,
              height: 1e3,
              path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            plotlylogo: {
              width: 1542,
              height: 1e3,
              path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            "z-axis": {
              width: 1e3,
              height: 1e3,
              path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            "3d_rotate": {
              width: 1e3,
              height: 1e3,
              path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            camera: {
              width: 1e3,
              height: 1e3,
              path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            movie: {
              width: 1e3,
              height: 1e3,
              path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            question: {
              width: 857.1,
              height: 1e3,
              path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            disk: {
              width: 857.1,
              height: 1e3,
              path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            drawopenpath: {
              width: 70,
              height: 70,
              path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z",
              transform: "matrix(1 0 0 1 -15 -15)"
            },
            drawclosedpath: {
              width: 90,
              height: 90,
              path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z",
              transform: "matrix(1 0 0 1 -5 -5)"
            },
            lasso: {
              width: 1031,
              height: 1e3,
              path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            selectbox: {
              width: 1e3,
              height: 1e3,
              path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
              transform: "matrix(1 0 0 -1 0 850)"
            },
            drawline: {
              width: 70,
              height: 70,
              path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z",
              transform: "matrix(1 0 0 1 -15 -15)"
            },
            drawrect: {
              width: 80,
              height: 80,
              path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
              transform: "matrix(1 0 0 1 -10 -10)"
            },
            drawcircle: {
              width: 80,
              height: 80,
              path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z",
              transform: "matrix(1 0 0 1 -10 -10)"
            },
            eraseshape: {
              width: 80,
              height: 80,
              path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z",
              transform: "matrix(1 0 0 1 -10 -10)"
            },
            spikeline: {
              width: 1e3,
              height: 1e3,
              path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
              transform: "matrix(1.5 0 0 -1.5 0 850)"
            },
            pencil: {
              width: 1792,
              height: 1792,
              path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
              transform: "matrix(1 0 0 1 0 1)"
            },
            newplotlylogo: {
              name: "newplotlylogo",
              svg: ["<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'>", "<defs>", " <style>", "  .cls-0{fill:#000;}", "  .cls-1{fill:#FFF;}", "  .cls-2{fill:#F26;}", "  .cls-3{fill:#D69;}", "  .cls-4{fill:#BAC;}", "  .cls-5{fill:#9EF;}", " </style>", "</defs>", " <title>plotly-logomark</title>", " <g id='symbol'>", "  <rect class='cls-0' x='0' y='0' width='132' height='132' rx='18' ry='18'/>", "  <circle class='cls-5' cx='102' cy='30' r='6'/>", "  <circle class='cls-4' cx='78' cy='30' r='6'/>", "  <circle class='cls-4' cx='78' cy='54' r='6'/>", "  <circle class='cls-3' cx='54' cy='30' r='6'/>", "  <circle class='cls-2' cx='30' cy='30' r='6'/>", "  <circle class='cls-2' cx='30' cy='54' r='6'/>", "  <path class='cls-1' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/>", "  <path class='cls-1' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/>", "  <path class='cls-1' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/>", "  <path class='cls-1' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/>", " </g>", "</svg>"].join("")
            }
          };
        },
        2546: function (e, t) {
          "use strict";

          t.isLeftAnchor = function (e) {
            return "left" === e.xanchor || "auto" === e.xanchor && e.x <= 1 / 3;
          }, t.isCenterAnchor = function (e) {
            return "center" === e.xanchor || "auto" === e.xanchor && e.x > 1 / 3 && e.x < 2 / 3;
          }, t.isRightAnchor = function (e) {
            return "right" === e.xanchor || "auto" === e.xanchor && e.x >= 2 / 3;
          }, t.isTopAnchor = function (e) {
            return "top" === e.yanchor || "auto" === e.yanchor && e.y >= 2 / 3;
          }, t.isMiddleAnchor = function (e) {
            return "middle" === e.yanchor || "auto" === e.yanchor && e.y > 1 / 3 && e.y < 2 / 3;
          }, t.isBottomAnchor = function (e) {
            return "bottom" === e.yanchor || "auto" === e.yanchor && e.y <= 1 / 3;
          };
        },
        4313: function (e, t, r) {
          "use strict";

          var n = r(8953),
            a = n.mod,
            i = n.modHalf,
            o = Math.PI,
            l = 2 * o;
          function s(e) {
            return Math.abs(e[1] - e[0]) > l - 1e-14;
          }
          function c(e, t) {
            return i(t - e, l);
          }
          function u(e, t) {
            if (s(t)) return !0;
            var r, n;
            t[0] < t[1] ? (r = t[0], n = t[1]) : (r = t[1], n = t[0]), (r = a(r, l)) > (n = a(n, l)) && (n += l);
            var i = a(e, l),
              o = i + l;
            return i >= r && i <= n || o >= r && o <= n;
          }
          function f(e, t, r, n, a, i, c) {
            a = a || 0, i = i || 0;
            var u,
              f,
              d,
              h,
              p,
              v = s([r, n]);
            function g(e, t) {
              return [e * Math.cos(t) + a, i - e * Math.sin(t)];
            }
            v ? (u = 0, f = o, d = l) : r < n ? (u = r, d = n) : (u = n, d = r), e < t ? (h = e, p = t) : (h = t, p = e);
            var m,
              y = Math.abs(d - u) <= o ? 0 : 1;
            function x(e, t, r) {
              return "A" + [e, e] + " " + [0, y, r] + " " + g(e, t);
            }
            return v ? m = null === h ? "M" + g(p, u) + x(p, f, 0) + x(p, d, 0) + "Z" : "M" + g(h, u) + x(h, f, 0) + x(h, d, 0) + "ZM" + g(p, u) + x(p, f, 1) + x(p, d, 1) + "Z" : null === h ? (m = "M" + g(p, u) + x(p, d, 0), c && (m += "L0,0Z")) : m = "M" + g(h, u) + "L" + g(p, u) + x(p, d, 0) + "L" + g(h, d) + x(h, u, 1) + "Z", m;
          }
          e.exports = {
            deg2rad: function (e) {
              return e / 180 * o;
            },
            rad2deg: function (e) {
              return e / o * 180;
            },
            angleDelta: c,
            angleDist: function (e, t) {
              return Math.abs(c(e, t));
            },
            isFullCircle: s,
            isAngleInsideSector: u,
            isPtInsideSector: function (e, t, r, n) {
              return !!u(t, n) && (r[0] < r[1] ? (a = r[0], i = r[1]) : (a = r[1], i = r[0]), e >= a && e <= i);
              var a, i;
            },
            pathArc: function (e, t, r, n, a) {
              return f(null, e, t, r, n, a, 0);
            },
            pathSector: function (e, t, r, n, a) {
              return f(null, e, t, r, n, a, 1);
            },
            pathAnnulus: function (e, t, r, n, a, i) {
              return f(e, t, r, n, a, i, 1);
            }
          };
        },
        7800: function (e, t, r) {
          "use strict";

          var n = r(3229).decode,
            a = r(6174),
            i = Array.isArray,
            o = ArrayBuffer,
            l = DataView;
          function s(e) {
            return o.isView(e) && !(e instanceof l);
          }
          function c(e) {
            return i(e) || s(e);
          }
          t.isTypedArray = s, t.isArrayOrTypedArray = c, t.isArray1D = function (e) {
            return !c(e[0]);
          }, t.ensureArray = function (e, t) {
            return i(e) || (e = []), e.length = t, e;
          };
          var u = {
            u1c: "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
            i1: "undefined" == typeof Int8Array ? void 0 : Int8Array,
            u1: "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
            i2: "undefined" == typeof Int16Array ? void 0 : Int16Array,
            u2: "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
            i4: "undefined" == typeof Int32Array ? void 0 : Int32Array,
            u4: "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
            f4: "undefined" == typeof Float32Array ? void 0 : Float32Array,
            f8: "undefined" == typeof Float64Array ? void 0 : Float64Array
          };
          function f(e) {
            return e.constructor === ArrayBuffer;
          }
          function d(e, t, r) {
            if (c(e)) {
              if (c(e[0])) {
                for (var n = r, a = 0; a < e.length; a++) n = t(n, e[a].length);
                return n;
              }
              return e.length;
            }
            return 0;
          }
          u.uint8c = u.u1c, u.uint8 = u.u1, u.int8 = u.i1, u.uint16 = u.u2, u.int16 = u.i2, u.uint32 = u.u4, u.int32 = u.i4, u.float32 = u.f4, u.float64 = u.f8, t.isArrayBuffer = f, t.decodeTypedArraySpec = function (e) {
            var t = [],
              r = function (e) {
                return {
                  bdata: e.bdata,
                  dtype: e.dtype,
                  shape: e.shape
                };
              }(e),
              a = r.dtype,
              i = u[a];
            if (!i) throw new Error('Error in dtype: "' + a + '"');
            var o = i.BYTES_PER_ELEMENT,
              l = r.bdata;
            f(l) || (l = n(l));
            var s = void 0 === r.shape ? [l.byteLength / o] : ("" + r.shape).split(",");
            s.reverse();
            var c,
              d,
              h = s.length,
              p = +s[0],
              v = o * p,
              g = 0;
            if (1 === h) t = new i(l);else if (2 === h) for (c = +s[1], d = 0; d < c; d++) t[d] = new i(l, g, p), g += v;else {
              if (3 !== h) throw new Error("ndim: " + h + 'is not supported with the shape:"' + r.shape + '"');
              c = +s[1];
              for (var m = +s[2], y = 0; y < m; y++) for (t[y] = [], d = 0; d < c; d++) t[y][d] = new i(l, g, p), g += v;
            }
            return t.bdata = r.bdata, t.dtype = r.dtype, t.shape = s.reverse().join(","), e._inputArray = t, t;
          }, t.isTypedArraySpec = function (e) {
            return a(e) && e.hasOwnProperty("dtype") && "string" == typeof e.dtype && e.hasOwnProperty("bdata") && ("string" == typeof e.bdata || f(e.bdata)) && (void 0 === e.shape || e.hasOwnProperty("shape") && ("string" == typeof e.shape || "number" == typeof e.shape));
          }, t.concat = function () {
            var e,
              t,
              r,
              n,
              a,
              o,
              l,
              s,
              c = [],
              u = !0,
              f = 0;
            for (r = 0; r < arguments.length; r++) (o = (n = arguments[r]).length) && (t ? c.push(n) : (t = n, a = o), i(n) ? e = !1 : (u = !1, f ? e !== n.constructor && (e = !1) : e = n.constructor), f += o);
            if (!f) return [];
            if (!c.length) return t;
            if (u) return t.concat.apply(t, c);
            if (e) {
              for ((l = new e(f)).set(t), r = 0; r < c.length; r++) n = c[r], l.set(n, a), a += n.length;
              return l;
            }
            for (l = new Array(f), s = 0; s < t.length; s++) l[s] = t[s];
            for (r = 0; r < c.length; r++) {
              for (n = c[r], s = 0; s < n.length; s++) l[a + s] = n[s];
              a += s;
            }
            return l;
          }, t.maxRowLength = function (e) {
            return d(e, Math.max, 0);
          }, t.minRowLength = function (e) {
            return d(e, Math.min, 1 / 0);
          };
        },
        4498: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(3821).BADNUM,
            i = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
          e.exports = function (e) {
            return "string" == typeof e && (e = e.replace(i, "")), n(e) ? Number(e) : a;
          };
        },
        4823: function (e) {
          "use strict";

          e.exports = function (e) {
            var t = e._fullLayout;
            t._glcanvas && t._glcanvas.size() && t._glcanvas.each(function (e) {
              e.regl && e.regl.clear({
                color: !0,
                depth: !0
              });
            });
          };
        },
        3493: function (e) {
          "use strict";

          e.exports = function (e) {
            e._responsiveChartHandler && (window.removeEventListener("resize", e._responsiveChartHandler), delete e._responsiveChartHandler);
          };
        },
        4220: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(5657),
            i = r(3049).extendFlat,
            o = r(9829),
            l = r(9017),
            s = r(8766),
            c = r(438).DESELECTDIM,
            u = r(5632),
            f = r(694).counter,
            d = r(8953).modHalf,
            h = r(7800).isArrayOrTypedArray,
            p = r(7800).isTypedArraySpec,
            v = r(7800).decodeTypedArraySpec;
          function g(e, r) {
            var n = t.valObjectMeta[r.valType];
            if (r.arrayOk && h(e)) return !0;
            if (n.validateFunction) return n.validateFunction(e, r);
            var a = {},
              i = a,
              o = {
                set: function (e) {
                  i = e;
                }
              };
            return n.coerceFunction(e, o, a, r), i !== a;
          }
          t.valObjectMeta = {
            data_array: {
              coerceFunction: function (e, t, r) {
                t.set(h(e) ? e : p(e) ? v(e) : r);
              }
            },
            enumerated: {
              coerceFunction: function (e, t, r, n) {
                n.coerceNumber && (e = +e), -1 === n.values.indexOf(e) ? t.set(r) : t.set(e);
              },
              validateFunction: function (e, t) {
                t.coerceNumber && (e = +e);
                for (var r = t.values, n = 0; n < r.length; n++) {
                  var a = String(r[n]);
                  if ("/" === a.charAt(0) && "/" === a.charAt(a.length - 1)) {
                    if (new RegExp(a.substr(1, a.length - 2)).test(e)) return !0;
                  } else if (e === r[n]) return !0;
                }
                return !1;
              }
            },
            boolean: {
              coerceFunction: function (e, t, r) {
                !0 === e || !1 === e ? t.set(e) : t.set(r);
              }
            },
            number: {
              coerceFunction: function (e, t, r, a) {
                p(e) && (e = v(e)), !n(e) || void 0 !== a.min && e < a.min || void 0 !== a.max && e > a.max ? t.set(r) : t.set(+e);
              }
            },
            integer: {
              coerceFunction: function (e, t, r, a) {
                -1 === (a.extras || []).indexOf(e) ? (p(e) && (e = v(e)), e % 1 || !n(e) || void 0 !== a.min && e < a.min || void 0 !== a.max && e > a.max ? t.set(r) : t.set(+e)) : t.set(e);
              }
            },
            string: {
              coerceFunction: function (e, t, r, n) {
                if ("string" != typeof e) {
                  var a = "number" == typeof e;
                  !0 !== n.strict && a ? t.set(String(e)) : t.set(r);
                } else n.noBlank && !e ? t.set(r) : t.set(e);
              }
            },
            color: {
              coerceFunction: function (e, t, r) {
                p(e) && (e = v(e)), a(e).isValid() ? t.set(e) : t.set(r);
              }
            },
            colorlist: {
              coerceFunction: function (e, t, r) {
                Array.isArray(e) && e.length && e.every(function (e) {
                  return a(e).isValid();
                }) ? t.set(e) : t.set(r);
              }
            },
            colorscale: {
              coerceFunction: function (e, t, r) {
                t.set(l.get(e, r));
              }
            },
            angle: {
              coerceFunction: function (e, t, r) {
                p(e) && (e = v(e)), "auto" === e ? t.set("auto") : n(e) ? t.set(d(+e, 360)) : t.set(r);
              }
            },
            subplotid: {
              coerceFunction: function (e, t, r, n) {
                var a = n.regex || f(r);
                "string" == typeof e && a.test(e) ? t.set(e) : t.set(r);
              },
              validateFunction: function (e, t) {
                var r = t.dflt;
                return e === r || "string" == typeof e && !!f(r).test(e);
              }
            },
            flaglist: {
              coerceFunction: function (e, t, r, n) {
                if (-1 === (n.extras || []).indexOf(e)) {
                  if ("string" == typeof e) {
                    for (var a = e.split("+"), i = 0; i < a.length;) {
                      var o = a[i];
                      -1 === n.flags.indexOf(o) || a.indexOf(o) < i ? a.splice(i, 1) : i++;
                    }
                    a.length ? t.set(a.join("+")) : t.set(r);
                  } else t.set(r);
                } else t.set(e);
              }
            },
            any: {
              coerceFunction: function (e, t, r) {
                void 0 === e ? t.set(r) : t.set(p(e) ? v(e) : e);
              }
            },
            info_array: {
              coerceFunction: function (e, r, n, a) {
                function i(e, r, n) {
                  var a,
                    i = {
                      set: function (e) {
                        a = e;
                      }
                    };
                  return void 0 === n && (n = r.dflt), t.valObjectMeta[r.valType].coerceFunction(e, i, n, r), a;
                }
                if (p(e) && (e = v(e)), h(e)) {
                  var o,
                    l,
                    s,
                    c,
                    u,
                    f,
                    d = 2 === a.dimensions || "1-2" === a.dimensions && Array.isArray(e) && h(e[0]),
                    g = a.items,
                    m = [],
                    y = Array.isArray(g),
                    x = y && d && h(g[0]),
                    b = d && y && !x,
                    _ = y && !b ? g.length : e.length;
                  if (n = Array.isArray(n) ? n : [], d) for (o = 0; o < _; o++) for (m[o] = [], s = h(e[o]) ? e[o] : [], u = b ? g.length : y ? g[o].length : s.length, l = 0; l < u; l++) c = b ? g[l] : y ? g[o][l] : g, void 0 !== (f = i(s[l], c, (n[o] || [])[l])) && (m[o][l] = f);else for (o = 0; o < _; o++) void 0 !== (f = i(e[o], y ? g[o] : g, n[o])) && (m[o] = f);
                  r.set(m);
                } else r.set(n);
              },
              validateFunction: function (e, t) {
                if (!h(e)) return !1;
                var r = t.items,
                  n = Array.isArray(r),
                  a = 2 === t.dimensions;
                if (!t.freeLength && e.length !== r.length) return !1;
                for (var i = 0; i < e.length; i++) if (a) {
                  if (!h(e[i]) || !t.freeLength && e[i].length !== r[i].length) return !1;
                  for (var o = 0; o < e[i].length; o++) if (!g(e[i][o], n ? r[i][o] : r)) return !1;
                } else if (!g(e[i], n ? r[i] : r)) return !1;
                return !0;
              }
            }
          }, t.coerce = function (e, r, n, a, i) {
            var o = u(n, a).get(),
              l = u(e, a),
              s = u(r, a),
              c = l.get(),
              f = r._template;
            if (void 0 === c && f && (c = u(f, a).get(), f = 0), void 0 === i && (i = o.dflt), o.arrayOk) {
              if (h(c)) return s.set(c), c;
              if (p(c)) return c = v(c), s.set(c), c;
            }
            var d = t.valObjectMeta[o.valType].coerceFunction;
            d(c, s, i, o);
            var m = s.get();
            return f && m === i && !g(c, o) && (d(c = u(f, a).get(), s, i, o), m = s.get()), m;
          }, t.coerce2 = function (e, r, n, a, i) {
            var o = u(e, a),
              l = t.coerce(e, r, n, a, i);
            return null != o.get() && l;
          }, t.coerceFont = function (e, t, r, n) {
            n || (n = {}), r = i({}, r);
            var a = {
              family: e(t + ".family", (r = i(r, n.overrideDflt || {})).family),
              size: e(t + ".size", r.size),
              color: e(t + ".color", r.color),
              weight: e(t + ".weight", r.weight),
              style: e(t + ".style", r.style)
            };
            if (n.noFontVariant || (a.variant = e(t + ".variant", r.variant)), n.noFontLineposition || (a.lineposition = e(t + ".lineposition", r.lineposition)), n.noFontTextcase || (a.textcase = e(t + ".textcase", r.textcase)), !n.noFontShadow) {
              var o = r.shadow;
              "none" === o && n.autoShadowDflt && (o = "auto"), a.shadow = e(t + ".shadow", o);
            }
            return a;
          }, t.coercePattern = function (e, t, r, n) {
            if (e(t + ".shape")) {
              e(t + ".solidity"), e(t + ".size");
              var a = "overlay" === e(t + ".fillmode");
              if (!n) {
                var i = e(t + ".bgcolor", a ? r : void 0);
                e(t + ".fgcolor", a ? s.contrast(i) : r);
              }
              e(t + ".fgopacity", a ? .5 : 1);
            }
          }, t.coerceHoverinfo = function (e, r, n) {
            var a,
              i = r._module.attributes,
              l = i.hoverinfo ? i : o,
              s = l.hoverinfo;
            if (1 === n._dataLength) {
              var c = "all" === s.dflt ? s.flags.slice() : s.dflt.split("+");
              c.splice(c.indexOf("name"), 1), a = c.join("+");
            }
            return t.coerce(e, r, l, "hoverinfo", a);
          }, t.coerceSelectionMarkerOpacity = function (e, t) {
            if (e.marker) {
              var r,
                n,
                a = e.marker.opacity;
              void 0 !== a && (h(a) || e.selected || e.unselected || (r = a, n = c * a), t("selected.marker.opacity", r), t("unselected.marker.opacity", n));
            }
          }, t.validate = g;
        },
        2596: function (e, t, r) {
          "use strict";

          var n,
            a,
            i = r(2696).DC,
            o = r(721),
            l = r(8636),
            s = r(8953).mod,
            c = r(3821),
            u = c.BADNUM,
            f = c.ONEDAY,
            d = c.ONEHOUR,
            h = c.ONEMIN,
            p = c.ONESEC,
            v = c.EPOCHJD,
            g = r(3626),
            m = r(2696).aL,
            y = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m,
            x = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m,
            b = new Date().getFullYear() - 70;
          function _(e) {
            return e && g.componentsRegistry.calendars && "string" == typeof e && "gregorian" !== e;
          }
          function w(e, t) {
            return String(e + Math.pow(10, t)).substr(1);
          }
          t.dateTick0 = function (e, r) {
            var n = function (e, t) {
              return _(e) ? t ? g.getComponentMethod("calendars", "CANONICAL_SUNDAY")[e] : g.getComponentMethod("calendars", "CANONICAL_TICK")[e] : t ? "2000-01-02" : "2000-01-01";
            }(e, !!r);
            if (r < 2) return n;
            var a = t.dateTime2ms(n, e);
            return a += f * (r - 1), t.ms2DateTime(a, 0, e);
          }, t.dfltRange = function (e) {
            return _(e) ? g.getComponentMethod("calendars", "DFLTRANGE")[e] : ["2000-01-01", "2001-01-01"];
          }, t.isJSDate = function (e) {
            return "object" == typeof e && null !== e && "function" == typeof e.getTime;
          }, t.dateTime2ms = function (e, r) {
            if (t.isJSDate(e)) {
              var i = e.getTimezoneOffset() * h,
                o = (e.getUTCMinutes() - e.getMinutes()) * h + (e.getUTCSeconds() - e.getSeconds()) * p + (e.getUTCMilliseconds() - e.getMilliseconds());
              if (o) {
                var l = 3 * h;
                i = i - l / 2 + s(o - i + l / 2, l);
              }
              return (e = Number(e) - i) >= n && e <= a ? e : u;
            }
            if ("string" != typeof e && "number" != typeof e) return u;
            e = String(e);
            var c = _(r),
              m = e.charAt(0);
            !c || "G" !== m && "g" !== m || (e = e.substr(1), r = "");
            var w = c && "chinese" === r.substr(0, 7),
              T = e.match(w ? x : y);
            if (!T) return u;
            var M = T[1],
              k = T[3] || "1",
              A = Number(T[5] || 1),
              L = Number(T[7] || 0),
              S = Number(T[9] || 0),
              C = Number(T[11] || 0);
            if (c) {
              if (2 === M.length) return u;
              var O;
              M = Number(M);
              try {
                var D = g.getComponentMethod("calendars", "getCal")(r);
                if (w) {
                  var P = "i" === k.charAt(k.length - 1);
                  k = parseInt(k, 10), O = D.newDate(M, D.toMonthIndex(M, k, P), A);
                } else O = D.newDate(M, Number(k), A);
              } catch (e) {
                return u;
              }
              return O ? (O.toJD() - v) * f + L * d + S * h + C * p : u;
            }
            M = 2 === M.length ? (Number(M) + 2e3 - b) % 100 + b : Number(M), k -= 1;
            var z = new Date(Date.UTC(2e3, k, A, L, S));
            return z.setUTCFullYear(M), z.getUTCMonth() !== k || z.getUTCDate() !== A ? u : z.getTime() + C * p;
          }, n = t.MIN_MS = t.dateTime2ms("-9999"), a = t.MAX_MS = t.dateTime2ms("9999-12-31 23:59:59.9999"), t.isDateTime = function (e, r) {
            return t.dateTime2ms(e, r) !== u;
          };
          var T = 90 * f,
            M = 3 * d,
            k = 5 * h;
          function A(e, t, r, n, a) {
            if ((t || r || n || a) && (e += " " + w(t, 2) + ":" + w(r, 2), (n || a) && (e += ":" + w(n, 2), a))) {
              for (var i = 4; a % 10 == 0;) i -= 1, a /= 10;
              e += "." + w(a, i);
            }
            return e;
          }
          t.ms2DateTime = function (e, t, r) {
            if ("number" != typeof e || !(e >= n && e <= a)) return u;
            t || (t = 0);
            var i,
              o,
              l,
              c,
              y,
              x,
              b = Math.floor(10 * s(e + .05, 1)),
              w = Math.round(e - b / 10);
            if (_(r)) {
              var L = Math.floor(w / f) + v,
                S = Math.floor(s(e, f));
              try {
                i = g.getComponentMethod("calendars", "getCal")(r).fromJD(L).formatDate("yyyy-mm-dd");
              } catch (e) {
                i = m("G%Y-%m-%d")(new Date(w));
              }
              if ("-" === i.charAt(0)) for (; i.length < 11;) i = "-0" + i.substr(1);else for (; i.length < 10;) i = "0" + i;
              o = t < T ? Math.floor(S / d) : 0, l = t < T ? Math.floor(S % d / h) : 0, c = t < M ? Math.floor(S % h / p) : 0, y = t < k ? S % p * 10 + b : 0;
            } else x = new Date(w), i = m("%Y-%m-%d")(x), o = t < T ? x.getUTCHours() : 0, l = t < T ? x.getUTCMinutes() : 0, c = t < M ? x.getUTCSeconds() : 0, y = t < k ? 10 * x.getUTCMilliseconds() + b : 0;
            return A(i, o, l, c, y);
          }, t.ms2DateTimeLocal = function (e) {
            if (!(e >= n + f && e <= a - f)) return u;
            var t = Math.floor(10 * s(e + .05, 1)),
              r = new Date(Math.round(e - t / 10));
            return A(i("%Y-%m-%d")(r), r.getHours(), r.getMinutes(), r.getSeconds(), 10 * r.getUTCMilliseconds() + t);
          }, t.cleanDate = function (e, r, n) {
            if (e === u) return r;
            if (t.isJSDate(e) || "number" == typeof e && isFinite(e)) {
              if (_(n)) return l.error("JS Dates and milliseconds are incompatible with world calendars", e), r;
              if (!(e = t.ms2DateTimeLocal(+e)) && void 0 !== r) return r;
            } else if (!t.isDateTime(e, n)) return l.error("unrecognized date", e), r;
            return e;
          };
          var L = /%\d?f/g,
            S = /%h/g,
            C = {
              1: "1",
              2: "1",
              3: "2",
              4: "2"
            };
          function O(e, t, r, n) {
            e = e.replace(L, function (e) {
              var r = Math.min(+e.charAt(1) || 6, 6);
              return (t / 1e3 % 1 + 2).toFixed(r).substr(2).replace(/0+$/, "") || "0";
            });
            var a = new Date(Math.floor(t + .05));
            if (e = e.replace(S, function () {
              return C[r("%q")(a)];
            }), _(n)) try {
              e = g.getComponentMethod("calendars", "worldCalFmt")(e, t, n);
            } catch (e) {
              return "Invalid";
            }
            return r(e)(a);
          }
          var D = [59, 59.9, 59.99, 59.999, 59.9999];
          t.formatDate = function (e, t, r, n, a, i) {
            if (a = _(a) && a, !t) if ("y" === r) t = i.year;else if ("m" === r) t = i.month;else {
              if ("d" !== r) return function (e, t) {
                var r = s(e + .05, f),
                  n = w(Math.floor(r / d), 2) + ":" + w(s(Math.floor(r / h), 60), 2);
                if ("M" !== t) {
                  o(t) || (t = 0);
                  var a = (100 + Math.min(s(e / p, 60), D[t])).toFixed(t).substr(1);
                  t > 0 && (a = a.replace(/0+$/, "").replace(/[\.]$/, "")), n += ":" + a;
                }
                return n;
              }(e, r) + "\n" + O(i.dayMonthYear, e, n, a);
              t = i.dayMonth + "\n" + i.year;
            }
            return O(t, e, n, a);
          };
          var P = 3 * f;
          t.incrementMonth = function (e, t, r) {
            r = _(r) && r;
            var n = s(e, f);
            if (e = Math.round(e - n), r) try {
              var a = Math.round(e / f) + v,
                i = g.getComponentMethod("calendars", "getCal")(r),
                o = i.fromJD(a);
              return t % 12 ? i.add(o, t, "m") : i.add(o, t / 12, "y"), (o.toJD() - v) * f + n;
            } catch (t) {
              l.error("invalid ms " + e + " in calendar " + r);
            }
            var c = new Date(e + P);
            return c.setUTCMonth(c.getUTCMonth() + t) + n - P;
          }, t.findExactDates = function (e, t) {
            for (var r, n, a = 0, i = 0, l = 0, s = 0, c = _(t) && g.getComponentMethod("calendars", "getCal")(t), u = 0; u < e.length; u++) if (n = e[u], o(n)) {
              if (!(n % f)) if (c) try {
                1 === (r = c.fromJD(n / f + v)).day() ? 1 === r.month() ? a++ : i++ : l++;
              } catch (e) {} else 1 === (r = new Date(n)).getUTCDate() ? 0 === r.getUTCMonth() ? a++ : i++ : l++;
            } else s++;
            l += i += a;
            var d = e.length - s;
            return {
              exactYears: a / d,
              exactMonths: i / d,
              exactDays: l / d
            };
          };
        },
        5425: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(8636),
            i = r(5236),
            o = r(1191);
          function l(e) {
            var t = e && e.parentNode;
            t && t.removeChild(e);
          }
          function s(e, t, r) {
            var n = "plotly.js-style-" + e,
              i = document.getElementById(n);
            i || ((i = document.createElement("style")).setAttribute("id", n), i.appendChild(document.createTextNode("")), document.head.appendChild(i));
            var o = i.sheet;
            o.insertRule ? o.insertRule(t + "{" + r + "}", 0) : o.addRule ? o.addRule(t, r, 0) : a.warn("addStyleRule failed");
          }
          function c(e) {
            var t = window.getComputedStyle(e, null),
              r = t.getPropertyValue("-webkit-transform") || t.getPropertyValue("-moz-transform") || t.getPropertyValue("-ms-transform") || t.getPropertyValue("-o-transform") || t.getPropertyValue("transform");
            return "none" === r ? null : r.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function (e) {
              return +e;
            });
          }
          function u(e) {
            for (var t = []; f(e);) t.push(e), e = e.parentNode, "function" == typeof ShadowRoot && e instanceof ShadowRoot && (e = e.host);
            return t;
          }
          function f(e) {
            return e && (e instanceof Element || e instanceof HTMLElement);
          }
          e.exports = {
            getGraphDiv: function (e) {
              var t;
              if ("string" == typeof e) {
                if (null === (t = document.getElementById(e))) throw new Error("No DOM element with id '" + e + "' exists on the page.");
                return t;
              }
              if (null == e) throw new Error("DOM element provided is null or undefined");
              return e;
            },
            isPlotDiv: function (e) {
              var t = n.select(e);
              return t.node() instanceof HTMLElement && t.size() && t.classed("js-plotly-plot");
            },
            removeElement: l,
            addStyleRule: function (e, t) {
              s("global", e, t);
            },
            addRelatedStyleRule: s,
            deleteRelatedStyleRule: function (e) {
              var t = "plotly.js-style-" + e,
                r = document.getElementById(t);
              r && l(r);
            },
            getFullTransformMatrix: function (e) {
              var t = u(e),
                r = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
              return t.forEach(function (e) {
                var t = c(e);
                if (t) {
                  var n = i.convertCssMatrix(t);
                  r = o.multiply(r, r, n);
                }
              }), r;
            },
            getElementTransformMatrix: c,
            getElementAndAncestors: u,
            equalDomRects: function (e, t) {
              return e && t && e.top === t.top && e.left === t.left && e.right === t.right && e.bottom === t.bottom;
            }
          };
        },
        8596: function (e, t, r) {
          "use strict";

          var n = r(7683).EventEmitter,
            a = {
              init: function (e) {
                if (e._ev instanceof n) return e;
                var t = new n(),
                  r = new n();
                return e._ev = t, e._internalEv = r, e.on = t.on.bind(t), e.once = t.once.bind(t), e.removeListener = t.removeListener.bind(t), e.removeAllListeners = t.removeAllListeners.bind(t), e._internalOn = r.on.bind(r), e._internalOnce = r.once.bind(r), e._removeInternalListener = r.removeListener.bind(r), e._removeAllInternalListeners = r.removeAllListeners.bind(r), e.emit = function (n, a) {
                  "undefined" != typeof jQuery && jQuery(e).trigger(n, a), t.emit(n, a), r.emit(n, a);
                }, e;
              },
              triggerHandler: function (e, t, r) {
                var n, a;
                "undefined" != typeof jQuery && (n = jQuery(e).triggerHandler(t, r));
                var i = e._ev;
                if (!i) return n;
                var o,
                  l = i._events[t];
                if (!l) return n;
                function s(e) {
                  return e.listener ? (i.removeListener(t, e.listener), e.fired ? void 0 : (e.fired = !0, e.listener.apply(i, [r]))) : e.apply(i, [r]);
                }
                for (l = Array.isArray(l) ? l : [l], o = 0; o < l.length - 1; o++) s(l[o]);
                return a = s(l[o]), void 0 !== n ? n : a;
              },
              purge: function (e) {
                return delete e._ev, delete e.on, delete e.once, delete e.removeListener, delete e.removeAllListeners, delete e.emit, delete e._ev, delete e._internalEv, delete e._internalOn, delete e._internalOnce, delete e._removeInternalListener, delete e._removeAllInternalListeners, e;
              }
            };
          e.exports = a;
        },
        3049: function (e, t, r) {
          "use strict";

          var n = r(6174),
            a = Array.isArray;
          function i(e, t, r, o) {
            var l,
              s,
              c,
              u,
              f,
              d,
              h,
              p = e[0],
              v = e.length;
            if (2 === v && a(p) && a(e[1]) && 0 === p.length) {
              if (h = function (e, t) {
                var r, n;
                for (r = 0; r < e.length; r++) {
                  if (null !== (n = e[r]) && "object" == typeof n) return !1;
                  void 0 !== n && (t[r] = n);
                }
                return !0;
              }(e[1], p), h) return p;
              p.splice(0, p.length);
            }
            for (var g = 1; g < v; g++) for (s in l = e[g]) c = p[s], u = l[s], o && a(u) ? p[s] = u : t && u && (n(u) || (f = a(u))) ? (f ? (f = !1, d = c && a(c) ? c : []) : d = c && n(c) ? c : {}, p[s] = i([d, u], t, r, o)) : (void 0 !== u || r) && (p[s] = u);
            return p;
          }
          t.extendFlat = function () {
            return i(arguments, !1, !1, !1);
          }, t.extendDeep = function () {
            return i(arguments, !0, !1, !1);
          }, t.extendDeepAll = function () {
            return i(arguments, !0, !0, !1);
          }, t.extendDeepNoArrays = function () {
            return i(arguments, !0, !1, !0);
          };
        },
        8965: function (e) {
          "use strict";

          e.exports = function (e) {
            for (var t = {}, r = [], n = 0, a = 0; a < e.length; a++) {
              var i = e[a];
              1 !== t[i] && (t[i] = 1, r[n++] = i);
            }
            return r;
          };
        },
        8926: function (e) {
          "use strict";

          function t(e) {
            return !0 === e.visible;
          }
          function r(e) {
            var t = e[0].trace;
            return !0 === t.visible && 0 !== t._length;
          }
          e.exports = function (e) {
            for (var n, a = (n = e, Array.isArray(n) && Array.isArray(n[0]) && n[0][0] && n[0][0].trace ? r : t), i = [], o = 0; o < e.length; o++) {
              var l = e[o];
              a(l) && i.push(l);
            }
            return i;
          };
        },
        3447: function (e, t, r) {
          "use strict";

          var n,
            a,
            i,
            o = r(8953).mod;
          function l(e, t, r, n, a, i, o, l) {
            var s = r - e,
              c = a - e,
              u = o - a,
              f = n - t,
              d = i - t,
              h = l - i,
              p = s * h - u * f;
            if (0 === p) return null;
            var v = (c * h - u * d) / p,
              g = (c * f - s * d) / p;
            return g < 0 || g > 1 || v < 0 || v > 1 ? null : {
              x: e + s * v,
              y: t + f * v
            };
          }
          function s(e, t, r, n, a) {
            var i = n * e + a * t;
            if (i < 0) return n * n + a * a;
            if (i > r) {
              var o = n - e,
                l = a - t;
              return o * o + l * l;
            }
            var s = n * t - a * e;
            return s * s / r;
          }
          t.segmentsIntersect = l, t.segmentDistance = function (e, t, r, n, a, i, o, c) {
            if (l(e, t, r, n, a, i, o, c)) return 0;
            var u = r - e,
              f = n - t,
              d = o - a,
              h = c - i,
              p = u * u + f * f,
              v = d * d + h * h,
              g = Math.min(s(u, f, p, a - e, i - t), s(u, f, p, o - e, c - t), s(d, h, v, e - a, t - i), s(d, h, v, r - a, n - i));
            return Math.sqrt(g);
          }, t.getTextLocation = function (e, t, r, l) {
            if (e === a && l === i || (n = {}, a = e, i = l), n[r]) return n[r];
            var s = e.getPointAtLength(o(r - l / 2, t)),
              c = e.getPointAtLength(o(r + l / 2, t)),
              u = Math.atan((c.y - s.y) / (c.x - s.x)),
              f = e.getPointAtLength(o(r, t)),
              d = {
                x: (4 * f.x + s.x + c.x) / 6,
                y: (4 * f.y + s.y + c.y) / 6,
                theta: u
              };
            return n[r] = d, d;
          }, t.clearLocationCache = function () {
            a = null;
          }, t.getVisibleSegment = function (e, t, r) {
            var n,
              a,
              i = t.left,
              o = t.right,
              l = t.top,
              s = t.bottom,
              c = 0,
              u = e.getTotalLength(),
              f = u;
            function d(t) {
              var r = e.getPointAtLength(t);
              0 === t ? n = r : t === u && (a = r);
              var c = r.x < i ? i - r.x : r.x > o ? r.x - o : 0,
                f = r.y < l ? l - r.y : r.y > s ? r.y - s : 0;
              return Math.sqrt(c * c + f * f);
            }
            for (var h = d(c); h;) {
              if ((c += h + r) > f) return;
              h = d(c);
            }
            for (h = d(f); h;) {
              if (c > (f -= h + r)) return;
              h = d(f);
            }
            return {
              min: c,
              max: f,
              len: f - c,
              total: u,
              isClosed: 0 === c && f === u && Math.abs(n.x - a.x) < .1 && Math.abs(n.y - a.y) < .1
            };
          }, t.findPointOnPath = function (e, t, r, n) {
            for (var a, i, o, l = (n = n || {}).pathLength || e.getTotalLength(), s = n.tolerance || .001, c = n.iterationLimit || 30, u = e.getPointAtLength(0)[r] > e.getPointAtLength(l)[r] ? -1 : 1, f = 0, d = 0, h = l; f < c;) {
              if (a = (d + h) / 2, o = (i = e.getPointAtLength(a))[r] - t, Math.abs(o) < s) return i;
              u * o > 0 ? h = a : d = a, f++;
            }
            return i;
          };
        },
        9527: function (e) {
          "use strict";

          e.exports = function (e) {
            return e;
          };
        },
        688: function (e) {
          "use strict";

          e.exports = function (e, t) {
            if (!t) return e;
            var r = 1 / Math.abs(t),
              n = r > 1 ? (r * e + r * t) / r : e + t,
              a = String(n).length;
            if (a > 16) {
              var i = String(t).length;
              if (a >= String(e).length + i) {
                var o = parseFloat(n).toPrecision(12);
                -1 === o.indexOf("e+") && (n = +o);
              }
            }
            return n;
          };
        },
        4809: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(2696).aL,
            i = r(6464).GP,
            o = r(721),
            l = r(3821),
            s = l.FP_SAFE,
            c = -s,
            u = l.BADNUM,
            f = e.exports = {};
          f.adjustFormat = function (e) {
            return !e || /^\d[.]\df/.test(e) || /[.]\d%/.test(e) ? e : "0.f" === e ? "~f" : /^\d%/.test(e) ? "~%" : /^\ds/.test(e) ? "~s" : !/^[~,.0$]/.test(e) && /[&fps]/.test(e) ? "~" + e : e;
          };
          var d = {};
          f.warnBadFormat = function (e) {
            var t = String(e);
            d[t] || (d[t] = 1, f.warn('encountered bad format: "' + t + '"'));
          }, f.noFormat = function (e) {
            return String(e);
          }, f.numberFormat = function (e) {
            var t;
            try {
              t = i(f.adjustFormat(e));
            } catch (t) {
              return f.warnBadFormat(e), f.noFormat;
            }
            return t;
          }, f.nestedProperty = r(5632), f.keyedContainer = r(4967), f.relativeAttr = r(2047), f.isPlainObject = r(6174), f.toLogRange = r(8083), f.relinkPrivateKeys = r(428);
          var h = r(7800);
          f.isArrayBuffer = h.isArrayBuffer, f.isTypedArray = h.isTypedArray, f.isArrayOrTypedArray = h.isArrayOrTypedArray, f.isArray1D = h.isArray1D, f.ensureArray = h.ensureArray, f.concat = h.concat, f.maxRowLength = h.maxRowLength, f.minRowLength = h.minRowLength;
          var p = r(8953);
          f.mod = p.mod, f.modHalf = p.modHalf;
          var v = r(4220);
          f.valObjectMeta = v.valObjectMeta, f.coerce = v.coerce, f.coerce2 = v.coerce2, f.coerceFont = v.coerceFont, f.coercePattern = v.coercePattern, f.coerceHoverinfo = v.coerceHoverinfo, f.coerceSelectionMarkerOpacity = v.coerceSelectionMarkerOpacity, f.validate = v.validate;
          var g = r(2596);
          f.dateTime2ms = g.dateTime2ms, f.isDateTime = g.isDateTime, f.ms2DateTime = g.ms2DateTime, f.ms2DateTimeLocal = g.ms2DateTimeLocal, f.cleanDate = g.cleanDate, f.isJSDate = g.isJSDate, f.formatDate = g.formatDate, f.incrementMonth = g.incrementMonth, f.dateTick0 = g.dateTick0, f.dfltRange = g.dfltRange, f.findExactDates = g.findExactDates, f.MIN_MS = g.MIN_MS, f.MAX_MS = g.MAX_MS;
          var m = r(8813);
          f.findBin = m.findBin, f.sorterAsc = m.sorterAsc, f.sorterDes = m.sorterDes, f.distinctVals = m.distinctVals, f.roundUp = m.roundUp, f.sort = m.sort, f.findIndexOfMin = m.findIndexOfMin, f.sortObjectKeys = r(2994);
          var y = r(9258);
          f.aggNums = y.aggNums, f.len = y.len, f.mean = y.mean, f.geometricMean = y.geometricMean, f.median = y.median, f.midRange = y.midRange, f.variance = y.variance, f.stdev = y.stdev, f.interp = y.interp;
          var x = r(5236);
          f.init2dArray = x.init2dArray, f.transposeRagged = x.transposeRagged, f.dot = x.dot, f.translationMatrix = x.translationMatrix, f.rotationMatrix = x.rotationMatrix, f.rotationXYMatrix = x.rotationXYMatrix, f.apply3DTransform = x.apply3DTransform, f.apply2DTransform = x.apply2DTransform, f.apply2DTransform2 = x.apply2DTransform2, f.convertCssMatrix = x.convertCssMatrix, f.inverseTransformMatrix = x.inverseTransformMatrix;
          var b = r(4313);
          f.deg2rad = b.deg2rad, f.rad2deg = b.rad2deg, f.angleDelta = b.angleDelta, f.angleDist = b.angleDist, f.isFullCircle = b.isFullCircle, f.isAngleInsideSector = b.isAngleInsideSector, f.isPtInsideSector = b.isPtInsideSector, f.pathArc = b.pathArc, f.pathSector = b.pathSector, f.pathAnnulus = b.pathAnnulus;
          var _ = r(2546);
          f.isLeftAnchor = _.isLeftAnchor, f.isCenterAnchor = _.isCenterAnchor, f.isRightAnchor = _.isRightAnchor, f.isTopAnchor = _.isTopAnchor, f.isMiddleAnchor = _.isMiddleAnchor, f.isBottomAnchor = _.isBottomAnchor;
          var w = r(3447);
          f.segmentsIntersect = w.segmentsIntersect, f.segmentDistance = w.segmentDistance, f.getTextLocation = w.getTextLocation, f.clearLocationCache = w.clearLocationCache, f.getVisibleSegment = w.getVisibleSegment, f.findPointOnPath = w.findPointOnPath;
          var T = r(3049);
          f.extendFlat = T.extendFlat, f.extendDeep = T.extendDeep, f.extendDeepAll = T.extendDeepAll, f.extendDeepNoArrays = T.extendDeepNoArrays;
          var M = r(8636);
          f.log = M.log, f.warn = M.warn, f.error = M.error;
          var k = r(694);
          f.counterRegex = k.counter;
          var A = r(4025);
          f.throttle = A.throttle, f.throttleDone = A.done, f.clearThrottle = A.clear;
          var L = r(5425);
          function S(e) {
            var t = {};
            for (var r in e) for (var n = e[r], a = 0; a < n.length; a++) t[n[a]] = +r;
            return t;
          }
          f.getGraphDiv = L.getGraphDiv, f.isPlotDiv = L.isPlotDiv, f.removeElement = L.removeElement, f.addStyleRule = L.addStyleRule, f.addRelatedStyleRule = L.addRelatedStyleRule, f.deleteRelatedStyleRule = L.deleteRelatedStyleRule, f.getFullTransformMatrix = L.getFullTransformMatrix, f.getElementTransformMatrix = L.getElementTransformMatrix, f.getElementAndAncestors = L.getElementAndAncestors, f.equalDomRects = L.equalDomRects, f.clearResponsive = r(3493), f.preserveDrawingBuffer = r(2521), f.makeTraceGroups = r(5944), f._ = r(8514), f.notifier = r(7355), f.filterUnique = r(8965), f.filterVisible = r(8926), f.pushUnique = r(6539), f.increment = r(688), f.cleanNumber = r(4498), f.ensureNumber = function (e) {
            return o(e) ? (e = Number(e)) > s || e < c ? u : e : u;
          }, f.isIndex = function (e, t) {
            return !(void 0 !== t && e >= t) && o(e) && e >= 0 && e % 1 == 0;
          }, f.noop = r(4969), f.identity = r(9527), f.repeat = function (e, t) {
            for (var r = new Array(t), n = 0; n < t; n++) r[n] = e;
            return r;
          }, f.swapAttrs = function (e, t, r, n) {
            r || (r = "x"), n || (n = "y");
            for (var a = 0; a < t.length; a++) {
              var i = t[a],
                o = f.nestedProperty(e, i.replace("?", r)),
                l = f.nestedProperty(e, i.replace("?", n)),
                s = o.get();
              o.set(l.get()), l.set(s);
            }
          }, f.raiseToTop = function (e) {
            e.parentNode.appendChild(e);
          }, f.cancelTransition = function (e) {
            return e.transition().duration(0);
          }, f.constrain = function (e, t, r) {
            return t > r ? Math.max(r, Math.min(t, e)) : Math.max(t, Math.min(r, e));
          }, f.bBoxIntersect = function (e, t, r) {
            return r = r || 0, e.left <= t.right + r && t.left <= e.right + r && e.top <= t.bottom + r && t.top <= e.bottom + r;
          }, f.simpleMap = function (e, t, r, n, a) {
            for (var i = e.length, o = new Array(i), l = 0; l < i; l++) o[l] = t(e[l], r, n, a);
            return o;
          }, f.randstr = function e(t, r, n, a) {
            if (n || (n = 16), void 0 === r && (r = 24), r <= 0) return "0";
            var i,
              o,
              l = Math.log(Math.pow(2, r)) / Math.log(n),
              s = "";
            for (i = 2; l === 1 / 0; i *= 2) l = Math.log(Math.pow(2, r / i)) / Math.log(n) * i;
            var c = l - Math.floor(l);
            for (i = 0; i < Math.floor(l); i++) s = Math.floor(Math.random() * n).toString(n) + s;
            c && (o = Math.pow(n, c), s = Math.floor(Math.random() * o).toString(n) + s);
            var u = parseInt(s, n);
            return t && t[s] || u !== 1 / 0 && u >= Math.pow(2, r) ? a > 10 ? (f.warn("randstr failed uniqueness"), s) : e(t, r, n, (a || 0) + 1) : s;
          }, f.OptionControl = function (e, t) {
            e || (e = {}), t || (t = "opt");
            var r = {
              optionList: [],
              _newoption: function (n) {
                n[t] = e, r[n.name] = n, r.optionList.push(n);
              }
            };
            return r["_" + t] = e, r;
          }, f.smooth = function (e, t) {
            if ((t = Math.round(t) || 0) < 2) return e;
            var r,
              n,
              a,
              i,
              o = e.length,
              l = 2 * o,
              s = 2 * t - 1,
              c = new Array(s),
              u = new Array(o);
            for (r = 0; r < s; r++) c[r] = (1 - Math.cos(Math.PI * (r + 1) / t)) / (2 * t);
            for (r = 0; r < o; r++) {
              for (i = 0, n = 0; n < s; n++) (a = r + n + 1 - t) < -o ? a -= l * Math.round(a / l) : a >= l && (a -= l * Math.floor(a / l)), a < 0 ? a = -1 - a : a >= o && (a = l - 1 - a), i += e[a] * c[n];
              u[r] = i;
            }
            return u;
          }, f.syncOrAsync = function (e, t, r) {
            var n;
            function a() {
              return f.syncOrAsync(e, t, r);
            }
            for (; e.length;) if ((n = (0, e.splice(0, 1)[0])(t)) && n.then) return n.then(a);
            return r && r(t);
          }, f.stripTrailingSlash = function (e) {
            return "/" === e.substr(-1) ? e.substr(0, e.length - 1) : e;
          }, f.noneOrAll = function (e, t, r) {
            if (e) {
              var n,
                a = !1,
                i = !0;
              for (n = 0; n < r.length; n++) null != e[r[n]] ? a = !0 : i = !1;
              if (a && !i) for (n = 0; n < r.length; n++) e[r[n]] = t[r[n]];
            }
          }, f.mergeArray = function (e, t, r, n) {
            var a = "function" == typeof n;
            if (f.isArrayOrTypedArray(e)) for (var i = Math.min(e.length, t.length), o = 0; o < i; o++) {
              var l = e[o];
              t[o][r] = a ? n(l) : l;
            }
          }, f.mergeArrayCastPositive = function (e, t, r) {
            return f.mergeArray(e, t, r, function (e) {
              var t = +e;
              return isFinite(t) && t > 0 ? t : 0;
            });
          }, f.fillArray = function (e, t, r, n) {
            if (n = n || f.identity, f.isArrayOrTypedArray(e)) for (var a = 0; a < t.length; a++) t[a][r] = n(e[a]);
          }, f.castOption = function (e, t, r, n) {
            n = n || f.identity;
            var a = f.nestedProperty(e, r).get();
            return f.isArrayOrTypedArray(a) ? Array.isArray(t) && f.isArrayOrTypedArray(a[t[0]]) ? n(a[t[0]][t[1]]) : n(a[t]) : a;
          }, f.extractOption = function (e, t, r, n) {
            if (r in e) return e[r];
            var a = f.nestedProperty(t, n).get();
            return Array.isArray(a) ? void 0 : a;
          }, f.tagSelected = function (e, t, r) {
            var n,
              a,
              i = t.selectedpoints,
              o = t._indexToPoints;
            o && (n = S(o));
            for (var l = 0; l < i.length; l++) {
              var s = i[l];
              if (f.isIndex(s) || f.isArrayOrTypedArray(s) && f.isIndex(s[0]) && f.isIndex(s[1])) {
                var c = n ? n[s] : s,
                  u = r ? r[c] : c;
                void 0 !== (a = u) && a < e.length && (e[u].selected = 1);
              }
            }
          }, f.selIndices2selPoints = function (e) {
            var t = e.selectedpoints,
              r = e._indexToPoints;
            if (r) {
              for (var n = S(r), a = [], i = 0; i < t.length; i++) {
                var o = t[i];
                if (f.isIndex(o)) {
                  var l = n[o];
                  f.isIndex(l) && a.push(l);
                }
              }
              return a;
            }
            return t;
          }, f.getTargetArray = function (e, t) {
            var r = t.target;
            if ("string" == typeof r && r) {
              var n = f.nestedProperty(e, r).get();
              return !!f.isArrayOrTypedArray(n) && n;
            }
            return !!f.isArrayOrTypedArray(r) && r;
          }, f.minExtend = function e(t, r, n) {
            var a = {};
            "object" != typeof r && (r = {});
            var i,
              o,
              l,
              s = "pieLike" === n ? -1 : 3,
              c = Object.keys(t);
            for (i = 0; i < c.length; i++) l = t[o = c[i]], "_" !== o.charAt(0) && "function" != typeof l && ("module" === o ? a[o] = l : Array.isArray(l) ? a[o] = "colorscale" === o || -1 === s ? l.slice() : l.slice(0, s) : f.isTypedArray(l) ? a[o] = -1 === s ? l.subarray() : l.subarray(0, s) : a[o] = l && "object" == typeof l ? e(t[o], r[o], n) : l);
            for (c = Object.keys(r), i = 0; i < c.length; i++) "object" == typeof (l = r[o = c[i]]) && o in a && "object" == typeof a[o] || (a[o] = l);
            return a;
          }, f.titleCase = function (e) {
            return e.charAt(0).toUpperCase() + e.substr(1);
          }, f.containsAny = function (e, t) {
            for (var r = 0; r < t.length; r++) if (-1 !== e.indexOf(t[r])) return !0;
            return !1;
          }, f.isIE = function () {
            return void 0 !== window.navigator.msSaveBlob;
          };
          var C = /Version\/[\d\.]+.*Safari/;
          f.isSafari = function () {
            return C.test(window.navigator.userAgent);
          };
          var O = /iPad|iPhone|iPod/;
          f.isIOS = function () {
            return O.test(window.navigator.userAgent);
          };
          var D = /Firefox\/(\d+)\.\d+/;
          f.getFirefoxVersion = function () {
            var e = D.exec(window.navigator.userAgent);
            if (e && 2 === e.length) {
              var t = parseInt(e[1]);
              if (!isNaN(t)) return t;
            }
            return null;
          }, f.isD3Selection = function (e) {
            return e instanceof n.selection;
          }, f.ensureSingle = function (e, t, r, n) {
            var a = e.select(t + (r ? "." + r : ""));
            if (a.size()) return a;
            var i = e.append(t);
            return r && i.classed(r, !0), n && i.call(n), i;
          }, f.ensureSingleById = function (e, t, r, n) {
            var a = e.select(t + "#" + r);
            if (a.size()) return a;
            var i = e.append(t).attr("id", r);
            return n && i.call(n), i;
          }, f.objectFromPath = function (e, t) {
            for (var r, n = e.split("."), a = r = {}, i = 0; i < n.length; i++) {
              var o = n[i],
                l = null,
                s = n[i].match(/(.*)\[([0-9]+)\]/);
              s ? (o = s[1], l = s[2], r = r[o] = [], i === n.length - 1 ? r[l] = t : r[l] = {}, r = r[l]) : (i === n.length - 1 ? r[o] = t : r[o] = {}, r = r[o]);
            }
            return a;
          };
          var P = /^([^\[\.]+)\.(.+)?/,
            z = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
          function I(e) {
            return "__" === e.slice(0, 2);
          }
          f.expandObjectPaths = function (e) {
            var t, r, n, a, i, o, l;
            if ("object" == typeof e && !Array.isArray(e)) for (r in e) if (e.hasOwnProperty(r)) if (t = r.match(P)) {
              if (a = e[r], I(n = t[1])) continue;
              delete e[r], e[n] = f.extendDeepNoArrays(e[n] || {}, f.objectFromPath(r, f.expandObjectPaths(a))[n]);
            } else if (t = r.match(z)) {
              if (a = e[r], I(n = t[1])) continue;
              if (i = parseInt(t[2]), delete e[r], e[n] = e[n] || [], "." === t[3]) l = t[4], o = e[n][i] = e[n][i] || {}, f.extendDeepNoArrays(o, f.objectFromPath(l, f.expandObjectPaths(a)));else {
                if (I(n)) continue;
                e[n][i] = f.expandObjectPaths(a);
              }
            } else {
              if (I(r)) continue;
              e[r] = f.expandObjectPaths(e[r]);
            }
            return e;
          }, f.numSeparate = function (e, t, r) {
            if (r || (r = !1), "string" != typeof t || 0 === t.length) throw new Error("Separator string required for formatting!");
            "number" == typeof e && (e = String(e));
            var n = /(\d+)(\d{3})/,
              a = t.charAt(0),
              i = t.charAt(1),
              o = e.split("."),
              l = o[0],
              s = o.length > 1 ? a + o[1] : "";
            if (i && (o.length > 1 || l.length > 4 || r)) for (; n.test(l);) l = l.replace(n, "$1" + i + "$2");
            return l + s;
          }, f.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
          var E = /^\w*$/;
          f.templateString = function (e, t) {
            var r = {};
            return e.replace(f.TEMPLATE_STRING_REGEX, function (e, n) {
              var a;
              return E.test(n) ? a = t[n] : (r[n] = r[n] || f.nestedProperty(t, n).get, a = r[n]()), f.isValidTextValue(a) ? a : "";
            });
          };
          var R = {
            max: 10,
            count: 0,
            name: "hovertemplate"
          };
          f.hovertemplateString = function () {
            return j.apply(R, arguments);
          };
          var N = {
            max: 10,
            count: 0,
            name: "texttemplate"
          };
          f.texttemplateString = function () {
            return j.apply(N, arguments);
          };
          var F = /^(\S+)([\*\/])(-?\d+(\.\d+)?)$/,
            H = {
              max: 10,
              count: 0,
              name: "texttemplate",
              parseMultDiv: !0
            };
          f.texttemplateStringForShapes = function () {
            return j.apply(H, arguments);
          };
          var B = /^[:|\|]/;
          function j(e, t, r) {
            var n = this,
              i = arguments;
            t || (t = {});
            var o = {};
            return e.replace(f.TEMPLATE_STRING_REGEX, function (e, l, s) {
              var c = "_xother" === l || "_yother" === l,
                u = "_xother_" === l || "_yother_" === l,
                d = "xother_" === l || "yother_" === l,
                h = "xother" === l || "yother" === l || c || d || u,
                p = l;
              (c || u) && (p = p.substring(1)), (d || u) && (p = p.substring(0, p.length - 1));
              var v,
                g,
                m,
                y = null,
                x = null;
              if (n.parseMultDiv) {
                var b = function (e) {
                  var t = e.match(F);
                  return t ? {
                    key: t[1],
                    op: t[2],
                    number: Number(t[3])
                  } : {
                    key: e,
                    op: null,
                    number: null
                  };
                }(p);
                p = b.key, y = b.op, x = b.number;
              }
              if (h) {
                if (void 0 === (v = t[p])) return "";
              } else for (m = 3; m < i.length; m++) if (g = i[m]) {
                if (g.hasOwnProperty(p)) {
                  v = g[p];
                  break;
                }
                if (E.test(p) || (v = f.nestedProperty(g, p).get(), (v = o[p] || f.nestedProperty(g, p).get()) && (o[p] = v)), void 0 !== v) break;
              }
              if (void 0 !== v && ("*" === y && (v *= x), "/" === y && (v /= x)), void 0 === v && n) return n.count < n.max && (f.warn("Variable '" + p + "' in " + n.name + " could not be found!"), v = e), n.count === n.max && f.warn("Too many " + n.name + " warnings - additional warnings will be suppressed"), n.count++, e;
              if (s) {
                var _;
                if (":" === s[0] && (_ = r ? r.numberFormat : f.numberFormat, "" !== v && (v = _(s.replace(B, ""))(v))), "|" === s[0]) {
                  _ = r ? r.timeFormat : a;
                  var w = f.dateTime2ms(v);
                  v = f.formatDate(w, s.replace(B, ""), !1, _);
                }
              } else {
                var T = p + "Label";
                t.hasOwnProperty(T) && (v = t[T]);
              }
              return h && (v = "(" + v + ")", (c || u) && (v = " " + v), (d || u) && (v += " ")), v;
            });
          }
          f.subplotSort = function (e, t) {
            for (var r = Math.min(e.length, t.length) + 1, n = 0, a = 0, i = 0; i < r; i++) {
              var o = e.charCodeAt(i) || 0,
                l = t.charCodeAt(i) || 0,
                s = o >= 48 && o <= 57,
                c = l >= 48 && l <= 57;
              if (s && (n = 10 * n + o - 48), c && (a = 10 * a + l - 48), !s || !c) {
                if (n !== a) return n - a;
                if (o !== l) return o - l;
              }
            }
            return a - n;
          };
          var Y = 2e9;
          f.seedPseudoRandom = function () {
            Y = 2e9;
          }, f.pseudoRandom = function () {
            var e = Y;
            return Y = (69069 * Y + 1) % 4294967296, Math.abs(Y - e) < 429496729 ? f.pseudoRandom() : Y / 4294967296;
          }, f.fillText = function (e, t, r) {
            var n = Array.isArray(r) ? function (e) {
                r.push(e);
              } : function (e) {
                r.text = e;
              },
              a = f.extractOption(e, t, "htx", "hovertext");
            if (f.isValidTextValue(a)) return n(a);
            var i = f.extractOption(e, t, "tx", "text");
            return f.isValidTextValue(i) ? n(i) : void 0;
          }, f.isValidTextValue = function (e) {
            return e || 0 === e;
          }, f.formatPercent = function (e, t) {
            t = t || 0;
            for (var r = (Math.round(100 * e * Math.pow(10, t)) * Math.pow(.1, t)).toFixed(t) + "%", n = 0; n < t; n++) -1 !== r.indexOf(".") && (r = (r = r.replace("0%", "%")).replace(".%", "%"));
            return r;
          }, f.isHidden = function (e) {
            var t = window.getComputedStyle(e).display;
            return !t || "none" === t;
          }, f.strTranslate = function (e, t) {
            return e || t ? "translate(" + e + "," + t + ")" : "";
          }, f.strRotate = function (e) {
            return e ? "rotate(" + e + ")" : "";
          }, f.strScale = function (e) {
            return 1 !== e ? "scale(" + e + ")" : "";
          }, f.getTextTransform = function (e) {
            var t = e.noCenter,
              r = e.textX,
              n = e.textY,
              a = e.targetX,
              i = e.targetY,
              o = e.anchorX || 0,
              l = e.anchorY || 0,
              s = e.rotate,
              c = e.scale;
            return c ? c > 1 && (c = 1) : c = 0, f.strTranslate(a - c * (r + o), i - c * (n + l)) + f.strScale(c) + (s ? "rotate(" + s + (t ? "" : " " + r + " " + n) + ")" : "");
          }, f.setTransormAndDisplay = function (e, t) {
            e.attr("transform", f.getTextTransform(t)), e.style("display", t.scale ? null : "none");
          }, f.ensureUniformFontSize = function (e, t) {
            var r = f.extendFlat({}, t);
            return r.size = Math.max(t.size, e._fullLayout.uniformtext.minsize || 0), r;
          }, f.join2 = function (e, t, r) {
            var n = e.length;
            return n > 1 ? e.slice(0, -1).join(t) + r + e[n - 1] : e.join(t);
          }, f.bigFont = function (e) {
            return Math.round(1.2 * e);
          };
          var V = f.getFirefoxVersion(),
            U = null !== V && V < 86;
          f.getPositionFromD3Event = function () {
            return U ? [n.event.layerX, n.event.layerY] : [n.event.offsetX, n.event.offsetY];
          };
        },
        6174: function (e) {
          "use strict";

          e.exports = function (e) {
            return window && window.process && window.process.versions ? "[object Object]" === Object.prototype.toString.call(e) : "[object Object]" === Object.prototype.toString.call(e) && Object.getPrototypeOf(e).hasOwnProperty("hasOwnProperty");
          };
        },
        4967: function (e, t, r) {
          "use strict";

          var n = r(5632),
            a = /^\w*$/;
          e.exports = function (e, t, r, i) {
            var o, l, s;
            r = r || "name", i = i || "value";
            var c = {};
            t && t.length ? (s = n(e, t), l = s.get()) : l = e, t = t || "";
            var u = {};
            if (l) for (o = 0; o < l.length; o++) u[l[o][r]] = o;
            var f = a.test(i),
              d = {
                set: function (e, t) {
                  var a = null === t ? 4 : 0;
                  if (!l) {
                    if (!s || 4 === a) return;
                    l = [], s.set(l);
                  }
                  var o = u[e];
                  if (void 0 === o) {
                    if (4 === a) return;
                    a |= 3, o = l.length, u[e] = o;
                  } else t !== (f ? l[o][i] : n(l[o], i).get()) && (a |= 2);
                  var h = l[o] = l[o] || {};
                  return h[r] = e, f ? h[i] = t : n(h, i).set(t), null !== t && (a &= -5), c[o] = c[o] | a, d;
                },
                get: function (e) {
                  if (l) {
                    var t = u[e];
                    return void 0 === t ? void 0 : f ? l[t][i] : n(l[t], i).get();
                  }
                },
                rename: function (e, t) {
                  var n = u[e];
                  return void 0 === n || (c[n] = 1 | c[n], u[t] = n, delete u[e], l[n][r] = t), d;
                },
                remove: function (e) {
                  var t = u[e];
                  if (void 0 === t) return d;
                  var a = l[t];
                  if (Object.keys(a).length > 2) return c[t] = 2 | c[t], d.set(e, null);
                  if (f) {
                    for (o = t; o < l.length; o++) c[o] = 3 | c[o];
                    for (o = t; o < l.length; o++) u[l[o][r]]--;
                    l.splice(t, 1), delete u[e];
                  } else n(a, i).set(null), c[t] = 6 | c[t];
                  return d;
                },
                constructUpdate: function () {
                  for (var e, a, o = {}, s = Object.keys(c), u = 0; u < s.length; u++) a = s[u], e = t + "[" + a + "]", l[a] ? (1 & c[a] && (o[e + "." + r] = l[a][r]), 2 & c[a] && (o[e + "." + i] = f ? 4 & c[a] ? null : l[a][i] : 4 & c[a] ? null : n(l[a], i).get())) : o[e] = null;
                  return o;
                }
              };
            return d;
          };
        },
        8514: function (e, t, r) {
          "use strict";

          var n = r(3626);
          e.exports = function (e, t) {
            for (var r = e._context.locale, a = 0; a < 2; a++) {
              for (var i = e._context.locales, o = 0; o < 2; o++) {
                var l = (i[r] || {}).dictionary;
                if (l) {
                  var s = l[t];
                  if (s) return s;
                }
                i = n.localeRegistry;
              }
              var c = r.split("-")[0];
              if (c === r) break;
              r = c;
            }
            return t;
          };
        },
        8636: function (e, t, r) {
          "use strict";

          var n = r(4452).dfltConfig,
            a = r(7355),
            i = e.exports = {};
          i.log = function () {
            var e;
            if (n.logging > 1) {
              var t = ["LOG:"];
              for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
              console.trace.apply(console, t);
            }
            if (n.notifyOnLogging > 1) {
              var r = [];
              for (e = 0; e < arguments.length; e++) r.push(arguments[e]);
              a(r.join("<br>"), "long");
            }
          }, i.warn = function () {
            var e;
            if (n.logging > 0) {
              var t = ["WARN:"];
              for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
              console.trace.apply(console, t);
            }
            if (n.notifyOnLogging > 0) {
              var r = [];
              for (e = 0; e < arguments.length; e++) r.push(arguments[e]);
              a(r.join("<br>"), "stick");
            }
          }, i.error = function () {
            var e;
            if (n.logging > 0) {
              var t = ["ERROR:"];
              for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
              console.error.apply(console, t);
            }
            if (n.notifyOnLogging > 0) {
              var r = [];
              for (e = 0; e < arguments.length; e++) r.push(arguments[e]);
              a(r.join("<br>"), "stick");
            }
          };
        },
        5944: function (e, t, r) {
          "use strict";

          var n = r(5568);
          e.exports = function (e, t, r) {
            var a = e.selectAll("g." + r.replace(/\s/g, ".")).data(t, function (e) {
              return e[0].trace.uid;
            });
            a.exit().remove(), a.enter().append("g").attr("class", r), a.order();
            var i = e.classed("rangeplot") ? "nodeRangePlot3" : "node3";
            return a.each(function (e) {
              e[0][i] = n.select(this);
            }), a;
          };
        },
        5236: function (e, t, r) {
          "use strict";

          var n = r(1191);
          t.init2dArray = function (e, t) {
            for (var r = new Array(e), n = 0; n < e; n++) r[n] = new Array(t);
            return r;
          }, t.transposeRagged = function (e) {
            var t,
              r,
              n = 0,
              a = e.length;
            for (t = 0; t < a; t++) n = Math.max(n, e[t].length);
            var i = new Array(n);
            for (t = 0; t < n; t++) for (i[t] = new Array(a), r = 0; r < a; r++) i[t][r] = e[r][t];
            return i;
          }, t.dot = function (e, r) {
            if (!e.length || !r.length || e.length !== r.length) return null;
            var n,
              a,
              i = e.length;
            if (e[0].length) for (n = new Array(i), a = 0; a < i; a++) n[a] = t.dot(e[a], r);else if (r[0].length) {
              var o = t.transposeRagged(r);
              for (n = new Array(o.length), a = 0; a < o.length; a++) n[a] = t.dot(e, o[a]);
            } else for (n = 0, a = 0; a < i; a++) n += e[a] * r[a];
            return n;
          }, t.translationMatrix = function (e, t) {
            return [[1, 0, e], [0, 1, t], [0, 0, 1]];
          }, t.rotationMatrix = function (e) {
            var t = e * Math.PI / 180;
            return [[Math.cos(t), -Math.sin(t), 0], [Math.sin(t), Math.cos(t), 0], [0, 0, 1]];
          }, t.rotationXYMatrix = function (e, r, n) {
            return t.dot(t.dot(t.translationMatrix(r, n), t.rotationMatrix(e)), t.translationMatrix(-r, -n));
          }, t.apply3DTransform = function (e) {
            return function () {
              var r = arguments,
                n = 1 === arguments.length ? r[0] : [r[0], r[1], r[2] || 0];
              return t.dot(e, [n[0], n[1], n[2], 1]).slice(0, 3);
            };
          }, t.apply2DTransform = function (e) {
            return function () {
              var r = arguments;
              3 === r.length && (r = r[0]);
              var n = 1 === arguments.length ? r[0] : [r[0], r[1]];
              return t.dot(e, [n[0], n[1], 1]).slice(0, 2);
            };
          }, t.apply2DTransform2 = function (e) {
            var r = t.apply2DTransform(e);
            return function (e) {
              return r(e.slice(0, 2)).concat(r(e.slice(2, 4)));
            };
          }, t.convertCssMatrix = function (e) {
            if (e) {
              var t = e.length;
              if (16 === t) return e;
              if (6 === t) return [e[0], e[1], 0, 0, e[2], e[3], 0, 0, 0, 0, 1, 0, e[4], e[5], 0, 1];
            }
            return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
          }, t.inverseTransformMatrix = function (e) {
            var t = [];
            return n.invert(t, e), [[t[0], t[1], t[2], t[3]], [t[4], t[5], t[6], t[7]], [t[8], t[9], t[10], t[11]], [t[12], t[13], t[14], t[15]]];
          };
        },
        8953: function (e) {
          "use strict";

          e.exports = {
            mod: function (e, t) {
              var r = e % t;
              return r < 0 ? r + t : r;
            },
            modHalf: function (e, t) {
              return Math.abs(e) > t / 2 ? e - Math.round(e / t) * t : e;
            }
          };
        },
        5632: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(7800).isArrayOrTypedArray;
          function i(e, t) {
            return function () {
              var r,
                n,
                o,
                l,
                s,
                c = e;
              for (l = 0; l < t.length - 1; l++) {
                if (-1 === (r = t[l])) {
                  for (n = !0, o = [], s = 0; s < c.length; s++) o[s] = i(c[s], t.slice(l + 1))(), o[s] !== o[0] && (n = !1);
                  return n ? o[0] : o;
                }
                if ("number" == typeof r && !a(c)) return;
                if ("object" != typeof (c = c[r]) || null === c) return;
              }
              if ("object" == typeof c && null !== c && null !== (o = c[t[l]])) return o;
            };
          }
          e.exports = function (e, t) {
            if (n(t)) t = String(t);else if ("string" != typeof t || "[-1]" === t.substr(t.length - 4)) throw "bad property string";
            var r,
              a,
              o,
              l,
              c = t.split(".");
            for (l = 0; l < c.length; l++) if ("__" === String(c[l]).slice(0, 2)) throw "bad property string";
            for (l = 0; l < c.length;) {
              if (r = String(c[l]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/)) {
                if (r[1]) c[l] = r[1];else {
                  if (0 !== l) throw "bad property string";
                  c.splice(0, 1);
                }
                for (a = r[2].substr(1, r[2].length - 2).split("]["), o = 0; o < a.length; o++) l++, c.splice(l, 0, Number(a[o]));
              }
              l++;
            }
            return "object" != typeof e ? function (e, t, r) {
              return {
                set: function () {
                  throw "bad container";
                },
                get: function () {},
                astr: t,
                parts: r,
                obj: e
              };
            }(e, t, c) : {
              set: s(e, c, t),
              get: i(e, c),
              astr: t,
              parts: c,
              obj: e
            };
          };
          var o = /(^|\.)args\[/;
          function l(e, t) {
            return void 0 === e || null === e && !t.match(o);
          }
          function s(e, t, r) {
            return function (n) {
              var i,
                o,
                s = e,
                d = "",
                h = [[e, d]],
                p = l(n, r);
              for (o = 0; o < t.length - 1; o++) {
                if ("number" == typeof (i = t[o]) && !a(s)) throw "array index but container is not an array";
                if (-1 === i) {
                  if (p = !u(s, t.slice(o + 1), n, r)) break;
                  return;
                }
                if (!f(s, i, t[o + 1], p)) break;
                if ("object" != typeof (s = s[i]) || null === s) throw "container is not an object";
                d = c(d, i), h.push([s, d]);
              }
              if (p) {
                if (o === t.length - 1 && (delete s[t[o]], Array.isArray(s) && +t[o] == s.length - 1)) for (; s.length && void 0 === s[s.length - 1];) s.pop();
              } else s[t[o]] = n;
            };
          }
          function c(e, t) {
            var r = t;
            return n(t) ? r = "[" + t + "]" : e && (r = "." + t), e + r;
          }
          function u(e, t, r, n) {
            var i,
              o = a(r),
              c = !0,
              u = r,
              d = n.replace("-1", 0),
              h = !o && l(r, d),
              p = t[0];
            for (i = 0; i < e.length; i++) d = n.replace("-1", i), o && (h = l(u = r[i % r.length], d)), h && (c = !1), f(e, i, p, h) && s(e[i], t, n.replace("-1", i))(u);
            return c;
          }
          function f(e, t, r, n) {
            if (void 0 === e[t]) {
              if (n) return !1;
              e[t] = "number" == typeof r ? [] : {};
            }
            return !0;
          }
        },
        4969: function (e) {
          "use strict";

          e.exports = function () {};
        },
        7355: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(721),
            i = [];
          e.exports = function (e, t) {
            if (-1 === i.indexOf(e)) {
              i.push(e);
              var r = 1e3;
              a(t) ? r = t : "long" === t && (r = 3e3);
              var o = n.select("body").selectAll(".plotly-notifier").data([0]);
              o.enter().append("div").classed("plotly-notifier", !0), o.selectAll(".notifier-note").data(i).enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function (e) {
                var a = n.select(this);
                a.append("button").classed("notifier-close", !0).html("&times;").on("click", function () {
                  a.transition().call(l);
                });
                for (var i = a.append("p"), o = e.split(/<br\s*\/?>/g), s = 0; s < o.length; s++) s && i.append("br"), i.append("span").text(o[s]);
                "stick" === t ? a.transition().duration(350).style("opacity", 1) : a.transition().duration(700).style("opacity", 1).transition().delay(r).call(l);
              });
            }
            function l(e) {
              e.duration(700).style("opacity", 0).each("end", function (e) {
                var t = i.indexOf(e);
                -1 !== t && i.splice(t, 1), n.select(this).remove();
              });
            }
          };
        },
        3134: function (e, t, r) {
          "use strict";

          var n = r(7983),
            a = "data-savedcursor";
          e.exports = function (e, t) {
            var r = e.attr(a);
            if (t) {
              if (!r) {
                for (var i = (e.attr("class") || "").split(" "), o = 0; o < i.length; o++) {
                  var l = i[o];
                  0 === l.indexOf("cursor-") && e.attr(a, l.substr(7)).classed(l, !1);
                }
                e.attr(a) || e.attr(a, "!!");
              }
              n(e, t);
            } else r && (e.attr(a, null), "!!" === r ? n(e) : n(e, r));
          };
        },
        899: function (e, t, r) {
          "use strict";

          var n = r(5236).dot,
            a = r(3821).BADNUM,
            i = e.exports = {};
          i.tester = function (e) {
            var t,
              r = e.slice(),
              n = r[0][0],
              i = n,
              o = r[0][1],
              l = o;
            for (r[r.length - 1][0] === r[0][0] && r[r.length - 1][1] === r[0][1] || r.push(r[0]), t = 1; t < r.length; t++) n = Math.min(n, r[t][0]), i = Math.max(i, r[t][0]), o = Math.min(o, r[t][1]), l = Math.max(l, r[t][1]);
            var s,
              c = !1;
            5 === r.length && (r[0][0] === r[1][0] ? r[2][0] === r[3][0] && r[0][1] === r[3][1] && r[1][1] === r[2][1] && (c = !0, s = function (e) {
              return e[0] === r[0][0];
            }) : r[0][1] === r[1][1] && r[2][1] === r[3][1] && r[0][0] === r[3][0] && r[1][0] === r[2][0] && (c = !0, s = function (e) {
              return e[1] === r[0][1];
            }));
            var u = !0,
              f = r[0];
            for (t = 1; t < r.length; t++) if (f[0] !== r[t][0] || f[1] !== r[t][1]) {
              u = !1;
              break;
            }
            return {
              xmin: n,
              xmax: i,
              ymin: o,
              ymax: l,
              pts: r,
              contains: c ? function (e, t) {
                var r = e[0],
                  c = e[1];
                return !(r === a || r < n || r > i || c === a || c < o || c > l || t && s(e));
              } : function (e, t) {
                var s = e[0],
                  c = e[1];
                if (s === a || s < n || s > i || c === a || c < o || c > l) return !1;
                var u,
                  f,
                  d,
                  h,
                  p,
                  v = r.length,
                  g = r[0][0],
                  m = r[0][1],
                  y = 0;
                for (u = 1; u < v; u++) if (f = g, d = m, g = r[u][0], m = r[u][1], !(s < (h = Math.min(f, g)) || s > Math.max(f, g) || c > Math.max(d, m))) if (c < Math.min(d, m)) s !== h && y++;else {
                  if (c === (p = g === f ? c : d + (s - f) * (m - d) / (g - f))) return 1 !== u || !t;
                  c <= p && s !== h && y++;
                }
                return y % 2 == 1;
              },
              isRect: c,
              degenerate: u
            };
          }, i.isSegmentBent = function (e, t, r, a) {
            var i,
              o,
              l,
              s = e[t],
              c = [e[r][0] - s[0], e[r][1] - s[1]],
              u = n(c, c),
              f = Math.sqrt(u),
              d = [-c[1] / f, c[0] / f];
            for (i = t + 1; i < r; i++) if (o = [e[i][0] - s[0], e[i][1] - s[1]], (l = n(o, c)) < 0 || l > u || Math.abs(n(o, d)) > a) return !0;
            return !1;
          }, i.filter = function (e, t) {
            var r = [e[0]],
              n = 0,
              a = 0;
            function o(o) {
              e.push(o);
              var l = r.length,
                s = n;
              r.splice(a + 1);
              for (var c = s + 1; c < e.length; c++) (c === e.length - 1 || i.isSegmentBent(e, s, c + 1, t)) && (r.push(e[c]), r.length < l - 2 && (n = c, a = r.length - 1), s = c);
            }
            return e.length > 1 && o(e.pop()), {
              addPt: o,
              raw: e,
              filtered: r
            };
          };
        },
        2521: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(3087);
          e.exports = function (e) {
            var t;
            if ("string" != typeof (t = e && e.hasOwnProperty("userAgent") ? e.userAgent : function () {
              var e;
              return "undefined" != typeof navigator && (e = navigator.userAgent), e && e.headers && "string" == typeof e.headers["user-agent"] && (e = e.headers["user-agent"]), e;
            }())) return !0;
            var r = a({
              ua: {
                headers: {
                  "user-agent": t
                }
              },
              tablet: !0,
              featureDetect: !1
            });
            if (!r) for (var i = t.split(" "), o = 1; o < i.length; o++) if (-1 !== i[o].indexOf("Safari")) for (var l = o - 1; l > -1; l--) {
              var s = i[l];
              if ("Version/" === s.substr(0, 8)) {
                var c = s.substr(8).split(".")[0];
                if (n(c) && (c = +c), c >= 13) return !0;
              }
            }
            return r;
          };
        },
        6539: function (e) {
          "use strict";

          e.exports = function (e, t) {
            if (t instanceof RegExp) {
              for (var r = t.toString(), n = 0; n < e.length; n++) if (e[n] instanceof RegExp && e[n].toString() === r) return e;
              e.push(t);
            } else !t && 0 !== t || -1 !== e.indexOf(t) || e.push(t);
            return e;
          };
        },
        486: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(4452).dfltConfig,
            i = {
              add: function (e, t, r, n, i) {
                var o, l;
                e.undoQueue = e.undoQueue || {
                  index: 0,
                  queue: [],
                  sequence: !1
                }, l = e.undoQueue.index, e.autoplay ? e.undoQueue.inSequence || (e.autoplay = !1) : (!e.undoQueue.sequence || e.undoQueue.beginSequence ? (o = {
                  undo: {
                    calls: [],
                    args: []
                  },
                  redo: {
                    calls: [],
                    args: []
                  }
                }, e.undoQueue.queue.splice(l, e.undoQueue.queue.length - l, o), e.undoQueue.index += 1) : o = e.undoQueue.queue[l - 1], e.undoQueue.beginSequence = !1, o && (o.undo.calls.unshift(t), o.undo.args.unshift(r), o.redo.calls.push(n), o.redo.args.push(i)), e.undoQueue.queue.length > a.queueLength && (e.undoQueue.queue.shift(), e.undoQueue.index--));
              },
              startSequence: function (e) {
                e.undoQueue = e.undoQueue || {
                  index: 0,
                  queue: [],
                  sequence: !1
                }, e.undoQueue.sequence = !0, e.undoQueue.beginSequence = !0;
              },
              stopSequence: function (e) {
                e.undoQueue = e.undoQueue || {
                  index: 0,
                  queue: [],
                  sequence: !1
                }, e.undoQueue.sequence = !1, e.undoQueue.beginSequence = !1;
              },
              undo: function (e) {
                var t, r;
                if (!(void 0 === e.undoQueue || isNaN(e.undoQueue.index) || e.undoQueue.index <= 0)) {
                  for (e.undoQueue.index--, t = e.undoQueue.queue[e.undoQueue.index], e.undoQueue.inSequence = !0, r = 0; r < t.undo.calls.length; r++) i.plotDo(e, t.undo.calls[r], t.undo.args[r]);
                  e.undoQueue.inSequence = !1, e.autoplay = !1;
                }
              },
              redo: function (e) {
                var t, r;
                if (!(void 0 === e.undoQueue || isNaN(e.undoQueue.index) || e.undoQueue.index >= e.undoQueue.queue.length)) {
                  for (t = e.undoQueue.queue[e.undoQueue.index], e.undoQueue.inSequence = !0, r = 0; r < t.redo.calls.length; r++) i.plotDo(e, t.redo.calls[r], t.redo.args[r]);
                  e.undoQueue.inSequence = !1, e.autoplay = !1, e.undoQueue.index++;
                }
              },
              plotDo: function (e, t, r) {
                e.autoplay = !0, r = function (e, t) {
                  for (var r, a = [], i = 0; i < t.length; i++) r = t[i], a[i] = r === e ? r : "object" == typeof r ? Array.isArray(r) ? n.extendDeep([], r) : n.extendDeepAll({}, r) : r;
                  return a;
                }(e, r), t.apply(null, r);
              }
            };
          e.exports = i;
        },
        694: function (e, t) {
          "use strict";

          t.counter = function (e, t, r, n) {
            var a = (t || "") + (r ? "" : "$"),
              i = !1 === n ? "" : "^";
            return "xy" === e ? new RegExp(i + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + a) : new RegExp(i + e + "([2-9]|[1-9][0-9]+)?" + a);
          };
        },
        2047: function (e) {
          "use strict";

          var t = /^(.*)(\.[^\.\[\]]+|\[\d\])$/,
            r = /^[^\.\[\]]+$/;
          e.exports = function (e, n) {
            for (; n;) {
              var a = e.match(t);
              if (a) e = a[1];else {
                if (!e.match(r)) throw new Error("bad relativeAttr call:" + [e, n]);
                e = "";
              }
              if ("^" !== n.charAt(0)) break;
              n = n.slice(1);
            }
            return e && "[" !== n.charAt(0) ? e + "." + n : e + n;
          };
        },
        428: function (e, t, r) {
          "use strict";

          var n = r(7800).isArrayOrTypedArray,
            a = r(6174);
          e.exports = function e(t, r) {
            for (var i in r) {
              var o = r[i],
                l = t[i];
              if (l !== o) if ("_" === i.charAt(0) || "function" == typeof o) {
                if (i in t) continue;
                t[i] = o;
              } else if (n(o) && n(l) && a(o[0])) {
                if ("customdata" === i || "ids" === i) continue;
                for (var s = Math.min(o.length, l.length), c = 0; c < s; c++) l[c] !== o[c] && a(o[c]) && a(l[c]) && e(l[c], o[c]);
              } else a(o) && a(l) && (e(l, o), Object.keys(l).length || delete t[i]);
            }
          };
        },
        8813: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(8636),
            i = r(9527),
            o = r(3821).BADNUM,
            l = 1e-9;
          function s(e, t) {
            return e < t;
          }
          function c(e, t) {
            return e <= t;
          }
          function u(e, t) {
            return e > t;
          }
          function f(e, t) {
            return e >= t;
          }
          t.findBin = function (e, t, r) {
            if (n(t.start)) return r ? Math.ceil((e - t.start) / t.size - l) - 1 : Math.floor((e - t.start) / t.size + l);
            var i,
              o,
              d = 0,
              h = t.length,
              p = 0,
              v = h > 1 ? (t[h - 1] - t[0]) / (h - 1) : 1;
            for (o = v >= 0 ? r ? s : c : r ? f : u, e += v * l * (r ? -1 : 1) * (v >= 0 ? 1 : -1); d < h && p++ < 100;) o(t[i = Math.floor((d + h) / 2)], e) ? d = i + 1 : h = i;
            return p > 90 && a.log("Long binary search..."), d - 1;
          }, t.sorterAsc = function (e, t) {
            return e - t;
          }, t.sorterDes = function (e, t) {
            return t - e;
          }, t.distinctVals = function (e) {
            var r,
              n = e.slice();
            for (n.sort(t.sorterAsc), r = n.length - 1; r > -1 && n[r] === o; r--);
            for (var a, i = n[r] - n[0] || 1, l = i / (r || 1) / 1e4, s = [], c = 0; c <= r; c++) {
              var u = n[c],
                f = u - a;
              void 0 === a ? (s.push(u), a = u) : f > l && (i = Math.min(i, f), s.push(u), a = u);
            }
            return {
              vals: s,
              minDiff: i
            };
          }, t.roundUp = function (e, t, r) {
            for (var n, a = 0, i = t.length - 1, o = 0, l = r ? 0 : 1, s = r ? 1 : 0, c = r ? Math.ceil : Math.floor; a < i && o++ < 100;) t[n = c((a + i) / 2)] <= e ? a = n + l : i = n - s;
            return t[a];
          }, t.sort = function (e, t) {
            for (var r = 0, n = 0, a = 1; a < e.length; a++) {
              var i = t(e[a], e[a - 1]);
              if (i < 0 ? r = 1 : i > 0 && (n = 1), r && n) return e.sort(t);
            }
            return n ? e : e.reverse();
          }, t.findIndexOfMin = function (e, t) {
            t = t || i;
            for (var r, n = 1 / 0, a = 0; a < e.length; a++) {
              var o = t(e[a]);
              o < n && (n = o, r = a);
            }
            return r;
          };
        },
        7983: function (e) {
          "use strict";

          e.exports = function (e, t) {
            (e.attr("class") || "").split(" ").forEach(function (t) {
              0 === t.indexOf("cursor-") && e.classed(t, !1);
            }), t && e.classed("cursor-" + t, !0);
          };
        },
        2994: function (e) {
          "use strict";

          e.exports = function (e) {
            return Object.keys(e).sort();
          };
        },
        9258: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(7800).isArrayOrTypedArray;
          t.aggNums = function (e, r, i, o) {
            var l, s;
            if ((!o || o > i.length) && (o = i.length), n(r) || (r = !1), a(i[0])) {
              for (s = new Array(o), l = 0; l < o; l++) s[l] = t.aggNums(e, r, i[l]);
              i = s;
            }
            for (l = 0; l < o; l++) n(r) ? n(i[l]) && (r = e(+r, +i[l])) : r = i[l];
            return r;
          }, t.len = function (e) {
            return t.aggNums(function (e) {
              return e + 1;
            }, 0, e);
          }, t.mean = function (e, r) {
            return r || (r = t.len(e)), t.aggNums(function (e, t) {
              return e + t;
            }, 0, e) / r;
          }, t.geometricMean = function (e, r) {
            return r || (r = t.len(e)), Math.pow(t.aggNums(function (e, t) {
              return e * t;
            }, 1, e), 1 / r);
          }, t.midRange = function (e) {
            if (void 0 !== e && 0 !== e.length) return (t.aggNums(Math.max, null, e) + t.aggNums(Math.min, null, e)) / 2;
          }, t.variance = function (e, r, a) {
            return r || (r = t.len(e)), n(a) || (a = t.mean(e, r)), t.aggNums(function (e, t) {
              return e + Math.pow(t - a, 2);
            }, 0, e) / r;
          }, t.stdev = function (e, r, n) {
            return Math.sqrt(t.variance(e, r, n));
          }, t.median = function (e) {
            var r = e.slice().sort();
            return t.interp(r, .5);
          }, t.interp = function (e, t) {
            if (!n(t)) throw "n should be a finite number";
            if ((t = t * e.length - .5) < 0) return e[0];
            if (t > e.length - 1) return e[e.length - 1];
            var r = t % 1;
            return r * e[Math.ceil(t)] + (1 - r) * e[Math.floor(t)];
          };
        },
        635: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4809),
            i = a.strTranslate,
            o = r(2972),
            l = r(4530).LINE_SPACING,
            s = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
          t.convertToTspans = function (e, r, g) {
            var L = e.text(),
              S = !e.attr("data-notex") && r && r._context.typesetMath && "undefined" != typeof MathJax && L.match(s),
              D = n.select(e.node().parentNode);
            if (!D.empty()) {
              var P = e.attr("class") ? e.attr("class").split(" ")[0] : "text";
              return P += "-math", D.selectAll("svg." + P).remove(), D.selectAll("g." + P + "-group").remove(), e.style("display", null).attr({
                "data-unformatted": L,
                "data-math": "N"
              }), S ? (r && r._promises || []).push(new Promise(function (t) {
                e.style("display", "none");
                var r = parseInt(e.node().style.fontSize, 10),
                  o = {
                    fontSize: r
                  };
                !function (e, t, r) {
                  var i,
                    o,
                    l,
                    s,
                    d = parseInt((MathJax.version || "").split(".")[0]);
                  if (2 === d || 3 === d) {
                    var h = function () {
                        var r = "math-output-" + a.randstr({}, 64),
                          i = (s = n.select("body").append("div").attr({
                            id: r
                          }).style({
                            visibility: "hidden",
                            position: "absolute",
                            "font-size": t.fontSize + "px"
                          }).text(e.replace(c, "\\lt ").replace(u, "\\gt "))).node();
                        return 2 === d ? MathJax.Hub.Typeset(i) : MathJax.typeset([i]);
                      },
                      p = function () {
                        var t = s.select(2 === d ? ".MathJax_SVG" : ".MathJax"),
                          i = !t.empty() && s.select("svg").node();
                        if (i) {
                          var o,
                            l = i.getBoundingClientRect();
                          o = 2 === d ? n.select("body").select("#MathJax_SVG_glyphs") : t.select("defs"), r(t, o, l);
                        } else a.log("There was an error in the tex syntax.", e), r();
                        s.remove();
                      };
                    2 === d ? MathJax.Hub.Queue(function () {
                      return o = a.extendDeepAll({}, MathJax.Hub.config), l = MathJax.Hub.processSectionDelay, void 0 !== MathJax.Hub.processSectionDelay && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({
                        messageStyle: "none",
                        tex2jax: {
                          inlineMath: f
                        },
                        displayAlign: "left"
                      });
                    }, function () {
                      if ("SVG" !== (i = MathJax.Hub.config.menuSettings.renderer)) return MathJax.Hub.setRenderer("SVG");
                    }, h, p, function () {
                      if ("SVG" !== i) return MathJax.Hub.setRenderer(i);
                    }, function () {
                      return void 0 !== l && (MathJax.Hub.processSectionDelay = l), MathJax.Hub.Config(o);
                    }) : 3 === d && (o = a.extendDeepAll({}, MathJax.config), MathJax.config.tex || (MathJax.config.tex = {}), MathJax.config.tex.inlineMath = f, "svg" !== (i = MathJax.config.startup.output) && (MathJax.config.startup.output = "svg"), MathJax.startup.defaultReady(), MathJax.startup.promise.then(function () {
                      h(), p(), "svg" !== i && (MathJax.config.startup.output = i), MathJax.config = o;
                    }));
                  } else a.warn("No MathJax version:", MathJax.version);
                }(S[2], o, function (n, a, o) {
                  D.selectAll("svg." + P).remove(), D.selectAll("g." + P + "-group").remove();
                  var l = n && n.select("svg");
                  if (!l || !l.node()) return z(), void t();
                  var s = D.append("g").classed(P + "-group", !0).attr({
                    "pointer-events": "none",
                    "data-unformatted": L,
                    "data-math": "Y"
                  });
                  s.node().appendChild(l.node()), a && a.node() && l.node().insertBefore(a.node().cloneNode(!0), l.node().firstChild);
                  var c = o.width,
                    u = o.height;
                  l.attr({
                    class: P,
                    height: u,
                    preserveAspectRatio: "xMinYMin meet"
                  }).style({
                    overflow: "visible",
                    "pointer-events": "none"
                  });
                  var f = e.node().style.fill || "black",
                    d = l.select("g");
                  d.attr({
                    fill: f,
                    stroke: f
                  });
                  var h = d.node().getBoundingClientRect(),
                    p = h.width,
                    v = h.height;
                  (p > c || v > u) && (l.style("overflow", "hidden"), p = (h = l.node().getBoundingClientRect()).width, v = h.height);
                  var m = +e.attr("x"),
                    y = +e.attr("y"),
                    x = -(r || e.node().getBoundingClientRect().height) / 4;
                  if ("y" === P[0]) s.attr({
                    transform: "rotate(" + [-90, m, y] + ")" + i(-p / 2, x - v / 2)
                  });else if ("l" === P[0]) y = x - v / 2;else if ("a" === P[0] && 0 !== P.indexOf("atitle")) m = 0, y = x;else {
                    var b = e.attr("text-anchor");
                    m -= p * ("middle" === b ? .5 : "end" === b ? 1 : 0), y = y + x - v / 2;
                  }
                  l.attr({
                    x: m,
                    y: y
                  }), g && g.call(e, s), t(s);
                });
              })) : z(), e;
            }
            function z() {
              D.empty() || (P = e.attr("class") + "-math", D.select("svg." + P).remove()), e.text("").style("white-space", "pre");
              var r = function (e, t) {
                t = t.replace(m, " ");
                var r,
                  i = !1,
                  s = [],
                  c = -1;
                function u() {
                  c++;
                  var t = document.createElementNS(o.svg, "tspan");
                  n.select(t).attr({
                    class: "line",
                    dy: c * l + "em"
                  }), e.appendChild(t), r = t;
                  var a = s;
                  if (s = [{
                    node: t
                  }], a.length > 1) for (var i = 1; i < a.length; i++) f(a[i]);
                }
                function f(e) {
                  var t,
                    a = e.type,
                    i = {};
                  if ("a" === a) {
                    t = "a";
                    var l = e.target,
                      c = e.href,
                      u = e.popup;
                    c && (i = {
                      "xlink:xlink:show": "_blank" === l || "_" !== l.charAt(0) ? "new" : "replace",
                      target: l,
                      "xlink:xlink:href": c
                    }, u && (i.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + u + '");return false;'));
                  } else t = "tspan";
                  e.style && (i.style = e.style);
                  var f = document.createElementNS(o.svg, t);
                  if ("sup" === a || "sub" === a) {
                    g(r, v), r.appendChild(f);
                    var d = document.createElementNS(o.svg, "tspan");
                    g(d, v), n.select(d).attr("dy", p[a]), i.dy = h[a], r.appendChild(f), r.appendChild(d);
                  } else r.appendChild(f);
                  n.select(f).attr(i), r = e.node = f, s.push(e);
                }
                function g(e, t) {
                  e.appendChild(document.createTextNode(t));
                }
                function L(e) {
                  if (1 !== s.length) {
                    var n = s.pop();
                    e !== n.type && a.log("Start tag <" + n.type + "> doesnt match end tag <" + e + ">. Pretending it did match.", t), r = s[s.length - 1].node;
                  } else a.log("Ignoring unexpected end tag </" + e + ">.", t);
                }
                b.test(t) ? u() : (r = e, s = [{
                  node: e
                }]);
                for (var S = t.split(y), D = 0; D < S.length; D++) {
                  var P = S[D],
                    z = P.match(x),
                    I = z && z[2].toLowerCase(),
                    E = d[I];
                  if ("br" === I) u();else if (void 0 === E) g(r, C(P));else if (z[1]) L(I);else {
                    var R = z[4],
                      N = {
                        type: I
                      },
                      F = k(R, _);
                    if (F ? (F = F.replace(A, "$1 fill:"), E && (F += ";" + E)) : E && (F = E), F && (N.style = F), "a" === I) {
                      i = !0;
                      var H = k(R, w);
                      if (H) {
                        var B = O(H);
                        B && (N.href = B, N.target = k(R, T) || "_blank", N.popup = k(R, M));
                      }
                    }
                    f(N);
                  }
                }
                return i;
              }(e.node(), L);
              r && e.style("pointer-events", "all"), t.positionText(e), g && g.call(e);
            }
          };
          var c = /(<|&lt;|&#60;)/g,
            u = /(>|&gt;|&#62;)/g,
            f = [["$", "$"], ["\\(", "\\)"]],
            d = {
              sup: "font-size:70%",
              sub: "font-size:70%",
              s: "text-decoration:line-through",
              u: "text-decoration:underline",
              b: "font-weight:bold",
              i: "font-style:italic",
              a: "cursor:pointer",
              span: "",
              em: "font-style:italic;font-weight:bold"
            },
            h = {
              sub: "0.3em",
              sup: "-0.6em"
            },
            p = {
              sub: "-0.21em",
              sup: "0.42em"
            },
            v = "​",
            g = ["http:", "https:", "mailto:", "", void 0, ":"],
            m = t.NEWLINES = /(\r\n?|\n)/g,
            y = /(<[^<>]*>)/,
            x = /<(\/?)([^ >]*)(\s+(.*))?>/i,
            b = /<br(\s+.*)?>/i;
          t.BR_TAG_ALL = /<br(\s+.*)?>/gi;
          var _ = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i,
            w = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i,
            T = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i,
            M = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
          function k(e, t) {
            if (!e) return null;
            var r = e.match(t),
              n = r && (r[3] || r[4]);
            return n && C(n);
          }
          var A = /(^|;)\s*color:/;
          t.plainText = function (e, t) {
            for (var r = void 0 !== (t = t || {}).len && -1 !== t.len ? t.len : 1 / 0, n = void 0 !== t.allowedTags ? t.allowedTags : ["br"], a = e.split(y), i = [], o = "", l = 0, s = 0; s < a.length; s++) {
              var c = a[s],
                u = c.match(x),
                f = u && u[2].toLowerCase();
              if (f) -1 !== n.indexOf(f) && (i.push(c), o = f);else {
                var d = c.length;
                if (l + d < r) i.push(c), l += d;else if (l < r) {
                  var h = r - l;
                  o && ("br" !== o || h <= 3 || d <= 3) && i.pop(), r > 3 ? i.push(c.substr(0, h - 3) + "...") : i.push(c.substr(0, h));
                  break;
                }
                o = "";
              }
            }
            return i.join("");
          };
          var L = {
              mu: "μ",
              amp: "&",
              lt: "<",
              gt: ">",
              nbsp: " ",
              times: "×",
              plusmn: "±",
              deg: "°"
            },
            S = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
          function C(e) {
            return e.replace(S, function (e, t) {
              return ("#" === t.charAt(0) ? function (e) {
                if (!(e > 1114111)) {
                  var t = String.fromCodePoint;
                  if (t) return t(e);
                  var r = String.fromCharCode;
                  return e <= 65535 ? r(e) : r(55232 + (e >> 10), e % 1024 + 56320);
                }
              }("x" === t.charAt(1) ? parseInt(t.substr(2), 16) : parseInt(t.substr(1), 10)) : L[t]) || e;
            });
          }
          function O(e) {
            var t = encodeURI(decodeURI(e)),
              r = document.createElement("a"),
              n = document.createElement("a");
            r.href = e, n.href = t;
            var a = r.protocol,
              i = n.protocol;
            return -1 !== g.indexOf(a) && -1 !== g.indexOf(i) ? t : "";
          }
          function D(e, t, r) {
            var n,
              i,
              o,
              l = r.horizontalAlign,
              s = r.verticalAlign || "top",
              c = e.node().getBoundingClientRect(),
              u = t.node().getBoundingClientRect();
            return i = "bottom" === s ? function () {
              return c.bottom - n.height;
            } : "middle" === s ? function () {
              return c.top + (c.height - n.height) / 2;
            } : function () {
              return c.top;
            }, o = "right" === l ? function () {
              return c.right - n.width;
            } : "center" === l ? function () {
              return c.left + (c.width - n.width) / 2;
            } : function () {
              return c.left;
            }, function () {
              n = this.node().getBoundingClientRect();
              var e = o() - u.left,
                t = i() - u.top,
                l = r.gd || {};
              if (r.gd) {
                l._fullLayout._calcInverseTransform(l);
                var s = a.apply3DTransform(l._fullLayout._invTransform)(e, t);
                e = s[0], t = s[1];
              }
              return this.style({
                top: t + "px",
                left: e + "px",
                "z-index": 1e3
              }), this;
            };
          }
          t.convertEntities = C, t.sanitizeHTML = function (e) {
            e = e.replace(m, " ");
            for (var t = document.createElement("p"), r = t, a = [], i = e.split(y), o = 0; o < i.length; o++) {
              var l = i[o],
                s = l.match(x),
                c = s && s[2].toLowerCase();
              if (c in d) {
                if (s[1]) a.length && (r = a.pop());else {
                  var u = s[4],
                    f = k(u, _),
                    h = f ? {
                      style: f
                    } : {};
                  if ("a" === c) {
                    var p = k(u, w);
                    if (p) {
                      var v = O(p);
                      if (v) {
                        h.href = v;
                        var g = k(u, T);
                        g && (h.target = g);
                      }
                    }
                  }
                  var b = document.createElement(c);
                  r.appendChild(b), n.select(b).attr(h), r = b, a.push(b);
                }
              } else r.appendChild(document.createTextNode(C(l)));
            }
            return t.innerHTML;
          }, t.lineCount = function (e) {
            return e.selectAll("tspan.line").size() || 1;
          }, t.positionText = function (e, t, r) {
            return e.each(function () {
              var e = n.select(this);
              function a(t, r) {
                return void 0 === r ? null === (r = e.attr(t)) && (e.attr(t, 0), r = 0) : e.attr(t, r), r;
              }
              var i = a("x", t),
                o = a("y", r);
              "text" === this.nodeName && e.selectAll("tspan.line").attr({
                x: i,
                y: o
              });
            });
          };
          var P = "1px ";
          t.makeTextShadow = function (e) {
            return P + P + P + e + ", -" + P + "-" + P + P + e + ", " + P + "-" + P + P + e + ", -" + P + P + P + e;
          }, t.makeEditable = function (e, t) {
            var r = t.gd,
              a = t.delegate,
              i = n.dispatch("edit", "input", "cancel"),
              o = a || e;
            if (e.style({
              "pointer-events": a ? "none" : "all"
            }), 1 !== e.size()) throw new Error("boo");
            function l() {
              var a, l, c, u, f;
              a = n.select(r).select(".svg-container"), l = a.append("div"), c = e.node().style, u = parseFloat(c.fontSize || 12), void 0 === (f = t.text) && (f = e.attr("data-unformatted")), l.classed("plugin-editable editable", !0).style({
                position: "absolute",
                "font-family": c.fontFamily || "Arial",
                "font-size": u,
                color: t.fill || c.fill || "black",
                opacity: 1,
                "background-color": t.background || "transparent",
                outline: "#ffffff33 1px solid",
                margin: [-u / 8 + 1, 0, 0, -1].join("px ") + "px",
                padding: "0",
                "box-sizing": "border-box"
              }).attr({
                contenteditable: !0
              }).text(f).call(D(e, a, t)).on("blur", function () {
                r._editing = !1, e.text(this.textContent).style({
                  opacity: 1
                });
                var t,
                  a = n.select(this).attr("class");
                (t = a ? "." + a.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(e.node().parentNode).select(t).style({
                  opacity: 0
                });
                var o = this.textContent;
                n.select(this).transition().duration(0).remove(), n.select(document).on("mouseup", null), i.edit.call(e, o);
              }).on("focus", function () {
                var e = this;
                r._editing = !0, n.select(document).on("mouseup", function () {
                  if (n.event.target === e) return !1;
                  document.activeElement === l.node() && l.node().blur();
                });
              }).on("keyup", function () {
                27 === n.event.which ? (r._editing = !1, e.style({
                  opacity: 1
                }), n.select(this).style({
                  opacity: 0
                }).on("blur", function () {
                  return !1;
                }).transition().remove(), i.cancel.call(e, this.textContent)) : (i.input.call(e, this.textContent), n.select(this).call(D(e, a, t)));
              }).on("keydown", function () {
                13 === n.event.which && this.blur();
              }).call(s), e.style({
                opacity: 0
              });
              var d,
                h = o.attr("class");
              (d = h ? "." + h.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(e.node().parentNode).select(d).style({
                opacity: 0
              });
            }
            function s(e) {
              var t = e.node(),
                r = document.createRange();
              r.selectNodeContents(t);
              var n = window.getSelection();
              n.removeAllRanges(), n.addRange(r), t.focus();
            }
            return t.immediate ? l() : o.on("click", l), n.rebind(e, i, "on");
          };
        },
        4025: function (e, t) {
          "use strict";

          var r = {};
          function n(e) {
            e && null !== e.timer && (clearTimeout(e.timer), e.timer = null);
          }
          t.throttle = function (e, t, a) {
            var i = r[e],
              o = Date.now();
            if (!i) {
              for (var l in r) r[l].ts < o - 6e4 && delete r[l];
              i = r[e] = {
                ts: 0,
                timer: null
              };
            }
            function s() {
              a(), i.ts = Date.now(), i.onDone && (i.onDone(), i.onDone = null);
            }
            n(i), o > i.ts + t ? s() : i.timer = setTimeout(function () {
              s(), i.timer = null;
            }, t);
          }, t.done = function (e) {
            var t = r[e];
            return t && t.timer ? new Promise(function (e) {
              var r = t.onDone;
              t.onDone = function () {
                r && r(), e(), t.onDone = null;
              };
            }) : Promise.resolve();
          }, t.clear = function (e) {
            if (e) n(r[e]), delete r[e];else for (var a in r) t.clear(a);
          };
        },
        8083: function (e, t, r) {
          "use strict";

          var n = r(721);
          e.exports = function (e, t) {
            if (e > 0) return Math.log(e) / Math.LN10;
            var r = Math.log(Math.min(t[0], t[1])) / Math.LN10;
            return n(r) || (r = Math.log(Math.max(t[0], t[1])) / Math.LN10 - 6), r;
          };
        },
        4611: function (e) {
          "use strict";

          e.exports = {
            moduleType: "locale",
            name: "en-US",
            dictionary: {
              "Click to enter Colorscale title": "Click to enter Colorscale title"
            },
            format: {
              date: "%m/%d/%Y"
            }
          };
        },
        227: function (e) {
          "use strict";

          e.exports = {
            moduleType: "locale",
            name: "en",
            dictionary: {
              "Click to enter Colorscale title": "Click to enter Colourscale title"
            },
            format: {
              days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
              shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
              months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
              shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
              periods: ["AM", "PM"],
              dateTime: "%a %b %e %X %Y",
              date: "%d/%m/%Y",
              time: "%H:%M:%S",
              decimal: ".",
              thousands: ",",
              grouping: [3],
              currency: ["$", ""],
              year: "%Y",
              month: "%b %Y",
              dayMonth: "%b %-d",
              dayMonthYear: "%b %-d, %Y"
            }
          };
        },
        6037: function (e, t, r) {
          "use strict";

          var n = r(3626);
          e.exports = function (e) {
            for (var t, r, a = n.layoutArrayContainers, i = n.layoutArrayRegexes, o = e.split("[")[0], l = 0; l < i.length; l++) if ((r = e.match(i[l])) && 0 === r.index) {
              t = r[0];
              break;
            }
            if (t || (t = a[a.indexOf(o)]), !t) return !1;
            var s = e.substr(t.length);
            return s ? !!(r = s.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/)) && {
              array: t,
              index: Number(r[1]),
              property: r[3] || ""
            } : {
              array: t,
              index: "",
              property: ""
            };
          };
        },
        3582: function (e, t, r) {
          "use strict";

          var n = r(3049).extendFlat,
            a = r(6174),
            i = {
              valType: "flaglist",
              extras: ["none"],
              flags: ["calc", "clearAxisTypes", "plot", "style", "markerSize", "colorbars"]
            },
            o = {
              valType: "flaglist",
              extras: ["none"],
              flags: ["calc", "plot", "legend", "ticks", "axrange", "layoutstyle", "modebar", "camera", "arraydraw", "colorbars"]
            },
            l = i.flags.slice().concat(["fullReplot"]),
            s = o.flags.slice().concat("layoutReplot");
          function c(e) {
            for (var t = {}, r = 0; r < e.length; r++) t[e[r]] = !1;
            return t;
          }
          function u(e, t, r) {
            var i = n({}, e);
            for (var o in i) {
              var l = i[o];
              a(l) && (i[o] = f(l, t, 0, o));
            }
            return "from-root" === r && (i.editType = t), i;
          }
          function f(e, t, r, a) {
            if (e.valType) {
              var i = n({}, e);
              if (i.editType = t, Array.isArray(e.items)) {
                i.items = new Array(e.items.length);
                for (var o = 0; o < e.items.length; o++) i.items[o] = f(e.items[o], t);
              }
              return i;
            }
            return u(e, t, "_" === a.charAt(0) ? "nested" : "from-root");
          }
          e.exports = {
            traces: i,
            layout: o,
            traceFlags: function () {
              return c(l);
            },
            layoutFlags: function () {
              return c(s);
            },
            update: function (e, t) {
              var r = t.editType;
              if (r && "none" !== r) for (var n = r.split("+"), a = 0; a < n.length; a++) e[n[a]] = !0;
            },
            overrideAll: u
          };
        },
        887: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(6472),
            i = r(3626),
            o = r(4809),
            l = r(4122),
            s = r(5975),
            c = r(8766),
            u = s.cleanId,
            f = s.getFromTrace,
            d = i.traceIs;
          function h(e, t) {
            var r = e[t],
              n = t.charAt(0);
            r && "paper" !== r && (e[t] = u(r, n, !0));
          }
          function p(e) {
            function t(t, r) {
              var n = e[t],
                a = e.title && e.title[r];
              n && !a && (e.title || (e.title = {}), e.title[r] = e[t], delete e[t]);
            }
            e && ("string" != typeof e.title && "number" != typeof e.title || (e.title = {
              text: e.title
            }), t("titlefont", "font"), t("titleposition", "position"), t("titleside", "side"), t("titleoffset", "offset"));
          }
          function v(e) {
            if (!o.isPlainObject(e)) return !1;
            var t = e.name;
            return delete e.name, delete e.showlegend, ("string" == typeof t || "number" == typeof t) && String(t);
          }
          function g(e, t, r, n) {
            if (r && !n) return e;
            if (n && !r) return t;
            if (!e.trim()) return t;
            if (!t.trim()) return e;
            var a,
              i = Math.min(e.length, t.length);
            for (a = 0; a < i && e.charAt(a) === t.charAt(a); a++);
            return e.substr(0, a).trim();
          }
          function m(e) {
            var t = "middle",
              r = "center";
            return "string" == typeof e && (-1 !== e.indexOf("top") ? t = "top" : -1 !== e.indexOf("bottom") && (t = "bottom"), -1 !== e.indexOf("left") ? r = "left" : -1 !== e.indexOf("right") && (r = "right")), t + " " + r;
          }
          function y(e, t) {
            return t in e && "object" == typeof e[t] && 0 === Object.keys(e[t]).length;
          }
          t.clearPromiseQueue = function (e) {
            Array.isArray(e._promises) && e._promises.length > 0 && o.log("Clearing previous rejected promises from queue."), e._promises = [];
          }, t.cleanLayout = function (e) {
            var r, n;
            e || (e = {}), e.xaxis1 && (e.xaxis || (e.xaxis = e.xaxis1), delete e.xaxis1), e.yaxis1 && (e.yaxis || (e.yaxis = e.yaxis1), delete e.yaxis1), e.scene1 && (e.scene || (e.scene = e.scene1), delete e.scene1);
            var i = (l.subplotsRegistry.cartesian || {}).attrRegex,
              s = (l.subplotsRegistry.polar || {}).attrRegex,
              f = (l.subplotsRegistry.ternary || {}).attrRegex,
              d = (l.subplotsRegistry.gl3d || {}).attrRegex,
              v = Object.keys(e);
            for (r = 0; r < v.length; r++) {
              var g = v[r];
              if (i && i.test(g)) {
                var m = e[g];
                m.anchor && "free" !== m.anchor && (m.anchor = u(m.anchor)), m.overlaying && (m.overlaying = u(m.overlaying)), m.type || (m.isdate ? m.type = "date" : m.islog ? m.type = "log" : !1 === m.isdate && !1 === m.islog && (m.type = "linear")), "withzero" !== m.autorange && "tozero" !== m.autorange || (m.autorange = !0, m.rangemode = "tozero"), m.insiderange && delete m.range, delete m.islog, delete m.isdate, delete m.categories, y(m, "domain") && delete m.domain, void 0 !== m.autotick && (void 0 === m.tickmode && (m.tickmode = m.autotick ? "auto" : "linear"), delete m.autotick), p(m);
              } else if (s && s.test(g)) p(e[g].radialaxis);else if (f && f.test(g)) {
                var x = e[g];
                p(x.aaxis), p(x.baxis), p(x.caxis);
              } else if (d && d.test(g)) {
                var b = e[g],
                  _ = b.cameraposition;
                if (Array.isArray(_) && 4 === _[0].length) {
                  var w = _[0],
                    T = _[1],
                    M = _[2],
                    k = a([], w),
                    A = [];
                  for (n = 0; n < 3; ++n) A[n] = T[n] + M * k[2 + 4 * n];
                  b.camera = {
                    eye: {
                      x: A[0],
                      y: A[1],
                      z: A[2]
                    },
                    center: {
                      x: T[0],
                      y: T[1],
                      z: T[2]
                    },
                    up: {
                      x: 0,
                      y: 0,
                      z: 1
                    }
                  }, delete b.cameraposition;
                }
                p(b.xaxis), p(b.yaxis), p(b.zaxis);
              }
            }
            var L = Array.isArray(e.annotations) ? e.annotations.length : 0;
            for (r = 0; r < L; r++) {
              var S = e.annotations[r];
              o.isPlainObject(S) && (S.ref && ("paper" === S.ref ? (S.xref = "paper", S.yref = "paper") : "data" === S.ref && (S.xref = "x", S.yref = "y"), delete S.ref), h(S, "xref"), h(S, "yref"));
            }
            var C = Array.isArray(e.shapes) ? e.shapes.length : 0;
            for (r = 0; r < C; r++) {
              var O = e.shapes[r];
              o.isPlainObject(O) && (h(O, "xref"), h(O, "yref"));
            }
            var D = Array.isArray(e.images) ? e.images.length : 0;
            for (r = 0; r < D; r++) {
              var P = e.images[r];
              o.isPlainObject(P) && (h(P, "xref"), h(P, "yref"));
            }
            var z = e.legend;
            return z && (z.x > 3 ? (z.x = 1.02, z.xanchor = "left") : z.x < -2 && (z.x = -.02, z.xanchor = "right"), z.y > 3 ? (z.y = 1.02, z.yanchor = "bottom") : z.y < -2 && (z.y = -.02, z.yanchor = "top")), p(e), "rotate" === e.dragmode && (e.dragmode = "orbit"), c.clean(e), e.template && e.template.layout && t.cleanLayout(e.template.layout), e;
          }, t.cleanData = function (e) {
            for (var r = 0; r < e.length; r++) {
              var n,
                a = e[r];
              if ("histogramy" === a.type && "xbins" in a && !("ybins" in a) && (a.ybins = a.xbins, delete a.xbins), a.error_y && "opacity" in a.error_y) {
                var s = c.defaults,
                  f = a.error_y.color || (d(a, "bar") ? c.defaultLine : s[r % s.length]);
                a.error_y.color = c.addOpacity(c.rgb(f), c.opacity(f) * a.error_y.opacity), delete a.error_y.opacity;
              }
              if ("bardir" in a && ("h" !== a.bardir || !d(a, "bar") && "histogram" !== a.type.substr(0, 9) || (a.orientation = "h", t.swapXYData(a)), delete a.bardir), "histogramy" === a.type && t.swapXYData(a), "histogramx" !== a.type && "histogramy" !== a.type || (a.type = "histogram"), "scl" in a && !("colorscale" in a) && (a.colorscale = a.scl, delete a.scl), "reversescl" in a && !("reversescale" in a) && (a.reversescale = a.reversescl, delete a.reversescl), a.xaxis && (a.xaxis = u(a.xaxis, "x")), a.yaxis && (a.yaxis = u(a.yaxis, "y")), d(a, "gl3d") && a.scene && (a.scene = l.subplotsRegistry.gl3d.cleanId(a.scene)), !d(a, "pie-like") && !d(a, "bar-like")) if (Array.isArray(a.textposition)) for (n = 0; n < a.textposition.length; n++) a.textposition[n] = m(a.textposition[n]);else a.textposition && (a.textposition = m(a.textposition));
              var h = i.getModule(a);
              if (h && h.colorbar) {
                var x = h.colorbar.container,
                  b = x ? a[x] : a;
                b && b.colorscale && ("YIGnBu" === b.colorscale && (b.colorscale = "YlGnBu"), "YIOrRd" === b.colorscale && (b.colorscale = "YlOrRd"));
              }
              if ("surface" === a.type && o.isPlainObject(a.contours)) {
                var _ = ["x", "y", "z"];
                for (n = 0; n < _.length; n++) {
                  var w = a.contours[_[n]];
                  o.isPlainObject(w) && (w.highlightColor && (w.highlightcolor = w.highlightColor, delete w.highlightColor), w.highlightWidth && (w.highlightwidth = w.highlightWidth, delete w.highlightWidth));
                }
              }
              if ("candlestick" === a.type || "ohlc" === a.type) {
                var T = !1 !== (a.increasing || {}).showlegend,
                  M = !1 !== (a.decreasing || {}).showlegend,
                  k = v(a.increasing),
                  A = v(a.decreasing);
                if (!1 !== k && !1 !== A) {
                  var L = g(k, A, T, M);
                  L && (a.name = L);
                } else !k && !A || a.name || (a.name = k || A);
              }
              if (Array.isArray(a.transforms)) {
                var S = a.transforms;
                for (n = 0; n < S.length; n++) {
                  var C = S[n];
                  if (o.isPlainObject(C)) switch (C.type) {
                    case "filter":
                      C.filtersrc && (C.target = C.filtersrc, delete C.filtersrc), C.calendar && (C.valuecalendar || (C.valuecalendar = C.calendar), delete C.calendar);
                      break;
                    case "groupby":
                      if (C.styles = C.styles || C.style, C.styles && !Array.isArray(C.styles)) {
                        var O = C.styles,
                          D = Object.keys(O);
                        C.styles = [];
                        for (var P = 0; P < D.length; P++) C.styles.push({
                          target: D[P],
                          value: O[D[P]]
                        });
                      }
                  }
                }
              }
              y(a, "line") && delete a.line, "marker" in a && (y(a.marker, "line") && delete a.marker.line, y(a, "marker") && delete a.marker), c.clean(a), a.autobinx && (delete a.autobinx, delete a.xbins), a.autobiny && (delete a.autobiny, delete a.ybins), p(a), a.colorbar && p(a.colorbar), a.marker && a.marker.colorbar && p(a.marker.colorbar), a.line && a.line.colorbar && p(a.line.colorbar), a.aaxis && p(a.aaxis), a.baxis && p(a.baxis);
            }
          }, t.swapXYData = function (e) {
            var t;
            if (o.swapAttrs(e, ["?", "?0", "d?", "?bins", "nbins?", "autobin?", "?src", "error_?"]), Array.isArray(e.z) && Array.isArray(e.z[0]) && (e.transpose ? delete e.transpose : e.transpose = !0), e.error_x && e.error_y) {
              var r = e.error_y,
                n = "copy_ystyle" in r ? r.copy_ystyle : !(r.color || r.thickness || r.width);
              o.swapAttrs(e, ["error_?.copy_ystyle"]), n && o.swapAttrs(e, ["error_?.color", "error_?.thickness", "error_?.width"]);
            }
            if ("string" == typeof e.hoverinfo) {
              var a = e.hoverinfo.split("+");
              for (t = 0; t < a.length; t++) "x" === a[t] ? a[t] = "y" : "y" === a[t] && (a[t] = "x");
              e.hoverinfo = a.join("+");
            }
          }, t.coerceTraceIndices = function (e, t) {
            if (n(t)) return [t];
            if (!Array.isArray(t) || !t.length) return e.data.map(function (e, t) {
              return t;
            });
            if (Array.isArray(t)) {
              for (var r = [], a = 0; a < t.length; a++) o.isIndex(t[a], e.data.length) ? r.push(t[a]) : o.warn("trace index (", t[a], ") is not a number or is out of bounds");
              return r;
            }
            return t;
          }, t.manageArrayContainers = function (e, t, r) {
            var a = e.obj,
              i = e.parts,
              l = i.length,
              s = i[l - 1],
              c = n(s);
            if (c && null === t) {
              var u = i.slice(0, l - 1).join(".");
              o.nestedProperty(a, u).get().splice(s, 1);
            } else c && void 0 === e.get() ? (void 0 === e.get() && (r[e.astr] = null), e.set(t)) : e.set(t);
          };
          var x = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
          function b(e) {
            var t = e.search(x);
            if (t > 0) return e.substr(0, t);
          }
          t.hasParent = function (e, t) {
            for (var r = b(t); r;) {
              if (r in e) return !0;
              r = b(r);
            }
            return !1;
          };
          var _ = ["x", "y", "z"];
          t.clearAxisTypes = function (e, t, r) {
            for (var n = 0; n < t.length; n++) for (var a = e._fullData[n], i = 0; i < 3; i++) {
              var l = f(e, a, _[i]);
              if (l && "log" !== l.type) {
                var s = l._name,
                  c = l._id.substr(1);
                if ("scene" === c.substr(0, 5)) {
                  if (void 0 !== r[c]) continue;
                  s = c + "." + s;
                }
                var u = s + ".type";
                void 0 === r[s] && void 0 === r[u] && o.nestedProperty(e.layout, u).set(null);
              }
            }
          };
        },
        742: function (e, t, r) {
          "use strict";

          var n = r(1420);
          t._doPlot = n._doPlot, t.newPlot = n.newPlot, t.restyle = n.restyle, t.relayout = n.relayout, t.redraw = n.redraw, t.update = n.update, t._guiRestyle = n._guiRestyle, t._guiRelayout = n._guiRelayout, t._guiUpdate = n._guiUpdate, t._storeDirectGUIEdit = n._storeDirectGUIEdit, t.react = n.react, t.extendTraces = n.extendTraces, t.prependTraces = n.prependTraces, t.addTraces = n.addTraces, t.deleteTraces = n.deleteTraces, t.moveTraces = n.moveTraces, t.purge = n.purge, t.addFrames = n.addFrames, t.deleteFrames = n.deleteFrames, t.animate = n.animate, t.setPlotConfig = n.setPlotConfig;
          var a = r(5425).getGraphDiv,
            i = r(8231).eraseActiveShape;
          t.deleteActiveShape = function (e) {
            return i(a(e));
          }, t.toImage = r(491), t.validate = r(2466), t.downloadImage = r(6452);
          var o = r(3853);
          t.makeTemplate = o.makeTemplate, t.validateTemplate = o.validateTemplate;
        },
        5844: function (e, t, r) {
          "use strict";

          var n = r(6174),
            a = r(4969),
            i = r(8636),
            o = r(8813).sorterAsc,
            l = r(3626);
          t.containerArrayMatch = r(6037);
          var s = t.isAddVal = function (e) {
              return "add" === e || n(e);
            },
            c = t.isRemoveVal = function (e) {
              return null === e || "remove" === e;
            };
          t.applyContainerArrayChanges = function (e, t, r, n, u) {
            var f = t.astr,
              d = l.getComponentMethod(f, "supplyLayoutDefaults"),
              h = l.getComponentMethod(f, "draw"),
              p = l.getComponentMethod(f, "drawOne"),
              v = n.replot || n.recalc || d === a || h === a,
              g = e.layout,
              m = e._fullLayout;
            if (r[""]) {
              Object.keys(r).length > 1 && i.warn("Full array edits are incompatible with other edits", f);
              var y = r[""][""];
              if (c(y)) t.set(null);else {
                if (!Array.isArray(y)) return i.warn("Unrecognized full array edit value", f, y), !0;
                t.set(y);
              }
              return !v && (d(g, m), h(e), !0);
            }
            var x,
              b,
              _,
              w,
              T,
              M,
              k,
              A,
              L = Object.keys(r).map(Number).sort(o),
              S = t.get(),
              C = S || [],
              O = u(m, f).get(),
              D = [],
              P = -1,
              z = C.length;
            for (x = 0; x < L.length; x++) if (w = r[_ = L[x]], T = Object.keys(w), M = w[""], k = s(M), _ < 0 || _ > C.length - (k ? 0 : 1)) i.warn("index out of range", f, _);else if (void 0 !== M) T.length > 1 && i.warn("Insertion & removal are incompatible with edits to the same index.", f, _), c(M) ? D.push(_) : k ? ("add" === M && (M = {}), C.splice(_, 0, M), O && O.splice(_, 0, {})) : i.warn("Unrecognized full object edit value", f, _, M), -1 === P && (P = _);else for (b = 0; b < T.length; b++) A = f + "[" + _ + "].", u(C[_], T[b], A).set(w[T[b]]);
            for (x = D.length - 1; x >= 0; x--) C.splice(D[x], 1), O && O.splice(D[x], 1);
            if (C.length ? S || t.set(C) : t.set(null), v) return !1;
            if (d(g, m), p !== a) {
              var I;
              if (-1 === P) I = L;else {
                for (z = Math.max(C.length, z), I = [], x = 0; x < L.length && !((_ = L[x]) >= P); x++) I.push(_);
                for (x = P; x < z; x++) I.push(x);
              }
              for (x = 0; x < I.length; x++) p(e, I[x]);
            } else h(e);
            return !0;
          };
        },
        1420: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(721),
            i = r(9784),
            o = r(4809),
            l = o.nestedProperty,
            s = r(8596),
            c = r(486),
            u = r(3626),
            f = r(7297),
            d = r(4122),
            h = r(9714),
            p = r(259),
            v = r(5829),
            g = r(2203),
            m = r(8766),
            y = r(5284).initInteractions,
            x = r(2972),
            b = r(4844).clearOutline,
            _ = r(4452).dfltConfig,
            w = r(5844),
            T = r(887),
            M = r(1817),
            k = r(3582),
            A = r(4826).AX_NAME_PATTERN,
            L = 0;
          function S(e) {
            var t = e._fullLayout;
            t._redrawFromAutoMarginCount ? t._redrawFromAutoMarginCount-- : e.emit("plotly_afterplot");
          }
          function C(e, t) {
            try {
              e._fullLayout._paper.style("background", t);
            } catch (e) {
              o.error(e);
            }
          }
          function O(e, t) {
            C(e, m.combine(t, "white"));
          }
          function D(e, t) {
            if (!e._context) {
              e._context = o.extendDeep({}, _);
              var r = n.select("base");
              e._context._baseUrl = r.size() && r.attr("href") ? window.location.href.split("#")[0] : "";
            }
            var a,
              l,
              s,
              c = e._context;
            if (t) {
              for (l = Object.keys(t), a = 0; a < l.length; a++) "editable" !== (s = l[a]) && "edits" !== s && s in c && ("setBackground" === s && "opaque" === t[s] ? c[s] = O : c[s] = t[s]);
              t.plot3dPixelRatio && !c.plotGlPixelRatio && (c.plotGlPixelRatio = c.plot3dPixelRatio);
              var u = t.editable;
              if (void 0 !== u) for (c.editable = u, l = Object.keys(c.edits), a = 0; a < l.length; a++) c.edits[l[a]] = u;
              if (t.edits) for (l = Object.keys(t.edits), a = 0; a < l.length; a++) (s = l[a]) in c.edits && (c.edits[s] = t.edits[s]);
              c._exportedPlot = t._exportedPlot;
            }
            c.staticPlot && (c.editable = !1, c.edits = {}, c.autosizable = !1, c.scrollZoom = !1, c.doubleClick = !1, c.showTips = !1, c.showLink = !1, c.displayModeBar = !1), "hover" !== c.displayModeBar || i || (c.displayModeBar = !0), "transparent" !== c.setBackground && "function" == typeof c.setBackground || (c.setBackground = C), c._hasZeroHeight = c._hasZeroHeight || 0 === e.clientHeight, c._hasZeroWidth = c._hasZeroWidth || 0 === e.clientWidth;
            var f = c.scrollZoom,
              d = c._scrollZoom = {};
            if (!0 === f) d.cartesian = 1, d.gl3d = 1, d.geo = 1, d.mapbox = 1, d.map = 1;else if ("string" == typeof f) {
              var h = f.split("+");
              for (a = 0; a < h.length; a++) d[h[a]] = 1;
            } else !1 !== f && (d.gl3d = 1, d.geo = 1, d.mapbox = 1, d.map = 1);
          }
          function P(e, t) {
            var r,
              n,
              a = t + 1,
              i = [];
            for (r = 0; r < e.length; r++) (n = e[r]) < 0 ? i.push(a + n) : i.push(n);
            return i;
          }
          function z(e, t, r) {
            var n, a;
            for (n = 0; n < t.length; n++) {
              if ((a = t[n]) !== parseInt(a, 10)) throw new Error("all values in " + r + " must be integers");
              if (a >= e.data.length || a < -e.data.length) throw new Error(r + " must be valid indices for gd.data.");
              if (t.indexOf(a, n + 1) > -1 || a >= 0 && t.indexOf(-e.data.length + a) > -1 || a < 0 && t.indexOf(e.data.length + a) > -1) throw new Error("each index in " + r + " must be unique.");
            }
          }
          function I(e, t, r) {
            if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
            if (void 0 === t) throw new Error("currentIndices is a required argument.");
            if (Array.isArray(t) || (t = [t]), z(e, t, "currentIndices"), void 0 === r || Array.isArray(r) || (r = [r]), void 0 !== r && z(e, r, "newIndices"), void 0 !== r && t.length !== r.length) throw new Error("current and new indices must be of equal length.");
          }
          function E(e, t, r, n, i) {
            !function (e, t, r, n) {
              var a = o.isPlainObject(n);
              if (!Array.isArray(e.data)) throw new Error("gd.data must be an array");
              if (!o.isPlainObject(t)) throw new Error("update must be a key:value object");
              if (void 0 === r) throw new Error("indices must be an integer or array of integers");
              for (var i in z(e, r, "indices"), t) {
                if (!Array.isArray(t[i]) || t[i].length !== r.length) throw new Error("attribute " + i + " must be an array of length equal to indices array length");
                if (a && (!(i in n) || !Array.isArray(n[i]) || n[i].length !== t[i].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
              }
            }(e, t, r, n);
            for (var s = function (e, t, r, n) {
                var i,
                  s,
                  c,
                  u,
                  f,
                  d = o.isPlainObject(n),
                  h = [];
                for (var p in Array.isArray(r) || (r = [r]), r = P(r, e.data.length - 1), t) for (var v = 0; v < r.length; v++) {
                  if (i = e.data[r[v]], s = (c = l(i, p)).get(), u = t[p][v], !o.isArrayOrTypedArray(u)) throw new Error("attribute: " + p + " index: " + v + " must be an array");
                  if (!o.isArrayOrTypedArray(s)) throw new Error("cannot extend missing or non-array attribute: " + p);
                  if (s.constructor !== u.constructor) throw new Error("cannot extend array with an array of a different type: " + p);
                  f = d ? n[p][v] : n, a(f) || (f = -1), h.push({
                    prop: c,
                    target: s,
                    insert: u,
                    maxp: Math.floor(f)
                  });
                }
                return h;
              }(e, t, r, n), c = {}, u = {}, f = 0; f < s.length; f++) {
              var d = s[f].prop,
                h = s[f].maxp,
                p = i(s[f].target, s[f].insert, h);
              d.set(p[0]), Array.isArray(c[d.astr]) || (c[d.astr] = []), c[d.astr].push(p[1]), Array.isArray(u[d.astr]) || (u[d.astr] = []), u[d.astr].push(s[f].target.length);
            }
            return {
              update: c,
              maxPoints: u
            };
          }
          function R(e, t) {
            var r = new e.constructor(e.length + t.length);
            return r.set(e), r.set(t, e.length), r;
          }
          function N(e, r, n, a) {
            e = o.getGraphDiv(e), T.clearPromiseQueue(e);
            var i = {};
            if ("string" == typeof r) i[r] = n;else {
              if (!o.isPlainObject(r)) return o.warn("Restyle fail.", r, n, a), Promise.reject();
              i = o.extendFlat({}, r), void 0 === a && (a = n);
            }
            Object.keys(i).length && (e.changed = !0);
            var l = T.coerceTraceIndices(e, a),
              s = j(e, i, l),
              u = s.flags;
            u.calc && (e.calcdata = void 0), u.clearAxisTypes && T.clearAxisTypes(e, l, {});
            var f = [];
            u.fullReplot ? f.push(t._doPlot) : (f.push(d.previousPromises), d.supplyDefaults(e), u.markerSize && (d.doCalcdata(e), q(f)), u.style && f.push(M.doTraceStyle), u.colorbars && f.push(M.doColorBars), f.push(S)), f.push(d.rehover, d.redrag, d.reselect), c.add(e, N, [e, s.undoit, s.traces], N, [e, s.redoit, s.traces]);
            var h = o.syncOrAsync(f, e);
            return h && h.then || (h = Promise.resolve()), h.then(function () {
              return e.emit("plotly_restyle", s.eventData), e;
            });
          }
          function F(e) {
            return void 0 === e ? null : e;
          }
          function H(e, t) {
            return t ? function (t, r, n) {
              var a = l(t, r),
                i = a.set;
              return a.set = function (t) {
                B((n || "") + r, a.get(), t, e), i(t);
              }, a;
            } : l;
          }
          function B(e, t, r, n) {
            if (Array.isArray(t) || Array.isArray(r)) for (var a = Array.isArray(t) ? t : [], i = Array.isArray(r) ? r : [], l = Math.max(a.length, i.length), s = 0; s < l; s++) B(e + "[" + s + "]", a[s], i[s], n);else if (o.isPlainObject(t) || o.isPlainObject(r)) {
              var c = o.isPlainObject(t) ? t : {},
                u = o.isPlainObject(r) ? r : {},
                f = o.extendFlat({}, c, u);
              for (var d in f) B(e + "." + d, c[d], u[d], n);
            } else void 0 === n[e] && (n[e] = F(t));
          }
          function j(e, t, r) {
            var n,
              a = e._fullLayout,
              i = e._fullData,
              s = e.data,
              c = a._guiEditing,
              p = H(a._preGUI, c),
              v = o.extendDeepAll({}, t);
            Y(t);
            var g,
              m = k.traceFlags(),
              y = {},
              x = {};
            function b() {
              return r.map(function () {});
            }
            function _(e) {
              var t = h.id2name(e);
              -1 === g.indexOf(t) && g.push(t);
            }
            function w(e) {
              return "LAYOUT" + e + ".autorange";
            }
            function M(e) {
              return "LAYOUT" + e + ".range";
            }
            function A(e) {
              for (var t = e; t < i.length; t++) if (i[t]._input === s[e]) return i[t];
            }
            function L(n, i, o) {
              if (Array.isArray(n)) n.forEach(function (e) {
                L(e, i, o);
              });else if (!(n in t) && !T.hasParent(t, n)) {
                var l;
                if ("LAYOUT" === n.substr(0, 6)) l = p(e.layout, n.replace("LAYOUT", ""));else {
                  var u = r[o];
                  l = H(a._tracePreGUI[A(u)._fullInput.uid], c)(s[u], n);
                }
                n in x || (x[n] = b()), void 0 === x[n][o] && (x[n][o] = F(l.get())), void 0 !== i && l.set(i);
              }
            }
            function S(e) {
              return function (t) {
                return i[t][e];
              };
            }
            function C(e) {
              return function (t, n) {
                return !1 === t ? i[r[n]][e] : null;
              };
            }
            for (var O in t) {
              if (T.hasParent(t, O)) throw new Error("cannot set " + O + " and a parent attribute simultaneously");
              var D,
                P,
                z,
                I,
                E,
                R,
                N = t[O];
              if ("autobinx" !== O && "autobiny" !== O || (O = O.charAt(O.length - 1) + "bins", N = Array.isArray(N) ? N.map(C(O)) : !1 === N ? r.map(S(O)) : null), y[O] = N, "LAYOUT" !== O.substr(0, 6)) {
                for (x[O] = b(), n = 0; n < r.length; n++) if (D = s[r[n]], P = A(r[n]), I = (z = H(a._tracePreGUI[P._fullInput.uid], c)(D, O)).get(), void 0 !== (E = Array.isArray(N) ? N[n % N.length] : N)) {
                  var B = z.parts[z.parts.length - 1],
                    j = O.substr(0, O.length - B.length - 1),
                    V = j ? j + "." : "",
                    U = j ? l(P, j).get() : P;
                  if ((R = f.getTraceValObject(P, z.parts)) && R.impliedEdits && null !== E) for (var q in R.impliedEdits) L(o.relativeAttr(O, q), R.impliedEdits[q], n);else if ("thicknessmode" !== B && "lenmode" !== B || I === E || "fraction" !== E && "pixels" !== E || !U) {
                    if ("type" === O && ("pie" === E != ("pie" === I) || "funnelarea" === E != ("funnelarea" === I))) {
                      var G = "x",
                        Z = "y";
                      "bar" !== E && "bar" !== I || "h" !== D.orientation || (G = "y", Z = "x"), o.swapAttrs(D, ["?", "?src"], "labels", G), o.swapAttrs(D, ["d?", "?0"], "label", G), o.swapAttrs(D, ["?", "?src"], "values", Z), "pie" === I || "funnelarea" === I ? (l(D, "marker.color").set(l(D, "marker.colors").get()), a._pielayer.selectAll("g.trace").remove()) : u.traceIs(D, "cartesian") && l(D, "marker.colors").set(l(D, "marker.color").get());
                    }
                  } else {
                    var W = a._size,
                      J = U.orient,
                      X = "top" === J || "bottom" === J;
                    if ("thicknessmode" === B) {
                      var K = X ? W.h : W.w;
                      L(V + "thickness", U.thickness * ("fraction" === E ? 1 / K : K), n);
                    } else {
                      var Q = X ? W.w : W.h;
                      L(V + "len", U.len * ("fraction" === E ? 1 / Q : Q), n);
                    }
                  }
                  if (x[O][n] = F(I), -1 !== ["swapxy", "swapxyaxes", "orientation", "orientationaxes"].indexOf(O)) {
                    if ("orientation" === O) {
                      z.set(E);
                      var $ = D.x && !D.y ? "h" : "v";
                      if ((z.get() || $) === P.orientation) continue;
                    } else "orientationaxes" === O && (D.orientation = {
                      v: "h",
                      h: "v"
                    }[P.orientation]);
                    T.swapXYData(D), m.calc = m.clearAxisTypes = !0;
                  } else -1 !== d.dataArrayContainers.indexOf(z.parts[0]) ? (T.manageArrayContainers(z, E, x), m.calc = !0) : (R ? R.arrayOk && !u.traceIs(P, "regl") && (o.isArrayOrTypedArray(E) || o.isArrayOrTypedArray(I)) ? m.calc = !0 : k.update(m, R) : m.calc = !0, z.set(E));
                }
                if (-1 !== ["swapxyaxes", "orientationaxes"].indexOf(O) && h.swap(e, r), "orientationaxes" === O) {
                  var ee = l(e.layout, "hovermode"),
                    te = ee.get();
                  "x" === te ? ee.set("y") : "y" === te ? ee.set("x") : "x unified" === te ? ee.set("y unified") : "y unified" === te && ee.set("x unified");
                }
                if (-1 !== ["orientation", "type"].indexOf(O)) {
                  for (g = [], n = 0; n < r.length; n++) {
                    var re = s[r[n]];
                    u.traceIs(re, "cartesian") && (_(re.xaxis || "x"), _(re.yaxis || "y"));
                  }
                  L(g.map(w), !0, 0), L(g.map(M), [0, 1], 0);
                }
              } else z = p(e.layout, O.replace("LAYOUT", "")), x[O] = [F(z.get())], z.set(Array.isArray(N) ? N[0] : N), m.calc = !0;
            }
            return (m.calc || m.plot) && (m.fullReplot = !0), {
              flags: m,
              undoit: x,
              redoit: y,
              traces: r,
              eventData: o.extendDeepNoArrays([], [v, r])
            };
          }
          function Y(e) {
            var t,
              r,
              n,
              a = o.counterRegex("axis", ".title", !1, !1),
              i = /colorbar\.title$/,
              l = Object.keys(e);
            for (t = 0; t < l.length; t++) r = l[t], n = e[r], "title" !== r && !a.test(r) && !i.test(r) || "string" != typeof n && "number" != typeof n ? r.indexOf("titlefont") > -1 && -1 === r.indexOf("grouptitlefont") ? s(r, r.replace("titlefont", "title.font")) : r.indexOf("titleposition") > -1 ? s(r, r.replace("titleposition", "title.position")) : r.indexOf("titleside") > -1 ? s(r, r.replace("titleside", "title.side")) : r.indexOf("titleoffset") > -1 && s(r, r.replace("titleoffset", "title.offset")) : s(r, r.replace("title", "title.text"));
            function s(t, r) {
              e[r] = e[t], delete e[t];
            }
          }
          function V(e, t, r) {
            e = o.getGraphDiv(e), T.clearPromiseQueue(e);
            var n = {};
            if ("string" == typeof t) n[t] = r;else {
              if (!o.isPlainObject(t)) return o.warn("Relayout fail.", t, r), Promise.reject();
              n = o.extendFlat({}, t);
            }
            Object.keys(n).length && (e.changed = !0);
            var a = J(e, n),
              i = a.flags;
            i.calc && (e.calcdata = void 0);
            var l = [d.previousPromises];
            i.layoutReplot ? l.push(M.layoutReplot) : Object.keys(n).length && (U(e, i, a) || d.supplyDefaults(e), i.legend && l.push(M.doLegend), i.layoutstyle && l.push(M.layoutStyles), i.axrange && q(l, a.rangesAltered), i.ticks && l.push(M.doTicksRelayout), i.modebar && l.push(M.doModeBar), i.camera && l.push(M.doCamera), i.colorbars && l.push(M.doColorBars), l.push(S)), l.push(d.rehover, d.redrag, d.reselect), c.add(e, V, [e, a.undoit], V, [e, a.redoit]);
            var s = o.syncOrAsync(l, e);
            return s && s.then || (s = Promise.resolve(e)), s.then(function () {
              return e.emit("plotly_relayout", a.eventData), e;
            });
          }
          function U(e, t, r) {
            var n,
              a,
              i = e._fullLayout;
            if (!t.axrange) return !1;
            for (var l in t) if ("axrange" !== l && t[l]) return !1;
            var s = function (e, t) {
                return o.coerce(n, a, v, e, t);
              },
              c = {};
            for (var u in r.rangesAltered) {
              var f = h.id2name(u);
              if (n = e.layout[f], a = i[f], p(n, a, s, c), a._matchGroup) for (var d in a._matchGroup) if (d !== u) {
                var g = i[h.id2name(d)];
                g.autorange = a.autorange, g.range = a.range.slice(), g._input.range = a.range.slice();
              }
            }
            return !0;
          }
          function q(e, t) {
            var r = t ? function (e) {
              var r = [];
              for (var n in t) {
                var a = h.getFromId(e, n);
                if (r.push(n), -1 !== (a.ticklabelposition || "").indexOf("inside") && a._anchorAxis && r.push(a._anchorAxis._id), a._matchGroup) for (var i in a._matchGroup) t[i] || r.push(i);
              }
              return h.draw(e, r, {
                skipTitle: !0
              });
            } : function (e) {
              return h.draw(e, "redraw");
            };
            e.push(b, M.doAutoRangeAndConstraints, r, M.drawData, M.finalDraw);
          }
          var G = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/,
            Z = /^[xyz]axis[0-9]*\.autorange$/,
            W = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
          function J(e, t) {
            var r,
              n,
              a,
              i = e.layout,
              s = e._fullLayout,
              c = s._guiEditing,
              d = H(s._preGUI, c),
              p = Object.keys(t),
              v = h.list(e),
              g = o.extendDeepAll({}, t),
              m = {};
            for (Y(t), p = Object.keys(t), n = 0; n < p.length; n++) if (0 === p[n].indexOf("allaxes")) {
              for (a = 0; a < v.length; a++) {
                var y = v[a]._id.substr(1),
                  x = -1 !== y.indexOf("scene") ? y + "." : "",
                  b = p[n].replace("allaxes", x + v[a]._name);
                t[b] || (t[b] = t[p[n]]);
              }
              delete t[p[n]];
            }
            var _ = k.layoutFlags(),
              M = {},
              L = {};
            function S(e, r) {
              if (Array.isArray(e)) e.forEach(function (e) {
                S(e, r);
              });else if (!(e in t) && !T.hasParent(t, e)) {
                var n = d(i, e);
                e in L || (L[e] = F(n.get())), void 0 !== r && n.set(r);
              }
            }
            var C,
              O = {};
            function D(e) {
              var t = h.name2id(e.split(".")[0]);
              return O[t] = 1, t;
            }
            for (var P in t) {
              if (T.hasParent(t, P)) throw new Error("cannot set " + P + " and a parent attribute simultaneously");
              for (var z = d(i, P), I = t[P], E = z.parts.length - 1; E > 0 && "string" != typeof z.parts[E];) E--;
              var R = z.parts[E],
                N = z.parts[E - 1] + "." + R,
                B = z.parts.slice(0, E).join("."),
                j = l(e.layout, B).get(),
                V = l(s, B).get(),
                U = z.get();
              if (void 0 !== I) {
                M[P] = I, L[P] = "reverse" === R ? I : F(U);
                var q = f.getLayoutValObject(s, z.parts);
                if (q && q.impliedEdits && null !== I) for (var J in q.impliedEdits) S(o.relativeAttr(P, J), q.impliedEdits[J]);
                if (-1 !== ["width", "height"].indexOf(P)) {
                  if (I) {
                    S("autosize", null);
                    var K = "height" === P ? "width" : "height";
                    S(K, s[K]);
                  } else s[P] = e._initialAutoSize[P];
                } else if ("autosize" === P) S("width", I ? null : s.width), S("height", I ? null : s.height);else if (N.match(G)) D(N), l(s, B + "._inputRange").set(null);else if (N.match(Z)) {
                  D(N), l(s, B + "._inputRange").set(null);
                  var Q = l(s, B).get();
                  Q._inputDomain && (Q._input.domain = Q._inputDomain.slice());
                } else N.match(W) && l(s, B + "._inputDomain").set(null);
                if ("type" === R) {
                  C = j;
                  var $ = "linear" === V.type && "log" === I,
                    ee = "log" === V.type && "linear" === I;
                  if ($ || ee) {
                    if (C && C.range) {
                      if (V.autorange) $ && (C.range = C.range[1] > C.range[0] ? [1, 2] : [2, 1]);else {
                        var te = C.range[0],
                          re = C.range[1];
                        $ ? (te <= 0 && re <= 0 && S(B + ".autorange", !0), te <= 0 ? te = re / 1e6 : re <= 0 && (re = te / 1e6), S(B + ".range[0]", Math.log(te) / Math.LN10), S(B + ".range[1]", Math.log(re) / Math.LN10)) : (S(B + ".range[0]", Math.pow(10, te)), S(B + ".range[1]", Math.pow(10, re)));
                      }
                    } else S(B + ".autorange", !0);
                    Array.isArray(s._subplots.polar) && s._subplots.polar.length && s[z.parts[0]] && "radialaxis" === z.parts[1] && delete s[z.parts[0]]._subplot.viewInitial["radialaxis.range"], u.getComponentMethod("annotations", "convertCoords")(e, V, I, S), u.getComponentMethod("images", "convertCoords")(e, V, I, S);
                  } else S(B + ".autorange", !0), S(B + ".range", null);
                  l(s, B + "._inputRange").set(null);
                } else if (R.match(A)) {
                  var ne = l(s, P).get(),
                    ae = (I || {}).type;
                  ae && "-" !== ae || (ae = "linear"), u.getComponentMethod("annotations", "convertCoords")(e, ne, ae, S), u.getComponentMethod("images", "convertCoords")(e, ne, ae, S);
                }
                var ie = w.containerArrayMatch(P);
                if (ie) {
                  r = ie.array, n = ie.index;
                  var oe = ie.property,
                    le = q || {
                      editType: "calc"
                    };
                  "" !== n && "" === oe && (w.isAddVal(I) ? L[P] = null : w.isRemoveVal(I) ? L[P] = (l(i, r).get() || [])[n] : o.warn("unrecognized full object value", t)), k.update(_, le), m[r] || (m[r] = {});
                  var se = m[r][n];
                  se || (se = m[r][n] = {}), se[oe] = I, delete t[P];
                } else "reverse" === R ? (j.range ? j.range.reverse() : (S(B + ".autorange", !0), j.range = [1, 0]), V.autorange ? _.calc = !0 : _.plot = !0) : ("dragmode" === P && (!1 === I && !1 !== U || !1 !== I && !1 === U) || s._has("scatter-like") && s._has("regl") && "dragmode" === P && ("lasso" === I || "select" === I) && "lasso" !== U && "select" !== U || s._has("gl2d") ? _.plot = !0 : q ? k.update(_, q) : _.calc = !0, z.set(I));
              }
            }
            for (r in m) w.applyContainerArrayChanges(e, d(i, r), m[r], _, d) || (_.plot = !0);
            for (var ce in O) {
              var ue = (C = h.getFromId(e, ce)) && C._constraintGroup;
              if (ue) for (var fe in _.calc = !0, ue) O[fe] || (h.getFromId(e, fe)._constraintShrinkable = !0);
            }
            (X(e) || t.height || t.width) && (_.plot = !0);
            var de = s.shapes;
            for (n = 0; n < de.length; n++) if (de[n].showlegend) {
              _.calc = !0;
              break;
            }
            return (_.plot || _.calc) && (_.layoutReplot = !0), {
              flags: _,
              rangesAltered: O,
              undoit: L,
              redoit: M,
              eventData: g
            };
          }
          function X(e) {
            var t = e._fullLayout,
              r = t.width,
              n = t.height;
            return e.layout.autosize && d.plotAutoSize(e, e.layout, t), t.width !== r || t.height !== n;
          }
          function K(e, r, n, a) {
            e = o.getGraphDiv(e), T.clearPromiseQueue(e), o.isPlainObject(r) || (r = {}), o.isPlainObject(n) || (n = {}), Object.keys(r).length && (e.changed = !0), Object.keys(n).length && (e.changed = !0);
            var i = T.coerceTraceIndices(e, a),
              l = j(e, o.extendFlat({}, r), i),
              s = l.flags,
              u = J(e, o.extendFlat({}, n)),
              f = u.flags;
            (s.calc || f.calc) && (e.calcdata = void 0), s.clearAxisTypes && T.clearAxisTypes(e, i, n);
            var h = [];
            f.layoutReplot ? h.push(M.layoutReplot) : s.fullReplot ? h.push(t._doPlot) : (h.push(d.previousPromises), U(e, f, u) || d.supplyDefaults(e), s.style && h.push(M.doTraceStyle), (s.colorbars || f.colorbars) && h.push(M.doColorBars), f.legend && h.push(M.doLegend), f.layoutstyle && h.push(M.layoutStyles), f.axrange && q(h, u.rangesAltered), f.ticks && h.push(M.doTicksRelayout), f.modebar && h.push(M.doModeBar), f.camera && h.push(M.doCamera), h.push(S)), h.push(d.rehover, d.redrag, d.reselect), c.add(e, K, [e, l.undoit, u.undoit, l.traces], K, [e, l.redoit, u.redoit, l.traces]);
            var p = o.syncOrAsync(h, e);
            return p && p.then || (p = Promise.resolve(e)), p.then(function () {
              return e.emit("plotly_update", {
                data: l.eventData,
                layout: u.eventData
              }), e;
            });
          }
          function Q(e) {
            return function (t) {
              t._fullLayout._guiEditing = !0;
              var r = e.apply(null, arguments);
              return t._fullLayout._guiEditing = !1, r;
            };
          }
          var $ = [{
              pattern: /^hiddenlabels/,
              attr: "legend.uirevision"
            }, {
              pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
            }, {
              pattern: /axis\d*\.showspikes$/,
              attr: "modebar.uirevision"
            }, {
              pattern: /(hover|drag)mode$/,
              attr: "modebar.uirevision"
            }, {
              pattern: /^(scene\d*)\.camera/
            }, {
              pattern: /^(geo\d*)\.(projection|center|fitbounds)/
            }, {
              pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
            }, {
              pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
            }, {
              pattern: /^(polar\d*\.angularaxis)\.rotation/
            }, {
              pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
            }, {
              pattern: /^(map\d*)\.(center|zoom|bearing|pitch)/
            }, {
              pattern: /^legend\.(x|y)$/,
              attr: "editrevision"
            }, {
              pattern: /^(shapes|annotations)/,
              attr: "editrevision"
            }, {
              pattern: /^title\.text$/,
              attr: "editrevision"
            }],
            ee = [{
              pattern: /^selectedpoints$/,
              attr: "selectionrevision"
            }, {
              pattern: /(^|value\.)visible$/,
              attr: "legend.uirevision"
            }, {
              pattern: /^dimensions\[\d+\]\.constraintrange/
            }, {
              pattern: /^node\.(x|y|groups)/
            }, {
              pattern: /^level$/
            }, {
              pattern: /(^|value\.)name$/
            }, {
              pattern: /colorbar\.title\.text$/
            }, {
              pattern: /colorbar\.(x|y)$/,
              attr: "editrevision"
            }];
          function te(e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r],
                a = e.match(n.pattern);
              if (a) {
                var i = a[1] || "";
                return {
                  head: i,
                  tail: e.substr(i.length + 1),
                  attr: n.attr
                };
              }
            }
          }
          function re(e, t) {
            var r = l(t, e).get();
            if (void 0 !== r) return r;
            var n = e.split(".");
            for (n.pop(); n.length > 1;) if (n.pop(), void 0 !== (r = l(t, n.join(".") + ".uirevision").get())) return r;
            return t.uirevision;
          }
          function ne(e, t) {
            for (var r = 0; r < t.length; r++) if (t[r]._fullInput.uid === e) return r;
            return -1;
          }
          function ae(e, t, r) {
            for (var n = 0; n < t.length; n++) if (t[n].uid === e) return n;
            return !t[r] || t[r].uid ? -1 : r;
          }
          function ie(e, t) {
            var r = o.isPlainObject(e),
              n = Array.isArray(e);
            return r || n ? (r && o.isPlainObject(t) || n && Array.isArray(t)) && JSON.stringify(e) === JSON.stringify(t) : e === t;
          }
          function oe(e, t, r, n) {
            var a,
              i,
              s,
              c = n.getValObject,
              u = n.flags,
              f = n.immutable,
              d = n.inArray,
              h = n.arrayIndex;
            function p() {
              var e = a.editType;
              d && -1 !== e.indexOf("arraydraw") ? o.pushUnique(u.arrays[d], h) : (k.update(u, a), "none" !== e && u.nChanges++, n.transition && a.anim && u.nChangesAnim++, (G.test(s) || Z.test(s)) && (u.rangesAltered[r[0]] = 1), W.test(s) && l(t, "_inputDomain").set(null), "datarevision" === i && (u.newDataRevision = 1));
            }
            function v(e) {
              return "data_array" === e.valType || e.arrayOk;
            }
            for (i in e) {
              if (u.calc && !n.transition) return;
              var g = e[i],
                m = t[i],
                y = r.concat(i);
              if (s = y.join("."), "_" !== i.charAt(0) && "function" != typeof g && g !== m) {
                if (("tick0" === i || "dtick" === i) && "geo" !== r[0]) {
                  var x = t.tickmode;
                  if ("auto" === x || "array" === x || !x) continue;
                }
                if (("range" !== i || !t.autorange) && ("zmin" !== i && "zmax" !== i || "contourcarpet" !== t.type) && (a = c(y)) && (!a._compareAsJSON || JSON.stringify(g) !== JSON.stringify(m))) {
                  var b,
                    _ = a.valType,
                    w = v(a),
                    T = Array.isArray(g),
                    M = Array.isArray(m);
                  if (T && M) {
                    var A = "_input_" + i,
                      L = e[A],
                      S = t[A];
                    if (Array.isArray(L) && L === S) continue;
                  }
                  if (void 0 === m) w && T ? u.calc = !0 : p();else if (a._isLinkedToArray) {
                    var C = [],
                      O = !1;
                    d || (u.arrays[i] = C);
                    var D = Math.min(g.length, m.length),
                      P = Math.max(g.length, m.length);
                    if (D !== P) {
                      if ("arraydraw" !== a.editType) {
                        p();
                        continue;
                      }
                      O = !0;
                    }
                    for (b = 0; b < D; b++) oe(g[b], m[b], y.concat(b), o.extendFlat({
                      inArray: i,
                      arrayIndex: b
                    }, n));
                    if (O) for (b = D; b < P; b++) C.push(b);
                  } else !_ && o.isPlainObject(g) ? oe(g, m, y, n) : w ? T && M ? (f && (u.calc = !0), (f || n.newDataRevision) && p()) : T !== M ? u.calc = !0 : p() : T && M && g.length === m.length && String(g) === String(m) || p();
                }
              }
            }
            for (i in t) if (!(i in e) && "_" !== i.charAt(0) && "function" != typeof t[i]) {
              if (v(a = c(r.concat(i))) && Array.isArray(t[i])) return void (u.calc = !0);
              p();
            }
          }
          function le(e, t) {
            var r;
            for (r in e) if ("_" !== r.charAt(0)) {
              var n = e[r],
                a = t[r];
              if (n !== a) if (o.isPlainObject(n) && o.isPlainObject(a)) {
                if (le(n, a)) return !0;
              } else {
                if (!Array.isArray(n) || !Array.isArray(a)) return !0;
                if (n.length !== a.length) return !0;
                for (var i = 0; i < n.length; i++) if (n[i] !== a[i]) {
                  if (!o.isPlainObject(n[i]) || !o.isPlainObject(a[i])) return !0;
                  if (le(n[i], a[i])) return !0;
                }
              }
            }
          }
          function se(e) {
            var t = e._fullLayout,
              r = e.getBoundingClientRect();
            if (!o.equalDomRects(r, t._lastBBox)) {
              var n = t._invTransform = o.inverseTransformMatrix(o.getFullTransformMatrix(e));
              t._invScaleX = Math.sqrt(n[0][0] * n[0][0] + n[0][1] * n[0][1] + n[0][2] * n[0][2]), t._invScaleY = Math.sqrt(n[1][0] * n[1][0] + n[1][1] * n[1][1] + n[1][2] * n[1][2]), t._lastBBox = r;
            }
          }
          t.animate = function (e, t, r) {
            if (e = o.getGraphDiv(e), !o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
            var n = e._transitionData;
            n._frameQueue || (n._frameQueue = []);
            var a = (r = d.supplyAnimationDefaults(r)).transition,
              i = r.frame;
            function l(e) {
              return Array.isArray(a) ? e >= a.length ? a[0] : a[e] : a;
            }
            function s(e) {
              return Array.isArray(i) ? e >= i.length ? i[0] : i[e] : i;
            }
            function c(e, t) {
              var r = 0;
              return function () {
                if (e && ++r === t) return e();
              };
            }
            return void 0 === n._frameWaitingCnt && (n._frameWaitingCnt = 0), new Promise(function (i, u) {
              function f() {
                e.emit("plotly_animating"), n._lastFrameAt = -1 / 0, n._timeToNext = 0, n._runningTransitions = 0, n._currentFrame = null;
                var t = function () {
                  n._animationRaf = window.requestAnimationFrame(t), Date.now() - n._lastFrameAt > n._timeToNext && function () {
                    n._currentFrame && n._currentFrame.onComplete && n._currentFrame.onComplete();
                    var t = n._currentFrame = n._frameQueue.shift();
                    if (t) {
                      var r = t.name ? t.name.toString() : null;
                      e._fullLayout._currentFrame = r, n._lastFrameAt = Date.now(), n._timeToNext = t.frameOpts.duration, d.transition(e, t.frame.data, t.frame.layout, T.coerceTraceIndices(e, t.frame.traces), t.frameOpts, t.transitionOpts).then(function () {
                        t.onComplete && t.onComplete();
                      }), e.emit("plotly_animatingframe", {
                        name: r,
                        frame: t.frame,
                        animation: {
                          frame: t.frameOpts,
                          transition: t.transitionOpts
                        }
                      });
                    } else e.emit("plotly_animated"), window.cancelAnimationFrame(n._animationRaf), n._animationRaf = null;
                  }();
                };
                t();
              }
              var h,
                p,
                v = 0;
              function g(e) {
                return Array.isArray(a) ? v >= a.length ? e.transitionOpts = a[v] : e.transitionOpts = a[0] : e.transitionOpts = a, v++, e;
              }
              var m = [],
                y = null == t,
                x = Array.isArray(t);
              if (y || x || !o.isPlainObject(t)) {
                if (y || -1 !== ["string", "number"].indexOf(typeof t)) for (h = 0; h < n._frames.length; h++) (p = n._frames[h]) && (y || String(p.group) === String(t)) && m.push({
                  type: "byname",
                  name: String(p.name),
                  data: g({
                    name: p.name
                  })
                });else if (x) for (h = 0; h < t.length; h++) {
                  var b = t[h];
                  -1 !== ["number", "string"].indexOf(typeof b) ? (b = String(b), m.push({
                    type: "byname",
                    name: b,
                    data: g({
                      name: b
                    })
                  })) : o.isPlainObject(b) && m.push({
                    type: "object",
                    data: g(o.extendFlat({}, b))
                  });
                }
              } else m.push({
                type: "object",
                data: g(o.extendFlat({}, t))
              });
              for (h = 0; h < m.length; h++) if ("byname" === (p = m[h]).type && !n._frameHash[p.data.name]) return o.warn('animate failure: frame not found: "' + p.data.name + '"'), void u();
              -1 !== ["next", "immediate"].indexOf(r.mode) && function () {
                if (0 !== n._frameQueue.length) {
                  for (; n._frameQueue.length;) {
                    var t = n._frameQueue.pop();
                    t.onInterrupt && t.onInterrupt();
                  }
                  e.emit("plotly_animationinterrupted", []);
                }
              }(), "reverse" === r.direction && m.reverse();
              var _ = e._fullLayout._currentFrame;
              if (_ && r.fromcurrent) {
                var w = -1;
                for (h = 0; h < m.length; h++) if ("byname" === (p = m[h]).type && p.name === _) {
                  w = h;
                  break;
                }
                if (w > 0 && w < m.length - 1) {
                  var M = [];
                  for (h = 0; h < m.length; h++) p = m[h], ("byname" !== m[h].type || h > w) && M.push(p);
                  m = M;
                }
              }
              m.length > 0 ? function (t) {
                if (0 !== t.length) {
                  for (var a = 0; a < t.length; a++) {
                    var o;
                    o = "byname" === t[a].type ? d.computeFrame(e, t[a].name) : t[a].data;
                    var h = s(a),
                      p = l(a);
                    p.duration = Math.min(p.duration, h.duration);
                    var v = {
                      frame: o,
                      name: t[a].name,
                      frameOpts: h,
                      transitionOpts: p
                    };
                    a === t.length - 1 && (v.onComplete = c(i, 2), v.onInterrupt = u), n._frameQueue.push(v);
                  }
                  "immediate" === r.mode && (n._lastFrameAt = -1 / 0), n._animationRaf || f();
                }
              }(m) : (e.emit("plotly_animated"), i());
            });
          }, t.addFrames = function (e, t, r) {
            if (e = o.getGraphDiv(e), null == t) return Promise.resolve();
            if (!o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
            var n,
              a,
              i,
              l,
              s = e._transitionData._frames,
              u = e._transitionData._frameHash;
            if (!Array.isArray(t)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + t);
            var f = s.length + 2 * t.length,
              h = [],
              p = {};
            for (n = t.length - 1; n >= 0; n--) if (o.isPlainObject(t[n])) {
              var v = t[n].name,
                g = (u[v] || p[v] || {}).name,
                m = t[n].name,
                y = u[g] || p[g];
              g && m && "number" == typeof m && y && L < 5 && (L++, o.warn('addFrames: overwriting frame "' + (u[g] || p[g]).name + '" with a frame whose name of type "number" also equates to "' + g + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), 5 === L && o.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), p[v] = {
                name: v
              }, h.push({
                frame: d.supplyFrameDefaults(t[n]),
                index: r && void 0 !== r[n] && null !== r[n] ? r[n] : f + n
              });
            }
            h.sort(function (e, t) {
              return e.index > t.index ? -1 : e.index < t.index ? 1 : 0;
            });
            var x = [],
              b = [],
              _ = s.length;
            for (n = h.length - 1; n >= 0; n--) {
              if ("number" == typeof (a = h[n].frame).name && o.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !a.name) for (; u[a.name = "frame " + e._transitionData._counter++];);
              if (u[a.name]) {
                for (i = 0; i < s.length && (s[i] || {}).name !== a.name; i++);
                x.push({
                  type: "replace",
                  index: i,
                  value: a
                }), b.unshift({
                  type: "replace",
                  index: i,
                  value: s[i]
                });
              } else l = Math.max(0, Math.min(h[n].index, _)), x.push({
                type: "insert",
                index: l,
                value: a
              }), b.unshift({
                type: "delete",
                index: l
              }), _++;
            }
            var w = d.modifyFrames,
              T = d.modifyFrames,
              M = [e, b],
              k = [e, x];
            return c && c.add(e, w, M, T, k), d.modifyFrames(e, x);
          }, t.deleteFrames = function (e, t) {
            if (e = o.getGraphDiv(e), !o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
            var r,
              n,
              a = e._transitionData._frames,
              i = [],
              l = [];
            if (!t) for (t = [], r = 0; r < a.length; r++) t.push(r);
            for ((t = t.slice()).sort(), r = t.length - 1; r >= 0; r--) n = t[r], i.push({
              type: "delete",
              index: n
            }), l.unshift({
              type: "insert",
              index: n,
              value: a[n]
            });
            var s = d.modifyFrames,
              u = d.modifyFrames,
              f = [e, l],
              h = [e, i];
            return c && c.add(e, s, f, u, h), d.modifyFrames(e, i);
          }, t.addTraces = function e(r, n, a) {
            r = o.getGraphDiv(r);
            var i,
              l,
              s = [],
              u = t.deleteTraces,
              f = e,
              d = [r, s],
              h = [r, n];
            for (function (e, t, r) {
              var n, a;
              if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
              if (void 0 === t) throw new Error("traces must be defined.");
              for (Array.isArray(t) || (t = [t]), n = 0; n < t.length; n++) if ("object" != typeof (a = t[n]) || Array.isArray(a) || null === a) throw new Error("all values in traces array must be non-array objects");
              if (void 0 === r || Array.isArray(r) || (r = [r]), void 0 !== r && r.length !== t.length) throw new Error("if indices is specified, traces.length must equal indices.length");
            }(r, n, a), Array.isArray(n) || (n = [n]), n = n.map(function (e) {
              return o.extendFlat({}, e);
            }), T.cleanData(n), i = 0; i < n.length; i++) r.data.push(n[i]);
            for (i = 0; i < n.length; i++) s.push(-n.length + i);
            if (void 0 === a) return l = t.redraw(r), c.add(r, u, d, f, h), l;
            Array.isArray(a) || (a = [a]);
            try {
              I(r, s, a);
            } catch (e) {
              throw r.data.splice(r.data.length - n.length, n.length), e;
            }
            return c.startSequence(r), c.add(r, u, d, f, h), l = t.moveTraces(r, s, a), c.stopSequence(r), l;
          }, t.deleteTraces = function e(r, n) {
            r = o.getGraphDiv(r);
            var a,
              i,
              l = [],
              s = t.addTraces,
              u = e,
              f = [r, l, n],
              d = [r, n];
            if (void 0 === n) throw new Error("indices must be an integer or array of integers.");
            for (Array.isArray(n) || (n = [n]), z(r, n, "indices"), (n = P(n, r.data.length - 1)).sort(o.sorterDes), a = 0; a < n.length; a += 1) i = r.data.splice(n[a], 1)[0], l.push(i);
            var h = t.redraw(r);
            return c.add(r, s, f, u, d), h;
          }, t.extendTraces = function e(r, n, a, i) {
            var l = E(r = o.getGraphDiv(r), n, a, i, function (e, t, r) {
                var n, a;
                if (o.isTypedArray(e)) {
                  if (r < 0) {
                    var i = new e.constructor(0),
                      l = R(e, t);
                    r < 0 ? (n = l, a = i) : (n = i, a = l);
                  } else if (n = new e.constructor(r), a = new e.constructor(e.length + t.length - r), r === t.length) n.set(t), a.set(e);else if (r < t.length) {
                    var s = t.length - r;
                    n.set(t.subarray(s)), a.set(e), a.set(t.subarray(0, s), e.length);
                  } else {
                    var c = r - t.length,
                      u = e.length - c;
                    n.set(e.subarray(u)), n.set(t, c), a.set(e.subarray(0, u));
                  }
                } else n = e.concat(t), a = r >= 0 && r < n.length ? n.splice(0, n.length - r) : [];
                return [n, a];
              }),
              s = t.redraw(r),
              u = [r, l.update, a, l.maxPoints];
            return c.add(r, t.prependTraces, u, e, arguments), s;
          }, t.moveTraces = function e(r, n, a) {
            var i,
              l = [],
              s = [],
              u = e,
              f = e,
              d = [r = o.getGraphDiv(r), a, n],
              h = [r, n, a];
            if (I(r, n, a), n = Array.isArray(n) ? n : [n], void 0 === a) for (a = [], i = 0; i < n.length; i++) a.push(-n.length + i);
            for (a = Array.isArray(a) ? a : [a], n = P(n, r.data.length - 1), a = P(a, r.data.length - 1), i = 0; i < r.data.length; i++) -1 === n.indexOf(i) && l.push(r.data[i]);
            for (i = 0; i < n.length; i++) s.push({
              newIndex: a[i],
              trace: r.data[n[i]]
            });
            for (s.sort(function (e, t) {
              return e.newIndex - t.newIndex;
            }), i = 0; i < s.length; i += 1) l.splice(s[i].newIndex, 0, s[i].trace);
            r.data = l;
            var p = t.redraw(r);
            return c.add(r, u, d, f, h), p;
          }, t.prependTraces = function e(r, n, a, i) {
            var l = E(r = o.getGraphDiv(r), n, a, i, function (e, t, r) {
                var n, a;
                if (o.isTypedArray(e)) {
                  if (r <= 0) {
                    var i = new e.constructor(0),
                      l = R(t, e);
                    r < 0 ? (n = l, a = i) : (n = i, a = l);
                  } else if (n = new e.constructor(r), a = new e.constructor(e.length + t.length - r), r === t.length) n.set(t), a.set(e);else if (r < t.length) {
                    var s = t.length - r;
                    n.set(t.subarray(0, s)), a.set(t.subarray(s)), a.set(e, s);
                  } else {
                    var c = r - t.length;
                    n.set(t), n.set(e.subarray(0, c), t.length), a.set(e.subarray(c));
                  }
                } else n = t.concat(e), a = r >= 0 && r < n.length ? n.splice(r, n.length) : [];
                return [n, a];
              }),
              s = t.redraw(r),
              u = [r, l.update, a, l.maxPoints];
            return c.add(r, t.extendTraces, u, e, arguments), s;
          }, t.newPlot = function (e, r, n, a) {
            return e = o.getGraphDiv(e), d.cleanPlot([], {}, e._fullData || [], e._fullLayout || {}), d.purge(e), t._doPlot(e, r, n, a);
          }, t._doPlot = function (e, r, a, i) {
            var l;
            if (e = o.getGraphDiv(e), s.init(e), o.isPlainObject(r)) {
              var c = r;
              r = c.data, a = c.layout, i = c.config, l = c.frames;
            }
            if (!1 === s.triggerHandler(e, "plotly_beforeplot", [r, a, i])) return Promise.reject();
            r || a || o.isPlotDiv(e) || o.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", e), D(e, i), a || (a = {}), n.select(e).classed("js-plotly-plot", !0), g.makeTester(), Array.isArray(e._promises) || (e._promises = []);
            var f = 0 === (e.data || []).length && Array.isArray(r);
            Array.isArray(r) && (T.cleanData(r), f ? e.data = r : e.data.push.apply(e.data, r), e.empty = !1), e.layout && !f || (e.layout = T.cleanLayout(a)), d.supplyDefaults(e);
            var p = e._fullLayout,
              v = p._has("cartesian");
            p._replotting = !0, (f || p._shouldCreateBgLayer) && (function (e) {
              var t = n.select(e),
                r = e._fullLayout;
              if (r._calcInverseTransform = se, r._calcInverseTransform(e), r._container = t.selectAll(".plot-container").data([0]), r._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0), r._paperdiv = r._container.selectAll(".svg-container").data([0]), r._paperdiv.enter().append("div").classed("user-select-none", !0).classed("svg-container", !0).style("position", "relative"), r._glcontainer = r._paperdiv.selectAll(".gl-container").data([{}]), r._glcontainer.enter().append("div").classed("gl-container", !0), r._paperdiv.selectAll(".main-svg").remove(), r._paperdiv.select(".modebar-container").remove(), r._paper = r._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), r._toppaper = r._paperdiv.append("svg").classed("main-svg", !0), r._modebardiv = r._paperdiv.append("div"), delete r._modeBar, r._hoverpaper = r._paperdiv.append("svg").classed("main-svg", !0), !r._uid) {
                var a = {};
                n.selectAll("defs").each(function () {
                  this.id && (a[this.id.split("-")[1]] = 1);
                }), r._uid = o.randstr(a);
              }
              r._paperdiv.selectAll(".main-svg").attr(x.svgAttrs), r._defs = r._paper.append("defs").attr("id", "defs-" + r._uid), r._clips = r._defs.append("g").classed("clips", !0), r._topdefs = r._toppaper.append("defs").attr("id", "topdefs-" + r._uid), r._topclips = r._topdefs.append("g").classed("clips", !0), r._bgLayer = r._paper.append("g").classed("bglayer", !0), r._draggers = r._paper.append("g").classed("draglayer", !0);
              var i = r._paper.append("g").classed("layer-below", !0);
              r._imageLowerLayer = i.append("g").classed("imagelayer", !0), r._shapeLowerLayer = i.append("g").classed("shapelayer", !0), r._cartesianlayer = r._paper.append("g").classed("cartesianlayer", !0), r._polarlayer = r._paper.append("g").classed("polarlayer", !0), r._smithlayer = r._paper.append("g").classed("smithlayer", !0), r._ternarylayer = r._paper.append("g").classed("ternarylayer", !0), r._geolayer = r._paper.append("g").classed("geolayer", !0), r._funnelarealayer = r._paper.append("g").classed("funnelarealayer", !0), r._pielayer = r._paper.append("g").classed("pielayer", !0), r._iciclelayer = r._paper.append("g").classed("iciclelayer", !0), r._treemaplayer = r._paper.append("g").classed("treemaplayer", !0), r._sunburstlayer = r._paper.append("g").classed("sunburstlayer", !0), r._indicatorlayer = r._toppaper.append("g").classed("indicatorlayer", !0), r._glimages = r._paper.append("g").classed("glimages", !0);
              var l = r._toppaper.append("g").classed("layer-above", !0);
              r._imageUpperLayer = l.append("g").classed("imagelayer", !0), r._shapeUpperLayer = l.append("g").classed("shapelayer", !0), r._selectionLayer = r._toppaper.append("g").classed("selectionlayer", !0), r._infolayer = r._toppaper.append("g").classed("infolayer", !0), r._menulayer = r._toppaper.append("g").classed("menulayer", !0), r._zoomlayer = r._toppaper.append("g").classed("zoomlayer", !0), r._hoverlayer = r._hoverpaper.append("g").classed("hoverlayer", !0), r._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), e.emit("plotly_framework");
            }(e), p._shouldCreateBgLayer && delete p._shouldCreateBgLayer), g.initGradients(e), g.initPatterns(e), f && h.saveShowSpikeInitial(e);
            var m = !e.calcdata || e.calcdata.length !== (e._fullData || []).length;
            m && d.doCalcdata(e);
            for (var b = 0; b < e.calcdata.length; b++) e.calcdata[b][0].trace = e._fullData[b];
            e._context.responsive ? e._responsiveChartHandler || (e._responsiveChartHandler = function () {
              o.isHidden(e) || d.resize(e);
            }, window.addEventListener("resize", e._responsiveChartHandler)) : o.clearResponsive(e);
            var _ = o.extendFlat({}, p._size),
              w = 0;
            function k() {
              if (d.clearAutoMarginIds(e), M.drawMarginPushers(e), h.allowAutoMargin(e), e._fullLayout.title.text && e._fullLayout.title.automargin && d.allowAutoMargin(e, "title.automargin"), p._has("pie")) for (var t = e._fullData, r = 0; r < t.length; r++) {
                var n = t[r];
                "pie" === n.type && n.automargin && d.allowAutoMargin(e, "pie." + n.uid + ".automargin");
              }
              return d.doAutoMargin(e), d.previousPromises(e);
            }
            function A() {
              e._transitioning || (M.doAutoRangeAndConstraints(e), f && h.saveRangeInitial(e), u.getComponentMethod("rangeslider", "calcAutorange")(e));
            }
            var L = [d.previousPromises, function () {
              if (l) return t.addFrames(e, l);
            }, function t() {
              for (var r = p._basePlotModules, n = 0; n < r.length; n++) r[n].drawFramework && r[n].drawFramework(e);
              !p._glcanvas && p._has("gl") && (p._glcanvas = p._glcontainer.selectAll(".gl-canvas").data([{
                key: "contextLayer",
                context: !0,
                pick: !1
              }, {
                key: "focusLayer",
                context: !1,
                pick: !1
              }, {
                key: "pickLayer",
                context: !1,
                pick: !0
              }], function (e) {
                return e.key;
              }), p._glcanvas.enter().append("canvas").attr("class", function (e) {
                return "gl-canvas gl-canvas-" + e.key.replace("Layer", "");
              }).style({
                position: "absolute",
                top: 0,
                left: 0,
                overflow: "visible",
                "pointer-events": "none"
              }));
              var a = e._context.plotGlPixelRatio;
              if (p._glcanvas) {
                p._glcanvas.attr("width", p.width * a).attr("height", p.height * a).style("width", p.width + "px").style("height", p.height + "px");
                var i = p._glcanvas.data()[0].regl;
                if (i && (Math.floor(p.width * a) !== i._gl.drawingBufferWidth || Math.floor(p.height * a) !== i._gl.drawingBufferHeight)) {
                  var l = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
                  if (!w) return o.log(l + " Clearing graph and plotting again."), d.cleanPlot([], {}, e._fullData, p), d.supplyDefaults(e), p = e._fullLayout, d.doCalcdata(e), w++, t();
                  o.error(l);
                }
              }
              return "h" === p.modebar.orientation ? p._modebardiv.style("height", null).style("width", "100%") : p._modebardiv.style("width", null).style("height", p.height + "px"), d.previousPromises(e);
            }, k, function () {
              if (d.didMarginChange(_, p._size)) return o.syncOrAsync([k, M.layoutStyles], e);
            }];
            v && L.push(function () {
              if (m) return o.syncOrAsync([u.getComponentMethod("shapes", "calcAutorange"), u.getComponentMethod("annotations", "calcAutorange"), A], e);
              A();
            }), L.push(M.layoutStyles), v && L.push(function () {
              return h.draw(e, f ? "" : "redraw");
            }, function (e) {
              var t = e._fullLayout._insideTickLabelsUpdaterange;
              if (t) return e._fullLayout._insideTickLabelsUpdaterange = void 0, V(e, t).then(function () {
                h.saveRangeInitial(e, !0);
              });
            }), L.push(M.drawData, M.finalDraw, y, d.addLinks, d.rehover, d.redrag, d.reselect, d.doAutoMargin, d.previousPromises);
            var C = o.syncOrAsync(L, e);
            return C && C.then || (C = Promise.resolve()), C.then(function () {
              return S(e), e;
            });
          }, t.purge = function (e) {
            var t = (e = o.getGraphDiv(e))._fullLayout || {},
              r = e._fullData || [];
            return d.cleanPlot([], {}, r, t), d.purge(e), s.purge(e), t._container && t._container.remove(), delete e._context, e;
          }, t.react = function (e, r, n, a) {
            var i, s;
            e = o.getGraphDiv(e), T.clearPromiseQueue(e);
            var c = e._fullData,
              h = e._fullLayout;
            if (o.isPlotDiv(e) && c && h) {
              if (o.isPlainObject(r)) {
                var p = r;
                r = p.data, n = p.layout, a = p.config, i = p.frames;
              }
              var v = !1;
              if (a) {
                var g = o.extendDeep({}, e._context);
                e._context = void 0, D(e, a), v = le(g, e._context);
              }
              e.data = r || [], T.cleanData(e.data), e.layout = n || {}, T.cleanLayout(e.layout), function (e, t, r, n) {
                var a,
                  i,
                  s,
                  c,
                  u,
                  f,
                  d,
                  h,
                  p,
                  v,
                  g = n._preGUI,
                  m = [],
                  y = {},
                  x = {};
                for (a in g) {
                  if (u = te(a, $)) {
                    if (p = u.head, v = u.tail, i = u.attr || p + ".uirevision", (c = (s = l(n, i).get()) && re(i, t)) && c === s) {
                      if (null === (f = g[a]) && (f = void 0), ie(h = (d = l(t, a)).get(), f)) {
                        void 0 === h && "autorange" === v && m.push(p), d.set(F(l(n, a).get()));
                        continue;
                      }
                      if ("autorange" === v || "range[" === v.substr(0, 6)) {
                        var b = g[p + ".range[0]"],
                          _ = g[p + ".range[1]"],
                          w = g[p + ".autorange"];
                        if (w || null === w && null === b && null === _) {
                          if (!(p in y)) {
                            var T = l(t, p).get();
                            y[p] = T && (T.autorange || !1 !== T.autorange && (!T.range || 2 !== T.range.length));
                          }
                          if (y[p]) {
                            d.set(F(l(n, a).get()));
                            continue;
                          }
                        }
                      }
                    }
                  } else o.warn("unrecognized GUI edit: " + a);
                  delete g[a], u && "range[" === u.tail.substr(0, 6) && (x[u.head] = 1);
                }
                for (var M = 0; M < m.length; M++) {
                  var k = m[M];
                  if (x[k]) {
                    var A = l(t, k).get();
                    A && delete A.autorange;
                  }
                }
                var L = n._tracePreGUI;
                for (var S in L) {
                  var C,
                    O = L[S],
                    D = null;
                  for (a in O) {
                    if (!D) {
                      var P = ne(S, r);
                      if (P < 0) {
                        delete L[S];
                        break;
                      }
                      var z = ae(S, e, (C = r[P]._fullInput).index);
                      if (z < 0) {
                        delete L[S];
                        break;
                      }
                      D = e[z];
                    }
                    if (u = te(a, ee)) {
                      if (u.attr ? c = (s = l(n, u.attr).get()) && re(u.attr, t) : (s = C.uirevision, void 0 === (c = D.uirevision) && (c = t.uirevision)), c && c === s && (null === (f = O[a]) && (f = void 0), ie(h = (d = l(D, a)).get(), f))) {
                        d.set(F(l(C, a).get()));
                        continue;
                      }
                    } else o.warn("unrecognized GUI edit: " + a + " in trace uid " + S);
                    delete O[a];
                  }
                }
              }(e.data, e.layout, c, h), d.supplyDefaults(e, {
                skipUpdateCalc: !0
              });
              var m = e._fullData,
                y = e._fullLayout,
                x = void 0 === y.datarevision,
                b = y.transition,
                _ = function (e, t, r, n, a) {
                  var i = k.layoutFlags();
                  return i.arrays = {}, i.rangesAltered = {}, i.nChanges = 0, i.nChangesAnim = 0, oe(t, r, [], {
                    getValObject: function (e) {
                      return f.getLayoutValObject(r, e);
                    },
                    flags: i,
                    immutable: n,
                    transition: a,
                    gd: e
                  }), (i.plot || i.calc) && (i.layoutReplot = !0), a && i.nChanges && i.nChangesAnim && (i.anim = i.nChanges === i.nChangesAnim ? "all" : "some"), i;
                }(e, h, y, x, b),
                w = _.newDataRevision,
                A = function (e, t, r, n, a, i) {
                  var o = t.length === r.length;
                  if (!a && !o) return {
                    fullReplot: !0,
                    calc: !0
                  };
                  var l,
                    s,
                    c = k.traceFlags();
                  c.arrays = {}, c.nChanges = 0, c.nChangesAnim = 0;
                  var u = {
                      getValObject: function (e) {
                        var t = f.getTraceValObject(s, e);
                        return !s._module.animatable && t.anim && (t.anim = !1), t;
                      },
                      flags: c,
                      immutable: n,
                      transition: a,
                      newDataRevision: i,
                      gd: e
                    },
                    h = {};
                  for (l = 0; l < t.length; l++) if (r[l]) {
                    if (s = r[l]._fullInput, d.hasMakesDataTransform(s) && (s = r[l]), h[s.uid]) continue;
                    h[s.uid] = 1, oe(t[l]._fullInput, s, [], u);
                  }
                  return (c.calc || c.plot) && (c.fullReplot = !0), a && c.nChanges && c.nChangesAnim && (c.anim = c.nChanges === c.nChangesAnim && o ? "all" : "some"), c;
                }(e, c, m, x, b, w);
              if (X(e) && (_.layoutReplot = !0), A.calc || _.calc) {
                e.calcdata = void 0;
                for (var L = Object.getOwnPropertyNames(y), C = 0; C < L.length; C++) {
                  var O = L[C],
                    P = O.substring(0, 5);
                  if ("xaxis" === P || "yaxis" === P) {
                    var z = y[O]._emptyCategories;
                    z && z();
                  }
                }
              } else d.supplyDefaultsUpdateCalc(e.calcdata, m);
              var I = [];
              if (i && (e._transitionData = {}, d.createTransitionData(e), I.push(function () {
                return t.addFrames(e, i);
              })), y.transition && !v && (A.anim || _.anim)) _.ticks && I.push(M.doTicksRelayout), d.doCalcdata(e), M.doAutoRangeAndConstraints(e), I.push(function () {
                return d.transitionFromReact(e, A, _, h);
              });else if (A.fullReplot || _.layoutReplot || v) e._fullLayout._skipDefaults = !0, I.push(t._doPlot);else {
                for (var E in _.arrays) {
                  var R = _.arrays[E];
                  if (R.length) {
                    var N = u.getComponentMethod(E, "drawOne");
                    if (N !== o.noop) for (var H = 0; H < R.length; H++) N(e, R[H]);else {
                      var B = u.getComponentMethod(E, "draw");
                      if (B === o.noop) throw new Error("cannot draw components: " + E);
                      B(e);
                    }
                  }
                }
                I.push(d.previousPromises), A.style && I.push(M.doTraceStyle), (A.colorbars || _.colorbars) && I.push(M.doColorBars), _.legend && I.push(M.doLegend), _.layoutstyle && I.push(M.layoutStyles), _.axrange && q(I), _.ticks && I.push(M.doTicksRelayout), _.modebar && I.push(M.doModeBar), _.camera && I.push(M.doCamera), I.push(S);
              }
              I.push(d.rehover, d.redrag, d.reselect), (s = o.syncOrAsync(I, e)) && s.then || (s = Promise.resolve(e));
            } else s = t.newPlot(e, r, n, a);
            return s.then(function () {
              return e.emit("plotly_react", {
                data: r,
                layout: n
              }), e;
            });
          }, t.redraw = function (e) {
            if (e = o.getGraphDiv(e), !o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
            return T.cleanData(e.data), T.cleanLayout(e.layout), e.calcdata = void 0, t._doPlot(e).then(function () {
              return e.emit("plotly_redraw"), e;
            });
          }, t.relayout = V, t.restyle = N, t.setPlotConfig = function (e) {
            return o.extendFlat(_, e);
          }, t.update = K, t._guiRelayout = Q(V), t._guiRestyle = Q(N), t._guiUpdate = Q(K), t._storeDirectGUIEdit = function (e, t, r) {
            for (var n in r) B(n, l(e, n).get(), r[n], t);
          };
        },
        4452: function (e) {
          "use strict";

          var t = {
              staticPlot: {
                valType: "boolean",
                dflt: !1
              },
              typesetMath: {
                valType: "boolean",
                dflt: !0
              },
              plotlyServerURL: {
                valType: "string",
                dflt: ""
              },
              editable: {
                valType: "boolean",
                dflt: !1
              },
              edits: {
                annotationPosition: {
                  valType: "boolean",
                  dflt: !1
                },
                annotationTail: {
                  valType: "boolean",
                  dflt: !1
                },
                annotationText: {
                  valType: "boolean",
                  dflt: !1
                },
                axisTitleText: {
                  valType: "boolean",
                  dflt: !1
                },
                colorbarPosition: {
                  valType: "boolean",
                  dflt: !1
                },
                colorbarTitleText: {
                  valType: "boolean",
                  dflt: !1
                },
                legendPosition: {
                  valType: "boolean",
                  dflt: !1
                },
                legendText: {
                  valType: "boolean",
                  dflt: !1
                },
                shapePosition: {
                  valType: "boolean",
                  dflt: !1
                },
                titleText: {
                  valType: "boolean",
                  dflt: !1
                }
              },
              editSelection: {
                valType: "boolean",
                dflt: !0
              },
              autosizable: {
                valType: "boolean",
                dflt: !1
              },
              responsive: {
                valType: "boolean",
                dflt: !1
              },
              fillFrame: {
                valType: "boolean",
                dflt: !1
              },
              frameMargins: {
                valType: "number",
                dflt: 0,
                min: 0,
                max: .5
              },
              scrollZoom: {
                valType: "flaglist",
                flags: ["cartesian", "gl3d", "geo", "mapbox", "map"],
                extras: [!0, !1],
                dflt: "gl3d+geo+map"
              },
              doubleClick: {
                valType: "enumerated",
                values: [!1, "reset", "autosize", "reset+autosize"],
                dflt: "reset+autosize"
              },
              doubleClickDelay: {
                valType: "number",
                dflt: 300,
                min: 0
              },
              showAxisDragHandles: {
                valType: "boolean",
                dflt: !0
              },
              showAxisRangeEntryBoxes: {
                valType: "boolean",
                dflt: !0
              },
              showTips: {
                valType: "boolean",
                dflt: !0
              },
              showLink: {
                valType: "boolean",
                dflt: !1
              },
              linkText: {
                valType: "string",
                dflt: "Edit chart",
                noBlank: !0
              },
              sendData: {
                valType: "boolean",
                dflt: !0
              },
              showSources: {
                valType: "any",
                dflt: !1
              },
              displayModeBar: {
                valType: "enumerated",
                values: ["hover", !0, !1],
                dflt: "hover"
              },
              showSendToCloud: {
                valType: "boolean",
                dflt: !1
              },
              showEditInChartStudio: {
                valType: "boolean",
                dflt: !1
              },
              modeBarButtonsToRemove: {
                valType: "any",
                dflt: []
              },
              modeBarButtonsToAdd: {
                valType: "any",
                dflt: []
              },
              modeBarButtons: {
                valType: "any",
                dflt: !1
              },
              toImageButtonOptions: {
                valType: "any",
                dflt: {}
              },
              displaylogo: {
                valType: "boolean",
                dflt: !0
              },
              watermark: {
                valType: "boolean",
                dflt: !1
              },
              plotGlPixelRatio: {
                valType: "number",
                dflt: 2,
                min: 1,
                max: 4
              },
              setBackground: {
                valType: "any",
                dflt: "transparent"
              },
              topojsonURL: {
                valType: "string",
                noBlank: !0,
                dflt: "https://cdn.plot.ly/"
              },
              mapboxAccessToken: {
                valType: "string",
                dflt: null
              },
              logging: {
                valType: "integer",
                min: 0,
                max: 2,
                dflt: 1
              },
              notifyOnLogging: {
                valType: "integer",
                min: 0,
                max: 2,
                dflt: 0
              },
              queueLength: {
                valType: "integer",
                min: 0,
                dflt: 0
              },
              globalTransforms: {
                valType: "any",
                dflt: []
              },
              locale: {
                valType: "string",
                dflt: "en-US"
              },
              locales: {
                valType: "any",
                dflt: {}
              }
            },
            r = {};
          !function e(t, r) {
            for (var n in t) {
              var a = t[n];
              a.valType ? r[n] = a.dflt : (r[n] || (r[n] = {}), e(a, r[n]));
            }
          }(t, r), e.exports = {
            configAttributes: t,
            dfltConfig: r
          };
        },
        7297: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(4809),
            i = r(9829),
            o = r(6704),
            l = r(8935),
            s = r(9722),
            c = r(4452).configAttributes,
            u = r(3582),
            f = a.extendDeepAll,
            d = a.isPlainObject,
            h = a.isArrayOrTypedArray,
            p = a.nestedProperty,
            v = a.valObjectMeta,
            g = "_isSubplotObj",
            m = "_isLinkedToArray",
            y = "_deprecated",
            x = [g, m, "_arrayAttrRegexps", y];
          function b(e, t, r) {
            if (!e) return !1;
            if (e._isLinkedToArray) if (_(t[r])) r++;else if (r < t.length) return !1;
            for (; r < t.length; r++) {
              var n = e[t[r]];
              if (!d(n)) break;
              if (e = n, r === t.length - 1) break;
              if (e._isLinkedToArray) {
                if (!_(t[++r])) return !1;
              } else if ("info_array" === e.valType) {
                var a = t[++r];
                if (!_(a)) return !1;
                var i = e.items;
                if (Array.isArray(i)) {
                  if (a >= i.length) return !1;
                  if (2 === e.dimensions) {
                    if (r++, t.length === r) return e;
                    var o = t[r];
                    if (!_(o)) return !1;
                    e = i[a][o];
                  } else e = i[a];
                } else e = i;
              }
            }
            return e;
          }
          function _(e) {
            return e === Math.round(e) && e >= 0;
          }
          function w() {
            var e,
              t,
              r = {};
            for (e in f(r, o), n.subplotsRegistry) if ((t = n.subplotsRegistry[e]).layoutAttributes) if (Array.isArray(t.attr)) for (var a = 0; a < t.attr.length; a++) M(r, t, t.attr[a]);else M(r, t, "subplot" === t.attr ? t.name : t.attr);
            for (e in n.componentsRegistry) {
              var i = (t = n.componentsRegistry[e]).schema;
              if (i && (i.subplots || i.layout)) {
                var l = i.subplots;
                if (l && l.xaxis && !l.yaxis) for (var s in l.xaxis) delete r.yaxis[s];
                delete r.xaxis.shift, delete r.xaxis.autoshift;
              } else "colorscale" === t.name ? f(r, t.layoutAttributes) : t.layoutAttributes && k(r, t.layoutAttributes, t.name);
            }
            return {
              layoutAttributes: T(r)
            };
          }
          function T(e) {
            return function (e) {
              t.crawl(e, function (e, r, n) {
                t.isValObject(e) ? !0 !== e.arrayOk && "data_array" !== e.valType || (n[r + "src"] = {
                  valType: "string",
                  editType: "none"
                }) : d(e) && (e.role = "object");
              });
            }(e), function (e) {
              t.crawl(e, function (e, t, r) {
                if (e) {
                  var n = e[m];
                  n && (delete e[m], r[t] = {
                    items: {}
                  }, r[t].items[n] = e, r[t].role = "object");
                }
              });
            }(e), function (e) {
              !function e(t) {
                for (var r in t) if (d(t[r])) e(t[r]);else if (Array.isArray(t[r])) for (var n = 0; n < t[r].length; n++) e(t[r][n]);else t[r] instanceof RegExp && (t[r] = t[r].toString());
              }(e);
            }(e), e;
          }
          function M(e, t, r) {
            var n = p(e, r),
              a = f({}, t.layoutAttributes);
            a[g] = !0, n.set(a);
          }
          function k(e, t, r) {
            var n = p(e, r);
            n.set(f(n.get() || {}, t));
          }
          t.IS_SUBPLOT_OBJ = g, t.IS_LINKED_TO_ARRAY = m, t.DEPRECATED = y, t.UNDERSCORE_ATTRS = x, t.get = function () {
            var e = {};
            n.allTypes.forEach(function (r) {
              e[r] = function (e) {
                var r, a;
                a = (r = n.modules[e]._module).basePlotModule;
                var o = {
                    type: null
                  },
                  l = f({}, i),
                  s = f({}, r.attributes);
                t.crawl(s, function (e, t, r, n, a) {
                  p(l, a).set(void 0), void 0 === e && p(s, a).set(void 0);
                }), f(o, l), n.traceIs(e, "noOpacity") && delete o.opacity, n.traceIs(e, "showLegend") || (delete o.showlegend, delete o.legendgroup), n.traceIs(e, "noHover") && (delete o.hoverinfo, delete o.hoverlabel), r.selectPoints || delete o.selectedpoints, f(o, s), a.attributes && f(o, a.attributes), o.type = e;
                var c = {
                  meta: r.meta || {},
                  categories: r.categories || {},
                  animatable: Boolean(r.animatable),
                  type: e,
                  attributes: T(o)
                };
                if (r.layoutAttributes) {
                  var u = {};
                  f(u, r.layoutAttributes), c.layoutAttributes = T(u);
                }
                return r.animatable || t.crawl(c, function (e) {
                  t.isValObject(e) && "anim" in e && delete e.anim;
                }), c;
              }(r);
            });
            var r,
              a = {};
            return Object.keys(n.transformsRegistry).forEach(function (e) {
              a[e] = function (e) {
                var t = n.transformsRegistry[e],
                  r = f({}, t.attributes);
                return Object.keys(n.componentsRegistry).forEach(function (t) {
                  var a = n.componentsRegistry[t];
                  a.schema && a.schema.transforms && a.schema.transforms[e] && Object.keys(a.schema.transforms[e]).forEach(function (t) {
                    k(r, a.schema.transforms[e][t], t);
                  });
                }), {
                  attributes: T(r)
                };
              }(e);
            }), {
              defs: {
                valObjects: v,
                metaKeys: x.concat(["description", "role", "editType", "impliedEdits"]),
                editType: {
                  traces: u.traces,
                  layout: u.layout
                },
                impliedEdits: {}
              },
              traces: e,
              layout: w(),
              transforms: a,
              frames: (r = {
                frames: f({}, l)
              }, T(r), r.frames),
              animation: T(s),
              config: T(c)
            };
          }, t.crawl = function (e, r, n, a) {
            var i = n || 0;
            a = a || "", Object.keys(e).forEach(function (n) {
              var o = e[n];
              if (-1 === x.indexOf(n)) {
                var l = (a ? a + "." : "") + n;
                r(o, n, e, i, l), t.isValObject(o) || d(o) && "impliedEdits" !== n && t.crawl(o, r, i + 1, l);
              }
            });
          }, t.isValObject = function (e) {
            return e && void 0 !== e.valType;
          }, t.findArrayAttributes = function (e) {
            var r,
              n,
              a = [],
              o = [],
              l = [];
            function s(e, t, n, a) {
              o = o.slice(0, a).concat([t]), l = l.slice(0, a).concat([e && e._isLinkedToArray]), e && ("data_array" === e.valType || !0 === e.arrayOk) && ("colorbar" !== o[a - 1] || "ticktext" !== t && "tickvals" !== t) && c(r, 0, "");
            }
            function c(e, t, r) {
              var i = e[o[t]],
                s = r + o[t];
              if (t === o.length - 1) h(i) && a.push(n + s);else if (l[t]) {
                if (Array.isArray(i)) for (var u = 0; u < i.length; u++) d(i[u]) && c(i[u], t + 1, s + "[" + u + "].");
              } else d(i) && c(i, t + 1, s + ".");
            }
            r = e, n = "", t.crawl(i, s), e._module && e._module.attributes && t.crawl(e._module.attributes, s);
            var u = e.transforms;
            if (u) for (var f = 0; f < u.length; f++) {
              var p = u[f],
                v = p._module;
              v && (n = "transforms[" + f + "].", r = p, t.crawl(v.attributes, s));
            }
            return a;
          }, t.getTraceValObject = function (e, t) {
            var r,
              a,
              o = t[0],
              l = 1;
            if ("transforms" === o) {
              if (1 === t.length) return i.transforms;
              var s = e.transforms;
              if (!Array.isArray(s) || !s.length) return !1;
              var c = t[1];
              if (!_(c) || c >= s.length) return !1;
              a = (r = (n.transformsRegistry[s[c].type] || {}).attributes) && r[t[2]], l = 3;
            } else {
              var u = e._module;
              if (u || (u = (n.modules[e.type || i.type.dflt] || {})._module), !u) return !1;
              if (!(a = (r = u.attributes) && r[o])) {
                var f = u.basePlotModule;
                f && f.attributes && (a = f.attributes[o]);
              }
              a || (a = i[o]);
            }
            return b(a, t, l);
          }, t.getLayoutValObject = function (e, t) {
            var r = function (e, t) {
              var r,
                a,
                i,
                l,
                s = e._basePlotModules;
              if (s) {
                var c;
                for (r = 0; r < s.length; r++) {
                  if ((i = s[r]).attrRegex && i.attrRegex.test(t)) {
                    if (i.layoutAttrOverrides) return i.layoutAttrOverrides;
                    !c && i.layoutAttributes && (c = i.layoutAttributes);
                  }
                  var u = i.baseLayoutAttrOverrides;
                  if (u && t in u) return u[t];
                }
                if (c) return c;
              }
              var f = e._modules;
              if (f) for (r = 0; r < f.length; r++) if ((l = f[r].layoutAttributes) && t in l) return l[t];
              for (a in n.componentsRegistry) {
                if ("colorscale" === (i = n.componentsRegistry[a]).name && 0 === t.indexOf("coloraxis")) return i.layoutAttributes[t];
                if (!i.schema && t === i.name) return i.layoutAttributes;
              }
              return t in o && o[t];
            }(e, t[0]);
            return b(r, t, 1);
          };
        },
        8032: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9829),
            i = "templateitemname",
            o = {
              name: {
                valType: "string",
                editType: "none"
              }
            };
          function l(e) {
            return e && "string" == typeof e;
          }
          function s(e) {
            var t = e.length - 1;
            return "s" !== e.charAt(t) && n.warn("bad argument to arrayDefaultKey: " + e), e.substr(0, e.length - 1) + "defaults";
          }
          o[i] = {
            valType: "string",
            editType: "calc"
          }, t.templatedArray = function (e, t) {
            return t._isLinkedToArray = e, t.name = o.name, t[i] = o[i], t;
          }, t.traceTemplater = function (e) {
            var t,
              r,
              i = {};
            for (t in e) r = e[t], Array.isArray(r) && r.length && (i[t] = 0);
            return {
              newTrace: function (o) {
                var l = {
                  type: t = n.coerce(o, {}, a, "type"),
                  _template: null
                };
                if (t in i) {
                  r = e[t];
                  var s = i[t] % r.length;
                  i[t]++, l._template = r[s];
                }
                return l;
              }
            };
          }, t.newContainer = function (e, t, r) {
            var a = e._template,
              i = a && (a[t] || r && a[r]);
            return n.isPlainObject(i) || (i = null), e[t] = {
              _template: i
            };
          }, t.arrayTemplater = function (e, t, r) {
            var n = e._template,
              a = n && n[s(t)],
              o = n && n[t];
            Array.isArray(o) && o.length || (o = []);
            var c = {};
            return {
              newItem: function (e) {
                var t = {
                    name: e.name,
                    _input: e
                  },
                  n = t[i] = e[i];
                if (!l(n)) return t._template = a, t;
                for (var s = 0; s < o.length; s++) {
                  var u = o[s];
                  if (u.name === n) return c[n] = 1, t._template = u, t;
                }
                return t[r] = e[r] || !1, t._template = !1, t;
              },
              defaultItems: function () {
                for (var e = [], t = 0; t < o.length; t++) {
                  var r = o[t],
                    n = r.name;
                  if (l(n) && !c[n]) {
                    var a = {
                      _template: r,
                      name: n,
                      _input: {
                        _templateitemname: n
                      }
                    };
                    a[i] = r[i], e.push(a), c[n] = 1;
                  }
                }
                return e;
              }
            };
          }, t.arrayDefaultKey = s, t.arrayEditor = function (e, t, r) {
            var a = (n.nestedProperty(e, t).get() || []).length,
              o = r._index,
              l = o >= a && (r._input || {})._templateitemname;
            l && (o = a);
            var s,
              c = t + "[" + o + "]";
            function u() {
              s = {}, l && (s[c] = {}, s[c][i] = l);
            }
            function f(e, t) {
              l ? n.nestedProperty(s[c], e).set(t) : s[c + "." + e] = t;
            }
            function d() {
              var e = s;
              return u(), e;
            }
            return u(), {
              modifyBase: function (e, t) {
                s[e] = t;
              },
              modifyItem: f,
              getUpdateObj: d,
              applyUpdate: function (t, r) {
                t && f(t, r);
                var a = d();
                for (var i in a) n.nestedProperty(e, i).set(a[i]);
              }
            };
          };
        },
        1817: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(3626),
            i = r(4122),
            o = r(4809),
            l = r(635),
            s = r(4823),
            c = r(8766),
            u = r(2203),
            f = r(7240),
            d = r(5433),
            h = r(9714),
            p = r(4530),
            v = r(4391),
            g = v.enforce,
            m = v.clean,
            y = r(2919).doAutoRange,
            x = "start",
            b = r(4826).zindexSeparator;
          function _(e, t, r) {
            for (var n = 0; n < r.length; n++) {
              var a = r[n][0],
                i = r[n][1];
              if (!(a[0] >= e[1] || a[1] <= e[0]) && i[0] < t[1] && i[1] > t[0]) return !0;
            }
            return !1;
          }
          function w(e) {
            var r,
              a,
              l,
              s,
              f,
              v,
              g = e._fullLayout,
              m = g._size,
              y = m.p,
              x = h.list(e, "", !0);
            if (g._paperdiv.style({
              width: e._context.responsive && g.autosize && !e._context._hasZeroWidth && !e.layout.width ? "100%" : g.width + "px",
              height: e._context.responsive && g.autosize && !e._context._hasZeroHeight && !e.layout.height ? "100%" : g.height + "px"
            }).selectAll(".main-svg").call(u.setSize, g.width, g.height), e._context.setBackground(e, g.paper_bgcolor), t.drawMainTitle(e), d.manage(e), !g._has("cartesian")) return i.previousPromises(e);
            function w(e, t, r) {
              var n = e._lw / 2;
              return "x" === e._id.charAt(0) ? t ? "top" === r ? t._offset - y - n : t._offset + t._length + y + n : m.t + m.h * (1 - (e.position || 0)) + n % 1 : t ? "right" === r ? t._offset + t._length + y + n : t._offset - y - n : m.l + m.w * (e.position || 0) + n % 1;
            }
            for (r = 0; r < x.length; r++) {
              var M = (s = x[r])._anchorAxis;
              s._linepositions = {}, s._lw = u.crispRound(e, s.linewidth, 1), s._mainLinePosition = w(s, M, s.side), s._mainMirrorPosition = s.mirror && M ? w(s, M, p.OPPOSITE_SIDE[s.side]) : null;
            }
            var A = [],
              L = [],
              S = [],
              C = 1 === c.opacity(g.paper_bgcolor) && 1 === c.opacity(g.plot_bgcolor) && g.paper_bgcolor === g.plot_bgcolor;
            for (a in g._plots) if ((l = g._plots[a]).mainplot) l.bg && l.bg.remove(), l.bg = void 0;else {
              var O = l.xaxis.domain,
                D = l.yaxis.domain,
                P = l.plotgroup;
              if (_(O, D, S) && -1 === a.indexOf(b)) {
                var z = P.node(),
                  I = l.bg = o.ensureSingle(P, "rect", "bg");
                z.insertBefore(I.node(), z.childNodes[0]), L.push(a);
              } else P.select("rect.bg").remove(), S.push([O, D]), C || (A.push(a), L.push(a));
            }
            var E,
              R,
              N,
              F,
              H,
              B,
              j,
              Y,
              V,
              U,
              q,
              G,
              Z,
              W = g._bgLayer.selectAll(".bg").data(A);
            for (W.enter().append("rect").classed("bg", !0), W.exit().remove(), W.each(function (e) {
              g._plots[e].bg = n.select(this);
            }), r = 0; r < L.length; r++) l = g._plots[L[r]], f = l.xaxis, v = l.yaxis, l.bg && void 0 !== f._offset && void 0 !== v._offset && l.bg.call(u.setRect, f._offset - y, v._offset - y, f._length + 2 * y, v._length + 2 * y).call(c.fill, g.plot_bgcolor).style("stroke-width", 0);
            if (!g._hasOnlyLargeSploms) for (a in g._plots) {
              l = g._plots[a], f = l.xaxis, v = l.yaxis;
              var J,
                X,
                K = l.clipId = "clip" + g._uid + a + "plot",
                Q = o.ensureSingleById(g._clips, "clipPath", K, function (e) {
                  e.classed("plotclip", !0).append("rect");
                });
              l.clipRect = Q.select("rect").attr({
                width: f._length,
                height: v._length
              }), u.setTranslate(l.plot, f._offset, v._offset), l._hasClipOnAxisFalse ? (J = null, X = K) : (J = K, X = null), u.setClipUrl(l.plot, J, e), l.layerClipId = X;
            }
            function $(e) {
              return "M" + E + "," + e + "H" + R;
            }
            function ee(e) {
              return "M" + f._offset + "," + e + "h" + f._length;
            }
            function te(e) {
              return "M" + e + "," + Y + "V" + j;
            }
            function re(e) {
              return void 0 !== v._shift && (e += v._shift), "M" + e + "," + v._offset + "v" + v._length;
            }
            function ne(e, t, r) {
              if (!e.showline || a !== e._mainSubplot) return "";
              if (!e._anchorAxis) return r(e._mainLinePosition);
              var n = t(e._mainLinePosition);
              return e.mirror && (n += t(e._mainMirrorPosition)), n;
            }
            for (a in g._plots) {
              l = g._plots[a], f = l.xaxis, v = l.yaxis;
              var ae = "M0,0";
              T(f, a) && (H = k(f, "left", v, x), E = f._offset - (H ? y + H : 0), B = k(f, "right", v, x), R = f._offset + f._length + (B ? y + B : 0), N = w(f, v, "bottom"), F = w(f, v, "top"), !(Z = !f._anchorAxis || a !== f._mainSubplot) || "allticks" !== f.mirror && "all" !== f.mirror || (f._linepositions[a] = [N, F]), ae = ne(f, $, ee), Z && f.showline && ("all" === f.mirror || "allticks" === f.mirror) && (ae += $(N) + $(F)), l.xlines.style("stroke-width", f._lw + "px").call(c.stroke, f.showline ? f.linecolor : "rgba(0,0,0,0)")), l.xlines.attr("d", ae);
              var ie = "M0,0";
              T(v, a) && (q = k(v, "bottom", f, x), j = v._offset + v._length + (q ? y : 0), G = k(v, "top", f, x), Y = v._offset - (G ? y : 0), V = w(v, f, "left"), U = w(v, f, "right"), !(Z = !v._anchorAxis || a !== v._mainSubplot) || "allticks" !== v.mirror && "all" !== v.mirror || (v._linepositions[a] = [V, U]), ie = ne(v, te, re), Z && v.showline && ("all" === v.mirror || "allticks" === v.mirror) && (ie += te(V) + te(U)), l.ylines.style("stroke-width", v._lw + "px").call(c.stroke, v.showline ? v.linecolor : "rgba(0,0,0,0)")), l.ylines.attr("d", ie);
            }
            return h.makeClipPaths(e), i.previousPromises(e);
          }
          function T(e, t) {
            return (e.ticks || e.showline) && (t === e._mainSubplot || "all" === e.mirror || "allticks" === e.mirror);
          }
          function M(e, t, r) {
            if (!r.showline || !r._lw) return !1;
            if ("all" === r.mirror || "allticks" === r.mirror) return !0;
            var n = r._anchorAxis;
            if (!n) return !1;
            var a = p.FROM_BL[t];
            return r.side === t ? n.domain[a] === e.domain[a] : r.mirror && n.domain[1 - a] === e.domain[1 - a];
          }
          function k(e, t, r, n) {
            if (M(e, t, r)) return r._lw;
            for (var a = 0; a < n.length; a++) {
              var i = n[a];
              if (i._mainAxis === r._mainAxis && M(e, t, i)) return i._lw;
            }
            return 0;
          }
          function A(e) {
            return "top" === e ? p.CAP_SHIFT + .3 + "em" : "bottom" === e ? "-0.3em" : p.MID_SHIFT + "em";
          }
          t.layoutStyles = function (e) {
            return o.syncOrAsync([i.doAutoMargin, w], e);
          }, t.drawMainTitle = function (e) {
            var t = e._fullLayout.title,
              r = e._fullLayout,
              a = function (e) {
                var t = e.title,
                  r = "middle";
                return o.isRightAnchor(t) ? r = "end" : o.isLeftAnchor(t) && (r = x), r;
              }(r),
              s = function (e) {
                var t = e.title,
                  r = "0em";
                return o.isTopAnchor(t) ? r = p.CAP_SHIFT + "em" : o.isMiddleAnchor(t) && (r = p.MID_SHIFT + "em"), r;
              }(r),
              c = function (e, t) {
                var r = e.title,
                  n = e._size,
                  a = 0;
                return "0em" !== t && t ? t === p.CAP_SHIFT + "em" && (a = r.pad.t) : a = -r.pad.b, "auto" === r.y ? n.t / 2 : "paper" === r.yref ? n.t + n.h - n.h * r.y + a : e.height - e.height * r.y + a;
              }(r, s),
              d = function (e, t) {
                var r = e.title,
                  n = e._size,
                  a = 0;
                return t === x ? a = r.pad.l : "end" === t && (a = -r.pad.r), "paper" === r.xref ? n.l + n.w * r.x + a : e.width * r.x + a;
              }(r, a);
            if (f.draw(e, "gtitle", {
              propContainer: r,
              propName: "title.text",
              subtitlePropName: "title.subtitle.text",
              placeholder: r._dfltTitle.plot,
              subtitlePlaceholder: r._dfltTitle.subtitle,
              attributes: {
                x: d,
                y: c,
                "text-anchor": a,
                dy: s
              }
            }), t.text && t.automargin) {
              var h = n.selectAll(".gtitle"),
                v = u.bBox(n.selectAll(".g-gtitle").node()).height,
                g = function (e, t, r) {
                  var n = t.y,
                    a = t.yanchor,
                    i = n > .5 ? "t" : "b",
                    o = e._fullLayout.margin[i],
                    l = 0;
                  return "paper" === t.yref ? l = r + t.pad.t + t.pad.b : "container" === t.yref && (l = function (e, t, r, n, a) {
                    var i = 0;
                    return "middle" === r && (i += a / 2), "t" === e ? ("top" === r && (i += a), i += n - t * n) : ("bottom" === r && (i += a), i += t * n), i;
                  }(i, n, a, e._fullLayout.height, r) + t.pad.t + t.pad.b), l > o ? l : 0;
                }(e, t, v);
              if (g > 0) {
                !function (e, t, r, n) {
                  var a = "title.automargin",
                    l = e._fullLayout.title,
                    s = l.y > .5 ? "t" : "b",
                    c = {
                      x: l.x,
                      y: l.y,
                      t: 0,
                      b: 0
                    },
                    u = {};
                  "paper" === l.yref && function (e, t, r, n, a) {
                    var i = "paper" === t.yref ? e._fullLayout._size.h : e._fullLayout.height,
                      l = o.isTopAnchor(t) ? n : n - a,
                      s = "b" === r ? i - l : l;
                    return !(o.isTopAnchor(t) && "t" === r || o.isBottomAnchor(t) && "b" === r) && s < a;
                  }(e, l, s, t, n) ? c[s] = r : "container" === l.yref && (u[s] = r, e._fullLayout._reservedMargin[a] = u), i.allowAutoMargin(e, a), i.autoMargin(e, a, c);
                }(e, c, g, v), h.attr({
                  x: d,
                  y: c,
                  "text-anchor": a,
                  dy: A(t.yanchor)
                }).call(l.positionText, d, c);
                var m = (t.text.match(l.BR_TAG_ALL) || []).length;
                if (m) {
                  var y = p.LINE_SPACING * m + p.MID_SHIFT;
                  0 === t.y && (y = -y), h.selectAll(".line").each(function () {
                    var e = +this.getAttribute("dy").slice(0, -2) - y + "em";
                    this.setAttribute("dy", e);
                  });
                }
                var b = n.selectAll(".gtitle-subtitle");
                if (b.node()) {
                  var _ = h.node().getBBox(),
                    w = _.y + _.height + f.SUBTITLE_PADDING_EM * t.subtitle.font.size;
                  b.attr({
                    x: d,
                    y: w,
                    "text-anchor": a,
                    dy: A(t.yanchor)
                  }).call(l.positionText, d, w);
                }
              }
            }
          }, t.doTraceStyle = function (e) {
            var r,
              n = e.calcdata,
              o = [];
            for (r = 0; r < n.length; r++) {
              var l = n[r],
                c = l[0] || {},
                u = c.trace || {},
                f = u._module || {},
                d = f.arraysToCalcdata;
              d && d(l, u);
              var h = f.editStyle;
              h && o.push({
                fn: h,
                cd0: c
              });
            }
            if (o.length) {
              for (r = 0; r < o.length; r++) {
                var p = o[r];
                p.fn(e, p.cd0);
              }
              s(e), t.redrawReglTraces(e);
            }
            return i.style(e), a.getComponentMethod("legend", "draw")(e), i.previousPromises(e);
          }, t.doColorBars = function (e) {
            return a.getComponentMethod("colorbar", "draw")(e), i.previousPromises(e);
          }, t.layoutReplot = function (e) {
            var t = e.layout;
            return e.layout = void 0, a.call("_doPlot", e, "", t);
          }, t.doLegend = function (e) {
            return a.getComponentMethod("legend", "draw")(e), i.previousPromises(e);
          }, t.doTicksRelayout = function (e) {
            return h.draw(e, "redraw"), e._fullLayout._hasOnlyLargeSploms && (a.subplotsRegistry.splom.updateGrid(e), s(e), t.redrawReglTraces(e)), t.drawMainTitle(e), i.previousPromises(e);
          }, t.doModeBar = function (e) {
            var t = e._fullLayout;
            d.manage(e);
            for (var r = 0; r < t._basePlotModules.length; r++) {
              var n = t._basePlotModules[r].updateFx;
              n && n(e);
            }
            return i.previousPromises(e);
          }, t.doCamera = function (e) {
            for (var t = e._fullLayout, r = t._subplots.gl3d, n = 0; n < r.length; n++) {
              var a = t[r[n]];
              a._scene.setViewport(a);
            }
          }, t.drawData = function (e) {
            var r = e._fullLayout;
            s(e);
            for (var n = r._basePlotModules, o = 0; o < n.length; o++) n[o].plot(e);
            return t.redrawReglTraces(e), i.style(e), a.getComponentMethod("selections", "draw")(e), a.getComponentMethod("shapes", "draw")(e), a.getComponentMethod("annotations", "draw")(e), a.getComponentMethod("images", "draw")(e), r._replotting = !1, i.previousPromises(e);
          }, t.redrawReglTraces = function (e) {
            var t = e._fullLayout;
            if (t._has("regl")) {
              var r,
                n,
                a = e._fullData,
                i = [],
                l = [];
              for (t._hasOnlyLargeSploms && t._splomGrid.draw(), r = 0; r < a.length; r++) {
                var s = a[r];
                !0 === s.visible && 0 !== s._length && ("splom" === s.type ? t._splomScenes[s.uid].draw() : "scattergl" === s.type ? o.pushUnique(i, s.xaxis + s.yaxis) : "scatterpolargl" === s.type && o.pushUnique(l, s.subplot));
              }
              for (r = 0; r < i.length; r++) (n = t._plots[i[r]])._scene && n._scene.draw();
              for (r = 0; r < l.length; r++) (n = t[l[r]]._subplot)._scene && n._scene.draw();
            }
          }, t.doAutoRangeAndConstraints = function (e) {
            for (var t, r = h.list(e, "", !0), n = {}, a = 0; a < r.length; a++) if (!n[(t = r[a])._id]) {
              n[t._id] = 1, m(e, t), y(e, t);
              var i = t._matchGroup;
              if (i) for (var o in i) {
                var l = h.getFromId(e, o);
                y(e, l, t.range), n[o] = 1;
              }
            }
            g(e);
          }, t.finalDraw = function (e) {
            a.getComponentMethod("rangeslider", "draw")(e), a.getComponentMethod("rangeselector", "draw")(e);
          }, t.drawMarginPushers = function (e) {
            a.getComponentMethod("legend", "draw")(e), a.getComponentMethod("rangeselector", "draw")(e), a.getComponentMethod("sliders", "draw")(e), a.getComponentMethod("updatemenus", "draw")(e), a.getComponentMethod("colorbar", "draw")(e);
          };
        },
        3853: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = n.isPlainObject,
            i = r(7297),
            o = r(4122),
            l = r(9829),
            s = r(8032),
            c = r(4452).dfltConfig;
          function u(e, t) {
            e = n.extendDeep({}, e);
            var r,
              i,
              o = Object.keys(e).sort();
            function l(t, r, n) {
              if (a(r) && a(t)) u(t, r);else if (Array.isArray(r) && Array.isArray(t)) {
                var o = s.arrayTemplater({
                  _template: e
                }, n);
                for (i = 0; i < r.length; i++) {
                  var l = r[i],
                    c = o.newItem(l)._template;
                  c && u(c, l);
                }
                var f = o.defaultItems();
                for (i = 0; i < f.length; i++) r.push(f[i]._template);
                for (i = 0; i < r.length; i++) delete r[i].templateitemname;
              }
            }
            for (r = 0; r < o.length; r++) {
              var c = o[r],
                d = e[c];
              if (c in t ? l(d, t[c], c) : t[c] = d, f(c) === c) for (var h in t) {
                var p = f(h);
                h === p || p !== c || h in e || l(d, t[h], c);
              }
            }
          }
          function f(e) {
            return e.replace(/[0-9]+$/, "");
          }
          function d(e, t, r, i, o) {
            var l = o && r(o);
            for (var c in e) {
              var u = e[c],
                h = v(e, c, i),
                p = v(e, c, o),
                g = r(p);
              if (!g) {
                var m = f(c);
                m !== c && (g = r(p = v(e, m, o)));
              }
              if (!(l && l === g || !g || g._noTemplating || "data_array" === g.valType || g.arrayOk && Array.isArray(u))) if (!g.valType && a(u)) d(u, t, r, h, p);else if (g._isLinkedToArray && Array.isArray(u)) for (var y = !1, x = 0, b = {}, _ = 0; _ < u.length; _++) {
                var w = u[_];
                if (a(w)) {
                  var T = w.name;
                  if (T) b[T] || (d(w, t, r, v(u, x, h), v(u, x, p)), x++, b[T] = 1);else if (!y) {
                    var M = v(e, s.arrayDefaultKey(c), i),
                      k = v(u, x, h);
                    d(w, t, r, k, v(u, x, p));
                    var A = n.nestedProperty(t, k);
                    n.nestedProperty(t, M).set(A.get()), A.set(null), y = !0;
                  }
                }
              } else n.nestedProperty(t, h).set(u);
            }
          }
          function h(e, t) {
            return i.getLayoutValObject(e, n.nestedProperty({}, t).parts);
          }
          function p(e, t) {
            return i.getTraceValObject(e, n.nestedProperty({}, t).parts);
          }
          function v(e, t, r) {
            return r ? Array.isArray(e) ? r + "[" + t + "]" : r + "." + t : t;
          }
          function g(e) {
            for (var t = 0; t < e.length; t++) if (a(e[t])) return !0;
          }
          function m(e) {
            var t;
            switch (e.code) {
              case "data":
                t = "The template has no key data.";
                break;
              case "layout":
                t = "The template has no key layout.";
                break;
              case "missing":
                t = e.path ? "There are no templates for item " + e.path + " with name " + e.templateitemname : "There are no templates for trace " + e.index + ", of type " + e.traceType + ".";
                break;
              case "unused":
                t = e.path ? "The template item at " + e.path + " was not used in constructing the plot." : e.dataCount ? "Some of the templates of type " + e.traceType + " were not used. The template has " + e.templateCount + " traces, the data only has " + e.dataCount + " of this type." : "The template has " + e.templateCount + " traces of type " + e.traceType + " but there are none in the data.";
                break;
              case "reused":
                t = "Some of the templates of type " + e.traceType + " were used more than once. The template has " + e.templateCount + " traces, the data has " + e.dataCount + " of this type.";
            }
            return e.msg = t, e;
          }
          t.makeTemplate = function (e) {
            e = n.isPlainObject(e) ? e : n.getGraphDiv(e), e = n.extendDeep({
              _context: c
            }, {
              data: e.data,
              layout: e.layout
            }), o.supplyDefaults(e);
            var t = e.data || [],
              r = e.layout || {};
            r._basePlotModules = e._fullLayout._basePlotModules, r._modules = e._fullLayout._modules;
            var i = {
              data: {},
              layout: {}
            };
            t.forEach(function (e) {
              var t = {};
              d(e, t, p.bind(null, e));
              var r = n.coerce(e, {}, l, "type"),
                a = i.data[r];
              a || (a = i.data[r] = []), a.push(t);
            }), d(r, i.layout, h.bind(null, r)), delete i.layout.template;
            var s = r.template;
            if (a(s)) {
              var f,
                v,
                g,
                m,
                y,
                x,
                b = s.layout;
              a(b) && u(b, i.layout);
              var _ = s.data;
              if (a(_)) {
                for (v in i.data) if (g = _[v], Array.isArray(g)) {
                  for (x = (y = i.data[v]).length, m = g.length, f = 0; f < x; f++) u(g[f % m], y[f]);
                  for (f = x; f < m; f++) y.push(n.extendDeep({}, g[f]));
                }
                for (v in _) v in i.data || (i.data[v] = n.extendDeep([], _[v]));
              }
            }
            return i;
          }, t.validateTemplate = function (e, t) {
            var r = n.extendDeep({}, {
                _context: c,
                data: e.data,
                layout: e.layout
              }),
              i = r.layout || {};
            a(t) || (t = i.template || {});
            var l = t.layout,
              s = t.data,
              u = [];
            r.layout = i, r.layout.template = t, o.supplyDefaults(r);
            var d = r._fullLayout,
              h = r._fullData,
              p = {};
            if (a(l) ? (function e(t, r) {
              for (var n in t) if ("_" !== n.charAt(0) && a(t[n])) {
                var i,
                  o = f(n),
                  l = [];
                for (i = 0; i < r.length; i++) l.push(v(t, n, r[i])), o !== n && l.push(v(t, o, r[i]));
                for (i = 0; i < l.length; i++) p[l[i]] = 1;
                e(t[n], l);
              }
            }(d, ["layout"]), function e(t, r) {
              for (var n in t) if (-1 === n.indexOf("defaults") && a(t[n])) {
                var i = v(t, n, r);
                p[i] ? e(t[n], i) : u.push({
                  code: "unused",
                  path: i
                });
              }
            }(l, "layout")) : u.push({
              code: "layout"
            }), a(s)) {
              for (var y, x = {}, b = 0; b < h.length; b++) {
                var _ = h[b];
                x[y = _.type] = (x[y] || 0) + 1, _._fullInput._template || u.push({
                  code: "missing",
                  index: _._fullInput.index,
                  traceType: y
                });
              }
              for (y in s) {
                var w = s[y].length,
                  T = x[y] || 0;
                w > T ? u.push({
                  code: "unused",
                  traceType: y,
                  templateCount: w,
                  dataCount: T
                }) : T > w && u.push({
                  code: "reused",
                  traceType: y,
                  templateCount: w,
                  dataCount: T
                });
              }
            } else u.push({
              code: "data"
            });
            if (function e(t, r) {
              for (var n in t) if ("_" !== n.charAt(0)) {
                var i = t[n],
                  o = v(t, n, r);
                a(i) ? (Array.isArray(t) && !1 === i._template && i.templateitemname && u.push({
                  code: "missing",
                  path: o,
                  templateitemname: i.templateitemname
                }), e(i, o)) : Array.isArray(i) && g(i) && e(i, o);
              }
            }({
              data: h,
              layout: d
            }, ""), u.length) return u.map(m);
          };
        },
        491: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(1420),
            i = r(4122),
            o = r(4809),
            l = r(4619),
            s = r(6243),
            c = r(2914),
            u = r(9697).version,
            f = {
              format: {
                valType: "enumerated",
                values: ["png", "jpeg", "webp", "svg", "full-json"],
                dflt: "png"
              },
              width: {
                valType: "number",
                min: 1
              },
              height: {
                valType: "number",
                min: 1
              },
              scale: {
                valType: "number",
                min: 0,
                dflt: 1
              },
              setBackground: {
                valType: "any",
                dflt: !1
              },
              imageDataOnly: {
                valType: "boolean",
                dflt: !1
              }
            };
          e.exports = function (e, t) {
            var r, d, h, p;
            function v(e) {
              return !(e in t) || o.validate(t[e], f[e]);
            }
            if (t = t || {}, o.isPlainObject(e) ? (r = e.data || [], d = e.layout || {}, h = e.config || {}, p = {}) : (e = o.getGraphDiv(e), r = o.extendDeep([], e.data), d = o.extendDeep({}, e.layout), h = e._context, p = e._fullLayout || {}), !v("width") && null !== t.width || !v("height") && null !== t.height) throw new Error("Height and width should be pixel values.");
            if (!v("format")) throw new Error("Export format is not " + o.join2(f.format.values, ", ", " or ") + ".");
            var g = {};
            function m(e, r) {
              return o.coerce(t, g, f, e, r);
            }
            var y = m("format"),
              x = m("width"),
              b = m("height"),
              _ = m("scale"),
              w = m("setBackground"),
              T = m("imageDataOnly"),
              M = document.createElement("div");
            M.style.position = "absolute", M.style.left = "-5000px", document.body.appendChild(M);
            var k = o.extendFlat({}, d);
            x ? k.width = x : null === t.width && n(p.width) && (k.width = p.width), b ? k.height = b : null === t.height && n(p.height) && (k.height = p.height);
            var A = o.extendFlat({}, h, {
                _exportedPlot: !0,
                staticPlot: !0,
                setBackground: w
              }),
              L = l.getRedrawFunc(M);
            function S() {
              return new Promise(function (e) {
                setTimeout(e, l.getDelay(M._fullLayout));
              });
            }
            function C() {
              return new Promise(function (e, t) {
                var r = s(M, y, _),
                  n = M._fullLayout.width,
                  f = M._fullLayout.height;
                function d() {
                  a.purge(M), document.body.removeChild(M);
                }
                if ("full-json" === y) {
                  var h = i.graphJson(M, !1, "keepdata", "object", !0, !0);
                  return h.version = u, h = JSON.stringify(h), d(), e(T ? h : l.encodeJSON(h));
                }
                if (d(), "svg" === y) return e(T ? r : l.encodeSVG(r));
                var p = document.createElement("canvas");
                p.id = o.randstr(), c({
                  format: y,
                  width: n,
                  height: f,
                  scale: _,
                  canvas: p,
                  svg: r,
                  promise: !0
                }).then(e).catch(t);
              });
            }
            return new Promise(function (e, t) {
              a.newPlot(M, r, k, A).then(L).then(S).then(C).then(function (t) {
                e(function (e) {
                  return T ? e.replace(l.IMAGE_URL_PREFIX, "") : e;
                }(t));
              }).catch(function (e) {
                t(e);
              });
            });
          };
        },
        2466: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(4122),
            i = r(7297),
            o = r(4452).dfltConfig,
            l = n.isPlainObject,
            s = Array.isArray,
            c = n.isArrayOrTypedArray;
          function u(e, t, r, a, i, o) {
            o = o || [];
            for (var f = Object.keys(e), d = 0; d < f.length; d++) {
              var g = f[d];
              if ("transforms" !== g) {
                var m = o.slice();
                m.push(g);
                var y = e[g],
                  x = t[g],
                  b = v(r, g),
                  _ = (b || {}).valType,
                  w = "info_array" === _,
                  T = "colorscale" === _,
                  M = (b || {}).items;
                if (p(r, g)) {
                  if (l(y) && l(x) && "any" !== _) u(y, x, b, a, i, m);else if (w && s(y)) {
                    y.length > x.length && a.push(h("unused", i, m.concat(x.length)));
                    var k,
                      A,
                      L,
                      S,
                      C,
                      O = x.length,
                      D = Array.isArray(M);
                    if (D && (O = Math.min(O, M.length)), 2 === b.dimensions) {
                      for (A = 0; A < O; A++) if (s(y[A])) {
                        y[A].length > x[A].length && a.push(h("unused", i, m.concat(A, x[A].length)));
                        var P = x[A].length;
                        for (k = 0; k < (D ? Math.min(P, M[A].length) : P); k++) L = D ? M[A][k] : M, S = y[A][k], C = x[A][k], n.validate(S, L) ? C !== S && C !== +S && a.push(h("dynamic", i, m.concat(A, k), S, C)) : a.push(h("value", i, m.concat(A, k), S));
                      } else a.push(h("array", i, m.concat(A), y[A]));
                    } else for (A = 0; A < O; A++) L = D ? M[A] : M, S = y[A], C = x[A], n.validate(S, L) ? C !== S && C !== +S && a.push(h("dynamic", i, m.concat(A), S, C)) : a.push(h("value", i, m.concat(A), S));
                  } else if (b.items && !w && s(y)) {
                    var z,
                      I,
                      E = M[Object.keys(M)[0]],
                      R = [];
                    for (z = 0; z < x.length; z++) {
                      var N = x[z]._index || z;
                      if ((I = m.slice()).push(N), l(y[N]) && l(x[z])) {
                        R.push(N);
                        var F = y[N],
                          H = x[z];
                        l(F) && !1 !== F.visible && !1 === H.visible ? a.push(h("invisible", i, I)) : u(F, H, E, a, i, I);
                      }
                    }
                    for (z = 0; z < y.length; z++) (I = m.slice()).push(z), l(y[z]) ? -1 === R.indexOf(z) && a.push(h("unused", i, I)) : a.push(h("object", i, I, y[z]));
                  } else !l(y) && l(x) ? a.push(h("object", i, m, y)) : c(y) || !c(x) || w || T ? g in t ? n.validate(y, b) ? "enumerated" === b.valType && (b.coerceNumber && y !== +x || y !== x) && a.push(h("dynamic", i, m, y, x)) : a.push(h("value", i, m, y)) : a.push(h("unused", i, m, y)) : a.push(h("array", i, m, y));
                } else a.push(h("schema", i, m));
              }
            }
            return a;
          }
          e.exports = function (e, t) {
            void 0 === e && (e = []), void 0 === t && (t = {});
            var r,
              c,
              f = i.get(),
              d = [],
              p = {
                _context: n.extendFlat({}, o)
              };
            s(e) ? (p.data = n.extendDeep([], e), r = e) : (p.data = [], r = [], d.push(h("array", "data"))), l(t) ? (p.layout = n.extendDeep({}, t), c = t) : (p.layout = {}, c = {}, arguments.length > 1 && d.push(h("object", "layout"))), a.supplyDefaults(p);
            for (var v = p._fullData, g = r.length, m = 0; m < g; m++) {
              var y = r[m],
                x = ["data", m];
              if (l(y)) {
                var b = v[m],
                  _ = b.type,
                  w = f.traces[_].attributes;
                w.type = {
                  valType: "enumerated",
                  values: [_]
                }, !1 === b.visible && !1 !== y.visible && d.push(h("invisible", x)), u(y, b, w, d, x);
                var T = y.transforms,
                  M = b.transforms;
                if (T) {
                  s(T) || d.push(h("array", x, ["transforms"])), x.push("transforms");
                  for (var k = 0; k < T.length; k++) {
                    var A = ["transforms", k],
                      L = T[k].type;
                    if (l(T[k])) {
                      var S = f.transforms[L] ? f.transforms[L].attributes : {};
                      S.type = {
                        valType: "enumerated",
                        values: Object.keys(f.transforms)
                      }, u(T[k], M[k], S, d, x, A);
                    } else d.push(h("object", x, A));
                  }
                }
              } else d.push(h("object", x));
            }
            var C = p._fullLayout,
              O = function (e, t) {
                for (var r = e.layout.layoutAttributes, a = 0; a < t.length; a++) {
                  var i = t[a],
                    o = e.traces[i.type],
                    l = o.layoutAttributes;
                  l && (i.subplot ? n.extendFlat(r[o.attributes.subplot.dflt], l) : n.extendFlat(r, l));
                }
                return r;
              }(f, v);
            return u(c, C, O, d, "layout"), 0 === d.length ? void 0 : d;
          };
          var f = {
            object: function (e, t) {
              return ("layout" === e && "" === t ? "The layout argument" : "data" === e[0] && "" === t ? "Trace " + e[1] + " in the data argument" : d(e) + "key " + t) + " must be linked to an object container";
            },
            array: function (e, t) {
              return ("data" === e ? "The data argument" : d(e) + "key " + t) + " must be linked to an array container";
            },
            schema: function (e, t) {
              return d(e) + "key " + t + " is not part of the schema";
            },
            unused: function (e, t, r) {
              var n = l(r) ? "container" : "key";
              return d(e) + n + " " + t + " did not get coerced";
            },
            dynamic: function (e, t, r, n) {
              return [d(e) + "key", t, "(set to '" + r + "')", "got reset to", "'" + n + "'", "during defaults."].join(" ");
            },
            invisible: function (e, t) {
              return (t ? d(e) + "item " + t : "Trace " + e[1]) + " got defaulted to be not visible";
            },
            value: function (e, t, r) {
              return [d(e) + "key " + t, "is set to an invalid value (" + r + ")"].join(" ");
            }
          };
          function d(e) {
            return s(e) ? "In data trace " + e[1] + ", " : "In " + e + ", ";
          }
          function h(e, t, r, a, i) {
            var o, l;
            r = r || "", s(t) ? (o = t[0], l = t[1]) : (o = t, l = null);
            var c = function (e) {
                if (!s(e)) return String(e);
                for (var t = "", r = 0; r < e.length; r++) {
                  var n = e[r];
                  "number" == typeof n ? t = t.substr(0, t.length - 1) + "[" + n + "]" : t += n, r < e.length - 1 && (t += ".");
                }
                return t;
              }(r),
              u = f[e](t, c, a, i);
            return n.log(u), {
              code: e,
              container: o,
              trace: l,
              path: r,
              astr: c,
              msg: u
            };
          }
          function p(e, t) {
            var r = m(t),
              n = r.keyMinusId,
              a = r.id;
            return !!(n in e && e[n]._isSubplotObj && a) || t in e;
          }
          function v(e, t) {
            return t in e ? e[t] : e[m(t).keyMinusId];
          }
          var g = n.counterRegex("([a-z]+)");
          function m(e) {
            var t = e.match(g);
            return {
              keyMinusId: t && t[1],
              id: t && t[2]
            };
          }
        },
        9722: function (e) {
          "use strict";

          e.exports = {
            mode: {
              valType: "enumerated",
              dflt: "afterall",
              values: ["immediate", "next", "afterall"]
            },
            direction: {
              valType: "enumerated",
              values: ["forward", "reverse"],
              dflt: "forward"
            },
            fromcurrent: {
              valType: "boolean",
              dflt: !1
            },
            frame: {
              duration: {
                valType: "number",
                min: 0,
                dflt: 500
              },
              redraw: {
                valType: "boolean",
                dflt: !0
              }
            },
            transition: {
              duration: {
                valType: "number",
                min: 0,
                dflt: 500,
                editType: "none"
              },
              easing: {
                valType: "enumerated",
                dflt: "cubic-in-out",
                values: ["linear", "quad", "cubic", "sin", "exp", "circle", "elastic", "back", "bounce", "linear-in", "quad-in", "cubic-in", "sin-in", "exp-in", "circle-in", "elastic-in", "back-in", "bounce-in", "linear-out", "quad-out", "cubic-out", "sin-out", "exp-out", "circle-out", "elastic-out", "back-out", "bounce-out", "linear-in-out", "quad-in-out", "cubic-in-out", "sin-in-out", "exp-in-out", "circle-in-out", "elastic-in-out", "back-in-out", "bounce-in-out"],
                editType: "none"
              },
              ordering: {
                valType: "enumerated",
                values: ["layout first", "traces first"],
                dflt: "layout first",
                editType: "none"
              }
            }
          };
        },
        9008: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8032);
          e.exports = function (e, t, r) {
            var i,
              o,
              l = r.name,
              s = r.inclusionAttr || "visible",
              c = t[l],
              u = n.isArrayOrTypedArray(e[l]) ? e[l] : [],
              f = t[l] = [],
              d = a.arrayTemplater(t, l, s);
            for (i = 0; i < u.length; i++) {
              var h = u[i];
              n.isPlainObject(h) ? o = d.newItem(h) : (o = d.newItem({}))[s] = !1, o._index = i, !1 !== o[s] && r.handleItemDefaults(h, o, t, r), f.push(o);
            }
            var p = d.defaultItems();
            for (i = 0; i < p.length; i++) (o = p[i])._index = f.length, r.handleItemDefaults({}, o, t, r, {}), f.push(o);
            if (n.isArrayOrTypedArray(c)) {
              var v = Math.min(c.length, f.length);
              for (i = 0; i < v; i++) n.relinkPrivateKeys(f[i], c[i]);
            }
            return f;
          };
        },
        9829: function (e, t, r) {
          "use strict";

          var n = r(337),
            a = r(192);
          e.exports = {
            type: {
              valType: "enumerated",
              values: [],
              dflt: "scatter",
              editType: "calc+clearAxisTypes",
              _noTemplating: !0
            },
            visible: {
              valType: "enumerated",
              values: [!0, !1, "legendonly"],
              dflt: !0,
              editType: "calc"
            },
            showlegend: {
              valType: "boolean",
              dflt: !0,
              editType: "style"
            },
            legend: {
              valType: "subplotid",
              dflt: "legend",
              editType: "style"
            },
            legendgroup: {
              valType: "string",
              dflt: "",
              editType: "style"
            },
            legendgrouptitle: {
              text: {
                valType: "string",
                dflt: "",
                editType: "style"
              },
              font: n({
                editType: "style"
              }),
              editType: "style"
            },
            legendrank: {
              valType: "number",
              dflt: 1e3,
              editType: "style"
            },
            legendwidth: {
              valType: "number",
              min: 0,
              editType: "style"
            },
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1,
              editType: "style"
            },
            name: {
              valType: "string",
              editType: "style"
            },
            uid: {
              valType: "string",
              editType: "plot",
              anim: !0
            },
            ids: {
              valType: "data_array",
              editType: "calc",
              anim: !0
            },
            customdata: {
              valType: "data_array",
              editType: "calc"
            },
            meta: {
              valType: "any",
              arrayOk: !0,
              editType: "plot"
            },
            selectedpoints: {
              valType: "any",
              editType: "calc"
            },
            hoverinfo: {
              valType: "flaglist",
              flags: ["x", "y", "z", "text", "name"],
              extras: ["all", "none", "skip"],
              arrayOk: !0,
              dflt: "all",
              editType: "none"
            },
            hoverlabel: a.hoverlabel,
            stream: {
              token: {
                valType: "string",
                noBlank: !0,
                strict: !0,
                editType: "calc"
              },
              maxpoints: {
                valType: "number",
                min: 0,
                max: 1e4,
                dflt: 500,
                editType: "calc"
              },
              editType: "calc"
            },
            transforms: {
              _isLinkedToArray: "transform",
              editType: "calc"
            },
            uirevision: {
              valType: "any",
              editType: "none"
            }
          };
        },
        528: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809),
            i = a.dateTime2ms,
            o = a.incrementMonth,
            l = r(3821).ONEAVGMONTH;
          e.exports = function (e, t, r, a) {
            if ("date" !== t.type) return {
              vals: a
            };
            var s = e[r + "periodalignment"];
            if (!s) return {
              vals: a
            };
            var c,
              u = e[r + "period"];
            if (n(u)) {
              if ((u = +u) <= 0) return {
                vals: a
              };
            } else if ("string" == typeof u && "M" === u.charAt(0)) {
              var f = +u.substring(1);
              if (!(f > 0 && Math.round(f) === f)) return {
                vals: a
              };
              c = f;
            }
            for (var d = t.calendar, h = "start" === s, p = "end" === s, v = e[r + "period0"], g = i(v, d) || 0, m = [], y = [], x = [], b = a.length, _ = 0; _ < b; _++) {
              var w,
                T,
                M,
                k = a[_];
              if (c) {
                for (w = Math.round((k - g) / (c * l)), M = o(g, c * w, d); M > k;) M = o(M, -c, d);
                for (; M <= k;) M = o(M, c, d);
                T = o(M, -c, d);
              } else {
                for (M = g + (w = Math.round((k - g) / u)) * u; M > k;) M -= u;
                for (; M <= k;) M += u;
                T = M - u;
              }
              m[_] = h ? T : p ? M : (T + M) / 2, y[_] = T, x[_] = M;
            }
            return {
              vals: m,
              starts: y,
              ends: x
            };
          };
        },
        5126: function (e) {
          "use strict";

          e.exports = {
            xaxis: {
              valType: "subplotid",
              dflt: "x",
              editType: "calc+clearAxisTypes"
            },
            yaxis: {
              valType: "subplotid",
              dflt: "y",
              editType: "calc+clearAxisTypes"
            }
          };
        },
        2919: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(721),
            i = r(4809),
            o = r(3821).FP_SAFE,
            l = r(3626),
            s = r(2203),
            c = r(5975),
            u = c.getFromId,
            f = c.isLinked;
          function d(e, t) {
            var r,
              n,
              a = [],
              o = e._fullLayout,
              l = p(o, t, 0),
              s = p(o, t, 1),
              c = g(e, t),
              u = c.min,
              f = c.max;
            if (0 === u.length || 0 === f.length) return i.simpleMap(t.range, t.r2l);
            var d = u[0].val,
              v = f[0].val;
            for (r = 1; r < u.length && d === v; r++) d = Math.min(d, u[r].val);
            for (r = 1; r < f.length && d === v; r++) v = Math.max(v, f[r].val);
            var m = t.autorange,
              y = "reversed" === m || "min reversed" === m || "max reversed" === m;
            if (!y && t.range) {
              var x = i.simpleMap(t.range, t.r2l);
              y = x[1] < x[0];
            }
            "reversed" === t.autorange && (t.autorange = !0);
            var b,
              _,
              w,
              T,
              k,
              A,
              L = t.rangemode,
              S = "tozero" === L,
              C = "nonnegative" === L,
              O = t._length,
              D = O / 10,
              P = 0;
            for (r = 0; r < u.length; r++) for (b = u[r], n = 0; n < f.length; n++) (A = (_ = f[n]).val - b.val - h(t, b.val, _.val)) > 0 && ((k = O - l(b) - s(_)) > D ? A / k > P && (w = b, T = _, P = A / k) : A / O > P && (w = {
              val: b.val,
              nopad: 1
            }, T = {
              val: _.val,
              nopad: 1
            }, P = A / O));
            if (d === v) {
              var z = d - 1,
                I = d + 1;
              if (S) {
                if (0 === d) a = [0, 1];else {
                  var E = (d > 0 ? f : u).reduce(function (e, t) {
                      return Math.max(e, s(t));
                    }, 0),
                    R = d / (1 - Math.min(.5, E / O));
                  a = d > 0 ? [0, R] : [R, 0];
                }
              } else a = C ? [Math.max(0, z), Math.max(1, I)] : [z, I];
            } else S ? (w.val >= 0 && (w = {
              val: 0,
              nopad: 1
            }), T.val <= 0 && (T = {
              val: 0,
              nopad: 1
            })) : C && (w.val - P * l(w) < 0 && (w = {
              val: 0,
              nopad: 1
            }), T.val <= 0 && (T = {
              val: 1,
              nopad: 1
            })), P = (T.val - w.val - h(t, b.val, _.val)) / (O - l(w) - s(T)), a = [w.val - P * l(w), T.val + P * s(T)];
            return a = M(a, t), t.limitRange && t.limitRange(), y && a.reverse(), i.simpleMap(a, t.l2r || Number);
          }
          function h(e, t, r) {
            var n = 0;
            if (e.rangebreaks) for (var a = e.locateBreaks(t, r), i = 0; i < a.length; i++) {
              var o = a[i];
              n += o.max - o.min;
            }
            return n;
          }
          function p(e, t, r) {
            var a = .05 * t._length,
              o = t._anchorAxis || {};
            if (-1 !== (t.ticklabelposition || "").indexOf("inside") || -1 !== (o.ticklabelposition || "").indexOf("inside")) {
              var l = t.isReversed();
              if (!l) {
                var c = i.simpleMap(t.range, t.r2l);
                l = c[1] < c[0];
              }
              l && (r = !r);
            }
            var u = 0;
            return f(e, t._id) || (u = function (e, t, r) {
              var a = 0,
                o = "x" === t._id.charAt(0);
              for (var l in e._plots) {
                var c = e._plots[l];
                if (t._id === c.xaxis._id || t._id === c.yaxis._id) {
                  var u = (o ? c.yaxis : c.xaxis) || {};
                  if (-1 !== (u.ticklabelposition || "").indexOf("inside") && (!r && ("left" === u.side || "bottom" === u.side) || r && ("top" === u.side || "right" === u.side))) {
                    if (u._vals) {
                      var f = i.deg2rad(u._tickAngles[u._id + "tick"] || 0),
                        d = Math.abs(Math.cos(f)),
                        h = Math.abs(Math.sin(f));
                      if (!u._vals[0].bb) {
                        var p = u._id + "tick";
                        u._selections[p].each(function (e) {
                          var t = n.select(this);
                          t.select(".text-math-group").empty() && (e.bb = s.bBox(t.node()));
                        });
                      }
                      for (var g = 0; g < u._vals.length; g++) {
                        var m = u._vals[g].bb;
                        if (m) {
                          var y = 2 * v + m.width,
                            x = 2 * v + m.height;
                          a = Math.max(a, o ? Math.max(y * d, x * h) : Math.max(x * d, y * h));
                        }
                      }
                    }
                    "inside" === u.ticks && "inside" === u.ticklabelposition && (a += u.ticklen || 0);
                  }
                }
              }
              return a;
            }(e, t, r)), a = Math.max(u, a), "domain" === t.constrain && t._inputDomain && (a *= (t._inputDomain[1] - t._inputDomain[0]) / (t.domain[1] - t.domain[0])), function (e) {
              return e.nopad ? 0 : e.pad + (e.extrapad ? a : u);
            };
          }
          e.exports = {
            applyAutorangeOptions: M,
            getAutoRange: d,
            makePadFn: p,
            doAutoRange: function (e, t, r) {
              if (t.setScale(), t.autorange) {
                t.range = r ? r.slice() : d(e, t), t._r = t.range.slice(), t._rl = i.simpleMap(t._r, t.r2l);
                var n = t._input,
                  a = {};
                a[t._attr + ".range"] = t.range, a[t._attr + ".autorange"] = t.autorange, l.call("_storeDirectGUIEdit", e.layout, e._fullLayout._preGUI, a), n.range = t.range.slice(), n.autorange = t.autorange;
              }
              var o = t._anchorAxis;
              if (o && o.rangeslider) {
                var s = o.rangeslider[t._name];
                s && "auto" === s.rangemode && (s.range = d(e, t)), o._input.rangeslider[t._name] = i.extendFlat({}, s);
              }
            },
            findExtremes: function (e, t, r) {
              r || (r = {}), e._m || e.setScale();
              var n,
                i,
                l,
                s,
                c,
                u,
                f,
                d,
                h,
                p = [],
                v = [],
                g = t.length,
                x = r.padded || !1,
                _ = r.tozero && ("linear" === e.type || "-" === e.type),
                w = "log" === e.type,
                T = !1,
                M = r.vpadLinearized || !1;
              function k(e) {
                if (Array.isArray(e)) return T = !0, function (t) {
                  return Math.max(Number(e[t] || 0), 0);
                };
                var t = Math.max(Number(e || 0), 0);
                return function () {
                  return t;
                };
              }
              var A = k((e._m > 0 ? r.ppadplus : r.ppadminus) || r.ppad || 0),
                L = k((e._m > 0 ? r.ppadminus : r.ppadplus) || r.ppad || 0),
                S = k(r.vpadplus || r.vpad),
                C = k(r.vpadminus || r.vpad);
              if (!T) {
                if (d = 1 / 0, h = -1 / 0, w) for (n = 0; n < g; n++) (i = t[n]) < d && i > 0 && (d = i), i > h && i < o && (h = i);else for (n = 0; n < g; n++) (i = t[n]) < d && i > -o && (d = i), i > h && i < o && (h = i);
                t = [d, h], g = 2;
              }
              var O = {
                tozero: _,
                extrapad: x
              };
              function D(r) {
                l = t[r], a(l) && (u = A(r), f = L(r), M ? (s = e.c2l(l) - C(r), c = e.c2l(l) + S(r)) : (d = l - C(r), h = l + S(r), w && d < h / 10 && (d = h / 10), s = e.c2l(d), c = e.c2l(h)), _ && (s = Math.min(0, s), c = Math.max(0, c)), b(s) && m(p, s, f, O), b(c) && y(v, c, u, O));
              }
              var P = Math.min(6, g);
              for (n = 0; n < P; n++) D(n);
              for (n = g - 1; n >= P; n--) D(n);
              return {
                min: p,
                max: v,
                opts: r
              };
            },
            concatExtremes: g
          };
          var v = 3;
          function g(e, t, r) {
            var n,
              a,
              i,
              o = t._id,
              l = e._fullData,
              s = e._fullLayout,
              c = [],
              f = [];
            function d(e, t) {
              for (n = 0; n < t.length; n++) {
                var r = e[t[n]],
                  l = (r._extremes || {})[o];
                if (!0 === r.visible && l) {
                  for (a = 0; a < l.min.length; a++) i = l.min[a], m(c, i.val, i.pad, {
                    extrapad: i.extrapad
                  });
                  for (a = 0; a < l.max.length; a++) i = l.max[a], y(f, i.val, i.pad, {
                    extrapad: i.extrapad
                  });
                }
              }
            }
            if (d(l, t._traceIndices), d(s.annotations || [], t._annIndices || []), d(s.shapes || [], t._shapeIndices || []), t._matchGroup && !r) for (var h in t._matchGroup) if (h !== t._id) {
              var p = u(e, h),
                v = g(e, p, !0),
                x = t._length / p._length;
              for (a = 0; a < v.min.length; a++) i = v.min[a], m(c, i.val, i.pad * x, {
                extrapad: i.extrapad
              });
              for (a = 0; a < v.max.length; a++) i = v.max[a], y(f, i.val, i.pad * x, {
                extrapad: i.extrapad
              });
            }
            return {
              min: c,
              max: f
            };
          }
          function m(e, t, r, n) {
            x(e, t, r, n, _);
          }
          function y(e, t, r, n) {
            x(e, t, r, n, w);
          }
          function x(e, t, r, n, a) {
            for (var i = n.tozero, o = n.extrapad, l = !0, s = 0; s < e.length && l; s++) {
              var c = e[s];
              if (a(c.val, t) && c.pad >= r && (c.extrapad || !o)) {
                l = !1;
                break;
              }
              a(t, c.val) && c.pad <= r && (o || !c.extrapad) && (e.splice(s, 1), s--);
            }
            if (l) {
              var u = i && 0 === t;
              e.push({
                val: t,
                pad: u ? 0 : r,
                extrapad: !u && o
              });
            }
          }
          function b(e) {
            return a(e) && Math.abs(e) < o;
          }
          function _(e, t) {
            return e <= t;
          }
          function w(e, t) {
            return e >= t;
          }
          function T(e, t, r) {
            return void 0 === t || void 0 === r || (t = e.d2l(t)) < e.d2l(r);
          }
          function M(e, t) {
            if (!t || !t.autorangeoptions) return e;
            var r = e[0],
              n = e[1],
              a = t.autorangeoptions.include;
            if (void 0 !== a) {
              var o = t.d2l(r),
                l = t.d2l(n);
              i.isArrayOrTypedArray(a) || (a = [a]);
              for (var s = 0; s < a.length; s++) {
                var c = t.d2l(a[s]);
                o >= c && (o = c, r = c), l <= c && (l = c, n = c);
              }
            }
            return r = function (e, t) {
              var r = t.autorangeoptions;
              return r && void 0 !== r.minallowed && T(t, r.minallowed, r.maxallowed) ? r.minallowed : r && void 0 !== r.clipmin && T(t, r.clipmin, r.clipmax) ? Math.max(e, t.d2l(r.clipmin)) : e;
            }(r, t), n = function (e, t) {
              var r = t.autorangeoptions;
              return r && void 0 !== r.maxallowed && T(t, r.minallowed, r.maxallowed) ? r.maxallowed : r && void 0 !== r.clipmax && T(t, r.clipmin, r.clipmax) ? Math.min(e, t.d2l(r.clipmax)) : e;
            }(n, t), [r, n];
          }
        },
        5511: function (e) {
          "use strict";

          e.exports = function (e, t, r) {
            var n, a;
            if (r) {
              var i = "reversed" === t || "min reversed" === t || "max reversed" === t;
              n = r[i ? 1 : 0], a = r[i ? 0 : 1];
            }
            var o = e("autorangeoptions.minallowed", null === a ? n : void 0),
              l = e("autorangeoptions.maxallowed", null === n ? a : void 0);
            void 0 === o && e("autorangeoptions.clipmin"), void 0 === l && e("autorangeoptions.clipmax"), e("autorangeoptions.include");
          };
        },
        9714: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(721),
            i = r(4122),
            o = r(3626),
            l = r(4809),
            s = l.strTranslate,
            c = r(635),
            u = r(7240),
            f = r(8766),
            d = r(2203),
            h = r(5829),
            p = r(8599),
            v = r(3821),
            g = v.ONEMAXYEAR,
            m = v.ONEAVGYEAR,
            y = v.ONEMINYEAR,
            x = v.ONEMAXQUARTER,
            b = v.ONEAVGQUARTER,
            _ = v.ONEMINQUARTER,
            w = v.ONEMAXMONTH,
            T = v.ONEAVGMONTH,
            M = v.ONEMINMONTH,
            k = v.ONEWEEK,
            A = v.ONEDAY,
            L = A / 2,
            S = v.ONEHOUR,
            C = v.ONEMIN,
            O = v.ONESEC,
            D = v.ONEMILLI,
            P = v.ONEMICROSEC,
            z = v.MINUS_SIGN,
            I = v.BADNUM,
            E = {
              K: "zeroline"
            },
            R = {
              K: "gridline",
              L: "path"
            },
            N = {
              K: "minor-gridline",
              L: "path"
            },
            F = {
              K: "tick",
              L: "path"
            },
            H = {
              K: "tick",
              L: "text"
            },
            B = {
              width: ["x", "r", "l", "xl", "xr"],
              height: ["y", "t", "b", "yt", "yb"],
              right: ["r", "xr"],
              left: ["l", "xl"],
              top: ["t", "yt"],
              bottom: ["b", "yb"]
            },
            j = r(4530),
            Y = j.MID_SHIFT,
            V = j.CAP_SHIFT,
            U = j.LINE_SPACING,
            q = j.OPPOSITE_SIDE,
            G = e.exports = {};
          G.setConvert = r(9091);
          var Z = r(9666),
            W = r(5975),
            J = W.idSort,
            X = W.isLinked;
          G.id2name = W.id2name, G.name2id = W.name2id, G.cleanId = W.cleanId, G.list = W.list, G.listIds = W.listIds, G.getFromId = W.getFromId, G.getFromTrace = W.getFromTrace;
          var K = r(2919);
          G.getAutoRange = K.getAutoRange, G.findExtremes = K.findExtremes;
          var Q = 1e-4;
          function $(e) {
            var t = (e[1] - e[0]) * Q;
            return [e[0] - t, e[1] + t];
          }
          G.coerceRef = function (e, t, r, n, a, i) {
            var o = n.charAt(n.length - 1),
              s = r._fullLayout._subplots[o + "axis"],
              c = n + "ref",
              u = {};
            return a || (a = s[0] || ("string" == typeof i ? i : i[0])), i || (i = a), s = s.concat(s.map(function (e) {
              return e + " domain";
            })), u[c] = {
              valType: "enumerated",
              values: s.concat(i ? "string" == typeof i ? [i] : i : []),
              dflt: a
            }, l.coerce(e, t, u, c);
          }, G.getRefType = function (e) {
            return void 0 === e ? e : "paper" === e ? "paper" : "pixel" === e ? "pixel" : /( domain)$/.test(e) ? "domain" : "range";
          }, G.coercePosition = function (e, t, r, n, a, i) {
            var o, s;
            if ("range" !== G.getRefType(n)) o = l.ensureNumber, s = r(a, i);else {
              var c = G.getFromId(t, n);
              s = r(a, i = c.fraction2r(i)), o = c.cleanPos;
            }
            e[a] = o(s);
          }, G.cleanPosition = function (e, t, r) {
            return ("paper" === r || "pixel" === r ? l.ensureNumber : G.getFromId(t, r).cleanPos)(e);
          }, G.redrawComponents = function (e, t) {
            t = t || G.listIds(e);
            var r = e._fullLayout;
            function n(n, a, i, l) {
              for (var s = o.getComponentMethod(n, a), c = {}, u = 0; u < t.length; u++) for (var f = r[G.id2name(t[u])][i], d = 0; d < f.length; d++) {
                var h = f[d];
                if (!c[h] && (s(e, h), c[h] = 1, l)) return;
              }
            }
            n("annotations", "drawOne", "_annIndices"), n("shapes", "drawOne", "_shapeIndices"), n("images", "draw", "_imgIndices", !0), n("selections", "drawOne", "_selectionIndices");
          };
          var ee = G.getDataConversions = function (e, t, r, n) {
            var a,
              i = "x" === r || "y" === r || "z" === r ? r : n;
            if (l.isArrayOrTypedArray(i)) {
              if (a = {
                type: Z(n, void 0, {
                  autotypenumbers: e._fullLayout.autotypenumbers
                }),
                _categories: []
              }, G.setConvert(a), "category" === a.type) for (var o = 0; o < n.length; o++) a.d2c(n[o]);
            } else a = G.getFromTrace(e, t, i);
            return a ? {
              d2c: a.d2c,
              c2d: a.c2d
            } : "ids" === i ? {
              d2c: re,
              c2d: re
            } : {
              d2c: te,
              c2d: te
            };
          };
          function te(e) {
            return +e;
          }
          function re(e) {
            return String(e);
          }
          function ne(e, t) {
            return Math.abs((e / t + .5) % 1 - .5) < .001;
          }
          function ae(e, t) {
            return Math.abs(e / t - 1) < .001;
          }
          function ie(e) {
            return +e.substring(1);
          }
          function oe(e, t) {
            return e.rangebreaks && (t = t.filter(function (t) {
              return e.maskBreaks(t.x) !== I;
            })), t;
          }
          function le(e) {
            var t = e._mainAxis,
              r = [];
            if (t._vals) for (var n = 0; n < t._vals.length; n++) if (!t._vals[n].noTick) {
              var a = t.l2p(t._vals[n].x),
                i = e.p2l(a),
                o = G.tickText(e, i);
              t._vals[n].minor && (o.minor = !0, o.text = ""), r.push(o);
            }
            return oe(e, r);
          }
          function se(e, t) {
            var r = $(l.simpleMap(e.range, e.r2l)),
              n = Math.min(r[0], r[1]),
              a = Math.max(r[0], r[1]),
              i = "category" === e.type ? e.d2l_noadd : e.d2l;
            "log" === e.type && "L" !== String(e.dtick).charAt(0) && (e.dtick = "L" + Math.pow(10, Math.floor(Math.min(e.range[0], e.range[1])) - 1));
            for (var o = [], s = 0; s <= 1; s++) if ((void 0 === t || !(t && s || !1 === t && !s)) && (!s || e.minor)) {
              var c = s ? e.minor.tickvals : e.tickvals,
                u = s ? [] : e.ticktext;
              if (c) {
                l.isArrayOrTypedArray(u) || (u = []);
                for (var f = 0; f < c.length; f++) {
                  var d = i(c[f]);
                  if (d > n && d < a) {
                    var h = G.tickText(e, d, !1, String(u[f]));
                    s && (h.minor = !0, h.text = ""), o.push(h);
                  }
                }
              }
            }
            return oe(e, o);
          }
          G.getDataToCoordFunc = function (e, t, r, n) {
            return ee(e, t, r, n).d2c;
          }, G.counterLetter = function (e) {
            var t = e.charAt(0);
            return "x" === t ? "y" : "y" === t ? "x" : void 0;
          }, G.minDtick = function (e, t, r, n) {
            -1 === ["log", "category", "multicategory"].indexOf(e.type) && n ? void 0 === e._minDtick ? (e._minDtick = t, e._forceTick0 = r) : e._minDtick && ((e._minDtick / t + 1e-6) % 1 < 2e-6 && ((r - e._forceTick0) / t % 1 + 1.000001) % 1 < 2e-6 ? (e._minDtick = t, e._forceTick0 = r) : ((t / e._minDtick + 1e-6) % 1 > 2e-6 || ((r - e._forceTick0) / e._minDtick % 1 + 1.000001) % 1 > 2e-6) && (e._minDtick = 0)) : e._minDtick = 0;
          }, G.saveRangeInitial = function (e, t) {
            for (var r = G.list(e, "", !0), n = !1, a = 0; a < r.length; a++) {
              var i = r[a],
                o = void 0 === i._rangeInitial0 && void 0 === i._rangeInitial1,
                l = o || i.range[0] !== i._rangeInitial0 || i.range[1] !== i._rangeInitial1,
                s = i.autorange;
              (o && !0 !== s || t && l) && (i._rangeInitial0 = "min" === s || "max reversed" === s ? void 0 : i.range[0], i._rangeInitial1 = "max" === s || "min reversed" === s ? void 0 : i.range[1], i._autorangeInitial = s, n = !0);
            }
            return n;
          }, G.saveShowSpikeInitial = function (e, t) {
            for (var r = G.list(e, "", !0), n = !1, a = "on", i = 0; i < r.length; i++) {
              var o = r[i],
                l = void 0 === o._showSpikeInitial,
                s = l || !(o.showspikes === o._showspikes);
              (l || t && s) && (o._showSpikeInitial = o.showspikes, n = !0), "on" !== a || o.showspikes || (a = "off");
            }
            return e._fullLayout._cartesianSpikesEnabled = a, n;
          }, G.autoBin = function (e, t, r, n, i, o) {
            var s,
              c = l.aggNums(Math.min, null, e),
              u = l.aggNums(Math.max, null, e);
            if ("category" === t.type || "multicategory" === t.type) return {
              start: c - .5,
              end: u + .5,
              size: Math.max(1, Math.round(o) || 1),
              _dataSpan: u - c
            };
            if (i || (i = t.calendar), s = "log" === t.type ? {
              type: "linear",
              range: [c, u]
            } : {
              type: t.type,
              range: l.simpleMap([c, u], t.c2r, 0, i),
              calendar: i
            }, G.setConvert(s), o = o && p.dtick(o, s.type)) s.dtick = o, s.tick0 = p.tick0(void 0, s.type, i);else {
              var f;
              if (r) f = (u - c) / r;else {
                var d = l.distinctVals(e),
                  h = Math.pow(10, Math.floor(Math.log(d.minDiff) / Math.LN10)),
                  v = h * l.roundUp(d.minDiff / h, [.9, 1.9, 4.9, 9.9], !0);
                f = Math.max(v, 2 * l.stdev(e) / Math.pow(e.length, n ? .25 : .4)), a(f) || (f = 1);
              }
              G.autoTicks(s, f);
            }
            var g,
              m = s.dtick,
              y = G.tickIncrement(G.tickFirst(s), m, "reverse", i);
            if ("number" == typeof m) y = function (e, t, r, n, i) {
              var o = 0,
                l = 0,
                s = 0,
                c = 0;
              function u(t) {
                return (1 + 100 * (t - e) / r.dtick) % 100 < 2;
              }
              for (var f = 0; f < t.length; f++) t[f] % 1 == 0 ? s++ : a(t[f]) || c++, u(t[f]) && o++, u(t[f] + r.dtick / 2) && l++;
              var d = t.length - c;
              if (s === d && "date" !== r.type) r.dtick < 1 ? e = n - .5 * r.dtick : (e -= .5) + r.dtick < n && (e += r.dtick);else if (l < .1 * d && (o > .3 * d || u(n) || u(i))) {
                var h = r.dtick / 2;
                e += e + h < n ? h : -h;
              }
              return e;
            }(y, e, s, c, u), g = y + (1 + Math.floor((u - y) / m)) * m;else for ("M" === s.dtick.charAt(0) && (y = function (e, t, r, n, a) {
              var i = l.findExactDates(t, a);
              if (i.exactDays > .8) {
                var o = Number(r.substr(1));
                i.exactYears > .8 && o % 12 == 0 ? e = G.tickIncrement(e, "M6", "reverse") + 1.5 * A : i.exactMonths > .8 ? e = G.tickIncrement(e, "M1", "reverse") + 15.5 * A : e -= L;
                var s = G.tickIncrement(e, r);
                if (s <= n) return s;
              }
              return e;
            }(y, e, m, c, i)), g = y; g <= u;) g = G.tickIncrement(g, m, !1, i);
            return {
              start: t.c2r(y, 0, i),
              end: t.c2r(g, 0, i),
              size: m,
              _dataSpan: u - c
            };
          }, G.prepMinorTicks = function (e, t, r) {
            if (!t.minor.dtick) {
              delete e.dtick;
              var n,
                i = t.dtick && a(t._tmin);
              if (i) {
                var o = G.tickIncrement(t._tmin, t.dtick, !0);
                n = [t._tmin, .99 * o + .01 * t._tmin];
              } else {
                var s = l.simpleMap(t.range, t.r2l);
                n = [s[0], .8 * s[0] + .2 * s[1]];
              }
              if (e.range = l.simpleMap(n, t.l2r), e._isMinor = !0, G.prepTicks(e, r), i) {
                var c = a(t.dtick),
                  u = a(e.dtick),
                  f = c ? t.dtick : +t.dtick.substring(1),
                  d = u ? e.dtick : +e.dtick.substring(1);
                c && u ? ne(f, d) ? f === 2 * k && d === 2 * A && (e.dtick = k) : f === 2 * k && d === 3 * A ? e.dtick = k : f !== k || (t._input.minor || {}).nticks ? ae(f / d, 2.5) ? e.dtick = f / 2 : e.dtick = f : e.dtick = A : "M" === String(t.dtick).charAt(0) ? u ? e.dtick = "M1" : ne(f, d) ? f >= 12 && 2 === d && (e.dtick = "M3") : e.dtick = t.dtick : "L" === String(e.dtick).charAt(0) ? "L" === String(t.dtick).charAt(0) ? ne(f, d) || (e.dtick = ae(f / d, 2.5) ? t.dtick / 2 : t.dtick) : e.dtick = "D1" : "D2" === e.dtick && +t.dtick > 1 && (e.dtick = 1);
              }
              e.range = t.range;
            }
            void 0 === t.minor._tick0Init && (e.tick0 = t.tick0);
          }, G.prepTicks = function (e, t) {
            var r = l.simpleMap(e.range, e.r2l, void 0, void 0, t);
            if ("auto" === e.tickmode || !e.dtick) {
              var n,
                i = e.nticks;
              i || ("category" === e.type || "multicategory" === e.type ? (n = e.tickfont ? l.bigFont(e.tickfont.size || 12) : 15, i = e._length / n) : (n = "y" === e._id.charAt(0) ? 40 : 80, i = l.constrain(e._length / n, 4, 9) + 1), "radialaxis" === e._name && (i *= 2)), e.minor && "array" !== e.minor.tickmode || "array" === e.tickmode && (i *= 100), e._roughDTick = Math.abs(r[1] - r[0]) / i, G.autoTicks(e, e._roughDTick), e._minDtick > 0 && e.dtick < 2 * e._minDtick && (e.dtick = e._minDtick, e.tick0 = e.l2r(e._forceTick0));
            }
            "period" === e.ticklabelmode && function (e) {
              var t;
              function r() {
                return !(a(e.dtick) || "M" !== e.dtick.charAt(0));
              }
              var n = r(),
                i = G.getTickFormat(e);
              if (i) {
                var o = e._dtickInit !== e.dtick;
                /%[fLQsSMX]/.test(i) || (/%[HI]/.test(i) ? (t = S, o && !n && e.dtick < S && (e.dtick = S)) : /%p/.test(i) ? (t = L, o && !n && e.dtick < L && (e.dtick = L)) : /%[Aadejuwx]/.test(i) ? (t = A, o && !n && e.dtick < A && (e.dtick = A)) : /%[UVW]/.test(i) ? (t = k, o && !n && e.dtick < k && (e.dtick = k)) : /%[Bbm]/.test(i) ? (t = T, o && (n ? ie(e.dtick) < 1 : e.dtick < M) && (e.dtick = "M1")) : /%[q]/.test(i) ? (t = b, o && (n ? ie(e.dtick) < 3 : e.dtick < _) && (e.dtick = "M3")) : /%[Yy]/.test(i) && (t = m, o && (n ? ie(e.dtick) < 12 : e.dtick < y) && (e.dtick = "M12")));
              }
              (n = r()) && e.tick0 === e._dowTick0 && (e.tick0 = e._rawTick0), e._definedDelta = t;
            }(e), e.tick0 || (e.tick0 = "date" === e.type ? "2000-01-01" : 0), "date" === e.type && e.dtick < .1 && (e.dtick = .1), me(e);
          }, G.calcTicks = function (e, t) {
            for (var r, n, i, o, s = e.type, c = e.calendar, u = e.ticklabelstep, f = "period" === e.ticklabelmode, d = e.range[0] > e.range[1], h = !e.ticklabelindex || l.isArrayOrTypedArray(e.ticklabelindex) ? e.ticklabelindex : [e.ticklabelindex], p = l.simpleMap(e.range, e.r2l, void 0, void 0, t), v = p[1] < p[0], z = Math.min(p[0], p[1]), E = Math.max(p[0], p[1]), R = Math.max(1e3, e._length || 0), N = [], F = [], H = [], B = [], j = [], Y = e.minor && (e.minor.ticks || e.minor.showgrid), V = 1; V >= (Y ? 0 : 1); V--) {
              var U = !V;
              V ? (e._dtickInit = e.dtick, e._tick0Init = e.tick0) : (e.minor._dtickInit = e.minor.dtick, e.minor._tick0Init = e.minor.tick0);
              var q = V ? e : l.extendFlat({}, e, e.minor);
              if (U ? G.prepMinorTicks(q, e, t) : G.prepTicks(q, t), "array" !== q.tickmode) {
                if ("sync" !== q.tickmode) {
                  var Z = $(p),
                    W = Z[0],
                    J = Z[1],
                    X = a(q.dtick),
                    K = "log" === s && !(X || "L" === q.dtick.charAt(0)),
                    Q = G.tickFirst(q, t);
                  if (V) {
                    if (e._tmin = Q, Q < W !== v) break;
                    "category" !== s && "multicategory" !== s || (J = v ? Math.max(-.5, J) : Math.min(e._categories.length - .5, J));
                  }
                  var ee,
                    te,
                    re = null,
                    ne = Q;
                  V && (X ? te = e.dtick : "date" === s ? "string" == typeof e.dtick && "M" === e.dtick.charAt(0) && (te = T * e.dtick.substring(1)) : te = e._roughDTick, ee = Math.round((e.r2l(ne) - e.r2l(e.tick0)) / te) - 1);
                  var ae = q.dtick;
                  for (q.rangebreaks && q._tick0Init !== q.tick0 && (ne = Ne(ne, e), v || (ne = G.tickIncrement(ne, ae, !v, c))), V && f && (ne = G.tickIncrement(ne, ae, !v, c), ee--); v ? ne >= J : ne <= J; ne = G.tickIncrement(ne, ae, v, c)) {
                    if (V && ee++, q.rangebreaks && !v) {
                      if (ne < W) continue;
                      if (q.maskBreaks(ne) === I && Ne(ne, q) >= E) break;
                    }
                    if (H.length > R || ne === re) break;
                    re = ne;
                    var ie = {
                      value: ne
                    };
                    V ? (K && ne !== (0 | ne) && (ie.simpleLabel = !0), u > 1 && ee % u && (ie.skipLabel = !0), H.push(ie)) : (ie.minor = !0, B.push(ie));
                  }
                } else H = [], N = le(e);
              } else V ? (H = [], N = se(e, !U)) : (B = [], F = se(e, !U));
            }
            !B || B.length < 2 ? h = !1 : (r = (B[1].value - B[0].value) * (d ? -1 : 1), n = e.tickformat, (/%f/.test(n) ? r >= P : /%L/.test(n) ? r >= D : /%[SX]/.test(n) ? r >= O : /%M/.test(n) ? r >= C : /%[HI]/.test(n) ? r >= S : /%p/.test(n) ? r >= L : /%[Aadejuwx]/.test(n) ? r >= A : /%[UVW]/.test(n) ? r >= k : /%[Bbm]/.test(n) ? r >= M : /%[q]/.test(n) ? r >= _ : !/%[Yy]/.test(n) || r >= y) || (h = !1));
            if (h) {
              var oe = H.concat(B);
              f && H.length && (oe = oe.slice(1)), (oe = oe.sort(function (e, t) {
                return e.value - t.value;
              }).filter(function (e, t, r) {
                return 0 === t || e.value !== r[t - 1].value;
              })).map(function (e, t) {
                return void 0 !== e.minor || e.skipLabel ? null : t;
              }).filter(function (e) {
                return null !== e;
              }).forEach(function (e) {
                h.map(function (t) {
                  var r = e + t;
                  r >= 0 && r < oe.length && l.pushUnique(j, oe[r]);
                });
              });
            } else j = H;
            if (Y && !("inside" === e.minor.ticks && "outside" === e.ticks || "outside" === e.minor.ticks && "inside" === e.ticks)) {
              for (var ce = H.map(function (e) {
                  return e.value;
                }), ue = [], fe = 0; fe < B.length; fe++) {
                var de = B[fe],
                  he = de.value;
                if (-1 === ce.indexOf(he)) {
                  for (var pe = !1, ve = 0; !pe && ve < H.length; ve++) 1e7 + H[ve].value === 1e7 + he && (pe = !0);
                  pe || ue.push(de);
                }
              }
              B = ue;
            }
            if (f && function (e, t, r) {
              for (var n = 0; n < e.length; n++) {
                var a = e[n].value,
                  i = n,
                  o = n + 1;
                n < e.length - 1 ? (i = n, o = n + 1) : n > 0 ? (i = n - 1, o = n) : (i = n, o = n);
                var l,
                  s = e[i].value,
                  c = e[o].value,
                  u = Math.abs(c - s),
                  f = r || u,
                  d = 0;
                f >= y ? d = u >= y && u <= g ? u : m : r === b && f >= _ ? d = u >= _ && u <= x ? u : b : f >= M ? d = u >= M && u <= w ? u : T : r === k && f >= k ? d = k : f >= A ? d = A : r === L && f >= L ? d = L : r === S && f >= S && (d = S), d >= u && (d = u, l = !0);
                var h = a + d;
                if (t.rangebreaks && d > 0) {
                  for (var p = 0, v = 0; v < 84; v++) {
                    var C = (v + .5) / 84;
                    t.maskBreaks(a * (1 - C) + C * h) !== I && p++;
                  }
                  (d *= p / 84) || (e[n].drop = !0), l && u > k && (d = u);
                }
                (d > 0 || 0 === n) && (e[n].periodX = a + d / 2);
              }
            }(j, e, e._definedDelta), e.rangebreaks) {
              var ge = "y" === e._id.charAt(0),
                me = 1;
              "auto" === e.tickmode && (me = e.tickfont ? e.tickfont.size : 12);
              var ye = NaN;
              for (i = H.length - 1; i > -1; i--) if (H[i].drop) H.splice(i, 1);else {
                H[i].value = Ne(H[i].value, e);
                var xe = e.c2p(H[i].value);
                (ge ? ye > xe - me : ye < xe + me) ? H.splice(v ? i + 1 : i, 1) : ye = xe;
              }
            }
            Re(e) && 360 === Math.abs(p[1] - p[0]) && H.pop(), e._tmax = (H[H.length - 1] || {}).value, e._prevDateHead = "", e._inCalcTicks = !0;
            var be,
              _e = function (t) {
                t.text = "", e._prevDateHead = o;
              };
            function we(e, t) {
              var r = G.tickText(e, t.value, !1, t.simpleLabel),
                n = t.periodX;
              return void 0 !== n && (r.periodX = n, (n > E || n < z) && (n > E && (r.periodX = E), n < z && (r.periodX = z), _e(r))), r;
            }
            for (H = H.concat(B), i = 0; i < H.length; i++) {
              var Te = H[i].minor,
                Me = H[i].value;
              Te ? ((be = h && -1 !== j.indexOf(H[i]) ? we(e, H[i]) : {
                x: Me
              }).minor = !0, F.push(be)) : (o = e._prevDateHead, be = we(e, H[i]), (H[i].skipLabel || h && -1 === j.indexOf(H[i])) && _e(be), N.push(be));
            }
            return N = N.concat(F), e._inCalcTicks = !1, f && N.length && (N[0].noTick = !0), N;
          };
          var ce = [2, 5, 10],
            ue = [1, 2, 3, 6, 12],
            fe = [1, 2, 5, 10, 15, 30],
            de = [1, 2, 3, 7, 14],
            he = [-.046, 0, .301, .477, .602, .699, .778, .845, .903, .954, 1],
            pe = [-.301, 0, .301, .699, 1],
            ve = [15, 30, 45, 90, 180];
          function ge(e, t, r) {
            return t * l.roundUp(e / t, r);
          }
          function me(e) {
            var t = e.dtick;
            if (e._tickexponent = 0, a(t) || "string" == typeof t || (t = 1), "category" !== e.type && "multicategory" !== e.type || (e._tickround = null), "date" === e.type) {
              var r = e.r2l(e.tick0),
                n = e.l2r(r).replace(/(^-|i)/g, ""),
                i = n.length;
              if ("M" === String(t).charAt(0)) i > 10 || "01-01" !== n.substr(5) ? e._tickround = "d" : e._tickround = +t.substr(1) % 12 == 0 ? "y" : "m";else if (t >= A && i <= 10 || t >= 15 * A) e._tickround = "d";else if (t >= C && i <= 16 || t >= S) e._tickround = "M";else if (t >= O && i <= 19 || t >= C) e._tickround = "S";else {
                var o = e.l2r(r + t).replace(/^-/, "").length;
                e._tickround = Math.max(i, o) - 20, e._tickround < 0 && (e._tickround = 4);
              }
            } else if (a(t) || "L" === t.charAt(0)) {
              var l = e.range.map(e.r2d || Number);
              a(t) || (t = Number(t.substr(1))), e._tickround = 2 - Math.floor(Math.log(t) / Math.LN10 + .01);
              var s = Math.max(Math.abs(l[0]), Math.abs(l[1])),
                c = Math.floor(Math.log(s) / Math.LN10 + .01),
                u = void 0 === e.minexponent ? 3 : e.minexponent;
              Math.abs(c) > u && (be(e.exponentformat) && !_e(c) ? e._tickexponent = 3 * Math.round((c - 1) / 3) : e._tickexponent = c);
            } else e._tickround = null;
          }
          function ye(e, t, r) {
            var n = e.tickfont || {};
            return {
              x: t,
              dx: 0,
              dy: 0,
              text: r || "",
              fontSize: n.size,
              font: n.family,
              fontWeight: n.weight,
              fontStyle: n.style,
              fontVariant: n.variant,
              fontTextcase: n.textcase,
              fontLineposition: n.lineposition,
              fontShadow: n.shadow,
              fontColor: n.color
            };
          }
          G.autoTicks = function (e, t, r) {
            var n;
            function i(e) {
              return Math.pow(e, Math.floor(Math.log(t) / Math.LN10));
            }
            if ("date" === e.type) {
              e.tick0 = l.dateTick0(e.calendar, 0);
              var o = 2 * t;
              if (o > m) t /= m, n = i(10), e.dtick = "M" + 12 * ge(t, n, ce);else if (o > T) t /= T, e.dtick = "M" + ge(t, 1, ue);else if (o > A) {
                if (e.dtick = ge(t, A, e._hasDayOfWeekBreaks ? [1, 2, 7, 14] : de), !r) {
                  var s = G.getTickFormat(e),
                    c = "period" === e.ticklabelmode;
                  c && (e._rawTick0 = e.tick0), /%[uVW]/.test(s) ? e.tick0 = l.dateTick0(e.calendar, 2) : e.tick0 = l.dateTick0(e.calendar, 1), c && (e._dowTick0 = e.tick0);
                }
              } else o > S ? e.dtick = ge(t, S, ue) : o > C ? e.dtick = ge(t, C, fe) : o > O ? e.dtick = ge(t, O, fe) : (n = i(10), e.dtick = ge(t, n, ce));
            } else if ("log" === e.type) {
              e.tick0 = 0;
              var u = l.simpleMap(e.range, e.r2l);
              if (e._isMinor && (t *= 1.5), t > .7) e.dtick = Math.ceil(t);else if (Math.abs(u[1] - u[0]) < 1) {
                var f = 1.5 * Math.abs((u[1] - u[0]) / t);
                t = Math.abs(Math.pow(10, u[1]) - Math.pow(10, u[0])) / f, n = i(10), e.dtick = "L" + ge(t, n, ce);
              } else e.dtick = t > .3 ? "D2" : "D1";
            } else "category" === e.type || "multicategory" === e.type ? (e.tick0 = 0, e.dtick = Math.ceil(Math.max(t, 1))) : Re(e) ? (e.tick0 = 0, n = 1, e.dtick = ge(t, n, ve)) : (e.tick0 = 0, n = i(10), e.dtick = ge(t, n, ce));
            if (0 === e.dtick && (e.dtick = 1), !a(e.dtick) && "string" != typeof e.dtick) {
              var d = e.dtick;
              throw e.dtick = 1, "ax.dtick error: " + String(d);
            }
          }, G.tickIncrement = function (e, t, r, i) {
            var o = r ? -1 : 1;
            if (a(t)) return l.increment(e, o * t);
            var s = t.charAt(0),
              c = o * Number(t.substr(1));
            if ("M" === s) return l.incrementMonth(e, c, i);
            if ("L" === s) return Math.log(Math.pow(10, e) + c) / Math.LN10;
            if ("D" === s) {
              var u = "D2" === t ? pe : he,
                f = e + .01 * o,
                d = l.roundUp(l.mod(f, 1), u, r);
              return Math.floor(f) + Math.log(n.round(Math.pow(10, d), 1)) / Math.LN10;
            }
            throw "unrecognized dtick " + String(t);
          }, G.tickFirst = function (e, t) {
            var r = e.r2l || Number,
              i = l.simpleMap(e.range, r, void 0, void 0, t),
              o = i[1] < i[0],
              s = o ? Math.floor : Math.ceil,
              c = $(i)[0],
              u = e.dtick,
              f = r(e.tick0);
            if (a(u)) {
              var d = s((c - f) / u) * u + f;
              return "category" !== e.type && "multicategory" !== e.type || (d = l.constrain(d, 0, e._categories.length - 1)), d;
            }
            var h = u.charAt(0),
              p = Number(u.substr(1));
            if ("M" === h) {
              for (var v, g, m, y = 0, x = f; y < 10;) {
                if (((v = G.tickIncrement(x, u, o, e.calendar)) - c) * (x - c) <= 0) return o ? Math.min(x, v) : Math.max(x, v);
                g = (c - (x + v) / 2) / (v - x), m = h + (Math.abs(Math.round(g)) || 1) * p, x = G.tickIncrement(x, m, g < 0 ? !o : o, e.calendar), y++;
              }
              return l.error("tickFirst did not converge", e), x;
            }
            if ("L" === h) return Math.log(s((Math.pow(10, c) - f) / p) * p + f) / Math.LN10;
            if ("D" === h) {
              var b = "D2" === u ? pe : he,
                _ = l.roundUp(l.mod(c, 1), b, o);
              return Math.floor(c) + Math.log(n.round(Math.pow(10, _), 1)) / Math.LN10;
            }
            throw "unrecognized dtick " + String(u);
          }, G.tickText = function (e, t, r, n) {
            var i,
              o = ye(e, t),
              s = "array" === e.tickmode,
              c = r || s,
              u = e.type,
              f = "category" === u ? e.d2l_noadd : e.d2l,
              d = function (t) {
                var r = e.l2p(t);
                return r >= 0 && r <= e._length ? t : null;
              };
            if (s && l.isArrayOrTypedArray(e.ticktext)) {
              var h = l.simpleMap(e.range, e.r2l),
                p = (Math.abs(h[1] - h[0]) - (e._lBreaks || 0)) / 1e4;
              for (i = 0; i < e.ticktext.length && !(Math.abs(t - f(e.tickvals[i])) < p); i++);
              if (i < e.ticktext.length) return o.text = String(e.ticktext[i]), o.xbnd = [d(o.x - .5), d(o.x + e.dtick - .5)], o;
            }
            function v(n) {
              if (void 0 === n) return !0;
              if (r) return "none" === n;
              var a = {
                first: e._tmin,
                last: e._tmax
              }[n];
              return "all" !== n && t !== a;
            }
            var g = r ? "never" : "none" !== e.exponentformat && v(e.showexponent) ? "hide" : "";
            if ("date" === u ? function (e, t, r, n) {
              var i = e._tickround,
                o = r && e.hoverformat || G.getTickFormat(e);
              (n = !o && n) && (i = a(i) ? 4 : {
                y: "m",
                m: "d",
                d: "M",
                M: "S",
                S: 4
              }[i]);
              var s,
                c = l.formatDate(t.x, o, i, e._dateFormat, e.calendar, e._extraFormat),
                u = c.indexOf("\n");
              if (-1 !== u && (s = c.substr(u + 1), c = c.substr(0, u)), n && (void 0 === s || "00:00:00" !== c && "00:00" !== c ? 8 === c.length && (c = c.replace(/:00$/, "")) : (c = s, s = "")), s) if (r) "d" === i ? c += ", " + s : c = s + (c ? ", " + c : "");else if (e._inCalcTicks && e._prevDateHead === s) {
                var f = Fe(e),
                  d = e._trueSide || e.side;
                (!f && "top" === d || f && "bottom" === d) && (c += "<br> ");
              } else e._prevDateHead = s, c += "<br>" + s;
              t.text = c;
            }(e, o, r, c) : "log" === u ? function (e, t, r, n, i) {
              var o = e.dtick,
                s = t.x,
                c = e.tickformat,
                u = "string" == typeof o && o.charAt(0);
              if ("never" === i && (i = ""), n && "L" !== u && (o = "L3", u = "L"), c || "L" === u) t.text = we(Math.pow(10, s), e, i, n);else if (a(o) || "D" === u && l.mod(s + .01, 1) < .1) {
                var f = Math.round(s),
                  d = Math.abs(f),
                  h = e.exponentformat;
                "power" === h || be(h) && _e(f) ? (t.text = 0 === f ? 1 : 1 === f ? "10" : "10<sup>" + (f > 1 ? "" : z) + d + "</sup>", t.fontSize *= 1.25) : ("e" === h || "E" === h) && d > 2 ? t.text = "1" + h + (f > 0 ? "+" : z) + d : (t.text = we(Math.pow(10, s), e, "", "fakehover"), "D1" === o && "y" === e._id.charAt(0) && (t.dy -= t.fontSize / 6));
              } else {
                if ("D" !== u) throw "unrecognized dtick " + String(o);
                t.text = String(Math.round(Math.pow(10, l.mod(s, 1)))), t.fontSize *= .75;
              }
              if ("D1" === e.dtick) {
                var p = String(t.text).charAt(0);
                "0" !== p && "1" !== p || ("y" === e._id.charAt(0) ? t.dx -= t.fontSize / 4 : (t.dy += t.fontSize / 2, t.dx += (e.range[1] > e.range[0] ? 1 : -1) * t.fontSize * (s < 0 ? .5 : .25)));
              }
            }(e, o, 0, c, g) : "category" === u ? function (e, t) {
              var r = e._categories[Math.round(t.x)];
              void 0 === r && (r = ""), t.text = String(r);
            }(e, o) : "multicategory" === u ? function (e, t, r) {
              var n = Math.round(t.x),
                a = e._categories[n] || [],
                i = void 0 === a[1] ? "" : String(a[1]),
                o = void 0 === a[0] ? "" : String(a[0]);
              r ? t.text = o + " - " + i : (t.text = i, t.text2 = o);
            }(e, o, r) : Re(e) ? function (e, t, r, n, a) {
              if ("radians" !== e.thetaunit || r) t.text = we(t.x, e, a, n);else {
                var i = t.x / 180;
                if (0 === i) t.text = "0";else {
                  var o = function (e) {
                    function t(e, t) {
                      return Math.abs(e - t) <= 1e-6;
                    }
                    var r = function (e) {
                        for (var r = 1; !t(Math.round(e * r) / r, e);) r *= 10;
                        return r;
                      }(e),
                      n = e * r,
                      a = Math.abs(function e(r, n) {
                        return t(n, 0) ? r : e(n, r % n);
                      }(n, r));
                    return [Math.round(n / a), Math.round(r / a)];
                  }(i);
                  if (o[1] >= 100) t.text = we(l.deg2rad(t.x), e, a, n);else {
                    var s = t.x < 0;
                    1 === o[1] ? 1 === o[0] ? t.text = "π" : t.text = o[0] + "π" : t.text = ["<sup>", o[0], "</sup>", "⁄", "<sub>", o[1], "</sub>", "π"].join(""), s && (t.text = z + t.text);
                  }
                }
              }
            }(e, o, r, c, g) : function (e, t, r, n, a) {
              "never" === a ? a = "" : "all" === e.showexponent && Math.abs(t.x / e.dtick) < 1e-6 && (a = "hide"), t.text = we(t.x, e, a, n);
            }(e, o, 0, c, g), n || (e.tickprefix && !v(e.showtickprefix) && (o.text = e.tickprefix + o.text), e.ticksuffix && !v(e.showticksuffix) && (o.text += e.ticksuffix)), e.labelalias && e.labelalias.hasOwnProperty(o.text)) {
              var m = e.labelalias[o.text];
              "string" == typeof m && (o.text = m);
            }
            return ("boundaries" === e.tickson || e.showdividers) && (o.xbnd = [d(o.x - .5), d(o.x + e.dtick - .5)]), o;
          }, G.hoverLabelText = function (e, t, r) {
            r && (e = l.extendFlat({}, e, {
              hoverformat: r
            }));
            var n = l.isArrayOrTypedArray(t) ? t[0] : t,
              a = l.isArrayOrTypedArray(t) ? t[1] : void 0;
            if (void 0 !== a && a !== n) return G.hoverLabelText(e, n, r) + " - " + G.hoverLabelText(e, a, r);
            var i = "log" === e.type && n <= 0,
              o = G.tickText(e, e.c2l(i ? -n : n), "hover").text;
            return i ? 0 === n ? "0" : z + o : o;
          };
          var xe = ["f", "p", "n", "μ", "m", "", "k", "M", "G", "T"];
          function be(e) {
            return "SI" === e || "B" === e;
          }
          function _e(e) {
            return e > 14 || e < -15;
          }
          function we(e, t, r, n) {
            var i = e < 0,
              o = t._tickround,
              s = r || t.exponentformat || "B",
              c = t._tickexponent,
              u = G.getTickFormat(t),
              f = t.separatethousands;
            if (n) {
              var d = {
                exponentformat: s,
                minexponent: t.minexponent,
                dtick: "none" === t.showexponent ? t.dtick : a(e) && Math.abs(e) || 1,
                range: "none" === t.showexponent ? t.range.map(t.r2d) : [0, e || 1]
              };
              me(d), o = (Number(d._tickround) || 0) + 4, c = d._tickexponent, t.hoverformat && (u = t.hoverformat);
            }
            if (u) return t._numFormat(u)(e).replace(/-/g, z);
            var h,
              p = Math.pow(10, -o) / 2;
            if ("none" === s && (c = 0), (e = Math.abs(e)) < p) e = "0", i = !1;else {
              if (e += p, c && (e *= Math.pow(10, -c), o += c), 0 === o) e = String(Math.floor(e));else if (o < 0) {
                e = (e = String(Math.round(e))).substr(0, e.length + o);
                for (var v = o; v < 0; v++) e += "0";
              } else {
                var g = (e = String(e)).indexOf(".") + 1;
                g && (e = e.substr(0, g + o).replace(/\.?0+$/, ""));
              }
              e = l.numSeparate(e, t._separators, f);
            }
            return c && "hide" !== s && (be(s) && _e(c) && (s = "power"), h = c < 0 ? z + -c : "power" !== s ? "+" + c : String(c), "e" === s || "E" === s ? e += s + h : "power" === s ? e += "×10<sup>" + h + "</sup>" : "B" === s && 9 === c ? e += "B" : be(s) && (e += xe[c / 3 + 5])), i ? z + e : e;
          }
          function Te(e, t) {
            if (e) {
              var r = Object.keys(B).reduce(function (e, r) {
                return -1 !== t.indexOf(r) && B[r].forEach(function (t) {
                  e[t] = 1;
                }), e;
              }, {});
              Object.keys(e).forEach(function (t) {
                r[t] || (1 === t.length ? e[t] = 0 : delete e[t]);
              });
            }
          }
          function Me(e, t) {
            for (var r = [], n = {}, a = 0; a < t.length; a++) {
              var i = t[a];
              n[i.text2] ? n[i.text2].push(i.x) : n[i.text2] = [i.x];
            }
            for (var o in n) r.push(ye(e, l.interp(n[o], .5), o));
            return r;
          }
          function ke(e) {
            return void 0 !== e.periodX ? e.periodX : e.x;
          }
          function Ae(e) {
            return [e.text, e.x, e.axInfo, e.font, e.fontSize, e.fontColor].join("_");
          }
          function Le(e) {
            var t = e.title.font.size,
              r = (e.title.text.match(c.BR_TAG_ALL) || []).length;
            return e.title.hasOwnProperty("standoff") ? t * (V + r * U) : r ? t * (r + 1) * U : t;
          }
          function Se(e, t) {
            var r = e.l2p(t);
            return r > 1 && r < e._length - 1;
          }
          function Ce(e) {
            var t = n.select(e),
              r = t.select(".text-math-group");
            return r.empty() ? t.select("text") : r;
          }
          function Oe(e) {
            return e._id + ".automargin";
          }
          function De(e) {
            return Oe(e) + ".mirror";
          }
          function Pe(e) {
            return e._id + ".rangeslider";
          }
          function ze(e, t) {
            for (var r = 0; r < t.length; r++) -1 === e.indexOf(t[r]) && e.push(t[r]);
          }
          function Ie(e, t, r) {
            var n,
              a,
              i = [],
              o = [],
              s = e.layout;
            for (n = 0; n < t.length; n++) i.push(G.getFromId(e, t[n]));
            for (n = 0; n < r.length; n++) o.push(G.getFromId(e, r[n]));
            var c = Object.keys(h),
              u = ["anchor", "domain", "overlaying", "position", "side", "tickangle", "editType"],
              f = ["linear", "log"];
            for (n = 0; n < c.length; n++) {
              var d = c[n],
                p = i[0][d],
                v = o[0][d],
                g = !0,
                m = !1,
                y = !1;
              if ("_" !== d.charAt(0) && "function" != typeof p && -1 === u.indexOf(d)) {
                for (a = 1; a < i.length && g; a++) {
                  var x = i[a][d];
                  "type" === d && -1 !== f.indexOf(p) && -1 !== f.indexOf(x) && p !== x ? m = !0 : x !== p && (g = !1);
                }
                for (a = 1; a < o.length && g; a++) {
                  var b = o[a][d];
                  "type" === d && -1 !== f.indexOf(v) && -1 !== f.indexOf(b) && v !== b ? y = !0 : o[a][d] !== v && (g = !1);
                }
                g && (m && (s[i[0]._name].type = "linear"), y && (s[o[0]._name].type = "linear"), Ee(s, d, i, o, e._fullLayout._dfltTitle));
              }
            }
            for (n = 0; n < e._fullLayout.annotations.length; n++) {
              var _ = e._fullLayout.annotations[n];
              -1 !== t.indexOf(_.xref) && -1 !== r.indexOf(_.yref) && l.swapAttrs(s.annotations[n], ["?"]);
            }
          }
          function Ee(e, t, r, n, a) {
            var i,
              o = l.nestedProperty,
              s = o(e[r[0]._name], t).get(),
              c = o(e[n[0]._name], t).get();
            for ("title" === t && (s && s.text === a.x && (s.text = a.y), c && c.text === a.y && (c.text = a.x)), i = 0; i < r.length; i++) o(e, r[i]._name + "." + t).set(c);
            for (i = 0; i < n.length; i++) o(e, n[i]._name + "." + t).set(s);
          }
          function Re(e) {
            return "angularaxis" === e._id;
          }
          function Ne(e, t) {
            for (var r = t._rangebreaks.length, n = 0; n < r; n++) {
              var a = t._rangebreaks[n];
              if (e >= a.min && e < a.max) return a.max;
            }
            return e;
          }
          function Fe(e) {
            return -1 !== (e.ticklabelposition || "").indexOf("inside");
          }
          function He(e, t) {
            Fe(e._anchorAxis || {}) && e._hideCounterAxisInsideTickLabels && e._hideCounterAxisInsideTickLabels(t);
          }
          function Be(e, t, r, n) {
            var a,
              i = "free" === e.anchor || void 0 !== e.overlaying && !1 !== e.overlaying ? e.overlaying : e._id;
            a = n ? "right" === e.side ? t : -t : t, i in r || (r[i] = {}), e.side in r[i] || (r[i][e.side] = 0), r[i][e.side] += a;
          }
          G.getTickFormat = function (e) {
            var t, r, n, a, i, o, l, s;
            function c(e) {
              return "string" != typeof e ? e : Number(e.replace("M", "")) * T;
            }
            function u(e, t) {
              var r = ["L", "D"];
              if (typeof e == typeof t) {
                if ("number" == typeof e) return e - t;
                var n = r.indexOf(e.charAt(0)),
                  a = r.indexOf(t.charAt(0));
                return n === a ? Number(e.replace(/(L|D)/g, "")) - Number(t.replace(/(L|D)/g, "")) : n - a;
              }
              return "number" == typeof e ? 1 : -1;
            }
            function f(e, t) {
              var r = null === t[0],
                n = null === t[1],
                a = u(e, t[0]) >= 0,
                i = u(e, t[1]) <= 0;
              return (r || a) && (n || i);
            }
            if (e.tickformatstops && e.tickformatstops.length > 0) switch (e.type) {
              case "date":
              case "linear":
                for (t = 0; t < e.tickformatstops.length; t++) if ((n = e.tickformatstops[t]).enabled && (a = e.dtick, o = void 0, void 0, void 0, o = c || function (e) {
                  return e;
                }, l = (i = n.dtickrange)[0], s = i[1], (!l && "number" != typeof l || o(l) <= o(a)) && (!s && "number" != typeof s || o(s) >= o(a)))) {
                  r = n;
                  break;
                }
                break;
              case "log":
                for (t = 0; t < e.tickformatstops.length; t++) if ((n = e.tickformatstops[t]).enabled && f(e.dtick, n.dtickrange)) {
                  r = n;
                  break;
                }
            }
            return r ? r.value : e.tickformat;
          }, G.getSubplots = function (e, t) {
            var r = e._fullLayout._subplots,
              n = r.cartesian.concat(r.gl2d || []),
              a = t ? G.findSubplotsWithAxis(n, t) : n;
            return a.sort(function (e, t) {
              var r = e.substr(1).split("y"),
                n = t.substr(1).split("y");
              return r[0] === n[0] ? +r[1] - +n[1] : +r[0] - +n[0];
            }), a;
          }, G.findSubplotsWithAxis = function (e, t) {
            for (var r = new RegExp("x" === t._id.charAt(0) ? "^" + t._id + "y" : t._id + "$"), n = [], a = 0; a < e.length; a++) {
              var i = e[a];
              r.test(i) && n.push(i);
            }
            return n;
          }, G.makeClipPaths = function (e) {
            var t = e._fullLayout;
            if (!t._hasOnlyLargeSploms) {
              var r,
                a,
                i = {
                  _offset: 0,
                  _length: t.width,
                  _id: ""
                },
                o = {
                  _offset: 0,
                  _length: t.height,
                  _id: ""
                },
                l = G.list(e, "x", !0),
                s = G.list(e, "y", !0),
                c = [];
              for (r = 0; r < l.length; r++) for (c.push({
                x: l[r],
                y: o
              }), a = 0; a < s.length; a++) 0 === r && c.push({
                x: i,
                y: s[a]
              }), c.push({
                x: l[r],
                y: s[a]
              });
              var u = t._clips.selectAll(".axesclip").data(c, function (e) {
                return e.x._id + e.y._id;
              });
              u.enter().append("clipPath").classed("axesclip", !0).attr("id", function (e) {
                return "clip" + t._uid + e.x._id + e.y._id;
              }).append("rect"), u.exit().remove(), u.each(function (e) {
                n.select(this).select("rect").attr({
                  x: e.x._offset || 0,
                  y: e.y._offset || 0,
                  width: e.x._length || 1,
                  height: e.y._length || 1
                });
              });
            }
          }, G.draw = function (e, t, r) {
            var n = e._fullLayout;
            "redraw" === t && n._paper.selectAll("g.subplot").each(function (e) {
              var t = e[0],
                r = n._plots[t];
              if (r) {
                var a = r.xaxis,
                  i = r.yaxis;
                r.xaxislayer.selectAll("." + a._id + "tick").remove(), r.yaxislayer.selectAll("." + i._id + "tick").remove(), r.xaxislayer.selectAll("." + a._id + "tick2").remove(), r.yaxislayer.selectAll("." + i._id + "tick2").remove(), r.xaxislayer.selectAll("." + a._id + "divider").remove(), r.yaxislayer.selectAll("." + i._id + "divider").remove(), r.minorGridlayer && r.minorGridlayer.selectAll("path").remove(), r.gridlayer && r.gridlayer.selectAll("path").remove(), r.zerolinelayer && r.zerolinelayer.selectAll("path").remove(), n._infolayer.select(".g-" + a._id + "title").remove(), n._infolayer.select(".g-" + i._id + "title").remove();
              }
            });
            var a = t && "redraw" !== t ? t : G.listIds(e),
              i = G.list(e).filter(function (e) {
                return e.autoshift;
              }).map(function (e) {
                return e.overlaying;
              });
            a.map(function (t) {
              var r = G.getFromId(e, t);
              if ("sync" === r.tickmode && r.overlaying) {
                var n = a.findIndex(function (e) {
                  return e === r.overlaying;
                });
                n >= 0 && a.unshift(a.splice(n, 1).shift());
              }
            });
            var o = {
              false: {
                left: 0,
                right: 0
              }
            };
            return l.syncOrAsync(a.map(function (t) {
              return function () {
                if (t) {
                  var n = G.getFromId(e, t);
                  r || (r = {}), r.axShifts = o, r.overlayingShiftedAx = i;
                  var a = G.drawOne(e, n, r);
                  return n._shiftPusher && Be(n, n._fullDepth || 0, o, !0), n._r = n.range.slice(), n._rl = l.simpleMap(n._r, n.r2l), a;
                }
              };
            }));
          }, G.drawOne = function (e, t, r) {
            var n,
              a,
              s,
              h = (r = r || {}).axShifts || {},
              p = r.overlayingShiftedAx || [];
            t.setScale();
            var v = e._fullLayout,
              g = t._id,
              m = g.charAt(0),
              y = G.counterLetter(g),
              x = v._plots[t._mainSubplot];
            if (x) {
              if (t._shiftPusher = t.autoshift || -1 !== p.indexOf(t._id) || -1 !== p.indexOf(t.overlaying), t._shiftPusher & "free" === t.anchor) {
                var b = t.linewidth / 2 || 0;
                "inside" === t.ticks && (b += t.ticklen), Be(t, b, h, !0), Be(t, t.shift || 0, h, !1);
              }
              !0 === r.skipTitle && void 0 !== t._shift || (t._shift = function (e, t) {
                return e.autoshift ? t[e.overlaying][e.side] : e.shift || 0;
              }(t, h));
              var _ = x[m + "axislayer"],
                w = t._mainLinePosition,
                T = w += t._shift,
                M = t._mainMirrorPosition,
                k = t._vals = G.calcTicks(t),
                A = [t.mirror, T, M].join("_");
              for (n = 0; n < k.length; n++) k[n].axInfo = A;
              t._selections = {}, t._tickAngles && (t._prevTickAngles = t._tickAngles), t._tickAngles = {}, t._depth = null;
              var L = {};
              if (t.visible) {
                var S,
                  C,
                  O = G.makeTransTickFn(t),
                  D = G.makeTransTickLabelFn(t),
                  P = "inside" === t.ticks,
                  z = "outside" === t.ticks;
                if ("boundaries" === t.tickson) {
                  var I = function (e, t) {
                    var r,
                      n = [],
                      a = function (e, t) {
                        var r = e.xbnd[t];
                        null !== r && n.push(l.extendFlat({}, e, {
                          x: r
                        }));
                      };
                    if (t.length) {
                      for (r = 0; r < t.length; r++) a(t[r], 0);
                      a(t[r - 1], 1);
                    }
                    return n;
                  }(0, k);
                  C = G.clipEnds(t, I), S = P ? C : I;
                } else C = G.clipEnds(t, k), S = P && "period" !== t.ticklabelmode ? C : k;
                var E,
                  R = t._gridVals = C,
                  N = function (e, t) {
                    var r,
                      n,
                      a = [],
                      i = t.length && t[t.length - 1].x < t[0].x,
                      o = function (e, t) {
                        var r = e.xbnd[t];
                        null !== r && a.push(l.extendFlat({}, e, {
                          x: r
                        }));
                      };
                    if (e.showdividers && t.length) {
                      for (r = 0; r < t.length; r++) {
                        var s = t[r];
                        s.text2 !== n && o(s, i ? 1 : 0), n = s.text2;
                      }
                      o(t[r - 1], i ? 0 : 1);
                    }
                    return a;
                  }(t, k);
                if (!v._hasOnlyLargeSploms) {
                  var F = t._subplotsWith,
                    H = {};
                  for (n = 0; n < F.length; n++) {
                    a = F[n];
                    var B = (s = v._plots[a])[y + "axis"],
                      j = B._mainAxis._id;
                    if (!H[j]) {
                      H[j] = 1;
                      var Z = "x" === m ? "M0," + B._offset + "v" + B._length : "M" + B._offset + ",0h" + B._length;
                      G.drawGrid(e, t, {
                        vals: R,
                        counterAxis: B,
                        layer: s.gridlayer.select("." + g),
                        minorLayer: s.minorGridlayer.select("." + g),
                        path: Z,
                        transFn: O
                      }), G.drawZeroLine(e, t, {
                        counterAxis: B,
                        layer: s.zerolinelayer,
                        path: Z,
                        transFn: O
                      });
                    }
                  }
                }
                var W = G.getTickSigns(t),
                  J = G.getTickSigns(t, "minor");
                if (t.ticks || t.minor && t.minor.ticks) {
                  var X,
                    K,
                    Q,
                    $,
                    ee = G.makeTickPath(t, T, W[2]),
                    te = G.makeTickPath(t, T, J[2], {
                      minor: !0
                    });
                  if (t._anchorAxis && t.mirror && !0 !== t.mirror ? (X = G.makeTickPath(t, M, W[3]), K = G.makeTickPath(t, M, J[3], {
                    minor: !0
                  }), Q = ee + X, $ = te + K) : (X = "", K = "", Q = ee, $ = te), t.showdividers && z && "boundaries" === t.tickson) {
                    var re = {};
                    for (n = 0; n < N.length; n++) re[N[n].x] = 1;
                    E = function (e) {
                      return re[e.x] ? X : Q;
                    };
                  } else E = function (e) {
                    return e.minor ? $ : Q;
                  };
                }
                if (G.drawTicks(e, t, {
                  vals: S,
                  layer: _,
                  path: E,
                  transFn: O
                }), "allticks" === t.mirror) {
                  var ne = Object.keys(t._linepositions || {});
                  for (n = 0; n < ne.length; n++) {
                    a = ne[n], s = v._plots[a];
                    var ae = t._linepositions[a] || [],
                      ie = ae[0],
                      oe = ae[1],
                      le = ae[2],
                      se = G.makeTickPath(t, ie, le ? W[0] : J[0], {
                        minor: le
                      }) + G.makeTickPath(t, oe, le ? W[1] : J[1], {
                        minor: le
                      });
                    G.drawTicks(e, t, {
                      vals: S,
                      layer: s[m + "axislayer"],
                      path: se,
                      transFn: O
                    });
                  }
                }
                var ce = [];
                if (ce.push(function () {
                  return G.drawLabels(e, t, {
                    vals: k,
                    layer: _,
                    plotinfo: s,
                    transFn: D,
                    labelFns: G.makeLabelFns(t, T)
                  });
                }), "multicategory" === t.type) {
                  var ue = {
                    x: 2,
                    y: 10
                  }[m];
                  ce.push(function () {
                    var r = {
                        x: "height",
                        y: "width"
                      }[m],
                      n = de()[r] + ue + (t._tickAngles[g + "tick"] ? t.tickfont.size * U : 0);
                    return G.drawLabels(e, t, {
                      vals: Me(t, k),
                      layer: _,
                      cls: g + "tick2",
                      repositionOnUpdate: !0,
                      secondary: !0,
                      transFn: O,
                      labelFns: G.makeLabelFns(t, T + n * W[4])
                    });
                  }), ce.push(function () {
                    return t._depth = W[4] * (de("tick2")[t.side] - T), function (e, t, r) {
                      var n = t._id + "divider",
                        a = r.vals,
                        i = r.layer.selectAll("path." + n).data(a, Ae);
                      i.exit().remove(), i.enter().insert("path", ":first-child").classed(n, 1).classed("crisp", 1).call(f.stroke, t.dividercolor).style("stroke-width", d.crispRound(e, t.dividerwidth, 1) + "px"), i.attr("transform", r.transFn).attr("d", r.path);
                    }(e, t, {
                      vals: N,
                      layer: _,
                      path: G.makeTickPath(t, T, W[4], {
                        len: t._depth
                      }),
                      transFn: O
                    });
                  });
                } else t.title.hasOwnProperty("standoff") && ce.push(function () {
                  t._depth = W[4] * (de()[t.side] - T);
                });
                var fe = o.getComponentMethod("rangeslider", "isVisible")(t);
                return r.skipTitle || fe && "bottom" === t.side || ce.push(function () {
                  return function (e, t) {
                    var r,
                      n = e._fullLayout,
                      a = t._id,
                      i = a.charAt(0),
                      o = t.title.font.size,
                      l = (t.title.text.match(c.BR_TAG_ALL) || []).length;
                    if (t.title.hasOwnProperty("standoff")) "bottom" === t.side || "right" === t.side ? r = t._depth + t.title.standoff + o * V : "top" !== t.side && "left" !== t.side || (r = t._depth + t.title.standoff + o * (Y + l * U));else {
                      var s = Fe(t);
                      if ("multicategory" === t.type) r = t._depth;else {
                        var f = 1.5 * o;
                        s && (f = .5 * o, "outside" === t.ticks && (f += t.ticklen)), r = 10 + f + (t.linewidth ? t.linewidth - 1 : 0);
                      }
                      s || (r += "x" === i ? "top" === t.side ? o * (t.showticklabels ? 1 : 0) : o * (t.showticklabels ? 1.5 : .5) : "right" === t.side ? o * (t.showticklabels ? 1 : .5) : o * (t.showticklabels ? .5 : 0));
                    }
                    var h,
                      p,
                      v,
                      g,
                      m = G.getPxPosition(e, t);
                    if ("x" === i ? (p = t._offset + t._length / 2, v = "top" === t.side ? m - r : m + r) : (v = t._offset + t._length / 2, p = "right" === t.side ? m + r : m - r, h = {
                      rotate: "-90",
                      offset: 0
                    }), "multicategory" !== t.type) {
                      var y = t._selections[t._id + "tick"];
                      if (g = {
                        selection: y,
                        side: t.side
                      }, y && y.node() && y.node().parentNode) {
                        var x = d.getTranslate(y.node().parentNode);
                        g.offsetLeft = x.x, g.offsetTop = x.y;
                      }
                      t.title.hasOwnProperty("standoff") && (g.pad = 0);
                    }
                    return t._titleStandoff = r, u.draw(e, a + "title", {
                      propContainer: t,
                      propName: t._name + ".title.text",
                      placeholder: n._dfltTitle[i],
                      avoid: g,
                      transform: h,
                      attributes: {
                        x: p,
                        y: v,
                        "text-anchor": "middle"
                      }
                    });
                  }(e, t);
                }), ce.push(function () {
                  var r,
                    n,
                    a,
                    l,
                    s = t.side.charAt(0),
                    c = q[t.side].charAt(0),
                    u = G.getPxPosition(e, t),
                    f = z ? t.ticklen : 0;
                  (t.automargin || fe || t._shiftPusher) && ("multicategory" === t.type ? r = de("tick2") : (r = de(), "x" === m && "b" === s && (t._depth = Math.max(r.width > 0 ? r.bottom - u : 0, f))));
                  var d = 0,
                    h = 0;
                  if (t._shiftPusher && (d = Math.max(f, r.height > 0 ? "l" === s ? u - r.left : r.right - u : 0), t.title.text !== v._dfltTitle[m] && (h = (t._titleStandoff || 0) + (t._titleScoot || 0), "l" === s && (h += Le(t))), t._fullDepth = Math.max(d, h)), t.automargin) {
                    n = {
                      x: 0,
                      y: 0,
                      r: 0,
                      l: 0,
                      t: 0,
                      b: 0
                    };
                    var p = [0, 1],
                      g = "number" == typeof t._shift ? t._shift : 0;
                    if ("x" === m) {
                      if ("b" === s ? n[s] = t._depth : (n[s] = t._depth = Math.max(r.width > 0 ? u - r.top : 0, f), p.reverse()), r.width > 0) {
                        var x = r.right - (t._offset + t._length);
                        x > 0 && (n.xr = 1, n.r = x);
                        var b = t._offset - r.left;
                        b > 0 && (n.xl = 0, n.l = b);
                      }
                    } else if ("l" === s ? (t._depth = Math.max(r.height > 0 ? u - r.left : 0, f), n[s] = t._depth - g) : (t._depth = Math.max(r.height > 0 ? r.right - u : 0, f), n[s] = t._depth + g, p.reverse()), r.height > 0) {
                      var _ = r.bottom - (t._offset + t._length);
                      _ > 0 && (n.yb = 0, n.b = _);
                      var w = t._offset - r.top;
                      w > 0 && (n.yt = 1, n.t = w);
                    }
                    n[y] = "free" === t.anchor ? t.position : t._anchorAxis.domain[p[0]], t.title.text !== v._dfltTitle[m] && (n[s] += Le(t) + (t.title.standoff || 0)), t.mirror && "free" !== t.anchor && ((a = {
                      x: 0,
                      y: 0,
                      r: 0,
                      l: 0,
                      t: 0,
                      b: 0
                    })[c] = t.linewidth, t.mirror && !0 !== t.mirror && (a[c] += f), !0 === t.mirror || "ticks" === t.mirror ? a[y] = t._anchorAxis.domain[p[1]] : "all" !== t.mirror && "allticks" !== t.mirror || (a[y] = [t._counterDomainMin, t._counterDomainMax][p[1]]));
                  }
                  fe && (l = o.getComponentMethod("rangeslider", "autoMarginOpts")(e, t)), "string" == typeof t.automargin && (Te(n, t.automargin), Te(a, t.automargin)), i.autoMargin(e, Oe(t), n), i.autoMargin(e, De(t), a), i.autoMargin(e, Pe(t), l);
                }), l.syncOrAsync(ce);
              }
            }
            function de(e) {
              var r = g + (e || "tick");
              return L[r] || (L[r] = function (e, t, r) {
                var n, a, i, o;
                if (e._selections[t].size()) n = 1 / 0, a = -1 / 0, i = 1 / 0, o = -1 / 0, e._selections[t].each(function () {
                  var e = Ce(this),
                    t = d.bBox(e.node().parentNode);
                  n = Math.min(n, t.top), a = Math.max(a, t.bottom), i = Math.min(i, t.left), o = Math.max(o, t.right);
                });else {
                  var l = G.makeLabelFns(e, r);
                  n = a = l.yFn({
                    dx: 0,
                    dy: 0,
                    fontSize: 0
                  }), i = o = l.xFn({
                    dx: 0,
                    dy: 0,
                    fontSize: 0
                  });
                }
                return {
                  top: n,
                  bottom: a,
                  left: i,
                  right: o,
                  height: a - n,
                  width: o - i
                };
              }(t, r, T)), L[r];
            }
          }, G.getTickSigns = function (e, t) {
            var r = e._id.charAt(0),
              n = {
                x: "top",
                y: "right"
              }[r],
              a = e.side === n ? 1 : -1,
              i = [-1, 1, a, -a];
            return "inside" !== (t ? (e.minor || {}).ticks : e.ticks) == ("x" === r) && (i = i.map(function (e) {
              return -e;
            })), e.side && i.push({
              l: -1,
              t: -1,
              r: 1,
              b: 1
            }[e.side.charAt(0)]), i;
          }, G.makeTransTickFn = function (e) {
            return "x" === e._id.charAt(0) ? function (t) {
              return s(e._offset + e.l2p(t.x), 0);
            } : function (t) {
              return s(0, e._offset + e.l2p(t.x));
            };
          }, G.makeTransTickLabelFn = function (e) {
            var t = function (e) {
                var t = e.ticklabelposition || "",
                  r = function (e) {
                    return -1 !== t.indexOf(e);
                  },
                  n = r("top"),
                  a = r("left"),
                  i = r("right"),
                  o = r("bottom"),
                  l = r("inside"),
                  s = o || a || n || i;
                if (!s && !l) return [0, 0];
                var c = e.side,
                  u = s ? (e.tickwidth || 0) / 2 : 0,
                  f = 3,
                  d = e.tickfont ? e.tickfont.size : 12;
                return (o || n) && (u += d * V, f += (e.linewidth || 0) / 2), (a || i) && (u += (e.linewidth || 0) / 2, f += 3), l && "top" === c && (f -= d * (1 - V)), (a || n) && (u = -u), "bottom" !== c && "right" !== c || (f = -f), [s ? u : 0, l ? f : 0];
              }(e),
              r = e.ticklabelshift || 0,
              n = e.ticklabelstandoff || 0,
              a = t[0],
              i = t[1],
              o = e.range[0] > e.range[1],
              l = e.ticklabelposition && -1 !== e.ticklabelposition.indexOf("inside"),
              c = !l;
            if (r && (r *= o ? -1 : 1), n) {
              var u = e.side;
              n *= l && ("top" === u || "left" === u) || c && ("bottom" === u || "right" === u) ? 1 : -1;
            }
            return "x" === e._id.charAt(0) ? function (t) {
              return s(a + e._offset + e.l2p(ke(t)) + r, i + n);
            } : function (t) {
              return s(i + n, a + e._offset + e.l2p(ke(t)) + r);
            };
          }, G.makeTickPath = function (e, t, r, n) {
            n || (n = {});
            var a = n.minor;
            if (a && !e.minor) return "";
            var i = void 0 !== n.len ? n.len : a ? e.minor.ticklen : e.ticklen,
              o = e._id.charAt(0),
              l = (e.linewidth || 1) / 2;
            return "x" === o ? "M0," + (t + l * r) + "v" + i * r : "M" + (t + l * r) + ",0h" + i * r;
          }, G.makeLabelFns = function (e, t, r) {
            var n = e.ticklabelposition || "",
              i = function (e) {
                return -1 !== n.indexOf(e);
              },
              o = i("top"),
              s = i("left"),
              c = i("right"),
              u = i("bottom") || s || o || c,
              f = i("inside"),
              d = "inside" === n && "inside" === e.ticks || !f && "outside" === e.ticks && "boundaries" !== e.tickson,
              h = 0,
              p = 0,
              v = d ? e.ticklen : 0;
            if (f ? v *= -1 : u && (v = 0), d && (h += v, r)) {
              var g = l.deg2rad(r);
              h = v * Math.cos(g) + 1, p = v * Math.sin(g);
            }
            e.showticklabels && (d || e.showline) && (h += .2 * e.tickfont.size);
            var m,
              y,
              x,
              b,
              _,
              w = {
                labelStandoff: h += (e.linewidth || 1) / 2 * (f ? -1 : 1),
                labelShift: p
              },
              T = 0,
              M = e.side,
              k = e._id.charAt(0),
              A = e.tickangle;
            if ("x" === k) b = (_ = !f && "bottom" === M || f && "top" === M) ? 1 : -1, f && (b *= -1), m = p * b, y = t + h * b, x = _ ? 1 : -.2, 90 === Math.abs(A) && (f ? x += Y : x = -90 === A && "bottom" === M ? V : 90 === A && "top" === M ? Y : .5, T = Y / 2 * (A / 90)), w.xFn = function (e) {
              return e.dx + m + T * e.fontSize;
            }, w.yFn = function (e) {
              return e.dy + y + e.fontSize * x;
            }, w.anchorFn = function (e, t) {
              if (u) {
                if (s) return "end";
                if (c) return "start";
              }
              return a(t) && 0 !== t && 180 !== t ? t * b < 0 !== f ? "end" : "start" : "middle";
            }, w.heightFn = function (t, r, n) {
              return r < -60 || r > 60 ? -.5 * n : "top" === e.side !== f ? -n : 0;
            };else if ("y" === k) {
              if (b = (_ = !f && "left" === M || f && "right" === M) ? 1 : -1, f && (b *= -1), m = h, y = p * b, x = 0, f || 90 !== Math.abs(A) || (x = -90 === A && "left" === M || 90 === A && "right" === M ? V : .5), f) {
                var L = a(A) ? +A : 0;
                if (0 !== L) {
                  var S = l.deg2rad(L);
                  T = Math.abs(Math.sin(S)) * V * b, x = 0;
                }
              }
              w.xFn = function (e) {
                return e.dx + t - (m + e.fontSize * x) * b + T * e.fontSize;
              }, w.yFn = function (e) {
                return e.dy + y + e.fontSize * Y;
              }, w.anchorFn = function (e, t) {
                return a(t) && 90 === Math.abs(t) ? "middle" : _ ? "end" : "start";
              }, w.heightFn = function (t, r, n) {
                return "right" === e.side && (r *= -1), r < -30 ? -n : r < 30 ? -.5 * n : 0;
              };
            }
            return w;
          }, G.drawTicks = function (e, t, r) {
            r = r || {};
            var a = t._id + "tick",
              i = [].concat(t.minor && t.minor.ticks ? r.vals.filter(function (e) {
                return e.minor && !e.noTick;
              }) : []).concat(t.ticks ? r.vals.filter(function (e) {
                return !e.minor && !e.noTick;
              }) : []),
              o = r.layer.selectAll("path." + a).data(i, Ae);
            o.exit().remove(), o.enter().append("path").classed(a, 1).classed("ticks", 1).classed("crisp", !1 !== r.crisp).each(function (e) {
              return f.stroke(n.select(this), e.minor ? t.minor.tickcolor : t.tickcolor);
            }).style("stroke-width", function (r) {
              return d.crispRound(e, r.minor ? t.minor.tickwidth : t.tickwidth, 1) + "px";
            }).attr("d", r.path).style("display", null), He(t, [F]), o.attr("transform", r.transFn);
          }, G.drawGrid = function (e, t, r) {
            if (r = r || {}, "sync" !== t.tickmode) {
              var a = t._id + "grid",
                i = t.minor && t.minor.showgrid,
                o = i ? r.vals.filter(function (e) {
                  return e.minor;
                }) : [],
                l = t.showgrid ? r.vals.filter(function (e) {
                  return !e.minor;
                }) : [],
                s = r.counterAxis;
              if (s && G.shouldShowZeroLine(e, t, s)) for (var c = "array" === t.tickmode, u = 0; u < l.length; u++) {
                var h = l[u].x;
                if (c ? !h : Math.abs(h) < t.dtick / 100) {
                  if (l = l.slice(0, u).concat(l.slice(u + 1)), !c) break;
                  u--;
                }
              }
              t._gw = d.crispRound(e, t.gridwidth, 1);
              for (var p = i ? d.crispRound(e, t.minor.gridwidth, 1) : 0, v = r.layer, g = r.minorLayer, m = 1; m >= 0; m--) {
                var y = m ? v : g;
                if (y) {
                  var x = y.selectAll("path." + a).data(m ? l : o, Ae);
                  x.exit().remove(), x.enter().append("path").classed(a, 1).classed("crisp", !1 !== r.crisp), x.attr("transform", r.transFn).attr("d", r.path).each(function (e) {
                    return f.stroke(n.select(this), e.minor ? t.minor.gridcolor : t.gridcolor || "#ddd");
                  }).style("stroke-dasharray", function (e) {
                    return d.dashStyle(e.minor ? t.minor.griddash : t.griddash, e.minor ? t.minor.gridwidth : t.gridwidth);
                  }).style("stroke-width", function (e) {
                    return (e.minor ? p : t._gw) + "px";
                  }).style("display", null), "function" == typeof r.path && x.attr("d", r.path);
                }
              }
              He(t, [R, N]);
            }
          }, G.drawZeroLine = function (e, t, r) {
            r = r || r;
            var n = t._id + "zl",
              a = G.shouldShowZeroLine(e, t, r.counterAxis),
              i = r.layer.selectAll("path." + n).data(a ? [{
                x: 0,
                id: t._id
              }] : []);
            i.exit().remove(), i.enter().append("path").classed(n, 1).classed("zl", 1).classed("crisp", !1 !== r.crisp).each(function () {
              r.layer.selectAll("path").sort(function (e, t) {
                return J(e.id, t.id);
              });
            }), i.attr("transform", r.transFn).attr("d", r.path).call(f.stroke, t.zerolinecolor || f.defaultLine).style("stroke-width", d.crispRound(e, t.zerolinewidth, t._gw || 1) + "px").style("display", null), He(t, [E]);
          }, G.drawLabels = function (e, t, r) {
            r = r || {};
            var i = e._fullLayout,
              o = t._id,
              u = r.cls || o + "tick",
              f = r.vals.filter(function (e) {
                return e.text;
              }),
              h = r.labelFns,
              p = r.secondary ? 0 : t.tickangle,
              v = (t._prevTickAngles || {})[u],
              g = r.layer.selectAll("g." + u).data(t.showticklabels ? f : [], Ae),
              m = [];
            function y(e, i) {
              e.each(function (e) {
                var o = n.select(this),
                  l = o.select(".text-math-group"),
                  u = h.anchorFn(e, i),
                  f = r.transFn.call(o.node(), e) + (a(i) && 0 != +i ? " rotate(" + i + "," + h.xFn(e) + "," + (h.yFn(e) - e.fontSize / 2) + ")" : ""),
                  p = c.lineCount(o),
                  v = U * e.fontSize,
                  g = h.heightFn(e, a(i) ? +i : 0, (p - 1) * v);
                if (g && (f += s(0, g)), l.empty()) {
                  var m = o.select("text");
                  m.attr({
                    transform: f,
                    "text-anchor": u
                  }), m.style("opacity", 1), t._adjustTickLabelsOverflow && t._adjustTickLabelsOverflow();
                } else {
                  var y = d.bBox(l.node()).width * {
                    end: -.5,
                    start: .5
                  }[u];
                  l.attr("transform", f + s(y, 0));
                }
              });
            }
            g.enter().append("g").classed(u, 1).append("text").attr("text-anchor", "middle").each(function (t) {
              var r = n.select(this),
                a = e._promises.length;
              r.call(c.positionText, h.xFn(t), h.yFn(t)).call(d.font, {
                family: t.font,
                size: t.fontSize,
                color: t.fontColor,
                weight: t.fontWeight,
                style: t.fontStyle,
                variant: t.fontVariant,
                textcase: t.fontTextcase,
                lineposition: t.fontLineposition,
                shadow: t.fontShadow
              }).text(t.text).call(c.convertToTspans, e), e._promises[a] ? m.push(e._promises.pop().then(function () {
                y(r, p);
              })) : y(r, p);
            }), He(t, [H]), g.exit().remove(), r.repositionOnUpdate && g.each(function (e) {
              n.select(this).select("text").call(c.positionText, h.xFn(e), h.yFn(e));
            }), t._adjustTickLabelsOverflow = function () {
              var r = t.ticklabeloverflow;
              if (r && "allow" !== r) {
                var a = -1 !== r.indexOf("hide"),
                  o = "x" === t._id.charAt(0),
                  s = 0,
                  c = o ? e._fullLayout.width : e._fullLayout.height;
                if (-1 !== r.indexOf("domain")) {
                  var u = l.simpleMap(t.range, t.r2l);
                  s = t.l2p(u[0]) + t._offset, c = t.l2p(u[1]) + t._offset;
                }
                var f = Math.min(s, c),
                  h = Math.max(s, c),
                  p = t.side,
                  v = 1 / 0,
                  m = -1 / 0;
                for (var y in g.each(function (e) {
                  var r = n.select(this);
                  if (r.select(".text-math-group").empty()) {
                    var i = d.bBox(r.node()),
                      l = 0;
                    o ? (i.right > h || i.left < f) && (l = 1) : (i.bottom > h || i.top + (t.tickangle ? 0 : e.fontSize / 4) < f) && (l = 1);
                    var s = r.select("text");
                    l ? a && s.style("opacity", 0) : (s.style("opacity", 1), v = "bottom" === p || "right" === p ? Math.min(v, o ? i.top : i.left) : -1 / 0, m = "top" === p || "left" === p ? Math.max(m, o ? i.bottom : i.right) : 1 / 0);
                  }
                }), i._plots) {
                  var x = i._plots[y];
                  if (t._id === x.xaxis._id || t._id === x.yaxis._id) {
                    var b = o ? x.yaxis : x.xaxis;
                    b && (b["_visibleLabelMin_" + t._id] = v, b["_visibleLabelMax_" + t._id] = m);
                  }
                }
              }
            }, t._hideCounterAxisInsideTickLabels = function (e) {
              var r = "x" === t._id.charAt(0),
                a = [];
              for (var o in i._plots) {
                var l = i._plots[o];
                t._id !== l.xaxis._id && t._id !== l.yaxis._id || a.push(r ? l.yaxis : l.xaxis);
              }
              a.forEach(function (r, a) {
                r && Fe(r) && (e || [E, N, R, F, H]).forEach(function (e) {
                  var o = "tick" === e.K && "text" === e.L && "period" === t.ticklabelmode,
                    l = i._plots[t._mainSubplot];
                  (e.K === E.K ? l.zerolinelayer.selectAll("." + t._id + "zl") : e.K === N.K ? l.minorGridlayer.selectAll("." + t._id) : e.K === R.K ? l.gridlayer.selectAll("." + t._id) : l[t._id.charAt(0) + "axislayer"]).each(function () {
                    var i = n.select(this);
                    e.L && (i = i.selectAll(e.L)), i.each(function (i) {
                      var l = t.l2p(o ? ke(i) : i.x) + t._offset,
                        s = n.select(this);
                      l < t["_visibleLabelMax_" + r._id] && l > t["_visibleLabelMin_" + r._id] ? s.style("display", "none") : "tick" !== e.K || a || s.style("display", null);
                    });
                  });
                });
              });
            }, y(g, v + 1 ? v : p);
            var x = null;
            t._selections && (t._selections[u] = g);
            var b = [function () {
              return m.length && Promise.all(m);
            }];
            t.automargin && i._redrawFromAutoMarginCount && 90 === v ? (x = v, b.push(function () {
              y(g, v);
            })) : b.push(function () {
              if (y(g, p), f.length && t.autotickangles && ("log" !== t.type || "D" !== String(t.dtick).charAt(0))) {
                x = t.autotickangles[0];
                var e,
                  n = 0,
                  a = [],
                  i = 1;
                g.each(function (e) {
                  n = Math.max(n, e.fontSize);
                  var r = t.l2p(e.x),
                    o = Ce(this),
                    l = d.bBox(o.node());
                  i = Math.max(i, c.lineCount(o)), a.push({
                    top: 0,
                    bottom: 10,
                    height: 10,
                    left: r - l.width / 2,
                    right: r + l.width / 2 + 2,
                    width: l.width + 2
                  });
                });
                var o = ("boundaries" === t.tickson || t.showdividers) && !r.secondary,
                  s = f.length,
                  u = Math.abs((f[s - 1].x - f[0].x) * t._m) / (s - 1),
                  h = o ? u / 2 : u,
                  v = o ? t.ticklen : 1.25 * n * i,
                  m = h / Math.sqrt(Math.pow(h, 2) + Math.pow(v, 2)),
                  b = t.autotickangles.map(function (e) {
                    return e * Math.PI / 180;
                  }),
                  _ = b.find(function (e) {
                    return Math.abs(Math.cos(e)) <= m;
                  });
                void 0 === _ && (_ = b.reduce(function (e, t) {
                  return Math.abs(Math.cos(e)) < Math.abs(Math.cos(t)) ? e : t;
                }, b[0]));
                var w = _ * (180 / Math.PI);
                if (o) {
                  var T = 2;
                  for (t.ticks && (T += t.tickwidth / 2), e = 0; e < a.length; e++) {
                    var M = f[e].xbnd,
                      k = a[e];
                    if (null !== M[0] && k.left - t.l2p(M[0]) < T || null !== M[1] && t.l2p(M[1]) - k.right < T) {
                      x = w;
                      break;
                    }
                  }
                } else {
                  var A = t.ticklabelposition || "",
                    L = function (e) {
                      return -1 !== A.indexOf(e);
                    },
                    S = L("top"),
                    C = L("left"),
                    O = L("right"),
                    D = L("bottom") || C || S || O ? (t.tickwidth || 0) + 6 : 0;
                  for (e = 0; e < a.length - 1; e++) if (l.bBoxIntersect(a[e], a[e + 1], D)) {
                    x = w;
                    break;
                  }
                }
                x && y(g, x);
              }
            }), t._tickAngles && b.push(function () {
              t._tickAngles[u] = null === x ? a(p) ? p : 0 : x;
            });
            var _ = function () {
                var e = 0,
                  r = 0;
                return g.each(function (n, a) {
                  var i,
                    o = Ce(this);
                  o.select(".text-math-group").empty() && (t._vals[a] && (i = t._vals[a].bb || d.bBox(o.node()), t._vals[a].bb = i), e = Math.max(e, i.width), r = Math.max(r, i.height));
                }), {
                  labelsMaxW: e,
                  labelsMaxH: r
                };
              },
              w = t._anchorAxis;
            if (w && (w.autorange || w.insiderange) && Fe(t) && !X(i, t._id) && (i._insideTickLabelsUpdaterange || (i._insideTickLabelsUpdaterange = {}), w.autorange && (i._insideTickLabelsUpdaterange[w._name + ".autorange"] = w.autorange, b.push(_)), w.insiderange)) {
              var T = _(),
                M = "y" === t._id.charAt(0) ? T.labelsMaxW : T.labelsMaxH;
              M += 6, "inside" === t.ticklabelposition && (M += t.ticklen || 0);
              var k = "right" === t.side || "top" === t.side ? 1 : -1,
                A = 1 === k ? 1 : 0,
                L = 1 === k ? 0 : 1,
                S = [];
              S[L] = w.range[L];
              var C = w.range,
                O = w.r2p(C[A]),
                D = w.r2p(C[L]),
                P = i._insideTickLabelsUpdaterange[w._name + ".range"];
              if (P) {
                var z = w.r2p(P[A]),
                  I = w.r2p(P[L]),
                  B = k * ("y" === t._id.charAt(0) ? 1 : -1);
                B * O < B * z && (O = z, S[A] = C[A] = P[A]), B * D > B * I && (D = I, S[L] = C[L] = P[L]);
              }
              var j = Math.abs(D - O);
              j - M > 0 ? M *= 1 + M / (j -= M) : M = 0, "y" !== t._id.charAt(0) && (M = -M), S[A] = w.p2r(w.r2p(C[A]) + k * M), "min" === w.autorange || "max reversed" === w.autorange ? (S[0] = null, w._rangeInitial0 = void 0, w._rangeInitial1 = void 0) : "max" !== w.autorange && "min reversed" !== w.autorange || (S[1] = null, w._rangeInitial0 = void 0, w._rangeInitial1 = void 0), i._insideTickLabelsUpdaterange[w._name + ".range"] = S;
            }
            var Y = l.syncOrAsync(b);
            return Y && Y.then && e._promises.push(Y), Y;
          }, G.getPxPosition = function (e, t) {
            var r,
              n = e._fullLayout._size,
              a = t._id.charAt(0),
              i = t.side;
            return "free" !== t.anchor ? r = t._anchorAxis : "x" === a ? r = {
              _offset: n.t + (1 - (t.position || 0)) * n.h,
              _length: 0
            } : "y" === a && (r = {
              _offset: n.l + (t.position || 0) * n.w + t._shift,
              _length: 0
            }), "top" === i || "left" === i ? r._offset : "bottom" === i || "right" === i ? r._offset + r._length : void 0;
          }, G.shouldShowZeroLine = function (e, t, r) {
            var n = l.simpleMap(t.range, t.r2l);
            return n[0] * n[1] <= 0 && t.zeroline && ("linear" === t.type || "-" === t.type) && !(t.rangebreaks && t.maskBreaks(0) === I) && (Se(t, 0) || !function (e, t, r, n) {
              var a = r._mainAxis;
              if (a) {
                var i = e._fullLayout,
                  o = t._id.charAt(0),
                  l = G.counterLetter(t._id),
                  s = t._offset + (Math.abs(n[0]) < Math.abs(n[1]) == ("x" === o) ? 0 : t._length),
                  c = i._plots[r._mainSubplot];
                if (!(c.mainplotinfo || c).overlays.length) return h(r);
                for (var u = G.list(e, l), f = 0; f < u.length; f++) {
                  var d = u[f];
                  if (d._mainAxis === a && h(d)) return !0;
                }
              }
              function h(e) {
                if (!e.showline || !e.linewidth) return !1;
                var r = Math.max((e.linewidth + t.zerolinewidth) / 2, 1);
                function n(e) {
                  return "number" == typeof e && Math.abs(e - s) < r;
                }
                if (n(e._mainLinePosition) || n(e._mainMirrorPosition)) return !0;
                var a = e._linepositions || {};
                for (var i in a) if (n(a[i][0]) || n(a[i][1])) return !0;
              }
            }(e, t, r, n) || function (e, t) {
              for (var r = e._fullData, n = t._mainSubplot, a = t._id.charAt(0), i = 0; i < r.length; i++) {
                var l = r[i];
                if (!0 === l.visible && l.xaxis + l.yaxis === n) {
                  if (o.traceIs(l, "bar-like") && l.orientation === {
                    x: "h",
                    y: "v"
                  }[a]) return !0;
                  if (l.fill && l.fill.charAt(l.fill.length - 1) === a) return !0;
                }
              }
              return !1;
            }(e, t));
          }, G.clipEnds = function (e, t) {
            return t.filter(function (t) {
              return Se(e, t.x);
            });
          }, G.allowAutoMargin = function (e) {
            for (var t = G.list(e, "", !0), r = 0; r < t.length; r++) {
              var n = t[r];
              n.automargin && (i.allowAutoMargin(e, Oe(n)), n.mirror && i.allowAutoMargin(e, De(n))), o.getComponentMethod("rangeslider", "isVisible")(n) && i.allowAutoMargin(e, Pe(n));
            }
          }, G.swap = function (e, t) {
            for (var r = function (e, t) {
                var r,
                  n,
                  a = [];
                for (r = 0; r < t.length; r++) {
                  var i = [],
                    o = e._fullData[t[r]].xaxis,
                    l = e._fullData[t[r]].yaxis;
                  if (o && l) {
                    for (n = 0; n < a.length; n++) -1 === a[n].x.indexOf(o) && -1 === a[n].y.indexOf(l) || i.push(n);
                    if (i.length) {
                      var s,
                        c = a[i[0]];
                      if (i.length > 1) for (n = 1; n < i.length; n++) s = a[i[n]], ze(c.x, s.x), ze(c.y, s.y);
                      ze(c.x, [o]), ze(c.y, [l]);
                    } else a.push({
                      x: [o],
                      y: [l]
                    });
                  }
                }
                return a;
              }(e, t), n = 0; n < r.length; n++) Ie(e, r[n].x, r[n].y);
          };
        },
        9666: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809),
            i = r(3821).BADNUM,
            o = a.isArrayOrTypedArray,
            l = a.isDateTime,
            s = a.cleanNumber,
            c = Math.round;
          function u(e, t) {
            return t ? n(e) : "number" == typeof e;
          }
          function f(e) {
            return Math.max(1, (e - 1) / 1e3);
          }
          e.exports = function (e, t, r) {
            var a = e,
              d = r.noMultiCategory;
            if (o(a) && !a.length) return "-";
            if (!d && function (e) {
              return o(e[0]) && o(e[1]);
            }(a)) return "multicategory";
            if (d && Array.isArray(a[0])) {
              for (var h = [], p = 0; p < a.length; p++) if (o(a[p])) for (var v = 0; v < a[p].length; v++) h.push(a[p][v]);
              a = h;
            }
            if (function (e, t) {
              for (var r = e.length, a = f(r), i = 0, o = 0, s = {}, u = 0; u < r; u += a) {
                var d = e[c(u)],
                  h = String(d);
                s[h] || (s[h] = 1, l(d, t) && i++, n(d) && o++);
              }
              return i > 2 * o;
            }(a, t)) return "date";
            var g = "strict" !== r.autotypenumbers;
            return function (e, t) {
              for (var r = e.length, n = f(r), a = 0, o = 0, l = {}, u = 0; u < r; u += n) {
                var d = e[c(u)],
                  h = String(d);
                if (!l[h]) {
                  l[h] = 1;
                  var p = typeof d;
                  "boolean" === p ? o++ : (t ? s(d) !== i : "number" === p) ? a++ : "string" === p && o++;
                }
              }
              return o > 2 * a;
            }(a, g) ? "category" : function (e, t) {
              for (var r = e.length, n = 0; n < r; n++) if (u(e[n], t)) return !0;
              return !1;
            }(a, g) ? "linear" : "-";
          };
        },
        7655: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(3626),
            i = r(4809),
            o = r(8032),
            l = r(9008),
            s = r(5829),
            c = r(2777),
            u = r(7433),
            f = r(2036),
            d = r(4616),
            h = r(6473),
            p = r(7405),
            v = r(259),
            g = r(9091),
            m = r(4826).WEEKDAY_PATTERN,
            y = r(4826).HOUR_PATTERN;
          function x(e, t, r) {
            function a(r, n) {
              return i.coerce(e, t, s.rangebreaks, r, n);
            }
            if (a("enabled")) {
              var o = a("bounds");
              if (o && o.length >= 2) {
                var l,
                  c,
                  u = "";
                if (2 === o.length) for (l = 0; l < 2; l++) if (c = _(o[l])) {
                  u = m;
                  break;
                }
                var f = a("pattern", u);
                if (f === m) for (l = 0; l < 2; l++) (c = _(o[l])) && (t.bounds[l] = o[l] = c - 1);
                if (f) for (l = 0; l < 2; l++) switch (c = o[l], f) {
                  case m:
                    if (!n(c)) return void (t.enabled = !1);
                    if ((c = +c) !== Math.floor(c) || c < 0 || c >= 7) return void (t.enabled = !1);
                    t.bounds[l] = o[l] = c;
                    break;
                  case y:
                    if (!n(c)) return void (t.enabled = !1);
                    if ((c = +c) < 0 || c > 24) return void (t.enabled = !1);
                    t.bounds[l] = o[l] = c;
                }
                if (!1 === r.autorange) {
                  var d = r.range;
                  if (d[0] < d[1]) {
                    if (o[0] < d[0] && o[1] > d[1]) return void (t.enabled = !1);
                  } else if (o[0] > d[0] && o[1] < d[1]) return void (t.enabled = !1);
                }
              } else {
                var h = a("values");
                if (!h || !h.length) return void (t.enabled = !1);
                a("dvalue");
              }
            }
          }
          e.exports = function (e, t, r, n, y) {
            var b,
              _ = n.letter,
              w = n.font || {},
              T = n.splomStash || {},
              M = r("visible", !n.visibleDflt),
              k = t._template || {},
              A = t.type || k.type || "-";
            "date" === A && (a.getComponentMethod("calendars", "handleDefaults")(e, t, "calendar", n.calendar), n.noTicklabelmode || (b = r("ticklabelmode"))), n.noTicklabelindex || "date" !== A && "linear" !== A || r("ticklabelindex");
            var L = "";
            n.noTicklabelposition && "multicategory" !== A || (L = i.coerce(e, t, {
              ticklabelposition: {
                valType: "enumerated",
                dflt: "outside",
                values: "period" === b ? ["outside", "inside"] : "x" === _ ? ["outside", "inside", "outside left", "inside left", "outside right", "inside right"] : ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"]
              }
            }, "ticklabelposition")), n.noTicklabeloverflow || r("ticklabeloverflow", -1 !== L.indexOf("inside") ? "hide past domain" : "category" === A || "multicategory" === A ? "allow" : "hide past div"), g(t, y), v(e, t, r, n), h(e, t, r, n), "category" === A || n.noHover || r("hoverformat");
            var S = r("color"),
              C = S !== s.color.dflt ? S : w.color,
              O = T.label || y._dfltTitle[_];
            if (d(e, t, r, A, n), !M) return t;
            r("title.text", O), i.coerceFont(r, "title.font", w, {
              overrideDflt: {
                size: i.bigFont(w.size),
                color: C
              }
            }), c(e, t, r, A);
            var D = n.hasMinor;
            if (D && (o.newContainer(t, "minor"), c(e, t, r, A, {
              isMinor: !0
            })), f(e, t, r, A, n), u(e, t, r, n), D) {
              var P = n.isMinor;
              n.isMinor = !0, u(e, t, r, n), n.isMinor = P;
            }
            p(e, t, r, {
              dfltColor: S,
              bgColor: n.bgColor,
              showGrid: n.showGrid,
              hasMinor: D,
              attributes: s
            }), !D || t.minor.ticks || t.minor.showgrid || delete t.minor, (t.showline || t.ticks) && r("mirror");
            var z,
              I = "multicategory" === A;
            if (n.noTickson || "category" !== A && !I || !t.ticks && !t.showgrid || (I && (z = "boundaries"), "boundaries" === r("tickson", z) && delete t.ticklabelposition), I && r("showdividers") && (r("dividercolor"), r("dividerwidth")), "date" === A) if (l(e, t, {
              name: "rangebreaks",
              inclusionAttr: "enabled",
              handleItemDefaults: x
            }), t.rangebreaks.length) {
              for (var E = 0; E < t.rangebreaks.length; E++) if (t.rangebreaks[E].pattern === m) {
                t._hasDayOfWeekBreaks = !0;
                break;
              }
              if (g(t, y), y._has("scattergl") || y._has("splom")) for (var R = 0; R < n.data.length; R++) {
                var N = n.data[R];
                "scattergl" !== N.type && "splom" !== N.type || (N.visible = !1, i.warn(N.type + " traces do not work on axes with rangebreaks. Setting trace " + N.index + " to `visible: false`."));
              }
            } else delete t.rangebreaks;
            return t;
          };
          var b = {
            sun: 1,
            mon: 2,
            tue: 3,
            wed: 4,
            thu: 5,
            fri: 6,
            sat: 7
          };
          function _(e) {
            if ("string" == typeof e) return b[e.substr(0, 3).toLowerCase()];
          }
        },
        712: function (e, t, r) {
          "use strict";

          var n = r(7296),
            a = n.FORMAT_LINK,
            i = n.DATE_FORMAT_LINK;
          function o(e, t) {
            return ["Sets the " + e + " formatting rule" + (t ? "for `" + t + "` " : ""), "using d3 formatting mini-languages", "which are very similar to those in Python. For numbers, see: " + a + "."].join(" ");
          }
          function l(e, t) {
            return o(e, t) + [" And for dates see: " + i + ".", "We add two items to d3's date formatter:", "*%h* for half of the year as a decimal number as well as", "*%{n}f* for fractional seconds", "with n digits. For example, *2016-10-13 09:15:23.456* with tickformat", "*%H~%M~%S.%2f* would display *09~15~23.46*"].join(" ");
          }
          e.exports = {
            axisHoverFormat: function (e, t) {
              return {
                valType: "string",
                dflt: "",
                editType: "none",
                description: (t ? o : l)("hover text", e) + ["By default the values are formatted using " + (t ? "generic number format" : "`" + e + "axis.hoverformat`") + "."].join(" ")
              };
            },
            descriptionOnlyNumbers: o,
            descriptionWithDates: l
          };
        },
        5975: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(4826);
          function i(e, t) {
            if (t && t.length) for (var r = 0; r < t.length; r++) if (t[r][e]) return !0;
            return !1;
          }
          t.id2name = function (e) {
            if ("string" == typeof e && e.match(a.AX_ID_PATTERN)) {
              var t = e.split(" ")[0].substr(1);
              return "1" === t && (t = ""), e.charAt(0) + "axis" + t;
            }
          }, t.name2id = function (e) {
            if (e.match(a.AX_NAME_PATTERN)) {
              var t = e.substr(5);
              return "1" === t && (t = ""), e.charAt(0) + t;
            }
          }, t.cleanId = function (e, t, r) {
            var n = /( domain)$/.test(e);
            if ("string" == typeof e && e.match(a.AX_ID_PATTERN) && (!t || e.charAt(0) === t) && (!n || r)) {
              var i = e.split(" ")[0].substr(1).replace(/^0+/, "");
              return "1" === i && (i = ""), e.charAt(0) + i + (n && r ? " domain" : "");
            }
          }, t.list = function (e, r, n) {
            var a = e._fullLayout;
            if (!a) return [];
            var i,
              o = t.listIds(e, r),
              l = new Array(o.length);
            for (i = 0; i < o.length; i++) {
              var s = o[i];
              l[i] = a[s.charAt(0) + "axis" + s.substr(1)];
            }
            if (!n) {
              var c = a._subplots.gl3d || [];
              for (i = 0; i < c.length; i++) {
                var u = a[c[i]];
                r ? l.push(u[r + "axis"]) : l.push(u.xaxis, u.yaxis, u.zaxis);
              }
            }
            return l;
          }, t.listIds = function (e, t) {
            var r = e._fullLayout;
            if (!r) return [];
            var n = r._subplots;
            return t ? n[t + "axis"] : n.xaxis.concat(n.yaxis);
          }, t.getFromId = function (e, r, n) {
            var a = e._fullLayout;
            return r = void 0 === r || "string" != typeof r ? r : r.replace(" domain", ""), "x" === n ? r = r.replace(/y[0-9]*/, "") : "y" === n && (r = r.replace(/x[0-9]*/, "")), a[t.id2name(r)];
          }, t.getFromTrace = function (e, r, a) {
            var i = e._fullLayout,
              o = null;
            if (n.traceIs(r, "gl3d")) {
              var l = r.scene;
              "scene" === l.substr(0, 5) && (o = i[l][a + "axis"]);
            } else o = t.getFromId(e, r[a + "axis"] || a);
            return o;
          }, t.idSort = function (e, t) {
            var r = e.charAt(0),
              n = t.charAt(0);
            return r !== n ? r > n ? 1 : -1 : +(e.substr(1) || 1) - +(t.substr(1) || 1);
          }, t.ref2id = function (e) {
            return !!/^[xyz]/.test(e) && e.split(" ")[0];
          }, t.isLinked = function (e, t) {
            return i(t, e._axisMatchGroups) || i(t, e._axisConstraintGroups);
          };
        },
        6473: function (e, t, r) {
          "use strict";

          var n = r(7800).isTypedArraySpec;
          e.exports = function (e, t, r, a) {
            if ("category" === t.type) {
              var i,
                o = e.categoryarray,
                l = Array.isArray(o) && o.length > 0 || n(o);
              l && (i = "array");
              var s,
                c = r("categoryorder", i);
              "array" === c && (s = r("categoryarray")), l || "array" !== c || (c = t.categoryorder = "trace"), "trace" === c ? t._initialCategories = [] : "array" === c ? t._initialCategories = s.slice() : (s = function (e, t) {
                var r,
                  n,
                  a,
                  i = t.dataAttr || e._id.charAt(0),
                  o = {};
                if (t.axData) r = t.axData;else for (r = [], n = 0; n < t.data.length; n++) {
                  var l = t.data[n];
                  l[i + "axis"] === e._id && r.push(l);
                }
                for (n = 0; n < r.length; n++) {
                  var s = r[n][i];
                  for (a = 0; a < s.length; a++) {
                    var c = s[a];
                    null != c && (o[c] = 1);
                  }
                }
                return Object.keys(o);
              }(t, a).sort(), "category ascending" === c ? t._initialCategories = s : "category descending" === c && (t._initialCategories = s.reverse()));
            }
          };
        },
        8599: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809),
            i = r(3821),
            o = i.ONEDAY,
            l = i.ONEWEEK;
          t.dtick = function (e, t) {
            var r = "log" === t,
              a = "date" === t,
              i = "category" === t,
              l = a ? o : 1;
            if (!e) return l;
            if (n(e)) return (e = Number(e)) <= 0 ? l : i ? Math.max(1, Math.round(e)) : a ? Math.max(.1, e) : e;
            if ("string" != typeof e || !a && !r) return l;
            var s = e.charAt(0),
              c = e.substr(1);
            return (c = n(c) ? Number(c) : 0) <= 0 || !(a && "M" === s && c === Math.round(c) || r && "L" === s || r && "D" === s && (1 === c || 2 === c)) ? l : e;
          }, t.tick0 = function (e, t, r, i) {
            return "date" === t ? a.cleanDate(e, a.dateTick0(r, i % l == 0 ? 1 : 0)) : "D1" !== i && "D2" !== i ? n(e) ? Number(e) : 0 : void 0;
          };
        },
        4826: function (e, t, r) {
          "use strict";

          var n = r(694).counter;
          e.exports = {
            idRegex: {
              x: n("x", "( domain)?"),
              y: n("y", "( domain)?")
            },
            attrRegex: n("[xy]axis"),
            xAxisMatch: n("xaxis"),
            yAxisMatch: n("yaxis"),
            AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
            AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
            SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
            HOUR_PATTERN: "hour",
            WEEKDAY_PATTERN: "day of week",
            MINDRAG: 8,
            MINZOOM: 20,
            DRAGGERSIZE: 20,
            REDRAWDELAY: 50,
            DFLTRANGEX: [-1, 6],
            DFLTRANGEY: [-1, 4],
            traceLayerClasses: ["imagelayer", "heatmaplayer", "contourcarpetlayer", "contourlayer", "funnellayer", "waterfalllayer", "barlayer", "carpetlayer", "violinlayer", "boxlayer", "ohlclayer", "scattercarpetlayer", "scatterlayer"],
            clipOnAxisFalseQuery: [".scatterlayer", ".barlayer", ".funnellayer", ".waterfalllayer"],
            layerValue2layerClass: {
              "above traces": "above",
              "below traces": "below"
            },
            zindexSeparator: "z"
          };
        },
        4391: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(2919),
            i = r(5975).id2name,
            o = r(5829),
            l = r(7611),
            s = r(9091),
            c = r(3821).ALMOST_EQUAL,
            u = r(4530).FROM_BL;
          function f(e, t, r) {
            var a = r.axIds,
              l = r.layoutOut,
              s = r.hasImage,
              c = l._axisConstraintGroups,
              u = l._axisMatchGroups,
              f = t._id,
              v = f.charAt(0),
              g = ((l._splomAxes || {})[v] || {})[f] || {},
              m = t._id,
              y = "x" === m.charAt(0);
            function x(r, a) {
              return n.coerce(e, t, o, r, a);
            }
            t._matchGroup = null, t._constraintGroup = null, x("constrain", s ? "domain" : "range"), n.coerce(e, t, {
              constraintoward: {
                valType: "enumerated",
                values: y ? ["left", "center", "right"] : ["bottom", "middle", "top"],
                dflt: y ? "center" : "middle"
              }
            }, "constraintoward");
            var b,
              _,
              w = t.type,
              T = [];
            for (b = 0; b < a.length; b++) (_ = a[b]) !== m && l[i(_)].type === w && T.push(_);
            var M = h(c, m);
            if (M) {
              var k = [];
              for (b = 0; b < T.length; b++) M[_ = T[b]] || k.push(_);
              T = k;
            }
            var A,
              L,
              S = T.length;
            S && (e.matches || g.matches) && (A = n.coerce(e, t, {
              matches: {
                valType: "enumerated",
                values: T,
                dflt: -1 !== T.indexOf(g.matches) ? g.matches : void 0
              }
            }, "matches"));
            var C = s && !y ? t.anchor : void 0;
            if (S && !A && (e.scaleanchor || C) && (L = n.coerce(e, t, {
              scaleanchor: {
                valType: "enumerated",
                values: T.concat([!1])
              }
            }, "scaleanchor", C)), A) {
              t._matchGroup = p(u, m, A, 1);
              var O = l[i(A)],
                D = d(l, t) / d(l, O);
              y !== ("x" === A.charAt(0)) && (D = (y ? "x" : "y") + D), p(c, m, A, D);
            } else e.matches && -1 !== a.indexOf(e.matches) && n.warn("ignored " + t._name + '.matches: "' + e.matches + '" to avoid an infinite loop');
            if (L) {
              var P = x("scaleratio");
              P || (P = t.scaleratio = 1), p(c, m, L, P);
            } else e.scaleanchor && -1 !== a.indexOf(e.scaleanchor) && n.warn("ignored " + t._name + '.scaleanchor: "' + e.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
          }
          function d(e, t) {
            var r = t.domain;
            return r || (r = e[i(t.overlaying)].domain), r[1] - r[0];
          }
          function h(e, t) {
            for (var r = 0; r < e.length; r++) if (e[r][t]) return e[r];
            return null;
          }
          function p(e, t, r, n) {
            var a,
              i,
              o,
              l,
              s,
              c = h(e, t);
            null === c ? ((c = {})[t] = 1, s = e.length, e.push(c)) : s = e.indexOf(c);
            var u = Object.keys(c);
            for (a = 0; a < e.length; a++) if (o = e[a], a !== s && o[r]) {
              var f = o[r];
              for (i = 0; i < u.length; i++) o[l = u[i]] = v(f, v(n, c[l]));
              return void e.splice(s, 1);
            }
            if (1 !== n) for (i = 0; i < u.length; i++) {
              var d = u[i];
              c[d] = v(n, c[d]);
            }
            c[r] = 1;
          }
          function v(e, t) {
            var r,
              n,
              a = "",
              i = "";
            "string" == typeof e && (r = (a = e.match(/^[xy]*/)[0]).length, e = +e.substr(r)), "string" == typeof t && (n = (i = t.match(/^[xy]*/)[0]).length, t = +t.substr(n));
            var o = e * t;
            return r || n ? r && n && a.charAt(0) !== i.charAt(0) ? r === n ? o : (r > n ? a.substr(n) : i.substr(r)) + o : a + i + e * t : o;
          }
          function g(e, t) {
            for (var r = t._size, n = r.h / r.w, a = {}, i = Object.keys(e), o = 0; o < i.length; o++) {
              var l = i[o],
                s = e[l];
              if ("string" == typeof s) {
                var c = s.match(/^[xy]*/)[0],
                  u = c.length;
                s = +s.substr(u);
                for (var f = "y" === c.charAt(0) ? n : 1 / n, d = 0; d < u; d++) s *= f;
              }
              a[l] = s;
            }
            return a;
          }
          function m(e, t) {
            var r = e._inputDomain,
              n = u[e.constraintoward],
              a = r[0] + (r[1] - r[0]) * n;
            e.domain = e._input.domain = [a + (r[0] - a) / t, a + (r[1] - a) / t], e.setScale();
          }
          t.handleDefaults = function (e, t, r) {
            var a,
              o,
              l,
              c,
              u,
              d,
              h,
              p,
              v = r.axIds,
              g = r.axHasImage,
              m = t._axisConstraintGroups = [],
              y = t._axisMatchGroups = [];
            for (a = 0; a < v.length; a++) f(u = e[c = i(v[a])], d = t[c], {
              axIds: v,
              layoutOut: t,
              hasImage: g[c]
            });
            function x(e, r) {
              for (a = 0; a < e.length; a++) for (l in o = e[a]) t[i(l)][r] = o;
            }
            for (x(y, "_matchGroup"), a = 0; a < m.length; a++) for (l in o = m[a]) if ((d = t[i(l)]).fixedrange) {
              for (var b in o) {
                var _ = i(b);
                !1 === (e[_] || {}).fixedrange && n.warn("fixedrange was specified as false for axis " + _ + " but was overridden because another axis in its constraint group has fixedrange true"), t[_].fixedrange = !0;
              }
              break;
            }
            for (a = 0; a < m.length;) {
              for (l in o = m[a]) {
                (d = t[i(l)])._matchGroup && Object.keys(d._matchGroup).length === Object.keys(o).length && (m.splice(a, 1), a--);
                break;
              }
              a++;
            }
            x(m, "_constraintGroup");
            var w = ["constrain", "range", "autorange", "rangemode", "rangebreaks", "categoryorder", "categoryarray"],
              T = !1,
              M = !1;
            function k() {
              p = d[h], "rangebreaks" === h && (M = d._hasDayOfWeekBreaks);
            }
            for (a = 0; a < y.length; a++) {
              o = y[a];
              for (var A = 0; A < w.length; A++) {
                var L;
                for (l in h = w[A], p = null, o) if (u = e[c = i(l)], d = t[c], h in d) {
                  if (!d.matches && (L = d, h in u)) {
                    k();
                    break;
                  }
                  null === p && h in u && k();
                }
                if ("range" === h && p && u.range && 2 === u.range.length && null !== u.range[0] && null !== u.range[1] && (T = !0), "autorange" === h && null === p && T && (p = !1), null === p && h in L && (p = L[h]), null !== p) for (l in o) (d = t[i(l)])[h] = "range" === h ? p.slice() : p, "rangebreaks" === h && (d._hasDayOfWeekBreaks = M, s(d, t));
              }
            }
          }, t.enforce = function (e) {
            var t,
              r,
              n,
              o,
              s,
              u,
              f,
              d,
              h = e._fullLayout,
              p = h._axisConstraintGroups || [];
            for (t = 0; t < p.length; t++) {
              n = g(p[t], h);
              var v = Object.keys(n),
                y = 1 / 0,
                x = 0,
                b = 1 / 0,
                _ = {},
                w = {},
                T = !1;
              for (r = 0; r < v.length; r++) w[o = v[r]] = s = h[i(o)], s._inputDomain ? s.domain = s._inputDomain.slice() : s._inputDomain = s.domain.slice(), s._inputRange || (s._inputRange = s.range.slice()), s.setScale(), _[o] = u = Math.abs(s._m) / n[o], y = Math.min(y, u), "domain" !== s.constrain && s._constraintShrinkable || (b = Math.min(b, u)), delete s._constraintShrinkable, x = Math.max(x, u), "domain" === s.constrain && (T = !0);
              if (!(y > c * x) || T) for (r = 0; r < v.length; r++) if (u = _[o = v[r]], f = (s = w[o]).constrain, u !== b || "domain" === f) if (d = u / b, "range" === f) l(s, d);else {
                var M = s._inputDomain,
                  k = (s.domain[1] - s.domain[0]) / (M[1] - M[0]),
                  A = (s.r2l(s.range[1]) - s.r2l(s.range[0])) / (s.r2l(s._inputRange[1]) - s.r2l(s._inputRange[0]));
                if ((d /= k) * A < 1) {
                  s.domain = s._input.domain = M.slice(), l(s, d);
                  continue;
                }
                if (A < 1 && (s.range = s._input.range = s._inputRange.slice(), d *= A), s.autorange) {
                  var L = s.r2l(s.range[0]),
                    S = s.r2l(s.range[1]),
                    C = (L + S) / 2,
                    O = C,
                    D = C,
                    P = Math.abs(S - C),
                    z = C - P * d * 1.0001,
                    I = C + P * d * 1.0001,
                    E = a.makePadFn(h, s, 0),
                    R = a.makePadFn(h, s, 1);
                  m(s, d);
                  var N,
                    F,
                    H = Math.abs(s._m),
                    B = a.concatExtremes(e, s),
                    j = B.min,
                    Y = B.max;
                  for (F = 0; F < j.length; F++) (N = j[F].val - E(j[F]) / H) > z && N < O && (O = N);
                  for (F = 0; F < Y.length; F++) (N = Y[F].val + R(Y[F]) / H) < I && N > D && (D = N);
                  d /= (D - O) / (2 * P), O = s.l2r(O), D = s.l2r(D), s.range = s._input.range = L < S ? [O, D] : [D, O];
                }
                m(s, d);
              }
            }
          }, t.getAxisGroup = function (e, t) {
            for (var r = e._axisMatchGroups, n = 0; n < r.length; n++) if (r[n][t]) return "g" + n;
            return t;
          }, t.clean = function (e, t) {
            if (t._inputDomain) {
              for (var r = !1, n = t._id, a = e._fullLayout._axisConstraintGroups, i = 0; i < a.length; i++) if (a[i][n]) {
                r = !0;
                break;
              }
              r && "domain" === t.constrain || (t._input.domain = t.domain = t._inputDomain, delete t._inputDomain);
            }
          };
        },
        1680: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4809),
            i = a.numberFormat,
            o = r(5657),
            l = r(4043),
            s = r(3626),
            c = a.strTranslate,
            u = r(635),
            f = r(8766),
            d = r(2203),
            h = r(2141),
            p = r(9714),
            v = r(7983),
            g = r(4751),
            m = r(414),
            y = m.selectingOrDrawing,
            x = m.freeMode,
            b = r(4530).FROM_TL,
            _ = r(4823),
            w = r(1817).redrawReglTraces,
            T = r(4122),
            M = r(5975).getFromId,
            k = r(4844).prepSelect,
            A = r(4844).clearOutline,
            L = r(4844).selectOnClick,
            S = r(7611),
            C = r(4826),
            O = C.MINDRAG,
            D = C.MINZOOM,
            P = !0;
          function z(e, t, r, n) {
            var i = a.ensureSingle(e.draglayer, t, r, function (t) {
              t.classed("drag", !0).style({
                fill: "transparent",
                "stroke-width": 0
              }).attr("data-subplot", e.id);
            });
            return i.call(v, n), i.node();
          }
          function I(e, t, r, a, i, o, l) {
            var s = z(e, "rect", t, r);
            return n.select(s).call(d.setRect, a, i, o, l), s;
          }
          function E(e, t) {
            for (var r = 0; r < e.length; r++) if (!e[r].fixedrange) return t;
            return "";
          }
          function R(e, t, r, n, a) {
            for (var i = 0; i < e.length; i++) {
              var o = e[i];
              if (!o.fixedrange) if (o.rangebreaks) {
                var l = "y" === o._id.charAt(0),
                  s = l ? 1 - t : t,
                  c = l ? 1 - r : r;
                n[o._name + ".range[0]"] = o.l2r(o.p2l(s * o._length)), n[o._name + ".range[1]"] = o.l2r(o.p2l(c * o._length));
              } else {
                var u = o._rl[0],
                  f = o._rl[1] - u;
                n[o._name + ".range[0]"] = o.l2r(u + f * t), n[o._name + ".range[1]"] = o.l2r(u + f * r);
              }
            }
            if (a && a.length) {
              var d = (t + (1 - r)) / 2;
              R(a, d, 1 - d, n, []);
            }
          }
          function N(e, t) {
            for (var r = 0; r < e.length; r++) {
              var n = e[r];
              if (!n.fixedrange) {
                if (n.rangebreaks) {
                  var a = n._length,
                    i = (n.p2l(0 + t) - n.p2l(0) + (n.p2l(a + t) - n.p2l(a))) / 2;
                  n.range = [n.l2r(n._rl[0] - i), n.l2r(n._rl[1] - i)];
                } else n.range = [n.l2r(n._rl[0] - t / n._m), n.l2r(n._rl[1] - t / n._m)];
                n.limitRange && n.limitRange();
              }
            }
          }
          function F(e) {
            return 1 - (e >= 0 ? Math.min(e, .9) : 1 / (1 / Math.max(e, -.3) + 3.222));
          }
          function H(e, t, r, n, a) {
            return e.append("path").attr("class", "zoombox").style({
              fill: t > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
              "stroke-width": 0
            }).attr("transform", c(r, n)).attr("d", a + "Z");
          }
          function B(e, t, r) {
            return e.append("path").attr("class", "zoombox-corners").style({
              fill: f.background,
              stroke: f.defaultLine,
              "stroke-width": 1,
              opacity: 0
            }).attr("transform", c(t, r)).attr("d", "M0,0Z");
          }
          function j(e, t, r, n, a, i) {
            e.attr("d", n + "M" + r.l + "," + r.t + "v" + r.h + "h" + r.w + "v-" + r.h + "h-" + r.w + "Z"), Y(e, t, a, i);
          }
          function Y(e, t, r, n) {
            r || (e.transition().style("fill", n > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), t.transition().style("opacity", 1).duration(200));
          }
          function V(e) {
            n.select(e).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
          }
          function U(e) {
            P && e.data && e._context.showTips && (a.notifier(a._(e, "Double-click to zoom back out"), "long"), P = !1);
          }
          function q(e) {
            var t = Math.floor(Math.min(e.b - e.t, e.r - e.l, D) / 2);
            return "M" + (e.l - 3.5) + "," + (e.t - .5 + t) + "h3v" + -t + "h" + t + "v-3h-" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.t - .5 + t) + "h-3v" + -t + "h" + -t + "v-3h" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.b + .5 - t) + "h-3v" + t + "h" + -t + "v3h" + (t + 3) + "ZM" + (e.l - 3.5) + "," + (e.b + .5 - t) + "h3v" + t + "h" + t + "v3h-" + (t + 3) + "Z";
          }
          function G(e, t, r, n, i) {
            for (var o, l, s, c, u = !1, f = {}, d = {}, h = (i || {}).xaHash, p = (i || {}).yaHash, v = 0; v < t.length; v++) {
              var g = t[v];
              for (o in r) if (g[o]) {
                for (s in g) i && (h[s] || p[s]) || ("x" === s.charAt(0) ? r : n)[s] || (f[s] = o);
                for (l in n) i && (h[l] || p[l]) || !g[l] || (u = !0);
              }
              for (l in n) if (g[l]) for (c in g) i && (h[c] || p[c]) || ("x" === c.charAt(0) ? r : n)[c] || (d[c] = l);
            }
            u && (a.extendFlat(f, d), d = {});
            var m = {},
              y = [];
            for (s in f) {
              var x = M(e, s);
              y.push(x), m[x._id] = x;
            }
            var b = {},
              _ = [];
            for (c in d) {
              var w = M(e, c);
              _.push(w), b[w._id] = w;
            }
            return {
              xaHash: m,
              yaHash: b,
              xaxes: y,
              yaxes: _,
              xLinks: f,
              yLinks: d,
              isSubplotConstrained: u
            };
          }
          function Z(e, t) {
            if (l) {
              var r = void 0 !== e.onwheel ? "wheel" : "mousewheel";
              e._onwheel && e.removeEventListener(r, e._onwheel), e._onwheel = t, e.addEventListener(r, t, {
                passive: !1
              });
            } else void 0 !== e.onwheel ? e.onwheel = t : void 0 !== e.onmousewheel ? e.onmousewheel = t : e.isAddedWheelEvent || (e.isAddedWheelEvent = !0, e.addEventListener("wheel", t, {
              passive: !1
            }));
          }
          function W(e) {
            var t = [];
            for (var r in e) t.push(e[r]);
            return t;
          }
          e.exports = {
            makeDragBox: function (e, t, r, l, c, f, v, m) {
              var P,
                z,
                Y,
                J,
                X,
                K,
                Q,
                $,
                ee,
                te,
                re,
                ne,
                ae,
                ie,
                oe,
                le,
                se,
                ce,
                ue,
                fe,
                de,
                he,
                pe,
                ve = e._fullLayout._zoomlayer,
                ge = v + m === "nsew",
                me = 1 === (v + m).length;
              function ye() {
                if (P = t.xaxis, z = t.yaxis, ee = P._length, te = z._length, Q = P._offset, $ = z._offset, (Y = {})[P._id] = P, (J = {})[z._id] = z, v && m) for (var r = t.overlays, n = 0; n < r.length; n++) {
                  var a = r[n].xaxis;
                  Y[a._id] = a;
                  var i = r[n].yaxis;
                  J[i._id] = i;
                }
                X = W(Y), K = W(J), ae = E(X, m), ie = E(K, v), oe = !ie && !ae, ne = G(e, e._fullLayout._axisMatchGroups, Y, J);
                var o = (re = G(e, e._fullLayout._axisConstraintGroups, Y, J, ne)).isSubplotConstrained || ne.isSubplotConstrained;
                le = m || o, se = v || o;
                var l = e._fullLayout;
                ce = l._has("scattergl"), ue = l._has("splom"), fe = l._has("svg");
              }
              r += t.yaxis._shift, ye();
              var xe = function (e, t, r) {
                  return e ? "nsew" === e ? r ? "" : "pan" === t ? "move" : "crosshair" : e.toLowerCase() + "-resize" : "pointer";
                }(ie + ae, e._fullLayout.dragmode, ge),
                be = I(t, v + m + "drag", xe, r, l, c, f);
              if (oe && !ge) return be.onmousedown = null, be.style.pointerEvents = "none", be;
              var _e,
                we,
                Te,
                Me,
                ke,
                Ae,
                Le,
                Se,
                Ce,
                Oe,
                De = {
                  element: be,
                  gd: e,
                  plotinfo: t
                };
              function Pe() {
                De.plotinfo.selection = !1, A(e);
              }
              function ze(e, r) {
                var a = De.gd;
                if (a._fullLayout._activeShapeIndex >= 0) a._fullLayout._deactivateShape(a);else {
                  var o = a._fullLayout.clickmode;
                  if (V(a), 2 !== e || me || Ue(), ge) o.indexOf("select") > -1 && L(r, a, X, K, t.id, De), o.indexOf("event") > -1 && h.click(a, r, t.id);else if (1 === e && me) {
                    var l = v ? z : P,
                      c = "s" === v || "w" === m ? 0 : 1,
                      f = l._name + ".range[" + c + "]",
                      d = function (e, t) {
                        var r,
                          n = e.range[t],
                          a = Math.abs(n - e.range[1 - t]);
                        return "date" === e.type ? n : "log" === e.type ? (r = Math.ceil(Math.max(0, -Math.log(a) / Math.LN10)) + 3, i("." + r + "g")(Math.pow(10, n))) : (r = Math.floor(Math.log(Math.abs(n)) / Math.LN10) - Math.floor(Math.log(a) / Math.LN10) + 4, i("." + String(r) + "g")(n));
                      }(l, c),
                      p = "left",
                      g = "middle";
                    if (l.fixedrange) return;
                    v ? (g = "n" === v ? "top" : "bottom", "right" === l.side && (p = "right")) : "e" === m && (p = "right"), a._context.showAxisRangeEntryBoxes && n.select(be).call(u.makeEditable, {
                      gd: a,
                      immediate: !0,
                      background: a._fullLayout.paper_bgcolor,
                      text: String(d),
                      fill: l.tickfont ? l.tickfont.color : "#444",
                      horizontalAlign: p,
                      verticalAlign: g
                    }).on("edit", function (e) {
                      var t = l.d2r(e);
                      void 0 !== t && s.call("_guiRelayout", a, f, t);
                    });
                  }
                }
              }
              function Ie(t, r) {
                if (e._transitioningWithDuration) return !1;
                var n = Math.max(0, Math.min(ee, he * t + _e)),
                  a = Math.max(0, Math.min(te, pe * r + we)),
                  i = Math.abs(n - _e),
                  o = Math.abs(a - we);
                function l() {
                  Le = "", Te.r = Te.l, Te.t = Te.b, Ce.attr("d", "M0,0Z");
                }
                if (Te.l = Math.min(_e, n), Te.r = Math.max(_e, n), Te.t = Math.min(we, a), Te.b = Math.max(we, a), re.isSubplotConstrained) i > D || o > D ? (Le = "xy", i / ee > o / te ? (o = i * te / ee, we > a ? Te.t = we - o : Te.b = we + o) : (i = o * ee / te, _e > n ? Te.l = _e - i : Te.r = _e + i), Ce.attr("d", q(Te))) : l();else if (ne.isSubplotConstrained) {
                  if (i > D || o > D) {
                    Le = "xy";
                    var s = Math.min(Te.l / ee, (te - Te.b) / te),
                      c = Math.max(Te.r / ee, (te - Te.t) / te);
                    Te.l = s * ee, Te.r = c * ee, Te.b = (1 - s) * te, Te.t = (1 - c) * te, Ce.attr("d", q(Te));
                  } else l();
                } else !ie || o < Math.min(Math.max(.6 * i, O), D) ? i < O || !ae ? l() : (Te.t = 0, Te.b = te, Le = "x", Ce.attr("d", function (e, t) {
                  return "M" + (e.l - .5) + "," + (t - D - .5) + "h-3v" + (2 * D + 1) + "h3ZM" + (e.r + .5) + "," + (t - D - .5) + "h3v" + (2 * D + 1) + "h-3Z";
                }(Te, we))) : !ae || i < Math.min(.6 * o, D) ? (Te.l = 0, Te.r = ee, Le = "y", Ce.attr("d", function (e, t) {
                  return "M" + (t - D - .5) + "," + (e.t - .5) + "v-3h" + (2 * D + 1) + "v3ZM" + (t - D - .5) + "," + (e.b + .5) + "v3h" + (2 * D + 1) + "v-3Z";
                }(Te, _e))) : (Le = "xy", Ce.attr("d", q(Te)));
                Te.w = Te.r - Te.l, Te.h = Te.b - Te.t, Le && (Oe = !0), e._dragged = Oe, j(Se, Ce, Te, ke, Ae, Me), Ee(), e.emit("plotly_relayouting", de), Ae = !0;
              }
              function Ee() {
                de = {}, "xy" !== Le && "x" !== Le || (R(X, Te.l / ee, Te.r / ee, de, re.xaxes), Ye("x", de)), "xy" !== Le && "y" !== Le || (R(K, (te - Te.b) / te, (te - Te.t) / te, de, re.yaxes), Ye("y", de));
              }
              function Re() {
                Ee(), V(e), qe(), U(e);
              }
              De.prepFn = function (t, r, n) {
                var i = De.dragmode,
                  l = e._fullLayout.dragmode;
                l !== i && (De.dragmode = l), ye(), he = e._fullLayout._invScaleX, pe = e._fullLayout._invScaleY, oe || (ge ? t.shiftKey ? "pan" === l ? l = "zoom" : y(l) || (l = "pan") : t.ctrlKey && (l = "pan") : l = "pan"), x(l) ? De.minDrag = 1 : De.minDrag = void 0, y(l) ? (De.xaxes = X, De.yaxes = K, k(t, r, n, De, l)) : (De.clickFn = ze, y(i) && Pe(), oe || ("zoom" === l ? (De.moveFn = Ie, De.doneFn = Re, De.minDrag = 1, function (t, r, n) {
                  var i = be.getBoundingClientRect();
                  _e = r - i.left, we = n - i.top, e._fullLayout._calcInverseTransform(e);
                  var l = a.apply3DTransform(e._fullLayout._invTransform)(_e, we);
                  _e = l[0], we = l[1], Te = {
                    l: _e,
                    r: _e,
                    w: 0,
                    t: we,
                    b: we,
                    h: 0
                  }, Me = e._hmpixcount ? e._hmlumcount / e._hmpixcount : o(e._fullLayout.plot_bgcolor).getLuminance(), Ae = !1, Le = "xy", Oe = !1, Se = H(ve, Me, Q, $, ke = "M0,0H" + ee + "V" + te + "H0V0"), Ce = B(ve, Q, $);
                }(0, r, n)) : "pan" === l && (De.moveFn = je, De.doneFn = qe))), e._fullLayout._redrag = function () {
                  var t = e._dragdata;
                  if (t && t.element === be) {
                    var r = e._fullLayout.dragmode;
                    y(r) || (ye(), Ge([0, 0, ee, te]), De.moveFn(t.dx, t.dy));
                  }
                };
              }, g.init(De);
              var Ne = [0, 0, ee, te],
                Fe = null,
                He = C.REDRAWDELAY,
                Be = t.mainplot ? e._fullLayout._plots[t.mainplot] : t;
              function je(t, r) {
                if (t *= he, r *= pe, !e._transitioningWithDuration) {
                  if (e._fullLayout._replotting = !0, "ew" === ae || "ns" === ie) {
                    var n = ae ? -t : 0,
                      a = ie ? -r : 0;
                    if (ne.isSubplotConstrained) {
                      if (ae && ie) {
                        var i = (t / ee - r / te) / 2;
                        n = -(t = i * ee), a = -(r = -i * te);
                      }
                      ie ? n = -a * ee / te : a = -n * te / ee;
                    }
                    return ae && (N(X, t), Ye("x")), ie && (N(K, r), Ye("y")), Ge([n, a, ee, te]), Ve(), void e.emit("plotly_relayouting", de);
                  }
                  var o,
                    l,
                    s = "w" === ae == ("n" === ie) ? 1 : -1;
                  if (ae && ie && (re.isSubplotConstrained || ne.isSubplotConstrained)) {
                    var c = (t / ee + s * r / te) / 2;
                    t = c * ee, r = s * c * te;
                  }
                  if ("w" === ae ? t = h(X, 0, t) : "e" === ae ? t = h(X, 1, -t) : ae || (t = 0), "n" === ie ? r = h(K, 1, r) : "s" === ie ? r = h(K, 0, -r) : ie || (r = 0), o = "w" === ae ? t : 0, l = "n" === ie ? r : 0, re.isSubplotConstrained && !ne.isSubplotConstrained || ne.isSubplotConstrained && ae && ie && s > 0) {
                    var u;
                    if (ne.isSubplotConstrained || !ae && 1 === ie.length) {
                      for (u = 0; u < X.length; u++) X[u].range = X[u]._r.slice(), S(X[u], 1 - r / te);
                      o = (t = r * ee / te) / 2;
                    }
                    if (ne.isSubplotConstrained || !ie && 1 === ae.length) {
                      for (u = 0; u < K.length; u++) K[u].range = K[u]._r.slice(), S(K[u], 1 - t / ee);
                      l = (r = t * te / ee) / 2;
                    }
                  }
                  ne.isSubplotConstrained && ie || Ye("x"), ne.isSubplotConstrained && ae || Ye("y");
                  var f = ee - t,
                    d = te - r;
                  !ne.isSubplotConstrained || ae && ie || (ae ? (l = o ? 0 : t * te / ee, d = f * te / ee) : (o = l ? 0 : r * ee / te, f = d * ee / te)), Ge([o, l, f, d]), Ve(), e.emit("plotly_relayouting", de);
                }
                function h(e, t, r) {
                  for (var n, a, i = 1 - t, o = 0; o < e.length; o++) {
                    var l = e[o];
                    if (!l.fixedrange) {
                      n = l, a = l._rl[i] + (l._rl[t] - l._rl[i]) / F(r / l._length);
                      var s = l.l2r(a);
                      !1 !== s && void 0 !== s && (l.range[t] = s);
                    }
                  }
                  return n._length * (n._rl[t] - a) / (n._rl[t] - n._rl[i]);
                }
              }
              function Ye(e, t) {
                for (var r = ne.isSubplotConstrained ? {
                    x: K,
                    y: X
                  }[e] : ne[e + "axes"], n = ne.isSubplotConstrained ? {
                    x: X,
                    y: K
                  }[e] : [], a = 0; a < r.length; a++) {
                  var i = r[a],
                    o = i._id,
                    l = ne.xLinks[o] || ne.yLinks[o],
                    s = n[0] || Y[l] || J[l];
                  s && (t ? (t[i._name + ".range[0]"] = t[s._name + ".range[0]"], t[i._name + ".range[1]"] = t[s._name + ".range[1]"]) : i.range = s.range.slice());
                }
              }
              function Ve() {
                var r,
                  n = [];
                function a(e) {
                  for (r = 0; r < e.length; r++) e[r].fixedrange || n.push(e[r]._id);
                }
                function i(e, t) {
                  for (r = 0; r < e.length; r++) {
                    var a = e[r],
                      i = a[t];
                    a.fixedrange || "sync" !== i.tickmode || n.push(i._id);
                  }
                }
                for (le && (a(X), a(re.xaxes), a(ne.xaxes), i(t.overlays, "xaxis")), se && (a(K), a(re.yaxes), a(ne.yaxes), i(t.overlays, "yaxis")), de = {}, r = 0; r < n.length; r++) {
                  var o = n[r],
                    l = M(e, o);
                  p.drawOne(e, l, {
                    skipTitle: !0
                  }), de[l._name + ".range[0]"] = l.range[0], de[l._name + ".range[1]"] = l.range[1];
                }
                p.redrawComponents(e, n);
              }
              function Ue() {
                if (!e._transitioningWithDuration) {
                  var t = e._context.doubleClick,
                    r = [];
                  ae && (r = r.concat(X)), ie && (r = r.concat(K)), ne.xaxes && (r = r.concat(ne.xaxes)), ne.yaxes && (r = r.concat(ne.yaxes));
                  var n,
                    a,
                    i = {};
                  if ("reset+autosize" === t) for (t = "autosize", a = 0; a < r.length; a++) {
                    var o = (n = r[a])._rangeInitial0,
                      l = n._rangeInitial1,
                      c = void 0 !== o || void 0 !== l;
                    if (c && (void 0 !== o && o !== n.range[0] || void 0 !== l && l !== n.range[1]) || !c && !0 !== n.autorange) {
                      t = "reset";
                      break;
                    }
                  }
                  if ("autosize" === t) for (a = 0; a < r.length; a++) (n = r[a]).fixedrange || (i[n._name + ".autorange"] = !0);else if ("reset" === t) for ((ae || re.isSubplotConstrained) && (r = r.concat(re.xaxes)), ie && !re.isSubplotConstrained && (r = r.concat(re.yaxes)), re.isSubplotConstrained && (ae ? ie || (r = r.concat(K)) : r = r.concat(X)), a = 0; a < r.length; a++) if (!(n = r[a]).fixedrange) {
                    var u = n._name,
                      f = n._autorangeInitial;
                    void 0 === n._rangeInitial0 && void 0 === n._rangeInitial1 ? i[u + ".autorange"] = !0 : void 0 === n._rangeInitial0 ? (i[u + ".autorange"] = f, i[u + ".range"] = [null, n._rangeInitial1]) : void 0 === n._rangeInitial1 ? (i[u + ".range"] = [n._rangeInitial0, null], i[u + ".autorange"] = f) : i[u + ".range"] = [n._rangeInitial0, n._rangeInitial1];
                  }
                  e.emit("plotly_doubleclick", null), s.call("_guiRelayout", e, i);
                }
              }
              function qe() {
                Ge([0, 0, ee, te]), a.syncOrAsync([T.previousPromises, function () {
                  e._fullLayout._replotting = !1, s.call("_guiRelayout", e, de);
                }], e);
              }
              function Ge(t) {
                var r,
                  n,
                  i,
                  o,
                  l = e._fullLayout,
                  c = l._plots,
                  u = l._subplots.cartesian;
                if (ue && s.subplotsRegistry.splom.drag(e), ce) for (r = 0; r < u.length; r++) if (i = (n = c[u[r]]).xaxis, o = n.yaxis, n._scene) {
                  i.limitRange && i.limitRange(), o.limitRange && o.limitRange();
                  var f = a.simpleMap(i.range, i.r2l),
                    h = a.simpleMap(o.range, o.r2l);
                  n._scene.update({
                    range: [f[0], h[0], f[1], h[1]]
                  });
                }
                if ((ue || ce) && (_(e), w(e)), fe) {
                  var p = t[2] / P._length,
                    g = t[3] / z._length;
                  for (r = 0; r < u.length; r++) {
                    i = (n = c[u[r]]).xaxis, o = n.yaxis;
                    var y,
                      x,
                      b,
                      T,
                      M = (le || ne.isSubplotConstrained) && !i.fixedrange && Y[i._id],
                      k = (se || ne.isSubplotConstrained) && !o.fixedrange && J[o._id];
                    if (M ? (y = p, b = m || ne.isSubplotConstrained ? t[0] : Je(i, y)) : ne.xaHash[i._id] ? (y = p, b = t[0] * i._length / P._length) : ne.yaHash[i._id] ? (y = g, b = "ns" === ie ? -t[1] * i._length / z._length : Je(i, y, {
                      n: "top",
                      s: "bottom"
                    }[ie])) : b = We(i, y = Ze(i, p, g)), y > 1 && (void 0 !== i.maxallowed && le === (i.range[0] < i.range[1] ? "e" : "w") || void 0 !== i.minallowed && le === (i.range[0] < i.range[1] ? "w" : "e")) && (y = 1, b = 0), k ? (x = g, T = v || ne.isSubplotConstrained ? t[1] : Je(o, x)) : ne.yaHash[o._id] ? (x = g, T = t[1] * o._length / z._length) : ne.xaHash[o._id] ? (x = p, T = "ew" === ae ? -t[0] * o._length / P._length : Je(o, x, {
                      e: "right",
                      w: "left"
                    }[ae])) : T = We(o, x = Ze(o, p, g)), x > 1 && (void 0 !== o.maxallowed && se === (o.range[0] < o.range[1] ? "n" : "s") || void 0 !== o.minallowed && se === (o.range[0] < o.range[1] ? "s" : "n")) && (x = 1, T = 0), y || x) {
                      y || (y = 1), x || (x = 1);
                      var A = i._offset - b / y,
                        L = o._offset - T / x;
                      n.clipRect.call(d.setTranslate, b, T).call(d.setScale, y, x), n.plot.call(d.setTranslate, A, L).call(d.setScale, 1 / y, 1 / x), y === n.xScaleFactor && x === n.yScaleFactor || (d.setPointGroupScale(n.zoomScalePts, y, x), d.setTextPointsScale(n.zoomScaleTxt, y, x)), d.hideOutsideRangePoints(n.clipOnAxisFalseTraces, n), n.xScaleFactor = y, n.yScaleFactor = x;
                    }
                  }
                }
              }
              function Ze(e, t, r) {
                return e.fixedrange ? 0 : le && re.xaHash[e._id] ? t : se && (re.isSubplotConstrained ? re.xaHash : re.yaHash)[e._id] ? r : 0;
              }
              function We(e, t) {
                return t ? (e.range = e._r.slice(), S(e, t), Je(e, t)) : 0;
              }
              function Je(e, t, r) {
                return e._length * (1 - t) * b[r || e.constraintoward || "middle"];
              }
              return v.length * m.length != 1 && Z(be, function (t) {
                if (e._context._scrollZoom.cartesian || e._fullLayout._enablescrollzoom) {
                  if (Pe(), e._transitioningWithDuration) return t.preventDefault(), void t.stopPropagation();
                  ye(), clearTimeout(Fe);
                  var r = -t.deltaY;
                  if (isFinite(r) || (r = t.wheelDelta / 10), isFinite(r)) {
                    var n,
                      i = Math.exp(-Math.min(Math.max(r, -20), 20) / 200),
                      o = Be.draglayer.select(".nsewdrag").node().getBoundingClientRect(),
                      l = (t.clientX - o.left) / o.width,
                      s = (o.bottom - t.clientY) / o.height;
                    if (le) {
                      for (m || (l = .5), n = 0; n < X.length; n++) c(X[n], l, i);
                      Ye("x"), Ne[2] *= i, Ne[0] += Ne[2] * l * (1 / i - 1);
                    }
                    if (se) {
                      for (v || (s = .5), n = 0; n < K.length; n++) c(K[n], s, i);
                      Ye("y"), Ne[3] *= i, Ne[1] += Ne[3] * (1 - s) * (1 / i - 1);
                    }
                    Ge(Ne), Ve(), e.emit("plotly_relayouting", de), Fe = setTimeout(function () {
                      e._fullLayout && (Ne = [0, 0, ee, te], qe());
                    }, He), t.preventDefault();
                  } else a.log("Did not find wheel motion attributes: ", t);
                }
                function c(e, t, r) {
                  if (!e.fixedrange) {
                    var n = a.simpleMap(e.range, e.r2l),
                      i = n[0] + (n[1] - n[0]) * t;
                    e.range = n.map(function (t) {
                      return e.l2r(i + (t - i) * r);
                    });
                  }
                }
              }), be;
            },
            makeDragger: z,
            makeRectDragger: I,
            makeZoombox: H,
            makeCorners: B,
            updateZoombox: j,
            xyCorners: q,
            transitionZoombox: Y,
            removeZoombox: V,
            showDoubleClickNotifier: U,
            attachWheelEventHandler: Z
          };
        },
        5284: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(2141),
            i = r(4751),
            o = r(7983),
            l = r(1680).makeDragBox,
            s = r(4826).DRAGGERSIZE;
          t.initInteractions = function (e) {
            var r = e._fullLayout;
            if (e._context.staticPlot) n.select(e).selectAll(".drag").remove();else if (r._has("cartesian") || r._has("splom")) {
              Object.keys(r._plots || {}).sort(function (e, t) {
                if ((r._plots[e].mainplot && !0) === (r._plots[t].mainplot && !0)) {
                  var n = e.split("y"),
                    a = t.split("y");
                  return n[0] === a[0] ? Number(n[1] || 1) - Number(a[1] || 1) : Number(n[0] || 1) - Number(a[0] || 1);
                }
                return r._plots[e].mainplot ? 1 : -1;
              }).forEach(function (t) {
                var n = r._plots[t],
                  o = n.xaxis,
                  c = n.yaxis;
                if (!n.mainplot) {
                  var u = l(e, n, o._offset, c._offset, o._length, c._length, "ns", "ew");
                  u.onmousemove = function (r) {
                    e._fullLayout._rehover = function () {
                      e._fullLayout._hoversubplot === t && e._fullLayout._plots[t] && a.hover(e, r, t);
                    }, a.hover(e, r, t), e._fullLayout._lasthover = u, e._fullLayout._hoversubplot = t;
                  }, u.onmouseout = function (t) {
                    e._dragging || (e._fullLayout._hoversubplot = null, i.unhover(e, t));
                  }, e._context.showAxisDragHandles && (l(e, n, o._offset - s, c._offset - s, s, s, "n", "w"), l(e, n, o._offset + o._length, c._offset - s, s, s, "n", "e"), l(e, n, o._offset - s, c._offset + c._length, s, s, "s", "w"), l(e, n, o._offset + o._length, c._offset + c._length, s, s, "s", "e"));
                }
                if (e._context.showAxisDragHandles) {
                  if (t === o._mainSubplot) {
                    var f = o._mainLinePosition;
                    "top" === o.side && (f -= s), l(e, n, o._offset + .1 * o._length, f, .8 * o._length, s, "", "ew"), l(e, n, o._offset, f, .1 * o._length, s, "", "w"), l(e, n, o._offset + .9 * o._length, f, .1 * o._length, s, "", "e");
                  }
                  if (t === c._mainSubplot) {
                    var d = c._mainLinePosition;
                    "right" !== c.side && (d -= s), l(e, n, d, c._offset + .1 * c._length, s, .8 * c._length, "ns", ""), l(e, n, d, c._offset + .9 * c._length, s, .1 * c._length, "s", ""), l(e, n, d, c._offset, s, .1 * c._length, "n", "");
                  }
                }
              });
              var o = r._hoverlayer.node();
              o.onmousemove = function (t) {
                t.target = e._fullLayout._lasthover, a.hover(e, t, r._hoversubplot);
              }, o.onclick = function (t) {
                t.target = e._fullLayout._lasthover, a.click(e, t);
              }, o.onmousedown = function (t) {
                e._fullLayout._lasthover.onmousedown(t);
              }, t.updateFx(e);
            }
          }, t.updateFx = function (e) {
            var t = e._fullLayout,
              r = "pan" === t.dragmode ? "move" : "crosshair";
            o(t._draggers, r);
          };
        },
        706: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(4809),
            i = r(5975);
          e.exports = function (e) {
            return function (t, r) {
              var o = t[e];
              if (Array.isArray(o)) for (var l = n.subplotsRegistry.cartesian, s = l.idRegex, c = r._subplots, u = c.xaxis, f = c.yaxis, d = c.cartesian, h = r._has("cartesian") || r._has("gl2d"), p = 0; p < o.length; p++) {
                var v = o[p];
                if (a.isPlainObject(v)) {
                  var g = i.cleanId(v.xref, "x", !1),
                    m = i.cleanId(v.yref, "y", !1),
                    y = s.x.test(g),
                    x = s.y.test(m);
                  if (y || x) {
                    h || a.pushUnique(r._basePlotModules, l);
                    var b = !1;
                    y && -1 === u.indexOf(g) && (u.push(g), b = !0), x && -1 === f.indexOf(m) && (f.push(m), b = !0), b && y && x && d.push(g + m);
                  }
                }
              }
            };
          };
        },
        84: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(3626),
            i = r(4809),
            o = r(4122),
            l = r(2203),
            s = r(4173).eV,
            c = r(5975),
            u = r(4826),
            f = r(2972),
            d = i.ensureSingle;
          function h(e, t, r) {
            return i.ensureSingle(e, t, r, function (e) {
              e.datum(r);
            });
          }
          var p = u.zindexSeparator;
          function v(e, t, r, i, o) {
            for (var c, f, d, h = u.traceLayerClasses, p = e._fullLayout, v = p._zindices, g = p._modules, m = [], y = [], x = 0; x < v.length; x++) for (var b = v[x], _ = 0; _ < g.length; _++) {
              var w = (c = g[_]).name,
                T = a.modules[w].categories;
              if (T.svg) {
                var M = c.layerName || w + "layer",
                  k = M + (x ? Number(x) + 1 : ""),
                  A = c.plot;
                d = (f = s(r, A, b))[0], r = f[1], d.length && m.push({
                  i: h.indexOf(M),
                  zindex: x,
                  className: k,
                  plotMethod: A,
                  cdModule: d
                }), T.zoomScale && y.push("." + k);
              }
            }
            m.sort(function (e, t) {
              return (e.zindex || 0) - (t.zindex || 0) || e.i - t.i;
            });
            var L = t.plot.selectAll("g.mlayer").data(m, function (e) {
              return e.className;
            });
            if (L.enter().append("g").attr("class", function (e) {
              return e.className;
            }).classed("mlayer", !0).classed("rangeplot", t.isRangePlot), L.exit().remove(), L.order(), L.each(function (r) {
              var a = n.select(this),
                s = r.className;
              r.plotMethod(e, t, r.cdModule, a, i, o), -1 === u.clipOnAxisFalseQuery.indexOf("." + s) && l.setClipUrl(a, t.layerClipId, e);
            }), p._has("scattergl") && (c = a.getModule("scattergl"), d = s(r, c)[0], c.plot(e, t, d)), !e._context.staticPlot && (t._hasClipOnAxisFalse && (t.clipOnAxisFalseTraces = t.plot.selectAll(u.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), y.length)) {
              var S = t.plot.selectAll(y.join(",")).selectAll(".trace");
              t.zoomScalePts = S.selectAll("path.point"), t.zoomScaleTxt = S.selectAll(".textpoint");
            }
          }
          function g(e, t) {
            var r = e._fullLayout,
              n = t.plotgroup,
              a = t.id,
              i = -1 !== a.indexOf(p),
              o = u.layerValue2layerClass[t.xaxis.layer],
              l = u.layerValue2layerClass[t.yaxis.layer],
              s = r._hasOnlyLargeSploms;
            if (!t.mainplot || r._zindices.length > 1) {
              if (s) t.xlines = d(n, "path", "xlines-above"), t.ylines = d(n, "path", "ylines-above"), t.xaxislayer = d(n, "g", "xaxislayer-above"), t.yaxislayer = d(n, "g", "yaxislayer-above");else {
                if (!i) {
                  var f = d(n, "g", "layer-subplot");
                  t.shapelayer = d(f, "g", "shapelayer"), t.imagelayer = d(f, "g", "imagelayer"), t.minorGridlayer = d(n, "g", "minor-gridlayer"), t.gridlayer = d(n, "g", "gridlayer"), t.zerolinelayer = d(n, "g", "zerolinelayer");
                  var v = d(n, "g", "layer-between");
                  t.shapelayerBetween = d(v, "g", "shapelayer"), t.imagelayerBetween = d(v, "g", "imagelayer"), d(n, "path", "xlines-below"), d(n, "path", "ylines-below"), t.overlinesBelow = d(n, "g", "overlines-below"), d(n, "g", "xaxislayer-below"), d(n, "g", "yaxislayer-below"), t.overaxesBelow = d(n, "g", "overaxes-below");
                }
                t.overplot = d(n, "g", "overplot"), t.plot = d(t.overplot, "g", a), i || (t.xlines = d(n, "path", "xlines-above"), t.ylines = d(n, "path", "ylines-above"), t.overlinesAbove = d(n, "g", "overlines-above"), d(n, "g", "xaxislayer-above"), d(n, "g", "yaxislayer-above"), t.overaxesAbove = d(n, "g", "overaxes-above"), t.xlines = n.select(".xlines-" + o), t.ylines = n.select(".ylines-" + l), t.xaxislayer = n.select(".xaxislayer-" + o), t.yaxislayer = n.select(".yaxislayer-" + l));
              }
            } else {
              var g = t.mainplotinfo,
                m = g.plotgroup,
                y = a + "-x",
                x = a + "-y";
              t.minorGridlayer = g.minorGridlayer, t.gridlayer = g.gridlayer, t.zerolinelayer = g.zerolinelayer, d(g.overlinesBelow, "path", y), d(g.overlinesBelow, "path", x), d(g.overaxesBelow, "g", y), d(g.overaxesBelow, "g", x), t.plot = d(g.overplot, "g", a), d(g.overlinesAbove, "path", y), d(g.overlinesAbove, "path", x), d(g.overaxesAbove, "g", y), d(g.overaxesAbove, "g", x), t.xlines = m.select(".overlines-" + o).select("." + y), t.ylines = m.select(".overlines-" + l).select("." + x), t.xaxislayer = m.select(".overaxes-" + o).select("." + y), t.yaxislayer = m.select(".overaxes-" + l).select("." + x);
            }
            i || (s || (h(t.minorGridlayer, "g", t.xaxis._id), h(t.minorGridlayer, "g", t.yaxis._id), t.minorGridlayer.selectAll("g").map(function (e) {
              return e[0];
            }).sort(c.idSort), h(t.gridlayer, "g", t.xaxis._id), h(t.gridlayer, "g", t.yaxis._id), t.gridlayer.selectAll("g").map(function (e) {
              return e[0];
            }).sort(c.idSort)), t.xlines.style("fill", "none").classed("crisp", !0), t.ylines.style("fill", "none").classed("crisp", !0));
          }
          function m(e, t) {
            if (e) {
              var r = {};
              for (var a in e.each(function (e) {
                var a = e[0];
                n.select(this).remove(), y(a, t), r[a] = !0;
              }), t._plots) for (var i = t._plots[a].overlays || [], o = 0; o < i.length; o++) {
                var l = i[o];
                r[l.id] && l.plot.selectAll(".trace").remove();
              }
            }
          }
          function y(e, t) {
            t._draggers.selectAll("g." + e).remove(), t._defs.select("#clip" + t._uid + e + "plot").remove();
          }
          t.name = "cartesian", t.attr = ["xaxis", "yaxis"], t.idRoot = ["x", "y"], t.idRegex = u.idRegex, t.attrRegex = u.attrRegex, t.attributes = r(5126), t.layoutAttributes = r(5829), t.supplyLayoutDefaults = r(4098), t.transitionAxes = r(4982), t.finalizeSubplots = function (e, t) {
            var r,
              n,
              a,
              o = t._subplots,
              l = o.xaxis,
              s = o.yaxis,
              f = o.cartesian,
              d = f.concat(o.gl2d || []),
              h = {},
              p = {};
            for (r = 0; r < d.length; r++) {
              var v = d[r].split("y");
              h[v[0]] = 1, p["y" + v[1]] = 1;
            }
            for (r = 0; r < l.length; r++) h[n = l[r]] || (a = (e[c.id2name(n)] || {}).anchor, u.idRegex.y.test(a) || (a = "y"), f.push(n + a), d.push(n + a), p[a] || (p[a] = 1, i.pushUnique(s, a)));
            for (r = 0; r < s.length; r++) p[a = s[r]] || (n = (e[c.id2name(a)] || {}).anchor, u.idRegex.x.test(n) || (n = "x"), f.push(n + a), d.push(n + a), h[n] || (h[n] = 1, i.pushUnique(l, n)));
            if (!d.length) {
              for (var g in n = "", a = "", e) u.attrRegex.test(g) && ("x" === g.charAt(0) ? (!n || +g.substr(5) < +n.substr(5)) && (n = g) : (!a || +g.substr(5) < +a.substr(5)) && (a = g));
              n = n ? c.name2id(n) : "x", a = a ? c.name2id(a) : "y", l.push(n), s.push(a), f.push(n + a);
            }
          }, t.plot = function (e, t, r, n) {
            var a,
              o = e._fullLayout,
              l = o._subplots.cartesian,
              s = e.calcdata;
            if (!Array.isArray(t)) for (t = [], a = 0; a < s.length; a++) t.push(a);
            for (var c = o._zindices, u = 0; u < c.length; u++) {
              var f = c[u];
              for (a = 0; a < l.length; a++) {
                var d = l[a],
                  h = o._plots[d];
                if (u > 0) {
                  var g = h.id;
                  if (-1 !== g.indexOf(p)) continue;
                  g += p + (u + 1), h = i.extendFlat({}, h, {
                    id: g,
                    plot: o._cartesianlayer.selectAll(".subplot").select("." + g)
                  });
                }
                for (var m, y = [], x = 0; x < s.length; x++) {
                  var b = s[x],
                    _ = b[0].trace;
                  f === (_.zorder || 0) && _.xaxis + _.yaxis === d && ((-1 !== t.indexOf(_.index) || _.carpet) && (m && m[0].trace.xaxis + m[0].trace.yaxis === d && -1 !== ["tonextx", "tonexty", "tonext"].indexOf(_.fill) && -1 === y.indexOf(m) && y.push(m), y.push(b)), m = b);
                }
                v(e, h, y, r, n);
              }
            }
          }, t.clean = function (e, t, r, n) {
            var a,
              i,
              o,
              l = n._plots || {},
              s = t._plots || {},
              u = n._subplots || {};
            if (n._hasOnlyLargeSploms && !t._hasOnlyLargeSploms) for (o in l) (a = l[o]).plotgroup && a.plotgroup.remove();
            var f = n._has && n._has("gl"),
              d = t._has && t._has("gl");
            if (f && !d) for (o in l) (a = l[o])._scene && a._scene.destroy();
            if (u.xaxis && u.yaxis) {
              var h = c.listIds({
                _fullLayout: n
              });
              for (i = 0; i < h.length; i++) {
                var v = h[i];
                t[c.id2name(v)] || n._infolayer.selectAll(".g-" + v + "title").remove();
              }
            }
            var g = n._has && n._has("cartesian"),
              x = t._has && t._has("cartesian");
            if (g && !x) m(n._cartesianlayer.selectAll(".subplot"), n), n._defs.selectAll(".axesclip").remove(), delete n._axisConstraintGroups, delete n._axisMatchGroups;else if (u.cartesian) for (i = 0; i < u.cartesian.length; i++) {
              var b = u.cartesian[i];
              if (-1 === b.indexOf(p) && !s[b]) {
                var _ = "." + b + ",." + b + "-x,." + b + "-y";
                n._cartesianlayer.selectAll(_).remove(), y(b, n);
              }
            }
          }, t.drawFramework = function (e) {
            var t,
              r = e._fullLayout,
              a = e.calcdata,
              o = {};
            for (t = 0; t < a.length; t++) {
              var l = a[t][0],
                s = l.trace.zorder || 0;
              o[s] || (o[s] = []), o[s].push(l);
            }
            var c = Object.keys(o).map(Number).sort(i.sorterAsc);
            c.length || (c = [0]), r._zindices = c;
            var u = function (e) {
                var t,
                  r,
                  n,
                  a,
                  i,
                  o,
                  l = e._fullLayout,
                  s = l._zindices.length,
                  c = l._subplots.cartesian,
                  u = c.length,
                  f = [],
                  d = [];
                for (t = 0; t < u; t++) {
                  n = c[t], i = (a = l._plots[n]).xaxis, o = a.yaxis;
                  var h = i._mainAxis,
                    v = o._mainAxis,
                    g = h._id + v._id,
                    m = l._plots[g];
                  a.overlays = [], g !== n && m ? (a.mainplot = g, a.mainplotinfo = m, d.push(n)) : (a.mainplot = void 0, a.mainplotinfo = void 0, f.push(n));
                }
                for (t = 0; t < d.length; t++) n = d[t], (a = l._plots[n]).mainplotinfo.overlays.push(a);
                var y = f.concat(d),
                  x = [];
                for (t = 0; t < u; t++) {
                  n = y[t], i = (a = l._plots[n]).xaxis, o = a.yaxis;
                  for (var b = [], _ = 1; _ <= s; _++) {
                    var w = "";
                    for (_ > 1 && (w += p + _), b.push(n + w), r = 0; r < a.overlays.length; r++) b.push(a.overlays[r].id + w);
                  }
                  b = b.concat([i.layer, o.layer, i.overlaying || "", o.overlaying || ""]), x.push(b);
                }
                return x;
              }(e),
              f = u.length,
              h = [];
            for (t = 0; t < f; t++) h[t] = u[t].slice();
            for (var v = 1; v < c.length; v++) {
              var y = [];
              for (t = 0; t < f; t++) y[t] = u[t].slice(), y[t][0] += p + (v + 1);
              h = h.concat(y);
            }
            var x = r._cartesianlayer.selectAll(".subplot").data(h, String);
            x.enter().append("g").attr("class", function (e) {
              return "subplot " + e[0];
            }), x.order(), x.exit().call(m, r), x.each(function (t) {
              var a = t[0],
                o = a.indexOf(p),
                l = -1 !== o,
                s = l ? a.slice(0, o) : a,
                c = r._plots[a];
              c || (c = i.extendFlat({}, r._plots[s])) && (c.id = a, r._plots[a] = c, r._subplots.cartesian.push(a)), c && (c.plotgroup = n.select(this), g(e, c), l || (c.draglayer = d(r._draggers, "g", a)));
            });
          }, t.rangePlot = function (e, t, r) {
            g(e, t), v(e, t, r), o.style(e);
          }, t.toSVG = function (e) {
            var t = e._fullLayout._glimages,
              r = n.select(e).selectAll(".svg-container");
            r.filter(function (e, t) {
              return t === r.size() - 1;
            }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function () {
              var e = this,
                r = e.toDataURL("image/png");
              t.append("svg:image").attr({
                xmlns: f.svg,
                "xlink:href": r,
                preserveAspectRatio: "none",
                x: 0,
                y: 0,
                width: e.style.width,
                height: e.style.height
              });
            });
          }, t.updateFx = r(5284).updateFx;
        },
        5829: function (e, t, r) {
          "use strict";

          var n = r(337),
            a = r(229),
            i = r(4850).T,
            o = r(3049).extendFlat,
            l = r(8032).templatedArray,
            s = r(712).descriptionWithDates,
            c = r(3821).ONEDAY,
            u = r(4826),
            f = u.HOUR_PATTERN,
            d = u.WEEKDAY_PATTERN,
            h = {
              valType: "enumerated",
              values: ["auto", "linear", "array"],
              editType: "ticks",
              impliedEdits: {
                tick0: void 0,
                dtick: void 0
              }
            },
            p = o({}, h, {
              values: h.values.slice().concat(["sync"])
            });
          function v(e) {
            return {
              valType: "integer",
              min: 0,
              dflt: e ? 5 : 0,
              editType: "ticks"
            };
          }
          var g = {
              valType: "any",
              editType: "ticks",
              impliedEdits: {
                tickmode: "linear"
              }
            },
            m = {
              valType: "any",
              editType: "ticks",
              impliedEdits: {
                tickmode: "linear"
              }
            },
            y = {
              valType: "data_array",
              editType: "ticks"
            },
            x = {
              valType: "enumerated",
              values: ["outside", "inside", ""],
              editType: "ticks"
            };
          function b(e) {
            var t = {
              valType: "number",
              min: 0,
              editType: "ticks"
            };
            return e || (t.dflt = 5), t;
          }
          function _(e) {
            var t = {
              valType: "number",
              min: 0,
              editType: "ticks"
            };
            return e || (t.dflt = 1), t;
          }
          var w = {
              valType: "color",
              dflt: a.defaultLine,
              editType: "ticks"
            },
            T = {
              valType: "color",
              dflt: a.lightLine,
              editType: "ticks"
            };
          function M(e) {
            var t = {
              valType: "number",
              min: 0,
              editType: "ticks"
            };
            return e || (t.dflt = 1), t;
          }
          var k = o({}, i, {
              editType: "ticks"
            }),
            A = {
              valType: "boolean",
              editType: "ticks"
            };
          e.exports = {
            visible: {
              valType: "boolean",
              editType: "plot"
            },
            color: {
              valType: "color",
              dflt: a.defaultLine,
              editType: "ticks"
            },
            title: {
              text: {
                valType: "string",
                editType: "ticks"
              },
              font: n({
                editType: "ticks"
              }),
              standoff: {
                valType: "number",
                min: 0,
                editType: "ticks"
              },
              editType: "ticks"
            },
            type: {
              valType: "enumerated",
              values: ["-", "linear", "log", "date", "category", "multicategory"],
              dflt: "-",
              editType: "calc",
              _noTemplating: !0
            },
            autotypenumbers: {
              valType: "enumerated",
              values: ["convert types", "strict"],
              dflt: "convert types",
              editType: "calc"
            },
            autorange: {
              valType: "enumerated",
              values: [!0, !1, "reversed", "min reversed", "max reversed", "min", "max"],
              dflt: !0,
              editType: "axrange",
              impliedEdits: {
                "range[0]": void 0,
                "range[1]": void 0
              }
            },
            autorangeoptions: {
              minallowed: {
                valType: "any",
                editType: "plot",
                impliedEdits: {
                  "range[0]": void 0,
                  "range[1]": void 0
                }
              },
              maxallowed: {
                valType: "any",
                editType: "plot",
                impliedEdits: {
                  "range[0]": void 0,
                  "range[1]": void 0
                }
              },
              clipmin: {
                valType: "any",
                editType: "plot",
                impliedEdits: {
                  "range[0]": void 0,
                  "range[1]": void 0
                }
              },
              clipmax: {
                valType: "any",
                editType: "plot",
                impliedEdits: {
                  "range[0]": void 0,
                  "range[1]": void 0
                }
              },
              include: {
                valType: "any",
                arrayOk: !0,
                editType: "plot",
                impliedEdits: {
                  "range[0]": void 0,
                  "range[1]": void 0
                }
              },
              editType: "plot"
            },
            rangemode: {
              valType: "enumerated",
              values: ["normal", "tozero", "nonnegative"],
              dflt: "normal",
              editType: "plot"
            },
            range: {
              valType: "info_array",
              items: [{
                valType: "any",
                editType: "axrange",
                impliedEdits: {
                  "^autorange": !1
                },
                anim: !0
              }, {
                valType: "any",
                editType: "axrange",
                impliedEdits: {
                  "^autorange": !1
                },
                anim: !0
              }],
              editType: "axrange",
              impliedEdits: {
                autorange: !1
              },
              anim: !0
            },
            minallowed: {
              valType: "any",
              editType: "plot",
              impliedEdits: {
                "^autorange": !1
              }
            },
            maxallowed: {
              valType: "any",
              editType: "plot",
              impliedEdits: {
                "^autorange": !1
              }
            },
            fixedrange: {
              valType: "boolean",
              dflt: !1,
              editType: "calc"
            },
            insiderange: {
              valType: "info_array",
              items: [{
                valType: "any",
                editType: "plot"
              }, {
                valType: "any",
                editType: "plot"
              }],
              editType: "plot"
            },
            scaleanchor: {
              valType: "enumerated",
              values: [u.idRegex.x.toString(), u.idRegex.y.toString(), !1],
              editType: "plot"
            },
            scaleratio: {
              valType: "number",
              min: 0,
              dflt: 1,
              editType: "plot"
            },
            constrain: {
              valType: "enumerated",
              values: ["range", "domain"],
              editType: "plot"
            },
            constraintoward: {
              valType: "enumerated",
              values: ["left", "center", "right", "top", "middle", "bottom"],
              editType: "plot"
            },
            matches: {
              valType: "enumerated",
              values: [u.idRegex.x.toString(), u.idRegex.y.toString()],
              editType: "calc"
            },
            rangebreaks: l("rangebreak", {
              enabled: {
                valType: "boolean",
                dflt: !0,
                editType: "calc"
              },
              bounds: {
                valType: "info_array",
                items: [{
                  valType: "any",
                  editType: "calc"
                }, {
                  valType: "any",
                  editType: "calc"
                }],
                editType: "calc"
              },
              pattern: {
                valType: "enumerated",
                values: [d, f, ""],
                editType: "calc"
              },
              values: {
                valType: "info_array",
                freeLength: !0,
                editType: "calc",
                items: {
                  valType: "any",
                  editType: "calc"
                }
              },
              dvalue: {
                valType: "number",
                editType: "calc",
                min: 0,
                dflt: c
              },
              editType: "calc"
            }),
            tickmode: p,
            nticks: v(),
            tick0: g,
            dtick: m,
            ticklabelstep: {
              valType: "integer",
              min: 1,
              dflt: 1,
              editType: "ticks"
            },
            tickvals: y,
            ticktext: {
              valType: "data_array",
              editType: "ticks"
            },
            ticks: x,
            tickson: {
              valType: "enumerated",
              values: ["labels", "boundaries"],
              dflt: "labels",
              editType: "ticks"
            },
            ticklabelmode: {
              valType: "enumerated",
              values: ["instant", "period"],
              dflt: "instant",
              editType: "ticks"
            },
            ticklabelposition: {
              valType: "enumerated",
              values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"],
              dflt: "outside",
              editType: "calc"
            },
            ticklabeloverflow: {
              valType: "enumerated",
              values: ["allow", "hide past div", "hide past domain"],
              editType: "calc"
            },
            ticklabelshift: {
              valType: "integer",
              dflt: 0,
              editType: "ticks"
            },
            ticklabelstandoff: {
              valType: "integer",
              dflt: 0,
              editType: "ticks"
            },
            ticklabelindex: {
              valType: "integer",
              arrayOk: !0,
              editType: "calc"
            },
            mirror: {
              valType: "enumerated",
              values: [!0, "ticks", !1, "all", "allticks"],
              dflt: !1,
              editType: "ticks+layoutstyle"
            },
            ticklen: b(),
            tickwidth: _(),
            tickcolor: w,
            showticklabels: {
              valType: "boolean",
              dflt: !0,
              editType: "ticks"
            },
            labelalias: {
              valType: "any",
              dflt: !1,
              editType: "ticks"
            },
            automargin: {
              valType: "flaglist",
              flags: ["height", "width", "left", "right", "top", "bottom"],
              extras: [!0, !1],
              dflt: !1,
              editType: "ticks"
            },
            showspikes: {
              valType: "boolean",
              dflt: !1,
              editType: "modebar"
            },
            spikecolor: {
              valType: "color",
              dflt: null,
              editType: "none"
            },
            spikethickness: {
              valType: "number",
              dflt: 3,
              editType: "none"
            },
            spikedash: o({}, i, {
              dflt: "dash",
              editType: "none"
            }),
            spikemode: {
              valType: "flaglist",
              flags: ["toaxis", "across", "marker"],
              dflt: "toaxis",
              editType: "none"
            },
            spikesnap: {
              valType: "enumerated",
              values: ["data", "cursor", "hovered data"],
              dflt: "hovered data",
              editType: "none"
            },
            tickfont: n({
              editType: "ticks"
            }),
            tickangle: {
              valType: "angle",
              dflt: "auto",
              editType: "ticks"
            },
            autotickangles: {
              valType: "info_array",
              freeLength: !0,
              items: {
                valType: "angle"
              },
              dflt: [0, 30, 90],
              editType: "ticks"
            },
            tickprefix: {
              valType: "string",
              dflt: "",
              editType: "ticks"
            },
            showtickprefix: {
              valType: "enumerated",
              values: ["all", "first", "last", "none"],
              dflt: "all",
              editType: "ticks"
            },
            ticksuffix: {
              valType: "string",
              dflt: "",
              editType: "ticks"
            },
            showticksuffix: {
              valType: "enumerated",
              values: ["all", "first", "last", "none"],
              dflt: "all",
              editType: "ticks"
            },
            showexponent: {
              valType: "enumerated",
              values: ["all", "first", "last", "none"],
              dflt: "all",
              editType: "ticks"
            },
            exponentformat: {
              valType: "enumerated",
              values: ["none", "e", "E", "power", "SI", "B"],
              dflt: "B",
              editType: "ticks"
            },
            minexponent: {
              valType: "number",
              dflt: 3,
              min: 0,
              editType: "ticks"
            },
            separatethousands: {
              valType: "boolean",
              dflt: !1,
              editType: "ticks"
            },
            tickformat: {
              valType: "string",
              dflt: "",
              editType: "ticks",
              description: s("tick label")
            },
            tickformatstops: l("tickformatstop", {
              enabled: {
                valType: "boolean",
                dflt: !0,
                editType: "ticks"
              },
              dtickrange: {
                valType: "info_array",
                items: [{
                  valType: "any",
                  editType: "ticks"
                }, {
                  valType: "any",
                  editType: "ticks"
                }],
                editType: "ticks"
              },
              value: {
                valType: "string",
                dflt: "",
                editType: "ticks"
              },
              editType: "ticks"
            }),
            hoverformat: {
              valType: "string",
              dflt: "",
              editType: "none",
              description: s("hover text")
            },
            showline: {
              valType: "boolean",
              dflt: !1,
              editType: "ticks+layoutstyle"
            },
            linecolor: {
              valType: "color",
              dflt: a.defaultLine,
              editType: "layoutstyle"
            },
            linewidth: {
              valType: "number",
              min: 0,
              dflt: 1,
              editType: "ticks+layoutstyle"
            },
            showgrid: A,
            gridcolor: T,
            gridwidth: M(),
            griddash: k,
            zeroline: {
              valType: "boolean",
              editType: "ticks"
            },
            zerolinecolor: {
              valType: "color",
              dflt: a.defaultLine,
              editType: "ticks"
            },
            zerolinewidth: {
              valType: "number",
              dflt: 1,
              editType: "ticks"
            },
            showdividers: {
              valType: "boolean",
              dflt: !0,
              editType: "ticks"
            },
            dividercolor: {
              valType: "color",
              dflt: a.defaultLine,
              editType: "ticks"
            },
            dividerwidth: {
              valType: "number",
              dflt: 1,
              editType: "ticks"
            },
            anchor: {
              valType: "enumerated",
              values: ["free", u.idRegex.x.toString(), u.idRegex.y.toString()],
              editType: "plot"
            },
            side: {
              valType: "enumerated",
              values: ["top", "bottom", "left", "right"],
              editType: "plot"
            },
            overlaying: {
              valType: "enumerated",
              values: ["free", u.idRegex.x.toString(), u.idRegex.y.toString()],
              editType: "plot"
            },
            minor: {
              tickmode: h,
              nticks: v("minor"),
              tick0: g,
              dtick: m,
              tickvals: y,
              ticks: x,
              ticklen: b("minor"),
              tickwidth: _("minor"),
              tickcolor: w,
              gridcolor: T,
              gridwidth: M("minor"),
              griddash: k,
              showgrid: A,
              editType: "ticks"
            },
            layer: {
              valType: "enumerated",
              values: ["above traces", "below traces"],
              dflt: "above traces",
              editType: "plot"
            },
            domain: {
              valType: "info_array",
              items: [{
                valType: "number",
                min: 0,
                max: 1,
                editType: "plot"
              }, {
                valType: "number",
                min: 0,
                max: 1,
                editType: "plot"
              }],
              dflt: [0, 1],
              editType: "plot"
            },
            position: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 0,
              editType: "plot"
            },
            autoshift: {
              valType: "boolean",
              dflt: !1,
              editType: "plot"
            },
            shift: {
              valType: "number",
              editType: "plot"
            },
            categoryorder: {
              valType: "enumerated",
              values: ["trace", "category ascending", "category descending", "array", "total ascending", "total descending", "min ascending", "min descending", "max ascending", "max descending", "sum ascending", "sum descending", "mean ascending", "mean descending", "geometric mean ascending", "geometric mean descending", "median ascending", "median descending"],
              dflt: "trace",
              editType: "calc"
            },
            categoryarray: {
              valType: "data_array",
              editType: "calc"
            },
            uirevision: {
              valType: "any",
              editType: "none"
            },
            editType: "calc",
            _deprecated: {
              autotick: {
                valType: "boolean",
                editType: "ticks"
              },
              title: {
                valType: "string",
                editType: "ticks"
              },
              titlefont: n({
                editType: "ticks"
              })
            }
          };
        },
        4098: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8766),
            i = r(6040).isUnifiedHover,
            o = r(5265),
            l = r(8032),
            s = r(6704),
            c = r(5829),
            u = r(4392),
            f = r(7655),
            d = r(4391),
            h = r(957),
            p = r(5975),
            v = p.id2name,
            g = p.name2id,
            m = r(4826).AX_ID_PATTERN,
            y = r(3626),
            x = y.traceIs,
            b = y.getComponentMethod;
          function _(e, t, r) {
            Array.isArray(e[t]) ? e[t].push(r) : e[t] = [r];
          }
          e.exports = function (e, t, r) {
            var y,
              w,
              T = t.autotypenumbers,
              M = {},
              k = {},
              A = {},
              L = {},
              S = {},
              C = {},
              O = {},
              D = {},
              P = {},
              z = {};
            for (y = 0; y < r.length; y++) {
              var I = r[y];
              if (x(I, "cartesian") || x(I, "gl2d")) {
                var E, R;
                if (I.xaxis) E = v(I.xaxis), _(M, E, I);else if (I.xaxes) for (w = 0; w < I.xaxes.length; w++) _(M, v(I.xaxes[w]), I);
                if (I.yaxis) R = v(I.yaxis), _(M, R, I);else if (I.yaxes) for (w = 0; w < I.yaxes.length; w++) _(M, v(I.yaxes[w]), I);
                "funnel" === I.type ? "h" === I.orientation ? (E && (k[E] = !0), R && (O[R] = !0)) : R && (A[R] = !0) : "image" === I.type ? (R && (D[R] = !0), E && (D[E] = !0)) : (R && (S[R] = !0, C[R] = !0), x(I, "carpet") && ("carpet" !== I.type || I._cheater) || E && (L[E] = !0)), "carpet" === I.type && I._cheater && E && (k[E] = !0), x(I, "2dMap") && (P[E] = !0, P[R] = !0), x(I, "oriented") && (z["h" === I.orientation ? R : E] = !0);
              }
            }
            var N = t._subplots,
              F = N.xaxis,
              H = N.yaxis,
              B = n.simpleMap(F, v),
              j = n.simpleMap(H, v),
              Y = B.concat(j),
              V = a.background;
            F.length && H.length && (V = n.coerce(e, t, s, "plot_bgcolor"));
            var U,
              q,
              G,
              Z,
              W,
              J = a.combine(V, t.paper_bgcolor);
            function X() {
              var e = M[U] || [];
              W._traceIndices = e.map(function (e) {
                return e._expandedIndex;
              }), W._annIndices = [], W._shapeIndices = [], W._selectionIndices = [], W._imgIndices = [], W._subplotsWith = [], W._counterAxes = [], W._name = W._attr = U, W._id = q;
            }
            function K(e, t) {
              return n.coerce(Z, W, c, e, t);
            }
            function Q(e, t) {
              return n.coerce2(Z, W, c, e, t);
            }
            function $(e) {
              return "x" === e ? H : F;
            }
            function ee(t, r) {
              for (var n = "x" === t ? B : j, a = [], i = 0; i < n.length; i++) {
                var o = n[i];
                o === r || (e[o] || {}).overlaying || a.push(g(o));
              }
              return a;
            }
            var te = {
                x: $("x"),
                y: $("y")
              },
              re = te.x.concat(te.y),
              ne = {},
              ae = [];
            function ie() {
              var e = Z.matches;
              m.test(e) && -1 === re.indexOf(e) && (ne[e] = Z.type, ae = Object.keys(ne));
            }
            var oe = o(e, t),
              le = i(oe);
            for (y = 0; y < Y.length; y++) {
              U = Y[y], q = g(U), G = U.charAt(0), n.isPlainObject(e[U]) || (e[U] = {}), Z = e[U], W = l.newContainer(t, U, G + "axis"), X();
              var se = "x" === G && !L[U] && k[U] || "y" === G && !S[U] && A[U],
                ce = "y" === G && (!C[U] && O[U] || D[U]),
                ue = {
                  hasMinor: !0,
                  letter: G,
                  font: t.font,
                  outerTicks: P[U],
                  showGrid: !z[U],
                  data: M[U] || [],
                  bgColor: J,
                  calendar: t.calendar,
                  automargin: !0,
                  visibleDflt: se,
                  reverseDflt: ce,
                  autotypenumbersDflt: T,
                  splomStash: ((t._splomAxes || {})[G] || {})[q],
                  noAutotickangles: "y" === G
                };
              K("uirevision", t.uirevision), u(Z, W, K, ue), f(Z, W, K, ue, t);
              var fe = le && G === oe.charAt(0),
                de = Q("spikecolor", le ? W.color : void 0),
                he = Q("spikethickness", le ? 1.5 : void 0),
                pe = Q("spikedash", le ? "dot" : void 0),
                ve = Q("spikemode", le ? "across" : void 0),
                ge = Q("spikesnap");
              K("showspikes", !!(fe || de || he || pe || ve || ge)) || (delete W.spikecolor, delete W.spikethickness, delete W.spikedash, delete W.spikemode, delete W.spikesnap);
              var me = v(Z.overlaying),
                ye = [0, 1];
              if (void 0 !== t[me]) {
                var xe = v(t[me].anchor);
                void 0 !== t[xe] && (ye = t[xe].domain);
              }
              h(Z, W, K, {
                letter: G,
                counterAxes: te[G],
                overlayableAxes: ee(G, U),
                grid: t.grid,
                overlayingDomain: ye
              }), K("title.standoff"), ie(), W._input = Z;
            }
            for (y = 0; y < ae.length;) {
              q = ae[y++], G = (U = v(q)).charAt(0), n.isPlainObject(e[U]) || (e[U] = {}), Z = e[U], W = l.newContainer(t, U, G + "axis"), X();
              var be = {
                letter: G,
                font: t.font,
                outerTicks: P[U],
                showGrid: !z[U],
                data: [],
                bgColor: J,
                calendar: t.calendar,
                automargin: !0,
                visibleDflt: !1,
                reverseDflt: !1,
                autotypenumbersDflt: T,
                splomStash: ((t._splomAxes || {})[G] || {})[q]
              };
              K("uirevision", t.uirevision), W.type = ne[q] || "linear", f(Z, W, K, be, t), h(Z, W, K, {
                letter: G,
                counterAxes: te[G],
                overlayableAxes: ee(G, U),
                grid: t.grid
              }), K("fixedrange"), ie(), W._input = Z;
            }
            var _e = b("rangeslider", "handleDefaults"),
              we = b("rangeselector", "handleDefaults");
            for (y = 0; y < B.length; y++) U = B[y], Z = e[U], W = t[U], _e(e, t, U), "date" === W.type && we(Z, W, t, j, W.calendar), K("fixedrange");
            for (y = 0; y < j.length; y++) {
              U = j[y], Z = e[U], W = t[U];
              var Te = t[v(W.anchor)];
              K("fixedrange", b("rangeslider", "isVisible")(Te));
            }
            d.handleDefaults(e, t, {
              axIds: re.concat(ae).sort(p.idSort),
              axHasImage: D
            });
          };
        },
        7405: function (e, t, r) {
          "use strict";

          var n = r(5657).mix,
            a = r(229),
            i = r(4809);
          e.exports = function (e, t, r, o) {
            var l = (o = o || {}).dfltColor;
            function s(r, n) {
              return i.coerce2(e, t, o.attributes, r, n);
            }
            var c = s("linecolor", l),
              u = s("linewidth");
            r("showline", o.showLine || !!c || !!u) || (delete t.linecolor, delete t.linewidth);
            var f = s("gridcolor", n(l, o.bgColor, o.blend || a.lightFraction).toRgbString()),
              d = s("gridwidth"),
              h = s("griddash");
            if (r("showgrid", o.showGrid || !!f || !!d || !!h) || (delete t.gridcolor, delete t.gridwidth, delete t.griddash), o.hasMinor) {
              var p = s("minor.gridcolor", n(t.gridcolor, o.bgColor, 67).toRgbString()),
                v = s("minor.gridwidth", t.gridwidth || 1),
                g = s("minor.griddash", t.griddash || "solid");
              r("minor.showgrid", !!p || !!v || !!g) || (delete t.minor.gridcolor, delete t.minor.gridwidth, delete t.minor.griddash);
            }
            if (!o.noZeroLine) {
              var m = s("zerolinecolor", l),
                y = s("zerolinewidth");
              r("zeroline", o.showGrid || !!m || !!y) || (delete t.zerolinecolor, delete t.zerolinewidth);
            }
          };
        },
        957: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809);
          e.exports = function (e, t, r, i) {
            var o,
              l,
              s,
              c,
              u,
              f,
              d = i.counterAxes || [],
              h = i.overlayableAxes || [],
              p = i.letter,
              v = i.grid,
              g = i.overlayingDomain;
            v && (l = v._domains[p][v._axisMap[t._id]], o = v._anchors[t._id], l && (s = v[p + "side"].split(" ")[0], c = v.domain[p]["right" === s || "top" === s ? 1 : 0])), l = l || [0, 1], o = o || (n(e.position) ? "free" : d[0] || "free"), s = s || ("x" === p ? "bottom" : "left"), c = c || 0, u = 0, f = !1;
            var m = a.coerce(e, t, {
                anchor: {
                  valType: "enumerated",
                  values: ["free"].concat(d),
                  dflt: o
                }
              }, "anchor"),
              y = a.coerce(e, t, {
                side: {
                  valType: "enumerated",
                  values: "x" === p ? ["bottom", "top"] : ["left", "right"],
                  dflt: s
                }
              }, "side");
            "free" === m && ("y" === p && (r("autoshift") && (c = "left" === y ? g[0] : g[1], f = !t.automargin || t.automargin, u = "left" === y ? -3 : 3), r("shift", u)), r("position", c)), r("automargin", f);
            var x = !1;
            if (h.length && (x = a.coerce(e, t, {
              overlaying: {
                valType: "enumerated",
                values: [!1].concat(h),
                dflt: !1
              }
            }, "overlaying")), !x) {
              var b = r("domain", l);
              b[0] > b[1] - 1 / 4096 && (t.domain = l), a.noneOrAll(e.domain, t.domain, l), "sync" === t.tickmode && (t.tickmode = "auto");
            }
            return r("layer"), t;
          };
        },
        4616: function (e, t, r) {
          "use strict";

          var n = r(7703);
          e.exports = function (e, t, r, a, i) {
            i || (i = {});
            var o = i.tickSuffixDflt,
              l = n(e);
            r("tickprefix") && r("showtickprefix", l), r("ticksuffix", o) && r("showticksuffix", l);
          };
        },
        259: function (e, t, r) {
          "use strict";

          var n = r(5511);
          e.exports = function (e, t, r, a) {
            var i = t._template || {},
              o = t.type || i.type || "-";
            r("minallowed"), r("maxallowed");
            var l,
              s = r("range");
            s || a.noInsiderange || "log" === o || (!(l = r("insiderange")) || null !== l[0] && null !== l[1] || (t.insiderange = !1, l = void 0), l && (s = r("range", l)));
            var c,
              u = t.getAutorangeDflt(s, a),
              f = r("autorange", u);
            !s || (null !== s[0] || null !== s[1]) && (null !== s[0] && null !== s[1] || "reversed" !== f && !0 !== f) && (null === s[0] || "min" !== f && "max reversed" !== f) && (null === s[1] || "max" !== f && "min reversed" !== f) || (s = void 0, delete t.range, t.autorange = !0, c = !0), c || (f = r("autorange", u = t.getAutorangeDflt(s, a))), f && (n(r, f, s), "linear" !== o && "-" !== o || r("rangemode")), t.cleanRange();
          };
        },
        7611: function (e, t, r) {
          "use strict";

          var n = r(4530).FROM_BL;
          e.exports = function (e, t, r) {
            void 0 === r && (r = n[e.constraintoward || "center"]);
            var a = [e.r2l(e.range[0]), e.r2l(e.range[1])],
              i = a[0] + (a[1] - a[0]) * r;
            e.range = e._input.range = [e.l2r(i + (a[0] - i) * t), e.l2r(i + (a[1] - i) * t)], e.setScale();
          };
        },
        9091: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(2696).aL,
            i = r(4809),
            o = i.numberFormat,
            l = r(721),
            s = i.cleanNumber,
            c = i.ms2DateTime,
            u = i.dateTime2ms,
            f = i.ensureNumber,
            d = i.isArrayOrTypedArray,
            h = r(3821),
            p = h.FP_SAFE,
            v = h.BADNUM,
            g = h.LOG_CLIP,
            m = h.ONEWEEK,
            y = h.ONEDAY,
            x = h.ONEHOUR,
            b = h.ONEMIN,
            _ = h.ONESEC,
            w = r(5975),
            T = r(4826),
            M = T.HOUR_PATTERN,
            k = T.WEEKDAY_PATTERN;
          function A(e) {
            return Math.pow(10, e);
          }
          function L(e) {
            return null != e;
          }
          e.exports = function (e, t) {
            t = t || {};
            var r = e._id || "x",
              h = r.charAt(0);
            function S(t, r) {
              if (t > 0) return Math.log(t) / Math.LN10;
              if (t <= 0 && r && e.range && 2 === e.range.length) {
                var n = e.range[0],
                  a = e.range[1];
                return .5 * (n + a - 2 * g * Math.abs(n - a));
              }
              return v;
            }
            function C(t, r, n, a) {
              if ((a || {}).msUTC && l(t)) return +t;
              var o = u(t, n || e.calendar);
              if (o === v) {
                if (!l(t)) return v;
                t = +t;
                var s = Math.floor(10 * i.mod(t + .05, 1)),
                  c = Math.round(t - s / 10);
                o = u(new Date(c)) + s / 10;
              }
              return o;
            }
            function O(t, r, n) {
              return c(t, r, n || e.calendar);
            }
            function D(t) {
              return e._categories[Math.round(t)];
            }
            function P(t) {
              if (L(t)) {
                if (void 0 === e._categoriesMap && (e._categoriesMap = {}), void 0 !== e._categoriesMap[t]) return e._categoriesMap[t];
                e._categories.push("number" == typeof t ? String(t) : t);
                var r = e._categories.length - 1;
                return e._categoriesMap[t] = r, r;
              }
              return v;
            }
            function z(t) {
              if (e._categoriesMap) return e._categoriesMap[t];
            }
            function I(e) {
              var t = z(e);
              return void 0 !== t ? t : l(e) ? +e : void 0;
            }
            function E(e) {
              return l(e) ? +e : z(e);
            }
            function R(e, t, r) {
              return n.round(r + t * e, 2);
            }
            function N(e, t, r) {
              return (e - r) / t;
            }
            var F = function (t) {
                return l(t) ? R(t, e._m, e._b) : v;
              },
              H = function (t) {
                return N(t, e._m, e._b);
              };
            if (e.rangebreaks) {
              var B = "y" === h;
              F = function (t) {
                if (!l(t)) return v;
                var r = e._rangebreaks.length;
                if (!r) return R(t, e._m, e._b);
                var n = B;
                e.range[0] > e.range[1] && (n = !n);
                for (var a = n ? -1 : 1, i = a * t, o = 0, s = 0; s < r; s++) {
                  var c = a * e._rangebreaks[s].min,
                    u = a * e._rangebreaks[s].max;
                  if (i < c) break;
                  if (!(i > u)) {
                    o = i < (c + u) / 2 ? s : s + 1;
                    break;
                  }
                  o = s + 1;
                }
                var f = e._B[o] || 0;
                return isFinite(f) ? R(t, e._m2, f) : 0;
              }, H = function (t) {
                var r = e._rangebreaks.length;
                if (!r) return N(t, e._m, e._b);
                for (var n = 0, a = 0; a < r && !(t < e._rangebreaks[a].pmin); a++) t > e._rangebreaks[a].pmax && (n = a + 1);
                return N(t, e._m2, e._B[n]);
              };
            }
            e.c2l = "log" === e.type ? S : f, e.l2c = "log" === e.type ? A : f, e.l2p = F, e.p2l = H, e.c2p = "log" === e.type ? function (e, t) {
              return F(S(e, t));
            } : F, e.p2c = "log" === e.type ? function (e) {
              return A(H(e));
            } : H, -1 !== ["linear", "-"].indexOf(e.type) ? (e.d2r = e.r2d = e.d2c = e.r2c = e.d2l = e.r2l = s, e.c2d = e.c2r = e.l2d = e.l2r = f, e.d2p = e.r2p = function (t) {
              return e.l2p(s(t));
            }, e.p2d = e.p2r = H, e.cleanPos = f) : "log" === e.type ? (e.d2r = e.d2l = function (e, t) {
              return S(s(e), t);
            }, e.r2d = e.r2c = function (e) {
              return A(s(e));
            }, e.d2c = e.r2l = s, e.c2d = e.l2r = f, e.c2r = S, e.l2d = A, e.d2p = function (t, r) {
              return e.l2p(e.d2r(t, r));
            }, e.p2d = function (e) {
              return A(H(e));
            }, e.r2p = function (t) {
              return e.l2p(s(t));
            }, e.p2r = H, e.cleanPos = f) : "date" === e.type ? (e.d2r = e.r2d = i.identity, e.d2c = e.r2c = e.d2l = e.r2l = C, e.c2d = e.c2r = e.l2d = e.l2r = O, e.d2p = e.r2p = function (t, r, n) {
              return e.l2p(C(t, 0, n));
            }, e.p2d = e.p2r = function (e, t, r) {
              return O(H(e), t, r);
            }, e.cleanPos = function (t) {
              return i.cleanDate(t, v, e.calendar);
            }) : "category" === e.type ? (e.d2c = e.d2l = P, e.r2d = e.c2d = e.l2d = D, e.d2r = e.d2l_noadd = I, e.r2c = function (t) {
              var r = E(t);
              return void 0 !== r ? r : e.fraction2r(.5);
            }, e.l2r = e.c2r = f, e.r2l = E, e.d2p = function (t) {
              return e.l2p(e.r2c(t));
            }, e.p2d = function (e) {
              return D(H(e));
            }, e.r2p = e.d2p, e.p2r = H, e.cleanPos = function (e) {
              return "string" == typeof e && "" !== e ? e : f(e);
            }) : "multicategory" === e.type && (e.r2d = e.c2d = e.l2d = D, e.d2r = e.d2l_noadd = I, e.r2c = function (t) {
              var r = I(t);
              return void 0 !== r ? r : e.fraction2r(.5);
            }, e.r2c_just_indices = z, e.l2r = e.c2r = f, e.r2l = I, e.d2p = function (t) {
              return e.l2p(e.r2c(t));
            }, e.p2d = function (e) {
              return D(H(e));
            }, e.r2p = e.d2p, e.p2r = H, e.cleanPos = function (e) {
              return Array.isArray(e) || "string" == typeof e && "" !== e ? e : f(e);
            }, e.setupMultiCategory = function (n) {
              var a,
                o,
                l = e._traceIndices,
                s = e._matchGroup;
              if (s && 0 === e._categories.length) for (var c in s) if (c !== r) {
                var u = t[w.id2name(c)];
                l = l.concat(u._traceIndices);
              }
              var f = [[0, {}], [0, {}]],
                p = [];
              for (a = 0; a < l.length; a++) {
                var v = n[l[a]];
                if (h in v) {
                  var g = v[h],
                    m = v._length || i.minRowLength(g);
                  if (d(g[0]) && d(g[1])) for (o = 0; o < m; o++) {
                    var y = g[0][o],
                      x = g[1][o];
                    L(y) && L(x) && (p.push([y, x]), y in f[0][1] || (f[0][1][y] = f[0][0]++), x in f[1][1] || (f[1][1][x] = f[1][0]++));
                  }
                }
              }
              for (p.sort(function (e, t) {
                var r = f[0][1],
                  n = r[e[0]] - r[t[0]];
                if (n) return n;
                var a = f[1][1];
                return a[e[1]] - a[t[1]];
              }), a = 0; a < p.length; a++) P(p[a]);
            }), e.fraction2r = function (t) {
              var r = e.r2l(e.range[0]),
                n = e.r2l(e.range[1]);
              return e.l2r(r + t * (n - r));
            }, e.r2fraction = function (t) {
              var r = e.r2l(e.range[0]),
                n = e.r2l(e.range[1]);
              return (e.r2l(t) - r) / (n - r);
            }, e.limitRange = function (t) {
              var r = e.minallowed,
                n = e.maxallowed;
              if (void 0 !== r || void 0 !== n) {
                t || (t = "range");
                var a = i.nestedProperty(e, t).get(),
                  o = i.simpleMap(a, e.r2l),
                  l = o[1] < o[0];
                l && o.reverse();
                var s = i.simpleMap([r, n], e.r2l);
                if (void 0 !== r && o[0] < s[0] && (a[l ? 1 : 0] = r), void 0 !== n && o[1] > s[1] && (a[l ? 0 : 1] = n), a[0] === a[1]) {
                  var c = e.l2r(r),
                    u = e.l2r(n);
                  if (void 0 !== r) {
                    var f = c + 1;
                    void 0 !== n && (f = Math.min(f, u)), a[l ? 1 : 0] = f;
                  }
                  if (void 0 !== n) {
                    var d = u + 1;
                    void 0 !== r && (d = Math.max(d, c)), a[l ? 0 : 1] = d;
                  }
                }
              }
            }, e.cleanRange = function (t, r) {
              e._cleanRange(t, r), e.limitRange(t);
            }, e._cleanRange = function (t, r) {
              r || (r = {}), t || (t = "range");
              var n,
                a,
                o = i.nestedProperty(e, t).get();
              if (a = (a = "date" === e.type ? i.dfltRange(e.calendar) : "y" === h ? T.DFLTRANGEY : "realaxis" === e._name ? [0, 1] : r.dfltRange || T.DFLTRANGEX).slice(), "tozero" !== e.rangemode && "nonnegative" !== e.rangemode || (a[0] = 0), o && 2 === o.length) {
                var s = null === o[0],
                  c = null === o[1];
                for ("date" !== e.type || e.autorange || (o[0] = i.cleanDate(o[0], v, e.calendar), o[1] = i.cleanDate(o[1], v, e.calendar)), n = 0; n < 2; n++) if ("date" === e.type) {
                  if (!i.isDateTime(o[n], e.calendar)) {
                    e[t] = a;
                    break;
                  }
                  if (e.r2l(o[0]) === e.r2l(o[1])) {
                    var u = i.constrain(e.r2l(o[0]), i.MIN_MS + 1e3, i.MAX_MS - 1e3);
                    o[0] = e.l2r(u - 1e3), o[1] = e.l2r(u + 1e3);
                    break;
                  }
                } else {
                  if (!l(o[n])) {
                    if (s || c || !l(o[1 - n])) {
                      e[t] = a;
                      break;
                    }
                    o[n] = o[1 - n] * (n ? 10 : .1);
                  }
                  if (o[n] < -p ? o[n] = -p : o[n] > p && (o[n] = p), o[0] === o[1]) {
                    var f = Math.max(1, Math.abs(1e-6 * o[0]));
                    o[0] -= f, o[1] += f;
                  }
                }
              } else i.nestedProperty(e, t).set(a);
            }, e.setScale = function (r) {
              var n = t._size;
              if (e.overlaying) {
                var a = w.getFromId({
                  _fullLayout: t
                }, e.overlaying);
                e.domain = a.domain;
              }
              var i = r && e._r ? "_r" : "range",
                o = e.calendar;
              e.cleanRange(i);
              var l,
                s,
                c = e.r2l(e[i][0], o),
                u = e.r2l(e[i][1], o),
                f = "y" === h;
              if (f ? (e._offset = n.t + (1 - e.domain[1]) * n.h, e._length = n.h * (e.domain[1] - e.domain[0]), e._m = e._length / (c - u), e._b = -e._m * u) : (e._offset = n.l + e.domain[0] * n.w, e._length = n.w * (e.domain[1] - e.domain[0]), e._m = e._length / (u - c), e._b = -e._m * c), e._rangebreaks = [], e._lBreaks = 0, e._m2 = 0, e._B = [], e.rangebreaks && (e._rangebreaks = e.locateBreaks(Math.min(c, u), Math.max(c, u)), e._rangebreaks.length)) {
                for (l = 0; l < e._rangebreaks.length; l++) s = e._rangebreaks[l], e._lBreaks += Math.abs(s.max - s.min);
                var d = f;
                c > u && (d = !d), d && e._rangebreaks.reverse();
                var p = d ? -1 : 1;
                for (e._m2 = p * e._length / (Math.abs(u - c) - e._lBreaks), e._B.push(-e._m2 * (f ? u : c)), l = 0; l < e._rangebreaks.length; l++) s = e._rangebreaks[l], e._B.push(e._B[e._B.length - 1] - p * e._m2 * (s.max - s.min));
                for (l = 0; l < e._rangebreaks.length; l++) (s = e._rangebreaks[l]).pmin = F(s.min), s.pmax = F(s.max);
              }
              if (!isFinite(e._m) || !isFinite(e._b) || e._length < 0) throw t._replotting = !1, new Error("Something went wrong with axis scaling");
            }, e.maskBreaks = function (t) {
              var r,
                n,
                a,
                o,
                l,
                c = e.rangebreaks || [];
              c._cachedPatterns || (c._cachedPatterns = c.map(function (t) {
                return t.enabled && t.bounds ? i.simpleMap(t.bounds, t.pattern ? s : e.d2c) : null;
              })), c._cachedValues || (c._cachedValues = c.map(function (t) {
                return t.enabled && t.values ? i.simpleMap(t.values, e.d2c).sort(i.sorterAsc) : null;
              }));
              for (var u = 0; u < c.length; u++) {
                var f = c[u];
                if (f.enabled) if (f.bounds) {
                  var d = f.pattern;
                  switch (n = (r = c._cachedPatterns[u])[0], a = r[1], d) {
                    case k:
                      o = (l = new Date(t)).getUTCDay(), n > a && (a += 7, o < n && (o += 7));
                      break;
                    case M:
                      o = (l = new Date(t)).getUTCHours() + (l.getUTCMinutes() / 60 + l.getUTCSeconds() / 3600 + l.getUTCMilliseconds() / 36e5), n > a && (a += 24, o < n && (o += 24));
                      break;
                    case "":
                      o = t;
                  }
                  if (o >= n && o < a) return v;
                } else for (var h = c._cachedValues[u], p = 0; p < h.length; p++) if (a = (n = h[p]) + f.dvalue, t >= n && t < a) return v;
              }
              return t;
            }, e.locateBreaks = function (t, r) {
              var n,
                a,
                o,
                l,
                c = [];
              if (!e.rangebreaks) return c;
              var u = e.rangebreaks.slice().sort(function (e, t) {
                  return e.pattern === k && t.pattern === M ? -1 : t.pattern === k && e.pattern === M ? 1 : 0;
                }),
                f = function (e, n) {
                  if ((e = i.constrain(e, t, r)) !== (n = i.constrain(n, t, r))) {
                    for (var a = !0, o = 0; o < c.length; o++) {
                      var l = c[o];
                      e < l.max && n >= l.min && (e < l.min && (l.min = e), n > l.max && (l.max = n), a = !1);
                    }
                    a && c.push({
                      min: e,
                      max: n
                    });
                  }
                };
              for (n = 0; n < u.length; n++) {
                var d = u[n];
                if (d.enabled) if (d.bounds) {
                  var h = t,
                    p = r;
                  d.pattern && (h = Math.floor(h)), o = (a = i.simpleMap(d.bounds, d.pattern ? s : e.r2l))[0], l = a[1];
                  var v,
                    g,
                    w = new Date(h);
                  switch (d.pattern) {
                    case k:
                      g = m, v = (l - o + (l < o ? 7 : 0)) * y, h += o * y - (w.getUTCDay() * y + w.getUTCHours() * x + w.getUTCMinutes() * b + w.getUTCSeconds() * _ + w.getUTCMilliseconds());
                      break;
                    case M:
                      g = y, v = (l - o + (l < o ? 24 : 0)) * x, h += o * x - (w.getUTCHours() * x + w.getUTCMinutes() * b + w.getUTCSeconds() * _ + w.getUTCMilliseconds());
                      break;
                    default:
                      h = Math.min(a[0], a[1]), v = g = (p = Math.max(a[0], a[1])) - h;
                  }
                  for (var T = h; T < p; T += g) f(T, T + v);
                } else for (var A = i.simpleMap(d.values, e.d2c), L = 0; L < A.length; L++) f(o = A[L], l = o + d.dvalue);
              }
              return c.sort(function (e, t) {
                return e.min - t.min;
              }), c;
            }, e.makeCalcdata = function (t, r, n) {
              var a,
                o,
                l,
                s,
                c = e.type,
                u = "date" === c && t[r + "calendar"];
              if (r in t) {
                if (a = t[r], s = t._length || i.minRowLength(a), i.isTypedArray(a) && ("linear" === c || "log" === c)) {
                  if (s === a.length) return a;
                  if (a.subarray) return a.subarray(0, s);
                }
                if ("multicategory" === c) return function (e, t) {
                  for (var r = new Array(t), n = 0; n < t; n++) {
                    var a = (e[0] || [])[n],
                      i = (e[1] || [])[n];
                    r[n] = z([a, i]);
                  }
                  return r;
                }(a, s);
                for (o = new Array(s), l = 0; l < s; l++) o[l] = e.d2c(a[l], 0, u, n);
              } else {
                var f = r + "0" in t ? e.d2c(t[r + "0"], 0, u) : 0,
                  d = t["d" + r] ? Number(t["d" + r]) : 1;
                for (a = t[{
                  x: "y",
                  y: "x"
                }[r]], s = t._length || a.length, o = new Array(s), l = 0; l < s; l++) o[l] = f + l * d;
              }
              if (e.rangebreaks) for (l = 0; l < s; l++) o[l] = e.maskBreaks(o[l]);
              return o;
            }, e.isValidRange = function (t, r) {
              return Array.isArray(t) && 2 === t.length && (r && null === t[0] || l(e.r2l(t[0]))) && (r && null === t[1] || l(e.r2l(t[1])));
            }, e.getAutorangeDflt = function (t, r) {
              var n = !e.isValidRange(t, "nullOk");
              return n && r && r.reverseDflt ? n = "reversed" : t && (null === t[0] && null === t[1] ? n = !0 : null === t[0] && null !== t[1] ? n = "min" : null !== t[0] && null === t[1] && (n = "max")), n;
            }, e.isReversed = function () {
              var t = e.autorange;
              return "reversed" === t || "min reversed" === t || "max reversed" === t;
            }, e.isPtWithinRange = function (t, r) {
              var n = e.c2l(t[h], null, r),
                a = e.r2l(e.range[0]),
                i = e.r2l(e.range[1]);
              return a < i ? a <= n && n <= i : i <= n && n <= a;
            }, e._emptyCategories = function () {
              e._categories = [], e._categoriesMap = {};
            }, e.clearCalc = function () {
              var r = e._matchGroup;
              if (r) {
                var n = null,
                  a = null;
                for (var i in r) {
                  var o = t[w.id2name(i)];
                  if (o._categories) {
                    n = o._categories, a = o._categoriesMap;
                    break;
                  }
                }
                n && a ? (e._categories = n, e._categoriesMap = a) : e._emptyCategories();
              } else e._emptyCategories();
              if (e._initialCategories) for (var l = 0; l < e._initialCategories.length; l++) P(e._initialCategories[l]);
            }, e.sortByInitialCategories = function () {
              var n = [];
              if (e._emptyCategories(), e._initialCategories) for (var a = 0; a < e._initialCategories.length; a++) P(e._initialCategories[a]);
              n = n.concat(e._traceIndices);
              var i = e._matchGroup;
              for (var o in i) if (r !== o) {
                var l = t[w.id2name(o)];
                l._categories = e._categories, l._categoriesMap = e._categoriesMap, n = n.concat(l._traceIndices);
              }
              return n;
            };
            var j = t._d3locale;
            "date" === e.type && (e._dateFormat = j ? j.timeFormat : a, e._extraFormat = t._extraFormat), e._separators = t.separators, e._numFormat = j ? j.numberFormat : o, delete e._minDtick, delete e._forceTick0;
          };
        },
        7703: function (e) {
          "use strict";

          e.exports = function (e) {
            var t = ["showexponent", "showtickprefix", "showticksuffix"].filter(function (t) {
              return void 0 !== e[t];
            });
            if (t.every(function (r) {
              return e[r] === e[t[0]];
            }) || 1 === t.length) return e[t[0]];
          };
        },
        2036: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(8766).contrast,
            i = r(5829),
            o = r(7703),
            l = r(9008);
          function s(e, t) {
            function r(r, a) {
              return n.coerce(e, t, i.tickformatstops, r, a);
            }
            r("enabled") && (r("dtickrange"), r("value"));
          }
          e.exports = function (e, t, r, c, u) {
            u || (u = {});
            var f = r("labelalias");
            n.isPlainObject(f) || delete t.labelalias;
            var d = o(e);
            if (r("showticklabels")) {
              u.noTicklabelshift || r("ticklabelshift"), u.noTicklabelstandoff || r("ticklabelstandoff");
              var h = u.font || {},
                p = t.color,
                v = -1 !== (t.ticklabelposition || "").indexOf("inside") ? a(u.bgColor) : p && p !== i.color.dflt ? p : h.color;
              if (n.coerceFont(r, "tickfont", h, {
                overrideDflt: {
                  color: v
                }
              }), u.noTicklabelstep || "multicategory" === c || "log" === c || r("ticklabelstep"), !u.noAng) {
                var g = r("tickangle");
                u.noAutotickangles || "auto" !== g || r("autotickangles");
              }
              if ("category" !== c) {
                var m = r("tickformat");
                l(e, t, {
                  name: "tickformatstops",
                  inclusionAttr: "enabled",
                  handleItemDefaults: s
                }), t.tickformatstops.length || delete t.tickformatstops, u.noExp || m || "date" === c || (r("showexponent", d), r("exponentformat"), r("minexponent"), r("separatethousands"));
              }
            }
          };
        },
        7433: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(5829);
          e.exports = function (e, t, r, i) {
            var o = i.isMinor,
              l = o ? e.minor || {} : e,
              s = o ? t.minor : t,
              c = o ? a.minor : a,
              u = o ? "minor." : "",
              f = n.coerce2(l, s, c, "ticklen", o ? .6 * (t.ticklen || 5) : void 0),
              d = n.coerce2(l, s, c, "tickwidth", o ? t.tickwidth || 1 : void 0),
              h = n.coerce2(l, s, c, "tickcolor", (o ? t.tickcolor : void 0) || s.color);
            r(u + "ticks", !o && i.outerTicks || f || d || h ? "outside" : "") || (delete s.ticklen, delete s.tickwidth, delete s.tickcolor);
          };
        },
        2777: function (e, t, r) {
          "use strict";

          var n = r(8599),
            a = r(4809).isArrayOrTypedArray,
            i = r(7800).isTypedArraySpec,
            o = r(7800).decodeTypedArraySpec;
          e.exports = function (e, t, r, l, s) {
            s || (s = {});
            var c = s.isMinor,
              u = c ? e.minor || {} : e,
              f = c ? t.minor : t,
              d = c ? "minor." : "";
            function h(e) {
              var t = u[e];
              return i(t) && (t = o(t)), void 0 !== t ? t : (f._template || {})[e];
            }
            var p = h("tick0"),
              v = h("dtick"),
              g = h("tickvals"),
              m = r(d + "tickmode", a(g) ? "array" : v ? "linear" : "auto");
            if ("auto" === m || "sync" === m) r(d + "nticks");else if ("linear" === m) {
              var y = f.dtick = n.dtick(v, l);
              f.tick0 = n.tick0(p, l, t.calendar, y);
            } else "multicategory" !== l && (void 0 === r(d + "tickvals") ? f.tickmode = "auto" : c || r("ticktext"));
          };
        },
        4982: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(3626),
            i = r(4809),
            o = r(2203),
            l = r(9714);
          e.exports = function (e, t, r, s) {
            var c = e._fullLayout;
            if (0 !== t.length) {
              var u, f, d, h;
              s && (u = s());
              var p = n.ease(r.easing);
              return e._transitionData._interruptCallbacks.push(function () {
                return window.cancelAnimationFrame(h), h = null, function () {
                  for (var r = {}, n = 0; n < t.length; n++) {
                    var i = t[n],
                      o = i.plotinfo.xaxis,
                      l = i.plotinfo.yaxis;
                    i.xr0 && (r[o._name + ".range"] = i.xr0.slice()), i.yr0 && (r[l._name + ".range"] = i.yr0.slice());
                  }
                  return a.call("relayout", e, r).then(function () {
                    for (var e = 0; e < t.length; e++) v(t[e].plotinfo);
                  });
                }();
              }), f = Date.now(), h = window.requestAnimationFrame(function n() {
                d = Date.now();
                for (var i = Math.min(1, (d - f) / r.duration), o = p(i), l = 0; l < t.length; l++) g(t[l], o);
                d - f > r.duration ? (function () {
                  for (var r = {}, n = 0; n < t.length; n++) {
                    var i = t[n],
                      o = i.plotinfo.xaxis,
                      l = i.plotinfo.yaxis;
                    i.xr1 && (r[o._name + ".range"] = i.xr1.slice()), i.yr1 && (r[l._name + ".range"] = i.yr1.slice());
                  }
                  u && u(), a.call("relayout", e, r).then(function () {
                    for (var e = 0; e < t.length; e++) v(t[e].plotinfo);
                  });
                }(), h = window.cancelAnimationFrame(n)) : h = window.requestAnimationFrame(n);
              }), Promise.resolve();
            }
            function v(e) {
              var t = e.xaxis,
                r = e.yaxis;
              c._defs.select("#" + e.clipId + "> rect").call(o.setTranslate, 0, 0).call(o.setScale, 1, 1), e.plot.call(o.setTranslate, t._offset, r._offset).call(o.setScale, 1, 1);
              var n = e.plot.selectAll(".scatterlayer .trace");
              n.selectAll(".point").call(o.setPointGroupScale, 1, 1), n.selectAll(".textpoint").call(o.setTextPointsScale, 1, 1), n.call(o.hideOutsideRangePoints, e);
            }
            function g(t, r) {
              var n = t.plotinfo,
                a = n.xaxis,
                s = n.yaxis,
                c = a._length,
                u = s._length,
                f = !!t.xr1,
                d = !!t.yr1,
                h = [];
              if (f) {
                var p = i.simpleMap(t.xr0, a.r2l),
                  v = i.simpleMap(t.xr1, a.r2l),
                  g = p[1] - p[0],
                  m = v[1] - v[0];
                h[0] = (p[0] * (1 - r) + r * v[0] - p[0]) / (p[1] - p[0]) * c, h[2] = c * (1 - r + r * m / g), a.range[0] = a.l2r(p[0] * (1 - r) + r * v[0]), a.range[1] = a.l2r(p[1] * (1 - r) + r * v[1]);
              } else h[0] = 0, h[2] = c;
              if (d) {
                var y = i.simpleMap(t.yr0, s.r2l),
                  x = i.simpleMap(t.yr1, s.r2l),
                  b = y[1] - y[0],
                  _ = x[1] - x[0];
                h[1] = (y[1] * (1 - r) + r * x[1] - y[1]) / (y[0] - y[1]) * u, h[3] = u * (1 - r + r * _ / b), s.range[0] = a.l2r(y[0] * (1 - r) + r * x[0]), s.range[1] = s.l2r(y[1] * (1 - r) + r * x[1]);
              } else h[1] = 0, h[3] = u;
              l.drawOne(e, a, {
                skipTitle: !0
              }), l.drawOne(e, s, {
                skipTitle: !0
              }), l.redrawComponents(e, [a._id, s._id]);
              var w = f ? c / h[2] : 1,
                T = d ? u / h[3] : 1,
                M = f ? h[0] : 0,
                k = d ? h[1] : 0,
                A = f ? h[0] / h[2] * c : 0,
                L = d ? h[1] / h[3] * u : 0,
                S = a._offset - A,
                C = s._offset - L;
              n.clipRect.call(o.setTranslate, M, k).call(o.setScale, 1 / w, 1 / T), n.plot.call(o.setTranslate, S, C).call(o.setScale, w, T), o.setPointGroupScale(n.zoomScalePts, 1 / w, 1 / T), o.setTextPointsScale(n.zoomScaleTxt, 1 / w, 1 / T);
            }
            l.redrawComponents(e);
          };
        },
        4392: function (e, t, r) {
          "use strict";

          var n = r(3626).traceIs,
            a = r(9666);
          function i(e) {
            return {
              v: "x",
              h: "y"
            }[e.orientation || "v"];
          }
          function o(e, t) {
            var r = i(e),
              a = n(e, "box-violin"),
              o = n(e._fullInput || {}, "candlestick");
            return a && !o && t === r && void 0 === e[r] && void 0 === e[r + "0"];
          }
          e.exports = function (e, t, r, l) {
            r("autotypenumbers", l.autotypenumbersDflt), "-" === r("type", (l.splomStash || {}).type) && (function (e, t) {
              if ("-" === e.type) {
                var r,
                  l = e._id,
                  s = l.charAt(0);
                -1 !== l.indexOf("scene") && (l = s);
                var c = function (e, t, r) {
                  for (var n = 0; n < e.length; n++) {
                    var a = e[n];
                    if ("splom" === a.type && a._length > 0 && (a["_" + r + "axes"] || {})[t]) return a;
                    if ((a[r + "axis"] || r) === t) {
                      if (o(a, r)) return a;
                      if ((a[r] || []).length || a[r + "0"]) return a;
                    }
                  }
                }(t, l, s);
                if (c) if ("histogram" !== c.type || s !== {
                  v: "y",
                  h: "x"
                }[c.orientation || "v"]) {
                  var u = s + "calendar",
                    f = c[u],
                    d = {
                      noMultiCategory: !n(c, "cartesian") || n(c, "noMultiCategory")
                    };
                  if ("box" === c.type && c._hasPreCompStats && s === {
                    h: "x",
                    v: "y"
                  }[c.orientation || "v"] && (d.noMultiCategory = !0), d.autotypenumbers = e.autotypenumbers, o(c, s)) {
                    var h = i(c),
                      p = [];
                    for (r = 0; r < t.length; r++) {
                      var v = t[r];
                      n(v, "box-violin") && (v[s + "axis"] || s) === l && (void 0 !== v[h] ? p.push(v[h][0]) : void 0 !== v.name ? p.push(v.name) : p.push("text"), v[u] !== f && (f = void 0));
                    }
                    e.type = a(p, f, d);
                  } else if ("splom" === c.type) {
                    var g = c.dimensions[c._axesDim[l]];
                    g.visible && (e.type = a(g.values, f, d));
                  } else e.type = a(c[s] || [c[s + "0"]], f, d);
                } else e.type = "linear";
              }
            }(t, l.data), "-" === t.type ? t.type = "linear" : e.type = t.type);
          };
        },
        251: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(4809);
          function i(e, t, r) {
            var n,
              i,
              o,
              l = !1;
            if ("data" === t.type) n = e._fullData[null !== t.traces ? t.traces[0] : 0];else {
              if ("layout" !== t.type) return !1;
              n = e._fullLayout;
            }
            return i = a.nestedProperty(n, t.prop).get(), (o = r[t.type] = r[t.type] || {}).hasOwnProperty(t.prop) && o[t.prop] !== i && (l = !0), o[t.prop] = i, {
              changed: l,
              value: i
            };
          }
          function o(e, t) {
            var r = [],
              n = t[0],
              i = {};
            if ("string" == typeof n) i[n] = t[1];else {
              if (!a.isPlainObject(n)) return r;
              i = n;
            }
            return s(i, function (e, t, n) {
              r.push({
                type: "layout",
                prop: e,
                value: n
              });
            }, "", 0), r;
          }
          function l(e, t) {
            var r,
              n,
              i,
              o,
              l = [];
            if (n = t[0], i = t[1], r = t[2], o = {}, "string" == typeof n) o[n] = i;else {
              if (!a.isPlainObject(n)) return l;
              o = n, void 0 === r && (r = i);
            }
            return void 0 === r && (r = null), s(o, function (t, n, a) {
              var i, o;
              if (Array.isArray(a)) {
                o = a.slice();
                var s = Math.min(o.length, e.data.length);
                r && (s = Math.min(s, r.length)), i = [];
                for (var c = 0; c < s; c++) i[c] = r ? r[c] : c;
              } else o = a, i = r ? r.slice() : null;
              if (null === i) Array.isArray(o) && (o = o[0]);else if (Array.isArray(i)) {
                if (!Array.isArray(o)) {
                  var u = o;
                  o = [];
                  for (var f = 0; f < i.length; f++) o[f] = u;
                }
                o.length = Math.min(i.length, o.length);
              }
              l.push({
                type: "data",
                prop: t,
                traces: i,
                value: o
              });
            }, "", 0), l;
          }
          function s(e, t, r, n) {
            Object.keys(e).forEach(function (i) {
              var o = e[i];
              if ("_" !== i[0]) {
                var l = r + (n > 0 ? "." : "") + i;
                a.isPlainObject(o) ? s(o, t, l, n + 1) : t(l, i, o);
              }
            });
          }
          t.manageCommandObserver = function (e, r, n, o) {
            var l = {},
              s = !0;
            r && r._commandObserver && (l = r._commandObserver), l.cache || (l.cache = {}), l.lookupTable = {};
            var c = t.hasSimpleAPICommandBindings(e, n, l.lookupTable);
            if (r && r._commandObserver) {
              if (c) return l;
              if (r._commandObserver.remove) return r._commandObserver.remove(), r._commandObserver = null, l;
            }
            if (c) {
              i(e, c, l.cache), l.check = function () {
                if (s) {
                  var t = i(e, c, l.cache);
                  return t.changed && o && void 0 !== l.lookupTable[t.value] && (l.disable(), Promise.resolve(o({
                    value: t.value,
                    type: c.type,
                    prop: c.prop,
                    traces: c.traces,
                    index: l.lookupTable[t.value]
                  })).then(l.enable, l.enable)), t.changed;
                }
              };
              for (var u = ["plotly_relayout", "plotly_redraw", "plotly_restyle", "plotly_update", "plotly_animatingframe", "plotly_afterplot"], f = 0; f < u.length; f++) e._internalOn(u[f], l.check);
              l.remove = function () {
                for (var t = 0; t < u.length; t++) e._removeInternalListener(u[t], l.check);
              };
            } else a.log("Unable to automatically bind plot updates to API command"), l.lookupTable = {}, l.remove = function () {};
            return l.disable = function () {
              s = !1;
            }, l.enable = function () {
              s = !0;
            }, r && (r._commandObserver = l), l;
          }, t.hasSimpleAPICommandBindings = function (e, r, n) {
            var a,
              i,
              o = r.length;
            for (a = 0; a < o; a++) {
              var l,
                s = r[a],
                c = s.method,
                u = s.args;
              if (Array.isArray(u) || (u = []), !c) return !1;
              var f = t.computeAPICommandBindings(e, c, u);
              if (1 !== f.length) return !1;
              if (i) {
                if ((l = f[0]).type !== i.type) return !1;
                if (l.prop !== i.prop) return !1;
                if (Array.isArray(i.traces)) {
                  if (!Array.isArray(l.traces)) return !1;
                  l.traces.sort();
                  for (var d = 0; d < i.traces.length; d++) if (i.traces[d] !== l.traces[d]) return !1;
                } else if (l.prop !== i.prop) return !1;
              } else i = f[0], Array.isArray(i.traces) && i.traces.sort();
              var h = (l = f[0]).value;
              if (Array.isArray(h)) {
                if (1 !== h.length) return !1;
                h = h[0];
              }
              n && (n[h] = a);
            }
            return i;
          }, t.executeAPICommand = function (e, t, r) {
            if ("skip" === t) return Promise.resolve();
            var i = n.apiMethodRegistry[t],
              o = [e];
            Array.isArray(r) || (r = []);
            for (var l = 0; l < r.length; l++) o.push(r[l]);
            return i.apply(null, o).catch(function (e) {
              return a.warn("API call to Plotly." + t + " rejected.", e), Promise.reject(e);
            });
          }, t.computeAPICommandBindings = function (e, t, r) {
            var n;
            switch (Array.isArray(r) || (r = []), t) {
              case "restyle":
                n = l(e, r);
                break;
              case "relayout":
                n = o(0, r);
                break;
              case "update":
                n = l(e, [r[0], r[2]]).concat(o(0, [r[1]]));
                break;
              case "animate":
                n = function (e, t) {
                  return Array.isArray(t[0]) && 1 === t[0].length && -1 !== ["string", "number"].indexOf(typeof t[0][0]) ? [{
                    type: "layout",
                    prop: "_currentFrame",
                    value: t[0][0].toString()
                  }] : [];
                }(0, r);
                break;
              default:
                n = [];
            }
            return n;
          };
        },
        3792: function (e, t, r) {
          "use strict";

          var n = r(3049).extendFlat;
          t.u = function (e, t) {
            t = t || {};
            var r = {
                valType: "info_array",
                editType: (e = e || {}).editType,
                items: [{
                  valType: "number",
                  min: 0,
                  max: 1,
                  editType: e.editType
                }, {
                  valType: "number",
                  min: 0,
                  max: 1,
                  editType: e.editType
                }],
                dflt: [0, 1]
              },
              a = (e.name && e.name, e.trace, t.description && t.description, {
                x: n({}, r, {}),
                y: n({}, r, {}),
                editType: e.editType
              });
            return e.noGridCell || (a.row = {
              valType: "integer",
              min: 0,
              dflt: 0,
              editType: e.editType
            }, a.column = {
              valType: "integer",
              min: 0,
              dflt: 0,
              editType: e.editType
            }), a;
          }, t.N = function (e, t, r, n) {
            var a = n && n.x || [0, 1],
              i = n && n.y || [0, 1],
              o = t.grid;
            if (o) {
              var l = r("domain.column");
              void 0 !== l && (l < o.columns ? a = o._domains.x[l] : delete e.domain.column);
              var s = r("domain.row");
              void 0 !== s && (s < o.rows ? i = o._domains.y[s] : delete e.domain.row);
            }
            var c = r("domain.x", a),
              u = r("domain.y", i);
            c[0] < c[1] || (e.domain.x = a.slice()), u[0] < u[1] || (e.domain.y = i.slice());
          };
        },
        337: function (e) {
          "use strict";

          e.exports = function (e) {
            var t = e.variantValues,
              r = e.editType,
              n = e.colorEditType;
            void 0 === n && (n = r);
            var a = {
              editType: r,
              valType: "integer",
              min: 1,
              max: 1e3,
              extras: ["normal", "bold"],
              dflt: "normal"
            };
            e.noNumericWeightValues && (a.valType = "enumerated", a.values = a.extras, a.extras = void 0, a.min = void 0, a.max = void 0);
            var i = {
              family: {
                valType: "string",
                noBlank: !0,
                strict: !0,
                editType: r
              },
              size: {
                valType: "number",
                min: 1,
                editType: r
              },
              color: {
                valType: "color",
                editType: n
              },
              weight: a,
              style: {
                editType: r,
                valType: "enumerated",
                values: ["normal", "italic"],
                dflt: "normal"
              },
              variant: e.noFontVariant ? void 0 : {
                editType: r,
                valType: "enumerated",
                values: t || ["normal", "small-caps", "all-small-caps", "all-petite-caps", "petite-caps", "unicase"],
                dflt: "normal"
              },
              textcase: e.noFontTextcase ? void 0 : {
                editType: r,
                valType: "enumerated",
                values: ["normal", "word caps", "upper", "lower"],
                dflt: "normal"
              },
              lineposition: e.noFontLineposition ? void 0 : {
                editType: r,
                valType: "flaglist",
                flags: ["under", "over", "through"],
                extras: ["none"],
                dflt: "none"
              },
              shadow: e.noFontShadow ? void 0 : {
                editType: r,
                valType: "string",
                dflt: e.autoShadowDflt ? "auto" : "none"
              },
              editType: r
            };
            return e.autoSize && (i.size.dflt = "auto"), e.autoColor && (i.color.dflt = "auto"), e.arrayOk && (i.family.arrayOk = !0, i.weight.arrayOk = !0, i.style.arrayOk = !0, e.noFontVariant || (i.variant.arrayOk = !0), e.noFontTextcase || (i.textcase.arrayOk = !0), e.noFontLineposition || (i.lineposition.arrayOk = !0), e.noFontShadow || (i.shadow.arrayOk = !0), i.size.arrayOk = !0, i.color.arrayOk = !0), i;
          };
        },
        8935: function (e) {
          "use strict";

          e.exports = {
            _isLinkedToArray: "frames_entry",
            group: {
              valType: "string"
            },
            name: {
              valType: "string"
            },
            traces: {
              valType: "any"
            },
            baseframe: {
              valType: "string"
            },
            data: {
              valType: "any"
            },
            layout: {
              valType: "any"
            }
          };
        },
        4173: function (e, t, r) {
          "use strict";

          var n = r(3626);
          r(4826).SUBPLOT_PATTERN;
          t.eV = function (e, t, r) {
            var a,
              i = [],
              o = [];
            if (!(a = "string" == typeof t ? n.getModule(t).plot : "function" == typeof t ? t : t.plot)) return [i, e];
            for (var l = r, s = 0; s < e.length; s++) {
              var c = e[s],
                u = c[0].trace,
                f = void 0 !== u.zorder;
              !0 === u.visible && 0 !== u._length && (!u._module || u._module.plot !== a || f && u.zorder !== l ? o.push(c) : i.push(c));
            }
            return [i, o];
          };
        },
        5802: function (e) {
          "use strict";

          function t(e, t) {
            var r,
              n,
              a = [0, 0, 0, 0];
            for (r = 0; r < 4; ++r) for (n = 0; n < 4; ++n) a[n] += e[4 * r + n] * t[r];
            return a;
          }
          e.exports = function (e, r) {
            return t(e.projection, t(e.view, t(e.model, [r[0], r[1], r[2], 1])));
          };
        },
        6704: function (e, t, r) {
          "use strict";

          var n = r(337),
            a = r(9722),
            i = r(229),
            o = r(4101),
            l = r(2307),
            s = r(7891),
            c = r(3049).extendFlat,
            u = n({
              editType: "calc"
            });
          u.family.dflt = '"Open Sans", verdana, arial, sans-serif', u.size.dflt = 12, u.color.dflt = i.defaultLine, e.exports = {
            font: u,
            title: {
              text: {
                valType: "string",
                editType: "layoutstyle"
              },
              font: n({
                editType: "layoutstyle"
              }),
              subtitle: {
                text: {
                  valType: "string",
                  editType: "layoutstyle"
                },
                font: n({
                  editType: "layoutstyle"
                }),
                editType: "layoutstyle"
              },
              xref: {
                valType: "enumerated",
                dflt: "container",
                values: ["container", "paper"],
                editType: "layoutstyle"
              },
              yref: {
                valType: "enumerated",
                dflt: "container",
                values: ["container", "paper"],
                editType: "layoutstyle"
              },
              x: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: .5,
                editType: "layoutstyle"
              },
              y: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: "auto",
                editType: "layoutstyle"
              },
              xanchor: {
                valType: "enumerated",
                dflt: "auto",
                values: ["auto", "left", "center", "right"],
                editType: "layoutstyle"
              },
              yanchor: {
                valType: "enumerated",
                dflt: "auto",
                values: ["auto", "top", "middle", "bottom"],
                editType: "layoutstyle"
              },
              pad: c(s({
                editType: "layoutstyle"
              }), {}),
              automargin: {
                valType: "boolean",
                dflt: !1,
                editType: "plot"
              },
              editType: "layoutstyle"
            },
            uniformtext: {
              mode: {
                valType: "enumerated",
                values: [!1, "hide", "show"],
                dflt: !1,
                editType: "plot"
              },
              minsize: {
                valType: "number",
                min: 0,
                dflt: 0,
                editType: "plot"
              },
              editType: "plot"
            },
            autosize: {
              valType: "boolean",
              dflt: !1,
              editType: "none"
            },
            width: {
              valType: "number",
              min: 10,
              dflt: 700,
              editType: "plot"
            },
            height: {
              valType: "number",
              min: 10,
              dflt: 450,
              editType: "plot"
            },
            minreducedwidth: {
              valType: "number",
              min: 2,
              dflt: 64,
              editType: "plot"
            },
            minreducedheight: {
              valType: "number",
              min: 2,
              dflt: 64,
              editType: "plot"
            },
            margin: {
              l: {
                valType: "number",
                min: 0,
                dflt: 80,
                editType: "plot"
              },
              r: {
                valType: "number",
                min: 0,
                dflt: 80,
                editType: "plot"
              },
              t: {
                valType: "number",
                min: 0,
                dflt: 100,
                editType: "plot"
              },
              b: {
                valType: "number",
                min: 0,
                dflt: 80,
                editType: "plot"
              },
              pad: {
                valType: "number",
                min: 0,
                dflt: 0,
                editType: "plot"
              },
              autoexpand: {
                valType: "boolean",
                dflt: !0,
                editType: "plot"
              },
              editType: "plot"
            },
            computed: {
              valType: "any",
              editType: "none"
            },
            paper_bgcolor: {
              valType: "color",
              dflt: i.background,
              editType: "plot"
            },
            plot_bgcolor: {
              valType: "color",
              dflt: i.background,
              editType: "layoutstyle"
            },
            autotypenumbers: {
              valType: "enumerated",
              values: ["convert types", "strict"],
              dflt: "convert types",
              editType: "calc"
            },
            separators: {
              valType: "string",
              editType: "plot"
            },
            hidesources: {
              valType: "boolean",
              dflt: !1,
              editType: "plot"
            },
            showlegend: {
              valType: "boolean",
              editType: "legend"
            },
            colorway: {
              valType: "colorlist",
              dflt: i.defaults,
              editType: "calc"
            },
            datarevision: {
              valType: "any",
              editType: "calc"
            },
            uirevision: {
              valType: "any",
              editType: "none"
            },
            editrevision: {
              valType: "any",
              editType: "none"
            },
            selectionrevision: {
              valType: "any",
              editType: "none"
            },
            template: {
              valType: "any",
              editType: "calc"
            },
            newshape: o.newshape,
            activeshape: o.activeshape,
            newselection: l.newselection,
            activeselection: l.activeselection,
            meta: {
              valType: "any",
              arrayOk: !0,
              editType: "plot"
            },
            transition: c({}, a.transition, {
              editType: "none"
            }),
            _deprecated: {
              title: {
                valType: "string",
                editType: "layoutstyle"
              },
              titlefont: n({
                editType: "layoutstyle"
              })
            }
          };
        },
        7891: function (e) {
          "use strict";

          e.exports = function (e) {
            var t = e.editType;
            return {
              t: {
                valType: "number",
                dflt: 0,
                editType: t
              },
              r: {
                valType: "number",
                dflt: 0,
                editType: t
              },
              b: {
                valType: "number",
                dflt: 0,
                editType: t
              },
              l: {
                valType: "number",
                dflt: 0,
                editType: t
              },
              editType: t
            };
          };
        },
        4122: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(2696).de,
            i = r(6464).OE,
            o = r(721),
            l = r(3229),
            s = r(3626),
            c = r(7297),
            u = r(8032),
            f = r(4809),
            d = r(8766),
            h = r(3821).BADNUM,
            p = r(5975),
            v = r(8534).clearOutline,
            g = r(6667),
            m = r(9722),
            y = r(8935),
            x = r(4173).eV,
            b = f.relinkPrivateKeys,
            _ = f._,
            w = e.exports = {};
          f.extendFlat(w, s), w.attributes = r(9829), w.attributes.type.values = w.allTypes, w.fontAttrs = r(337), w.layoutAttributes = r(6704);
          var T = w.transformsRegistry,
            M = r(251);
          w.executeAPICommand = M.executeAPICommand, w.computeAPICommandBindings = M.computeAPICommandBindings, w.manageCommandObserver = M.manageCommandObserver, w.hasSimpleAPICommandBindings = M.hasSimpleAPICommandBindings, w.redrawText = function (e) {
            return e = f.getGraphDiv(e), new Promise(function (t) {
              setTimeout(function () {
                e._fullLayout && (s.getComponentMethod("annotations", "draw")(e), s.getComponentMethod("legend", "draw")(e), s.getComponentMethod("colorbar", "draw")(e), t(w.previousPromises(e)));
              }, 300);
            });
          }, w.resize = function (e) {
            var t;
            e = f.getGraphDiv(e);
            var r = new Promise(function (r, n) {
              e && !f.isHidden(e) || n(new Error("Resize must be passed a displayed plot div element.")), e._redrawTimer && clearTimeout(e._redrawTimer), e._resolveResize && (t = e._resolveResize), e._resolveResize = r, e._redrawTimer = setTimeout(function () {
                if (!e.layout || e.layout.width && e.layout.height || f.isHidden(e)) r(e);else {
                  delete e.layout.width, delete e.layout.height;
                  var t = e.changed;
                  e.autoplay = !0, s.call("relayout", e, {
                    autosize: !0
                  }).then(function () {
                    e.changed = t, e._resolveResize === r && (delete e._resolveResize, r(e));
                  });
                }
              }, 100);
            });
            return t && t(r), r;
          }, w.previousPromises = function (e) {
            if ((e._promises || []).length) return Promise.all(e._promises).then(function () {
              e._promises = [];
            });
          }, w.addLinks = function (e) {
            if (e._context.showLink || e._context.showSources) {
              var t = e._fullLayout,
                r = f.ensureSingle(t._paper, "text", "js-plot-link-container", function (e) {
                  e.style({
                    "font-family": '"Open Sans", Arial, sans-serif',
                    "font-size": "12px",
                    fill: d.defaultLine,
                    "pointer-events": "all"
                  }).each(function () {
                    var e = n.select(this);
                    e.append("tspan").classed("js-link-to-tool", !0), e.append("tspan").classed("js-link-spacer", !0), e.append("tspan").classed("js-sourcelinks", !0);
                  });
                }),
                a = r.node(),
                i = {
                  y: t._paper.attr("height") - 9
                };
              document.body.contains(a) && a.getComputedTextLength() >= t.width - 20 ? (i["text-anchor"] = "start", i.x = 5) : (i["text-anchor"] = "end", i.x = t._paper.attr("width") - 7), r.attr(i);
              var o = r.select(".js-link-to-tool"),
                l = r.select(".js-link-spacer"),
                s = r.select(".js-sourcelinks");
              e._context.showSources && e._context.showSources(e), e._context.showLink && function (e, t) {
                t.text("");
                var r = t.append("a").attr({
                  "xlink:xlink:href": "#",
                  class: "link--impt link--embedview",
                  "font-weight": "bold"
                }).text(e._context.linkText + " " + String.fromCharCode(187));
                if (e._context.sendData) r.on("click", function () {
                  w.sendDataToCloud(e);
                });else {
                  var n = window.location.pathname.split("/"),
                    a = window.location.search;
                  r.attr({
                    "xlink:xlink:show": "new",
                    "xlink:xlink:href": "/" + n[2].split(".")[0] + "/" + n[1] + a
                  });
                }
              }(e, o), l.text(o.text() && s.text() ? " - " : "");
            }
          }, w.sendDataToCloud = function (e) {
            var t = (window.PLOTLYENV || {}).BASE_URL || e._context.plotlyServerURL;
            if (t) {
              e.emit("plotly_beforeexport");
              var r = n.select(e).append("div").attr("id", "hiddenform").style("display", "none"),
                a = r.append("form").attr({
                  action: t + "/external",
                  method: "post",
                  target: "_blank"
                });
              return a.append("input").attr({
                type: "text",
                name: "data"
              }).node().value = w.graphJson(e, !1, "keepdata"), a.node().submit(), r.remove(), e.emit("plotly_afterexport"), !1;
            }
          };
          var k = ["days", "shortDays", "months", "shortMonths", "periods", "dateTime", "date", "time", "decimal", "thousands", "grouping", "currency"],
            A = ["year", "month", "dayMonth", "dayMonthYear"];
          function L(e, t) {
            var r = e._context.locale;
            r || (r = "en-US");
            var n = !1,
              a = {};
            function i(e) {
              for (var r = !0, i = 0; i < t.length; i++) {
                var o = t[i];
                a[o] || (e[o] ? a[o] = e[o] : r = !1);
              }
              r && (n = !0);
            }
            for (var o = 0; o < 2; o++) {
              for (var l = e._context.locales, c = 0; c < 2; c++) {
                var u = (l[r] || {}).format;
                if (u && (i(u), n)) break;
                l = s.localeRegistry;
              }
              var f = r.split("-")[0];
              if (n || f === r) break;
              r = f;
            }
            return n || i(s.localeRegistry.en.format), a;
          }
          function S(e, t) {
            var r = {
                _fullLayout: t
              },
              n = "x" === e._id.charAt(0),
              a = e._mainAxis._anchorAxis,
              i = "",
              o = "",
              l = "";
            if (a && (l = a._mainAxis._id, i = n ? e._id + l : l + e._id), !i || !t._plots[i]) {
              i = "";
              for (var s = e._counterAxes, c = 0; c < s.length; c++) {
                var u = s[c],
                  f = n ? e._id + u : u + e._id;
                o || (o = f);
                var d = p.getFromId(r, u);
                if (l && d.overlaying === l) {
                  i = f;
                  break;
                }
              }
            }
            return i || o;
          }
          function C(e) {
            var t = e.transforms;
            if (Array.isArray(t) && t.length) for (var r = 0; r < t.length; r++) {
              var n = t[r],
                a = n._module || T[n.type];
              if (a && a.makesData) return !0;
            }
            return !1;
          }
          function O(e, t, r, n) {
            for (var a = e.transforms, i = [e], o = 0; o < a.length; o++) {
              var l = a[o],
                s = T[l.type];
              s && s.transform && (i = s.transform(i, {
                transform: l,
                fullTrace: e,
                fullData: t,
                layout: r,
                fullLayout: n,
                transformIndex: o
              }));
            }
            return i;
          }
          function D(e) {
            return "string" == typeof e && "px" === e.substr(e.length - 2) && parseFloat(e);
          }
          function P(e) {
            var t = e.margin;
            if (!e._size) {
              var r = e._size = {
                l: Math.round(t.l),
                r: Math.round(t.r),
                t: Math.round(t.t),
                b: Math.round(t.b),
                p: Math.round(t.pad)
              };
              r.w = Math.round(e.width) - r.l - r.r, r.h = Math.round(e.height) - r.t - r.b;
            }
            e._pushmargin || (e._pushmargin = {}), e._pushmarginIds || (e._pushmarginIds = {}), e._reservedMargin || (e._reservedMargin = {});
          }
          w.supplyDefaults = function (e, t) {
            var r = t && t.skipUpdateCalc,
              n = e._fullLayout || {};
            if (n._skipDefaults) delete n._skipDefaults;else {
              var o,
                l = e._fullLayout = {},
                c = e.layout || {},
                u = e._fullData || [],
                d = e._fullData = [],
                h = e.data || [],
                p = e.calcdata || [],
                g = e._context || {};
              e._transitionData || w.createTransitionData(e), l._dfltTitle = {
                plot: _(e, "Click to enter Plot title"),
                subtitle: _(e, "Click to enter Plot subtitle"),
                x: _(e, "Click to enter X axis title"),
                y: _(e, "Click to enter Y axis title"),
                colorbar: _(e, "Click to enter Colorscale title"),
                annotation: _(e, "new text")
              }, l._traceWord = _(e, "trace");
              var m = L(e, k);
              if (l._mapboxAccessToken = g.mapboxAccessToken, n._initialAutoSizeIsDone) {
                var y = n.width,
                  x = n.height;
                w.supplyLayoutGlobalDefaults(c, l, m), c.width || (l.width = y), c.height || (l.height = x), w.sanitizeMargins(l);
              } else {
                w.supplyLayoutGlobalDefaults(c, l, m);
                var T = !c.width || !c.height,
                  M = l.autosize,
                  S = g.autosizable;
                T && (M || S) ? w.plotAutoSize(e, c, l) : T && w.sanitizeMargins(l), !M && T && (c.width = l.width, c.height = l.height);
              }
              l._d3locale = function (e, t) {
                return e.decimal = t.charAt(0), e.thousands = t.charAt(1), {
                  numberFormat: function (t) {
                    try {
                      t = i(e).format(f.adjustFormat(t));
                    } catch (e) {
                      return f.warnBadFormat(t), f.noFormat;
                    }
                    return t;
                  },
                  timeFormat: a(e).utcFormat
                };
              }(m, l.separators), l._extraFormat = L(e, A), l._initialAutoSizeIsDone = !0, l._dataLength = h.length, l._modules = [], l._visibleModules = [], l._basePlotModules = [];
              var C = l._subplots = function () {
                  var e,
                    t,
                    r = s.collectableSubplotTypes,
                    n = {};
                  if (!r) {
                    r = [];
                    var a = s.subplotsRegistry;
                    for (var i in a) {
                      var o = a[i].attr;
                      if (o && (r.push(i), Array.isArray(o))) for (t = 0; t < o.length; t++) f.pushUnique(r, o[t]);
                    }
                  }
                  for (e = 0; e < r.length; e++) n[r[e]] = [];
                  return n;
                }(),
                O = l._splomAxes = {
                  x: {},
                  y: {}
                },
                D = l._splomSubplots = {};
              l._splomGridDflt = {}, l._scatterStackOpts = {}, l._firstScatter = {}, l._alignmentOpts = {}, l._colorAxes = {}, l._requestRangeslider = {}, l._traceUids = function (e, t) {
                var r,
                  n,
                  a = t.length,
                  i = [];
                for (r = 0; r < e.length; r++) {
                  var o = e[r]._fullInput;
                  o !== n && i.push(o), n = o;
                }
                var l = i.length,
                  s = new Array(a),
                  c = {};
                function u(e, t) {
                  s[t] = e, c[e] = 1;
                }
                function d(e, t) {
                  if (e && "string" == typeof e && !c[e]) return u(e, t), !0;
                }
                for (r = 0; r < a; r++) {
                  var h = t[r].uid;
                  "number" == typeof h && (h = String(h)), d(h, r) || r < l && d(i[r].uid, r) || u(f.randstr(c), r);
                }
                return s;
              }(u, h), l._globalTransforms = (e._context || {}).globalTransforms, w.supplyDataDefaults(h, d, c, l);
              var z = Object.keys(O.x),
                I = Object.keys(O.y);
              if (z.length > 1 && I.length > 1) {
                for (s.getComponentMethod("grid", "sizeDefaults")(c, l), o = 0; o < z.length; o++) f.pushUnique(C.xaxis, z[o]);
                for (o = 0; o < I.length; o++) f.pushUnique(C.yaxis, I[o]);
                for (var E in D) f.pushUnique(C.cartesian, E);
              }
              if (l._has = w._hasPlotType.bind(l), u.length === d.length) for (o = 0; o < d.length; o++) b(d[o], u[o]);
              w.supplyLayoutModuleDefaults(c, l, d, e._transitionData);
              var R = l._visibleModules,
                N = [];
              for (o = 0; o < R.length; o++) {
                var F = R[o].crossTraceDefaults;
                F && f.pushUnique(N, F);
              }
              for (o = 0; o < N.length; o++) N[o](d, l);
              l._hasOnlyLargeSploms = 1 === l._basePlotModules.length && "splom" === l._basePlotModules[0].name && z.length > 15 && I.length > 15 && 0 === l.shapes.length && 0 === l.images.length, w.linkSubplots(d, l, u, n), w.cleanPlot(d, l, u, n);
              var H = !(!n._has || !n._has("gl2d")),
                B = !(!l._has || !l._has("gl2d")),
                j = !(!n._has || !n._has("cartesian")) || H,
                Y = !(!l._has || !l._has("cartesian")) || B;
              j && !Y ? n._bgLayer.remove() : Y && !j && (l._shouldCreateBgLayer = !0), n._zoomlayer && !e._dragging && v({
                _fullLayout: n
              }), function (e, t) {
                var r,
                  n = [];
                t.meta && (r = t._meta = {
                  meta: t.meta,
                  layout: {
                    meta: t.meta
                  }
                });
                for (var a = 0; a < e.length; a++) {
                  var i = e[a];
                  i.meta ? n[i.index] = i._meta = {
                    meta: i.meta
                  } : t.meta && (i._meta = {
                    meta: t.meta
                  }), t.meta && (i._meta.layout = {
                    meta: t.meta
                  });
                }
                n.length && (r || (r = t._meta = {}), r.data = n);
              }(d, l), b(l, n), s.getComponentMethod("colorscale", "crossTraceDefaults")(d, l), l._preGUI || (l._preGUI = {}), l._tracePreGUI || (l._tracePreGUI = {});
              var V,
                U = l._tracePreGUI,
                q = {};
              for (V in U) q[V] = "old";
              for (o = 0; o < d.length; o++) q[V = d[o]._fullInput.uid] || (U[V] = {}), q[V] = "new";
              for (V in q) "old" === q[V] && delete U[V];
              P(l), s.getComponentMethod("rangeslider", "makeData")(l), r || p.length !== d.length || w.supplyDefaultsUpdateCalc(p, d);
            }
          }, w.supplyDefaultsUpdateCalc = function (e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r],
                a = (e[r] || [])[0];
              if (a && a.trace) {
                var i = a.trace;
                if (i._hasCalcTransform) {
                  var o,
                    l,
                    s,
                    c = i._arrayAttrs;
                  for (o = 0; o < c.length; o++) l = c[o], s = f.nestedProperty(i, l).get().slice(), f.nestedProperty(n, l).set(s);
                }
                a.trace = n;
              }
            }
          }, w.createTransitionData = function (e) {
            e._transitionData || (e._transitionData = {}), e._transitionData._frames || (e._transitionData._frames = []), e._transitionData._frameHash || (e._transitionData._frameHash = {}), e._transitionData._counter || (e._transitionData._counter = 0), e._transitionData._interruptCallbacks || (e._transitionData._interruptCallbacks = []);
          }, w._hasPlotType = function (e) {
            var t,
              r = this._basePlotModules || [];
            for (t = 0; t < r.length; t++) if (r[t].name === e) return !0;
            var n = this._modules || [];
            for (t = 0; t < n.length; t++) {
              var a = n[t].name;
              if (a === e) return !0;
              var i = s.modules[a];
              if (i && i.categories[e]) return !0;
            }
            return !1;
          }, w.cleanPlot = function (e, t, r, n) {
            var a,
              i,
              o = n._basePlotModules || [];
            for (a = 0; a < o.length; a++) {
              var l = o[a];
              l.clean && l.clean(e, t, r, n);
            }
            var s = n._has && n._has("gl"),
              c = t._has && t._has("gl");
            s && !c && void 0 !== n._glcontainer && (n._glcontainer.selectAll(".gl-canvas").remove(), n._glcontainer.selectAll(".no-webgl").remove(), n._glcanvas = null);
            var u = !!n._infolayer;
            e: for (a = 0; a < r.length; a++) {
              var f = r[a].uid;
              for (i = 0; i < e.length; i++) if (f === e[i].uid) continue e;
              u && n._infolayer.select(".cb" + f).remove();
            }
          }, w.linkSubplots = function (e, t, r, n) {
            var a,
              i,
              o = n._plots || {},
              l = t._plots = {},
              c = t._subplots,
              u = {
                _fullData: e,
                _fullLayout: t
              },
              d = c.cartesian.concat(c.gl2d || []);
            for (a = 0; a < d.length; a++) {
              var h,
                v = d[a],
                g = o[v],
                m = p.getFromId(u, v, "x"),
                y = p.getFromId(u, v, "y");
              for (g ? h = l[v] = g : (h = l[v] = {}).id = v, m._counterAxes.push(y._id), y._counterAxes.push(m._id), m._subplotsWith.push(v), y._subplotsWith.push(v), h.xaxis = m, h.yaxis = y, h._hasClipOnAxisFalse = !1, i = 0; i < e.length; i++) {
                var x = e[i];
                if (x.xaxis === h.xaxis._id && x.yaxis === h.yaxis._id && !1 === x.cliponaxis) {
                  h._hasClipOnAxisFalse = !0;
                  break;
                }
              }
            }
            var b,
              _ = p.list(u, null, !0);
            for (a = 0; a < _.length; a++) {
              var w = null;
              (b = _[a]).overlaying && (w = p.getFromId(u, b.overlaying)) && w.overlaying && (b.overlaying = !1, w = null), b._mainAxis = w || b, w && (b.domain = w.domain.slice()), b._anchorAxis = "free" === b.anchor ? null : p.getFromId(u, b.anchor);
            }
            for (a = 0; a < _.length; a++) if ((b = _[a])._counterAxes.sort(p.idSort), b._subplotsWith.sort(f.subplotSort), b._mainSubplot = S(b, t), b._counterAxes.length && (b.spikemode && -1 !== b.spikemode.indexOf("across") || b.automargin && b.mirror && "free" !== b.anchor || s.getComponentMethod("rangeslider", "isVisible")(b))) {
              var T = 1,
                M = 0;
              for (i = 0; i < b._counterAxes.length; i++) {
                var k = p.getFromId(u, b._counterAxes[i]);
                T = Math.min(T, k.domain[0]), M = Math.max(M, k.domain[1]);
              }
              T < M && (b._counterDomainMin = T, b._counterDomainMax = M);
            }
          }, w.clearExpandedTraceDefaultColors = function (e) {
            var t, r, n;
            for (r = [], (t = e._module._colorAttrs) || (e._module._colorAttrs = t = [], c.crawl(e._module.attributes, function (e, n, a, i) {
              r[i] = n, r.length = i + 1, "color" === e.valType && void 0 === e.dflt && t.push(r.join("."));
            })), n = 0; n < t.length; n++) f.nestedProperty(e, "_input." + t[n]).get() || f.nestedProperty(e, t[n]).set(null);
          }, w.supplyDataDefaults = function (e, t, r, n) {
            var a,
              i,
              o,
              l = n._modules,
              c = n._visibleModules,
              d = n._basePlotModules,
              h = 0,
              p = 0;
            function v(e) {
              t.push(e);
              var r = e._module;
              r && (f.pushUnique(l, r), !0 === e.visible && f.pushUnique(c, r), f.pushUnique(d, e._module.basePlotModule), h++, !1 !== e._input.visible && p++);
            }
            n._transformModules = [];
            var g = {},
              m = [],
              y = (r.template || {}).data || {},
              x = u.traceTemplater(y);
            for (a = 0; a < e.length; a++) {
              if (o = e[a], (i = x.newTrace(o)).uid = n._traceUids[a], w.supplyTraceDefaults(o, i, p, n, a), i.index = a, i._input = o, i._expandedIndex = h, i.transforms && i.transforms.length) for (var _ = !1 !== o.visible && !1 === i.visible, T = O(i, t, r, n), M = 0; M < T.length; M++) {
                var k = T[M],
                  A = {
                    _template: i._template,
                    type: i.type,
                    uid: i.uid + M
                  };
                _ && !1 === k.visible && delete k.visible, w.supplyTraceDefaults(k, A, h, n, a), b(A, k), A.index = a, A._input = o, A._fullInput = i, A._expandedIndex = h, A._expandedInput = k, v(A);
              } else i._fullInput = i, i._expandedInput = i, v(i);
              s.traceIs(i, "carpetAxis") && (g[i.carpet] = i), s.traceIs(i, "carpetDependent") && m.push(a);
            }
            for (a = 0; a < m.length; a++) if ((i = t[m[a]]).visible) {
              var L = g[i.carpet];
              i._carpet = L, L && L.visible ? (i.xaxis = L.xaxis, i.yaxis = L.yaxis) : i.visible = !1;
            }
          }, w.supplyAnimationDefaults = function (e) {
            var t;
            e = e || {};
            var r = {};
            function n(t, n) {
              return f.coerce(e || {}, r, m, t, n);
            }
            if (n("mode"), n("direction"), n("fromcurrent"), Array.isArray(e.frame)) for (r.frame = [], t = 0; t < e.frame.length; t++) r.frame[t] = w.supplyAnimationFrameDefaults(e.frame[t] || {});else r.frame = w.supplyAnimationFrameDefaults(e.frame || {});
            if (Array.isArray(e.transition)) for (r.transition = [], t = 0; t < e.transition.length; t++) r.transition[t] = w.supplyAnimationTransitionDefaults(e.transition[t] || {});else r.transition = w.supplyAnimationTransitionDefaults(e.transition || {});
            return r;
          }, w.supplyAnimationFrameDefaults = function (e) {
            var t = {};
            function r(r, n) {
              return f.coerce(e || {}, t, m.frame, r, n);
            }
            return r("duration"), r("redraw"), t;
          }, w.supplyAnimationTransitionDefaults = function (e) {
            var t = {};
            function r(r, n) {
              return f.coerce(e || {}, t, m.transition, r, n);
            }
            return r("duration"), r("easing"), t;
          }, w.supplyFrameDefaults = function (e) {
            var t = {};
            function r(r, n) {
              return f.coerce(e, t, y, r, n);
            }
            return r("group"), r("name"), r("traces"), r("baseframe"), r("data"), r("layout"), t;
          }, w.supplyTraceDefaults = function (e, t, r, n, a) {
            var i,
              o = n.colorway || d.defaults,
              l = o[r % o.length];
            function c(r, n) {
              return f.coerce(e, t, w.attributes, r, n);
            }
            var u = c("visible");
            c("type"), c("name", n._traceWord + " " + a), c("uirevision", n.uirevision);
            var h = w.getModule(t);
            if (t._module = h, h) {
              var p = h.basePlotModule,
                v = p.attr,
                g = p.attributes;
              if (v && g) {
                var m = n._subplots,
                  y = "";
                if (u || "gl2d" !== p.name) {
                  if (Array.isArray(v)) for (i = 0; i < v.length; i++) {
                    var x = v[i],
                      b = f.coerce(e, t, g, x);
                    m[x] && f.pushUnique(m[x], b), y += b;
                  } else y = f.coerce(e, t, g, v);
                  m[p.name] && f.pushUnique(m[p.name], y);
                }
              }
            }
            if (u) {
              if (c("customdata"), c("ids"), c("meta"), s.traceIs(t, "showLegend") ? (f.coerce(e, t, h.attributes.showlegend ? h.attributes : w.attributes, "showlegend"), c("legend"), c("legendwidth"), c("legendgroup"), c("legendgrouptitle.text"), c("legendrank"), t._dfltShowLegend = !0) : t._dfltShowLegend = !1, h && h.supplyDefaults(e, t, l, n), s.traceIs(t, "noOpacity") || c("opacity"), s.traceIs(t, "notLegendIsolatable") && (t.visible = !!t.visible), s.traceIs(t, "noHover") || (t.hovertemplate || f.coerceHoverinfo(e, t, n), "parcats" !== t.type && s.getComponentMethod("fx", "supplyDefaults")(e, t, l, n)), h && h.selectPoints) {
                var _ = c("selectedpoints");
                f.isTypedArray(_) && (t.selectedpoints = Array.from(_));
              }
              w.supplyTransformDefaults(e, t, n);
            }
            return t;
          }, w.hasMakesDataTransform = C, w.supplyTransformDefaults = function (e, t, r) {
            if (t._length || C(e)) {
              var n = r._globalTransforms || [],
                a = r._transformModules || [];
              if (Array.isArray(e.transforms) || 0 !== n.length) for (var i = e.transforms || [], o = n.concat(i), l = t.transforms = [], s = 0; s < o.length; s++) {
                var c,
                  u = o[s],
                  d = u.type,
                  h = T[d],
                  p = !(u._module && u._module === h),
                  v = h && "function" == typeof h.transform;
                h || f.warn("Unrecognized transform type " + d + "."), h && h.supplyDefaults && (p || v) ? ((c = h.supplyDefaults(u, t, r, e)).type = d, c._module = h, f.pushUnique(a, h)) : c = f.extendFlat({}, u), l.push(c);
              }
            }
          }, w.supplyLayoutGlobalDefaults = function (e, t, r) {
            function n(r, n) {
              return f.coerce(e, t, w.layoutAttributes, r, n);
            }
            var a = e.template;
            f.isPlainObject(a) && (t.template = a, t._template = a.layout, t._dataTemplate = a.data), n("autotypenumbers");
            var i = f.coerceFont(n, "font"),
              o = i.size;
            f.coerceFont(n, "title.font", i, {
              overrideDflt: {
                size: Math.round(1.4 * o)
              }
            }), n("title.text", t._dfltTitle.plot), n("title.xref");
            var l = n("title.yref");
            n("title.pad.t"), n("title.pad.r"), n("title.pad.b"), n("title.pad.l");
            var c = n("title.automargin");
            n("title.x"), n("title.xanchor"), n("title.y"), n("title.yanchor"), n("title.subtitle.text", t._dfltTitle.subtitle), f.coerceFont(n, "title.subtitle.font", i, {
              overrideDflt: {
                size: Math.round(.7 * t.title.font.size)
              }
            }), c && ("paper" === l && (0 !== t.title.y && (t.title.y = 1), "auto" === t.title.yanchor && (t.title.yanchor = 0 === t.title.y ? "top" : "bottom")), "container" === l && ("auto" === t.title.y && (t.title.y = 1), "auto" === t.title.yanchor && (t.title.yanchor = t.title.y < .5 ? "bottom" : "top"))), n("uniformtext.mode") && n("uniformtext.minsize"), n("autosize", !(e.width && e.height)), n("width"), n("height"), n("minreducedwidth"), n("minreducedheight"), n("margin.l"), n("margin.r"), n("margin.t"), n("margin.b"), n("margin.pad"), n("margin.autoexpand"), e.width && e.height && w.sanitizeMargins(t), s.getComponentMethod("grid", "sizeDefaults")(e, t), n("paper_bgcolor"), n("separators", r.decimal + r.thousands), n("hidesources"), n("colorway"), n("datarevision");
            var u = n("uirevision");
            n("editrevision", u), n("selectionrevision", u), s.getComponentMethod("modebar", "supplyLayoutDefaults")(e, t), s.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(e, t, n), s.getComponentMethod("selections", "supplyDrawNewSelectionDefaults")(e, t, n), n("meta"), f.isPlainObject(e.transition) && (n("transition.duration"), n("transition.easing"), n("transition.ordering")), s.getComponentMethod("calendars", "handleDefaults")(e, t, "calendar"), s.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(e, t, n), f.coerce(e, t, g, "scattermode");
          }, w.plotAutoSize = function (e, t, r) {
            var n,
              a,
              i = e._context || {},
              l = i.frameMargins,
              s = f.isPlotDiv(e);
            if (s && e.emit("plotly_autosize"), i.fillFrame) n = window.innerWidth, a = window.innerHeight, document.body.style.overflow = "hidden";else {
              var c = s ? window.getComputedStyle(e) : {};
              if (n = D(c.width) || D(c.maxWidth) || r.width, a = D(c.height) || D(c.maxHeight) || r.height, o(l) && l > 0) {
                var u = 1 - 2 * l;
                n = Math.round(u * n), a = Math.round(u * a);
              }
            }
            var d = w.layoutAttributes.width.min,
              h = w.layoutAttributes.height.min;
            n < d && (n = d), a < h && (a = h);
            var p = !t.width && Math.abs(r.width - n) > 1,
              v = !t.height && Math.abs(r.height - a) > 1;
            (v || p) && (p && (r.width = n), v && (r.height = a)), e._initialAutoSize || (e._initialAutoSize = {
              width: n,
              height: a
            }), w.sanitizeMargins(r);
          }, w.supplyLayoutModuleDefaults = function (e, t, r, n) {
            var a,
              i,
              o,
              l = s.componentsRegistry,
              c = t._basePlotModules,
              u = s.subplotsRegistry.cartesian;
            for (a in l) (o = l[a]).includeBasePlot && o.includeBasePlot(e, t);
            for (var d in c.length || c.push(u), t._has("cartesian") && (s.getComponentMethod("grid", "contentDefaults")(e, t), u.finalizeSubplots(e, t)), t._subplots) t._subplots[d].sort(f.subplotSort);
            for (i = 0; i < c.length; i++) (o = c[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r);
            var h = t._modules;
            for (i = 0; i < h.length; i++) (o = h[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r);
            var p = t._transformModules;
            for (i = 0; i < p.length; i++) (o = p[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r, n);
            for (a in l) (o = l[a]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r);
          }, w.purge = function (e) {
            var t = e._fullLayout || {};
            void 0 !== t._glcontainer && (t._glcontainer.selectAll(".gl-canvas").remove(), t._glcontainer.remove(), t._glcanvas = null), t._modeBar && t._modeBar.destroy(), e._transitionData && (e._transitionData._interruptCallbacks && (e._transitionData._interruptCallbacks.length = 0), e._transitionData._animationRaf && window.cancelAnimationFrame(e._transitionData._animationRaf)), f.clearThrottle(), f.clearResponsive(e), delete e.data, delete e.layout, delete e._fullData, delete e._fullLayout, delete e.calcdata, delete e.empty, delete e.fid, delete e.undoqueue, delete e.undonum, delete e.autoplay, delete e.changed, delete e._promises, delete e._redrawTimer, delete e._hmlumcount, delete e._hmpixcount, delete e._transitionData, delete e._transitioning, delete e._initialAutoSize, delete e._transitioningWithDuration, delete e._dragging, delete e._dragged, delete e._dragdata, delete e._hoverdata, delete e._snapshotInProgress, delete e._editing, delete e._mouseDownTime, delete e._legendMouseDownTime, e.removeAllListeners && e.removeAllListeners();
          }, w.style = function (e) {
            var t,
              r = e._fullLayout._visibleModules,
              n = [];
            for (t = 0; t < r.length; t++) {
              var a = r[t];
              a.style && f.pushUnique(n, a.style);
            }
            for (t = 0; t < n.length; t++) n[t](e);
          }, w.sanitizeMargins = function (e) {
            if (e && e.margin) {
              var t,
                r = e.width,
                n = e.height,
                a = e.margin,
                i = r - (a.l + a.r),
                o = n - (a.t + a.b);
              i < 0 && (t = (r - 1) / (a.l + a.r), a.l = Math.floor(t * a.l), a.r = Math.floor(t * a.r)), o < 0 && (t = (n - 1) / (a.t + a.b), a.t = Math.floor(t * a.t), a.b = Math.floor(t * a.b));
            }
          }, w.clearAutoMarginIds = function (e) {
            e._fullLayout._pushmarginIds = {};
          }, w.allowAutoMargin = function (e, t) {
            e._fullLayout._pushmarginIds[t] = 1;
          }, w.autoMargin = function (e, t, r) {
            var n = e._fullLayout,
              a = n.width,
              i = n.height,
              o = n.margin,
              l = n.minreducedwidth,
              s = n.minreducedheight,
              c = f.constrain(a - o.l - o.r, 2, l),
              u = f.constrain(i - o.t - o.b, 2, s),
              d = Math.max(0, a - c),
              h = Math.max(0, i - u),
              p = n._pushmargin,
              v = n._pushmarginIds;
            if (!1 !== o.autoexpand) {
              if (r) {
                var g = r.pad;
                if (void 0 === g && (g = Math.min(12, o.l, o.r, o.t, o.b)), d) {
                  var m = (r.l + r.r) / d;
                  m > 1 && (r.l /= m, r.r /= m);
                }
                if (h) {
                  var y = (r.t + r.b) / h;
                  y > 1 && (r.t /= y, r.b /= y);
                }
                var x = void 0 !== r.xl ? r.xl : r.x,
                  b = void 0 !== r.xr ? r.xr : r.x,
                  _ = void 0 !== r.yt ? r.yt : r.y,
                  T = void 0 !== r.yb ? r.yb : r.y;
                p[t] = {
                  l: {
                    val: x,
                    size: r.l + g
                  },
                  r: {
                    val: b,
                    size: r.r + g
                  },
                  b: {
                    val: T,
                    size: r.b + g
                  },
                  t: {
                    val: _,
                    size: r.t + g
                  }
                }, v[t] = 1;
              } else delete p[t], delete v[t];
              if (!n._replotting) return w.doAutoMargin(e);
            }
          }, w.doAutoMargin = function (e) {
            var t = e._fullLayout,
              r = t.width,
              n = t.height;
            t._size || (t._size = {}), P(t);
            var a = t._size,
              i = t.margin,
              l = {
                t: 0,
                b: 0,
                l: 0,
                r: 0
              },
              c = f.extendFlat({}, a),
              u = i.l,
              d = i.r,
              h = i.t,
              v = i.b,
              g = t._pushmargin,
              m = t._pushmarginIds,
              y = t.minreducedwidth,
              x = t.minreducedheight;
            if (!1 !== i.autoexpand) {
              for (var b in g) m[b] || delete g[b];
              var _ = e._fullLayout._reservedMargin;
              for (var T in _) for (var M in _[T]) {
                var k = _[T][M];
                l[M] = Math.max(l[M], k);
              }
              for (var A in g.base = {
                l: {
                  val: 0,
                  size: u
                },
                r: {
                  val: 1,
                  size: d
                },
                t: {
                  val: 1,
                  size: h
                },
                b: {
                  val: 0,
                  size: v
                }
              }, l) {
                var L = 0;
                for (var S in g) "base" !== S && o(g[S][A].size) && (L = g[S][A].size > L ? g[S][A].size : L);
                var C = Math.max(0, i[A] - L);
                l[A] = Math.max(0, l[A] - C);
              }
              for (var O in g) {
                var D = g[O].l || {},
                  z = g[O].b || {},
                  I = D.val,
                  E = D.size,
                  R = z.val,
                  N = z.size,
                  F = r - l.r - l.l,
                  H = n - l.t - l.b;
                for (var B in g) {
                  if (o(E) && g[B].r) {
                    var j = g[B].r.val,
                      Y = g[B].r.size;
                    if (j > I) {
                      var V = (E * j + (Y - F) * I) / (j - I),
                        U = (Y * (1 - I) + (E - F) * (1 - j)) / (j - I);
                      V + U > u + d && (u = V, d = U);
                    }
                  }
                  if (o(N) && g[B].t) {
                    var q = g[B].t.val,
                      G = g[B].t.size;
                    if (q > R) {
                      var Z = (N * q + (G - H) * R) / (q - R),
                        W = (G * (1 - R) + (N - H) * (1 - q)) / (q - R);
                      Z + W > v + h && (v = Z, h = W);
                    }
                  }
                }
              }
            }
            var J = f.constrain(r - i.l - i.r, 2, y),
              X = f.constrain(n - i.t - i.b, 2, x),
              K = Math.max(0, r - J),
              Q = Math.max(0, n - X);
            if (K) {
              var $ = (u + d) / K;
              $ > 1 && (u /= $, d /= $);
            }
            if (Q) {
              var ee = (v + h) / Q;
              ee > 1 && (v /= ee, h /= ee);
            }
            if (a.l = Math.round(u) + l.l, a.r = Math.round(d) + l.r, a.t = Math.round(h) + l.t, a.b = Math.round(v) + l.b, a.p = Math.round(i.pad), a.w = Math.round(r) - a.l - a.r, a.h = Math.round(n) - a.t - a.b, !t._replotting && (w.didMarginChange(c, a) || function (e) {
              if ("_redrawFromAutoMarginCount" in e._fullLayout) return !1;
              var t = p.list(e, "", !0);
              for (var r in t) if (t[r].autoshift || t[r].shift) return !0;
              return !1;
            }(e))) {
              "_redrawFromAutoMarginCount" in t ? t._redrawFromAutoMarginCount++ : t._redrawFromAutoMarginCount = 1;
              var te = 3 * (1 + Object.keys(m).length);
              if (t._redrawFromAutoMarginCount < te) return s.call("_doPlot", e);
              t._size = c, f.warn("Too many auto-margin redraws.");
            }
            !function (e) {
              var t = p.list(e, "", !0);
              ["_adjustTickLabelsOverflow", "_hideCounterAxisInsideTickLabels"].forEach(function (e) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r][e];
                  n && n();
                }
              });
            }(e);
          };
          var z = ["l", "r", "t", "b", "p", "w", "h"];
          function I(e, t, r) {
            var n = !1,
              a = [w.previousPromises, function () {
                if (e._transitionData) return e._transitioning = !1, function (e) {
                  var t = Promise.resolve();
                  if (!e) return t;
                  for (; e.length;) t = t.then(e.shift());
                  return t;
                }(e._transitionData._interruptCallbacks);
              }, r.prepareFn, w.rehover, w.reselect, function () {
                return e.emit("plotly_transitioning", []), new Promise(function (a) {
                  e._transitioning = !0, t.duration > 0 && (e._transitioningWithDuration = !0), e._transitionData._interruptCallbacks.push(function () {
                    n = !0;
                  }), r.redraw && e._transitionData._interruptCallbacks.push(function () {
                    return s.call("redraw", e);
                  }), e._transitionData._interruptCallbacks.push(function () {
                    e.emit("plotly_transitioninterrupted", []);
                  });
                  var i = 0,
                    o = 0;
                  function l() {
                    return i++, function () {
                      var t;
                      o++, n || o !== i || (t = a, e._transitionData && (function (e) {
                        if (e) for (; e.length;) e.shift();
                      }(e._transitionData._interruptCallbacks), Promise.resolve().then(function () {
                        if (r.redraw) return s.call("redraw", e);
                      }).then(function () {
                        e._transitioning = !1, e._transitioningWithDuration = !1, e.emit("plotly_transitioned", []);
                      }).then(t)));
                    };
                  }
                  r.runFn(l), setTimeout(l());
                });
              }],
              i = f.syncOrAsync(a, e);
            return i && i.then || (i = Promise.resolve()), i.then(function () {
              return e;
            });
          }
          w.didMarginChange = function (e, t) {
            for (var r = 0; r < z.length; r++) {
              var n = z[r],
                a = e[n],
                i = t[n];
              if (!o(a) || Math.abs(i - a) > 1) return !0;
            }
            return !1;
          }, w.graphJson = function (e, t, r, n, a, i) {
            (a && t && !e._fullData || a && !t && !e._fullLayout) && w.supplyDefaults(e);
            var o = a ? e._fullData : e.data,
              s = a ? e._fullLayout : e.layout,
              c = (e._transitionData || {})._frames;
            function u(e, t) {
              if ("function" == typeof e) return t ? "_function_" : null;
              if (f.isPlainObject(e)) {
                var n,
                  a = {};
                return Object.keys(e).sort().forEach(function (i) {
                  if (-1 === ["_", "["].indexOf(i.charAt(0))) if ("function" != typeof e[i]) {
                    if ("keepdata" === r) {
                      if ("src" === i.substr(i.length - 3)) return;
                    } else if ("keepstream" === r) {
                      if ("string" == typeof (n = e[i + "src"]) && n.indexOf(":") > 0 && !f.isPlainObject(e.stream)) return;
                    } else if ("keepall" !== r && "string" == typeof (n = e[i + "src"]) && n.indexOf(":") > 0) return;
                    a[i] = u(e[i], t);
                  } else t && (a[i] = "_function");
                }), a;
              }
              var i = Array.isArray(e),
                o = f.isTypedArray(e);
              if ((i || o) && e.dtype && e.shape) {
                var s = e.bdata;
                return u({
                  dtype: e.dtype,
                  shape: e.shape,
                  bdata: f.isArrayBuffer(s) ? l.encode(s) : s
                }, t);
              }
              return i ? e.map(function (e) {
                return u(e, t);
              }) : o ? f.simpleMap(e, f.identity) : f.isJSDate(e) ? f.ms2DateTimeLocal(+e) : e;
            }
            var d = {
              data: (o || []).map(function (e) {
                var r = u(e);
                return t && delete r.fit, r;
              })
            };
            if (!t && (d.layout = u(s), a)) {
              var h = s._size;
              d.layout.computed = {
                margin: {
                  b: h.b,
                  l: h.l,
                  r: h.r,
                  t: h.t
                }
              };
            }
            return c && (d.frames = u(c)), i && (d.config = u(e._context, !0)), "object" === n ? d : JSON.stringify(d);
          }, w.modifyFrames = function (e, t) {
            var r,
              n,
              a,
              i = e._transitionData._frames,
              o = e._transitionData._frameHash;
            for (r = 0; r < t.length; r++) switch ((n = t[r]).type) {
              case "replace":
                a = n.value;
                var l = (i[n.index] || {}).name,
                  s = a.name;
                i[n.index] = o[s] = a, s !== l && (delete o[l], o[s] = a);
                break;
              case "insert":
                o[(a = n.value).name] = a, i.splice(n.index, 0, a);
                break;
              case "delete":
                delete o[(a = i[n.index]).name], i.splice(n.index, 1);
            }
            return Promise.resolve();
          }, w.computeFrame = function (e, t) {
            var r,
              n,
              a,
              i,
              o = e._transitionData._frameHash;
            if (!t) throw new Error("computeFrame must be given a string frame name");
            var l = o[t.toString()];
            if (!l) return !1;
            for (var s = [l], c = [l.name]; l.baseframe && (l = o[l.baseframe.toString()]) && -1 === c.indexOf(l.name);) s.push(l), c.push(l.name);
            for (var u = {}; l = s.pop();) if (l.layout && (u.layout = w.extendLayout(u.layout, l.layout)), l.data) {
              if (u.data || (u.data = []), !(n = l.traces)) for (n = [], r = 0; r < l.data.length; r++) n[r] = r;
              for (u.traces || (u.traces = []), r = 0; r < l.data.length; r++) null != (a = n[r]) && (-1 === (i = u.traces.indexOf(a)) && (i = u.data.length, u.traces[i] = a), u.data[i] = w.extendTrace(u.data[i], l.data[r]));
            }
            return u;
          }, w.recomputeFrameHash = function (e) {
            for (var t = e._transitionData._frameHash = {}, r = e._transitionData._frames, n = 0; n < r.length; n++) {
              var a = r[n];
              a && a.name && (t[a.name] = a);
            }
          }, w.extendObjectWithContainers = function (e, t, r) {
            var n,
              a,
              i,
              o,
              l,
              s,
              c,
              u = f.extendDeepNoArrays({}, t || {}),
              d = f.expandObjectPaths(u),
              h = {};
            if (r && r.length) for (i = 0; i < r.length; i++) void 0 === (a = (n = f.nestedProperty(d, r[i])).get()) ? f.nestedProperty(h, r[i]).set(null) : (n.set(null), f.nestedProperty(h, r[i]).set(a));
            if (e = f.extendDeepNoArrays(e || {}, d), r && r.length) for (i = 0; i < r.length; i++) if (s = f.nestedProperty(h, r[i]).get()) {
              for (c = (l = f.nestedProperty(e, r[i])).get(), Array.isArray(c) || (c = [], l.set(c)), o = 0; o < s.length; o++) {
                var p = s[o];
                c[o] = null === p ? null : w.extendObjectWithContainers(c[o], p);
              }
              l.set(c);
            }
            return e;
          }, w.dataArrayContainers = ["transforms", "dimensions"], w.layoutArrayContainers = s.layoutArrayContainers, w.extendTrace = function (e, t) {
            return w.extendObjectWithContainers(e, t, w.dataArrayContainers);
          }, w.extendLayout = function (e, t) {
            return w.extendObjectWithContainers(e, t, w.layoutArrayContainers);
          }, w.transition = function (e, t, r, n, a, i) {
            var o = {
                redraw: a.redraw
              },
              l = {},
              s = [];
            return o.prepareFn = function () {
              for (var a = Array.isArray(t) ? t.length : 0, i = n.slice(0, a), o = 0; o < i.length; o++) {
                var c = i[o],
                  u = e._fullData[c]._module;
                if (u) {
                  if (u.animatable) {
                    var d = u.basePlotModule.name;
                    l[d] || (l[d] = []), l[d].push(c);
                  }
                  e.data[i[o]] = w.extendTrace(e.data[i[o]], t[o]);
                }
              }
              var h = f.expandObjectPaths(f.extendDeepNoArrays({}, r)),
                p = /^[xy]axis[0-9]*$/;
              for (var v in h) p.test(v) && delete h[v].range;
              w.extendLayout(e.layout, h), delete e.calcdata, w.supplyDefaults(e), w.doCalcdata(e);
              var g = f.expandObjectPaths(r);
              if (g) {
                var m = e._fullLayout._plots;
                for (var y in m) {
                  var x = m[y],
                    b = x.xaxis,
                    _ = x.yaxis,
                    T = b.range.slice(),
                    M = _.range.slice(),
                    k = null,
                    A = null,
                    L = null,
                    S = null;
                  Array.isArray(g[b._name + ".range"]) ? k = g[b._name + ".range"].slice() : Array.isArray((g[b._name] || {}).range) && (k = g[b._name].range.slice()), Array.isArray(g[_._name + ".range"]) ? A = g[_._name + ".range"].slice() : Array.isArray((g[_._name] || {}).range) && (A = g[_._name].range.slice()), T && k && (b.r2l(T[0]) !== b.r2l(k[0]) || b.r2l(T[1]) !== b.r2l(k[1])) && (L = {
                    xr0: T,
                    xr1: k
                  }), M && A && (_.r2l(M[0]) !== _.r2l(A[0]) || _.r2l(M[1]) !== _.r2l(A[1])) && (S = {
                    yr0: M,
                    yr1: A
                  }), (L || S) && s.push(f.extendFlat({
                    plotinfo: x
                  }, L, S));
                }
              }
              return Promise.resolve();
            }, o.runFn = function (t) {
              var n,
                a,
                o = e._fullLayout._basePlotModules,
                c = s.length;
              if (r) for (a = 0; a < o.length; a++) o[a].transitionAxes && o[a].transitionAxes(e, s, i, t);
              for (var u in c ? ((n = f.extendFlat({}, i)).duration = 0, delete l.cartesian) : n = i, l) {
                var d = l[u];
                e._fullData[d[0]]._module.basePlotModule.plot(e, d, n, t);
              }
            }, I(e, i, o);
          }, w.transitionFromReact = function (e, t, r, n) {
            var a = e._fullLayout,
              i = a.transition,
              o = {},
              l = [];
            return o.prepareFn = function () {
              var e = a._plots;
              for (var i in o.redraw = !1, "some" === t.anim && (o.redraw = !0), "some" === r.anim && (o.redraw = !0), e) {
                var s = e[i],
                  c = s.xaxis,
                  u = s.yaxis,
                  d = n[c._name].range.slice(),
                  h = n[u._name].range.slice(),
                  p = c.range.slice(),
                  v = u.range.slice();
                c.setScale(), u.setScale();
                var g = null,
                  m = null;
                c.r2l(d[0]) === c.r2l(p[0]) && c.r2l(d[1]) === c.r2l(p[1]) || (g = {
                  xr0: d,
                  xr1: p
                }), u.r2l(h[0]) === u.r2l(v[0]) && u.r2l(h[1]) === u.r2l(v[1]) || (m = {
                  yr0: h,
                  yr1: v
                }), (g || m) && l.push(f.extendFlat({
                  plotinfo: s
                }, g, m));
              }
              return Promise.resolve();
            }, o.runFn = function (r) {
              for (var n, a, o, s = e._fullData, c = e._fullLayout._basePlotModules, u = [], d = 0; d < s.length; d++) u.push(d);
              function h() {
                if (e._fullLayout) for (var t = 0; t < c.length; t++) c[t].transitionAxes && c[t].transitionAxes(e, l, n, r);
              }
              function p() {
                if (e._fullLayout) for (var t = 0; t < c.length; t++) c[t].plot(e, o, a, r);
              }
              l.length && t.anim ? "traces first" === i.ordering ? (n = f.extendFlat({}, i, {
                duration: 0
              }), o = u, a = i, setTimeout(h, i.duration), p()) : (n = i, o = null, a = f.extendFlat({}, i, {
                duration: 0
              }), setTimeout(p, n.duration), h()) : l.length ? (n = i, h()) : t.anim && (o = u, a = i, p());
            }, I(e, i, o);
          }, w.doCalcdata = function (e, t) {
            var r,
              n,
              a,
              i,
              o = p.list(e),
              l = e._fullData,
              u = e._fullLayout,
              d = new Array(l.length),
              v = (e.calcdata || []).slice();
            for (e.calcdata = d, u._numBoxes = 0, u._numViolins = 0, u._violinScaleGroupStats = {}, e._hmpixcount = 0, e._hmlumcount = 0, u._piecolormap = {}, u._sunburstcolormap = {}, u._treemapcolormap = {}, u._iciclecolormap = {}, u._funnelareacolormap = {}, a = 0; a < l.length; a++) Array.isArray(t) && -1 === t.indexOf(a) && (d[a] = v[a]);
            for (a = 0; a < l.length; a++) (r = l[a])._arrayAttrs = c.findArrayAttributes(r), r._extremes = {};
            var g = u._subplots.polar || [];
            for (a = 0; a < g.length; a++) o.push(u[g[a]].radialaxis, u[g[a]].angularaxis);
            for (var m in u._colorAxes) {
              var y = u[m];
              !1 !== y.cauto && (delete y.cmin, delete y.cmax);
            }
            var x = !1;
            function b(t) {
              if (r = l[t], n = r._module, !0 === r.visible && r.transforms) {
                if (n && n.calc) {
                  var a = n.calc(e, r);
                  a[0] && a[0].t && a[0].t._scene && delete a[0].t._scene.dirty;
                }
                for (i = 0; i < r.transforms.length; i++) {
                  var o = r.transforms[i];
                  (n = T[o.type]) && n.calcTransform && (r._hasCalcTransform = !0, x = !0, n.calcTransform(e, r, o));
                }
              }
            }
            function _(t, a) {
              if (r = l[t], !!(n = r._module).isContainer === a) {
                var o = [];
                if (!0 === r.visible && 0 !== r._length) {
                  delete r._indexToPoints;
                  var s = r.transforms || [];
                  for (i = s.length - 1; i >= 0; i--) if (s[i].enabled) {
                    r._indexToPoints = s[i]._indexToPoints;
                    break;
                  }
                  n && n.calc && (o = n.calc(e, r));
                }
                Array.isArray(o) && o[0] || (o = [{
                  x: h,
                  y: h
                }]), o[0].t || (o[0].t = {}), o[0].trace = r, d[t] = o;
              }
            }
            for (R(o, l, u), a = 0; a < l.length; a++) _(a, !0);
            for (a = 0; a < l.length; a++) b(a);
            for (x && R(o, l, u), a = 0; a < l.length; a++) _(a, !0);
            for (a = 0; a < l.length; a++) _(a, !1);
            N(e);
            var w = function (e, t) {
              var r,
                n,
                a,
                i,
                o,
                l = [];
              function c(e, r, n) {
                var a = r._id.charAt(0);
                if ("histogram2dcontour" === e) {
                  var i = r._counterAxes[0],
                    o = p.getFromId(t, i),
                    l = "x" === a || "x" === i && "category" === o.type,
                    s = "y" === a || "y" === i && "category" === o.type;
                  return function (e, t) {
                    return 0 === e || 0 === t || l && e === n[t].length - 1 || s && t === n.length - 1 ? -1 : ("y" === a ? t : e) - 1;
                  };
                }
                return function (e, t) {
                  return "y" === a ? t : e;
                };
              }
              var u = {
                min: function (e) {
                  return f.aggNums(Math.min, null, e);
                },
                max: function (e) {
                  return f.aggNums(Math.max, null, e);
                },
                sum: function (e) {
                  return f.aggNums(function (e, t) {
                    return e + t;
                  }, null, e);
                },
                total: function (e) {
                  return f.aggNums(function (e, t) {
                    return e + t;
                  }, null, e);
                },
                mean: function (e) {
                  return f.mean(e);
                },
                "geometric mean": function (e) {
                  return f.geometricMean(e);
                },
                median: function (e) {
                  return f.median(e);
                }
              };
              function d(e, t) {
                return e[1] - t[1];
              }
              function h(e, t) {
                return t[1] - e[1];
              }
              for (r = 0; r < e.length; r++) {
                var v = e[r];
                if ("category" === v.type) {
                  var g = v.categoryorder.match(E);
                  if (g) {
                    var m = g[1],
                      y = g[2],
                      x = v._id.charAt(0),
                      b = "x" === x,
                      _ = [];
                    for (n = 0; n < v._categories.length; n++) _.push([v._categories[n], []]);
                    for (n = 0; n < v._traceIndices.length; n++) {
                      var w = v._traceIndices[n],
                        T = t._fullData[w];
                      if (!0 === T.visible) {
                        var M = T.type;
                        s.traceIs(T, "histogram") && (delete T._xautoBinFinished, delete T._yautoBinFinished);
                        var k = "splom" === M,
                          A = "scattergl" === M,
                          L = t.calcdata[w];
                        for (a = 0; a < L.length; a++) {
                          var S,
                            C,
                            O = L[a];
                          if (k) {
                            var D = T._axesDim[v._id];
                            if (!b) {
                              var P = T._diag[D][0];
                              P && (v = t._fullLayout[p.id2name(P)]);
                            }
                            var z = O.trace.dimensions[D].values;
                            for (i = 0; i < z.length; i++) for (S = v._categoriesMap[z[i]], o = 0; o < O.trace.dimensions.length; o++) if (o !== D) {
                              var I = O.trace.dimensions[o];
                              _[S][1].push(I.values[i]);
                            }
                          } else if (A) {
                            for (i = 0; i < O.t.x.length; i++) b ? (S = O.t.x[i], C = O.t.y[i]) : (S = O.t.y[i], C = O.t.x[i]), _[S][1].push(C);
                            O.t && O.t._scene && delete O.t._scene.dirty;
                          } else if (O.hasOwnProperty("z")) {
                            C = O.z;
                            var R = c(T.type, v, C);
                            for (i = 0; i < C.length; i++) for (o = 0; o < C[i].length; o++) (S = R(o, i)) + 1 && _[S][1].push(C[i][o]);
                          } else for (void 0 === (S = O.p) && (S = O[x]), void 0 === (C = O.s) && (C = O.v), void 0 === C && (C = b ? O.y : O.x), Array.isArray(C) || (C = void 0 === C ? [] : [C]), i = 0; i < C.length; i++) _[S][1].push(C[i]);
                        }
                      }
                    }
                    v._categoriesValue = _;
                    var N = [];
                    for (n = 0; n < _.length; n++) N.push([_[n][0], u[m](_[n][1])]);
                    N.sort("descending" === y ? h : d), v._categoriesAggregatedValue = N, v._initialCategories = N.map(function (e) {
                      return e[0];
                    }), l = l.concat(v.sortByInitialCategories());
                  }
                }
              }
              return l;
            }(o, e);
            if (w.length) {
              for (u._numBoxes = 0, u._numViolins = 0, a = 0; a < w.length; a++) _(w[a], !0);
              for (a = 0; a < w.length; a++) _(w[a], !1);
              N(e);
            }
            s.getComponentMethod("fx", "calc")(e), s.getComponentMethod("errorbars", "calc")(e);
          };
          var E = /(total|sum|min|max|mean|geometric mean|median) (ascending|descending)/;
          function R(e, t, r) {
            var n = {};
            function a(e) {
              e.clearCalc(), "multicategory" === e.type && e.setupMultiCategory(t), n[e._id] = 1;
            }
            f.simpleMap(e, a);
            for (var i = r._axisMatchGroups || [], o = 0; o < i.length; o++) for (var l in i[o]) n[l] || a(r[p.id2name(l)]);
          }
          function N(e) {
            var t,
              r,
              n,
              a = e._fullLayout,
              i = a._visibleModules,
              o = {};
            for (r = 0; r < i.length; r++) {
              var l = i[r],
                s = l.crossTraceCalc;
              if (s) {
                var c = l.basePlotModule.name;
                o[c] ? f.pushUnique(o[c], s) : o[c] = [s];
              }
            }
            for (n in o) {
              var u = o[n],
                d = a._subplots[n];
              if (Array.isArray(d)) for (t = 0; t < d.length; t++) {
                var h = d[t],
                  p = "cartesian" === n ? a._plots[h] : a[h];
                for (r = 0; r < u.length; r++) u[r](e, p, h);
              } else for (r = 0; r < u.length; r++) u[r](e);
            }
          }
          w.rehover = function (e) {
            e._fullLayout._rehover && e._fullLayout._rehover();
          }, w.redrag = function (e) {
            e._fullLayout._redrag && e._fullLayout._redrag();
          }, w.reselect = function (e) {
            var t = e._fullLayout,
              r = (e.layout || {}).selections,
              n = t._previousSelections;
            t._previousSelections = r;
            var a = t._reselect || JSON.stringify(r) !== JSON.stringify(n);
            s.getComponentMethod("selections", "reselect")(e, a);
          }, w.generalUpdatePerTraceModule = function (e, t, r, n) {
            var a,
              i = t.traceHash,
              o = {};
            for (a = 0; a < r.length; a++) {
              var l = r[a],
                s = l[0].trace;
              s.visible && (o[s.type] = o[s.type] || [], o[s.type].push(l));
            }
            for (var c in i) if (!o[c]) {
              var u = i[c][0];
              u[0].trace.visible = !1, o[c] = [u];
            }
            for (var d in o) {
              var h = o[d];
              h[0][0].trace._module.plot(e, t, f.filterVisible(h), n);
            }
            t.traceHash = o;
          }, w.plotBasePlot = function (e, t, r, n, a) {
            var i = s.getModule(e),
              o = x(t.calcdata, i)[0];
            i.plot(t, o, n, a);
          }, w.cleanBasePlot = function (e, t, r, n, a) {
            var i = a._has && a._has(e),
              o = r._has && r._has(e);
            i && !o && a["_" + e + "layer"].selectAll("g.trace").remove();
          };
        },
        3208: function (e, t, r) {
          "use strict";

          var n = r(7296);
          function a(e) {
            var t = e.description ? " " + e.description : "",
              r = e.keys || [];
            if (r.length > 0) {
              for (var n = [], a = 0; a < r.length; a++) n[a] = "`" + r[a] + "`";
              t += "Finally, the template string has access to ", t = 1 === r.length ? t + "variable " + n[0] : t + "variables " + n.slice(0, -1).join(", ") + " and " + n.slice(-1) + ".";
            }
            return t;
          }
          n.FORMAT_LINK, n.DATE_FORMAT_LINK, t.rb = function (e, t) {
            e = e || {}, a(t = t || {});
            var r = {
              valType: "string",
              dflt: "",
              editType: e.editType || "none"
            };
            return !1 !== e.arrayOk && (r.arrayOk = !0), r;
          }, t.ay = function (e, t) {
            e = e || {}, a(t = t || {});
            var r = {
              valType: "string",
              dflt: "",
              editType: e.editType || "calc"
            };
            return !1 !== e.arrayOk && (r.arrayOk = !0), r;
          }, t.LF = function (e, t) {
            return t = t || {}, (e = e || {}).newshape, a(t), {
              valType: "string",
              dflt: "",
              editType: e.editType || "arraydraw"
            };
          };
        },
        3626: function (e, t, r) {
          "use strict";

          var n = r(8636),
            a = r(4969),
            i = r(6539),
            o = r(6174),
            l = r(5425).addStyleRule,
            s = r(3049),
            c = r(9829),
            u = r(6704),
            f = s.extendFlat,
            d = s.extendDeepAll;
          function h(e) {
            var a = e.name,
              i = e.categories,
              o = e.meta;
            if (t.modules[a]) n.log("Type " + a + " already registered");else {
              t.subplotsRegistry[e.basePlotModule.name] || function (e) {
                var r = e.name;
                if (t.subplotsRegistry[r]) n.log("Plot type " + r + " already registered.");else for (var a in m(e), t.subplotsRegistry[r] = e, t.componentsRegistry) b(a, e.name);
              }(e.basePlotModule);
              for (var s = {}, c = 0; c < i.length; c++) s[i[c]] = !0, t.allCategories[i[c]] = !0;
              for (var u in t.modules[a] = {
                _module: e,
                categories: s
              }, o && Object.keys(o).length && (t.modules[a].meta = o), t.allTypes.push(a), t.componentsRegistry) y(u, a);
              e.layoutAttributes && f(t.traceLayoutAttributes, e.layoutAttributes);
              var d = e.basePlotModule,
                h = d.name;
              if ("mapbox" === h) {
                var p = d.constants.styleRules;
                for (var v in p) l(".js-plotly-plot .plotly .mapboxgl-" + v, p[v]);
              }
              "map" === h && r(6144), "geo" !== h && "mapbox" !== h && "map" !== h || void 0 !== window.PlotlyGeoAssets || (window.PlotlyGeoAssets = {
                topojson: {}
              });
            }
          }
          function p(e) {
            if ("string" != typeof e.name) throw new Error("Component module *name* must be a string.");
            var r = e.name;
            for (var n in t.componentsRegistry[r] = e, e.layoutAttributes && (e.layoutAttributes._isLinkedToArray && i(t.layoutArrayContainers, r), m(e)), t.modules) y(r, n);
            for (var a in t.subplotsRegistry) b(r, a);
            for (var o in t.transformsRegistry) x(r, o);
            e.schema && e.schema.layout && d(u, e.schema.layout);
          }
          function v(e) {
            if ("string" != typeof e.name) throw new Error("Transform module *name* must be a string.");
            var r = "Transform module " + e.name,
              a = "function" == typeof e.transform,
              i = "function" == typeof e.calcTransform;
            if (!a && !i) throw new Error(r + " is missing a *transform* or *calcTransform* method.");
            for (var l in a && i && n.log([r + " has both a *transform* and *calcTransform* methods.", "Please note that all *transform* methods are executed", "before all *calcTransform* methods."].join(" ")), o(e.attributes) || n.log(r + " registered without an *attributes* object."), "function" != typeof e.supplyDefaults && n.log(r + " registered without a *supplyDefaults* method."), t.transformsRegistry[e.name] = e, t.componentsRegistry) x(l, e.name);
          }
          function g(e) {
            var r = e.name,
              n = r.split("-")[0],
              a = e.dictionary,
              i = e.format,
              o = a && Object.keys(a).length,
              l = i && Object.keys(i).length,
              s = t.localeRegistry,
              c = s[r];
            if (c || (s[r] = c = {}), n !== r) {
              var u = s[n];
              u || (s[n] = u = {}), o && u.dictionary === c.dictionary && (u.dictionary = a), l && u.format === c.format && (u.format = i);
            }
            o && (c.dictionary = a), l && (c.format = i);
          }
          function m(e) {
            if (e.layoutAttributes) {
              var r = e.layoutAttributes._arrayAttrRegexps;
              if (r) for (var n = 0; n < r.length; n++) i(t.layoutArrayRegexes, r[n]);
            }
          }
          function y(e, r) {
            var n = t.componentsRegistry[e].schema;
            if (n && n.traces) {
              var a = n.traces[r];
              a && d(t.modules[r]._module.attributes, a);
            }
          }
          function x(e, r) {
            var n = t.componentsRegistry[e].schema;
            if (n && n.transforms) {
              var a = n.transforms[r];
              a && d(t.transformsRegistry[r].attributes, a);
            }
          }
          function b(e, r) {
            var n = t.componentsRegistry[e].schema;
            if (n && n.subplots) {
              var a = t.subplotsRegistry[r],
                i = a.layoutAttributes,
                o = "subplot" === a.attr ? a.name : a.attr;
              Array.isArray(o) && (o = o[0]);
              var l = n.subplots[o];
              i && l && d(i, l);
            }
          }
          function _(e) {
            return "object" == typeof e && (e = e.type), e;
          }
          t.modules = {}, t.allCategories = {}, t.allTypes = [], t.subplotsRegistry = {}, t.transformsRegistry = {}, t.componentsRegistry = {}, t.layoutArrayContainers = [], t.layoutArrayRegexes = [], t.traceLayoutAttributes = {}, t.localeRegistry = {}, t.apiMethodRegistry = {}, t.collectableSubplotTypes = null, t.register = function (e) {
            if (t.collectableSubplotTypes = null, !e) throw new Error("No argument passed to Plotly.register.");
            e && !Array.isArray(e) && (e = [e]);
            for (var r = 0; r < e.length; r++) {
              var n = e[r];
              if (!n) throw new Error("Invalid module was attempted to be registered!");
              switch (n.moduleType) {
                case "trace":
                  h(n);
                  break;
                case "transform":
                  v(n);
                  break;
                case "component":
                  p(n);
                  break;
                case "locale":
                  g(n);
                  break;
                case "apiMethod":
                  var a = n.name;
                  t.apiMethodRegistry[a] = n.fn;
                  break;
                default:
                  throw new Error("Invalid module was attempted to be registered!");
              }
            }
          }, t.getModule = function (e) {
            var r = t.modules[_(e)];
            return !!r && r._module;
          }, t.traceIs = function (e, r) {
            if ("various" === (e = _(e))) return !1;
            var a = t.modules[e];
            return a || (e && n.log("Unrecognized trace type " + e + "."), a = t.modules[c.type.dflt]), !!a.categories[r];
          }, t.getTransformIndices = function (e, t) {
            for (var r = [], n = e.transforms || [], a = 0; a < n.length; a++) n[a].type === t && r.push(a);
            return r;
          }, t.hasTransform = function (e, t) {
            for (var r = e.transforms || [], n = 0; n < r.length; n++) if (r[n].type === t) return !0;
            return !1;
          }, t.getComponentMethod = function (e, r) {
            var n = t.componentsRegistry[e];
            return n && n[r] || a;
          }, t.call = function () {
            var e = arguments[0],
              r = [].slice.call(arguments, 1);
            return t.apiMethodRegistry[e].apply(null, r);
          };
        },
        3164: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(4809),
            i = a.extendFlat,
            o = a.extendDeep;
          function l(e) {
            var t;
            switch (e) {
              case "themes__thumb":
                t = {
                  autosize: !0,
                  width: 150,
                  height: 150,
                  title: {
                    text: ""
                  },
                  showlegend: !1,
                  margin: {
                    l: 5,
                    r: 5,
                    t: 5,
                    b: 5,
                    pad: 0
                  },
                  annotations: []
                };
                break;
              case "thumbnail":
                t = {
                  title: {
                    text: ""
                  },
                  hidesources: !0,
                  showlegend: !1,
                  borderwidth: 0,
                  bordercolor: "",
                  margin: {
                    l: 1,
                    r: 1,
                    t: 1,
                    b: 1,
                    pad: 0
                  },
                  annotations: []
                };
                break;
              default:
                t = {};
            }
            return t;
          }
          e.exports = function (e, t) {
            var r,
              a,
              s = e.data,
              c = e.layout,
              u = o([], s),
              f = o({}, c, l(t.tileClass)),
              d = e._context || {};
            if (t.width && (f.width = t.width), t.height && (f.height = t.height), "thumbnail" === t.tileClass || "themes__thumb" === t.tileClass) {
              f.annotations = [];
              var h = Object.keys(f);
              for (r = 0; r < h.length; r++) a = h[r], ["xaxis", "yaxis", "zaxis"].indexOf(a.slice(0, 5)) > -1 && (f[h[r]].title = {
                text: ""
              });
              for (r = 0; r < u.length; r++) {
                var p = u[r];
                p.showscale = !1, p.marker && (p.marker.showscale = !1), n.traceIs(p, "pie-like") && (p.textposition = "none");
              }
            }
            if (Array.isArray(t.annotations)) for (r = 0; r < t.annotations.length; r++) f.annotations.push(t.annotations[r]);
            var v = Object.keys(f).filter(function (e) {
              return e.match(/^scene\d*$/);
            });
            if (v.length) {
              var g = {};
              for ("thumbnail" === t.tileClass && (g = {
                title: {
                  text: ""
                },
                showaxeslabels: !1,
                showticklabels: !1,
                linetickenable: !1
              }), r = 0; r < v.length; r++) {
                var m = f[v[r]];
                m.xaxis || (m.xaxis = {}), m.yaxis || (m.yaxis = {}), m.zaxis || (m.zaxis = {}), i(m.xaxis, g), i(m.yaxis, g), i(m.zaxis, g), m._scene = null;
              }
            }
            var y = document.createElement("div");
            t.tileClass && (y.className = t.tileClass);
            var x = {
              gd: y,
              td: y,
              layout: f,
              data: u,
              config: {
                staticPlot: void 0 === t.staticPlot || t.staticPlot,
                plotGlPixelRatio: void 0 === t.plotGlPixelRatio ? 2 : t.plotGlPixelRatio,
                displaylogo: t.displaylogo || !1,
                showLink: t.showLink || !1,
                showTips: t.showTips || !1,
                mapboxAccessToken: d.mapboxAccessToken
              }
            };
            return "transparent" !== t.setBackground && (x.config.setBackground = t.setBackground || "opaque"), x.gd.defaultLayout = l(t.tileClass), x;
          };
        },
        6452: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(491),
            i = r(3353),
            o = r(4619);
          e.exports = function (e, t) {
            var r;
            return n.isPlainObject(e) || (r = n.getGraphDiv(e)), (t = t || {}).format = t.format || "png", t.width = t.width || null, t.height = t.height || null, t.imageDataOnly = !0, new Promise(function (l, s) {
              r && r._snapshotInProgress && s(new Error("Snapshotting already in progress.")), n.isIE() && "svg" !== t.format && s(new Error(o.MSG_IE_BAD_FORMAT)), r && (r._snapshotInProgress = !0);
              var c = a(e, t),
                u = t.filename || e.fn || "newplot";
              u += "." + t.format.replace("-", "."), c.then(function (e) {
                return r && (r._snapshotInProgress = !1), i(e, u, t.format);
              }).then(function (e) {
                l(e);
              }).catch(function (e) {
                r && (r._snapshotInProgress = !1), s(e);
              });
            });
          };
        },
        3353: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(4619);
          e.exports = function (e, t, r) {
            var i = document.createElement("a"),
              o = "download" in i;
            return new Promise(function (l, s) {
              var c, u;
              if (n.isIE()) return c = a.createBlob(e, "svg"), window.navigator.msSaveBlob(c, t), c = null, l(t);
              if (o) return c = a.createBlob(e, r), u = a.createObjectURL(c), i.href = u, i.download = t, document.body.appendChild(i), i.click(), document.body.removeChild(i), a.revokeObjectURL(u), c = null, l(t);
              if (n.isSafari()) {
                var f = "svg" === r ? "," : ";base64,";
                return a.octetStream(f + encodeURIComponent(e)), l(t);
              }
              s(new Error("download error"));
            });
          };
        },
        4619: function (e, t, r) {
          "use strict";

          var n = r(3626);
          t.getDelay = function (e) {
            return e._has && (e._has("gl3d") || e._has("gl2d") || e._has("mapbox") || e._has("map")) ? 500 : 0;
          }, t.getRedrawFunc = function (e) {
            return function () {
              n.getComponentMethod("colorbar", "draw")(e);
            };
          }, t.encodeSVG = function (e) {
            return "data:image/svg+xml," + encodeURIComponent(e);
          }, t.encodeJSON = function (e) {
            return "data:application/json," + encodeURIComponent(e);
          };
          var a = window.URL || window.webkitURL;
          t.createObjectURL = function (e) {
            return a.createObjectURL(e);
          }, t.revokeObjectURL = function (e) {
            return a.revokeObjectURL(e);
          }, t.createBlob = function (e, t) {
            if ("svg" === t) return new window.Blob([e], {
              type: "image/svg+xml;charset=utf-8"
            });
            if ("full-json" === t) return new window.Blob([e], {
              type: "application/json;charset=utf-8"
            });
            var r = function (e) {
              for (var t = e.length, r = new ArrayBuffer(t), n = new Uint8Array(r), a = 0; a < t; a++) n[a] = e.charCodeAt(a);
              return r;
            }(window.atob(e));
            return new window.Blob([r], {
              type: "image/" + t
            });
          }, t.octetStream = function (e) {
            document.location.href = "data:application/octet-stream" + e;
          }, t.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/, t.MSG_IE_BAD_FORMAT = "Sorry IE does not support downloading from canvas. Try {format:'svg'} instead.";
        },
        6170: function (e, t, r) {
          "use strict";

          var n = r(4619),
            a = {
              getDelay: n.getDelay,
              getRedrawFunc: n.getRedrawFunc,
              clone: r(3164),
              toSVG: r(6243),
              svgToImg: r(2914),
              toImage: r(6896),
              downloadImage: r(6452)
            };
          e.exports = a;
        },
        2914: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(7683).EventEmitter,
            i = r(4619);
          e.exports = function (e) {
            var t = e.emitter || new a(),
              r = new Promise(function (a, o) {
                var l = window.Image,
                  s = e.svg,
                  c = e.format || "png";
                if (n.isIE() && "svg" !== c) {
                  var u = new Error(i.MSG_IE_BAD_FORMAT);
                  return o(u), e.promise ? r : t.emit("error", u);
                }
                var f,
                  d,
                  h = e.canvas,
                  p = e.scale || 1,
                  v = e.width || 300,
                  g = e.height || 150,
                  m = p * v,
                  y = p * g,
                  x = h.getContext("2d", {
                    willReadFrequently: !0
                  }),
                  b = new l();
                "svg" === c || n.isSafari() ? d = i.encodeSVG(s) : (f = i.createBlob(s, "svg"), d = i.createObjectURL(f)), h.width = m, h.height = y, b.onload = function () {
                  var r;
                  switch (f = null, i.revokeObjectURL(d), "svg" !== c && x.drawImage(b, 0, 0, m, y), c) {
                    case "jpeg":
                      r = h.toDataURL("image/jpeg");
                      break;
                    case "png":
                      r = h.toDataURL("image/png");
                      break;
                    case "webp":
                      r = h.toDataURL("image/webp");
                      break;
                    case "svg":
                      r = d;
                      break;
                    default:
                      var n = "Image format is not jpeg, png, svg or webp.";
                      if (o(new Error(n)), !e.promise) return t.emit("error", n);
                  }
                  a(r), e.promise || t.emit("success", r);
                }, b.onerror = function (r) {
                  if (f = null, i.revokeObjectURL(d), o(r), !e.promise) return t.emit("error", r);
                }, b.src = d;
              });
            return e.promise ? r : t;
          };
        },
        6896: function (e, t, r) {
          "use strict";

          var n = r(7683).EventEmitter,
            a = r(3626),
            i = r(4809),
            o = r(4619),
            l = r(3164),
            s = r(6243),
            c = r(2914);
          e.exports = function (e, t) {
            var r = new n(),
              u = l(e, {
                format: "png"
              }),
              f = u.gd;
            f.style.position = "absolute", f.style.left = "-5000px", document.body.appendChild(f);
            var d = o.getRedrawFunc(f);
            return a.call("_doPlot", f, u.data, u.layout, u.config).then(d).then(function () {
              var e = o.getDelay(f._fullLayout);
              setTimeout(function () {
                var e = s(f),
                  n = document.createElement("canvas");
                n.id = i.randstr(), (r = c({
                  format: t.format,
                  width: f._fullLayout.width,
                  height: f._fullLayout.height,
                  canvas: n,
                  emitter: r,
                  svg: e
                })).clean = function () {
                  f && document.body.removeChild(f);
                };
              }, e);
            }).catch(function (e) {
              r.emit("error", e);
            }), r;
          };
        },
        6243: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4809),
            i = r(2203),
            o = r(8766),
            l = r(2972),
            s = /"/g,
            c = "TOBESTRIPPED",
            u = new RegExp('("' + c + ")|(" + c + '")', "g");
          e.exports = function (e, t, r) {
            var f,
              d = e._fullLayout,
              h = d._paper,
              p = d._toppaper,
              v = d.width,
              g = d.height;
            h.insert("rect", ":first-child").call(i.setRect, 0, 0, v, g).call(o.fill, d.paper_bgcolor);
            var m = d._basePlotModules || [];
            for (f = 0; f < m.length; f++) {
              var y = m[f];
              y.toSVG && y.toSVG(e);
            }
            if (p) {
              var x = p.node().childNodes,
                b = Array.prototype.slice.call(x);
              for (f = 0; f < b.length; f++) {
                var _ = b[f];
                _.childNodes.length && h.node().appendChild(_);
              }
            }
            d._draggers && d._draggers.remove(), h.node().style.background = "", h.selectAll("text").attr({
              "data-unformatted": null,
              "data-math": null
            }).each(function () {
              var e = n.select(this);
              if ("hidden" !== this.style.visibility && "none" !== this.style.display) {
                e.style({
                  visibility: null,
                  display: null
                });
                var t = this.style.fontFamily;
                t && -1 !== t.indexOf('"') && e.style("font-family", t.replace(s, c));
                var r = this.style.fontWeight;
                !r || "normal" !== r && "400" !== r || e.style("font-weight", void 0);
                var a = this.style.fontStyle;
                a && "normal" === a && e.style("font-style", void 0);
                var i = this.style.fontVariant;
                i && "normal" === i && e.style("font-variant", void 0);
              } else e.remove();
            }), h.selectAll(".gradient_filled,.pattern_filled").each(function () {
              var e = n.select(this),
                t = this.style.fill;
              t && -1 !== t.indexOf("url(") && e.style("fill", t.replace(s, c));
              var r = this.style.stroke;
              r && -1 !== r.indexOf("url(") && e.style("stroke", r.replace(s, c));
            }), "pdf" !== t && "eps" !== t || h.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), h.node().setAttributeNS(l.xmlns, "xmlns", l.svg), h.node().setAttributeNS(l.xmlns, "xmlns:xlink", l.xlink), "svg" === t && r && (h.attr("width", r * v), h.attr("height", r * g), h.attr("viewBox", "0 0 " + v + " " + g));
            var w = new window.XMLSerializer().serializeToString(h.node());
            return w = (w = (w = function (e) {
              var t = n.select("body").append("div").style({
                  display: "none"
                }).html(""),
                r = e.replace(/(&[^;]*;)/gi, function (e) {
                  return "&lt;" === e ? "&#60;" : "&rt;" === e ? "&#62;" : -1 !== e.indexOf("<") || -1 !== e.indexOf(">") ? "" : t.html(e).text();
                });
              return t.remove(), r;
            }(w)).replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;")).replace(u, "'"), a.isIE() && (w = (w = (w = w.replace(/"/gi, "'")).replace(/(\('#)([^']*)('\))/gi, '("#$2")')).replace(/(\\')/gi, '"')), w;
          };
        },
        5374: function (e, t, r) {
          "use strict";

          var n = r(4809);
          e.exports = function (e, t) {
            for (var r = 0; r < e.length; r++) e[r].i = r;
            n.mergeArray(t.text, e, "tx"), n.mergeArray(t.hovertext, e, "htx");
            var a = t.marker;
            if (a) {
              n.mergeArray(a.opacity, e, "mo", !0), n.mergeArray(a.color, e, "mc");
              var i = a.line;
              i && (n.mergeArray(i.color, e, "mlc"), n.mergeArrayCastPositive(i.width, e, "mlw"));
            }
          };
        },
        1481: function (e, t, r) {
          "use strict";

          var n = r(6640),
            a = r(712).axisHoverFormat,
            i = r(3208).rb,
            o = r(3208).ay,
            l = r(7163),
            s = r(337),
            c = r(6155),
            u = r(4850).k,
            f = r(3049).extendFlat,
            d = s({
              editType: "calc",
              arrayOk: !0,
              colorEditType: "style"
            }),
            h = f({}, n.marker.line.width, {
              dflt: 0
            }),
            p = f({
              width: h,
              editType: "calc"
            }, l("marker.line")),
            v = f({
              line: p,
              editType: "calc"
            }, l("marker"), {
              opacity: {
                valType: "number",
                arrayOk: !0,
                dflt: 1,
                min: 0,
                max: 1,
                editType: "style"
              },
              pattern: u,
              cornerradius: {
                valType: "any",
                editType: "calc"
              }
            });
          e.exports = {
            x: n.x,
            x0: n.x0,
            dx: n.dx,
            y: n.y,
            y0: n.y0,
            dy: n.dy,
            xperiod: n.xperiod,
            yperiod: n.yperiod,
            xperiod0: n.xperiod0,
            yperiod0: n.yperiod0,
            xperiodalignment: n.xperiodalignment,
            yperiodalignment: n.yperiodalignment,
            xhoverformat: a("x"),
            yhoverformat: a("y"),
            text: n.text,
            texttemplate: o({
              editType: "plot"
            }, {
              keys: c.eventDataKeys
            }),
            hovertext: n.hovertext,
            hovertemplate: i({}, {
              keys: c.eventDataKeys
            }),
            textposition: {
              valType: "enumerated",
              values: ["inside", "outside", "auto", "none"],
              dflt: "auto",
              arrayOk: !0,
              editType: "calc"
            },
            insidetextanchor: {
              valType: "enumerated",
              values: ["end", "middle", "start"],
              dflt: "end",
              editType: "plot"
            },
            textangle: {
              valType: "angle",
              dflt: "auto",
              editType: "plot"
            },
            textfont: f({}, d, {}),
            insidetextfont: f({}, d, {}),
            outsidetextfont: f({}, d, {}),
            constraintext: {
              valType: "enumerated",
              values: ["inside", "outside", "both", "none"],
              dflt: "both",
              editType: "calc"
            },
            cliponaxis: f({}, n.cliponaxis, {}),
            orientation: {
              valType: "enumerated",
              values: ["v", "h"],
              editType: "calc+clearAxisTypes"
            },
            base: {
              valType: "any",
              dflt: null,
              arrayOk: !0,
              editType: "calc"
            },
            offset: {
              valType: "number",
              dflt: null,
              arrayOk: !0,
              editType: "calc"
            },
            width: {
              valType: "number",
              dflt: null,
              min: 0,
              arrayOk: !0,
              editType: "calc"
            },
            marker: v,
            offsetgroup: n.offsetgroup,
            alignmentgroup: n.alignmentgroup,
            selected: {
              marker: {
                opacity: n.selected.marker.opacity,
                color: n.selected.marker.color,
                editType: "style"
              },
              textfont: n.selected.textfont,
              editType: "style"
            },
            unselected: {
              marker: {
                opacity: n.unselected.marker.opacity,
                color: n.unselected.marker.color,
                editType: "style"
              },
              textfont: n.unselected.textfont,
              editType: "style"
            },
            zorder: n.zorder,
            _deprecated: {
              bardir: {
                valType: "enumerated",
                editType: "calc",
                values: ["v", "h"]
              }
            }
          };
        },
        7565: function (e, t, r) {
          "use strict";

          var n = r(9714),
            a = r(528),
            i = r(5477).hasColorscale,
            o = r(8379),
            l = r(5374),
            s = r(8861);
          e.exports = function (e, t) {
            var r,
              c,
              u,
              f,
              d,
              h,
              p = n.getFromId(e, t.xaxis || "x"),
              v = n.getFromId(e, t.yaxis || "y"),
              g = {
                msUTC: !(!t.base && 0 !== t.base)
              };
            "h" === t.orientation ? (r = p.makeCalcdata(t, "x", g), u = v.makeCalcdata(t, "y"), f = a(t, v, "y", u), d = !!t.yperiodalignment, h = "y") : (r = v.makeCalcdata(t, "y", g), u = p.makeCalcdata(t, "x"), f = a(t, p, "x", u), d = !!t.xperiodalignment, h = "x"), c = f.vals;
            for (var m = Math.min(c.length, r.length), y = new Array(m), x = 0; x < m; x++) y[x] = {
              p: c[x],
              s: r[x]
            }, d && (y[x].orig_p = u[x], y[x][h + "End"] = f.ends[x], y[x][h + "Start"] = f.starts[x]), t.ids && (y[x].id = String(t.ids[x]));
            return i(t, "marker") && o(e, t, {
              vals: t.marker.color,
              containerStr: "marker",
              cLetter: "c"
            }), i(t, "marker.line") && o(e, t, {
              vals: t.marker.line.color,
              containerStr: "marker.line",
              cLetter: "c"
            }), l(y, t), s(y, t), y;
          };
        },
        6155: function (e) {
          "use strict";

          e.exports = {
            TEXTPAD: 3,
            eventDataKeys: ["value", "label"]
          };
        },
        4782: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809).isArrayOrTypedArray,
            i = r(3821).BADNUM,
            o = r(3626),
            l = r(9714),
            s = r(4391).getAxisGroup,
            c = r(2880);
          function u(e, t, r, o, u) {
            if (o.length) {
              var b, _, w, T;
              switch (function (e, t) {
                var r, i;
                for (r = 0; r < t.length; r++) {
                  var o,
                    l = t[r],
                    s = l[0].trace,
                    c = "funnel" === s.type ? s._base : s.base,
                    u = "h" === s.orientation ? s.xcalendar : s.ycalendar,
                    f = "category" === e.type || "multicategory" === e.type ? function () {
                      return null;
                    } : e.d2c;
                  if (a(c)) {
                    for (i = 0; i < Math.min(c.length, l.length); i++) o = f(c[i], 0, u), n(o) ? (l[i].b = +o, l[i].hasB = 1) : l[i].b = 0;
                    for (; i < l.length; i++) l[i].b = 0;
                  } else {
                    o = f(c, 0, u);
                    var d = n(o);
                    for (o = d ? o : 0, i = 0; i < l.length; i++) l[i].b = o, d && (l[i].hasB = 1);
                  }
                }
              }(r, o), u.mode) {
                case "overlay":
                  f(t, r, o, u);
                  break;
                case "group":
                  for (b = [], _ = [], w = 0; w < o.length; w++) void 0 === (T = o[w])[0].trace.offset ? _.push(T) : b.push(T);
                  _.length && function (e, t, r, n, a) {
                    var o = new c(n, {
                      posAxis: t,
                      sepNegVal: !1,
                      overlapNoMerge: !a.norm
                    });
                    (function (e, t, r, n) {
                      for (var a = e._fullLayout, i = r.positions, o = r.distinctPositions, l = r.minDiff, c = r.traces, u = c.length, f = i.length !== o.length, d = l * (1 - n.gap), g = s(a, t._id) + c[0][0].trace.orientation, m = a._alignmentOpts[g] || {}, y = 0; y < u; y++) {
                        var x,
                          b,
                          _ = c[y],
                          w = _[0].trace,
                          T = m[w.alignmentgroup] || {},
                          M = Object.keys(T.offsetGroups || {}).length,
                          k = (x = M ? d / M : f ? d / u : d) * (1 - (n.groupgap || 0));
                        b = M ? ((2 * w._offsetIndex + 1 - M) * x - k) / 2 : f ? ((2 * y + 1 - u) * x - k) / 2 : -k / 2;
                        var A = _[0].t;
                        A.barwidth = k, A.poffset = b, A.bargroupwidth = d, A.bardelta = l;
                      }
                      r.binWidth = c[0][0].t.barwidth / 100, h(r), p(t, r), v(t, r, f);
                    })(e, t, o, a), function (e, t) {
                      for (var r = e.traces, n = 0; n < r.length; n++) {
                        var a = r[n];
                        if (void 0 === a[0].trace.base) for (var o = new c([a], {
                            posAxis: t,
                            sepNegVal: !0,
                            overlapNoMerge: !0
                          }), l = 0; l < a.length; l++) {
                          var s = a[l];
                          if (s.p !== i) {
                            var u = o.put(s.p, s.b + s.s);
                            u && (s.b = u);
                          }
                        }
                      }
                    }(o, t), a.norm ? (m(o), y(r, o, a)) : g(r, o);
                  }(e, t, r, _, u), b.length && f(t, r, b, u);
                  break;
                case "stack":
                case "relative":
                  for (b = [], _ = [], w = 0; w < o.length; w++) void 0 === (T = o[w])[0].trace.base ? _.push(T) : b.push(T);
                  !function (e) {
                    if (!(e.length < 2)) {
                      var t, r, a, i, o, l;
                      for (t = 0; t < e.length && void 0 === (i = (r = e[t][0].trace).marker ? r.marker.cornerradius : void 0); t++);
                      if (void 0 !== i) for (o = n(i) ? +i : +i.slice(0, -1), l = n(i) ? "px" : "%", t = 0; t < e.length; t++) (a = e[t][0].t).cornerradiusvalue = o, a.cornerradiusform = l;
                    }
                  }(_), _.length && function (e, t, r, n, a) {
                    var o = new c(n, {
                      posAxis: t,
                      sepNegVal: "relative" === a.mode,
                      overlapNoMerge: !(a.norm || "stack" === a.mode || "relative" === a.mode)
                    });
                    d(t, o, a), function (e, t, r) {
                      var n,
                        a,
                        o,
                        s,
                        c,
                        u,
                        f = x(e),
                        d = t.traces;
                      for (s = 0; s < d.length; s++) if ("funnel" === (a = (n = d[s])[0].trace).type) for (c = 0; c < n.length; c++) (u = n[c]).s !== i && t.put(u.p, -.5 * u.s);
                      for (s = 0; s < d.length; s++) {
                        o = "funnel" === (a = (n = d[s])[0].trace).type;
                        var h = [];
                        for (c = 0; c < n.length; c++) if ((u = n[c]).s !== i) {
                          var p;
                          p = o ? u.s : u.s + u.b;
                          var v = t.put(u.p, p),
                            g = v + p;
                          u.b = v, u[f] = g, r.norm || (h.push(g), u.hasB && h.push(v));
                        }
                        r.norm || (a._extremes[e._id] = l.findExtremes(e, h, {
                          tozero: !0,
                          padded: !0
                        }));
                      }
                    }(r, o, a);
                    for (var s = 0; s < n.length; s++) for (var u = n[s], f = 0; f < u.length; f++) {
                      var h = u[f];
                      h.s !== i && h.b + h.s === o.get(h.p, h.s) && (h._outmost = !0);
                    }
                    a.norm && y(r, o, a);
                  }(0, t, r, _, u), b.length && f(t, r, b, u);
              }
              !function (e) {
                var t, r, a, i, o, l, s;
                for (t = 0; t < e.length; t++) a = (r = e[t])[0].trace, void 0 === (i = r[0].t).cornerradiusvalue && void 0 !== (o = a.marker ? a.marker.cornerradius : void 0) && (l = n(o) ? +o : +o.slice(0, -1), s = n(o) ? "px" : "%", i.cornerradiusvalue = l, i.cornerradiusform = s);
              }(o), function (e, t) {
                var r,
                  i,
                  o,
                  l = x(t),
                  s = {},
                  c = 1 / 0,
                  u = -1 / 0;
                for (r = 0; r < e.length; r++) for (o = e[r], i = 0; i < o.length; i++) {
                  var f = o[i].p;
                  n(f) && (c = Math.min(c, f), u = Math.max(u, f));
                }
                var d = 1e4 / (u - c),
                  h = s.round = function (e) {
                    return String(Math.round(d * (e - c)));
                  },
                  p = {},
                  v = {},
                  g = e.some(function (e) {
                    var t = e[0].trace;
                    return "marker" in t && t.marker.cornerradius;
                  });
                for (r = 0; r < e.length; r++) {
                  (o = e[r])[0].t.extents = s;
                  var m = o[0].t.poffset,
                    y = a(m);
                  for (i = 0; i < o.length; i++) {
                    var b = o[i],
                      _ = b[l] - b.w / 2;
                    if (n(_)) {
                      var w = b[l] + b.w / 2,
                        T = h(b.p);
                      s[T] ? s[T] = [Math.min(_, s[T][0]), Math.max(w, s[T][1])] : s[T] = [_, w];
                    }
                    if (b.p0 = b.p + (y ? m[i] : m), b.p1 = b.p0 + b.w, b.s0 = b.b, b.s1 = b.s0 + b.s, g) {
                      var M = Math.min(b.s0, b.s1) || 0,
                        k = Math.max(b.s0, b.s1) || 0,
                        A = b[l];
                      p[A] = A in p ? Math.min(p[A], M) : M, v[A] = A in v ? Math.max(v[A], k) : k;
                    }
                  }
                }
                g && function (e, t, r, n) {
                  for (var a = x(n), i = 0; i < e.length; i++) for (var o = e[i], l = 0; l < o.length; l++) {
                    var s = o[l],
                      c = s[a];
                    s._sMin = t[c], s._sMax = r[c];
                  }
                }(e, p, v, t);
              }(o, t);
            }
          }
          function f(e, t, r, n) {
            for (var a = 0; a < r.length; a++) {
              var i = r[a],
                o = new c([i], {
                  posAxis: e,
                  sepNegVal: !1,
                  overlapNoMerge: !n.norm
                });
              d(e, o, n), n.norm ? (m(o), y(t, o, n)) : g(t, o);
            }
          }
          function d(e, t, r) {
            for (var n = t.minDiff, a = t.traces, i = n * (1 - r.gap), o = i * (1 - (r.groupgap || 0)), l = -o / 2, s = 0; s < a.length; s++) {
              var c = a[s][0].t;
              c.barwidth = o, c.poffset = l, c.bargroupwidth = i, c.bardelta = n;
            }
            t.binWidth = a[0][0].t.barwidth / 100, h(t), p(e, t), v(e, t);
          }
          function h(e) {
            var t,
              r,
              i = e.traces;
            for (t = 0; t < i.length; t++) {
              var o,
                l = i[t],
                s = l[0],
                c = s.trace,
                u = s.t,
                f = c._offset || c.offset,
                d = u.poffset;
              if (a(f)) {
                for (o = Array.prototype.slice.call(f, 0, l.length), r = 0; r < o.length; r++) n(o[r]) || (o[r] = d);
                for (r = o.length; r < l.length; r++) o.push(d);
                u.poffset = o;
              } else void 0 !== f && (u.poffset = f);
              var h = c._width || c.width,
                p = u.barwidth;
              if (a(h)) {
                var v = Array.prototype.slice.call(h, 0, l.length);
                for (r = 0; r < v.length; r++) n(v[r]) || (v[r] = p);
                for (r = v.length; r < l.length; r++) v.push(p);
                if (u.barwidth = v, void 0 === f) {
                  for (o = [], r = 0; r < l.length; r++) o.push(d + (p - v[r]) / 2);
                  u.poffset = o;
                }
              } else void 0 !== h && (u.barwidth = h, void 0 === f && (u.poffset = d + (p - h) / 2));
            }
          }
          function p(e, t) {
            for (var r = t.traces, n = x(e), i = 0; i < r.length; i++) for (var o = r[i], l = o[0].t, s = l.poffset, c = a(s), u = l.barwidth, f = a(u), d = 0; d < o.length; d++) {
              var h = o[d],
                p = h.w = f ? u[d] : u;
              void 0 === h.p && (h.p = h[n], h["orig_" + n] = h[n]);
              var v = (c ? s[d] : s) + p / 2;
              h[n] = h.p + v;
            }
          }
          function v(e, t, r) {
            var n = t.traces,
              i = t.minDiff / 2;
            l.minDtick(e, t.minDiff, t.distinctPositions[0], r);
            for (var o = 0; o < n.length; o++) {
              var s,
                c,
                u,
                f,
                d = n[o],
                h = d[0],
                p = h.trace,
                v = [];
              for (f = 0; f < d.length; f++) c = (s = d[f]).p - i, u = s.p + i, v.push(c, u);
              if (p.width || p.offset) {
                var g = h.t,
                  m = g.poffset,
                  y = g.barwidth,
                  x = a(m),
                  b = a(y);
                for (f = 0; f < d.length; f++) {
                  s = d[f];
                  var _ = x ? m[f] : m,
                    w = b ? y[f] : y;
                  u = (c = s.p + _) + w, v.push(c, u);
                }
              }
              p._extremes[e._id] = l.findExtremes(e, v, {
                padded: !1
              });
            }
          }
          function g(e, t) {
            for (var r = t.traces, n = x(e), a = 0; a < r.length; a++) {
              for (var i = r[a], o = i[0].trace, s = "scatter" === o.type, c = "v" === o.orientation, u = [], f = !1, d = 0; d < i.length; d++) {
                var h = i[d],
                  p = s ? 0 : h.b,
                  v = s ? c ? h.y : h.x : p + h.s;
                h[n] = v, u.push(v), h.hasB && u.push(p), h.hasB && h.b || (f = !0);
              }
              o._extremes[e._id] = l.findExtremes(e, u, {
                tozero: f,
                padded: !0
              });
            }
          }
          function m(e) {
            for (var t = e.traces, r = 0; r < t.length; r++) for (var n = t[r], a = 0; a < n.length; a++) {
              var o = n[a];
              o.s !== i && e.put(o.p, o.b + o.s);
            }
          }
          function y(e, t, r) {
            var a = t.traces,
              o = x(e),
              s = "fraction" === r.norm ? 1 : 100,
              c = s / 1e9,
              u = e.l2c(e.c2l(0)),
              f = "stack" === r.mode ? s : u;
            function d(t) {
              return n(e.c2l(t)) && (t < u - c || t > f + c || !n(u));
            }
            for (var h = 0; h < a.length; h++) {
              for (var p = a[h], v = p[0].trace, g = [], m = !1, y = !1, b = 0; b < p.length; b++) {
                var _ = p[b];
                if (_.s !== i) {
                  var w = Math.abs(s / t.get(_.p, _.s));
                  _.b *= w, _.s *= w;
                  var T = _.b,
                    M = T + _.s;
                  _[o] = M, g.push(M), y = y || d(M), _.hasB && (g.push(T), y = y || d(T)), _.hasB && _.b || (m = !0);
                }
              }
              v._extremes[e._id] = l.findExtremes(e, g, {
                tozero: m,
                padded: y
              });
            }
          }
          function x(e) {
            return e._id.charAt(0);
          }
          e.exports = {
            crossTraceCalc: function (e, t) {
              for (var r = t.xaxis, n = t.yaxis, a = e._fullLayout, i = e._fullData, l = e.calcdata, s = [], c = [], f = 0; f < i.length; f++) {
                var d = i[f];
                if (!0 === d.visible && o.traceIs(d, "bar") && d.xaxis === r._id && d.yaxis === n._id && ("h" === d.orientation ? s.push(l[f]) : c.push(l[f]), d._computePh)) for (var h = e.calcdata[f], p = 0; p < h.length; p++) "function" == typeof h[p].ph0 && (h[p].ph0 = h[p].ph0()), "function" == typeof h[p].ph1 && (h[p].ph1 = h[p].ph1());
              }
              var v = {
                xCat: "category" === r.type || "multicategory" === r.type,
                yCat: "category" === n.type || "multicategory" === n.type,
                mode: a.barmode,
                norm: a.barnorm,
                gap: a.bargap,
                groupgap: a.bargroupgap
              };
              u(e, r, n, c, v), u(e, n, r, s, v);
            },
            setGroupPositions: u
          };
        },
        7550: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809),
            i = r(8766),
            o = r(3626),
            l = r(9867),
            s = r(9669),
            c = r(9760),
            u = r(6301),
            f = r(1481),
            d = a.coerceFont;
          function h(e) {
            if (n(e)) {
              if ((e = +e) >= 0) return e;
            } else if ("string" == typeof e && "%" === (e = e.trim()).slice(-1) && n(e.slice(0, -1)) && (e = +e.slice(0, -1)) >= 0) return e + "%";
          }
          function p(e, t, r, n, i, o) {
            var l = !(!1 === (o = o || {}).moduleHasSelected),
              s = !(!1 === o.moduleHasUnselected),
              c = !(!1 === o.moduleHasConstrain),
              u = !(!1 === o.moduleHasCliponaxis),
              f = !(!1 === o.moduleHasTextangle),
              h = !(!1 === o.moduleHasInsideanchor),
              p = !!o.hasPathbar,
              v = Array.isArray(i) || "auto" === i,
              g = v || "inside" === i,
              m = v || "outside" === i;
            if (g || m) {
              var y = d(n, "textfont", r.font),
                x = a.extendFlat({}, y),
                b = !(e.textfont && e.textfont.color);
              if (b && delete x.color, d(n, "insidetextfont", x), p) {
                var _ = a.extendFlat({}, y);
                b && delete _.color, d(n, "pathbar.textfont", _);
              }
              m && d(n, "outsidetextfont", y), l && n("selected.textfont.color"), s && n("unselected.textfont.color"), c && n("constraintext"), u && n("cliponaxis"), f && n("textangle"), n("texttemplate");
            }
            g && h && n("insidetextanchor");
          }
          e.exports = {
            supplyDefaults: function (e, t, r, n) {
              function u(r, n) {
                return a.coerce(e, t, f, r, n);
              }
              if (l(e, t, n, u)) {
                s(e, t, n, u), u("xhoverformat"), u("yhoverformat"), u("zorder"), u("orientation", t.x && !t.y ? "h" : "v"), u("base"), u("offset"), u("width"), u("text"), u("hovertext"), u("hovertemplate");
                var d = u("textposition");
                p(e, 0, n, u, d, {
                  moduleHasSelected: !0,
                  moduleHasUnselected: !0,
                  moduleHasConstrain: !0,
                  moduleHasCliponaxis: !0,
                  moduleHasTextangle: !0,
                  moduleHasInsideanchor: !0
                }), c(e, t, u, r, n);
                var h = (t.marker.line || {}).color,
                  v = o.getComponentMethod("errorbars", "supplyDefaults");
                v(e, t, h || i.defaultLine, {
                  axis: "y"
                }), v(e, t, h || i.defaultLine, {
                  axis: "x",
                  inherit: "y"
                }), a.coerceSelectionMarkerOpacity(t, u);
              } else t.visible = !1;
            },
            crossTraceDefaults: function (e, t) {
              var r, n;
              function i(e, t) {
                return a.coerce(n._input, n, f, e, t);
              }
              for (var o = 0; o < e.length; o++) if ("bar" === (n = e[o]).type) {
                r = n._input;
                var l = i("marker.cornerradius", t.barcornerradius);
                n.marker && (n.marker.cornerradius = h(l)), "group" === t.barmode && u(r, n, t, i);
              }
            },
            handleText: p,
            validateCornerradius: h
          };
        },
        9541: function (e) {
          "use strict";

          e.exports = function (e, t, r) {
            return e.x = "xVal" in t ? t.xVal : t.x, e.y = "yVal" in t ? t.yVal : t.y, t.xa && (e.xaxis = t.xa), t.ya && (e.yaxis = t.ya), "h" === r.orientation ? (e.label = e.y, e.value = e.x) : (e.label = e.x, e.value = e.y), e;
          };
        },
        2843: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(5657),
            i = r(4809).isArrayOrTypedArray;
          t.coerceString = function (e, t, r) {
            if ("string" == typeof t) {
              if (t || !e.noBlank) return t;
            } else if (("number" == typeof t || !0 === t) && !e.strict) return String(t);
            return void 0 !== r ? r : e.dflt;
          }, t.coerceNumber = function (e, t, r) {
            if (n(t)) {
              t = +t;
              var a = e.min,
                i = e.max;
              if (!(void 0 !== a && t < a || void 0 !== i && t > i)) return t;
            }
            return void 0 !== r ? r : e.dflt;
          }, t.coerceColor = function (e, t, r) {
            return a(t).isValid() ? t : void 0 !== r ? r : e.dflt;
          }, t.coerceEnumerated = function (e, t, r) {
            return e.coerceNumber && (t = +t), -1 !== e.values.indexOf(t) ? t : void 0 !== r ? r : e.dflt;
          }, t.getValue = function (e, t) {
            var r;
            return i(e) ? t < e.length && (r = e[t]) : r = e, r;
          }, t.getLineWidth = function (e, t) {
            return 0 < t.mlw ? t.mlw : i(e.marker.line.width) ? 0 : e.marker.line.width;
          };
        },
        1664: function (e, t, r) {
          "use strict";

          var n = r(2141),
            a = r(3626),
            i = r(8766),
            o = r(4809).fillText,
            l = r(2843).getLineWidth,
            s = r(9714).hoverLabelText,
            c = r(3821).BADNUM;
          function u(e, t, r, a, i) {
            var l,
              u,
              f,
              d,
              h,
              p,
              v,
              g = e.cd,
              m = g[0].trace,
              y = g[0].t,
              x = "closest" === a,
              b = "waterfall" === m.type,
              _ = e.maxHoverDistance,
              w = e.maxSpikeDistance;
            "h" === m.orientation ? (l = r, u = t, f = "y", d = "x", h = I, p = P) : (l = t, u = r, f = "x", d = "y", p = I, h = P);
            var T = m[f + "period"],
              M = x || T;
            function k(e) {
              return L(e, -1);
            }
            function A(e) {
              return L(e, 1);
            }
            function L(e, t) {
              var r = e.w;
              return e[f] + t * r / 2;
            }
            function S(e) {
              return e[f + "End"] - e[f + "Start"];
            }
            var C = x ? k : T ? function (e) {
                return e.p - S(e) / 2;
              } : function (e) {
                return Math.min(k(e), e.p - y.bardelta / 2);
              },
              O = x ? A : T ? function (e) {
                return e.p + S(e) / 2;
              } : function (e) {
                return Math.max(A(e), e.p + y.bardelta / 2);
              };
            function D(e, t, r) {
              return i.finiteRange && (r = 0), n.inbox(e - l, t - l, r + Math.min(1, Math.abs(t - e) / v) - 1);
            }
            function P(e) {
              return D(C(e), O(e), _);
            }
            function z(e) {
              var t = e[d];
              if (b) {
                var r = Math.abs(e.rawS) || 0;
                u > 0 ? t += r : u < 0 && (t -= r);
              }
              return t;
            }
            function I(e) {
              var t = u,
                r = e.b,
                a = z(e);
              return n.inbox(r - t, a - t, _ + (a - t) / (a - r) - 1);
            }
            var E = e[f + "a"],
              R = e[d + "a"];
            v = Math.abs(E.r2c(E.range[1]) - E.r2c(E.range[0]));
            var N = n.getDistanceFunction(a, h, p, function (e) {
              return (h(e) + p(e)) / 2;
            });
            if (n.getClosest(g, N, e), !1 !== e.index && g[e.index].p !== c) {
              M || (C = function (e) {
                return Math.min(k(e), e.p - y.bargroupwidth / 2);
              }, O = function (e) {
                return Math.max(A(e), e.p + y.bargroupwidth / 2);
              });
              var F = g[e.index],
                H = m.base ? F.b + F.s : F.s;
              e[d + "0"] = e[d + "1"] = R.c2p(F[d], !0), e[d + "LabelVal"] = H;
              var B = y.extents[y.extents.round(F.p)];
              e[f + "0"] = E.c2p(x ? C(F) : B[0], !0), e[f + "1"] = E.c2p(x ? O(F) : B[1], !0);
              var j = void 0 !== F.orig_p;
              return e[f + "LabelVal"] = j ? F.orig_p : F.p, e.labelLabel = s(E, e[f + "LabelVal"], m[f + "hoverformat"]), e.valueLabel = s(R, e[d + "LabelVal"], m[d + "hoverformat"]), e.baseLabel = s(R, F.b, m[d + "hoverformat"]), e.spikeDistance = (function (e) {
                var t = u,
                  r = e.b,
                  a = z(e);
                return n.inbox(r - t, a - t, w + (a - t) / (a - r) - 1);
              }(F) + function (e) {
                return D(k(e), A(e), w);
              }(F)) / 2, e[f + "Spike"] = E.c2p(F.p, !0), o(F, m, e), e.hovertemplate = m.hovertemplate, e;
            }
          }
          function f(e, t) {
            var r = t.mcc || e.marker.color,
              n = t.mlcc || e.marker.line.color,
              a = l(e, t);
            return i.opacity(r) ? r : i.opacity(n) && a ? n : void 0;
          }
          e.exports = {
            hoverPoints: function (e, t, r, n, i) {
              var o = u(e, t, r, n, i);
              if (o) {
                var l = o.cd,
                  s = l[0].trace,
                  c = l[o.index];
                return o.color = f(s, c), a.getComponentMethod("errorbars", "hoverInfo")(c, s, o), [o];
              }
            },
            hoverOnBars: u,
            getTraceColor: f
          };
        },
        8218: function (e, t, r) {
          "use strict";

          e.exports = {
            attributes: r(1481),
            layoutAttributes: r(5412),
            supplyDefaults: r(7550).supplyDefaults,
            crossTraceDefaults: r(7550).crossTraceDefaults,
            supplyLayoutDefaults: r(8931),
            calc: r(7565),
            crossTraceCalc: r(4782).crossTraceCalc,
            colorbar: r(1146),
            arraysToCalcdata: r(5374),
            plot: r(2995).plot,
            style: r(6851).style,
            styleOnSelect: r(6851).styleOnSelect,
            hoverPoints: r(1664).hoverPoints,
            eventData: r(9541),
            selectPoints: r(8384),
            moduleType: "trace",
            name: "bar",
            basePlotModule: r(84),
            categories: ["bar-like", "cartesian", "svg", "bar", "oriented", "errorBarsOK", "showLegend", "zoomScale"],
            animatable: !0,
            meta: {}
          };
        },
        5412: function (e) {
          "use strict";

          e.exports = {
            barmode: {
              valType: "enumerated",
              values: ["stack", "group", "overlay", "relative"],
              dflt: "group",
              editType: "calc"
            },
            barnorm: {
              valType: "enumerated",
              values: ["", "fraction", "percent"],
              dflt: "",
              editType: "calc"
            },
            bargap: {
              valType: "number",
              min: 0,
              max: 1,
              editType: "calc"
            },
            bargroupgap: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 0,
              editType: "calc"
            },
            barcornerradius: {
              valType: "any",
              editType: "calc"
            }
          };
        },
        8931: function (e, t, r) {
          "use strict";

          var n = r(3626),
            a = r(9714),
            i = r(4809),
            o = r(5412),
            l = r(7550).validateCornerradius;
          e.exports = function (e, t, r) {
            function s(r, n) {
              return i.coerce(e, t, o, r, n);
            }
            for (var c = !1, u = !1, f = !1, d = {}, h = s("barmode"), p = 0; p < r.length; p++) {
              var v = r[p];
              if (n.traceIs(v, "bar") && v.visible) {
                if (c = !0, "group" === h) {
                  var g = v.xaxis + v.yaxis;
                  d[g] && (f = !0), d[g] = !0;
                }
                v.visible && "histogram" === v.type && "category" !== a.getFromId({
                  _fullLayout: t
                }, v["v" === v.orientation ? "xaxis" : "yaxis"]).type && (u = !0);
              }
            }
            if (c) {
              "overlay" !== h && s("barnorm"), s("bargap", u && !f ? 0 : .2), s("bargroupgap");
              var m = s("barcornerradius");
              t.barcornerradius = l(m);
            } else delete t.barmode;
          };
        },
        2995: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(721),
            i = r(4809),
            o = r(635),
            l = r(8766),
            s = r(2203),
            c = r(3626),
            u = r(9714).tickText,
            f = r(4102),
            d = f.recordMinTextSize,
            h = f.clearMinTextSize,
            p = r(6851),
            v = r(2843),
            g = r(6155),
            m = r(1481),
            y = m.text,
            x = m.textposition,
            b = r(6040).appendArrayPointValue,
            _ = g.TEXTPAD;
          function w(e) {
            return e.id;
          }
          function T(e) {
            if (e.ids) return w;
          }
          function M(e) {
            return (e > 0) - (e < 0);
          }
          function k(e, t) {
            return e < t ? 1 : -1;
          }
          function A(e, t, r, n) {
            var a;
            return !t.uniformtext.mode && L(r) ? (n && (a = n()), e.transition().duration(r.duration).ease(r.easing).each("end", function () {
              a && a();
            }).each("interrupt", function () {
              a && a();
            })) : e;
          }
          function L(e) {
            return e && e.duration > 0;
          }
          function S(e, t, r, n, a) {
            return !(e < 0 || t < 0) && (r <= e && n <= t || r <= t && n <= e || (a ? e >= r * (t / n) : t >= n * (e / r)));
          }
          function C(e) {
            return "auto" === e ? 0 : e;
          }
          function O(e, t) {
            var r = Math.PI / 180 * t,
              n = Math.abs(Math.sin(r)),
              a = Math.abs(Math.cos(r));
            return {
              x: e.width * a + e.height * n,
              y: e.width * n + e.height * a
            };
          }
          function D(e, t, r, n, a, i) {
            var o = !!i.isHorizontal,
              l = !!i.constrained,
              s = i.angle || 0,
              c = i.anchor,
              u = "end" === c,
              f = "start" === c,
              d = ((i.leftToRight || 0) + 1) / 2,
              h = 1 - d,
              p = i.hasB,
              v = i.r,
              g = i.overhead,
              m = a.width,
              y = a.height,
              x = Math.abs(t - e),
              b = Math.abs(n - r),
              w = x > 2 * _ && b > 2 * _ ? _ : 0;
            x -= 2 * w, b -= 2 * w;
            var T = C(s);
            "auto" !== s || m <= x && y <= b || !(m > x || y > b) || (m > b || y > x) && m < y == x < b || (T += 90);
            var M,
              A,
              L = O(a, T);
            if (v && v - g > _) {
              var S = function (e, t, r, n, a, i, o, l, s) {
                var c,
                  u,
                  f,
                  d,
                  h = Math.max(0, Math.abs(t - e) - 2 * _),
                  p = Math.max(0, Math.abs(n - r) - 2 * _),
                  v = i - _,
                  g = o ? v - Math.sqrt(v * v - (v - o) * (v - o)) : v,
                  m = s ? 2 * v : l ? v - o : 2 * g,
                  y = s ? 2 * v : l ? 2 * g : v - o;
                return a.y / a.x >= p / (h - m) ? d = p / a.y : a.y / a.x <= (p - y) / h ? d = h / a.x : !s && l ? (c = a.x * a.x + a.y * a.y / 4, f = (h - v) * (h - v) + (p / 2 - v) * (p / 2 - v) - v * v, d = (-(u = -2 * a.x * (h - v) - a.y * (p / 2 - v)) + Math.sqrt(u * u - 4 * c * f)) / (2 * c)) : s ? (c = (a.x * a.x + a.y * a.y) / 4, f = (h / 2 - v) * (h / 2 - v) + (p / 2 - v) * (p / 2 - v) - v * v, d = (-(u = -a.x * (h / 2 - v) - a.y * (p / 2 - v)) + Math.sqrt(u * u - 4 * c * f)) / (2 * c)) : (c = a.x * a.x / 4 + a.y * a.y, f = (h / 2 - v) * (h / 2 - v) + (p - v) * (p - v) - v * v, d = (-(u = -a.x * (h / 2 - v) - 2 * a.y * (p - v)) + Math.sqrt(u * u - 4 * c * f)) / (2 * c)), {
                  scale: d = Math.min(1, d),
                  pad: l ? Math.max(0, v - Math.sqrt(Math.max(0, v * v - (v - (p - a.y * d) / 2) * (v - (p - a.y * d) / 2))) - o) : Math.max(0, v - Math.sqrt(Math.max(0, v * v - (v - (h - a.x * d) / 2) * (v - (h - a.x * d) / 2))) - o)
                };
              }(e, t, r, n, L, v, g, o, p);
              M = S.scale, A = S.pad;
            } else M = 1, l && (M = Math.min(1, x / L.x, b / L.y)), A = 0;
            var D = a.left * h + a.right * d,
              P = (a.top + a.bottom) / 2,
              z = (e + _) * h + (t - _) * d,
              I = (r + n) / 2,
              E = 0,
              R = 0;
            if (f || u) {
              var N = (o ? L.x : L.y) / 2;
              v && (u || p) && (w += A);
              var F = o ? k(e, t) : k(r, n);
              o ? f ? (z = e + F * w, E = -F * N) : (z = t - F * w, E = F * N) : f ? (I = r + F * w, R = -F * N) : (I = n - F * w, R = F * N);
            }
            return {
              textX: D,
              textY: P,
              targetX: z,
              targetY: I,
              anchorX: E,
              anchorY: R,
              scale: M,
              rotate: T
            };
          }
          e.exports = {
            plot: function (e, t, r, f, g, m) {
              var w = t.xaxis,
                P = t.yaxis,
                z = e._fullLayout,
                I = e._context.staticPlot;
              g || (g = {
                mode: z.barmode,
                norm: z.barmode,
                gap: z.bargap,
                groupgap: z.bargroupgap
              }, h("bar", z));
              var E = i.makeTraceGroups(f, r, "trace bars").each(function (r) {
                var c = n.select(this),
                  f = r[0].trace,
                  h = r[0].t,
                  E = "waterfall" === f.type,
                  R = "funnel" === f.type,
                  N = "histogram" === f.type,
                  F = "bar" === f.type,
                  H = F || R,
                  B = 0;
                E && f.connector.visible && "between" === f.connector.mode && (B = f.connector.line.width / 2);
                var j = "h" === f.orientation,
                  Y = L(g),
                  V = i.ensureSingle(c, "g", "points"),
                  U = T(f),
                  q = V.selectAll("g.point").data(i.identity, U);
                q.enter().append("g").classed("point", !0), q.exit().remove(), q.each(function (c, T) {
                  var L,
                    E,
                    R = n.select(this),
                    V = function (e, t, r, n) {
                      var a = [],
                        i = [],
                        o = n ? t : r,
                        l = n ? r : t;
                      return a[0] = o.c2p(e.s0, !0), i[0] = l.c2p(e.p0, !0), a[1] = o.c2p(e.s1, !0), i[1] = l.c2p(e.p1, !0), n ? [a, i] : [i, a];
                    }(c, w, P, j),
                    U = V[0][0],
                    q = V[0][1],
                    G = V[1][0],
                    Z = V[1][1],
                    W = 0 == (j ? q - U : Z - G);
                  if (W && H && v.getLineWidth(f, c) && (W = !1), W || (W = !(a(U) && a(q) && a(G) && a(Z))), c.isBlank = W, W && (j ? q = U : Z = G), B && !W && (j ? (U -= k(U, q) * B, q += k(U, q) * B) : (G -= k(G, Z) * B, Z += k(G, Z) * B)), "waterfall" === f.type) {
                    if (!W) {
                      var J = f[c.dir].marker;
                      L = J.line.width, E = J.color;
                    }
                  } else L = v.getLineWidth(f, c), E = c.mc || f.marker.color;
                  function X(e) {
                    var t = n.round(L / 2 % 1, 2);
                    return 0 === g.gap && 0 === g.groupgap ? n.round(Math.round(e) - t, 2) : e;
                  }
                  var K = l.opacity(E) < 1 || L > .01 ? X : function (e, t, r) {
                    return r && e === t ? e : Math.abs(e - t) >= 2 ? X(e) : e > t ? Math.ceil(e) : Math.floor(e);
                  };
                  e._context.staticPlot || (U = K(U, q, j), q = K(q, U, j), G = K(G, Z, !j), Z = K(Z, G, !j));
                  var Q,
                    $ = j ? w.c2p : P.c2p;
                  Q = c.s0 > 0 ? c._sMax : c.s0 < 0 ? c._sMin : c.s1 > 0 ? c._sMax : c._sMin;
                  var ee,
                    te,
                    re = F || N ? function (e, t) {
                      if (!e) return 0;
                      var r,
                        n = j ? Math.abs(Z - G) : Math.abs(q - U),
                        a = j ? Math.abs(q - U) : Math.abs(Z - G),
                        i = K(Math.abs($(Q, !0) - $(0, !0))),
                        o = c.hasB ? Math.min(n / 2, a / 2) : Math.min(n / 2, i);
                      return r = "%" === t ? n * (Math.min(50, e) / 100) : e, K(Math.max(Math.min(r, o), 0));
                    }(h.cornerradiusvalue, h.cornerradiusform) : 0,
                    ne = "M" + U + "," + G + "V" + Z + "H" + q + "V" + G + "Z",
                    ae = 0;
                  if (re && c.s) {
                    var ie = 0 === M(c.s0) || M(c.s) === M(c.s0) ? c.s1 : c.s0;
                    if ((ae = K(c.hasB ? 0 : Math.abs($(Q, !0) - $(ie, !0)))) < re) {
                      var oe = k(U, q),
                        le = k(G, Z),
                        se = oe === -le ? 1 : 0;
                      if (j) {
                        if (c.hasB) ee = "M" + (U + re * oe) + "," + G + "A " + re + "," + re + " 0 0 " + se + " " + U + "," + (G + re * le) + "V" + (Z - re * le) + "A " + re + "," + re + " 0 0 " + se + " " + (U + re * oe) + "," + Z + "H" + (q - re * oe) + "A " + re + "," + re + " 0 0 " + se + " " + q + "," + (Z - re * le) + "V" + (G + re * le) + "A " + re + "," + re + " 0 0 " + se + " " + (q - re * oe) + "," + G + "Z";else {
                          var ce = (te = Math.abs(q - U) + ae) < re ? re - Math.sqrt(te * (2 * re - te)) : 0,
                            ue = ae > 0 ? Math.sqrt(ae * (2 * re - ae)) : 0,
                            fe = oe > 0 ? Math.max : Math.min;
                          ee = "M" + U + "," + G + "V" + (Z - ce * le) + "H" + fe(q - (re - ae) * oe, U) + "A " + re + "," + re + " 0 0 " + se + " " + q + "," + (Z - re * le - ue) + "V" + (G + re * le + ue) + "A " + re + "," + re + " 0 0 " + se + " " + fe(q - (re - ae) * oe, U) + "," + (G + ce * le) + "Z";
                        }
                      } else if (c.hasB) ee = "M" + (U + re * oe) + "," + G + "A " + re + "," + re + " 0 0 " + se + " " + U + "," + (G + re * le) + "V" + (Z - re * le) + "A " + re + "," + re + " 0 0 " + se + " " + (U + re * oe) + "," + Z + "H" + (q - re * oe) + "A " + re + "," + re + " 0 0 " + se + " " + q + "," + (Z - re * le) + "V" + (G + re * le) + "A " + re + "," + re + " 0 0 " + se + " " + (q - re * oe) + "," + G + "Z";else {
                        var de = (te = Math.abs(Z - G) + ae) < re ? re - Math.sqrt(te * (2 * re - te)) : 0,
                          he = ae > 0 ? Math.sqrt(ae * (2 * re - ae)) : 0,
                          pe = le > 0 ? Math.max : Math.min;
                        ee = "M" + (U + de * oe) + "," + G + "V" + pe(Z - (re - ae) * le, G) + "A " + re + "," + re + " 0 0 " + se + " " + (U + re * oe - he) + "," + Z + "H" + (q - re * oe + he) + "A " + re + "," + re + " 0 0 " + se + " " + (q - de * oe) + "," + pe(Z - (re - ae) * le, G) + "V" + G + "Z";
                      }
                    } else ee = ne;
                  } else ee = ne;
                  var ve = A(i.ensureSingle(R, "path"), z, g, m);
                  if (ve.style("vector-effect", I ? "none" : "non-scaling-stroke").attr("d", isNaN((q - U) * (Z - G)) || W && e._context.staticPlot ? "M0,0Z" : ee).call(s.setClipUrl, t.layerClipId, e), !z.uniformtext.mode && Y) {
                    var ge = s.makePointStyleFns(f);
                    s.singlePointStyle(c, ve, f, ge, e);
                  }
                  !function (e, t, r, n, a, l, c, f, h, g, m, w, T) {
                    var M,
                      L = t.xaxis,
                      P = t.yaxis,
                      z = e._fullLayout;
                    function I(t, r, n) {
                      return i.ensureSingle(t, "text").text(r).attr({
                        class: "bartext bartext-" + M,
                        "text-anchor": "middle",
                        "data-notex": 1
                      }).call(s.font, n).call(o.convertToTspans, e);
                    }
                    var E = n[0].trace,
                      R = "h" === E.orientation,
                      N = function (e, t, r, n, a) {
                        var o,
                          l = t[0].trace;
                        return o = l.texttemplate ? function (e, t, r, n, a) {
                          var o = t[0].trace,
                            l = i.castOption(o, r, "texttemplate");
                          if (!l) return "";
                          var s,
                            c,
                            f,
                            d,
                            h = "histogram" === o.type,
                            p = "waterfall" === o.type,
                            v = "funnel" === o.type,
                            g = "h" === o.orientation;
                          function m(e) {
                            return u(d, d.c2l(e), !0).text;
                          }
                          g ? (s = "y", c = a, f = "x", d = n) : (s = "x", c = n, f = "y", d = a);
                          var y,
                            x = t[r],
                            _ = {};
                          _.label = x.p, _.labelLabel = _[s + "Label"] = (y = x.p, u(c, c.c2l(y), !0).text);
                          var w = i.castOption(o, x.i, "text");
                          (0 === w || w) && (_.text = w), _.value = x.s, _.valueLabel = _[f + "Label"] = m(x.s);
                          var T = {};
                          b(T, o, x.i), (h || void 0 === T.x) && (T.x = g ? _.value : _.label), (h || void 0 === T.y) && (T.y = g ? _.label : _.value), (h || void 0 === T.xLabel) && (T.xLabel = g ? _.valueLabel : _.labelLabel), (h || void 0 === T.yLabel) && (T.yLabel = g ? _.labelLabel : _.valueLabel), p && (_.delta = +x.rawS || x.s, _.deltaLabel = m(_.delta), _.final = x.v, _.finalLabel = m(_.final), _.initial = _.final - _.delta, _.initialLabel = m(_.initial)), v && (_.value = x.s, _.valueLabel = m(_.value), _.percentInitial = x.begR, _.percentInitialLabel = i.formatPercent(x.begR), _.percentPrevious = x.difR, _.percentPreviousLabel = i.formatPercent(x.difR), _.percentTotal = x.sumR, _.percenTotalLabel = i.formatPercent(x.sumR));
                          var M = i.castOption(o, x.i, "customdata");
                          return M && (_.customdata = M), i.texttemplateString(l, _, e._d3locale, T, _, o._meta || {});
                        }(e, t, r, n, a) : l.textinfo ? function (e, t, r, n) {
                          var a = e[0].trace,
                            o = "h" === a.orientation,
                            l = "waterfall" === a.type,
                            s = "funnel" === a.type;
                          function c(e) {
                            return u(o ? r : n, +e, !0).text;
                          }
                          var f,
                            d,
                            h = a.textinfo,
                            p = e[t],
                            v = h.split("+"),
                            g = [],
                            m = function (e) {
                              return -1 !== v.indexOf(e);
                            };
                          if (m("label") && g.push((d = e[t].p, u(o ? n : r, d, !0).text)), m("text") && (0 === (f = i.castOption(a, p.i, "text")) || f) && g.push(f), l) {
                            var y = +p.rawS || p.s,
                              x = p.v,
                              b = x - y;
                            m("initial") && g.push(c(b)), m("delta") && g.push(c(y)), m("final") && g.push(c(x));
                          }
                          if (s) {
                            m("value") && g.push(c(p.s));
                            var _ = 0;
                            m("percent initial") && _++, m("percent previous") && _++, m("percent total") && _++;
                            var w = _ > 1;
                            m("percent initial") && (f = i.formatPercent(p.begR), w && (f += " of initial"), g.push(f)), m("percent previous") && (f = i.formatPercent(p.difR), w && (f += " of previous"), g.push(f)), m("percent total") && (f = i.formatPercent(p.sumR), w && (f += " of total"), g.push(f));
                          }
                          return g.join("<br>");
                        }(t, r, n, a) : v.getValue(l.text, r), v.coerceString(y, o);
                      }(z, n, a, L, P);
                    M = function (e, t) {
                      var r = v.getValue(e.textposition, t);
                      return v.coerceEnumerated(x, r);
                    }(E, a);
                    var F = "stack" === w.mode || "relative" === w.mode,
                      H = n[a],
                      B = !F || H._outmost,
                      j = H.hasB,
                      Y = g && g - m > _;
                    if (N && "none" !== M && (!H.isBlank && l !== c && f !== h || "auto" !== M && "inside" !== M)) {
                      var V = z.font,
                        U = p.getBarColor(n[a], E),
                        q = p.getInsideTextFont(E, a, V, U),
                        G = p.getOutsideTextFont(E, a, V),
                        Z = E.insidetextanchor || "end",
                        W = r.datum();
                      R ? "log" === L.type && W.s0 <= 0 && (l = L.range[0] < L.range[1] ? 0 : L._length) : "log" === P.type && W.s0 <= 0 && (f = P.range[0] < P.range[1] ? P._length : 0);
                      var J,
                        X,
                        K,
                        Q,
                        $,
                        ee = Math.abs(c - l),
                        te = Math.abs(h - f),
                        re = ee - 2 * _,
                        ne = te - 2 * _;
                      if ("outside" === M && (B || H.hasB || (M = "inside")), "auto" === M) if (B) {
                        M = "inside", J = I(r, N, $ = i.ensureUniformFontSize(e, q)), K = (X = s.bBox(J.node())).width, Q = X.height;
                        var ae,
                          ie = K > 0 && Q > 0;
                        ae = Y ? j ? S(re - 2 * g, ne, K, Q, R) || S(re, ne - 2 * g, K, Q, R) : R ? S(re - (g - m), ne, K, Q, R) || S(re, ne - 2 * (g - m), K, Q, R) : S(re, ne - (g - m), K, Q, R) || S(re - 2 * (g - m), ne, K, Q, R) : S(re, ne, K, Q, R), ie && ae ? M = "inside" : (M = "outside", J.remove(), J = null);
                      } else M = "inside";
                      if (!J) {
                        var oe = (J = I(r, N, $ = i.ensureUniformFontSize(e, "outside" === M ? G : q))).attr("transform");
                        if (J.attr("transform", ""), K = (X = s.bBox(J.node())).width, Q = X.height, J.attr("transform", oe), K <= 0 || Q <= 0) return void J.remove();
                      }
                      var le,
                        se = E.textangle;
                      le = "outside" === M ? function (e, t, r, n, a, i) {
                        var o,
                          l = !!i.isHorizontal,
                          s = !!i.constrained,
                          c = i.angle || 0,
                          u = a.width,
                          f = a.height,
                          d = Math.abs(t - e),
                          h = Math.abs(n - r);
                        o = l ? h > 2 * _ ? _ : 0 : d > 2 * _ ? _ : 0;
                        var p = 1;
                        s && (p = l ? Math.min(1, h / f) : Math.min(1, d / u));
                        var v = C(c),
                          g = O(a, v),
                          m = (l ? g.x : g.y) / 2,
                          y = (a.left + a.right) / 2,
                          x = (a.top + a.bottom) / 2,
                          b = (e + t) / 2,
                          w = (r + n) / 2,
                          T = 0,
                          M = 0,
                          A = l ? k(t, e) : k(r, n);
                        return l ? (b = t - A * o, T = A * m) : (w = n + A * o, M = -A * m), {
                          textX: y,
                          textY: x,
                          targetX: b,
                          targetY: w,
                          anchorX: T,
                          anchorY: M,
                          scale: p,
                          rotate: v
                        };
                      }(l, c, f, h, X, {
                        isHorizontal: R,
                        constrained: "both" === E.constraintext || "outside" === E.constraintext,
                        angle: se
                      }) : D(l, c, f, h, X, {
                        isHorizontal: R,
                        constrained: "both" === E.constraintext || "inside" === E.constraintext,
                        angle: se,
                        anchor: Z,
                        hasB: j,
                        r: g,
                        overhead: m
                      }), le.fontSize = $.size, d("histogram" === E.type ? "bar" : E.type, le, z), H.transform = le;
                      var ce = A(J, z, w, T);
                      i.setTransormAndDisplay(ce, le);
                    } else r.select("text").remove();
                  }(e, t, R, r, T, U, q, G, Z, re, ae, g, m), t.layerClipId && s.hideOutsideRangePoint(c, R.select("text"), w, P, f.xcalendar, f.ycalendar);
                });
                var G = !1 === f.cliponaxis;
                s.setClipUrl(c, G ? null : t.layerClipId, e);
              });
              c.getComponentMethod("errorbars", "plot")(e, E, t, g);
            },
            toMoveInsideBar: D
          };
        },
        8384: function (e) {
          "use strict";

          function t(e, t, r, n, a) {
            var i = t.c2p(n ? e.s0 : e.p0, !0),
              o = t.c2p(n ? e.s1 : e.p1, !0),
              l = r.c2p(n ? e.p0 : e.s0, !0),
              s = r.c2p(n ? e.p1 : e.s1, !0);
            return a ? [(i + o) / 2, (l + s) / 2] : n ? [o, (l + s) / 2] : [(i + o) / 2, s];
          }
          e.exports = function (e, r) {
            var n,
              a = e.cd,
              i = e.xaxis,
              o = e.yaxis,
              l = a[0].trace,
              s = "funnel" === l.type,
              c = "h" === l.orientation,
              u = [];
            if (!1 === r) for (n = 0; n < a.length; n++) a[n].selected = 0;else for (n = 0; n < a.length; n++) {
              var f = a[n],
                d = "ct" in f ? f.ct : t(f, i, o, c, s);
              r.contains(d, !1, n, e) ? (u.push({
                pointNumber: n,
                x: i.c2d(f.x),
                y: o.c2d(f.y)
              }), f.selected = 1) : f.selected = 0;
            }
            return u;
          };
        },
        2880: function (e, t, r) {
          "use strict";

          e.exports = a;
          var n = r(4809).distinctVals;
          function a(e, t) {
            this.traces = e, this.sepNegVal = t.sepNegVal, this.overlapNoMerge = t.overlapNoMerge;
            for (var r = 1 / 0, a = t.posAxis._id.charAt(0), i = [], o = 0; o < e.length; o++) {
              for (var l = e[o], s = 0; s < l.length; s++) {
                var c = l[s],
                  u = c.p;
                void 0 === u && (u = c[a]), void 0 !== u && i.push(u);
              }
              l[0] && l[0].width1 && (r = Math.min(l[0].width1, r));
            }
            this.positions = i;
            var f = n(i);
            this.distinctPositions = f.vals, 1 === f.vals.length && r !== 1 / 0 ? this.minDiff = r : this.minDiff = Math.min(f.minDiff, r);
            var d = (t.posAxis || {}).type;
            "category" !== d && "multicategory" !== d || (this.minDiff = 1), this.binWidth = this.minDiff, this.bins = {};
          }
          a.prototype.put = function (e, t) {
            var r = this.getLabel(e, t),
              n = this.bins[r] || 0;
            return this.bins[r] = n + t, n;
          }, a.prototype.get = function (e, t) {
            var r = this.getLabel(e, t);
            return this.bins[r] || 0;
          }, a.prototype.getLabel = function (e, t) {
            return (t < 0 && this.sepNegVal ? "v" : "^") + (this.overlapNoMerge ? e : Math.round(e / this.binWidth));
          };
        },
        6851: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(8766),
            i = r(2203),
            o = r(4809),
            l = r(3626),
            s = r(4102).resizeText,
            c = r(1481),
            u = c.textfont,
            f = c.insidetextfont,
            d = c.outsidetextfont,
            h = r(2843);
          function p(e, t, r) {
            i.pointStyle(e.selectAll("path"), t, r), v(e, t, r);
          }
          function v(e, t, r) {
            e.selectAll("text").each(function (e) {
              var a = n.select(this),
                l = o.ensureUniformFontSize(r, g(a, e, t, r));
              i.font(a, l);
            });
          }
          function g(e, t, r, n) {
            var a = n._fullLayout.font,
              i = r.textfont;
            if (e.classed("bartext-inside")) {
              var o = _(t, r);
              i = y(r, t.i, a, o);
            } else e.classed("bartext-outside") && (i = x(r, t.i, a));
            return i;
          }
          function m(e, t, r) {
            return b(u, e.textfont, t, r);
          }
          function y(e, t, r, n) {
            var i = m(e, t, r);
            return (void 0 === e._input.textfont || void 0 === e._input.textfont.color || Array.isArray(e.textfont.color) && void 0 === e.textfont.color[t]) && (i = {
              color: a.contrast(n),
              family: i.family,
              size: i.size,
              weight: i.weight,
              style: i.style,
              variant: i.variant,
              textcase: i.textcase,
              lineposition: i.lineposition,
              shadow: i.shadow
            }), b(f, e.insidetextfont, t, i);
          }
          function x(e, t, r) {
            var n = m(e, t, r);
            return b(d, e.outsidetextfont, t, n);
          }
          function b(e, t, r, n) {
            t = t || {};
            var a = h.getValue(t.family, r),
              i = h.getValue(t.size, r),
              o = h.getValue(t.color, r),
              l = h.getValue(t.weight, r),
              s = h.getValue(t.style, r),
              c = h.getValue(t.variant, r),
              u = h.getValue(t.textcase, r),
              f = h.getValue(t.lineposition, r),
              d = h.getValue(t.shadow, r);
            return {
              family: h.coerceString(e.family, a, n.family),
              size: h.coerceNumber(e.size, i, n.size),
              color: h.coerceColor(e.color, o, n.color),
              weight: h.coerceString(e.weight, l, n.weight),
              style: h.coerceString(e.style, s, n.style),
              variant: h.coerceString(e.variant, c, n.variant),
              textcase: h.coerceString(e.variant, u, n.textcase),
              lineposition: h.coerceString(e.variant, f, n.lineposition),
              shadow: h.coerceString(e.variant, d, n.shadow)
            };
          }
          function _(e, t) {
            return "waterfall" === t.type ? t[e.dir].marker.color : e.mcc || e.mc || t.marker.color;
          }
          e.exports = {
            style: function (e) {
              var t = n.select(e).selectAll('g[class^="barlayer"]').selectAll("g.trace");
              s(e, t, "bar");
              var r = t.size(),
                a = e._fullLayout;
              t.style("opacity", function (e) {
                return e[0].trace.opacity;
              }).each(function (e) {
                ("stack" === a.barmode && r > 1 || 0 === a.bargap && 0 === a.bargroupgap && !e[0].trace.marker.line.width) && n.select(this).attr("shape-rendering", "crispEdges");
              }), t.selectAll("g.points").each(function (t) {
                p(n.select(this), t[0].trace, e);
              }), l.getComponentMethod("errorbars", "style")(t);
            },
            styleTextPoints: v,
            styleOnSelect: function (e, t, r) {
              var a = t[0].trace;
              a.selectedpoints ? function (e, t, r) {
                i.selectedPointStyle(e.selectAll("path"), t), function (e, t, r) {
                  e.each(function (e) {
                    var a,
                      l = n.select(this);
                    if (e.selected) {
                      a = o.ensureUniformFontSize(r, g(l, e, t, r));
                      var s = t.selected.textfont && t.selected.textfont.color;
                      s && (a.color = s), i.font(l, a);
                    } else i.selectedTextStyle(l, t);
                  });
                }(e.selectAll("text"), t, r);
              }(r, a, e) : (p(r, a, e), l.getComponentMethod("errorbars", "style")(r));
            },
            getInsideTextFont: y,
            getOutsideTextFont: x,
            getBarColor: _,
            resizeText: s
          };
        },
        9760: function (e, t, r) {
          "use strict";

          var n = r(8766),
            a = r(5477).hasColorscale,
            i = r(9356),
            o = r(4809).coercePattern;
          e.exports = function (e, t, r, l, s) {
            var c = r("marker.color", l),
              u = a(e, "marker");
            u && i(e, t, s, r, {
              prefix: "marker.",
              cLetter: "c"
            }), r("marker.line.color", n.defaultLine), a(e, "marker.line") && i(e, t, s, r, {
              prefix: "marker.line.",
              cLetter: "c"
            }), r("marker.line.width"), r("marker.opacity"), o(r, "marker.pattern", c, u), r("selected.marker.color"), r("unselected.marker.color");
          };
        },
        4102: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4809);
          function i(e) {
            return "_" + e + "Text_minsize";
          }
          e.exports = {
            recordMinTextSize: function (e, t, r) {
              if (r.uniformtext.mode) {
                var n = i(e),
                  a = r.uniformtext.minsize,
                  o = t.scale * t.fontSize;
                t.hide = o < a, r[n] = r[n] || 1 / 0, t.hide || (r[n] = Math.min(r[n], Math.max(o, a)));
              }
            },
            clearMinTextSize: function (e, t) {
              t[i(e)] = void 0;
            },
            resizeText: function (e, t, r) {
              var i = e._fullLayout,
                o = i["_" + r + "Text_minsize"];
              if (o) {
                var l,
                  s = "hide" === i.uniformtext.mode;
                switch (r) {
                  case "funnelarea":
                  case "pie":
                  case "sunburst":
                    l = "g.slice";
                    break;
                  case "treemap":
                  case "icicle":
                    l = "g.slice, g.pathbar";
                    break;
                  default:
                    l = "g.points > g.point";
                }
                t.selectAll(l).each(function (e) {
                  var t = e.transform;
                  if (t) {
                    t.scale = s && t.hide ? 0 : o / t.fontSize;
                    var r = n.select(this).select("text");
                    a.setTransormAndDisplay(r, t);
                  }
                });
              }
            }
          };
        },
        3031: function (e, t, r) {
          "use strict";

          var n = r(9829),
            a = r(3792).u,
            i = r(337),
            o = r(229),
            l = r(3208).rb,
            s = r(3208).ay,
            c = r(3049).extendFlat,
            u = r(4850).k,
            f = i({
              editType: "plot",
              arrayOk: !0,
              colorEditType: "plot"
            });
          e.exports = {
            labels: {
              valType: "data_array",
              editType: "calc"
            },
            label0: {
              valType: "number",
              dflt: 0,
              editType: "calc"
            },
            dlabel: {
              valType: "number",
              dflt: 1,
              editType: "calc"
            },
            values: {
              valType: "data_array",
              editType: "calc"
            },
            marker: {
              colors: {
                valType: "data_array",
                editType: "calc"
              },
              line: {
                color: {
                  valType: "color",
                  dflt: o.defaultLine,
                  arrayOk: !0,
                  editType: "style"
                },
                width: {
                  valType: "number",
                  min: 0,
                  dflt: 0,
                  arrayOk: !0,
                  editType: "style"
                },
                editType: "calc"
              },
              pattern: u,
              editType: "calc"
            },
            text: {
              valType: "data_array",
              editType: "plot"
            },
            hovertext: {
              valType: "string",
              dflt: "",
              arrayOk: !0,
              editType: "style"
            },
            scalegroup: {
              valType: "string",
              dflt: "",
              editType: "calc"
            },
            textinfo: {
              valType: "flaglist",
              flags: ["label", "text", "value", "percent"],
              extras: ["none"],
              editType: "calc"
            },
            hoverinfo: c({}, n.hoverinfo, {
              flags: ["label", "text", "value", "percent", "name"]
            }),
            hovertemplate: l({}, {
              keys: ["label", "color", "value", "percent", "text"]
            }),
            texttemplate: s({
              editType: "plot"
            }, {
              keys: ["label", "color", "value", "percent", "text"]
            }),
            textposition: {
              valType: "enumerated",
              values: ["inside", "outside", "auto", "none"],
              dflt: "auto",
              arrayOk: !0,
              editType: "plot"
            },
            textfont: c({}, f, {}),
            insidetextorientation: {
              valType: "enumerated",
              values: ["horizontal", "radial", "tangential", "auto"],
              dflt: "auto",
              editType: "plot"
            },
            insidetextfont: c({}, f, {}),
            outsidetextfont: c({}, f, {}),
            automargin: {
              valType: "boolean",
              dflt: !1,
              editType: "plot"
            },
            title: {
              text: {
                valType: "string",
                dflt: "",
                editType: "plot"
              },
              font: c({}, f, {}),
              position: {
                valType: "enumerated",
                values: ["top left", "top center", "top right", "middle center", "bottom left", "bottom center", "bottom right"],
                editType: "plot"
              },
              editType: "plot"
            },
            domain: a({
              name: "pie",
              trace: !0,
              editType: "calc"
            }),
            hole: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 0,
              editType: "calc"
            },
            sort: {
              valType: "boolean",
              dflt: !0,
              editType: "calc"
            },
            direction: {
              valType: "enumerated",
              values: ["clockwise", "counterclockwise"],
              dflt: "counterclockwise",
              editType: "calc"
            },
            rotation: {
              valType: "angle",
              dflt: 0,
              editType: "calc"
            },
            pull: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 0,
              arrayOk: !0,
              editType: "calc"
            },
            _deprecated: {
              title: {
                valType: "string",
                dflt: "",
                editType: "calc"
              },
              titlefont: c({}, f, {}),
              titleposition: {
                valType: "enumerated",
                values: ["top left", "top center", "top right", "middle center", "bottom left", "bottom center", "bottom right"],
                editType: "calc"
              }
            }
          };
        },
        6052: function (e, t, r) {
          "use strict";

          var n = r(4122);
          t.name = "pie", t.plot = function (e, r, a, i) {
            n.plotBasePlot(t.name, e, r, a, i);
          }, t.clean = function (e, r, a, i) {
            n.cleanBasePlot(t.name, e, r, a, i);
          };
        },
        4148: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(5657),
            i = r(8766),
            o = {};
          function l(e) {
            return function (t, r) {
              return !!t && !!(t = a(t)).isValid() && (t = i.addOpacity(t, t.getAlpha()), e[r] || (e[r] = t), t);
            };
          }
          function s(e, t) {
            var r,
              n = JSON.stringify(e),
              i = t[n];
            if (!i) {
              for (i = e.slice(), r = 0; r < e.length; r++) i.push(a(e[r]).lighten(20).toHexString());
              for (r = 0; r < e.length; r++) i.push(a(e[r]).darken(20).toHexString());
              t[n] = i;
            }
            return i;
          }
          e.exports = {
            calc: function (e, t) {
              var r,
                a,
                i = [],
                o = e._fullLayout,
                s = o.hiddenlabels || [],
                c = t.labels,
                u = t.marker.colors || [],
                f = t.values,
                d = t._length,
                h = t._hasValues && d;
              if (t.dlabel) for (c = new Array(d), r = 0; r < d; r++) c[r] = String(t.label0 + r * t.dlabel);
              var p = {},
                v = l(o["_" + t.type + "colormap"]),
                g = 0,
                m = !1;
              for (r = 0; r < d; r++) {
                var y, x, b;
                if (h) {
                  if (y = f[r], !n(y)) continue;
                  y = +y;
                } else y = 1;
                void 0 !== (x = c[r]) && "" !== x || (x = r);
                var _ = p[x = String(x)];
                void 0 === _ ? (p[x] = i.length, (b = -1 !== s.indexOf(x)) || (g += y), i.push({
                  v: y,
                  label: x,
                  color: v(u[r], x),
                  i: r,
                  pts: [r],
                  hidden: b
                })) : (m = !0, (a = i[_]).v += y, a.pts.push(r), a.hidden || (g += y), !1 === a.color && u[r] && (a.color = v(u[r], x)));
              }
              return i = i.filter(function (e) {
                return e.v >= 0;
              }), ("funnelarea" === t.type ? m : t.sort) && i.sort(function (e, t) {
                return t.v - e.v;
              }), i[0] && (i[0].vTotal = g), i;
            },
            crossTraceCalc: function (e, t) {
              var r = (t || {}).type;
              r || (r = "pie");
              var n = e._fullLayout,
                a = e.calcdata,
                i = n[r + "colorway"],
                l = n["_" + r + "colormap"];
              n["extend" + r + "colors"] && (i = s(i, o));
              for (var c = 0, u = 0; u < a.length; u++) {
                var f = a[u];
                if (f[0].trace.type === r) for (var d = 0; d < f.length; d++) {
                  var h = f[d];
                  !1 === h.color && (l[h.label] ? h.color = l[h.label] : (l[h.label] = h.color = i[c % i.length], c++));
                }
              }
            },
            makePullColorFn: l,
            generateExtendedColors: s
          };
        },
        6979: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809),
            i = r(3031),
            o = r(3792).N,
            l = r(7550).handleText,
            s = r(4809).coercePattern;
          function c(e, t) {
            var r = a.isArrayOrTypedArray(e),
              i = a.isArrayOrTypedArray(t),
              o = Math.min(r ? e.length : 1 / 0, i ? t.length : 1 / 0);
            if (isFinite(o) || (o = 0), o && i) {
              for (var l, s = 0; s < o; s++) {
                var c = t[s];
                if (n(c) && c > 0) {
                  l = !0;
                  break;
                }
              }
              l || (o = 0);
            }
            return {
              hasLabels: r,
              hasValues: i,
              len: o
            };
          }
          function u(e, t, r, n, a) {
            n("marker.line.width") && n("marker.line.color", a ? void 0 : r.paper_bgcolor);
            var i = n("marker.colors");
            s(n, "marker.pattern", i), e.marker && !t.marker.pattern.fgcolor && (t.marker.pattern.fgcolor = e.marker.colors), t.marker.pattern.bgcolor || (t.marker.pattern.bgcolor = r.paper_bgcolor);
          }
          e.exports = {
            handleLabelsAndValues: c,
            handleMarkerDefaults: u,
            supplyDefaults: function (e, t, r, n) {
              function s(r, n) {
                return a.coerce(e, t, i, r, n);
              }
              var f = c(s("labels"), s("values")),
                d = f.len;
              if (t._hasLabels = f.hasLabels, t._hasValues = f.hasValues, !t._hasLabels && t._hasValues && (s("label0"), s("dlabel")), d) {
                t._length = d, u(e, t, n, s, !0), s("scalegroup");
                var h,
                  p = s("text"),
                  v = s("texttemplate");
                if (v || (h = s("textinfo", a.isArrayOrTypedArray(p) ? "text+percent" : "percent")), s("hovertext"), s("hovertemplate"), v || h && "none" !== h) {
                  var g = s("textposition");
                  l(e, t, n, s, g, {
                    moduleHasSelected: !1,
                    moduleHasUnselected: !1,
                    moduleHasConstrain: !1,
                    moduleHasCliponaxis: !1,
                    moduleHasTextangle: !1,
                    moduleHasInsideanchor: !1
                  }), (Array.isArray(g) || "auto" === g || "outside" === g) && s("automargin"), ("inside" === g || "auto" === g || Array.isArray(g)) && s("insidetextorientation");
                } else "none" === h && s("textposition", "none");
                o(t, n, s);
                var m = s("hole");
                if (s("title.text")) {
                  var y = s("title.position", m ? "middle center" : "top center");
                  m || "middle center" !== y || (t.title.position = "top center"), a.coerceFont(s, "title.font", n.font);
                }
                s("sort"), s("direction"), s("rotation"), s("pull");
              } else t.visible = !1;
            }
          };
        },
        568: function (e, t, r) {
          "use strict";

          var n = r(6040).appendArrayMultiPointValues;
          e.exports = function (e, t) {
            var r = {
              curveNumber: t.index,
              pointNumbers: e.pts,
              data: t._input,
              fullData: t,
              label: e.label,
              color: e.color,
              value: e.v,
              percent: e.percent,
              text: e.text,
              bbox: e.bbox,
              v: e.v
            };
            return 1 === e.pts.length && (r.pointNumber = r.i = e.pts[0]), n(r, t, e.pts), "funnelarea" === t.type && (delete r.v, delete r.i), r;
          };
        },
        5067: function (e, t, r) {
          "use strict";

          var n = r(2203),
            a = r(8766);
          e.exports = function (e, t, r, i) {
            var o = r.marker.pattern;
            o && o.shape ? n.pointStyle(e, r, i, t) : a.fill(e, t.color);
          };
        },
        7252: function (e, t, r) {
          "use strict";

          var n = r(4809);
          function a(e) {
            return -1 !== e.indexOf("e") ? e.replace(/[.]?0+e/, "e") : -1 !== e.indexOf(".") ? e.replace(/[.]?0+$/, "") : e;
          }
          t.formatPiePercent = function (e, t) {
            var r = a((100 * e).toPrecision(3));
            return n.numSeparate(r, t) + "%";
          }, t.formatPieValue = function (e, t) {
            var r = a(e.toPrecision(10));
            return n.numSeparate(r, t);
          }, t.getFirstFilled = function (e, t) {
            if (n.isArrayOrTypedArray(e)) for (var r = 0; r < t.length; r++) {
              var a = e[t[r]];
              if (a || 0 === a || "" === a) return a;
            }
          }, t.castOption = function (e, r) {
            return n.isArrayOrTypedArray(e) ? t.getFirstFilled(e, r) : e || void 0;
          }, t.getRotationAngle = function (e) {
            return ("auto" === e ? 0 : e) * Math.PI / 180;
          };
        },
        9913: function (e, t, r) {
          "use strict";

          e.exports = {
            attributes: r(3031),
            supplyDefaults: r(6979).supplyDefaults,
            supplyLayoutDefaults: r(3464),
            layoutAttributes: r(4031),
            calc: r(4148).calc,
            crossTraceCalc: r(4148).crossTraceCalc,
            plot: r(5734).plot,
            style: r(140),
            styleOne: r(2891),
            moduleType: "trace",
            name: "pie",
            basePlotModule: r(6052),
            categories: ["pie-like", "pie", "showLegend"],
            meta: {}
          };
        },
        4031: function (e) {
          "use strict";

          e.exports = {
            hiddenlabels: {
              valType: "data_array",
              editType: "calc"
            },
            piecolorway: {
              valType: "colorlist",
              editType: "calc"
            },
            extendpiecolors: {
              valType: "boolean",
              dflt: !0,
              editType: "calc"
            }
          };
        },
        3464: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(4031);
          e.exports = function (e, t) {
            function r(r, i) {
              return n.coerce(e, t, a, r, i);
            }
            r("hiddenlabels"), r("piecolorway", t.colorway), r("extendpiecolors");
          };
        },
        5734: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(4122),
            i = r(2141),
            o = r(8766),
            l = r(2203),
            s = r(4809),
            c = s.strScale,
            u = s.strTranslate,
            f = r(635),
            d = r(4102),
            h = d.recordMinTextSize,
            p = d.clearMinTextSize,
            v = r(6155).TEXTPAD,
            g = r(7252),
            m = r(568),
            y = r(4809).isValidTextValue;
          function x(e, t, r) {
            var a = r[0],
              o = a.cx,
              l = a.cy,
              c = a.trace,
              u = "funnelarea" === c.type;
            "_hasHoverLabel" in c || (c._hasHoverLabel = !1), "_hasHoverEvent" in c || (c._hasHoverEvent = !1), e.on("mouseover", function (e) {
              var r = t._fullLayout,
                f = t._fullData[c.index];
              if (!t._dragging && !1 !== r.hovermode) {
                var d = f.hoverinfo;
                if (Array.isArray(d) && (d = i.castHoverinfo({
                  hoverinfo: [g.castOption(d, e.pts)],
                  _module: c._module
                }, r, 0)), "all" === d && (d = "label+text+value+percent+name"), f.hovertemplate || "none" !== d && "skip" !== d && d) {
                  var h = e.rInscribed || 0,
                    p = o + e.pxmid[0] * (1 - h),
                    v = l + e.pxmid[1] * (1 - h),
                    y = r.separators,
                    x = [];
                  if (d && -1 !== d.indexOf("label") && x.push(e.label), e.text = g.castOption(f.hovertext || f.text, e.pts), d && -1 !== d.indexOf("text")) {
                    var b = e.text;
                    s.isValidTextValue(b) && x.push(b);
                  }
                  e.value = e.v, e.valueLabel = g.formatPieValue(e.v, y), d && -1 !== d.indexOf("value") && x.push(e.valueLabel), e.percent = e.v / a.vTotal, e.percentLabel = g.formatPiePercent(e.percent, y), d && -1 !== d.indexOf("percent") && x.push(e.percentLabel);
                  var _ = f.hoverlabel,
                    w = _.font,
                    T = [];
                  i.loneHover({
                    trace: c,
                    x0: p - h * a.r,
                    x1: p + h * a.r,
                    y: v,
                    _x0: u ? o + e.TL[0] : p - h * a.r,
                    _x1: u ? o + e.TR[0] : p + h * a.r,
                    _y0: u ? l + e.TL[1] : v - h * a.r,
                    _y1: u ? l + e.BL[1] : v + h * a.r,
                    text: x.join("<br>"),
                    name: f.hovertemplate || -1 !== d.indexOf("name") ? f.name : void 0,
                    idealAlign: e.pxmid[0] < 0 ? "left" : "right",
                    color: g.castOption(_.bgcolor, e.pts) || e.color,
                    borderColor: g.castOption(_.bordercolor, e.pts),
                    fontFamily: g.castOption(w.family, e.pts),
                    fontSize: g.castOption(w.size, e.pts),
                    fontColor: g.castOption(w.color, e.pts),
                    nameLength: g.castOption(_.namelength, e.pts),
                    textAlign: g.castOption(_.align, e.pts),
                    hovertemplate: g.castOption(f.hovertemplate, e.pts),
                    hovertemplateLabels: e,
                    eventData: [m(e, f)]
                  }, {
                    container: r._hoverlayer.node(),
                    outerContainer: r._paper.node(),
                    gd: t,
                    inOut_bbox: T
                  }), e.bbox = T[0], c._hasHoverLabel = !0;
                }
                c._hasHoverEvent = !0, t.emit("plotly_hover", {
                  points: [m(e, f)],
                  event: n.event
                });
              }
            }), e.on("mouseout", function (e) {
              var r = t._fullLayout,
                a = t._fullData[c.index],
                o = n.select(this).datum();
              c._hasHoverEvent && (e.originalEvent = n.event, t.emit("plotly_unhover", {
                points: [m(o, a)],
                event: n.event
              }), c._hasHoverEvent = !1), c._hasHoverLabel && (i.loneUnhover(r._hoverlayer.node()), c._hasHoverLabel = !1);
            }), e.on("click", function (e) {
              var r = t._fullLayout,
                a = t._fullData[c.index];
              t._dragging || !1 === r.hovermode || (t._hoverdata = [m(e, a)], i.click(t, n.event));
            });
          }
          function b(e, t, r) {
            var n = g.castOption(e.insidetextfont.color, t.pts);
            !n && e._input.textfont && (n = g.castOption(e._input.textfont.color, t.pts));
            var a = g.castOption(e.insidetextfont.family, t.pts) || g.castOption(e.textfont.family, t.pts) || r.family,
              i = g.castOption(e.insidetextfont.size, t.pts) || g.castOption(e.textfont.size, t.pts) || r.size,
              l = g.castOption(e.insidetextfont.weight, t.pts) || g.castOption(e.textfont.weight, t.pts) || r.weight,
              s = g.castOption(e.insidetextfont.style, t.pts) || g.castOption(e.textfont.style, t.pts) || r.style,
              c = g.castOption(e.insidetextfont.variant, t.pts) || g.castOption(e.textfont.variant, t.pts) || r.variant,
              u = g.castOption(e.insidetextfont.textcase, t.pts) || g.castOption(e.textfont.textcase, t.pts) || r.textcase,
              f = g.castOption(e.insidetextfont.lineposition, t.pts) || g.castOption(e.textfont.lineposition, t.pts) || r.lineposition,
              d = g.castOption(e.insidetextfont.shadow, t.pts) || g.castOption(e.textfont.shadow, t.pts) || r.shadow;
            return {
              color: n || o.contrast(t.color),
              family: a,
              size: i,
              weight: l,
              style: s,
              variant: c,
              textcase: u,
              lineposition: f,
              shadow: d
            };
          }
          function _(e, t) {
            for (var r, n, a = 0; a < e.length; a++) if ((n = (r = e[a][0]).trace).title.text) {
              var i = n.title.text;
              n._meta && (i = s.templateString(i, n._meta));
              var o = l.tester.append("text").attr("data-notex", 1).text(i).call(l.font, n.title.font).call(f.convertToTspans, t),
                c = l.bBox(o.node(), !0);
              r.titleBox = {
                width: c.width,
                height: c.height
              }, o.remove();
            }
          }
          function w(e, t, r) {
            var n = r.r || t.rpx1,
              a = t.rInscribed;
            if (t.startangle === t.stopangle) return {
              rCenter: 1 - a,
              scale: 0,
              rotate: 0,
              textPosAngle: 0
            };
            var i,
              o = t.ring,
              l = 1 === o && Math.abs(t.startangle - t.stopangle) === 2 * Math.PI,
              s = t.halfangle,
              c = t.midangle,
              u = r.trace.insidetextorientation,
              f = "horizontal" === u,
              d = "tangential" === u,
              h = "radial" === u,
              p = "auto" === u,
              v = [];
            if (!p) {
              var g,
                m = function (r, a) {
                  if (function (e, t) {
                    var r = e.startangle,
                      n = e.stopangle;
                    return r > t && t > n || r < t && t < n;
                  }(t, r)) {
                    var l = Math.abs(r - t.startangle),
                      s = Math.abs(r - t.stopangle),
                      c = l < s ? l : s;
                    (i = "tan" === a ? M(e, n, o, c, 0) : T(e, n, o, c, Math.PI / 2)).textPosAngle = r, v.push(i);
                  }
                };
              if (f || d) {
                for (g = 4; g >= -4; g -= 2) m(Math.PI * g, "tan");
                for (g = 4; g >= -4; g -= 2) m(Math.PI * (g + 1), "tan");
              }
              if (f || h) {
                for (g = 4; g >= -4; g -= 2) m(Math.PI * (g + 1.5), "rad");
                for (g = 4; g >= -4; g -= 2) m(Math.PI * (g + .5), "rad");
              }
            }
            if (l || p || f) {
              var y = Math.sqrt(e.width * e.width + e.height * e.height);
              if ((i = {
                scale: a * n * 2 / y,
                rCenter: 1 - a,
                rotate: 0
              }).textPosAngle = (t.startangle + t.stopangle) / 2, i.scale >= 1) return i;
              v.push(i);
            }
            (p || h) && ((i = T(e, n, o, s, c)).textPosAngle = (t.startangle + t.stopangle) / 2, v.push(i)), (p || d) && ((i = M(e, n, o, s, c)).textPosAngle = (t.startangle + t.stopangle) / 2, v.push(i));
            for (var x = 0, b = 0, _ = 0; _ < v.length; _++) {
              var w = v[_].scale;
              if (b < w && (b = w, x = _), !p && b >= 1) break;
            }
            return v[x];
          }
          function T(e, t, r, n, a) {
            t = Math.max(0, t - 2 * v);
            var i = e.width / e.height,
              o = L(i, n, t, r);
            return {
              scale: 2 * o / e.height,
              rCenter: k(i, o / t),
              rotate: A(a)
            };
          }
          function M(e, t, r, n, a) {
            t = Math.max(0, t - 2 * v);
            var i = e.height / e.width,
              o = L(i, n, t, r);
            return {
              scale: 2 * o / e.width,
              rCenter: k(i, o / t),
              rotate: A(a + Math.PI / 2)
            };
          }
          function k(e, t) {
            return Math.cos(t) - e * t;
          }
          function A(e) {
            return (180 / Math.PI * e + 720) % 180 - 90;
          }
          function L(e, t, r, n) {
            var a = e + 1 / (2 * Math.tan(t));
            return r * Math.min(1 / (Math.sqrt(a * a + .5) + a), n / (Math.sqrt(e * e + n / 2) + e));
          }
          function S(e, t) {
            return e.v !== t.vTotal || t.trace.hole ? Math.min(1 / (1 + 1 / Math.sin(e.halfangle)), e.ring / 2) : 1;
          }
          function C(e, t) {
            var r = t.pxmid[0],
              n = t.pxmid[1],
              a = e.width / 2,
              i = e.height / 2;
            return r < 0 && (a *= -1), n < 0 && (i *= -1), {
              scale: 1,
              rCenter: 1,
              rotate: 0,
              x: a + Math.abs(i) * (a > 0 ? 1 : -1) / 2,
              y: i / (1 + r * r / (n * n)),
              outside: !0
            };
          }
          function O(e, t) {
            var r,
              n,
              a,
              i = e.trace,
              o = {
                x: e.cx,
                y: e.cy
              },
              l = {
                tx: 0,
                ty: 0
              };
            l.ty += i.title.font.size, a = P(i), -1 !== i.title.position.indexOf("top") ? (o.y -= (1 + a) * e.r, l.ty -= e.titleBox.height) : -1 !== i.title.position.indexOf("bottom") && (o.y += (1 + a) * e.r);
            var s,
              c = e.r / (void 0 === (s = e.trace.aspectratio) ? 1 : s),
              u = t.w * (i.domain.x[1] - i.domain.x[0]) / 2;
            return -1 !== i.title.position.indexOf("left") ? (u += c, o.x -= (1 + a) * c, l.tx += e.titleBox.width / 2) : -1 !== i.title.position.indexOf("center") ? u *= 2 : -1 !== i.title.position.indexOf("right") && (u += c, o.x += (1 + a) * c, l.tx -= e.titleBox.width / 2), r = u / e.titleBox.width, n = D(e, t) / e.titleBox.height, {
              x: o.x,
              y: o.y,
              scale: Math.min(r, n),
              tx: l.tx,
              ty: l.ty
            };
          }
          function D(e, t) {
            var r = e.trace,
              n = t.h * (r.domain.y[1] - r.domain.y[0]);
            return Math.min(e.titleBox.height, n / 2);
          }
          function P(e) {
            var t,
              r = e.pull;
            if (!r) return 0;
            if (s.isArrayOrTypedArray(r)) for (r = 0, t = 0; t < e.pull.length; t++) e.pull[t] > r && (r = e.pull[t]);
            return r;
          }
          function z(e, t) {
            for (var r = [], n = 0; n < e.length; n++) {
              var a = e[n][0],
                i = a.trace,
                o = i.domain,
                l = t.w * (o.x[1] - o.x[0]),
                s = t.h * (o.y[1] - o.y[0]);
              i.title.text && "middle center" !== i.title.position && (s -= D(a, t));
              var c = l / 2,
                u = s / 2;
              "funnelarea" !== i.type || i.scalegroup || (u /= i.aspectratio), a.r = Math.min(c, u) / (1 + P(i)), a.cx = t.l + t.w * (i.domain.x[1] + i.domain.x[0]) / 2, a.cy = t.t + t.h * (1 - i.domain.y[0]) - s / 2, i.title.text && -1 !== i.title.position.indexOf("bottom") && (a.cy -= D(a, t)), i.scalegroup && -1 === r.indexOf(i.scalegroup) && r.push(i.scalegroup);
            }
            !function (e, t) {
              for (var r, n, a, i = 0; i < t.length; i++) {
                var o = 1 / 0,
                  l = t[i];
                for (n = 0; n < e.length; n++) if ((a = (r = e[n][0]).trace).scalegroup === l) {
                  var s;
                  if ("pie" === a.type) s = r.r * r.r;else if ("funnelarea" === a.type) {
                    var c, u;
                    a.aspectratio > 1 ? u = (c = r.r) / a.aspectratio : c = (u = r.r) * a.aspectratio, s = (c *= (1 + a.baseratio) / 2) * u;
                  }
                  o = Math.min(o, s / r.vTotal);
                }
                for (n = 0; n < e.length; n++) if ((a = (r = e[n][0]).trace).scalegroup === l) {
                  var f = o * r.vTotal;
                  "funnelarea" === a.type && (f /= (1 + a.baseratio) / 2, f /= a.aspectratio), r.r = Math.sqrt(f);
                }
              }
            }(e, r);
          }
          function I(e, t) {
            return [e * Math.sin(t), -e * Math.cos(t)];
          }
          function E(e, t, r) {
            var n = e._fullLayout,
              a = r.trace,
              i = a.texttemplate,
              o = a.textinfo;
            if (!i && o && "none" !== o) {
              var l,
                c = o.split("+"),
                u = function (e) {
                  return -1 !== c.indexOf(e);
                },
                f = u("label"),
                d = u("text"),
                h = u("value"),
                p = u("percent"),
                v = n.separators;
              if (l = f ? [t.label] : [], d) {
                var m = g.getFirstFilled(a.text, t.pts);
                y(m) && l.push(m);
              }
              h && l.push(g.formatPieValue(t.v, v)), p && l.push(g.formatPiePercent(t.v / r.vTotal, v)), t.text = l.join("<br>");
            }
            if (i) {
              var x = s.castOption(a, t.i, "texttemplate");
              if (x) {
                var b = function (e) {
                    return {
                      label: e.label,
                      value: e.v,
                      valueLabel: g.formatPieValue(e.v, n.separators),
                      percent: e.v / r.vTotal,
                      percentLabel: g.formatPiePercent(e.v / r.vTotal, n.separators),
                      color: e.color,
                      text: e.text,
                      customdata: s.castOption(a, e.i, "customdata")
                    };
                  }(t),
                  _ = g.getFirstFilled(a.text, t.pts);
                (y(_) || "" === _) && (b.text = _), t.text = s.texttemplateString(x, b, e._fullLayout._d3locale, b, a._meta || {});
              } else t.text = "";
            }
          }
          function R(e, t) {
            var r = e.rotate * Math.PI / 180,
              n = Math.cos(r),
              a = Math.sin(r),
              i = (t.left + t.right) / 2,
              o = (t.top + t.bottom) / 2;
            e.textX = i * n - o * a, e.textY = i * a + o * n, e.noCenter = !0;
          }
          e.exports = {
            plot: function (e, t) {
              var r = e._context.staticPlot,
                i = e._fullLayout,
                d = i._size;
              p("pie", i), _(t, e), z(t, d);
              var v = s.makeTraceGroups(i._pielayer, t, "trace").each(function (t) {
                var p = n.select(this),
                  v = t[0],
                  m = v.trace;
                !function (e) {
                  var t,
                    r,
                    n,
                    a = e[0],
                    i = a.r,
                    o = a.trace,
                    l = g.getRotationAngle(o.rotation),
                    s = 2 * Math.PI / a.vTotal,
                    c = "px0",
                    u = "px1";
                  if ("counterclockwise" === o.direction) {
                    for (t = 0; t < e.length && e[t].hidden; t++);
                    if (t === e.length) return;
                    l += s * e[t].v, s *= -1, c = "px1", u = "px0";
                  }
                  for (n = I(i, l), t = 0; t < e.length; t++) (r = e[t]).hidden || (r[c] = n, r.startangle = l, l += s * r.v / 2, r.pxmid = I(i, l), r.midangle = l, n = I(i, l += s * r.v / 2), r.stopangle = l, r[u] = n, r.largeArc = r.v > a.vTotal / 2 ? 1 : 0, r.halfangle = Math.PI * Math.min(r.v / a.vTotal, .5), r.ring = 1 - o.hole, r.rInscribed = S(r, a));
                }(t), p.attr("stroke-linejoin", "round"), p.each(function () {
                  var y = n.select(this).selectAll("g.slice").data(t);
                  y.enter().append("g").classed("slice", !0), y.exit().remove();
                  var _ = [[[], []], [[], []]],
                    T = !1;
                  y.each(function (a, o) {
                    if (a.hidden) n.select(this).selectAll("path,g").remove();else {
                      a.pointNumber = a.i, a.curveNumber = m.index, _[a.pxmid[1] < 0 ? 0 : 1][a.pxmid[0] < 0 ? 0 : 1].push(a);
                      var c = v.cx,
                        u = v.cy,
                        d = n.select(this),
                        p = d.selectAll("path.surface").data([a]);
                      if (p.enter().append("path").classed("surface", !0).style({
                        "pointer-events": r ? "none" : "all"
                      }), d.call(x, e, t), m.pull) {
                        var y = +g.castOption(m.pull, a.pts) || 0;
                        y > 0 && (c += y * a.pxmid[0], u += y * a.pxmid[1]);
                      }
                      a.cxFinal = c, a.cyFinal = u;
                      var M = m.hole;
                      if (a.v === v.vTotal) {
                        var k = "M" + (c + a.px0[0]) + "," + (u + a.px0[1]) + D(a.px0, a.pxmid, !0, 1) + D(a.pxmid, a.px0, !0, 1) + "Z";
                        M ? p.attr("d", "M" + (c + M * a.px0[0]) + "," + (u + M * a.px0[1]) + D(a.px0, a.pxmid, !1, M) + D(a.pxmid, a.px0, !1, M) + "Z" + k) : p.attr("d", k);
                      } else {
                        var A = D(a.px0, a.px1, !0, 1);
                        if (M) {
                          var L = 1 - M;
                          p.attr("d", "M" + (c + M * a.px1[0]) + "," + (u + M * a.px1[1]) + D(a.px1, a.px0, !1, M) + "l" + L * a.px0[0] + "," + L * a.px0[1] + A + "Z");
                        } else p.attr("d", "M" + c + "," + u + "l" + a.px0[0] + "," + a.px0[1] + A + "Z");
                      }
                      E(e, a, v);
                      var S = g.castOption(m.textposition, a.pts),
                        O = d.selectAll("g.slicetext").data(a.text && "none" !== S ? [0] : []);
                      O.enter().append("g").classed("slicetext", !0), O.exit().remove(), O.each(function () {
                        var r = s.ensureSingle(n.select(this), "text", "", function (e) {
                            e.attr("data-notex", 1);
                          }),
                          d = s.ensureUniformFontSize(e, "outside" === S ? function (e, t, r) {
                            return {
                              color: g.castOption(e.outsidetextfont.color, t.pts) || g.castOption(e.textfont.color, t.pts) || r.color,
                              family: g.castOption(e.outsidetextfont.family, t.pts) || g.castOption(e.textfont.family, t.pts) || r.family,
                              size: g.castOption(e.outsidetextfont.size, t.pts) || g.castOption(e.textfont.size, t.pts) || r.size,
                              weight: g.castOption(e.outsidetextfont.weight, t.pts) || g.castOption(e.textfont.weight, t.pts) || r.weight,
                              style: g.castOption(e.outsidetextfont.style, t.pts) || g.castOption(e.textfont.style, t.pts) || r.style,
                              variant: g.castOption(e.outsidetextfont.variant, t.pts) || g.castOption(e.textfont.variant, t.pts) || r.variant,
                              textcase: g.castOption(e.outsidetextfont.textcase, t.pts) || g.castOption(e.textfont.textcase, t.pts) || r.textcase,
                              lineposition: g.castOption(e.outsidetextfont.lineposition, t.pts) || g.castOption(e.textfont.lineposition, t.pts) || r.lineposition,
                              shadow: g.castOption(e.outsidetextfont.shadow, t.pts) || g.castOption(e.textfont.shadow, t.pts) || r.shadow
                            };
                          }(m, a, i.font) : b(m, a, i.font));
                        r.text(a.text).attr({
                          class: "slicetext",
                          transform: "",
                          "text-anchor": "middle"
                        }).call(l.font, d).call(f.convertToTspans, e);
                        var p,
                          y = l.bBox(r.node());
                        if ("outside" === S) p = C(y, a);else if (p = w(y, a, v), "auto" === S && p.scale < 1) {
                          var x = s.ensureUniformFontSize(e, m.outsidetextfont);
                          r.call(l.font, x), p = C(y = l.bBox(r.node()), a);
                        }
                        var _ = p.textPosAngle,
                          M = void 0 === _ ? a.pxmid : I(v.r, _);
                        if (p.targetX = c + M[0] * p.rCenter + (p.x || 0), p.targetY = u + M[1] * p.rCenter + (p.y || 0), R(p, y), p.outside) {
                          var k = p.targetY;
                          a.yLabelMin = k - y.height / 2, a.yLabelMid = k, a.yLabelMax = k + y.height / 2, a.labelExtraX = 0, a.labelExtraY = 0, T = !0;
                        }
                        p.fontSize = d.size, h(m.type, p, i), t[o].transform = p, s.setTransormAndDisplay(r, p);
                      });
                    }
                    function D(e, t, r, n) {
                      var i = n * (t[0] - e[0]),
                        o = n * (t[1] - e[1]);
                      return "a" + n * v.r + "," + n * v.r + " 0 " + a.largeArc + (r ? " 1 " : " 0 ") + i + "," + o;
                    }
                  });
                  var M = n.select(this).selectAll("g.titletext").data(m.title.text ? [0] : []);
                  if (M.enter().append("g").classed("titletext", !0), M.exit().remove(), M.each(function () {
                    var t,
                      r = s.ensureSingle(n.select(this), "text", "", function (e) {
                        e.attr("data-notex", 1);
                      }),
                      a = m.title.text;
                    m._meta && (a = s.templateString(a, m._meta)), r.text(a).attr({
                      class: "titletext",
                      transform: "",
                      "text-anchor": "middle"
                    }).call(l.font, m.title.font).call(f.convertToTspans, e), t = "middle center" === m.title.position ? function (e) {
                      var t = Math.sqrt(e.titleBox.width * e.titleBox.width + e.titleBox.height * e.titleBox.height);
                      return {
                        x: e.cx,
                        y: e.cy,
                        scale: e.trace.hole * e.r * 2 / t,
                        tx: 0,
                        ty: -e.titleBox.height / 2 + e.trace.title.font.size
                      };
                    }(v) : O(v, d), r.attr("transform", u(t.x, t.y) + c(Math.min(1, t.scale)) + u(t.tx, t.ty));
                  }), T && function (e, t) {
                    var r, n, a, i, o, l, c, u, f, d, h, p, v;
                    function m(e, t) {
                      return e.pxmid[1] - t.pxmid[1];
                    }
                    function y(e, t) {
                      return t.pxmid[1] - e.pxmid[1];
                    }
                    function x(e, r) {
                      r || (r = {});
                      var a,
                        u,
                        f,
                        h,
                        p = r.labelExtraY + (n ? r.yLabelMax : r.yLabelMin),
                        v = n ? e.yLabelMin : e.yLabelMax,
                        m = n ? e.yLabelMax : e.yLabelMin,
                        y = e.cyFinal + o(e.px0[1], e.px1[1]),
                        x = p - v;
                      if (x * c > 0 && (e.labelExtraY = x), s.isArrayOrTypedArray(t.pull)) for (u = 0; u < d.length; u++) (f = d[u]) === e || (g.castOption(t.pull, e.pts) || 0) >= (g.castOption(t.pull, f.pts) || 0) || ((e.pxmid[1] - f.pxmid[1]) * c > 0 ? (x = f.cyFinal + o(f.px0[1], f.px1[1]) - v - e.labelExtraY) * c > 0 && (e.labelExtraY += x) : (m + e.labelExtraY - y) * c > 0 && (a = 3 * l * Math.abs(u - d.indexOf(e)), (h = f.cxFinal + i(f.px0[0], f.px1[0]) + a - (e.cxFinal + e.pxmid[0]) - e.labelExtraX) * l > 0 && (e.labelExtraX += h)));
                    }
                    for (n = 0; n < 2; n++) for (a = n ? m : y, o = n ? Math.max : Math.min, c = n ? 1 : -1, r = 0; r < 2; r++) {
                      for (i = r ? Math.max : Math.min, l = r ? 1 : -1, (u = e[n][r]).sort(a), f = e[1 - n][r], d = f.concat(u), p = [], h = 0; h < u.length; h++) void 0 !== u[h].yLabelMid && p.push(u[h]);
                      for (v = !1, h = 0; n && h < f.length; h++) if (void 0 !== f[h].yLabelMid) {
                        v = f[h];
                        break;
                      }
                      for (h = 0; h < p.length; h++) {
                        var b = h && p[h - 1];
                        v && !h && (b = v), x(p[h], b);
                      }
                    }
                  }(_, m), function (e, t) {
                    e.each(function (e) {
                      var r = n.select(this);
                      if (e.labelExtraX || e.labelExtraY) {
                        var a = r.select("g.slicetext text");
                        e.transform.targetX += e.labelExtraX, e.transform.targetY += e.labelExtraY, s.setTransormAndDisplay(a, e.transform);
                        var i = e.cxFinal + e.pxmid[0],
                          l = "M" + i + "," + (e.cyFinal + e.pxmid[1]),
                          c = (e.yLabelMax - e.yLabelMin) * (e.pxmid[0] < 0 ? -1 : 1) / 4;
                        if (e.labelExtraX) {
                          var u = e.labelExtraX * e.pxmid[1] / e.pxmid[0],
                            f = e.yLabelMid + e.labelExtraY - (e.cyFinal + e.pxmid[1]);
                          Math.abs(u) > Math.abs(f) ? l += "l" + f * e.pxmid[0] / e.pxmid[1] + "," + f + "H" + (i + e.labelExtraX + c) : l += "l" + e.labelExtraX + "," + u + "v" + (f - u) + "h" + c;
                        } else l += "V" + (e.yLabelMid + e.labelExtraY) + "h" + c;
                        s.ensureSingle(r, "path", "textline").call(o.stroke, t.outsidetextfont.color).attr({
                          "stroke-width": Math.min(2, t.outsidetextfont.size / 8),
                          d: l,
                          fill: "none"
                        });
                      } else r.select("path.textline").remove();
                    });
                  }(y, m), T && m.automargin) {
                    var k = l.bBox(p.node()),
                      A = m.domain,
                      L = d.w * (A.x[1] - A.x[0]),
                      S = d.h * (A.y[1] - A.y[0]),
                      D = (.5 * L - v.r) / d.w,
                      P = (.5 * S - v.r) / d.h;
                    a.autoMargin(e, "pie." + m.uid + ".automargin", {
                      xl: A.x[0] - D,
                      xr: A.x[1] + D,
                      yb: A.y[0] - P,
                      yt: A.y[1] + P,
                      l: Math.max(v.cx - v.r - k.left, 0),
                      r: Math.max(k.right - (v.cx + v.r), 0),
                      b: Math.max(k.bottom - (v.cy + v.r), 0),
                      t: Math.max(v.cy - v.r - k.top, 0),
                      pad: 5
                    });
                  }
                });
              });
              setTimeout(function () {
                v.selectAll("tspan").each(function () {
                  var e = n.select(this);
                  e.attr("dy") && e.attr("dy", e.attr("dy"));
                });
              }, 0);
            },
            formatSliceLabel: E,
            transformInsideText: w,
            determineInsideTextFont: b,
            positionTitleOutside: O,
            prerenderTitles: _,
            layoutAreas: z,
            attachFxHandlers: x,
            computeTransform: R
          };
        },
        140: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(2891),
            i = r(4102).resizeText;
          e.exports = function (e) {
            var t = e._fullLayout._pielayer.selectAll(".trace");
            i(e, t, "pie"), t.each(function (t) {
              var r = t[0].trace,
                i = n.select(this);
              i.style({
                opacity: r.opacity
              }), i.selectAll("path.surface").each(function (t) {
                n.select(this).call(a, t, r, e);
              });
            });
          };
        },
        2891: function (e, t, r) {
          "use strict";

          var n = r(8766),
            a = r(7252).castOption,
            i = r(5067);
          e.exports = function (e, t, r, o) {
            var l = r.marker.line,
              s = a(l.color, t.pts) || n.defaultLine,
              c = a(l.width, t.pts) || 0;
            e.call(i, t, r, o).style("stroke-width", c).call(n.stroke, s);
          };
        },
        9203: function (e, t, r) {
          "use strict";

          var n = r(4809);
          e.exports = function (e, t) {
            for (var r = 0; r < e.length; r++) e[r].i = r;
            n.mergeArray(t.text, e, "tx"), n.mergeArray(t.texttemplate, e, "txt"), n.mergeArray(t.hovertext, e, "htx"), n.mergeArray(t.customdata, e, "data"), n.mergeArray(t.textposition, e, "tp"), t.textfont && (n.mergeArrayCastPositive(t.textfont.size, e, "ts"), n.mergeArray(t.textfont.color, e, "tc"), n.mergeArray(t.textfont.family, e, "tf"), n.mergeArray(t.textfont.weight, e, "tw"), n.mergeArray(t.textfont.style, e, "ty"), n.mergeArray(t.textfont.variant, e, "tv"), n.mergeArray(t.textfont.textcase, e, "tC"), n.mergeArray(t.textfont.lineposition, e, "tE"), n.mergeArray(t.textfont.shadow, e, "tS"));
            var a = t.marker;
            if (a) {
              n.mergeArrayCastPositive(a.size, e, "ms"), n.mergeArrayCastPositive(a.opacity, e, "mo"), n.mergeArray(a.symbol, e, "mx"), n.mergeArray(a.angle, e, "ma"), n.mergeArray(a.standoff, e, "mf"), n.mergeArray(a.color, e, "mc");
              var i = a.line;
              a.line && (n.mergeArray(i.color, e, "mlc"), n.mergeArrayCastPositive(i.width, e, "mlw"));
              var o = a.gradient;
              o && "none" !== o.type && (n.mergeArray(o.type, e, "mgt"), n.mergeArray(o.color, e, "mgc"));
            }
          };
        },
        6640: function (e, t, r) {
          "use strict";

          var n = r(712).axisHoverFormat,
            a = r(3208).ay,
            i = r(3208).rb,
            o = r(7163),
            l = r(337),
            s = r(4850).T,
            c = r(4850).k,
            u = r(2203),
            f = r(2660),
            d = r(3049).extendFlat,
            h = r(9326);
          e.exports = {
            x: {
              valType: "data_array",
              editType: "calc+clearAxisTypes",
              anim: !0
            },
            x0: {
              valType: "any",
              dflt: 0,
              editType: "calc+clearAxisTypes",
              anim: !0
            },
            dx: {
              valType: "number",
              dflt: 1,
              editType: "calc",
              anim: !0
            },
            y: {
              valType: "data_array",
              editType: "calc+clearAxisTypes",
              anim: !0
            },
            y0: {
              valType: "any",
              dflt: 0,
              editType: "calc+clearAxisTypes",
              anim: !0
            },
            dy: {
              valType: "number",
              dflt: 1,
              editType: "calc",
              anim: !0
            },
            xperiod: {
              valType: "any",
              dflt: 0,
              editType: "calc"
            },
            yperiod: {
              valType: "any",
              dflt: 0,
              editType: "calc"
            },
            xperiod0: {
              valType: "any",
              editType: "calc"
            },
            yperiod0: {
              valType: "any",
              editType: "calc"
            },
            xperiodalignment: {
              valType: "enumerated",
              values: ["start", "middle", "end"],
              dflt: "middle",
              editType: "calc"
            },
            yperiodalignment: {
              valType: "enumerated",
              values: ["start", "middle", "end"],
              dflt: "middle",
              editType: "calc"
            },
            xhoverformat: n("x"),
            yhoverformat: n("y"),
            offsetgroup: {
              valType: "string",
              dflt: "",
              editType: "calc"
            },
            alignmentgroup: {
              valType: "string",
              dflt: "",
              editType: "calc"
            },
            stackgroup: {
              valType: "string",
              dflt: "",
              editType: "calc"
            },
            orientation: {
              valType: "enumerated",
              values: ["v", "h"],
              editType: "calc"
            },
            groupnorm: {
              valType: "enumerated",
              values: ["", "fraction", "percent"],
              dflt: "",
              editType: "calc"
            },
            stackgaps: {
              valType: "enumerated",
              values: ["infer zero", "interpolate"],
              dflt: "infer zero",
              editType: "calc"
            },
            text: {
              valType: "string",
              dflt: "",
              arrayOk: !0,
              editType: "calc"
            },
            texttemplate: a({}, {}),
            hovertext: {
              valType: "string",
              dflt: "",
              arrayOk: !0,
              editType: "style"
            },
            mode: {
              valType: "flaglist",
              flags: ["lines", "markers", "text"],
              extras: ["none"],
              editType: "calc"
            },
            hoveron: {
              valType: "flaglist",
              flags: ["points", "fills"],
              editType: "style"
            },
            hovertemplate: i({}, {
              keys: f.eventDataKeys
            }),
            line: {
              color: {
                valType: "color",
                editType: "style",
                anim: !0
              },
              width: {
                valType: "number",
                min: 0,
                dflt: 2,
                editType: "style",
                anim: !0
              },
              shape: {
                valType: "enumerated",
                values: ["linear", "spline", "hv", "vh", "hvh", "vhv"],
                dflt: "linear",
                editType: "plot"
              },
              smoothing: {
                valType: "number",
                min: 0,
                max: 1.3,
                dflt: 1,
                editType: "plot"
              },
              dash: d({}, s, {
                editType: "style"
              }),
              backoff: {
                valType: "number",
                min: 0,
                dflt: "auto",
                arrayOk: !0,
                editType: "plot"
              },
              simplify: {
                valType: "boolean",
                dflt: !0,
                editType: "plot"
              },
              editType: "plot"
            },
            connectgaps: {
              valType: "boolean",
              dflt: !1,
              editType: "calc"
            },
            cliponaxis: {
              valType: "boolean",
              dflt: !0,
              editType: "plot"
            },
            fill: {
              valType: "enumerated",
              values: ["none", "tozeroy", "tozerox", "tonexty", "tonextx", "toself", "tonext"],
              editType: "calc"
            },
            fillcolor: h(!0),
            fillgradient: d({
              type: {
                valType: "enumerated",
                values: ["radial", "horizontal", "vertical", "none"],
                dflt: "none",
                editType: "calc"
              },
              start: {
                valType: "number",
                editType: "calc"
              },
              stop: {
                valType: "number",
                editType: "calc"
              },
              colorscale: {
                valType: "colorscale",
                editType: "style"
              },
              editType: "calc"
            }),
            fillpattern: c,
            marker: d({
              symbol: {
                valType: "enumerated",
                values: u.symbolList,
                dflt: "circle",
                arrayOk: !0,
                editType: "style"
              },
              opacity: {
                valType: "number",
                min: 0,
                max: 1,
                arrayOk: !0,
                editType: "style",
                anim: !0
              },
              angle: {
                valType: "angle",
                dflt: 0,
                arrayOk: !0,
                editType: "plot",
                anim: !1
              },
              angleref: {
                valType: "enumerated",
                values: ["previous", "up"],
                dflt: "up",
                editType: "plot",
                anim: !1
              },
              standoff: {
                valType: "number",
                min: 0,
                dflt: 0,
                arrayOk: !0,
                editType: "plot",
                anim: !0
              },
              size: {
                valType: "number",
                min: 0,
                dflt: 6,
                arrayOk: !0,
                editType: "calc",
                anim: !0
              },
              maxdisplayed: {
                valType: "number",
                min: 0,
                dflt: 0,
                editType: "plot"
              },
              sizeref: {
                valType: "number",
                dflt: 1,
                editType: "calc"
              },
              sizemin: {
                valType: "number",
                min: 0,
                dflt: 0,
                editType: "calc"
              },
              sizemode: {
                valType: "enumerated",
                values: ["diameter", "area"],
                dflt: "diameter",
                editType: "calc"
              },
              line: d({
                width: {
                  valType: "number",
                  min: 0,
                  arrayOk: !0,
                  editType: "style",
                  anim: !0
                },
                editType: "calc"
              }, o("marker.line", {
                anim: !0
              })),
              gradient: {
                type: {
                  valType: "enumerated",
                  values: ["radial", "horizontal", "vertical", "none"],
                  arrayOk: !0,
                  dflt: "none",
                  editType: "calc"
                },
                color: {
                  valType: "color",
                  arrayOk: !0,
                  editType: "calc"
                },
                editType: "calc"
              },
              editType: "calc"
            }, o("marker", {
              anim: !0
            })),
            selected: {
              marker: {
                opacity: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  editType: "style"
                },
                color: {
                  valType: "color",
                  editType: "style"
                },
                size: {
                  valType: "number",
                  min: 0,
                  editType: "style"
                },
                editType: "style"
              },
              textfont: {
                color: {
                  valType: "color",
                  editType: "style"
                },
                editType: "style"
              },
              editType: "style"
            },
            unselected: {
              marker: {
                opacity: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  editType: "style"
                },
                color: {
                  valType: "color",
                  editType: "style"
                },
                size: {
                  valType: "number",
                  min: 0,
                  editType: "style"
                },
                editType: "style"
              },
              textfont: {
                color: {
                  valType: "color",
                  editType: "style"
                },
                editType: "style"
              },
              editType: "style"
            },
            textposition: {
              valType: "enumerated",
              values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"],
              dflt: "middle center",
              arrayOk: !0,
              editType: "calc"
            },
            textfont: l({
              editType: "calc",
              colorEditType: "style",
              arrayOk: !0
            }),
            zorder: {
              valType: "integer",
              dflt: 0,
              editType: "plot"
            }
          };
        },
        6544: function (e, t, r) {
          "use strict";

          var n = r(721),
            a = r(4809),
            i = r(9714),
            o = r(528),
            l = r(3821).BADNUM,
            s = r(4726),
            c = r(7272),
            u = r(9203),
            f = r(8861);
          function d(e, t, r, n, a, o, l) {
            var c = t._length,
              u = e._fullLayout,
              f = r._id,
              d = n._id,
              h = u._firstScatter[v(t)] === t.uid,
              p = (g(t, u, r, n) || {}).orientation,
              m = t.fill;
            r._minDtick = 0, n._minDtick = 0;
            var y = {
                padded: !0
              },
              x = {
                padded: !0
              };
            l && (y.ppad = x.ppad = l);
            var b = c < 2 || a[0] !== a[c - 1] || o[0] !== o[c - 1];
            b && ("tozerox" === m || "tonextx" === m && (h || "h" === p)) ? y.tozero = !0 : (t.error_y || {}).visible || "tonexty" !== m && "tozeroy" !== m && (s.hasMarkers(t) || s.hasText(t)) || (y.padded = !1, y.ppad = 0), b && ("tozeroy" === m || "tonexty" === m && (h || "v" === p)) ? x.tozero = !0 : "tonextx" !== m && "tozerox" !== m || (x.padded = !1), f && (t._extremes[f] = i.findExtremes(r, a, y)), d && (t._extremes[d] = i.findExtremes(n, o, x));
          }
          function h(e, t) {
            if (s.hasMarkers(e)) {
              var r,
                n = e.marker,
                o = 1.6 * (e.marker.sizeref || 1);
              if (r = "area" === e.marker.sizemode ? function (e) {
                return Math.max(Math.sqrt((e || 0) / o), 3);
              } : function (e) {
                return Math.max((e || 0) / o, 3);
              }, a.isArrayOrTypedArray(n.size)) {
                var l = {
                  type: "linear"
                };
                i.setConvert(l);
                for (var c = l.makeCalcdata(e.marker, "size"), u = new Array(t), f = 0; f < t; f++) u[f] = r(c[f]);
                return u;
              }
              return r(n.size);
            }
          }
          function p(e, t) {
            var r = v(t),
              n = e._firstScatter;
            n[r] || (n[r] = t.uid);
          }
          function v(e) {
            var t = e.stackgroup;
            return e.xaxis + e.yaxis + e.type + (t ? "-" + t : "");
          }
          function g(e, t, r, n) {
            var a = e.stackgroup;
            if (a) {
              var i = t._scatterStackOpts[r._id + n._id][a],
                o = "v" === i.orientation ? n : r;
              return "linear" === o.type || "log" === o.type ? i : void 0;
            }
          }
          e.exports = {
            calc: function (e, t) {
              var r,
                s,
                v,
                m,
                y,
                x,
                b = e._fullLayout,
                _ = t._xA = i.getFromId(e, t.xaxis || "x", "x"),
                w = t._yA = i.getFromId(e, t.yaxis || "y", "y"),
                T = _.makeCalcdata(t, "x"),
                M = w.makeCalcdata(t, "y"),
                k = o(t, _, "x", T),
                A = o(t, w, "y", M),
                L = k.vals,
                S = A.vals,
                C = t._length,
                O = new Array(C),
                D = t.ids,
                P = g(t, b, _, w),
                z = !1;
              p(b, t);
              var I,
                E = "x",
                R = "y";
              P ? (a.pushUnique(P.traceIndices, t._expandedIndex), (r = "v" === P.orientation) ? (R = "s", I = "x") : (E = "s", I = "y"), y = "interpolate" === P.stackgaps) : d(e, t, _, w, L, S, h(t, C));
              var N = !!t.xperiodalignment,
                F = !!t.yperiodalignment;
              for (s = 0; s < C; s++) {
                var H = O[s] = {},
                  B = n(L[s]),
                  j = n(S[s]);
                B && j ? (H[E] = L[s], H[R] = S[s], N && (H.orig_x = T[s], H.xEnd = k.ends[s], H.xStart = k.starts[s]), F && (H.orig_y = M[s], H.yEnd = A.ends[s], H.yStart = A.starts[s])) : P && (r ? B : j) ? (H[I] = r ? L[s] : S[s], H.gap = !0, y ? (H.s = l, z = !0) : H.s = 0) : H[E] = H[R] = l, D && (H.id = String(D[s]));
              }
              if (u(O, t), c(e, t), f(O, t), P) {
                for (s = 0; s < O.length;) O[s][I] === l ? O.splice(s, 1) : s++;
                if (a.sort(O, function (e, t) {
                  return e[I] - t[I] || e.i - t.i;
                }), z) {
                  for (s = 0; s < O.length - 1 && O[s].gap;) s++;
                  for ((x = O[s].s) || (x = O[s].s = 0), v = 0; v < s; v++) O[v].s = x;
                  for (m = O.length - 1; m > s && O[m].gap;) m--;
                  for (x = O[m].s, v = O.length - 1; v > m; v--) O[v].s = x;
                  for (; s < m;) if (O[++s].gap) {
                    for (v = s + 1; O[v].gap;) v++;
                    for (var Y = O[s - 1][I], V = O[s - 1].s, U = (O[v].s - V) / (O[v][I] - Y); s < v;) O[s].s = V + (O[s][I] - Y) * U, s++;
                  }
                }
              }
              return O;
            },
            calcMarkerSize: h,
            calcAxisExpansion: d,
            setFirstScatter: p,
            getStackOpts: g
          };
        },
        8861: function (e, t, r) {
          "use strict";

          var n = r(4809);
          e.exports = function (e, t) {
            n.isArrayOrTypedArray(t.selectedpoints) && n.tagSelected(e, t);
          };
        },
        7272: function (e, t, r) {
          "use strict";

          var n = r(5477).hasColorscale,
            a = r(8379),
            i = r(4726);
          e.exports = function (e, t) {
            i.hasLines(t) && n(t, "line") && a(e, t, {
              vals: t.line.color,
              containerStr: "line",
              cLetter: "c"
            }), i.hasMarkers(t) && (n(t, "marker") && a(e, t, {
              vals: t.marker.color,
              containerStr: "marker",
              cLetter: "c"
            }), n(t, "marker.line") && a(e, t, {
              vals: t.marker.line.color,
              containerStr: "marker.line",
              cLetter: "c"
            }));
          };
        },
        2660: function (e) {
          "use strict";

          e.exports = {
            PTS_LINESONLY: 20,
            minTolerance: .2,
            toleranceGrowth: 10,
            maxScreensAway: 20,
            eventDataKeys: []
          };
        },
        5603: function (e, t, r) {
          "use strict";

          var n = r(6544),
            a = r(4782).setGroupPositions;
          function i(e, t, r, n, a, i, o) {
            a[n] = !0;
            var l = {
              i: null,
              gap: !0,
              s: 0
            };
            if (l[o] = r, e.splice(t, 0, l), t && r === e[t - 1][o]) {
              var s = e[t - 1];
              l.s = s.s, l.i = s.i, l.gap = s.gap;
            } else i && (l.s = function (e, t, r, n) {
              var a = e[t - 1],
                i = e[t + 1];
              return i ? a ? a.s + (i.s - a.s) * (r - a[n]) / (i[n] - a[n]) : i.s : a.s;
            }(e, t, r, o));
            t || (e[0].t = e[1].t, e[0].trace = e[1].trace, delete e[1].t, delete e[1].trace);
          }
          e.exports = function (e, t) {
            "group" === e._fullLayout.scattermode && function (e, t) {
              for (var r = t.xaxis, n = t.yaxis, i = e._fullLayout, o = e._fullData, l = e.calcdata, s = [], c = [], u = 0; u < o.length; u++) {
                var f = o[u];
                !0 === f.visible && "scatter" === f.type && f.xaxis === r._id && f.yaxis === n._id && ("h" === f.orientation ? s.push(l[u]) : "v" === f.orientation && c.push(l[u]));
              }
              var d = {
                mode: i.scattermode,
                gap: i.scattergap
              };
              a(e, r, n, c, d), a(e, n, r, s, d);
            }(e, t);
            var r = t.xaxis,
              o = t.yaxis,
              l = r._id + o._id,
              s = e._fullLayout._scatterStackOpts[l];
            if (s) {
              var c,
                u,
                f,
                d,
                h,
                p,
                v,
                g,
                m,
                y,
                x,
                b,
                _,
                w,
                T,
                M = e.calcdata;
              for (var k in s) {
                var A = (y = s[k]).traceIndices;
                if (A.length) {
                  for (x = "interpolate" === y.stackgaps, b = y.groupnorm, "v" === y.orientation ? (_ = "x", w = "y") : (_ = "y", w = "x"), T = new Array(A.length), c = 0; c < T.length; c++) T[c] = !1;
                  p = M[A[0]];
                  var L = new Array(p.length);
                  for (c = 0; c < p.length; c++) L[c] = p[c][_];
                  for (c = 1; c < A.length; c++) {
                    for (h = M[A[c]], u = f = 0; u < h.length; u++) {
                      for (v = h[u][_]; v > L[f] && f < L.length; f++) i(h, u, L[f], c, T, x, _), u++;
                      if (v !== L[f]) {
                        for (d = 0; d < c; d++) i(M[A[d]], f, v, d, T, x, _);
                        L.splice(f, 0, v);
                      }
                      f++;
                    }
                    for (; f < L.length; f++) i(h, u, L[f], c, T, x, _), u++;
                  }
                  var S = L.length;
                  for (u = 0; u < p.length; u++) {
                    for (g = p[u][w] = p[u].s, c = 1; c < A.length; c++) (h = M[A[c]])[0].trace._rawLength = h[0].trace._length, h[0].trace._length = S, g += h[u].s, h[u][w] = g;
                    if (b) for (m = ("fraction" === b ? g : g / 100) || 1, c = 0; c < A.length; c++) {
                      var C = M[A[c]][u];
                      C[w] /= m, C.sNorm = C.s / m;
                    }
                  }
                  for (c = 0; c < A.length; c++) {
                    var O = (h = M[A[c]])[0].trace,
                      D = n.calcMarkerSize(O, O._rawLength),
                      P = Array.isArray(D);
                    if (D && T[c] || P) {
                      var z = D;
                      for (D = new Array(S), u = 0; u < S; u++) D[u] = h[u].gap ? 0 : P ? z[h[u].i] : z;
                    }
                    var I = new Array(S),
                      E = new Array(S);
                    for (u = 0; u < S; u++) I[u] = h[u].x, E[u] = h[u].y;
                    n.calcAxisExpansion(e, O, r, o, I, E, D), h[0].t.orientation = y.orientation;
                  }
                }
              }
            }
          };
        },
        3044: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(6301),
            i = r(6640);
          e.exports = function (e, t) {
            var r, o, l;
            function s(e) {
              return n.coerce(o._input, o, i, e);
            }
            if ("group" === t.scattermode) for (l = 0; l < e.length; l++) "scatter" === (o = e[l]).type && (r = o._input, a(r, o, t, s));
            for (l = 0; l < e.length; l++) {
              var c = e[l];
              if ("scatter" === c.type) {
                var u = c.fill;
                if ("none" !== u && "toself" !== u && (c.opacity = void 0, "tonexty" === u || "tonextx" === u)) for (var f = l - 1; f >= 0; f--) {
                  var d = e[f];
                  if ("scatter" === d.type && d.xaxis === c.xaxis && d.yaxis === c.yaxis) {
                    d.opacity = void 0;
                    break;
                  }
                }
              }
            }
          };
        },
        247: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(3626),
            i = r(6640),
            o = r(2660),
            l = r(4726),
            s = r(9867),
            c = r(9669),
            u = r(382),
            f = r(4272),
            d = r(8168),
            h = r(1602),
            p = r(663),
            v = r(4114),
            g = r(4809).coercePattern;
          e.exports = function (e, t, r, m) {
            function y(r, a) {
              return n.coerce(e, t, i, r, a);
            }
            var x = s(e, t, m, y);
            if (x || (t.visible = !1), t.visible) {
              c(e, t, m, y), y("xhoverformat"), y("yhoverformat"), y("zorder");
              var b = u(e, t, m, y);
              "group" === m.scattermode && void 0 === t.orientation && y("orientation", "v");
              var _ = !b && x < o.PTS_LINESONLY ? "lines+markers" : "lines";
              y("text"), y("hovertext"), y("mode", _), l.hasMarkers(t) && f(e, t, r, m, y, {
                gradient: !0
              }), l.hasLines(t) && (d(e, t, r, m, y, {
                backoff: !0
              }), h(e, t, y), y("connectgaps"), y("line.simplify")), l.hasText(t) && (y("texttemplate"), p(e, t, m, y));
              var w = [];
              (l.hasMarkers(t) || l.hasText(t)) && (y("cliponaxis"), y("marker.maxdisplayed"), w.push("points")), y("fill", b ? b.fillDflt : "none"), "none" !== t.fill && (v(e, t, r, y, {
                moduleHasFillgradient: !0
              }), l.hasLines(t) || h(e, t, y), g(y, "fillpattern", t.fillcolor, !1));
              var T = (t.line || {}).color,
                M = (t.marker || {}).color;
              "tonext" !== t.fill && "toself" !== t.fill || w.push("fills"), y("hoveron", w.join("+") || "points"), "fills" !== t.hoveron && y("hovertemplate");
              var k = a.getComponentMethod("errorbars", "supplyDefaults");
              k(e, t, T || M || r, {
                axis: "y"
              }), k(e, t, T || M || r, {
                axis: "x",
                inherit: "y"
              }), n.coerceSelectionMarkerOpacity(t, y);
            }
          };
        },
        9326: function (e) {
          "use strict";

          e.exports = function (e) {
            return {
              valType: "color",
              editType: "style",
              anim: !0
            };
          };
        },
        4114: function (e, t, r) {
          "use strict";

          var n = r(8766),
            a = r(4809).isArrayOrTypedArray;
          e.exports = function (e, t, r, i, o) {
            o || (o = {});
            var l,
              s = !1;
            if (t.marker) {
              var c = t.marker.color,
                u = (t.marker.line || {}).color;
              c && !a(c) ? s = c : u && !a(u) && (s = u);
            }
            if (o.moduleHasFillgradient && "none" !== i("fillgradient.type")) {
              i("fillgradient.start"), i("fillgradient.stop");
              var f = i("fillgradient.colorscale");
              f && (l = function (e) {
                for (var t = n.interpolate(e[0][1], e[1][1], .5), r = 2; r < e.length; r++) {
                  var a = n.interpolate(e[r - 1][1], e[r][1], .5);
                  t = n.interpolate(t, a, e[r - 1][0] / e[r][0]);
                }
                return t;
              }(f));
            }
            i("fillcolor", n.addOpacity((t.line || {}).color || s || l || r, .5));
          };
        },
        5294: function (e, t, r) {
          "use strict";

          var n = r(9714);
          e.exports = function (e, t, r) {
            var a = {},
              i = {
                _fullLayout: r
              },
              o = n.getFromTrace(i, t, "x"),
              l = n.getFromTrace(i, t, "y"),
              s = e.orig_x;
            void 0 === s && (s = e.x);
            var c = e.orig_y;
            return void 0 === c && (c = e.y), a.xLabel = n.tickText(o, o.c2l(s), !0).text, a.yLabel = n.tickText(l, l.c2l(c), !0).text, a;
          };
        },
        1539: function (e, t, r) {
          "use strict";

          var n = r(8766),
            a = r(4726);
          e.exports = function (e, t) {
            var r, i;
            if ("lines" === e.mode) return (r = e.line.color) && n.opacity(r) ? r : e.fillcolor;
            if ("none" === e.mode) return e.fill ? e.fillcolor : "";
            var o = t.mcc || (e.marker || {}).color,
              l = t.mlcc || ((e.marker || {}).line || {}).color;
            return (i = o && n.opacity(o) ? o : l && n.opacity(l) && (t.mlw || ((e.marker || {}).line || {}).width) ? l : "") ? n.opacity(i) < .3 ? n.addOpacity(i, .3) : i : (r = (e.line || {}).color) && n.opacity(r) && a.hasLines(e) && e.line.width ? r : e.fillcolor;
          };
        },
        6301: function (e, t, r) {
          "use strict";

          var n = r(4391).getAxisGroup;
          e.exports = function (e, t, r, a) {
            var i = t.orientation,
              o = t[{
                v: "x",
                h: "y"
              }[i] + "axis"],
              l = n(r, o) + i,
              s = r._alignmentOpts || {},
              c = a("alignmentgroup"),
              u = s[l];
            u || (u = s[l] = {});
            var f = u[c];
            f ? f.traces.push(t) : f = u[c] = {
              traces: [t],
              alignmentIndex: Object.keys(u).length,
              offsetGroups: {}
            };
            var d = a("offsetgroup"),
              h = f.offsetGroups,
              p = h[d];
            d && (p || (p = h[d] = {
              offsetIndex: Object.keys(h).length
            }), t._offsetIndex = p.offsetIndex);
          };
        },
        7255: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(2141),
            i = r(3626),
            o = r(1539),
            l = r(8766),
            s = n.fillText;
          e.exports = function (e, t, r, c) {
            var u = e.cd,
              f = u[0].trace,
              d = e.xa,
              h = e.ya,
              p = d.c2p(t),
              v = h.c2p(r),
              g = [p, v],
              m = f.hoveron || "",
              y = -1 !== f.mode.indexOf("markers") ? 3 : .5,
              x = !!f.xperiodalignment,
              b = !!f.yperiodalignment;
            if (-1 !== m.indexOf("points")) {
              var _ = function (e) {
                  var t = Math.max(y, e.mrc || 0),
                    r = d.c2p(e.x) - p,
                    n = h.c2p(e.y) - v;
                  return Math.max(Math.sqrt(r * r + n * n) - t, 1 - y / t);
                },
                w = a.getDistanceFunction(c, function (e) {
                  if (x) {
                    var t = d.c2p(e.xStart),
                      r = d.c2p(e.xEnd);
                    return p >= Math.min(t, r) && p <= Math.max(t, r) ? 0 : 1 / 0;
                  }
                  var n = Math.max(3, e.mrc || 0),
                    a = 1 - 1 / n,
                    i = Math.abs(d.c2p(e.x) - p);
                  return i < n ? a * i / n : i - n + a;
                }, function (e) {
                  if (b) {
                    var t = h.c2p(e.yStart),
                      r = h.c2p(e.yEnd);
                    return v >= Math.min(t, r) && v <= Math.max(t, r) ? 0 : 1 / 0;
                  }
                  var n = Math.max(3, e.mrc || 0),
                    a = 1 - 1 / n,
                    i = Math.abs(h.c2p(e.y) - v);
                  return i < n ? a * i / n : i - n + a;
                }, _);
              if (a.getClosest(u, w, e), !1 !== e.index) {
                var T = u[e.index],
                  M = d.c2p(T.x, !0),
                  k = h.c2p(T.y, !0),
                  A = T.mrc || 1;
                e.index = T.i;
                var L = u[0].t.orientation,
                  S = L && (T.sNorm || T.s),
                  C = "h" === L ? S : void 0 !== T.orig_x ? T.orig_x : T.x,
                  O = "v" === L ? S : void 0 !== T.orig_y ? T.orig_y : T.y;
                return n.extendFlat(e, {
                  color: o(f, T),
                  x0: M - A,
                  x1: M + A,
                  xLabelVal: C,
                  y0: k - A,
                  y1: k + A,
                  yLabelVal: O,
                  spikeDistance: _(T),
                  hovertemplate: f.hovertemplate
                }), s(T, f, e), i.getComponentMethod("errorbars", "hoverInfo")(T, f, e), [e];
              }
            }
            function D(e) {
              if (!e) return !1;
              var t = e.node();
              try {
                var r = new DOMPoint(g[0], g[1]);
                return t.isPointInFill(r);
              } catch (e) {
                var n = t.ownerSVGElement.createSVGPoint();
                return n.x = g[0], n.y = g[1], t.isPointInFill(n);
              }
            }
            if (-1 !== m.indexOf("fills") && f._fillElement && D(f._fillElement) && !D(f._fillExclusionElement)) {
              var P = function (e) {
                var t,
                  r,
                  n,
                  a,
                  i,
                  o,
                  l,
                  s,
                  c,
                  u = [],
                  f = 1 / 0,
                  p = -1 / 0,
                  v = 1 / 0,
                  m = -1 / 0;
                for (t = 0; t < e.length; t++) {
                  var y = e[t];
                  y.contains(g) && (u.push(y), v = Math.min(v, y.ymin), m = Math.max(m, y.ymax));
                }
                if (0 === u.length) return null;
                for (r = ((v = Math.max(v, 0)) + (m = Math.min(m, h._length))) / 2, t = 0; t < u.length; t++) for (a = u[t].pts, n = 1; n < a.length; n++) (s = a[n - 1][1]) > r != (c = a[n][1]) >= r && (o = a[n - 1][0], l = a[n][0], c - s && (i = o + (l - o) * (r - s) / (c - s), f = Math.min(f, i), p = Math.max(p, i)));
                return {
                  x0: f = Math.max(f, 0),
                  x1: p = Math.min(p, d._length),
                  y0: r,
                  y1: r
                };
              }(f._polygons);
              null === P && (P = {
                x0: g[0],
                x1: g[0],
                y0: g[1],
                y1: g[1]
              });
              var z = l.defaultLine;
              return l.opacity(f.fillcolor) ? z = f.fillcolor : l.opacity((f.line || {}).color) && (z = f.line.color), n.extendFlat(e, {
                distance: e.maxHoverDistance,
                x0: P.x0,
                x1: P.x1,
                y0: P.y0,
                y1: P.y1,
                color: z,
                hovertemplate: !1
              }), delete e.index, f.text && !n.isArrayOrTypedArray(f.text) ? e.text = String(f.text) : e.text = f.name, [e];
            }
          };
        },
        9693: function (e, t, r) {
          "use strict";

          var n = r(4726);
          e.exports = {
            hasLines: n.hasLines,
            hasMarkers: n.hasMarkers,
            hasText: n.hasText,
            isBubble: n.isBubble,
            attributes: r(6640),
            layoutAttributes: r(6667),
            supplyDefaults: r(247),
            crossTraceDefaults: r(3044),
            supplyLayoutDefaults: r(2332),
            calc: r(6544).calc,
            crossTraceCalc: r(5603),
            arraysToCalcdata: r(9203),
            plot: r(6098),
            colorbar: r(1146),
            formatLabels: r(5294),
            style: r(9408).style,
            styleOnSelect: r(9408).styleOnSelect,
            hoverPoints: r(7255),
            selectPoints: r(2665),
            animatable: !0,
            moduleType: "trace",
            name: "scatter",
            basePlotModule: r(84),
            categories: ["cartesian", "svg", "symbols", "errorBarsOK", "showLegend", "scatter-like", "zoomScale"],
            meta: {}
          };
        },
        6667: function (e) {
          "use strict";

          e.exports = {
            scattermode: {
              valType: "enumerated",
              values: ["group", "overlay"],
              dflt: "overlay",
              editType: "calc"
            },
            scattergap: {
              valType: "number",
              min: 0,
              max: 1,
              editType: "calc"
            }
          };
        },
        2332: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(6667);
          e.exports = function (e, t) {
            var r,
              i = "group" === t.barmode;
            "group" === t.scattermode && ("scattergap", r = i ? t.bargap : .2, n.coerce(e, t, a, "scattergap", r));
          };
        },
        8168: function (e, t, r) {
          "use strict";

          var n = r(4809).isArrayOrTypedArray,
            a = r(5477).hasColorscale,
            i = r(9356);
          e.exports = function (e, t, r, o, l, s) {
            s || (s = {});
            var c = (e.marker || {}).color;
            c && c._inputArray && (c = c._inputArray), l("line.color", r), a(e, "line") ? i(e, t, o, l, {
              prefix: "line.",
              cLetter: "c"
            }) : l("line.color", !n(c) && c || r), l("line.width"), s.noDash || l("line.dash"), s.backoff && l("line.backoff");
          };
        },
        5525: function (e, t, r) {
          "use strict";

          var n = r(2203),
            a = r(3821),
            i = a.BADNUM,
            o = a.LOG_CLIP,
            l = o + .5,
            s = o - .5,
            c = r(4809),
            u = c.segmentsIntersect,
            f = c.constrain,
            d = r(2660);
          e.exports = function (e, t) {
            var r,
              a,
              o,
              h,
              p,
              v,
              g,
              m,
              y,
              x,
              b,
              _,
              w,
              T,
              M,
              k,
              A,
              L,
              S = t.trace || {},
              C = t.xaxis,
              O = t.yaxis,
              D = "log" === C.type,
              P = "log" === O.type,
              z = C._length,
              I = O._length,
              E = t.backoff,
              R = S.marker,
              N = t.connectGaps,
              F = t.baseTolerance,
              H = t.shape,
              B = "linear" === H,
              j = S.fill && "none" !== S.fill,
              Y = [],
              V = d.minTolerance,
              U = e.length,
              q = new Array(U),
              G = 0;
            function Z(r) {
              var n = e[r];
              if (!n) return !1;
              var a = t.linearized ? C.l2p(n.x) : C.c2p(n.x),
                o = t.linearized ? O.l2p(n.y) : O.c2p(n.y);
              if (a === i) {
                if (D && (a = C.c2p(n.x, !0)), a === i) return !1;
                P && o === i && (a *= Math.abs(C._m * I * (C._m > 0 ? l : s) / (O._m * z * (O._m > 0 ? l : s)))), a *= 1e3;
              }
              if (o === i) {
                if (P && (o = O.c2p(n.y, !0)), o === i) return !1;
                o *= 1e3;
              }
              return [a, o];
            }
            function W(e, t, r, n) {
              var a = r - e,
                i = n - t,
                o = .5 - e,
                l = .5 - t,
                s = a * a + i * i,
                c = a * o + i * l;
              if (c > 0 && c < s) {
                var u = o * i - l * a;
                if (u * u < s) return !0;
              }
            }
            function J(e, t) {
              var r = e[0] / z,
                n = e[1] / I,
                a = Math.max(0, -r, r - 1, -n, n - 1);
              return a && void 0 !== A && W(r, n, A, L) && (a = 0), a && t && W(r, n, t[0] / z, t[1] / I) && (a = 0), (1 + d.toleranceGrowth * a) * F;
            }
            function X(e, t) {
              var r = e[0] - t[0],
                n = e[1] - t[1];
              return Math.sqrt(r * r + n * n);
            }
            var K,
              Q,
              $,
              ee,
              te,
              re,
              ne,
              ae = d.maxScreensAway,
              ie = -z * ae,
              oe = z * (1 + ae),
              le = -I * ae,
              se = I * (1 + ae),
              ce = [[ie, le, oe, le], [oe, le, oe, se], [oe, se, ie, se], [ie, se, ie, le]];
            function ue(e) {
              if (e[0] < ie || e[0] > oe || e[1] < le || e[1] > se) return [f(e[0], ie, oe), f(e[1], le, se)];
            }
            function fe(e, t) {
              return e[0] === t[0] && (e[0] === ie || e[0] === oe) || e[1] === t[1] && (e[1] === le || e[1] === se) || void 0;
            }
            function de(e, t, r) {
              return function (n, a) {
                var i = ue(n),
                  o = ue(a),
                  l = [];
                if (i && o && fe(i, o)) return l;
                i && l.push(i), o && l.push(o);
                var s = 2 * c.constrain((n[e] + a[e]) / 2, t, r) - ((i || n)[e] + (o || a)[e]);
                return s && ((i && o ? s > 0 == i[e] > o[e] ? i : o : i || o)[e] += s), l;
              };
            }
            function he(e) {
              var t = e[0],
                r = e[1],
                n = t === q[G - 1][0],
                a = r === q[G - 1][1];
              if (!n || !a) if (G > 1) {
                var i = t === q[G - 2][0],
                  o = r === q[G - 2][1];
                n && (t === ie || t === oe) && i ? o ? G-- : q[G - 1] = e : a && (r === le || r === se) && o ? i ? G-- : q[G - 1] = e : q[G++] = e;
              } else q[G++] = e;
            }
            function pe(e) {
              q[G - 1][0] !== e[0] && q[G - 1][1] !== e[1] && he([$, ee]), he(e), te = null, $ = ee = 0;
            }
            "linear" === H || "spline" === H ? ne = function (e, t) {
              for (var r = [], n = 0, a = 0; a < 4; a++) {
                var i = ce[a],
                  o = u(e[0], e[1], t[0], t[1], i[0], i[1], i[2], i[3]);
                o && (!n || Math.abs(o.x - r[0][0]) > 1 || Math.abs(o.y - r[0][1]) > 1) && (o = [o.x, o.y], n && X(o, e) < X(r[0], e) ? r.unshift(o) : r.push(o), n++);
              }
              return r;
            } : "hv" === H || "vh" === H ? ne = function (e, t) {
              var r = [],
                n = ue(e),
                a = ue(t);
              return n && a && fe(n, a) || (n && r.push(n), a && r.push(a)), r;
            } : "hvh" === H ? ne = de(0, ie, oe) : "vhv" === H && (ne = de(1, le, se));
            var ve = c.isArrayOrTypedArray(R);
            function ge(t) {
              if (t && E && (t.i = r, t.d = e, t.trace = S, t.marker = ve ? R[t.i] : R, t.backoff = E), A = t[0] / z, L = t[1] / I, K = t[0] < ie ? ie : t[0] > oe ? oe : 0, Q = t[1] < le ? le : t[1] > se ? se : 0, K || Q) {
                if (G) {
                  if (te) {
                    var n = ne(te, t);
                    n.length > 1 && (pe(n[0]), q[G++] = n[1]);
                  } else re = ne(q[G - 1], t)[0], q[G++] = re;
                } else q[G++] = [K || t[0], Q || t[1]];
                var a = q[G - 1];
                K && Q && (a[0] !== K || a[1] !== Q) ? (te && ($ !== K && ee !== Q ? he($ && ee ? (i = te, l = (o = t)[0] - i[0], s = (o[1] - i[1]) / l, (i[1] * o[0] - o[1] * i[0]) / l > 0 ? [s > 0 ? ie : oe, se] : [s > 0 ? oe : ie, le]) : [$ || K, ee || Q]) : $ && ee && he([$, ee])), he([K, Q])) : $ - K && ee - Q && he([K || $, Q || ee]), te = t, $ = K, ee = Q;
              } else te && pe(ne(te, t)[0]), q[G++] = t;
              var i, o, l, s;
            }
            for (r = 0; r < U; r++) if (a = Z(r)) {
              for (G = 0, te = null, ge(a), r++; r < U; r++) {
                if (!(h = Z(r))) {
                  if (N) continue;
                  break;
                }
                if (B && t.simplify) {
                  var me = Z(r + 1);
                  if (x = X(h, a), j && (0 === G || G === U - 1) || !(x < J(h, me) * V)) {
                    for (m = [(h[0] - a[0]) / x, (h[1] - a[1]) / x], p = a, b = x, _ = T = M = 0, g = !1, o = h, r++; r < e.length; r++) {
                      if (v = me, me = Z(r + 1), !v) {
                        if (N) continue;
                        break;
                      }
                      if (k = (y = [v[0] - a[0], v[1] - a[1]])[0] * m[1] - y[1] * m[0], T = Math.min(T, k), (M = Math.max(M, k)) - T > J(v, me)) break;
                      o = v, (w = y[0] * m[0] + y[1] * m[1]) > b ? (b = w, h = v, g = !1) : w < _ && (_ = w, p = v, g = !0);
                    }
                    if (g ? (ge(h), o !== p && ge(p)) : (p !== a && ge(p), o !== h && ge(h)), ge(o), r >= e.length || !v) break;
                    ge(v), a = v;
                  }
                } else ge(h);
              }
              te && he([$ || te[0], ee || te[1]]), Y.push(q.slice(0, G));
            }
            var ye = H.slice(H.length - 1);
            if (E && "h" !== ye && "v" !== ye) {
              for (var xe = !1, be = -1, _e = [], we = 0; we < Y.length; we++) for (var Te = 0; Te < Y[we].length - 1; Te++) {
                var Me = Y[we][Te],
                  ke = Y[we][Te + 1],
                  Ae = n.applyBackoff(ke, Me);
                Ae[0] === ke[0] && Ae[1] === ke[1] || (xe = !0), _e[be + 1] || (_e[++be] = [Me, [Ae[0], Ae[1]]]);
              }
              return xe ? _e : Y;
            }
            return Y;
          };
        },
        1602: function (e) {
          "use strict";

          e.exports = function (e, t, r) {
            "spline" === r("line.shape") && r("line.smoothing");
          };
        },
        7210: function (e) {
          "use strict";

          var t = {
            tonextx: 1,
            tonexty: 1,
            tonext: 1
          };
          e.exports = function (e, r, n) {
            var a,
              i,
              o,
              l,
              s,
              c = {},
              u = !1,
              f = -1,
              d = 0,
              h = -1;
            for (i = 0; i < n.length; i++) (o = (a = n[i][0].trace).stackgroup || "") ? o in c ? s = c[o] : (s = c[o] = d, d++) : a.fill in t && h >= 0 ? s = h : (s = h = d, d++), s < f && (u = !0), a._groupIndex = f = s;
            var p = n.slice();
            u && p.sort(function (e, t) {
              var r = e[0].trace,
                n = t[0].trace;
              return r._groupIndex - n._groupIndex || r.index - n.index;
            });
            var v = {};
            for (i = 0; i < p.length; i++) o = (a = p[i][0].trace).stackgroup || "", !0 === a.visible ? (a._nexttrace = null, a.fill in t && (l = v[o], a._prevtrace = l || null, l && (l._nexttrace = a)), a._ownfill = a.fill && ("tozero" === a.fill.substr(0, 6) || "toself" === a.fill || "to" === a.fill.substr(0, 2) && !a._prevtrace), v[o] = a) : a._prevtrace = a._nexttrace = a._ownfill = null;
            return p;
          };
        },
        2527: function (e, t, r) {
          "use strict";

          var n = r(721);
          e.exports = function (e, t) {
            t || (t = 2);
            var r = e.marker,
              a = r.sizeref || 1,
              i = r.sizemin || 0,
              o = "area" === r.sizemode ? function (e) {
                return Math.sqrt(e / a);
              } : function (e) {
                return e / a;
              };
            return function (e) {
              var r = o(e / t);
              return n(r) && r > 0 ? Math.max(r, i) : 0;
            };
          };
        },
        1146: function (e) {
          "use strict";

          e.exports = {
            container: "marker",
            min: "cmin",
            max: "cmax"
          };
        },
        4272: function (e, t, r) {
          "use strict";

          var n = r(8766),
            a = r(5477).hasColorscale,
            i = r(9356),
            o = r(4726);
          e.exports = function (e, t, r, l, s, c) {
            var u = o.isBubble(e),
              f = (e.line || {}).color;
            c = c || {}, f && (r = f), s("marker.symbol"), s("marker.opacity", u ? .7 : 1), s("marker.size"), c.noAngle || (s("marker.angle"), c.noAngleRef || s("marker.angleref"), c.noStandOff || s("marker.standoff")), s("marker.color", r), a(e, "marker") && i(e, t, l, s, {
              prefix: "marker.",
              cLetter: "c"
            }), c.noSelect || (s("selected.marker.color"), s("unselected.marker.color"), s("selected.marker.size"), s("unselected.marker.size")), c.noLine || (s("marker.line.color", f && !Array.isArray(f) && t.marker.color !== f ? f : u ? n.background : n.defaultLine), a(e, "marker.line") && i(e, t, l, s, {
              prefix: "marker.line.",
              cLetter: "c"
            }), s("marker.line.width", u ? 1 : 0)), u && (s("marker.sizeref"), s("marker.sizemin"), s("marker.sizemode")), c.gradient && "none" !== s("marker.gradient.type") && s("marker.gradient.color");
          };
        },
        9669: function (e, t, r) {
          "use strict";

          var n = r(4809).dateTick0,
            a = r(3821).ONEWEEK;
          function i(e, t) {
            return n(t, e % a == 0 ? 1 : 0);
          }
          e.exports = function (e, t, r, n, a) {
            if (a || (a = {
              x: !0,
              y: !0
            }), a.x) {
              var o = n("xperiod");
              o && (n("xperiod0", i(o, t.xcalendar)), n("xperiodalignment"));
            }
            if (a.y) {
              var l = n("yperiod");
              l && (n("yperiod0", i(l, t.ycalendar)), n("yperiodalignment"));
            }
          };
        },
        6098: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(3626),
            i = r(4809),
            o = i.ensureSingle,
            l = i.identity,
            s = r(2203),
            c = r(4726),
            u = r(5525),
            f = r(7210),
            d = r(899).tester;
          function h(e, t, r, f, h, p, v) {
            var g,
              m = e._context.staticPlot;
            !function (e, t, r, a, o) {
              var l = r.xaxis,
                s = r.yaxis,
                u = n.extent(i.simpleMap(l.range, l.r2c)),
                f = n.extent(i.simpleMap(s.range, s.r2c)),
                d = a[0].trace;
              if (c.hasMarkers(d)) {
                var h = d.marker.maxdisplayed;
                if (0 !== h) {
                  var p = a.filter(function (e) {
                      return e.x >= u[0] && e.x <= u[1] && e.y >= f[0] && e.y <= f[1];
                    }),
                    v = Math.ceil(p.length / h),
                    g = 0;
                  o.forEach(function (e, r) {
                    var n = e[0].trace;
                    c.hasMarkers(n) && n.marker.maxdisplayed > 0 && r < t && g++;
                  });
                  var m = Math.round(g * v / 3 + Math.floor(g / 3) * v / 7.1);
                  a.forEach(function (e) {
                    delete e.vis;
                  }), p.forEach(function (e, t) {
                    0 === Math.round((t + m) % v) && (e.vis = !0);
                  });
                }
              }
            }(0, t, r, f, h);
            var y = !!v && v.duration > 0;
            function x(e) {
              return y ? e.transition() : e;
            }
            var b = r.xaxis,
              _ = r.yaxis,
              w = f[0].trace,
              T = w.line,
              M = n.select(p),
              k = o(M, "g", "errorbars"),
              A = o(M, "g", "lines"),
              L = o(M, "g", "points"),
              S = o(M, "g", "text");
            if (a.getComponentMethod("errorbars", "plot")(e, k, r, v), !0 === w.visible) {
              var C, O;
              x(M).style("opacity", w.opacity);
              var D,
                P,
                z = w.fill.charAt(w.fill.length - 1);
              "x" !== z && "y" !== z && (z = ""), "y" === z ? (D = 1, P = _.c2p(0, !0)) : "x" === z && (D = 0, P = b.c2p(0, !0)), f[0][r.isRangePlot ? "nodeRangePlot3" : "node3"] = M;
              var I,
                E,
                R = "",
                N = [],
                F = w._prevtrace,
                H = null,
                B = null;
              F && (R = F._prevRevpath || "", O = F._nextFill, N = F._ownPolygons, H = F._fillsegments, B = F._fillElement);
              var j,
                Y,
                V,
                U,
                q,
                G,
                Z = "",
                W = "",
                J = [];
              w._polygons = [];
              var X = [],
                K = [],
                Q = i.noop;
              if (C = w._ownFill, c.hasLines(w) || "none" !== w.fill) {
                O && O.datum(f), -1 !== ["hv", "vh", "hvh", "vhv"].indexOf(T.shape) ? (j = s.steps(T.shape), Y = s.steps(T.shape.split("").reverse().join(""))) : j = Y = "spline" === T.shape ? function (e) {
                  var t = e[e.length - 1];
                  return e.length > 1 && e[0][0] === t[0] && e[0][1] === t[1] ? s.smoothclosed(e.slice(1), T.smoothing) : s.smoothopen(e, T.smoothing);
                } : function (e) {
                  return "M" + e.join("L");
                }, V = function (e) {
                  return Y(e.reverse());
                }, K = u(f, {
                  xaxis: b,
                  yaxis: _,
                  trace: w,
                  connectGaps: w.connectgaps,
                  baseTolerance: Math.max(T.width || 1, 3) / 4,
                  shape: T.shape,
                  backoff: T.backoff,
                  simplify: T.simplify,
                  fill: w.fill
                }), X = new Array(K.length);
                var $ = 0;
                for (g = 0; g < K.length; g++) {
                  var ee,
                    te = K[g];
                  ee && z ? ee.push.apply(ee, te) : (ee = te.slice(), X[$] = ee, $++);
                }
                w._fillElement = null, w._fillExclusionElement = B, w._fillsegments = X.slice(0, $), X = w._fillsegments, K.length && (U = K[0][0].slice(), G = (q = K[K.length - 1])[q.length - 1].slice()), Q = function (e) {
                  return function (t) {
                    if (I = j(t), E = V(t), Z ? z ? (Z += "L" + I.substr(1), W = E + "L" + W.substr(1)) : (Z += "Z" + I, W = E + "Z" + W) : (Z = I, W = E), c.hasLines(w)) {
                      var r = n.select(this);
                      if (r.datum(f), e) x(r.style("opacity", 0).attr("d", I).call(s.lineGroupStyle)).style("opacity", 1);else {
                        var a = x(r);
                        a.attr("d", I), s.singleLineStyle(f, a);
                      }
                    }
                  };
                };
              }
              var re = A.selectAll(".js-line").data(K);
              x(re.exit()).style("opacity", 0).remove(), re.each(Q(!1)), re.enter().append("path").classed("js-line", !0).style("vector-effect", m ? "none" : "non-scaling-stroke").call(s.lineGroupStyle).each(Q(!0)), s.setClipUrl(re, r.layerClipId, e);
              var ne = function () {
                  var e = new Array(X.length);
                  for (g = 0; g < X.length; g++) e[g] = d(X[g]);
                  return e;
                },
                ae = function (e) {
                  var t, r;
                  if (e && 0 !== e.length) {
                    for (t = new Array(e.length - 1 + X.length), r = 0; r < e.length - 1; r++) t[r] = d(e[r]);
                    var n = e[e.length - 1].slice();
                    for (n.reverse(), r = 0; r < X.length; r++) t[e.length - 1 + r] = d(X[r].concat(n));
                  } else for (t = new Array(X.length), r = 0; r < X.length; r++) {
                    var a = X[r][0].slice(),
                      i = X[r][X[r].length - 1].slice();
                    a[D] = i[D] = P;
                    var o = [i, a].concat(X[r]);
                    t[r] = d(o);
                  }
                  return t;
                };
              K.length ? (C ? (C.datum(f), U && G && (z ? (U[D] = G[D] = P, x(C).attr("d", "M" + G + "L" + U + "L" + Z.substr(1)).call(s.singleFillStyle, e), J = ae(null)) : (x(C).attr("d", Z + "Z").call(s.singleFillStyle, e), J = ne())), w._polygons = J, w._fillElement = C) : O && ("tonext" === w.fill.substr(0, 6) && Z && R ? ("tonext" === w.fill ? (x(O).attr("d", Z + "Z" + R + "Z").call(s.singleFillStyle, e), J = ne(), w._polygons = J.concat(N)) : (x(O).attr("d", Z + "L" + R.substr(1) + "Z").call(s.singleFillStyle, e), J = ae(H), w._polygons = J), w._fillElement = O) : oe(O)), w._prevRevpath = W) : (C ? oe(C) : O && oe(O), w._prevRevpath = null), w._ownPolygons = J, L.datum(f), S.datum(f), function (t, a, i) {
                var o,
                  u = i[0].trace,
                  f = c.hasMarkers(u),
                  d = c.hasText(u),
                  h = fe(u),
                  p = de,
                  v = de;
                if (f || d) {
                  var g = l,
                    m = u.stackgroup,
                    w = m && "infer zero" === e._fullLayout._scatterStackOpts[b._id + _._id][m].stackgaps;
                  u.marker.maxdisplayed || u._needsCull ? g = w ? se : le : m && !w && (g = ce), f && (p = g), d && (v = g);
                }
                var T,
                  M = (o = t.selectAll("path.point").data(p, h)).enter().append("path").classed("point", !0);
                y && M.call(s.pointStyle, u, e).call(s.translatePoints, b, _).style("opacity", 0).transition().style("opacity", 1), o.order(), f && (T = s.makePointStyleFns(u)), o.each(function (t) {
                  var a = n.select(this),
                    i = x(a);
                  s.translatePoint(t, i, b, _) ? (s.singlePointStyle(t, i, u, T, e), r.layerClipId && s.hideOutsideRangePoint(t, i, b, _, u.xcalendar, u.ycalendar), u.customdata && a.classed("plotly-customdata", null !== t.data && void 0 !== t.data)) : i.remove();
                }), y ? o.exit().transition().style("opacity", 0).remove() : o.exit().remove(), (o = a.selectAll("g").data(v, h)).enter().append("g").classed("textpoint", !0).append("text"), o.order(), o.each(function (e) {
                  var t = n.select(this),
                    a = x(t.select("text"));
                  s.translatePoint(e, a, b, _) ? r.layerClipId && s.hideOutsideRangePoint(e, t, b, _, u.xcalendar, u.ycalendar) : t.remove();
                }), o.selectAll("text").call(s.textPointStyle, u, e).each(function (e) {
                  var t = b.c2p(e.x),
                    r = _.c2p(e.y);
                  n.select(this).selectAll("tspan.line").each(function () {
                    x(n.select(this)).attr({
                      x: t,
                      y: r
                    });
                  });
                }), o.exit().remove();
              }(L, S, f);
              var ie = !1 === w.cliponaxis ? null : r.layerClipId;
              s.setClipUrl(L, ie, e), s.setClipUrl(S, ie, e);
            }
            function oe(e) {
              x(e).attr("d", "M0,0Z");
            }
            function le(e) {
              return e.filter(function (e) {
                return !e.gap && e.vis;
              });
            }
            function se(e) {
              return e.filter(function (e) {
                return e.vis;
              });
            }
            function ce(e) {
              return e.filter(function (e) {
                return !e.gap;
              });
            }
            function ue(e) {
              return e.id;
            }
            function fe(e) {
              if (e.ids) return ue;
            }
            function de() {
              return !1;
            }
          }
          e.exports = function (e, t, r, a, i, c) {
            var u,
              d,
              p = !i,
              v = !!i && i.duration > 0,
              g = f(e, t, r);
            (u = a.selectAll("g.trace").data(g, function (e) {
              return e[0].trace.uid;
            })).enter().append("g").attr("class", function (e) {
              return "trace scatter trace" + e[0].trace.uid;
            }).style("stroke-miterlimit", 2), u.order(), function (e, t, r) {
              t.each(function (t) {
                var a = o(n.select(this), "g", "fills");
                s.setClipUrl(a, r.layerClipId, e);
                var i = t[0].trace,
                  c = [];
                i._ownfill && c.push("_ownFill"), i._nexttrace && c.push("_nextFill");
                var u = a.selectAll("g").data(c, l);
                u.enter().append("g"), u.exit().each(function (e) {
                  i[e] = null;
                }).remove(), u.order().each(function (e) {
                  i[e] = o(n.select(this), "path", "js-fill");
                });
              });
            }(e, u, t), v ? (c && (d = c()), n.transition().duration(i.duration).ease(i.easing).each("end", function () {
              d && d();
            }).each("interrupt", function () {
              d && d();
            }).each(function () {
              a.selectAll("g.trace").each(function (r, n) {
                h(e, n, t, r, g, this, i);
              });
            })) : u.each(function (r, n) {
              h(e, n, t, r, g, this, i);
            }), p && u.exit().remove(), a.selectAll("path:not([d])").remove();
          };
        },
        2665: function (e, t, r) {
          "use strict";

          var n = r(4726);
          e.exports = function (e, t) {
            var r,
              a,
              i,
              o,
              l = e.cd,
              s = e.xaxis,
              c = e.yaxis,
              u = [],
              f = l[0].trace;
            if (!n.hasMarkers(f) && !n.hasText(f)) return [];
            if (!1 === t) for (r = 0; r < l.length; r++) l[r].selected = 0;else for (r = 0; r < l.length; r++) a = l[r], i = s.c2p(a.x), o = c.c2p(a.y), null !== a.i && t.contains([i, o], !1, r, e) ? (u.push({
              pointNumber: a.i,
              x: s.c2d(a.x),
              y: c.c2d(a.y)
            }), a.selected = 1) : a.selected = 0;
            return u;
          };
        },
        382: function (e) {
          "use strict";

          var t = ["orientation", "groupnorm", "stackgaps"];
          e.exports = function (e, r, n, a) {
            var i = n._scatterStackOpts,
              o = a("stackgroup");
            if (o) {
              var l = r.xaxis + r.yaxis,
                s = i[l];
              s || (s = i[l] = {});
              var c = s[o],
                u = !1;
              c ? c.traces.push(r) : (c = s[o] = {
                traceIndices: [],
                traces: [r]
              }, u = !0);
              for (var f = {
                  orientation: r.x && !r.y ? "h" : "v"
                }, d = 0; d < t.length; d++) {
                var h = t[d],
                  p = h + "Found";
                if (!c[p]) {
                  var v = void 0 !== e[h],
                    g = "orientation" === h;
                  if ((v || u) && (c[h] = a(h, f[h]), g && (c.fillDflt = "h" === c[h] ? "tonextx" : "tonexty"), v && (c[p] = !0, !u && (delete c.traces[0][h], g)))) for (var m = 0; m < c.traces.length - 1; m++) {
                    var y = c.traces[m];
                    y._input.fill !== y.fill && (y.fill = c.fillDflt);
                  }
                }
              }
              return c;
            }
          };
        },
        9408: function (e, t, r) {
          "use strict";

          var n = r(5568),
            a = r(2203),
            i = r(3626);
          function o(e, t, r) {
            a.pointStyle(e.selectAll("path.point"), t, r);
          }
          function l(e, t, r) {
            a.textPointStyle(e.selectAll("text"), t, r);
          }
          e.exports = {
            style: function (e) {
              var t = n.select(e).selectAll("g.trace.scatter");
              t.style("opacity", function (e) {
                return e[0].trace.opacity;
              }), t.selectAll("g.points").each(function (t) {
                o(n.select(this), t.trace || t[0].trace, e);
              }), t.selectAll("g.text").each(function (t) {
                l(n.select(this), t.trace || t[0].trace, e);
              }), t.selectAll("g.trace path.js-line").call(a.lineGroupStyle), t.selectAll("g.trace path.js-fill").call(a.fillGroupStyle, e, !1), i.getComponentMethod("errorbars", "style")(t);
            },
            stylePoints: o,
            styleText: l,
            styleOnSelect: function (e, t, r) {
              var n = t[0].trace;
              n.selectedpoints ? (a.selectedPointStyle(r.selectAll("path.point"), n), a.selectedTextStyle(r.selectAll("text"), n)) : (o(r, n, e), l(r, n, e));
            }
          };
        },
        4726: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(7800).isTypedArraySpec;
          e.exports = {
            hasLines: function (e) {
              return e.visible && e.mode && -1 !== e.mode.indexOf("lines");
            },
            hasMarkers: function (e) {
              return e.visible && (e.mode && -1 !== e.mode.indexOf("markers") || "splom" === e.type);
            },
            hasText: function (e) {
              return e.visible && e.mode && -1 !== e.mode.indexOf("text");
            },
            isBubble: function (e) {
              var t = e.marker;
              return n.isPlainObject(t) && (n.isArrayOrTypedArray(t.size) || a(t.size));
            }
          };
        },
        663: function (e, t, r) {
          "use strict";

          var n = r(4809);
          e.exports = function (e, t, r, a, i) {
            i = i || {}, a("textposition"), n.coerceFont(a, "textfont", i.font || r.font, i), i.noSelect || (a("selected.textfont.color"), a("unselected.textfont.color"));
          };
        },
        9867: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(3626);
          e.exports = function (e, t, r, i) {
            var o,
              l = i("x"),
              s = i("y");
            if (a.getComponentMethod("calendars", "handleTraceDefaults")(e, t, ["x", "y"], r), l) {
              var c = n.minRowLength(l);
              s ? o = Math.min(c, n.minRowLength(s)) : (o = c, i("y0"), i("dy"));
            } else {
              if (!s) return 0;
              o = n.minRowLength(s), i("x0"), i("dx");
            }
            return t._length = o, o;
          };
        },
        7908: function (e, t, r) {
          "use strict";

          var n = r(9714),
            a = r(4809),
            i = r(7297),
            o = r(5086).z,
            l = r(3821).BADNUM;
          t.moduleType = "transform", t.name = "aggregate";
          var s = t.attributes = {
              enabled: {
                valType: "boolean",
                dflt: !0,
                editType: "calc"
              },
              groups: {
                valType: "string",
                strict: !0,
                noBlank: !0,
                arrayOk: !0,
                dflt: "x",
                editType: "calc"
              },
              aggregations: {
                _isLinkedToArray: "aggregation",
                target: {
                  valType: "string",
                  editType: "calc"
                },
                func: {
                  valType: "enumerated",
                  values: ["count", "sum", "avg", "median", "mode", "rms", "stddev", "min", "max", "first", "last", "change", "range"],
                  dflt: "first",
                  editType: "calc"
                },
                funcmode: {
                  valType: "enumerated",
                  values: ["sample", "population"],
                  dflt: "sample",
                  editType: "calc"
                },
                enabled: {
                  valType: "boolean",
                  dflt: !0,
                  editType: "calc"
                },
                editType: "calc"
              },
              editType: "calc"
            },
            c = s.aggregations;
          function u(e, t, r, i) {
            if (i.enabled) {
              for (var o = i.target, s = a.nestedProperty(t, o), c = s.get(), u = function (e, t) {
                  var r = e.func,
                    n = t.d2c,
                    i = t.c2d;
                  switch (r) {
                    case "count":
                      return f;
                    case "first":
                      return d;
                    case "last":
                      return h;
                    case "sum":
                      return function (e, t) {
                        for (var r = 0, a = 0; a < t.length; a++) {
                          var o = n(e[t[a]]);
                          o !== l && (r += o);
                        }
                        return i(r);
                      };
                    case "avg":
                      return function (e, t) {
                        for (var r = 0, a = 0, o = 0; o < t.length; o++) {
                          var s = n(e[t[o]]);
                          s !== l && (r += s, a++);
                        }
                        return a ? i(r / a) : l;
                      };
                    case "min":
                      return function (e, t) {
                        for (var r = 1 / 0, a = 0; a < t.length; a++) {
                          var o = n(e[t[a]]);
                          o !== l && (r = Math.min(r, o));
                        }
                        return r === 1 / 0 ? l : i(r);
                      };
                    case "max":
                      return function (e, t) {
                        for (var r = -1 / 0, a = 0; a < t.length; a++) {
                          var o = n(e[t[a]]);
                          o !== l && (r = Math.max(r, o));
                        }
                        return r === -1 / 0 ? l : i(r);
                      };
                    case "range":
                      return function (e, t) {
                        for (var r = 1 / 0, a = -1 / 0, o = 0; o < t.length; o++) {
                          var s = n(e[t[o]]);
                          s !== l && (r = Math.min(r, s), a = Math.max(a, s));
                        }
                        return a === -1 / 0 || r === 1 / 0 ? l : i(a - r);
                      };
                    case "change":
                      return function (e, t) {
                        var r = n(e[t[0]]),
                          a = n(e[t[t.length - 1]]);
                        return r === l || a === l ? l : i(a - r);
                      };
                    case "median":
                      return function (e, t) {
                        for (var r = [], o = 0; o < t.length; o++) {
                          var s = n(e[t[o]]);
                          s !== l && r.push(s);
                        }
                        if (!r.length) return l;
                        r.sort(a.sorterAsc);
                        var c = (r.length - 1) / 2;
                        return i((r[Math.floor(c)] + r[Math.ceil(c)]) / 2);
                      };
                    case "mode":
                      return function (e, t) {
                        for (var r = {}, a = 0, o = l, s = 0; s < t.length; s++) {
                          var c = n(e[t[s]]);
                          if (c !== l) {
                            var u = r[c] = (r[c] || 0) + 1;
                            u > a && (a = u, o = c);
                          }
                        }
                        return a ? i(o) : l;
                      };
                    case "rms":
                      return function (e, t) {
                        for (var r = 0, a = 0, o = 0; o < t.length; o++) {
                          var s = n(e[t[o]]);
                          s !== l && (r += s * s, a++);
                        }
                        return a ? i(Math.sqrt(r / a)) : l;
                      };
                    case "stddev":
                      return function (t, r) {
                        var a,
                          i = 0,
                          o = 0,
                          s = 1,
                          c = l;
                        for (a = 0; a < r.length && c === l; a++) c = n(t[r[a]]);
                        if (c === l) return l;
                        for (; a < r.length; a++) {
                          var u = n(t[r[a]]);
                          if (u !== l) {
                            var f = u - c;
                            i += f, o += f * f, s++;
                          }
                        }
                        var d = "sample" === e.funcmode ? s - 1 : s;
                        return d ? Math.sqrt((o - i * i / s) / d) : 0;
                      };
                  }
                }(i, n.getDataConversions(e, t, o, c)), p = new Array(r.length), v = 0; v < r.length; v++) p[v] = u(c, r[v]);
              s.set(p), "count" === i.func && a.pushUnique(t._arrayAttrs, o);
            }
          }
          function f(e, t) {
            return t.length;
          }
          function d(e, t) {
            return e[t[0]];
          }
          function h(e, t) {
            return e[t[t.length - 1]];
          }
          t.supplyDefaults = function (e, t) {
            var r,
              n = {};
            function o(t, r) {
              return a.coerce(e, n, s, t, r);
            }
            if (!o("enabled")) return n;
            var l = i.findArrayAttributes(t),
              u = {};
            for (r = 0; r < l.length; r++) u[l[r]] = 1;
            var f = o("groups");
            if (!Array.isArray(f)) {
              if (!u[f]) return n.enabled = !1, n;
              u[f] = 0;
            }
            var d,
              h = e.aggregations || [],
              p = n.aggregations = new Array(h.length);
            function v(e, t) {
              return a.coerce(h[r], d, c, e, t);
            }
            for (r = 0; r < h.length; r++) {
              d = {
                _index: r
              };
              var g = v("target"),
                m = v("func");
              v("enabled") && g && (u[g] || "count" === m && void 0 === u[g]) ? ("stddev" === m && v("funcmode"), u[g] = 0, p[r] = d) : p[r] = {
                enabled: !1,
                _index: r
              };
            }
            for (r = 0; r < l.length; r++) u[l[r]] && p.push({
              target: l[r],
              func: c.func.dflt,
              enabled: !0,
              _index: -1
            });
            return n;
          }, t.calcTransform = function (e, t, r) {
            if (r.enabled) {
              var n = r.groups,
                i = a.getTargetArray(t, {
                  target: n
                });
              if (i) {
                var l,
                  s,
                  c,
                  f,
                  d = {},
                  h = {},
                  p = [],
                  v = o(t.transforms, r),
                  g = i.length;
                for (t._length && (g = Math.min(g, t._length)), l = 0; l < g; l++) void 0 === (c = d[s = i[l]]) ? (d[s] = p.length, f = [l], p.push(f), h[d[s]] = v(l)) : (p[c].push(l), h[d[s]] = (h[d[s]] || []).concat(v(l)));
                r._indexToPoints = h;
                var m = r.aggregations;
                for (l = 0; l < m.length; l++) u(e, t, p, m[l]);
                "string" == typeof n && u(e, t, p, {
                  target: n,
                  func: "first",
                  enabled: !0
                }), t._length = p.length;
              }
            }
          };
        },
        2849: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(3626),
            i = r(9714),
            o = r(5086).z,
            l = r(726),
            s = l.COMPARISON_OPS,
            c = l.INTERVAL_OPS,
            u = l.SET_OPS;
          t.moduleType = "transform", t.name = "filter", t.attributes = {
            enabled: {
              valType: "boolean",
              dflt: !0,
              editType: "calc"
            },
            target: {
              valType: "string",
              strict: !0,
              noBlank: !0,
              arrayOk: !0,
              dflt: "x",
              editType: "calc"
            },
            operation: {
              valType: "enumerated",
              values: [].concat(s).concat(c).concat(u),
              dflt: "=",
              editType: "calc"
            },
            value: {
              valType: "any",
              dflt: 0,
              editType: "calc"
            },
            preservegaps: {
              valType: "boolean",
              dflt: !1,
              editType: "calc"
            },
            editType: "calc"
          }, t.supplyDefaults = function (e) {
            var r = {};
            function i(a, i) {
              return n.coerce(e, r, t.attributes, a, i);
            }
            if (i("enabled")) {
              var o = i("target");
              if (n.isArrayOrTypedArray(o) && 0 === o.length) return r.enabled = !1, r;
              i("preservegaps"), i("operation"), i("value");
              var l = a.getComponentMethod("calendars", "handleDefaults");
              l(e, r, "valuecalendar", null), l(e, r, "targetcalendar", null);
            }
            return r;
          }, t.calcTransform = function (e, t, r) {
            if (r.enabled) {
              var a = n.getTargetArray(t, r);
              if (a) {
                var l = r.target,
                  f = a.length;
                t._length && (f = Math.min(f, t._length));
                var d = r.targetcalendar,
                  h = t._arrayAttrs,
                  p = r.preservegaps;
                if ("string" == typeof l) {
                  var v = n.nestedProperty(t, l + "calendar").get();
                  v && (d = v);
                }
                var g,
                  m,
                  y = function (e, t, r) {
                    var a = e.operation,
                      i = e.value,
                      o = n.isArrayOrTypedArray(i);
                    function l(e) {
                      return -1 !== e.indexOf(a);
                    }
                    var f,
                      d = function (r) {
                        return t(r, 0, e.valuecalendar);
                      },
                      h = function (e) {
                        return t(e, 0, r);
                      };
                    switch (l(s) ? f = d(o ? i[0] : i) : l(c) ? f = o ? [d(i[0]), d(i[1])] : [d(i), d(i)] : l(u) && (f = o ? i.map(d) : [d(i)]), a) {
                      case "=":
                        return function (e) {
                          return h(e) === f;
                        };
                      case "!=":
                        return function (e) {
                          return h(e) !== f;
                        };
                      case "<":
                        return function (e) {
                          return h(e) < f;
                        };
                      case "<=":
                        return function (e) {
                          return h(e) <= f;
                        };
                      case ">":
                        return function (e) {
                          return h(e) > f;
                        };
                      case ">=":
                        return function (e) {
                          return h(e) >= f;
                        };
                      case "[]":
                        return function (e) {
                          var t = h(e);
                          return t >= f[0] && t <= f[1];
                        };
                      case "()":
                        return function (e) {
                          var t = h(e);
                          return t > f[0] && t < f[1];
                        };
                      case "[)":
                        return function (e) {
                          var t = h(e);
                          return t >= f[0] && t < f[1];
                        };
                      case "(]":
                        return function (e) {
                          var t = h(e);
                          return t > f[0] && t <= f[1];
                        };
                      case "][":
                        return function (e) {
                          var t = h(e);
                          return t <= f[0] || t >= f[1];
                        };
                      case ")(":
                        return function (e) {
                          var t = h(e);
                          return t < f[0] || t > f[1];
                        };
                      case "](":
                        return function (e) {
                          var t = h(e);
                          return t <= f[0] || t > f[1];
                        };
                      case ")[":
                        return function (e) {
                          var t = h(e);
                          return t < f[0] || t >= f[1];
                        };
                      case "{}":
                        return function (e) {
                          return -1 !== f.indexOf(h(e));
                        };
                      case "}{":
                        return function (e) {
                          return -1 === f.indexOf(h(e));
                        };
                    }
                  }(r, i.getDataToCoordFunc(e, t, l, a), d),
                  x = {},
                  b = {},
                  _ = 0;
                p ? (g = function (e) {
                  x[e.astr] = n.extendDeep([], e.get()), e.set(new Array(f));
                }, m = function (e, t) {
                  var r = x[e.astr][t];
                  e.get()[t] = r;
                }) : (g = function (e) {
                  x[e.astr] = n.extendDeep([], e.get()), e.set([]);
                }, m = function (e, t) {
                  var r = x[e.astr][t];
                  e.get().push(r);
                }), M(g);
                for (var w = o(t.transforms, r), T = 0; T < f; T++) y(a[T]) ? (M(m, T), b[_++] = w(T)) : p && _++;
                r._indexToPoints = b, t._length = _;
              }
            }
            function M(e, r) {
              for (var a = 0; a < h.length; a++) e(n.nestedProperty(t, h[a]), r);
            }
          };
        },
        453: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(7297),
            i = r(4122),
            o = r(5086).z;
          function l(e, t) {
            var r,
              l,
              s,
              c,
              u,
              f,
              d,
              h,
              p,
              v,
              g = t.transform,
              m = t.transformIndex,
              y = e.transforms[m].groups,
              x = o(e.transforms, g);
            if (!n.isArrayOrTypedArray(y) || 0 === y.length) return [e];
            var b = n.filterUnique(y),
              _ = new Array(b.length),
              w = y.length,
              T = a.findArrayAttributes(e),
              M = g.styles || [],
              k = {};
            for (r = 0; r < M.length; r++) k[M[r].target] = M[r].value;
            g.styles && (v = n.keyedContainer(g, "styles", "target", "value.name"));
            var A = {},
              L = {};
            for (r = 0; r < b.length; r++) {
              A[f = b[r]] = r, L[f] = 0, (d = _[r] = n.extendDeepNoArrays({}, e))._group = f, d.transforms[m]._indexToPoints = {};
              var S = null;
              for (v && (S = v.get(f)), d.name = S || "" === S ? S : n.templateString(g.nameformat, {
                trace: e.name,
                group: f
              }), h = d.transforms, d.transforms = [], l = 0; l < h.length; l++) d.transforms[l] = n.extendDeepNoArrays({}, h[l]);
              for (l = 0; l < T.length; l++) n.nestedProperty(d, T[l]).set([]);
            }
            for (s = 0; s < T.length; s++) {
              for (c = T[s], l = 0, p = []; l < b.length; l++) p[l] = n.nestedProperty(_[l], c).get();
              for (u = n.nestedProperty(e, c).get(), l = 0; l < w; l++) p[A[y[l]]].push(u[l]);
            }
            for (l = 0; l < w; l++) (d = _[A[y[l]]]).transforms[m]._indexToPoints[L[y[l]]] = x(l), L[y[l]]++;
            for (r = 0; r < b.length; r++) f = b[r], d = _[r], i.clearExpandedTraceDefaultColors(d), d = n.extendDeepNoArrays(d, k[f] || {});
            return _;
          }
          t.moduleType = "transform", t.name = "groupby", t.attributes = {
            enabled: {
              valType: "boolean",
              dflt: !0,
              editType: "calc"
            },
            groups: {
              valType: "data_array",
              dflt: [],
              editType: "calc"
            },
            nameformat: {
              valType: "string",
              editType: "calc"
            },
            styles: {
              _isLinkedToArray: "style",
              target: {
                valType: "string",
                editType: "calc"
              },
              value: {
                valType: "any",
                dflt: {},
                editType: "calc",
                _compareAsJSON: !0
              },
              editType: "calc"
            },
            editType: "calc"
          }, t.supplyDefaults = function (e, r, a) {
            var i,
              o = {};
            function l(r, a) {
              return n.coerce(e, o, t.attributes, r, a);
            }
            if (!l("enabled")) return o;
            l("groups"), l("nameformat", a._dataLength > 1 ? "%{group} (%{trace})" : "%{group}");
            var s = e.styles,
              c = o.styles = [];
            if (s) for (i = 0; i < s.length; i++) {
              var u = c[i] = {};
              n.coerce(s[i], c[i], t.attributes.styles, "target");
              var f = n.coerce(s[i], c[i], t.attributes.styles, "value");
              n.isPlainObject(f) ? u.value = n.extendDeep({}, f) : f && delete u.value;
            }
            return o;
          }, t.transform = function (e, t) {
            var r,
              n,
              a,
              i = [];
            for (n = 0; n < e.length; n++) for (r = l(e[n], t), a = 0; a < r.length; a++) i.push(r[a]);
            return i;
          };
        },
        5086: function (e, t) {
          "use strict";

          t.z = function (e, t) {
            for (var r, n, a = 0; a < e.length && (r = e[a]) !== t; a++) r._indexToPoints && !1 !== r.enabled && (n = r._indexToPoints);
            var i = n ? function (e) {
              return n[e];
            } : function (e) {
              return [e];
            };
            return i;
          };
        },
        9855: function (e, t, r) {
          "use strict";

          var n = r(4809),
            a = r(9714),
            i = r(5086).z,
            o = r(3821).BADNUM;
          t.moduleType = "transform", t.name = "sort", t.attributes = {
            enabled: {
              valType: "boolean",
              dflt: !0,
              editType: "calc"
            },
            target: {
              valType: "string",
              strict: !0,
              noBlank: !0,
              arrayOk: !0,
              dflt: "x",
              editType: "calc"
            },
            order: {
              valType: "enumerated",
              values: ["ascending", "descending"],
              dflt: "ascending",
              editType: "calc"
            },
            editType: "calc"
          }, t.supplyDefaults = function (e) {
            var r = {};
            function a(a, i) {
              return n.coerce(e, r, t.attributes, a, i);
            }
            return a("enabled") && (a("target"), a("order")), r;
          }, t.calcTransform = function (e, t, r) {
            if (r.enabled) {
              var l = n.getTargetArray(t, r);
              if (l) {
                var s = r.target,
                  c = l.length;
                t._length && (c = Math.min(c, t._length));
                var u,
                  f,
                  d = t._arrayAttrs,
                  h = function (e, t, r, n) {
                    var a,
                      i = new Array(n),
                      l = new Array(n);
                    for (a = 0; a < n; a++) i[a] = {
                      v: t[a],
                      i: a
                    };
                    for (i.sort(function (e, t) {
                      switch (e.order) {
                        case "ascending":
                          return function (e, r) {
                            var n = t(e.v),
                              a = t(r.v);
                            return n === o ? 1 : a === o ? -1 : n - a;
                          };
                        case "descending":
                          return function (e, r) {
                            var n = t(e.v),
                              a = t(r.v);
                            return n === o ? 1 : a === o ? -1 : a - n;
                          };
                      }
                    }(e, r)), a = 0; a < n; a++) l[a] = i[a].i;
                    return l;
                  }(r, l, a.getDataToCoordFunc(e, t, s, l), c),
                  p = i(t.transforms, r),
                  v = {};
                for (u = 0; u < d.length; u++) {
                  var g = n.nestedProperty(t, d[u]),
                    m = g.get(),
                    y = new Array(c);
                  for (f = 0; f < c; f++) y[f] = m[h[f]];
                  g.set(y);
                }
                for (f = 0; f < c; f++) v[f] = p(h[f]);
                r._indexToPoints = v, t._length = c;
              }
            }
          };
        },
        9697: function (e, t) {
          "use strict";

          t.version = "2.35.2";
        },
        3087: function (e) {
          "use strict";

          e.exports = a, e.exports.isMobile = a, e.exports.default = a;
          var t = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
            r = /CrOS/,
            n = /android|ipad|playbook|silk/i;
          function a(e) {
            e || (e = {});
            var a = e.ua;
            if (a || "undefined" == typeof navigator || (a = navigator.userAgent), a && a.headers && "string" == typeof a.headers["user-agent"] && (a = a.headers["user-agent"]), "string" != typeof a) return !1;
            var i = t.test(a) && !r.test(a) || !!e.tablet && n.test(a);
            return !i && e.tablet && e.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== a.indexOf("Macintosh") && -1 !== a.indexOf("Safari") && (i = !0), i;
          }
        },
        5955: function (e, t, r) {
          "use strict";

          var n = r(2413),
            a = r.n(n),
            i = r(1070),
            o = r.n(i),
            l = r(2133),
            s = r.n(l),
            c = new URL(r(7035), r.b),
            u = new URL(r(3470), r.b),
            f = new URL(r(8164), r.b),
            d = new URL(r(4665), r.b),
            h = new URL(r(4890), r.b),
            p = new URL(r(3363), r.b),
            v = new URL(r(3490), r.b),
            g = new URL(r(7603), r.b),
            m = new URL(r(3913), r.b),
            y = new URL(r(1413), r.b),
            x = new URL(r(4643), r.b),
            b = new URL(r(216), r.b),
            _ = new URL(r(1907), r.b),
            w = new URL(r(8605), r.b),
            T = new URL(r(5446), r.b),
            M = new URL(r(6694), r.b),
            k = new URL(r(4420), r.b),
            A = new URL(r(5796), r.b),
            L = new URL(r(2228), r.b),
            S = new URL(r(9819), r.b),
            C = new URL(r(7695), r.b),
            O = new URL(r(8869), r.b),
            D = new URL(r(557), r.b),
            P = new URL(r(8460), r.b),
            z = new URL(r(8920), r.b),
            I = new URL(r(3737), r.b),
            E = new URL(r(7914), r.b),
            R = new URL(r(6117), r.b),
            N = new URL(r(6311), r.b),
            F = o()(a()),
            H = s()(c),
            B = s()(u),
            j = s()(f),
            Y = s()(d),
            V = s()(h),
            U = s()(p),
            q = s()(v),
            G = s()(g),
            Z = s()(m),
            W = s()(y),
            J = s()(x),
            X = s()(b),
            K = s()(_),
            Q = s()(w),
            $ = s()(T),
            ee = s()(M),
            te = s()(k),
            re = s()(A),
            ne = s()(L),
            ae = s()(S),
            ie = s()(C),
            oe = s()(O),
            le = s()(D),
            se = s()(P),
            ce = s()(z),
            ue = s()(I),
            fe = s()(E),
            de = s()(R),
            he = s()(N);
          F.push([e.id, ".maplibregl-map{font:12px/20px Helvetica Neue,Arial,Helvetica,sans-serif;overflow:hidden;position:relative;-webkit-tap-highlight-color:rgb(0 0 0/0)}.maplibregl-canvas{left:0;position:absolute;top:0}.maplibregl-map:fullscreen{height:100%;width:100%}.maplibregl-ctrl-group button.maplibregl-ctrl-compass{touch-action:none}.maplibregl-canvas-container.maplibregl-interactive,.maplibregl-ctrl-group button.maplibregl-ctrl-compass{cursor:grab;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-canvas-container.maplibregl-interactive.maplibregl-track-pointer{cursor:pointer}.maplibregl-canvas-container.maplibregl-interactive:active,.maplibregl-ctrl-group button.maplibregl-ctrl-compass:active{cursor:grabbing}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-canvas-container.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:pinch-zoom}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:none}.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures,.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-ctrl-bottom-left,.maplibregl-ctrl-bottom-right,.maplibregl-ctrl-top-left,.maplibregl-ctrl-top-right{pointer-events:none;position:absolute;z-index:2}.maplibregl-ctrl-top-left{left:0;top:0}.maplibregl-ctrl-top-right{right:0;top:0}.maplibregl-ctrl-bottom-left{bottom:0;left:0}.maplibregl-ctrl-bottom-right{bottom:0;right:0}.maplibregl-ctrl{clear:both;pointer-events:auto;transform:translate(0)}.maplibregl-ctrl-top-left .maplibregl-ctrl{float:left;margin:10px 0 0 10px}.maplibregl-ctrl-top-right .maplibregl-ctrl{float:right;margin:10px 10px 0 0}.maplibregl-ctrl-bottom-left .maplibregl-ctrl{float:left;margin:0 0 10px 10px}.maplibregl-ctrl-bottom-right .maplibregl-ctrl{float:right;margin:0 10px 10px 0}.maplibregl-ctrl-group{background:#fff;border-radius:4px}.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px rgba(0,0,0,.1)}@media (forced-colors:active){.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px ButtonText}}.maplibregl-ctrl-group button{background-color:transparent;border:0;box-sizing:border-box;cursor:pointer;display:block;height:29px;outline:none;padding:0;width:29px}.maplibregl-ctrl-group button+button{border-top:1px solid #ddd}.maplibregl-ctrl button .maplibregl-ctrl-icon{background-position:50%;background-repeat:no-repeat;display:block;height:100%;width:100%}@media (forced-colors:active){.maplibregl-ctrl-icon{background-color:transparent}.maplibregl-ctrl-group button+button{border-top:1px solid ButtonText}}.maplibregl-ctrl button::-moz-focus-inner{border:0;padding:0}.maplibregl-ctrl-attrib-button:focus,.maplibregl-ctrl-group button:focus{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl button:disabled{cursor:not-allowed}.maplibregl-ctrl button:disabled .maplibregl-ctrl-icon{opacity:.25}.maplibregl-ctrl button:not(:disabled):hover{background-color:rgb(0 0 0/5%)}.maplibregl-ctrl-group button:focus:focus-visible{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl-group button:focus:not(:focus-visible){box-shadow:none}.maplibregl-ctrl-group button:focus:first-child{border-radius:4px 4px 0 0}.maplibregl-ctrl-group button:focus:last-child{border-radius:0 0 4px 4px}.maplibregl-ctrl-group button:focus:only-child{border-radius:inherit}.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url(" + H + ")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url(" + B + ")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url(" + j + ")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url(" + Y + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url(" + V + ")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url(" + U + ")}}.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url(" + q + ")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url(" + G + ")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url(" + Z + ")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url(" + W + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url(" + J + ")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url(" + G + ")}}.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url(" + X + ")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url(" + K + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url(" + Q + ")}}.maplibregl-ctrl button.maplibregl-ctrl-terrain .maplibregl-ctrl-icon{background-image:url(" + $ + ")}.maplibregl-ctrl button.maplibregl-ctrl-terrain-enabled .maplibregl-ctrl-icon{background-image:url(" + ee + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url(" + te + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url(" + re + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url(" + ne + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url(" + ae + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url(" + ie + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url(" + oe + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-waiting .maplibregl-ctrl-icon{animation:maplibregl-spin 2s linear infinite}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url(" + le + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url(" + se + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url(" + ne + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url(" + ae + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url(" + ie + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url(" + oe + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url(" + ce + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url(" + ue + ")}}@keyframes maplibregl-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}a.maplibregl-ctrl-logo{background-image:url(" + fe + ");background-repeat:no-repeat;cursor:pointer;display:block;height:23px;margin:0 0 -4px -4px;overflow:hidden;width:88px}a.maplibregl-ctrl-logo.maplibregl-compact{width:14px}@media (forced-colors:active){a.maplibregl-ctrl-logo{background-color:transparent;background-image:url(" + fe + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){a.maplibregl-ctrl-logo{background-image:url(" + fe + ")}}.maplibregl-ctrl.maplibregl-ctrl-attrib{background-color:hsla(0,0%,100%,.5);margin:0;padding:0 5px}@media screen{.maplibregl-ctrl-attrib.maplibregl-compact{background-color:#fff;border-radius:12px;box-sizing:content-box;color:#000;margin:10px;min-height:20px;padding:2px 24px 2px 0;position:relative}.maplibregl-ctrl-attrib.maplibregl-compact-show{padding:2px 28px 2px 8px;visibility:visible}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact-show,.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact-show{border-radius:12px;padding:2px 8px 2px 28px}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-inner{display:none}.maplibregl-ctrl-attrib-button{background-color:hsla(0,0%,100%,.5);background-image:url(" + de + ");border:0;border-radius:12px;box-sizing:border-box;cursor:pointer;display:none;height:24px;outline:none;position:absolute;right:0;top:0;width:24px}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;list-style:none}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button::-webkit-details-marker{display:none}.maplibregl-ctrl-bottom-left .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-top-left .maplibregl-ctrl-attrib-button{left:0}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-inner{display:block}.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-button{background-color:rgb(0 0 0/5%)}.maplibregl-ctrl-bottom-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;right:0}.maplibregl-ctrl-top-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{right:0;top:0}.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{left:0;top:0}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;left:0}}@media screen and (forced-colors:active){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url(" + he + ")}}@media screen and (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url(" + de + ')}}.maplibregl-ctrl-attrib a{color:rgba(0,0,0,.75);text-decoration:none}.maplibregl-ctrl-attrib a:hover{color:inherit;text-decoration:underline}.maplibregl-attrib-empty{display:none}.maplibregl-ctrl-scale{background-color:hsla(0,0%,100%,.75);border:2px solid #333;border-top:#333;box-sizing:border-box;color:#333;font-size:10px;padding:0 5px}.maplibregl-popup{display:flex;left:0;pointer-events:none;position:absolute;top:0;will-change:transform}.maplibregl-popup-anchor-top,.maplibregl-popup-anchor-top-left,.maplibregl-popup-anchor-top-right{flex-direction:column}.maplibregl-popup-anchor-bottom,.maplibregl-popup-anchor-bottom-left,.maplibregl-popup-anchor-bottom-right{flex-direction:column-reverse}.maplibregl-popup-anchor-left{flex-direction:row}.maplibregl-popup-anchor-right{flex-direction:row-reverse}.maplibregl-popup-tip{border:10px solid transparent;height:0;width:0;z-index:1}.maplibregl-popup-anchor-top .maplibregl-popup-tip{align-self:center;border-bottom-color:#fff;border-top:none}.maplibregl-popup-anchor-top-left .maplibregl-popup-tip{align-self:flex-start;border-bottom-color:#fff;border-left:none;border-top:none}.maplibregl-popup-anchor-top-right .maplibregl-popup-tip{align-self:flex-end;border-bottom-color:#fff;border-right:none;border-top:none}.maplibregl-popup-anchor-bottom .maplibregl-popup-tip{align-self:center;border-bottom:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip{align-self:flex-start;border-bottom:none;border-left:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip{align-self:flex-end;border-bottom:none;border-right:none;border-top-color:#fff}.maplibregl-popup-anchor-left .maplibregl-popup-tip{align-self:center;border-left:none;border-right-color:#fff}.maplibregl-popup-anchor-right .maplibregl-popup-tip{align-self:center;border-left-color:#fff;border-right:none}.maplibregl-popup-close-button{background-color:transparent;border:0;border-radius:0 3px 0 0;cursor:pointer;position:absolute;right:0;top:0}.maplibregl-popup-close-button:hover{background-color:rgb(0 0 0/5%)}.maplibregl-popup-content{background:#fff;border-radius:3px;box-shadow:0 1px 2px rgba(0,0,0,.1);padding:15px 10px;pointer-events:auto;position:relative}.maplibregl-popup-anchor-top-left .maplibregl-popup-content{border-top-left-radius:0}.maplibregl-popup-anchor-top-right .maplibregl-popup-content{border-top-right-radius:0}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-content{border-bottom-left-radius:0}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-content{border-bottom-right-radius:0}.maplibregl-popup-track-pointer{display:none}.maplibregl-popup-track-pointer *{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-map:hover .maplibregl-popup-track-pointer{display:flex}.maplibregl-map:active .maplibregl-popup-track-pointer{display:none}.maplibregl-marker{left:0;position:absolute;top:0;transition:opacity .2s;will-change:transform}.maplibregl-user-location-dot,.maplibregl-user-location-dot:before{background-color:#1da1f2;border-radius:50%;height:15px;width:15px}.maplibregl-user-location-dot:before{animation:maplibregl-user-location-dot-pulse 2s infinite;content:"";position:absolute}.maplibregl-user-location-dot:after{border:2px solid #fff;border-radius:50%;box-shadow:0 0 3px rgba(0,0,0,.35);box-sizing:border-box;content:"";height:19px;left:-2px;position:absolute;top:-2px;width:19px}@keyframes maplibregl-user-location-dot-pulse{0%{opacity:1;transform:scale(1)}70%{opacity:0;transform:scale(3)}to{opacity:0;transform:scale(1)}}.maplibregl-user-location-dot-stale{background-color:#aaa}.maplibregl-user-location-dot-stale:after{display:none}.maplibregl-user-location-accuracy-circle{background-color:#1da1f233;border-radius:100%;height:1px;width:1px}.maplibregl-crosshair,.maplibregl-crosshair .maplibregl-interactive,.maplibregl-crosshair .maplibregl-interactive:active{cursor:crosshair}.maplibregl-boxzoom{background:#fff;border:2px dotted #202020;height:0;left:0;opacity:.5;position:absolute;top:0;width:0}.maplibregl-cooperative-gesture-screen{align-items:center;background:rgba(0,0,0,.4);color:#fff;display:flex;font-size:1.4em;inset:0;justify-content:center;line-height:1.2;opacity:0;padding:1rem;pointer-events:none;position:absolute;transition:opacity 1s ease 1s;z-index:99999}.maplibregl-cooperative-gesture-screen.maplibregl-show{opacity:1;transition:opacity .05s}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:none}@media (hover:none),(width <= 480px){.maplibregl-cooperative-gesture-screen .maplibregl-desktop-message{display:none}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:block}}.maplibregl-pseudo-fullscreen{height:100%!important;left:0!important;position:fixed!important;top:0!important;width:100%!important;z-index:99999}', ""]), t.A = F;
        },
        5568: function (e, t, r) {
          var n, a;
          (function () {
            var i = {
                version: "3.8.2"
              },
              o = [].slice,
              l = function (e) {
                return o.call(e);
              },
              s = self.document;
            function c(e) {
              return e && (e.ownerDocument || e.document || e).documentElement;
            }
            function u(e) {
              return e && (e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView);
            }
            if (s) try {
              l(s.documentElement.childNodes)[0].nodeType;
            } catch (e) {
              l = function (e) {
                for (var t = e.length, r = new Array(t); t--;) r[t] = e[t];
                return r;
              };
            }
            if (Date.now || (Date.now = function () {
              return +new Date();
            }), s) try {
              s.createElement("DIV").style.setProperty("opacity", 0, "");
            } catch (e) {
              var f = this.Element.prototype,
                d = f.setAttribute,
                h = f.setAttributeNS,
                p = this.CSSStyleDeclaration.prototype,
                v = p.setProperty;
              f.setAttribute = function (e, t) {
                d.call(this, e, t + "");
              }, f.setAttributeNS = function (e, t, r) {
                h.call(this, e, t, r + "");
              }, p.setProperty = function (e, t, r) {
                v.call(this, e, t + "", r);
              };
            }
            function g(e, t) {
              return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
            }
            function m(e) {
              return null === e ? NaN : +e;
            }
            function y(e) {
              return !isNaN(e);
            }
            function x(e) {
              return {
                left: function (t, r, n, a) {
                  for (arguments.length < 3 && (n = 0), arguments.length < 4 && (a = t.length); n < a;) {
                    var i = n + a >>> 1;
                    e(t[i], r) < 0 ? n = i + 1 : a = i;
                  }
                  return n;
                },
                right: function (t, r, n, a) {
                  for (arguments.length < 3 && (n = 0), arguments.length < 4 && (a = t.length); n < a;) {
                    var i = n + a >>> 1;
                    e(t[i], r) > 0 ? a = i : n = i + 1;
                  }
                  return n;
                }
              };
            }
            i.ascending = g, i.descending = function (e, t) {
              return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
            }, i.min = function (e, t) {
              var r,
                n,
                a = -1,
                i = e.length;
              if (1 === arguments.length) {
                for (; ++a < i;) if (null != (n = e[a]) && n >= n) {
                  r = n;
                  break;
                }
                for (; ++a < i;) null != (n = e[a]) && r > n && (r = n);
              } else {
                for (; ++a < i;) if (null != (n = t.call(e, e[a], a)) && n >= n) {
                  r = n;
                  break;
                }
                for (; ++a < i;) null != (n = t.call(e, e[a], a)) && r > n && (r = n);
              }
              return r;
            }, i.max = function (e, t) {
              var r,
                n,
                a = -1,
                i = e.length;
              if (1 === arguments.length) {
                for (; ++a < i;) if (null != (n = e[a]) && n >= n) {
                  r = n;
                  break;
                }
                for (; ++a < i;) null != (n = e[a]) && n > r && (r = n);
              } else {
                for (; ++a < i;) if (null != (n = t.call(e, e[a], a)) && n >= n) {
                  r = n;
                  break;
                }
                for (; ++a < i;) null != (n = t.call(e, e[a], a)) && n > r && (r = n);
              }
              return r;
            }, i.extent = function (e, t) {
              var r,
                n,
                a,
                i = -1,
                o = e.length;
              if (1 === arguments.length) {
                for (; ++i < o;) if (null != (n = e[i]) && n >= n) {
                  r = a = n;
                  break;
                }
                for (; ++i < o;) null != (n = e[i]) && (r > n && (r = n), a < n && (a = n));
              } else {
                for (; ++i < o;) if (null != (n = t.call(e, e[i], i)) && n >= n) {
                  r = a = n;
                  break;
                }
                for (; ++i < o;) null != (n = t.call(e, e[i], i)) && (r > n && (r = n), a < n && (a = n));
              }
              return [r, a];
            }, i.sum = function (e, t) {
              var r,
                n = 0,
                a = e.length,
                i = -1;
              if (1 === arguments.length) for (; ++i < a;) y(r = +e[i]) && (n += r);else for (; ++i < a;) y(r = +t.call(e, e[i], i)) && (n += r);
              return n;
            }, i.mean = function (e, t) {
              var r,
                n = 0,
                a = e.length,
                i = -1,
                o = a;
              if (1 === arguments.length) for (; ++i < a;) y(r = m(e[i])) ? n += r : --o;else for (; ++i < a;) y(r = m(t.call(e, e[i], i))) ? n += r : --o;
              if (o) return n / o;
            }, i.quantile = function (e, t) {
              var r = (e.length - 1) * t + 1,
                n = Math.floor(r),
                a = +e[n - 1],
                i = r - n;
              return i ? a + i * (e[n] - a) : a;
            }, i.median = function (e, t) {
              var r,
                n = [],
                a = e.length,
                o = -1;
              if (1 === arguments.length) for (; ++o < a;) y(r = m(e[o])) && n.push(r);else for (; ++o < a;) y(r = m(t.call(e, e[o], o))) && n.push(r);
              if (n.length) return i.quantile(n.sort(g), .5);
            }, i.variance = function (e, t) {
              var r,
                n,
                a = e.length,
                i = 0,
                o = 0,
                l = -1,
                s = 0;
              if (1 === arguments.length) for (; ++l < a;) y(r = m(e[l])) && (o += (n = r - i) * (r - (i += n / ++s)));else for (; ++l < a;) y(r = m(t.call(e, e[l], l))) && (o += (n = r - i) * (r - (i += n / ++s)));
              if (s > 1) return o / (s - 1);
            }, i.deviation = function () {
              var e = i.variance.apply(this, arguments);
              return e ? Math.sqrt(e) : e;
            };
            var b = x(g);
            function _(e) {
              return e.length;
            }
            i.bisectLeft = b.left, i.bisect = i.bisectRight = b.right, i.bisector = function (e) {
              return x(1 === e.length ? function (t, r) {
                return g(e(t), r);
              } : e);
            }, i.shuffle = function (e, t, r) {
              (i = arguments.length) < 3 && (r = e.length, i < 2 && (t = 0));
              for (var n, a, i = r - t; i;) a = Math.random() * i-- | 0, n = e[i + t], e[i + t] = e[a + t], e[a + t] = n;
              return e;
            }, i.permute = function (e, t) {
              for (var r = t.length, n = new Array(r); r--;) n[r] = e[t[r]];
              return n;
            }, i.pairs = function (e) {
              for (var t = 0, r = e.length - 1, n = e[0], a = new Array(r < 0 ? 0 : r); t < r;) a[t] = [n, n = e[++t]];
              return a;
            }, i.transpose = function (e) {
              if (!(a = e.length)) return [];
              for (var t = -1, r = i.min(e, _), n = new Array(r); ++t < r;) for (var a, o = -1, l = n[t] = new Array(a); ++o < a;) l[o] = e[o][t];
              return n;
            }, i.zip = function () {
              return i.transpose(arguments);
            }, i.keys = function (e) {
              var t = [];
              for (var r in e) t.push(r);
              return t;
            }, i.values = function (e) {
              var t = [];
              for (var r in e) t.push(e[r]);
              return t;
            }, i.entries = function (e) {
              var t = [];
              for (var r in e) t.push({
                key: r,
                value: e[r]
              });
              return t;
            }, i.merge = function (e) {
              for (var t, r, n, a = e.length, i = -1, o = 0; ++i < a;) o += e[i].length;
              for (r = new Array(o); --a >= 0;) for (t = (n = e[a]).length; --t >= 0;) r[--o] = n[t];
              return r;
            };
            var w = Math.abs;
            function T(e, t) {
              for (var r in t) Object.defineProperty(e.prototype, r, {
                value: t[r],
                enumerable: !1
              });
            }
            function M() {
              this._ = Object.create(null);
            }
            i.range = function (e, t, r) {
              if (arguments.length < 3 && (r = 1, arguments.length < 2 && (t = e, e = 0)), (t - e) / r == 1 / 0) throw new Error("infinite range");
              var n,
                a = [],
                i = function (e) {
                  for (var t = 1; e * t % 1;) t *= 10;
                  return t;
                }(w(r)),
                o = -1;
              if (e *= i, t *= i, (r *= i) < 0) for (; (n = e + r * ++o) > t;) a.push(n / i);else for (; (n = e + r * ++o) < t;) a.push(n / i);
              return a;
            }, i.map = function (e, t) {
              var r = new M();
              if (e instanceof M) e.forEach(function (e, t) {
                r.set(e, t);
              });else if (Array.isArray(e)) {
                var n,
                  a = -1,
                  i = e.length;
                if (1 === arguments.length) for (; ++a < i;) r.set(a, e[a]);else for (; ++a < i;) r.set(t.call(e, n = e[a], a), n);
              } else for (var o in e) r.set(o, e[o]);
              return r;
            };
            var k = "__proto__",
              A = "\0";
            function L(e) {
              return (e += "") === k || e[0] === A ? A + e : e;
            }
            function S(e) {
              return (e += "")[0] === A ? e.slice(1) : e;
            }
            function C(e) {
              return L(e) in this._;
            }
            function O(e) {
              return (e = L(e)) in this._ && delete this._[e];
            }
            function D() {
              var e = [];
              for (var t in this._) e.push(S(t));
              return e;
            }
            function P() {
              var e = 0;
              for (var t in this._) ++e;
              return e;
            }
            function z() {
              for (var e in this._) return !1;
              return !0;
            }
            function I() {
              this._ = Object.create(null);
            }
            function E(e) {
              return e;
            }
            function R(e, t, r) {
              return function () {
                var n = r.apply(t, arguments);
                return n === t ? e : n;
              };
            }
            function N(e, t) {
              if (t in e) return t;
              t = t.charAt(0).toUpperCase() + t.slice(1);
              for (var r = 0, n = F.length; r < n; ++r) {
                var a = F[r] + t;
                if (a in e) return a;
              }
            }
            T(M, {
              has: C,
              get: function (e) {
                return this._[L(e)];
              },
              set: function (e, t) {
                return this._[L(e)] = t;
              },
              remove: O,
              keys: D,
              values: function () {
                var e = [];
                for (var t in this._) e.push(this._[t]);
                return e;
              },
              entries: function () {
                var e = [];
                for (var t in this._) e.push({
                  key: S(t),
                  value: this._[t]
                });
                return e;
              },
              size: P,
              empty: z,
              forEach: function (e) {
                for (var t in this._) e.call(this, S(t), this._[t]);
              }
            }), i.nest = function () {
              var e,
                t,
                r = {},
                n = [],
                a = [];
              function o(a, i, l) {
                if (l >= n.length) return t ? t.call(r, i) : e ? i.sort(e) : i;
                for (var s, c, u, f, d = -1, h = i.length, p = n[l++], v = new M(); ++d < h;) (f = v.get(s = p(c = i[d]))) ? f.push(c) : v.set(s, [c]);
                return a ? (c = a(), u = function (e, t) {
                  c.set(e, o(a, t, l));
                }) : (c = {}, u = function (e, t) {
                  c[e] = o(a, t, l);
                }), v.forEach(u), c;
              }
              function l(e, t) {
                if (t >= n.length) return e;
                var r = [],
                  i = a[t++];
                return e.forEach(function (e, n) {
                  r.push({
                    key: e,
                    values: l(n, t)
                  });
                }), i ? r.sort(function (e, t) {
                  return i(e.key, t.key);
                }) : r;
              }
              return r.map = function (e, t) {
                return o(t, e, 0);
              }, r.entries = function (e) {
                return l(o(i.map, e, 0), 0);
              }, r.key = function (e) {
                return n.push(e), r;
              }, r.sortKeys = function (e) {
                return a[n.length - 1] = e, r;
              }, r.sortValues = function (t) {
                return e = t, r;
              }, r.rollup = function (e) {
                return t = e, r;
              }, r;
            }, i.set = function (e) {
              var t = new I();
              if (e) for (var r = 0, n = e.length; r < n; ++r) t.add(e[r]);
              return t;
            }, T(I, {
              has: C,
              add: function (e) {
                return this._[L(e += "")] = !0, e;
              },
              remove: O,
              values: D,
              size: P,
              empty: z,
              forEach: function (e) {
                for (var t in this._) e.call(this, S(t));
              }
            }), i.behavior = {}, i.rebind = function (e, t) {
              for (var r, n = 1, a = arguments.length; ++n < a;) e[r = arguments[n]] = R(e, t, t[r]);
              return e;
            };
            var F = ["webkit", "ms", "moz", "Moz", "o", "O"];
            function H() {}
            function B() {}
            function j(e) {
              var t = [],
                r = new M();
              function n() {
                for (var r, n = t, a = -1, i = n.length; ++a < i;) (r = n[a].on) && r.apply(this, arguments);
                return e;
              }
              return n.on = function (n, a) {
                var i,
                  o = r.get(n);
                return arguments.length < 2 ? o && o.on : (o && (o.on = null, t = t.slice(0, i = t.indexOf(o)).concat(t.slice(i + 1)), r.remove(n)), a && t.push(r.set(n, {
                  on: a
                })), e);
              }, n;
            }
            function Y() {
              i.event.preventDefault();
            }
            function V() {
              for (var e, t = i.event; e = t.sourceEvent;) t = e;
              return t;
            }
            function U(e) {
              for (var t = new B(), r = 0, n = arguments.length; ++r < n;) t[arguments[r]] = j(t);
              return t.of = function (r, n) {
                return function (a) {
                  try {
                    var o = a.sourceEvent = i.event;
                    a.target = e, i.event = a, t[a.type].apply(r, n);
                  } finally {
                    i.event = o;
                  }
                };
              }, t;
            }
            i.dispatch = function () {
              for (var e = new B(), t = -1, r = arguments.length; ++t < r;) e[arguments[t]] = j(e);
              return e;
            }, B.prototype.on = function (e, t) {
              var r = e.indexOf("."),
                n = "";
              if (r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), e) return arguments.length < 2 ? this[e].on(n) : this[e].on(n, t);
              if (2 === arguments.length) {
                if (null == t) for (e in this) this.hasOwnProperty(e) && this[e].on(n, null);
                return this;
              }
            }, i.event = null, i.requote = function (e) {
              return e.replace(q, "\\$&");
            };
            var q = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g,
              G = {}.__proto__ ? function (e, t) {
                e.__proto__ = t;
              } : function (e, t) {
                for (var r in t) e[r] = t[r];
              };
            function Z(e) {
              return G(e, K), e;
            }
            var W = function (e, t) {
                return t.querySelector(e);
              },
              J = function (e, t) {
                return t.querySelectorAll(e);
              },
              X = function (e, t) {
                var r = e.matches || e[N(e, "matchesSelector")];
                return X = function (e, t) {
                  return r.call(e, t);
                }, X(e, t);
              };
            "function" == typeof Sizzle && (W = function (e, t) {
              return Sizzle(e, t)[0] || null;
            }, J = Sizzle, X = Sizzle.matchesSelector), i.selection = function () {
              return i.select(s.documentElement);
            };
            var K = i.selection.prototype = [];
            function Q(e) {
              return "function" == typeof e ? e : function () {
                return W(e, this);
              };
            }
            function $(e) {
              return "function" == typeof e ? e : function () {
                return J(e, this);
              };
            }
            K.select = function (e) {
              var t,
                r,
                n,
                a,
                i = [];
              e = Q(e);
              for (var o = -1, l = this.length; ++o < l;) {
                i.push(t = []), t.parentNode = (n = this[o]).parentNode;
                for (var s = -1, c = n.length; ++s < c;) (a = n[s]) ? (t.push(r = e.call(a, a.__data__, s, o)), r && "__data__" in a && (r.__data__ = a.__data__)) : t.push(null);
              }
              return Z(i);
            }, K.selectAll = function (e) {
              var t,
                r,
                n = [];
              e = $(e);
              for (var a = -1, i = this.length; ++a < i;) for (var o = this[a], s = -1, c = o.length; ++s < c;) (r = o[s]) && (n.push(t = l(e.call(r, r.__data__, s, a))), t.parentNode = r);
              return Z(n);
            };
            var ee = "http://www.w3.org/1999/xhtml",
              te = {
                svg: "http://www.w3.org/2000/svg",
                xhtml: ee,
                xlink: "http://www.w3.org/1999/xlink",
                xml: "http://www.w3.org/XML/1998/namespace",
                xmlns: "http://www.w3.org/2000/xmlns/"
              };
            function re(e, t) {
              return e = i.ns.qualify(e), null == t ? e.local ? function () {
                this.removeAttributeNS(e.space, e.local);
              } : function () {
                this.removeAttribute(e);
              } : "function" == typeof t ? e.local ? function () {
                var r = t.apply(this, arguments);
                null == r ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, r);
              } : function () {
                var r = t.apply(this, arguments);
                null == r ? this.removeAttribute(e) : this.setAttribute(e, r);
              } : e.local ? function () {
                this.setAttributeNS(e.space, e.local, t);
              } : function () {
                this.setAttribute(e, t);
              };
            }
            function ne(e) {
              return e.trim().replace(/\s+/g, " ");
            }
            function ae(e) {
              return new RegExp("(?:^|\\s+)" + i.requote(e) + "(?:\\s+|$)", "g");
            }
            function ie(e) {
              return (e + "").trim().split(/^|\s+/);
            }
            function oe(e, t) {
              var r = (e = ie(e).map(le)).length;
              return "function" == typeof t ? function () {
                for (var n = -1, a = t.apply(this, arguments); ++n < r;) e[n](this, a);
              } : function () {
                for (var n = -1; ++n < r;) e[n](this, t);
              };
            }
            function le(e) {
              var t = ae(e);
              return function (r, n) {
                if (a = r.classList) return n ? a.add(e) : a.remove(e);
                var a = r.getAttribute("class") || "";
                n ? (t.lastIndex = 0, t.test(a) || r.setAttribute("class", ne(a + " " + e))) : r.setAttribute("class", ne(a.replace(t, " ")));
              };
            }
            function se(e, t, r) {
              return null == t ? function () {
                this.style.removeProperty(e);
              } : "function" == typeof t ? function () {
                var n = t.apply(this, arguments);
                null == n ? this.style.removeProperty(e) : this.style.setProperty(e, n, r);
              } : function () {
                this.style.setProperty(e, t, r);
              };
            }
            function ce(e, t) {
              return null == t ? function () {
                delete this[e];
              } : "function" == typeof t ? function () {
                var r = t.apply(this, arguments);
                null == r ? delete this[e] : this[e] = r;
              } : function () {
                this[e] = t;
              };
            }
            function ue(e) {
              return "function" == typeof e ? e : (e = i.ns.qualify(e)).local ? function () {
                return this.ownerDocument.createElementNS(e.space, e.local);
              } : function () {
                var t = this.ownerDocument,
                  r = this.namespaceURI;
                return r === ee && t.documentElement.namespaceURI === ee ? t.createElement(e) : t.createElementNS(r, e);
              };
            }
            function fe() {
              var e = this.parentNode;
              e && e.removeChild(this);
            }
            function de(e) {
              return {
                __data__: e
              };
            }
            function he(e) {
              return function () {
                return X(this, e);
              };
            }
            function pe(e) {
              return arguments.length || (e = g), function (t, r) {
                return t && r ? e(t.__data__, r.__data__) : !t - !r;
              };
            }
            function ve(e, t) {
              for (var r = 0, n = e.length; r < n; r++) for (var a, i = e[r], o = 0, l = i.length; o < l; o++) (a = i[o]) && t(a, o, r);
              return e;
            }
            function ge(e) {
              return G(e, me), e;
            }
            i.ns = {
              prefix: te,
              qualify: function (e) {
                var t = e.indexOf(":"),
                  r = e;
                return t >= 0 && "xmlns" !== (r = e.slice(0, t)) && (e = e.slice(t + 1)), te.hasOwnProperty(r) ? {
                  space: te[r],
                  local: e
                } : e;
              }
            }, K.attr = function (e, t) {
              if (arguments.length < 2) {
                if ("string" == typeof e) {
                  var r = this.node();
                  return (e = i.ns.qualify(e)).local ? r.getAttributeNS(e.space, e.local) : r.getAttribute(e);
                }
                for (t in e) this.each(re(t, e[t]));
                return this;
              }
              return this.each(re(e, t));
            }, K.classed = function (e, t) {
              if (arguments.length < 2) {
                if ("string" == typeof e) {
                  var r = this.node(),
                    n = (e = ie(e)).length,
                    a = -1;
                  if (t = r.classList) {
                    for (; ++a < n;) if (!t.contains(e[a])) return !1;
                  } else for (t = r.getAttribute("class"); ++a < n;) if (!ae(e[a]).test(t)) return !1;
                  return !0;
                }
                for (t in e) this.each(oe(t, e[t]));
                return this;
              }
              return this.each(oe(e, t));
            }, K.style = function (e, t, r) {
              var n = arguments.length;
              if (n < 3) {
                if ("string" != typeof e) {
                  for (r in n < 2 && (t = ""), e) this.each(se(r, e[r], t));
                  return this;
                }
                if (n < 2) {
                  var a = this.node();
                  return u(a).getComputedStyle(a, null).getPropertyValue(e);
                }
                r = "";
              }
              return this.each(se(e, t, r));
            }, K.property = function (e, t) {
              if (arguments.length < 2) {
                if ("string" == typeof e) return this.node()[e];
                for (t in e) this.each(ce(t, e[t]));
                return this;
              }
              return this.each(ce(e, t));
            }, K.text = function (e) {
              return arguments.length ? this.each("function" == typeof e ? function () {
                var t = e.apply(this, arguments);
                this.textContent = null == t ? "" : t;
              } : null == e ? function () {
                this.textContent = "";
              } : function () {
                this.textContent = e;
              }) : this.node().textContent;
            }, K.html = function (e) {
              return arguments.length ? this.each("function" == typeof e ? function () {
                var t = e.apply(this, arguments);
                this.innerHTML = null == t ? "" : t;
              } : null == e ? function () {
                this.innerHTML = "";
              } : function () {
                this.innerHTML = e;
              }) : this.node().innerHTML;
            }, K.append = function (e) {
              return e = ue(e), this.select(function () {
                return this.appendChild(e.apply(this, arguments));
              });
            }, K.insert = function (e, t) {
              return e = ue(e), t = Q(t), this.select(function () {
                return this.insertBefore(e.apply(this, arguments), t.apply(this, arguments) || null);
              });
            }, K.remove = function () {
              return this.each(fe);
            }, K.data = function (e, t) {
              var r,
                n,
                a = -1,
                i = this.length;
              if (!arguments.length) {
                for (e = new Array(i = (r = this[0]).length); ++a < i;) (n = r[a]) && (e[a] = n.__data__);
                return e;
              }
              function o(e, r) {
                var n,
                  a,
                  i,
                  o = e.length,
                  u = r.length,
                  f = Math.min(o, u),
                  d = new Array(u),
                  h = new Array(u),
                  p = new Array(o);
                if (t) {
                  var v,
                    g = new M(),
                    m = new Array(o);
                  for (n = -1; ++n < o;) (a = e[n]) && (g.has(v = t.call(a, a.__data__, n)) ? p[n] = a : g.set(v, a), m[n] = v);
                  for (n = -1; ++n < u;) (a = g.get(v = t.call(r, i = r[n], n))) ? !0 !== a && (d[n] = a, a.__data__ = i) : h[n] = de(i), g.set(v, !0);
                  for (n = -1; ++n < o;) n in m && !0 !== g.get(m[n]) && (p[n] = e[n]);
                } else {
                  for (n = -1; ++n < f;) a = e[n], i = r[n], a ? (a.__data__ = i, d[n] = a) : h[n] = de(i);
                  for (; n < u; ++n) h[n] = de(r[n]);
                  for (; n < o; ++n) p[n] = e[n];
                }
                h.update = d, h.parentNode = d.parentNode = p.parentNode = e.parentNode, l.push(h), s.push(d), c.push(p);
              }
              var l = ge([]),
                s = Z([]),
                c = Z([]);
              if ("function" == typeof e) for (; ++a < i;) o(r = this[a], e.call(r, r.parentNode.__data__, a));else for (; ++a < i;) o(r = this[a], e);
              return s.enter = function () {
                return l;
              }, s.exit = function () {
                return c;
              }, s;
            }, K.datum = function (e) {
              return arguments.length ? this.property("__data__", e) : this.property("__data__");
            }, K.filter = function (e) {
              var t,
                r,
                n,
                a = [];
              "function" != typeof e && (e = he(e));
              for (var i = 0, o = this.length; i < o; i++) {
                a.push(t = []), t.parentNode = (r = this[i]).parentNode;
                for (var l = 0, s = r.length; l < s; l++) (n = r[l]) && e.call(n, n.__data__, l, i) && t.push(n);
              }
              return Z(a);
            }, K.order = function () {
              for (var e = -1, t = this.length; ++e < t;) for (var r, n = this[e], a = n.length - 1, i = n[a]; --a >= 0;) (r = n[a]) && (i && i !== r.nextSibling && i.parentNode.insertBefore(r, i), i = r);
              return this;
            }, K.sort = function (e) {
              e = pe.apply(this, arguments);
              for (var t = -1, r = this.length; ++t < r;) this[t].sort(e);
              return this.order();
            }, K.each = function (e) {
              return ve(this, function (t, r, n) {
                e.call(t, t.__data__, r, n);
              });
            }, K.call = function (e) {
              var t = l(arguments);
              return e.apply(t[0] = this, t), this;
            }, K.empty = function () {
              return !this.node();
            }, K.node = function () {
              for (var e = 0, t = this.length; e < t; e++) for (var r = this[e], n = 0, a = r.length; n < a; n++) {
                var i = r[n];
                if (i) return i;
              }
              return null;
            }, K.size = function () {
              var e = 0;
              return ve(this, function () {
                ++e;
              }), e;
            };
            var me = [];
            function ye(e, t, r) {
              var n = "__on" + e,
                a = e.indexOf("."),
                o = be;
              a > 0 && (e = e.slice(0, a));
              var s = xe.get(e);
              function c() {
                var t = this[n];
                t && (this.removeEventListener(e, t, t.$), delete this[n]);
              }
              return s && (e = s, o = _e), a ? t ? function () {
                var a = o(t, l(arguments));
                c.call(this), this.addEventListener(e, this[n] = a, a.$ = r), a._ = t;
              } : c : t ? H : function () {
                var t,
                  r = new RegExp("^__on([^.]+)" + i.requote(e) + "$");
                for (var n in this) if (t = n.match(r)) {
                  var a = this[n];
                  this.removeEventListener(t[1], a, a.$), delete this[n];
                }
              };
            }
            i.selection.enter = ge, i.selection.enter.prototype = me, me.append = K.append, me.empty = K.empty, me.node = K.node, me.call = K.call, me.size = K.size, me.select = function (e) {
              for (var t, r, n, a, i, o = [], l = -1, s = this.length; ++l < s;) {
                n = (a = this[l]).update, o.push(t = []), t.parentNode = a.parentNode;
                for (var c = -1, u = a.length; ++c < u;) (i = a[c]) ? (t.push(n[c] = r = e.call(a.parentNode, i.__data__, c, l)), r.__data__ = i.__data__) : t.push(null);
              }
              return Z(o);
            }, me.insert = function (e, t) {
              var r, n, a;
              return arguments.length < 2 && (r = this, t = function (e, t, i) {
                var o,
                  l = r[i].update,
                  s = l.length;
                for (i != a && (a = i, n = 0), t >= n && (n = t + 1); !(o = l[n]) && ++n < s;);
                return o;
              }), K.insert.call(this, e, t);
            }, i.select = function (e) {
              var t;
              return "string" == typeof e ? (t = [W(e, s)]).parentNode = s.documentElement : (t = [e]).parentNode = c(e), Z([t]);
            }, i.selectAll = function (e) {
              var t;
              return "string" == typeof e ? (t = l(J(e, s))).parentNode = s.documentElement : (t = l(e)).parentNode = null, Z([t]);
            }, K.on = function (e, t, r) {
              var n = arguments.length;
              if (n < 3) {
                if ("string" != typeof e) {
                  for (r in n < 2 && (t = !1), e) this.each(ye(r, e[r], t));
                  return this;
                }
                if (n < 2) return (n = this.node()["__on" + e]) && n._;
                r = !1;
              }
              return this.each(ye(e, t, r));
            };
            var xe = i.map({
              mouseenter: "mouseover",
              mouseleave: "mouseout"
            });
            function be(e, t) {
              return function (r) {
                var n = i.event;
                i.event = r, t[0] = this.__data__;
                try {
                  e.apply(this, t);
                } finally {
                  i.event = n;
                }
              };
            }
            function _e(e, t) {
              var r = be(e, t);
              return function (e) {
                var t = this,
                  n = e.relatedTarget;
                n && (n === t || 8 & n.compareDocumentPosition(t)) || r.call(t, e);
              };
            }
            s && xe.forEach(function (e) {
              "on" + e in s && xe.remove(e);
            });
            var we,
              Te = 0;
            function Me(e) {
              var t = ".dragsuppress-" + ++Te,
                r = "click" + t,
                n = i.select(u(e)).on("touchmove" + t, Y).on("dragstart" + t, Y).on("selectstart" + t, Y);
              if (null == we && (we = !("onselectstart" in e) && N(e.style, "userSelect")), we) {
                var a = c(e).style,
                  o = a[we];
                a[we] = "none";
              }
              return function (e) {
                if (n.on(t, null), we && (a[we] = o), e) {
                  var i = function () {
                    n.on(r, null);
                  };
                  n.on(r, function () {
                    Y(), i();
                  }, !0), setTimeout(i, 0);
                }
              };
            }
            i.mouse = function (e) {
              return Ae(e, V());
            };
            var ke = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
            function Ae(e, t) {
              t.changedTouches && (t = t.changedTouches[0]);
              var r = e.ownerSVGElement || e;
              if (r.createSVGPoint) {
                var n = r.createSVGPoint();
                if (ke < 0) {
                  var a = u(e);
                  if (a.scrollX || a.scrollY) {
                    var o = (r = i.select("body").append("svg").style({
                      position: "absolute",
                      top: 0,
                      left: 0,
                      margin: 0,
                      padding: 0,
                      border: "none"
                    }, "important"))[0][0].getScreenCTM();
                    ke = !(o.f || o.e), r.remove();
                  }
                }
                return ke ? (n.x = t.pageX, n.y = t.pageY) : (n.x = t.clientX, n.y = t.clientY), [(n = n.matrixTransform(e.getScreenCTM().inverse())).x, n.y];
              }
              var l = e.getBoundingClientRect();
              return [t.clientX - l.left - e.clientLeft, t.clientY - l.top - e.clientTop];
            }
            function Le() {
              return i.event.changedTouches[0].identifier;
            }
            i.touch = function (e, t, r) {
              if (arguments.length < 3 && (r = t, t = V().changedTouches), t) for (var n, a = 0, i = t.length; a < i; ++a) if ((n = t[a]).identifier === r) return Ae(e, n);
            }, i.behavior.drag = function () {
              var e = U(a, "drag", "dragstart", "dragend"),
                t = null,
                r = o(H, i.mouse, u, "mousemove", "mouseup"),
                n = o(Le, i.touch, E, "touchmove", "touchend");
              function a() {
                this.on("mousedown.drag", r).on("touchstart.drag", n);
              }
              function o(r, n, a, o, l) {
                return function () {
                  var s,
                    c = this,
                    u = i.event.target.correspondingElement || i.event.target,
                    f = c.parentNode,
                    d = e.of(c, arguments),
                    h = 0,
                    p = r(),
                    v = ".drag" + (null == p ? "" : "-" + p),
                    g = i.select(a(u)).on(o + v, function () {
                      var e,
                        t,
                        r = n(f, p);
                      r && (e = r[0] - y[0], t = r[1] - y[1], h |= e | t, y = r, d({
                        type: "drag",
                        x: r[0] + s[0],
                        y: r[1] + s[1],
                        dx: e,
                        dy: t
                      }));
                    }).on(l + v, function () {
                      n(f, p) && (g.on(o + v, null).on(l + v, null), m(h), d({
                        type: "dragend"
                      }));
                    }),
                    m = Me(u),
                    y = n(f, p);
                  s = t ? [(s = t.apply(c, arguments)).x - y[0], s.y - y[1]] : [0, 0], d({
                    type: "dragstart"
                  });
                };
              }
              return a.origin = function (e) {
                return arguments.length ? (t = e, a) : t;
              }, i.rebind(a, e, "on");
            }, i.touches = function (e, t) {
              return arguments.length < 2 && (t = V().touches), t ? l(t).map(function (t) {
                var r = Ae(e, t);
                return r.identifier = t.identifier, r;
              }) : [];
            };
            var Se = 1e-6,
              Ce = Se * Se,
              Oe = Math.PI,
              De = 2 * Oe,
              Pe = De - Se,
              ze = Oe / 2,
              Ie = Oe / 180,
              Ee = 180 / Oe;
            function Re(e) {
              return e > 1 ? ze : e < -1 ? -ze : Math.asin(e);
            }
            function Ne(e) {
              return ((e = Math.exp(e)) + 1 / e) / 2;
            }
            var Fe = Math.SQRT2;
            i.interpolateZoom = function (e, t) {
              var r,
                n,
                a = e[0],
                i = e[1],
                o = e[2],
                l = t[0],
                s = t[1],
                c = t[2],
                u = l - a,
                f = s - i,
                d = u * u + f * f;
              if (d < Ce) n = Math.log(c / o) / Fe, r = function (e) {
                return [a + e * u, i + e * f, o * Math.exp(Fe * e * n)];
              };else {
                var h = Math.sqrt(d),
                  p = (c * c - o * o + 4 * d) / (2 * o * 2 * h),
                  v = (c * c - o * o - 4 * d) / (2 * c * 2 * h),
                  g = Math.log(Math.sqrt(p * p + 1) - p),
                  m = Math.log(Math.sqrt(v * v + 1) - v);
                n = (m - g) / Fe, r = function (e) {
                  var t,
                    r = e * n,
                    l = Ne(g),
                    s = o / (2 * h) * (l * (t = Fe * r + g, ((t = Math.exp(2 * t)) - 1) / (t + 1)) - function (e) {
                      return ((e = Math.exp(e)) - 1 / e) / 2;
                    }(g));
                  return [a + s * u, i + s * f, o * l / Ne(Fe * r + g)];
                };
              }
              return r.duration = 1e3 * n, r;
            }, i.behavior.zoom = function () {
              var e,
                t,
                r,
                n,
                a,
                o,
                l,
                c,
                f,
                d = {
                  x: 0,
                  y: 0,
                  k: 1
                },
                h = [960, 500],
                p = je,
                v = 250,
                g = 0,
                m = "mousedown.zoom",
                y = "mousemove.zoom",
                x = "mouseup.zoom",
                b = "touchstart.zoom",
                _ = U(w, "zoomstart", "zoom", "zoomend");
              function w(e) {
                e.on(m, D).on(Be + ".zoom", z).on("dblclick.zoom", I).on(b, P);
              }
              function T(e) {
                return [(e[0] - d.x) / d.k, (e[1] - d.y) / d.k];
              }
              function M(e) {
                d.k = Math.max(p[0], Math.min(p[1], e));
              }
              function k(e, t) {
                t = function (e) {
                  return [e[0] * d.k + d.x, e[1] * d.k + d.y];
                }(t), d.x += e[0] - t[0], d.y += e[1] - t[1];
              }
              function A(e, r, n, a) {
                e.__chart__ = {
                  x: d.x,
                  y: d.y,
                  k: d.k
                }, M(Math.pow(2, a)), k(t = r, n), e = i.select(e), v > 0 && (e = e.transition().duration(v)), e.call(w.event);
              }
              function L() {
                l && l.domain(o.range().map(function (e) {
                  return (e - d.x) / d.k;
                }).map(o.invert)), f && f.domain(c.range().map(function (e) {
                  return (e - d.y) / d.k;
                }).map(c.invert));
              }
              function S(e) {
                g++ || e({
                  type: "zoomstart"
                });
              }
              function C(e) {
                L(), e({
                  type: "zoom",
                  scale: d.k,
                  translate: [d.x, d.y]
                });
              }
              function O(e) {
                --g || (e({
                  type: "zoomend"
                }), t = null);
              }
              function D() {
                var e = this,
                  t = _.of(e, arguments),
                  r = 0,
                  n = i.select(u(e)).on(y, function () {
                    r = 1, k(i.mouse(e), a), C(t);
                  }).on(x, function () {
                    n.on(y, null).on(x, null), o(r), O(t);
                  }),
                  a = T(i.mouse(e)),
                  o = Me(e);
                Xa.call(e), S(t);
              }
              function P() {
                var e,
                  t = this,
                  r = _.of(t, arguments),
                  n = {},
                  o = 0,
                  l = ".zoom-" + i.event.changedTouches[0].identifier,
                  s = "touchmove" + l,
                  c = "touchend" + l,
                  u = [],
                  f = i.select(t),
                  h = Me(t);
                function p() {
                  var r = i.touches(t);
                  return e = d.k, r.forEach(function (e) {
                    e.identifier in n && (n[e.identifier] = T(e));
                  }), r;
                }
                function v() {
                  var e = i.event.target;
                  i.select(e).on(s, g).on(c, y), u.push(e);
                  for (var r = i.event.changedTouches, l = 0, f = r.length; l < f; ++l) n[r[l].identifier] = null;
                  var h = p(),
                    v = Date.now();
                  if (1 === h.length) {
                    if (v - a < 500) {
                      var m = h[0];
                      A(t, m, n[m.identifier], Math.floor(Math.log(d.k) / Math.LN2) + 1), Y();
                    }
                    a = v;
                  } else if (h.length > 1) {
                    m = h[0];
                    var x = h[1],
                      b = m[0] - x[0],
                      _ = m[1] - x[1];
                    o = b * b + _ * _;
                  }
                }
                function g() {
                  var l,
                    s,
                    c,
                    u,
                    f = i.touches(t);
                  Xa.call(t);
                  for (var d = 0, h = f.length; d < h; ++d, u = null) if (c = f[d], u = n[c.identifier]) {
                    if (s) break;
                    l = c, s = u;
                  }
                  if (u) {
                    var p = (p = c[0] - l[0]) * p + (p = c[1] - l[1]) * p,
                      v = o && Math.sqrt(p / o);
                    l = [(l[0] + c[0]) / 2, (l[1] + c[1]) / 2], s = [(s[0] + u[0]) / 2, (s[1] + u[1]) / 2], M(v * e);
                  }
                  a = null, k(l, s), C(r);
                }
                function y() {
                  if (i.event.touches.length) {
                    for (var e = i.event.changedTouches, t = 0, a = e.length; t < a; ++t) delete n[e[t].identifier];
                    for (var o in n) return void p();
                  }
                  i.selectAll(u).on(l, null), f.on(m, D).on(b, P), h(), O(r);
                }
                v(), S(r), f.on(m, null).on(b, v);
              }
              function z() {
                var a = _.of(this, arguments);
                n ? clearTimeout(n) : (Xa.call(this), e = T(t = r || i.mouse(this)), S(a)), n = setTimeout(function () {
                  n = null, O(a);
                }, 50), Y(), M(Math.pow(2, .002 * He()) * d.k), k(t, e), C(a);
              }
              function I() {
                var e = i.mouse(this),
                  t = Math.log(d.k) / Math.LN2;
                A(this, e, T(e), i.event.shiftKey ? Math.ceil(t) - 1 : Math.floor(t) + 1);
              }
              return Be || (Be = "onwheel" in s ? (He = function () {
                return -i.event.deltaY * (i.event.deltaMode ? 120 : 1);
              }, "wheel") : "onmousewheel" in s ? (He = function () {
                return i.event.wheelDelta;
              }, "mousewheel") : (He = function () {
                return -i.event.detail;
              }, "MozMousePixelScroll")), w.event = function (e) {
                e.each(function () {
                  var e = _.of(this, arguments),
                    r = d;
                  $a ? i.select(this).transition().each("start.zoom", function () {
                    d = this.__chart__ || {
                      x: 0,
                      y: 0,
                      k: 1
                    }, S(e);
                  }).tween("zoom:zoom", function () {
                    var n = h[0],
                      a = h[1],
                      o = t ? t[0] : n / 2,
                      l = t ? t[1] : a / 2,
                      s = i.interpolateZoom([(o - d.x) / d.k, (l - d.y) / d.k, n / d.k], [(o - r.x) / r.k, (l - r.y) / r.k, n / r.k]);
                    return function (t) {
                      var r = s(t),
                        a = n / r[2];
                      this.__chart__ = d = {
                        x: o - r[0] * a,
                        y: l - r[1] * a,
                        k: a
                      }, C(e);
                    };
                  }).each("interrupt.zoom", function () {
                    O(e);
                  }).each("end.zoom", function () {
                    O(e);
                  }) : (this.__chart__ = d, S(e), C(e), O(e));
                });
              }, w.translate = function (e) {
                return arguments.length ? (d = {
                  x: +e[0],
                  y: +e[1],
                  k: d.k
                }, L(), w) : [d.x, d.y];
              }, w.scale = function (e) {
                return arguments.length ? (d = {
                  x: d.x,
                  y: d.y,
                  k: null
                }, M(+e), L(), w) : d.k;
              }, w.scaleExtent = function (e) {
                return arguments.length ? (p = null == e ? je : [+e[0], +e[1]], w) : p;
              }, w.center = function (e) {
                return arguments.length ? (r = e && [+e[0], +e[1]], w) : r;
              }, w.size = function (e) {
                return arguments.length ? (h = e && [+e[0], +e[1]], w) : h;
              }, w.duration = function (e) {
                return arguments.length ? (v = +e, w) : v;
              }, w.x = function (e) {
                return arguments.length ? (l = e, o = e.copy(), d = {
                  x: 0,
                  y: 0,
                  k: 1
                }, w) : l;
              }, w.y = function (e) {
                return arguments.length ? (f = e, c = e.copy(), d = {
                  x: 0,
                  y: 0,
                  k: 1
                }, w) : f;
              }, i.rebind(w, _, "on");
            };
            var He,
              Be,
              je = [0, 1 / 0];
            function Ye() {}
            function Ve(e, t, r) {
              return this instanceof Ve ? (this.h = +e, this.s = +t, void (this.l = +r)) : arguments.length < 2 ? e instanceof Ve ? new Ve(e.h, e.s, e.l) : ut("" + e, ft, Ve) : new Ve(e, t, r);
            }
            i.color = Ye, Ye.prototype.toString = function () {
              return this.rgb() + "";
            }, i.hsl = Ve;
            var Ue = Ve.prototype = new Ye();
            function qe(e, t, r) {
              var n, a;
              function i(e) {
                return Math.round(255 * function (e) {
                  return e > 360 ? e -= 360 : e < 0 && (e += 360), e < 60 ? n + (a - n) * e / 60 : e < 180 ? a : e < 240 ? n + (a - n) * (240 - e) / 60 : n;
                }(e));
              }
              return e = isNaN(e) ? 0 : (e %= 360) < 0 ? e + 360 : e, t = isNaN(t) || t < 0 ? 0 : t > 1 ? 1 : t, n = 2 * (r = r < 0 ? 0 : r > 1 ? 1 : r) - (a = r <= .5 ? r * (1 + t) : r + t - r * t), new it(i(e + 120), i(e), i(e - 120));
            }
            function Ge(e, t, r) {
              return this instanceof Ge ? (this.h = +e, this.c = +t, void (this.l = +r)) : arguments.length < 2 ? e instanceof Ge ? new Ge(e.h, e.c, e.l) : function (e, t, r) {
                return e > 0 ? new Ge(Math.atan2(r, t) * Ee, Math.sqrt(t * t + r * r), e) : new Ge(NaN, NaN, e);
              }(e instanceof Je ? e.l : (e = dt((e = i.rgb(e)).r, e.g, e.b)).l, e.a, e.b) : new Ge(e, t, r);
            }
            Ue.brighter = function (e) {
              return e = Math.pow(.7, arguments.length ? e : 1), new Ve(this.h, this.s, this.l / e);
            }, Ue.darker = function (e) {
              return e = Math.pow(.7, arguments.length ? e : 1), new Ve(this.h, this.s, e * this.l);
            }, Ue.rgb = function () {
              return qe(this.h, this.s, this.l);
            }, i.hcl = Ge;
            var Ze = Ge.prototype = new Ye();
            function We(e, t, r) {
              return isNaN(e) && (e = 0), isNaN(t) && (t = 0), new Je(r, Math.cos(e *= Ie) * t, Math.sin(e) * t);
            }
            function Je(e, t, r) {
              return this instanceof Je ? (this.l = +e, this.a = +t, void (this.b = +r)) : arguments.length < 2 ? e instanceof Je ? new Je(e.l, e.a, e.b) : e instanceof Ge ? We(e.h, e.c, e.l) : dt((e = it(e)).r, e.g, e.b) : new Je(e, t, r);
            }
            Ze.brighter = function (e) {
              return new Ge(this.h, this.c, Math.min(100, this.l + Xe * (arguments.length ? e : 1)));
            }, Ze.darker = function (e) {
              return new Ge(this.h, this.c, Math.max(0, this.l - Xe * (arguments.length ? e : 1)));
            }, Ze.rgb = function () {
              return We(this.h, this.c, this.l).rgb();
            }, i.lab = Je;
            var Xe = 18,
              Ke = .95047,
              Qe = 1,
              $e = 1.08883,
              et = Je.prototype = new Ye();
            function tt(e, t, r) {
              var n = (e + 16) / 116,
                a = n + t / 500,
                i = n - r / 200;
              return new it(at(3.2404542 * (a = rt(a) * Ke) - 1.5371385 * (n = rt(n) * Qe) - .4985314 * (i = rt(i) * $e)), at(-.969266 * a + 1.8760108 * n + .041556 * i), at(.0556434 * a - .2040259 * n + 1.0572252 * i));
            }
            function rt(e) {
              return e > .206893034 ? e * e * e : (e - 4 / 29) / 7.787037;
            }
            function nt(e) {
              return e > .008856 ? Math.pow(e, 1 / 3) : 7.787037 * e + 4 / 29;
            }
            function at(e) {
              return Math.round(255 * (e <= .00304 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055));
            }
            function it(e, t, r) {
              return this instanceof it ? (this.r = ~~e, this.g = ~~t, void (this.b = ~~r)) : arguments.length < 2 ? e instanceof it ? new it(e.r, e.g, e.b) : ut("" + e, it, qe) : new it(e, t, r);
            }
            function ot(e) {
              return new it(e >> 16, e >> 8 & 255, 255 & e);
            }
            function lt(e) {
              return ot(e) + "";
            }
            et.brighter = function (e) {
              return new Je(Math.min(100, this.l + Xe * (arguments.length ? e : 1)), this.a, this.b);
            }, et.darker = function (e) {
              return new Je(Math.max(0, this.l - Xe * (arguments.length ? e : 1)), this.a, this.b);
            }, et.rgb = function () {
              return tt(this.l, this.a, this.b);
            }, i.rgb = it;
            var st = it.prototype = new Ye();
            function ct(e) {
              return e < 16 ? "0" + Math.max(0, e).toString(16) : Math.min(255, e).toString(16);
            }
            function ut(e, t, r) {
              var n,
                a,
                i,
                o = 0,
                l = 0,
                s = 0;
              if (n = /([a-z]+)\((.*)\)/.exec(e = e.toLowerCase())) switch (a = n[2].split(","), n[1]) {
                case "hsl":
                  return r(parseFloat(a[0]), parseFloat(a[1]) / 100, parseFloat(a[2]) / 100);
                case "rgb":
                  return t(pt(a[0]), pt(a[1]), pt(a[2]));
              }
              return (i = vt.get(e)) ? t(i.r, i.g, i.b) : (null == e || "#" !== e.charAt(0) || isNaN(i = parseInt(e.slice(1), 16)) || (4 === e.length ? (o = (3840 & i) >> 4, o |= o >> 4, l = 240 & i, l |= l >> 4, s = 15 & i, s |= s << 4) : 7 === e.length && (o = (16711680 & i) >> 16, l = (65280 & i) >> 8, s = 255 & i)), t(o, l, s));
            }
            function ft(e, t, r) {
              var n,
                a,
                i = Math.min(e /= 255, t /= 255, r /= 255),
                o = Math.max(e, t, r),
                l = o - i,
                s = (o + i) / 2;
              return l ? (a = s < .5 ? l / (o + i) : l / (2 - o - i), n = e == o ? (t - r) / l + (t < r ? 6 : 0) : t == o ? (r - e) / l + 2 : (e - t) / l + 4, n *= 60) : (n = NaN, a = s > 0 && s < 1 ? 0 : n), new Ve(n, a, s);
            }
            function dt(e, t, r) {
              var n = nt((.4124564 * (e = ht(e)) + .3575761 * (t = ht(t)) + .1804375 * (r = ht(r))) / Ke),
                a = nt((.2126729 * e + .7151522 * t + .072175 * r) / Qe);
              return Je(116 * a - 16, 500 * (n - a), 200 * (a - nt((.0193339 * e + .119192 * t + .9503041 * r) / $e)));
            }
            function ht(e) {
              return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
            }
            function pt(e) {
              var t = parseFloat(e);
              return "%" === e.charAt(e.length - 1) ? Math.round(2.55 * t) : t;
            }
            st.brighter = function (e) {
              e = Math.pow(.7, arguments.length ? e : 1);
              var t = this.r,
                r = this.g,
                n = this.b,
                a = 30;
              return t || r || n ? (t && t < a && (t = a), r && r < a && (r = a), n && n < a && (n = a), new it(Math.min(255, t / e), Math.min(255, r / e), Math.min(255, n / e))) : new it(a, a, a);
            }, st.darker = function (e) {
              return new it((e = Math.pow(.7, arguments.length ? e : 1)) * this.r, e * this.g, e * this.b);
            }, st.hsl = function () {
              return ft(this.r, this.g, this.b);
            }, st.toString = function () {
              return "#" + ct(this.r) + ct(this.g) + ct(this.b);
            };
            var vt = i.map({
              aliceblue: 15792383,
              antiquewhite: 16444375,
              aqua: 65535,
              aquamarine: 8388564,
              azure: 15794175,
              beige: 16119260,
              bisque: 16770244,
              black: 0,
              blanchedalmond: 16772045,
              blue: 255,
              blueviolet: 9055202,
              brown: 10824234,
              burlywood: 14596231,
              cadetblue: 6266528,
              chartreuse: 8388352,
              chocolate: 13789470,
              coral: 16744272,
              cornflowerblue: 6591981,
              cornsilk: 16775388,
              crimson: 14423100,
              cyan: 65535,
              darkblue: 139,
              darkcyan: 35723,
              darkgoldenrod: 12092939,
              darkgray: 11119017,
              darkgreen: 25600,
              darkgrey: 11119017,
              darkkhaki: 12433259,
              darkmagenta: 9109643,
              darkolivegreen: 5597999,
              darkorange: 16747520,
              darkorchid: 10040012,
              darkred: 9109504,
              darksalmon: 15308410,
              darkseagreen: 9419919,
              darkslateblue: 4734347,
              darkslategray: 3100495,
              darkslategrey: 3100495,
              darkturquoise: 52945,
              darkviolet: 9699539,
              deeppink: 16716947,
              deepskyblue: 49151,
              dimgray: 6908265,
              dimgrey: 6908265,
              dodgerblue: 2003199,
              firebrick: 11674146,
              floralwhite: 16775920,
              forestgreen: 2263842,
              fuchsia: 16711935,
              gainsboro: 14474460,
              ghostwhite: 16316671,
              gold: 16766720,
              goldenrod: 14329120,
              gray: 8421504,
              green: 32768,
              greenyellow: 11403055,
              grey: 8421504,
              honeydew: 15794160,
              hotpink: 16738740,
              indianred: 13458524,
              indigo: 4915330,
              ivory: 16777200,
              khaki: 15787660,
              lavender: 15132410,
              lavenderblush: 16773365,
              lawngreen: 8190976,
              lemonchiffon: 16775885,
              lightblue: 11393254,
              lightcoral: 15761536,
              lightcyan: 14745599,
              lightgoldenrodyellow: 16448210,
              lightgray: 13882323,
              lightgreen: 9498256,
              lightgrey: 13882323,
              lightpink: 16758465,
              lightsalmon: 16752762,
              lightseagreen: 2142890,
              lightskyblue: 8900346,
              lightslategray: 7833753,
              lightslategrey: 7833753,
              lightsteelblue: 11584734,
              lightyellow: 16777184,
              lime: 65280,
              limegreen: 3329330,
              linen: 16445670,
              magenta: 16711935,
              maroon: 8388608,
              mediumaquamarine: 6737322,
              mediumblue: 205,
              mediumorchid: 12211667,
              mediumpurple: 9662683,
              mediumseagreen: 3978097,
              mediumslateblue: 8087790,
              mediumspringgreen: 64154,
              mediumturquoise: 4772300,
              mediumvioletred: 13047173,
              midnightblue: 1644912,
              mintcream: 16121850,
              mistyrose: 16770273,
              moccasin: 16770229,
              navajowhite: 16768685,
              navy: 128,
              oldlace: 16643558,
              olive: 8421376,
              olivedrab: 7048739,
              orange: 16753920,
              orangered: 16729344,
              orchid: 14315734,
              palegoldenrod: 15657130,
              palegreen: 10025880,
              paleturquoise: 11529966,
              palevioletred: 14381203,
              papayawhip: 16773077,
              peachpuff: 16767673,
              peru: 13468991,
              pink: 16761035,
              plum: 14524637,
              powderblue: 11591910,
              purple: 8388736,
              rebeccapurple: 6697881,
              red: 16711680,
              rosybrown: 12357519,
              royalblue: 4286945,
              saddlebrown: 9127187,
              salmon: 16416882,
              sandybrown: 16032864,
              seagreen: 3050327,
              seashell: 16774638,
              sienna: 10506797,
              silver: 12632256,
              skyblue: 8900331,
              slateblue: 6970061,
              slategray: 7372944,
              slategrey: 7372944,
              snow: 16775930,
              springgreen: 65407,
              steelblue: 4620980,
              tan: 13808780,
              teal: 32896,
              thistle: 14204888,
              tomato: 16737095,
              turquoise: 4251856,
              violet: 15631086,
              wheat: 16113331,
              white: 16777215,
              whitesmoke: 16119285,
              yellow: 16776960,
              yellowgreen: 10145074
            });
            function gt(e) {
              return "function" == typeof e ? e : function () {
                return e;
              };
            }
            function mt(e) {
              return function (t, r, n) {
                return 2 === arguments.length && "function" == typeof r && (n = r, r = null), yt(t, r, e, n);
              };
            }
            function yt(e, t, r, n) {
              var a = {},
                o = i.dispatch("beforesend", "progress", "load", "error"),
                s = {},
                c = new XMLHttpRequest(),
                u = null;
              function f() {
                var e,
                  t = c.status;
                if (!t && function (e) {
                  var t = e.responseType;
                  return t && "text" !== t ? e.response : e.responseText;
                }(c) || t >= 200 && t < 300 || 304 === t) {
                  try {
                    e = r.call(a, c);
                  } catch (e) {
                    return void o.error.call(a, e);
                  }
                  o.load.call(a, e);
                } else o.error.call(a, c);
              }
              return self.XDomainRequest && !("withCredentials" in c) && /^(http(s)?:)?\/\//.test(e) && (c = new XDomainRequest()), "onload" in c ? c.onload = c.onerror = f : c.onreadystatechange = function () {
                c.readyState > 3 && f();
              }, c.onprogress = function (e) {
                var t = i.event;
                i.event = e;
                try {
                  o.progress.call(a, c);
                } finally {
                  i.event = t;
                }
              }, a.header = function (e, t) {
                return e = (e + "").toLowerCase(), arguments.length < 2 ? s[e] : (null == t ? delete s[e] : s[e] = t + "", a);
              }, a.mimeType = function (e) {
                return arguments.length ? (t = null == e ? null : e + "", a) : t;
              }, a.responseType = function (e) {
                return arguments.length ? (u = e, a) : u;
              }, a.response = function (e) {
                return r = e, a;
              }, ["get", "post"].forEach(function (e) {
                a[e] = function () {
                  return a.send.apply(a, [e].concat(l(arguments)));
                };
              }), a.send = function (r, n, i) {
                if (2 === arguments.length && "function" == typeof n && (i = n, n = null), c.open(r, e, !0), null == t || "accept" in s || (s.accept = t + ",*/*"), c.setRequestHeader) for (var l in s) c.setRequestHeader(l, s[l]);
                return null != t && c.overrideMimeType && c.overrideMimeType(t), null != u && (c.responseType = u), null != i && a.on("error", i).on("load", function (e) {
                  i(null, e);
                }), o.beforesend.call(a, c), c.send(null == n ? null : n), a;
              }, a.abort = function () {
                return c.abort(), a;
              }, i.rebind(a, o, "on"), null == n ? a : a.get(function (e) {
                return 1 === e.length ? function (t, r) {
                  e(null == t ? r : null);
                } : e;
              }(n));
            }
            vt.forEach(function (e, t) {
              vt.set(e, ot(t));
            }), i.functor = gt, i.xhr = mt(E), i.dsv = function (e, t) {
              var r = new RegExp('["' + e + "\n]"),
                n = e.charCodeAt(0);
              function a(e, r, n) {
                arguments.length < 3 && (n = r, r = null);
                var a = yt(e, t, null == r ? i : o(r), n);
                return a.row = function (e) {
                  return arguments.length ? a.response(null == (r = e) ? i : o(e)) : r;
                }, a;
              }
              function i(e) {
                return a.parse(e.responseText);
              }
              function o(e) {
                return function (t) {
                  return a.parse(t.responseText, e);
                };
              }
              function l(t) {
                return t.map(s).join(e);
              }
              function s(e) {
                return r.test(e) ? '"' + e.replace(/\"/g, '""') + '"' : e;
              }
              return a.parse = function (e, t) {
                var r;
                return a.parseRows(e, function (e, n) {
                  if (r) return r(e, n - 1);
                  var a = function (t) {
                    for (var r = {}, n = e.length, a = 0; a < n; ++a) r[e[a]] = t[a];
                    return r;
                  };
                  r = t ? function (e, r) {
                    return t(a(e), r);
                  } : a;
                });
              }, a.parseRows = function (e, t) {
                var r,
                  a,
                  i = {},
                  o = {},
                  l = [],
                  s = e.length,
                  c = 0,
                  u = 0;
                function f() {
                  if (c >= s) return o;
                  if (a) return a = !1, i;
                  var t = c;
                  if (34 === e.charCodeAt(t)) {
                    for (var r = t; r++ < s;) if (34 === e.charCodeAt(r)) {
                      if (34 !== e.charCodeAt(r + 1)) break;
                      ++r;
                    }
                    return c = r + 2, 13 === (l = e.charCodeAt(r + 1)) ? (a = !0, 10 === e.charCodeAt(r + 2) && ++c) : 10 === l && (a = !0), e.slice(t + 1, r).replace(/""/g, '"');
                  }
                  for (; c < s;) {
                    var l,
                      u = 1;
                    if (10 === (l = e.charCodeAt(c++))) a = !0;else if (13 === l) a = !0, 10 === e.charCodeAt(c) && (++c, ++u);else if (l !== n) continue;
                    return e.slice(t, c - u);
                  }
                  return e.slice(t);
                }
                for (; (r = f()) !== o;) {
                  for (var d = []; r !== i && r !== o;) d.push(r), r = f();
                  t && null == (d = t(d, u++)) || l.push(d);
                }
                return l;
              }, a.format = function (t) {
                if (Array.isArray(t[0])) return a.formatRows(t);
                var r = new I(),
                  n = [];
                return t.forEach(function (e) {
                  for (var t in e) r.has(t) || n.push(r.add(t));
                }), [n.map(s).join(e)].concat(t.map(function (t) {
                  return n.map(function (e) {
                    return s(t[e]);
                  }).join(e);
                })).join("\n");
              }, a.formatRows = function (e) {
                return e.map(l).join("\n");
              }, a;
            }, i.csv = i.dsv(",", "text/csv"), i.tsv = i.dsv("\t", "text/tab-separated-values");
            var xt,
              bt,
              _t,
              wt,
              Tt = this[N(this, "requestAnimationFrame")] || function (e) {
                setTimeout(e, 17);
              };
            function Mt(e, t, r) {
              var n = arguments.length;
              n < 2 && (t = 0), n < 3 && (r = Date.now());
              var a = {
                c: e,
                t: r + t,
                n: null
              };
              return bt ? bt.n = a : xt = a, bt = a, _t || (wt = clearTimeout(wt), _t = 1, Tt(kt)), a;
            }
            function kt() {
              var e = At(),
                t = Lt() - e;
              t > 24 ? (isFinite(t) && (clearTimeout(wt), wt = setTimeout(kt, t)), _t = 0) : (_t = 1, Tt(kt));
            }
            function At() {
              for (var e = Date.now(), t = xt; t;) e >= t.t && t.c(e - t.t) && (t.c = null), t = t.n;
              return e;
            }
            function Lt() {
              for (var e, t = xt, r = 1 / 0; t;) t.c ? (t.t < r && (r = t.t), t = (e = t).n) : t = e ? e.n = t.n : xt = t.n;
              return bt = e, r;
            }
            function St(e) {
              return e[0];
            }
            function Ct(e) {
              return e[1];
            }
            function Ot(e) {
              for (var t, r, n, a = e.length, i = [0, 1], o = 2, l = 2; l < a; l++) {
                for (; o > 1 && (t = e[i[o - 2]], r = e[i[o - 1]], n = e[l], (r[0] - t[0]) * (n[1] - t[1]) - (r[1] - t[1]) * (n[0] - t[0]) <= 0);) --o;
                i[o++] = l;
              }
              return i.slice(0, o);
            }
            function Dt(e, t) {
              return e[0] - t[0] || e[1] - t[1];
            }
            i.timer = function () {
              Mt.apply(this, arguments);
            }, i.timer.flush = function () {
              At(), Lt();
            }, i.round = function (e, t) {
              return t ? Math.round(e * (t = Math.pow(10, t))) / t : Math.round(e);
            }, i.geom = {}, i.geom.hull = function (e) {
              var t = St,
                r = Ct;
              if (arguments.length) return n(e);
              function n(e) {
                if (e.length < 3) return [];
                var n,
                  a = gt(t),
                  i = gt(r),
                  o = e.length,
                  l = [],
                  s = [];
                for (n = 0; n < o; n++) l.push([+a.call(this, e[n], n), +i.call(this, e[n], n), n]);
                for (l.sort(Dt), n = 0; n < o; n++) s.push([l[n][0], -l[n][1]]);
                var c = Ot(l),
                  u = Ot(s),
                  f = u[0] === c[0],
                  d = u[u.length - 1] === c[c.length - 1],
                  h = [];
                for (n = c.length - 1; n >= 0; --n) h.push(e[l[c[n]][2]]);
                for (n = +f; n < u.length - d; ++n) h.push(e[l[u[n]][2]]);
                return h;
              }
              return n.x = function (e) {
                return arguments.length ? (t = e, n) : t;
              }, n.y = function (e) {
                return arguments.length ? (r = e, n) : r;
              }, n;
            }, i.geom.polygon = function (e) {
              return G(e, Pt), e;
            };
            var Pt = i.geom.polygon.prototype = [];
            function zt(e, t, r) {
              return (r[0] - t[0]) * (e[1] - t[1]) < (r[1] - t[1]) * (e[0] - t[0]);
            }
            function It(e, t, r, n) {
              var a = e[0],
                i = r[0],
                o = t[0] - a,
                l = n[0] - i,
                s = e[1],
                c = r[1],
                u = t[1] - s,
                f = n[1] - c,
                d = (l * (s - c) - f * (a - i)) / (f * o - l * u);
              return [a + d * o, s + d * u];
            }
            function Et(e) {
              var t = e[0],
                r = e[e.length - 1];
              return !(t[0] - r[0] || t[1] - r[1]);
            }
            Pt.area = function () {
              for (var e, t = -1, r = this.length, n = this[r - 1], a = 0; ++t < r;) e = n, n = this[t], a += e[1] * n[0] - e[0] * n[1];
              return .5 * a;
            }, Pt.centroid = function (e) {
              var t,
                r,
                n = -1,
                a = this.length,
                i = 0,
                o = 0,
                l = this[a - 1];
              for (arguments.length || (e = -1 / (6 * this.area())); ++n < a;) t = l, l = this[n], r = t[0] * l[1] - l[0] * t[1], i += (t[0] + l[0]) * r, o += (t[1] + l[1]) * r;
              return [i * e, o * e];
            }, Pt.clip = function (e) {
              for (var t, r, n, a, i, o, l = Et(e), s = -1, c = this.length - Et(this), u = this[c - 1]; ++s < c;) {
                for (t = e.slice(), e.length = 0, a = this[s], i = t[(n = t.length - l) - 1], r = -1; ++r < n;) zt(o = t[r], u, a) ? (zt(i, u, a) || e.push(It(i, o, u, a)), e.push(o)) : zt(i, u, a) && e.push(It(i, o, u, a)), i = o;
                l && e.push(e[0]), u = a;
              }
              return e;
            };
            var Rt,
              Nt,
              Ft,
              Ht,
              Bt,
              jt = [],
              Yt = [];
            function Vt() {
              lr(this), this.edge = this.site = this.circle = null;
            }
            function Ut(e) {
              var t = jt.pop() || new Vt();
              return t.site = e, t;
            }
            function qt(e) {
              er(e), Ft.remove(e), jt.push(e), lr(e);
            }
            function Gt(e) {
              var t = e.circle,
                r = t.x,
                n = t.cy,
                a = {
                  x: r,
                  y: n
                },
                i = e.P,
                o = e.N,
                l = [e];
              qt(e);
              for (var s = i; s.circle && w(r - s.circle.x) < Se && w(n - s.circle.cy) < Se;) i = s.P, l.unshift(s), qt(s), s = i;
              l.unshift(s), er(s);
              for (var c = o; c.circle && w(r - c.circle.x) < Se && w(n - c.circle.cy) < Se;) o = c.N, l.push(c), qt(c), c = o;
              l.push(c), er(c);
              var u,
                f = l.length;
              for (u = 1; u < f; ++u) c = l[u], s = l[u - 1], ar(c.edge, s.site, c.site, a);
              s = l[0], (c = l[f - 1]).edge = nr(s.site, c.site, null, a), $t(s), $t(c);
            }
            function Zt(e) {
              for (var t, r, n, a, i = e.x, o = e.y, l = Ft._; l;) if ((n = Wt(l, o) - i) > Se) l = l.L;else {
                if (!((a = i - Jt(l, o)) > Se)) {
                  n > -Se ? (t = l.P, r = l) : a > -Se ? (t = l, r = l.N) : t = r = l;
                  break;
                }
                if (!l.R) {
                  t = l;
                  break;
                }
                l = l.R;
              }
              var s = Ut(e);
              if (Ft.insert(t, s), t || r) {
                if (t === r) return er(t), r = Ut(t.site), Ft.insert(s, r), s.edge = r.edge = nr(t.site, s.site), $t(t), void $t(r);
                if (r) {
                  er(t), er(r);
                  var c = t.site,
                    u = c.x,
                    f = c.y,
                    d = e.x - u,
                    h = e.y - f,
                    p = r.site,
                    v = p.x - u,
                    g = p.y - f,
                    m = 2 * (d * g - h * v),
                    y = d * d + h * h,
                    x = v * v + g * g,
                    b = {
                      x: (g * y - h * x) / m + u,
                      y: (d * x - v * y) / m + f
                    };
                  ar(r.edge, c, p, b), s.edge = nr(c, e, null, b), r.edge = nr(e, p, null, b), $t(t), $t(r);
                } else s.edge = nr(t.site, s.site);
              }
            }
            function Wt(e, t) {
              var r = e.site,
                n = r.x,
                a = r.y,
                i = a - t;
              if (!i) return n;
              var o = e.P;
              if (!o) return -1 / 0;
              var l = (r = o.site).x,
                s = r.y,
                c = s - t;
              if (!c) return l;
              var u = l - n,
                f = 1 / i - 1 / c,
                d = u / c;
              return f ? (-d + Math.sqrt(d * d - 2 * f * (u * u / (-2 * c) - s + c / 2 + a - i / 2))) / f + n : (n + l) / 2;
            }
            function Jt(e, t) {
              var r = e.N;
              if (r) return Wt(r, t);
              var n = e.site;
              return n.y === t ? n.x : 1 / 0;
            }
            function Xt(e) {
              this.site = e, this.edges = [];
            }
            function Kt(e, t) {
              return t.angle - e.angle;
            }
            function Qt() {
              lr(this), this.x = this.y = this.arc = this.site = this.cy = null;
            }
            function $t(e) {
              var t = e.P,
                r = e.N;
              if (t && r) {
                var n = t.site,
                  a = e.site,
                  i = r.site;
                if (n !== i) {
                  var o = a.x,
                    l = a.y,
                    s = n.x - o,
                    c = n.y - l,
                    u = i.x - o,
                    f = 2 * (s * (g = i.y - l) - c * u);
                  if (!(f >= -Ce)) {
                    var d = s * s + c * c,
                      h = u * u + g * g,
                      p = (g * d - c * h) / f,
                      v = (s * h - u * d) / f,
                      g = v + l,
                      m = Yt.pop() || new Qt();
                    m.arc = e, m.site = a, m.x = p + o, m.y = g + Math.sqrt(p * p + v * v), m.cy = g, e.circle = m;
                    for (var y = null, x = Bt._; x;) if (m.y < x.y || m.y === x.y && m.x <= x.x) {
                      if (!x.L) {
                        y = x.P;
                        break;
                      }
                      x = x.L;
                    } else {
                      if (!x.R) {
                        y = x;
                        break;
                      }
                      x = x.R;
                    }
                    Bt.insert(y, m), y || (Ht = m);
                  }
                }
              }
            }
            function er(e) {
              var t = e.circle;
              t && (t.P || (Ht = t.N), Bt.remove(t), Yt.push(t), lr(t), e.circle = null);
            }
            function tr(e, t) {
              var r = e.b;
              if (r) return !0;
              var n,
                a,
                i = e.a,
                o = t[0][0],
                l = t[1][0],
                s = t[0][1],
                c = t[1][1],
                u = e.l,
                f = e.r,
                d = u.x,
                h = u.y,
                p = f.x,
                v = f.y,
                g = (d + p) / 2,
                m = (h + v) / 2;
              if (v === h) {
                if (g < o || g >= l) return;
                if (d > p) {
                  if (i) {
                    if (i.y >= c) return;
                  } else i = {
                    x: g,
                    y: s
                  };
                  r = {
                    x: g,
                    y: c
                  };
                } else {
                  if (i) {
                    if (i.y < s) return;
                  } else i = {
                    x: g,
                    y: c
                  };
                  r = {
                    x: g,
                    y: s
                  };
                }
              } else if (a = m - (n = (d - p) / (v - h)) * g, n < -1 || n > 1) {
                if (d > p) {
                  if (i) {
                    if (i.y >= c) return;
                  } else i = {
                    x: (s - a) / n,
                    y: s
                  };
                  r = {
                    x: (c - a) / n,
                    y: c
                  };
                } else {
                  if (i) {
                    if (i.y < s) return;
                  } else i = {
                    x: (c - a) / n,
                    y: c
                  };
                  r = {
                    x: (s - a) / n,
                    y: s
                  };
                }
              } else if (h < v) {
                if (i) {
                  if (i.x >= l) return;
                } else i = {
                  x: o,
                  y: n * o + a
                };
                r = {
                  x: l,
                  y: n * l + a
                };
              } else {
                if (i) {
                  if (i.x < o) return;
                } else i = {
                  x: l,
                  y: n * l + a
                };
                r = {
                  x: o,
                  y: n * o + a
                };
              }
              return e.a = i, e.b = r, !0;
            }
            function rr(e, t) {
              this.l = e, this.r = t, this.a = this.b = null;
            }
            function nr(e, t, r, n) {
              var a = new rr(e, t);
              return Rt.push(a), r && ar(a, e, t, r), n && ar(a, t, e, n), Nt[e.i].edges.push(new ir(a, e, t)), Nt[t.i].edges.push(new ir(a, t, e)), a;
            }
            function ar(e, t, r, n) {
              e.a || e.b ? e.l === r ? e.b = n : e.a = n : (e.a = n, e.l = t, e.r = r);
            }
            function ir(e, t, r) {
              var n = e.a,
                a = e.b;
              this.edge = e, this.site = t, this.angle = r ? Math.atan2(r.y - t.y, r.x - t.x) : e.l === t ? Math.atan2(a.x - n.x, n.y - a.y) : Math.atan2(n.x - a.x, a.y - n.y);
            }
            function or() {
              this._ = null;
            }
            function lr(e) {
              e.U = e.C = e.L = e.R = e.P = e.N = null;
            }
            function sr(e, t) {
              var r = t,
                n = t.R,
                a = r.U;
              a ? a.L === r ? a.L = n : a.R = n : e._ = n, n.U = a, r.U = n, r.R = n.L, r.R && (r.R.U = r), n.L = r;
            }
            function cr(e, t) {
              var r = t,
                n = t.L,
                a = r.U;
              a ? a.L === r ? a.L = n : a.R = n : e._ = n, n.U = a, r.U = n, r.L = n.R, r.L && (r.L.U = r), n.R = r;
            }
            function ur(e) {
              for (; e.L;) e = e.L;
              return e;
            }
            function fr(e, t) {
              var r,
                n,
                a,
                i = e.sort(dr).pop();
              for (Rt = [], Nt = new Array(e.length), Ft = new or(), Bt = new or();;) if (a = Ht, i && (!a || i.y < a.y || i.y === a.y && i.x < a.x)) i.x === r && i.y === n || (Nt[i.i] = new Xt(i), Zt(i), r = i.x, n = i.y), i = e.pop();else {
                if (!a) break;
                Gt(a.arc);
              }
              t && (function (e) {
                for (var t, r, n, a, i, o = Rt, l = (r = e[0][0], n = e[0][1], a = e[1][0], i = e[1][1], function (e) {
                    var t,
                      o = e.a,
                      l = e.b,
                      s = o.x,
                      c = o.y,
                      u = 0,
                      f = 1,
                      d = l.x - s,
                      h = l.y - c;
                    if (t = r - s, d || !(t > 0)) {
                      if (t /= d, d < 0) {
                        if (t < u) return;
                        t < f && (f = t);
                      } else if (d > 0) {
                        if (t > f) return;
                        t > u && (u = t);
                      }
                      if (t = a - s, d || !(t < 0)) {
                        if (t /= d, d < 0) {
                          if (t > f) return;
                          t > u && (u = t);
                        } else if (d > 0) {
                          if (t < u) return;
                          t < f && (f = t);
                        }
                        if (t = n - c, h || !(t > 0)) {
                          if (t /= h, h < 0) {
                            if (t < u) return;
                            t < f && (f = t);
                          } else if (h > 0) {
                            if (t > f) return;
                            t > u && (u = t);
                          }
                          if (t = i - c, h || !(t < 0)) {
                            if (t /= h, h < 0) {
                              if (t > f) return;
                              t > u && (u = t);
                            } else if (h > 0) {
                              if (t < u) return;
                              t < f && (f = t);
                            }
                            return u > 0 && (e.a = {
                              x: s + u * d,
                              y: c + u * h
                            }), f < 1 && (e.b = {
                              x: s + f * d,
                              y: c + f * h
                            }), e;
                          }
                        }
                      }
                    }
                  }), s = o.length; s--;) (!tr(t = o[s], e) || !l(t) || w(t.a.x - t.b.x) < Se && w(t.a.y - t.b.y) < Se) && (t.a = t.b = null, o.splice(s, 1));
              }(t), function (e) {
                for (var t, r, n, a, i, o, l, s, c, u, f = e[0][0], d = e[1][0], h = e[0][1], p = e[1][1], v = Nt, g = v.length; g--;) if ((i = v[g]) && i.prepare()) for (s = (l = i.edges).length, o = 0; o < s;) n = (u = l[o].end()).x, a = u.y, t = (c = l[++o % s].start()).x, r = c.y, (w(n - t) > Se || w(a - r) > Se) && (l.splice(o, 0, new ir((m = i.site, y = u, x = w(n - f) < Se && p - a > Se ? {
                  x: f,
                  y: w(t - f) < Se ? r : p
                } : w(a - p) < Se && d - n > Se ? {
                  x: w(r - p) < Se ? t : d,
                  y: p
                } : w(n - d) < Se && a - h > Se ? {
                  x: d,
                  y: w(t - d) < Se ? r : h
                } : w(a - h) < Se && n - f > Se ? {
                  x: w(r - h) < Se ? t : f,
                  y: h
                } : null, b = void 0, (b = new rr(m, null)).a = y, b.b = x, Rt.push(b), b), i.site, null)), ++s);
                var m, y, x, b;
              }(t));
              var o = {
                cells: Nt,
                edges: Rt
              };
              return Ft = Bt = Rt = Nt = null, o;
            }
            function dr(e, t) {
              return t.y - e.y || t.x - e.x;
            }
            Xt.prototype.prepare = function () {
              for (var e, t = this.edges, r = t.length; r--;) (e = t[r].edge).b && e.a || t.splice(r, 1);
              return t.sort(Kt), t.length;
            }, ir.prototype = {
              start: function () {
                return this.edge.l === this.site ? this.edge.a : this.edge.b;
              },
              end: function () {
                return this.edge.l === this.site ? this.edge.b : this.edge.a;
              }
            }, or.prototype = {
              insert: function (e, t) {
                var r, n, a;
                if (e) {
                  if (t.P = e, t.N = e.N, e.N && (e.N.P = t), e.N = t, e.R) {
                    for (e = e.R; e.L;) e = e.L;
                    e.L = t;
                  } else e.R = t;
                  r = e;
                } else this._ ? (e = ur(this._), t.P = null, t.N = e, e.P = e.L = t, r = e) : (t.P = t.N = null, this._ = t, r = null);
                for (t.L = t.R = null, t.U = r, t.C = !0, e = t; r && r.C;) r === (n = r.U).L ? (a = n.R) && a.C ? (r.C = a.C = !1, n.C = !0, e = n) : (e === r.R && (sr(this, r), r = (e = r).U), r.C = !1, n.C = !0, cr(this, n)) : (a = n.L) && a.C ? (r.C = a.C = !1, n.C = !0, e = n) : (e === r.L && (cr(this, r), r = (e = r).U), r.C = !1, n.C = !0, sr(this, n)), r = e.U;
                this._.C = !1;
              },
              remove: function (e) {
                e.N && (e.N.P = e.P), e.P && (e.P.N = e.N), e.N = e.P = null;
                var t,
                  r,
                  n,
                  a = e.U,
                  i = e.L,
                  o = e.R;
                if (r = i ? o ? ur(o) : i : o, a ? a.L === e ? a.L = r : a.R = r : this._ = r, i && o ? (n = r.C, r.C = e.C, r.L = i, i.U = r, r !== o ? (a = r.U, r.U = e.U, e = r.R, a.L = e, r.R = o, o.U = r) : (r.U = a, a = r, e = r.R)) : (n = e.C, e = r), e && (e.U = a), !n) if (e && e.C) e.C = !1;else {
                  do {
                    if (e === this._) break;
                    if (e === a.L) {
                      if ((t = a.R).C && (t.C = !1, a.C = !0, sr(this, a), t = a.R), t.L && t.L.C || t.R && t.R.C) {
                        t.R && t.R.C || (t.L.C = !1, t.C = !0, cr(this, t), t = a.R), t.C = a.C, a.C = t.R.C = !1, sr(this, a), e = this._;
                        break;
                      }
                    } else if ((t = a.L).C && (t.C = !1, a.C = !0, cr(this, a), t = a.L), t.L && t.L.C || t.R && t.R.C) {
                      t.L && t.L.C || (t.R.C = !1, t.C = !0, sr(this, t), t = a.L), t.C = a.C, a.C = t.L.C = !1, cr(this, a), e = this._;
                      break;
                    }
                    t.C = !0, e = a, a = a.U;
                  } while (!e.C);
                  e && (e.C = !1);
                }
              }
            }, i.geom.voronoi = function (e) {
              var t = St,
                r = Ct,
                n = t,
                a = r,
                i = hr;
              if (e) return o(e);
              function o(e) {
                var t = new Array(e.length),
                  r = i[0][0],
                  n = i[0][1],
                  a = i[1][0],
                  o = i[1][1];
                return fr(l(e), i).cells.forEach(function (i, l) {
                  var s = i.edges,
                    c = i.site;
                  (t[l] = s.length ? s.map(function (e) {
                    var t = e.start();
                    return [t.x, t.y];
                  }) : c.x >= r && c.x <= a && c.y >= n && c.y <= o ? [[r, o], [a, o], [a, n], [r, n]] : []).point = e[l];
                }), t;
              }
              function l(e) {
                return e.map(function (e, t) {
                  return {
                    x: Math.round(n(e, t) / Se) * Se,
                    y: Math.round(a(e, t) / Se) * Se,
                    i: t
                  };
                });
              }
              return o.links = function (e) {
                return fr(l(e)).edges.filter(function (e) {
                  return e.l && e.r;
                }).map(function (t) {
                  return {
                    source: e[t.l.i],
                    target: e[t.r.i]
                  };
                });
              }, o.triangles = function (e) {
                var t = [];
                return fr(l(e)).cells.forEach(function (r, n) {
                  for (var a, i, o, l, s = r.site, c = r.edges.sort(Kt), u = -1, f = c.length, d = c[f - 1].edge, h = d.l === s ? d.r : d.l; ++u < f;) a = h, h = (d = c[u].edge).l === s ? d.r : d.l, n < a.i && n < h.i && (o = a, l = h, ((i = s).x - l.x) * (o.y - i.y) - (i.x - o.x) * (l.y - i.y) < 0) && t.push([e[n], e[a.i], e[h.i]]);
                }), t;
              }, o.x = function (e) {
                return arguments.length ? (n = gt(t = e), o) : t;
              }, o.y = function (e) {
                return arguments.length ? (a = gt(r = e), o) : r;
              }, o.clipExtent = function (e) {
                return arguments.length ? (i = null == e ? hr : e, o) : i === hr ? null : i;
              }, o.size = function (e) {
                return arguments.length ? o.clipExtent(e && [[0, 0], e]) : i === hr ? null : i && i[1];
              }, o;
            };
            var hr = [[-1e6, -1e6], [1e6, 1e6]];
            function pr(e) {
              return e.x;
            }
            function vr(e) {
              return e.y;
            }
            function gr(e, t, r, n, a, i) {
              if (!e(t, r, n, a, i)) {
                var o = .5 * (r + a),
                  l = .5 * (n + i),
                  s = t.nodes;
                s[0] && gr(e, s[0], r, n, o, l), s[1] && gr(e, s[1], o, n, a, l), s[2] && gr(e, s[2], r, l, o, i), s[3] && gr(e, s[3], o, l, a, i);
              }
            }
            function mr(e, t) {
              e = i.rgb(e), t = i.rgb(t);
              var r = e.r,
                n = e.g,
                a = e.b,
                o = t.r - r,
                l = t.g - n,
                s = t.b - a;
              return function (e) {
                return "#" + ct(Math.round(r + o * e)) + ct(Math.round(n + l * e)) + ct(Math.round(a + s * e));
              };
            }
            function yr(e, t) {
              var r,
                n = {},
                a = {};
              for (r in e) r in t ? n[r] = Tr(e[r], t[r]) : a[r] = e[r];
              for (r in t) r in e || (a[r] = t[r]);
              return function (e) {
                for (r in n) a[r] = n[r](e);
                return a;
              };
            }
            function xr(e, t) {
              return e = +e, t = +t, function (r) {
                return e * (1 - r) + t * r;
              };
            }
            function br(e, t) {
              var r,
                n,
                a,
                i = _r.lastIndex = wr.lastIndex = 0,
                o = -1,
                l = [],
                s = [];
              for (e += "", t += ""; (r = _r.exec(e)) && (n = wr.exec(t));) (a = n.index) > i && (a = t.slice(i, a), l[o] ? l[o] += a : l[++o] = a), (r = r[0]) === (n = n[0]) ? l[o] ? l[o] += n : l[++o] = n : (l[++o] = null, s.push({
                i: o,
                x: xr(r, n)
              })), i = wr.lastIndex;
              return i < t.length && (a = t.slice(i), l[o] ? l[o] += a : l[++o] = a), l.length < 2 ? s[0] ? (t = s[0].x, function (e) {
                return t(e) + "";
              }) : function () {
                return t;
              } : (t = s.length, function (e) {
                for (var r, n = 0; n < t; ++n) l[(r = s[n]).i] = r.x(e);
                return l.join("");
              });
            }
            i.geom.delaunay = function (e) {
              return i.geom.voronoi().triangles(e);
            }, i.geom.quadtree = function (e, t, r, n, a) {
              var i,
                o = St,
                l = Ct;
              if (i = arguments.length) return o = pr, l = vr, 3 === i && (a = r, n = t, r = t = 0), s(e);
              function s(e) {
                var s,
                  c,
                  u,
                  f,
                  d,
                  h,
                  p,
                  v,
                  g,
                  m = gt(o),
                  y = gt(l);
                if (null != t) h = t, p = r, v = n, g = a;else if (v = g = -(h = p = 1 / 0), c = [], u = [], d = e.length, i) for (f = 0; f < d; ++f) (s = e[f]).x < h && (h = s.x), s.y < p && (p = s.y), s.x > v && (v = s.x), s.y > g && (g = s.y), c.push(s.x), u.push(s.y);else for (f = 0; f < d; ++f) {
                  var x = +m(s = e[f], f),
                    b = +y(s, f);
                  x < h && (h = x), b < p && (p = b), x > v && (v = x), b > g && (g = b), c.push(x), u.push(b);
                }
                var _ = v - h,
                  T = g - p;
                function M(e, t, r, n, a, i, o, l) {
                  if (!isNaN(r) && !isNaN(n)) if (e.leaf) {
                    var s = e.x,
                      c = e.y;
                    if (null != s) {
                      if (w(s - r) + w(c - n) < .01) k(e, t, r, n, a, i, o, l);else {
                        var u = e.point;
                        e.x = e.y = e.point = null, k(e, u, s, c, a, i, o, l), k(e, t, r, n, a, i, o, l);
                      }
                    } else e.x = r, e.y = n, e.point = t;
                  } else k(e, t, r, n, a, i, o, l);
                }
                function k(e, t, r, n, a, i, o, l) {
                  var s = .5 * (a + o),
                    c = .5 * (i + l),
                    u = r >= s,
                    f = n >= c,
                    d = f << 1 | u;
                  e.leaf = !1, u ? a = s : o = s, f ? i = c : l = c, M(e = e.nodes[d] || (e.nodes[d] = {
                    leaf: !0,
                    nodes: [],
                    point: null,
                    x: null,
                    y: null
                  }), t, r, n, a, i, o, l);
                }
                _ > T ? g = p + _ : v = h + T;
                var A = {
                  leaf: !0,
                  nodes: [],
                  point: null,
                  x: null,
                  y: null,
                  add: function (e) {
                    M(A, e, +m(e, ++f), +y(e, f), h, p, v, g);
                  }
                };
                if (A.visit = function (e) {
                  gr(e, A, h, p, v, g);
                }, A.find = function (e) {
                  return function (e, t, r, n, a, i, o) {
                    var l,
                      s = 1 / 0;
                    return function e(c, u, f, d, h) {
                      if (!(u > i || f > o || d < n || h < a)) {
                        if (p = c.point) {
                          var p,
                            v = t - c.x,
                            g = r - c.y,
                            m = v * v + g * g;
                          if (m < s) {
                            var y = Math.sqrt(s = m);
                            n = t - y, a = r - y, i = t + y, o = r + y, l = p;
                          }
                        }
                        for (var x = c.nodes, b = .5 * (u + d), _ = .5 * (f + h), w = (r >= _) << 1 | t >= b, T = w + 4; w < T; ++w) if (c = x[3 & w]) switch (3 & w) {
                          case 0:
                            e(c, u, f, b, _);
                            break;
                          case 1:
                            e(c, b, f, d, _);
                            break;
                          case 2:
                            e(c, u, _, b, h);
                            break;
                          case 3:
                            e(c, b, _, d, h);
                        }
                      }
                    }(e, n, a, i, o), l;
                  }(A, e[0], e[1], h, p, v, g);
                }, f = -1, null == t) {
                  for (; ++f < d;) M(A, e[f], c[f], u[f], h, p, v, g);
                  --f;
                } else e.forEach(A.add);
                return c = u = e = s = null, A;
              }
              return s.x = function (e) {
                return arguments.length ? (o = e, s) : o;
              }, s.y = function (e) {
                return arguments.length ? (l = e, s) : l;
              }, s.extent = function (e) {
                return arguments.length ? (null == e ? t = r = n = a = null : (t = +e[0][0], r = +e[0][1], n = +e[1][0], a = +e[1][1]), s) : null == t ? null : [[t, r], [n, a]];
              }, s.size = function (e) {
                return arguments.length ? (null == e ? t = r = n = a = null : (t = r = 0, n = +e[0], a = +e[1]), s) : null == t ? null : [n - t, a - r];
              }, s;
            }, i.interpolateRgb = mr, i.interpolateObject = yr, i.interpolateNumber = xr, i.interpolateString = br;
            var _r = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
              wr = new RegExp(_r.source, "g");
            function Tr(e, t) {
              for (var r, n = i.interpolators.length; --n >= 0 && !(r = i.interpolators[n](e, t)););
              return r;
            }
            function Mr(e, t) {
              var r,
                n = [],
                a = [],
                i = e.length,
                o = t.length,
                l = Math.min(e.length, t.length);
              for (r = 0; r < l; ++r) n.push(Tr(e[r], t[r]));
              for (; r < i; ++r) a[r] = e[r];
              for (; r < o; ++r) a[r] = t[r];
              return function (e) {
                for (r = 0; r < l; ++r) a[r] = n[r](e);
                return a;
              };
            }
            i.interpolate = Tr, i.interpolators = [function (e, t) {
              var r = typeof t;
              return ("string" === r ? vt.has(t.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(t) ? mr : br : t instanceof Ye ? mr : Array.isArray(t) ? Mr : "object" === r && isNaN(t) ? yr : xr)(e, t);
            }], i.interpolateArray = Mr;
            var kr = function () {
                return E;
              },
              Ar = i.map({
                linear: kr,
                poly: function (e) {
                  return function (t) {
                    return Math.pow(t, e);
                  };
                },
                quad: function () {
                  return Or;
                },
                cubic: function () {
                  return Dr;
                },
                sin: function () {
                  return zr;
                },
                exp: function () {
                  return Ir;
                },
                circle: function () {
                  return Er;
                },
                elastic: function (e, t) {
                  var r;
                  return arguments.length < 2 && (t = .45), arguments.length ? r = t / De * Math.asin(1 / e) : (e = 1, r = t / 4), function (n) {
                    return 1 + e * Math.pow(2, -10 * n) * Math.sin((n - r) * De / t);
                  };
                },
                back: function (e) {
                  return e || (e = 1.70158), function (t) {
                    return t * t * ((e + 1) * t - e);
                  };
                },
                bounce: function () {
                  return Rr;
                }
              }),
              Lr = i.map({
                in: E,
                out: Sr,
                "in-out": Cr,
                "out-in": function (e) {
                  return Cr(Sr(e));
                }
              });
            function Sr(e) {
              return function (t) {
                return 1 - e(1 - t);
              };
            }
            function Cr(e) {
              return function (t) {
                return .5 * (t < .5 ? e(2 * t) : 2 - e(2 - 2 * t));
              };
            }
            function Or(e) {
              return e * e;
            }
            function Dr(e) {
              return e * e * e;
            }
            function Pr(e) {
              if (e <= 0) return 0;
              if (e >= 1) return 1;
              var t = e * e,
                r = t * e;
              return 4 * (e < .5 ? r : 3 * (e - t) + r - .75);
            }
            function zr(e) {
              return 1 - Math.cos(e * ze);
            }
            function Ir(e) {
              return Math.pow(2, 10 * (e - 1));
            }
            function Er(e) {
              return 1 - Math.sqrt(1 - e * e);
            }
            function Rr(e) {
              return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375;
            }
            function Nr(e, t) {
              return t -= e, function (r) {
                return Math.round(e + t * r);
              };
            }
            function Fr(e) {
              var t,
                r,
                n,
                a = [e.a, e.b],
                i = [e.c, e.d],
                o = Br(a),
                l = Hr(a, i),
                s = Br(((t = i)[0] += (n = -l) * (r = a)[0], t[1] += n * r[1], t)) || 0;
              a[0] * i[1] < i[0] * a[1] && (a[0] *= -1, a[1] *= -1, o *= -1, l *= -1), this.rotate = (o ? Math.atan2(a[1], a[0]) : Math.atan2(-i[0], i[1])) * Ee, this.translate = [e.e, e.f], this.scale = [o, s], this.skew = s ? Math.atan2(l, s) * Ee : 0;
            }
            function Hr(e, t) {
              return e[0] * t[0] + e[1] * t[1];
            }
            function Br(e) {
              var t = Math.sqrt(Hr(e, e));
              return t && (e[0] /= t, e[1] /= t), t;
            }
            i.ease = function (e) {
              var t,
                r = e.indexOf("-"),
                n = r >= 0 ? e.slice(0, r) : e,
                a = r >= 0 ? e.slice(r + 1) : "in";
              return n = Ar.get(n) || kr, a = Lr.get(a) || E, t = a(n.apply(null, o.call(arguments, 1))), function (e) {
                return e <= 0 ? 0 : e >= 1 ? 1 : t(e);
              };
            }, i.interpolateHcl = function (e, t) {
              e = i.hcl(e), t = i.hcl(t);
              var r = e.h,
                n = e.c,
                a = e.l,
                o = t.h - r,
                l = t.c - n,
                s = t.l - a;
              return isNaN(l) && (l = 0, n = isNaN(n) ? t.c : n), isNaN(o) ? (o = 0, r = isNaN(r) ? t.h : r) : o > 180 ? o -= 360 : o < -180 && (o += 360), function (e) {
                return We(r + o * e, n + l * e, a + s * e) + "";
              };
            }, i.interpolateHsl = function (e, t) {
              e = i.hsl(e), t = i.hsl(t);
              var r = e.h,
                n = e.s,
                a = e.l,
                o = t.h - r,
                l = t.s - n,
                s = t.l - a;
              return isNaN(l) && (l = 0, n = isNaN(n) ? t.s : n), isNaN(o) ? (o = 0, r = isNaN(r) ? t.h : r) : o > 180 ? o -= 360 : o < -180 && (o += 360), function (e) {
                return qe(r + o * e, n + l * e, a + s * e) + "";
              };
            }, i.interpolateLab = function (e, t) {
              e = i.lab(e), t = i.lab(t);
              var r = e.l,
                n = e.a,
                a = e.b,
                o = t.l - r,
                l = t.a - n,
                s = t.b - a;
              return function (e) {
                return tt(r + o * e, n + l * e, a + s * e) + "";
              };
            }, i.interpolateRound = Nr, i.transform = function (e) {
              var t = s.createElementNS(i.ns.prefix.svg, "g");
              return (i.transform = function (e) {
                if (null != e) {
                  t.setAttribute("transform", e);
                  var r = t.transform.baseVal.consolidate();
                }
                return new Fr(r ? r.matrix : jr);
              })(e);
            }, Fr.prototype.toString = function () {
              return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
            };
            var jr = {
              a: 1,
              b: 0,
              c: 0,
              d: 1,
              e: 0,
              f: 0
            };
            function Yr(e) {
              return e.length ? e.pop() + "," : "";
            }
            function Vr(e, t) {
              var r = [],
                n = [];
              return e = i.transform(e), t = i.transform(t), function (e, t, r, n) {
                if (e[0] !== t[0] || e[1] !== t[1]) {
                  var a = r.push("translate(", null, ",", null, ")");
                  n.push({
                    i: a - 4,
                    x: xr(e[0], t[0])
                  }, {
                    i: a - 2,
                    x: xr(e[1], t[1])
                  });
                } else (t[0] || t[1]) && r.push("translate(" + t + ")");
              }(e.translate, t.translate, r, n), function (e, t, r, n) {
                e !== t ? (e - t > 180 ? t += 360 : t - e > 180 && (e += 360), n.push({
                  i: r.push(Yr(r) + "rotate(", null, ")") - 2,
                  x: xr(e, t)
                })) : t && r.push(Yr(r) + "rotate(" + t + ")");
              }(e.rotate, t.rotate, r, n), function (e, t, r, n) {
                e !== t ? n.push({
                  i: r.push(Yr(r) + "skewX(", null, ")") - 2,
                  x: xr(e, t)
                }) : t && r.push(Yr(r) + "skewX(" + t + ")");
              }(e.skew, t.skew, r, n), function (e, t, r, n) {
                if (e[0] !== t[0] || e[1] !== t[1]) {
                  var a = r.push(Yr(r) + "scale(", null, ",", null, ")");
                  n.push({
                    i: a - 4,
                    x: xr(e[0], t[0])
                  }, {
                    i: a - 2,
                    x: xr(e[1], t[1])
                  });
                } else 1 === t[0] && 1 === t[1] || r.push(Yr(r) + "scale(" + t + ")");
              }(e.scale, t.scale, r, n), e = t = null, function (e) {
                for (var t, a = -1, i = n.length; ++a < i;) r[(t = n[a]).i] = t.x(e);
                return r.join("");
              };
            }
            function Ur(e, t) {
              return t = (t -= e = +e) || 1 / t, function (r) {
                return (r - e) / t;
              };
            }
            function qr(e, t) {
              return t = (t -= e = +e) || 1 / t, function (r) {
                return Math.max(0, Math.min(1, (r - e) / t));
              };
            }
            function Gr(e) {
              for (var t = e.source, r = e.target, n = function (e, t) {
                  if (e === t) return e;
                  for (var r = Zr(e), n = Zr(t), a = r.pop(), i = n.pop(), o = null; a === i;) o = a, a = r.pop(), i = n.pop();
                  return o;
                }(t, r), a = [t]; t !== n;) t = t.parent, a.push(t);
              for (var i = a.length; r !== n;) a.splice(i, 0, r), r = r.parent;
              return a;
            }
            function Zr(e) {
              for (var t = [], r = e.parent; null != r;) t.push(e), e = r, r = r.parent;
              return t.push(e), t;
            }
            function Wr(e) {
              e.fixed |= 2;
            }
            function Jr(e) {
              e.fixed &= -7;
            }
            function Xr(e) {
              e.fixed |= 4, e.px = e.x, e.py = e.y;
            }
            function Kr(e) {
              e.fixed &= -5;
            }
            function Qr(e, t, r) {
              var n = 0,
                a = 0;
              if (e.charge = 0, !e.leaf) for (var i, o = e.nodes, l = o.length, s = -1; ++s < l;) null != (i = o[s]) && (Qr(i, t, r), e.charge += i.charge, n += i.charge * i.cx, a += i.charge * i.cy);
              if (e.point) {
                e.leaf || (e.point.x += Math.random() - .5, e.point.y += Math.random() - .5);
                var c = t * r[e.point.index];
                e.charge += e.pointCharge = c, n += c * e.point.x, a += c * e.point.y;
              }
              e.cx = n / e.charge, e.cy = a / e.charge;
            }
            i.interpolateTransform = Vr, i.layout = {}, i.layout.bundle = function () {
              return function (e) {
                for (var t = [], r = -1, n = e.length; ++r < n;) t.push(Gr(e[r]));
                return t;
              };
            }, i.layout.chord = function () {
              var e,
                t,
                r,
                n,
                a,
                o,
                l,
                s = {},
                c = 0;
              function u() {
                var s,
                  u,
                  d,
                  h,
                  p,
                  v = {},
                  g = [],
                  m = i.range(n),
                  y = [];
                for (e = [], t = [], s = 0, h = -1; ++h < n;) {
                  for (u = 0, p = -1; ++p < n;) u += r[h][p];
                  g.push(u), y.push(i.range(n)), s += u;
                }
                for (a && m.sort(function (e, t) {
                  return a(g[e], g[t]);
                }), o && y.forEach(function (e, t) {
                  e.sort(function (e, n) {
                    return o(r[t][e], r[t][n]);
                  });
                }), s = (De - c * n) / s, u = 0, h = -1; ++h < n;) {
                  for (d = u, p = -1; ++p < n;) {
                    var x = m[h],
                      b = y[x][p],
                      _ = r[x][b],
                      w = u,
                      T = u += _ * s;
                    v[x + "-" + b] = {
                      index: x,
                      subindex: b,
                      startAngle: w,
                      endAngle: T,
                      value: _
                    };
                  }
                  t[x] = {
                    index: x,
                    startAngle: d,
                    endAngle: u,
                    value: g[x]
                  }, u += c;
                }
                for (h = -1; ++h < n;) for (p = h - 1; ++p < n;) {
                  var M = v[h + "-" + p],
                    k = v[p + "-" + h];
                  (M.value || k.value) && e.push(M.value < k.value ? {
                    source: k,
                    target: M
                  } : {
                    source: M,
                    target: k
                  });
                }
                l && f();
              }
              function f() {
                e.sort(function (e, t) {
                  return l((e.source.value + e.target.value) / 2, (t.source.value + t.target.value) / 2);
                });
              }
              return s.matrix = function (a) {
                return arguments.length ? (n = (r = a) && r.length, e = t = null, s) : r;
              }, s.padding = function (r) {
                return arguments.length ? (c = r, e = t = null, s) : c;
              }, s.sortGroups = function (r) {
                return arguments.length ? (a = r, e = t = null, s) : a;
              }, s.sortSubgroups = function (t) {
                return arguments.length ? (o = t, e = null, s) : o;
              }, s.sortChords = function (t) {
                return arguments.length ? (l = t, e && f(), s) : l;
              }, s.chords = function () {
                return e || u(), e;
              }, s.groups = function () {
                return t || u(), t;
              }, s;
            }, i.layout.force = function () {
              var e,
                t,
                r,
                n,
                a,
                o,
                l = {},
                s = i.dispatch("start", "tick", "end"),
                c = [1, 1],
                u = .9,
                f = $r,
                d = en,
                h = -30,
                p = tn,
                v = .1,
                g = .64,
                m = [],
                y = [];
              function x(e) {
                return function (t, r, n, a) {
                  if (t.point !== e) {
                    var i = t.cx - e.x,
                      o = t.cy - e.y,
                      l = a - r,
                      s = i * i + o * o;
                    if (l * l / g < s) {
                      if (s < p) {
                        var c = t.charge / s;
                        e.px -= i * c, e.py -= o * c;
                      }
                      return !0;
                    }
                    t.point && s && s < p && (c = t.pointCharge / s, e.px -= i * c, e.py -= o * c);
                  }
                  return !t.charge;
                };
              }
              function b(e) {
                e.px = i.event.x, e.py = i.event.y, l.resume();
              }
              return l.tick = function () {
                if ((r *= .99) < .005) return e = null, s.end({
                  type: "end",
                  alpha: r = 0
                }), !0;
                var t,
                  l,
                  f,
                  d,
                  p,
                  g,
                  b,
                  _,
                  w,
                  T = m.length,
                  M = y.length;
                for (l = 0; l < M; ++l) d = (f = y[l]).source, (g = (_ = (p = f.target).x - d.x) * _ + (w = p.y - d.y) * w) && (_ *= g = r * a[l] * ((g = Math.sqrt(g)) - n[l]) / g, w *= g, p.x -= _ * (b = d.weight + p.weight ? d.weight / (d.weight + p.weight) : .5), p.y -= w * b, d.x += _ * (b = 1 - b), d.y += w * b);
                if ((b = r * v) && (_ = c[0] / 2, w = c[1] / 2, l = -1, b)) for (; ++l < T;) (f = m[l]).x += (_ - f.x) * b, f.y += (w - f.y) * b;
                if (h) for (Qr(t = i.geom.quadtree(m), r, o), l = -1; ++l < T;) (f = m[l]).fixed || t.visit(x(f));
                for (l = -1; ++l < T;) (f = m[l]).fixed ? (f.x = f.px, f.y = f.py) : (f.x -= (f.px - (f.px = f.x)) * u, f.y -= (f.py - (f.py = f.y)) * u);
                s.tick({
                  type: "tick",
                  alpha: r
                });
              }, l.nodes = function (e) {
                return arguments.length ? (m = e, l) : m;
              }, l.links = function (e) {
                return arguments.length ? (y = e, l) : y;
              }, l.size = function (e) {
                return arguments.length ? (c = e, l) : c;
              }, l.linkDistance = function (e) {
                return arguments.length ? (f = "function" == typeof e ? e : +e, l) : f;
              }, l.distance = l.linkDistance, l.linkStrength = function (e) {
                return arguments.length ? (d = "function" == typeof e ? e : +e, l) : d;
              }, l.friction = function (e) {
                return arguments.length ? (u = +e, l) : u;
              }, l.charge = function (e) {
                return arguments.length ? (h = "function" == typeof e ? e : +e, l) : h;
              }, l.chargeDistance = function (e) {
                return arguments.length ? (p = e * e, l) : Math.sqrt(p);
              }, l.gravity = function (e) {
                return arguments.length ? (v = +e, l) : v;
              }, l.theta = function (e) {
                return arguments.length ? (g = e * e, l) : Math.sqrt(g);
              }, l.alpha = function (t) {
                return arguments.length ? (t = +t, r ? t > 0 ? r = t : (e.c = null, e.t = NaN, e = null, s.end({
                  type: "end",
                  alpha: r = 0
                })) : t > 0 && (s.start({
                  type: "start",
                  alpha: r = t
                }), e = Mt(l.tick)), l) : r;
              }, l.start = function () {
                var e,
                  t,
                  r,
                  i = m.length,
                  s = y.length,
                  u = c[0],
                  p = c[1];
                for (e = 0; e < i; ++e) (r = m[e]).index = e, r.weight = 0;
                for (e = 0; e < s; ++e) "number" == typeof (r = y[e]).source && (r.source = m[r.source]), "number" == typeof r.target && (r.target = m[r.target]), ++r.source.weight, ++r.target.weight;
                for (e = 0; e < i; ++e) r = m[e], isNaN(r.x) && (r.x = v("x", u)), isNaN(r.y) && (r.y = v("y", p)), isNaN(r.px) && (r.px = r.x), isNaN(r.py) && (r.py = r.y);
                if (n = [], "function" == typeof f) for (e = 0; e < s; ++e) n[e] = +f.call(this, y[e], e);else for (e = 0; e < s; ++e) n[e] = f;
                if (a = [], "function" == typeof d) for (e = 0; e < s; ++e) a[e] = +d.call(this, y[e], e);else for (e = 0; e < s; ++e) a[e] = d;
                if (o = [], "function" == typeof h) for (e = 0; e < i; ++e) o[e] = +h.call(this, m[e], e);else for (e = 0; e < i; ++e) o[e] = h;
                function v(r, n) {
                  if (!t) {
                    for (t = new Array(i), c = 0; c < i; ++c) t[c] = [];
                    for (c = 0; c < s; ++c) {
                      var a = y[c];
                      t[a.source.index].push(a.target), t[a.target.index].push(a.source);
                    }
                  }
                  for (var o, l = t[e], c = -1, u = l.length; ++c < u;) if (!isNaN(o = l[c][r])) return o;
                  return Math.random() * n;
                }
                return l.resume();
              }, l.resume = function () {
                return l.alpha(.1);
              }, l.stop = function () {
                return l.alpha(0);
              }, l.drag = function () {
                if (t || (t = i.behavior.drag().origin(E).on("dragstart.force", Wr).on("drag.force", b).on("dragend.force", Jr)), !arguments.length) return t;
                this.on("mouseover.force", Xr).on("mouseout.force", Kr).call(t);
              }, i.rebind(l, s, "on");
            };
            var $r = 20,
              en = 1,
              tn = 1 / 0;
            function rn(e, t) {
              return i.rebind(e, t, "sort", "children", "value"), e.nodes = e, e.links = cn, e;
            }
            function nn(e, t) {
              for (var r = [e]; null != (e = r.pop());) if (t(e), (a = e.children) && (n = a.length)) for (var n, a; --n >= 0;) r.push(a[n]);
            }
            function an(e, t) {
              for (var r = [e], n = []; null != (e = r.pop());) if (n.push(e), (i = e.children) && (a = i.length)) for (var a, i, o = -1; ++o < a;) r.push(i[o]);
              for (; null != (e = n.pop());) t(e);
            }
            function on(e) {
              return e.children;
            }
            function ln(e) {
              return e.value;
            }
            function sn(e, t) {
              return t.value - e.value;
            }
            function cn(e) {
              return i.merge(e.map(function (e) {
                return (e.children || []).map(function (t) {
                  return {
                    source: e,
                    target: t
                  };
                });
              }));
            }
            i.layout.hierarchy = function () {
              var e = sn,
                t = on,
                r = ln;
              function n(a) {
                var i,
                  o = [a],
                  l = [];
                for (a.depth = 0; null != (i = o.pop());) if (l.push(i), (c = t.call(n, i, i.depth)) && (s = c.length)) {
                  for (var s, c, u; --s >= 0;) o.push(u = c[s]), u.parent = i, u.depth = i.depth + 1;
                  r && (i.value = 0), i.children = c;
                } else r && (i.value = +r.call(n, i, i.depth) || 0), delete i.children;
                return an(a, function (t) {
                  var n, a;
                  e && (n = t.children) && n.sort(e), r && (a = t.parent) && (a.value += t.value);
                }), l;
              }
              return n.sort = function (t) {
                return arguments.length ? (e = t, n) : e;
              }, n.children = function (e) {
                return arguments.length ? (t = e, n) : t;
              }, n.value = function (e) {
                return arguments.length ? (r = e, n) : r;
              }, n.revalue = function (e) {
                return r && (nn(e, function (e) {
                  e.children && (e.value = 0);
                }), an(e, function (e) {
                  var t;
                  e.children || (e.value = +r.call(n, e, e.depth) || 0), (t = e.parent) && (t.value += e.value);
                })), e;
              }, n;
            }, i.layout.partition = function () {
              var e = i.layout.hierarchy(),
                t = [1, 1];
              function r(e, t, n, a) {
                var i = e.children;
                if (e.x = t, e.y = e.depth * a, e.dx = n, e.dy = a, i && (o = i.length)) {
                  var o,
                    l,
                    s,
                    c = -1;
                  for (n = e.value ? n / e.value : 0; ++c < o;) r(l = i[c], t, s = l.value * n, a), t += s;
                }
              }
              function n(e) {
                var t = e.children,
                  r = 0;
                if (t && (a = t.length)) for (var a, i = -1; ++i < a;) r = Math.max(r, n(t[i]));
                return 1 + r;
              }
              function a(a, i) {
                var o = e.call(this, a, i);
                return r(o[0], 0, t[0], t[1] / n(o[0])), o;
              }
              return a.size = function (e) {
                return arguments.length ? (t = e, a) : t;
              }, rn(a, e);
            }, i.layout.pie = function () {
              var e = Number,
                t = un,
                r = 0,
                n = De,
                a = 0;
              function o(l) {
                var s,
                  c = l.length,
                  u = l.map(function (t, r) {
                    return +e.call(o, t, r);
                  }),
                  f = +("function" == typeof r ? r.apply(this, arguments) : r),
                  d = ("function" == typeof n ? n.apply(this, arguments) : n) - f,
                  h = Math.min(Math.abs(d) / c, +("function" == typeof a ? a.apply(this, arguments) : a)),
                  p = h * (d < 0 ? -1 : 1),
                  v = i.sum(u),
                  g = v ? (d - c * p) / v : 0,
                  m = i.range(c),
                  y = [];
                return null != t && m.sort(t === un ? function (e, t) {
                  return u[t] - u[e];
                } : function (e, r) {
                  return t(l[e], l[r]);
                }), m.forEach(function (e) {
                  y[e] = {
                    data: l[e],
                    value: s = u[e],
                    startAngle: f,
                    endAngle: f += s * g + p,
                    padAngle: h
                  };
                }), y;
              }
              return o.value = function (t) {
                return arguments.length ? (e = t, o) : e;
              }, o.sort = function (e) {
                return arguments.length ? (t = e, o) : t;
              }, o.startAngle = function (e) {
                return arguments.length ? (r = e, o) : r;
              }, o.endAngle = function (e) {
                return arguments.length ? (n = e, o) : n;
              }, o.padAngle = function (e) {
                return arguments.length ? (a = e, o) : a;
              }, o;
            };
            var un = {};
            function fn(e) {
              return e.x;
            }
            function dn(e) {
              return e.y;
            }
            function hn(e, t, r) {
              e.y0 = t, e.y = r;
            }
            i.layout.stack = function () {
              var e = E,
                t = gn,
                r = mn,
                n = hn,
                a = fn,
                o = dn;
              function l(s, c) {
                if (!(h = s.length)) return s;
                var u = s.map(function (t, r) {
                    return e.call(l, t, r);
                  }),
                  f = u.map(function (e) {
                    return e.map(function (e, t) {
                      return [a.call(l, e, t), o.call(l, e, t)];
                    });
                  }),
                  d = t.call(l, f, c);
                u = i.permute(u, d), f = i.permute(f, d);
                var h,
                  p,
                  v,
                  g,
                  m = r.call(l, f, c),
                  y = u[0].length;
                for (v = 0; v < y; ++v) for (n.call(l, u[0][v], g = m[v], f[0][v][1]), p = 1; p < h; ++p) n.call(l, u[p][v], g += f[p - 1][v][1], f[p][v][1]);
                return s;
              }
              return l.values = function (t) {
                return arguments.length ? (e = t, l) : e;
              }, l.order = function (e) {
                return arguments.length ? (t = "function" == typeof e ? e : pn.get(e) || gn, l) : t;
              }, l.offset = function (e) {
                return arguments.length ? (r = "function" == typeof e ? e : vn.get(e) || mn, l) : r;
              }, l.x = function (e) {
                return arguments.length ? (a = e, l) : a;
              }, l.y = function (e) {
                return arguments.length ? (o = e, l) : o;
              }, l.out = function (e) {
                return arguments.length ? (n = e, l) : n;
              }, l;
            };
            var pn = i.map({
                "inside-out": function (e) {
                  var t,
                    r,
                    n = e.length,
                    a = e.map(yn),
                    o = e.map(xn),
                    l = i.range(n).sort(function (e, t) {
                      return a[e] - a[t];
                    }),
                    s = 0,
                    c = 0,
                    u = [],
                    f = [];
                  for (t = 0; t < n; ++t) r = l[t], s < c ? (s += o[r], u.push(r)) : (c += o[r], f.push(r));
                  return f.reverse().concat(u);
                },
                reverse: function (e) {
                  return i.range(e.length).reverse();
                },
                default: gn
              }),
              vn = i.map({
                silhouette: function (e) {
                  var t,
                    r,
                    n,
                    a = e.length,
                    i = e[0].length,
                    o = [],
                    l = 0,
                    s = [];
                  for (r = 0; r < i; ++r) {
                    for (t = 0, n = 0; t < a; t++) n += e[t][r][1];
                    n > l && (l = n), o.push(n);
                  }
                  for (r = 0; r < i; ++r) s[r] = (l - o[r]) / 2;
                  return s;
                },
                wiggle: function (e) {
                  var t,
                    r,
                    n,
                    a,
                    i,
                    o,
                    l,
                    s,
                    c,
                    u = e.length,
                    f = e[0],
                    d = f.length,
                    h = [];
                  for (h[0] = s = c = 0, r = 1; r < d; ++r) {
                    for (t = 0, a = 0; t < u; ++t) a += e[t][r][1];
                    for (t = 0, i = 0, l = f[r][0] - f[r - 1][0]; t < u; ++t) {
                      for (n = 0, o = (e[t][r][1] - e[t][r - 1][1]) / (2 * l); n < t; ++n) o += (e[n][r][1] - e[n][r - 1][1]) / l;
                      i += o * e[t][r][1];
                    }
                    h[r] = s -= a ? i / a * l : 0, s < c && (c = s);
                  }
                  for (r = 0; r < d; ++r) h[r] -= c;
                  return h;
                },
                expand: function (e) {
                  var t,
                    r,
                    n,
                    a = e.length,
                    i = e[0].length,
                    o = 1 / a,
                    l = [];
                  for (r = 0; r < i; ++r) {
                    for (t = 0, n = 0; t < a; t++) n += e[t][r][1];
                    if (n) for (t = 0; t < a; t++) e[t][r][1] /= n;else for (t = 0; t < a; t++) e[t][r][1] = o;
                  }
                  for (r = 0; r < i; ++r) l[r] = 0;
                  return l;
                },
                zero: mn
              });
            function gn(e) {
              return i.range(e.length);
            }
            function mn(e) {
              for (var t = -1, r = e[0].length, n = []; ++t < r;) n[t] = 0;
              return n;
            }
            function yn(e) {
              for (var t, r = 1, n = 0, a = e[0][1], i = e.length; r < i; ++r) (t = e[r][1]) > a && (n = r, a = t);
              return n;
            }
            function xn(e) {
              return e.reduce(bn, 0);
            }
            function bn(e, t) {
              return e + t[1];
            }
            function _n(e, t) {
              return wn(e, Math.ceil(Math.log(t.length) / Math.LN2 + 1));
            }
            function wn(e, t) {
              for (var r = -1, n = +e[0], a = (e[1] - n) / t, i = []; ++r <= t;) i[r] = a * r + n;
              return i;
            }
            function Tn(e) {
              return [i.min(e), i.max(e)];
            }
            function Mn(e, t) {
              return e.value - t.value;
            }
            function kn(e, t) {
              var r = e._pack_next;
              e._pack_next = t, t._pack_prev = e, t._pack_next = r, r._pack_prev = t;
            }
            function An(e, t) {
              e._pack_next = t, t._pack_prev = e;
            }
            function Ln(e, t) {
              var r = t.x - e.x,
                n = t.y - e.y,
                a = e.r + t.r;
              return .999 * a * a > r * r + n * n;
            }
            function Sn(e) {
              if ((t = e.children) && (s = t.length)) {
                var t,
                  r,
                  n,
                  a,
                  i,
                  o,
                  l,
                  s,
                  c = 1 / 0,
                  u = -1 / 0,
                  f = 1 / 0,
                  d = -1 / 0;
                if (t.forEach(Cn), (r = t[0]).x = -r.r, r.y = 0, x(r), s > 1 && ((n = t[1]).x = n.r, n.y = 0, x(n), s > 2)) for (Pn(r, n, a = t[2]), x(a), kn(r, a), r._pack_prev = a, kn(a, n), n = r._pack_next, i = 3; i < s; i++) {
                  Pn(r, n, a = t[i]);
                  var h = 0,
                    p = 1,
                    v = 1;
                  for (o = n._pack_next; o !== n; o = o._pack_next, p++) if (Ln(o, a)) {
                    h = 1;
                    break;
                  }
                  if (1 == h) for (l = r._pack_prev; l !== o._pack_prev && !Ln(l, a); l = l._pack_prev, v++);
                  h ? (p < v || p == v && n.r < r.r ? An(r, n = o) : An(r = l, n), i--) : (kn(r, a), n = a, x(a));
                }
                var g = (c + u) / 2,
                  m = (f + d) / 2,
                  y = 0;
                for (i = 0; i < s; i++) (a = t[i]).x -= g, a.y -= m, y = Math.max(y, a.r + Math.sqrt(a.x * a.x + a.y * a.y));
                e.r = y, t.forEach(On);
              }
              function x(e) {
                c = Math.min(e.x - e.r, c), u = Math.max(e.x + e.r, u), f = Math.min(e.y - e.r, f), d = Math.max(e.y + e.r, d);
              }
            }
            function Cn(e) {
              e._pack_next = e._pack_prev = e;
            }
            function On(e) {
              delete e._pack_next, delete e._pack_prev;
            }
            function Dn(e, t, r, n) {
              var a = e.children;
              if (e.x = t += n * e.x, e.y = r += n * e.y, e.r *= n, a) for (var i = -1, o = a.length; ++i < o;) Dn(a[i], t, r, n);
            }
            function Pn(e, t, r) {
              var n = e.r + r.r,
                a = t.x - e.x,
                i = t.y - e.y;
              if (n && (a || i)) {
                var o = t.r + r.r,
                  l = a * a + i * i,
                  s = .5 + ((n *= n) - (o *= o)) / (2 * l),
                  c = Math.sqrt(Math.max(0, 2 * o * (n + l) - (n -= l) * n - o * o)) / (2 * l);
                r.x = e.x + s * a + c * i, r.y = e.y + s * i - c * a;
              } else r.x = e.x + n, r.y = e.y;
            }
            function zn(e, t) {
              return e.parent == t.parent ? 1 : 2;
            }
            function In(e) {
              var t = e.children;
              return t.length ? t[0] : e.t;
            }
            function En(e) {
              var t,
                r = e.children;
              return (t = r.length) ? r[t - 1] : e.t;
            }
            function Rn(e, t, r) {
              var n = r / (t.i - e.i);
              t.c -= n, t.s += r, e.c += n, t.z += r, t.m += r;
            }
            function Nn(e, t, r) {
              return e.a.parent === t.parent ? e.a : r;
            }
            function Fn(e) {
              var t = e.children;
              return t && t.length ? Fn(t[0]) : e;
            }
            function Hn(e) {
              var t,
                r = e.children;
              return r && (t = r.length) ? Hn(r[t - 1]) : e;
            }
            function Bn(e) {
              return {
                x: e.x,
                y: e.y,
                dx: e.dx,
                dy: e.dy
              };
            }
            function jn(e, t) {
              var r = e.x + t[3],
                n = e.y + t[0],
                a = e.dx - t[1] - t[3],
                i = e.dy - t[0] - t[2];
              return a < 0 && (r += a / 2, a = 0), i < 0 && (n += i / 2, i = 0), {
                x: r,
                y: n,
                dx: a,
                dy: i
              };
            }
            function Yn(e) {
              var t = e[0],
                r = e[e.length - 1];
              return t < r ? [t, r] : [r, t];
            }
            function Vn(e) {
              return e.rangeExtent ? e.rangeExtent() : Yn(e.range());
            }
            function Un(e, t, r, n) {
              var a = r(e[0], e[1]),
                i = n(t[0], t[1]);
              return function (e) {
                return i(a(e));
              };
            }
            function qn(e, t) {
              var r,
                n = 0,
                a = e.length - 1,
                i = e[n],
                o = e[a];
              return o < i && (r = n, n = a, a = r, r = i, i = o, o = r), e[n] = t.floor(i), e[a] = t.ceil(o), e;
            }
            function Gn(e) {
              return e ? {
                floor: function (t) {
                  return Math.floor(t / e) * e;
                },
                ceil: function (t) {
                  return Math.ceil(t / e) * e;
                }
              } : Zn;
            }
            i.layout.histogram = function () {
              var e = !0,
                t = Number,
                r = Tn,
                n = _n;
              function a(a, o) {
                for (var l, s, c = [], u = a.map(t, this), f = r.call(this, u, o), d = n.call(this, f, u, o), h = (o = -1, u.length), p = d.length - 1, v = e ? 1 : 1 / h; ++o < p;) (l = c[o] = []).dx = d[o + 1] - (l.x = d[o]), l.y = 0;
                if (p > 0) for (o = -1; ++o < h;) (s = u[o]) >= f[0] && s <= f[1] && ((l = c[i.bisect(d, s, 1, p) - 1]).y += v, l.push(a[o]));
                return c;
              }
              return a.value = function (e) {
                return arguments.length ? (t = e, a) : t;
              }, a.range = function (e) {
                return arguments.length ? (r = gt(e), a) : r;
              }, a.bins = function (e) {
                return arguments.length ? (n = "number" == typeof e ? function (t) {
                  return wn(t, e);
                } : gt(e), a) : n;
              }, a.frequency = function (t) {
                return arguments.length ? (e = !!t, a) : e;
              }, a;
            }, i.layout.pack = function () {
              var e,
                t = i.layout.hierarchy().sort(Mn),
                r = 0,
                n = [1, 1];
              function a(a, i) {
                var o = t.call(this, a, i),
                  l = o[0],
                  s = n[0],
                  c = n[1],
                  u = null == e ? Math.sqrt : "function" == typeof e ? e : function () {
                    return e;
                  };
                if (l.x = l.y = 0, an(l, function (e) {
                  e.r = +u(e.value);
                }), an(l, Sn), r) {
                  var f = r * (e ? 1 : Math.max(2 * l.r / s, 2 * l.r / c)) / 2;
                  an(l, function (e) {
                    e.r += f;
                  }), an(l, Sn), an(l, function (e) {
                    e.r -= f;
                  });
                }
                return Dn(l, s / 2, c / 2, e ? 1 : 1 / Math.max(2 * l.r / s, 2 * l.r / c)), o;
              }
              return a.size = function (e) {
                return arguments.length ? (n = e, a) : n;
              }, a.radius = function (t) {
                return arguments.length ? (e = null == t || "function" == typeof t ? t : +t, a) : e;
              }, a.padding = function (e) {
                return arguments.length ? (r = +e, a) : r;
              }, rn(a, t);
            }, i.layout.tree = function () {
              var e = i.layout.hierarchy().sort(null).value(null),
                t = zn,
                r = [1, 1],
                n = null;
              function a(a, i) {
                var c = e.call(this, a, i),
                  u = c[0],
                  f = function (e) {
                    for (var t, r = {
                        A: null,
                        children: [e]
                      }, n = [r]; null != (t = n.pop());) for (var a, i = t.children, o = 0, l = i.length; o < l; ++o) n.push((i[o] = a = {
                      _: i[o],
                      parent: t,
                      children: (a = i[o].children) && a.slice() || [],
                      A: null,
                      a: null,
                      z: 0,
                      m: 0,
                      c: 0,
                      s: 0,
                      t: null,
                      i: o
                    }).a = a);
                    return r.children[0];
                  }(u);
                if (an(f, o), f.parent.m = -f.z, nn(f, l), n) nn(u, s);else {
                  var d = u,
                    h = u,
                    p = u;
                  nn(u, function (e) {
                    e.x < d.x && (d = e), e.x > h.x && (h = e), e.depth > p.depth && (p = e);
                  });
                  var v = t(d, h) / 2 - d.x,
                    g = r[0] / (h.x + t(h, d) / 2 + v),
                    m = r[1] / (p.depth || 1);
                  nn(u, function (e) {
                    e.x = (e.x + v) * g, e.y = e.depth * m;
                  });
                }
                return c;
              }
              function o(e) {
                var r = e.children,
                  n = e.parent.children,
                  a = e.i ? n[e.i - 1] : null;
                if (r.length) {
                  !function (e) {
                    for (var t, r = 0, n = 0, a = e.children, i = a.length; --i >= 0;) (t = a[i]).z += r, t.m += r, r += t.s + (n += t.c);
                  }(e);
                  var i = (r[0].z + r[r.length - 1].z) / 2;
                  a ? (e.z = a.z + t(e._, a._), e.m = e.z - i) : e.z = i;
                } else a && (e.z = a.z + t(e._, a._));
                e.parent.A = function (e, r, n) {
                  if (r) {
                    for (var a, i = e, o = e, l = r, s = i.parent.children[0], c = i.m, u = o.m, f = l.m, d = s.m; l = En(l), i = In(i), l && i;) s = In(s), (o = En(o)).a = e, (a = l.z + f - i.z - c + t(l._, i._)) > 0 && (Rn(Nn(l, e, n), e, a), c += a, u += a), f += l.m, c += i.m, d += s.m, u += o.m;
                    l && !En(o) && (o.t = l, o.m += f - u), i && !In(s) && (s.t = i, s.m += c - d, n = e);
                  }
                  return n;
                }(e, a, e.parent.A || n[0]);
              }
              function l(e) {
                e._.x = e.z + e.parent.m, e.m += e.parent.m;
              }
              function s(e) {
                e.x *= r[0], e.y = e.depth * r[1];
              }
              return a.separation = function (e) {
                return arguments.length ? (t = e, a) : t;
              }, a.size = function (e) {
                return arguments.length ? (n = null == (r = e) ? s : null, a) : n ? null : r;
              }, a.nodeSize = function (e) {
                return arguments.length ? (n = null == (r = e) ? null : s, a) : n ? r : null;
              }, rn(a, e);
            }, i.layout.cluster = function () {
              var e = i.layout.hierarchy().sort(null).value(null),
                t = zn,
                r = [1, 1],
                n = !1;
              function a(a, o) {
                var l,
                  s = e.call(this, a, o),
                  c = s[0],
                  u = 0;
                an(c, function (e) {
                  var r = e.children;
                  r && r.length ? (e.x = function (e) {
                    return e.reduce(function (e, t) {
                      return e + t.x;
                    }, 0) / e.length;
                  }(r), e.y = function (e) {
                    return 1 + i.max(e, function (e) {
                      return e.y;
                    });
                  }(r)) : (e.x = l ? u += t(e, l) : 0, e.y = 0, l = e);
                });
                var f = Fn(c),
                  d = Hn(c),
                  h = f.x - t(f, d) / 2,
                  p = d.x + t(d, f) / 2;
                return an(c, n ? function (e) {
                  e.x = (e.x - c.x) * r[0], e.y = (c.y - e.y) * r[1];
                } : function (e) {
                  e.x = (e.x - h) / (p - h) * r[0], e.y = (1 - (c.y ? e.y / c.y : 1)) * r[1];
                }), s;
              }
              return a.separation = function (e) {
                return arguments.length ? (t = e, a) : t;
              }, a.size = function (e) {
                return arguments.length ? (n = null == (r = e), a) : n ? null : r;
              }, a.nodeSize = function (e) {
                return arguments.length ? (n = null != (r = e), a) : n ? r : null;
              }, rn(a, e);
            }, i.layout.treemap = function () {
              var e,
                t = i.layout.hierarchy(),
                r = Math.round,
                n = [1, 1],
                a = null,
                o = Bn,
                l = !1,
                s = "squarify",
                c = .5 * (1 + Math.sqrt(5));
              function u(e, t) {
                for (var r, n, a = -1, i = e.length; ++a < i;) n = (r = e[a]).value * (t < 0 ? 0 : t), r.area = isNaN(n) || n <= 0 ? 0 : n;
              }
              function f(e) {
                var t = e.children;
                if (t && t.length) {
                  var r,
                    n,
                    a,
                    i = o(e),
                    l = [],
                    c = t.slice(),
                    d = 1 / 0,
                    v = "slice" === s ? i.dx : "dice" === s ? i.dy : "slice-dice" === s ? 1 & e.depth ? i.dy : i.dx : Math.min(i.dx, i.dy);
                  for (u(c, i.dx * i.dy / e.value), l.area = 0; (a = c.length) > 0;) l.push(r = c[a - 1]), l.area += r.area, "squarify" !== s || (n = h(l, v)) <= d ? (c.pop(), d = n) : (l.area -= l.pop().area, p(l, v, i, !1), v = Math.min(i.dx, i.dy), l.length = l.area = 0, d = 1 / 0);
                  l.length && (p(l, v, i, !0), l.length = l.area = 0), t.forEach(f);
                }
              }
              function d(e) {
                var t = e.children;
                if (t && t.length) {
                  var r,
                    n = o(e),
                    a = t.slice(),
                    i = [];
                  for (u(a, n.dx * n.dy / e.value), i.area = 0; r = a.pop();) i.push(r), i.area += r.area, null != r.z && (p(i, r.z ? n.dx : n.dy, n, !a.length), i.length = i.area = 0);
                  t.forEach(d);
                }
              }
              function h(e, t) {
                for (var r, n = e.area, a = 0, i = 1 / 0, o = -1, l = e.length; ++o < l;) (r = e[o].area) && (r < i && (i = r), r > a && (a = r));
                return t *= t, (n *= n) ? Math.max(t * a * c / n, n / (t * i * c)) : 1 / 0;
              }
              function p(e, t, n, a) {
                var i,
                  o = -1,
                  l = e.length,
                  s = n.x,
                  c = n.y,
                  u = t ? r(e.area / t) : 0;
                if (t == n.dx) {
                  for ((a || u > n.dy) && (u = n.dy); ++o < l;) (i = e[o]).x = s, i.y = c, i.dy = u, s += i.dx = Math.min(n.x + n.dx - s, u ? r(i.area / u) : 0);
                  i.z = !0, i.dx += n.x + n.dx - s, n.y += u, n.dy -= u;
                } else {
                  for ((a || u > n.dx) && (u = n.dx); ++o < l;) (i = e[o]).x = s, i.y = c, i.dx = u, c += i.dy = Math.min(n.y + n.dy - c, u ? r(i.area / u) : 0);
                  i.z = !1, i.dy += n.y + n.dy - c, n.x += u, n.dx -= u;
                }
              }
              function v(r) {
                var a = e || t(r),
                  i = a[0];
                return i.x = i.y = 0, i.value ? (i.dx = n[0], i.dy = n[1]) : i.dx = i.dy = 0, e && t.revalue(i), u([i], i.dx * i.dy / i.value), (e ? d : f)(i), l && (e = a), a;
              }
              return v.size = function (e) {
                return arguments.length ? (n = e, v) : n;
              }, v.padding = function (e) {
                if (!arguments.length) return a;
                function t(t) {
                  return jn(t, e);
                }
                var r;
                return o = null == (a = e) ? Bn : "function" == (r = typeof e) ? function (t) {
                  var r = e.call(v, t, t.depth);
                  return null == r ? Bn(t) : jn(t, "number" == typeof r ? [r, r, r, r] : r);
                } : "number" === r ? (e = [e, e, e, e], t) : t, v;
              }, v.round = function (e) {
                return arguments.length ? (r = e ? Math.round : Number, v) : r != Number;
              }, v.sticky = function (t) {
                return arguments.length ? (l = t, e = null, v) : l;
              }, v.ratio = function (e) {
                return arguments.length ? (c = e, v) : c;
              }, v.mode = function (e) {
                return arguments.length ? (s = e + "", v) : s;
              }, rn(v, t);
            }, i.random = {
              normal: function (e, t) {
                var r = arguments.length;
                return r < 2 && (t = 1), r < 1 && (e = 0), function () {
                  var r, n, a;
                  do {
                    a = (r = 2 * Math.random() - 1) * r + (n = 2 * Math.random() - 1) * n;
                  } while (!a || a > 1);
                  return e + t * r * Math.sqrt(-2 * Math.log(a) / a);
                };
              },
              logNormal: function () {
                var e = i.random.normal.apply(i, arguments);
                return function () {
                  return Math.exp(e());
                };
              },
              bates: function (e) {
                var t = i.random.irwinHall(e);
                return function () {
                  return t() / e;
                };
              },
              irwinHall: function (e) {
                return function () {
                  for (var t = 0, r = 0; r < e; r++) t += Math.random();
                  return t;
                };
              }
            }, i.scale = {};
            var Zn = {
              floor: E,
              ceil: E
            };
            function Wn(e, t, r, n) {
              var a = [],
                o = [],
                l = 0,
                s = Math.min(e.length, t.length) - 1;
              for (e[s] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++l <= s;) a.push(r(e[l - 1], e[l])), o.push(n(t[l - 1], t[l]));
              return function (t) {
                var r = i.bisect(e, t, 1, s) - 1;
                return o[r](a[r](t));
              };
            }
            function Jn(e, t, r, n) {
              var a, i;
              function o() {
                var o = Math.min(e.length, t.length) > 2 ? Wn : Un,
                  s = n ? qr : Ur;
                return a = o(e, t, s, r), i = o(t, e, s, Tr), l;
              }
              function l(e) {
                return a(e);
              }
              return l.invert = function (e) {
                return i(e);
              }, l.domain = function (t) {
                return arguments.length ? (e = t.map(Number), o()) : e;
              }, l.range = function (e) {
                return arguments.length ? (t = e, o()) : t;
              }, l.rangeRound = function (e) {
                return l.range(e).interpolate(Nr);
              }, l.clamp = function (e) {
                return arguments.length ? (n = e, o()) : n;
              }, l.interpolate = function (e) {
                return arguments.length ? (r = e, o()) : r;
              }, l.ticks = function (t) {
                return $n(e, t);
              }, l.tickFormat = function (t, r) {
                return d3_scale_linearTickFormat(e, t, r);
              }, l.nice = function (t) {
                return Kn(e, t), o();
              }, l.copy = function () {
                return Jn(e, t, r, n);
              }, o();
            }
            function Xn(e, t) {
              return i.rebind(e, t, "range", "rangeRound", "interpolate", "clamp");
            }
            function Kn(e, t) {
              return qn(e, Gn(Qn(e, t)[2])), qn(e, Gn(Qn(e, t)[2])), e;
            }
            function Qn(e, t) {
              null == t && (t = 10);
              var r = Yn(e),
                n = r[1] - r[0],
                a = Math.pow(10, Math.floor(Math.log(n / t) / Math.LN10)),
                i = t / n * a;
              return i <= .15 ? a *= 10 : i <= .35 ? a *= 5 : i <= .75 && (a *= 2), r[0] = Math.ceil(r[0] / a) * a, r[1] = Math.floor(r[1] / a) * a + .5 * a, r[2] = a, r;
            }
            function $n(e, t) {
              return i.range.apply(i, Qn(e, t));
            }
            function ea(e, t, r, n) {
              function a(e) {
                return (r ? Math.log(e < 0 ? 0 : e) : -Math.log(e > 0 ? 0 : -e)) / Math.log(t);
              }
              function i(e) {
                return r ? Math.pow(t, e) : -Math.pow(t, -e);
              }
              function o(t) {
                return e(a(t));
              }
              return o.invert = function (t) {
                return i(e.invert(t));
              }, o.domain = function (t) {
                return arguments.length ? (r = t[0] >= 0, e.domain((n = t.map(Number)).map(a)), o) : n;
              }, o.base = function (r) {
                return arguments.length ? (t = +r, e.domain(n.map(a)), o) : t;
              }, o.nice = function () {
                var t = qn(n.map(a), r ? Math : ta);
                return e.domain(t), n = t.map(i), o;
              }, o.ticks = function () {
                var e = Yn(n),
                  o = [],
                  l = e[0],
                  s = e[1],
                  c = Math.floor(a(l)),
                  u = Math.ceil(a(s)),
                  f = t % 1 ? 2 : t;
                if (isFinite(u - c)) {
                  if (r) {
                    for (; c < u; c++) for (var d = 1; d < f; d++) o.push(i(c) * d);
                    o.push(i(c));
                  } else for (o.push(i(c)); c++ < u;) for (d = f - 1; d > 0; d--) o.push(i(c) * d);
                  for (c = 0; o[c] < l; c++);
                  for (u = o.length; o[u - 1] > s; u--);
                  o = o.slice(c, u);
                }
                return o;
              }, o.copy = function () {
                return ea(e.copy(), t, r, n);
              }, Xn(o, e);
            }
            i.scale.linear = function () {
              return Jn([0, 1], [0, 1], Tr, !1);
            }, i.scale.log = function () {
              return ea(i.scale.linear().domain([0, 1]), 10, !0, [1, 10]);
            };
            var ta = {
              floor: function (e) {
                return -Math.ceil(-e);
              },
              ceil: function (e) {
                return -Math.floor(-e);
              }
            };
            function ra(e, t, r) {
              var n = na(t),
                a = na(1 / t);
              function i(t) {
                return e(n(t));
              }
              return i.invert = function (t) {
                return a(e.invert(t));
              }, i.domain = function (t) {
                return arguments.length ? (e.domain((r = t.map(Number)).map(n)), i) : r;
              }, i.ticks = function (e) {
                return $n(r, e);
              }, i.tickFormat = function (e, t) {
                return d3_scale_linearTickFormat(r, e, t);
              }, i.nice = function (e) {
                return i.domain(Kn(r, e));
              }, i.exponent = function (o) {
                return arguments.length ? (n = na(t = o), a = na(1 / t), e.domain(r.map(n)), i) : t;
              }, i.copy = function () {
                return ra(e.copy(), t, r);
              }, Xn(i, e);
            }
            function na(e) {
              return function (t) {
                return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
              };
            }
            function aa(e, t) {
              var r, n, a;
              function o(a) {
                return n[((r.get(a) || ("range" === t.t ? r.set(a, e.push(a)) : NaN)) - 1) % n.length];
              }
              function l(t, r) {
                return i.range(e.length).map(function (e) {
                  return t + r * e;
                });
              }
              return o.domain = function (n) {
                if (!arguments.length) return e;
                e = [], r = new M();
                for (var a, i = -1, l = n.length; ++i < l;) r.has(a = n[i]) || r.set(a, e.push(a));
                return o[t.t].apply(o, t.a);
              }, o.range = function (e) {
                return arguments.length ? (n = e, a = 0, t = {
                  t: "range",
                  a: arguments
                }, o) : n;
              }, o.rangePoints = function (r, i) {
                arguments.length < 2 && (i = 0);
                var s = r[0],
                  c = r[1],
                  u = e.length < 2 ? (s = (s + c) / 2, 0) : (c - s) / (e.length - 1 + i);
                return n = l(s + u * i / 2, u), a = 0, t = {
                  t: "rangePoints",
                  a: arguments
                }, o;
              }, o.rangeRoundPoints = function (r, i) {
                arguments.length < 2 && (i = 0);
                var s = r[0],
                  c = r[1],
                  u = e.length < 2 ? (s = c = Math.round((s + c) / 2), 0) : (c - s) / (e.length - 1 + i) | 0;
                return n = l(s + Math.round(u * i / 2 + (c - s - (e.length - 1 + i) * u) / 2), u), a = 0, t = {
                  t: "rangeRoundPoints",
                  a: arguments
                }, o;
              }, o.rangeBands = function (r, i, s) {
                arguments.length < 2 && (i = 0), arguments.length < 3 && (s = i);
                var c = r[1] < r[0],
                  u = r[c - 0],
                  f = (r[1 - c] - u) / (e.length - i + 2 * s);
                return n = l(u + f * s, f), c && n.reverse(), a = f * (1 - i), t = {
                  t: "rangeBands",
                  a: arguments
                }, o;
              }, o.rangeRoundBands = function (r, i, s) {
                arguments.length < 2 && (i = 0), arguments.length < 3 && (s = i);
                var c = r[1] < r[0],
                  u = r[c - 0],
                  f = r[1 - c],
                  d = Math.floor((f - u) / (e.length - i + 2 * s));
                return n = l(u + Math.round((f - u - (e.length - i) * d) / 2), d), c && n.reverse(), a = Math.round(d * (1 - i)), t = {
                  t: "rangeRoundBands",
                  a: arguments
                }, o;
              }, o.rangeBand = function () {
                return a;
              }, o.rangeExtent = function () {
                return Yn(t.a[0]);
              }, o.copy = function () {
                return aa(e, t);
              }, o.domain(e);
            }
            i.scale.pow = function () {
              return ra(i.scale.linear(), 1, [0, 1]);
            }, i.scale.sqrt = function () {
              return i.scale.pow().exponent(.5);
            }, i.scale.ordinal = function () {
              return aa([], {
                t: "range",
                a: [[]]
              });
            }, i.scale.category10 = function () {
              return i.scale.ordinal().range(ia);
            }, i.scale.category20 = function () {
              return i.scale.ordinal().range(oa);
            }, i.scale.category20b = function () {
              return i.scale.ordinal().range(la);
            }, i.scale.category20c = function () {
              return i.scale.ordinal().range(sa);
            };
            var ia = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(lt),
              oa = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(lt),
              la = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(lt),
              sa = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(lt);
            function ca(e, t) {
              var r;
              function n() {
                var n = 0,
                  o = t.length;
                for (r = []; ++n < o;) r[n - 1] = i.quantile(e, n / o);
                return a;
              }
              function a(e) {
                if (!isNaN(e = +e)) return t[i.bisect(r, e)];
              }
              return a.domain = function (t) {
                return arguments.length ? (e = t.map(m).filter(y).sort(g), n()) : e;
              }, a.range = function (e) {
                return arguments.length ? (t = e, n()) : t;
              }, a.quantiles = function () {
                return r;
              }, a.invertExtent = function (n) {
                return (n = t.indexOf(n)) < 0 ? [NaN, NaN] : [n > 0 ? r[n - 1] : e[0], n < r.length ? r[n] : e[e.length - 1]];
              }, a.copy = function () {
                return ca(e, t);
              }, n();
            }
            function ua(e, t, r) {
              var n, a;
              function i(t) {
                return r[Math.max(0, Math.min(a, Math.floor(n * (t - e))))];
              }
              function o() {
                return n = r.length / (t - e), a = r.length - 1, i;
              }
              return i.domain = function (r) {
                return arguments.length ? (e = +r[0], t = +r[r.length - 1], o()) : [e, t];
              }, i.range = function (e) {
                return arguments.length ? (r = e, o()) : r;
              }, i.invertExtent = function (t) {
                return [t = (t = r.indexOf(t)) < 0 ? NaN : t / n + e, t + 1 / n];
              }, i.copy = function () {
                return ua(e, t, r);
              }, o();
            }
            function fa(e, t) {
              function r(r) {
                if (r <= r) return t[i.bisect(e, r)];
              }
              return r.domain = function (t) {
                return arguments.length ? (e = t, r) : e;
              }, r.range = function (e) {
                return arguments.length ? (t = e, r) : t;
              }, r.invertExtent = function (r) {
                return r = t.indexOf(r), [e[r - 1], e[r]];
              }, r.copy = function () {
                return fa(e, t);
              }, r;
            }
            function da(e) {
              function t(e) {
                return +e;
              }
              return t.invert = t, t.domain = t.range = function (r) {
                return arguments.length ? (e = r.map(t), t) : e;
              }, t.ticks = function (t) {
                return $n(e, t);
              }, t.tickFormat = function (t, r) {
                return d3_scale_linearTickFormat(e, t, r);
              }, t.copy = function () {
                return da(e);
              }, t;
            }
            function ha() {
              return 0;
            }
            i.scale.quantile = function () {
              return ca([], []);
            }, i.scale.quantize = function () {
              return ua(0, 1, [0, 1]);
            }, i.scale.threshold = function () {
              return fa([.5], [0, 1]);
            }, i.scale.identity = function () {
              return da([0, 1]);
            }, i.svg = {}, i.svg.arc = function () {
              var e = va,
                t = ga,
                r = ha,
                n = pa,
                a = ma,
                i = ya,
                o = xa;
              function l() {
                var l = Math.max(0, +e.apply(this, arguments)),
                  c = Math.max(0, +t.apply(this, arguments)),
                  u = a.apply(this, arguments) - ze,
                  f = i.apply(this, arguments) - ze,
                  d = Math.abs(f - u),
                  h = u > f ? 0 : 1;
                if (c < l && (p = c, c = l, l = p), d >= Pe) return s(c, h) + (l ? s(l, 1 - h) : "") + "Z";
                var p,
                  v,
                  g,
                  m,
                  y,
                  x,
                  b,
                  _,
                  w,
                  T,
                  M,
                  k,
                  A = 0,
                  L = 0,
                  S = [];
                if ((m = (+o.apply(this, arguments) || 0) / 2) && (g = n === pa ? Math.sqrt(l * l + c * c) : +n.apply(this, arguments), h || (L *= -1), c && (L = Re(g / c * Math.sin(m))), l && (A = Re(g / l * Math.sin(m)))), c) {
                  y = c * Math.cos(u + L), x = c * Math.sin(u + L), b = c * Math.cos(f - L), _ = c * Math.sin(f - L);
                  var C = Math.abs(f - u - 2 * L) <= Oe ? 0 : 1;
                  if (L && ba(y, x, b, _) === h ^ C) {
                    var O = (u + f) / 2;
                    y = c * Math.cos(O), x = c * Math.sin(O), b = _ = null;
                  }
                } else y = x = 0;
                if (l) {
                  w = l * Math.cos(f - A), T = l * Math.sin(f - A), M = l * Math.cos(u + A), k = l * Math.sin(u + A);
                  var D = Math.abs(u - f + 2 * A) <= Oe ? 0 : 1;
                  if (A && ba(w, T, M, k) === 1 - h ^ D) {
                    var P = (u + f) / 2;
                    w = l * Math.cos(P), T = l * Math.sin(P), M = k = null;
                  }
                } else w = T = 0;
                if (d > Se && (p = Math.min(Math.abs(c - l) / 2, +r.apply(this, arguments))) > .001) {
                  v = l < c ^ h ? 0 : 1;
                  var z = p,
                    I = p;
                  if (d < Oe) {
                    var E = null == M ? [w, T] : null == b ? [y, x] : It([y, x], [M, k], [b, _], [w, T]),
                      R = y - E[0],
                      N = x - E[1],
                      F = b - E[0],
                      H = _ - E[1],
                      B = 1 / Math.sin(Math.acos((R * F + N * H) / (Math.sqrt(R * R + N * N) * Math.sqrt(F * F + H * H))) / 2),
                      j = Math.sqrt(E[0] * E[0] + E[1] * E[1]);
                    I = Math.min(p, (l - j) / (B - 1)), z = Math.min(p, (c - j) / (B + 1));
                  }
                  if (null != b) {
                    var Y = _a(null == M ? [w, T] : [M, k], [y, x], c, z, h),
                      V = _a([b, _], [w, T], c, z, h);
                    p === z ? S.push("M", Y[0], "A", z, ",", z, " 0 0,", v, " ", Y[1], "A", c, ",", c, " 0 ", 1 - h ^ ba(Y[1][0], Y[1][1], V[1][0], V[1][1]), ",", h, " ", V[1], "A", z, ",", z, " 0 0,", v, " ", V[0]) : S.push("M", Y[0], "A", z, ",", z, " 0 1,", v, " ", V[0]);
                  } else S.push("M", y, ",", x);
                  if (null != M) {
                    var U = _a([y, x], [M, k], l, -I, h),
                      q = _a([w, T], null == b ? [y, x] : [b, _], l, -I, h);
                    p === I ? S.push("L", q[0], "A", I, ",", I, " 0 0,", v, " ", q[1], "A", l, ",", l, " 0 ", h ^ ba(q[1][0], q[1][1], U[1][0], U[1][1]), ",", 1 - h, " ", U[1], "A", I, ",", I, " 0 0,", v, " ", U[0]) : S.push("L", q[0], "A", I, ",", I, " 0 0,", v, " ", U[0]);
                  } else S.push("L", w, ",", T);
                } else S.push("M", y, ",", x), null != b && S.push("A", c, ",", c, " 0 ", C, ",", h, " ", b, ",", _), S.push("L", w, ",", T), null != M && S.push("A", l, ",", l, " 0 ", D, ",", 1 - h, " ", M, ",", k);
                return S.push("Z"), S.join("");
              }
              function s(e, t) {
                return "M0," + e + "A" + e + "," + e + " 0 1," + t + " 0," + -e + "A" + e + "," + e + " 0 1," + t + " 0," + e;
              }
              return l.innerRadius = function (t) {
                return arguments.length ? (e = gt(t), l) : e;
              }, l.outerRadius = function (e) {
                return arguments.length ? (t = gt(e), l) : t;
              }, l.cornerRadius = function (e) {
                return arguments.length ? (r = gt(e), l) : r;
              }, l.padRadius = function (e) {
                return arguments.length ? (n = e == pa ? pa : gt(e), l) : n;
              }, l.startAngle = function (e) {
                return arguments.length ? (a = gt(e), l) : a;
              }, l.endAngle = function (e) {
                return arguments.length ? (i = gt(e), l) : i;
              }, l.padAngle = function (e) {
                return arguments.length ? (o = gt(e), l) : o;
              }, l.centroid = function () {
                var r = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2,
                  n = (+a.apply(this, arguments) + +i.apply(this, arguments)) / 2 - ze;
                return [Math.cos(n) * r, Math.sin(n) * r];
              }, l;
            };
            var pa = "auto";
            function va(e) {
              return e.innerRadius;
            }
            function ga(e) {
              return e.outerRadius;
            }
            function ma(e) {
              return e.startAngle;
            }
            function ya(e) {
              return e.endAngle;
            }
            function xa(e) {
              return e && e.padAngle;
            }
            function ba(e, t, r, n) {
              return (e - r) * t - (t - n) * e > 0 ? 0 : 1;
            }
            function _a(e, t, r, n, a) {
              var i = e[0] - t[0],
                o = e[1] - t[1],
                l = (a ? n : -n) / Math.sqrt(i * i + o * o),
                s = l * o,
                c = -l * i,
                u = e[0] + s,
                f = e[1] + c,
                d = t[0] + s,
                h = t[1] + c,
                p = (u + d) / 2,
                v = (f + h) / 2,
                g = d - u,
                m = h - f,
                y = g * g + m * m,
                x = r - n,
                b = u * h - d * f,
                _ = (m < 0 ? -1 : 1) * Math.sqrt(Math.max(0, x * x * y - b * b)),
                w = (b * m - g * _) / y,
                T = (-b * g - m * _) / y,
                M = (b * m + g * _) / y,
                k = (-b * g + m * _) / y,
                A = w - p,
                L = T - v,
                S = M - p,
                C = k - v;
              return A * A + L * L > S * S + C * C && (w = M, T = k), [[w - s, T - c], [w * r / x, T * r / x]];
            }
            function wa() {
              return !0;
            }
            function Ta(e) {
              var t = St,
                r = Ct,
                n = wa,
                a = ka,
                i = a.key,
                o = .7;
              function l(i) {
                var l,
                  s = [],
                  c = [],
                  u = -1,
                  f = i.length,
                  d = gt(t),
                  h = gt(r);
                function p() {
                  s.push("M", a(e(c), o));
                }
                for (; ++u < f;) n.call(this, l = i[u], u) ? c.push([+d.call(this, l, u), +h.call(this, l, u)]) : c.length && (p(), c = []);
                return c.length && p(), s.length ? s.join("") : null;
              }
              return l.x = function (e) {
                return arguments.length ? (t = e, l) : t;
              }, l.y = function (e) {
                return arguments.length ? (r = e, l) : r;
              }, l.defined = function (e) {
                return arguments.length ? (n = e, l) : n;
              }, l.interpolate = function (e) {
                return arguments.length ? (i = "function" == typeof e ? a = e : (a = Ma.get(e) || ka).key, l) : i;
              }, l.tension = function (e) {
                return arguments.length ? (o = e, l) : o;
              }, l;
            }
            i.svg.line = function () {
              return Ta(E);
            };
            var Ma = i.map({
              linear: ka,
              "linear-closed": Aa,
              step: function (e) {
                for (var t = 0, r = e.length, n = e[0], a = [n[0], ",", n[1]]; ++t < r;) a.push("H", (n[0] + (n = e[t])[0]) / 2, "V", n[1]);
                return r > 1 && a.push("H", n[0]), a.join("");
              },
              "step-before": La,
              "step-after": Sa,
              basis: Da,
              "basis-open": function (e) {
                if (e.length < 4) return ka(e);
                for (var t, r = [], n = -1, a = e.length, i = [0], o = [0]; ++n < 3;) t = e[n], i.push(t[0]), o.push(t[1]);
                for (r.push(Pa(Ea, i) + "," + Pa(Ea, o)), --n; ++n < a;) t = e[n], i.shift(), i.push(t[0]), o.shift(), o.push(t[1]), Ra(r, i, o);
                return r.join("");
              },
              "basis-closed": function (e) {
                for (var t, r, n = -1, a = e.length, i = a + 4, o = [], l = []; ++n < 4;) r = e[n % a], o.push(r[0]), l.push(r[1]);
                for (t = [Pa(Ea, o), ",", Pa(Ea, l)], --n; ++n < i;) r = e[n % a], o.shift(), o.push(r[0]), l.shift(), l.push(r[1]), Ra(t, o, l);
                return t.join("");
              },
              bundle: function (e, t) {
                var r = e.length - 1;
                if (r) for (var n, a, i = e[0][0], o = e[0][1], l = e[r][0] - i, s = e[r][1] - o, c = -1; ++c <= r;) a = c / r, (n = e[c])[0] = t * n[0] + (1 - t) * (i + a * l), n[1] = t * n[1] + (1 - t) * (o + a * s);
                return Da(e);
              },
              cardinal: function (e, t) {
                return e.length < 3 ? ka(e) : e[0] + Ca(e, Oa(e, t));
              },
              "cardinal-open": function (e, t) {
                return e.length < 4 ? ka(e) : e[1] + Ca(e.slice(1, -1), Oa(e, t));
              },
              "cardinal-closed": function (e, t) {
                return e.length < 3 ? Aa(e) : e[0] + Ca((e.push(e[0]), e), Oa([e[e.length - 2]].concat(e, [e[1]]), t));
              },
              monotone: function (e) {
                return e.length < 3 ? ka(e) : e[0] + Ca(e, function (e) {
                  for (var t, r, n, a, i = [], o = function (e) {
                      for (var t = 0, r = e.length - 1, n = [], a = e[0], i = e[1], o = n[0] = Na(a, i); ++t < r;) n[t] = (o + (o = Na(a = i, i = e[t + 1]))) / 2;
                      return n[t] = o, n;
                    }(e), l = -1, s = e.length - 1; ++l < s;) t = Na(e[l], e[l + 1]), w(t) < Se ? o[l] = o[l + 1] = 0 : (a = (r = o[l] / t) * r + (n = o[l + 1] / t) * n) > 9 && (a = 3 * t / Math.sqrt(a), o[l] = a * r, o[l + 1] = a * n);
                  for (l = -1; ++l <= s;) a = (e[Math.min(s, l + 1)][0] - e[Math.max(0, l - 1)][0]) / (6 * (1 + o[l] * o[l])), i.push([a || 0, o[l] * a || 0]);
                  return i;
                }(e));
              }
            });
            function ka(e) {
              return e.length > 1 ? e.join("L") : e + "Z";
            }
            function Aa(e) {
              return e.join("L") + "Z";
            }
            function La(e) {
              for (var t = 0, r = e.length, n = e[0], a = [n[0], ",", n[1]]; ++t < r;) a.push("V", (n = e[t])[1], "H", n[0]);
              return a.join("");
            }
            function Sa(e) {
              for (var t = 0, r = e.length, n = e[0], a = [n[0], ",", n[1]]; ++t < r;) a.push("H", (n = e[t])[0], "V", n[1]);
              return a.join("");
            }
            function Ca(e, t) {
              if (t.length < 1 || e.length != t.length && e.length != t.length + 2) return ka(e);
              var r = e.length != t.length,
                n = "",
                a = e[0],
                i = e[1],
                o = t[0],
                l = o,
                s = 1;
              if (r && (n += "Q" + (i[0] - 2 * o[0] / 3) + "," + (i[1] - 2 * o[1] / 3) + "," + i[0] + "," + i[1], a = e[1], s = 2), t.length > 1) {
                l = t[1], i = e[s], s++, n += "C" + (a[0] + o[0]) + "," + (a[1] + o[1]) + "," + (i[0] - l[0]) + "," + (i[1] - l[1]) + "," + i[0] + "," + i[1];
                for (var c = 2; c < t.length; c++, s++) i = e[s], l = t[c], n += "S" + (i[0] - l[0]) + "," + (i[1] - l[1]) + "," + i[0] + "," + i[1];
              }
              if (r) {
                var u = e[s];
                n += "Q" + (i[0] + 2 * l[0] / 3) + "," + (i[1] + 2 * l[1] / 3) + "," + u[0] + "," + u[1];
              }
              return n;
            }
            function Oa(e, t) {
              for (var r, n = [], a = (1 - t) / 2, i = e[0], o = e[1], l = 1, s = e.length; ++l < s;) r = i, i = o, o = e[l], n.push([a * (o[0] - r[0]), a * (o[1] - r[1])]);
              return n;
            }
            function Da(e) {
              if (e.length < 3) return ka(e);
              var t = 1,
                r = e.length,
                n = e[0],
                a = n[0],
                i = n[1],
                o = [a, a, a, (n = e[1])[0]],
                l = [i, i, i, n[1]],
                s = [a, ",", i, "L", Pa(Ea, o), ",", Pa(Ea, l)];
              for (e.push(e[r - 1]); ++t <= r;) n = e[t], o.shift(), o.push(n[0]), l.shift(), l.push(n[1]), Ra(s, o, l);
              return e.pop(), s.push("L", n), s.join("");
            }
            function Pa(e, t) {
              return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3];
            }
            Ma.forEach(function (e, t) {
              t.key = e, t.closed = /-closed$/.test(e);
            });
            var za = [0, 2 / 3, 1 / 3, 0],
              Ia = [0, 1 / 3, 2 / 3, 0],
              Ea = [0, 1 / 6, 2 / 3, 1 / 6];
            function Ra(e, t, r) {
              e.push("C", Pa(za, t), ",", Pa(za, r), ",", Pa(Ia, t), ",", Pa(Ia, r), ",", Pa(Ea, t), ",", Pa(Ea, r));
            }
            function Na(e, t) {
              return (t[1] - e[1]) / (t[0] - e[0]);
            }
            function Fa(e) {
              for (var t, r, n, a = -1, i = e.length; ++a < i;) r = (t = e[a])[0], n = t[1] - ze, t[0] = r * Math.cos(n), t[1] = r * Math.sin(n);
              return e;
            }
            function Ha(e) {
              var t = St,
                r = St,
                n = 0,
                a = Ct,
                i = wa,
                o = ka,
                l = o.key,
                s = o,
                c = "L",
                u = .7;
              function f(l) {
                var f,
                  d,
                  h,
                  p = [],
                  v = [],
                  g = [],
                  m = -1,
                  y = l.length,
                  x = gt(t),
                  b = gt(n),
                  _ = t === r ? function () {
                    return d;
                  } : gt(r),
                  w = n === a ? function () {
                    return h;
                  } : gt(a);
                function T() {
                  p.push("M", o(e(g), u), c, s(e(v.reverse()), u), "Z");
                }
                for (; ++m < y;) i.call(this, f = l[m], m) ? (v.push([d = +x.call(this, f, m), h = +b.call(this, f, m)]), g.push([+_.call(this, f, m), +w.call(this, f, m)])) : v.length && (T(), v = [], g = []);
                return v.length && T(), p.length ? p.join("") : null;
              }
              return f.x = function (e) {
                return arguments.length ? (t = r = e, f) : r;
              }, f.x0 = function (e) {
                return arguments.length ? (t = e, f) : t;
              }, f.x1 = function (e) {
                return arguments.length ? (r = e, f) : r;
              }, f.y = function (e) {
                return arguments.length ? (n = a = e, f) : a;
              }, f.y0 = function (e) {
                return arguments.length ? (n = e, f) : n;
              }, f.y1 = function (e) {
                return arguments.length ? (a = e, f) : a;
              }, f.defined = function (e) {
                return arguments.length ? (i = e, f) : i;
              }, f.interpolate = function (e) {
                return arguments.length ? (l = "function" == typeof e ? o = e : (o = Ma.get(e) || ka).key, s = o.reverse || o, c = o.closed ? "M" : "L", f) : l;
              }, f.tension = function (e) {
                return arguments.length ? (u = e, f) : u;
              }, f;
            }
            function Ba(e) {
              return e.source;
            }
            function ja(e) {
              return e.target;
            }
            function Ya(e) {
              return e.radius;
            }
            function Va(e) {
              return [e.x, e.y];
            }
            function Ua() {
              return 64;
            }
            function qa() {
              return "circle";
            }
            function Ga(e) {
              var t = Math.sqrt(e / Oe);
              return "M0," + t + "A" + t + "," + t + " 0 1,1 0," + -t + "A" + t + "," + t + " 0 1,1 0," + t + "Z";
            }
            i.svg.line.radial = function () {
              var e = Ta(Fa);
              return e.radius = e.x, delete e.x, e.angle = e.y, delete e.y, e;
            }, La.reverse = Sa, Sa.reverse = La, i.svg.area = function () {
              return Ha(E);
            }, i.svg.area.radial = function () {
              var e = Ha(Fa);
              return e.radius = e.x, delete e.x, e.innerRadius = e.x0, delete e.x0, e.outerRadius = e.x1, delete e.x1, e.angle = e.y, delete e.y, e.startAngle = e.y0, delete e.y0, e.endAngle = e.y1, delete e.y1, e;
            }, i.svg.chord = function () {
              var e = Ba,
                t = ja,
                r = Ya,
                n = ma,
                a = ya;
              function i(r, n) {
                var a,
                  i,
                  c = o(this, e, r, n),
                  u = o(this, t, r, n);
                return "M" + c.p0 + l(c.r, c.p1, c.a1 - c.a0) + (i = u, ((a = c).a0 == i.a0 && a.a1 == i.a1 ? s(c.r, c.p1, c.r, c.p0) : s(c.r, c.p1, u.r, u.p0) + l(u.r, u.p1, u.a1 - u.a0) + s(u.r, u.p1, c.r, c.p0)) + "Z");
              }
              function o(e, t, i, o) {
                var l = t.call(e, i, o),
                  s = r.call(e, l, o),
                  c = n.call(e, l, o) - ze,
                  u = a.call(e, l, o) - ze;
                return {
                  r: s,
                  a0: c,
                  a1: u,
                  p0: [s * Math.cos(c), s * Math.sin(c)],
                  p1: [s * Math.cos(u), s * Math.sin(u)]
                };
              }
              function l(e, t, r) {
                return "A" + e + "," + e + " 0 " + +(r > Oe) + ",1 " + t;
              }
              function s(e, t, r, n) {
                return "Q 0,0 " + n;
              }
              return i.radius = function (e) {
                return arguments.length ? (r = gt(e), i) : r;
              }, i.source = function (t) {
                return arguments.length ? (e = gt(t), i) : e;
              }, i.target = function (e) {
                return arguments.length ? (t = gt(e), i) : t;
              }, i.startAngle = function (e) {
                return arguments.length ? (n = gt(e), i) : n;
              }, i.endAngle = function (e) {
                return arguments.length ? (a = gt(e), i) : a;
              }, i;
            }, i.svg.diagonal = function () {
              var e = Ba,
                t = ja,
                r = Va;
              function n(n, a) {
                var i = e.call(this, n, a),
                  o = t.call(this, n, a),
                  l = (i.y + o.y) / 2,
                  s = [i, {
                    x: i.x,
                    y: l
                  }, {
                    x: o.x,
                    y: l
                  }, o];
                return "M" + (s = s.map(r))[0] + "C" + s[1] + " " + s[2] + " " + s[3];
              }
              return n.source = function (t) {
                return arguments.length ? (e = gt(t), n) : e;
              }, n.target = function (e) {
                return arguments.length ? (t = gt(e), n) : t;
              }, n.projection = function (e) {
                return arguments.length ? (r = e, n) : r;
              }, n;
            }, i.svg.diagonal.radial = function () {
              var e = i.svg.diagonal(),
                t = Va,
                r = e.projection;
              return e.projection = function (e) {
                return arguments.length ? r(function (e) {
                  return function () {
                    var t = e.apply(this, arguments),
                      r = t[0],
                      n = t[1] - ze;
                    return [r * Math.cos(n), r * Math.sin(n)];
                  };
                }(t = e)) : t;
              }, e;
            }, i.svg.symbol = function () {
              var e = qa,
                t = Ua;
              function r(r, n) {
                return (Za.get(e.call(this, r, n)) || Ga)(t.call(this, r, n));
              }
              return r.type = function (t) {
                return arguments.length ? (e = gt(t), r) : e;
              }, r.size = function (e) {
                return arguments.length ? (t = gt(e), r) : t;
              }, r;
            };
            var Za = i.map({
              circle: Ga,
              cross: function (e) {
                var t = Math.sqrt(e / 5) / 2;
                return "M" + -3 * t + "," + -t + "H" + -t + "V" + -3 * t + "H" + t + "V" + -t + "H" + 3 * t + "V" + t + "H" + t + "V" + 3 * t + "H" + -t + "V" + t + "H" + -3 * t + "Z";
              },
              diamond: function (e) {
                var t = Math.sqrt(e / (2 * Ja)),
                  r = t * Ja;
                return "M0," + -t + "L" + r + ",0 0," + t + " " + -r + ",0Z";
              },
              square: function (e) {
                var t = Math.sqrt(e) / 2;
                return "M" + -t + "," + -t + "L" + t + "," + -t + " " + t + "," + t + " " + -t + "," + t + "Z";
              },
              "triangle-down": function (e) {
                var t = Math.sqrt(e / Wa),
                  r = t * Wa / 2;
                return "M0," + r + "L" + t + "," + -r + " " + -t + "," + -r + "Z";
              },
              "triangle-up": function (e) {
                var t = Math.sqrt(e / Wa),
                  r = t * Wa / 2;
                return "M0," + -r + "L" + t + "," + r + " " + -t + "," + r + "Z";
              }
            });
            i.svg.symbolTypes = Za.keys();
            var Wa = Math.sqrt(3),
              Ja = Math.tan(30 * Ie);
            K.transition = function (e) {
              for (var t, r, n = $a || ++ri, a = ii(e), i = [], o = ei || {
                  time: Date.now(),
                  ease: Pr,
                  delay: 0,
                  duration: 250
                }, l = -1, s = this.length; ++l < s;) {
                i.push(t = []);
                for (var c = this[l], u = -1, f = c.length; ++u < f;) (r = c[u]) && oi(r, u, a, n, o), t.push(r);
              }
              return Qa(i, a, n);
            }, K.interrupt = function (e) {
              return this.each(null == e ? Xa : Ka(ii(e)));
            };
            var Xa = Ka(ii());
            function Ka(e) {
              return function () {
                var t, r, n;
                (t = this[e]) && (n = t[r = t.active]) && (n.timer.c = null, n.timer.t = NaN, --t.count ? delete t[r] : delete this[e], t.active += .5, n.event && n.event.interrupt.call(this, this.__data__, n.index));
              };
            }
            function Qa(e, t, r) {
              return G(e, ti), e.namespace = t, e.id = r, e;
            }
            var $a,
              ei,
              ti = [],
              ri = 0;
            function ni(e, t, r, n) {
              var a = e.id,
                i = e.namespace;
              return ve(e, "function" == typeof r ? function (e, o, l) {
                e[i][a].tween.set(t, n(r.call(e, e.__data__, o, l)));
              } : (r = n(r), function (e) {
                e[i][a].tween.set(t, r);
              }));
            }
            function ai(e) {
              return null == e && (e = ""), function () {
                this.textContent = e;
              };
            }
            function ii(e) {
              return null == e ? "__transition__" : "__transition_" + e + "__";
            }
            function oi(e, t, r, n, a) {
              var i,
                o,
                l,
                s,
                c,
                u = e[r] || (e[r] = {
                  active: 0,
                  count: 0
                }),
                f = u[n];
              function d(r) {
                var a = u.active,
                  d = u[a];
                for (var p in d && (d.timer.c = null, d.timer.t = NaN, --u.count, delete u[a], d.event && d.event.interrupt.call(e, e.__data__, d.index)), u) if (+p < n) {
                  var v = u[p];
                  v.timer.c = null, v.timer.t = NaN, --u.count, delete u[p];
                }
                o.c = h, Mt(function () {
                  return o.c && h(r || 1) && (o.c = null, o.t = NaN), 1;
                }, 0, i), u.active = n, f.event && f.event.start.call(e, e.__data__, t), c = [], f.tween.forEach(function (r, n) {
                  (n = n.call(e, e.__data__, t)) && c.push(n);
                }), s = f.ease, l = f.duration;
              }
              function h(a) {
                for (var i = a / l, o = s(i), d = c.length; d > 0;) c[--d].call(e, o);
                if (i >= 1) return f.event && f.event.end.call(e, e.__data__, t), --u.count ? delete u[n] : delete e[r], 1;
              }
              f || (i = a.time, o = Mt(function (e) {
                var t = f.delay;
                if (o.t = t + i, t <= e) return d(e - t);
                o.c = d;
              }, 0, i), f = u[n] = {
                tween: new M(),
                time: i,
                timer: o,
                delay: a.delay,
                duration: a.duration,
                ease: a.ease,
                index: t
              }, a = null, ++u.count);
            }
            ti.call = K.call, ti.empty = K.empty, ti.node = K.node, ti.size = K.size, i.transition = function (e, t) {
              return e && e.transition ? $a ? e.transition(t) : e : i.selection().transition(e);
            }, i.transition.prototype = ti, ti.select = function (e) {
              var t,
                r,
                n,
                a = this.id,
                i = this.namespace,
                o = [];
              e = Q(e);
              for (var l = -1, s = this.length; ++l < s;) {
                o.push(t = []);
                for (var c = this[l], u = -1, f = c.length; ++u < f;) (n = c[u]) && (r = e.call(n, n.__data__, u, l)) ? ("__data__" in n && (r.__data__ = n.__data__), oi(r, u, i, a, n[i][a]), t.push(r)) : t.push(null);
              }
              return Qa(o, i, a);
            }, ti.selectAll = function (e) {
              var t,
                r,
                n,
                a,
                i,
                o = this.id,
                l = this.namespace,
                s = [];
              e = $(e);
              for (var c = -1, u = this.length; ++c < u;) for (var f = this[c], d = -1, h = f.length; ++d < h;) if (n = f[d]) {
                i = n[l][o], r = e.call(n, n.__data__, d, c), s.push(t = []);
                for (var p = -1, v = r.length; ++p < v;) (a = r[p]) && oi(a, p, l, o, i), t.push(a);
              }
              return Qa(s, l, o);
            }, ti.filter = function (e) {
              var t,
                r,
                n = [];
              "function" != typeof e && (e = he(e));
              for (var a = 0, i = this.length; a < i; a++) {
                n.push(t = []);
                for (var o, l = 0, s = (o = this[a]).length; l < s; l++) (r = o[l]) && e.call(r, r.__data__, l, a) && t.push(r);
              }
              return Qa(n, this.namespace, this.id);
            }, ti.tween = function (e, t) {
              var r = this.id,
                n = this.namespace;
              return arguments.length < 2 ? this.node()[n][r].tween.get(e) : ve(this, null == t ? function (t) {
                t[n][r].tween.remove(e);
              } : function (a) {
                a[n][r].tween.set(e, t);
              });
            }, ti.attr = function (e, t) {
              if (arguments.length < 2) {
                for (t in e) this.attr(t, e[t]);
                return this;
              }
              var r = "transform" == e ? Vr : Tr,
                n = i.ns.qualify(e);
              function a() {
                this.removeAttribute(n);
              }
              function o() {
                this.removeAttributeNS(n.space, n.local);
              }
              return ni(this, "attr." + e, t, n.local ? function (e) {
                return null == e ? o : (e += "", function () {
                  var t,
                    a = this.getAttributeNS(n.space, n.local);
                  return a !== e && (t = r(a, e), function (e) {
                    this.setAttributeNS(n.space, n.local, t(e));
                  });
                });
              } : function (e) {
                return null == e ? a : (e += "", function () {
                  var t,
                    a = this.getAttribute(n);
                  return a !== e && (t = r(a, e), function (e) {
                    this.setAttribute(n, t(e));
                  });
                });
              });
            }, ti.attrTween = function (e, t) {
              var r = i.ns.qualify(e);
              return this.tween("attr." + e, r.local ? function (e, n) {
                var a = t.call(this, e, n, this.getAttributeNS(r.space, r.local));
                return a && function (e) {
                  this.setAttributeNS(r.space, r.local, a(e));
                };
              } : function (e, n) {
                var a = t.call(this, e, n, this.getAttribute(r));
                return a && function (e) {
                  this.setAttribute(r, a(e));
                };
              });
            }, ti.style = function (e, t, r) {
              var n = arguments.length;
              if (n < 3) {
                if ("string" != typeof e) {
                  for (r in n < 2 && (t = ""), e) this.style(r, e[r], t);
                  return this;
                }
                r = "";
              }
              function a() {
                this.style.removeProperty(e);
              }
              return ni(this, "style." + e, t, function (t) {
                return null == t ? a : (t += "", function () {
                  var n,
                    a = u(this).getComputedStyle(this, null).getPropertyValue(e);
                  return a !== t && (n = Tr(a, t), function (t) {
                    this.style.setProperty(e, n(t), r);
                  });
                });
              });
            }, ti.styleTween = function (e, t, r) {
              return arguments.length < 3 && (r = ""), this.tween("style." + e, function (n, a) {
                var i = t.call(this, n, a, u(this).getComputedStyle(this, null).getPropertyValue(e));
                return i && function (t) {
                  this.style.setProperty(e, i(t), r);
                };
              });
            }, ti.text = function (e) {
              return ni(this, "text", e, ai);
            }, ti.remove = function () {
              var e = this.namespace;
              return this.each("end.transition", function () {
                var t;
                this[e].count < 2 && (t = this.parentNode) && t.removeChild(this);
              });
            }, ti.ease = function (e) {
              var t = this.id,
                r = this.namespace;
              return arguments.length < 1 ? this.node()[r][t].ease : ("function" != typeof e && (e = i.ease.apply(i, arguments)), ve(this, function (n) {
                n[r][t].ease = e;
              }));
            }, ti.delay = function (e) {
              var t = this.id,
                r = this.namespace;
              return arguments.length < 1 ? this.node()[r][t].delay : ve(this, "function" == typeof e ? function (n, a, i) {
                n[r][t].delay = +e.call(n, n.__data__, a, i);
              } : (e = +e, function (n) {
                n[r][t].delay = e;
              }));
            }, ti.duration = function (e) {
              var t = this.id,
                r = this.namespace;
              return arguments.length < 1 ? this.node()[r][t].duration : ve(this, "function" == typeof e ? function (n, a, i) {
                n[r][t].duration = Math.max(1, e.call(n, n.__data__, a, i));
              } : (e = Math.max(1, e), function (n) {
                n[r][t].duration = e;
              }));
            }, ti.each = function (e, t) {
              var r = this.id,
                n = this.namespace;
              if (arguments.length < 2) {
                var a = ei,
                  o = $a;
                try {
                  $a = r, ve(this, function (t, a, i) {
                    ei = t[n][r], e.call(t, t.__data__, a, i);
                  });
                } finally {
                  ei = a, $a = o;
                }
              } else ve(this, function (a) {
                var o = a[n][r];
                (o.event || (o.event = i.dispatch("start", "end", "interrupt"))).on(e, t);
              });
              return this;
            }, ti.transition = function () {
              for (var e, t, r, n = this.id, a = ++ri, i = this.namespace, o = [], l = 0, s = this.length; l < s; l++) {
                o.push(e = []);
                for (var c, u = 0, f = (c = this[l]).length; u < f; u++) (t = c[u]) && oi(t, u, i, a, {
                  time: (r = t[i][n]).time,
                  ease: r.ease,
                  delay: r.delay + r.duration,
                  duration: r.duration
                }), e.push(t);
              }
              return Qa(o, i, a);
            }, i.svg.axis = function () {
              var e,
                t = i.scale.linear(),
                r = li,
                n = 6,
                a = 6,
                o = 3,
                s = [10],
                c = null;
              function u(l) {
                l.each(function () {
                  var l,
                    u = i.select(this),
                    f = this.__chart__ || t,
                    d = this.__chart__ = t.copy(),
                    h = null == c ? d.ticks ? d.ticks.apply(d, s) : d.domain() : c,
                    p = null == e ? d.tickFormat ? d.tickFormat.apply(d, s) : E : e,
                    v = u.selectAll(".tick").data(h, d),
                    g = v.enter().insert("g", ".domain").attr("class", "tick").style("opacity", Se),
                    m = i.transition(v.exit()).style("opacity", Se).remove(),
                    y = i.transition(v.order()).style("opacity", 1),
                    x = Math.max(n, 0) + o,
                    b = Vn(d),
                    _ = u.selectAll(".domain").data([0]),
                    w = (_.enter().append("path").attr("class", "domain"), i.transition(_));
                  g.append("line"), g.append("text");
                  var T,
                    M,
                    k,
                    A,
                    L = g.select("line"),
                    S = y.select("line"),
                    C = v.select("text").text(p),
                    O = g.select("text"),
                    D = y.select("text"),
                    P = "top" === r || "left" === r ? -1 : 1;
                  if ("bottom" === r || "top" === r ? (l = ci, T = "x", k = "y", M = "x2", A = "y2", C.attr("dy", P < 0 ? "0em" : ".71em").style("text-anchor", "middle"), w.attr("d", "M" + b[0] + "," + P * a + "V0H" + b[1] + "V" + P * a)) : (l = ui, T = "y", k = "x", M = "y2", A = "x2", C.attr("dy", ".32em").style("text-anchor", P < 0 ? "end" : "start"), w.attr("d", "M" + P * a + "," + b[0] + "H0V" + b[1] + "H" + P * a)), L.attr(A, P * n), O.attr(k, P * x), S.attr(M, 0).attr(A, P * n), D.attr(T, 0).attr(k, P * x), d.rangeBand) {
                    var z = d,
                      I = z.rangeBand() / 2;
                    f = d = function (e) {
                      return z(e) + I;
                    };
                  } else f.rangeBand ? f = d : m.call(l, d, f);
                  g.call(l, f, d), y.call(l, d, d);
                });
              }
              return u.scale = function (e) {
                return arguments.length ? (t = e, u) : t;
              }, u.orient = function (e) {
                return arguments.length ? (r = e in si ? e + "" : li, u) : r;
              }, u.ticks = function () {
                return arguments.length ? (s = l(arguments), u) : s;
              }, u.tickValues = function (e) {
                return arguments.length ? (c = e, u) : c;
              }, u.tickFormat = function (t) {
                return arguments.length ? (e = t, u) : e;
              }, u.tickSize = function (e) {
                var t = arguments.length;
                return t ? (n = +e, a = +arguments[t - 1], u) : n;
              }, u.innerTickSize = function (e) {
                return arguments.length ? (n = +e, u) : n;
              }, u.outerTickSize = function (e) {
                return arguments.length ? (a = +e, u) : a;
              }, u.tickPadding = function (e) {
                return arguments.length ? (o = +e, u) : o;
              }, u.tickSubdivide = function () {
                return arguments.length && u;
              }, u;
            };
            var li = "bottom",
              si = {
                top: 1,
                right: 1,
                bottom: 1,
                left: 1
              };
            function ci(e, t, r) {
              e.attr("transform", function (e) {
                var n = t(e);
                return "translate(" + (isFinite(n) ? n : r(e)) + ",0)";
              });
            }
            function ui(e, t, r) {
              e.attr("transform", function (e) {
                var n = t(e);
                return "translate(0," + (isFinite(n) ? n : r(e)) + ")";
              });
            }
            i.svg.brush = function () {
              var e,
                t,
                r = U(d, "brushstart", "brush", "brushend"),
                n = null,
                a = null,
                o = [0, 0],
                l = [0, 0],
                s = !0,
                c = !0,
                f = di[0];
              function d(e) {
                e.each(function () {
                  var e = i.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", g).on("touchstart.brush", g),
                    t = e.selectAll(".background").data([0]);
                  t.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), e.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
                  var r = e.selectAll(".resize").data(f, E);
                  r.exit().remove(), r.enter().append("g").attr("class", function (e) {
                    return "resize " + e;
                  }).style("cursor", function (e) {
                    return fi[e];
                  }).append("rect").attr("x", function (e) {
                    return /[ew]$/.test(e) ? -3 : null;
                  }).attr("y", function (e) {
                    return /^[ns]/.test(e) ? -3 : null;
                  }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), r.style("display", d.empty() ? "none" : null);
                  var o,
                    l = i.transition(e),
                    s = i.transition(t);
                  n && (o = Vn(n), s.attr("x", o[0]).attr("width", o[1] - o[0]), p(l)), a && (o = Vn(a), s.attr("y", o[0]).attr("height", o[1] - o[0]), v(l)), h(l);
                });
              }
              function h(e) {
                e.selectAll(".resize").attr("transform", function (e) {
                  return "translate(" + o[+/e$/.test(e)] + "," + l[+/^s/.test(e)] + ")";
                });
              }
              function p(e) {
                e.select(".extent").attr("x", o[0]), e.selectAll(".extent,.n>rect,.s>rect").attr("width", o[1] - o[0]);
              }
              function v(e) {
                e.select(".extent").attr("y", l[0]), e.selectAll(".extent,.e>rect,.w>rect").attr("height", l[1] - l[0]);
              }
              function g() {
                var f,
                  g,
                  m = this,
                  y = i.select(i.event.target),
                  x = r.of(m, arguments),
                  b = i.select(m),
                  _ = y.datum(),
                  w = !/^(n|s)$/.test(_) && n,
                  T = !/^(e|w)$/.test(_) && a,
                  M = y.classed("extent"),
                  k = Me(m),
                  A = i.mouse(m),
                  L = i.select(u(m)).on("keydown.brush", function () {
                    32 == i.event.keyCode && (M || (f = null, A[0] -= o[1], A[1] -= l[1], M = 2), Y());
                  }).on("keyup.brush", function () {
                    32 == i.event.keyCode && 2 == M && (A[0] += o[1], A[1] += l[1], M = 0, Y());
                  });
                if (i.event.changedTouches ? L.on("touchmove.brush", O).on("touchend.brush", P) : L.on("mousemove.brush", O).on("mouseup.brush", P), b.interrupt().selectAll("*").interrupt(), M) A[0] = o[0] - A[0], A[1] = l[0] - A[1];else if (_) {
                  var S = +/w$/.test(_),
                    C = +/^n/.test(_);
                  g = [o[1 - S] - A[0], l[1 - C] - A[1]], A[0] = o[S], A[1] = l[C];
                } else i.event.altKey && (f = A.slice());
                function O() {
                  var e = i.mouse(m),
                    t = !1;
                  g && (e[0] += g[0], e[1] += g[1]), M || (i.event.altKey ? (f || (f = [(o[0] + o[1]) / 2, (l[0] + l[1]) / 2]), A[0] = o[+(e[0] < f[0])], A[1] = l[+(e[1] < f[1])]) : f = null), w && D(e, n, 0) && (p(b), t = !0), T && D(e, a, 1) && (v(b), t = !0), t && (h(b), x({
                    type: "brush",
                    mode: M ? "move" : "resize"
                  }));
                }
                function D(r, n, a) {
                  var i,
                    u,
                    d = Vn(n),
                    h = d[0],
                    p = d[1],
                    v = A[a],
                    g = a ? l : o,
                    m = g[1] - g[0];
                  if (M && (h -= v, p -= m + v), i = (a ? c : s) ? Math.max(h, Math.min(p, r[a])) : r[a], M ? u = (i += v) + m : (f && (v = Math.max(h, Math.min(p, 2 * f[a] - i))), v < i ? (u = i, i = v) : u = v), g[0] != i || g[1] != u) return a ? t = null : e = null, g[0] = i, g[1] = u, !0;
                }
                function P() {
                  O(), b.style("pointer-events", "all").selectAll(".resize").style("display", d.empty() ? "none" : null), i.select("body").style("cursor", null), L.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), k(), x({
                    type: "brushend"
                  });
                }
                b.style("pointer-events", "none").selectAll(".resize").style("display", null), i.select("body").style("cursor", y.style("cursor")), x({
                  type: "brushstart"
                }), O();
              }
              return d.event = function (n) {
                n.each(function () {
                  var n = r.of(this, arguments),
                    a = {
                      x: o,
                      y: l,
                      i: e,
                      j: t
                    },
                    s = this.__chart__ || a;
                  this.__chart__ = a, $a ? i.select(this).transition().each("start.brush", function () {
                    e = s.i, t = s.j, o = s.x, l = s.y, n({
                      type: "brushstart"
                    });
                  }).tween("brush:brush", function () {
                    var r = Mr(o, a.x),
                      i = Mr(l, a.y);
                    return e = t = null, function (e) {
                      o = a.x = r(e), l = a.y = i(e), n({
                        type: "brush",
                        mode: "resize"
                      });
                    };
                  }).each("end.brush", function () {
                    e = a.i, t = a.j, n({
                      type: "brush",
                      mode: "resize"
                    }), n({
                      type: "brushend"
                    });
                  }) : (n({
                    type: "brushstart"
                  }), n({
                    type: "brush",
                    mode: "resize"
                  }), n({
                    type: "brushend"
                  }));
                });
              }, d.x = function (e) {
                return arguments.length ? (f = di[!(n = e) << 1 | !a], d) : n;
              }, d.y = function (e) {
                return arguments.length ? (f = di[!n << 1 | !(a = e)], d) : a;
              }, d.clamp = function (e) {
                return arguments.length ? (n && a ? (s = !!e[0], c = !!e[1]) : n ? s = !!e : a && (c = !!e), d) : n && a ? [s, c] : n ? s : a ? c : null;
              }, d.extent = function (r) {
                var i, s, c, u, f;
                return arguments.length ? (n && (i = r[0], s = r[1], a && (i = i[0], s = s[0]), e = [i, s], n.invert && (i = n(i), s = n(s)), s < i && (f = i, i = s, s = f), i == o[0] && s == o[1] || (o = [i, s])), a && (c = r[0], u = r[1], n && (c = c[1], u = u[1]), t = [c, u], a.invert && (c = a(c), u = a(u)), u < c && (f = c, c = u, u = f), c == l[0] && u == l[1] || (l = [c, u])), d) : (n && (e ? (i = e[0], s = e[1]) : (i = o[0], s = o[1], n.invert && (i = n.invert(i), s = n.invert(s)), s < i && (f = i, i = s, s = f))), a && (t ? (c = t[0], u = t[1]) : (c = l[0], u = l[1], a.invert && (c = a.invert(c), u = a.invert(u)), u < c && (f = c, c = u, u = f))), n && a ? [[i, c], [s, u]] : n ? [i, s] : a && [c, u]);
              }, d.clear = function () {
                return d.empty() || (o = [0, 0], l = [0, 0], e = t = null), d;
              }, d.empty = function () {
                return !!n && o[0] == o[1] || !!a && l[0] == l[1];
              }, i.rebind(d, r, "on");
            };
            var fi = {
                n: "ns-resize",
                e: "ew-resize",
                s: "ns-resize",
                w: "ew-resize",
                nw: "nwse-resize",
                ne: "nesw-resize",
                se: "nwse-resize",
                sw: "nesw-resize"
              },
              di = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []];
            function hi(e) {
              return JSON.parse(e.responseText);
            }
            function pi(e) {
              var t = s.createRange();
              return t.selectNode(s.body), t.createContextualFragment(e.responseText);
            }
            i.text = mt(function (e) {
              return e.responseText;
            }), i.json = function (e, t) {
              return yt(e, "application/json", hi, t);
            }, i.html = function (e, t) {
              return yt(e, "text/html", pi, t);
            }, i.xml = mt(function (e) {
              return e.responseXML;
            }), void 0 === (a = "function" == typeof (n = i) ? n.call(t, r, t, e) : n) || (e.exports = a);
          }).apply(self);
        },
        3229: function (e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            decode: function () {
              return l;
            },
            encode: function () {
              return o;
            }
          });
          for (var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), i = 0; i < 64; i++) a[n.charCodeAt(i)] = i;
          var o = function (e) {
              var t,
                r = new Uint8Array(e),
                a = r.length,
                i = "";
              for (t = 0; t < a; t += 3) i += n[r[t] >> 2], i += n[(3 & r[t]) << 4 | r[t + 1] >> 4], i += n[(15 & r[t + 1]) << 2 | r[t + 2] >> 6], i += n[63 & r[t + 2]];
              return a % 3 == 2 ? i = i.substring(0, i.length - 1) + "=" : a % 3 == 1 && (i = i.substring(0, i.length - 2) + "=="), i;
            },
            l = function (e) {
              var t,
                r,
                n,
                i,
                o,
                l = .75 * e.length,
                s = e.length,
                c = 0;
              "=" === e[e.length - 1] && (l--, "=" === e[e.length - 2] && l--);
              var u = new ArrayBuffer(l),
                f = new Uint8Array(u);
              for (t = 0; t < s; t += 4) r = a[e.charCodeAt(t)], n = a[e.charCodeAt(t + 1)], i = a[e.charCodeAt(t + 2)], o = a[e.charCodeAt(t + 3)], f[c++] = r << 2 | n >> 4, f[c++] = (15 & n) << 4 | i >> 2, f[c++] = (3 & i) << 6 | 63 & o;
              return u;
            };
        },
        1070: function (e) {
          "use strict";

          e.exports = function (e) {
            var t = [];
            return t.toString = function () {
              return this.map(function (t) {
                var r = "",
                  n = void 0 !== t[5];
                return t[4] && (r += "@supports (".concat(t[4], ") {")), t[2] && (r += "@media ".concat(t[2], " {")), n && (r += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), r += e(t), n && (r += "}"), t[2] && (r += "}"), t[4] && (r += "}"), r;
              }).join("");
            }, t.i = function (e, r, n, a, i) {
              "string" == typeof e && (e = [[null, e, void 0]]);
              var o = {};
              if (n) for (var l = 0; l < this.length; l++) {
                var s = this[l][0];
                null != s && (o[s] = !0);
              }
              for (var c = 0; c < e.length; c++) {
                var u = [].concat(e[c]);
                n && o[u[0]] || (void 0 !== i && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = i), r && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = r) : u[2] = r), a && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = a) : u[4] = "".concat(a)), t.push(u));
              }
            }, t;
          };
        },
        2133: function (e) {
          "use strict";

          e.exports = function (e, t) {
            return t || (t = {}), e ? (e = String(e.__esModule ? e.default : e), /^['"].*['"]$/.test(e) && (e = e.slice(1, -1)), t.hash && (e += t.hash), /["'() \t\n]|(%20)/.test(e) || t.needQuotes ? '"'.concat(e.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : e) : e;
          };
        },
        2413: function (e) {
          "use strict";

          e.exports = function (e) {
            return e[1];
          };
        },
        6464: function (e, t, r) {
          "use strict";

          function n(e, t) {
            if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
            var r,
              n = e.slice(0, r);
            return [n.length > 1 ? n[0] + n.slice(2) : n, +e.slice(r + 1)];
          }
          r.d(t, {
            GP: function () {
              return d;
            },
            OE: function () {
              return v;
            }
          });
          var a,
            i = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
          function o(e) {
            if (!(t = i.exec(e))) throw new Error("invalid format: " + e);
            var t;
            return new l({
              fill: t[1],
              align: t[2],
              sign: t[3],
              symbol: t[4],
              zero: t[5],
              width: t[6],
              comma: t[7],
              precision: t[8] && t[8].slice(1),
              trim: t[9],
              type: t[10]
            });
          }
          function l(e) {
            this.fill = void 0 === e.fill ? " " : e.fill + "", this.align = void 0 === e.align ? ">" : e.align + "", this.sign = void 0 === e.sign ? "-" : e.sign + "", this.symbol = void 0 === e.symbol ? "" : e.symbol + "", this.zero = !!e.zero, this.width = void 0 === e.width ? void 0 : +e.width, this.comma = !!e.comma, this.precision = void 0 === e.precision ? void 0 : +e.precision, this.trim = !!e.trim, this.type = void 0 === e.type ? "" : e.type + "";
          }
          function s(e, t) {
            var r = n(e, t);
            if (!r) return e + "";
            var a = r[0],
              i = r[1];
            return i < 0 ? "0." + new Array(-i).join("0") + a : a.length > i + 1 ? a.slice(0, i + 1) + "." + a.slice(i + 1) : a + new Array(i - a.length + 2).join("0");
          }
          o.prototype = l.prototype, l.prototype.toString = function () {
            return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
          };
          var c = {
            "%": function (e, t) {
              return (100 * e).toFixed(t);
            },
            b: function (e) {
              return Math.round(e).toString(2);
            },
            c: function (e) {
              return e + "";
            },
            d: function (e) {
              return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
            },
            e: function (e, t) {
              return e.toExponential(t);
            },
            f: function (e, t) {
              return e.toFixed(t);
            },
            g: function (e, t) {
              return e.toPrecision(t);
            },
            o: function (e) {
              return Math.round(e).toString(8);
            },
            p: function (e, t) {
              return s(100 * e, t);
            },
            r: s,
            s: function (e, t) {
              var r = n(e, t);
              if (!r) return e + "";
              var i = r[0],
                o = r[1],
                l = o - (a = 3 * Math.max(-8, Math.min(8, Math.floor(o / 3)))) + 1,
                s = i.length;
              return l === s ? i : l > s ? i + new Array(l - s + 1).join("0") : l > 0 ? i.slice(0, l) + "." + i.slice(l) : "0." + new Array(1 - l).join("0") + n(e, Math.max(0, t + l - 1))[0];
            },
            X: function (e) {
              return Math.round(e).toString(16).toUpperCase();
            },
            x: function (e) {
              return Math.round(e).toString(16);
            }
          };
          function u(e) {
            return e;
          }
          var f,
            d,
            h = Array.prototype.map,
            p = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
          function v(e) {
            var t,
              r,
              i = void 0 === e.grouping || void 0 === e.thousands ? u : (t = h.call(e.grouping, Number), r = e.thousands + "", function (e, n) {
                for (var a = e.length, i = [], o = 0, l = t[0], s = 0; a > 0 && l > 0 && (s + l + 1 > n && (l = Math.max(1, n - s)), i.push(e.substring(a -= l, a + l)), !((s += l + 1) > n));) l = t[o = (o + 1) % t.length];
                return i.reverse().join(r);
              }),
              l = void 0 === e.currency ? "" : e.currency[0] + "",
              s = void 0 === e.currency ? "" : e.currency[1] + "",
              f = void 0 === e.decimal ? "." : e.decimal + "",
              d = void 0 === e.numerals ? u : function (e) {
                return function (t) {
                  return t.replace(/[0-9]/g, function (t) {
                    return e[+t];
                  });
                };
              }(h.call(e.numerals, String)),
              v = void 0 === e.percent ? "%" : e.percent + "",
              g = void 0 === e.minus ? "-" : e.minus + "",
              m = void 0 === e.nan ? "NaN" : e.nan + "";
            function y(e) {
              var t = (e = o(e)).fill,
                r = e.align,
                n = e.sign,
                u = e.symbol,
                h = e.zero,
                y = e.width,
                x = e.comma,
                b = e.precision,
                _ = e.trim,
                w = e.type;
              "n" === w ? (x = !0, w = "g") : c[w] || (void 0 === b && (b = 12), _ = !0, w = "g"), (h || "0" === t && "=" === r) && (h = !0, t = "0", r = "=");
              var T = "$" === u ? l : "#" === u && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "",
                M = "$" === u ? s : /[%p]/.test(w) ? v : "",
                k = c[w],
                A = /[defgprs%]/.test(w);
              function L(e) {
                var o,
                  l,
                  s,
                  c = T,
                  u = M;
                if ("c" === w) u = k(e) + u, e = "";else {
                  var v = (e = +e) < 0 || 1 / e < 0;
                  if (e = isNaN(e) ? m : k(Math.abs(e), b), _ && (e = function (e) {
                    e: for (var t, r = e.length, n = 1, a = -1; n < r; ++n) switch (e[n]) {
                      case ".":
                        a = t = n;
                        break;
                      case "0":
                        0 === a && (a = n), t = n;
                        break;
                      default:
                        if (!+e[n]) break e;
                        a > 0 && (a = 0);
                    }
                    return a > 0 ? e.slice(0, a) + e.slice(t + 1) : e;
                  }(e)), v && 0 == +e && "+" !== n && (v = !1), c = (v ? "(" === n ? n : g : "-" === n || "(" === n ? "" : n) + c, u = ("s" === w ? p[8 + a / 3] : "") + u + (v && "(" === n ? ")" : ""), A) for (o = -1, l = e.length; ++o < l;) if (48 > (s = e.charCodeAt(o)) || s > 57) {
                    u = (46 === s ? f + e.slice(o + 1) : e.slice(o)) + u, e = e.slice(0, o);
                    break;
                  }
                }
                x && !h && (e = i(e, 1 / 0));
                var L = c.length + e.length + u.length,
                  S = L < y ? new Array(y - L + 1).join(t) : "";
                switch (x && h && (e = i(S + e, S.length ? y - u.length : 1 / 0), S = ""), r) {
                  case "<":
                    e = c + e + u + S;
                    break;
                  case "=":
                    e = c + S + e + u;
                    break;
                  case "^":
                    e = S.slice(0, L = S.length >> 1) + c + e + u + S.slice(L);
                    break;
                  default:
                    e = S + c + e + u;
                }
                return d(e);
              }
              return b = void 0 === b ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, b)) : Math.max(0, Math.min(20, b)), L.toString = function () {
                return e + "";
              }, L;
            }
            return {
              format: y,
              formatPrefix: function (e, t) {
                var r,
                  a = y(((e = o(e)).type = "f", e)),
                  i = 3 * Math.max(-8, Math.min(8, Math.floor((r = t, ((r = n(Math.abs(r))) ? r[1] : NaN) / 3)))),
                  l = Math.pow(10, -i),
                  s = p[8 + i / 3];
                return function (e) {
                  return a(l * e) + s;
                };
              }
            };
          }
          f = v({
            decimal: ".",
            thousands: ",",
            grouping: [3],
            currency: ["$", ""],
            minus: "-"
          }), d = f.format, f.formatPrefix;
        },
        2696: function (e, t, r) {
          "use strict";

          r.d(t, {
            DC: function () {
              return p;
            },
            de: function () {
              return d;
            },
            aL: function () {
              return v;
            }
          });
          var n = r(1681),
            a = r(2543),
            i = r(5735),
            o = r(7265),
            l = r(9830),
            s = r(9764);
          function c(e) {
            if (0 <= e.y && e.y < 100) {
              var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
              return t.setFullYear(e.y), t;
            }
            return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
          }
          function u(e) {
            if (0 <= e.y && e.y < 100) {
              var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
              return t.setUTCFullYear(e.y), t;
            }
            return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
          }
          function f(e, t, r) {
            return {
              y: e,
              m: t,
              d: r,
              H: 0,
              M: 0,
              S: 0,
              L: 0
            };
          }
          function d(e) {
            var t = e.dateTime,
              r = e.date,
              l = e.time,
              s = e.periods,
              d = e.days,
              h = e.shortDays,
              p = e.months,
              v = e.shortMonths,
              m = w(s),
              y = T(s),
              x = w(d),
              b = T(d),
              _ = w(h),
              Le = T(h),
              Se = w(p),
              Ce = T(p),
              Oe = w(v),
              De = T(v),
              Pe = {
                a: function (e) {
                  return h[e.getDay()];
                },
                A: function (e) {
                  return d[e.getDay()];
                },
                b: function (e) {
                  return v[e.getMonth()];
                },
                B: function (e) {
                  return p[e.getMonth()];
                },
                c: null,
                d: U,
                e: U,
                f: J,
                H: q,
                I: G,
                j: Z,
                L: W,
                m: X,
                M: K,
                p: function (e) {
                  return s[+(e.getHours() >= 12)];
                },
                q: function (e) {
                  return 1 + ~~(e.getMonth() / 3);
                },
                Q: ke,
                s: Ae,
                S: Q,
                u: $,
                U: ee,
                V: te,
                w: re,
                W: ne,
                x: null,
                X: null,
                y: ae,
                Y: ie,
                Z: oe,
                "%": Me
              },
              ze = {
                a: function (e) {
                  return h[e.getUTCDay()];
                },
                A: function (e) {
                  return d[e.getUTCDay()];
                },
                b: function (e) {
                  return v[e.getUTCMonth()];
                },
                B: function (e) {
                  return p[e.getUTCMonth()];
                },
                c: null,
                d: le,
                e: le,
                f: de,
                H: se,
                I: ce,
                j: ue,
                L: fe,
                m: he,
                M: pe,
                p: function (e) {
                  return s[+(e.getUTCHours() >= 12)];
                },
                q: function (e) {
                  return 1 + ~~(e.getUTCMonth() / 3);
                },
                Q: ke,
                s: Ae,
                S: ve,
                u: ge,
                U: me,
                V: ye,
                w: xe,
                W: be,
                x: null,
                X: null,
                y: _e,
                Y: we,
                Z: Te,
                "%": Me
              },
              Ie = {
                a: function (e, t, r) {
                  var n = _.exec(t.slice(r));
                  return n ? (e.w = Le[n[0].toLowerCase()], r + n[0].length) : -1;
                },
                A: function (e, t, r) {
                  var n = x.exec(t.slice(r));
                  return n ? (e.w = b[n[0].toLowerCase()], r + n[0].length) : -1;
                },
                b: function (e, t, r) {
                  var n = Oe.exec(t.slice(r));
                  return n ? (e.m = De[n[0].toLowerCase()], r + n[0].length) : -1;
                },
                B: function (e, t, r) {
                  var n = Se.exec(t.slice(r));
                  return n ? (e.m = Ce[n[0].toLowerCase()], r + n[0].length) : -1;
                },
                c: function (e, r, n) {
                  return Ne(e, t, r, n);
                },
                d: I,
                e: I,
                f: B,
                H: R,
                I: R,
                j: E,
                L: H,
                m: z,
                M: N,
                p: function (e, t, r) {
                  var n = m.exec(t.slice(r));
                  return n ? (e.p = y[n[0].toLowerCase()], r + n[0].length) : -1;
                },
                q: P,
                Q: Y,
                s: V,
                S: F,
                u: k,
                U: A,
                V: L,
                w: M,
                W: S,
                x: function (e, t, n) {
                  return Ne(e, r, t, n);
                },
                X: function (e, t, r) {
                  return Ne(e, l, t, r);
                },
                y: O,
                Y: C,
                Z: D,
                "%": j
              };
            function Ee(e, t) {
              return function (r) {
                var n,
                  a,
                  i,
                  o = [],
                  l = -1,
                  s = 0,
                  c = e.length;
                for (r instanceof Date || (r = new Date(+r)); ++l < c;) 37 === e.charCodeAt(l) && (o.push(e.slice(s, l)), null != (a = g[n = e.charAt(++l)]) ? n = e.charAt(++l) : a = "e" === n ? " " : "0", (i = t[n]) && (n = i(r, a)), o.push(n), s = l + 1);
                return o.push(e.slice(s, l)), o.join("");
              };
            }
            function Re(e, t) {
              return function (r) {
                var l,
                  s,
                  d = f(1900, void 0, 1);
                if (Ne(d, e, r += "", 0) != r.length) return null;
                if ("Q" in d) return new Date(d.Q);
                if ("s" in d) return new Date(1e3 * d.s + ("L" in d ? d.L : 0));
                if (t && !("Z" in d) && (d.Z = 0), "p" in d && (d.H = d.H % 12 + 12 * d.p), void 0 === d.m && (d.m = "q" in d ? d.q : 0), "V" in d) {
                  if (d.V < 1 || d.V > 53) return null;
                  "w" in d || (d.w = 1), "Z" in d ? (s = (l = u(f(d.y, 0, 1))).getUTCDay(), l = s > 4 || 0 === s ? n.rt.ceil(l) : (0, n.rt)(l), l = a.A.offset(l, 7 * (d.V - 1)), d.y = l.getUTCFullYear(), d.m = l.getUTCMonth(), d.d = l.getUTCDate() + (d.w + 6) % 7) : (s = (l = c(f(d.y, 0, 1))).getDay(), l = s > 4 || 0 === s ? i.By.ceil(l) : (0, i.By)(l), l = o.A.offset(l, 7 * (d.V - 1)), d.y = l.getFullYear(), d.m = l.getMonth(), d.d = l.getDate() + (d.w + 6) % 7);
                } else ("W" in d || "U" in d) && ("w" in d || (d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0), s = "Z" in d ? u(f(d.y, 0, 1)).getUTCDay() : c(f(d.y, 0, 1)).getDay(), d.m = 0, d.d = "W" in d ? (d.w + 6) % 7 + 7 * d.W - (s + 5) % 7 : d.w + 7 * d.U - (s + 6) % 7);
                return "Z" in d ? (d.H += d.Z / 100 | 0, d.M += d.Z % 100, u(d)) : c(d);
              };
            }
            function Ne(e, t, r, n) {
              for (var a, i, o = 0, l = t.length, s = r.length; o < l;) {
                if (n >= s) return -1;
                if (37 === (a = t.charCodeAt(o++))) {
                  if (a = t.charAt(o++), !(i = Ie[a in g ? t.charAt(o++) : a]) || (n = i(e, r, n)) < 0) return -1;
                } else if (a != r.charCodeAt(n++)) return -1;
              }
              return n;
            }
            return Pe.x = Ee(r, Pe), Pe.X = Ee(l, Pe), Pe.c = Ee(t, Pe), ze.x = Ee(r, ze), ze.X = Ee(l, ze), ze.c = Ee(t, ze), {
              format: function (e) {
                var t = Ee(e += "", Pe);
                return t.toString = function () {
                  return e;
                }, t;
              },
              parse: function (e) {
                var t = Re(e += "", !1);
                return t.toString = function () {
                  return e;
                }, t;
              },
              utcFormat: function (e) {
                var t = Ee(e += "", ze);
                return t.toString = function () {
                  return e;
                }, t;
              },
              utcParse: function (e) {
                var t = Re(e += "", !0);
                return t.toString = function () {
                  return e;
                }, t;
              }
            };
          }
          var h,
            p,
            v,
            g = {
              "-": "",
              _: " ",
              0: "0"
            },
            m = /^\s*\d+/,
            y = /^%/,
            x = /[\\^$*+?|[\]().{}]/g;
          function b(e, t, r) {
            var n = e < 0 ? "-" : "",
              a = (n ? -e : e) + "",
              i = a.length;
            return n + (i < r ? new Array(r - i + 1).join(t) + a : a);
          }
          function _(e) {
            return e.replace(x, "\\$&");
          }
          function w(e) {
            return new RegExp("^(?:" + e.map(_).join("|") + ")", "i");
          }
          function T(e) {
            for (var t = {}, r = -1, n = e.length; ++r < n;) t[e[r].toLowerCase()] = r;
            return t;
          }
          function M(e, t, r) {
            var n = m.exec(t.slice(r, r + 1));
            return n ? (e.w = +n[0], r + n[0].length) : -1;
          }
          function k(e, t, r) {
            var n = m.exec(t.slice(r, r + 1));
            return n ? (e.u = +n[0], r + n[0].length) : -1;
          }
          function A(e, t, r) {
            var n = m.exec(t.slice(r, r + 2));
            return n ? (e.U = +n[0], r + n[0].length) : -1;
          }
          function L(e, t, r) {
            var n = m.exec(t.slice(r, r + 2));
            return n ? (e.V = +n[0], r + n[0].length) : -1;
          }
          function S(e, t, r) {
            var n = m.exec(t.slice(r, r + 2));
            return n ? (e.W = +n[0], r + n[0].length) : -1;
          }
          function C(e, t, r) {
            var n = m.exec(t.slice(r, r + 4));
            return n ? (e.y = +n[0], r + n[0].length) : -1;
          }
          function O(e, t, r) {
            var n = m.exec(t.slice(r, r + 2));
            return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
          }
          function D(e, t, r) {
            var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
            return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
          }
          function P(e, t, r) {
            var n = m.exec(t.slice(r, r + 1));
            return n ? (e.q = 3 * n[0] - 3, r + n[0].length) : -1;
          }
          function z(e, t, r) {
            var n = m.exec(t.slice(r, r + 2));
            return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
          }
          function I(e, t, r) {
            var n = m.exec(t.slice(r, r + 2));
            return n ? (e.d = +n[0], r + n[0].length) : -1;
          }
          function E(e, t, r) {
            var n = m.exec(t.slice(r, r + 3));
            return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
          }
          function R(e, t, r) {
            var n = m.exec(t.slice(r, r + 2));
            return n ? (e.H = +n[0], r + n[0].length) : -1;
          }
          function N(e, t, r) {
            var n = m.exec(t.slice(r, r + 2));
            return n ? (e.M = +n[0], r + n[0].length) : -1;
          }
          function F(e, t, r) {
            var n = m.exec(t.slice(r, r + 2));
            return n ? (e.S = +n[0], r + n[0].length) : -1;
          }
          function H(e, t, r) {
            var n = m.exec(t.slice(r, r + 3));
            return n ? (e.L = +n[0], r + n[0].length) : -1;
          }
          function B(e, t, r) {
            var n = m.exec(t.slice(r, r + 6));
            return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
          }
          function j(e, t, r) {
            var n = y.exec(t.slice(r, r + 1));
            return n ? r + n[0].length : -1;
          }
          function Y(e, t, r) {
            var n = m.exec(t.slice(r));
            return n ? (e.Q = +n[0], r + n[0].length) : -1;
          }
          function V(e, t, r) {
            var n = m.exec(t.slice(r));
            return n ? (e.s = +n[0], r + n[0].length) : -1;
          }
          function U(e, t) {
            return b(e.getDate(), t, 2);
          }
          function q(e, t) {
            return b(e.getHours(), t, 2);
          }
          function G(e, t) {
            return b(e.getHours() % 12 || 12, t, 2);
          }
          function Z(e, t) {
            return b(1 + o.A.count((0, l.A)(e), e), t, 3);
          }
          function W(e, t) {
            return b(e.getMilliseconds(), t, 3);
          }
          function J(e, t) {
            return W(e, t) + "000";
          }
          function X(e, t) {
            return b(e.getMonth() + 1, t, 2);
          }
          function K(e, t) {
            return b(e.getMinutes(), t, 2);
          }
          function Q(e, t) {
            return b(e.getSeconds(), t, 2);
          }
          function $(e) {
            var t = e.getDay();
            return 0 === t ? 7 : t;
          }
          function ee(e, t) {
            return b(i.fz.count((0, l.A)(e) - 1, e), t, 2);
          }
          function te(e, t) {
            var r = e.getDay();
            return e = r >= 4 || 0 === r ? (0, i.dt)(e) : i.dt.ceil(e), b(i.dt.count((0, l.A)(e), e) + (4 === (0, l.A)(e).getDay()), t, 2);
          }
          function re(e) {
            return e.getDay();
          }
          function ne(e, t) {
            return b(i.By.count((0, l.A)(e) - 1, e), t, 2);
          }
          function ae(e, t) {
            return b(e.getFullYear() % 100, t, 2);
          }
          function ie(e, t) {
            return b(e.getFullYear() % 1e4, t, 4);
          }
          function oe(e) {
            var t = e.getTimezoneOffset();
            return (t > 0 ? "-" : (t *= -1, "+")) + b(t / 60 | 0, "0", 2) + b(t % 60, "0", 2);
          }
          function le(e, t) {
            return b(e.getUTCDate(), t, 2);
          }
          function se(e, t) {
            return b(e.getUTCHours(), t, 2);
          }
          function ce(e, t) {
            return b(e.getUTCHours() % 12 || 12, t, 2);
          }
          function ue(e, t) {
            return b(1 + a.A.count((0, s.A)(e), e), t, 3);
          }
          function fe(e, t) {
            return b(e.getUTCMilliseconds(), t, 3);
          }
          function de(e, t) {
            return fe(e, t) + "000";
          }
          function he(e, t) {
            return b(e.getUTCMonth() + 1, t, 2);
          }
          function pe(e, t) {
            return b(e.getUTCMinutes(), t, 2);
          }
          function ve(e, t) {
            return b(e.getUTCSeconds(), t, 2);
          }
          function ge(e) {
            var t = e.getUTCDay();
            return 0 === t ? 7 : t;
          }
          function me(e, t) {
            return b(n.Hl.count((0, s.A)(e) - 1, e), t, 2);
          }
          function ye(e, t) {
            var r = e.getUTCDay();
            return e = r >= 4 || 0 === r ? (0, n.pT)(e) : n.pT.ceil(e), b(n.pT.count((0, s.A)(e), e) + (4 === (0, s.A)(e).getUTCDay()), t, 2);
          }
          function xe(e) {
            return e.getUTCDay();
          }
          function be(e, t) {
            return b(n.rt.count((0, s.A)(e) - 1, e), t, 2);
          }
          function _e(e, t) {
            return b(e.getUTCFullYear() % 100, t, 2);
          }
          function we(e, t) {
            return b(e.getUTCFullYear() % 1e4, t, 4);
          }
          function Te() {
            return "+0000";
          }
          function Me() {
            return "%";
          }
          function ke(e) {
            return +e;
          }
          function Ae(e) {
            return Math.floor(+e / 1e3);
          }
          h = d({
            dateTime: "%x, %X",
            date: "%-m/%-d/%Y",
            time: "%-I:%M:%S %p",
            periods: ["AM", "PM"],
            days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
          }), p = h.format, h.parse, v = h.utcFormat, h.utcParse;
        },
        7265: function (e, t, r) {
          "use strict";

          r.d(t, {
            _: function () {
              return o;
            }
          });
          var n = r(3398),
            a = r(6291),
            i = (0, n.A)(function (e) {
              e.setHours(0, 0, 0, 0);
            }, function (e, t) {
              e.setDate(e.getDate() + t);
            }, function (e, t) {
              return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * a.rR) / a.Nm;
            }, function (e) {
              return e.getDate() - 1;
            });
          t.A = i;
          var o = i.range;
        },
        6291: function (e, t, r) {
          "use strict";

          r.d(t, {
            Fq: function () {
              return l;
            },
            JJ: function () {
              return i;
            },
            Nm: function () {
              return o;
            },
            Tt: function () {
              return n;
            },
            rR: function () {
              return a;
            }
          });
          var n = 1e3,
            a = 6e4,
            i = 36e5,
            o = 864e5,
            l = 6048e5;
        },
        936: function (e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            timeDay: function () {
              return m.A;
            },
            timeDays: function () {
              return m._;
            },
            timeFriday: function () {
              return y.Sh;
            },
            timeFridays: function () {
              return y.tz;
            },
            timeHour: function () {
              return v;
            },
            timeHours: function () {
              return g;
            },
            timeInterval: function () {
              return n.A;
            },
            timeMillisecond: function () {
              return i;
            },
            timeMilliseconds: function () {
              return o;
            },
            timeMinute: function () {
              return d;
            },
            timeMinutes: function () {
              return h;
            },
            timeMonday: function () {
              return y.By;
            },
            timeMondays: function () {
              return y.KP;
            },
            timeMonth: function () {
              return b;
            },
            timeMonths: function () {
              return _;
            },
            timeSaturday: function () {
              return y.kS;
            },
            timeSaturdays: function () {
              return y.t$;
            },
            timeSecond: function () {
              return c;
            },
            timeSeconds: function () {
              return u;
            },
            timeSunday: function () {
              return y.fz;
            },
            timeSundays: function () {
              return y.se;
            },
            timeThursday: function () {
              return y.dt;
            },
            timeThursdays: function () {
              return y.Q$;
            },
            timeTuesday: function () {
              return y.eQ;
            },
            timeTuesdays: function () {
              return y.yW;
            },
            timeWednesday: function () {
              return y.l3;
            },
            timeWednesdays: function () {
              return y.gf;
            },
            timeWeek: function () {
              return y.fz;
            },
            timeWeeks: function () {
              return y.se;
            },
            timeYear: function () {
              return w.A;
            },
            timeYears: function () {
              return w.V;
            },
            utcDay: function () {
              return C.A;
            },
            utcDays: function () {
              return C.o;
            },
            utcFriday: function () {
              return O.a1;
            },
            utcFridays: function () {
              return O.Zn;
            },
            utcHour: function () {
              return L;
            },
            utcHours: function () {
              return S;
            },
            utcMillisecond: function () {
              return i;
            },
            utcMilliseconds: function () {
              return o;
            },
            utcMinute: function () {
              return M;
            },
            utcMinutes: function () {
              return k;
            },
            utcMonday: function () {
              return O.rt;
            },
            utcMondays: function () {
              return O.ON;
            },
            utcMonth: function () {
              return P;
            },
            utcMonths: function () {
              return z;
            },
            utcSaturday: function () {
              return O.c8;
            },
            utcSaturdays: function () {
              return O.Xo;
            },
            utcSecond: function () {
              return c;
            },
            utcSeconds: function () {
              return u;
            },
            utcSunday: function () {
              return O.Hl;
            },
            utcSundays: function () {
              return O.aZ;
            },
            utcThursday: function () {
              return O.pT;
            },
            utcThursdays: function () {
              return O.wr;
            },
            utcTuesday: function () {
              return O.sr;
            },
            utcTuesdays: function () {
              return O.jN;
            },
            utcWednesday: function () {
              return O.z2;
            },
            utcWednesdays: function () {
              return O.G6;
            },
            utcWeek: function () {
              return O.Hl;
            },
            utcWeeks: function () {
              return O.aZ;
            },
            utcYear: function () {
              return I.A;
            },
            utcYears: function () {
              return I.j;
            }
          });
          var n = r(3398),
            a = (0, n.A)(function () {}, function (e, t) {
              e.setTime(+e + t);
            }, function (e, t) {
              return t - e;
            });
          a.every = function (e) {
            return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? (0, n.A)(function (t) {
              t.setTime(Math.floor(t / e) * e);
            }, function (t, r) {
              t.setTime(+t + r * e);
            }, function (t, r) {
              return (r - t) / e;
            }) : a : null;
          };
          var i = a,
            o = a.range,
            l = r(6291),
            s = (0, n.A)(function (e) {
              e.setTime(e - e.getMilliseconds());
            }, function (e, t) {
              e.setTime(+e + t * l.Tt);
            }, function (e, t) {
              return (t - e) / l.Tt;
            }, function (e) {
              return e.getUTCSeconds();
            }),
            c = s,
            u = s.range,
            f = (0, n.A)(function (e) {
              e.setTime(e - e.getMilliseconds() - e.getSeconds() * l.Tt);
            }, function (e, t) {
              e.setTime(+e + t * l.rR);
            }, function (e, t) {
              return (t - e) / l.rR;
            }, function (e) {
              return e.getMinutes();
            }),
            d = f,
            h = f.range,
            p = (0, n.A)(function (e) {
              e.setTime(e - e.getMilliseconds() - e.getSeconds() * l.Tt - e.getMinutes() * l.rR);
            }, function (e, t) {
              e.setTime(+e + t * l.JJ);
            }, function (e, t) {
              return (t - e) / l.JJ;
            }, function (e) {
              return e.getHours();
            }),
            v = p,
            g = p.range,
            m = r(7265),
            y = r(5735),
            x = (0, n.A)(function (e) {
              e.setDate(1), e.setHours(0, 0, 0, 0);
            }, function (e, t) {
              e.setMonth(e.getMonth() + t);
            }, function (e, t) {
              return t.getMonth() - e.getMonth() + 12 * (t.getFullYear() - e.getFullYear());
            }, function (e) {
              return e.getMonth();
            }),
            b = x,
            _ = x.range,
            w = r(9830),
            T = (0, n.A)(function (e) {
              e.setUTCSeconds(0, 0);
            }, function (e, t) {
              e.setTime(+e + t * l.rR);
            }, function (e, t) {
              return (t - e) / l.rR;
            }, function (e) {
              return e.getUTCMinutes();
            }),
            M = T,
            k = T.range,
            A = (0, n.A)(function (e) {
              e.setUTCMinutes(0, 0, 0);
            }, function (e, t) {
              e.setTime(+e + t * l.JJ);
            }, function (e, t) {
              return (t - e) / l.JJ;
            }, function (e) {
              return e.getUTCHours();
            }),
            L = A,
            S = A.range,
            C = r(2543),
            O = r(1681),
            D = (0, n.A)(function (e) {
              e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
            }, function (e, t) {
              e.setUTCMonth(e.getUTCMonth() + t);
            }, function (e, t) {
              return t.getUTCMonth() - e.getUTCMonth() + 12 * (t.getUTCFullYear() - e.getUTCFullYear());
            }, function (e) {
              return e.getUTCMonth();
            }),
            P = D,
            z = D.range,
            I = r(9764);
        },
        3398: function (e, t, r) {
          "use strict";

          r.d(t, {
            A: function () {
              return i;
            }
          });
          var n = new Date(),
            a = new Date();
          function i(e, t, r, o) {
            function l(t) {
              return e(t = 0 === arguments.length ? new Date() : new Date(+t)), t;
            }
            return l.floor = function (t) {
              return e(t = new Date(+t)), t;
            }, l.ceil = function (r) {
              return e(r = new Date(r - 1)), t(r, 1), e(r), r;
            }, l.round = function (e) {
              var t = l(e),
                r = l.ceil(e);
              return e - t < r - e ? t : r;
            }, l.offset = function (e, r) {
              return t(e = new Date(+e), null == r ? 1 : Math.floor(r)), e;
            }, l.range = function (r, n, a) {
              var i,
                o = [];
              if (r = l.ceil(r), a = null == a ? 1 : Math.floor(a), !(r < n && a > 0)) return o;
              do {
                o.push(i = new Date(+r)), t(r, a), e(r);
              } while (i < r && r < n);
              return o;
            }, l.filter = function (r) {
              return i(function (t) {
                if (t >= t) for (; e(t), !r(t);) t.setTime(t - 1);
              }, function (e, n) {
                if (e >= e) if (n < 0) for (; ++n <= 0;) for (; t(e, -1), !r(e););else for (; --n >= 0;) for (; t(e, 1), !r(e););
              });
            }, r && (l.count = function (t, i) {
              return n.setTime(+t), a.setTime(+i), e(n), e(a), Math.floor(r(n, a));
            }, l.every = function (e) {
              return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? l.filter(o ? function (t) {
                return o(t) % e == 0;
              } : function (t) {
                return l.count(0, t) % e == 0;
              }) : l : null;
            }), l;
          }
        },
        2543: function (e, t, r) {
          "use strict";

          r.d(t, {
            o: function () {
              return o;
            }
          });
          var n = r(3398),
            a = r(6291),
            i = (0, n.A)(function (e) {
              e.setUTCHours(0, 0, 0, 0);
            }, function (e, t) {
              e.setUTCDate(e.getUTCDate() + t);
            }, function (e, t) {
              return (t - e) / a.Nm;
            }, function (e) {
              return e.getUTCDate() - 1;
            });
          t.A = i;
          var o = i.range;
        },
        1681: function (e, t, r) {
          "use strict";

          r.d(t, {
            G6: function () {
              return g;
            },
            Hl: function () {
              return o;
            },
            ON: function () {
              return p;
            },
            Xo: function () {
              return x;
            },
            Zn: function () {
              return y;
            },
            a1: function () {
              return f;
            },
            aZ: function () {
              return h;
            },
            c8: function () {
              return d;
            },
            jN: function () {
              return v;
            },
            pT: function () {
              return u;
            },
            rt: function () {
              return l;
            },
            sr: function () {
              return s;
            },
            wr: function () {
              return m;
            },
            z2: function () {
              return c;
            }
          });
          var n = r(3398),
            a = r(6291);
          function i(e) {
            return (0, n.A)(function (t) {
              t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
            }, function (e, t) {
              e.setUTCDate(e.getUTCDate() + 7 * t);
            }, function (e, t) {
              return (t - e) / a.Fq;
            });
          }
          var o = i(0),
            l = i(1),
            s = i(2),
            c = i(3),
            u = i(4),
            f = i(5),
            d = i(6),
            h = o.range,
            p = l.range,
            v = s.range,
            g = c.range,
            m = u.range,
            y = f.range,
            x = d.range;
        },
        9764: function (e, t, r) {
          "use strict";

          r.d(t, {
            j: function () {
              return i;
            }
          });
          var n = r(3398),
            a = (0, n.A)(function (e) {
              e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
            }, function (e, t) {
              e.setUTCFullYear(e.getUTCFullYear() + t);
            }, function (e, t) {
              return t.getUTCFullYear() - e.getUTCFullYear();
            }, function (e) {
              return e.getUTCFullYear();
            });
          a.every = function (e) {
            return isFinite(e = Math.floor(e)) && e > 0 ? (0, n.A)(function (t) {
              t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
            }, function (t, r) {
              t.setUTCFullYear(t.getUTCFullYear() + r * e);
            }) : null;
          }, t.A = a;
          var i = a.range;
        },
        5735: function (e, t, r) {
          "use strict";

          r.d(t, {
            By: function () {
              return l;
            },
            KP: function () {
              return p;
            },
            Q$: function () {
              return m;
            },
            Sh: function () {
              return f;
            },
            dt: function () {
              return u;
            },
            eQ: function () {
              return s;
            },
            fz: function () {
              return o;
            },
            gf: function () {
              return g;
            },
            kS: function () {
              return d;
            },
            l3: function () {
              return c;
            },
            se: function () {
              return h;
            },
            t$: function () {
              return x;
            },
            tz: function () {
              return y;
            },
            yW: function () {
              return v;
            }
          });
          var n = r(3398),
            a = r(6291);
          function i(e) {
            return (0, n.A)(function (t) {
              t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
            }, function (e, t) {
              e.setDate(e.getDate() + 7 * t);
            }, function (e, t) {
              return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * a.rR) / a.Fq;
            });
          }
          var o = i(0),
            l = i(1),
            s = i(2),
            c = i(3),
            u = i(4),
            f = i(5),
            d = i(6),
            h = o.range,
            p = l.range,
            v = s.range,
            g = c.range,
            m = u.range,
            y = f.range,
            x = d.range;
        },
        9830: function (e, t, r) {
          "use strict";

          r.d(t, {
            V: function () {
              return i;
            }
          });
          var n = r(3398),
            a = (0, n.A)(function (e) {
              e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
            }, function (e, t) {
              e.setFullYear(e.getFullYear() + t);
            }, function (e, t) {
              return t.getFullYear() - e.getFullYear();
            }, function (e) {
              return e.getFullYear();
            });
          a.every = function (e) {
            return isFinite(e = Math.floor(e)) && e > 0 ? (0, n.A)(function (t) {
              t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
            }, function (t, r) {
              t.setFullYear(t.getFullYear() + r * e);
            }) : null;
          }, t.A = a;
          var i = a.range;
        },
        7683: function (e) {
          "use strict";

          var t,
            r = "object" == typeof Reflect ? Reflect : null,
            n = r && "function" == typeof r.apply ? r.apply : function (e, t, r) {
              return Function.prototype.apply.call(e, t, r);
            };
          t = r && "function" == typeof r.ownKeys ? r.ownKeys : Object.getOwnPropertySymbols ? function (e) {
            return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
          } : function (e) {
            return Object.getOwnPropertyNames(e);
          };
          var a = Number.isNaN || function (e) {
            return e != e;
          };
          function i() {
            i.init.call(this);
          }
          e.exports = i, e.exports.once = function (e, t) {
            return new Promise(function (r, n) {
              function a(r) {
                e.removeListener(t, i), n(r);
              }
              function i() {
                "function" == typeof e.removeListener && e.removeListener("error", a), r([].slice.call(arguments));
              }
              v(e, t, i, {
                once: !0
              }), "error" !== t && function (e, t, r) {
                "function" == typeof e.on && v(e, "error", t, {
                  once: !0
                });
              }(e, a);
            });
          }, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
          var o = 10;
          function l(e) {
            if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
          }
          function s(e) {
            return void 0 === e._maxListeners ? i.defaultMaxListeners : e._maxListeners;
          }
          function c(e, t, r, n) {
            var a, i, o, c;
            if (l(r), void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), i = e._events), o = i[t]), void 0 === o) o = i[t] = r, ++e._eventsCount;else if ("function" == typeof o ? o = i[t] = n ? [r, o] : [o, r] : n ? o.unshift(r) : o.push(r), (a = s(e)) > 0 && o.length > a && !o.warned) {
              o.warned = !0;
              var u = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
              u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = t, u.count = o.length, c = u, console && console.warn && console.warn(c);
            }
            return e;
          }
          function u() {
            if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
          }
          function f(e, t, r) {
            var n = {
                fired: !1,
                wrapFn: void 0,
                target: e,
                type: t,
                listener: r
              },
              a = u.bind(n);
            return a.listener = r, n.wrapFn = a, a;
          }
          function d(e, t, r) {
            var n = e._events;
            if (void 0 === n) return [];
            var a = n[t];
            return void 0 === a ? [] : "function" == typeof a ? r ? [a.listener || a] : [a] : r ? function (e) {
              for (var t = new Array(e.length), r = 0; r < t.length; ++r) t[r] = e[r].listener || e[r];
              return t;
            }(a) : p(a, a.length);
          }
          function h(e) {
            var t = this._events;
            if (void 0 !== t) {
              var r = t[e];
              if ("function" == typeof r) return 1;
              if (void 0 !== r) return r.length;
            }
            return 0;
          }
          function p(e, t) {
            for (var r = new Array(t), n = 0; n < t; ++n) r[n] = e[n];
            return r;
          }
          function v(e, t, r, n) {
            if ("function" == typeof e.on) n.once ? e.once(t, r) : e.on(t, r);else {
              if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
              e.addEventListener(t, function a(i) {
                n.once && e.removeEventListener(t, a), r(i);
              });
            }
          }
          Object.defineProperty(i, "defaultMaxListeners", {
            enumerable: !0,
            get: function () {
              return o;
            },
            set: function (e) {
              if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
              o = e;
            }
          }), i.init = function () {
            void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
          }, i.prototype.setMaxListeners = function (e) {
            if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
            return this._maxListeners = e, this;
          }, i.prototype.getMaxListeners = function () {
            return s(this);
          }, i.prototype.emit = function (e) {
            for (var t = [], r = 1; r < arguments.length; r++) t.push(arguments[r]);
            var a = "error" === e,
              i = this._events;
            if (void 0 !== i) a = a && void 0 === i.error;else if (!a) return !1;
            if (a) {
              var o;
              if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
              var l = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
              throw l.context = o, l;
            }
            var s = i[e];
            if (void 0 === s) return !1;
            if ("function" == typeof s) n(s, this, t);else {
              var c = s.length,
                u = p(s, c);
              for (r = 0; r < c; ++r) n(u[r], this, t);
            }
            return !0;
          }, i.prototype.addListener = function (e, t) {
            return c(this, e, t, !1);
          }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function (e, t) {
            return c(this, e, t, !0);
          }, i.prototype.once = function (e, t) {
            return l(t), this.on(e, f(this, e, t)), this;
          }, i.prototype.prependOnceListener = function (e, t) {
            return l(t), this.prependListener(e, f(this, e, t)), this;
          }, i.prototype.removeListener = function (e, t) {
            var r, n, a, i, o;
            if (l(t), void 0 === (n = this._events)) return this;
            if (void 0 === (r = n[e])) return this;
            if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));else if ("function" != typeof r) {
              for (a = -1, i = r.length - 1; i >= 0; i--) if (r[i] === t || r[i].listener === t) {
                o = r[i].listener, a = i;
                break;
              }
              if (a < 0) return this;
              0 === a ? r.shift() : function (e, t) {
                for (; t + 1 < e.length; t++) e[t] = e[t + 1];
                e.pop();
              }(r, a), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, o || t);
            }
            return this;
          }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function (e) {
            var t, r, n;
            if (void 0 === (r = this._events)) return this;
            if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;
            if (0 === arguments.length) {
              var a,
                i = Object.keys(r);
              for (n = 0; n < i.length; ++n) "removeListener" !== (a = i[n]) && this.removeAllListeners(a);
              return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
            }
            if ("function" == typeof (t = r[e])) this.removeListener(e, t);else if (void 0 !== t) for (n = t.length - 1; n >= 0; n--) this.removeListener(e, t[n]);
            return this;
          }, i.prototype.listeners = function (e) {
            return d(this, e, !0);
          }, i.prototype.rawListeners = function (e) {
            return d(this, e, !1);
          }, i.listenerCount = function (e, t) {
            return "function" == typeof e.listenerCount ? e.listenerCount(t) : h.call(e, t);
          }, i.prototype.listenerCount = h, i.prototype.eventNames = function () {
            return this._eventsCount > 0 ? t(this._events) : [];
          };
        },
        721: function (e, t, r) {
          "use strict";

          var n = r(9914);
          e.exports = function (e) {
            var t = typeof e;
            if ("string" === t) {
              var r = e;
              if (0 == (e = +e) && n(r)) return !1;
            } else if ("number" !== t) return !1;
            return e - e < 1;
          };
        },
        4840: function (e) {
          e.exports = function (e, t) {
            var r = t[0],
              n = t[1],
              a = t[2],
              i = t[3],
              o = t[4],
              l = t[5],
              s = t[6],
              c = t[7],
              u = t[8],
              f = t[9],
              d = t[10],
              h = t[11],
              p = t[12],
              v = t[13],
              g = t[14],
              m = t[15];
            return e[0] = l * (d * m - h * g) - f * (s * m - c * g) + v * (s * h - c * d), e[1] = -(n * (d * m - h * g) - f * (a * m - i * g) + v * (a * h - i * d)), e[2] = n * (s * m - c * g) - l * (a * m - i * g) + v * (a * c - i * s), e[3] = -(n * (s * h - c * d) - l * (a * h - i * d) + f * (a * c - i * s)), e[4] = -(o * (d * m - h * g) - u * (s * m - c * g) + p * (s * h - c * d)), e[5] = r * (d * m - h * g) - u * (a * m - i * g) + p * (a * h - i * d), e[6] = -(r * (s * m - c * g) - o * (a * m - i * g) + p * (a * c - i * s)), e[7] = r * (s * h - c * d) - o * (a * h - i * d) + u * (a * c - i * s), e[8] = o * (f * m - h * v) - u * (l * m - c * v) + p * (l * h - c * f), e[9] = -(r * (f * m - h * v) - u * (n * m - i * v) + p * (n * h - i * f)), e[10] = r * (l * m - c * v) - o * (n * m - i * v) + p * (n * c - i * l), e[11] = -(r * (l * h - c * f) - o * (n * h - i * f) + u * (n * c - i * l)), e[12] = -(o * (f * g - d * v) - u * (l * g - s * v) + p * (l * d - s * f)), e[13] = r * (f * g - d * v) - u * (n * g - a * v) + p * (n * d - a * f), e[14] = -(r * (l * g - s * v) - o * (n * g - a * v) + p * (n * s - a * l)), e[15] = r * (l * d - s * f) - o * (n * d - a * f) + u * (n * s - a * l), e;
          };
        },
        9698: function (e) {
          e.exports = function (e) {
            var t = new Float32Array(16);
            return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
          };
        },
        7938: function (e) {
          e.exports = function (e, t) {
            return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
          };
        },
        7519: function (e) {
          e.exports = function () {
            var e = new Float32Array(16);
            return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
          };
        },
        6900: function (e) {
          e.exports = function (e) {
            var t = e[0],
              r = e[1],
              n = e[2],
              a = e[3],
              i = e[4],
              o = e[5],
              l = e[6],
              s = e[7],
              c = e[8],
              u = e[9],
              f = e[10],
              d = e[11],
              h = e[12],
              p = e[13],
              v = e[14],
              g = e[15];
            return (t * o - r * i) * (f * g - d * v) - (t * l - n * i) * (u * g - d * p) + (t * s - a * i) * (u * v - f * p) + (r * l - n * o) * (c * g - d * h) - (r * s - a * o) * (c * v - f * h) + (n * s - a * l) * (c * p - u * h);
          };
        },
        6472: function (e) {
          e.exports = function (e, t) {
            var r = t[0],
              n = t[1],
              a = t[2],
              i = t[3],
              o = r + r,
              l = n + n,
              s = a + a,
              c = r * o,
              u = n * o,
              f = n * l,
              d = a * o,
              h = a * l,
              p = a * s,
              v = i * o,
              g = i * l,
              m = i * s;
            return e[0] = 1 - f - p, e[1] = u + m, e[2] = d - g, e[3] = 0, e[4] = u - m, e[5] = 1 - c - p, e[6] = h + v, e[7] = 0, e[8] = d + g, e[9] = h - v, e[10] = 1 - c - f, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
          };
        },
        3061: function (e) {
          e.exports = function (e, t, r) {
            var n,
              a,
              i,
              o = r[0],
              l = r[1],
              s = r[2],
              c = Math.sqrt(o * o + l * l + s * s);
            return Math.abs(c) < 1e-6 ? null : (o *= c = 1 / c, l *= c, s *= c, n = Math.sin(t), i = 1 - (a = Math.cos(t)), e[0] = o * o * i + a, e[1] = l * o * i + s * n, e[2] = s * o * i - l * n, e[3] = 0, e[4] = o * l * i - s * n, e[5] = l * l * i + a, e[6] = s * l * i + o * n, e[7] = 0, e[8] = o * s * i + l * n, e[9] = l * s * i - o * n, e[10] = s * s * i + a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e);
          };
        },
        3606: function (e) {
          e.exports = function (e, t, r) {
            var n = t[0],
              a = t[1],
              i = t[2],
              o = t[3],
              l = n + n,
              s = a + a,
              c = i + i,
              u = n * l,
              f = n * s,
              d = n * c,
              h = a * s,
              p = a * c,
              v = i * c,
              g = o * l,
              m = o * s,
              y = o * c;
            return e[0] = 1 - (h + v), e[1] = f + y, e[2] = d - m, e[3] = 0, e[4] = f - y, e[5] = 1 - (u + v), e[6] = p + g, e[7] = 0, e[8] = d + m, e[9] = p - g, e[10] = 1 - (u + h), e[11] = 0, e[12] = r[0], e[13] = r[1], e[14] = r[2], e[15] = 1, e;
          };
        },
        8698: function (e) {
          e.exports = function (e, t) {
            return e[0] = t[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = t[1], e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = t[2], e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
          };
        },
        6924: function (e) {
          e.exports = function (e, t) {
            return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = t[0], e[13] = t[1], e[14] = t[2], e[15] = 1, e;
          };
        },
        1181: function (e) {
          e.exports = function (e, t) {
            var r = Math.sin(t),
              n = Math.cos(t);
            return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = n, e[6] = r, e[7] = 0, e[8] = 0, e[9] = -r, e[10] = n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
          };
        },
        5258: function (e) {
          e.exports = function (e, t) {
            var r = Math.sin(t),
              n = Math.cos(t);
            return e[0] = n, e[1] = 0, e[2] = -r, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = r, e[9] = 0, e[10] = n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
          };
        },
        4815: function (e) {
          e.exports = function (e, t) {
            var r = Math.sin(t),
              n = Math.cos(t);
            return e[0] = n, e[1] = r, e[2] = 0, e[3] = 0, e[4] = -r, e[5] = n, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
          };
        },
        7301: function (e) {
          e.exports = function (e, t, r, n, a, i, o) {
            var l = 1 / (r - t),
              s = 1 / (a - n),
              c = 1 / (i - o);
            return e[0] = 2 * i * l, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 2 * i * s, e[6] = 0, e[7] = 0, e[8] = (r + t) * l, e[9] = (a + n) * s, e[10] = (o + i) * c, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = o * i * 2 * c, e[15] = 0, e;
          };
        },
        7193: function (e) {
          e.exports = function (e) {
            return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
          };
        },
        1191: function (e, t, r) {
          e.exports = {
            create: r(7519),
            clone: r(9698),
            copy: r(7938),
            identity: r(7193),
            transpose: r(256),
            invert: r(6559),
            adjoint: r(4840),
            determinant: r(6900),
            multiply: r(4787),
            translate: r(4165),
            scale: r(8697),
            rotate: r(2416),
            rotateX: r(1066),
            rotateY: r(4201),
            rotateZ: r(3920),
            fromRotation: r(3061),
            fromRotationTranslation: r(3606),
            fromScaling: r(8698),
            fromTranslation: r(6924),
            fromXRotation: r(1181),
            fromYRotation: r(5258),
            fromZRotation: r(4815),
            fromQuat: r(6472),
            frustum: r(7301),
            perspective: r(5313),
            perspectiveFromFieldOfView: r(2253),
            ortho: r(4633),
            lookAt: r(6645),
            str: r(6992)
          };
        },
        6559: function (e) {
          e.exports = function (e, t) {
            var r = t[0],
              n = t[1],
              a = t[2],
              i = t[3],
              o = t[4],
              l = t[5],
              s = t[6],
              c = t[7],
              u = t[8],
              f = t[9],
              d = t[10],
              h = t[11],
              p = t[12],
              v = t[13],
              g = t[14],
              m = t[15],
              y = r * l - n * o,
              x = r * s - a * o,
              b = r * c - i * o,
              _ = n * s - a * l,
              w = n * c - i * l,
              T = a * c - i * s,
              M = u * v - f * p,
              k = u * g - d * p,
              A = u * m - h * p,
              L = f * g - d * v,
              S = f * m - h * v,
              C = d * m - h * g,
              O = y * C - x * S + b * L + _ * A - w * k + T * M;
            return O ? (O = 1 / O, e[0] = (l * C - s * S + c * L) * O, e[1] = (a * S - n * C - i * L) * O, e[2] = (v * T - g * w + m * _) * O, e[3] = (d * w - f * T - h * _) * O, e[4] = (s * A - o * C - c * k) * O, e[5] = (r * C - a * A + i * k) * O, e[6] = (g * b - p * T - m * x) * O, e[7] = (u * T - d * b + h * x) * O, e[8] = (o * S - l * A + c * M) * O, e[9] = (n * A - r * S - i * M) * O, e[10] = (p * w - v * b + m * y) * O, e[11] = (f * b - u * w - h * y) * O, e[12] = (l * k - o * L - s * M) * O, e[13] = (r * L - n * k + a * M) * O, e[14] = (v * x - p * _ - g * y) * O, e[15] = (u * _ - f * x + d * y) * O, e) : null;
          };
        },
        6645: function (e, t, r) {
          var n = r(7193);
          e.exports = function (e, t, r, a) {
            var i,
              o,
              l,
              s,
              c,
              u,
              f,
              d,
              h,
              p,
              v = t[0],
              g = t[1],
              m = t[2],
              y = a[0],
              x = a[1],
              b = a[2],
              _ = r[0],
              w = r[1],
              T = r[2];
            return Math.abs(v - _) < 1e-6 && Math.abs(g - w) < 1e-6 && Math.abs(m - T) < 1e-6 ? n(e) : (f = v - _, d = g - w, h = m - T, i = x * (h *= p = 1 / Math.sqrt(f * f + d * d + h * h)) - b * (d *= p), o = b * (f *= p) - y * h, l = y * d - x * f, (p = Math.sqrt(i * i + o * o + l * l)) ? (i *= p = 1 / p, o *= p, l *= p) : (i = 0, o = 0, l = 0), s = d * l - h * o, c = h * i - f * l, u = f * o - d * i, (p = Math.sqrt(s * s + c * c + u * u)) ? (s *= p = 1 / p, c *= p, u *= p) : (s = 0, c = 0, u = 0), e[0] = i, e[1] = s, e[2] = f, e[3] = 0, e[4] = o, e[5] = c, e[6] = d, e[7] = 0, e[8] = l, e[9] = u, e[10] = h, e[11] = 0, e[12] = -(i * v + o * g + l * m), e[13] = -(s * v + c * g + u * m), e[14] = -(f * v + d * g + h * m), e[15] = 1, e);
          };
        },
        4787: function (e) {
          e.exports = function (e, t, r) {
            var n = t[0],
              a = t[1],
              i = t[2],
              o = t[3],
              l = t[4],
              s = t[5],
              c = t[6],
              u = t[7],
              f = t[8],
              d = t[9],
              h = t[10],
              p = t[11],
              v = t[12],
              g = t[13],
              m = t[14],
              y = t[15],
              x = r[0],
              b = r[1],
              _ = r[2],
              w = r[3];
            return e[0] = x * n + b * l + _ * f + w * v, e[1] = x * a + b * s + _ * d + w * g, e[2] = x * i + b * c + _ * h + w * m, e[3] = x * o + b * u + _ * p + w * y, x = r[4], b = r[5], _ = r[6], w = r[7], e[4] = x * n + b * l + _ * f + w * v, e[5] = x * a + b * s + _ * d + w * g, e[6] = x * i + b * c + _ * h + w * m, e[7] = x * o + b * u + _ * p + w * y, x = r[8], b = r[9], _ = r[10], w = r[11], e[8] = x * n + b * l + _ * f + w * v, e[9] = x * a + b * s + _ * d + w * g, e[10] = x * i + b * c + _ * h + w * m, e[11] = x * o + b * u + _ * p + w * y, x = r[12], b = r[13], _ = r[14], w = r[15], e[12] = x * n + b * l + _ * f + w * v, e[13] = x * a + b * s + _ * d + w * g, e[14] = x * i + b * c + _ * h + w * m, e[15] = x * o + b * u + _ * p + w * y, e;
          };
        },
        4633: function (e) {
          e.exports = function (e, t, r, n, a, i, o) {
            var l = 1 / (t - r),
              s = 1 / (n - a),
              c = 1 / (i - o);
            return e[0] = -2 * l, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * s, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * c, e[11] = 0, e[12] = (t + r) * l, e[13] = (a + n) * s, e[14] = (o + i) * c, e[15] = 1, e;
          };
        },
        5313: function (e) {
          e.exports = function (e, t, r, n, a) {
            var i = 1 / Math.tan(t / 2),
              o = 1 / (n - a);
            return e[0] = i / r, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = i, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = (a + n) * o, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = 2 * a * n * o, e[15] = 0, e;
          };
        },
        2253: function (e) {
          e.exports = function (e, t, r, n) {
            var a = Math.tan(t.upDegrees * Math.PI / 180),
              i = Math.tan(t.downDegrees * Math.PI / 180),
              o = Math.tan(t.leftDegrees * Math.PI / 180),
              l = Math.tan(t.rightDegrees * Math.PI / 180),
              s = 2 / (o + l),
              c = 2 / (a + i);
            return e[0] = s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = c, e[6] = 0, e[7] = 0, e[8] = -(o - l) * s * .5, e[9] = (a - i) * c * .5, e[10] = n / (r - n), e[11] = -1, e[12] = 0, e[13] = 0, e[14] = n * r / (r - n), e[15] = 0, e;
          };
        },
        2416: function (e) {
          e.exports = function (e, t, r, n) {
            var a,
              i,
              o,
              l,
              s,
              c,
              u,
              f,
              d,
              h,
              p,
              v,
              g,
              m,
              y,
              x,
              b,
              _,
              w,
              T,
              M,
              k,
              A,
              L,
              S = n[0],
              C = n[1],
              O = n[2],
              D = Math.sqrt(S * S + C * C + O * O);
            return Math.abs(D) < 1e-6 ? null : (S *= D = 1 / D, C *= D, O *= D, a = Math.sin(r), o = 1 - (i = Math.cos(r)), l = t[0], s = t[1], c = t[2], u = t[3], f = t[4], d = t[5], h = t[6], p = t[7], v = t[8], g = t[9], m = t[10], y = t[11], x = S * S * o + i, b = C * S * o + O * a, _ = O * S * o - C * a, w = S * C * o - O * a, T = C * C * o + i, M = O * C * o + S * a, k = S * O * o + C * a, A = C * O * o - S * a, L = O * O * o + i, e[0] = l * x + f * b + v * _, e[1] = s * x + d * b + g * _, e[2] = c * x + h * b + m * _, e[3] = u * x + p * b + y * _, e[4] = l * w + f * T + v * M, e[5] = s * w + d * T + g * M, e[6] = c * w + h * T + m * M, e[7] = u * w + p * T + y * M, e[8] = l * k + f * A + v * L, e[9] = s * k + d * A + g * L, e[10] = c * k + h * A + m * L, e[11] = u * k + p * A + y * L, t !== e && (e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e);
          };
        },
        1066: function (e) {
          e.exports = function (e, t, r) {
            var n = Math.sin(r),
              a = Math.cos(r),
              i = t[4],
              o = t[5],
              l = t[6],
              s = t[7],
              c = t[8],
              u = t[9],
              f = t[10],
              d = t[11];
            return t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[4] = i * a + c * n, e[5] = o * a + u * n, e[6] = l * a + f * n, e[7] = s * a + d * n, e[8] = c * a - i * n, e[9] = u * a - o * n, e[10] = f * a - l * n, e[11] = d * a - s * n, e;
          };
        },
        4201: function (e) {
          e.exports = function (e, t, r) {
            var n = Math.sin(r),
              a = Math.cos(r),
              i = t[0],
              o = t[1],
              l = t[2],
              s = t[3],
              c = t[8],
              u = t[9],
              f = t[10],
              d = t[11];
            return t !== e && (e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = i * a - c * n, e[1] = o * a - u * n, e[2] = l * a - f * n, e[3] = s * a - d * n, e[8] = i * n + c * a, e[9] = o * n + u * a, e[10] = l * n + f * a, e[11] = s * n + d * a, e;
          };
        },
        3920: function (e) {
          e.exports = function (e, t, r) {
            var n = Math.sin(r),
              a = Math.cos(r),
              i = t[0],
              o = t[1],
              l = t[2],
              s = t[3],
              c = t[4],
              u = t[5],
              f = t[6],
              d = t[7];
            return t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = i * a + c * n, e[1] = o * a + u * n, e[2] = l * a + f * n, e[3] = s * a + d * n, e[4] = c * a - i * n, e[5] = u * a - o * n, e[6] = f * a - l * n, e[7] = d * a - s * n, e;
          };
        },
        8697: function (e) {
          e.exports = function (e, t, r) {
            var n = r[0],
              a = r[1],
              i = r[2];
            return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e[4] = t[4] * a, e[5] = t[5] * a, e[6] = t[6] * a, e[7] = t[7] * a, e[8] = t[8] * i, e[9] = t[9] * i, e[10] = t[10] * i, e[11] = t[11] * i, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
          };
        },
        6992: function (e) {
          e.exports = function (e) {
            return "mat4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ", " + e[9] + ", " + e[10] + ", " + e[11] + ", " + e[12] + ", " + e[13] + ", " + e[14] + ", " + e[15] + ")";
          };
        },
        4165: function (e) {
          e.exports = function (e, t, r) {
            var n,
              a,
              i,
              o,
              l,
              s,
              c,
              u,
              f,
              d,
              h,
              p,
              v = r[0],
              g = r[1],
              m = r[2];
            return t === e ? (e[12] = t[0] * v + t[4] * g + t[8] * m + t[12], e[13] = t[1] * v + t[5] * g + t[9] * m + t[13], e[14] = t[2] * v + t[6] * g + t[10] * m + t[14], e[15] = t[3] * v + t[7] * g + t[11] * m + t[15]) : (n = t[0], a = t[1], i = t[2], o = t[3], l = t[4], s = t[5], c = t[6], u = t[7], f = t[8], d = t[9], h = t[10], p = t[11], e[0] = n, e[1] = a, e[2] = i, e[3] = o, e[4] = l, e[5] = s, e[6] = c, e[7] = u, e[8] = f, e[9] = d, e[10] = h, e[11] = p, e[12] = n * v + l * g + f * m + t[12], e[13] = a * v + s * g + d * m + t[13], e[14] = i * v + c * g + h * m + t[14], e[15] = o * v + u * g + p * m + t[15]), e;
          };
        },
        256: function (e) {
          e.exports = function (e, t) {
            if (e === t) {
              var r = t[1],
                n = t[2],
                a = t[3],
                i = t[6],
                o = t[7],
                l = t[11];
              e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = r, e[6] = t[9], e[7] = t[13], e[8] = n, e[9] = i, e[11] = t[14], e[12] = a, e[13] = o, e[14] = l;
            } else e[0] = t[0], e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = t[1], e[5] = t[5], e[6] = t[9], e[7] = t[13], e[8] = t[2], e[9] = t[6], e[10] = t[10], e[11] = t[14], e[12] = t[3], e[13] = t[7], e[14] = t[11], e[15] = t[15];
            return e;
          };
        },
        9784: function (e, t, r) {
          "use strict";

          var n,
            a = r(8253);
          n = "function" == typeof r.g.matchMedia ? !r.g.matchMedia("(hover: none)").matches : a, e.exports = n;
        },
        4043: function (e, t, r) {
          "use strict";

          var n = r(8253);
          e.exports = n && function () {
            var e = !1;
            try {
              var t = Object.defineProperty({}, "passive", {
                get: function () {
                  e = !0;
                }
              });
              window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
            } catch (t) {
              e = !1;
            }
            return e;
          }();
        },
        8253: function (e) {
          e.exports = !0;
        },
        9914: function (e) {
          "use strict";

          e.exports = function (e) {
            for (var t, r = e.length, n = 0; n < r; n++) if (((t = e.charCodeAt(n)) < 9 || t > 13) && 32 !== t && 133 !== t && 160 !== t && 5760 !== t && 6158 !== t && (t < 8192 || t > 8205) && 8232 !== t && 8233 !== t && 8239 !== t && 8287 !== t && 8288 !== t && 12288 !== t && 65279 !== t) return !1;
            return !0;
          };
        },
        4039: function (e) {
          var t = {
            left: 0,
            top: 0
          };
          e.exports = function (e, r, n) {
            r = r || e.currentTarget || e.srcElement, Array.isArray(n) || (n = [0, 0]);
            var a,
              i = e.clientX || 0,
              o = e.clientY || 0,
              l = (a = r) === window || a === document || a === document.body ? t : a.getBoundingClientRect();
            return n[0] = i - l.left, n[1] = o - l.top, n;
          };
        },
        1116: function (e, t, r) {
          var n, a, i, o;
          a = "Promise", o = function () {
            "use strict";

            var e,
              t,
              r,
              n = Object.prototype.toString,
              a = "undefined" != typeof setImmediate ? function (e) {
                return setImmediate(e);
              } : setTimeout;
            try {
              Object.defineProperty({}, "x", {}), e = function (e, t, r, n) {
                return Object.defineProperty(e, t, {
                  value: r,
                  writable: !0,
                  configurable: !1 !== n
                });
              };
            } catch (t) {
              e = function (e, t, r) {
                return e[t] = r, e;
              };
            }
            function i(e, n) {
              r.add(e, n), t || (t = a(r.drain));
            }
            function o(e) {
              var t,
                r = typeof e;
              return null == e || "object" != r && "function" != r || (t = e.then), "function" == typeof t && t;
            }
            function l() {
              for (var e = 0; e < this.chain.length; e++) s(this, 1 === this.state ? this.chain[e].success : this.chain[e].failure, this.chain[e]);
              this.chain.length = 0;
            }
            function s(e, t, r) {
              var n, a;
              try {
                !1 === t ? r.reject(e.msg) : (n = !0 === t ? e.msg : t.call(void 0, e.msg)) === r.promise ? r.reject(TypeError("Promise-chain cycle")) : (a = o(n)) ? a.call(n, r.resolve, r.reject) : r.resolve(n);
              } catch (e) {
                r.reject(e);
              }
            }
            function c(e) {
              var t,
                r = this;
              if (!r.triggered) {
                r.triggered = !0, r.def && (r = r.def);
                try {
                  (t = o(e)) ? i(function () {
                    var n = new d(r);
                    try {
                      t.call(e, function () {
                        c.apply(n, arguments);
                      }, function () {
                        u.apply(n, arguments);
                      });
                    } catch (e) {
                      u.call(n, e);
                    }
                  }) : (r.msg = e, r.state = 1, r.chain.length > 0 && i(l, r));
                } catch (e) {
                  u.call(new d(r), e);
                }
              }
            }
            function u(e) {
              var t = this;
              t.triggered || (t.triggered = !0, t.def && (t = t.def), t.msg = e, t.state = 2, t.chain.length > 0 && i(l, t));
            }
            function f(e, t, r, n) {
              for (var a = 0; a < t.length; a++) !function (a) {
                e.resolve(t[a]).then(function (e) {
                  r(a, e);
                }, n);
              }(a);
            }
            function d(e) {
              this.def = e, this.triggered = !1;
            }
            function h(e) {
              this.promise = e, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
            }
            function p(e) {
              if ("function" != typeof e) throw TypeError("Not a function");
              if (0 !== this.__NPO__) throw TypeError("Not a promise");
              this.__NPO__ = 1;
              var t = new h(this);
              this.then = function (e, r) {
                var n = {
                  success: "function" != typeof e || e,
                  failure: "function" == typeof r && r
                };
                return n.promise = new this.constructor(function (e, t) {
                  if ("function" != typeof e || "function" != typeof t) throw TypeError("Not a function");
                  n.resolve = e, n.reject = t;
                }), t.chain.push(n), 0 !== t.state && i(l, t), n.promise;
              }, this.catch = function (e) {
                return this.then(void 0, e);
              };
              try {
                e.call(void 0, function (e) {
                  c.call(t, e);
                }, function (e) {
                  u.call(t, e);
                });
              } catch (e) {
                u.call(t, e);
              }
            }
            r = function () {
              var e, r, n;
              function a(e, t) {
                this.fn = e, this.self = t, this.next = void 0;
              }
              return {
                add: function (t, i) {
                  n = new a(t, i), r ? r.next = n : e = n, r = n, n = void 0;
                },
                drain: function () {
                  var n = e;
                  for (e = r = t = void 0; n;) n.fn.call(n.self), n = n.next;
                }
              };
            }();
            var v = e({}, "constructor", p, !1);
            return p.prototype = v, e(v, "__NPO__", 0, !1), e(p, "resolve", function (e) {
              return e && "object" == typeof e && 1 === e.__NPO__ ? e : new this(function (t, r) {
                if ("function" != typeof t || "function" != typeof r) throw TypeError("Not a function");
                t(e);
              });
            }), e(p, "reject", function (e) {
              return new this(function (t, r) {
                if ("function" != typeof t || "function" != typeof r) throw TypeError("Not a function");
                r(e);
              });
            }), e(p, "all", function (e) {
              var t = this;
              return "[object Array]" != n.call(e) ? t.reject(TypeError("Not an array")) : 0 === e.length ? t.resolve([]) : new t(function (r, n) {
                if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                var a = e.length,
                  i = Array(a),
                  o = 0;
                f(t, e, function (e, t) {
                  i[e] = t, ++o === a && r(i);
                }, n);
              });
            }), e(p, "race", function (e) {
              var t = this;
              return "[object Array]" != n.call(e) ? t.reject(TypeError("Not an array")) : new t(function (r, n) {
                if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                f(t, e, function (e, t) {
                  r(t);
                }, n);
              });
            }), p;
          }, (i = void 0 !== r.g ? r.g : this)[a] = i[a] || o(), e.exports ? e.exports = i[a] : void 0 === (n = function () {
            return i[a];
          }.call(t, r, t, e)) || (e.exports = n);
        },
        7976: function (e) {
          "use strict";

          var t = Object.getOwnPropertySymbols,
            r = Object.prototype.hasOwnProperty,
            n = Object.prototype.propertyIsEnumerable;
          e.exports = function () {
            try {
              if (!Object.assign) return !1;
              var e = new String("abc");
              if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
              for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
              if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
                return t[e];
              }).join("")) return !1;
              var n = {};
              return "abcdefghijklmnopqrst".split("").forEach(function (e) {
                n[e] = e;
              }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
            } catch (e) {
              return !1;
            }
          }() ? Object.assign : function (e, a) {
            for (var i, o, l = function (e) {
                if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(e);
              }(e), s = 1; s < arguments.length; s++) {
              for (var c in i = Object(arguments[s])) r.call(i, c) && (l[c] = i[c]);
              if (t) {
                o = t(i);
                for (var u = 0; u < o.length; u++) n.call(i, o[u]) && (l[o[u]] = i[o[u]]);
              }
            }
            return l;
          };
        },
        6953: function (e) {
          e.exports = function (e) {
            var a = [];
            return e.replace(r, function (e, r, i) {
              var o = r.toLowerCase();
              for (i = function (e) {
                var t = e.match(n);
                return t ? t.map(Number) : [];
              }(i), "m" == o && i.length > 2 && (a.push([r].concat(i.splice(0, 2))), o = "l", r = "m" == r ? "l" : "L");;) {
                if (i.length == t[o]) return i.unshift(r), a.push(i);
                if (i.length < t[o]) throw new Error("malformed path data");
                a.push([r].concat(i.splice(0, t[o])));
              }
            }), a;
          };
          var t = {
              a: 7,
              c: 6,
              h: 1,
              l: 2,
              m: 2,
              q: 4,
              s: 4,
              t: 2,
              v: 1,
              z: 0
            },
            r = /([astvzqmhlc])([^astvzqmhlc]*)/gi,
            n = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
        },
        2773: function (e) {
          e.exports = function (e, t, r, n) {
            var a = e[0],
              i = e[1],
              o = !1;
            void 0 === r && (r = 0), void 0 === n && (n = t.length);
            for (var l = n - r, s = 0, c = l - 1; s < l; c = s++) {
              var u = t[s + r][0],
                f = t[s + r][1],
                d = t[c + r][0],
                h = t[c + r][1];
              f > i != h > i && a < (d - u) * (i - f) / (h - f) + u && (o = !o);
            }
            return o;
          };
        },
        1516: function (e, t, r) {
          var n,
            a = r(2391),
            i = r(2990),
            o = r(6202),
            l = r(2222),
            s = r(7527),
            c = r(4491),
            u = !1,
            f = i();
          function d(e, t, r) {
            var a = n.segments(e),
              i = n.segments(t),
              o = r(n.combine(a, i));
            return n.polygon(o);
          }
          n = {
            buildLog: function (e) {
              return !0 === e ? u = a() : !1 === e && (u = !1), !1 !== u && u.list;
            },
            epsilon: function (e) {
              return f.epsilon(e);
            },
            segments: function (e) {
              var t = o(!0, f, u);
              return e.regions.forEach(t.addRegion), {
                segments: t.calculate(e.inverted),
                inverted: e.inverted
              };
            },
            combine: function (e, t) {
              return {
                combined: o(!1, f, u).calculate(e.segments, e.inverted, t.segments, t.inverted),
                inverted1: e.inverted,
                inverted2: t.inverted
              };
            },
            selectUnion: function (e) {
              return {
                segments: s.union(e.combined, u),
                inverted: e.inverted1 || e.inverted2
              };
            },
            selectIntersect: function (e) {
              return {
                segments: s.intersect(e.combined, u),
                inverted: e.inverted1 && e.inverted2
              };
            },
            selectDifference: function (e) {
              return {
                segments: s.difference(e.combined, u),
                inverted: e.inverted1 && !e.inverted2
              };
            },
            selectDifferenceRev: function (e) {
              return {
                segments: s.differenceRev(e.combined, u),
                inverted: !e.inverted1 && e.inverted2
              };
            },
            selectXor: function (e) {
              return {
                segments: s.xor(e.combined, u),
                inverted: e.inverted1 !== e.inverted2
              };
            },
            polygon: function (e) {
              return {
                regions: l(e.segments, f, u),
                inverted: e.inverted
              };
            },
            polygonFromGeoJSON: function (e) {
              return c.toPolygon(n, e);
            },
            polygonToGeoJSON: function (e) {
              return c.fromPolygon(n, f, e);
            },
            union: function (e, t) {
              return d(e, t, n.selectUnion);
            },
            intersect: function (e, t) {
              return d(e, t, n.selectIntersect);
            },
            difference: function (e, t) {
              return d(e, t, n.selectDifference);
            },
            differenceRev: function (e, t) {
              return d(e, t, n.selectDifferenceRev);
            },
            xor: function (e, t) {
              return d(e, t, n.selectXor);
            }
          }, "object" == typeof window && (window.PolyBool = n), e.exports = n;
        },
        2391: function (e) {
          e.exports = function () {
            var e,
              t = 0,
              r = !1;
            function n(t, r) {
              return e.list.push({
                type: t,
                data: r ? JSON.parse(JSON.stringify(r)) : void 0
              }), e;
            }
            return e = {
              list: [],
              segmentId: function () {
                return t++;
              },
              checkIntersection: function (e, t) {
                return n("check", {
                  seg1: e,
                  seg2: t
                });
              },
              segmentChop: function (e, t) {
                return n("div_seg", {
                  seg: e,
                  pt: t
                }), n("chop", {
                  seg: e,
                  pt: t
                });
              },
              statusRemove: function (e) {
                return n("pop_seg", {
                  seg: e
                });
              },
              segmentUpdate: function (e) {
                return n("seg_update", {
                  seg: e
                });
              },
              segmentNew: function (e, t) {
                return n("new_seg", {
                  seg: e,
                  primary: t
                });
              },
              segmentRemove: function (e) {
                return n("rem_seg", {
                  seg: e
                });
              },
              tempStatus: function (e, t, r) {
                return n("temp_status", {
                  seg: e,
                  above: t,
                  below: r
                });
              },
              rewind: function (e) {
                return n("rewind", {
                  seg: e
                });
              },
              status: function (e, t, r) {
                return n("status", {
                  seg: e,
                  above: t,
                  below: r
                });
              },
              vert: function (t) {
                return t === r ? e : (r = t, n("vert", {
                  x: t
                }));
              },
              log: function (e) {
                return "string" != typeof e && (e = JSON.stringify(e, !1, "  ")), n("log", {
                  txt: e
                });
              },
              reset: function () {
                return n("reset");
              },
              selected: function (e) {
                return n("selected", {
                  segs: e
                });
              },
              chainStart: function (e) {
                return n("chain_start", {
                  seg: e
                });
              },
              chainRemoveHead: function (e, t) {
                return n("chain_rem_head", {
                  index: e,
                  pt: t
                });
              },
              chainRemoveTail: function (e, t) {
                return n("chain_rem_tail", {
                  index: e,
                  pt: t
                });
              },
              chainNew: function (e, t) {
                return n("chain_new", {
                  pt1: e,
                  pt2: t
                });
              },
              chainMatch: function (e) {
                return n("chain_match", {
                  index: e
                });
              },
              chainClose: function (e) {
                return n("chain_close", {
                  index: e
                });
              },
              chainAddHead: function (e, t) {
                return n("chain_add_head", {
                  index: e,
                  pt: t
                });
              },
              chainAddTail: function (e, t) {
                return n("chain_add_tail", {
                  index: e,
                  pt: t
                });
              },
              chainConnect: function (e, t) {
                return n("chain_con", {
                  index1: e,
                  index2: t
                });
              },
              chainReverse: function (e) {
                return n("chain_rev", {
                  index: e
                });
              },
              chainJoin: function (e, t) {
                return n("chain_join", {
                  index1: e,
                  index2: t
                });
              },
              done: function () {
                return n("done");
              }
            };
          };
        },
        2990: function (e) {
          e.exports = function (e) {
            "number" != typeof e && (e = 1e-10);
            var t = {
              epsilon: function (t) {
                return "number" == typeof t && (e = t), e;
              },
              pointAboveOrOnLine: function (t, r, n) {
                var a = r[0],
                  i = r[1],
                  o = n[0],
                  l = n[1],
                  s = t[0];
                return (o - a) * (t[1] - i) - (l - i) * (s - a) >= -e;
              },
              pointBetween: function (t, r, n) {
                var a = t[1] - r[1],
                  i = n[0] - r[0],
                  o = t[0] - r[0],
                  l = n[1] - r[1],
                  s = o * i + a * l;
                return !(s < e || s - (i * i + l * l) > -e);
              },
              pointsSameX: function (t, r) {
                return Math.abs(t[0] - r[0]) < e;
              },
              pointsSameY: function (t, r) {
                return Math.abs(t[1] - r[1]) < e;
              },
              pointsSame: function (e, r) {
                return t.pointsSameX(e, r) && t.pointsSameY(e, r);
              },
              pointsCompare: function (e, r) {
                return t.pointsSameX(e, r) ? t.pointsSameY(e, r) ? 0 : e[1] < r[1] ? -1 : 1 : e[0] < r[0] ? -1 : 1;
              },
              pointsCollinear: function (t, r, n) {
                var a = t[0] - r[0],
                  i = t[1] - r[1],
                  o = r[0] - n[0],
                  l = r[1] - n[1];
                return Math.abs(a * l - o * i) < e;
              },
              linesIntersect: function (t, r, n, a) {
                var i = r[0] - t[0],
                  o = r[1] - t[1],
                  l = a[0] - n[0],
                  s = a[1] - n[1],
                  c = i * s - o * l;
                if (Math.abs(c) < e) return !1;
                var u = t[0] - n[0],
                  f = t[1] - n[1],
                  d = (l * f - s * u) / c,
                  h = (i * f - o * u) / c,
                  p = {
                    alongA: 0,
                    alongB: 0,
                    pt: [t[0] + d * i, t[1] + d * o]
                  };
                return p.alongA = d <= -e ? -2 : d < e ? -1 : d - 1 <= -e ? 0 : d - 1 < e ? 1 : 2, p.alongB = h <= -e ? -2 : h < e ? -1 : h - 1 <= -e ? 0 : h - 1 < e ? 1 : 2, p;
              },
              pointInsideRegion: function (t, r) {
                for (var n = t[0], a = t[1], i = r[r.length - 1][0], o = r[r.length - 1][1], l = !1, s = 0; s < r.length; s++) {
                  var c = r[s][0],
                    u = r[s][1];
                  u - a > e != o - a > e && (i - c) * (a - u) / (o - u) + c - n > e && (l = !l), i = c, o = u;
                }
                return l;
              }
            };
            return t;
          };
        },
        4491: function (e) {
          var t = {
            toPolygon: function (e, t) {
              function r(t) {
                if (t.length <= 0) return e.segments({
                  inverted: !1,
                  regions: []
                });
                function r(t) {
                  var r = t.slice(0, t.length - 1);
                  return e.segments({
                    inverted: !1,
                    regions: [r]
                  });
                }
                for (var n = r(t[0]), a = 1; a < t.length; a++) n = e.selectDifference(e.combine(n, r(t[a])));
                return n;
              }
              if ("Polygon" === t.type) return e.polygon(r(t.coordinates));
              if ("MultiPolygon" === t.type) {
                for (var n = e.segments({
                    inverted: !1,
                    regions: []
                  }), a = 0; a < t.coordinates.length; a++) n = e.selectUnion(e.combine(n, r(t.coordinates[a])));
                return e.polygon(n);
              }
              throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
            },
            fromPolygon: function (e, t, r) {
              function n(e, r) {
                return t.pointInsideRegion([.5 * (e[0][0] + e[1][0]), .5 * (e[0][1] + e[1][1])], r);
              }
              function a(e) {
                return {
                  region: e,
                  children: []
                };
              }
              r = e.polygon(e.segments(r));
              var i = a(null);
              function o(e, t) {
                for (var r = 0; r < e.children.length; r++) if (n(t, (l = e.children[r]).region)) return void o(l, t);
                var i = a(t);
                for (r = 0; r < e.children.length; r++) {
                  var l;
                  n((l = e.children[r]).region, t) && (i.children.push(l), e.children.splice(r, 1), r--);
                }
                e.children.push(i);
              }
              for (var l = 0; l < r.regions.length; l++) {
                var s = r.regions[l];
                s.length < 3 || o(i, s);
              }
              function c(e, t) {
                for (var r = 0, n = e[e.length - 1][0], a = e[e.length - 1][1], i = [], o = 0; o < e.length; o++) {
                  var l = e[o][0],
                    s = e[o][1];
                  i.push([l, s]), r += s * n - l * a, n = l, a = s;
                }
                return r < 0 !== t && i.reverse(), i.push([i[0][0], i[0][1]]), i;
              }
              var u = [];
              function f(e) {
                var t = [c(e.region, !1)];
                u.push(t);
                for (var r = 0; r < e.children.length; r++) t.push(d(e.children[r]));
              }
              function d(e) {
                for (var t = 0; t < e.children.length; t++) f(e.children[t]);
                return c(e.region, !0);
              }
              for (l = 0; l < i.children.length; l++) f(i.children[l]);
              return u.length <= 0 ? {
                type: "Polygon",
                coordinates: []
              } : 1 == u.length ? {
                type: "Polygon",
                coordinates: u[0]
              } : {
                type: "MultiPolygon",
                coordinates: u
              };
            }
          };
          e.exports = t;
        },
        6202: function (e, t, r) {
          var n = r(8916);
          e.exports = function (e, t, r) {
            function a(e, t, n) {
              return {
                id: r ? r.segmentId() : -1,
                start: e,
                end: t,
                myFill: {
                  above: n.myFill.above,
                  below: n.myFill.below
                },
                otherFill: null
              };
            }
            var i = n.create();
            function o(e, r) {
              i.insertBefore(e, function (n) {
                return a = e.isStart, i = e.pt, o = r, l = n.isStart, s = n.pt, c = n.other.pt, (0 !== (u = t.pointsCompare(i, s)) ? u : t.pointsSame(o, c) ? 0 : a !== l ? a ? 1 : -1 : t.pointAboveOrOnLine(o, l ? s : c, l ? c : s) ? 1 : -1) < 0;
                var a, i, o, l, s, c, u;
              });
            }
            function l(e, t) {
              var r = function (e, t) {
                var r = n.node({
                  isStart: !0,
                  pt: e.start,
                  seg: e,
                  primary: t,
                  other: null,
                  status: null
                });
                return o(r, e.end), r;
              }(e, t);
              return function (e, t, r) {
                var a = n.node({
                  isStart: !1,
                  pt: t.end,
                  seg: t,
                  primary: r,
                  other: e,
                  status: null
                });
                e.other = a, o(a, e.pt);
              }(r, e, t), r;
            }
            function s(e, t) {
              var n = a(t, e.seg.end, e.seg);
              return function (e, t) {
                r && r.segmentChop(e.seg, t), e.other.remove(), e.seg.end = t, e.other.pt = t, o(e.other, e.pt);
              }(e, t), l(n, e.primary);
            }
            function c(a, o) {
              var l = n.create();
              function c(e) {
                return l.findTransition(function (r) {
                  var n, a, i, o, l, s;
                  return n = e, a = r.ev, i = n.seg.start, o = n.seg.end, l = a.seg.start, s = a.seg.end, (t.pointsCollinear(i, l, s) ? t.pointsCollinear(o, l, s) || t.pointAboveOrOnLine(o, l, s) ? 1 : -1 : t.pointAboveOrOnLine(i, l, s) ? 1 : -1) > 0;
                });
              }
              function u(e, n) {
                var a = e.seg,
                  i = n.seg,
                  o = a.start,
                  l = a.end,
                  c = i.start,
                  u = i.end;
                r && r.checkIntersection(a, i);
                var f = t.linesIntersect(o, l, c, u);
                if (!1 === f) {
                  if (!t.pointsCollinear(o, l, c)) return !1;
                  if (t.pointsSame(o, u) || t.pointsSame(l, c)) return !1;
                  var d = t.pointsSame(o, c),
                    h = t.pointsSame(l, u);
                  if (d && h) return n;
                  var p = !d && t.pointBetween(o, c, u),
                    v = !h && t.pointBetween(l, c, u);
                  if (d) return v ? s(n, l) : s(e, u), n;
                  p && (h || (v ? s(n, l) : s(e, u)), s(n, o));
                } else 0 === f.alongA && (-1 === f.alongB ? s(e, c) : 0 === f.alongB ? s(e, f.pt) : 1 === f.alongB && s(e, u)), 0 === f.alongB && (-1 === f.alongA ? s(n, o) : 0 === f.alongA ? s(n, f.pt) : 1 === f.alongA && s(n, l));
                return !1;
              }
              for (var f = []; !i.isEmpty();) {
                var d = i.getHead();
                if (r && r.vert(d.pt[0]), d.isStart) {
                  r && r.segmentNew(d.seg, d.primary);
                  var h = c(d),
                    p = h.before ? h.before.ev : null,
                    v = h.after ? h.after.ev : null;
                  function g() {
                    if (p) {
                      var e = u(d, p);
                      if (e) return e;
                    }
                    return !!v && u(d, v);
                  }
                  r && r.tempStatus(d.seg, !!p && p.seg, !!v && v.seg);
                  var m,
                    y,
                    x = g();
                  if (x) e ? (y = null === d.seg.myFill.below || d.seg.myFill.above !== d.seg.myFill.below) && (x.seg.myFill.above = !x.seg.myFill.above) : x.seg.otherFill = d.seg.myFill, r && r.segmentUpdate(x.seg), d.other.remove(), d.remove();
                  if (i.getHead() !== d) {
                    r && r.rewind(d.seg);
                    continue;
                  }
                  e ? (y = null === d.seg.myFill.below || d.seg.myFill.above !== d.seg.myFill.below, d.seg.myFill.below = v ? v.seg.myFill.above : a, d.seg.myFill.above = y ? !d.seg.myFill.below : d.seg.myFill.below) : null === d.seg.otherFill && (m = v ? d.primary === v.primary ? v.seg.otherFill.above : v.seg.myFill.above : d.primary ? o : a, d.seg.otherFill = {
                    above: m,
                    below: m
                  }), r && r.status(d.seg, !!p && p.seg, !!v && v.seg), d.other.status = h.insert(n.node({
                    ev: d
                  }));
                } else {
                  var b = d.status;
                  if (null === b) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
                  if (l.exists(b.prev) && l.exists(b.next) && u(b.prev.ev, b.next.ev), r && r.statusRemove(b.ev.seg), b.remove(), !d.primary) {
                    var _ = d.seg.myFill;
                    d.seg.myFill = d.seg.otherFill, d.seg.otherFill = _;
                  }
                  f.push(d.seg);
                }
                i.getHead().remove();
              }
              return r && r.done(), f;
            }
            return e ? {
              addRegion: function (e) {
                for (var n, a, i, o = e[e.length - 1], s = 0; s < e.length; s++) {
                  n = o, o = e[s];
                  var c = t.pointsCompare(n, o);
                  0 !== c && l((a = c < 0 ? n : o, i = c < 0 ? o : n, {
                    id: r ? r.segmentId() : -1,
                    start: a,
                    end: i,
                    myFill: {
                      above: null,
                      below: null
                    },
                    otherFill: null
                  }), !0);
                }
              },
              calculate: function (e) {
                return c(e, !1);
              }
            } : {
              calculate: function (e, t, r, n) {
                return e.forEach(function (e) {
                  l(a(e.start, e.end, e), !0);
                }), r.forEach(function (e) {
                  l(a(e.start, e.end, e), !1);
                }), c(t, n);
              }
            };
          };
        },
        8916: function (e) {
          e.exports = {
            create: function () {
              var e = {
                root: {
                  root: !0,
                  next: null
                },
                exists: function (t) {
                  return null !== t && t !== e.root;
                },
                isEmpty: function () {
                  return null === e.root.next;
                },
                getHead: function () {
                  return e.root.next;
                },
                insertBefore: function (t, r) {
                  for (var n = e.root, a = e.root.next; null !== a;) {
                    if (r(a)) return t.prev = a.prev, t.next = a, a.prev.next = t, void (a.prev = t);
                    n = a, a = a.next;
                  }
                  n.next = t, t.prev = n, t.next = null;
                },
                findTransition: function (t) {
                  for (var r = e.root, n = e.root.next; null !== n && !t(n);) r = n, n = n.next;
                  return {
                    before: r === e.root ? null : r,
                    after: n,
                    insert: function (e) {
                      return e.prev = r, e.next = n, r.next = e, null !== n && (n.prev = e), e;
                    }
                  };
                }
              };
              return e;
            },
            node: function (e) {
              return e.prev = null, e.next = null, e.remove = function () {
                e.prev.next = e.next, e.next && (e.next.prev = e.prev), e.prev = null, e.next = null;
              }, e;
            }
          };
        },
        2222: function (e) {
          e.exports = function (e, t, r) {
            var n = [],
              a = [];
            return e.forEach(function (e) {
              var i = e.start,
                o = e.end;
              if (t.pointsSame(i, o)) console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");else {
                r && r.chainStart(e);
                for (var l = {
                    index: 0,
                    matches_head: !1,
                    matches_pt1: !1
                  }, s = {
                    index: 0,
                    matches_head: !1,
                    matches_pt1: !1
                  }, c = l, u = 0; u < n.length; u++) {
                  var f = (g = n[u])[0],
                    d = (g[1], g[g.length - 1]);
                  if (g[g.length - 2], t.pointsSame(f, i)) {
                    if (M(u, !0, !0)) break;
                  } else if (t.pointsSame(f, o)) {
                    if (M(u, !0, !1)) break;
                  } else if (t.pointsSame(d, i)) {
                    if (M(u, !1, !0)) break;
                  } else if (t.pointsSame(d, o) && M(u, !1, !1)) break;
                }
                if (c === l) return n.push([i, o]), void (r && r.chainNew(i, o));
                if (c === s) {
                  r && r.chainMatch(l.index);
                  var h = l.index,
                    p = l.matches_pt1 ? o : i,
                    v = l.matches_head,
                    g = n[h],
                    m = v ? g[0] : g[g.length - 1],
                    y = v ? g[1] : g[g.length - 2],
                    x = v ? g[g.length - 1] : g[0],
                    b = v ? g[g.length - 2] : g[1];
                  return t.pointsCollinear(y, m, p) && (v ? (r && r.chainRemoveHead(l.index, p), g.shift()) : (r && r.chainRemoveTail(l.index, p), g.pop()), m = y), t.pointsSame(x, p) ? (n.splice(h, 1), t.pointsCollinear(b, x, m) && (v ? (r && r.chainRemoveTail(l.index, m), g.pop()) : (r && r.chainRemoveHead(l.index, m), g.shift())), r && r.chainClose(l.index), void a.push(g)) : void (v ? (r && r.chainAddHead(l.index, p), g.unshift(p)) : (r && r.chainAddTail(l.index, p), g.push(p)));
                }
                var _ = l.index,
                  w = s.index;
                r && r.chainConnect(_, w);
                var T = n[_].length < n[w].length;
                l.matches_head ? s.matches_head ? T ? (k(_), A(_, w)) : (k(w), A(w, _)) : A(w, _) : s.matches_head ? A(_, w) : T ? (k(_), A(w, _)) : (k(w), A(_, w));
              }
              function M(e, t, r) {
                return c.index = e, c.matches_head = t, c.matches_pt1 = r, c === l ? (c = s, !1) : (c = null, !0);
              }
              function k(e) {
                r && r.chainReverse(e), n[e].reverse();
              }
              function A(e, a) {
                var i = n[e],
                  o = n[a],
                  l = i[i.length - 1],
                  s = i[i.length - 2],
                  c = o[0],
                  u = o[1];
                t.pointsCollinear(s, l, c) && (r && r.chainRemoveTail(e, l), i.pop(), l = s), t.pointsCollinear(l, c, u) && (r && r.chainRemoveHead(a, c), o.shift()), r && r.chainJoin(e, a), n[e] = i.concat(o), n.splice(a, 1);
              }
            }), a;
          };
        },
        7527: function (e) {
          function t(e, t, r) {
            var n = [];
            return e.forEach(function (e) {
              var a = (e.myFill.above ? 8 : 0) + (e.myFill.below ? 4 : 0) + (e.otherFill && e.otherFill.above ? 2 : 0) + (e.otherFill && e.otherFill.below ? 1 : 0);
              0 !== t[a] && n.push({
                id: r ? r.segmentId() : -1,
                start: e.start,
                end: e.end,
                myFill: {
                  above: 1 === t[a],
                  below: 2 === t[a]
                },
                otherFill: null
              });
            }), r && r.selected(n), n;
          }
          var r = {
            union: function (e, r) {
              return t(e, [0, 2, 1, 0, 2, 2, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0], r);
            },
            intersect: function (e, r) {
              return t(e, [0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 1, 1, 0, 2, 1, 0], r);
            },
            difference: function (e, r) {
              return t(e, [0, 0, 0, 0, 2, 0, 2, 0, 1, 1, 0, 0, 0, 1, 2, 0], r);
            },
            differenceRev: function (e, r) {
              return t(e, [0, 2, 1, 0, 0, 0, 1, 1, 0, 2, 0, 2, 0, 0, 0, 0], r);
            },
            xor: function (e, r) {
              return t(e, [0, 2, 1, 0, 2, 0, 0, 1, 1, 0, 0, 2, 0, 1, 2, 0], r);
            }
          };
          e.exports = r;
        },
        5657: function (e, t, r) {
          var n;
          !function (a) {
            var i = /^\s+/,
              o = /\s+$/,
              l = 0,
              s = a.round,
              c = a.min,
              u = a.max,
              f = a.random;
            function d(e, t) {
              if (t = t || {}, (e = e || "") instanceof d) return e;
              if (!(this instanceof d)) return new d(e, t);
              var r = function (e) {
                var t,
                  r,
                  n,
                  l = {
                    r: 0,
                    g: 0,
                    b: 0
                  },
                  s = 1,
                  f = null,
                  d = null,
                  h = null,
                  p = !1,
                  v = !1;
                return "string" == typeof e && (e = function (e) {
                  e = e.replace(i, "").replace(o, "").toLowerCase();
                  var t,
                    r = !1;
                  if (O[e]) e = O[e], r = !0;else if ("transparent" == e) return {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0,
                    format: "name"
                  };
                  return (t = V.rgb.exec(e)) ? {
                    r: t[1],
                    g: t[2],
                    b: t[3]
                  } : (t = V.rgba.exec(e)) ? {
                    r: t[1],
                    g: t[2],
                    b: t[3],
                    a: t[4]
                  } : (t = V.hsl.exec(e)) ? {
                    h: t[1],
                    s: t[2],
                    l: t[3]
                  } : (t = V.hsla.exec(e)) ? {
                    h: t[1],
                    s: t[2],
                    l: t[3],
                    a: t[4]
                  } : (t = V.hsv.exec(e)) ? {
                    h: t[1],
                    s: t[2],
                    v: t[3]
                  } : (t = V.hsva.exec(e)) ? {
                    h: t[1],
                    s: t[2],
                    v: t[3],
                    a: t[4]
                  } : (t = V.hex8.exec(e)) ? {
                    r: E(t[1]),
                    g: E(t[2]),
                    b: E(t[3]),
                    a: H(t[4]),
                    format: r ? "name" : "hex8"
                  } : (t = V.hex6.exec(e)) ? {
                    r: E(t[1]),
                    g: E(t[2]),
                    b: E(t[3]),
                    format: r ? "name" : "hex"
                  } : (t = V.hex4.exec(e)) ? {
                    r: E(t[1] + "" + t[1]),
                    g: E(t[2] + "" + t[2]),
                    b: E(t[3] + "" + t[3]),
                    a: H(t[4] + "" + t[4]),
                    format: r ? "name" : "hex8"
                  } : !!(t = V.hex3.exec(e)) && {
                    r: E(t[1] + "" + t[1]),
                    g: E(t[2] + "" + t[2]),
                    b: E(t[3] + "" + t[3]),
                    format: r ? "name" : "hex"
                  };
                }(e)), "object" == typeof e && (U(e.r) && U(e.g) && U(e.b) ? (t = e.r, r = e.g, n = e.b, l = {
                  r: 255 * z(t, 255),
                  g: 255 * z(r, 255),
                  b: 255 * z(n, 255)
                }, p = !0, v = "%" === String(e.r).substr(-1) ? "prgb" : "rgb") : U(e.h) && U(e.s) && U(e.v) ? (f = N(e.s), d = N(e.v), l = function (e, t, r) {
                  e = 6 * z(e, 360), t = z(t, 100), r = z(r, 100);
                  var n = a.floor(e),
                    i = e - n,
                    o = r * (1 - t),
                    l = r * (1 - i * t),
                    s = r * (1 - (1 - i) * t),
                    c = n % 6;
                  return {
                    r: 255 * [r, l, o, o, s, r][c],
                    g: 255 * [s, r, r, l, o, o][c],
                    b: 255 * [o, o, s, r, r, l][c]
                  };
                }(e.h, f, d), p = !0, v = "hsv") : U(e.h) && U(e.s) && U(e.l) && (f = N(e.s), h = N(e.l), l = function (e, t, r) {
                  var n, a, i;
                  function o(e, t, r) {
                    return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + 6 * (t - e) * r : r < .5 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
                  }
                  if (e = z(e, 360), t = z(t, 100), r = z(r, 100), 0 === t) n = a = i = r;else {
                    var l = r < .5 ? r * (1 + t) : r + t - r * t,
                      s = 2 * r - l;
                    n = o(s, l, e + 1 / 3), a = o(s, l, e), i = o(s, l, e - 1 / 3);
                  }
                  return {
                    r: 255 * n,
                    g: 255 * a,
                    b: 255 * i
                  };
                }(e.h, f, h), p = !0, v = "hsl"), e.hasOwnProperty("a") && (s = e.a)), s = P(s), {
                  ok: p,
                  format: e.format || v,
                  r: c(255, u(l.r, 0)),
                  g: c(255, u(l.g, 0)),
                  b: c(255, u(l.b, 0)),
                  a: s
                };
              }(e);
              this._originalInput = e, this._r = r.r, this._g = r.g, this._b = r.b, this._a = r.a, this._roundA = s(100 * this._a) / 100, this._format = t.format || r.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = s(this._r)), this._g < 1 && (this._g = s(this._g)), this._b < 1 && (this._b = s(this._b)), this._ok = r.ok, this._tc_id = l++;
            }
            function h(e, t, r) {
              e = z(e, 255), t = z(t, 255), r = z(r, 255);
              var n,
                a,
                i = u(e, t, r),
                o = c(e, t, r),
                l = (i + o) / 2;
              if (i == o) n = a = 0;else {
                var s = i - o;
                switch (a = l > .5 ? s / (2 - i - o) : s / (i + o), i) {
                  case e:
                    n = (t - r) / s + (t < r ? 6 : 0);
                    break;
                  case t:
                    n = (r - e) / s + 2;
                    break;
                  case r:
                    n = (e - t) / s + 4;
                }
                n /= 6;
              }
              return {
                h: n,
                s: a,
                l: l
              };
            }
            function p(e, t, r) {
              e = z(e, 255), t = z(t, 255), r = z(r, 255);
              var n,
                a,
                i = u(e, t, r),
                o = c(e, t, r),
                l = i,
                s = i - o;
              if (a = 0 === i ? 0 : s / i, i == o) n = 0;else {
                switch (i) {
                  case e:
                    n = (t - r) / s + (t < r ? 6 : 0);
                    break;
                  case t:
                    n = (r - e) / s + 2;
                    break;
                  case r:
                    n = (e - t) / s + 4;
                }
                n /= 6;
              }
              return {
                h: n,
                s: a,
                v: l
              };
            }
            function v(e, t, r, n) {
              var a = [R(s(e).toString(16)), R(s(t).toString(16)), R(s(r).toString(16))];
              return n && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
            }
            function g(e, t, r, n) {
              return [R(F(n)), R(s(e).toString(16)), R(s(t).toString(16)), R(s(r).toString(16))].join("");
            }
            function m(e, t) {
              t = 0 === t ? 0 : t || 10;
              var r = d(e).toHsl();
              return r.s -= t / 100, r.s = I(r.s), d(r);
            }
            function y(e, t) {
              t = 0 === t ? 0 : t || 10;
              var r = d(e).toHsl();
              return r.s += t / 100, r.s = I(r.s), d(r);
            }
            function x(e) {
              return d(e).desaturate(100);
            }
            function b(e, t) {
              t = 0 === t ? 0 : t || 10;
              var r = d(e).toHsl();
              return r.l += t / 100, r.l = I(r.l), d(r);
            }
            function _(e, t) {
              t = 0 === t ? 0 : t || 10;
              var r = d(e).toRgb();
              return r.r = u(0, c(255, r.r - s(-t / 100 * 255))), r.g = u(0, c(255, r.g - s(-t / 100 * 255))), r.b = u(0, c(255, r.b - s(-t / 100 * 255))), d(r);
            }
            function w(e, t) {
              t = 0 === t ? 0 : t || 10;
              var r = d(e).toHsl();
              return r.l -= t / 100, r.l = I(r.l), d(r);
            }
            function T(e, t) {
              var r = d(e).toHsl(),
                n = (r.h + t) % 360;
              return r.h = n < 0 ? 360 + n : n, d(r);
            }
            function M(e) {
              var t = d(e).toHsl();
              return t.h = (t.h + 180) % 360, d(t);
            }
            function k(e) {
              var t = d(e).toHsl(),
                r = t.h;
              return [d(e), d({
                h: (r + 120) % 360,
                s: t.s,
                l: t.l
              }), d({
                h: (r + 240) % 360,
                s: t.s,
                l: t.l
              })];
            }
            function A(e) {
              var t = d(e).toHsl(),
                r = t.h;
              return [d(e), d({
                h: (r + 90) % 360,
                s: t.s,
                l: t.l
              }), d({
                h: (r + 180) % 360,
                s: t.s,
                l: t.l
              }), d({
                h: (r + 270) % 360,
                s: t.s,
                l: t.l
              })];
            }
            function L(e) {
              var t = d(e).toHsl(),
                r = t.h;
              return [d(e), d({
                h: (r + 72) % 360,
                s: t.s,
                l: t.l
              }), d({
                h: (r + 216) % 360,
                s: t.s,
                l: t.l
              })];
            }
            function S(e, t, r) {
              t = t || 6, r = r || 30;
              var n = d(e).toHsl(),
                a = 360 / r,
                i = [d(e)];
              for (n.h = (n.h - (a * t >> 1) + 720) % 360; --t;) n.h = (n.h + a) % 360, i.push(d(n));
              return i;
            }
            function C(e, t) {
              t = t || 6;
              for (var r = d(e).toHsv(), n = r.h, a = r.s, i = r.v, o = [], l = 1 / t; t--;) o.push(d({
                h: n,
                s: a,
                v: i
              })), i = (i + l) % 1;
              return o;
            }
            d.prototype = {
              isDark: function () {
                return this.getBrightness() < 128;
              },
              isLight: function () {
                return !this.isDark();
              },
              isValid: function () {
                return this._ok;
              },
              getOriginalInput: function () {
                return this._originalInput;
              },
              getFormat: function () {
                return this._format;
              },
              getAlpha: function () {
                return this._a;
              },
              getBrightness: function () {
                var e = this.toRgb();
                return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3;
              },
              getLuminance: function () {
                var e,
                  t,
                  r,
                  n = this.toRgb();
                return e = n.r / 255, t = n.g / 255, r = n.b / 255, .2126 * (e <= .03928 ? e / 12.92 : a.pow((e + .055) / 1.055, 2.4)) + .7152 * (t <= .03928 ? t / 12.92 : a.pow((t + .055) / 1.055, 2.4)) + .0722 * (r <= .03928 ? r / 12.92 : a.pow((r + .055) / 1.055, 2.4));
              },
              setAlpha: function (e) {
                return this._a = P(e), this._roundA = s(100 * this._a) / 100, this;
              },
              toHsv: function () {
                var e = p(this._r, this._g, this._b);
                return {
                  h: 360 * e.h,
                  s: e.s,
                  v: e.v,
                  a: this._a
                };
              },
              toHsvString: function () {
                var e = p(this._r, this._g, this._b),
                  t = s(360 * e.h),
                  r = s(100 * e.s),
                  n = s(100 * e.v);
                return 1 == this._a ? "hsv(" + t + ", " + r + "%, " + n + "%)" : "hsva(" + t + ", " + r + "%, " + n + "%, " + this._roundA + ")";
              },
              toHsl: function () {
                var e = h(this._r, this._g, this._b);
                return {
                  h: 360 * e.h,
                  s: e.s,
                  l: e.l,
                  a: this._a
                };
              },
              toHslString: function () {
                var e = h(this._r, this._g, this._b),
                  t = s(360 * e.h),
                  r = s(100 * e.s),
                  n = s(100 * e.l);
                return 1 == this._a ? "hsl(" + t + ", " + r + "%, " + n + "%)" : "hsla(" + t + ", " + r + "%, " + n + "%, " + this._roundA + ")";
              },
              toHex: function (e) {
                return v(this._r, this._g, this._b, e);
              },
              toHexString: function (e) {
                return "#" + this.toHex(e);
              },
              toHex8: function (e) {
                return function (e, t, r, n, a) {
                  var i = [R(s(e).toString(16)), R(s(t).toString(16)), R(s(r).toString(16)), R(F(n))];
                  return a && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) && i[3].charAt(0) == i[3].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
                }(this._r, this._g, this._b, this._a, e);
              },
              toHex8String: function (e) {
                return "#" + this.toHex8(e);
              },
              toRgb: function () {
                return {
                  r: s(this._r),
                  g: s(this._g),
                  b: s(this._b),
                  a: this._a
                };
              },
              toRgbString: function () {
                return 1 == this._a ? "rgb(" + s(this._r) + ", " + s(this._g) + ", " + s(this._b) + ")" : "rgba(" + s(this._r) + ", " + s(this._g) + ", " + s(this._b) + ", " + this._roundA + ")";
              },
              toPercentageRgb: function () {
                return {
                  r: s(100 * z(this._r, 255)) + "%",
                  g: s(100 * z(this._g, 255)) + "%",
                  b: s(100 * z(this._b, 255)) + "%",
                  a: this._a
                };
              },
              toPercentageRgbString: function () {
                return 1 == this._a ? "rgb(" + s(100 * z(this._r, 255)) + "%, " + s(100 * z(this._g, 255)) + "%, " + s(100 * z(this._b, 255)) + "%)" : "rgba(" + s(100 * z(this._r, 255)) + "%, " + s(100 * z(this._g, 255)) + "%, " + s(100 * z(this._b, 255)) + "%, " + this._roundA + ")";
              },
              toName: function () {
                return 0 === this._a ? "transparent" : !(this._a < 1) && (D[v(this._r, this._g, this._b, !0)] || !1);
              },
              toFilter: function (e) {
                var t = "#" + g(this._r, this._g, this._b, this._a),
                  r = t,
                  n = this._gradientType ? "GradientType = 1, " : "";
                if (e) {
                  var a = d(e);
                  r = "#" + g(a._r, a._g, a._b, a._a);
                }
                return "progid:DXImageTransform.Microsoft.gradient(" + n + "startColorstr=" + t + ",endColorstr=" + r + ")";
              },
              toString: function (e) {
                var t = !!e;
                e = e || this._format;
                var r = !1,
                  n = this._a < 1 && this._a >= 0;
                return t || !n || "hex" !== e && "hex6" !== e && "hex3" !== e && "hex4" !== e && "hex8" !== e && "name" !== e ? ("rgb" === e && (r = this.toRgbString()), "prgb" === e && (r = this.toPercentageRgbString()), "hex" !== e && "hex6" !== e || (r = this.toHexString()), "hex3" === e && (r = this.toHexString(!0)), "hex4" === e && (r = this.toHex8String(!0)), "hex8" === e && (r = this.toHex8String()), "name" === e && (r = this.toName()), "hsl" === e && (r = this.toHslString()), "hsv" === e && (r = this.toHsvString()), r || this.toHexString()) : "name" === e && 0 === this._a ? this.toName() : this.toRgbString();
              },
              clone: function () {
                return d(this.toString());
              },
              _applyModification: function (e, t) {
                var r = e.apply(null, [this].concat([].slice.call(t)));
                return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
              },
              lighten: function () {
                return this._applyModification(b, arguments);
              },
              brighten: function () {
                return this._applyModification(_, arguments);
              },
              darken: function () {
                return this._applyModification(w, arguments);
              },
              desaturate: function () {
                return this._applyModification(m, arguments);
              },
              saturate: function () {
                return this._applyModification(y, arguments);
              },
              greyscale: function () {
                return this._applyModification(x, arguments);
              },
              spin: function () {
                return this._applyModification(T, arguments);
              },
              _applyCombination: function (e, t) {
                return e.apply(null, [this].concat([].slice.call(t)));
              },
              analogous: function () {
                return this._applyCombination(S, arguments);
              },
              complement: function () {
                return this._applyCombination(M, arguments);
              },
              monochromatic: function () {
                return this._applyCombination(C, arguments);
              },
              splitcomplement: function () {
                return this._applyCombination(L, arguments);
              },
              triad: function () {
                return this._applyCombination(k, arguments);
              },
              tetrad: function () {
                return this._applyCombination(A, arguments);
              }
            }, d.fromRatio = function (e, t) {
              if ("object" == typeof e) {
                var r = {};
                for (var n in e) e.hasOwnProperty(n) && (r[n] = "a" === n ? e[n] : N(e[n]));
                e = r;
              }
              return d(e, t);
            }, d.equals = function (e, t) {
              return !(!e || !t) && d(e).toRgbString() == d(t).toRgbString();
            }, d.random = function () {
              return d.fromRatio({
                r: f(),
                g: f(),
                b: f()
              });
            }, d.mix = function (e, t, r) {
              r = 0 === r ? 0 : r || 50;
              var n = d(e).toRgb(),
                a = d(t).toRgb(),
                i = r / 100;
              return d({
                r: (a.r - n.r) * i + n.r,
                g: (a.g - n.g) * i + n.g,
                b: (a.b - n.b) * i + n.b,
                a: (a.a - n.a) * i + n.a
              });
            }, d.readability = function (e, t) {
              var r = d(e),
                n = d(t);
              return (a.max(r.getLuminance(), n.getLuminance()) + .05) / (a.min(r.getLuminance(), n.getLuminance()) + .05);
            }, d.isReadable = function (e, t, r) {
              var n,
                a,
                i,
                o,
                l,
                s = d.readability(e, t);
              switch (a = !1, (i = r, "AA" !== (o = ((i = i || {
                level: "AA",
                size: "small"
              }).level || "AA").toUpperCase()) && "AAA" !== o && (o = "AA"), "small" !== (l = (i.size || "small").toLowerCase()) && "large" !== l && (l = "small"), n = {
                level: o,
                size: l
              }).level + n.size) {
                case "AAsmall":
                case "AAAlarge":
                  a = s >= 4.5;
                  break;
                case "AAlarge":
                  a = s >= 3;
                  break;
                case "AAAsmall":
                  a = s >= 7;
              }
              return a;
            }, d.mostReadable = function (e, t, r) {
              var n,
                a,
                i,
                o,
                l = null,
                s = 0;
              a = (r = r || {}).includeFallbackColors, i = r.level, o = r.size;
              for (var c = 0; c < t.length; c++) (n = d.readability(e, t[c])) > s && (s = n, l = d(t[c]));
              return d.isReadable(e, l, {
                level: i,
                size: o
              }) || !a ? l : (r.includeFallbackColors = !1, d.mostReadable(e, ["#fff", "#000"], r));
            };
            var O = d.names = {
                aliceblue: "f0f8ff",
                antiquewhite: "faebd7",
                aqua: "0ff",
                aquamarine: "7fffd4",
                azure: "f0ffff",
                beige: "f5f5dc",
                bisque: "ffe4c4",
                black: "000",
                blanchedalmond: "ffebcd",
                blue: "00f",
                blueviolet: "8a2be2",
                brown: "a52a2a",
                burlywood: "deb887",
                burntsienna: "ea7e5d",
                cadetblue: "5f9ea0",
                chartreuse: "7fff00",
                chocolate: "d2691e",
                coral: "ff7f50",
                cornflowerblue: "6495ed",
                cornsilk: "fff8dc",
                crimson: "dc143c",
                cyan: "0ff",
                darkblue: "00008b",
                darkcyan: "008b8b",
                darkgoldenrod: "b8860b",
                darkgray: "a9a9a9",
                darkgreen: "006400",
                darkgrey: "a9a9a9",
                darkkhaki: "bdb76b",
                darkmagenta: "8b008b",
                darkolivegreen: "556b2f",
                darkorange: "ff8c00",
                darkorchid: "9932cc",
                darkred: "8b0000",
                darksalmon: "e9967a",
                darkseagreen: "8fbc8f",
                darkslateblue: "483d8b",
                darkslategray: "2f4f4f",
                darkslategrey: "2f4f4f",
                darkturquoise: "00ced1",
                darkviolet: "9400d3",
                deeppink: "ff1493",
                deepskyblue: "00bfff",
                dimgray: "696969",
                dimgrey: "696969",
                dodgerblue: "1e90ff",
                firebrick: "b22222",
                floralwhite: "fffaf0",
                forestgreen: "228b22",
                fuchsia: "f0f",
                gainsboro: "dcdcdc",
                ghostwhite: "f8f8ff",
                gold: "ffd700",
                goldenrod: "daa520",
                gray: "808080",
                green: "008000",
                greenyellow: "adff2f",
                grey: "808080",
                honeydew: "f0fff0",
                hotpink: "ff69b4",
                indianred: "cd5c5c",
                indigo: "4b0082",
                ivory: "fffff0",
                khaki: "f0e68c",
                lavender: "e6e6fa",
                lavenderblush: "fff0f5",
                lawngreen: "7cfc00",
                lemonchiffon: "fffacd",
                lightblue: "add8e6",
                lightcoral: "f08080",
                lightcyan: "e0ffff",
                lightgoldenrodyellow: "fafad2",
                lightgray: "d3d3d3",
                lightgreen: "90ee90",
                lightgrey: "d3d3d3",
                lightpink: "ffb6c1",
                lightsalmon: "ffa07a",
                lightseagreen: "20b2aa",
                lightskyblue: "87cefa",
                lightslategray: "789",
                lightslategrey: "789",
                lightsteelblue: "b0c4de",
                lightyellow: "ffffe0",
                lime: "0f0",
                limegreen: "32cd32",
                linen: "faf0e6",
                magenta: "f0f",
                maroon: "800000",
                mediumaquamarine: "66cdaa",
                mediumblue: "0000cd",
                mediumorchid: "ba55d3",
                mediumpurple: "9370db",
                mediumseagreen: "3cb371",
                mediumslateblue: "7b68ee",
                mediumspringgreen: "00fa9a",
                mediumturquoise: "48d1cc",
                mediumvioletred: "c71585",
                midnightblue: "191970",
                mintcream: "f5fffa",
                mistyrose: "ffe4e1",
                moccasin: "ffe4b5",
                navajowhite: "ffdead",
                navy: "000080",
                oldlace: "fdf5e6",
                olive: "808000",
                olivedrab: "6b8e23",
                orange: "ffa500",
                orangered: "ff4500",
                orchid: "da70d6",
                palegoldenrod: "eee8aa",
                palegreen: "98fb98",
                paleturquoise: "afeeee",
                palevioletred: "db7093",
                papayawhip: "ffefd5",
                peachpuff: "ffdab9",
                peru: "cd853f",
                pink: "ffc0cb",
                plum: "dda0dd",
                powderblue: "b0e0e6",
                purple: "800080",
                rebeccapurple: "663399",
                red: "f00",
                rosybrown: "bc8f8f",
                royalblue: "4169e1",
                saddlebrown: "8b4513",
                salmon: "fa8072",
                sandybrown: "f4a460",
                seagreen: "2e8b57",
                seashell: "fff5ee",
                sienna: "a0522d",
                silver: "c0c0c0",
                skyblue: "87ceeb",
                slateblue: "6a5acd",
                slategray: "708090",
                slategrey: "708090",
                snow: "fffafa",
                springgreen: "00ff7f",
                steelblue: "4682b4",
                tan: "d2b48c",
                teal: "008080",
                thistle: "d8bfd8",
                tomato: "ff6347",
                turquoise: "40e0d0",
                violet: "ee82ee",
                wheat: "f5deb3",
                white: "fff",
                whitesmoke: "f5f5f5",
                yellow: "ff0",
                yellowgreen: "9acd32"
              },
              D = d.hexNames = function (e) {
                var t = {};
                for (var r in e) e.hasOwnProperty(r) && (t[e[r]] = r);
                return t;
              }(O);
            function P(e) {
              return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
            }
            function z(e, t) {
              (function (e) {
                return "string" == typeof e && -1 != e.indexOf(".") && 1 === parseFloat(e);
              })(e) && (e = "100%");
              var r = function (e) {
                return "string" == typeof e && -1 != e.indexOf("%");
              }(e);
              return e = c(t, u(0, parseFloat(e))), r && (e = parseInt(e * t, 10) / 100), a.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
            }
            function I(e) {
              return c(1, u(0, e));
            }
            function E(e) {
              return parseInt(e, 16);
            }
            function R(e) {
              return 1 == e.length ? "0" + e : "" + e;
            }
            function N(e) {
              return e <= 1 && (e = 100 * e + "%"), e;
            }
            function F(e) {
              return a.round(255 * parseFloat(e)).toString(16);
            }
            function H(e) {
              return E(e) / 255;
            }
            var B,
              j,
              Y,
              V = (j = "[\\s|\\(]+(" + (B = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + B + ")[,|\\s]+(" + B + ")\\s*\\)?", Y = "[\\s|\\(]+(" + B + ")[,|\\s]+(" + B + ")[,|\\s]+(" + B + ")[,|\\s]+(" + B + ")\\s*\\)?", {
                CSS_UNIT: new RegExp(B),
                rgb: new RegExp("rgb" + j),
                rgba: new RegExp("rgba" + Y),
                hsl: new RegExp("hsl" + j),
                hsla: new RegExp("hsla" + Y),
                hsv: new RegExp("hsv" + j),
                hsva: new RegExp("hsva" + Y),
                hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
              });
            function U(e) {
              return !!V.CSS_UNIT.exec(e);
            }
            e.exports ? e.exports = d : void 0 === (n = function () {
              return d;
            }.call(t, r, t, e)) || (e.exports = n);
          }(Math);
        },
        1401: function (e, t, r) {
          var n = r(6834),
            a = r(7976),
            i = n.instance();
          function o(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          o.prototype = new n.baseCalendar(), a(o.prototype, {
            name: "Chinese",
            jdEpoch: 1721425.5,
            hasYearZero: !1,
            minMonth: 0,
            firstMonth: 0,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Chinese",
                epochs: ["BEC", "EC"],
                monthNumbers: function (e, t) {
                  if ("string" == typeof e) {
                    var r = e.match(s);
                    return r ? r[0] : "";
                  }
                  var n = this._validateYear(e),
                    a = e.month(),
                    i = "" + this.toChineseMonth(n, a);
                  return t && i.length < 2 && (i = "0" + i), this.isIntercalaryMonth(n, a) && (i += "i"), i;
                },
                monthNames: function (e) {
                  if ("string" == typeof e) {
                    var t = e.match(c);
                    return t ? t[0] : "";
                  }
                  var r = this._validateYear(e),
                    n = e.month(),
                    a = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"][this.toChineseMonth(r, n) - 1];
                  return this.isIntercalaryMonth(r, n) && (a = "闰" + a), a;
                },
                monthNamesShort: function (e) {
                  if ("string" == typeof e) {
                    var t = e.match(u);
                    return t ? t[0] : "";
                  }
                  var r = this._validateYear(e),
                    n = e.month(),
                    a = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"][this.toChineseMonth(r, n) - 1];
                  return this.isIntercalaryMonth(r, n) && (a = "闰" + a), a;
                },
                parseMonth: function (e, t) {
                  e = this._validateYear(e);
                  var r,
                    n = parseInt(t);
                  if (isNaN(n)) "闰" === t[0] && (r = !0, t = t.substring(1)), "月" === t[t.length - 1] && (t = t.substring(0, t.length - 1)), n = 1 + ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"].indexOf(t);else {
                    var a = t[t.length - 1];
                    r = "i" === a || "I" === a;
                  }
                  return this.toMonthIndex(e, n, r);
                },
                dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                digits: null,
                dateFormat: "yyyy/mm/dd",
                firstDay: 1,
                isRTL: !1
              }
            },
            _validateYear: function (e, t) {
              if (e.year && (e = e.year()), "number" != typeof e || e < 1888 || e > 2111) throw t.replace(/\{0\}/, this.local.name);
              return e;
            },
            toMonthIndex: function (e, t, r) {
              var a = this.intercalaryMonth(e);
              if (r && t !== a || t < 1 || t > 12) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
              return a ? !r && t <= a ? t - 1 : t : t - 1;
            },
            toChineseMonth: function (e, t) {
              e.year && (t = (e = e.year()).month());
              var r = this.intercalaryMonth(e);
              if (t < 0 || t > (r ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
              return r ? t < r ? t + 1 : t : t + 1;
            },
            intercalaryMonth: function (e) {
              return e = this._validateYear(e), f[e - f[0]] >> 13;
            },
            isIntercalaryMonth: function (e, t) {
              e.year && (t = (e = e.year()).month());
              var r = this.intercalaryMonth(e);
              return !!r && r === t;
            },
            leapYear: function (e) {
              return 0 !== this.intercalaryMonth(e);
            },
            weekOfYear: function (e, t, r) {
              var a,
                o = this._validateYear(e, n.local.invalidyear),
                l = d[o - d[0]],
                s = l >> 9 & 4095,
                c = l >> 5 & 15,
                u = 31 & l;
              (a = i.newDate(s, c, u)).add(4 - (a.dayOfWeek() || 7), "d");
              var f = this.toJD(e, t, r) - a.toJD();
              return 1 + Math.floor(f / 7);
            },
            monthsInYear: function (e) {
              return this.leapYear(e) ? 13 : 12;
            },
            daysInMonth: function (e, t) {
              e.year && (t = e.month(), e = e.year()), e = this._validateYear(e);
              var r = f[e - f[0]];
              if (t > (r >> 13 ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
              return r & 1 << 12 - t ? 30 : 29;
            },
            weekDay: function (e, t, r) {
              return (this.dayOfWeek(e, t, r) || 7) < 6;
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, l, r, n.local.invalidDate);
              e = this._validateYear(a.year()), t = a.month(), r = a.day();
              var o = this.isIntercalaryMonth(e, t),
                l = this.toChineseMonth(e, t),
                s = function (e, t, r, n, a) {
                  var i, o, l;
                  if ("object" == typeof e) o = e, i = t || {};else {
                    var s;
                    if (!("number" == typeof e && e >= 1888 && e <= 2111)) throw new Error("Lunar year outside range 1888-2111");
                    if (!("number" == typeof t && t >= 1 && t <= 12)) throw new Error("Lunar month outside range 1 - 12");
                    if (!("number" == typeof r && r >= 1 && r <= 30)) throw new Error("Lunar day outside range 1 - 30");
                    "object" == typeof n ? (s = !1, i = n) : (s = !!n, i = {}), o = {
                      year: e,
                      month: t,
                      day: r,
                      isIntercalary: s
                    };
                  }
                  l = o.day - 1;
                  var c,
                    u = f[o.year - f[0]],
                    h = u >> 13;
                  c = h && (o.month > h || o.isIntercalary) ? o.month : o.month - 1;
                  for (var p = 0; p < c; p++) l += u & 1 << 12 - p ? 30 : 29;
                  var v = d[o.year - d[0]],
                    g = new Date(v >> 9 & 4095, (v >> 5 & 15) - 1, (31 & v) + l);
                  return i.year = g.getFullYear(), i.month = 1 + g.getMonth(), i.day = g.getDate(), i;
                }(e, l, r, o);
              return i.toJD(s.year, s.month, s.day);
            },
            fromJD: function (e) {
              var t = i.fromJD(e),
                r = function (e, t, r, n) {
                  var a, i;
                  if ("object" == typeof e) a = e, i = t || {};else {
                    if (!("number" == typeof e && e >= 1888 && e <= 2111)) throw new Error("Solar year outside range 1888-2111");
                    if (!("number" == typeof t && t >= 1 && t <= 12)) throw new Error("Solar month outside range 1 - 12");
                    if (!("number" == typeof r && r >= 1 && r <= 31)) throw new Error("Solar day outside range 1 - 31");
                    a = {
                      year: e,
                      month: t,
                      day: r
                    }, i = {};
                  }
                  var o = d[a.year - d[0]],
                    l = a.year << 9 | a.month << 5 | a.day;
                  i.year = l >= o ? a.year : a.year - 1, o = d[i.year - d[0]];
                  var s,
                    c = new Date(o >> 9 & 4095, (o >> 5 & 15) - 1, 31 & o),
                    u = new Date(a.year, a.month - 1, a.day);
                  s = Math.round((u - c) / 864e5);
                  var h,
                    p = f[i.year - f[0]];
                  for (h = 0; h < 13; h++) {
                    var v = p & 1 << 12 - h ? 30 : 29;
                    if (s < v) break;
                    s -= v;
                  }
                  var g = p >> 13;
                  return !g || h < g ? (i.isIntercalary = !1, i.month = 1 + h) : h === g ? (i.isIntercalary = !0, i.month = h) : (i.isIntercalary = !1, i.month = h), i.day = 1 + s, i;
                }(t.year(), t.month(), t.day()),
                n = this.toMonthIndex(r.year, r.month, r.isIntercalary);
              return this.newDate(r.year, n, r.day);
            },
            fromString: function (e) {
              var t = e.match(l),
                r = this._validateYear(+t[1]),
                n = +t[2],
                a = !!t[3],
                i = this.toMonthIndex(r, n, a),
                o = +t[4];
              return this.newDate(r, i, o);
            },
            add: function (e, t, r) {
              var n = e.year(),
                a = e.month(),
                i = this.isIntercalaryMonth(n, a),
                l = this.toChineseMonth(n, a),
                s = Object.getPrototypeOf(o.prototype).add.call(this, e, t, r);
              if ("y" === r) {
                var c = s.year(),
                  u = s.month(),
                  f = this.isIntercalaryMonth(c, l),
                  d = i && f ? this.toMonthIndex(c, l, !0) : this.toMonthIndex(c, l, !1);
                d !== u && s.month(d);
              }
              return s;
            }
          });
          var l = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m,
            s = /^\d?\d[iI]?/m,
            c = /^闰?十?[一二三四五六七八九]?月/m,
            u = /^闰?十?[一二三四五六七八九]?/m;
          n.calendars.chinese = o;
          var f = [1887, 5780, 5802, 19157, 2742, 50359, 1198, 2646, 46378, 7466, 3412, 30122, 5482, 67949, 2396, 5294, 43597, 6732, 6954, 36181, 2772, 4954, 18781, 2396, 54427, 5274, 6730, 47781, 5800, 6868, 21210, 4790, 59703, 2350, 5270, 46667, 3402, 3496, 38325, 1388, 4782, 18735, 2350, 52374, 6804, 7498, 44457, 2906, 1388, 29294, 4700, 63789, 6442, 6804, 56138, 5802, 2772, 38235, 1210, 4698, 22827, 5418, 63125, 3476, 5802, 43701, 2484, 5302, 27223, 2646, 70954, 7466, 3412, 54698, 5482, 2412, 38062, 5294, 2636, 32038, 6954, 60245, 2772, 4826, 43357, 2394, 5274, 39501, 6730, 72357, 5800, 5844, 53978, 4790, 2358, 38039, 5270, 87627, 3402, 3496, 54708, 5484, 4782, 43311, 2350, 3222, 27978, 7498, 68965, 2904, 5484, 45677, 4700, 6444, 39573, 6804, 6986, 19285, 2772, 62811, 1210, 4698, 47403, 5418, 5780, 38570, 5546, 76469, 2420, 5302, 51799, 2646, 5414, 36501, 3412, 5546, 18869, 2412, 54446, 5276, 6732, 48422, 6822, 2900, 28010, 4826, 92509, 2394, 5274, 55883, 6730, 6820, 47956, 5812, 2778, 18779, 2358, 62615, 5270, 5450, 46757, 3492, 5556, 27318, 4718, 67887, 2350, 3222, 52554, 7498, 3428, 38252, 5468, 4700, 31022, 6444, 64149, 6804, 6986, 43861, 2772, 5338, 35421, 2650, 70955, 5418, 5780, 54954, 5546, 2740, 38074, 5302, 2646, 29991, 3366, 61011, 3412, 5546, 43445, 2412, 5294, 35406, 6732, 72998, 6820, 6996, 52586, 2778, 2396, 38045, 5274, 6698, 23333, 6820, 64338, 5812, 2746, 43355, 2358, 5270, 39499, 5450, 79525, 3492, 5548],
            d = [1887, 966732, 967231, 967733, 968265, 968766, 969297, 969798, 970298, 970829, 971330, 971830, 972362, 972863, 973395, 973896, 974397, 974928, 975428, 975929, 976461, 976962, 977462, 977994, 978494, 979026, 979526, 980026, 980558, 981059, 981559, 982091, 982593, 983124, 983624, 984124, 984656, 985157, 985656, 986189, 986690, 987191, 987722, 988222, 988753, 989254, 989754, 990286, 990788, 991288, 991819, 992319, 992851, 993352, 993851, 994383, 994885, 995385, 995917, 996418, 996918, 997450, 997949, 998481, 998982, 999483, 1000014, 1000515, 1001016, 1001548, 1002047, 1002578, 1003080, 1003580, 1004111, 1004613, 1005113, 1005645, 1006146, 1006645, 1007177, 1007678, 1008209, 1008710, 1009211, 1009743, 1010243, 1010743, 1011275, 1011775, 1012306, 1012807, 1013308, 1013840, 1014341, 1014841, 1015373, 1015874, 1016404, 1016905, 1017405, 1017937, 1018438, 1018939, 1019471, 1019972, 1020471, 1021002, 1021503, 1022035, 1022535, 1023036, 1023568, 1024069, 1024568, 1025100, 1025601, 1026102, 1026633, 1027133, 1027666, 1028167, 1028666, 1029198, 1029699, 1030199, 1030730, 1031231, 1031763, 1032264, 1032764, 1033296, 1033797, 1034297, 1034828, 1035329, 1035830, 1036362, 1036861, 1037393, 1037894, 1038394, 1038925, 1039427, 1039927, 1040459, 1040959, 1041491, 1041992, 1042492, 1043023, 1043524, 1044024, 1044556, 1045057, 1045558, 1046090, 1046590, 1047121, 1047622, 1048122, 1048654, 1049154, 1049655, 1050187, 1050689, 1051219, 1051720, 1052220, 1052751, 1053252, 1053752, 1054284, 1054786, 1055285, 1055817, 1056317, 1056849, 1057349, 1057850, 1058382, 1058883, 1059383, 1059915, 1060415, 1060947, 1061447, 1061947, 1062479, 1062981, 1063480, 1064012, 1064514, 1065014, 1065545, 1066045, 1066577, 1067078, 1067578, 1068110, 1068611, 1069112, 1069642, 1070142, 1070674, 1071175, 1071675, 1072207, 1072709, 1073209, 1073740, 1074241, 1074741, 1075273, 1075773, 1076305, 1076807, 1077308, 1077839, 1078340, 1078840, 1079372, 1079871, 1080403, 1080904];
        },
        2210: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "Coptic",
            jdEpoch: 1825029.5,
            daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Coptic",
                epochs: ["BAM", "AM"],
                monthNames: ["Thout", "Paopi", "Hathor", "Koiak", "Tobi", "Meshir", "Paremhat", "Paremoude", "Pashons", "Paoni", "Epip", "Mesori", "Pi Kogi Enavot"],
                monthNamesShort: ["Tho", "Pao", "Hath", "Koi", "Tob", "Mesh", "Pat", "Pad", "Pash", "Pao", "Epi", "Meso", "PiK"],
                dayNames: ["Tkyriaka", "Pesnau", "Pshoment", "Peftoou", "Ptiou", "Psoou", "Psabbaton"],
                dayNamesShort: ["Tky", "Pes", "Psh", "Pef", "Pti", "Pso", "Psa"],
                dayNamesMin: ["Tk", "Pes", "Psh", "Pef", "Pt", "Pso", "Psa"],
                digits: null,
                dateFormat: "dd/mm/yyyy",
                firstDay: 0,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return (e = t.year() + (t.year() < 0 ? 1 : 0)) % 4 == 3 || e % 4 == -1;
            },
            monthsInYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
              return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
            },
            weekDay: function (e, t, r) {
              return (this.dayOfWeek(e, t, r) || 7) < 6;
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return (e = a.year()) < 0 && e++, a.day() + 30 * (a.month() - 1) + 365 * (e - 1) + Math.floor(e / 4) + this.jdEpoch - 1;
            },
            fromJD: function (e) {
              var t = Math.floor(e) + .5 - this.jdEpoch,
                r = Math.floor((t - Math.floor((t + 366) / 1461)) / 365) + 1;
              r <= 0 && r--, t = Math.floor(e) + .5 - this.newDate(r, 1, 1).toJD();
              var n = Math.floor(t / 30) + 1,
                a = t - 30 * (n - 1) + 1;
              return this.newDate(r, n, a);
            }
          }), n.calendars.coptic = i;
        },
        8569: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "Discworld",
            jdEpoch: 1721425.5,
            daysPerMonth: [16, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Discworld",
                epochs: ["BUC", "UC"],
                monthNames: ["Ick", "Offle", "February", "March", "April", "May", "June", "Grune", "August", "Spune", "Sektober", "Ember", "December"],
                monthNamesShort: ["Ick", "Off", "Feb", "Mar", "Apr", "May", "Jun", "Gru", "Aug", "Spu", "Sek", "Emb", "Dec"],
                dayNames: ["Sunday", "Octeday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                dayNamesShort: ["Sun", "Oct", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                dayNamesMin: ["Su", "Oc", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                digits: null,
                dateFormat: "yyyy/mm/dd",
                firstDay: 2,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), !1;
            },
            monthsInYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 13;
            },
            daysInYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 400;
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 8) + 1;
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
              return this.daysPerMonth[r.month() - 1];
            },
            daysInWeek: function () {
              return 8;
            },
            dayOfWeek: function (e, t, r) {
              return (this._validate(e, t, r, n.local.invalidDate).day() + 1) % 8;
            },
            weekDay: function (e, t, r) {
              var n = this.dayOfWeek(e, t, r);
              return n >= 2 && n <= 6;
            },
            extraInfo: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return {
                century: o[Math.floor((a.year() - 1) / 100) + 1] || ""
              };
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return e = a.year() + (a.year() < 0 ? 1 : 0), t = a.month(), (r = a.day()) + (t > 1 ? 16 : 0) + (t > 2 ? 32 * (t - 2) : 0) + 400 * (e - 1) + this.jdEpoch - 1;
            },
            fromJD: function (e) {
              e = Math.floor(e + .5) - Math.floor(this.jdEpoch) - 1;
              var t = Math.floor(e / 400) + 1;
              e -= 400 * (t - 1), e += e > 15 ? 16 : 0;
              var r = Math.floor(e / 32) + 1,
                n = e - 32 * (r - 1) + 1;
              return this.newDate(t <= 0 ? t - 1 : t, r, n);
            }
          });
          var o = {
            20: "Fruitbat",
            21: "Anchovy"
          };
          n.calendars.discworld = i;
        },
        1133: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "Ethiopian",
            jdEpoch: 1724220.5,
            daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Ethiopian",
                epochs: ["BEE", "EE"],
                monthNames: ["Meskerem", "Tikemet", "Hidar", "Tahesas", "Tir", "Yekatit", "Megabit", "Miazia", "Genbot", "Sene", "Hamle", "Nehase", "Pagume"],
                monthNamesShort: ["Mes", "Tik", "Hid", "Tah", "Tir", "Yek", "Meg", "Mia", "Gen", "Sen", "Ham", "Neh", "Pag"],
                dayNames: ["Ehud", "Segno", "Maksegno", "Irob", "Hamus", "Arb", "Kidame"],
                dayNamesShort: ["Ehu", "Seg", "Mak", "Iro", "Ham", "Arb", "Kid"],
                dayNamesMin: ["Eh", "Se", "Ma", "Ir", "Ha", "Ar", "Ki"],
                digits: null,
                dateFormat: "dd/mm/yyyy",
                firstDay: 0,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return (e = t.year() + (t.year() < 0 ? 1 : 0)) % 4 == 3 || e % 4 == -1;
            },
            monthsInYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
              return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
            },
            weekDay: function (e, t, r) {
              return (this.dayOfWeek(e, t, r) || 7) < 6;
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return (e = a.year()) < 0 && e++, a.day() + 30 * (a.month() - 1) + 365 * (e - 1) + Math.floor(e / 4) + this.jdEpoch - 1;
            },
            fromJD: function (e) {
              var t = Math.floor(e) + .5 - this.jdEpoch,
                r = Math.floor((t - Math.floor((t + 366) / 1461)) / 365) + 1;
              r <= 0 && r--, t = Math.floor(e) + .5 - this.newDate(r, 1, 1).toJD();
              var n = Math.floor(t / 30) + 1,
                a = t - 30 * (n - 1) + 1;
              return this.newDate(r, n, a);
            }
          }), n.calendars.ethiopian = i;
        },
        8295: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          function o(e, t) {
            return e - t * Math.floor(e / t);
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "Hebrew",
            jdEpoch: 347995.5,
            daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 29],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 7,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Hebrew",
                epochs: ["BAM", "AM"],
                monthNames: ["Nisan", "Iyar", "Sivan", "Tammuz", "Av", "Elul", "Tishrei", "Cheshvan", "Kislev", "Tevet", "Shevat", "Adar", "Adar II"],
                monthNamesShort: ["Nis", "Iya", "Siv", "Tam", "Av", "Elu", "Tis", "Che", "Kis", "Tev", "She", "Ada", "Ad2"],
                dayNames: ["Yom Rishon", "Yom Sheni", "Yom Shlishi", "Yom Revi'i", "Yom Chamishi", "Yom Shishi", "Yom Shabbat"],
                dayNamesShort: ["Ris", "She", "Shl", "Rev", "Cha", "Shi", "Sha"],
                dayNamesMin: ["Ri", "She", "Shl", "Re", "Ch", "Shi", "Sha"],
                digits: null,
                dateFormat: "dd/mm/yyyy",
                firstDay: 0,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return this._leapYear(t.year());
            },
            _leapYear: function (e) {
              return o(7 * (e = e < 0 ? e + 1 : e) + 1, 19) < 7;
            },
            monthsInYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), this._leapYear(e.year ? e.year() : e) ? 13 : 12;
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInYear: function (e) {
              return e = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year(), this.toJD(-1 === e ? 1 : e + 1, 7, 1) - this.toJD(e, 7, 1);
            },
            daysInMonth: function (e, t) {
              return e.year && (t = e.month(), e = e.year()), this._validate(e, t, this.minDay, n.local.invalidMonth), 12 === t && this.leapYear(e) || 8 === t && 5 === o(this.daysInYear(e), 10) ? 30 : 9 === t && 3 === o(this.daysInYear(e), 10) ? 29 : this.daysPerMonth[t - 1];
            },
            weekDay: function (e, t, r) {
              return 6 !== this.dayOfWeek(e, t, r);
            },
            extraInfo: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return {
                yearType: (this.leapYear(a) ? "embolismic" : "common") + " " + ["deficient", "regular", "complete"][this.daysInYear(a) % 10 - 3]
              };
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              e = a.year(), t = a.month(), r = a.day();
              var i = e <= 0 ? e + 1 : e,
                o = this.jdEpoch + this._delay1(i) + this._delay2(i) + r + 1;
              if (t < 7) {
                for (var l = 7; l <= this.monthsInYear(e); l++) o += this.daysInMonth(e, l);
                for (l = 1; l < t; l++) o += this.daysInMonth(e, l);
              } else for (l = 7; l < t; l++) o += this.daysInMonth(e, l);
              return o;
            },
            _delay1: function (e) {
              var t = Math.floor((235 * e - 234) / 19),
                r = 12084 + 13753 * t,
                n = 29 * t + Math.floor(r / 25920);
              return o(3 * (n + 1), 7) < 3 && n++, n;
            },
            _delay2: function (e) {
              var t = this._delay1(e - 1),
                r = this._delay1(e);
              return this._delay1(e + 1) - r == 356 ? 2 : r - t == 382 ? 1 : 0;
            },
            fromJD: function (e) {
              e = Math.floor(e) + .5;
              for (var t = Math.floor(98496 * (e - this.jdEpoch) / 35975351) - 1; e >= this.toJD(-1 === t ? 1 : t + 1, 7, 1);) t++;
              for (var r = e < this.toJD(t, 1, 1) ? 7 : 1; e > this.toJD(t, r, this.daysInMonth(t, r));) r++;
              var n = e - this.toJD(t, r, 1) + 1;
              return this.newDate(t, r, n);
            }
          }), n.calendars.hebrew = i;
        },
        5512: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "Islamic",
            jdEpoch: 1948439.5,
            daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Islamic",
                epochs: ["BH", "AH"],
                monthNames: ["Muharram", "Safar", "Rabi' al-awwal", "Rabi' al-thani", "Jumada al-awwal", "Jumada al-thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"],
                monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
                dayNames: ["Yawm al-ahad", "Yawm al-ithnayn", "Yawm ath-thulaathaa'", "Yawm al-arbi'aa'", "Yawm al-khamīs", "Yawm al-jum'a", "Yawm as-sabt"],
                dayNamesShort: ["Aha", "Ith", "Thu", "Arb", "Kha", "Jum", "Sab"],
                dayNamesMin: ["Ah", "It", "Th", "Ar", "Kh", "Ju", "Sa"],
                digits: null,
                dateFormat: "yyyy/mm/dd",
                firstDay: 6,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              return (11 * this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year() + 14) % 30 < 11;
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInYear: function (e) {
              return this.leapYear(e) ? 355 : 354;
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
              return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
            },
            weekDay: function (e, t, r) {
              return 5 !== this.dayOfWeek(e, t, r);
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return e = a.year(), t = a.month(), e = e <= 0 ? e + 1 : e, (r = a.day()) + Math.ceil(29.5 * (t - 1)) + 354 * (e - 1) + Math.floor((3 + 11 * e) / 30) + this.jdEpoch - 1;
            },
            fromJD: function (e) {
              e = Math.floor(e) + .5;
              var t = Math.floor((30 * (e - this.jdEpoch) + 10646) / 10631);
              t = t <= 0 ? t - 1 : t;
              var r = Math.min(12, Math.ceil((e - 29 - this.toJD(t, 1, 1)) / 29.5) + 1),
                n = e - this.toJD(t, r, 1) + 1;
              return this.newDate(t, r, n);
            }
          }), n.calendars.islamic = i;
        },
        2645: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "Julian",
            jdEpoch: 1721423.5,
            daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Julian",
                epochs: ["BC", "AD"],
                monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                digits: null,
                dateFormat: "mm/dd/yyyy",
                firstDay: 0,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return (e = t.year() < 0 ? t.year() + 1 : t.year()) % 4 == 0;
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
              return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
            },
            weekDay: function (e, t, r) {
              return (this.dayOfWeek(e, t, r) || 7) < 6;
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return e = a.year(), t = a.month(), r = a.day(), e < 0 && e++, t <= 2 && (e--, t += 12), Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (t + 1)) + r - 1524.5;
            },
            fromJD: function (e) {
              var t = Math.floor(e + .5) + 1524,
                r = Math.floor((t - 122.1) / 365.25),
                n = Math.floor(365.25 * r),
                a = Math.floor((t - n) / 30.6001),
                i = a - Math.floor(a < 14 ? 1 : 13),
                o = r - Math.floor(i > 2 ? 4716 : 4715),
                l = t - n - Math.floor(30.6001 * a);
              return o <= 0 && o--, this.newDate(o, i, l);
            }
          }), n.calendars.julian = i;
        },
        2324: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          function o(e, t) {
            return e - t * Math.floor(e / t);
          }
          function l(e, t) {
            return o(e - 1, t) + 1;
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "Mayan",
            jdEpoch: 584282.5,
            hasYearZero: !0,
            minMonth: 0,
            firstMonth: 0,
            minDay: 0,
            regionalOptions: {
              "": {
                name: "Mayan",
                epochs: ["", ""],
                monthNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
                monthNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
                dayNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
                dayNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
                dayNamesMin: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
                digits: null,
                dateFormat: "YYYY.m.d",
                firstDay: 0,
                isRTL: !1,
                haabMonths: ["Pop", "Uo", "Zip", "Zotz", "Tzec", "Xul", "Yaxkin", "Mol", "Chen", "Yax", "Zac", "Ceh", "Mac", "Kankin", "Muan", "Pax", "Kayab", "Cumku", "Uayeb"],
                tzolkinMonths: ["Imix", "Ik", "Akbal", "Kan", "Chicchan", "Cimi", "Manik", "Lamat", "Muluc", "Oc", "Chuen", "Eb", "Ben", "Ix", "Men", "Cib", "Caban", "Etznab", "Cauac", "Ahau"]
              }
            },
            leapYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), !1;
            },
            formatYear: function (e) {
              e = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year();
              var t = Math.floor(e / 400);
              return e %= 400, e += e < 0 ? 400 : 0, t + "." + Math.floor(e / 20) + "." + e % 20;
            },
            forYear: function (e) {
              if ((e = e.split(".")).length < 3) throw "Invalid Mayan year";
              for (var t = 0, r = 0; r < e.length; r++) {
                var n = parseInt(e[r], 10);
                if (Math.abs(n) > 19 || r > 0 && n < 0) throw "Invalid Mayan year";
                t = 20 * t + n;
              }
              return t;
            },
            monthsInYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 18;
            },
            weekOfYear: function (e, t, r) {
              return this._validate(e, t, r, n.local.invalidDate), 0;
            },
            daysInYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 360;
            },
            daysInMonth: function (e, t) {
              return this._validate(e, t, this.minDay, n.local.invalidMonth), 20;
            },
            daysInWeek: function () {
              return 5;
            },
            dayOfWeek: function (e, t, r) {
              return this._validate(e, t, r, n.local.invalidDate).day();
            },
            weekDay: function (e, t, r) {
              return this._validate(e, t, r, n.local.invalidDate), !0;
            },
            extraInfo: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate).toJD(),
                i = this._toHaab(a),
                o = this._toTzolkin(a);
              return {
                haabMonthName: this.local.haabMonths[i[0] - 1],
                haabMonth: i[0],
                haabDay: i[1],
                tzolkinDayName: this.local.tzolkinMonths[o[0] - 1],
                tzolkinDay: o[0],
                tzolkinTrecena: o[1]
              };
            },
            _toHaab: function (e) {
              var t = o(8 + (e -= this.jdEpoch) + 340, 365);
              return [Math.floor(t / 20) + 1, o(t, 20)];
            },
            _toTzolkin: function (e) {
              return [l(20 + (e -= this.jdEpoch), 20), l(e + 4, 13)];
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return a.day() + 20 * a.month() + 360 * a.year() + this.jdEpoch;
            },
            fromJD: function (e) {
              e = Math.floor(e) + .5 - this.jdEpoch;
              var t = Math.floor(e / 360);
              e %= 360, e += e < 0 ? 360 : 0;
              var r = Math.floor(e / 20),
                n = e % 20;
              return this.newDate(t, r, n);
            }
          }), n.calendars.mayan = i;
        },
        1662: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          i.prototype = new n.baseCalendar();
          var o = n.instance("gregorian");
          a(i.prototype, {
            name: "Nanakshahi",
            jdEpoch: 2257673.5,
            daysPerMonth: [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Nanakshahi",
                epochs: ["BN", "AN"],
                monthNames: ["Chet", "Vaisakh", "Jeth", "Harh", "Sawan", "Bhadon", "Assu", "Katak", "Maghar", "Poh", "Magh", "Phagun"],
                monthNamesShort: ["Che", "Vai", "Jet", "Har", "Saw", "Bha", "Ass", "Kat", "Mgr", "Poh", "Mgh", "Pha"],
                dayNames: ["Somvaar", "Mangalvar", "Budhvaar", "Veervaar", "Shukarvaar", "Sanicharvaar", "Etvaar"],
                dayNamesShort: ["Som", "Mangal", "Budh", "Veer", "Shukar", "Sanichar", "Et"],
                dayNamesMin: ["So", "Ma", "Bu", "Ve", "Sh", "Sa", "Et"],
                digits: null,
                dateFormat: "dd-mm-yyyy",
                firstDay: 0,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear);
              return o.leapYear(t.year() + (t.year() < 1 ? 1 : 0) + 1469);
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(1 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
              return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
            },
            weekDay: function (e, t, r) {
              return (this.dayOfWeek(e, t, r) || 7) < 6;
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidMonth);
              (e = a.year()) < 0 && e++;
              for (var i = a.day(), l = 1; l < a.month(); l++) i += this.daysPerMonth[l - 1];
              return i + o.toJD(e + 1468, 3, 13);
            },
            fromJD: function (e) {
              e = Math.floor(e + .5);
              for (var t = Math.floor((e - (this.jdEpoch - 1)) / 366); e >= this.toJD(t + 1, 1, 1);) t++;
              for (var r = e - Math.floor(this.toJD(t, 1, 1) + .5) + 1, n = 1; r > this.daysInMonth(t, n);) r -= this.daysInMonth(t, n), n++;
              return this.newDate(t, n, r);
            }
          }), n.calendars.nanakshahi = i;
        },
        6445: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "Nepali",
            jdEpoch: 1700709.5,
            daysPerMonth: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            daysPerYear: 365,
            regionalOptions: {
              "": {
                name: "Nepali",
                epochs: ["BBS", "ABS"],
                monthNames: ["Baisakh", "Jestha", "Ashadh", "Shrawan", "Bhadra", "Ashwin", "Kartik", "Mangsir", "Paush", "Mangh", "Falgun", "Chaitra"],
                monthNamesShort: ["Bai", "Je", "As", "Shra", "Bha", "Ash", "Kar", "Mang", "Pau", "Ma", "Fal", "Chai"],
                dayNames: ["Aaitabaar", "Sombaar", "Manglbaar", "Budhabaar", "Bihibaar", "Shukrabaar", "Shanibaar"],
                dayNamesShort: ["Aaita", "Som", "Mangl", "Budha", "Bihi", "Shukra", "Shani"],
                dayNamesMin: ["Aai", "So", "Man", "Bu", "Bi", "Shu", "Sha"],
                digits: null,
                dateFormat: "dd/mm/yyyy",
                firstDay: 1,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              return this.daysInYear(e) !== this.daysPerYear;
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInYear: function (e) {
              if (e = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year(), void 0 === this.NEPALI_CALENDAR_DATA[e]) return this.daysPerYear;
              for (var t = 0, r = this.minMonth; r <= 12; r++) t += this.NEPALI_CALENDAR_DATA[e][r];
              return t;
            },
            daysInMonth: function (e, t) {
              return e.year && (t = e.month(), e = e.year()), this._validate(e, t, this.minDay, n.local.invalidMonth), void 0 === this.NEPALI_CALENDAR_DATA[e] ? this.daysPerMonth[t - 1] : this.NEPALI_CALENDAR_DATA[e][t];
            },
            weekDay: function (e, t, r) {
              return 6 !== this.dayOfWeek(e, t, r);
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              e = a.year(), t = a.month(), r = a.day();
              var i = n.instance(),
                o = 0,
                l = t,
                s = e;
              this._createMissingCalendarData(e);
              var c = e - (l > 9 || 9 === l && r >= this.NEPALI_CALENDAR_DATA[s][0] ? 56 : 57);
              for (9 !== t && (o = r, l--); 9 !== l;) l <= 0 && (l = 12, s--), o += this.NEPALI_CALENDAR_DATA[s][l], l--;
              return 9 === t ? (o += r - this.NEPALI_CALENDAR_DATA[s][0]) < 0 && (o += i.daysInYear(c)) : o += this.NEPALI_CALENDAR_DATA[s][9] - this.NEPALI_CALENDAR_DATA[s][0], i.newDate(c, 1, 1).add(o, "d").toJD();
            },
            fromJD: function (e) {
              var t = n.instance().fromJD(e),
                r = t.year(),
                a = t.dayOfYear(),
                i = r + 56;
              this._createMissingCalendarData(i);
              for (var o = 9, l = this.NEPALI_CALENDAR_DATA[i][0], s = this.NEPALI_CALENDAR_DATA[i][o] - l + 1; a > s;) ++o > 12 && (o = 1, i++), s += this.NEPALI_CALENDAR_DATA[i][o];
              var c = this.NEPALI_CALENDAR_DATA[i][o] - (s - a);
              return this.newDate(i, o, c);
            },
            _createMissingCalendarData: function (e) {
              var t = this.daysPerMonth.slice(0);
              t.unshift(17);
              for (var r = e - 1; r < e + 2; r++) void 0 === this.NEPALI_CALENDAR_DATA[r] && (this.NEPALI_CALENDAR_DATA[r] = t);
            },
            NEPALI_CALENDAR_DATA: {
              1970: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              1971: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
              1972: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
              1973: [19, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              1974: [19, 31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30],
              1975: [18, 31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30],
              1976: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              1977: [18, 31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
              1978: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              1979: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              1980: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              1981: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
              1982: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              1983: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              1984: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              1985: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
              1986: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              1987: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              1988: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              1989: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
              1990: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              1991: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              1992: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              1993: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
              1994: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              1995: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
              1996: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              1997: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              1998: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              1999: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2e3: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              2001: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2002: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2003: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2004: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              2005: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2006: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2007: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2008: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
              2009: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2010: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2011: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2012: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
              2013: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2014: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2015: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2016: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
              2017: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2018: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2019: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              2020: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
              2021: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2022: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
              2023: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              2024: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
              2025: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2026: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2027: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              2028: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2029: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
              2030: [17, 31, 32, 31, 32, 31, 30, 30, 30, 30, 30, 30, 31],
              2031: [17, 31, 32, 31, 32, 31, 31, 31, 31, 31, 31, 31, 31],
              2032: [17, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
              2033: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2034: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2035: [17, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
              2036: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2037: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2038: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2039: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
              2040: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2041: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2042: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2043: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
              2044: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2045: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2046: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2047: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
              2048: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2049: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
              2050: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              2051: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
              2052: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2053: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
              2054: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              2055: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 29, 30],
              2056: [17, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
              2057: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2058: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              2059: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2060: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2061: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2062: [17, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
              2063: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2064: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2065: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2066: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
              2067: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2068: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2069: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2070: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
              2071: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2072: [17, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2073: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
              2074: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
              2075: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2076: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
              2077: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
              2078: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
              2079: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
              2080: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
              2081: [17, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
              2082: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
              2083: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
              2084: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
              2085: [17, 31, 32, 31, 32, 31, 31, 30, 30, 29, 30, 30, 30],
              2086: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
              2087: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
              2088: [16, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
              2089: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
              2090: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
              2091: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
              2092: [16, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
              2093: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
              2094: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
              2095: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30],
              2096: [17, 30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
              2097: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
              2098: [17, 31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 30, 31],
              2099: [17, 31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30],
              2100: [17, 31, 32, 31, 32, 30, 31, 30, 29, 30, 29, 30, 30]
            }
          }), n.calendars.nepali = i;
        },
        506: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          function o(e, t) {
            return e - t * Math.floor(e / t);
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "Persian",
            jdEpoch: 1948320.5,
            daysPerMonth: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Persian",
                epochs: ["BP", "AP"],
                monthNames: ["Farvardin", "Ordibehesht", "Khordad", "Tir", "Mordad", "Shahrivar", "Mehr", "Aban", "Azar", "Day", "Bahman", "Esfand"],
                monthNamesShort: ["Far", "Ord", "Kho", "Tir", "Mor", "Sha", "Meh", "Aba", "Aza", "Day", "Bah", "Esf"],
                dayNames: ["Yekshambe", "Doshambe", "Seshambe", "Chæharshambe", "Panjshambe", "Jom'e", "Shambe"],
                dayNamesShort: ["Yek", "Do", "Se", "Chæ", "Panj", "Jom", "Sha"],
                dayNamesMin: ["Ye", "Do", "Se", "Ch", "Pa", "Jo", "Sh"],
                digits: null,
                dateFormat: "yyyy/mm/dd",
                firstDay: 6,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return 682 * ((t.year() - (t.year() > 0 ? 474 : 473)) % 2820 + 474 + 38) % 2816 < 682;
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(-(n.dayOfWeek() + 1) % 7, "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
              return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
            },
            weekDay: function (e, t, r) {
              return 5 !== this.dayOfWeek(e, t, r);
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              e = a.year(), t = a.month(), r = a.day();
              var i = e - (e >= 0 ? 474 : 473),
                l = 474 + o(i, 2820);
              return r + (t <= 7 ? 31 * (t - 1) : 30 * (t - 1) + 6) + Math.floor((682 * l - 110) / 2816) + 365 * (l - 1) + 1029983 * Math.floor(i / 2820) + this.jdEpoch - 1;
            },
            fromJD: function (e) {
              var t = (e = Math.floor(e) + .5) - this.toJD(475, 1, 1),
                r = Math.floor(t / 1029983),
                n = o(t, 1029983),
                a = 2820;
              if (1029982 !== n) {
                var i = Math.floor(n / 366),
                  l = o(n, 366);
                a = Math.floor((2134 * i + 2816 * l + 2815) / 1028522) + i + 1;
              }
              var s = a + 2820 * r + 474;
              s = s <= 0 ? s - 1 : s;
              var c = e - this.toJD(s, 1, 1) + 1,
                u = c <= 186 ? Math.ceil(c / 31) : Math.ceil((c - 6) / 30),
                f = e - this.toJD(s, u, 1) + 1;
              return this.newDate(s, u, f);
            }
          }), n.calendars.persian = i, n.calendars.jalali = i;
        },
        4756: function (e, t, r) {
          var n = r(6834),
            a = r(7976),
            i = n.instance();
          function o(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          o.prototype = new n.baseCalendar(), a(o.prototype, {
            name: "Taiwan",
            jdEpoch: 2419402.5,
            yearsOffset: 1911,
            daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Taiwan",
                epochs: ["BROC", "ROC"],
                monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                digits: null,
                dateFormat: "yyyy/mm/dd",
                firstDay: 1,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return e = this._t2gYear(t.year()), i.leapYear(e);
            },
            weekOfYear: function (e, t, r) {
              var a = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return e = this._t2gYear(a.year()), i.weekOfYear(e, a.month(), a.day());
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
              return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
            },
            weekDay: function (e, t, r) {
              return (this.dayOfWeek(e, t, r) || 7) < 6;
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return e = this._t2gYear(a.year()), i.toJD(e, a.month(), a.day());
            },
            fromJD: function (e) {
              var t = i.fromJD(e),
                r = this._g2tYear(t.year());
              return this.newDate(r, t.month(), t.day());
            },
            _t2gYear: function (e) {
              return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
            },
            _g2tYear: function (e) {
              return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
            }
          }), n.calendars.taiwan = o;
        },
        1858: function (e, t, r) {
          var n = r(6834),
            a = r(7976),
            i = n.instance();
          function o(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          o.prototype = new n.baseCalendar(), a(o.prototype, {
            name: "Thai",
            jdEpoch: 1523098.5,
            yearsOffset: 543,
            daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Thai",
                epochs: ["BBE", "BE"],
                monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                digits: null,
                dateFormat: "dd/mm/yyyy",
                firstDay: 0,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return e = this._t2gYear(t.year()), i.leapYear(e);
            },
            weekOfYear: function (e, t, r) {
              var a = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return e = this._t2gYear(a.year()), i.weekOfYear(e, a.month(), a.day());
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
              return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
            },
            weekDay: function (e, t, r) {
              return (this.dayOfWeek(e, t, r) || 7) < 6;
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate);
              return e = this._t2gYear(a.year()), i.toJD(e, a.month(), a.day());
            },
            fromJD: function (e) {
              var t = i.fromJD(e),
                r = this._g2tYear(t.year());
              return this.newDate(r, t.month(), t.day());
            },
            _t2gYear: function (e) {
              return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
            },
            _g2tYear: function (e) {
              return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
            }
          }), n.calendars.thai = o;
        },
        7985: function (e, t, r) {
          var n = r(6834),
            a = r(7976);
          function i(e) {
            this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
          }
          i.prototype = new n.baseCalendar(), a(i.prototype, {
            name: "UmmAlQura",
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Umm al-Qura",
                epochs: ["BH", "AH"],
                monthNames: ["Al-Muharram", "Safar", "Rabi' al-awwal", "Rabi' Al-Thani", "Jumada Al-Awwal", "Jumada Al-Thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"],
                monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
                dayNames: ["Yawm al-Ahad", "Yawm al-Ithnain", "Yawm al-Thalāthā’", "Yawm al-Arba‘ā’", "Yawm al-Khamīs", "Yawm al-Jum‘a", "Yawm al-Sabt"],
                dayNamesMin: ["Ah", "Ith", "Th", "Ar", "Kh", "Ju", "Sa"],
                digits: null,
                dateFormat: "yyyy/mm/dd",
                firstDay: 6,
                isRTL: !0
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
              return 355 === this.daysInYear(t.year());
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInYear: function (e) {
              for (var t = 0, r = 1; r <= 12; r++) t += this.daysInMonth(e, r);
              return t;
            },
            daysInMonth: function (e, t) {
              for (var r = this._validate(e, t, this.minDay, n.local.invalidMonth).toJD() - 24e5 + .5, a = 0, i = 0; i < o.length; i++) {
                if (o[i] > r) return o[a] - o[a - 1];
                a++;
              }
              return 30;
            },
            weekDay: function (e, t, r) {
              return 5 !== this.dayOfWeek(e, t, r);
            },
            toJD: function (e, t, r) {
              var a = this._validate(e, t, r, n.local.invalidDate),
                i = 12 * (a.year() - 1) + a.month() - 15292;
              return a.day() + o[i - 1] - 1 + 24e5 - .5;
            },
            fromJD: function (e) {
              for (var t = e - 24e5 + .5, r = 0, n = 0; n < o.length && !(o[n] > t); n++) r++;
              var a = r + 15292,
                i = Math.floor((a - 1) / 12),
                l = i + 1,
                s = a - 12 * i,
                c = t - o[r - 1] + 1;
              return this.newDate(l, s, c);
            },
            isValid: function (e, t, r) {
              var a = n.baseCalendar.prototype.isValid.apply(this, arguments);
              return a && (a = (e = null != e.year ? e.year : e) >= 1276 && e <= 1500), a;
            },
            _validate: function (e, t, r, a) {
              var i = n.baseCalendar.prototype._validate.apply(this, arguments);
              if (i.year < 1276 || i.year > 1500) throw a.replace(/\{0\}/, this.local.name);
              return i;
            }
          }), n.calendars.ummalqura = i;
          var o = [20, 50, 79, 109, 138, 168, 197, 227, 256, 286, 315, 345, 374, 404, 433, 463, 492, 522, 551, 581, 611, 641, 670, 700, 729, 759, 788, 818, 847, 877, 906, 936, 965, 995, 1024, 1054, 1083, 1113, 1142, 1172, 1201, 1231, 1260, 1290, 1320, 1350, 1379, 1409, 1438, 1468, 1497, 1527, 1556, 1586, 1615, 1645, 1674, 1704, 1733, 1763, 1792, 1822, 1851, 1881, 1910, 1940, 1969, 1999, 2028, 2058, 2087, 2117, 2146, 2176, 2205, 2235, 2264, 2294, 2323, 2353, 2383, 2413, 2442, 2472, 2501, 2531, 2560, 2590, 2619, 2649, 2678, 2708, 2737, 2767, 2796, 2826, 2855, 2885, 2914, 2944, 2973, 3003, 3032, 3062, 3091, 3121, 3150, 3180, 3209, 3239, 3268, 3298, 3327, 3357, 3386, 3416, 3446, 3476, 3505, 3535, 3564, 3594, 3623, 3653, 3682, 3712, 3741, 3771, 3800, 3830, 3859, 3889, 3918, 3948, 3977, 4007, 4036, 4066, 4095, 4125, 4155, 4185, 4214, 4244, 4273, 4303, 4332, 4362, 4391, 4421, 4450, 4480, 4509, 4539, 4568, 4598, 4627, 4657, 4686, 4716, 4745, 4775, 4804, 4834, 4863, 4893, 4922, 4952, 4981, 5011, 5040, 5070, 5099, 5129, 5158, 5188, 5218, 5248, 5277, 5307, 5336, 5366, 5395, 5425, 5454, 5484, 5513, 5543, 5572, 5602, 5631, 5661, 5690, 5720, 5749, 5779, 5808, 5838, 5867, 5897, 5926, 5956, 5985, 6015, 6044, 6074, 6103, 6133, 6162, 6192, 6221, 6251, 6281, 6311, 6340, 6370, 6399, 6429, 6458, 6488, 6517, 6547, 6576, 6606, 6635, 6665, 6694, 6724, 6753, 6783, 6812, 6842, 6871, 6901, 6930, 6960, 6989, 7019, 7048, 7078, 7107, 7137, 7166, 7196, 7225, 7255, 7284, 7314, 7344, 7374, 7403, 7433, 7462, 7492, 7521, 7551, 7580, 7610, 7639, 7669, 7698, 7728, 7757, 7787, 7816, 7846, 7875, 7905, 7934, 7964, 7993, 8023, 8053, 8083, 8112, 8142, 8171, 8201, 8230, 8260, 8289, 8319, 8348, 8378, 8407, 8437, 8466, 8496, 8525, 8555, 8584, 8614, 8643, 8673, 8702, 8732, 8761, 8791, 8821, 8850, 8880, 8909, 8938, 8968, 8997, 9027, 9056, 9086, 9115, 9145, 9175, 9205, 9234, 9264, 9293, 9322, 9352, 9381, 9410, 9440, 9470, 9499, 9529, 9559, 9589, 9618, 9648, 9677, 9706, 9736, 9765, 9794, 9824, 9853, 9883, 9913, 9943, 9972, 10002, 10032, 10061, 10090, 10120, 10149, 10178, 10208, 10237, 10267, 10297, 10326, 10356, 10386, 10415, 10445, 10474, 10504, 10533, 10562, 10592, 10621, 10651, 10680, 10710, 10740, 10770, 10799, 10829, 10858, 10888, 10917, 10947, 10976, 11005, 11035, 11064, 11094, 11124, 11153, 11183, 11213, 11242, 11272, 11301, 11331, 11360, 11389, 11419, 11448, 11478, 11507, 11537, 11567, 11596, 11626, 11655, 11685, 11715, 11744, 11774, 11803, 11832, 11862, 11891, 11921, 11950, 11980, 12010, 12039, 12069, 12099, 12128, 12158, 12187, 12216, 12246, 12275, 12304, 12334, 12364, 12393, 12423, 12453, 12483, 12512, 12542, 12571, 12600, 12630, 12659, 12688, 12718, 12747, 12777, 12807, 12837, 12866, 12896, 12926, 12955, 12984, 13014, 13043, 13072, 13102, 13131, 13161, 13191, 13220, 13250, 13280, 13310, 13339, 13368, 13398, 13427, 13456, 13486, 13515, 13545, 13574, 13604, 13634, 13664, 13693, 13723, 13752, 13782, 13811, 13840, 13870, 13899, 13929, 13958, 13988, 14018, 14047, 14077, 14107, 14136, 14166, 14195, 14224, 14254, 14283, 14313, 14342, 14372, 14401, 14431, 14461, 14490, 14520, 14550, 14579, 14609, 14638, 14667, 14697, 14726, 14756, 14785, 14815, 14844, 14874, 14904, 14933, 14963, 14993, 15021, 15051, 15081, 15110, 15140, 15169, 15199, 15228, 15258, 15287, 15317, 15347, 15377, 15406, 15436, 15465, 15494, 15524, 15553, 15582, 15612, 15641, 15671, 15701, 15731, 15760, 15790, 15820, 15849, 15878, 15908, 15937, 15966, 15996, 16025, 16055, 16085, 16114, 16144, 16174, 16204, 16233, 16262, 16292, 16321, 16350, 16380, 16409, 16439, 16468, 16498, 16528, 16558, 16587, 16617, 16646, 16676, 16705, 16734, 16764, 16793, 16823, 16852, 16882, 16912, 16941, 16971, 17001, 17030, 17060, 17089, 17118, 17148, 17177, 17207, 17236, 17266, 17295, 17325, 17355, 17384, 17414, 17444, 17473, 17502, 17532, 17561, 17591, 17620, 17650, 17679, 17709, 17738, 17768, 17798, 17827, 17857, 17886, 17916, 17945, 17975, 18004, 18034, 18063, 18093, 18122, 18152, 18181, 18211, 18241, 18270, 18300, 18330, 18359, 18388, 18418, 18447, 18476, 18506, 18535, 18565, 18595, 18625, 18654, 18684, 18714, 18743, 18772, 18802, 18831, 18860, 18890, 18919, 18949, 18979, 19008, 19038, 19068, 19098, 19127, 19156, 19186, 19215, 19244, 19274, 19303, 19333, 19362, 19392, 19422, 19452, 19481, 19511, 19540, 19570, 19599, 19628, 19658, 19687, 19717, 19746, 19776, 19806, 19836, 19865, 19895, 19924, 19954, 19983, 20012, 20042, 20071, 20101, 20130, 20160, 20190, 20219, 20249, 20279, 20308, 20338, 20367, 20396, 20426, 20455, 20485, 20514, 20544, 20573, 20603, 20633, 20662, 20692, 20721, 20751, 20780, 20810, 20839, 20869, 20898, 20928, 20957, 20987, 21016, 21046, 21076, 21105, 21135, 21164, 21194, 21223, 21253, 21282, 21312, 21341, 21371, 21400, 21430, 21459, 21489, 21519, 21548, 21578, 21607, 21637, 21666, 21696, 21725, 21754, 21784, 21813, 21843, 21873, 21902, 21932, 21962, 21991, 22021, 22050, 22080, 22109, 22138, 22168, 22197, 22227, 22256, 22286, 22316, 22346, 22375, 22405, 22434, 22464, 22493, 22522, 22552, 22581, 22611, 22640, 22670, 22700, 22730, 22759, 22789, 22818, 22848, 22877, 22906, 22936, 22965, 22994, 23024, 23054, 23083, 23113, 23143, 23173, 23202, 23232, 23261, 23290, 23320, 23349, 23379, 23408, 23438, 23467, 23497, 23527, 23556, 23586, 23616, 23645, 23674, 23704, 23733, 23763, 23792, 23822, 23851, 23881, 23910, 23940, 23970, 23999, 24029, 24058, 24088, 24117, 24147, 24176, 24206, 24235, 24265, 24294, 24324, 24353, 24383, 24413, 24442, 24472, 24501, 24531, 24560, 24590, 24619, 24648, 24678, 24707, 24737, 24767, 24796, 24826, 24856, 24885, 24915, 24944, 24974, 25003, 25032, 25062, 25091, 25121, 25150, 25180, 25210, 25240, 25269, 25299, 25328, 25358, 25387, 25416, 25446, 25475, 25505, 25534, 25564, 25594, 25624, 25653, 25683, 25712, 25742, 25771, 25800, 25830, 25859, 25888, 25918, 25948, 25977, 26007, 26037, 26067, 26096, 26126, 26155, 26184, 26214, 26243, 26272, 26302, 26332, 26361, 26391, 26421, 26451, 26480, 26510, 26539, 26568, 26598, 26627, 26656, 26686, 26715, 26745, 26775, 26805, 26834, 26864, 26893, 26923, 26952, 26982, 27011, 27041, 27070, 27099, 27129, 27159, 27188, 27218, 27248, 27277, 27307, 27336, 27366, 27395, 27425, 27454, 27484, 27513, 27542, 27572, 27602, 27631, 27661, 27691, 27720, 27750, 27779, 27809, 27838, 27868, 27897, 27926, 27956, 27985, 28015, 28045, 28074, 28104, 28134, 28163, 28193, 28222, 28252, 28281, 28310, 28340, 28369, 28399, 28428, 28458, 28488, 28517, 28547, 28577, 28607, 28636, 28665, 28695, 28724, 28754, 28783, 28813, 28843, 28872, 28901, 28931, 28960, 28990, 29019, 29049, 29078, 29108, 29137, 29167, 29196, 29226, 29255, 29285, 29315, 29345, 29375, 29404, 29434, 29463, 29492, 29522, 29551, 29580, 29610, 29640, 29669, 29699, 29729, 29759, 29788, 29818, 29847, 29876, 29906, 29935, 29964, 29994, 30023, 30053, 30082, 30112, 30141, 30171, 30200, 30230, 30259, 30289, 30318, 30348, 30378, 30408, 30437, 30467, 30496, 30526, 30555, 30585, 30614, 30644, 30673, 30703, 30732, 30762, 30791, 30821, 30850, 30880, 30909, 30939, 30968, 30998, 31027, 31057, 31086, 31116, 31145, 31175, 31204, 31234, 31263, 31293, 31322, 31352, 31381, 31411, 31441, 31471, 31500, 31530, 31559, 31589, 31618, 31648, 31676, 31706, 31736, 31766, 31795, 31825, 31854, 31884, 31913, 31943, 31972, 32002, 32031, 32061, 32090, 32120, 32150, 32180, 32209, 32239, 32268, 32298, 32327, 32357, 32386, 32416, 32445, 32475, 32504, 32534, 32563, 32593, 32622, 32652, 32681, 32711, 32740, 32770, 32799, 32829, 32858, 32888, 32917, 32947, 32976, 33006, 33035, 33065, 33094, 33124, 33153, 33183, 33213, 33243, 33272, 33302, 33331, 33361, 33390, 33420, 33450, 33479, 33509, 33539, 33568, 33598, 33627, 33657, 33686, 33716, 33745, 33775, 33804, 33834, 33863, 33893, 33922, 33952, 33981, 34011, 34040, 34069, 34099, 34128, 34158, 34187, 34217, 34247, 34277, 34306, 34336, 34365, 34395, 34424, 34454, 34483, 34512, 34542, 34571, 34601, 34631, 34660, 34690, 34719, 34749, 34778, 34808, 34837, 34867, 34896, 34926, 34955, 34985, 35015, 35044, 35074, 35103, 35133, 35162, 35192, 35222, 35251, 35280, 35310, 35340, 35370, 35399, 35429, 35458, 35488, 35517, 35547, 35576, 35605, 35635, 35665, 35694, 35723, 35753, 35782, 35811, 35841, 35871, 35901, 35930, 35960, 35989, 36019, 36048, 36078, 36107, 36136, 36166, 36195, 36225, 36254, 36284, 36314, 36343, 36373, 36403, 36433, 36462, 36492, 36521, 36551, 36580, 36610, 36639, 36669, 36698, 36728, 36757, 36786, 36816, 36845, 36875, 36904, 36934, 36963, 36993, 37022, 37052, 37081, 37111, 37141, 37170, 37200, 37229, 37259, 37288, 37318, 37347, 37377, 37406, 37436, 37465, 37495, 37524, 37554, 37584, 37613, 37643, 37672, 37701, 37731, 37760, 37790, 37819, 37849, 37878, 37908, 37938, 37967, 37997, 38027, 38056, 38085, 38115, 38144, 38174, 38203, 38233, 38262, 38292, 38322, 38351, 38381, 38410, 38440, 38469, 38499, 38528, 38558, 38587, 38617, 38646, 38676, 38705, 38735, 38764, 38794, 38823, 38853, 38882, 38912, 38941, 38971, 39001, 39030, 39059, 39089, 39118, 39148, 39178, 39208, 39237, 39267, 39297, 39326, 39355, 39385, 39414, 39444, 39473, 39503, 39532, 39562, 39592, 39621, 39650, 39680, 39709, 39739, 39768, 39798, 39827, 39857, 39886, 39916, 39946, 39975, 40005, 40035, 40064, 40094, 40123, 40153, 40182, 40212, 40241, 40271, 40300, 40330, 40359, 40389, 40418, 40448, 40477, 40507, 40536, 40566, 40595, 40625, 40655, 40685, 40714, 40744, 40773, 40803, 40832, 40862, 40892, 40921, 40951, 40980, 41009, 41039, 41068, 41098, 41127, 41157, 41186, 41216, 41245, 41275, 41304, 41334, 41364, 41393, 41422, 41452, 41481, 41511, 41540, 41570, 41599, 41629, 41658, 41688, 41718, 41748, 41777, 41807, 41836, 41865, 41894, 41924, 41953, 41983, 42012, 42042, 42072, 42102, 42131, 42161, 42190, 42220, 42249, 42279, 42308, 42337, 42367, 42397, 42426, 42456, 42485, 42515, 42545, 42574, 42604, 42633, 42662, 42692, 42721, 42751, 42780, 42810, 42839, 42869, 42899, 42929, 42958, 42988, 43017, 43046, 43076, 43105, 43135, 43164, 43194, 43223, 43253, 43283, 43312, 43342, 43371, 43401, 43430, 43460, 43489, 43519, 43548, 43578, 43607, 43637, 43666, 43696, 43726, 43755, 43785, 43814, 43844, 43873, 43903, 43932, 43962, 43991, 44021, 44050, 44080, 44109, 44139, 44169, 44198, 44228, 44258, 44287, 44317, 44346, 44375, 44405, 44434, 44464, 44493, 44523, 44553, 44582, 44612, 44641, 44671, 44700, 44730, 44759, 44788, 44818, 44847, 44877, 44906, 44936, 44966, 44996, 45025, 45055, 45084, 45114, 45143, 45172, 45202, 45231, 45261, 45290, 45320, 45350, 45380, 45409, 45439, 45468, 45498, 45527, 45556, 45586, 45615, 45644, 45674, 45704, 45733, 45763, 45793, 45823, 45852, 45882, 45911, 45940, 45970, 45999, 46028, 46058, 46088, 46117, 46147, 46177, 46206, 46236, 46265, 46295, 46324, 46354, 46383, 46413, 46442, 46472, 46501, 46531, 46560, 46590, 46620, 46649, 46679, 46708, 46738, 46767, 46797, 46826, 46856, 46885, 46915, 46944, 46974, 47003, 47033, 47063, 47092, 47122, 47151, 47181, 47210, 47240, 47269, 47298, 47328, 47357, 47387, 47417, 47446, 47476, 47506, 47535, 47565, 47594, 47624, 47653, 47682, 47712, 47741, 47771, 47800, 47830, 47860, 47890, 47919, 47949, 47978, 48008, 48037, 48066, 48096, 48125, 48155, 48184, 48214, 48244, 48273, 48303, 48333, 48362, 48392, 48421, 48450, 48480, 48509, 48538, 48568, 48598, 48627, 48657, 48687, 48717, 48746, 48776, 48805, 48834, 48864, 48893, 48922, 48952, 48982, 49011, 49041, 49071, 49100, 49130, 49160, 49189, 49218, 49248, 49277, 49306, 49336, 49365, 49395, 49425, 49455, 49484, 49514, 49543, 49573, 49602, 49632, 49661, 49690, 49720, 49749, 49779, 49809, 49838, 49868, 49898, 49927, 49957, 49986, 50016, 50045, 50075, 50104, 50133, 50163, 50192, 50222, 50252, 50281, 50311, 50340, 50370, 50400, 50429, 50459, 50488, 50518, 50547, 50576, 50606, 50635, 50665, 50694, 50724, 50754, 50784, 50813, 50843, 50872, 50902, 50931, 50960, 50990, 51019, 51049, 51078, 51108, 51138, 51167, 51197, 51227, 51256, 51286, 51315, 51345, 51374, 51403, 51433, 51462, 51492, 51522, 51552, 51582, 51611, 51641, 51670, 51699, 51729, 51758, 51787, 51816, 51846, 51876, 51906, 51936, 51965, 51995, 52025, 52054, 52083, 52113, 52142, 52171, 52200, 52230, 52260, 52290, 52319, 52349, 52379, 52408, 52438, 52467, 52497, 52526, 52555, 52585, 52614, 52644, 52673, 52703, 52733, 52762, 52792, 52822, 52851, 52881, 52910, 52939, 52969, 52998, 53028, 53057, 53087, 53116, 53146, 53176, 53205, 53235, 53264, 53294, 53324, 53353, 53383, 53412, 53441, 53471, 53500, 53530, 53559, 53589, 53619, 53648, 53678, 53708, 53737, 53767, 53796, 53825, 53855, 53884, 53913, 53943, 53973, 54003, 54032, 54062, 54092, 54121, 54151, 54180, 54209, 54239, 54268, 54297, 54327, 54357, 54387, 54416, 54446, 54476, 54505, 54535, 54564, 54593, 54623, 54652, 54681, 54711, 54741, 54770, 54800, 54830, 54859, 54889, 54919, 54948, 54977, 55007, 55036, 55066, 55095, 55125, 55154, 55184, 55213, 55243, 55273, 55302, 55332, 55361, 55391, 55420, 55450, 55479, 55508, 55538, 55567, 55597, 55627, 55657, 55686, 55716, 55745, 55775, 55804, 55834, 55863, 55892, 55922, 55951, 55981, 56011, 56040, 56070, 56100, 56129, 56159, 56188, 56218, 56247, 56276, 56306, 56335, 56365, 56394, 56424, 56454, 56483, 56513, 56543, 56572, 56601, 56631, 56660, 56690, 56719, 56749, 56778, 56808, 56837, 56867, 56897, 56926, 56956, 56985, 57015, 57044, 57074, 57103, 57133, 57162, 57192, 57221, 57251, 57280, 57310, 57340, 57369, 57399, 57429, 57458, 57487, 57517, 57546, 57576, 57605, 57634, 57664, 57694, 57723, 57753, 57783, 57813, 57842, 57871, 57901, 57930, 57959, 57989, 58018, 58048, 58077, 58107, 58137, 58167, 58196, 58226, 58255, 58285, 58314, 58343, 58373, 58402, 58432, 58461, 58491, 58521, 58551, 58580, 58610, 58639, 58669, 58698, 58727, 58757, 58786, 58816, 58845, 58875, 58905, 58934, 58964, 58994, 59023, 59053, 59082, 59111, 59141, 59170, 59200, 59229, 59259, 59288, 59318, 59348, 59377, 59407, 59436, 59466, 59495, 59525, 59554, 59584, 59613, 59643, 59672, 59702, 59731, 59761, 59791, 59820, 59850, 59879, 59909, 59939, 59968, 59997, 60027, 60056, 60086, 60115, 60145, 60174, 60204, 60234, 60264, 60293, 60323, 60352, 60381, 60411, 60440, 60469, 60499, 60528, 60558, 60588, 60618, 60648, 60677, 60707, 60736, 60765, 60795, 60824, 60853, 60883, 60912, 60942, 60972, 61002, 61031, 61061, 61090, 61120, 61149, 61179, 61208, 61237, 61267, 61296, 61326, 61356, 61385, 61415, 61445, 61474, 61504, 61533, 61563, 61592, 61621, 61651, 61680, 61710, 61739, 61769, 61799, 61828, 61858, 61888, 61917, 61947, 61976, 62006, 62035, 62064, 62094, 62123, 62153, 62182, 62212, 62242, 62271, 62301, 62331, 62360, 62390, 62419, 62448, 62478, 62507, 62537, 62566, 62596, 62625, 62655, 62685, 62715, 62744, 62774, 62803, 62832, 62862, 62891, 62921, 62950, 62980, 63009, 63039, 63069, 63099, 63128, 63157, 63187, 63216, 63246, 63275, 63305, 63334, 63363, 63393, 63423, 63453, 63482, 63512, 63541, 63571, 63600, 63630, 63659, 63689, 63718, 63747, 63777, 63807, 63836, 63866, 63895, 63925, 63955, 63984, 64014, 64043, 64073, 64102, 64131, 64161, 64190, 64220, 64249, 64279, 64309, 64339, 64368, 64398, 64427, 64457, 64486, 64515, 64545, 64574, 64603, 64633, 64663, 64692, 64722, 64752, 64782, 64811, 64841, 64870, 64899, 64929, 64958, 64987, 65017, 65047, 65076, 65106, 65136, 65166, 65195, 65225, 65254, 65283, 65313, 65342, 65371, 65401, 65431, 65460, 65490, 65520, 65549, 65579, 65608, 65638, 65667, 65697, 65726, 65755, 65785, 65815, 65844, 65874, 65903, 65933, 65963, 65992, 66022, 66051, 66081, 66110, 66140, 66169, 66199, 66228, 66258, 66287, 66317, 66346, 66376, 66405, 66435, 66465, 66494, 66524, 66553, 66583, 66612, 66641, 66671, 66700, 66730, 66760, 66789, 66819, 66849, 66878, 66908, 66937, 66967, 66996, 67025, 67055, 67084, 67114, 67143, 67173, 67203, 67233, 67262, 67292, 67321, 67351, 67380, 67409, 67439, 67468, 67497, 67527, 67557, 67587, 67617, 67646, 67676, 67705, 67735, 67764, 67793, 67823, 67852, 67882, 67911, 67941, 67971, 68e3, 68030, 68060, 68089, 68119, 68148, 68177, 68207, 68236, 68266, 68295, 68325, 68354, 68384, 68414, 68443, 68473, 68502, 68532, 68561, 68591, 68620, 68650, 68679, 68708, 68738, 68768, 68797, 68827, 68857, 68886, 68916, 68946, 68975, 69004, 69034, 69063, 69092, 69122, 69152, 69181, 69211, 69240, 69270, 69300, 69330, 69359, 69388, 69418, 69447, 69476, 69506, 69535, 69565, 69595, 69624, 69654, 69684, 69713, 69743, 69772, 69802, 69831, 69861, 69890, 69919, 69949, 69978, 70008, 70038, 70067, 70097, 70126, 70156, 70186, 70215, 70245, 70274, 70303, 70333, 70362, 70392, 70421, 70451, 70481, 70510, 70540, 70570, 70599, 70629, 70658, 70687, 70717, 70746, 70776, 70805, 70835, 70864, 70894, 70924, 70954, 70983, 71013, 71042, 71071, 71101, 71130, 71159, 71189, 71218, 71248, 71278, 71308, 71337, 71367, 71397, 71426, 71455, 71485, 71514, 71543, 71573, 71602, 71632, 71662, 71691, 71721, 71751, 71781, 71810, 71839, 71869, 71898, 71927, 71957, 71986, 72016, 72046, 72075, 72105, 72135, 72164, 72194, 72223, 72253, 72282, 72311, 72341, 72370, 72400, 72429, 72459, 72489, 72518, 72548, 72577, 72607, 72637, 72666, 72695, 72725, 72754, 72784, 72813, 72843, 72872, 72902, 72931, 72961, 72991, 73020, 73050, 73080, 73109, 73139, 73168, 73197, 73227, 73256, 73286, 73315, 73345, 73375, 73404, 73434, 73464, 73493, 73523, 73552, 73581, 73611, 73640, 73669, 73699, 73729, 73758, 73788, 73818, 73848, 73877, 73907, 73936, 73965, 73995, 74024, 74053, 74083, 74113, 74142, 74172, 74202, 74231, 74261, 74291, 74320, 74349, 74379, 74408, 74437, 74467, 74497, 74526, 74556, 74586, 74615, 74645, 74675, 74704, 74733, 74763, 74792, 74822, 74851, 74881, 74910, 74940, 74969, 74999, 75029, 75058, 75088, 75117, 75147, 75176, 75206, 75235, 75264, 75294, 75323, 75353, 75383, 75412, 75442, 75472, 75501, 75531, 75560, 75590, 75619, 75648, 75678, 75707, 75737, 75766, 75796, 75826, 75856, 75885, 75915, 75944, 75974, 76003, 76032, 76062, 76091, 76121, 76150, 76180, 76210, 76239, 76269, 76299, 76328, 76358, 76387, 76416, 76446, 76475, 76505, 76534, 76564, 76593, 76623, 76653, 76682, 76712, 76741, 76771, 76801, 76830, 76859, 76889, 76918, 76948, 76977, 77007, 77036, 77066, 77096, 77125, 77155, 77185, 77214, 77243, 77273, 77302, 77332, 77361, 77390, 77420, 77450, 77479, 77509, 77539, 77569, 77598, 77627, 77657, 77686, 77715, 77745, 77774, 77804, 77833, 77863, 77893, 77923, 77952, 77982, 78011, 78041, 78070, 78099, 78129, 78158, 78188, 78217, 78247, 78277, 78307, 78336, 78366, 78395, 78425, 78454, 78483, 78513, 78542, 78572, 78601, 78631, 78661, 78690, 78720, 78750, 78779, 78808, 78838, 78867, 78897, 78926, 78956, 78985, 79015, 79044, 79074, 79104, 79133, 79163, 79192, 79222, 79251, 79281, 79310, 79340, 79369, 79399, 79428, 79458, 79487, 79517, 79546, 79576, 79606, 79635, 79665, 79695, 79724, 79753, 79783, 79812, 79841, 79871, 79900, 79930, 79960, 79990];
        },
        6834: function (e, t, r) {
          var n = r(7976);
          function a() {
            this.regionalOptions = [], this.regionalOptions[""] = {
              invalidCalendar: "Calendar {0} not found",
              invalidDate: "Invalid {0} date",
              invalidMonth: "Invalid {0} month",
              invalidYear: "Invalid {0} year",
              differentCalendars: "Cannot mix {0} and {1} dates"
            }, this.local = this.regionalOptions[""], this.calendars = {}, this._localCals = {};
          }
          function i(e, t, r, n) {
            if (this._calendar = e, this._year = t, this._month = r, this._day = n, 0 === this._calendar._validateLevel && !this._calendar.isValid(this._year, this._month, this._day)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
          }
          function o(e, t) {
            return "000000".substring(0, t - (e = "" + e).length) + e;
          }
          function l() {
            this.shortYearCutoff = "+10";
          }
          function s(e) {
            this.local = this.regionalOptions[e] || this.regionalOptions[""];
          }
          n(a.prototype, {
            instance: function (e, t) {
              e = (e || "gregorian").toLowerCase(), t = t || "";
              var r = this._localCals[e + "-" + t];
              if (!r && this.calendars[e] && (r = new this.calendars[e](t), this._localCals[e + "-" + t] = r), !r) throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, e);
              return r;
            },
            newDate: function (e, t, r, n, a) {
              return (n = (null != e && e.year ? e.calendar() : "string" == typeof n ? this.instance(n, a) : n) || this.instance()).newDate(e, t, r);
            },
            substituteDigits: function (e) {
              return function (t) {
                return (t + "").replace(/[0-9]/g, function (t) {
                  return e[t];
                });
              };
            },
            substituteChineseDigits: function (e, t) {
              return function (r) {
                for (var n = "", a = 0; r > 0;) {
                  var i = r % 10;
                  n = (0 === i ? "" : e[i] + t[a]) + n, a++, r = Math.floor(r / 10);
                }
                return 0 === n.indexOf(e[1] + t[1]) && (n = n.substr(1)), n || e[0];
              };
            }
          }), n(i.prototype, {
            newDate: function (e, t, r) {
              return this._calendar.newDate(null == e ? this : e, t, r);
            },
            year: function (e) {
              return 0 === arguments.length ? this._year : this.set(e, "y");
            },
            month: function (e) {
              return 0 === arguments.length ? this._month : this.set(e, "m");
            },
            day: function (e) {
              return 0 === arguments.length ? this._day : this.set(e, "d");
            },
            date: function (e, t, r) {
              if (!this._calendar.isValid(e, t, r)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
              return this._year = e, this._month = t, this._day = r, this;
            },
            leapYear: function () {
              return this._calendar.leapYear(this);
            },
            epoch: function () {
              return this._calendar.epoch(this);
            },
            formatYear: function () {
              return this._calendar.formatYear(this);
            },
            monthOfYear: function () {
              return this._calendar.monthOfYear(this);
            },
            weekOfYear: function () {
              return this._calendar.weekOfYear(this);
            },
            daysInYear: function () {
              return this._calendar.daysInYear(this);
            },
            dayOfYear: function () {
              return this._calendar.dayOfYear(this);
            },
            daysInMonth: function () {
              return this._calendar.daysInMonth(this);
            },
            dayOfWeek: function () {
              return this._calendar.dayOfWeek(this);
            },
            weekDay: function () {
              return this._calendar.weekDay(this);
            },
            extraInfo: function () {
              return this._calendar.extraInfo(this);
            },
            add: function (e, t) {
              return this._calendar.add(this, e, t);
            },
            set: function (e, t) {
              return this._calendar.set(this, e, t);
            },
            compareTo: function (e) {
              if (this._calendar.name !== e._calendar.name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, e._calendar.local.name);
              var t = this._year !== e._year ? this._year - e._year : this._month !== e._month ? this.monthOfYear() - e.monthOfYear() : this._day - e._day;
              return 0 === t ? 0 : t < 0 ? -1 : 1;
            },
            calendar: function () {
              return this._calendar;
            },
            toJD: function () {
              return this._calendar.toJD(this);
            },
            fromJD: function (e) {
              return this._calendar.fromJD(e);
            },
            toJSDate: function () {
              return this._calendar.toJSDate(this);
            },
            fromJSDate: function (e) {
              return this._calendar.fromJSDate(e);
            },
            toString: function () {
              return (this.year() < 0 ? "-" : "") + o(Math.abs(this.year()), 4) + "-" + o(this.month(), 2) + "-" + o(this.day(), 2);
            }
          }), n(l.prototype, {
            _validateLevel: 0,
            newDate: function (e, t, r) {
              return null == e ? this.today() : (e.year && (this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), r = e.day(), t = e.month(), e = e.year()), new i(this, e, t, r));
            },
            today: function () {
              return this.fromJSDate(new Date());
            },
            epoch: function (e) {
              return this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear).year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
            },
            formatYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
              return (t.year() < 0 ? "-" : "") + o(Math.abs(t.year()), 4);
            },
            monthsInYear: function (e) {
              return this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear), 12;
            },
            monthOfYear: function (e, t) {
              var r = this._validate(e, t, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
              return (r.month() + this.monthsInYear(r) - this.firstMonth) % this.monthsInYear(r) + this.minMonth;
            },
            fromMonthOfYear: function (e, t) {
              var r = (t + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(e) + this.minMonth;
              return this._validate(e, r, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth), r;
            },
            daysInYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
              return this.leapYear(t) ? 366 : 365;
            },
            dayOfYear: function (e, t, r) {
              var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
              return n.toJD() - this.newDate(n.year(), this.fromMonthOfYear(n.year(), this.minMonth), this.minDay).toJD() + 1;
            },
            daysInWeek: function () {
              return 7;
            },
            dayOfWeek: function (e, t, r) {
              var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
              return (Math.floor(this.toJD(n)) + 2) % this.daysInWeek();
            },
            extraInfo: function (e, t, r) {
              return this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), {};
            },
            add: function (e, t, r) {
              return this._validate(e, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate), this._correctAdd(e, this._add(e, t, r), t, r);
            },
            _add: function (e, t, r) {
              if (this._validateLevel++, "d" === r || "w" === r) {
                var n = e.toJD() + t * ("w" === r ? this.daysInWeek() : 1),
                  a = e.calendar().fromJD(n);
                return this._validateLevel--, [a.year(), a.month(), a.day()];
              }
              try {
                var i = e.year() + ("y" === r ? t : 0),
                  o = e.monthOfYear() + ("m" === r ? t : 0);
                a = e.day(), "y" === r ? (e.month() !== this.fromMonthOfYear(i, o) && (o = this.newDate(i, e.month(), this.minDay).monthOfYear()), o = Math.min(o, this.monthsInYear(i)), a = Math.min(a, this.daysInMonth(i, this.fromMonthOfYear(i, o)))) : "m" === r && (function (e) {
                  for (; o < e.minMonth;) i--, o += e.monthsInYear(i);
                  for (var t = e.monthsInYear(i); o > t - 1 + e.minMonth;) i++, o -= t, t = e.monthsInYear(i);
                }(this), a = Math.min(a, this.daysInMonth(i, this.fromMonthOfYear(i, o))));
                var l = [i, this.fromMonthOfYear(i, o), a];
                return this._validateLevel--, l;
              } catch (e) {
                throw this._validateLevel--, e;
              }
            },
            _correctAdd: function (e, t, r, n) {
              if (!(this.hasYearZero || "y" !== n && "m" !== n || 0 !== t[0] && e.year() > 0 == t[0] > 0)) {
                var a = {
                    y: [1, 1, "y"],
                    m: [1, this.monthsInYear(-1), "m"],
                    w: [this.daysInWeek(), this.daysInYear(-1), "d"],
                    d: [1, this.daysInYear(-1), "d"]
                  }[n],
                  i = r < 0 ? -1 : 1;
                t = this._add(e, r * a[0] + i * a[1], a[2]);
              }
              return e.date(t[0], t[1], t[2]);
            },
            set: function (e, t, r) {
              this._validate(e, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate);
              var n = "y" === r ? t : e.year(),
                a = "m" === r ? t : e.month(),
                i = "d" === r ? t : e.day();
              return "y" !== r && "m" !== r || (i = Math.min(i, this.daysInMonth(n, a))), e.date(n, a, i);
            },
            isValid: function (e, t, r) {
              this._validateLevel++;
              var n = this.hasYearZero || 0 !== e;
              if (n) {
                var a = this.newDate(e, t, this.minDay);
                n = t >= this.minMonth && t - this.minMonth < this.monthsInYear(a) && r >= this.minDay && r - this.minDay < this.daysInMonth(a);
              }
              return this._validateLevel--, n;
            },
            toJSDate: function (e, t, r) {
              var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
              return c.instance().fromJD(this.toJD(n)).toJSDate();
            },
            fromJSDate: function (e) {
              return this.fromJD(c.instance().fromJSDate(e).toJD());
            },
            _validate: function (e, t, r, n) {
              if (e.year) {
                if (0 === this._validateLevel && this.name !== e.calendar().name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, e.calendar().local.name);
                return e;
              }
              try {
                if (this._validateLevel++, 1 === this._validateLevel && !this.isValid(e, t, r)) throw n.replace(/\{0\}/, this.local.name);
                var a = this.newDate(e, t, r);
                return this._validateLevel--, a;
              } catch (e) {
                throw this._validateLevel--, e;
              }
            }
          }), s.prototype = new l(), n(s.prototype, {
            name: "Gregorian",
            jdEpoch: 1721425.5,
            daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            hasYearZero: !1,
            minMonth: 1,
            firstMonth: 1,
            minDay: 1,
            regionalOptions: {
              "": {
                name: "Gregorian",
                epochs: ["BCE", "CE"],
                monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                digits: null,
                dateFormat: "mm/dd/yyyy",
                firstDay: 0,
                isRTL: !1
              }
            },
            leapYear: function (e) {
              var t = this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
              return (e = t.year() + (t.year() < 0 ? 1 : 0)) % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
            },
            weekOfYear: function (e, t, r) {
              var n = this.newDate(e, t, r);
              return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
            },
            daysInMonth: function (e, t) {
              var r = this._validate(e, t, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
              return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
            },
            weekDay: function (e, t, r) {
              return (this.dayOfWeek(e, t, r) || 7) < 6;
            },
            toJD: function (e, t, r) {
              var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
              e = n.year(), t = n.month(), r = n.day(), e < 0 && e++, t < 3 && (t += 12, e--);
              var a = Math.floor(e / 100),
                i = 2 - a + Math.floor(a / 4);
              return Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (t + 1)) + r + i - 1524.5;
            },
            fromJD: function (e) {
              var t = Math.floor(e + .5),
                r = Math.floor((t - 1867216.25) / 36524.25),
                n = 1524 + (r = t + 1 + r - Math.floor(r / 4)),
                a = Math.floor((n - 122.1) / 365.25),
                i = Math.floor(365.25 * a),
                o = Math.floor((n - i) / 30.6001),
                l = n - i - Math.floor(30.6001 * o),
                s = o - (o > 13.5 ? 13 : 1),
                c = a - (s > 2.5 ? 4716 : 4715);
              return c <= 0 && c--, this.newDate(c, s, l);
            },
            toJSDate: function (e, t, r) {
              var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate),
                a = new Date(n.year(), n.month() - 1, n.day());
              return a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0), a.setHours(a.getHours() > 12 ? a.getHours() + 2 : 0), a;
            },
            fromJSDate: function (e) {
              return this.newDate(e.getFullYear(), e.getMonth() + 1, e.getDate());
            }
          });
          var c = e.exports = new a();
          c.cdate = i, c.baseCalendar = l, c.calendars.gregorian = s;
        },
        3428: function (e, t, r) {
          var n = r(7976),
            a = r(6834);
          n(a.regionalOptions[""], {
            invalidArguments: "Invalid arguments",
            invalidFormat: "Cannot format a date from another calendar",
            missingNumberAt: "Missing number at position {0}",
            unknownNameAt: "Unknown name at position {0}",
            unexpectedLiteralAt: "Unexpected literal at position {0}",
            unexpectedText: "Additional text found at end"
          }), a.local = a.regionalOptions[""], n(a.cdate.prototype, {
            formatDate: function (e, t) {
              return "string" != typeof e && (t = e, e = ""), this._calendar.formatDate(e || "", this, t);
            }
          }), n(a.baseCalendar.prototype, {
            UNIX_EPOCH: a.instance().newDate(1970, 1, 1).toJD(),
            SECS_PER_DAY: 86400,
            TICKS_EPOCH: a.instance().jdEpoch,
            TICKS_PER_DAY: 864e9,
            ATOM: "yyyy-mm-dd",
            COOKIE: "D, dd M yyyy",
            FULL: "DD, MM d, yyyy",
            ISO_8601: "yyyy-mm-dd",
            JULIAN: "J",
            RFC_822: "D, d M yy",
            RFC_850: "DD, dd-M-yy",
            RFC_1036: "D, d M yy",
            RFC_1123: "D, d M yyyy",
            RFC_2822: "D, d M yyyy",
            RSS: "D, d M yy",
            TICKS: "!",
            TIMESTAMP: "@",
            W3C: "yyyy-mm-dd",
            formatDate: function (e, t, r) {
              if ("string" != typeof e && (r = t, t = e, e = ""), !t) return "";
              if (t.calendar() !== this) throw a.local.invalidFormat || a.regionalOptions[""].invalidFormat;
              e = e || this.local.dateFormat;
              for (var n, i, o, l = (r = r || {}).dayNamesShort || this.local.dayNamesShort, s = r.dayNames || this.local.dayNames, c = r.monthNumbers || this.local.monthNumbers, u = r.monthNamesShort || this.local.monthNamesShort, f = r.monthNames || this.local.monthNames, d = (r.calculateWeek || this.local.calculateWeek, function (t, r) {
                  for (var n = 1; _ + n < e.length && e.charAt(_ + n) === t;) n++;
                  return _ += n - 1, Math.floor(n / (r || 1)) > 1;
                }), h = function (e, t, r, n) {
                  var a = "" + t;
                  if (d(e, n)) for (; a.length < r;) a = "0" + a;
                  return a;
                }, p = this, v = function (e) {
                  return "function" == typeof c ? c.call(p, e, d("m")) : y(h("m", e.month(), 2));
                }, g = function (e, t) {
                  return t ? "function" == typeof f ? f.call(p, e) : f[e.month() - p.minMonth] : "function" == typeof u ? u.call(p, e) : u[e.month() - p.minMonth];
                }, m = this.local.digits, y = function (e) {
                  return r.localNumbers && m ? m(e) : e;
                }, x = "", b = !1, _ = 0; _ < e.length; _++) if (b) "'" !== e.charAt(_) || d("'") ? x += e.charAt(_) : b = !1;else switch (e.charAt(_)) {
                case "d":
                  x += y(h("d", t.day(), 2));
                  break;
                case "D":
                  x += ("D", n = t.dayOfWeek(), i = l, o = s, d("D") ? o[n] : i[n]);
                  break;
                case "o":
                  x += h("o", t.dayOfYear(), 3);
                  break;
                case "w":
                  x += h("w", t.weekOfYear(), 2);
                  break;
                case "m":
                  x += v(t);
                  break;
                case "M":
                  x += g(t, d("M"));
                  break;
                case "y":
                  x += d("y", 2) ? t.year() : (t.year() % 100 < 10 ? "0" : "") + t.year() % 100;
                  break;
                case "Y":
                  d("Y", 2), x += t.formatYear();
                  break;
                case "J":
                  x += t.toJD();
                  break;
                case "@":
                  x += (t.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
                  break;
                case "!":
                  x += (t.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
                  break;
                case "'":
                  d("'") ? x += "'" : b = !0;
                  break;
                default:
                  x += e.charAt(_);
              }
              return x;
            },
            parseDate: function (e, t, r) {
              if (null == t) throw a.local.invalidArguments || a.regionalOptions[""].invalidArguments;
              if ("" === (t = "object" == typeof t ? t.toString() : t + "")) return null;
              e = e || this.local.dateFormat;
              var n = (r = r || {}).shortYearCutoff || this.shortYearCutoff;
              n = "string" != typeof n ? n : this.today().year() % 100 + parseInt(n, 10);
              for (var i = r.dayNamesShort || this.local.dayNamesShort, o = r.dayNames || this.local.dayNames, l = r.parseMonth || this.local.parseMonth, s = r.monthNumbers || this.local.monthNumbers, c = r.monthNamesShort || this.local.monthNamesShort, u = r.monthNames || this.local.monthNames, f = -1, d = -1, h = -1, p = -1, v = -1, g = !1, m = !1, y = function (t, r) {
                  for (var n = 1; A + n < e.length && e.charAt(A + n) === t;) n++;
                  return A += n - 1, Math.floor(n / (r || 1)) > 1;
                }, x = function (e, r) {
                  var n = y(e, r),
                    i = [2, 3, n ? 4 : 2, n ? 4 : 2, 10, 11, 20]["oyYJ@!".indexOf(e) + 1],
                    o = new RegExp("^-?\\d{1," + i + "}"),
                    l = t.substring(k).match(o);
                  if (!l) throw (a.local.missingNumberAt || a.regionalOptions[""].missingNumberAt).replace(/\{0\}/, k);
                  return k += l[0].length, parseInt(l[0], 10);
                }, b = this, _ = function () {
                  if ("function" == typeof s) {
                    y("m");
                    var e = s.call(b, t.substring(k));
                    return k += e.length, e;
                  }
                  return x("m");
                }, w = function (e, r, n, i) {
                  for (var o = y(e, i) ? n : r, l = 0; l < o.length; l++) if (t.substr(k, o[l].length).toLowerCase() === o[l].toLowerCase()) return k += o[l].length, l + b.minMonth;
                  throw (a.local.unknownNameAt || a.regionalOptions[""].unknownNameAt).replace(/\{0\}/, k);
                }, T = function () {
                  if ("function" == typeof u) {
                    var e = y("M") ? u.call(b, t.substring(k)) : c.call(b, t.substring(k));
                    return k += e.length, e;
                  }
                  return w("M", c, u);
                }, M = function () {
                  if (t.charAt(k) !== e.charAt(A)) throw (a.local.unexpectedLiteralAt || a.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, k);
                  k++;
                }, k = 0, A = 0; A < e.length; A++) if (m) "'" !== e.charAt(A) || y("'") ? M() : m = !1;else switch (e.charAt(A)) {
                case "d":
                  p = x("d");
                  break;
                case "D":
                  w("D", i, o);
                  break;
                case "o":
                  v = x("o");
                  break;
                case "w":
                  x("w");
                  break;
                case "m":
                  h = _();
                  break;
                case "M":
                  h = T();
                  break;
                case "y":
                  var L = A;
                  g = !y("y", 2), A = L, d = x("y", 2);
                  break;
                case "Y":
                  d = x("Y", 2);
                  break;
                case "J":
                  f = x("J") + .5, "." === t.charAt(k) && (k++, x("J"));
                  break;
                case "@":
                  f = x("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
                  break;
                case "!":
                  f = x("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
                  break;
                case "*":
                  k = t.length;
                  break;
                case "'":
                  y("'") ? M() : m = !0;
                  break;
                default:
                  M();
              }
              if (k < t.length) throw a.local.unexpectedText || a.regionalOptions[""].unexpectedText;
              if (-1 === d ? d = this.today().year() : d < 100 && g && (d += -1 === n ? 1900 : this.today().year() - this.today().year() % 100 - (d <= n ? 0 : 100)), "string" == typeof h && (h = l.call(this, d, h)), v > -1) {
                h = 1, p = v;
                for (var S = this.daysInMonth(d, h); p > S; S = this.daysInMonth(d, h)) h++, p -= S;
              }
              return f > -1 ? this.fromJD(f) : this.newDate(d, h, p);
            },
            determineDate: function (e, t, r, n, a) {
              r && "object" != typeof r && (a = n, n = r, r = null), "string" != typeof n && (a = n, n = "");
              var i = this;
              return t = t ? t.newDate() : null, null == e ? t : "string" == typeof e ? function (e) {
                try {
                  return i.parseDate(n, e, a);
                } catch (e) {}
                for (var t = ((e = e.toLowerCase()).match(/^c/) && r ? r.newDate() : null) || i.today(), o = /([+-]?[0-9]+)\s*(d|w|m|y)?/g, l = o.exec(e); l;) t.add(parseInt(l[1], 10), l[2] || "d"), l = o.exec(e);
                return t;
              }(e) : "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? t : i.today().add(e, "d") : i.newDate(e);
            }
          });
        },
        6144: function (e, t, r) {
          "use strict";

          r.r(t);
          var n = r(5072),
            a = r.n(n),
            i = r(7825),
            o = r.n(i),
            l = r(7659),
            s = r.n(l),
            c = r(5056),
            u = r.n(c),
            f = r(540),
            d = r.n(f),
            h = r(1113),
            p = r.n(h),
            v = r(5955),
            g = {};
          g.styleTagTransform = p(), g.setAttributes = u(), g.insert = s().bind(null, "head"), g.domAPI = o(), g.insertStyleElement = d(), a()(v.A, g), t.default = v.A && v.A.locals ? v.A.locals : void 0;
        },
        5072: function (e) {
          "use strict";

          var t = [];
          function r(e) {
            for (var r = -1, n = 0; n < t.length; n++) if (t[n].identifier === e) {
              r = n;
              break;
            }
            return r;
          }
          function n(e, n) {
            for (var i = {}, o = [], l = 0; l < e.length; l++) {
              var s = e[l],
                c = n.base ? s[0] + n.base : s[0],
                u = i[c] || 0,
                f = "".concat(c, " ").concat(u);
              i[c] = u + 1;
              var d = r(f),
                h = {
                  css: s[1],
                  media: s[2],
                  sourceMap: s[3],
                  supports: s[4],
                  layer: s[5]
                };
              if (-1 !== d) t[d].references++, t[d].updater(h);else {
                var p = a(h, n);
                n.byIndex = l, t.splice(l, 0, {
                  identifier: f,
                  updater: p,
                  references: 1
                });
              }
              o.push(f);
            }
            return o;
          }
          function a(e, t) {
            var r = t.domAPI(t);
            return r.update(e), function (t) {
              if (t) {
                if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
                r.update(e = t);
              } else r.remove();
            };
          }
          e.exports = function (e, a) {
            var i = n(e = e || [], a = a || {});
            return function (e) {
              e = e || [];
              for (var o = 0; o < i.length; o++) {
                var l = r(i[o]);
                t[l].references--;
              }
              for (var s = n(e, a), c = 0; c < i.length; c++) {
                var u = r(i[c]);
                0 === t[u].references && (t[u].updater(), t.splice(u, 1));
              }
              i = s;
            };
          };
        },
        7659: function (e) {
          "use strict";

          var t = {};
          e.exports = function (e, r) {
            var n = function (e) {
              if (void 0 === t[e]) {
                var r = document.querySelector(e);
                if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                  r = r.contentDocument.head;
                } catch (e) {
                  r = null;
                }
                t[e] = r;
              }
              return t[e];
            }(e);
            if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            n.appendChild(r);
          };
        },
        540: function (e) {
          "use strict";

          e.exports = function (e) {
            var t = document.createElement("style");
            return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
          };
        },
        5056: function (e, t, r) {
          "use strict";

          e.exports = function (e) {
            var t = r.nc;
            t && e.setAttribute("nonce", t);
          };
        },
        7825: function (e) {
          "use strict";

          e.exports = function (e) {
            if ("undefined" == typeof document) return {
              update: function () {},
              remove: function () {}
            };
            var t = e.insertStyleElement(e);
            return {
              update: function (r) {
                !function (e, t, r) {
                  var n = "";
                  r.supports && (n += "@supports (".concat(r.supports, ") {")), r.media && (n += "@media ".concat(r.media, " {"));
                  var a = void 0 !== r.layer;
                  a && (n += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), n += r.css, a && (n += "}"), r.media && (n += "}"), r.supports && (n += "}");
                  var i = r.sourceMap;
                  i && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleTagTransform(n, e, t.options);
                }(t, e, r);
              },
              remove: function () {
                !function (e) {
                  if (null === e.parentNode) return !1;
                  e.parentNode.removeChild(e);
                }(t);
              }
            };
          };
        },
        1113: function (e) {
          "use strict";

          e.exports = function (e, t) {
            if (t.styleSheet) t.styleSheet.cssText = e;else {
              for (; t.firstChild;) t.removeChild(t.firstChild);
              t.appendChild(document.createTextNode(e));
            }
          };
        },
        5446: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2722%27 height=%2722%27 fill=%27%23333%27 viewBox=%270 0 22 22%27%3E%3Cpath d=%27m1.754 13.406 4.453-4.851 3.09 3.09 3.281 3.277.969-.969-3.309-3.312 3.844-4.121 6.148 6.886h1.082v-.855l-7.207-8.07-4.84 5.187L6.169 6.57l-5.48 5.965v.871ZM.688 16.844h20.625v1.375H.688Zm0 0%27/%3E%3C/svg%3E";
        },
        6694: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2722%27 height=%2722%27 fill=%27%2333b5e5%27 viewBox=%270 0 22 22%27%3E%3Cpath d=%27m1.754 13.406 4.453-4.851 3.09 3.09 3.281 3.277.969-.969-3.309-3.312 3.844-4.121 6.148 6.886h1.082v-.855l-7.207-8.07-4.84 5.187L6.169 6.57l-5.48 5.965v.871ZM.688 16.844h20.625v1.375H.688Zm0 0%27/%3E%3C/svg%3E";
        },
        6117: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill-rule=%27evenodd%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0%27/%3E%3C/svg%3E";
        },
        6311: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27%23fff%27 fill-rule=%27evenodd%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0%27/%3E%3C/svg%3E";
        },
        4420: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
        },
        7035: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z%27/%3E%3C/svg%3E";
        },
        3470: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5%27/%3E%3C/svg%3E";
        },
        3490: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z%27/%3E%3C/svg%3E";
        },
        216: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27m10.5 14 4-8 4 8z%27/%3E%3Cpath fill=%27%23ccc%27 d=%27m10.5 16 4 8 4-8z%27/%3E%3C/svg%3E";
        },
        7695: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%2333b5e5%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3C/svg%3E";
        },
        2228: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%2333b5e5%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
        },
        3737: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23666%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3Cpath fill=%27red%27 d=%27m14 5 1 1-9 9-1-1z%27/%3E%3C/svg%3E";
        },
        8460: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23999%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3Cpath fill=%27red%27 d=%27m14 5 1 1-9 9-1-1z%27/%3E%3C/svg%3E";
        },
        5796: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23aaa%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3Cpath fill=%27red%27 d=%27m14 5 1 1-9 9-1-1z%27/%3E%3C/svg%3E";
        },
        8869: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23e54e33%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3C/svg%3E";
        },
        9819: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23e58978%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
        },
        557: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
        },
        8164: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z%27/%3E%3C/svg%3E";
        },
        4665: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5%27/%3E%3C/svg%3E";
        },
        1413: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M18.5 16c-1.75 0-2.5.75-2.5 2.5V24h1l1.5-3 5.5 4 1-1-4-5.5 3-1.5v-1zM13 18.5c0-1.75-.75-2.5-2.5-2.5H5v1l3 1.5L4 24l1 1 5.5-4 1.5 3h1zm3-8c0 1.75.75 2.5 2.5 2.5H24v-1l-3-1.5L25 5l-1-1-5.5 4L17 5h-1zM10.5 13c1.75 0 2.5-.75 2.5-2.5V5h-1l-1.5 3L5 4 4 5l4 5.5L5 12v1z%27/%3E%3C/svg%3E";
        },
        3913: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z%27/%3E%3C/svg%3E";
        },
        1907: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27m10.5 14 4-8 4 8z%27/%3E%3Cpath fill=%27%23ccc%27 d=%27m10.5 16 4 8 4-8z%27/%3E%3C/svg%3E";
        },
        8920: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
        },
        4890: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z%27/%3E%3C/svg%3E";
        },
        3363: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5%27/%3E%3C/svg%3E";
        },
        7603: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M18.5 16c-1.75 0-2.5.75-2.5 2.5V24h1l1.5-3 5.5 4 1-1-4-5.5 3-1.5v-1zM13 18.5c0-1.75-.75-2.5-2.5-2.5H5v1l3 1.5L4 24l1 1 5.5-4 1.5 3h1zm3-8c0 1.75.75 2.5 2.5 2.5H24v-1l-3-1.5L25 5l-1-1-5.5 4L17 5h-1zM10.5 13c1.75 0 2.5-.75 2.5-2.5V5h-1l-1.5 3L5 4 4 5l4 5.5L5 12v1z%27/%3E%3C/svg%3E";
        },
        4643: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z%27/%3E%3C/svg%3E";
        },
        8605: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27m10.5 14 4-8 4 8z%27/%3E%3Cpath fill=%27%23ccc%27 d=%27m10.5 16 4 8 4-8z%27/%3E%3C/svg%3E";
        },
        7914: function (e) {
          "use strict";

          e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2788%27 height=%2723%27 fill=%27none%27%3E%3Cpath fill=%27%23000%27 fill-opacity=%27.4%27 fill-rule=%27evenodd%27 d=%27M17.408 16.796h-1.827l2.501-12.095h.198l3.324 6.533.988 2.19.988-2.19 3.258-6.533h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.929 5.644h-.098l-2.914-5.644-.757-1.71-.345 1.71zm1.958-3.42-.726 3.663a1.255 1.255 0 0 1-1.232 1.011h-1.827a1.255 1.255 0 0 1-1.229-1.509l2.501-12.095a1.255 1.255 0 0 1 1.23-1.001h.197a1.25 1.25 0 0 1 1.12.685l3.19 6.273 3.125-6.263a1.25 1.25 0 0 1 1.123-.695h.181a1.255 1.255 0 0 1 1.227.991l1.443 6.71a5 5 0 0 1 .314-.787l.009-.016a4.6 4.6 0 0 1 1.777-1.887c.782-.46 1.668-.667 2.611-.667a4.6 4.6 0 0 1 1.7.32l.306.134c.21-.16.474-.256.759-.256h1.694a1.255 1.255 0 0 1 1.212.925 1.255 1.255 0 0 1 1.212-.925h1.711c.284 0 .545.094.755.252.613-.3 1.312-.45 2.075-.45 1.356 0 2.557.445 3.482 1.4q.47.48.763 1.064V4.701a1.255 1.255 0 0 1 1.255-1.255h1.86A1.255 1.255 0 0 1 54.44 4.7v9.194h2.217c.19 0 .37.043.532.118v-4.77c0-.356.147-.678.385-.906a2.42 2.42 0 0 1-.682-1.71c0-.665.267-1.253.735-1.7a2.45 2.45 0 0 1 1.722-.674 2.43 2.43 0 0 1 1.705.675q.318.302.504.683V4.7a1.255 1.255 0 0 1 1.255-1.255h1.744A1.255 1.255 0 0 1 65.812 4.7v3.335a4.8 4.8 0 0 1 1.526-.246c.938 0 1.817.214 2.59.69a4.47 4.47 0 0 1 1.67 1.743v-.98a1.255 1.255 0 0 1 1.256-1.256h1.777c.233 0 .451.064.639.174a3.4 3.4 0 0 1 1.567-.372c.346 0 .861.02 1.285.232a1.25 1.25 0 0 1 .689 1.004 4.7 4.7 0 0 1 .853-.588c.795-.44 1.675-.647 2.61-.647 1.385 0 2.65.39 3.525 1.396.836.938 1.168 2.173 1.168 3.528q-.001.515-.056 1.051a1.255 1.255 0 0 1-.947 1.09l.408.952a1.255 1.255 0 0 1-.477 1.552c-.418.268-.92.463-1.458.612-.613.171-1.304.244-2.049.244-1.06 0-2.043-.207-2.886-.698l-.015-.008c-.798-.48-1.419-1.135-1.818-1.963l-.004-.008a5.8 5.8 0 0 1-.548-2.512q0-.429.053-.843a1.3 1.3 0 0 1-.333-.086l-.166-.004c-.223 0-.426.062-.643.228-.03.024-.142.139-.142.59v3.883a1.255 1.255 0 0 1-1.256 1.256h-1.777a1.255 1.255 0 0 1-1.256-1.256V15.69l-.032.057a4.8 4.8 0 0 1-1.86 1.833 5.04 5.04 0 0 1-2.484.634 4.5 4.5 0 0 1-1.935-.424 1.25 1.25 0 0 1-.764.258h-1.71a1.255 1.255 0 0 1-1.256-1.255V7.687a2.4 2.4 0 0 1-.428.625c.253.23.412.561.412.93v7.553a1.255 1.255 0 0 1-1.256 1.255h-1.843a1.25 1.25 0 0 1-.894-.373c-.228.23-.544.373-.894.373H51.32a1.255 1.255 0 0 1-1.256-1.255v-1.251l-.061.117a4.7 4.7 0 0 1-1.782 1.884 4.77 4.77 0 0 1-2.485.67 5.6 5.6 0 0 1-1.485-.188l.009 2.764a1.255 1.255 0 0 1-1.255 1.259h-1.729a1.255 1.255 0 0 1-1.255-1.255v-3.537a1.255 1.255 0 0 1-1.167.793h-1.679a1.25 1.25 0 0 1-.77-.263 4.5 4.5 0 0 1-1.945.429c-.885 0-1.724-.21-2.495-.632l-.017-.01a5 5 0 0 1-1.081-.836 1.255 1.255 0 0 1-1.254 1.312h-1.81a1.255 1.255 0 0 1-1.228-.99l-.782-3.625-2.044 3.939a1.25 1.25 0 0 1-1.115.676h-.098a1.25 1.25 0 0 1-1.116-.68l-2.061-3.994zM35.92 16.63l.207-.114.223-.15q.493-.356.735-.785l.061-.118.033 1.332h1.678V9.242h-1.694l-.033 1.267q-.133-.329-.526-.658l-.032-.028a3.2 3.2 0 0 0-.668-.428l-.27-.12a3.3 3.3 0 0 0-1.235-.23q-1.136-.001-1.974.493a3.36 3.36 0 0 0-1.3 1.382q-.445.89-.444 2.074 0 1.2.51 2.107a3.8 3.8 0 0 0 1.382 1.381 3.9 3.9 0 0 0 1.893.477q.795 0 1.455-.33zm-2.789-5.38q-.576.675-.575 1.762 0 1.102.559 1.794.576.675 1.645.675a2.25 2.25 0 0 0 .934-.19 2.2 2.2 0 0 0 .468-.29l.178-.161a2.2 2.2 0 0 0 .397-.561q.244-.5.244-1.15v-.115q0-.708-.296-1.267l-.043-.077a2.2 2.2 0 0 0-.633-.709l-.13-.086-.047-.028a2.1 2.1 0 0 0-1.073-.285q-1.052 0-1.629.692zm2.316 2.706c.163-.17.28-.407.28-.83v-.114c0-.292-.06-.508-.15-.68a.96.96 0 0 0-.353-.389.85.85 0 0 0-.464-.127c-.4 0-.56.114-.664.239l-.01.012c-.148.174-.275.45-.275.945 0 .506.122.801.27.99.097.11.266.224.68.224.303 0 .504-.09.687-.269zm7.545 1.705a2.6 2.6 0 0 0 .331.423q.319.33.755.548l.173.074q.65.255 1.49.255 1.02 0 1.844-.493a3.45 3.45 0 0 0 1.316-1.4q.493-.904.493-2.089 0-1.909-.988-2.913-.988-1.02-2.584-1.02-.898 0-1.575.347a3 3 0 0 0-.415.262l-.199.166a3.4 3.4 0 0 0-.64.82V9.242h-1.712v11.553h1.729l-.017-5.134zm.53-1.138q.206.29.48.5l.155.11.053.034q.51.296 1.119.297 1.07 0 1.645-.675.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.435 0-.835.16a2 2 0 0 0-.284.136 2 2 0 0 0-.363.254 2.2 2.2 0 0 0-.46.569l-.082.162a2.6 2.6 0 0 0-.213 1.072v.115q0 .707.296 1.267l.135.211zm.964-.818a1.1 1.1 0 0 0 .367.385.94.94 0 0 0 .476.118c.423 0 .59-.117.687-.23.159-.194.28-.478.28-.95 0-.53-.133-.8-.266-.952l-.021-.025c-.078-.094-.231-.221-.68-.221a1 1 0 0 0-.503.135l-.012.007a.86.86 0 0 0-.335.343c-.073.133-.132.324-.132.614v.115a1.4 1.4 0 0 0 .14.66zm15.7-6.222q.347-.346.346-.856a1.05 1.05 0 0 0-.345-.79 1.18 1.18 0 0 0-.84-.329q-.51 0-.855.33a1.05 1.05 0 0 0-.346.79q0 .51.346.855.345.346.856.346.51 0 .839-.346zm4.337 9.314.033-1.332q.191.403.59.747l.098.081a4 4 0 0 0 .316.224l.223.122a3.2 3.2 0 0 0 1.44.322 3.8 3.8 0 0 0 1.875-.477 3.5 3.5 0 0 0 1.382-1.366q.527-.89.526-2.09 0-1.184-.444-2.073a3.24 3.24 0 0 0-1.283-1.399q-.823-.51-1.942-.51a3.5 3.5 0 0 0-1.527.344l-.086.043-.165.09a3 3 0 0 0-.33.214q-.432.315-.656.707a2 2 0 0 0-.099.198l.082-1.283V4.701h-1.744v12.095zm.473-2.509a2.5 2.5 0 0 0 .566.7q.117.098.245.18l.144.08a2.1 2.1 0 0 0 .975.232q1.07 0 1.645-.675.576-.69.576-1.778 0-1.102-.576-1.777-.56-.691-1.645-.692a2.2 2.2 0 0 0-1.015.235q-.22.113-.415.282l-.15.142a2.1 2.1 0 0 0-.42.594q-.223.479-.223 1.1v.115q0 .705.293 1.26zm2.616-.293c.157-.191.28-.479.28-.967 0-.51-.13-.79-.276-.961l-.021-.026c-.082-.1-.232-.225-.67-.225a.87.87 0 0 0-.681.279l-.012.011c-.154.155-.274.38-.274.807v.115c0 .285.057.499.144.669a1.1 1.1 0 0 0 .367.405c.137.082.28.123.455.123.423 0 .59-.118.686-.23zm8.266-3.013q.345-.13.724-.14l.069-.002q.493 0 .642.099l.247-1.794q-.196-.099-.717-.099a2.3 2.3 0 0 0-.545.063 2 2 0 0 0-.411.148 2.2 2.2 0 0 0-.4.249 2.5 2.5 0 0 0-.485.499 2.7 2.7 0 0 0-.32.581l-.05.137v-1.48h-1.778v7.553h1.777v-3.884q0-.546.159-.943a1.5 1.5 0 0 1 .466-.636 2.5 2.5 0 0 1 .399-.253 2 2 0 0 1 .224-.099zm9.784 2.656.05-.922q0-1.743-.856-2.698-.838-.97-2.584-.97-1.119-.001-2.007.493a3.46 3.46 0 0 0-1.4 1.382q-.493.906-.493 2.106 0 1.07.428 1.975.428.89 1.332 1.432.906.526 2.255.526.973 0 1.668-.185l.044-.012.135-.04q.613-.184.984-.421l-.542-1.267q-.3.162-.642.274l-.297.087q-.51.131-1.3.131-.954 0-1.497-.444a1.6 1.6 0 0 1-.192-.193q-.366-.44-.512-1.234l-.004-.021zm-5.427-1.256-.003.022h3.752v-.138q-.011-.727-.288-1.118a1 1 0 0 0-.156-.176q-.46-.428-1.316-.428-.986 0-1.494.604-.379.45-.494 1.234zm-27.053 2.77V4.7h-1.86v12.095h5.333V15.15zm7.103-5.908v7.553h-1.843V9.242h1.843z%27/%3E%3Cpath fill=%27%23fff%27 d=%27m19.63 11.151-.757-1.71-.345 1.71-1.12 5.644h-1.827L18.083 4.7h.197l3.325 6.533.988 2.19.988-2.19L26.839 4.7h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.93 5.644h-.098l-2.913-5.644zm14.836 5.81q-1.02 0-1.893-.478a3.8 3.8 0 0 1-1.381-1.382q-.51-.906-.51-2.106 0-1.185.444-2.074a3.36 3.36 0 0 1 1.3-1.382q.839-.494 1.974-.494a3.3 3.3 0 0 1 1.234.231 3.3 3.3 0 0 1 .97.575q.396.33.527.659l.033-1.267h1.694v7.553H37.18l-.033-1.332q-.279.593-1.02 1.053a3.17 3.17 0 0 1-1.662.444zm.296-1.482q.938 0 1.58-.642.642-.66.642-1.711v-.115q0-.708-.296-1.267a2.2 2.2 0 0 0-.807-.872 2.1 2.1 0 0 0-1.119-.313q-1.053 0-1.629.692-.575.675-.575 1.76 0 1.103.559 1.795.577.675 1.645.675zm6.521-6.237h1.711v1.4q.906-1.597 2.83-1.597 1.596 0 2.584 1.02.988 1.005.988 2.914 0 1.185-.493 2.09a3.46 3.46 0 0 1-1.316 1.399 3.5 3.5 0 0 1-1.844.493q-.954 0-1.662-.329a2.67 2.67 0 0 1-1.086-.97l.017 5.134h-1.728zm4.048 6.22q1.07 0 1.645-.674.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.592 0-1.12.296-.51.28-.822.823-.296.527-.296 1.234v.115q0 .708.296 1.267.313.543.823.855.51.296 1.119.297z%27/%3E%3Cpath fill=%27%23e1e3e9%27 d=%27M51.325 4.7h1.86v10.45h3.473v1.646h-5.333zm7.12 4.542h1.843v7.553h-1.843zm.905-1.415a1.16 1.16 0 0 1-.856-.346 1.17 1.17 0 0 1-.346-.856 1.05 1.05 0 0 1 .346-.79q.346-.329.856-.329.494 0 .839.33a1.05 1.05 0 0 1 .345.79 1.16 1.16 0 0 1-.345.855q-.33.346-.84.346zm7.875 9.133a3.17 3.17 0 0 1-1.662-.444q-.723-.46-1.004-1.053l-.033 1.332h-1.71V4.701h1.743v4.657l-.082 1.283q.279-.658 1.086-1.119a3.5 3.5 0 0 1 1.778-.477q1.119 0 1.942.51a3.24 3.24 0 0 1 1.283 1.4q.445.888.444 2.072 0 1.201-.526 2.09a3.5 3.5 0 0 1-1.382 1.366 3.8 3.8 0 0 1-1.876.477zm-.296-1.481q1.069 0 1.645-.675.577-.69.577-1.778 0-1.102-.577-1.776-.56-.691-1.645-.692a2.12 2.12 0 0 0-1.58.659q-.642.641-.642 1.694v.115q0 .71.296 1.267a2.4 2.4 0 0 0 .807.872 2.1 2.1 0 0 0 1.119.313zm5.927-6.237h1.777v1.481q.263-.757.856-1.217a2.14 2.14 0 0 1 1.349-.46q.527 0 .724.098l-.247 1.794q-.149-.099-.642-.099-.774 0-1.416.494-.626.493-.626 1.58v3.883h-1.777V9.242zm9.534 7.718q-1.35 0-2.255-.526-.904-.543-1.332-1.432a4.6 4.6 0 0 1-.428-1.975q0-1.2.493-2.106a3.46 3.46 0 0 1 1.4-1.382q.889-.495 2.007-.494 1.744 0 2.584.97.855.956.856 2.7 0 .444-.05.92h-5.43q.18 1.005.708 1.45.542.443 1.497.443.79 0 1.3-.131a4 4 0 0 0 .938-.362l.542 1.267q-.411.263-1.119.46-.708.198-1.711.197zm1.596-4.558q.016-1.02-.444-1.432-.46-.428-1.316-.428-1.728 0-1.991 1.86z%27/%3E%3Cpath d=%27M5.074 15.948a.484.657 0 0 0-.486.659v1.84a.484.657 0 0 0 .486.659h4.101a.484.657 0 0 0 .486-.659v-1.84a.484.657 0 0 0-.486-.659zm3.56 1.16H5.617v.838h3.017z%27 style=%27fill:%23fff;fill-rule:evenodd;stroke-width:1.03600001%27/%3E%3Cg style=%27stroke-width:1.12603545%27%3E%3Cpath d=%27M-9.408-1.416c-3.833-.025-7.056 2.912-7.08 6.615-.02 3.08 1.653 4.832 3.107 6.268.903.892 1.721 1.74 2.32 2.902l-.525-.004c-.543-.003-.992.304-1.24.639a1.87 1.87 0 0 0-.362 1.121l-.011 1.877c-.003.402.104.787.347 1.125.244.338.688.653 1.23.656l4.142.028c.542.003.99-.306 1.238-.641a1.87 1.87 0 0 0 .363-1.121l.012-1.875a1.87 1.87 0 0 0-.348-1.127c-.243-.338-.688-.653-1.23-.656l-.518-.004c.597-1.145 1.425-1.983 2.348-2.87 1.473-1.414 3.18-3.149 3.2-6.226-.016-3.59-2.923-6.684-6.993-6.707m-.006 1.1v.002c3.274.02 5.92 2.532 5.9 5.6-.017 2.706-1.39 4.026-2.863 5.44-1.034.994-2.118 2.033-2.814 3.633-.018.041-.052.055-.075.065q-.013.004-.02.01a.34.34 0 0 1-.226.084.34.34 0 0 1-.224-.086l-.092-.077c-.699-1.615-1.768-2.669-2.781-3.67-1.454-1.435-2.797-2.762-2.78-5.478.02-3.067 2.7-5.545 5.975-5.523m-.02 2.826c-1.62-.01-2.944 1.315-2.955 2.96-.01 1.646 1.295 2.988 2.916 2.999h.002c1.621.01 2.943-1.316 2.953-2.961.011-1.646-1.294-2.988-2.916-2.998m-.005 1.1c1.017.006 1.829.83 1.822 1.89s-.83 1.874-1.848 1.867c-1.018-.006-1.829-.83-1.822-1.89s.83-1.874 1.848-1.868m-2.155 11.857 4.14.025c.271.002.49.305.487.676l-.013 1.875c-.003.37-.224.67-.495.668l-4.14-.025c-.27-.002-.487-.306-.485-.676l.012-1.875c.003-.37.224-.67.494-.668%27 style=%27color:%23000;font-style:normal;font-variant:normal;font-weight:400;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:evenodd;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000;solid-opacity:1;vector-effect:none;fill:%23000;fill-opacity:.4;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto%27 transform=%27translate%2815.553 2.85%29scale%28.88807%29%27/%3E%3Cpath d=%27M-9.415-.316C-12.69-.338-15.37 2.14-15.39 5.207c-.017 2.716 1.326 4.041 2.78 5.477 1.013 1 2.081 2.055 2.78 3.67l.092.076a.34.34 0 0 0 .225.086.34.34 0 0 0 .227-.083l.019-.01c.022-.009.057-.024.074-.064.697-1.6 1.78-2.64 2.814-3.634 1.473-1.414 2.847-2.733 2.864-5.44.02-3.067-2.627-5.58-5.901-5.601m-.057 8.784c1.621.011 2.944-1.315 2.955-2.96.01-1.646-1.295-2.988-2.916-2.999-1.622-.01-2.945 1.315-2.955 2.96s1.295 2.989 2.916 3%27 style=%27clip-rule:evenodd;fill:%23e1e3e9;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4%27 transform=%27translate%2815.553 2.85%29scale%28.88807%29%27/%3E%3Cpath d=%27M-11.594 15.465c-.27-.002-.492.297-.494.668l-.012 1.876c-.003.371.214.673.485.675l4.14.027c.271.002.492-.298.495-.668l.012-1.877c.003-.37-.215-.672-.485-.674z%27 style=%27clip-rule:evenodd;fill:%23fff;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4%27 transform=%27translate%2815.553 2.85%29scale%28.88807%29%27/%3E%3C/g%3E%3C/svg%3E";
        }
      },
      t = {};
    function r(n) {
      var a = t[n];
      if (void 0 !== a) return a.exports;
      var i = t[n] = {
        id: n,
        exports: {}
      };
      return e[n].call(i.exports, i, i.exports, r), i.exports;
    }
    return r.m = e, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, {
        a: t
      }), t;
    }, r.d = function (e, t) {
      for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }, r.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.b = document.baseURI || self.location.href, r.nc = void 0, r(5611);
  }();
});